/* THIS FILE IS GENERATED, DO NOT EDIT! */
/* eslint-disable */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  Decimal: any;
  Duration: any;
  Email: any;
  Json: any;
  LocalDateTime: any;
  Long: any;
  PhoneNumber: any;
  SafeString: any;
  Time: any;
}

export interface AcceptCompanyPolicyAgreementInput {
  clientMutationId: Scalars["String"];
  fileId: Scalars["String"];
}

export interface AcceptCompanyPolicyAgreementPayload {
  clientMutationId: Scalars["String"];
  /** Updated flag */
  seenFlag?: Maybe<SeenFlag>;
}

export interface AcceptDevAccessAgreementInput {
  clientMutationId: Scalars["String"];
}

export interface AcceptDevAccessAgreementPayload {
  clientMutationId: Scalars["String"];
  success?: Maybe<Scalars["Boolean"]>;
}

export interface AcceptOfferInput {
  clientMutationId: Scalars["String"];
  offerType: OfferType;
}

export interface AcceptOfferPayload {
  availableProductOffers: Array<ProductOffer>;
  clientMutationId: Scalars["String"];
}

export interface AcceptedSuggestionExpenseActivity extends ExpenseActivity {
  id: Scalars["ID"];
  overrideStatus: ExpenseActivityOverrideStatus;
  previousData?: Maybe<PreviousExpenseData>;
  suggestion: AutomationSuggestion;
}

/**  ---[ Extended Types ]------------------ */
export interface Account extends Node {
  /** Returns the type of the accepted product offer for this account */
  acceptedProductOfferType: OfferType;
  /** The Risk Tiers 2.0 ACH Debit limits for this cuacc */
  achDebitLimits?: Maybe<AchDebitLimits>;
  adminHomeProductSegment?: Maybe<ProductSegmentType>;
  adminHomeWidgetAutopayOverview?: Maybe<AutopayOverview>;
  /** The AI Policy setting for the account. */
  aiPolicySetting?: Maybe<AiPolicySetting>;
  allowUserManualPayment?: Maybe<Scalars["Boolean"]>;
  /** The AMS metadata for the account. */
  amsMetadata?: Maybe<AmsMetadata>;
  /** The onboarding product the account was approved for */
  approvedBlueprintAtOnboarding?: Maybe<Scalars["String"]>;
  /** The assistant settings for the account. */
  assistantSettings?: Maybe<CompanyAssistantSetting>;
  /** Active automatic transfer settings for all deposits accounts owned by this customer account. */
  automaticTransferSettings?: Maybe<AutomaticTransferSettingsConnection>;
  /** Total amount of money that customer owes Brex, including entries that aren't due yet */
  balanceDue?: Maybe<Scalars["Int"]>;
  /**
   * Total amount of transactions by customer that have had auth but no clearing event
   *
   * DEPRECATED: This only includes USD balances, and will be incomplete for any customer being billed in non-USD amounts. The current consumers of this field are aware and are supposed to eventually migrate off this - https://brexhq.atlassian.net/browse/GACCT-285
   */
  balancePending?: Maybe<Scalars["Int"]>;
  /** Customer's global limit and balance consumption */
  balanceSummary?: Maybe<AccountBalanceSummary>;
  bankingAccounts?: Maybe<BankingAccountConnection>;
  /** Bill Pay's unique email for invoice processing */
  billForwardingEmailAddress?: Maybe<Scalars["String"]>;
  /** Billing payment intents targeting accounts owned by this customer account */
  billingPaymentIntents?: Maybe<BillingPaymentIntentConnection>;
  /** Billing payments made by this customer account */
  billingPayments?: Maybe<BillingPaymentConnection>;
  cardAccountType?: Maybe<CardAccountType>;
  /** The journal account corresponding to the primary card loan for this customer */
  cardCustomerJournalAccount?: Maybe<JournalAccount>;
  /**
   * Cash transactions belonging to the customer account. Statuses is the
   * only required filter. Supports first: and after: cursor based pagination.
   */
  cashTransactions?: Maybe<CashTransactionConnection>;
  /** Disable the chat when account is binary fraudulent */
  chatDisabled?: Maybe<Scalars["Boolean"]>;
  /** The Risk Tiers 2.0 cheque deposit limits for this cuacc */
  chequeDepositLimits?: Maybe<ChequeDepositLimits>;
  cobranding: Cobranding;
  collectionIntentions?: Maybe<CollectionIntentionConnection>;
  /** Company Type from signups */
  companyType?: Maybe<CompanyType>;
  contacts?: Maybe<PaymentContactConnection>;
  creditLimitOverview?: Maybe<CreditLimitOverview>;
  /** Amount that are currently in-flight and early credited for this customer */
  creditedPendingCollectionAmount?: Maybe<Scalars["Int"]>;
  /** The customer tier of the account (Naming obfuscated to avoid exposure to end users). */
  ct?: Maybe<Scalars["String"]>;
  /**
   * Amount of money a customer owes, minus the entries that haven't become due yet
   *
   * DEPRECATED: This only includes USD balances, and will be incomplete for any customer being billed in non-USD amounts. The current consumers of this field are aware and are supposed to eventually migrate off this - https://brexhq.atlassian.net/browse/GACCT-285
   */
  currentAmountDue?: Maybe<Scalars["Int"]>;
  /** DEPRECATE (BL-679): use billing_delinquencies instead */
  currentBillingDelinquency?: Maybe<BillingDelinquency>;
  currentBillingPeriod?: Maybe<BillingPeriod>;
  dateEstablished?: Maybe<Scalars["Time"]>;
  dbaName?: Maybe<Scalars["String"]>;
  /** Indicates if the account has all three of the following account types `CHECKING`, `TREASURY` and `VAULT` */
  ddaEnabled?: Maybe<Scalars["Boolean"]>;
  ddaMigrationState?: Maybe<DDAMigrationState>;
  /** The default funding source, this will be used for automatic collections and scheduled collections where no funding source is explicitly requested */
  defaultFundingSource?: Maybe<FundingSource>;
  /** @deprecated Use bankingAccounts instead */
  depositsAccounts?: Maybe<DepositsAccountConnection>;
  /** Is this account eligible to be converted to the specified card account type */
  eligibleForCardAccountType?: Maybe<AccountEligibleForCardAccountType>;
  embeddedReferral?: Maybe<EmbeddedReferral>;
  /** Employee Count Range from signups */
  employeeCountRange?: Maybe<EmployeeCountRange>;
  /** The enabled funding sources for this account */
  enabledFundingSources?: Maybe<FundingSourceConnection>;
  estimatedNextDueAmount?: Maybe<UpcomingDueAmount>;
  estimatedUpcomingDueAmounts?: Maybe<Array<Maybe<UpcomingDueAmount>>>;
  /** The external accounts the user had when they signed up (e.g. Shopify, Amazon, etc) */
  externalAccounts?: Maybe<Array<Maybe<Scalars["String"]>>>;
  /** Financial Product Type from signups */
  financialProductType?: Maybe<FinancialProductType>;
  financialSources?: Maybe<FinancialSourceConnection>;
  /** This is actually the enabled funding sources, please use enabled_funding_sources field */
  fundingSources?: Maybe<FundingSourceConnection>;
  /** Has the customer selected a funding source for autopay? */
  hasCustomerSelectedAutopayFundingSource: Scalars["Boolean"];
  hasLodgedCards: Scalars["Boolean"];
  /** Returns true if the account has two or more Cash admins */
  hasMultipleCashAdmins?: Maybe<Scalars["Boolean"]>;
  hasProductApplication: Scalars["Boolean"];
  hasTaxpayerNumber?: Maybe<Scalars["Boolean"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  incorporationState?: Maybe<Scalars["String"]>;
  /** Initial market segment from segmentation service */
  initialMarketSegment?: Maybe<Scalars["String"]>;
  /** @deprecated not useful */
  insertedAt?: Maybe<Scalars["Time"]>;
  /** Investment source from signups */
  investmentSource?: Maybe<InvestmentSource>;
  /** Returns true if the account is demo */
  isDemo?: Maybe<Scalars["Boolean"]>;
  /** Whether this account is a Financial Service Partner (FSP) */
  isFsp: Scalars["Boolean"];
  /** Is the account in 'Kill Yellow Tier' experiment's treatment group? */
  isInKillYellowTier?: Maybe<Scalars["Boolean"]>;
  /** Whether the account is part of the SVB cash restriction */
  isInSvbCashRestriction: Scalars["Boolean"];
  /** Whether this account was created internally i.e. from Retool */
  isInternalSignup?: Maybe<Scalars["Boolean"]>;
  /** Is the customer's card journal account on Buy Now Pay Later terms */
  isOnBnplTerms?: Maybe<Scalars["Boolean"]>;
  /** Returns true if the account is onboarded for wallet */
  isOnboardedForWallet?: Maybe<Scalars["Boolean"]>;
  /** Returns true if the account is sandbox */
  isSandbox?: Maybe<Scalars["Boolean"]>;
  /** Submission time of the latest product application for this account */
  latestApprovedProductApplicationSubmittedAt?: Maybe<Scalars["Time"]>;
  legalName?: Maybe<Scalars["String"]>;
  locale?: Maybe<Locale>;
  /** Answers to the business maturity question */
  maturity?: Maybe<Array<Maybe<Scalars["String"]>>>;
  maximumUserInitiatedPaymentAmount?: Maybe<Scalars["Int"]>;
  officeAddress?: Maybe<Address>;
  /** Amount we're currently trying to collect for this customer */
  outstandingCollectionAmount?: Maybe<Scalars["Int"]>;
  /** Partnership integrations of the account. */
  partnershipIntegrations?: Maybe<PartnershipIntegrationConnection>;
  /** Amount of all pending collections for this customer */
  pendingCollectionAmount?: Maybe<Scalars["Int"]>;
  pointsBalanceV2: Scalars["Long"];
  positivePayAccountSettings?: Maybe<PositivePayAccountSettingConnection>;
  /**
   * The line items this customer account has configured for purchase order, invoicing, etc.
   * These can be used for line items in a purchase order or an invoice.
   */
  productOrServiceItems?: Maybe<ItemConnection>;
  /** Account referral code from signup */
  referralCode?: Maybe<Scalars["String"]>;
  /** Returns true if the account requires autopay setup, false if autopay is already set up, or null if autopay setup is not applicable */
  requiresAutopaySetup?: Maybe<Scalars["Boolean"]>;
  rewardsBalance?: Maybe<RewardsBalance>;
  rewardsStatusV2: RewardsStatusV2;
  /** The risk tier of the account */
  riskTier?: Maybe<RiskTier>;
  /** Company monthly sales volume from soft signup payload */
  salesVolume?: Maybe<Scalars["String"]>;
  /** Amount we're currently trying to collect for this customer */
  scheduledCollectionAmount?: Maybe<Scalars["Int"]>;
  /**
   * Duplicated from deposits account level. Retrieves matching transactions
   * for a given customer account
   */
  searchDepositsTransactions?: Maybe<DepositsTransactionConnection>;
  selfServeEmailChangeStatus?: Maybe<SelfServeEmailChangeStatus>;
  /** User's intent for signing up for brex */
  signupIntent?: Maybe<Array<Maybe<Scalars["String"]>>>;
  ssoSettings?: Maybe<SSOSettings>;
  ssoStatus?: Maybe<AccountSSOStatus>;
  status?: Maybe<Scalars["String"]>;
  /** Was the account previously suspended and is now active */
  statusFromSuspendedToActive: Scalars["Boolean"];
  systemSettings?: Maybe<AccountSystemSettings>;
  timezone: Timezone;
  underwriting?: Maybe<UnderwritingAccount>;
  users?: Maybe<UserConnection>;
}

/**  ---[ Extended Types ]------------------ */
export interface AccountautomaticTransferSettingsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

/**  ---[ Extended Types ]------------------ */
export interface AccountbankingAccountsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  orderBy?: InputMaybe<BankingAccountOrder>;
  where?: InputMaybe<BankingAccountWhereInput>;
}

/**  ---[ Extended Types ]------------------ */
export interface AccountbillingPaymentIntentsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  hasCanCashAdvanceTarget?: InputMaybe<Scalars["Boolean"]>;
  hasReceivablesOffersTarget?: InputMaybe<Scalars["Boolean"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

/**  ---[ Extended Types ]------------------ */
export interface AccountbillingPaymentsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  cardPaymentsOnly?: InputMaybe<Scalars["Boolean"]>;
  entityBillingConfigurationIds?: InputMaybe<
    Array<InputMaybe<Scalars["String"]>>
  >;
  first?: InputMaybe<Scalars["Int"]>;
  from?: InputMaybe<Scalars["String"]>;
  last?: InputMaybe<Scalars["Int"]>;
  legalEntitiesLegalEntityIds?: InputMaybe<
    Array<InputMaybe<Scalars["String"]>>
  >;
  productTypes?: InputMaybe<Array<InputMaybe<PaymentProductType>>>;
  scheduledForOrder?: InputMaybe<OrderBy>;
  statuses?: InputMaybe<Array<InputMaybe<PaymentStatus>>>;
  to?: InputMaybe<Scalars["String"]>;
}

/**  ---[ Extended Types ]------------------ */
export interface AccountcashTransactionsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  depositsAccountId?: InputMaybe<Scalars["ID"]>;
  endInitiatedAt?: InputMaybe<Scalars["Time"]>;
  endProcessedAt?: InputMaybe<Scalars["Time"]>;
  endScheduledSendAt?: InputMaybe<Scalars["Time"]>;
  first?: InputMaybe<Scalars["Int"]>;
  isRecurring?: InputMaybe<Scalars["Boolean"]>;
  last?: InputMaybe<Scalars["Int"]>;
  maxAmountUsdCents?: InputMaybe<Scalars["Int"]>;
  minAmountUsdCents?: InputMaybe<Scalars["Int"]>;
  orderBy?: InputMaybe<Array<CashTransactionOrderBy>>;
  origin?: InputMaybe<CashTransactionOrigin>;
  paymentMethod?: InputMaybe<CashTransactionPaymentMethod>;
  recurringScheduleId?: InputMaybe<Scalars["ID"]>;
  searchQuery?: InputMaybe<Scalars["String"]>;
  startInitiatedAt?: InputMaybe<Scalars["Time"]>;
  startProcessedAt?: InputMaybe<Scalars["Time"]>;
  startScheduledSendAt?: InputMaybe<Scalars["Time"]>;
  statuses: Array<CashTransactionStatus>;
  transactionTypes?: InputMaybe<Array<CashTransactionType>>;
}

/**  ---[ Extended Types ]------------------ */
export interface AccountcollectionIntentionsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

/**  ---[ Extended Types ]------------------ */
export interface AccountcontactsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  exactNameMatch?: InputMaybe<Scalars["Boolean"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  searchQuery?: InputMaybe<Scalars["String"]>;
}

/**  ---[ Extended Types ]------------------ */
export interface AccountdepositsAccountsArgs {
  accountTypes?: InputMaybe<Array<InputMaybe<DepositsAccountType>>>;
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  id?: InputMaybe<Scalars["ID"]>;
  last?: InputMaybe<Scalars["Int"]>;
  priority?: InputMaybe<DepositsAccountsPriority>;
  status?: InputMaybe<DepositsAccountStatus>;
}

/**  ---[ Extended Types ]------------------ */
export interface AccounteligibleForCardAccountTypeArgs {
  toCardAccountType: CardAccountType;
}

/**  ---[ Extended Types ]------------------ */
export interface AccountenabledFundingSourcesArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

/**  ---[ Extended Types ]------------------ */
export interface AccountestimatedUpcomingDueAmountsArgs {
  numDays: Scalars["Int"];
}

/**  ---[ Extended Types ]------------------ */
export interface AccountfinancialSourcesArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

/**  ---[ Extended Types ]------------------ */
export interface AccountfundingSourcesArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

/**  ---[ Extended Types ]------------------ */
export interface AccountpartnershipIntegrationsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<PartnershipIntegrationFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

/**  ---[ Extended Types ]------------------ */
export interface AccountpositivePayAccountSettingsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  status?: InputMaybe<PositivePayAccountSettingStatus>;
}

/**  ---[ Extended Types ]------------------ */
export interface AccountproductOrServiceItemsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<ItemFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  sort?: InputMaybe<ItemOrderInput>;
}

/**  ---[ Extended Types ]------------------ */
export interface AccountsearchDepositsTransactionsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  depositsAccountId?: InputMaybe<Scalars["ID"]>;
  endTime?: InputMaybe<Scalars["Time"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  query?: InputMaybe<Scalars["String"]>;
  recurringPaymentId?: InputMaybe<Scalars["ID"]>;
  startTime?: InputMaybe<Scalars["Time"]>;
  status?: InputMaybe<Status>;
}

/**  ---[ Extended Types ]------------------ */
export interface AccountusersArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

/** Enum for the Account Rail */
export enum AccountAddressRail {
  GLOBAL_BANK_TRANSFER = "GLOBAL_BANK_TRANSFER",
  INTERNAL_TRANSFER = "INTERNAL_TRANSFER",
  INVALID = "INVALID",
  MANUAL = "MANUAL",
  SWIFT_WIRE = "SWIFT_WIRE",
  TRADING = "TRADING",
  UNSPECIFIED = "UNSPECIFIED",
  US_ACH = "US_ACH",
  US_CHEQUE = "US_CHEQUE",
  US_WIRE = "US_WIRE",
}

export interface AccountBalanceSummary {
  globalLimit?: Maybe<Scalars["Int"]>;
  remainingSpend?: Maybe<Scalars["Int"]>;
  usedBalance?: Maybe<Scalars["Int"]>;
}

export enum AccountBalanceType {
  CACHED = "CACHED",
  INVALID = "INVALID",
  REAL_TIME_API = "REAL_TIME_API",
}

export type AccountCategories =
  | CsvCategories
  | ExpensifyCategories
  | IntacctCategories
  | NetsuiteCategories
  | OracleFusionCategories
  | QbdCategories
  | QuickbooksCategories
  | SageIntacctCategories
  | WorkdayCategories
  | XeroCategories;

export enum AccountCategory {
  ACCOUNT_CATEGORY_ASSET = "ACCOUNT_CATEGORY_ASSET",
  ACCOUNT_CATEGORY_EQUITY = "ACCOUNT_CATEGORY_EQUITY",
  ACCOUNT_CATEGORY_INCOME = "ACCOUNT_CATEGORY_INCOME",
  ACCOUNT_CATEGORY_INVALID = "ACCOUNT_CATEGORY_INVALID",
  ACCOUNT_CATEGORY_LIABILITY = "ACCOUNT_CATEGORY_LIABILITY",
}

export interface AccountEligibleForCardAccountType {
  isEligible: Scalars["Boolean"];
}

export enum AccountIncorporationTypeInput {
  CORPORATION = "CORPORATION",
  LLC = "LLC",
  OTHER = "OTHER",
  PARTNERSHIP = "PARTNERSHIP",
  SOLE_PROPRIETORSHIP = "SOLE_PROPRIETORSHIP",
}

export interface AccountInstitutionDetails {
  accountNumber?: Maybe<Scalars["String"]>;
  accountType?: Maybe<AccountType>;
  routingNumber?: Maybe<Scalars["String"]>;
}

export interface AccountKycInformation {
  /** Id of verification analysis */
  analysisId?: Maybe<Scalars["String"]>;
  /** Status of 3rd party KYC application */
  kycStatus?: Maybe<AccountKycStatus>;
}

export enum AccountKycStatus {
  APPROVED = "APPROVED",
  DECLINED = "DECLINED",
  INVALID = "INVALID",
  PENDING = "PENDING",
  PENDING_KYC = "PENDING_KYC",
}

export enum AccountLocation {
  DOMESTIC = "DOMESTIC",
  INTERNATIONAL = "INTERNATIONAL",
}

export interface AccountManagementTaskEntityDetails
  extends InboxTaskEntityDetails {
  /** Optional. Whether the task has more granular task statuses. */
  additionalTaskState?: Maybe<AccountManagementTaskState>;
  /**
   * Optional.
   * Used for text: 'Autopay will pull your statement balance from [account] on [date].'
   */
  autopayAccountName?: Maybe<Scalars["String"]>;
  /**
   * Optional.
   * Used for text: 'Autopay will pull your statement balance from [account] on [date].'
   */
  autopayDate?: Maybe<Scalars["Time"]>;
  /**
   * Optional.
   * Used for text: 'Your bill to [X] will be paid on [date]'
   */
  billPaymentSendAt?: Maybe<Scalars["Time"]>;
  /**
   * Optional.
   * Used for text: 'Your bill to [X] will be paid on [date]'
   */
  billVendorName?: Maybe<Scalars["String"]>;
  /** Optional. Detailed state of the card application. Null if there is no card application. Used for unified app task. */
  cardAppState?: Maybe<AccountManagementTaskState>;
  /**
   * Optional.
   * Used for text: 'You should get it in the mail around [Date]'
   */
  cardEstimatedDeliveryDate?: Maybe<Scalars["Time"]>;
  /**
   * Optional.
   * Used for text: 'Your card ending in [XXXX] is all set!'
   */
  cardLast4?: Maybe<Scalars["String"]>;
  /** Optional. Detailed state of the cash application. Null if there is no cash application. Used for unified app task. */
  cashAppState?: Maybe<AccountManagementTaskState>;
  /**
   * Optional. In cents USD
   * Used for text: '$You've got [X] in your account!'
   */
  cashBalance?: Maybe<Scalars["Long"]>;
  /**
   * Optional
   * Used to link to Embedded Partner site to complete integration
   */
  embeddedPartnerIntegrationLink?: Maybe<Scalars["String"]>;
  /**
   * Optional
   * Used for text: 'Add Brex as a payment method in [X]'
   */
  embeddedPartnerName?: Maybe<Scalars["String"]>;
  /** Base64 encoded account ID. */
  encodedEntityId: Scalars["String"];
  /** The account ID. */
  entityId: Scalars["String"];
  /** Whether the task should be displayed or hidden. */
  isHidden: Scalars["Boolean"];
  /**
   * Optional.
   * Used for text: '[X] of your vendors can earn you Brex rewards'
   */
  migratedVendorCount?: Maybe<Scalars["Int"]>;
  /**
   * Optional. In cents USD
   * Used for text: 'You've got a card with a monthly limit of $[XX.XX]!'
   */
  monthlyLimit?: Maybe<Scalars["Long"]>;
  /**
   * Optional.
   * Used for text: 'You've linked Brex to [payroll provider]'
   */
  payrollProvider?: Maybe<Scalars["String"]>;
  /**
   * Optional.
   * Used for text: 'The reimbursements you approve will be paid out [daily/monthly/weekly].'
   */
  reimbursementsBilling?: Maybe<Scalars["String"]>;
  /**
   * Optional
   * Used to return the list of RFIs for the user to complete
   */
  requestForInformationList?: Maybe<Array<Scalars["String"]>>;
  /**
   * Optional.
   * The time an application was submitted, if any.
   */
  submittedAt?: Maybe<Scalars["Time"]>;
  /**
   * Optional.
   * Used for text: 'You have [X] transactions ready to prepare'
   */
  transactionCount?: Maybe<Scalars["Int"]>;
  /** Optional. For deposits-related tasks, the transaction type. Used to estimate processing times. */
  transactionType?: Maybe<TransactionType>;
  /**
   * Optional.
   * Used for text: '[X] users have been added to Brex'
   */
  userCount?: Maybe<Scalars["Int"]>;
}

/** Granular task states for account management surface tasks. */
export enum AccountManagementTaskState {
  APPROVED = "APPROVED",
  DOCUMENTS_REQUESTED = "DOCUMENTS_REQUESTED",
  IN_PROGRESS = "IN_PROGRESS",
  PROCESSING = "PROCESSING",
  REJECTED = "REJECTED",
}

export interface AccountPolicyCurrenciesErrors extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

/** Account level supported policy currencies */
export interface AccountPolicyCurrency {
  currency: Scalars["String"];
  enablementStatus: PolicyCurrencyEnablementStatus;
  fxRate: Scalars["Decimal"];
  fxRateTimestamp: Scalars["LocalDateTime"];
  usageStatus: PolicyCurrencyUsageStatus;
}

/** Currency with enabled status */
export interface AccountPolicyCurrencyWithEnabled {
  currency: Scalars["String"];
  isEnabled: PolicyCurrencyEnablementStatus;
}

export interface AccountPrincipalUserInput {
  email: Scalars["String"];
  firstName: Scalars["String"];
  lastName: Scalars["String"];
  password: Scalars["String"];
}

export enum AccountProvisioningType {
  /** Automatically create/provision a new customer account in the ERP system */
  AUTO_PROVISION = "AUTO_PROVISION",
  /** Use provided credential to connect to existing customer account in ERP */
  EXISTING_ACCOUNT = "EXISTING_ACCOUNT",
}

export enum AccountResourceAttribute {
  EMAIL_CHANGE_SETTING = "EMAIL_CHANGE_SETTING",
}

export interface AccountResourceOperation extends ResourceOperation {
  action: ResourceAction;
  attribute?: Maybe<AccountResourceAttribute>;
}

export interface AccountSSOStatus {
  enabled: Scalars["Boolean"];
}

/** Account settings for a specific account and entity pair */
export interface AccountSetting {
  /** @deprecated Use billingGroup.isPushPayments for local or not, and billingGroup.autoCollectionStatus if autoPay is enabled or disabled */
  collectionMode?: Maybe<CollectionMode>;
}

export enum AccountStatus {
  ACTIVE = "ACTIVE",
  CLOSED = "CLOSED",
  DUPLICATE = "DUPLICATE",
  IGNORED = "IGNORED",
  INELIGIBLE = "INELIGIBLE",
  INVALID = "INVALID",
  STALE = "STALE",
}

export enum AccountSubcategory {
  ACCOUNT_SUBCATEGORY_CASH = "ACCOUNT_SUBCATEGORY_CASH",
  ACCOUNT_SUBCATEGORY_COST = "ACCOUNT_SUBCATEGORY_COST",
  ACCOUNT_SUBCATEGORY_DEBT = "ACCOUNT_SUBCATEGORY_DEBT",
  ACCOUNT_SUBCATEGORY_INVALID = "ACCOUNT_SUBCATEGORY_INVALID",
  ACCOUNT_SUBCATEGORY_INVESTMENT = "ACCOUNT_SUBCATEGORY_INVESTMENT",
  ACCOUNT_SUBCATEGORY_PAYABLE = "ACCOUNT_SUBCATEGORY_PAYABLE",
  ACCOUNT_SUBCATEGORY_RECEIVABLE = "ACCOUNT_SUBCATEGORY_RECEIVABLE",
  ACCOUNT_SUBCATEGORY_RESTRICTED_CASH = "ACCOUNT_SUBCATEGORY_RESTRICTED_CASH",
  ACCOUNT_SUBCATEGORY_REVENUE = "ACCOUNT_SUBCATEGORY_REVENUE",
}

export enum AccountSuperAdminStatus {
  SUPER_ADMIN_ACTIVE = "SUPER_ADMIN_ACTIVE",
  SUPER_ADMIN_MISSING = "SUPER_ADMIN_MISSING",
  SUPER_ADMIN_PENDING = "SUPER_ADMIN_PENDING",
}

export interface AccountSystemSettings {
  bypassFinancialsSetup?: Maybe<Scalars["Boolean"]>;
  monthlyUserLimitRolloutEnabled?: Maybe<Scalars["Boolean"]>;
  showCashUpsell?: Maybe<Scalars["Boolean"]>;
}

export enum AccountType {
  CERTIFICATE_OF_DEPOSIT = "CERTIFICATE_OF_DEPOSIT",
  CHECKING = "CHECKING",
  CREDIT_CARD = "CREDIT_CARD",
  ECOMMERCE_PLATFORM = "ECOMMERCE_PLATFORM",
  ESPP = "ESPP",
  HEALTH_SAVINGS = "HEALTH_SAVINGS",
  INVALID = "INVALID",
  INVESTMENT = "INVESTMENT",
  LINE_OF_CREDIT = "LINE_OF_CREDIT",
  LOAN = "LOAN",
  MONEY_MARKET = "MONEY_MARKET",
  MORTGAGE = "MORTGAGE",
  RETIREMENT = "RETIREMENT",
  SAVINGS = "SAVINGS",
}

/** How the business plans to use Brex Account. */
export enum AccountUsageType {
  BO_DISBURSEMENTS = "BO_DISBURSEMENTS",
  BUSINESS_OPERATIONS = "BUSINESS_OPERATIONS",
  FX_TX = "FX_TX",
  HOLDING_INVESTMENT_CAPITAL = "HOLDING_INVESTMENT_CAPITAL",
  HOLDING_VC_FUNDS = "HOLDING_VC_FUNDS",
  INVESTMENT_ACTIVITIES = "INVESTMENT_ACTIVITIES",
  PAYROLL = "PAYROLL",
  REVENUE_COLLECTION_STORAGE = "REVENUE_COLLECTION_STORAGE",
  SUPPLIER_VENDOR_PAYMENTS = "SUPPLIER_VENDOR_PAYMENTS",
  TRAVEL_AND_EXPENSES = "TRAVEL_AND_EXPENSES",
}

export interface AccountingDefaultIntegrationFieldMappingConnection
  extends Connection {
  edges: Array<AccountingDefaultIntegrationFieldMappingEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"];
}

export interface AccountingDefaultIntegrationFieldMappingEdge {
  cursor?: Maybe<Scalars["String"]>;
  node: DefaultAccountingIntegrationFieldMapping;
}

export interface AccountingExportJobMetadata extends ExportJobMetadata {
  /** The sum of the successfully exported entries for the job grouped by currency type. */
  amountSumsByCurrency?: Maybe<Array<FinancialAsset>>;
  /** The automation rate of the successfully exported entries for the job. */
  automationRate?: Maybe<Scalars["Float"]>;
  /** Number of export entries attempted to be exported for the job. */
  exportEntriesAttemptedCount?: Maybe<Scalars["Int"]>;
  /** Number of export entries successfully exported for the job. */
  exportEntriesSucceededCount?: Maybe<Scalars["Int"]>;
  /** The ExportJobMetadata id. */
  id: Scalars["ID"];
}

/** ACCOUNTING EXPORT OPERATIONS */
export enum AccountingExportResourceAttribute {
  EXPORT_TARGET_DATA = "EXPORT_TARGET_DATA",
}

export interface AccountingExportResourceOperation extends ResourceOperation {
  action: ResourceAction;
  attribute?: Maybe<AccountingExportResourceAttribute>;
}

export enum AccountingFlag {
  /** Indicates conflicting rules were found for this accounting record. */
  CONFLICTING_RULES = "CONFLICTING_RULES",
  /** Custom rules were applied to this accounting record. */
  CUSTOM_RULES_APPLIED = "CUSTOM_RULES_APPLIED",
  /** The accounting record was manually recategorized. */
  MANUALLY_RECATEGORIZED = "MANUALLY_RECATEGORIZED",
  /** The accounting record is missing a GL account. */
  MISSING_GL_ACCOUNT = "MISSING_GL_ACCOUNT",
  /** Required fields are missing in this accounting record. */
  MISSING_REQUIRED_FIELDS = "MISSING_REQUIRED_FIELDS",
  /** Vendor is missing for this accounting record. */
  MISSING_VENDOR = "MISSING_VENDOR",
  /** The expense tied to this accounting record was not previously accrued. */
  NOT_PREVIOUSLY_ACCRUED = "NOT_PREVIOUSLY_ACCRUED",
  /** The expense tied to this accounting record is marked as a personal expense. */
  PERSONAL_EXPENSE = "PERSONAL_EXPENSE",
  /** The expense tied to this accounting record was previously accrued. */
  PREVIOUSLY_ACCRUED = "PREVIOUSLY_ACCRUED",
  /** The expense tied to this accounting record was previously accrued, but changes have been made. */
  PREVIOUSLY_ACCRUED_WITH_CHANGES = "PREVIOUSLY_ACCRUED_WITH_CHANGES",
  /** The expense tied to this accounting record was previously exported. */
  PREVIOUSLY_EXPORTED = "PREVIOUSLY_EXPORTED",
  /** The accounting record was resubmitted for processing. */
  RESUBMITTED = "RESUBMITTED",
  /** The accounting record was sent back for review. */
  SENT_BACK_FOR_REVIEW = "SENT_BACK_FOR_REVIEW",
  /** The expense was split into multiple expenses. */
  SPLIT_EXPENSE = "SPLIT_EXPENSE",
}

export interface AccountingIntegration {
  /** List accounting entity mappings. */
  accountingEntityMappings?: Maybe<Array<EntityMapping>>;
  /**
   * Paginated version of subsidiary settings.
   * For non multi-entity ERPs, we still create a parent subsidiary based on the connected vendor account.
   * Uses subsidiary.id as the unique identifier for pagination.
   */
  accountingSubsidiarySettings: AccountingSubsidiarySettingsConnection;
  /** Read-only, whether accrualsV2 is enabled */
  accrualsV2Enabled: Scalars["Boolean"];
  /** Required, capabilities of the integration supports. */
  capabilities?: Maybe<Array<IntegrationCapability>>;
  /** Required, connection status of the integration. */
  connectionStatus: AccountingIntegrationConnectionStatus;
  /** Required, when this template was created. */
  createdAt: Scalars["Time"];
  /** Required, ID of the vendor credential. */
  credentialId: Scalars["ID"];
  /** Required, export pipe. Pipe to export data from Brex to external ERP */
  exportPipe?: Maybe<ExportPipe>;
  /** Extended field */
  extendedFields?: Maybe<ExtendedFieldConnection>;
  /** A customer's fields that are required for accounting export */
  fieldsRequiredForExport: FieldsRequiredForExportConnection;
  /** List payment account mappings. */
  fundingSourceMappings?: Maybe<Array<EntityMapping>>;
  /** Read-only, multi entity specific details */
  hasConfiguredGLDetails?: Maybe<Scalars["Boolean"]>;
  /** Required, ID of the integration. */
  id: Scalars["ID"];
  /** Required, import pipe. Pipe to import data from external ERP to Brex */
  importPipe?: Maybe<ExportPipe>;
  /** Required, last import/export jobs. */
  lastExportJobs?: Maybe<Array<ExportJob>>;
  /** List mapping classes for this integration with pagination and filters. */
  mappingClasses: MappingClassConnection;
  /** Read-only, multi entity specific details */
  multiEntity?: Maybe<MultiEntity>;
  /** Required, the ID of the extended field option for the parent subsidiary. */
  parentSubsidiaryId: Scalars["String"];
  /** Required, settings on the parent subsidiary. */
  parentSubsidiarySettings: AccountingIntegrationSubsidiarySettings;
  /** Optional, purchase order import pipe. Pipe to import purchase order from external ERP to Brex */
  purchaseOrderImportPipe?: Maybe<ExportPipe>;
  /** Required, when this template was lastly refreshed. */
  refreshedAt: Scalars["Time"];
  /** Settings metadata for the integration. */
  settings: AccountingIntegrationSettings;
  /**
   * Required, settings on each subsidiary.
   * For non multi-entity ERPs, we still create a parent subsidiary for them based on the connected vendor account.
   * @deprecated Use accountingIntegration.accountingSubsidiarySettings instead
   */
  subsidiarySettings?: Maybe<Array<AccountingIntegrationSubsidiarySettings>>;
  /** Required, import/export status of the integration. */
  syncStatus: AccountingIntegrationSyncStatus;
  /** Required, type of the vendor. */
  vendor: AccountingIntegrationVendor;
  /** Optional, to load the credentials tied to the integration */
  vendorCredential?: Maybe<VendorCredential>;
  /** Get the Workflow Rules for this integration by filters */
  workflowRules?: Maybe<WorkflowRuleConnection>;
}

export interface AccountingIntegrationaccountingSubsidiarySettingsArgs {
  after?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<ListAccountingSubsidiarySettingsFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
}

export interface AccountingIntegrationextendedFieldsArgs {
  after?: InputMaybe<Scalars["String"]>;
  filter: ExtendedFieldFilterInput;
  first?: InputMaybe<Scalars["Int"]>;
  sort?: InputMaybe<ExtendedFieldSortByInput>;
}

export interface AccountingIntegrationfieldsRequiredForExportArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

export interface AccountingIntegrationmappingClassesArgs {
  after?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<MappingClassFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  sort?: InputMaybe<MappingClassSortInput>;
}

export interface AccountingIntegrationworkflowRulesArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<ListWorkflowRulesFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

export enum AccountingIntegrationAccrualsEnabledStatus {
  DISABLED = "DISABLED",
  ENABLED = "ENABLED",
}

export enum AccountingIntegrationBillableStatus {
  BILLABLE_TYPE_BILLABLE = "BILLABLE_TYPE_BILLABLE",
  BILLABLE_TYPE_NON_BILLABLE = "BILLABLE_TYPE_NON_BILLABLE",
  BILLABLE_TYPE_NOT_SET = "BILLABLE_TYPE_NOT_SET",
}

/**  ---[ Resource Types ]------------------ */
export interface AccountingIntegrationConnection extends Connection {
  edges: Array<AccountingIntegrationEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export enum AccountingIntegrationConnectionStatus {
  ACTIVE = "ACTIVE",
  DISABLED = "DISABLED",
}

export interface AccountingIntegrationEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<AccountingIntegration>;
}

/**  ---[ Input Types ]--------------------- */
export interface AccountingIntegrationFilterInput {
  /** Optional, filter by connection status. */
  connectionStatus?: InputMaybe<AccountingIntegrationConnectionStatus>;
  /** Optional, filter by vendor. */
  vendor?: InputMaybe<AccountingIntegrationVendor>;
}

export interface AccountingIntegrationIntercompanySettings {
  /**
   * Optional, we do not need to use this field right now.
   * It will become required when we support many-to-many intercompany relationships.
   */
  billingSubsidiary?: Maybe<ExtendedFieldOption>;
  /** Required, EPR specific intercompany settings extension. */
  extension: AccountingIntegrationIntercompanySettingsExtensionUnion;
  /** Required, the spending subsidiary. */
  spendingSubsidiary: ExtendedFieldOption;
}

export interface AccountingIntegrationIntercompanySettingsExtensionOneOfInput {
  netsuiteIntercompanySettingsExtensionInput?: InputMaybe<AccountingIntegrationNetsuiteIntercompanySettingsExtensionInput>;
}

export type AccountingIntegrationIntercompanySettingsExtensionUnion =
  AccountingIntegrationIntercompanySettingsNetsuiteExtension;

export interface AccountingIntegrationIntercompanySettingsInput {
  /**
   * Optional, we do not need to use this field right now.
   * It will become required when we support many-to-many intercompany relationships.
   */
  billingSubsidiaryId?: InputMaybe<Scalars["ID"]>;
  /** Required, must specify the intercompany settings extension to update. */
  intercompanySettingsExtensionInput: AccountingIntegrationIntercompanySettingsExtensionOneOfInput;
  /** Required, ID of the spending subsidiary. */
  spendingSubsidiaryId: Scalars["ID"];
}

export interface AccountingIntegrationIntercompanySettingsNetsuiteExtension {
  /** Optional intercompany settings for Netsuite. */
  cardIntercompanyAccountsPayableUserCategory?: Maybe<ExtendedFieldOption>;
  cardIntercompanyAccountsReceivableUserCategory?: Maybe<ExtendedFieldOption>;
  cardIntercompanyCustomer?: Maybe<ExtendedFieldOption>;
  cardIntercompanyVendor?: Maybe<ExtendedFieldOption>;
  reimbursementIntercompanyAccountsPayableUserCategory?: Maybe<ExtendedFieldOption>;
  reimbursementIntercompanyAccountsReceivableUserCategory?: Maybe<ExtendedFieldOption>;
  reimbursementIntercompanyCustomer?: Maybe<ExtendedFieldOption>;
  reimbursementIntercompanyVendor?: Maybe<ExtendedFieldOption>;
}

export interface AccountingIntegrationMutationError
  extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface AccountingIntegrationNetsuiteIntercompanySettingsExtensionInput {
  /** Netsuite intercompany settings. */
  cardIntercompanyAccountsPayableUserCategoryId?: InputMaybe<Scalars["ID"]>;
  cardIntercompanyAccountsReceivableUserCategoryId?: InputMaybe<Scalars["ID"]>;
  cardIntercompanyCustomerId?: InputMaybe<Scalars["ID"]>;
  cardIntercompanyVendorId?: InputMaybe<Scalars["ID"]>;
  reimbursementIntercompanyAccountsPayableUserCategoryId?: InputMaybe<
    Scalars["ID"]
  >;
  reimbursementIntercompanyAccountsReceivableUserCategoryId?: InputMaybe<
    Scalars["ID"]
  >;
  reimbursementIntercompanyCustomerId?: InputMaybe<Scalars["ID"]>;
  reimbursementIntercompanyVendorId?: InputMaybe<Scalars["ID"]>;
}

export interface AccountingIntegrationNetsuiteSubsidiarySettingsExtensionInput {
  taxPurchaseAccounts?: InputMaybe<
    Array<AccountingIntegrationNetsuiteTaxPurchaseAccountInput>
  >;
}

export interface AccountingIntegrationNetsuiteTaxPurchaseAccount {
  /** Key of the VX field. */
  extendedFieldKey: Scalars["String"];
  /** The VX field option. */
  extendedFieldOption: ExtendedFieldOption;
}

export interface AccountingIntegrationNetsuiteTaxPurchaseAccountInput {
  /** Required, key of the VX field. */
  extendedFieldKey: Scalars["String"];
  /** Required, ID of the VX field option. */
  extendedFieldOptionId: Scalars["ID"];
}

export interface AccountingIntegrationOracleFusionRequiredSegment {
  /** Required, extended field. */
  extendedField: ExtendedField;
  /** Required, extended field option. */
  extendedFieldOption: ExtendedFieldOption;
}

export interface AccountingIntegrationOracleFusionRequiredSegmentInput {
  /** Required, ID of the VX field. */
  extendedFieldId: Scalars["ID"];
  /** Required, ID of the VX field option. */
  extendedFieldOptionId: Scalars["ID"];
}

export interface AccountingIntegrationOracleFusionSubsidiarySettingsExtensionInput {
  /** Oracle fusion specific subsidiary settings. */
  accountsPayableAdditionalRequiredSegments?: InputMaybe<
    Array<AccountingIntegrationOracleFusionRequiredSegmentInput>
  >;
  accruedLiabilityAdditionalRequiredSegments?: InputMaybe<
    Array<AccountingIntegrationOracleFusionRequiredSegmentInput>
  >;
  accruedLiabilityReimbursementAdditionalRequiredSegments?: InputMaybe<
    Array<AccountingIntegrationOracleFusionRequiredSegmentInput>
  >;
  awxWalletAdditionalRequiredSegments?: InputMaybe<
    Array<AccountingIntegrationOracleFusionRequiredSegmentInput>
  >;
  collectionsAdditionalRequiredSegments?: InputMaybe<
    Array<AccountingIntegrationOracleFusionRequiredSegmentInput>
  >;
  ledgerName: Scalars["String"];
  personalExpenseAdditionalRequiredSegments?: InputMaybe<
    Array<AccountingIntegrationOracleFusionRequiredSegmentInput>
  >;
  reimbursementClearingAdditionalRequiredSegments?: InputMaybe<
    Array<AccountingIntegrationOracleFusionRequiredSegmentInput>
  >;
  reimbursementsAdditionalRequiredSegments?: InputMaybe<
    Array<AccountingIntegrationOracleFusionRequiredSegmentInput>
  >;
  rewardsAdditionalRequiredSegments?: InputMaybe<
    Array<AccountingIntegrationOracleFusionRequiredSegmentInput>
  >;
}

export interface AccountingIntegrationSageCreditCardAccount {
  /** The VX field option. */
  extendedFieldOption: ExtendedFieldOption;
}

export interface AccountingIntegrationSageIntacctSubsidiarySettingsExtensionInput {
  /** Export card id that's used for card expenses when creating an entry in Sage Intacct. */
  creditCardExtendedFieldOptionId?: InputMaybe<Scalars["String"]>;
}

export interface AccountingIntegrationSettings {
  /** Optional, whether accruals feature is enabled */
  accrualsEnabled?: Maybe<AccountingIntegrationAccrualsEnabledStatus>;
  /** Optional, auto import settings */
  autoImportSettings?: Maybe<AutoImportSettings>;
  /** Optional, bill pay specific export settings */
  billSettings?: Maybe<BillSettings>;
  /** Optional, whether autosync bills is enabled */
  billsEnabled?: Maybe<Scalars["Boolean"]>;
  /** Optional, the integration settings extensions for ERP */
  extension?: Maybe<AccountingIntegrationSettingsExtensionUnion>;
  /** Optional, Grouping strategy for exporting transactions */
  groupSettings?: Maybe<GroupSettings>;
  /** Optional, whether invoice is auto exported. */
  invoiceExportEnabled?: Maybe<Scalars["Boolean"]>;
  /** Optional, addition fields on the memo */
  memoSettings?: Maybe<MemoSettings>;
  /** Optional, whether purchase orders dropdown for bill matching is enabled */
  purchaseOrdersEnabled?: Maybe<Scalars["Boolean"]>;
  /** Optional, the type for exporting reimbursement card transactions. E.g. JE or VB */
  reimbursementExportType?: Maybe<TransactionExportType>;
  /** Optional, the earliest datetime from when exports can pull transactions. */
  syncFrom?: Maybe<Scalars["Time"]>;
  /** Optional, the type for exporting credit card transactions. E.g. JE or CC */
  transactionExportType?: Maybe<TransactionExportType>;
  /** Required, the vendorAccountId for the ERP. */
  vendorAccountId: Scalars["String"];
  /** Optional, whether vendor is auto exported upon creation. */
  vendorExportEnabled?: Maybe<Scalars["Boolean"]>;
  /** Optional, vendor-specific settings for export behavior. */
  vendorSettings?: Maybe<VendorSettings>;
}

export interface AccountingIntegrationSettingsExtensionOneOfInput {
  netsuiteExtension?: InputMaybe<AccountingIntegrationSettingsNetsuiteExtensionInput>;
  /**
   * Since GraphQL does not directly support union types for input, each input type is optional
   * to represent each type of union.
   *
   * Note that only one of the input types should be provided.
   * The server will validate that only one of the input types is provided.
   */
  workdayExtension?: InputMaybe<AccountingIntegrationSettingsWorkdayExtensionInput>;
}

export type AccountingIntegrationSettingsExtensionUnion =
  | AccountingIntegrationSettingsNetsuiteExtension
  | AccountingIntegrationSettingsQboExtension
  | AccountingIntegrationSettingsUCSVExtension
  | AccountingIntegrationSettingsWorkdayExtension
  | AccountingIntegrationSettingsXeroExtension;

export interface AccountingIntegrationSettingsNetsuiteExtension {
  /**
   * Settings for exporting Card Expenses to the Netsuite Name field.
   * What is exported to the Name field? One of VENDOR,PROJECT,CUSTOMER,EMPLOYEE
   */
  cardExpensesNameFieldTarget?: Maybe<Scalars["String"]>;
  /**
   * Settings for exporting Reimbursements to the Netsuite Name field.
   * What is exported to the Name field? One of VENDOR,PROJECT,CUSTOMER,EMPLOYEE
   */
  reimbursementsNameFieldTarget?: Maybe<Scalars["String"]>;
}

export interface AccountingIntegrationSettingsNetsuiteExtensionInput {
  cardExpensesNameFieldTarget?: InputMaybe<AccountingIntegrationSettingsNetsuiteNameFieldTarget>;
  reimbursementsNameFieldTarget?: InputMaybe<AccountingIntegrationSettingsNetsuiteNameFieldTarget>;
}

export enum AccountingIntegrationSettingsNetsuiteNameFieldTarget {
  CUSTOMER = "CUSTOMER",
  EMPLOYEE = "EMPLOYEE",
  PROJECT = "PROJECT",
  /** When exporting transactions to Netsuite, which of these values is used in the Netsuite Name field. */
  VENDOR = "VENDOR",
}

export interface AccountingIntegrationSettingsQboExtension {
  isBillSyncSupported?: Maybe<Scalars["Boolean"]>;
  /** Required, billpay-related settings extensions */
  subscriptionPlanName?: Maybe<Scalars["String"]>;
  subscriptionStatus?: Maybe<Scalars["String"]>;
}

export interface AccountingIntegrationSettingsUCSVExtension {
  /** The name of the ERP the customer is using */
  erpName?: Maybe<Scalars["String"]>;
}

export interface AccountingIntegrationSettingsWorkdayExtension {
  /** Required Workday-specific settings */
  ledgerType?: Maybe<Scalars["String"]>;
  /** Optional balancing extended field IDs */
  optionalBalancingExtendedFieldIds?: Maybe<Array<ExtendedField>>;
  /** Required balancing extended field ID */
  requiredBalancingExtendedFieldId?: Maybe<ExtendedField>;
}

export interface AccountingIntegrationSettingsWorkdayExtensionInput {
  /** Workday-specific settings */
  ledgerType?: InputMaybe<Scalars["String"]>;
  /** Optional balancing extended field IDs */
  optionalBalancingExtendedFieldIds?: InputMaybe<Array<Scalars["String"]>>;
  /** Required balancing extended field ID */
  requiredBalancingExtendedFieldId?: InputMaybe<Scalars["String"]>;
}

export interface AccountingIntegrationSettingsXeroExtension {
  /** Required, billpay-related settings extensions */
  isBillSyncSupported?: Maybe<Scalars["Boolean"]>;
}

export interface AccountingIntegrationSubsidiaryInput {
  /** Optional, the country of the subsidiary. */
  country?: InputMaybe<Scalars["String"]>;
  /** Required, name of the subsidiary. */
  name: Scalars["String"];
  /** Required, status of the subsidiary, can be active or inactive. */
  status: AccountingIntegrationSubsidiaryStatus;
  /** Required, internal ID of the subsidiary. */
  vendorInternalId: Scalars["String"];
}

export interface AccountingIntegrationSubsidiarySettings {
  /** Optional, GL account settings. */
  accountsPayableUserCategory?: Maybe<ExtendedFieldOption>;
  accruedLiabilityReimbursementUserCategory?: Maybe<ExtendedFieldOption>;
  accruedLiabilityUserCategory?: Maybe<ExtendedFieldOption>;
  awxWalletUserCategory?: Maybe<ExtendedFieldOption>;
  brexReimbursementClearingUserCategory?: Maybe<ExtendedFieldOption>;
  /** This account is used to close Brex card vendor bills and should be treated as a clearing account. */
  cardExpenseClearingUserCategory?: Maybe<ExtendedFieldOption>;
  collectionTargetUserCategory?: Maybe<ExtendedFieldOption>;
  /** Optional, default field mappings */
  defaultIntegrationFieldMappings: AccountingDefaultIntegrationFieldMappingConnection;
  /** Optional, EPR specific subsidiary settings extension. */
  extension?: Maybe<AccountingIntegrationSubsidiarySettingsExtensionUnion>;
  /** ID of the subsidiary settings. Not the same as the subsidiary id. */
  id: Scalars["ID"];
  /** Optional, intercompany settings. */
  intercompanySettings?: Maybe<
    Array<AccountingIntegrationIntercompanySettings>
  >;
  manualPaymentsUserCategory?: Maybe<ExtendedFieldOption>;
  personalExpenseUserCategory?: Maybe<ExtendedFieldOption>;
  /** The GL account that records the proceeds from the sale of physical items. */
  physicalItemIncomeUserCategory?: Maybe<ExtendedFieldOption>;
  reimbursementClearingUserCategory?: Maybe<ExtendedFieldOption>;
  reimbursementUserCategory?: Maybe<ExtendedFieldOption>;
  rewardsIncomeUserCategory?: Maybe<ExtendedFieldOption>;
  /** The GL account that records the proceeds from the sale of service items. */
  serviceItemIncomeUserCategory?: Maybe<ExtendedFieldOption>;
  /** Status of a subsidiary. Enabled/Disabled */
  status?: Maybe<SubsidiaryConnectionStatus>;
  /** Required, the subsidiary object. */
  subsidiary: ExtendedFieldOption;
  /**
   * Tax codes on this subsidiary.
   *
   * Includes enabled and disabled tax codes. Does not include soft-deleted values.
   *
   * Pagination is as per Relay convention
   *  first: number of items to return in a page after the `after` cursor.
   *  after: cursor to start the page at (exclusive).
   *  last: number of items to return in a page prior to the `before` cursor.
   *  before: cursor to end the page at (exclusive).
   */
  taxCodes?: Maybe<TaxCodesConnection>;
  /** How many enabled tax codes on this subsidiary. */
  taxCodesEnabledCount?: Maybe<Scalars["Int"]>;
  /** VAT settings on this subsidiary, at the subsidiary level. */
  vatSettings?: Maybe<VatSettings>;
  visibleGLFields?: Maybe<Array<GLAccountSetting>>;
}

export interface AccountingIntegrationSubsidiarySettingsdefaultIntegrationFieldMappingsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

export interface AccountingIntegrationSubsidiarySettingstaxCodesArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<TaxCodesFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

export interface AccountingIntegrationSubsidiarySettingsExtensionOneOfInput {
  /** Input fields for Netsuite subsidiary settings. */
  netsuiteSubsidiarySettingsExtensionInput?: InputMaybe<AccountingIntegrationNetsuiteSubsidiarySettingsExtensionInput>;
  /** Input fields for Oracle Fusion subsidiary settings. */
  oracleFusionSubsidiarySettingsExtensionInput?: InputMaybe<AccountingIntegrationOracleFusionSubsidiarySettingsExtensionInput>;
  /** Input fields for Sage Intacct subsidiary settings. */
  sageIntacctSubsidiarySettingsExtensionInput?: InputMaybe<AccountingIntegrationSageIntacctSubsidiarySettingsExtensionInput>;
}

export type AccountingIntegrationSubsidiarySettingsExtensionUnion =
  | AccountingIntegrationSubsidiarySettingsNetsuiteExtension
  | AccountingIntegrationSubsidiarySettingsOracleFusionExtension
  | AccountingIntegrationSubsidiarySettingsSageExtension;

export interface AccountingIntegrationSubsidiarySettingsInput {
  /** Update GL account settings, only need to pass in fields that need to be changed. */
  accountsPayableUserCategoryId?: InputMaybe<Scalars["String"]>;
  accruedLiabilityReimbursementUserCategoryId?: InputMaybe<Scalars["String"]>;
  accruedLiabilityUserCategoryId?: InputMaybe<Scalars["String"]>;
  awxWalletUserCategoryId?: InputMaybe<Scalars["String"]>;
  brexReimbursementClearingUserCategoryId?: InputMaybe<Scalars["String"]>;
  cardExpenseClearingUserCategoryId?: InputMaybe<Scalars["String"]>;
  collectionTargetUserCategoryId?: InputMaybe<Scalars["String"]>;
  /** Update intercompany settings. */
  intercompanySettings?: InputMaybe<
    Array<AccountingIntegrationIntercompanySettingsInput>
  >;
  manualPaymentsUserCategoryId?: InputMaybe<Scalars["String"]>;
  personalExpenseUserCategoryId?: InputMaybe<Scalars["String"]>;
  physicalItemIncomeUserCategoryId?: InputMaybe<Scalars["String"]>;
  reimbursementClearingUserCategoryId?: InputMaybe<Scalars["String"]>;
  reimbursementUserCategoryId?: InputMaybe<Scalars["String"]>;
  rewardsIncomeUserCategoryId?: InputMaybe<Scalars["String"]>;
  serviceItemIncomeUserCategoryId?: InputMaybe<Scalars["String"]>;
  /** Update status for a subsidiary */
  status?: InputMaybe<SubsidiaryConnectionStatus>;
  /** Required, ID of the subsidiary. */
  subsidiaryId: Scalars["ID"];
  /** Update ERP specific subsidiary settings. */
  subsidiarySettingsExtensionInput?: InputMaybe<AccountingIntegrationSubsidiarySettingsExtensionOneOfInput>;
}

export interface AccountingIntegrationSubsidiarySettingsNetsuiteExtension {
  taxPurchaseAccounts?: Maybe<
    Array<AccountingIntegrationNetsuiteTaxPurchaseAccount>
  >;
}

export interface AccountingIntegrationSubsidiarySettingsOracleFusionExtension {
  /** Optional subsidiary settings for oracle fusion. */
  accountsPayableAdditionalRequiredSegments?: Maybe<
    Array<AccountingIntegrationOracleFusionRequiredSegment>
  >;
  accruedLiabilityAdditionalRequiredSegments?: Maybe<
    Array<AccountingIntegrationOracleFusionRequiredSegment>
  >;
  accruedLiabilityReimbursementAdditionalRequiredSegments?: Maybe<
    Array<AccountingIntegrationOracleFusionRequiredSegment>
  >;
  awxWalletAdditionalRequiredSegments?: Maybe<
    Array<AccountingIntegrationOracleFusionRequiredSegment>
  >;
  collectionsAdditionalRequiredSegments?: Maybe<
    Array<AccountingIntegrationOracleFusionRequiredSegment>
  >;
  personalExpenseAdditionalRequiredSegments?: Maybe<
    Array<AccountingIntegrationOracleFusionRequiredSegment>
  >;
  reimbursementClearingAdditionalRequiredSegments?: Maybe<
    Array<AccountingIntegrationOracleFusionRequiredSegment>
  >;
  reimbursementsAdditionalRequiredSegments?: Maybe<
    Array<AccountingIntegrationOracleFusionRequiredSegment>
  >;
  rewardsAdditionalRequiredSegments?: Maybe<
    Array<AccountingIntegrationOracleFusionRequiredSegment>
  >;
}

export interface AccountingIntegrationSubsidiarySettingsSageExtension {
  /** Optional, Sage-specific settings */
  creditCardAccount?: Maybe<AccountingIntegrationSageCreditCardAccount>;
}

export enum AccountingIntegrationSubsidiaryStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

export enum AccountingIntegrationSyncStatus {
  EXPORTING = "EXPORTING",
  EXPORT_FAILED = "EXPORT_FAILED",
  IMPORTING = "IMPORTING",
  IMPORT_FAILED = "IMPORT_FAILED",
  SUCCESS = "SUCCESS",
}

export interface AccountingIntegrationUCSVExtensionInput {
  /** The name of the ERP the customer is using */
  erpName?: InputMaybe<Scalars["String"]>;
}

/**  ---[ Enums ]--------------------------- */
export enum AccountingIntegrationVendor {
  CAMPFIRE = "CAMPFIRE",
  CSV = "CSV",
  HANOVER_PARK = "HANOVER_PARK",
  INTACCT = "INTACCT",
  MS365_BC = "MS365_BC",
  MS365_FNO = "MS365_FNO",
  NETSUITE = "NETSUITE",
  ORACLE_FUSION = "ORACLE_FUSION",
  PUZZLE = "PUZZLE",
  QBD = "QBD",
  QBO = "QBO",
  RILLET = "RILLET",
  SAGE_INTACCT = "SAGE_INTACCT",
  WORKDAY = "WORKDAY",
  XERO = "XERO",
}

export interface AccountingJournalBoolValueInput {
  value?: InputMaybe<Scalars["Boolean"]>;
}

export enum AccountingJournalCollectionType {
  REVERSED = "REVERSED",
  SUCCESSFUL = "SUCCESSFUL",
}

export interface AccountingJournalEntriesCount {
  exportedCount?: Maybe<Scalars["Int"]>;
  inReviewCount?: Maybe<Scalars["Int"]>;
  readyForExportCount?: Maybe<Scalars["Int"]>;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface AccountingJournalEntry {
  account: Account;
  entryAttributes?: Maybe<Array<Maybe<AccountingJournalEntryAttribute>>>;
  entryPostedAt?: Maybe<Scalars["Time"]>;
  entrySourceUnion: AccountingJournalEntrySourceUnion;
  entryType: AccountingJournalEntryType;
  /**
   * The export entry associated with the Accounting Journal entry for the current active integration.
   * This will only exist if the entry has been exported.
   */
  exportEntry?: Maybe<AccountingJournalExportEntry>;
  exportedAt?: Maybe<Scalars["Time"]>;
  id: Scalars["ID"];
  reviewStatus: AccountingJournalEntryReviewStatus;
}

export enum AccountingJournalEntryAlert {
  CONFLICTING_RULES = "CONFLICTING_RULES",
  EMPLOYEE_MODIFIED = "EMPLOYEE_MODIFIED",
  MISSING_GL_ACCOUNT = "MISSING_GL_ACCOUNT",
  MISSING_MEMO = "MISSING_MEMO",
  MISSING_RECEIPT = "MISSING_RECEIPT",
  MISSING_REQUIRED_FIELDS = "MISSING_REQUIRED_FIELDS",
  MISSING_VENDOR = "MISSING_VENDOR",
  NO_ALERT = "NO_ALERT",
  OTHER_REASON = "OTHER_REASON",
  PERSONAL_EXPENSE = "PERSONAL_EXPENSE",
  SPLIT_EXPENSE = "SPLIT_EXPENSE",
  TMC_DATA_MISSING = "TMC_DATA_MISSING",
  TMC_DATA_PENDING = "TMC_DATA_PENDING",
  VAT_ELIGIBLE = "VAT_ELIGIBLE",
}

export enum AccountingJournalEntryAttribute {
  REVERTED = "REVERTED",
  SENT_BACK_FOR_REVIEW = "SENT_BACK_FOR_REVIEW",
  /**  TODO(lguan): deprecate */
  VAT_ELIGIBLE = "VAT_ELIGIBLE",
}

/** Rule condition based on accounting journal entry */
export interface AccountingJournalEntryCondition {
  /** Allowed AJE states for rule application */
  allowedStates: Array<RuleApplicationConditionAccountingJournalEntryState>;
}

export interface AccountingJournalEntryConnection extends Connection {
  edges: Array<AccountingJournalEntryEdge>;
  pageInfo: PageInfo;
  /** The sum of the entries' amount separated by currency */
  totalAmounts?: Maybe<Array<FinancialAsset>>;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface AccountingJournalEntryEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<AccountingJournalEntry>;
}

export enum AccountingJournalEntryFieldKeyType {
  ENTRY_POSTED_AT = "ENTRY_POSTED_AT",
}

/**
 * This input is used in both the legacy accountingJournalEntries query and the equivalent query using
 * Universal GQL (i.e. entityRows() and EntityFilterInput)
 */
export interface AccountingJournalEntryFilterInput {
  /** If the accounting record has a parent accrual, i.e. this accounting record is a reversal. */
  accountingRecordHasParentAccrual?: InputMaybe<Scalars["Boolean"]>;
  /** The source id of the accounting record i.e. expense_id, billing_payment_intent_id, etc. */
  accountingRecordSourceIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** The accounting records to fetch based on accounting record status. The default behavior is to fetch active accounting records only. */
  accountingRecordStatus?: InputMaybe<Array<AccountingRecordStatus>>;
  /** The type of the accounting record. */
  accountingRecordTypes?: InputMaybe<Array<AccountingRecordType>>;
  /** Accrual status for an accounting record. */
  accrualStatus?: InputMaybe<Array<AccountingRecordAccrualStatus>>;
  accruedAfter?: InputMaybe<Scalars["Time"]>;
  /** Filters for ERP posting (accrued at) date */
  accruedBefore?: InputMaybe<Scalars["Time"]>;
  budgetIds?: InputMaybe<Array<Scalars["ID"]>>;
  /**
   * Accepts a list of category IDs or nulls.
   * If null is provided, AJEs with no category ID will also be returned alongside AJEs matching the provided IDs.
   */
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
  collectionTypes?: InputMaybe<Array<AccountingJournalCollectionType>>;
  /**
   * Accepts a list of department IDs or nulls.
   * If null is provided, AJEs with no department ID will also be returned alongside AJEs matching the provided IDs.
   */
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
  /**
   * Matches transactions that belong to specific budgets or budgets that are descendants of the specified budgets.
   * If null is provided inside the list, will also return AJEs with no budget.
   */
  descendantFromBudgetIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
  employeeIds?: InputMaybe<Array<Scalars["ID"]>>;
  endDate?: InputMaybe<Scalars["Time"]>;
  entryAlerts?: InputMaybe<Array<AccountingJournalEntryAlert>>;
  entryAttributes?: InputMaybe<Array<AccountingJournalEntryAttribute>>;
  entryTypes?: InputMaybe<Array<AccountingJournalEntryType>>;
  expenseComplianceStatuses?: InputMaybe<
    Array<AccountingJournalExpenseComplianceStatus>
  >;
  /** Payment status of the expense. Non-Expense Accounting Records will not be included */
  expensePaymentStatuses?: InputMaybe<Array<ExpensePaymentStatusType>>;
  expenseStatuses?: InputMaybe<Array<AccountingJournalExpenseStatus>>;
  expenseTypes?: InputMaybe<Array<AccountingJournalExpenseType>>;
  /** Export entry status for a transaction. Must be set with export job ids for now. */
  exportEntryStatuses?: InputMaybe<Array<AccountingJournalExportEntryStatus>>;
  /** Export job ids to fetch associated transactions for. */
  exportJobIds?: InputMaybe<Array<Scalars["ID"]>>;
  exportedAfter?: InputMaybe<Scalars["Time"]>;
  /** Filters for exported date */
  exportedBefore?: InputMaybe<Scalars["Time"]>;
  glAccountIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Filter by the financial asset instrument codes only (e.g. USD, JPY, etc...) */
  instrumentCodes?: InputMaybe<Array<FinancialInstrumentCode>>;
  /** The Integration ID to list records for. */
  integrationId?: InputMaybe<Scalars["ID"]>;
  integrationRuleIds?: InputMaybe<Array<Scalars["ID"]>>;
  isRewardType?: InputMaybe<Scalars["Boolean"]>;
  legalEntityIds?: InputMaybe<Array<Scalars["ID"]>>;
  /**
   * Filter by the lodge card status of the transactions (i.e. is the transaction from a lodge card or not)
   * If null is provided, all transactions are included regardless of the lodge card status
   */
  lodgeCardStatuses?: InputMaybe<Array<LodgeCardStatus>>;
  /** The max expense or source expense invariant amount, inclusive. */
  maxAmount?: InputMaybe<FinancialAssetInput>;
  merchantCategoryIds?: InputMaybe<Array<Scalars["ID"]>>;
  merchantIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** The min expense or source expense invariant amount, inclusive. */
  minAmount?: InputMaybe<FinancialAssetInput>;
  purchasedAfter?: InputMaybe<Scalars["Time"]>;
  /** Filters for transaction date */
  purchasedBefore?: InputMaybe<Scalars["Time"]>;
  reviewStatus?: InputMaybe<Array<AccountingJournalEntryReviewStatus>>;
  searchQuery?: InputMaybe<Scalars["String"]>;
  /** The source id of the Accounting Journal Entry. */
  sourceIds?: InputMaybe<Array<Scalars["ID"]>>;
  startDate?: InputMaybe<Scalars["Time"]>;
  /**
   * Accepts a list of vendor IDs or nulls.
   * If null is provided, AJEs with no vendor ID will also be returned alongside AJEs matching the provided IDs.
   */
  vendorIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
  /**
   * Inputs with different keys are AND'd together. If key is set and no value is provided. Filters for entries missing
   * that key.
   */
  vxValueFilters?: InputMaybe<Array<AccountingVxValueFilterInput>>;
  /** Filters for entries that have the workflow rules applied to them. */
  workflowRuleIds?: InputMaybe<Array<Scalars["ID"]>>;
}

export enum AccountingJournalEntryReviewStatus {
  EXPORTED = "EXPORTED",
  EXPORTING = "EXPORTING",
  INCOMPLETE = "INCOMPLETE",
  IN_REVIEW = "IN_REVIEW",
  READY_FOR_EXPORT = "READY_FOR_EXPORT",
}

export type AccountingJournalEntrySourceUnion =
  | AccountingRecord
  | BillingPaymentIntent
  | Expense
  | StatementEntry;

export enum AccountingJournalEntryType {
  ACCOUNTING_RECORD = "ACCOUNTING_RECORD",
  BILLING_PAYMENT_INTENT = "BILLING_PAYMENT_INTENT",
  EXPENSE = "EXPENSE",
  /**  Will be deprecated with PSTE deprecation. */
  STE_COLLECTION = "STE_COLLECTION",
  /**  Will be deprecated with PSTE deprecation. */
  STE_REWARD = "STE_REWARD",
}

export interface AccountingJournalEnumValueInput {
  value?: InputMaybe<Scalars["String"]>;
}

export enum AccountingJournalExpenseComplianceStatus {
  COMPLETED = "COMPLETED",
  DUE = "DUE",
  OVERDUE = "OVERDUE",
}

/**  excludes Expense Statuses that won't have associated AJ Entries (DRAFT, VOID, CANCELLED) */
export enum AccountingJournalExpenseStatus {
  APPROVED = "APPROVED",
  OUT_OF_POLICY = "OUT_OF_POLICY",
  SETTLED = "SETTLED",
  SUBMITTED = "SUBMITTED",
}

/**  TMC expenses only match the TMC_* expense types */
export enum AccountingJournalExpenseType {
  CASH_ADVANCE = "CASH_ADVANCE",
  CHARGEBACK = "CHARGEBACK",
  COMPLETE = "COMPLETE",
  REFUNDED = "REFUNDED",
  REIMBURSEMENT = "REIMBURSEMENT",
  REPAYMENT = "REPAYMENT",
  TMC_CHARGEBACK = "TMC_CHARGEBACK",
  TMC_COMPLETE = "TMC_COMPLETE",
  TMC_REFUNDED = "TMC_REFUNDED",
}

export interface AccountingJournalExportEntry {
  /** ERP external id. If not set, then no associated external id exists. */
  externalReferenceId?: Maybe<Scalars["String"]>;
  /** ERP target link. If not set, then no associated link exists. */
  externalReferenceLink?: Maybe<Scalars["String"]>;
  /** ID of the export entry. */
  id: Scalars["ID"];
}

export enum AccountingJournalExportEntryStatus {
  FAILED = "FAILED",
  SUCCESS = "SUCCESS",
}

export enum AccountingJournalExportNotificationType {
  EMAIL = "EMAIL",
  INVALID = "INVALID",
}

export enum AccountingJournalExportType {
  CSV = "CSV",
  CSV_INTACCT_JE = "CSV_INTACCT_JE",
  DIRECT = "DIRECT",
  IIF = "IIF",
}

export interface AccountingJournalExtendedFieldValueInput {
  /**
   * Metadata for the EFV related to Extensible Workflow Rules.
   * This should be passed only when the EFV is set by a Extensible Workflow Rule (e.g. when a user manually resolves an
   * existing conflict, the ruleId should be maintained but hasConflict should be set to false)
   */
  extensibleWorkflowMetadata?: InputMaybe<ExtensibleWorkflowMetadataInput>;
  isDeleted?: InputMaybe<Scalars["Boolean"]>;
  key: Scalars["String"];
  values?: InputMaybe<Array<InputMaybe<AccountingJournalFieldValueInputUnion>>>;
}

/**
 * Acts as an input union depending on which field is not NULL
 * One field is required to be set
 */
export interface AccountingJournalFieldValueInputUnion {
  expenseBoolValueInput?: InputMaybe<AccountingJournalBoolValueInput>;
  expenseEnumValueInput?: InputMaybe<AccountingJournalEnumValueInput>;
  expenseIdentifierToStringValueInput?: InputMaybe<AccountingJournalIdentifierToStringValueInput>;
  expenseNumberValueInput?: InputMaybe<AccountingJournalNumberValueInput>;
  expenseStringValueInput?: InputMaybe<AccountingJournalStringValueInput>;
}

export interface AccountingJournalIdentifierToStringValueInput {
  displayName?: InputMaybe<Scalars["String"]>;
  identifier?: InputMaybe<Scalars["ID"]>;
}

export interface AccountingJournalIntegrationFieldInput {
  /** Required field, external integration field ID. */
  fieldId: Scalars["ID"];
  /** Required field, external integration entity ID. */
  fieldValue: Scalars["ID"];
}

export interface AccountingJournalNumberValueInput {
  value?: InputMaybe<Scalars["Decimal"]>;
}

export enum AccountingJournalReportFormatType {
  CSV = "CSV",
  TXT = "TXT",
  XLSX = "XLSX",
}

export interface AccountingJournalSortInput {
  order: OrderByDirection;
  sortKey: AccountingJournalEntryFieldKeyType;
}

export interface AccountingJournalStartIntegrationExportInput {
  csvTemplateId?: InputMaybe<Scalars["ID"]>;
  displayTime: Scalars["Time"];
  /**
   * [oneOf] Entity Filter to use when querying against UGQL (queries service) for finding objects to export.
   *          the resulting filter proto will match what's created when using the same filter in UGQL entityRows() query.
   * Only one of [filter, entityFilter, sourceIds] can be specified. An exception will be thrown if none or multiple are passed.
   */
  entityFilter?: InputMaybe<EntityFilterInput>;
  exportType: AccountingJournalExportType;
  /**
   * [oneOf] Accounting Journal filter used to find objects to export. NOTE: new uses cases should use entityFilter over filter
   * Only one of [filter, entityFilter, sourceIds] can be specified. An exception will be thrown if none or multiple are passed.
   */
  filter?: InputMaybe<AccountingJournalEntryFilterInput>;
  isPrimitive?: InputMaybe<Scalars["Boolean"]>;
  notificationType?: InputMaybe<AccountingJournalExportNotificationType>;
  /**
   * [oneOf] The specific source object IDs to export
   * Only one of [filter, entityFilter, sourceIds] can be specified. An exception will be thrown if none or multiple are passed.
   */
  sourceIds?: InputMaybe<Array<Scalars["ID"]>>;
  statementEntryTypes?: InputMaybe<Array<Scalars["String"]>>;
}

export interface AccountingJournalStartIntegrationExportPayload {
  exportAttemptId?: Maybe<Scalars["ID"]>;
}

export interface AccountingJournalStringValueInput {
  value?: InputMaybe<Scalars["String"]>;
}

/**  ---[ Input Types ]--------------------- */
export interface AccountingJournalUpdateAccountingRecordsInput {
  /**
   * [oneOf] Filter to find accounting records to update.
   * Exactly one of [filter, entityFilter, accountingRecordFilter] must be specified.
   * An exception will be thrown if none or multiple are passed.
   */
  accountingRecordFilter?: InputMaybe<AccountingRecordFilterInput>;
  /** Overrides the accrual reversal date. */
  accrualOverrideDate?: InputMaybe<Scalars["Time"]>;
  /**
   * The accrual status. When set will update the accounting record accrual status and the
   * reversal date to the date specified by the integration setting (or the override date if set)
   */
  accrualStatus?: InputMaybe<AccountingRecordAccrualStatus>;
  /** The booked accounting time for this accounting event. This field is ignored when null. */
  accruedAt?: InputMaybe<Scalars["Time"]>;
  /**
   * [oneOf] Entity Filter to use when querying against UGQL (queries service)
   *         the resulting filter proto will match what's created when using the same filter in UGQL entityRows() query.
   * Exactly one of [filter, entityFilter, accountingRecordFilter] must be specified.
   * An exception will be thrown if none or multiple are passed.
   */
  entityFilter?: InputMaybe<EntityFilterInput>;
  /**
   * [oneOf] Accounting Journal filter to use. NOTE: new uses cases should use entityFilter over filter
   * Exactly one of [filter, entityFilter, accountingRecordFilter] must be specified.
   * An exception will be thrown if none or multiple are passed.
   */
  filter?: InputMaybe<AccountingJournalEntryFilterInput>;
  /** The integration ID. */
  integrationId: Scalars["ID"];
}

/**  ---[ Resource Types ]------------------ */
export interface AccountingJournalUpdateAccountingRecordsResult {
  /** Some accounting records updated by this operation, filtered by ID. */
  accountingRecords: Array<AccountingRecord>;
  /** The number of accounting records updated by this operation. */
  updatedAccountingRecordCount: Scalars["Int"];
}

/**  ---[ Resource Types ]------------------ */
export interface AccountingJournalUpdateAccountingRecordsResultaccountingRecordsArgs {
  ids: Array<Scalars["ID"]>;
}

export interface AccountingJournalUpdateExpensesInput {
  /**
   * [oneOf] Filter to find accounting records to update.
   * Exactly one of [filter, entityFilter, accountingRecordFilter] must be specified.
   * An exception will be thrown if none or multiple are passed.
   */
  accountingRecordFilter?: InputMaybe<AccountingRecordFilterInput>;
  /** Optional, a budget ID to set for all matching expenses. */
  budgetId?: InputMaybe<Scalars["ID"]>;
  /**
   * [oneOf] Entity Filter to use when querying against UGQL (queries service)
   * the resulting filter proto will match what's created when using the same filter in UGQL entityRows() query.
   * Exactly one of [filter, entityFilter, accountingRecordFilter] must be specified.
   * An exception will be thrown if none or multiple are passed.
   */
  entityFilter?: InputMaybe<EntityFilterInput>;
  /** Optional, extended field values to set for all matching expenses. */
  extendedFieldValues?: InputMaybe<
    Array<AccountingJournalExtendedFieldValueInput>
  >;
  /**
   * [oneOf] Accounting Journal filter to use. NOTE: new uses cases should use entityFilter over filter
   * Exactly one of [filter, entityFilter, accountingRecordFilter] must be specified.
   * An exception will be thrown if none or multiple are passed.
   */
  filter?: InputMaybe<AccountingJournalEntryFilterInput>;
  /** Optional, integration field values to set for all matching expenses. */
  integrationFields?: InputMaybe<Array<AccountingJournalIntegrationFieldInput>>;
  /** The integration ID. */
  integrationId: Scalars["ID"];
  /** Optional, a memo to set for all matching expenses. */
  memo?: InputMaybe<Scalars["String"]>;
  /**
   * Optional, a user category ID to set for all matching expenses. Can send "CLEAR_OVERRIDE" to clear the current
   * override.
   */
  userCategoryId?: InputMaybe<Scalars["ID"]>;
  /**
   * Optional, the Accounting Record IDs visible on the current page.
   * The provided ARs will be synchronously "refreshed" - meaning fields inherited from the expense (e.g. Debit GL)
   * will be up to date without waiting for the AR event consumer.
   */
  visibleAccountingRecordIds?: InputMaybe<Array<Scalars["ID"]>>;
}

export interface AccountingJournalUpdateExpensesResult {
  /** Some expenses updated by this operation, filtered by ID. */
  expenses: Array<Expense>;
  /** The number of expenses updated by this operation. */
  updatedExpenseCount: Scalars["Int"];
  /**
   * Accounting Records visible on the current page that reflect any updates to the underlying Expenses
   * Will be empty if `visibleAccountingRecordIds` was not provided in the AccountingJournalUpdateExpensesInput
   */
  visibleAccountingRecords: Array<AccountingRecord>;
}

export interface AccountingJournalUpdateExpensesResultexpensesArgs {
  ids: Array<Scalars["ID"]>;
}

export enum AccountingMethodType {
  ACCRUAL = "ACCRUAL",
  ACTUAL = "ACTUAL",
}

/** An accounting record. */
export interface AccountingRecord extends ExtensibleEntity {
  /** The Customer Account that has visibility to this accounting record. */
  account: Account;
  /** The list of flags associated with this accounting record. */
  accountingFlags?: Maybe<Array<AccountingFlag>>;
  /** The accrual date of the accounting event if marked for accrual. */
  accrualReversalDate?: Maybe<Scalars["Time"]>;
  /** The status of the accrual if marked for accrual */
  accrualStatus?: Maybe<AccountingRecordAccrualStatus>;
  /** The booked accounting time for this accounting event. This is the time the accounting event was accrued in the ledger. */
  accruedAt: Scalars["Time"];
  /** The accured Accounting Record parent at the version it was last exported at. */
  accruedParentAtLastExportedVersion?: Maybe<AccountingRecord>;
  /**
   * Represents the balanced value of the double entry bookkeeping event, i.e., the sum of all debit line amounts equals the sum of all credit line amounts.
   * The amount of the source transaction ��� e.g. expense billing amount, card collection collected amount
   * May be negative
   */
  amount: FinancialAsset;
  automationWorkflowActions?: Maybe<AutomationWorkflowActionConnection>;
  /**
   * The export entry associated with the Accounting Journal entry for the current active integration.
   * This will only exist if the entry has been exported.
   */
  exportEntry?: Maybe<AccountingJournalExportEntry>;
  /** The time the accounting record was exported. Null if the accounting record has not been exported. */
  exportedAt?: Maybe<Scalars["Time"]>;
  extendedFieldInstance?: Maybe<ExtendedFieldInstance>;
  extendedFieldInstances?: Maybe<ExtendedFieldInstanceConnection>;
  /** The unique ID of the accounting record. */
  id: Scalars["ID"];
  /** The time the record was created. */
  insertedAt: Scalars["Time"];
  /** Named attributes associated with the accounting record (e.g. SENT_BACK_FOR_REVIEW, REVERTED, etc.) */
  journalEntryAttributes?: Maybe<Array<AccountingJournalEntryAttribute>>;
  /** The individual line items for a double entry bookkeeping event. */
  lineItems: AccountingRecordLineItemConnection;
  /** AR is locked based on AJE status, the default status is UNLOCKED */
  lockStatus?: Maybe<AccountingRecordLockedStatus>;
  /**
   * The id of the parent Accounting Record for accrued Accounting Records. This only exists for Accounting Records that
   * were reversed due to an accrual.
   */
  parentAccruedAccountingRecordId?: Maybe<Scalars["ID"]>;
  /** The review status of the accounting record. */
  reviewStatus: AccountingJournalEntryReviewStatus;
  /** The Workflow Rule evaluation status for this Accounting Record. */
  ruleEvaluationStatus: RuleEvaluationStatus;
  /** The source of the accounting record. */
  source?: Maybe<AccountingRecordSourceUnion>;
  /** The actual time the transaction that triggered this accounting event happened. I.e. For card expenses it is the time the card transaction was posted. */
  sourceTransactedAt: Scalars["Time"];
  /** The accounting record status. */
  status?: Maybe<AccountingRecordStatus>;
  /** Represents the type of accounting event captured by the accounting record data model */
  type: AccountingRecordType;
  /** The recently updated time. */
  updatedAt: Scalars["Time"];
  /** The accounting record version. */
  version?: Maybe<Scalars["Int"]>;
  /**
   * The source of the accounting record at the specific source version of this accounting record.
   * Currently only supported for expense source types.
   */
  versionedSource?: Maybe<AccountingRecordVersionedSourceUnion>;
}

/** An accounting record. */
export interface AccountingRecordautomationWorkflowActionsArgs {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
}

/** An accounting record. */
export interface AccountingRecordextendedFieldInstanceArgs {
  id: Scalars["ID"];
}

/** An accounting record. */
export interface AccountingRecordextendedFieldInstancesArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<ExtendedFieldFilterConditionInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

export enum AccountingRecordAccrualStatus {
  /** An accounting record that has not been marked for accrual. */
  ACTUAL = "ACTUAL",
  /** An accounting record that has been marked for accrual but not reversed yet. */
  PENDING = "PENDING",
  /** An accrued accounting record that has been reversed on it's associated reversal date (i.e. a new reversal AR has been created). */
  REVERSED = "REVERSED",
}

export interface AccountingRecordConnection extends Connection {
  edges: Array<AccountingRecordEdge>;
  /** The end date of the range of Accounting Records matching the filter */
  endDate?: Maybe<Scalars["Time"]>;
  pageInfo: PageInfo;
  /** The start date of the range of Accounting Records matching the filter */
  startDate?: Maybe<Scalars["Time"]>;
  /** The sum of the Records' amount separated by currency */
  totalAmounts?: Maybe<Array<FinancialAsset>>;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface AccountingRecordEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<AccountingRecord>;
}

/** The queryable fields of Accounting Records. Used for grouping/aggregations/sorting */
export enum AccountingRecordFieldKeyType {
  ACCRUED_AT = "ACCRUED_AT",
  ALL = "ALL",
  ENTRY_POSTED_AT = "ENTRY_POSTED_AT",
  /**  Expense Field Keys */
  EXPENSE_BUDGET = "EXPENSE_BUDGET",
  EXPENSE_BUDGET_NAME = "EXPENSE_BUDGET_NAME",
  EXPENSE_CUSTOMER_USER_ID = "EXPENSE_CUSTOMER_USER_ID",
  EXPENSE_FUNDING_ENTITY = "EXPENSE_FUNDING_ENTITY",
  EXPENSE_MEMO = "EXPENSE_MEMO",
  EXPENSE_SPENDING_ENTITY = "EXPENSE_SPENDING_ENTITY",
  EXPENSE_USER_FIRST_NAME = "EXPENSE_USER_FIRST_NAME",
  EXPENSE_USER_LAST_NAME = "EXPENSE_USER_LAST_NAME",
  EXPENSE_VENDOR_CATEGORY = "EXPENSE_VENDOR_CATEGORY",
  EXPENSE_VENDOR_CATEGORY_NAME = "EXPENSE_VENDOR_CATEGORY_NAME",
  EXPENSE_VENDOR_ID = "EXPENSE_VENDOR_ID",
  EXPENSE_VENDOR_NAME = "EXPENSE_VENDOR_NAME",
  SOURCE_TRANSACTED_AT = "SOURCE_TRANSACTED_AT",
  TYPE = "TYPE",
}

export interface AccountingRecordFieldKeyTypeWrapper {
  key: AccountingRecordFieldKeyType;
}

export interface AccountingRecordFieldSortKeyInput {
  /**
   * Required when used in Aggregate! Otherwise, can leave this empty
   * alias for the caller to identify the aggregate in the response
   */
  alias?: InputMaybe<Scalars["String"]>;
  /** Field key used in filter, group by, sort or aggregation */
  key: AccountingRecordSortKey;
}

/** Filtering of AccountingRecords using "Equal" and "In" conditions. Based on AccountingJournalEntryFilterInput. */
export interface AccountingRecordFilterCondition {
  /**
   * Various Accounting related conditions to filter Accounting Records by (e.g. MISSING_GL_ACCOUNT, RESUBMITTED)
   * These match up with the flags displayed in the "Accounting Flags" column of Accounting Journal
   */
  accountingFlags?: InputMaybe<Array<AccountingFlag>>;
  /** If the accounting record has a parent accrual, i.e. this accounting record is a reversal. */
  accountingRecordHasParentAccrual?: InputMaybe<Scalars["Boolean"]>;
  /** The source id of the accounting record i.e. expense_id, billing_payment_intent_id, etc. */
  accountingRecordSourceIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** The accounting records to fetch based on accounting record status. The default behavior is to fetch active accounting records only. */
  accountingRecordStatus?: InputMaybe<Array<AccountingRecordStatus>>;
  /** The type of the accounting record. */
  accountingRecordTypes?: InputMaybe<Array<AccountingRecordType>>;
  /** Accrual status for an accounting record. */
  accrualStatus?: InputMaybe<Array<AccountingRecordAccrualStatus>>;
  accruedAfter?: InputMaybe<Scalars["Time"]>;
  /** Filters for ERP posting (accrued at) date */
  accruedBefore?: InputMaybe<Scalars["Time"]>;
  budgetIds?: InputMaybe<Array<Scalars["ID"]>>;
  /**
   * Accepts a list of category IDs or nulls.
   * If null is provided, ARs with no category ID will also be returned alongside ARs matching the provided IDs.
   */
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
  /**
   * Accepts a list of department IDs or nulls.
   * If null is provided, ARs with no department ID will also be returned alongside ARs matching the provided IDs.
   */
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
  /**
   * Matches transactions that belong to specific budgets or budgets that are descendants of the specified budgets.
   * If null is provided inside the list, will also return ARs with no budget.
   */
  descendantFromBudgetIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
  employeeIds?: InputMaybe<Array<Scalars["ID"]>>;
  endDate?: InputMaybe<Scalars["Time"]>;
  /** DEPRECATED - use accountingFlags instead */
  entryAlerts?: InputMaybe<Array<AccountingJournalEntryAlert>>;
  /** DEPRECATED - use accountingFlags instead */
  entryAttributes?: InputMaybe<Array<AccountingJournalEntryAttribute>>;
  entryTypes?: InputMaybe<Array<AccountingJournalEntryType>>;
  expenseComplianceStatuses?: InputMaybe<
    Array<AccountingJournalExpenseComplianceStatus>
  >;
  /** Payment status of the expense. Non-Expense Accounting Records will not be included */
  expensePaymentStatuses?: InputMaybe<Array<ExpensePaymentStatusType>>;
  expenseStatuses?: InputMaybe<Array<AccountingJournalExpenseStatus>>;
  /** Export entry status for a transaction. Must be set with export job ids for now. */
  exportEntryStatuses?: InputMaybe<Array<AccountingJournalExportEntryStatus>>;
  /** Export job ids to fetch associated transactions for. */
  exportJobIds?: InputMaybe<Array<Scalars["ID"]>>;
  exportedAfter?: InputMaybe<Scalars["Time"]>;
  /** Filters for exported date */
  exportedBefore?: InputMaybe<Scalars["Time"]>;
  /** Filter by the financial asset instrument codes only (e.g. USD, JPY, etc...) */
  instrumentCodes?: InputMaybe<Array<FinancialInstrumentCode>>;
  /** The Integration ID to list records for. */
  integrationId?: InputMaybe<Scalars["ID"]>;
  legalEntityIds?: InputMaybe<Array<Scalars["ID"]>>;
  /**
   * Filter by the lodge card status of the transactions (i.e. is the transaction from a lodge card or not)
   * If null is provided, all transactions are included regardless of the lodge card status
   */
  lodgeCardStatuses?: InputMaybe<Array<LodgeCardStatus>>;
  /** The max expense or source expense invariant amount, inclusive. */
  maxAmount?: InputMaybe<FinancialAssetInput>;
  /** The min expense or source expense invariant amount, inclusive. */
  minAmount?: InputMaybe<FinancialAssetInput>;
  purchasedAfter?: InputMaybe<Scalars["Time"]>;
  /** Filters for transaction date */
  purchasedBefore?: InputMaybe<Scalars["Time"]>;
  reviewStatus?: InputMaybe<Array<AccountingJournalEntryReviewStatus>>;
  searchQuery?: InputMaybe<Scalars["String"]>;
  /** The source id of the Accounting Journal Entry. */
  sourceIds?: InputMaybe<Array<Scalars["ID"]>>;
  startDate?: InputMaybe<Scalars["Time"]>;
  /**
   * Accepts a list of vendor IDs or nulls.
   * If null is provided, ARs with no vendor ID will also be returned alongside ARs matching the provided IDs.
   */
  vendorIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
  /**
   * Inputs with different keys are AND'd together. If key is set and no value is provided. Filters for entries missing
   * that key.
   */
  vxValueFilters?: InputMaybe<Array<AccountingVxValueFilterInput>>;
  /** Filters for entries that have the workflow rules applied to them. */
  workflowRuleIds?: InputMaybe<Array<Scalars["ID"]>>;
}

/**
 * Specifies the filter condition to apply to query an AccountingRecord. The filter condition can be recursively defined to optionally
 * chained nested ANDs/ORs together.
 *
 * Only one of the fields may be defined in this input filter condition. If more than one field is defined, the query will fail.
 */
export interface AccountingRecordFilterConditionOneOf {
  /** The list of filters to AND together */
  and?: InputMaybe<Array<AccountingRecordFilterInput>>;
  /** The entity filter to apply */
  filterCondition?: InputMaybe<AccountingRecordFilterCondition>;
  /** The list of filters to OR together */
  or?: InputMaybe<Array<AccountingRecordFilterInput>>;
}

/**
 * The filter input for the accountingRecords query. The filter can be recursively defined to optionally chain nested
 * ANDs/ORs together. Based on the one from Business Intelligence's entityRows
 */
export interface AccountingRecordFilterInput {
  /** The filters to apply when querying */
  filter: AccountingRecordFilterConditionOneOf;
  /** Specify negate to optionally "NOT" the query filter */
  negate?: InputMaybe<Scalars["Boolean"]>;
}

/** An accounting record line item. */
export interface AccountingRecordLineItem extends ExtensibleEntity {
  /**
   * Represents the delta between the AR Line item itself at the time of being locked and the AR Line item adjusting entry on which rules and manual overrides continue to be applied.
   * They reflect line item values changes only. An empty list of changes means there are no differences in line items value mappings between the locked AR and unlocked AR.
   */
  adjustingChanges?: Maybe<AdjustingChanges>;
  /** Amount in original currency; always positive value. */
  amount: FinancialAsset;
  extendedFieldInstance?: Maybe<ExtendedFieldInstance>;
  extendedFieldInstances?: Maybe<ExtendedFieldInstanceConnection>;
  /** The extended field values on an accounting record */
  extendedFieldValues?: Maybe<ExtendedFieldValueConnection>;
  /** Flags to indicate specific conditions of an ARLI that are shown to the user (e.g. ARLI has conflicting rules). */
  flags?: Maybe<Array<AccountingRecordLineItemFlag>>;
  /**
   * Whether or not this Line Items EFVs have been copied from Source (i.e. copied from the underlying Expense).
   * Also referred to as the "primary" line item type (e.g. DEBIT for Card Expenses, CREDIT for Card Refund)
   */
  hasSourceExtendedFieldValues?: Maybe<Scalars["Boolean"]>;
  /** The unique ID of the accounting record line item. */
  id: Scalars["ID"];
  /** Represents the company that accrued the line item. */
  legalEntity: LegalEntity;
  /**
   * The 'source' field represents the entity that originated the accounting record line item. Currently only set on expenses
   * - If the source object can be itemized but hasn't been yet, the 'source' for each line will be the parent object's ID.
   * - If the source object can be itemized and has been, the 'source' for each line will be the child object's ID.
   * - For the sum line (the total of all items) and in all other scenarios, the 'source' will be null.
   */
  source?: Maybe<AccountingRecordLineItemSourceUnion>;
  /** Represents the type of a line item in a double entry bookkeeping event, i.e. debit and credit lines */
  type: AccountingRecordLineType;
}

/** An accounting record line item. */
export interface AccountingRecordLineItemextendedFieldInstanceArgs {
  id: Scalars["ID"];
}

/** An accounting record line item. */
export interface AccountingRecordLineItemextendedFieldInstancesArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<ExtendedFieldFilterConditionInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

/**
 * NOTE: Currently Pagination is not supported. All items are always returned and any input for the connection
 * is ignored
 */
export interface AccountingRecordLineItemConnection extends Connection {
  edges: Array<AccountingRecordLineItemEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface AccountingRecordLineItemEdge {
  cursor?: Maybe<Scalars["String"]>;
  node: AccountingRecordLineItem;
}

/**
 * Indicate specific conditions of a transaction that are flagged to the user in the UI (e.g. ARLI has conflicting rules).
 * Computing these on the BE speeds up render time.
 */
export enum AccountingRecordLineItemFlag {
  /** The lineItem has conflicting rules attempting to set different values on the same field */
  CONFLICTING_RULES = "CONFLICTING_RULES",
  /** An employee made a manual modification to one of the Extended Field Values on the lineItem */
  EMPLOYEE_MODIFIED = "EMPLOYEE_MODIFIED",
  /**
   * The lineItem has a field marked as required by Oracle Fusion, but is missing a value within Brex
   * NOTE: Currently (4.22.2024) only applicable to Oracle Fusion
   */
  MISSING_REQUIRED_FIELDS = "MISSING_REQUIRED_FIELDS",
  /** Workflow Rules were applied to the source object. Will not be set if the only rules applied were Integration Settings */
  WORKFLOW_RULES_APPLIED = "WORKFLOW_RULES_APPLIED",
}

/** Source of the accounting record line item */
export type AccountingRecordLineItemSourceUnion = Expense;

/** The type of accounting record line item. */
export enum AccountingRecordLineType {
  /** Represents an entry that decreases an asset account or increases a liability or equity account. */
  CREDIT = "CREDIT",
  /** Represents an entry that increases an asset account or decreases a liability or equity account. */
  DEBIT = "DEBIT",
}

/** Indicates when a AR record is marked as Locked / Unlocked. If AR is locked then it cannot be modified. else it can. */
export enum AccountingRecordLockedStatus {
  /**
   * Represents that the Accounting Record is locked and cannot be modified by the user but modifiable by system (rules, jobs...).
   * The Locked status is not enforced at the platform level.
   */
  LOCKED = "LOCKED",
  /** Represents that the Accounting Record is not locked and can be modified */
  UNLOCKED = "UNLOCKED",
}

export interface AccountingRecordSortInput {
  /** The direction to sort by */
  direction: OrderByDirection;
  /** Required sort key */
  fieldKey: AccountingRecordFieldSortKeyInput;
}

/** The queryable fields of Accounting Records. Used for grouping/aggregations/sorting */
export enum AccountingRecordSortKey {
  ACCRUED_AT = "ACCRUED_AT",
  ENTRY_POSTED_AT = "ENTRY_POSTED_AT",
  /**  Expense Field Keys */
  EXPENSE_BUDGET = "EXPENSE_BUDGET",
  EXPENSE_BUDGET_NAME = "EXPENSE_BUDGET_NAME",
  EXPENSE_CUSTOMER_USER_ID = "EXPENSE_CUSTOMER_USER_ID",
  EXPENSE_FUNDING_ENTITY = "EXPENSE_FUNDING_ENTITY",
  EXPENSE_MEMO = "EXPENSE_MEMO",
  EXPENSE_SPENDING_ENTITY = "EXPENSE_SPENDING_ENTITY",
  EXPENSE_USER_FIRST_NAME = "EXPENSE_USER_FIRST_NAME",
  EXPENSE_USER_LAST_NAME = "EXPENSE_USER_LAST_NAME",
  EXPENSE_VENDOR_CATEGORY = "EXPENSE_VENDOR_CATEGORY",
  EXPENSE_VENDOR_CATEGORY_NAME = "EXPENSE_VENDOR_CATEGORY_NAME",
  EXPENSE_VENDOR_ID = "EXPENSE_VENDOR_ID",
  EXPENSE_VENDOR_NAME = "EXPENSE_VENDOR_NAME",
  SOURCE_TRANSACTED_AT = "SOURCE_TRANSACTED_AT",
  TYPE = "TYPE",
}

export interface AccountingRecordSourceExportEntriesConnection
  extends Connection {
  edges: Array<AccountingRecordSourceExportEntryEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface AccountingRecordSourceExportEntriesFilterInput {
  accountingRecordSourceId: Scalars["ID"];
  integrationId: Scalars["ID"];
}

export interface AccountingRecordSourceExportEntry {
  exportEntry: AccountingJournalExportEntry;
  id: Scalars["ID"];
  versionedAccountingRecord: AccountingRecord;
}

export interface AccountingRecordSourceExportEntryEdge {
  cursor?: Maybe<Scalars["String"]>;
  node: AccountingRecordSourceExportEntry;
}

/** Source of the accounting record. */
export type AccountingRecordSourceUnion =
  | BillingPaymentIntent
  | Expense
  | FAM
  | InvoiceV1
  | Payment;

/** Indicate the accounting record status */
export enum AccountingRecordStatus {
  /** The accounting record is ACTIVE and able to be exported. */
  ACTIVE = "ACTIVE",
  /** The accounting record is adjusting entry and is mutable but not exportable */
  ADJUSTING_ENTRY = "ADJUSTING_ENTRY",
  /** The accounting record is deleted and should no longer visible to the user. */
  DELETED = "DELETED",
  /** The accounting record is DRAFT and able to be exported as accrual only. */
  DRAFT = "DRAFT",
}

/** The type of accounting record. */
export enum AccountingRecordType {
  /** For bill expenses. Created as soon as the expense is drafted. */
  BILL_EXPENSE = "BILL_EXPENSE",
  /** Card collection payment moves money from customer to Brex as a card payment */
  CARD_COLLECTION = "CARD_COLLECTION",
  /** A payment made from Brex to the customer to represent a return of funds for a card collection. E.g. customer overpaid for card statement. */
  CARD_COLLECTION_REFUND = "CARD_COLLECTION_REFUND",
  /** Expense post type (for Expense which does not required approval - e.g. card Expense). */
  CARD_EXPENSE_POST = "CARD_EXPENSE_POST",
  /**
   * Card expenses that represent a credit to the customer. Created after the card payment has cleared. e.g. merchant refunds.
   * This is not to be confused with a repayment.
   */
  CARD_EXPENSE_REFUND = "CARD_EXPENSE_REFUND",
  /** Card Expense repayment */
  CARD_EXPENSE_REPAYMENT = "CARD_EXPENSE_REPAYMENT",
  /** Represents submission of an invoice */
  INVOICE = "INVOICE",
  /** Represents payment of an invoice */
  INVOICE_PAYMENT = "INVOICE_PAYMENT",
  /** Reimbursement approval to represent a reimbursement that has not been fulfilled yet (accrual basis) */
  REIMBURSEMENT_APPROVAL = "REIMBURSEMENT_APPROVAL",
  /** Reimbursement Expense repayment */
  REIMBURSEMENT_EXPENSE_REPAYMENT = "REIMBURSEMENT_EXPENSE_REPAYMENT",
  /**
   * Reimbursement pull payment moves money from the customer to Brex
   * Represents a liability closing for a reimbursement. (accrual basis)
   */
  REIMBURSEMENT_MONEY_MOVEMENT_PAYIN = "REIMBURSEMENT_MONEY_MOVEMENT_PAYIN",
  /**
   * Reimbursement push payment moves money from Brex to another source - e.g. an employee or 3rd party
   * Represents a liability closing for a reimbursement. (accrual basis)
   */
  REIMBURSEMENT_MONEY_MOVEMENT_PAYOUT = "REIMBURSEMENT_MONEY_MOVEMENT_PAYOUT",
  /**
   * Reimbursement payout reversal. Represents money moving from employee bank account back to Brex or AWX.
   * This may happen when we try to payout an employee for a reimbursement, the bank rejects the payment, and we need to reverse the payout.
   */
  REIMBURSEMENT_MONEY_MOVEMENT_PAYOUT_REVERSAL = "REIMBURSEMENT_MONEY_MOVEMENT_PAYOUT_REVERSAL",
  /**
   * Reimbursement money movement refund moves money from Brex back to the customers bank account when a reimbursement payment is refunded.
   * This only captures US funded reimbursements. For locally funded reimbursements the intermediary bank account is owned by the customer through Airwallex and not Brex
   * So we do not need to capture it within Brex accounting system.
   */
  REIMBURSEMENT_MONEY_MOVEMENT_REFUND = "REIMBURSEMENT_MONEY_MOVEMENT_REFUND",
  /** Reimbursement posted, represents a reimbursement that has been fulfilled (cash basis) */
  REIMBURSEMENT_POST = "REIMBURSEMENT_POST",
  /** Reward redemption type */
  REWARD_REDEMPTION = "REWARD_REDEMPTION",
}

/** Source of the accounting record at the source version for the accounting record. */
export type AccountingRecordVersionedSourceUnion = Expense;

export interface AccountingRuleSuggestionDataInput {
  /** The rule's body. */
  body: Scalars["Json"];
  /** The rule's integration ID. */
  integrationId: Scalars["ID"];
  /** The rule's name. */
  name: Scalars["String"];
  /** The rule's priority. */
  priority: Scalars["Int"];
  /** The rule's ID. Only present for accounting rule updates. */
  ruleId?: InputMaybe<Scalars["ID"]>;
  /** The rule's type. */
  type: Scalars["String"];
}

export interface AccountingRuleSuggestionInformation {
  /** The rule's body. */
  body: Scalars["Json"];
  /** The rule's integration ID. */
  integrationId: Scalars["ID"];
  /** The rule's name. */
  name: Scalars["String"];
  /** The rule's priority. */
  priority: Scalars["Int"];
  /** The rule's ID. Only present for accounting rule updates. */
  ruleId?: Maybe<Scalars["ID"]>;
  /** Optional. The rule's score. */
  score?: Maybe<Scalars["Float"]>;
  /** The rule's type. */
  type: Scalars["String"];
}

/** Subsidiary settings connection for pagination */
export interface AccountingSubsidiarySettingsConnection extends Connection {
  edges: Array<AccountingSubsidiarySettingsEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

/** Edge for subsidiary settings pagination */
export interface AccountingSubsidiarySettingsEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<AccountingIntegrationSubsidiarySettings>;
}

/**
 * Legacy Behavior - If none of the value types are set, the resulting filter will be for null values on the given fieldKey
 *                 - You should always use the nullValue type instead as that behavior will eventually be removed.
 */
export interface AccountingVxValueFilterInput {
  /** Boolean value to filter for. Only one value type should be set. */
  boolValue?: InputMaybe<Scalars["Boolean"]>;
  /** The key of the field to filter for. */
  fieldKey: Scalars["String"];
  /** Identifier values to filter for. Only one value type should be set. */
  identifierValues?: InputMaybe<Array<Scalars["ID"]>>;
  /**
   * Optional, filters by Accounting Record line item types. If not set, all line item types will be considered.
   * nullValue filtering always considers all line item types (i.e. lineItemTypes will be ignored if nullValue is passed)
   */
  lineItemTypes?: InputMaybe<Array<AccountingRecordLineType>>;
  /**
   * Filter for null or non-null values. Only one value type should be set.
   *
   * If you want to filter for null values, you should use this value type instead of the legacy behavior of
   * not setting any value types to filter on nulls. That behavior will eventually be removed.
   */
  nullValue?: InputMaybe<NullValue>;
  /** String values to filter for. Only one value type should be set. */
  stringValues?: InputMaybe<Array<Scalars["String"]>>;
}

export interface AccountsUsedInUnderwritingResponse {
  accounts?: Maybe<Array<BankAccountUnderwritingData>>;
}

export interface AccrualSettingsInput {
  /** Whether accruals feature is enabled */
  accrualsEnabled?: InputMaybe<AccountingIntegrationAccrualsEnabledStatus>;
}

export interface AccrualsPaid {
  dividend: FinancialAsset;
  rebate: FinancialAsset;
  total: FinancialAsset;
}

export enum AchDebitCapability {
  ENABLED = "ENABLED",
  RESTRICTED = "RESTRICTED",
  REVOKED = "REVOKED",
}

/** Object defining brex-originated ach debit limits */
export interface AchDebitLimits {
  /** The length of the payout delay in business days for ach debits */
  achDebitPayoutDelay: Scalars["Int"];
  /** The remaining limit available for making ach debits today */
  achRemainingLimitToday: Scalars["Int"];
  /** The remaining limit available for making ach debits tomorrow */
  achRemainingLimitTomorrow: Scalars["Int"];
  /** The total limit definition for brex-originated ach debits */
  achTotalLimitUsdCents: Scalars["Int"];
  /** The next business day, inclusive of today. ex if today=Friday, return Friday's date. if today=Saturday, return Monday's date */
  firstAvailableBusinessDay: Scalars["Time"];
  /** The second next business day, inclusive of today. ex if today=Monday, return Tuesdays's date. if today=Friday, return Monday's date */
  secondAvailableBusinessDay: Scalars["Time"];
}

export interface AchDetails {
  counterparty: Counterparty;
  estimatedOn: Scalars["Time"];
  initiatorCustomerUser?: Maybe<User>;
  method: Method;
  origin: Origin;
  transferDescription?: Maybe<Scalars["String"]>;
}

export interface AchPaymentInstrument {
  accountClass?: Maybe<BankAccountClass>;
  accountNumber?: Maybe<Scalars["String"]>;
  accountType?: Maybe<BankAccountType>;
  address?: Maybe<Address>;
  /** A small logo for the beneficiary bank in base64 format. WARNING: may cause significantly slower response times */
  beneficiaryBankLogoBase64?: Maybe<Scalars["String"]>;
  /** Not yet implemented, will always be null. Is in the schema so the app can use the URL if available, falling back to base64 */
  beneficiaryBankLogoUrl?: Maybe<Scalars["String"]>;
  beneficiaryBankName?: Maybe<Scalars["String"]>;
  routingNumber?: Maybe<Scalars["String"]>;
}

export interface AchPaymentInstrumentFindInput {
  accountNumber: Scalars["String"];
  routingNumber: Scalars["String"];
}

export interface AchPaymentInstrumentInput {
  accountClass: BankAccountClass;
  accountNumber: Scalars["String"];
  accountType: BankAccountType;
  routingNumber: Scalars["String"];
}

export interface AchReturnDetails {
  counterparty: Counterparty;
  initiatorCustomerUser?: Maybe<User>;
  method: Method;
  origin: Origin;
  returnReason: ReturnReason;
}

export interface AchTransferDetails {
  identificationNumber?: Maybe<Scalars["String"]>;
  returnDetails?: Maybe<ReturnDetails>;
  traceNumber?: Maybe<Scalars["String"]>;
}

export interface ActionLog {
  /** The name of the action. */
  action: Scalars["String"];
  /** The external customer who triggered the action. Will be null for actions triggered by internal Brex system/users. */
  actor?: Maybe<Employee>;
  /** The user id being co-piloted when the action was taken. Can be null. */
  onBehalfOfEmployee?: Maybe<Employee>;
  /** When the action occurred. */
  updatedAt?: Maybe<Scalars["Time"]>;
  /** The value which the action has set to. Can be null for some actions. */
  value?: Maybe<Scalars["String"]>;
}

export interface ActivateCardInput {
  /** The client mutation id */
  clientMutationId: Scalars["String"];
  /** Last four characters of the pan of the card to activate */
  last4: Scalars["String"];
  /** The pin to set for the card */
  pin?: InputMaybe<Scalars["String"]>;
}

export interface ActivateCardPayload {
  /** The card that has been activated */
  card?: Maybe<Card>;
  /** The client mutation id */
  clientMutationId: Scalars["String"];
}

export interface ActivateIntegrationInput {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
}

export interface ActivateIntegrationPayload {
  clientMutationId: Scalars["String"];
  integration?: Maybe<Integration>;
}

export enum ActivateUserAuthType {
  JWT = "JWT",
}

export interface ActivateUserInfo {
  legalAgreements?: InputMaybe<Array<InputMaybe<LegalAgreementReference>>>;
  password: Scalars["String"];
}

export interface ActivateUserInput {
  activationToken: Scalars["String"];
  clientMutationId: Scalars["String"];
  user?: InputMaybe<ActivateUserInfo>;
}

export interface ActivateUserPayloadV2 {
  authType: ActivateUserAuthType;
  clientMutationId: Scalars["String"];
  customerAccountId: Scalars["ID"];
  token: Scalars["String"];
  userEligibleForMobileOnboarding: Scalars["Boolean"];
  userId: Scalars["ID"];
}

/** userActiveOauthApplications */
export interface ActiveOauthApplicationsConnection extends Connection {
  edges: Array<ActiveOauthApplicationsEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface ActiveOauthApplicationsEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<OauthApplication>;
}

export interface ActiveSession {
  device?: Maybe<Device>;
  /** @deprecated Use sessionHash instead */
  id?: Maybe<Scalars["String"]>;
  sessionHash?: Maybe<Scalars["String"]>;
  startDate?: Maybe<Scalars["Time"]>;
}

/** ActiveSessions */
export interface ActiveSessionsConnection extends Connection {
  edges?: Maybe<Array<Maybe<GetActiveSessionsEdge>>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

/** ActivityHistory */
export interface ActivityHistoryConnection extends Connection {
  edges?: Maybe<Array<Maybe<ActivityHistoryEdge>>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface ActivityHistoryEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<IdentityActivity>;
}

export enum ActivityOriginatorType {
  COLLECTION_PROMISE = "COLLECTION_PROMISE",
  COLLECTION_PROMISE_REVERSAL = "COLLECTION_PROMISE_REVERSAL",
  FEE_CHARGED = "FEE_CHARGED",
  FEE_WAIVED = "FEE_WAIVED",
}

export interface Actor {
  actorId?: Maybe<Scalars["String"]>;
  displayName: Scalars["String"];
  email?: Maybe<Scalars["String"]>;
  onBehalfOf?: Maybe<OnBehalfOf>;
  type: ActorType;
}

export enum ActorType {
  BREX_SUPPORT = "BREX_SUPPORT",
  EXTERNAL_USER = "EXTERNAL_USER",
  OAUTH_CLIENT = "OAUTH_CLIENT",
  SYSTEM = "SYSTEM",
  /**  TODO change this to CUSTOMER_USER */
  USER = "USER",
}

export interface ActorTypeNode {
  displayName: Scalars["String"];
  value: ActorType;
}

export interface ActorTypesEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<ActorTypeNode>;
}

export interface AddAttendeesInput {
  attendeeUserIds?: InputMaybe<Array<Scalars["ID"]>>;
  clientMutationId: Scalars["String"];
  groupEventId: Scalars["ID"];
}

export interface AddAttendeesResult {
  attendees?: Maybe<Array<EventAttendee>>;
  error?: Maybe<Scalars["String"]>;
}

export interface AddAutoApproveUserIdInput {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
}

export interface AddBillsToBatchInput {
  /** ID of the bill batch */
  billBatchId: Scalars["ID"];
  /** List of bill expenses IDs to be added to the batch */
  bills: Array<Scalars["ID"]>;
  /** Idempotency key */
  clientMutationId: Scalars["String"];
}

export interface AddBillsToBatchResult {
  /** Possible list of errors from the mutation */
  errors?: Maybe<Array<BillBatchMutationError>>;
  /** The updated bill batch object */
  result?: Maybe<BillBatch>;
}

export interface AddFspBookkeeperInput {
  bookkeeperAccountId: Scalars["String"];
  clientMutationId: Scalars["String"];
}

export interface AddFspBookkeeperPayload {
  clientMutationId: Scalars["String"];
  policyUrn?: Maybe<Scalars["String"]>;
}

export interface AddFspBookkeeperUserInput {
  bookkeeperUserId: Scalars["String"];
  clientMutationId: Scalars["String"];
}

export interface AddFspBookkeeperUserPayload {
  clientMutationId: Scalars["String"];
  groupUrn?: Maybe<Scalars["String"]>;
}

export enum AddOns {
  ADVANCED_GLOBAL = "ADVANCED_GLOBAL",
  IMPLEMENTATION = "IMPLEMENTATION",
  METAL_CARDS = "METAL_CARDS",
  TRAVEL = "TRAVEL",
}

export interface AddSubsidiaryDefaultEntityInput {
  clientMutationId: Scalars["String"];
  externalIntegrationEntityId: Scalars["ID"];
  subsidiaryId: Scalars["ID"];
}

export interface AddSubsidiaryDefaultEntityPayload {
  clientMutationId: Scalars["String"];
}

export interface AddToCohortInput {
  key: Scalars["String"];
}

export interface AddToCohortResult {
  cohorts: Array<CohortSegment>;
  result?: Maybe<Scalars["Boolean"]>;
}

export interface AddUsersActionInput {
  addedMembers?: InputMaybe<BudgetPersonnelInput>;
  addedOwners?: InputMaybe<BudgetPersonnelInput>;
}

export type AdditionalDataV2 = AdditionalPurchaseDataV2;

export interface AdditionalMerchantDisputeInput {
  cancelledProductInput?: InputMaybe<CancelledProductInput>;
  cancelledServiceInput?: InputMaybe<CancelledServiceInput>;
  duplicateChargedInput?: InputMaybe<DuplicateChargedInput>;
  notAsDescribedProductInput?: InputMaybe<NotAsDescribedProductInput>;
  notAsDescribedServiceInput?: InputMaybe<NotAsDescribedServiceInput>;
  notReceivedInput?: InputMaybe<NotReceivedInput>;
  overChargedInput?: InputMaybe<OverChargedInput>;
  promisedByMerchantInput?: InputMaybe<PromisedByMerchantInput>;
  returnedProductInput?: InputMaybe<ReturnedProductInput>;
}

export interface AdditionalPurchaseDataV2 {
  accrualRate?: Maybe<Scalars["Float"]>;
  accrualRateModifier?: Maybe<Scalars["Float"]>;
  modifierTriggerName?: Maybe<Scalars["String"]>;
  selectedTriggerName?: Maybe<Scalars["String"]>;
}

export interface AdditionalReturnTier {
  additionalReturnApyBps?: Maybe<Scalars["Int"]>;
  baseApyBps?: Maybe<Scalars["Int"]>;
  minimumBalance?: Maybe<FinancialAsset>;
  name?: Maybe<Scalars["String"]>;
  totalApyBps?: Maybe<Scalars["Int"]>;
}

/** Represents a physical address */
export interface Address {
  /** First line of the address */
  address1?: Maybe<Scalars["String"]>;
  /** Second line of the address */
  address2?: Maybe<Scalars["String"]>;
  /** The city in which the address is located */
  city?: Maybe<Scalars["String"]>;
  /** Country in which the address is located */
  country?: Maybe<Scalars["String"]>;
  /** The country metadata for the address. Not filled, just for compatibility */
  countryMetadata?: Maybe<Country>;
  /** State or province in which the address is located */
  state?: Maybe<Scalars["String"]>;
  /** Postal or ZIP code for the address */
  zip?: Maybe<Scalars["String"]>;
}

/** Contains the parameters to collect information of Address type. */
export interface AddressInformation {
  /** Type of the information requirement */
  displayType: RequirementInformationFieldDisplayType;
  /** Identifier of the information requirement */
  key: Scalars["String"];
  /** Name of the information requirement to be displayed */
  name: Scalars["String"];
}

export interface AddressInput {
  address1: Scalars["String"];
  address2?: InputMaybe<Scalars["String"]>;
  city: Scalars["String"];
  country: Scalars["String"];
  state: Scalars["String"];
  zip: Scalars["String"];
}

/**
 * Contain the delta of changes between the locked ARLI and unlocked ARLI. The changes are represented as a list of extended field values.
 * If an empty list is returned, it means there are no differences in line items value mappings between the locked AR and unlocked AR.
 */
export interface AdjustingChanges {
  deletedKeys?: Maybe<Array<Maybe<DeletedValue>>>;
  extendedFieldValues?: Maybe<ExtendedFieldValueConnection>;
  status?: Maybe<AdjustingChangesStatus>;
}

/** Indicates if the accounting line item has adjusting changes or not */
export enum AdjustingChangesStatus {
  /** Indicates that the line item has adjusting changes, and the locked line item is different from the unlocked line item */
  HAS_CHANGES = "HAS_CHANGES",
  /** Indicates that the line item does not have adjusting changes and the locked line item is same as unlocked line item */
  NO_CHANGE = "NO_CHANGE",
}

export interface AdminHomeDisplaySetting {
  sectionEnablements: Array<SectionEnablement>;
}

export interface AdminHomeDisplaySettingInput {
  sectionEnablements: Array<SectionEnablementInput>;
}

/** Enum type for admin home section. */
export enum AdminHomeSectionType {
  ACTIVITY = "ACTIVITY",
  METRIC = "METRIC",
}

export interface AdminHomeSetting {
  displaySetting?: Maybe<AdminHomeDisplaySetting>;
  id: Scalars["ID"];
}

export interface AdminHomeWidget {
  ctaInfo?: Maybe<AdminHomeWidgetCTA>;
  id: Scalars["ID"];
  metadata?: Maybe<AdminHomeWidgetMetadata>;
  status?: Maybe<AdminHomeWidgetStatus>;
  widgetType: WidgetType;
}

export interface AdminHomeWidgetCTA {
  ctaUrl: Scalars["String"];
  displayStyle: CtaDisplayStyleType;
  displayText: Scalars["String"];
}

export interface AdminHomeWidgetDefinition {
  widgetId: Scalars["ID"];
  widgetType: WidgetType;
}

export interface AdminHomeWidgetDefinitionConnection {
  adminHomeWidgetDefinitions?: Maybe<Array<AdminHomeWidgetDefinition>>;
}

export type AdminHomeWidgetMetadata =
  | WidgetBalanceAndCashFlow
  | WidgetCashFlowSummaries
  | WidgetCreditLimitData
  | WidgetPercentageData
  | WidgetRewardsCards
  | WidgetRewardsMilestones
  | WidgetTabularData
  | WidgetTimeSeriesData
  | WidgetTransactionsData
  | WidgetYieldBreakdown;

/** Enum type for admin home widget status. */
export enum AdminHomeWidgetStatus {
  BLOCKED = "BLOCKED",
  UNBLOCKED = "UNBLOCKED",
}

export type AdminHomeWidgetTemplate = AdminHomeWidget | StackAdminHomeWidget;

export interface AdminHomeWidgetsByProductSegmentConnection {
  widgetTemplates?: Maybe<Array<AdminHomeWidgetTemplate>>;
  /** @deprecated Use widgetTemplates instead. */
  widgets?: Maybe<Array<AdminHomeWidget>>;
}

export enum AdminRoleFilter {
  ADMINS = "ADMINS",
  ALL = "ALL",
  NON_ADMINS = "NON_ADMINS",
}

export interface AdvanceToNextStepInput {
  clientMutationId: Scalars["String"];
  completedOfferStep: OfferSetupStepType;
  offerType: OfferType;
}

export interface AdvanceToNextStepPayload {
  availableProductOffers: Array<ProductOffer>;
  clientMutationId: Scalars["String"];
}

export enum AffidavitChannel {
  MOBILE = "MOBILE",
  WEB = "WEB",
}

export enum AggregateFunction {
  COUNT = "COUNT",
  SUM = "SUM",
}

export type AggregationResult =
  | DateHistogramAggregationResult
  | GroupAggregationResult
  | SumAggregationResult;

/** AI policy settings for a customer account */
export interface AiPolicySetting {
  /** List of expense types that are enabled for AI policy processing */
  expenseTypes: Array<ExpenseType>;
  /** List of spend limit IDs that are enabled for AI policy processing */
  spendLimitIds: Array<Scalars["ID"]>;
}

/** Any string intended for looking up airports (IATA codes). */
export interface AirAutocompleteFilterInput {
  queryString: Scalars["String"];
}

/** ---[ Types ]------------ */
export interface AirAutocompleteResult {
  /** The IATA airport code (e.g., SFO, LAX). */
  airportCode: Scalars["String"];
  airportName?: Maybe<Scalars["String"]>;
  /**
   * The IATA city code, if it exists. Examples:
   * - NYC for all airports in New York
   * - RIO for all airports in Rio de Janeiro
   */
  cityCode?: Maybe<Scalars["String"]>;
  /** A location that represents the airport city, if it exists. */
  cityLocation?: Maybe<TravelLocation>;
  /** High-level location info */
  location?: Maybe<TravelLocation>;
}

/** Results from an airport autocomplete query. */
export interface AirAutocompleteResults {
  results?: Maybe<Array<AirAutocompleteResult>>;
}

/** ---[ Types ]------------ */
export interface AirLoyalty {
  airlineCode: Scalars["String"];
  airlineName?: Maybe<Scalars["String"]>;
  loyaltyNumber: Scalars["String"];
}

export enum AirSeatStatus {
  CANCELED = "CANCELED",
  CONFIRMED = "CONFIRMED",
  PENDING = "PENDING",
}

export interface AirwallexCardsRequirements {
  /** If we do recommend, this indicates if we still need to collect data sharing consent first. */
  needToCollectConsent: Scalars["Boolean"];
  /** Whether we recommend Airwallex card products for better acceptance rates */
  recommended: Scalars["Boolean"];
}

export interface AirwallexCardsUserRequirements {
  /** If we do recommend, this indicates if we still need to collect date of birth first */
  needToCollectDateOfBirth: Scalars["Boolean"];
  /** Whether we recommend Airwallex cards to the user for better acceptance rates */
  recommended: Scalars["Boolean"];
}

/** Input for Airwallex Hosted Flow */
export interface AirwallexHostedFlowPayloadInput {
  /** Resolution of the Airwallex Hosted Flow */
  resolution: AirwallexHostedFlowResolution;
}

/** Resolution of an Airwallex Hosted Flow */
export enum AirwallexHostedFlowResolution {
  /** The Airwallex Hosted Flow returned an error */
  ERROR = "ERROR",
  /** The Airwallex Hosted Flow was submitted */
  SUBMITTED = "SUBMITTED",
}

export enum AirwallexKycStatus {
  ACTION_REQUIRED = "ACTION_REQUIRED",
  ACTIVE = "ACTIVE",
  CREATED = "CREATED",
  RFI_ACTION_REQUIRED = "RFI_ACTION_REQUIRED",
  RFI_ANSWERED = "RFI_ANSWERED",
  RFI_CLOSED = "RFI_CLOSED",
  SUBMITTED = "SUBMITTED",
  SUSPENDED = "SUSPENDED",
}

/** Alert Object */
export interface Alert {
  body: Scalars["String"];
  cchnoId: Scalars["String"];
  createdAt: Scalars["Time"];
  customer: User;
  id: Scalars["ID"];
  notificationGroupId: Scalars["String"];
  notificationType: Scalars["String"];
  originId: Scalars["String"];
  primaryCta?: Maybe<AlertCta>;
  read: Scalars["Boolean"];
  secondaryCta?: Maybe<AlertCta>;
  shortBody: Scalars["String"];
  shortTitle: Scalars["String"];
  subscribable: Scalars["Boolean"];
  subscribed: Scalars["Boolean"];
  title: Scalars["String"];
  updatedAt: Scalars["Time"];
}

export interface AlertConnection extends Connection {
  edges: Array<AlertEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

/** Call to Action Object */
export interface AlertCta {
  link: Scalars["String"];
  text: Scalars["String"];
}

export interface AlertEdge {
  cursor?: Maybe<Scalars["String"]>;
  node: Alert;
}

/** Budget allocation metrics */
export interface AllocationMetrics {
  /** The spent amount from spend limit recurrences currently active */
  activeSpentAmount: FinancialAsset;
  /** The current allocation amount of a budget period */
  currentAllocatedAmount: FinancialAsset;
  /** The past spent amount from spend limit recurrences that have closed */
  pastSpentAmount: FinancialAsset;
}

export interface AllocationRecommendation {
  amount: Scalars["Long"];
  averageMonthlyOutflow?: Maybe<Scalars["Long"]>;
  depositsAccount: DepositsAccount;
}

export interface AmountBasedApprovalChain {
  approvalChain: Array<PolicyApprovalStep>;
  threshold: FinancialAsset;
}

export interface AmountBasedApprovalChainInput {
  approvalChain: Array<PolicyApprovalStepInput>;
  threshold: FinancialAssetInput;
}

export interface AmsDisplaySetting {
  isDismissed: Scalars["Boolean"];
}

export interface AmsMetadata {
  progressStatus?: Maybe<AmsProgressStatus>;
}

/** Ams Progress Status */
export enum AmsProgressStatus {
  COMPLETE = "COMPLETE",
  IN_PROGRESS = "IN_PROGRESS",
  NOT_INITIALIZED = "NOT_INITIALIZED",
}

export interface AmsSetting {
  applicationStatus?: Maybe<ApplicationStatus>;
  displaySetting?: Maybe<AmsDisplaySetting>;
}

export enum AmsTaskStatus {
  APPROVED = "APPROVED",
  DOCUMENTS_REQUESTED = "DOCUMENTS_REQUESTED",
  IN_PROGRESS = "IN_PROGRESS",
  PROCESSING = "PROCESSING",
  REJECTED = "REJECTED",
}

export interface Analysis extends Node {
  /** Customer Account ID associated with the Analysis */
  customerAccountId: Scalars["String"];
  /** The ID of an object */
  id: Scalars["ID"];
  /** Analysis start time */
  insertedAt?: Maybe<Scalars["Time"]>;
  /** Requirement version used in the Analysis */
  requirementVersionId: Scalars["String"];
  /** Outcome / result of the analysis */
  result?: Maybe<AnalysisResult>;
  /** Analysis status within the workflow */
  status?: Maybe<AnalysisStatus>;
  /** ID of the subject of the Analysis */
  subjectId: Scalars["String"];
}

export enum AnalysisContextType {
  ROLE_CHANGE_ACCOUNT_ADMIN = "ROLE_CHANGE_ACCOUNT_ADMIN",
  ROLE_CHANGE_BILL_PAY_ADMIN = "ROLE_CHANGE_BILL_PAY_ADMIN",
  ROLE_CHANGE_CASH_UPSELL = "ROLE_CHANGE_CASH_UPSELL",
  ROLE_CHANGE_SUPER_ADMIN = "ROLE_CHANGE_SUPER_ADMIN",
  TERMS_CARD = "TERMS_CARD",
  TERMS_CARD_AND_CASH = "TERMS_CARD_AND_CASH",
  TERMS_CASH = "TERMS_CASH",
}

export enum AnalysisResult {
  APPROVED = "APPROVED",
  ERROR = "ERROR",
  INVALID = "INVALID",
  PENDING_EVIDENCE = "PENDING_EVIDENCE",
  PENDING_REJECTION = "PENDING_REJECTION",
  PENDING_RETRY = "PENDING_RETRY",
  PENDING_REVIEW = "PENDING_REVIEW",
  REJECTED = "REJECTED",
}

export enum AnalysisStatus {
  CANCELLED = "CANCELLED",
  COMPLETED = "COMPLETED",
  ERROR = "ERROR",
  INVALID = "INVALID",
  NEW = "NEW",
  PENDING = "PENDING",
  RUNNING = "RUNNING",
}

export enum Api {
  ACCOUNTING = "ACCOUNTING",
  AUTOMATION = "AUTOMATION",
  BUDGETS = "BUDGETS",
  EMBEDDED = "EMBEDDED",
  EXPENSES = "EXPENSES",
  FIELDS = "FIELDS",
  INVALID = "INVALID",
  ONBOARDING = "ONBOARDING",
  PAYMENTS = "PAYMENTS",
  REWARDS = "REWARDS",
  TEAM = "TEAM",
  TRANSACTIONS = "TRANSACTIONS",
  TRAVEL = "TRAVEL",
}

export interface ApiClient {
  clientId?: Maybe<Scalars["String"]>;
  clientName?: Maybe<Scalars["String"]>;
  clientUrl?: Maybe<Scalars["String"]>;
}

/** ## --- Custom Apps Types --- */
export interface App {
  /**
   * The identifier of the app. These are globally unique.
   * Example would be "candidate-app"
   */
  identifier: Scalars["String"];
  /** The display name of the app. */
  name: Scalars["String"];
}

export interface AppInstallation extends Node {
  /** The app that is installed. */
  app?: Maybe<App>;
  /** Self-signed JWT token for app authentication */
  authToken: Scalars["String"];
  /** The ID of an object */
  id: Scalars["ID"];
}

export interface AppInstallationConnection extends Connection {
  edges: Array<AppInstallationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"];
}

export interface AppInstallationEdge {
  node: AppInstallation;
}

export enum ApplicationMethod {
  CONNECT_BANK_ACCOUNT = "CONNECT_BANK_ACCOUNT",
  UPLOAD_BANK_STATEMENT = "UPLOAD_BANK_STATEMENT",
  USE_BUSINESS_ACCOUNT = "USE_BUSINESS_ACCOUNT",
}

export interface ApplicationSession {
  id: Scalars["ID"];
  sessionId: Scalars["String"];
}

export interface ApplicationStatus {
  bbaAppStatus?: Maybe<AmsTaskStatus>;
  cardAppStatus?: Maybe<AmsTaskStatus>;
  isAmsComplete: Scalars["Boolean"];
}

/**
 * A representation of an Approval Chain that hides backend implementation details that clients should not care about (e.g.
 * "RuleSets").
 *
 * This is currently defined as a union encompassing only `BudgetApprovalChainDefinition`, but can be more in the future.
 */
export type ApprovalChainDefinition = BudgetApprovalChainDefinition;

/** New policies registered, limit increase is temporary, should be removed soon */
export interface ApprovalChainResult {
  approvalChainPolicy: Policy;
  limitIncreasePolicy?: Maybe<Policy>;
}

export interface ApprovalChainStep {
  reviewers: Array<ApprovalChainTarget>;
}

export interface ApprovalChainStepInput {
  reviewers: Array<ApprovalChainTargetInput>;
}

export type ApprovalChainTarget = Employee | UserRoleTarget;

/**
 * Should only contain one target type
 * (@oneOf is not supported for inputs)
 */
export interface ApprovalChainTargetInput {
  customerUserId?: InputMaybe<Scalars["String"]>;
  userRole?: InputMaybe<ApprovalChainUserRole>;
}

export enum ApprovalChainUserRole {
  ACCOUNT_ADMIN = "ACCOUNT_ADMIN",
  BREX_OPS = "BREX_OPS",
}

export enum ApprovalStatus {
  APPROVED = "APPROVED",
  PENDING_APPROVAL = "PENDING_APPROVAL",
}

export interface ApprovalsRequest {
  id: Scalars["ID"];
}

export interface ApprovalsUnsafeFlag {
  value?: Maybe<Scalars["String"]>;
}

export enum ApprovalsUnsafeFlagKeyType {
  CUSTOMER_ACCOUNT_ID = "CUSTOMER_ACCOUNT_ID",
  CUSTOMER_USER_ID = "CUSTOMER_USER_ID",
  INVALID = "INVALID",
}

export interface ApproveBeneficiariesError extends StandardClientError {
  code: ErrorCode;
  errorSubtype: ApproveBeneficiariesErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export enum ApproveBeneficiariesErrorCode {
  INVALID_OTP_CODE = "INVALID_OTP_CODE",
  RATE_LIMITED = "RATE_LIMITED",
}

/**  ---[ Input Types ]--- */
export interface ApproveBeneficiariesInput {
  /** The OTP code that was sent to the admin's phone number and email */
  otpCode: Scalars["String"];
  /** The beneficiaries to approve */
  trustedBeneficiariesIds: Array<Scalars["ID"]>;
}

export interface ApproveBeneficiariesResult extends MutationResult {
  errors?: Maybe<Array<ApproveBeneficiariesError>>;
  result?: Maybe<Array<TrustedBeneficiary>>;
}

/** Input to approve a limit increase request. */
export interface ApproveBudgetLimitIncreaseRequestInput {
  id: Scalars["ID"];
  isAdminOverride: Scalars["Boolean"];
  version: Scalars["Int"];
}

export interface ApproveBudgetLimitIncreaseRequestV2Result
  extends MutationResult {
  /** The ID of the budget limit increase request. */
  budgetLimitIncreaseRequestEntityId?: Maybe<Scalars["ID"]>;
  /** A list of user errors for mutation responses. Clients should always request this field when performing mutations */
  errors?: Maybe<Array<ClientError>>;
}

/** Input type to approve a budget request */
export interface ApproveBudgetRequestInput {
  budgetRequestEntityId: Scalars["ID"];
  isAdminOverride: Scalars["Boolean"];
  version: Scalars["Int"];
}

export interface ApproveBudgetRequestV2Result extends MutationResult {
  /** The ID of the budget request. */
  budgetRequestEntityId?: Maybe<Scalars["ID"]>;
  /** A list of user errors for mutation responses. Clients should always request this field when performing mutations */
  errors?: Maybe<Array<ClientError>>;
}

export interface ArcMetricsGraph {
  percentage: Scalars["Float"];
}

/** Input for archiving the limit group */
export interface ArchiveLimitGroupInput {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
}

export interface ArchiveLimitGroupResult extends MutationResult {
  errors?: Maybe<Array<LimitGroupMutationError>>;
}

/** Input for the spend budget archivation */
export interface ArchiveSpendBudgetInput {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
}

export interface ArchiveSpendBudgetResult extends MutationResult {
  errors?: Maybe<Array<SpendBudgetMutationError>>;
}

/** Input for the spend limit archivation */
export interface ArchiveSpendLimitInput {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
}

export interface ArchiveSpendLimitResult extends MutationResult {
  errors?: Maybe<Array<StandardClientError>>;
}

/** A resource representing a the details of a loyalty program. */
export interface AscendaDetailsV2 {
  /** The currency name of the loyalty program e.g TrueBlue points */
  currencyName?: Maybe<Scalars["String"]>;
  /** The slogan of the airline */
  description?: Maybe<Scalars["String"]>;
  /** The url of the airline's enrollment page */
  enrollmentLink?: Maybe<Scalars["String"]>;
  /** The estimated processing time in hours */
  estimatedProcessingTimeHours?: Maybe<Scalars["Int"]>;
  /** The currency name of the loyalty program e.g JetBlue TrueBlue points */
  fullCurrencyName?: Maybe<Scalars["String"]>;
  /** Details of whether the loyalty program is under maintenance and for how long */
  maintenance: AscendaMaintenanceV2;
  /** The name of the partner, e.g JetBlue */
  partnerName?: Maybe<Scalars["String"]>;
  /** The name of the loyalty program e.g Cathay */
  programName?: Maybe<Scalars["String"]>;
  /** The short name of the loyalty program, e.g Miles */
  shortProgramName?: Maybe<Scalars["String"]>;
  /** The T&C of the airline */
  termsAndConditionsLink?: Maybe<Scalars["String"]>;
}

export interface AscendaMaintenanceV2 {
  creditingDelayHours?: Maybe<Scalars["Int"]>;
  enabled: Scalars["Boolean"];
}

export interface AscendaTransferPayloadV2 {
  exchangeRate: Scalars["Int"];
  loyaltyProgramId: Scalars["String"];
}

/** Asset */
export interface Asset extends Node {
  /** The actual data for the asset (whose type is one of the AssetData types). */
  data: AssetData;
  /**
   * Download Url: short lived, proxied by Filestore unless fiuo is true.
   * @deprecated use expiringUrl instead
   */
  downloadUrl?: Maybe<Scalars["String"]>;
  /** An expiring link to the asset generated by S3. includes expiry time in the response. */
  expiringPresignedUrl?: Maybe<ExpiringUrl>;
  /** An expiring link to the asset, unique each time it's requested. includes expiry time in the response. */
  expiringViewUrl?: Maybe<ExpiringUrl>;
  /** The ID of an object */
  id: Scalars["ID"];
  /**
   * Short-lived, presigned download URL: usable without authorization.
   * @deprecated use expiringUrl instead
   */
  presignedDownloadUrl?: Maybe<Scalars["String"]>;
}

export type AssetData = EmailAsset | FileAsset;

/** Input type for assigning budgets to cards. */
export interface AssignBudgetToCardInput {
  budgetId: Scalars["ID"];
  budgetMappingExpiration?: InputMaybe<BudgetMappingExpiration>;
  clientMutationId: Scalars["String"];
  effectiveRange?: InputMaybe<EffectiveRangeInput>;
  networkCardId: Scalars["ID"];
  type?: InputMaybe<BudgetMappingType>;
}

/** Response type for assigning budgets to cards. */
export interface AssignBudgetToCardResult {
  cardBudgetMapping: CardBudgetMapping;
  clientMutationId: Scalars["String"];
}

export interface AssignFSPUsersRolesInput {
  clientCustomerAccountId: Scalars["ID"];
  fspCustomerUsers: Array<FSPUser>;
}

export interface AssignFSPUsersRolesResult {
  fspCustomerUserIds?: Maybe<Array<Scalars["ID"]>>;
}

/** The types of relationships for filtering who is assigned a request. */
export enum AssignedToFilterInput {
  /** Assigned to anyone in the user's company */
  COMPANY = "COMPANY",
  /** Assigned to the logged in user */
  ME = "ME",
  /** Assigned to anyone except the logged in user */
  OTHERS = "OTHERS",
}

export interface AssistantCitedTextMessage extends AssistantMessage {
  /**
   * Citation sources, which are not individual citations themselves that are referenced in a cited text. Individual
   * citations are listed in each citation source object
   */
  citationSources: Array<CitationSource>;
  links?: Maybe<Array<AssistantMessageLink>>;
  messageId: Scalars["ID"];
  origin: AssistantMessageOrigin;
  /** Generated text, e.g. an answer to the user's question */
  text: Scalars["String"];
}

export interface AssistantEnablements {
  aiCommenting: EnablementState;
  chatInSlack: EnablementState;
}

export interface AssistantEnablementsInput {
  aiCommenting?: InputMaybe<EnablementState>;
  chatInSlack?: InputMaybe<EnablementState>;
}

/** A set of Expenses to be rendered as a single message block */
export interface AssistantExpensesMessage extends AssistantMessage {
  /** The individual items to be rendered in this expense group card. */
  items: Array<AssistantExpensesMessageItem>;
  links?: Maybe<Array<AssistantMessageLink>>;
  messageId: Scalars["ID"];
  origin: AssistantMessageOrigin;
}

export interface AssistantExpensesMessageItem {
  /**
   * 0 or more suggestions regarding the budget attribute of the expense.
   * Suggestions will always be sorted from highest confidence to lowest confidence if confidence is available.
   */
  budgetSuggestions: Array<AutomationSuggestion>;
  /** The full expense item that contains memo, budget, attendees, and addendum info. */
  expense: Expense;
  /**
   * 0 or more suggestions regarding the attendee attribute of the expense.
   * Suggestions will always be sorted from highest confidence to lowest confidence if confidence is available.
   */
  listAttendeeSuggestions: Array<AutomationSuggestion>;
  /**
   * 0 or more suggestions regarding the memo attribute of the expense.
   * Suggestions will always be sorted from highest confidence to lowest confidence if confidence is available.
   */
  memoSuggestions: Array<AutomationSuggestion>;
  /**
   * A list of fields that are proposed to be updated by the assistant, along with the field's proposed new value.
   * If this list is empty, the assistant is not proposing to update any fields.
   */
  proposedUpdatedFields: Array<AssistantProposedExpensesMessageItemField>;
  /**
   * A list of fields that have been updated by the assistant.
   * If this list is empty, the assistant has not updated any fields.
   */
  updatedFields: Array<AssistantExpensesMessageItemField>;
}

export enum AssistantExpensesMessageItemField {
  ATTENDEES = "ATTENDEES",
  BUDGET = "BUDGET",
  EXPENSE_CATEGORY = "EXPENSE_CATEGORY",
  MEMO = "MEMO",
  RECEIPT = "RECEIPT",
}

export enum AssistantFeedbackSentiment {
  /** Used to support google play Generative AI feedback requirements. */
  ABUSIVE = "ABUSIVE",
  NEGATIVE = "NEGATIVE",
  POSITIVE = "POSITIVE",
}

/** The simplest message block type, only rendering plain non-markdown text with no interactive elements. */
export interface AssistantFreeTextMessage extends AssistantMessage {
  links?: Maybe<Array<AssistantMessageLink>>;
  message: Scalars["String"];
  messageId: Scalars["ID"];
  origin: AssistantMessageOrigin;
}

/** A card to display a number of rules the assistant has stored for the user. */
export interface AssistantGuidanceCard extends AssistantMessage {
  links?: Maybe<Array<AssistantMessageLink>>;
  messageId: Scalars["ID"];
  origin: AssistantMessageOrigin;
  rules: Array<AssistantGuidanceRule>;
}

export interface AssistantGuidanceRule {
  id: Scalars["ID"];
  /**
   * Human understandable string explaining a rule.
   * ex: "I will automatically set all expenses at Costco to your Office Supplies budget."
   */
  ruleText: Scalars["String"];
  status: AssistantRuleStatus;
}

export interface AssistantMessage {
  /** All messages may have links back to the product, e.g. to the EDP or to the Reimbursement page, etc. */
  links?: Maybe<Array<AssistantMessageLink>>;
  /**
   * Unique BE-generated ID to identify a message from the assistant in a session.
   * Clients should retain these in memory for the duration of a session.
   */
  messageId: Scalars["ID"];
  /** Enum to identify who sent the message. */
  origin: AssistantMessageOrigin;
}

export interface AssistantMessageLink {
  /** The link display text, e.g. "View Expense" */
  displayText: Scalars["String"];
  /** The link value, e.g. a URL */
  linkValue: Scalars["String"];
}

export enum AssistantMessageOrigin {
  ASSISTANT = "ASSISTANT",
  USER = "USER",
}

export interface AssistantMessagesConnection extends Connection {
  edges: Array<AssistantMessagesConnectionGroupEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface AssistantMessagesConnectionGroupEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<AssistantMessage>;
}

export enum AssistantMode {
  /** Assistant is ON with AUTO_PILOT */
  AUTO_PILOT = "AUTO_PILOT",
  /** Assistant feature is not available */
  INELIGIBLE = "INELIGIBLE",
  /** Assistant is OFF */
  OFF = "OFF",
  /** Assistant is ON without AUTO_PILOT */
  ON = "ON",
}

/**
 * A card to explain a portion of an expense policy in a concise manner.
 * This card is NOT meant to directly answer specific questions and will generally be
 * coupled with a FreeText card containing a more direct answer to any questions.
 */
export interface AssistantPolicyDetailsCard extends AssistantMessage {
  /** A markdown string generated by the Assistant service to concisely explain a portion of the user's expense policy */
  detailsMarkdown: Scalars["String"];
  links?: Maybe<Array<AssistantMessageLink>>;
  messageId: Scalars["ID"];
  origin: AssistantMessageOrigin;
  policy: Policy;
  policyDetailsCategory: AssistantPolicyDetailsCategory;
}

/** The category of information within the policy that is being explained. */
export enum AssistantPolicyDetailsCategory {
  CARD_DOCUMENTATION = "CARD_DOCUMENTATION",
  CAR_RENTAL = "CAR_RENTAL",
  FLIGHTS = "FLIGHTS",
  HOTELS = "HOTELS",
  MEALS = "MEALS",
  MERCHANTS = "MERCHANTS",
  OTHER = "OTHER",
  REIMBURSEMENT_DOCUMENTATION = "REIMBURSEMENT_DOCUMENTATION",
}

export interface AssistantProposedExpenseAttendees {
  /** Expense attendees being proposed to be added */
  addAttendees: Array<ExpenseAttendee>;
  /** Expense attendees being proposed to be removed */
  removeAttendees: Array<ExpenseAttendee>;
}

export interface AssistantProposedExpenseBudget {
  /** ID of spend limit or legacy budget being proposed */
  budget: Budget;
}

export interface AssistantProposedExpenseCategory {
  /** Identifier of the expense category being proposed */
  expenseCategoryId: Scalars["String"];
  /** Name of the expense category being proposed */
  expenseCategoryName: Scalars["String"];
}

export interface AssistantProposedExpenseMemo {
  /** Text of memo being proposed */
  memo: Scalars["String"];
}

export type AssistantProposedExpensesMessageItemField =
  | AssistantProposedExpenseAttendees
  | AssistantProposedExpenseBudget
  | AssistantProposedExpenseCategory
  | AssistantProposedExpenseMemo;

export enum AssistantRuleStatus {
  ACTIVE = "ACTIVE",
  DELETED = "DELETED",
}

export enum AssistantStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

/** A potential reply suggested by the agent that the user can choose to use. */
export interface AssistantSuggestedReplyMessage extends AssistantMessage {
  links?: Maybe<Array<AssistantMessageLink>>;
  messageId: Scalars["ID"];
  origin: AssistantMessageOrigin;
  /** The suggested reply to be rendered */
  reply: Scalars["String"];
  /** Whether the suggested reply is static or requires user completion */
  textCompletionFormat: AssistantSuggestedReplyMessageFormat;
}

export enum AssistantSuggestedReplyMessageFormat {
  /**
   * A single string from the user should be appended to the end of the reply string.
   * E.g. "Update the memos for all expenses above to be:"
   */
  APPEND_TEXT_TO_END = "APPEND_TEXT_TO_END",
  /** The reply does not require any user text completion */
  NO_TEXT_COMPLETION = "NO_TEXT_COMPLETION",
}

export interface AsyncCreateDefaultUserSpendLimitsInput {
  /** Spend Limit Authorization Settings. */
  authorizationSettings: SpendLimitAuthorizationSettingsInput;
  /** The idempotency key */
  clientMutationId: Scalars["String"];
  /** End date of the spend limit */
  endDate?: InputMaybe<Scalars["Date"]>;
  /** The ID of the expense policy for this limit. */
  expensePolicyId: Scalars["ID"];
  /** Recurrence type of the spend limit */
  periodRecurrenceType: SpendLimitPeriodRecurrenceType;
  /** Start date of the spend limit */
  startDate?: InputMaybe<Scalars["Date"]>;
  /** The user IDs */
  userIds: Array<Scalars["ID"]>;
}

export interface AsyncCreateDefaultUserSpendLimitsResult
  extends MutationResult {
  errors?: Maybe<Array<StandardClientError>>;
  workflowId: Scalars["String"];
}

export interface AsyncCreateExpensesSearchReportInput {
  /**
   * The expense filter input used to get the list of expenses to be exported.
   * Only one of [filter, queryFilter] can be specified.
   * If both are specified, queryFilter will take precedence.
   */
  filter?: InputMaybe<ExpenseFilterInput>;
  /** The number of expenses expected in the report */
  numExpenses: Scalars["Int"];
  /**
   * [oneOf] Entity Filter to be provided into QueriesService.executeQuery().
   * Only one of [filter, queryFilter] can be specified.
   * If both are specified, queryFilter will take precedence.
   */
  queryFilter?: InputMaybe<ExpenseReportQueryInput>;
  /** The report format type for the exported expenses search. */
  reportFormat: ReportFormatType;
  /** Sets the report mode */
  reportMode?: InputMaybe<ReportMode>;
  /** The report options for the exported expenses search. */
  reportOptions?: InputMaybe<Array<ReportOption>>;
  /** Flag to indicate if email notification should be sent upon task completion. Defaults to false. */
  sendNotification?: InputMaybe<Scalars["Boolean"]>;
}

export interface AsyncCreateExpensesSearchReportResult {
  /** The expenses export task. */
  task: Task;
}

export enum AttendeeRequirementsFilter {
  HAS_ACCESSIBILITY_REQUIREMENTS = "HAS_ACCESSIBILITY_REQUIREMENTS",
  HAS_ANY_REQUIREMENTS = "HAS_ANY_REQUIREMENTS",
  HAS_DIETARY_REQUIREMENTS = "HAS_DIETARY_REQUIREMENTS",
  HAS_NO_REQUIREMENTS = "HAS_NO_REQUIREMENTS",
}

export enum AttendeeStatus {
  ADDED = "ADDED",
  BOOKED = "BOOKED",
  CONFIRMED = "CONFIRMED",
  DECLINED = "DECLINED",
  DELETED = "DELETED",
  INVITED = "INVITED",
}

export interface AttendeeSuggestion {
  confidenceLevel: SuggestionConfidenceLevel;
}

export interface AttendeesAddendum extends ExpenseAddendum {
  /** Attendees who are not on the Brex system */
  externalAttendees: Array<ExternalAttendee>;
  /** The unique ID of the expense addendum. */
  id: Scalars["ID"];
  /** Attendees who are on the Brex system on the same account as the expense. */
  internalAttendees: Array<Employee>;
}

export interface AttendeesAddendumInput {
  /** Attendees who are not on the Brex system */
  externalAttendees: Array<ExternalAttendeeInput>;
  /** Attendees who are on the Brex system on the same account as the expense. */
  internalAttendees: Array<InternalAttendeeInput>;
}

export enum AttendeesContainGovernmentOfficialStatus {
  GOVERNMENT_OFFICIAL_ABSENT = "GOVERNMENT_OFFICIAL_ABSENT",
  GOVERNMENT_OFFICIAL_PRESENT = "GOVERNMENT_OFFICIAL_PRESENT",
}

export enum AttendeesRequirements {
  /** Requires that the attendee have a company name defined. */
  REQUIRE_COMPANY_NAME = "REQUIRE_COMPANY_NAME",
  /** Requires that a government official attendee have employment status defined. */
  REQUIRE_GOVERNMENT_EMPLOYMENT_STATUS_ACTION = "REQUIRE_GOVERNMENT_EMPLOYMENT_STATUS_ACTION",
  /** Requires external attendee title */
  REQUIRE_TITLE = "REQUIRE_TITLE",
}

/** Type containing review rules for attendees. */
export interface AttendeesReviewRules {
  /** Whether managers should be flagged as attendees */
  shouldFlagManagerAsAttendee: Scalars["Boolean"];
  /** Whether attendees should be checked against a list of government officials */
  shouldRunBriberyCheck: Scalars["Boolean"];
}

/** Input for review rules concerning attendees. */
export interface AttendeesReviewRulesInput {
  /** Whether managers should be flagged as attendees */
  shouldFlagManagerAsAttendee: Scalars["Boolean"];
  /** Whether attendees should be checked against a list of government officials */
  shouldRunBriberyCheck: Scalars["Boolean"];
}

/** The source to destination mapping that will be created */
export interface AttributeMapping {
  attributeType: AttributeType;
  destinationAttributeId: Scalars["ID"];
  id?: InputMaybe<Scalars["ID"]>;
  sourceValue: Scalars["String"];
}

/** The type of attribute */
export enum AttributeType {
  LEGAL_ENTITY = "LEGAL_ENTITY",
}

export interface AttributionMetadataInput {
  /** identifier for fb */
  fbc?: InputMaybe<Scalars["String"]>;
  /** identifier for fb */
  fbp?: InputMaybe<Scalars["String"]>;
  /** google click id */
  gclid?: InputMaybe<Scalars["String"]>;
  /** microsoft click id */
  msclkid?: InputMaybe<Scalars["String"]>;
  /** anonymous id coming from Segment */
  segmentAnonymousId?: InputMaybe<Scalars["String"]>;
}

/**
 * Bank State Branch (BSB) - Australian banking code.
 * * Bank State Branch (BSB) - branch identifier.
 * * account number - account identifier within the bank.
 */
export interface AuLocal {
  accountNumber?: Maybe<Scalars["String"]>;
  bsbCode?: Maybe<Scalars["String"]>;
}

/**
 * Bank State Branch (BSB) - Australian banking code.
 * * Bank State Branch (BSB) - branch identifier.
 * * account number - account identifier within the bank.
 */
export interface AuLocalInput {
  accountNumber?: InputMaybe<Scalars["String"]>;
  bsbCode?: InputMaybe<Scalars["String"]>;
}

export interface AuditActorTypesFilterOptionsConnection extends Connection {
  edges?: Maybe<Array<Maybe<ActorTypesEdge>>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface AuditDecision {
  violationReason?: Maybe<Scalars["String"]>;
}

export interface AuditGroup extends Node {
  /** The creation date of this group. */
  createdAt: Scalars["LocalDateTime"];
  /** The earliest expense date of this group. Only expenses created after this date will be assigned to the group (as determined by the purchased data field). */
  earliestExpenseDate: Scalars["LocalDateTime"];
  /** The group escalation reason and summary of the audit group, e.g. "Meal expenses outside travel dates are assigned to New York Onsite". */
  escalationSummary?: Maybe<EscalationSummary>;
  /** The audited expenses include expense metadata and audit decisions */
  groupedExpenses?: Maybe<ExpenseGroupConnection>;
  /** The ID of an object */
  id: Scalars["ID"];
  /** The latest expense date of this group. Only expenses created before this date will be assigned to the group (as determined by the purchased data field). */
  latestExpenseDate: Scalars["LocalDateTime"];
  /** The priority of the audit group indicating the urgency of the group is. */
  priority?: Maybe<AuditGroupPriority>;
  /** The status of the group. it helps to indicate if the group is active vs closed */
  status?: Maybe<AuditGroupStatus>;
  /** The title of the audit group, eg. "New York Onsite". */
  title: Scalars["String"];
  /** The total purchased amount aggregated across all expenses within this audit group */
  totalPurchasedAmount?: Maybe<FinancialAsset>;
  /** The modification date of this group. */
  updatedAt: Scalars["LocalDateTime"];
}

export interface AuditGroupgroupedExpensesArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<ExpenseEntityFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  groupBy: ExpenseGroupByInput;
  last?: InputMaybe<Scalars["Int"]>;
  sorts?: InputMaybe<Array<ExpenseEntitySortInput>>;
}

/** An audit group connection for audit group pagination. */
export interface AuditGroupConnection extends Connection {
  /** The audit groups in the current page of results. */
  edges?: Maybe<Array<AuditGroupEdge>>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of audit groups matching the filter criteria specified for this connection. */
  totalCount: Scalars["Int"];
}

/** An audit group edge for Audit Group pagination. */
export interface AuditGroupEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The audit group at this edge. */
  node: AuditGroup;
}

/** Holds LLM-generated audit escalation reasons for a group. */
export interface AuditGroupEscalationReason {
  auditDecision?: Maybe<AuditDecision>;
  escalatedExpenses?: Maybe<Array<Expense>>;
  title: Scalars["String"];
}

export interface AuditGroupMutationError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export enum AuditGroupPriority {
  HIGH = "HIGH",
  LOW = "LOW",
  MEDIUM = "MEDIUM",
}

export enum AuditGroupStatus {
  AUDITED = "AUDITED",
  PENDING_AUDIT = "PENDING_AUDIT",
  PENDING_USER_ACTION = "PENDING_USER_ACTION",
}

/** Filters available to control which audit groups get returned. */
export interface AuditGroupWhereInput {
  /** Match IN specific audit group ids, match ALL when no filter is provided */
  auditGroupIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Match IN specific audit group statuses, match ALL when no filter or an empty list is provided */
  statuses?: InputMaybe<Array<AuditGroupStatus>>;
}

export interface AuditLog {
  actor: Actor;
  context?: Maybe<Context>;
  finishedAt: Scalars["Time"];
  id: Scalars["ID"];
  operationType: AuditOperationType;
  primitive: AuditPrimitive;
  status: AuditLogStatus;
  structuredData?: Maybe<StructuredData>;
  target: Target;
}

export interface AuditLogEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<AuditLog>;
}

export interface AuditLogSort {
  field?: InputMaybe<AuditLogsSortField>;
  order?: InputMaybe<AuditLogsSortOrder>;
}

/** AuditLogs */
export enum AuditLogStatus {
  FAILED = "FAILED",
  SUCCEEDED = "SUCCEEDED",
}

export interface AuditLogsConnection extends Connection {
  edges?: Maybe<Array<Maybe<AuditLogEdge>>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

/**  Shared by task manager dgs */
export interface AuditLogsFilterInput {
  /**  Only supported for internal use cases. */
  actorId?: InputMaybe<Scalars["String"]>;
  actorName?: InputMaybe<Scalars["String"]>;
  actorType?: InputMaybe<ActorType>;
  actorTypes?: InputMaybe<Array<InputMaybe<ActorType>>>;
  finishedAfter?: InputMaybe<Scalars["Time"]>;
  finishedBefore?: InputMaybe<Scalars["Time"]>;
  id?: InputMaybe<Scalars["String"]>;
  logTargetId?: InputMaybe<Scalars["ID"]>;
  operationName?: InputMaybe<AuditOperationName>;
  operationNames?: InputMaybe<Array<InputMaybe<AuditOperationName>>>;
  primitive?: InputMaybe<AuditPrimitive>;
  searchText?: InputMaybe<Scalars["String"]>;
  targetId?: InputMaybe<Scalars["String"]>;
  targetName?: InputMaybe<Scalars["String"]>;
  targetType?: InputMaybe<TargetType>;
  targetTypes?: InputMaybe<Array<InputMaybe<TargetType>>>;
  transactionId?: InputMaybe<Scalars["String"]>;
}

export enum AuditLogsSortField {
  ACTOR_NAME = "ACTOR_NAME",
  FINISHED_AT = "FINISHED_AT",
  OPERATION_NAME = "OPERATION_NAME",
}

export enum AuditLogsSortOrder {
  ASCENDING = "ASCENDING",
  DESCENDING = "DESCENDING",
}

export interface AuditLogsTotalCount {
  value?: Maybe<Scalars["Long"]>;
}

export enum AuditOperationName {
  ACCOUNTING_ACCRUAL_REVERSAL_CREATED = "ACCOUNTING_ACCRUAL_REVERSAL_CREATED",
  ACCOUNTING_ACCRUAL_STATUS_SET = "ACCOUNTING_ACCRUAL_STATUS_SET",
  ACCOUNTING_CUSTOM_RULE_CREATED = "ACCOUNTING_CUSTOM_RULE_CREATED",
  ACCOUNTING_CUSTOM_RULE_DELETED = "ACCOUNTING_CUSTOM_RULE_DELETED",
  ACCOUNTING_CUSTOM_RULE_UPDATED = "ACCOUNTING_CUSTOM_RULE_UPDATED",
  ACCOUNTING_EXPORTED = "ACCOUNTING_EXPORTED",
  ACCOUNTING_EXPORT_BILL_EXPORT_FAILED = "ACCOUNTING_EXPORT_BILL_EXPORT_FAILED",
  ACCOUNTING_EXPORT_BILL_EXPORT_SUCCEEDED = "ACCOUNTING_EXPORT_BILL_EXPORT_SUCCEEDED",
  ACCOUNTING_EXPORT_ENTRY_EXPORT_FAILED = "ACCOUNTING_EXPORT_ENTRY_EXPORT_FAILED",
  ACCOUNTING_EXPORT_ENTRY_EXPORT_SUCCEEDED = "ACCOUNTING_EXPORT_ENTRY_EXPORT_SUCCEEDED",
  ACCOUNTING_EXPORT_PAYMENT_EXPORT_FAILED = "ACCOUNTING_EXPORT_PAYMENT_EXPORT_FAILED",
  ACCOUNTING_EXPORT_PAYMENT_EXPORT_SUCCEEDED = "ACCOUNTING_EXPORT_PAYMENT_EXPORT_SUCCEEDED",
  ACCOUNTING_EXPORT_STARTED = "ACCOUNTING_EXPORT_STARTED",
  ACCOUNTING_IMPORT_STARTED = "ACCOUNTING_IMPORT_STARTED",
  ACCOUNTING_INTEGRATION_SETTINGS_CHANGED = "ACCOUNTING_INTEGRATION_SETTINGS_CHANGED",
  ACCOUNTING_MAPPING_CREATED = "ACCOUNTING_MAPPING_CREATED",
  ACCOUNTING_MAPPING_DELETED = "ACCOUNTING_MAPPING_DELETED",
  ACCOUNTING_MAPPING_UPDATED = "ACCOUNTING_MAPPING_UPDATED",
  ACCOUNTING_PREPARED_AS_ACTUAL = "ACCOUNTING_PREPARED_AS_ACTUAL",
  ACCOUNTING_REVIEW_STATUS_SET = "ACCOUNTING_REVIEW_STATUS_SET",
  ACCOUNTING_SENT_BACK_TO_PREPARE = "ACCOUNTING_SENT_BACK_TO_PREPARE",
  ACCOUNTING_SUBSIDIARY_SETTINGS_CHANGED = "ACCOUNTING_SUBSIDIARY_SETTINGS_CHANGED",
  ACTIVATE_CARD = "ACTIVATE_CARD",
  AUDIT_TRAIL_EXPORTED = "AUDIT_TRAIL_EXPORTED",
  AUTO_INVITE_SETTING_CREATED = "AUTO_INVITE_SETTING_CREATED",
  AUTO_INVITE_SETTING_DELETED = "AUTO_INVITE_SETTING_DELETED",
  AUTO_INVITE_SETTING_UPDATED = "AUTO_INVITE_SETTING_UPDATED",
  BILL_ACCRUE_DATE_CHANGED = "BILL_ACCRUE_DATE_CHANGED",
  BILL_ACCRUE_DATE_DELETED = "BILL_ACCRUE_DATE_DELETED",
  BILL_DUE_DATE_CHANGED = "BILL_DUE_DATE_CHANGED",
  BILL_DUE_DATE_DELETED = "BILL_DUE_DATE_DELETED",
  BILL_ERP_AP_ACCOUNT_CHANGED = "BILL_ERP_AP_ACCOUNT_CHANGED",
  BILL_ERP_AP_ACCOUNT_DELETED = "BILL_ERP_AP_ACCOUNT_DELETED",
  BILL_ERP_PAYMENT_ACCOUNT_CHANGED = "BILL_ERP_PAYMENT_ACCOUNT_CHANGED",
  BILL_ERP_PAYMENT_ACCOUNT_DELETED = "BILL_ERP_PAYMENT_ACCOUNT_DELETED",
  BILL_INVOICE_ADDED = "BILL_INVOICE_ADDED",
  BILL_INVOICE_DELETED = "BILL_INVOICE_DELETED",
  BILL_INVOICE_RECEIVED_BY_EMAIL = "BILL_INVOICE_RECEIVED_BY_EMAIL",
  BILL_MARKED_PAID = "BILL_MARKED_PAID",
  BILL_MARKED_UNIQUE = "BILL_MARKED_UNIQUE",
  BILL_PAYMENT_DETAILS_CHANGED = "BILL_PAYMENT_DETAILS_CHANGED",
  BILL_PAYMENT_INITIATED = "BILL_PAYMENT_INITIATED",
  BILL_PAYMENT_RETRIED = "BILL_PAYMENT_RETRIED",
  BILL_PAYMENT_TYPE_CHANGED = "BILL_PAYMENT_TYPE_CHANGED",
  BILL_PURCHASE_ORDER_CHANGED = "BILL_PURCHASE_ORDER_CHANGED",
  BILL_SEND_ON_DATE_CHANGED = "BILL_SEND_ON_DATE_CHANGED",
  BILL_SEND_ON_DATE_DELETED = "BILL_SEND_ON_DATE_DELETED",
  BILL_SOURCE_ACCOUNT_CHANGED = "BILL_SOURCE_ACCOUNT_CHANGED",
  BILL_VENDOR_CHANGED = "BILL_VENDOR_CHANGED",
  BOOKING_APPROVAL_REQUESTED = "BOOKING_APPROVAL_REQUESTED",
  BOOKING_APPROVED = "BOOKING_APPROVED",
  BOOKING_CREATED = "BOOKING_CREATED",
  BOOKING_DENIED = "BOOKING_DENIED",
  BOOKING_FARE_UPDATED = "BOOKING_FARE_UPDATED",
  BOOKING_STATUS_UPDATED = "BOOKING_STATUS_UPDATED",
  BUDGET_ALLOWED_MCC_ADDED = "BUDGET_ALLOWED_MCC_ADDED",
  BUDGET_ALLOWED_MCC_REMOVED = "BUDGET_ALLOWED_MCC_REMOVED",
  BUDGET_AMOUNT_ADDED = "BUDGET_AMOUNT_ADDED",
  BUDGET_AMOUNT_DECREASED = "BUDGET_AMOUNT_DECREASED",
  BUDGET_AMOUNT_INCREASED = "BUDGET_AMOUNT_INCREASED",
  BUDGET_AMOUNT_REMOVED = "BUDGET_AMOUNT_REMOVED",
  BUDGET_ARCHIVED = "BUDGET_ARCHIVED",
  BUDGET_AUTO_CREATE_LIMIT_CARDS_SETTING_CHANGED = "BUDGET_AUTO_CREATE_LIMIT_CARDS_SETTING_CHANGED",
  BUDGET_AUTO_TRANSFER_CARDS_DISABLED = "BUDGET_AUTO_TRANSFER_CARDS_DISABLED",
  BUDGET_AUTO_TRANSFER_CARDS_ENABLED = "BUDGET_AUTO_TRANSFER_CARDS_ENABLED",
  BUDGET_BLOCKED_MCC_ADDED = "BUDGET_BLOCKED_MCC_ADDED",
  BUDGET_BLOCKED_MCC_REMOVED = "BUDGET_BLOCKED_MCC_REMOVED",
  BUDGET_BLOCK_REIMBURSEMENT_AND_BUDGET_SELECTION_DISABLED = "BUDGET_BLOCK_REIMBURSEMENT_AND_BUDGET_SELECTION_DISABLED",
  BUDGET_BLOCK_REIMBURSEMENT_AND_BUDGET_SELECTION_ENABLED = "BUDGET_BLOCK_REIMBURSEMENT_AND_BUDGET_SELECTION_ENABLED",
  BUDGET_CREATED = "BUDGET_CREATED",
  BUDGET_CURRENCY_CHANGED = "BUDGET_CURRENCY_CHANGED",
  BUDGET_DELETED = "BUDGET_DELETED",
  BUDGET_DESCRIPTION_CHANGED = "BUDGET_DESCRIPTION_CHANGED",
  BUDGET_EXPIRATION_DATE_CHANGED = "BUDGET_EXPIRATION_DATE_CHANGED",
  BUDGET_EXPIRED = "BUDGET_EXPIRED",
  BUDGET_GENERIC_ACTION = "BUDGET_GENERIC_ACTION",
  BUDGET_LEGAL_ENTITY_CHANGED = "BUDGET_LEGAL_ENTITY_CHANGED",
  BUDGET_LEGAL_ENTITY_REMOVED = "BUDGET_LEGAL_ENTITY_REMOVED",
  BUDGET_LIMIT_DECREASED = "BUDGET_LIMIT_DECREASED",
  BUDGET_LIMIT_FLEXIBILITY_DISABLED = "BUDGET_LIMIT_FLEXIBILITY_DISABLED",
  BUDGET_LIMIT_FLEXIBILITY_ENABLED = "BUDGET_LIMIT_FLEXIBILITY_ENABLED",
  BUDGET_LIMIT_FLEXIBILITY_THRESHOLD_CHANGED = "BUDGET_LIMIT_FLEXIBILITY_THRESHOLD_CHANGED",
  BUDGET_LIMIT_INCREASED = "BUDGET_LIMIT_INCREASED",
  BUDGET_LIMIT_INCREASE_REQUESTED = "BUDGET_LIMIT_INCREASE_REQUESTED",
  BUDGET_LIMIT_INCREASE_REQUEST_APPROVED = "BUDGET_LIMIT_INCREASE_REQUEST_APPROVED",
  BUDGET_LIMIT_INCREASE_REQUEST_REJECTED = "BUDGET_LIMIT_INCREASE_REQUEST_REJECTED",
  BUDGET_LIMIT_REMOVED = "BUDGET_LIMIT_REMOVED",
  BUDGET_LIMIT_REQUESTS_DISABLED = "BUDGET_LIMIT_REQUESTS_DISABLED",
  BUDGET_LIMIT_REQUESTS_ENABLED = "BUDGET_LIMIT_REQUESTS_ENABLED",
  BUDGET_LIMIT_VISIBILITY_DISABLED = "BUDGET_LIMIT_VISIBILITY_DISABLED",
  BUDGET_LIMIT_VISIBILITY_ENABLED = "BUDGET_LIMIT_VISIBILITY_ENABLED",
  BUDGET_MCC_DISABLED = "BUDGET_MCC_DISABLED",
  BUDGET_MCC_ENABLED = "BUDGET_MCC_ENABLED",
  BUDGET_MEMBERS_ADDED = "BUDGET_MEMBERS_ADDED",
  BUDGET_MEMBERS_REMOVED = "BUDGET_MEMBERS_REMOVED",
  BUDGET_MEMBER_EXPENSE_VISIBILITY_DISABLED = "BUDGET_MEMBER_EXPENSE_VISIBILITY_DISABLED",
  BUDGET_MEMBER_EXPENSE_VISIBILITY_ENABLED = "BUDGET_MEMBER_EXPENSE_VISIBILITY_ENABLED",
  BUDGET_NAME_CHANGED = "BUDGET_NAME_CHANGED",
  BUDGET_OWNERS_ADDED = "BUDGET_OWNERS_ADDED",
  BUDGET_OWNERS_REMOVED = "BUDGET_OWNERS_REMOVED",
  BUDGET_PARENT_BUDGET_CHANGED = "BUDGET_PARENT_BUDGET_CHANGED",
  BUDGET_POLICY_CHANGED = "BUDGET_POLICY_CHANGED",
  BUDGET_RECURRENCE_CHANGED = "BUDGET_RECURRENCE_CHANGED",
  BUDGET_REOPENED = "BUDGET_REOPENED",
  BUDGET_REQUESTED = "BUDGET_REQUESTED",
  BUDGET_REQUEST_APPROVED = "BUDGET_REQUEST_APPROVED",
  BUDGET_ROLLOVER_SETTINGS_CHANGED = "BUDGET_ROLLOVER_SETTINGS_CHANGED",
  BUDGET_ROLLOVER_SETTINGS_DISABLED = "BUDGET_ROLLOVER_SETTINGS_DISABLED",
  BUDGET_ROLLOVER_SETTINGS_ENABLED = "BUDGET_ROLLOVER_SETTINGS_ENABLED",
  BUDGET_SPEND_CAP_ADDED = "BUDGET_SPEND_CAP_ADDED",
  BUDGET_SPEND_CAP_CHANGED = "BUDGET_SPEND_CAP_CHANGED",
  BUDGET_SPEND_CAP_REMOVED = "BUDGET_SPEND_CAP_REMOVED",
  BUDGET_START_DATE_CHANGED = "BUDGET_START_DATE_CHANGED",
  BUDGET_START_DATE_REMOVED = "BUDGET_START_DATE_REMOVED",
  BUDGET_TERMINATED = "BUDGET_TERMINATED",
  BUDGET_TRANSACTION_LIMIT_CHANGED = "BUDGET_TRANSACTION_LIMIT_CHANGED",
  BUDGET_TRANSACTION_LIMIT_REMOVED = "BUDGET_TRANSACTION_LIMIT_REMOVED",
  CARD_ADDED_TO_DIGITAL_WALLET = "CARD_ADDED_TO_DIGITAL_WALLET",
  CARD_EXPENSE_DECLINED = "CARD_EXPENSE_DECLINED",
  CARD_LIMIT_SOURCE_AUTO_ASSIGNMENT_DISABLED = "CARD_LIMIT_SOURCE_AUTO_ASSIGNMENT_DISABLED",
  CARD_LIMIT_SOURCE_AUTO_ASSIGNMENT_ENABLED = "CARD_LIMIT_SOURCE_AUTO_ASSIGNMENT_ENABLED",
  CREATE_CARD = "CREATE_CARD",
  EXPENSE_AFFIDAVIT_GENERATED = "EXPENSE_AFFIDAVIT_GENERATED",
  EXPENSE_APPROVAL_SKIPPED_FOR_MULTIPLE_REVIEWERS = "EXPENSE_APPROVAL_SKIPPED_FOR_MULTIPLE_REVIEWERS",
  EXPENSE_APPROVAL_SKIPPED_FOR_SINGLE_REVIEWER = "EXPENSE_APPROVAL_SKIPPED_FOR_SINGLE_REVIEWER",
  EXPENSE_APPROVED = "EXPENSE_APPROVED",
  EXPENSE_ATTENDEES_CHANGED = "EXPENSE_ATTENDEES_CHANGED",
  EXPENSE_BILLING_AMOUNT_SET = "EXPENSE_BILLING_AMOUNT_SET",
  EXPENSE_BILLING_ENTITY_CHANGED = "EXPENSE_BILLING_ENTITY_CHANGED",
  EXPENSE_BUDGET_CHANGED = "EXPENSE_BUDGET_CHANGED",
  EXPENSE_CANCELED = "EXPENSE_CANCELED",
  EXPENSE_MEMO_DELETED = "EXPENSE_MEMO_DELETED",
  EXPENSE_MEMO_SET = "EXPENSE_MEMO_SET",
  EXPENSE_PAID = "EXPENSE_PAID",
  EXPENSE_RECEIPT_ADDED = "EXPENSE_RECEIPT_ADDED",
  EXPENSE_RECEIPT_DELETED = "EXPENSE_RECEIPT_DELETED",
  EXPENSE_REEVALUATED = "EXPENSE_REEVALUATED",
  EXPENSE_REJECTED = "EXPENSE_REJECTED",
  EXPENSE_REVIEW_REQUESTED_FOR_ADMIN = "EXPENSE_REVIEW_REQUESTED_FOR_ADMIN",
  EXPENSE_SPENDING_ENTITY_CHANGED = "EXPENSE_SPENDING_ENTITY_CHANGED",
  EXPENSE_SPLIT = "EXPENSE_SPLIT",
  EXPENSE_SUBMITTED = "EXPENSE_SUBMITTED",
  EXTENDED_FIELD_VALUE_DELETED = "EXTENDED_FIELD_VALUE_DELETED",
  EXTENDED_FIELD_VALUE_SET = "EXTENDED_FIELD_VALUE_SET",
  GROUP_EVENT_ATTENDEES_UPDATED = "GROUP_EVENT_ATTENDEES_UPDATED",
  GROUP_EVENT_CANCELLED = "GROUP_EVENT_CANCELLED",
  GROUP_EVENT_CREATED = "GROUP_EVENT_CREATED",
  GROUP_EVENT_UPDATED = "GROUP_EVENT_UPDATED",
  HRIS_SYNC_FINISHED = "HRIS_SYNC_FINISHED",
  HRIS_SYNC_STARTED = "HRIS_SYNC_STARTED",
  IDP_AUTH_FAILED = "IDP_AUTH_FAILED",
  LIMIT_CURRENCY_CHANGED = "LIMIT_CURRENCY_CHANGED",
  LIMIT_DESCRIPTION_CHANGED = "LIMIT_DESCRIPTION_CHANGED",
  LIMIT_GROUP_ARCHIVED = "LIMIT_GROUP_ARCHIVED",
  LIMIT_GROUP_CREATED = "LIMIT_GROUP_CREATED",
  LIMIT_GROUP_DELETED = "LIMIT_GROUP_DELETED",
  LIMIT_GROUP_EXPIRED = "LIMIT_GROUP_EXPIRED",
  LIMIT_GROUP_MOVED = "LIMIT_GROUP_MOVED",
  LIMIT_GROUP_PROPAGATION_ENDED = "LIMIT_GROUP_PROPAGATION_ENDED",
  LIMIT_GROUP_PROPAGATION_ENQUEUED = "LIMIT_GROUP_PROPAGATION_ENQUEUED",
  LIMIT_GROUP_PROPAGATION_FAILED = "LIMIT_GROUP_PROPAGATION_FAILED",
  LIMIT_GROUP_PROPAGATION_STARTED = "LIMIT_GROUP_PROPAGATION_STARTED",
  LIMIT_GROUP_REOPENED = "LIMIT_GROUP_REOPENED",
  LIMIT_GROUP_UPDATED = "LIMIT_GROUP_UPDATED",
  LIMIT_GROUP_UPDATED_USER_GROUP = "LIMIT_GROUP_UPDATED_USER_GROUP",
  LIMIT_LIMIT_DECREASED = "LIMIT_LIMIT_DECREASED",
  LIMIT_LIMIT_INCREASED = "LIMIT_LIMIT_INCREASED",
  LIMIT_NAME_CHANGED = "LIMIT_NAME_CHANGED",
  PARTNER_ACCOUNT_INTEGRATION_CREATED = "PARTNER_ACCOUNT_INTEGRATION_CREATED",
  PARTNER_ACCOUNT_INTEGRATION_STATUS_UPDATED = "PARTNER_ACCOUNT_INTEGRATION_STATUS_UPDATED",
  PARTNER_ACCOUNT_INTEGRATION_TYPES_UPDATED = "PARTNER_ACCOUNT_INTEGRATION_TYPES_UPDATED",
  RAIL_ACCOUNT_DETAILS_ACH_CREATED = "RAIL_ACCOUNT_DETAILS_ACH_CREATED",
  RAIL_ACCOUNT_DETAILS_ACH_DELETED = "RAIL_ACCOUNT_DETAILS_ACH_DELETED",
  RAIL_ACCOUNT_DETAILS_ACH_UPDATED = "RAIL_ACCOUNT_DETAILS_ACH_UPDATED",
  RAIL_ACCOUNT_DETAILS_CHECK_CREATED = "RAIL_ACCOUNT_DETAILS_CHECK_CREATED",
  RAIL_ACCOUNT_DETAILS_CHECK_DELETED = "RAIL_ACCOUNT_DETAILS_CHECK_DELETED",
  RAIL_ACCOUNT_DETAILS_CHECK_UPDATED = "RAIL_ACCOUNT_DETAILS_CHECK_UPDATED",
  RAIL_ACCOUNT_DETAILS_DOMESTIC_WIRE_CREATED = "RAIL_ACCOUNT_DETAILS_DOMESTIC_WIRE_CREATED",
  RAIL_ACCOUNT_DETAILS_DOMESTIC_WIRE_DELETED = "RAIL_ACCOUNT_DETAILS_DOMESTIC_WIRE_DELETED",
  RAIL_ACCOUNT_DETAILS_DOMESTIC_WIRE_UPDATED = "RAIL_ACCOUNT_DETAILS_DOMESTIC_WIRE_UPDATED",
  RAIL_ACCOUNT_DETAILS_GLOBAL_BANK_TRANSFER_CREATED = "RAIL_ACCOUNT_DETAILS_GLOBAL_BANK_TRANSFER_CREATED",
  RAIL_ACCOUNT_DETAILS_GLOBAL_BANK_TRANSFER_DELETED = "RAIL_ACCOUNT_DETAILS_GLOBAL_BANK_TRANSFER_DELETED",
  RAIL_ACCOUNT_DETAILS_GLOBAL_BANK_TRANSFER_UPDATED = "RAIL_ACCOUNT_DETAILS_GLOBAL_BANK_TRANSFER_UPDATED",
  RAIL_ACCOUNT_DETAILS_INTERNATIONAL_WIRE_CREATED = "RAIL_ACCOUNT_DETAILS_INTERNATIONAL_WIRE_CREATED",
  RAIL_ACCOUNT_DETAILS_INTERNATIONAL_WIRE_DELETED = "RAIL_ACCOUNT_DETAILS_INTERNATIONAL_WIRE_DELETED",
  RAIL_ACCOUNT_DETAILS_INTERNATIONAL_WIRE_UPDATED = "RAIL_ACCOUNT_DETAILS_INTERNATIONAL_WIRE_UPDATED",
  READ_CARD_PAN = "READ_CARD_PAN",
  REISSUE_CARD = "REISSUE_CARD",
  REPAYMENT_CANCELLED = "REPAYMENT_CANCELLED",
  REPAYMENT_COMPLETED = "REPAYMENT_COMPLETED",
  REPAYMENT_REQUESTED = "REPAYMENT_REQUESTED",
  REPAYMENT_REQUEST_APPROVED = "REPAYMENT_REQUEST_APPROVED",
  REPAYMENT_SUBMITTED = "REPAYMENT_SUBMITTED",
  ROLE_CREATED = "ROLE_CREATED",
  ROLE_DELETED = "ROLE_DELETED",
  ROLE_UPDATED = "ROLE_UPDATED",
  SPEND_BUDGET_ALLOWED_MCC_ADDED = "SPEND_BUDGET_ALLOWED_MCC_ADDED",
  SPEND_BUDGET_ALLOWED_MCC_REMOVED = "SPEND_BUDGET_ALLOWED_MCC_REMOVED",
  SPEND_BUDGET_AMOUNT_ADDED = "SPEND_BUDGET_AMOUNT_ADDED",
  SPEND_BUDGET_AMOUNT_DECREASED = "SPEND_BUDGET_AMOUNT_DECREASED",
  SPEND_BUDGET_AMOUNT_INCREASED = "SPEND_BUDGET_AMOUNT_INCREASED",
  SPEND_BUDGET_AMOUNT_REMOVED = "SPEND_BUDGET_AMOUNT_REMOVED",
  SPEND_BUDGET_ARCHIVED = "SPEND_BUDGET_ARCHIVED",
  SPEND_BUDGET_AUTO_CREATE_LIMIT_CARDS_SETTING_CHANGED = "SPEND_BUDGET_AUTO_CREATE_LIMIT_CARDS_SETTING_CHANGED",
  SPEND_BUDGET_AUTO_TRANSFER_CARDS_DISABLED = "SPEND_BUDGET_AUTO_TRANSFER_CARDS_DISABLED",
  SPEND_BUDGET_AUTO_TRANSFER_CARDS_ENABLED = "SPEND_BUDGET_AUTO_TRANSFER_CARDS_ENABLED",
  SPEND_BUDGET_BLOCKED_MCC_ADDED = "SPEND_BUDGET_BLOCKED_MCC_ADDED",
  SPEND_BUDGET_BLOCKED_MCC_REMOVED = "SPEND_BUDGET_BLOCKED_MCC_REMOVED",
  SPEND_BUDGET_BLOCK_REIMBURSEMENT_AND_BUDGET_SELECTION_DISABLED = "SPEND_BUDGET_BLOCK_REIMBURSEMENT_AND_BUDGET_SELECTION_DISABLED",
  SPEND_BUDGET_BLOCK_REIMBURSEMENT_AND_BUDGET_SELECTION_ENABLED = "SPEND_BUDGET_BLOCK_REIMBURSEMENT_AND_BUDGET_SELECTION_ENABLED",
  SPEND_BUDGET_CREATED = "SPEND_BUDGET_CREATED",
  SPEND_BUDGET_CURRENCY_CHANGED = "SPEND_BUDGET_CURRENCY_CHANGED",
  SPEND_BUDGET_DELETED = "SPEND_BUDGET_DELETED",
  SPEND_BUDGET_DESCRIPTION_CHANGED = "SPEND_BUDGET_DESCRIPTION_CHANGED",
  SPEND_BUDGET_END_DATE_CHANGED = "SPEND_BUDGET_END_DATE_CHANGED",
  SPEND_BUDGET_EXPIRED = "SPEND_BUDGET_EXPIRED",
  SPEND_BUDGET_LEGAL_ENTITY_CHANGED = "SPEND_BUDGET_LEGAL_ENTITY_CHANGED",
  SPEND_BUDGET_LEGAL_ENTITY_REMOVED = "SPEND_BUDGET_LEGAL_ENTITY_REMOVED",
  SPEND_BUDGET_LIMIT_DECREASED = "SPEND_BUDGET_LIMIT_DECREASED",
  SPEND_BUDGET_LIMIT_FLEXIBILITY_DISABLED = "SPEND_BUDGET_LIMIT_FLEXIBILITY_DISABLED",
  SPEND_BUDGET_LIMIT_FLEXIBILITY_ENABLED = "SPEND_BUDGET_LIMIT_FLEXIBILITY_ENABLED",
  SPEND_BUDGET_LIMIT_FLEXIBILITY_THRESHOLD_CHANGED = "SPEND_BUDGET_LIMIT_FLEXIBILITY_THRESHOLD_CHANGED",
  SPEND_BUDGET_LIMIT_INCREASED = "SPEND_BUDGET_LIMIT_INCREASED",
  SPEND_BUDGET_LIMIT_INCREASE_REQUESTED = "SPEND_BUDGET_LIMIT_INCREASE_REQUESTED",
  SPEND_BUDGET_LIMIT_INCREASE_REQUEST_APPROVED = "SPEND_BUDGET_LIMIT_INCREASE_REQUEST_APPROVED",
  SPEND_BUDGET_LIMIT_INCREASE_REQUEST_REJECTED = "SPEND_BUDGET_LIMIT_INCREASE_REQUEST_REJECTED",
  SPEND_BUDGET_LIMIT_REMOVED = "SPEND_BUDGET_LIMIT_REMOVED",
  SPEND_BUDGET_LIMIT_REQUESTS_DISABLED = "SPEND_BUDGET_LIMIT_REQUESTS_DISABLED",
  SPEND_BUDGET_LIMIT_REQUESTS_ENABLED = "SPEND_BUDGET_LIMIT_REQUESTS_ENABLED",
  SPEND_BUDGET_LIMIT_VISIBILITY_DISABLED = "SPEND_BUDGET_LIMIT_VISIBILITY_DISABLED",
  SPEND_BUDGET_LIMIT_VISIBILITY_ENABLED = "SPEND_BUDGET_LIMIT_VISIBILITY_ENABLED",
  SPEND_BUDGET_MCC_DISABLED = "SPEND_BUDGET_MCC_DISABLED",
  SPEND_BUDGET_MCC_ENABLED = "SPEND_BUDGET_MCC_ENABLED",
  SPEND_BUDGET_MEMBERS_ADDED = "SPEND_BUDGET_MEMBERS_ADDED",
  SPEND_BUDGET_MEMBERS_REMOVED = "SPEND_BUDGET_MEMBERS_REMOVED",
  SPEND_BUDGET_MEMBER_EXPENSE_VISIBILITY_DISABLED = "SPEND_BUDGET_MEMBER_EXPENSE_VISIBILITY_DISABLED",
  SPEND_BUDGET_MEMBER_EXPENSE_VISIBILITY_ENABLED = "SPEND_BUDGET_MEMBER_EXPENSE_VISIBILITY_ENABLED",
  SPEND_BUDGET_NAME_CHANGED = "SPEND_BUDGET_NAME_CHANGED",
  SPEND_BUDGET_OWNERS_ADDED = "SPEND_BUDGET_OWNERS_ADDED",
  SPEND_BUDGET_OWNERS_REMOVED = "SPEND_BUDGET_OWNERS_REMOVED",
  SPEND_BUDGET_PARENT_BUDGET_CHANGED = "SPEND_BUDGET_PARENT_BUDGET_CHANGED",
  SPEND_BUDGET_POLICY_CHANGED = "SPEND_BUDGET_POLICY_CHANGED",
  SPEND_BUDGET_REOPENED = "SPEND_BUDGET_REOPENED",
  SPEND_BUDGET_REQUESTED = "SPEND_BUDGET_REQUESTED",
  SPEND_BUDGET_REQUEST_APPROVED = "SPEND_BUDGET_REQUEST_APPROVED",
  SPEND_BUDGET_RESET_PERIOD_CHANGED = "SPEND_BUDGET_RESET_PERIOD_CHANGED",
  SPEND_BUDGET_ROLLOVER_SETTINGS_CHANGED = "SPEND_BUDGET_ROLLOVER_SETTINGS_CHANGED",
  SPEND_BUDGET_ROLLOVER_SETTINGS_DISABLED = "SPEND_BUDGET_ROLLOVER_SETTINGS_DISABLED",
  SPEND_BUDGET_ROLLOVER_SETTINGS_ENABLED = "SPEND_BUDGET_ROLLOVER_SETTINGS_ENABLED",
  SPEND_BUDGET_SPEND_CAP_ADDED = "SPEND_BUDGET_SPEND_CAP_ADDED",
  SPEND_BUDGET_SPEND_CAP_CHANGED = "SPEND_BUDGET_SPEND_CAP_CHANGED",
  SPEND_BUDGET_SPEND_CAP_REMOVED = "SPEND_BUDGET_SPEND_CAP_REMOVED",
  SPEND_BUDGET_START_DATE_CHANGED = "SPEND_BUDGET_START_DATE_CHANGED",
  SPEND_BUDGET_START_DATE_REMOVED = "SPEND_BUDGET_START_DATE_REMOVED",
  SPEND_BUDGET_TERMINATED = "SPEND_BUDGET_TERMINATED",
  SPEND_BUDGET_TRANSACTION_LIMIT_CHANGED = "SPEND_BUDGET_TRANSACTION_LIMIT_CHANGED",
  SPEND_BUDGET_TRANSACTION_LIMIT_REMOVED = "SPEND_BUDGET_TRANSACTION_LIMIT_REMOVED",
  SPEND_LIMIT_ALLOWED_MCC_ADDED = "SPEND_LIMIT_ALLOWED_MCC_ADDED",
  SPEND_LIMIT_ALLOWED_MCC_REMOVED = "SPEND_LIMIT_ALLOWED_MCC_REMOVED",
  SPEND_LIMIT_ARCHIVED = "SPEND_LIMIT_ARCHIVED",
  SPEND_LIMIT_AUTO_CREATE_LIMIT_CARDS_SETTING_CHANGED = "SPEND_LIMIT_AUTO_CREATE_LIMIT_CARDS_SETTING_CHANGED",
  SPEND_LIMIT_AUTO_TRANSFER_CARDS_DISABLED = "SPEND_LIMIT_AUTO_TRANSFER_CARDS_DISABLED",
  SPEND_LIMIT_AUTO_TRANSFER_CARDS_ENABLED = "SPEND_LIMIT_AUTO_TRANSFER_CARDS_ENABLED",
  SPEND_LIMIT_BLOCKED_MCC_ADDED = "SPEND_LIMIT_BLOCKED_MCC_ADDED",
  SPEND_LIMIT_BLOCKED_MCC_REMOVED = "SPEND_LIMIT_BLOCKED_MCC_REMOVED",
  SPEND_LIMIT_BLOCK_REIMBURSEMENT_AND_BUDGET_SELECTION_DISABLED = "SPEND_LIMIT_BLOCK_REIMBURSEMENT_AND_BUDGET_SELECTION_DISABLED",
  SPEND_LIMIT_BLOCK_REIMBURSEMENT_AND_BUDGET_SELECTION_ENABLED = "SPEND_LIMIT_BLOCK_REIMBURSEMENT_AND_BUDGET_SELECTION_ENABLED",
  SPEND_LIMIT_CREATED = "SPEND_LIMIT_CREATED",
  SPEND_LIMIT_CURRENCY_CHANGED = "SPEND_LIMIT_CURRENCY_CHANGED",
  SPEND_LIMIT_DELETED = "SPEND_LIMIT_DELETED",
  SPEND_LIMIT_DESCRIPTION_CHANGED = "SPEND_LIMIT_DESCRIPTION_CHANGED",
  SPEND_LIMIT_END_DATE_CHANGED = "SPEND_LIMIT_END_DATE_CHANGED",
  SPEND_LIMIT_EXPIRED = "SPEND_LIMIT_EXPIRED",
  SPEND_LIMIT_LEGAL_ENTITY_CHANGED = "SPEND_LIMIT_LEGAL_ENTITY_CHANGED",
  SPEND_LIMIT_LEGAL_ENTITY_REMOVED = "SPEND_LIMIT_LEGAL_ENTITY_REMOVED",
  SPEND_LIMIT_LIMIT_DECREASED = "SPEND_LIMIT_LIMIT_DECREASED",
  SPEND_LIMIT_LIMIT_FLEXIBILITY_DISABLED = "SPEND_LIMIT_LIMIT_FLEXIBILITY_DISABLED",
  SPEND_LIMIT_LIMIT_FLEXIBILITY_ENABLED = "SPEND_LIMIT_LIMIT_FLEXIBILITY_ENABLED",
  SPEND_LIMIT_LIMIT_FLEXIBILITY_THRESHOLD_CHANGED = "SPEND_LIMIT_LIMIT_FLEXIBILITY_THRESHOLD_CHANGED",
  SPEND_LIMIT_LIMIT_INCREASED = "SPEND_LIMIT_LIMIT_INCREASED",
  SPEND_LIMIT_LIMIT_INCREASE_REQUESTED = "SPEND_LIMIT_LIMIT_INCREASE_REQUESTED",
  SPEND_LIMIT_LIMIT_INCREASE_REQUEST_APPROVED = "SPEND_LIMIT_LIMIT_INCREASE_REQUEST_APPROVED",
  SPEND_LIMIT_LIMIT_INCREASE_REQUEST_REJECTED = "SPEND_LIMIT_LIMIT_INCREASE_REQUEST_REJECTED",
  SPEND_LIMIT_LIMIT_REQUESTS_DISABLED = "SPEND_LIMIT_LIMIT_REQUESTS_DISABLED",
  SPEND_LIMIT_LIMIT_REQUESTS_ENABLED = "SPEND_LIMIT_LIMIT_REQUESTS_ENABLED",
  SPEND_LIMIT_LIMIT_VISIBILITY_DISABLED = "SPEND_LIMIT_LIMIT_VISIBILITY_DISABLED",
  SPEND_LIMIT_LIMIT_VISIBILITY_ENABLED = "SPEND_LIMIT_LIMIT_VISIBILITY_ENABLED",
  SPEND_LIMIT_MCC_DISABLED = "SPEND_LIMIT_MCC_DISABLED",
  SPEND_LIMIT_MCC_ENABLED = "SPEND_LIMIT_MCC_ENABLED",
  SPEND_LIMIT_MEMBERS_ADDED = "SPEND_LIMIT_MEMBERS_ADDED",
  SPEND_LIMIT_MEMBERS_REMOVED = "SPEND_LIMIT_MEMBERS_REMOVED",
  SPEND_LIMIT_MEMBER_EXPENSE_VISIBILITY_DISABLED = "SPEND_LIMIT_MEMBER_EXPENSE_VISIBILITY_DISABLED",
  SPEND_LIMIT_MEMBER_EXPENSE_VISIBILITY_ENABLED = "SPEND_LIMIT_MEMBER_EXPENSE_VISIBILITY_ENABLED",
  SPEND_LIMIT_NAME_CHANGED = "SPEND_LIMIT_NAME_CHANGED",
  SPEND_LIMIT_OWNERS_ADDED = "SPEND_LIMIT_OWNERS_ADDED",
  SPEND_LIMIT_OWNERS_REMOVED = "SPEND_LIMIT_OWNERS_REMOVED",
  SPEND_LIMIT_PARENT_BUDGET_CHANGED = "SPEND_LIMIT_PARENT_BUDGET_CHANGED",
  SPEND_LIMIT_POLICY_CHANGED = "SPEND_LIMIT_POLICY_CHANGED",
  SPEND_LIMIT_REOPENED = "SPEND_LIMIT_REOPENED",
  SPEND_LIMIT_REQUESTED = "SPEND_LIMIT_REQUESTED",
  SPEND_LIMIT_REQUEST_APPROVED = "SPEND_LIMIT_REQUEST_APPROVED",
  SPEND_LIMIT_RESET_PERIOD_CHANGED = "SPEND_LIMIT_RESET_PERIOD_CHANGED",
  SPEND_LIMIT_ROLLOVER_SETTINGS_CHANGED = "SPEND_LIMIT_ROLLOVER_SETTINGS_CHANGED",
  SPEND_LIMIT_ROLLOVER_SETTINGS_DISABLED = "SPEND_LIMIT_ROLLOVER_SETTINGS_DISABLED",
  SPEND_LIMIT_ROLLOVER_SETTINGS_ENABLED = "SPEND_LIMIT_ROLLOVER_SETTINGS_ENABLED",
  SPEND_LIMIT_START_DATE_CHANGED = "SPEND_LIMIT_START_DATE_CHANGED",
  SPEND_LIMIT_START_DATE_REMOVED = "SPEND_LIMIT_START_DATE_REMOVED",
  SPEND_LIMIT_TERMINATED = "SPEND_LIMIT_TERMINATED",
  SPEND_LIMIT_TRANSACTION_LIMIT_CHANGED = "SPEND_LIMIT_TRANSACTION_LIMIT_CHANGED",
  SPEND_LIMIT_TRANSACTION_LIMIT_REMOVED = "SPEND_LIMIT_TRANSACTION_LIMIT_REMOVED",
  SPOTNANA_SERVICE_FEE_UPDATED = "SPOTNANA_SERVICE_FEE_UPDATED",
  SSO_INTEGRATION_CREATED = "SSO_INTEGRATION_CREATED",
  SSO_INTEGRATION_DELETED = "SSO_INTEGRATION_DELETED",
  SSO_INTEGRATION_UPDATED = "SSO_INTEGRATION_UPDATED",
  SSO_ROUTING_UPDATED = "SSO_ROUTING_UPDATED",
  SSO_USER_EXCLUDED = "SSO_USER_EXCLUDED",
  SSO_USER_EXCLUSION_ADDED = "SSO_USER_EXCLUSION_ADDED",
  SSO_USER_EXCLUSION_REMOVED = "SSO_USER_EXCLUSION_REMOVED",
  SSO_USER_INCLUDED = "SSO_USER_INCLUDED",
  SUSPEND_CARD = "SUSPEND_CARD",
  TERMINATE_CARD = "TERMINATE_CARD",
  TRANSFER_CARD = "TRANSFER_CARD",
  TRIP_BOOKING_ADDED = "TRIP_BOOKING_ADDED",
  TRIP_CREATED = "TRIP_CREATED",
  TRIP_STATUS_UPDATED = "TRIP_STATUS_UPDATED",
  UNSUSPEND_CARD = "UNSUSPEND_CARD",
  /** @deprecated Use specific update card operations */
  UPDATE_CARD = "UPDATE_CARD",
  UPDATE_CARD_ADDRESS = "UPDATE_CARD_ADDRESS",
  UPDATE_CARD_NAME = "UPDATE_CARD_NAME",
  UPDATE_CARD_PIN = "UPDATE_CARD_PIN",
  USER_AGGREGATOR_UPDATED = "USER_AGGREGATOR_UPDATED",
  USER_COST_CENTER_UPDATED = "USER_COST_CENTER_UPDATED",
  USER_CREATED = "USER_CREATED",
  USER_CUSTOM_ATTRIBUTE_UPDATED = "USER_CUSTOM_ATTRIBUTE_UPDATED",
  USER_DELETED = "USER_DELETED",
  USER_DEPARTMENT_UPDATED = "USER_DEPARTMENT_UPDATED",
  USER_EMAIL_UPDATED = "USER_EMAIL_UPDATED",
  USER_EMPLOYMENT_STATUS_UPDATED = "USER_EMPLOYMENT_STATUS_UPDATED",
  USER_EMPLOYMENT_TYPE_UPDATED = "USER_EMPLOYMENT_TYPE_UPDATED",
  USER_FIRST_NAME_UPDATED = "USER_FIRST_NAME_UPDATED",
  USER_INVITED = "USER_INVITED",
  USER_LAST_NAME_UPDATED = "USER_LAST_NAME_UPDATED",
  USER_LEGAL_ENTITY_UPDATED = "USER_LEGAL_ENTITY_UPDATED",
  USER_LOCATION_UPDATED = "USER_LOCATION_UPDATED",
  USER_MANAGER_UPDATED = "USER_MANAGER_UPDATED",
  USER_METADATA_UPDATED = "USER_METADATA_UPDATED",
  USER_ONBOARDED_AT_UPDATED = "USER_ONBOARDED_AT_UPDATED",
  USER_REMOTE_DISPLAY_ID_UPDATED = "USER_REMOTE_DISPLAY_ID_UPDATED",
  USER_REMOTE_ID_UPDATED = "USER_REMOTE_ID_UPDATED",
  USER_ROLE_UPDATED = "USER_ROLE_UPDATED",
  USER_SESSION_REVOKED = "USER_SESSION_REVOKED",
  USER_SESSION_STARTED = "USER_SESSION_STARTED",
  USER_SIGN_IN_DISABLED = "USER_SIGN_IN_DISABLED",
  USER_SIGN_IN_ENABLED = "USER_SIGN_IN_ENABLED",
  USER_STATUS_UPDATED = "USER_STATUS_UPDATED",
  USER_TITLE_UPDATED = "USER_TITLE_UPDATED",
  VENDOR_1099_ELIGIBILITY_UPDATED = "VENDOR_1099_ELIGIBILITY_UPDATED",
  VENDOR_CONTACT_NAME_ADDED = "VENDOR_CONTACT_NAME_ADDED",
  VENDOR_CONTACT_NAME_REMOVED = "VENDOR_CONTACT_NAME_REMOVED",
  VENDOR_CONTACT_NAME_UPDATED = "VENDOR_CONTACT_NAME_UPDATED",
  VENDOR_CREATED = "VENDOR_CREATED",
  VENDOR_DELETED = "VENDOR_DELETED",
  VENDOR_EMAIL_ADDED = "VENDOR_EMAIL_ADDED",
  VENDOR_EMAIL_REMOVED = "VENDOR_EMAIL_REMOVED",
  VENDOR_EMAIL_UPDATED = "VENDOR_EMAIL_UPDATED",
  VENDOR_INVITED_TO_SELF_SERVE_PAYMENT_INSTRUMENT = "VENDOR_INVITED_TO_SELF_SERVE_PAYMENT_INSTRUMENT",
  VENDOR_INVITED_TO_SELF_SERVE_TAX_INFO = "VENDOR_INVITED_TO_SELF_SERVE_TAX_INFO",
  VENDOR_LINKED_ERP_VENDOR_UPDATED = "VENDOR_LINKED_ERP_VENDOR_UPDATED",
  VENDOR_NAME_UPDATED = "VENDOR_NAME_UPDATED",
  VENDOR_OWNERS_UPDATED = "VENDOR_OWNERS_UPDATED",
  VENDOR_PHONE_ADDED = "VENDOR_PHONE_ADDED",
  VENDOR_PHONE_REMOVED = "VENDOR_PHONE_REMOVED",
  VENDOR_PHONE_UPDATED = "VENDOR_PHONE_UPDATED",
  VENDOR_W9_ADDRESS_UPDATED = "VENDOR_W9_ADDRESS_UPDATED",
  VENDOR_W9_BUSINESS_NAME_UPDATED = "VENDOR_W9_BUSINESS_NAME_UPDATED",
  VENDOR_W9_DOCUMENT_REMOVED = "VENDOR_W9_DOCUMENT_REMOVED",
  VENDOR_W9_DOCUMENT_UPLOADED = "VENDOR_W9_DOCUMENT_UPLOADED",
  VENDOR_W9_LEGAL_NAME_UPDATED = "VENDOR_W9_LEGAL_NAME_UPDATED",
  VENDOR_W9_TAX_CLASSIFICATION_UPDATED = "VENDOR_W9_TAX_CLASSIFICATION_UPDATED",
  VENDOR_W9_TAX_ID_UPDATED = "VENDOR_W9_TAX_ID_UPDATED",
  VENDOR_WEBSITE_ADDED = "VENDOR_WEBSITE_ADDED",
  VENDOR_WEBSITE_REMOVED = "VENDOR_WEBSITE_REMOVED",
  VENDOR_WEBSITE_UPDATED = "VENDOR_WEBSITE_UPDATED",
}

export interface AuditOperationNameFilterOptionsConnection extends Connection {
  edges?: Maybe<Array<Maybe<AuditOperationTypeEdge>>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface AuditOperationNameFilterOptionsInput {
  primitivesFilter?: InputMaybe<Array<AuditPrimitive>>;
}

export interface AuditOperationType {
  displayName?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  name?: Maybe<AuditOperationName>;
}

export interface AuditOperationTypeEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<AuditOperationType>;
}

/** An escalation reason based on policy rules, e.g. "Meals over $25 require review". */
export interface AuditPolicyDecision extends AuditDecision {
  violationReason?: Maybe<Scalars["String"]>;
}

export enum AuditPrimitive {
  ACCOUNT = "ACCOUNT",
  ACCOUNTING = "ACCOUNTING",
  BILL = "BILL",
  BUDGETS = "BUDGETS",
  CARD = "CARD",
  EXPENSE = "EXPENSE",
  LOGIN = "LOGIN",
  ROLE = "ROLE",
  SPEND_BUDGET = "SPEND_BUDGET",
  SPEND_LIMIT = "SPEND_LIMIT",
  TRAVEL = "TRAVEL",
  UNKNOWN = "UNKNOWN",
  USER = "USER",
}

/** An escalation reason based on SOP rules, e.g. "Commute expenses aren't allowed". */
export interface AuditSopDecision extends AuditDecision {
  violationReason?: Maybe<Scalars["String"]>;
}

export interface AuditSpreadsheetExportInput {
  filters?: InputMaybe<AuditLogsFilterInput>;
  numAuditLogs?: InputMaybe<Scalars["Long"]>;
  /** Flag to indicate if email notification should be sent upon task completion. */
  sendNotification?: InputMaybe<Scalars["Boolean"]>;
  sorts?: InputMaybe<Array<InputMaybe<AuditLogSort>>>;
}

export interface AuditSpreadsheetExportRequest {
  numAuditLogs?: Maybe<Scalars["Long"]>;
  /** Flag to indicate if email notification should be sent upon task completion. */
  sendNotification?: Maybe<Scalars["Boolean"]>;
}

export interface AuditSpreadsheetExportResponse {
  assetId: Scalars["ID"];
}

export enum AuditStatus {
  AUDITED = "AUDITED",
  PENDING_AUDIT = "PENDING_AUDIT",
  PENDING_USER_ACTION = "PENDING_USER_ACTION",
}

export type AuditSuggestedAction =
  | LeaveCommentInformation
  | MarkAsReviewedInformation
  | RequestRepaymentInformation;

export interface AuditSuggestionInformation {
  /** Suggested audit action. */
  suggestedAction?: Maybe<AuditSuggestedAction>;
}

export interface AuditTargetTypesFilterOptionsConnection extends Connection {
  edges?: Maybe<Array<Maybe<TargetTypesEdge>>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export enum AuthAction {
  ACCEPT = "ACCEPT",
  ACTIVATE = "ACTIVATE",
  ADMIN_OVERRIDE = "ADMIN_OVERRIDE",
  ADMIN_OVERRIDE_COPILOT = "ADMIN_OVERRIDE_COPILOT",
  APPROVE = "APPROVE",
  APPROVE_COPILOT = "APPROVE_COPILOT",
  ATTEND = "ATTEND",
  BATCH_GET = "BATCH_GET",
  BATCH_GET_COPILOT = "BATCH_GET_COPILOT",
  CANCEL = "CANCEL",
  CANCEL_COPILOT = "CANCEL_COPILOT",
  CLOSE = "CLOSE",
  COMPLETE = "COMPLETE",
  COMPLETE_COPILOT = "COMPLETE_COPILOT",
  CREATE = "CREATE",
  CREATE_ADMIN = "CREATE_ADMIN",
  CREATE_COPILOT = "CREATE_COPILOT",
  DEACTIVATE = "DEACTIVATE",
  DELETE = "DELETE",
  DELETE_ALL = "DELETE_ALL",
  DELETE_COPILOT = "DELETE_COPILOT",
  DISABLE = "DISABLE",
  DISMISS = "DISMISS",
  DISMISS_COPILOT = "DISMISS_COPILOT",
  ENABLE = "ENABLE",
  ENROLL = "ENROLL",
  EXECUTE = "EXECUTE",
  EXPORT = "EXPORT",
  FAIL = "FAIL",
  IMPORT = "IMPORT",
  INVITE = "INVITE",
  LIFT = "LIFT",
  LIST = "LIST",
  LIST_COPILOT = "LIST_COPILOT",
  MANAGE = "MANAGE",
  MERGE = "MERGE",
  OVERRIDE = "OVERRIDE",
  OWN = "OWN",
  PERFORM = "PERFORM",
  PERFORM_COPILOT = "PERFORM_COPILOT",
  PROVISION = "PROVISION",
  REACTIVATE = "REACTIVATE",
  READ = "READ",
  READ_COPILOT = "READ_COPILOT",
  READ_LIMITED = "READ_LIMITED",
  READ_OWN = "READ_OWN",
  REISSUE = "REISSUE",
  REJECT = "REJECT",
  REJECT_COPILOT = "REJECT_COPILOT",
  REPLACE = "REPLACE",
  REQUEST = "REQUEST",
  RESOLVE = "RESOLVE",
  RESOLVE_COPILOT = "RESOLVE_COPILOT",
  RETRY = "RETRY",
  RETRY_COPILOT = "RETRY_COPILOT",
  RETURN = "RETURN",
  REVIEW = "REVIEW",
  REVIEW_COPILOT = "REVIEW_COPILOT",
  REVOKE = "REVOKE",
  REVOKE_COPILOT = "REVOKE_COPILOT",
  SEND = "SEND",
  SETTLE = "SETTLE",
  SETTLE_COPILOT = "SETTLE_COPILOT",
  SETUP = "SETUP",
  SHARE = "SHARE",
  SIMULATE = "SIMULATE",
  SIMULATE_COPILOT = "SIMULATE_COPILOT",
  SKIP = "SKIP",
  SUBMIT = "SUBMIT",
  SUBMIT_COPILOT = "SUBMIT_COPILOT",
  SUSPEND = "SUSPEND",
  TERMINATE = "TERMINATE",
  TERMINATE_COPILOT = "TERMINATE_COPILOT",
  TRANSFER = "TRANSFER",
  UNSUSPEND = "UNSUSPEND",
  UPDATE = "UPDATE",
  UPDATE_ALL = "UPDATE_ALL",
  UPDATE_COPILOT = "UPDATE_COPILOT",
  VIEW = "VIEW",
  VOID = "VOID",
  WRITE = "WRITE",
}

export interface AuthActor {
  id: Scalars["ID"];
  type: AuthActorType;
}

export enum AuthActorType {
  GROUP = "GROUP",
  USER = "USER",
}

export interface AuthCapability {
  capabilityGroup?: Maybe<AuthCapabilityGroup>;
  childCapabilityKeys: Array<AuthCapabilityKey>;
  customerFacing?: Maybe<Scalars["Boolean"]>;
  description: Scalars["String"];
  displayName: Scalars["String"];
  key: AuthCapabilityKey;
  requiredCapabilityKeys: Array<AuthCapabilityKey>;
}

export interface AuthCapabilityGroup {
  description: Scalars["String"];
  displayName: Scalars["String"];
  domain?: Maybe<AuthDomain>;
  key: AuthCapabilityGroupKey;
}

export enum AuthCapabilityGroupKey {
  ACCOUNTING_AUTOMATIONS = "ACCOUNTING_AUTOMATIONS",
  ACCOUNTING_CLOSE = "ACCOUNTING_CLOSE",
  AUDIT_TRAIL = "AUDIT_TRAIL",
  BANKING = "BANKING",
  BILLING = "BILLING",
  BILLS = "BILLS",
  BUDGETS = "BUDGETS",
  CARDS_AND_SPEND_LIMITS = "CARDS_AND_SPEND_LIMITS",
  CREDIT = "CREDIT",
  ENTITIES = "ENTITIES",
  ERP_INTEGRATIONS = "ERP_INTEGRATIONS",
  EVENTS = "EVENTS",
  EXPENSES = "EXPENSES",
  EXTERNAL_ACCOUNTS = "EXTERNAL_ACCOUNTS",
  FIELDS = "FIELDS",
  HRIS_INTEGRATIONS = "HRIS_INTEGRATIONS",
  INSIGHTS = "INSIGHTS",
  ORGANIZATION = "ORGANIZATION",
  PAYMENTS = "PAYMENTS",
  POLICIES = "POLICIES",
  PURCHASE_ORDERS = "PURCHASE_ORDERS",
  REIMBURSEMENTS = "REIMBURSEMENTS",
  REPORTS = "REPORTS",
  REWARDS = "REWARDS",
  RFI = "RFI",
  TRANSACTIONS_AND_STATEMENTS = "TRANSACTIONS_AND_STATEMENTS",
  TRIPS = "TRIPS",
  USERS = "USERS",
  VENDORS = "VENDORS",
}

export enum AuthCapabilityKey {
  BILLING_MANAGE_PAYMENTS = "BILLING_MANAGE_PAYMENTS",
  BILLING_VIEW_BILLING_ACTIVITY = "BILLING_VIEW_BILLING_ACTIVITY",
  BILLING_VIEW_PAYMENTS = "BILLING_VIEW_PAYMENTS",
  BILLING_VIEW_TRANSACTIONS_AND_STATEMENTS = "BILLING_VIEW_TRANSACTIONS_AND_STATEMENTS",
  CREATE_EMPLOYEE_CARDS = "CREATE_EMPLOYEE_CARDS",
  CREATE_PURCHASING_CARDS = "CREATE_PURCHASING_CARDS",
  CREATE_SPEND_LIMIT_CARDS = "CREATE_SPEND_LIMIT_CARDS",
  DEACTIVATE_USERS = "DEACTIVATE_USERS",
  DRAFT_BANKING_PAYMENTS = "DRAFT_BANKING_PAYMENTS",
  DRAFT_BILLS = "DRAFT_BILLS",
  EXPORT_TO_ERP = "EXPORT_TO_ERP",
  INVITE_USERS = "INVITE_USERS",
  MANAGE_ACCOUNTING_RULES = "MANAGE_ACCOUNTING_RULES",
  MANAGE_ALL_BILLS = "MANAGE_ALL_BILLS",
  MANAGE_BANKING_ACCOUNTS_AND_PAYMENTS = "MANAGE_BANKING_ACCOUNTS_AND_PAYMENTS",
  MANAGE_BUDGETS = "MANAGE_BUDGETS",
  MANAGE_CARDS = "MANAGE_CARDS",
  MANAGE_CARDS_AND_SPEND_LIMITS = "MANAGE_CARDS_AND_SPEND_LIMITS",
  MANAGE_COPILOT_RELATIONSHIPS = "MANAGE_COPILOT_RELATIONSHIPS",
  MANAGE_DIRECTORY_SYNC = "MANAGE_DIRECTORY_SYNC",
  MANAGE_ERP_CONNECTION = "MANAGE_ERP_CONNECTION",
  MANAGE_EXPENSES = "MANAGE_EXPENSES",
  MANAGE_GROUP_EVENTS = "MANAGE_GROUP_EVENTS",
  MANAGE_INTEGRATIONS = "MANAGE_INTEGRATIONS",
  MANAGE_INVOICING = "MANAGE_INVOICING",
  MANAGE_LEGAL_ENTITIES = "MANAGE_LEGAL_ENTITIES",
  MANAGE_ONBOARDING_RFI = "MANAGE_ONBOARDING_RFI",
  MANAGE_ORGANIZATION_ATTRIBUTES = "MANAGE_ORGANIZATION_ATTRIBUTES",
  MANAGE_PARTNERS = "MANAGE_PARTNERS",
  MANAGE_POLICIES = "MANAGE_POLICIES",
  MANAGE_REPORTS = "MANAGE_REPORTS",
  MANAGE_REWARDS = "MANAGE_REWARDS",
  MANAGE_ROLES = "MANAGE_ROLES",
  MANAGE_SPEND_LIMITS = "MANAGE_SPEND_LIMITS",
  MANAGE_SPEND_MIGRATION = "MANAGE_SPEND_MIGRATION",
  MANAGE_TRAVEL = "MANAGE_TRAVEL",
  MANAGE_USERS = "MANAGE_USERS",
  MANAGE_USER_DETAILS = "MANAGE_USER_DETAILS",
  OWN_PHYSICAL_CARDS = "OWN_PHYSICAL_CARDS",
  OWN_VIRTUAL_CARDS = "OWN_VIRTUAL_CARDS",
  PREPARE_ACCOUNTING_EXPORT = "PREPARE_ACCOUNTING_EXPORT",
  REDEEM_REWARDS_CASHOUT = "REDEEM_REWARDS_CASHOUT",
  REDEEM_REWARDS_TRAVEL = "REDEEM_REWARDS_TRAVEL",
  REDEEM_REWARDS_VAS = "REDEEM_REWARDS_VAS",
  RELEASE_BILL_PAYMENTS = "RELEASE_BILL_PAYMENTS",
  SYNC_ERP = "SYNC_ERP",
  TRAVEL_USER = "TRAVEL_USER",
  UNEXPORT_TRANSACTIONS = "UNEXPORT_TRANSACTIONS",
  /** @deprecated No longer supported */
  VIEW_ACCOUNTING_AUDIT_HISTORY = "VIEW_ACCOUNTING_AUDIT_HISTORY",
  VIEW_ACCOUNTING_RULES = "VIEW_ACCOUNTING_RULES",
  VIEW_ACCOUNT_AUDIT_LOG = "VIEW_ACCOUNT_AUDIT_LOG",
  VIEW_ALL_BILLS = "VIEW_ALL_BILLS",
  VIEW_BANKING_ACCOUNTS = "VIEW_BANKING_ACCOUNTS",
  VIEW_BUDGETS = "VIEW_BUDGETS",
  VIEW_CARDS = "VIEW_CARDS",
  VIEW_CARDS_AND_SPEND_LIMITS = "VIEW_CARDS_AND_SPEND_LIMITS",
  VIEW_EXPENSES = "VIEW_EXPENSES",
  VIEW_GROUP_EVENTS = "VIEW_GROUP_EVENTS",
  VIEW_LEGAL_ENTITIES = "VIEW_LEGAL_ENTITIES",
  VIEW_ORGANIZATION = "VIEW_ORGANIZATION",
  VIEW_POLICIES = "VIEW_POLICIES",
  VIEW_REPORTS = "VIEW_REPORTS",
  VIEW_REWARDS = "VIEW_REWARDS",
  VIEW_SPEND_LIMITS = "VIEW_SPEND_LIMITS",
  VIEW_TRANSACTIONS = "VIEW_TRANSACTIONS",
  VIEW_TRAVEL = "VIEW_TRAVEL",
  VIEW_USERS = "VIEW_USERS",
}

export interface AuthDomain {
  displayName: Scalars["String"];
  key: AuthDomainKey;
}

export enum AuthDomainKey {
  ACCOUNTING = "ACCOUNTING",
  ACCOUNTS = "ACCOUNTS",
  BILL_PAY = "BILL_PAY",
  HIERARCHIES = "HIERARCHIES",
  REPORTING = "REPORTING",
  REWARDS = "REWARDS",
  RFI = "RFI",
  SECURITY = "SECURITY",
  SPEND = "SPEND",
  TRAVEL = "TRAVEL",
}

export interface AuthPayloadOneOfInput {
  /** Input fields create and connect Google Workspace Connection for a specific client */
  googleWorkspaceAuthPayloadInput?: InputMaybe<GoogleWorkspaceAuthPayloadInput>;
  /** Input fields create and connect Gusto Connection */
  gustoAuthPayloadInput?: InputMaybe<GustoAuthPayloadInput>;
  /** Input fields create and connect to Microsoft Graph for a specific client */
  microsoftGraphAuthPayloadInput?: InputMaybe<MicrosoftGraphAuthPayloadInput>;
  /** Input fields create and connect to Microsoft 365 for a specific client */
  ms365bcAuthPayloadInput?: InputMaybe<MS365BCAuthPayloadInput>;
  /** Input fields create and connect to Microsoft 365 Finance and Operations for a specific client */
  ms365fnoAuthPayloadInput?: InputMaybe<MS365FNOAuthPayloadInput>;
  /** Input fields create and connect Netsuite Connection */
  netsuiteAuthPayloadInput?: InputMaybe<NetsuiteAuthPayloadInput>;
  /** Input fields create and connect Oracle Fusion Connection */
  oracleFusionAuthPayloadInput?: InputMaybe<OracleFusionAuthPayloadInput>;
  /** Input fields create and connect to Puzzle for a specific client */
  puzzleAuthPayloadInput?: InputMaybe<PuzzleAuthPayloadInput>;
  /** Input fields create and connect Quickbooks Desktop Connection */
  qbdAuthPayloadInput?: InputMaybe<QbdAuthPayloadInput>;
  /** Input fields create and connect Quickbooks Connection */
  quickbooksAuthPayloadInput?: InputMaybe<QuickbooksAuthPayloadInput>;
  /** Input fields create and connect Sage Intacct Connection */
  sageIntacctAuthPayloadInput?: InputMaybe<SageIntacctAuthPayloadInput>;
  /** Input fields create and connect Shopify Connection */
  shopifyAuthPayloadInput?: InputMaybe<ShopifyAuthPayloadInput>;
  /** Input fields create and connect Workday Connection */
  workdayAuthPayloadInput?: InputMaybe<WorkdayAuthPayloadInput>;
  /** Input fields create and connect Xero Connection */
  xeroAuthPayloadInput?: InputMaybe<XeroAuthPayloadInput>;
}

export enum AuthResourceType {
  ACCOUNT = "ACCOUNT",
  ACCOUNTING_INTEGRATION = "ACCOUNTING_INTEGRATION",
  ACCOUNTING_JOURNAL = "ACCOUNTING_JOURNAL",
  ACCOUNTING_RECORD = "ACCOUNTING_RECORD",
  ACCOUNT_BALANCE = "ACCOUNT_BALANCE",
  ACCOUNT_ENTERPRISE_IDP_CONFIGURATION = "ACCOUNT_ENTERPRISE_IDP_CONFIGURATION",
  ACCOUNT_MANAGEMENT = "ACCOUNT_MANAGEMENT",
  ACCOUNT_NICKNAME = "ACCOUNT_NICKNAME",
  ACCOUNT_REPORT = "ACCOUNT_REPORT",
  ACCOUNT_SETTINGS = "ACCOUNT_SETTINGS",
  ACCOUNT_SSO_CONFIGURATION = "ACCOUNT_SSO_CONFIGURATION",
  ADMIN_ROLE = "ADMIN_ROLE",
  ADMIN_ROLE_ASSIGNMENT = "ADMIN_ROLE_ASSIGNMENT",
  ADMIN_STATUS = "ADMIN_STATUS",
  ADMIN_USER = "ADMIN_USER",
  AI_ASSISTANT_SETTINGS = "AI_ASSISTANT_SETTINGS",
  AI_EXPENSE_JUDGEMENT = "AI_EXPENSE_JUDGEMENT",
  ANALYSIS = "ANALYSIS",
  ANALYSIS_ACCOUNT_TYPE = "ANALYSIS_ACCOUNT_TYPE",
  APPROVAL = "APPROVAL",
  ATTRIBUTE_MAPPING = "ATTRIBUTE_MAPPING",
  AUDIT_LOG = "AUDIT_LOG",
  AUDIT_LOG_TARGET = "AUDIT_LOG_TARGET",
  AUDIT_NOTE = "AUDIT_NOTE",
  AUDIT_NOTE_TYPE = "AUDIT_NOTE_TYPE",
  AUDIT_OPERATION = "AUDIT_OPERATION",
  AUDIT_TIMELINE_ENTRY = "AUDIT_TIMELINE_ENTRY",
  AUTH_DECLINES = "AUTH_DECLINES",
  AUTOMATION_SUGGESTION = "AUTOMATION_SUGGESTION",
  AUTOMATION_WORKFLOW_SPEC = "AUTOMATION_WORKFLOW_SPEC",
  AUTO_INVITE_SETTING = "AUTO_INVITE_SETTING",
  BASIC_BILL_POLICY = "BASIC_BILL_POLICY",
  BILL = "BILL",
  BILLING_ACTIVITY = "BILLING_ACTIVITY",
  BILLING_AUTO_COLLECTION_SETTINGS = "BILLING_AUTO_COLLECTION_SETTINGS",
  BILLING_INVOICE = "BILLING_INVOICE",
  BILLING_PAYMENT = "BILLING_PAYMENT",
  BILLING_POLICY = "BILLING_POLICY",
  BILLING_TRANSACTION = "BILLING_TRANSACTION",
  BILL_PAYMENT = "BILL_PAYMENT",
  BILL_PAY_ACCESS = "BILL_PAY_ACCESS",
  BOOKING = "BOOKING",
  BUDGET = "BUDGET",
  BUDGET_CONTROLLER = "BUDGET_CONTROLLER",
  BUDGET_LIMIT = "BUDGET_LIMIT",
  BUDGET_MAPPING = "BUDGET_MAPPING",
  BUDGET_MAPPING_CARD = "BUDGET_MAPPING_CARD",
  BUDGET_MEMBERSHIP = "BUDGET_MEMBERSHIP",
  BUDGET_PROGRAM = "BUDGET_PROGRAM",
  BUDGET_REQUEST = "BUDGET_REQUEST",
  BUDGET_REQUEST_COMMENT = "BUDGET_REQUEST_COMMENT",
  BUDGET_TEMPLATE = "BUDGET_TEMPLATE",
  BUDGET_USER = "BUDGET_USER",
  CARD = "CARD",
  CARD_ACCOUNT_TYPE = "CARD_ACCOUNT_TYPE",
  CARD_ADMIN_ROLE_ASSIGNMENT = "CARD_ADMIN_ROLE_ASSIGNMENT",
  CARD_ALIAS = "CARD_ALIAS",
  CARD_CROSS_PAY = "CARD_CROSS_PAY",
  CARD_DISPLAY_NAME = "CARD_DISPLAY_NAME",
  CARD_ENTITY_BILLING_CONFIGURATION_OVERRIDE = "CARD_ENTITY_BILLING_CONFIGURATION_OVERRIDE",
  CARD_FINANCIAL_DETAIL_ADDENDA = "CARD_FINANCIAL_DETAIL_ADDENDA",
  CARD_LIMIT_CATEGORY = "CARD_LIMIT_CATEGORY",
  CARD_PAN = "CARD_PAN",
  CARD_PIN = "CARD_PIN",
  CARD_SPENDING_ENTITY_OVERRIDE = "CARD_SPENDING_ENTITY_OVERRIDE",
  CARD_SPEND_CONTROL = "CARD_SPEND_CONTROL",
  CARD_STATEMENT = "CARD_STATEMENT",
  CASH_ACCOUNT = "CASH_ACCOUNT",
  CASH_ADMIN_ROLE_ASSIGNMENT = "CASH_ADMIN_ROLE_ASSIGNMENT",
  CASH_FUND = "CASH_FUND",
  CASH_OFFBOARDING = "CASH_OFFBOARDING",
  CASH_OFFBOARDING_WITHDRAWAL = "CASH_OFFBOARDING_WITHDRAWAL",
  CASH_PAYMENT = "CASH_PAYMENT",
  CASH_PAYMENT_POLICY = "CASH_PAYMENT_POLICY",
  CASH_STATEMENT = "CASH_STATEMENT",
  CASH_TRANSACTION = "CASH_TRANSACTION",
  CASH_TRANSACTION_ACH_DEBIT = "CASH_TRANSACTION_ACH_DEBIT",
  CASH_TRANSACTION_BOOK_TRANSFER = "CASH_TRANSACTION_BOOK_TRANSFER",
  CASH_VENDOR = "CASH_VENDOR",
  CIP_REFRESH = "CIP_REFRESH",
  CLAWBACK = "CLAWBACK",
  CLAWBACK_FOR_OTHER = "CLAWBACK_FOR_OTHER",
  CLAWBACK_PAYMENT = "CLAWBACK_PAYMENT",
  COHORT = "COHORT",
  COLLECTION_EARLY_CREDIT_COMMITMENT = "COLLECTION_EARLY_CREDIT_COMMITMENT",
  COLLECTION_INFLIGHT_BALANCE = "COLLECTION_INFLIGHT_BALANCE",
  COLLECTION_PROMISE = "COLLECTION_PROMISE",
  COMMS_CHANNEL = "COMMS_CHANNEL",
  COMMS_INCIDENTS = "COMMS_INCIDENTS",
  COMPANY = "COMPANY",
  COMPANY_INFO = "COMPANY_INFO",
  COMPANY_TRANSACTION = "COMPANY_TRANSACTION",
  COMPLIANCE_RATING = "COMPLIANCE_RATING",
  COMPLIANCE_RATING_SETTINGS = "COMPLIANCE_RATING_SETTINGS",
  COPILOT = "COPILOT",
  COPILOT_ACCESS_CHANGE = "COPILOT_ACCESS_CHANGE",
  COST_CENTER = "COST_CENTER",
  CREDIT = "CREDIT",
  CUSTOM_ROLE = "CUSTOM_ROLE",
  DEPARTMENT = "DEPARTMENT",
  DEVELOPER_SETTING = "DEVELOPER_SETTING",
  DEVPORTAL_TOKEN = "DEVPORTAL_TOKEN",
  DRAWDOWN_AUTHORIZATION = "DRAWDOWN_AUTHORIZATION",
  DUTY_OF_CARE = "DUTY_OF_CARE",
  EBA_ACH_INTL_PAYMENT = "EBA_ACH_INTL_PAYMENT",
  EBA_CHECK_PAYMENT = "EBA_CHECK_PAYMENT",
  EBA_PAYMENT = "EBA_PAYMENT",
  EBA_WIRE_DOM_PAYMENT = "EBA_WIRE_DOM_PAYMENT",
  EBA_WIRE_INTL_PAYMENT = "EBA_WIRE_INTL_PAYMENT",
  EBA_WIRE_PAYMENT = "EBA_WIRE_PAYMENT",
  EMBEDDED_USER = "EMBEDDED_USER",
  /** @deprecated Use EMPLOYEE_CARD_ACCESS instead */
  EMPLOYEE_CARD = "EMPLOYEE_CARD",
  EMPLOYEE_CARD_ACCESS = "EMPLOYEE_CARD_ACCESS",
  EXPENSE = "EXPENSE",
  EXPENSE_ADDENDUM = "EXPENSE_ADDENDUM",
  EXPENSE_BILL_PAY = "EXPENSE_BILL_PAY",
  EXPENSE_BILL_PAY_DRAFT = "EXPENSE_BILL_PAY_DRAFT",
  EXPENSE_BUDGET_ASSIGNMENT = "EXPENSE_BUDGET_ASSIGNMENT",
  EXPENSE_COMMENT = "EXPENSE_COMMENT",
  EXPENSE_REPORT = "EXPENSE_REPORT",
  EXPENSE_SETTING = "EXPENSE_SETTING",
  EXPENSE_TRAVEL_CATEGORY = "EXPENSE_TRAVEL_CATEGORY",
  EXPORT = "EXPORT",
  EXPORT_JOB = "EXPORT_JOB",
  EXPORT_TARGET_DATA = "EXPORT_TARGET_DATA",
  EXTENSIBLE_FIELDS = "EXTENSIBLE_FIELDS",
  EXTENSIBLE_WORKFLOW_EVALUATION = "EXTENSIBLE_WORKFLOW_EVALUATION",
  EXTENSIBLE_WORKFLOW_RULE = "EXTENSIBLE_WORKFLOW_RULE",
  FEATURE_TOGGLE = "FEATURE_TOGGLE",
  FEE = "FEE",
  FILE = "FILE",
  FILE_LINK = "FILE_LINK",
  FINANCIAL_ACCOUNT = "FINANCIAL_ACCOUNT",
  FINANCIAL_ACCOUNT_ONBOARDING_APPLICATION = "FINANCIAL_ACCOUNT_ONBOARDING_APPLICATION",
  FINANCIAL_DOCUMENT = "FINANCIAL_DOCUMENT",
  FINANCIAL_DOCUMENT_SETTING = "FINANCIAL_DOCUMENT_SETTING",
  FINANCIAL_INSTITUTION = "FINANCIAL_INSTITUTION",
  FINANCIAL_SOURCE = "FINANCIAL_SOURCE",
  FINANCIAL_SPREAD_ACCOUNT = "FINANCIAL_SPREAD_ACCOUNT",
  FINANCIAL_SPREAD_DOCUMENT_SUBMISSION = "FINANCIAL_SPREAD_DOCUMENT_SUBMISSION",
  FORWARDING_ADDRESS = "FORWARDING_ADDRESS",
  FRAUD_ALERT = "FRAUD_ALERT",
  FRAUD_ANALYSIS = "FRAUD_ANALYSIS",
  FRAUD_DISPUTE = "FRAUD_DISPUTE",
  FSP_CLIENT_CONNECTION = "FSP_CLIENT_CONNECTION",
  FSP_CONNECTION = "FSP_CONNECTION",
  FSP_TEAM = "FSP_TEAM",
  FUNDING_SOURCE = "FUNDING_SOURCE",
  GLOBAL_REPORT = "GLOBAL_REPORT",
  GROUP_EVENT = "GROUP_EVENT",
  GROUP_EVENT_COMMENT = "GROUP_EVENT_COMMENT",
  HRIS_CONNECTION = "HRIS_CONNECTION",
  HRIS_RAAS_CONFIGURATION = "HRIS_RAAS_CONFIGURATION",
  IMPLEMENTATION_PANEL = "IMPLEMENTATION_PANEL",
  INSIGHT = "INSIGHT",
  INSIGHT_COMMENT = "INSIGHT_COMMENT",
  INSIGHT_SETTINGS = "INSIGHT_SETTINGS",
  INTEGRATION = "INTEGRATION",
  INTERNAL_NOTE = "INTERNAL_NOTE",
  INTERNAL_TICKET = "INTERNAL_TICKET",
  INVOICE = "INVOICE",
  INVOICE_DETAILS = "INVOICE_DETAILS",
  JOURNAL_ACCOUNT = "JOURNAL_ACCOUNT",
  JOURNAL_ACTIVITY = "JOURNAL_ACTIVITY",
  JOURNAL_ENTRY = "JOURNAL_ENTRY",
  LEGAL_ENTITY = "LEGAL_ENTITY",
  LEGAL_ENTITY_BILLING_CONFIGURATION = "LEGAL_ENTITY_BILLING_CONFIGURATION",
  LEGAL_ENTITY_KYC = "LEGAL_ENTITY_KYC",
  LIABLE_TRANSMISSION = "LIABLE_TRANSMISSION",
  LIMIT_GROUP = "LIMIT_GROUP",
  LIMIT_INCREASE_REQUEST = "LIMIT_INCREASE_REQUEST",
  LIMIT_INCREASE_REQUEST_COMMENT = "LIMIT_INCREASE_REQUEST_COMMENT",
  LIMIT_UTILIZATION_TRIGGER = "LIMIT_UTILIZATION_TRIGGER",
  LOCALE_SETTINGS = "LOCALE_SETTINGS",
  LOCATION = "LOCATION",
  MFA_RESET = "MFA_RESET",
  MFA_SETUP = "MFA_SETUP",
  MILEAGE_SETTING = "MILEAGE_SETTING",
  NON_ADMIN_ROLE = "NON_ADMIN_ROLE",
  NON_ADMIN_STATUS = "NON_ADMIN_STATUS",
  ONBOARDING_APPLICATION = "ONBOARDING_APPLICATION",
  OPERATION = "OPERATION",
  OUTREACH_CONTACTS = "OUTREACH_CONTACTS",
  PARTNERSHIP = "PARTNERSHIP",
  PASSWORD_RESET = "PASSWORD_RESET",
  PAYIN = "PAYIN",
  PAYMENT_APPROVAL_SETTINGS_NOTIFICATION = "PAYMENT_APPROVAL_SETTINGS_NOTIFICATION",
  PAYROLL_PROVIDER = "PAYROLL_PROVIDER",
  PERSONAL_CARD_BOOKING = "PERSONAL_CARD_BOOKING",
  PHYSICAL_CARD_ACCESS = "PHYSICAL_CARD_ACCESS",
  PLAN_AND_BILLING_SETTING = "PLAN_AND_BILLING_SETTING",
  POLICY = "POLICY",
  POLICY_CURRENCY = "POLICY_CURRENCY",
  POLICY_DEFAULT = "POLICY_DEFAULT",
  POLICY_LINE_ITEM_RECEIPT_CATEGORY = "POLICY_LINE_ITEM_RECEIPT_CATEGORY",
  POSITIVE_PAY_SETTINGS = "POSITIVE_PAY_SETTINGS",
  PROCESS_PROVIDER_TRANSACTION = "PROCESS_PROVIDER_TRANSACTION",
  PROCUREMENT_INTERNAL_PURCHASE_ORDER = "PROCUREMENT_INTERNAL_PURCHASE_ORDER",
  PROCUREMENT_POLICY = "PROCUREMENT_POLICY",
  PROCUREMENT_PURCHASE_ORDER = "PROCUREMENT_PURCHASE_ORDER",
  PRODUCT_ACTIVATION_CTA = "PRODUCT_ACTIVATION_CTA",
  PRODUCT_SELECTION = "PRODUCT_SELECTION",
  PURCHASE_ORDER_NUMBER = "PURCHASE_ORDER_NUMBER",
  /** @deprecated Use PURCHASING_CARD_ACCESS instead */
  PURCHASING_CARD = "PURCHASING_CARD",
  PURCHASING_CARD_ACCESS = "PURCHASING_CARD_ACCESS",
  PUSH_PAYMENT_INSTRUCTIONS = "PUSH_PAYMENT_INSTRUCTIONS",
  QBO_INTEGRATION = "QBO_INTEGRATION",
  QUALIFYING_BUDGET_PROGRAM = "QUALIFYING_BUDGET_PROGRAM",
  RAD_ENTITY = "RAD_ENTITY",
  RAD_USER = "RAD_USER",
  RAILS = "RAILS",
  RECEIPT = "RECEIPT",
  RECEIPT_AUTOGEN_SETTINGS = "RECEIPT_AUTOGEN_SETTINGS",
  RECEIPT_INTEGRATION = "RECEIPT_INTEGRATION",
  RECEIPT_VALIDATION_SETTING = "RECEIPT_VALIDATION_SETTING",
  RECONCILIATION_INCONSISTENCY = "RECONCILIATION_INCONSISTENCY",
  REDEMPTION = "REDEMPTION",
  REFERRALS = "REFERRALS",
  REIMBURSEMENT = "REIMBURSEMENT",
  REIMBURSEMENT_EVENT = "REIMBURSEMENT_EVENT",
  REIMBURSEMENT_FAILURE = "REIMBURSEMENT_FAILURE",
  REIMBURSEMENT_HEALTH = "REIMBURSEMENT_HEALTH",
  REIMBURSEMENT_METADATA = "REIMBURSEMENT_METADATA",
  REIMBURSEMENT_PAYMENT = "REIMBURSEMENT_PAYMENT",
  REIMBURSEMENT_PAYMENT_SOURCE = "REIMBURSEMENT_PAYMENT_SOURCE",
  REIMBURSEMENT_TERMS_AND_CONDITIONS = "REIMBURSEMENT_TERMS_AND_CONDITIONS",
  REPORT = "REPORT",
  REQUEST = "REQUEST",
  REQUEST_ACTION = "REQUEST_ACTION",
  REQUEST_ACTION_STATUS = "REQUEST_ACTION_STATUS",
  /** @deprecated Use REQUEST_RESTRICTED_PRE_ACTIVATION instead */
  REQUEST_AMS = "REQUEST_AMS",
  REQUEST_DEADLINE = "REQUEST_DEADLINE",
  REQUEST_EXPENSE = "REQUEST_EXPENSE",
  /** @deprecated Use REQUEST_RESTRICTED instead */
  REQUEST_NON_EXPENSE = "REQUEST_NON_EXPENSE",
  REQUEST_RESTRICTED = "REQUEST_RESTRICTED",
  REQUEST_RESTRICTED_PRE_ACTIVATION = "REQUEST_RESTRICTED_PRE_ACTIVATION",
  REQUEST_STANDARD = "REQUEST_STANDARD",
  REWARDS_BALANCE = "REWARDS_BALANCE",
  REWARDS_CAMPAIGN = "REWARDS_CAMPAIGN",
  REWARDS_CASH_BALANCE_REDEMPTION = "REWARDS_CASH_BALANCE_REDEMPTION",
  REWARDS_GIFT_CARD_REDEMPTION = "REWARDS_GIFT_CARD_REDEMPTION",
  REWARDS_POINTS = "REWARDS_POINTS",
  REWARDS_REFERRAL = "REWARDS_REFERRAL",
  REWARDS_STATEMENT_CREDIT_REDEMPTION = "REWARDS_STATEMENT_CREDIT_REDEMPTION",
  REWARDS_STATUS = "REWARDS_STATUS",
  REWARDS_TRAVEL_REDEMPTION = "REWARDS_TRAVEL_REDEMPTION",
  REWARDS_VAS_REDEMPTION = "REWARDS_VAS_REDEMPTION",
  RFI = "RFI",
  ROLE = "ROLE",
  SAAS_BILLING_DATA = "SAAS_BILLING_DATA",
  SANDBOX_ACCOUNT_ACTION = "SANDBOX_ACCOUNT_ACTION",
  SAVED_VIEW = "SAVED_VIEW",
  SELF_ATTESTATION_ACCOUNT_TYPE = "SELF_ATTESTATION_ACCOUNT_TYPE",
  SPENDING_ENTITY = "SPENDING_ENTITY",
  SPEND_INSIGHT = "SPEND_INSIGHT",
  SPEND_LIMIT = "SPEND_LIMIT",
  /** @deprecated Use SPEND_LIMIT_CARD_ACCESS instead */
  SPEND_LIMIT_CARD = "SPEND_LIMIT_CARD",
  SPEND_LIMIT_CARD_ACCESS = "SPEND_LIMIT_CARD_ACCESS",
  SPEND_REPORT = "SPEND_REPORT",
  SPOTNANA_REWARDS = "SPOTNANA_REWARDS",
  SPOTNANA_TRAVEL_REPORT = "SPOTNANA_TRAVEL_REPORT",
  STATEMENTS = "STATEMENTS",
  STATEMENTS_SETTING = "STATEMENTS_SETTING",
  SUPER_ADMIN_ROLE_ASSIGNMENT = "SUPER_ADMIN_ROLE_ASSIGNMENT",
  SUPPORT_SPECIALIST_INFORMATION = "SUPPORT_SPECIALIST_INFORMATION",
  TITLE = "TITLE",
  TRACKING_EXPENSE_POLICY = "TRACKING_EXPENSE_POLICY",
  TRANSMISSION = "TRANSMISSION",
  TRANSMISSION_ASSOCIATION_CONFIGS = "TRANSMISSION_ASSOCIATION_CONFIGS",
  TRANSMISSION_BATCH = "TRANSMISSION_BATCH",
  TRANSMISSION_CONFIG = "TRANSMISSION_CONFIG",
  TRANSMISSION_MOVEMENT = "TRANSMISSION_MOVEMENT",
  TRANSMISSION_MOVEMENT_BATCH = "TRANSMISSION_MOVEMENT_BATCH",
  TRANSMISSION_QUOTE = "TRANSMISSION_QUOTE",
  TRAVEL_ACCESS = "TRAVEL_ACCESS",
  TRAVEL_ADMIN_ACCESS = "TRAVEL_ADMIN_ACCESS",
  TRAVEL_INTEGRATION_CREDENTIAL = "TRAVEL_INTEGRATION_CREDENTIAL",
  TRAVEL_REPORT = "TRAVEL_REPORT",
  TRIP = "TRIP",
  TRUSTED_BENEFICIARY = "TRUSTED_BENEFICIARY",
  TRUSTED_BENEFICIARY_OTP = "TRUSTED_BENEFICIARY_OTP",
  UNDERWRITING_ACCOUNT = "UNDERWRITING_ACCOUNT",
  UNDERWRITING_BANK_CONNECTION = "UNDERWRITING_BANK_CONNECTION",
  UNDERWRITING_CONNECT_BANK_NOTICE = "UNDERWRITING_CONNECT_BANK_NOTICE",
  UNDERWRITING_FINANCIAL_DOCUMENT = "UNDERWRITING_FINANCIAL_DOCUMENT",
  UNDERWRITING_POLICY = "UNDERWRITING_POLICY",
  USER = "USER",
  USER_ACTIVITY = "USER_ACTIVITY",
  USER_ADMIN_DETAIL = "USER_ADMIN_DETAIL",
  USER_ATTRIBUTE = "USER_ATTRIBUTE",
  USER_DETAIL = "USER_DETAIL",
  USER_DEVICE = "USER_DEVICE",
  USER_EMAIL = "USER_EMAIL",
  USER_EMAIL_CHANGE_REQUEST = "USER_EMAIL_CHANGE_REQUEST",
  USER_EMAIL_CHANGE_SETTING = "USER_EMAIL_CHANGE_SETTING",
  USER_GROUP = "USER_GROUP",
  USER_GROUP_MEMBERSHIP = "USER_GROUP_MEMBERSHIP",
  USER_LIMIT = "USER_LIMIT",
  USER_ROLE_ASSIGNMENT = "USER_ROLE_ASSIGNMENT",
  USER_SESSION = "USER_SESSION",
  USER_STATUS = "USER_STATUS",
  VENDOR = "VENDOR",
  VENDOR_CARD = "VENDOR_CARD",
  VENDOR_CREDENTIAL = "VENDOR_CREDENTIAL",
  VENDOR_FILE_MATCH = "VENDOR_FILE_MATCH",
  VENDOR_GROUP = "VENDOR_GROUP",
  VENDOR_GROUP_MEMBERSHIP = "VENDOR_GROUP_MEMBERSHIP",
  VENDOR_OWNER_GROUP = "VENDOR_OWNER_GROUP",
  VENDOR_SPEND_SUMMARY = "VENDOR_SPEND_SUMMARY",
  VENDOR_UNMASKED_TIN = "VENDOR_UNMASKED_TIN",
  VERIFICATION_ACCOUNT_TYPE_REQUEST = "VERIFICATION_ACCOUNT_TYPE_REQUEST",
  VERIFICATION_REQUEST = "VERIFICATION_REQUEST",
  VIP_BOOKING = "VIP_BOOKING",
  VIRTUAL_CARD_ACCESS = "VIRTUAL_CARD_ACCESS",
  VIRTUAL_SPEND_LIMIT_CARD = "VIRTUAL_SPEND_LIMIT_CARD",
}

export interface AuthRole extends Node {
  config?: Maybe<AuthRoleConfiguration>;
  description: Scalars["String"];
  displayName: Scalars["String"];
  /** The ID of an object */
  id: Scalars["ID"];
  isAdmin?: Maybe<Scalars["Boolean"]>;
  isCustom: Scalars["Boolean"];
  isDeleted?: Maybe<Scalars["Boolean"]>;
  name: Scalars["String"];
  roleType: AuthRoleType;
  userCount?: Maybe<Scalars["Int"]>;
}

export interface AuthRoleAssignment {
  actor: AuthActor;
  id: Scalars["ID"];
  role: AuthRole;
}

export interface AuthRoleConfiguration {
  capabilities?: Maybe<Array<Maybe<AuthCapability>>>;
  roleConfigurationSummary: Array<AuthRoleConfigurationSummary>;
}

export interface AuthRoleConfigurationSummary {
  accessSummary: AuthRoleConfigurationSummaryType;
  domain?: Maybe<AuthDomain>;
}

export enum AuthRoleConfigurationSummaryType {
  FULL_ACCESS = "FULL_ACCESS",
  PARTIAL_ACCESS = "PARTIAL_ACCESS",
}

export interface AuthRoleConnection extends Connection {
  edges: Array<AuthRoleEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

/** Role edge for the Role connection. */
export interface AuthRoleEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<AuthRole>;
}

export interface AuthRoleError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export enum AuthRoleType {
  ACCESS = "ACCESS",
  FUNCTIONAL = "FUNCTIONAL",
}

/** Available period types for an authorization limit. @deprecated(reason: "Use LimitResetFrequency instead which provides more detailed documentation for each value.") */
export enum AuthorizationLimitPeriodType {
  ONE_TIME = "ONE_TIME",
  PER_MONTH = "PER_MONTH",
  PER_QUARTER = "PER_QUARTER",
  PER_WEEK = "PER_WEEK",
  PER_YEAR = "PER_YEAR",
}

export interface AuthorizationSettings {
  /** The date after which spending is no longer allowed. All transactions will be declined after this date */
  endDate?: Maybe<Scalars["Date"]>;
  /** The exact settings that control how limits are configured and enforced */
  limitSettings?: Maybe<LimitSettings>;
  /** Merchant category controls */
  merchantCategoryControls?: Maybe<MerchantCategoryControls>;
  /** The date when spending is first allowed. No transactions will be authorized before this date */
  startDate?: Maybe<Scalars["Date"]>;
}

export interface AuthorizeDrawdownRequestInput {
  clientMutationId: Scalars["String"];
  depositsAccountId: Scalars["ID"];
  idempotencyKey?: InputMaybe<Scalars["String"]>;
  maxAuthorizationAmountUsdCents?: InputMaybe<Scalars["Int"]>;
  /** Logical ID of a payment instrument */
  paymentInstrumentId: Scalars["ID"];
  paymentInstrumentVersion: Scalars["Int"];
}

export interface AuthorizeDrawdownRequestPayload {
  clientMutationId: Scalars["String"];
  drawdownAuthorization: DrawdownAuthorization;
}

export interface AuthorizedEmployee {
  /** The employee that was authorized to view the CommentThread/entity via the Comment */
  authorizedEmployee: Employee;
}

export enum AutoApprovalPeriodType {
  /** A limit which only takes into account the amount on the current request. */
  ONE_TIME = "ONE_TIME",
  /** Every month */
  PER_MONTH = "PER_MONTH",
  /** Every quarter */
  PER_QUARTER = "PER_QUARTER",
  /** Every week */
  PER_WEEK = "PER_WEEK",
  /** Every year */
  PER_YEAR = "PER_YEAR",
}

export enum AutoCollectionStatus {
  /** Expected for Reimbursement Tracking, and Manual Reimbursement Disbursements */
  DISABLED = "DISABLED",
  /** Almost-always true for Card, except for exceptions by servicing */
  ENABLED = "ENABLED",
  /** A Card-specific state usually set by servicing and can be ignored for most use cases. */
  TEMPORARILY_DISABLED = "TEMPORARILY_DISABLED",
}

/** Enum related to spend limits that indicates how auto limit card creation works for members. */
export enum AutoCreateLimitCardsSetting {
  /** All limit members will get limit cards automatically created for them. */
  ALL_MEMBERS = "ALL_MEMBERS",
  /** Limit members will not get limit cards automatically created for them. */
  DISABLED = "DISABLED",
}

export interface AutoImportField {
  autoImportFieldType: AutoImportFieldType;
  /** Required when uniquely identifying unique fields that share the same type */
  vendorInternalId?: Maybe<Scalars["String"]>;
}

export interface AutoImportFieldInput {
  autoImportFieldType: AutoImportFieldType;
  /** Required to uniquely identify custom field */
  vendorInternalId?: InputMaybe<Scalars["String"]>;
}

export enum AutoImportFieldType {
  CLASS = "CLASS",
  CREDIT_CARD = "CREDIT_CARD",
  CURRENCY = "CURRENCY",
  CUSTOM = "CUSTOM",
  CUSTOMER = "CUSTOMER",
  DEPARTMENT = "DEPARTMENT",
  EMPLOYEE = "EMPLOYEE",
  GL_ACCOUNT = "GL_ACCOUNT",
  LOCATION = "LOCATION",
  PROJECT = "PROJECT",
  PURCHASE_ORDER = "PURCHASE_ORDER",
  SEGMENT = "SEGMENT",
  SUBSIDIARY = "SUBSIDIARY",
  TAX_CODE = "TAX_CODE",
  VENDOR = "VENDOR",
}

/** Auto import settings configured for the integration. It is either all fields or specific fields */
export interface AutoImportSettings {
  /** Optional, import all additional fields */
  autoImportAllFields?: Maybe<Scalars["Boolean"]>;
  /** Optional, import specific fields */
  autoImportFields?: Maybe<Array<AutoImportField>>;
  /** Optional, last time we auto imported */
  lastImportedAt?: Maybe<Scalars["Time"]>;
}

export interface AutoImportSettingsOneOfInput {
  /**
   * Since GraphQL does not directly support union types for input, each input type is optional
   * to represent each type of union.
   *
   * Note that only one of the input types should be provided.
   * The server will validate that only one of the input types is provided.
   */
  autoImportAllFields?: InputMaybe<Scalars["Boolean"]>;
  autoImportFields?: InputMaybe<Array<AutoImportFieldInput>>;
}

/** Auto initiated by a Brex system */
export interface AutoInitiated {
  /** The originator id of the auto initiated payment */
  originatorId?: Maybe<Scalars["String"]>;
  /** The originator type of the auto initiated payment */
  originatorType: Scalars["String"];
}

export interface AutoInitiatedBilling {
  originatorId?: Maybe<Scalars["String"]>;
  originatorType: Scalars["String"];
}

/** [oneof] Either provide userRoles & access or roleIDs. */
export interface AutoInviteAssignmentInput {
  access?: InputMaybe<Array<UserProductAccess>>;
  roleIds?: InputMaybe<Array<Scalars["ID"]>>;
  userRoles?: InputMaybe<Array<UserRole>>;
}

export interface AutoInviteSetting {
  /** @deprecated settings should specify roleIds instead */
  access?: Maybe<Array<UserProductAccess>>;
  active: Scalars["Boolean"];
  autoInvitedUserCount: Scalars["Int"];
  condition: Scalars["String"];
  createdBy?: Maybe<User>;
  deletedAt?: Maybe<Scalars["Time"]>;
  id: Scalars["ID"];
  insertedAt: Scalars["Time"];
  lastUpdatedBy?: Maybe<User>;
  name: Scalars["String"];
  roleIds?: Maybe<Array<Scalars["ID"]>>;
  updatedAt: Scalars["Time"];
  /** @deprecated settings should specify roleIds instead */
  userRole?: Maybe<Array<UserRole>>;
}

export interface AutoInviteSettingConnection extends Connection {
  edges: Array<AutoInviteSettingEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface AutoInviteSettingEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<AutoInviteSetting>;
}

export interface AutoInviteSettingError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

/** The identifier to get auto invite settings with, right now we only support ID */
export interface AutoInviteSettingIdentifier {
  id?: InputMaybe<Scalars["ID"]>;
  type: AutoInviteSettingIdentifierType;
}

export enum AutoInviteSettingIdentifierType {
  ID = "ID",
}

/** The type of memo that will be auto-generated. */
export enum AutoMemoType {
  /** The memo will be a pre-defined custom text. */
  CUSTOM_TEXT = "CUSTOM_TEXT",
  /** The memo will be generated with spend limit description only when the budget is procurement */
  DESCRIPTION = "DESCRIPTION",
  /** The memo will be generated with the name of the budget */
  STANDARD = "STANDARD",
}

/** Whether or not users should be auto-offboarded when they are terminated or set to INACTIVE in the customer's HR System. */
export interface AutoOffboardSetting {
  isEnabled?: Maybe<Scalars["Boolean"]>;
}

/** Whether or not users should be auto-offboarded when they are terminated or set to INACTIVE in the customer's HR System. */
export interface AutoOffboardSettingInput {
  /** Must be set to TRUE if included. This attribute is ignored and included only to prevent having an empty type. */
  isEnabled?: InputMaybe<Scalars["Boolean"]>;
}

/** How to present auto-onboarding settings. */
export enum AutoOffboardingAvailability {
  /** Indicates there are no known issues with syncing and auto-offboarding. */
  AVAILABLE = "AVAILABLE",
  /**
   * Indicates there may be some issues with syncing and auto-offboarding. For example, we've seen a given HR system work
   * for some customers but not others.
   */
  BETA = "BETA",
  /**
   * Indicates that we are syncing data for this customer, but something about the sync is unreliable and it is
   * best to have the customer stick to manual offboarding.
   */
  DISABLED = "DISABLED",
}

/** Whether or not users should be auto-onboarded when they are added to the customer's HR System. */
export interface AutoOnboardSetting {
  userSetting: HrisUserSetting;
}

/** Whether or not users should be auto-onboarded when they are added to the customer's HR System. */
export interface AutoOnboardSettingInput {
  userSetting: HrisUserSettingInput;
}

/** How to present auto-onboarding settings. */
export enum AutoOnboardingAvailability {
  /** Indicates there are no known issues with syncing and auto-onboarding. */
  AVAILABLE = "AVAILABLE",
  /**
   * Indicates there may be some issues with syncing and auto-onboarding. For example, we've seen some HR systems work
   * for some customers but not others.
   */
  BETA = "BETA",
  /**
   * Indicates that we are syncing data for this customer, but something about the sync is unreliable and it is
   * best to have the customer stick to manual onboarding.
   */
  DISABLED = "DISABLED",
}

/** Setting for auto-transferring budget cards when their owners are either disabled or removed as members from the budget. */
export enum AutoTransferCardsSetting {
  /** Budget cards will not be transferred. */
  DISABLED = "DISABLED",
  /** Budget cards will be transferred. */
  ENABLED = "ENABLED",
}

export enum AutomatchType {
  NAME = "NAME",
  NAME_AND_ID = "NAME_AND_ID",
}

export interface AutomaticTransferDailySchedule {
  cadence?: Maybe<Scalars["Int"]>;
}

export interface AutomaticTransferDepositsAccount {
  /** Encoded deposits account id */
  depositsAccountId: Scalars["ID"];
}

export interface AutomaticTransferFinancialAccount {
  /** Encoded external financial account id */
  financialAccountId: Scalars["ID"];
}

export interface AutomaticTransferMonthlySchedule {
  /** Day of the month to schedule transactions */
  dayOfMonth: Scalars["Int"];
}

export type AutomaticTransferSchedule =
  | AutomaticTransferDailySchedule
  | AutomaticTransferMonthlySchedule
  | AutomaticTransferWeeklySchedule;

/** Object defining automatic transfer settings */
export interface AutomaticTransferSettings extends Node {
  /** Either the threshold amount or exact transfer amount based on the automatic_transfer_type */
  amountUsdCents: Scalars["Int"];
  /** Type of automatic transfer configured by this setting */
  automaticTransferType: AutomaticTransferType;
  /** The ID of an object */
  id: Scalars["ID"];
  /** The minimum balance below which automatic transfers will be initiated */
  minimumBalanceThresholdUsdCents?: Maybe<Scalars["Int"]>;
  /** The timestamp when the next automatic transaction will be initiated */
  nextTransactionScheduledAt: Scalars["Time"];
  /** The cadence at which automatic transfers will be evaluated */
  schedule: AutomaticTransferSchedule;
  /** The account from which funds will be sent for the automatic transfer */
  sourceAccount: AutomaticTransferSourceAccount;
  /** The account to which funds will be sent for the automatic transfer */
  targetAccount: AutomaticTransferTargetAccount;
}

export interface AutomaticTransferSettingsConnection {
  edges?: Maybe<Array<Maybe<AutomaticTransferSettingsEdge>>>;
  pageInfo: PageInfo;
}

export interface AutomaticTransferSettingsEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<AutomaticTransferSettings>;
}

export type AutomaticTransferSourceAccount =
  | AutomaticTransferDepositsAccount
  | AutomaticTransferFinancialAccount;

export type AutomaticTransferTargetAccount = AutomaticTransferDepositsAccount;

export enum AutomaticTransferType {
  FIXED_AMOUNT = "FIXED_AMOUNT",
  INVALID = "INVALID",
  MAX_THRESHOLD = "MAX_THRESHOLD",
  MIN_THRESHOLD = "MIN_THRESHOLD",
}

export interface AutomaticTransferWeeklySchedule {
  /**
   * 1 = Every week on dayOfWeek
   * 2 = Every other week on dayOfWeek
   */
  cadence: Scalars["Int"];
  /** Day of the week to schedule transactions */
  dayOfWeek: BusinessDay;
}

export enum AutomationResolutionStatus {
  /** This suggestion or all suggestions in this suggestion group are in a terminal state. */
  RESOLVED = "RESOLVED",
  /** This suggestion or some suggestions in this suggestion group are not in a terminal state. */
  UNRESOLVED = "UNRESOLVED",
}

/**
 * A proposed change to update some aspect of the Customer's data or configurations.
 * A suggestion applies to a specific field of an entity on empower (ex. memo field of an Expense).
 */
export interface AutomationSuggestion {
  /** The suggestion's confidence score in the range [0, 1]. Reflects the confidence that this suggestion will be accepted. */
  confidenceScore?: Maybe<Scalars["Float"]>;
  /** [oneof] User edited suggestion data. null if there is no user edit. */
  editedData?: Maybe<AutomationSuggestionData>;
  id: Scalars["ID"];
  /** The suggestion's priority score. A higher priority score means that this suggestion is more important. */
  priorityScore?: Maybe<Scalars["Float"]>;
  /**
   * State data about how the suggestion was resolved.
   * REQUIRED if the current suggestion is in a terminal state (ex: you can't un-accept an accepted suggestion,
   * so ACCEPTED is a terminal state).
   */
  resolution?: Maybe<AutomationSuggestionResolution>;
  /** [oneof] Specific data about the suggestion which is unique to the Suggestion Type. */
  suggestionData: AutomationSuggestionData;
  /** Specific entity that the suggestion applies to. */
  suggestionEntity: AutomationSuggestionEntity;
  /** The suggestion's group. Not all suggestions are part of a group. */
  suggestionGroup?: Maybe<AutomationSuggestionGroup>;
  /** Current state of the Suggestion (suggested, accepted, declined). */
  suggestionStatus: AutomationSuggestionStatus;
  /** Specific type of suggestion (ex. memo suggestion). */
  suggestionType: AutomationSuggestionType;
}

export interface AutomationSuggestionAction {
  /** The action to apply to the suggestion. */
  actionType: AutomationSuggestionActionType;
  /**
   * When true  - Suggestions Service will wait 10s before applying the action, unless a CANCEL action is sent.
   * Suggestion will be moved into a tentatively applied state.
   * When false - Suggestion action will be confirmed with no delay for undo.
   *
   * Default true.
   */
  cancellable: Scalars["Boolean"];
  /** Edited accounting rule suggestion data. Only for use with accounting rule suggestions. */
  editedAccountingRuleData?: InputMaybe<AccountingRuleSuggestionDataInput>;
  /** Edited workflow rule suggestion data. Only for use with workflow rule suggestions. */
  editedWorkflowRuleData?: InputMaybe<WorkflowRuleSuggestionDataInput>;
  /** The idempotency key of this suggestion action. */
  idempotencyKey: Scalars["String"];
  /** The suggestion ID to which the action should be applied. */
  suggestionId: Scalars["ID"];
  /**
   * If true:  Suggestions Service will apply the suggestion action to the suggestion entity.
   * If false: Suggestion Service will NOT apply the action to the suggestion entity.
   * Either the caller or a downstream service is responsible for performing the actual update to the suggestion entity.
   *
   * For example, consider a Memo Suggestion.
   * - If action_type = ACCEPT and update_entity = true:
   * A suggestion action record will be created. The suggestion record will be marked as ACCEPTED.
   * The Suggestions Service will update the memo of the expense.
   * - If action_type = ACCEPT and update_entity = false:
   * A suggestion action record will be created. The suggestion record will be marked as ACCEPTED.
   * However, the Suggestions Service will not directly update the expense with the new memo. Instead, either the
   * caller/clientside must issue a separate request to update the expense, or a downstream service must consume the
   * SuggestionMutatedEvent and update the expense.
   *
   * Default false.
   */
  updateEntity: Scalars["Boolean"];
}

export enum AutomationSuggestionActionType {
  /** Suggestion was accepted by user. */
  ACCEPT = "ACCEPT",
  /**
   * Cancel the previous action and restore the Suggestion to SUGGESTED state.
   * Suggestion must be in a TENTATIVE state.
   */
  CANCEL_PREVIOUS_ACTION = "CANCEL_PREVIOUS_ACTION",
  /** Suggestion was declined by user. */
  DECLINE = "DECLINE",
  /** Dismiss the suggestion on behalf of the user. */
  DISMISS = "DISMISS",
}

export interface AutomationSuggestionConnection extends Connection {
  edges: Array<AutomationSuggestionEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export type AutomationSuggestionData =
  | AccountingRuleSuggestionInformation
  | AuditSuggestionInformation
  | BudgetSuggestionInformation
  | ExpenseCategorySuggestionInformation
  | FieldSuggestionInformation
  | ListAttendeesSuggestionInformation
  | MemoSuggestionInformation
  | TripSuggestionInformation
  | WorkflowRuleSuggestionInformation;

export interface AutomationSuggestionEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<AutomationSuggestion>;
}

export interface AutomationSuggestionEntity {
  /** ID of the specific entity that the suggestion applies to. */
  id: Scalars["ID"];
  /**
   * The actual GQL entity data which is resolved by another DGS.
   * Note this field will be null if we have not yet added support to resolve that entity type.
   */
  suggestionEntityData?: Maybe<AutomationSuggestionEntityData>;
  /**
   * Type of entity that the suggestion applies to.
   * There is an 1:N mapping between EntityTypes and SuggestionTypes
   */
  suggestionEntityType: AutomationSuggestionEntityType;
}

export type AutomationSuggestionEntityData = Expense;

export interface AutomationSuggestionEntityInput {
  /** IDs of the specific entities that the suggestion applies to. */
  suggestionEntityIds: Array<Scalars["ID"]>;
  /** Type of entity that the suggestion applies to. */
  suggestionEntityType: AutomationSuggestionEntityType;
}

export enum AutomationSuggestionEntityType {
  /** Suggestion applies to a metadata element of an Expense. */
  EXPENSE = "EXPENSE",
  /** Suggestion applies to an export attempt. */
  EXPORT_ATTEMPT = "EXPORT_ATTEMPT",
  /** Suggestion applies to a configured integration. */
  INTEGRATION = "INTEGRATION",
  /** Suggestion applies to an integration during FTUX. */
  INTEGRATION_FTUX = "INTEGRATION_FTUX",
}

export interface AutomationSuggestionGroup {
  /** All suggestions belonging to this group. Prefer `topSuggestions` to limit the number of results. */
  allSuggestions: Array<AutomationSuggestion>;
  id: Scalars["ID"];
  /** The mapping class associated with this suggestion group, if any. */
  mappingClass?: Maybe<MappingClass>;
  /** The suggestion group's priority score. A higher priority score means that this suggestion group is more important. */
  priorityScore?: Maybe<Scalars["Float"]>;
  /** This group's resolution status. */
  resolutionStatus: AutomationResolutionStatus;
  /** Specific entity that the suggestions in this group apply to. */
  suggestionEntity: AutomationSuggestionEntity;
  /** Specific type of suggestions in this group (ex. memo suggestion). */
  suggestionType: AutomationSuggestionType;
  /** The suggestion group's tags. */
  tags: Array<AutomationSuggestionGroupTag>;
  /** Top suggestions by confidence score belonging to this group. */
  topSuggestions: Array<AutomationSuggestion>;
}

export interface AutomationSuggestionGrouptopSuggestionsArgs {
  first: Scalars["Int"];
}

export interface AutomationSuggestionGroupConnection extends Connection {
  edges: Array<AutomationSuggestionGroupEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"];
}

export interface AutomationSuggestionGroupEdge {
  cursor?: Maybe<Scalars["String"]>;
  node: AutomationSuggestionGroup;
}

export enum AutomationSuggestionGroupResolution {
  /** Accept the top suggestion in each suggestion group. */
  ACCEPT_TOP_SUGGESTION = "ACCEPT_TOP_SUGGESTION",
  /** Decline the top suggestion in each suggestion group and dismiss the rest. */
  DECLINE_TOP_SUGGESTION_DISMISS_OTHERS = "DECLINE_TOP_SUGGESTION_DISMISS_OTHERS",
}

export interface AutomationSuggestionGroupTag {
  key: Scalars["String"];
  value: Scalars["String"];
}

export interface AutomationSuggestionGroupTagInput {
  key: Scalars["String"];
  /** A value to match for the given key. Only value OR values should be specified. */
  value?: InputMaybe<Scalars["String"]>;
  /** Values to match one of for the given key. Only value OR values should be specified. */
  values?: InputMaybe<Array<Scalars["String"]>>;
}

export interface AutomationSuggestionGroupsFilterInput {
  /** Match IN specific resolution statuses, default to [UNRESOLVED] when no filter is provided. */
  resolutionStatuses?: InputMaybe<Array<AutomationResolutionStatus>>;
  /** Match IN specific suggestion entities, match ALL when no filter is provided */
  suggestionEntities?: InputMaybe<Array<AutomationSuggestionEntityInput>>;
  /** Match IN specific suggestion group IDs, match ALL groups when no filter is provided. */
  suggestionGroupIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Match IN specific suggestion types, match ALL when no filter is provided */
  suggestionTypes?: InputMaybe<Array<AutomationSuggestionType>>;
  /** Match suggestion groups with ALL of the given tags, match ALL groups when no filter is provided. */
  tags?: InputMaybe<Array<AutomationSuggestionGroupTagInput>>;
}

export interface AutomationSuggestionGroupsSortInput {
  order: OrderByDirection;
  sortKey: AutomationSuggestionGroupsSortKey;
}

export enum AutomationSuggestionGroupsSortKey {
  /** Sorts by ID */
  ID = "ID",
  /** Sorts by priority score */
  PRIORITY_SCORE = "PRIORITY_SCORE",
}

export interface AutomationSuggestionResolution {
  /** Time at which the suggestion was resolved. */
  resolvedAt: Scalars["LocalDateTime"];
  /** Information specific to who resolved the suggestion */
  resolvedBy: AutomationSuggestionResolvedBy;
}

export type AutomationSuggestionResolvedBy =
  | AutomationSuggestionResolvedBySystem
  | AutomationSuggestionResolvedByUser;

export interface AutomationSuggestionResolvedBySystem {
  /** Service identifier of the service that resolved the suggestion. */
  systemId: Scalars["String"];
}

export interface AutomationSuggestionResolvedByUser {
  /** Customer user ID of the user who resolved the suggestion. */
  userId: Scalars["ID"];
}

export enum AutomationSuggestionStatus {
  /** Suggestion was accepted by the user and has been applied. This is a terminal state. */
  ACCEPTED = "ACCEPTED",
  /** Suggestion was not accepted and has been ignored. This is a terminal state. */
  DECLINED = "DECLINED",
  /** Suggestion was dismissed on behalf of the user by Brex. This is a terminal state. */
  DISMISSED = "DISMISSED",
  /** Initial state before any decisions have been made about the suggestion. */
  SUGGESTED = "SUGGESTED",
  /** Suggestion is in a tentatively accepted state (which can be cancelled/transitioned to SUGGESTED). */
  TENTATIVELY_ACCEPTED = "TENTATIVELY_ACCEPTED",
  /** Suggestion is in a tentatively declined state (which can be cancelled/transitioned to SUGGESTED). */
  TENTATIVELY_DECLINED = "TENTATIVELY_DECLINED",
}

export enum AutomationSuggestionType {
  /** An accounting rule that can be created */
  ACCOUNTING_RULE = "ACCOUNTING_RULE",
  /** A suggested action for audit */
  AUDIT = "AUDIT",
  /** A budget that can be assigned */
  BUDGET = "BUDGET",
  /** Expense category can be assigned to */
  EXPENSE_CATEGORY = "EXPENSE_CATEGORY",
  /** An extended option field */
  EXTENDED_FIELD_OPTION = "EXTENDED_FIELD_OPTION",
  /** Attendees can be added */
  LIST_ATTENDEES = "LIST_ATTENDEES",
  /** A potential memo that can be applied */
  MEMO = "MEMO",
  /** A suggested trip that an expense could be part of */
  TRIP = "TRIP",
  /** A new or updated workflow rule */
  WORKFLOW_RULE = "WORKFLOW_RULE",
}

export interface AutomationSuggestionsExpenseFilterInput {
  statuses?: InputMaybe<Array<AutomationSuggestionStatus>>;
  types?: InputMaybe<Array<AutomationSuggestionType>>;
}

export interface AutomationSuggestionsFilterInput {
  /** Match IN specific customer users ids, match ALL when no filter is provided */
  customerUserIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Match IN specific suggestion entities, match ALL when no filter is provided */
  suggestionEntities?: InputMaybe<Array<AutomationSuggestionEntityInput>>;
  /** Match IN specific suggestion ids, match ALL when no filter is provided */
  suggestionIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Match IN specific suggestion statuses, match ALL when no filter is provided */
  suggestionStatuses?: InputMaybe<Array<AutomationSuggestionStatus>>;
  /** Match IN specific suggestion types, match ALL when no filter is provided */
  suggestionTypes?: InputMaybe<Array<AutomationSuggestionType>>;
}

export interface AutomationSuggestionsOptionFieldInstanceWhereInput {
  /** Match IN specific suggestion statuses, match ALL when no filter is provided */
  statuses?: InputMaybe<Array<AutomationSuggestionStatus>>;
}

export interface AutomationWorkflowAccountingExportBlock
  extends IWorkflowBlock {
  key: Scalars["String"];
  nextKey?: Maybe<Scalars["String"]>;
}

export interface AutomationWorkflowAccountingExportBlockInput {
  key: Scalars["String"];
  nextKey?: InputMaybe<Scalars["String"]>;
}

export interface AutomationWorkflowAccountingPrepareBlock
  extends IWorkflowBlock {
  key: Scalars["String"];
  nextKey?: Maybe<Scalars["String"]>;
}

export interface AutomationWorkflowAccountingPrepareBlockInput {
  key: Scalars["String"];
  nextKey?: InputMaybe<Scalars["String"]>;
}

export interface AutomationWorkflowAction extends Node {
  automationWorkflowSpec?: Maybe<AutomationWorkflowSpec>;
  descriptor?: Maybe<WorkflowActionDescriptor>;
  id: Scalars["ID"];
  scheduledAt?: Maybe<Scalars["Time"]>;
  startedAt: Scalars["Time"];
}

export interface AutomationWorkflowActionConnection {
  edges: Array<AutomationWorkflowActionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"];
}

export interface AutomationWorkflowActionEdge {
  cursor: Scalars["String"];
  node: AutomationWorkflowAction;
}

export type AutomationWorkflowBlock =
  | AutomationWorkflowAccountingExportBlock
  | AutomationWorkflowAccountingPrepareBlock
  | WorkflowBooleanMatchCondition
  | WorkflowDurationMatchCondition
  | WorkflowEnumeratedListMatchCondition
  | WorkflowEnumeratedMatchCondition
  | WorkflowFinancialAssetMatchCondition
  | WorkflowIdentifierMatchCondition
  | WorkflowLocationMatchCondition
  | WorkflowLogicOperatorConditionBlock
  | WorkflowNumberMatchCondition
  | WorkflowStringMatchCondition;

export interface AutomationWorkflowBlockOneOfInput {
  accountingExportActionBlock?: InputMaybe<AutomationWorkflowAccountingExportBlockInput>;
  accountingPrepareActionBlock?: InputMaybe<AutomationWorkflowAccountingPrepareBlockInput>;
  booleanMatchCondition?: InputMaybe<WorkflowBooleanMatchConditionInput>;
  durationMatchCondition?: InputMaybe<WorkflowDurationMatchConditionInput>;
  enumeratedListMatchCondition?: InputMaybe<WorkflowEnumeratedListMatchConditionInput>;
  enumeratedMatchCondition?: InputMaybe<WorkflowEnumeratedMatchConditionInput>;
  financialAssetMatchCondition?: InputMaybe<WorkflowFinancialAssetMatchConditionInput>;
  identifierMatchCondition?: InputMaybe<WorkflowIdentifierMatchConditionInput>;
  locationMatchCondition?: InputMaybe<WorkflowLocationMatchConditionInput>;
  logicalOperatorConditionBlock?: InputMaybe<WorkflowLogicOperatorConditionBlockInput>;
  stringMatchCondition?: InputMaybe<WorkflowStringMatchConditionInput>;
}

export type AutomationWorkflowCadence =
  | AutomationWorkflowDaily
  | AutomationWorkflowHourly
  | AutomationWorkflowMonthly
  | AutomationWorkflowWeekly;

export interface AutomationWorkflowCadenceOneOfInput {
  daily?: InputMaybe<AutomationWorkflowDailyInput>;
  hourly?: InputMaybe<AutomationWorkflowHourlyInput>;
  monthly?: InputMaybe<AutomationWorkflowMonthlyInput>;
  weekly?: InputMaybe<AutomationWorkflowWeeklyInput>;
}

export interface AutomationWorkflowDaily {
  time: AutomationWorkflowTimeAndTimezone;
}

export interface AutomationWorkflowDailyInput {
  time: AutomationWorkflowTimeAndTimezoneInput;
}

export interface AutomationWorkflowHourly {
  hoursBetween: Scalars["Int"];
  timezoneName: Scalars["String"];
}

export interface AutomationWorkflowHourlyInput {
  hoursBetween: Scalars["Int"];
  timezoneName: Scalars["String"];
}

export interface AutomationWorkflowMonthly {
  dayOfMonth: Scalars["Int"];
  time: AutomationWorkflowTimeAndTimezone;
}

export interface AutomationWorkflowMonthlyInput {
  dayOfMonth: Scalars["Int"];
  time: AutomationWorkflowTimeAndTimezoneInput;
}

export interface AutomationWorkflowSpec extends Node {
  allSteps?: Maybe<Array<AutomationWorkflowStep>>;
  cadence?: Maybe<AutomationWorkflowCadence>;
  id: Scalars["ID"];
  name: Scalars["String"];
  status: AutomationWorkflowSpecStatus;
  updatedAt: Scalars["Time"];
  /** The user that updated this workflow spec. If null, you can assume this spec was updated by Brex. */
  updatedByUser?: Maybe<User>;
  workflowEntity: WorkflowEntity;
}

export interface AutomationWorkflowSpecConnection {
  edges: Array<AutomationWorkflowSpecEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"];
}

export interface AutomationWorkflowSpecEdge {
  cursor: Scalars["String"];
  node: AutomationWorkflowSpec;
}

export enum AutomationWorkflowSpecStatus {
  ACTIVE = "ACTIVE",
  DELETED = "DELETED",
  PAUSED = "PAUSED",
}

export interface AutomationWorkflowStep {
  allBlocks?: Maybe<Array<AutomationWorkflowBlock>>;
}

export interface AutomationWorkflowStepInput {
  blocks: Array<AutomationWorkflowBlockOneOfInput>;
}

export interface AutomationWorkflowTimeAndTimezone {
  hour: Scalars["Int"];
  minutes: Scalars["Int"];
  timezoneName: Scalars["String"];
}

export interface AutomationWorkflowTimeAndTimezoneInput {
  hour: Scalars["Int"];
  minutes: Scalars["Int"];
  timezoneName: Scalars["String"];
}

export interface AutomationWorkflowWeekly {
  dayOfWeek: DayOfWeek;
  time: AutomationWorkflowTimeAndTimezone;
}

export interface AutomationWorkflowWeeklyInput {
  dayOfWeek: DayOfWeek;
  time: AutomationWorkflowTimeAndTimezoneInput;
}

export type AutopayDetails = NextExpectedPaymentInfo;

/** Represents an autopay funding source for a given entity and product type */
export interface AutopayFundingSource {
  /** Funding Source */
  fundingSource?: Maybe<FundingSource>;
  /** Funding Source Product type configured for autopay */
  productType: FundingSourceProductType;
}

export interface AutopayFundingSourceConnection extends Connection {
  /** The autopay funding sources in the current page of results. */
  edges: Array<AutopayFundingSourceEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of autopay funding sources matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface AutopayFundingSourceEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The autopay funding source at this edge. */
  node?: Maybe<AutopayFundingSource>;
}

export interface AutopayOverview {
  autopayDetails?: Maybe<AutopayDetails>;
  isAutopayEnabled: Scalars["Boolean"];
  /** Currently hiding auto pay status for multi entity */
  shouldDisplayAutopayStatus: Scalars["Boolean"];
}

export type AuxiliaryMetadata = MileageAuxiliaryMetadata;

export interface AvailableLimitConnection extends Connection {
  /** The limits in the current page of results. */
  edges: Array<AvailableLimitEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of limits (spend limit and user limit) matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface AvailableLimitEdge {
  /**
   * Proactive expense indicators that indicate why a expense cannot be assigned to budget on the current edge
   * null if no error occurs during budget expense assignment
   */
  assignmentFailureError?: Maybe<LimitAssignmentFailureError>;
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The display limit at this edge. */
  node: DisplayLimit;
}

export interface AvailableLimitsInput {
  /**
   * If this is true, we will dry run authorization checks for the expense against the limits, and return any assignment failure errors if they occur.
   * NOTE: This should only be used when querying for a single expense e.g. lazy loading the spend limit selector, and not for batch loading expenses as it has known performance constraints,
   * and we'll currently throw an UNIMPLEMENTED error if more than one expense is being queried.
   */
  includeAuthorizations?: InputMaybe<Scalars["Boolean"]>;
  /** Filters the results to match the desired search term. */
  searchText?: InputMaybe<Scalars["String"]>;
}

export interface AvailableSpendLimitConnection extends Connection {
  /** The spend limits in the current page of results. */
  edges: Array<AvailableSpendLimitEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of spend limits matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface AvailableSpendLimitEdge {
  /**
   * Proactive expense indicators that indicate why a expense cannot be assigned to budget on the current edge
   * null if no error occurs during budget expense assignment
   */
  assignmentFailureError?: Maybe<SpendLimitAssignmentFailureError>;
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The spend limit at this edge. */
  node: SpendLimit;
}

export interface AvailableSpendLimitsInput {
  /**
   * If this is true, we will dry run authorization checks for the expense against the spend limits, and return any assignment failure errors if they occur.
   * NOTE: This should only be used when querying for a single expense e.g. lazy loading the spend limit selector, and not for batch loading expenses as it has known performance constraints,
   * and we'll currently throw an UNIMPLEMENTED error if more than one expense is being queried.
   */
  includeAuthorizations?: InputMaybe<Scalars["Boolean"]>;
  /** Filters the results to match the desired search term. */
  searchText?: InputMaybe<Scalars["String"]>;
}

export interface AverageMonthlySpendResponse {
  value?: Maybe<FinancialAsset>;
}

/** TODO: Replace with KYCIndividual */
export interface BORefreshIndividual {
  /** Address of the individual */
  address: KYCAddressInput;
  /** Country of citizenship of the individual */
  countryOfCitizenship?: InputMaybe<Scalars["String"]>;
  /** Date of birth of the individual */
  dob?: InputMaybe<Scalars["Date"]>;
  /** Full name of the individual */
  fullName: FullNameInput;
  /** Document details of the individual */
  individualDocument?: InputMaybe<IndividualDocumentInput>;
  /** Ownership percentage of the individual */
  ownershipPercentage?: InputMaybe<Scalars["Int"]>;
  /** Phone number of the individual */
  phoneNumber: Scalars["String"];
  /** List of roles associated with the individual */
  roles: Array<ObjectNodeType>;
  /** Title of the individual */
  title: IndividualTitle;
}

export interface BORefreshIndividualPrefill {
  /** Address of the individual */
  address?: Maybe<KYCAddress>;
  /** Full name of the individual */
  fullName: FullName;
  /** Ownership percentage of the individual */
  ownershipPercentage?: Maybe<Scalars["Int"]>;
  /** Phone number of the individual */
  phoneNumber?: Maybe<Scalars["String"]>;
  /** List of roles associated with the individual */
  roles: Array<ObjectNodeType>;
  /** Whether ID should be collected for the individual */
  shouldCollectId?: Maybe<Scalars["Boolean"]>;
  /** Title of the individual */
  title?: Maybe<IndividualTitle>;
}

export interface BORefreshRequestConfig {
  individuals: Array<BORefreshIndividualPrefill>;
}

export interface BORefreshSubmissionPayloadInput {
  individuals: Array<BORefreshIndividual>;
}

export interface BRDLocalPayloadInput {
  cpfNumber?: InputMaybe<Scalars["String"]>;
  legalRepLocalIdBack?: InputMaybe<Scalars["String"]>;
  legalRepLocalIdFront?: InputMaybe<Scalars["String"]>;
  legalRepSelfie?: InputMaybe<Scalars["String"]>;
}

export interface BackupWithholdingSubmissionPayloadInput {
  subjectToBackupWithholding: Scalars["Boolean"];
  submitted: Scalars["Boolean"];
  w9SignedDate: Scalars["Date"];
}

export interface BalanceBreakdown {
  /** The unsigned sum of all transactions. Transactions that add money to the Cash account are included only if they have been fully processed (transaction has hit the bank). Transactions that remove money from the Cash account are removed once the transaction is started. */
  availableBalance: Scalars["Int"];
  /** Unsigned sum of transactions that haven't finished processing (both for incoming and outgoing transactions). */
  processingBalance: Scalars["Int"];
  /** Unsigned sum of incoming transactions that haven't finished processing. */
  processingBalanceIn: Scalars["Int"];
  /** Unsigned sum of outgoing transactions that haven't finished processing. */
  processingBalanceOut: Scalars["Int"];
  /** Card transactions for the day that accumulate until it's processed from the Cash account at the end of the day. */
  sameDayCardBalance: Scalars["Int"];
  /** Unsigned sum of transactions that are scheduled for the future (both for incoming and outgoing transactions). */
  scheduledFundsAmount: Scalars["Int"];
}

export enum BalancePolarity {
  BALANCE_POLARITY_CREDIT = "BALANCE_POLARITY_CREDIT",
  BALANCE_POLARITY_DEBIT = "BALANCE_POLARITY_DEBIT",
  BALANCE_POLARITY_INVALID = "BALANCE_POLARITY_INVALID",
}

export enum BalanceSufficiencyLevel {
  /** Insufficient. */
  INSUFFICIENT = "INSUFFICIENT",
  /** Sufficient. */
  SUFFICIENT = "SUFFICIENT",
  /** Unknown. */
  UNKNOWN = "UNKNOWN",
}

export interface BalanceWithTimestamp {
  asOfDatetime: Scalars["Time"];
  value?: Maybe<FinancialAsset>;
}

export enum BankAccountClass {
  BUSINESS = "BUSINESS",
  PERSONAL = "PERSONAL",
}

export enum BankAccountClassType {
  BUSINESS = "BUSINESS",
  PERSONAL = "PERSONAL",
}

/** Represents the class of the account owner. */
export enum BankAccountCls {
  /** Represents an account belonging to an individual (CCD) */
  BUSINESS = "BUSINESS",
  /** Invalid enum value */
  INVALID = "INVALID",
  /** Represents an account belonging to a business (PPD) */
  PERSONAL = "PERSONAL",
}

export type BankAccountInfo =
  | AuLocal
  | BrLocal
  | CaLocal
  | HuLocal
  | Iban
  | InLocal
  | JpLocal
  | MxLocal
  | NzLocal
  | PhLocal
  | PlLocal
  | SgLocal
  | UkLocal
  | UsAba
  | ZaSwift;

export interface BankAccountInfoInput {
  auLocal?: InputMaybe<AuLocalInput>;
  brLocal?: InputMaybe<BrLocalInput>;
  caLocal?: InputMaybe<CaLocalInput>;
  huLocal?: InputMaybe<HuLocalInput>;
  iban?: InputMaybe<IbanInput>;
  inLocal?: InputMaybe<InLocalInput>;
  jpLocal?: InputMaybe<JpLocalInput>;
  mxLocal?: InputMaybe<MxLocalInput>;
  nzLocal?: InputMaybe<NzLocalInput>;
  phLocal?: InputMaybe<PhLocalInput>;
  plLocal?: InputMaybe<PlLocalInput>;
  sgLocal?: InputMaybe<SgLocalInput>;
  ukLocal?: InputMaybe<UkLocalInput>;
  usAba?: InputMaybe<UsAbaInput>;
  zaSwift?: InputMaybe<ZaSwiftInput>;
}

export interface BankAccountSourceInput {
  accountName: Scalars["String"];
  accountNumber: Scalars["String"];
  accountType: Scalars["String"];
  bankName?: InputMaybe<Scalars["String"]>;
  ownershipVerified?: InputMaybe<Scalars["Boolean"]>;
  routingNumber: Scalars["String"];
}

export enum BankAccountType {
  CHECKING = "CHECKING",
  SAVINGS = "SAVINGS",
}

export interface BankAccountUnderwritingData {
  accountNumber?: Maybe<Scalars["String"]>;
  amount?: Maybe<FinancialAsset>;
  financialAccountId: Scalars["String"];
  percentageContributionToOverallStaleness?: Maybe<Scalars["Float"]>;
  staleDays?: Maybe<Scalars["Int"]>;
}

/** Response that includes the  */
export interface BankAccountsAnomalySignals {
  /** SVB connection that has observed significant cash balance drop */
  anomalyOutflowsConnection?: Maybe<FinancialSource>;
  /** financial_source_id of the SVB connection that has observed significant cash balance drop */
  anomalyOutflowsConnectionSourceId?: Maybe<Scalars["String"]>;
}

export interface BankConnectionGenerateUrlError extends MutationError {
  errors?: Maybe<Array<BankConnectionGenerateUrlErrors>>;
}

export interface BankConnectionGenerateUrlErrors extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface BankConnectionGenerateUrlInput {
  intent: BankConnectionIntent;
  redirectUri?: InputMaybe<Scalars["String"]>;
  vendor: FinancialsVendor;
}

export type BankConnectionGenerateUrlResult =
  | BankConnectionGenerateUrlError
  | BankConnectionUrl;

export enum BankConnectionIntent {
  BBA_INVOICING = "BBA_INVOICING",
}

export interface BankConnectionUrl {
  url?: Maybe<Scalars["String"]>;
}

export interface BankStatementRequiredItemMetadata {
  financialAccount: FinancialAccount;
}

export interface BankingAccount {
  balance?: Maybe<BankingAccountBalance>;
  cashflow?: Maybe<BankingAccountCashflow>;
  displayName?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
  priority?: Maybe<BankingAccountPriority>;
  status?: Maybe<BankingAccountStatus>;
}

export interface BankingAccountcashflowArgs {
  endTime: Scalars["Time"];
  startTime: Scalars["Time"];
}

export interface BankingAccountBalance {
  available?: Maybe<FinancialAsset>;
  processingIn?: Maybe<FinancialAsset>;
  processingOut?: Maybe<FinancialAsset>;
  scheduled?: Maybe<FinancialAsset>;
  total?: Maybe<FinancialAsset>;
}

export interface BankingAccountBalancesFilters {
  accountTypes?: InputMaybe<Array<BankingAccountType>>;
  statuses?: InputMaybe<Array<BankingAccountStatus>>;
}

export interface BankingAccountCashflow {
  inflows?: Maybe<FinancialAsset>;
  outflows?: Maybe<FinancialAsset>;
}

export interface BankingAccountConnection {
  balance?: Maybe<BankingAccountBalance>;
  edges?: Maybe<Array<BankingAccountEdge>>;
  pageInfo?: Maybe<PageInfo>;
}

export interface BankingAccountDailyBalanceSnapshotsInput {
  depositsAccountIds?: InputMaybe<Array<Scalars["ID"]>>;
  endDate: Scalars["Date"];
  startDate: Scalars["Date"];
}

export interface BankingAccountDailyBalanceSnapshotsResponse {
  dailyBalanceSnapshots: Array<DailyBalanceSnapshot>;
}

export interface BankingAccountEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<BankingAccount>;
}

export interface BankingAccountOrder {
  direction?: InputMaybe<OrderDirection>;
  field?: InputMaybe<BankingAccountOrderField>;
}

export enum BankingAccountOrderField {
  DISPLAY_ORDER = "DISPLAY_ORDER",
}

export enum BankingAccountPriority {
  NON_PRIMARY = "NON_PRIMARY",
  PRIMARY = "PRIMARY",
}

export enum BankingAccountStatus {
  ACTIVE = "ACTIVE",
  CLOSED = "CLOSED",
  SUSPENDED = "SUSPENDED",
}

export enum BankingAccountType {
  CHECKING = "CHECKING",
  TREASURY = "TREASURY",
  VAULT = "VAULT",
}

export interface BankingAccountWhereInput {
  priorities?: InputMaybe<Array<BankingAccountPriority>>;
  statuses?: InputMaybe<Array<BankingAccountStatus>>;
  types?: InputMaybe<Array<BankingAccountType>>;
}

/** For representing a Counterparty object in BankingCounterparty domain. */
export interface BankingCounterparty extends Node {
  /** Address of account holder */
  accountHolderAddress?: Maybe<CounterpartyAddress>;
  /** Account holder name of this counterparty */
  accountHolderName: Scalars["String"];
  /** Account reference that is for display only, not an ID */
  accountReference?: Maybe<Scalars["String"]>;
  /** Bank account class of this counterparty */
  bankAccountClass: BankAccountClass;
  /** Address of the bank */
  bankAddress?: Maybe<CounterpartyAddress>;
  /** Name of the bank */
  bankName?: Maybe<Scalars["String"]>;
  /** Optional. Valid when rail is global bank transfer */
  globalTransferPaymentMethod?: Maybe<GlobalTransferPaymentMethod>;
  /** The ID of an object */
  id: Scalars["ID"];
  /** Insertion timestamp */
  insertedAt: Scalars["Time"];
  /** Invalidation timestamp */
  invalidatedAt?: Maybe<Scalars["Time"]>;
  /** Key-value pairs that describe the counterparty */
  properties?: Maybe<Scalars["Json"]>;
  /** Rail of this Counterparty */
  rail: BankingGatewayRail;
  /** Rail requirement identifier */
  railRequirementId: Scalars["ID"];
  /** Current status */
  status: CounterpartyStatus;
  /** Target country */
  targetCountry: Scalars["String"];
  /** Target currency */
  targetCurrency: Scalars["String"];
  /** Trusted beneficiaries for this counterparty */
  trustedBeneficiaries?: Maybe<Array<Maybe<CounterpartyTrustedBeneficiary>>>;
}

/** Input for :banking_counterparty */
export interface BankingCounterpartyInput {
  /** Json blob that contains all required data for creating a banking counterparty */
  properties?: InputMaybe<Scalars["Json"]>;
  /** Rail requirement identifier. For more detail, see node object :rail_requirement */
  railRequirementId: Scalars["ID"];
}

export interface BankingCounterpartyPaymentInstrument {
  counterparty?: Maybe<BankingCounterparty>;
}

export interface BankingCounterpartyPaymentInstrumentInput {
  counterparty: BankingCounterpartyInput;
  idempotencyKey: Scalars["String"];
}

export interface BankingDailyAccountsSnapshotsInput {
  endDate: Scalars["Date"];
  startDate: Scalars["Date"];
}

export interface BankingDailyAccountsSnapshotsResponse {
  depositsAccountsDailySnapshots: Array<DepositsAccountDailySnapshots>;
}

/** The source of funds was a banking gateway account */
export interface BankingGatewayAccount {
  /** A placeholder always true field to make the object queryable */
  bankingGatewayAccount?: Maybe<Scalars["Boolean"]>;
}

/** Describes the Rail that's used/desired in a transfer. */
export enum BankingGatewayRail {
  /**
   * Fintech-powered international transfers via local payment methods, offered by Wise, Airwallex and others.
   * This pseudo rail does not include international swift wire, only local transfers via FX conversions.
   */
  GLOBAL_BANK_TRANSFER = "GLOBAL_BANK_TRANSFER",
  /** Internal book transfer within Brex. */
  INTERNAL_TRANSFER = "INTERNAL_TRANSFER",
  /** Invalid enum value */
  INVALID = "INVALID",
  /** Manual execution by Ops */
  MANUAL = "MANUAL",
  /** SWIFT international Wire */
  SWIFT_WIRE = "SWIFT_WIRE",
  /** Trading transfer, used for MMF trading. */
  TRADING = "TRADING",
  /** As an input, signals banking_gateway that it should decide on the best approach/s. */
  UNSPECIFIED = "UNSPECIFIED",
  /** US ACH. */
  US_ACH = "US_ACH",
  /** US Cheque for withdrawal, externally originated incoming debit */
  US_CHEQUE = "US_CHEQUE",
  /** US Cheque for deposit, Brex originated outgoing debit */
  US_CHEQUE_DEPOSIT = "US_CHEQUE_DEPOSIT",
  /** US Wire. */
  US_WIRE = "US_WIRE",
}

export interface BankingHolidays {
  bankingHolidays: Array<Scalars["Date"]>;
}

export interface BankingInboxTaskEntityDetails extends InboxTaskEntityDetails {
  cashTransaction?: Maybe<CashTransaction>;
  /** Base64 encoded transaction ID. */
  encodedEntityId: Scalars["String"];
  /** The transaction ID. */
  entityId: Scalars["String"];
}

export interface BankingInvoice {
  /** The invoice contact */
  contact?: Maybe<BankingInvoiceContact>;
  /** The created timestamp */
  createdAt: Scalars["Time"];
  /** The customer account ID */
  customerAccountId: Scalars["String"];
  /** The deposits account */
  depositsAccount?: Maybe<DepositsAccount>;
  /** The due date */
  dueDate?: Maybe<Scalars["Date"]>;
  /** The banking invoice ID */
  id: Scalars["ID"];
  /** Invoice date. base_created_at for regular invoice; scheduled_date for recurring invoice. */
  invoiceDate?: Maybe<Scalars["Time"]>;
  /** The invoice number */
  number: Scalars["String"];
  /** The Filestore asset ID for generating the invoice PDF */
  pdfAssetId?: Maybe<Scalars["String"]>;
  /** The associated recurring schedule id. Null if not a recurring invoice. */
  recurringScheduleId?: Maybe<Scalars["String"]>;
  /** Scheduled date for invoice. Null if not a recurring invoice. */
  scheduledDate?: Maybe<Scalars["Date"]>;
  /** The time when an invoice was sent, or is scheduled to be sent. */
  sendTime?: Maybe<Scalars["Time"]>;
  /** The invoice status */
  status?: Maybe<BankingInvoiceStatus>;
  /** The invoice total amount */
  total?: Maybe<FinancialAsset>;
  /** The associated transaction id */
  transactionId?: Maybe<Scalars["String"]>;
}

export interface BankingInvoiceContact {
  /** The invoice contact email */
  email?: Maybe<Scalars["String"]>;
  /** The invoice contact ID */
  id: Scalars["ID"];
  /** The invoice contact name */
  name?: Maybe<Scalars["String"]>;
  /** The invoice contact type */
  type: BankingInvoiceContactType;
}

export enum BankingInvoiceContactType {
  INVOICER = "INVOICER",
  PAYER = "PAYER",
}

/** The available fields that are queryable that relate to banking invoices */
export enum BankingInvoiceEntityFieldKeyType {
  ALL = "ALL",
  CREATED_AT = "CREATED_AT",
  DEPOSITS_ACCOUNT_ID = "DEPOSITS_ACCOUNT_ID",
  DUE_DATE = "DUE_DATE",
  INVOICE_DATE = "INVOICE_DATE",
  STATUS = "STATUS",
  TOTAL_AMOUNT = "TOTAL_AMOUNT",
}

/** Filters for the banking invoice entity. */
export interface BankingInvoiceEntityFieldMatcherInput {
  createdTimeBetween?: InputMaybe<TimeIntervalInput>;
  depositAccountIds?: InputMaybe<Array<Scalars["ID"]>>;
  dueDateTimeBetween?: InputMaybe<TimeIntervalInput>;
  invoiceDateBetween?: InputMaybe<TimeIntervalInput>;
  searchQuery?: InputMaybe<Scalars["String"]>;
  sendTimeBetween?: InputMaybe<TimeIntervalInput>;
  status?: InputMaybe<Array<BankingInvoiceStatus>>;
  totalAmountBetween?: InputMaybe<IntegerIntervalInput>;
}

export interface BankingInvoiceFieldKeyTypeWrapper {
  key: BankingInvoiceEntityFieldKeyType;
}

export enum BankingInvoiceStatus {
  AWAITING_PAYMENT = "AWAITING_PAYMENT",
  DELETED = "DELETED",
  DRAFT = "DRAFT",
  OTHER = "OTHER",
  OVERDUE = "OVERDUE",
  PAID = "PAID",
  PARTIALLY_PAID = "PARTIALLY_PAID",
  PAYMENT_SCHEDULED = "PAYMENT_SCHEDULED",
  SCHEDULED = "SCHEDULED",
  VOIDED = "VOIDED",
}

export interface BankingPoliciesFilterInput {
  policyType: BankingPolicyType;
  statusFilter: StatusFilterInput;
}

export interface BankingPolicy {
  author?: Maybe<Employee>;
  customerAccountId: Scalars["String"];
  deletedAt?: Maybe<Scalars["LocalDateTime"]>;
  /** Specific details per policy type */
  details: BankingPolicyDetails;
  enrollment?: Maybe<PolicyEnrollmentStatus>;
  isAuthoredByUser?: Maybe<Scalars["Boolean"]>;
  isDefaultPolicy?: Maybe<Scalars["Boolean"]>;
  policyId?: Maybe<Scalars["ID"]>;
  policyType: BankingPolicyType;
  reviewStatus?: Maybe<PolicyReviewStatus>;
  reviewedAt?: Maybe<Scalars["LocalDateTime"]>;
  reviewerId?: Maybe<Scalars["String"]>;
}

export type BankingPolicyDetails = BankingTransactionPolicyDetails;

export enum BankingPolicyType {
  BANKING_TRANSACTION = "BANKING_TRANSACTION",
}

export interface BankingStatement {
  depositsAccount: DepositsAccount;
  id: Scalars["ID"];
  name: Scalars["String"];
  periodEndTime: Scalars["Time"];
  periodStartTime: Scalars["Time"];
}

export interface BankingStatementConnection extends Connection {
  edges: Array<BankingStatementEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"];
}

export interface BankingStatementEdge {
  cursor?: Maybe<Scalars["String"]>;
  node: BankingStatement;
}

export interface BankingTaxStatement {
  downloadUrl: Scalars["String"];
  taxStatementType: TaxStatementType;
  taxYear: Scalars["Int"];
}

export interface BankingTaxStatementsResponse {
  taxStatements: Array<BankingTaxStatement>;
}

export interface BankingTransaction {
  /** ACH Identification Number */
  achIdentificationNumber?: Maybe<Scalars["String"]>;
  /** The amount of the transaction in USD cents */
  amountUSDCents: Scalars["Long"];
  /** The time the transaction was approved */
  approvedAt?: Maybe<Scalars["LocalDateTime"]>;
  /** Why the transaction failed */
  cancellationReason?: Maybe<BankingTransactionCancellationReason>;
  /** The counterparty financial account */
  counterpartyFinancialAccount?: Maybe<FinancialAccount>;
  /** The counterparty payee contact id */
  counterpartyPayeeContactId?: Maybe<Scalars["String"]>;
  /** The counterparty payee contact version */
  counterpartyPayeeContactVersion?: Maybe<Scalars["String"]>;
  /** The counterparty payee payment instrument id */
  counterpartyPayeePaymentInstrumentId?: Maybe<Scalars["Int"]>;
  /** The counterparty payee payment instrument version */
  counterpartyPayeePaymentInstrumentVersion?: Maybe<Scalars["Long"]>;
  /** The customer account ID */
  customerAccountId: Scalars["ID"];
  /** Customer inputted memo */
  customerMemo?: Maybe<Scalars["String"]>;
  /**
   * The timestamp shown to the customer. The actual time field this derives from (e.g. failedAt, processedAt) depends
   * on the status of the transaction
   */
  customerTimestamp?: Maybe<Scalars["LocalDateTime"]>;
  /** The deposits account */
  depositsAccount: DepositsAccount;
  /**
   * The deposits account ID.
   * @deprecated Use depositsAccount.id instead
   */
  depositsAccountId: Scalars["ID"];
  /** Customer inputted display name */
  displayName?: Maybe<Scalars["String"]>;
  /** External memo attached to the transaction */
  externalMemo?: Maybe<Scalars["String"]>;
  /** The time the transaction failed */
  failedAt?: Maybe<Scalars["LocalDateTime"]>;
  /** FX Quote */
  fxQuote?: Maybe<PaymentFxQuote>;
  /** The banking transaction ID */
  id: Scalars["ID"];
  /** When the transaction entered PROCESSING status */
  initiatedAt?: Maybe<Scalars["LocalDateTime"]>;
  /** The user that initiated the transaction */
  initiatedByCustomerUser?: Maybe<User>;
  /** For an intra-account book transfer, the source deposits account */
  intraAccountBookTransferSourceDepositsAccount?: Maybe<DepositsAccount>;
  /** For an intra-account book transfer, the target deposits account */
  intraAccountBookTransferTargetDepositsAccount?: Maybe<DepositsAccount>;
  /** When the transaction was processed and impacted the customer balance */
  processedAt?: Maybe<Scalars["LocalDateTime"]>;
  /** The time the transaction was created */
  scheduledAt?: Maybe<Scalars["LocalDateTime"]>;
  /** The time the transaction was scheduled for */
  scheduledSendAt?: Maybe<Scalars["LocalDateTime"]>;
  /** The time the transaction was settled */
  settledAt?: Maybe<Scalars["LocalDateTime"]>;
  /** Snapshot of the account's balance at the time the transaction settled */
  settledBalanceSnapshotUsdCents?: Maybe<Scalars["Long"]>;
  /** The status of the transaction (initiated, processing, failed, etc) */
  status: BankingTransactionStatus;
  /** The type of the transaction (ACH, Wire, etc) */
  type: BankingTransactionType;
  /** The last time the transaction was updated */
  updatedAt?: Maybe<Scalars["LocalDateTime"]>;
}

export enum BankingTransactionCancellationReason {
  TRANSACTION_CANCELLATION_REASON_ACCOUNT_CLOSED = "TRANSACTION_CANCELLATION_REASON_ACCOUNT_CLOSED",
  TRANSACTION_CANCELLATION_REASON_ACCOUNT_NOT_FOUND = "TRANSACTION_CANCELLATION_REASON_ACCOUNT_NOT_FOUND",
  TRANSACTION_CANCELLATION_REASON_ACH_DEBIT_CAPABILITY_REVOKED = "TRANSACTION_CANCELLATION_REASON_ACH_DEBIT_CAPABILITY_REVOKED",
  TRANSACTION_CANCELLATION_REASON_APPROVAL_DENIED = "TRANSACTION_CANCELLATION_REASON_APPROVAL_DENIED",
  TRANSACTION_CANCELLATION_REASON_BLOCKED_BY_POSITIVE_PAY = "TRANSACTION_CANCELLATION_REASON_BLOCKED_BY_POSITIVE_PAY",
  TRANSACTION_CANCELLATION_REASON_CUSTOMER_EDITED = "TRANSACTION_CANCELLATION_REASON_CUSTOMER_EDITED",
  TRANSACTION_CANCELLATION_REASON_EXCEEDS_AUTHORIZED_VENDOR_DRAWDOWN_AMOUNT = "TRANSACTION_CANCELLATION_REASON_EXCEEDS_AUTHORIZED_VENDOR_DRAWDOWN_AMOUNT",
  TRANSACTION_CANCELLATION_REASON_FAILED_COLUMN_FX_QUOTE_BOOKING = "TRANSACTION_CANCELLATION_REASON_FAILED_COLUMN_FX_QUOTE_BOOKING",
  TRANSACTION_CANCELLATION_REASON_FAILED_VERIFICATION = "TRANSACTION_CANCELLATION_REASON_FAILED_VERIFICATION",
  TRANSACTION_CANCELLATION_REASON_INSUFFICIENT_FUNDS = "TRANSACTION_CANCELLATION_REASON_INSUFFICIENT_FUNDS",
  TRANSACTION_CANCELLATION_REASON_MISSED_SEND_ON = "TRANSACTION_CANCELLATION_REASON_MISSED_SEND_ON",
  TRANSACTION_CANCELLATION_REASON_SACA_BALANCE_COMMITMENT_VIOLATION = "TRANSACTION_CANCELLATION_REASON_SACA_BALANCE_COMMITMENT_VIOLATION",
  TRANSACTION_CANCELLATION_REASON_SYSTEM_CANCELLED = "TRANSACTION_CANCELLATION_REASON_SYSTEM_CANCELLED",
  TRANSACTION_CANCELLATION_REASON_UNAUTHORIZED_VENDOR_DRAWDOWN_REQUEST = "TRANSACTION_CANCELLATION_REASON_UNAUTHORIZED_VENDOR_DRAWDOWN_REQUEST",
  TRANSACTION_CANCELLATION_REASON_USER_CANCELLED = "TRANSACTION_CANCELLATION_REASON_USER_CANCELLED",
}

/** The available fields that are queryable that relate to banking transactions */
export enum BankingTransactionEntityFieldKeyType {
  ALL = "ALL",
  AMOUNT_USD_CENTS = "AMOUNT_USD_CENTS",
  BANKING_TRANSACTION_STATUS = "BANKING_TRANSACTION_STATUS",
  BANKING_TRANSACTION_TYPE = "BANKING_TRANSACTION_TYPE",
  CUSTOMER_ACCOUNT_ID = "CUSTOMER_ACCOUNT_ID",
  CUSTOMER_MEMO = "CUSTOMER_MEMO",
  CUSTOMER_TIMESTAMP = "CUSTOMER_TIMESTAMP",
  DEPOSITS_ACCOUNT_ID = "DEPOSITS_ACCOUNT_ID",
  DISPLAY_NAME = "DISPLAY_NAME",
  INITIATED_AT = "INITIATED_AT",
  PROCESSED_AT = "PROCESSED_AT",
  SCHEDULED_SEND_AT = "SCHEDULED_SEND_AT",
}

/** Filters for the banking transaction entity. */
export interface BankingTransactionEntityFieldMatcherInput {
  customerTimeBetween?: InputMaybe<TimeIntervalInput>;
  /** Matches IN deposit account ids */
  depositAccountIds?: InputMaybe<Array<Scalars["ID"]>>;
  searchQuery?: InputMaybe<Scalars["String"]>;
  transactionAmountBetween?: InputMaybe<IntegerIntervalInput>;
  transactionStatus?: InputMaybe<Array<BankingTransactionStatus>>;
  transactionTimeBetween?: InputMaybe<TimeIntervalInput>;
  transactionType?: InputMaybe<Array<BankingTransactionType>>;
}

export interface BankingTransactionFieldKeyTypeWrapper {
  key: BankingTransactionEntityFieldKeyType;
}

export interface BankingTransactionPolicyDetails {
  excludedAdmins?: Maybe<Array<Employee>>;
  transactionThresholds: Array<TransactionThreshold>;
}

export interface BankingTransactionPolicyDetailsInput {
  excludedAdmins?: InputMaybe<Array<Scalars["String"]>>;
  transactionThresholds: Array<TransactionThresholdInput>;
}

/** A banking transaction request. */
export interface BankingTransactionRequest extends Node, Request {
  /**
   * Fetch actions on the Request.
   * Can be filtered e.g. to select only pending actions
   */
  actions?: Maybe<RequestActionConnection>;
  /** User that canceled the request */
  canceledBy?: Maybe<Employee>;
  /** The compliance status for the request */
  complianceStatus?: Maybe<ComplianceStatus>;
  /** When the request was created. */
  createdAt: Scalars["Time"];
  /**
   * The employee who initiated the request.
   * This field could be null if we create the Request from a service
   */
  createdBy?: Maybe<Employee>;
  /** The compliance status for the request that is derived from the submitter and reviewer compliance statuses. */
  derivedComplianceStatus?: Maybe<DerivedComplianceStatus>;
  /** The ID of an object */
  id: Scalars["ID"];
  /** The timestamp when a controller overridden the request */
  overriddenAt?: Maybe<Scalars["Time"]>;
  /** The employee who overridden the request. */
  overriddenBy?: Maybe<Employee>;
  /** User id being co-piloted when this request was overridden. */
  overriddenOnBehalfOf?: Maybe<Employee>;
  /** The employee who owns the request. */
  owner?: Maybe<Employee>;
  /**
   * The user who initiated the request
   * @deprecated Incorrect permission scoping, use owner instead
   */
  requestedBy?: Maybe<User>;
  /**
   * The employee who initiated the request
   * @deprecated Not clear whether this is owner or creator of request after copilot context was introduced, use owner instead
   */
  requestedByEmployee?: Maybe<Employee>;
  /** The reviewer compliance status for the request. */
  reviewerComplianceStatus?: Maybe<ComplianceStatus>;
  /** The timestamp when reviewer compliance deadline will be reached */
  reviewerDeadlineAt?: Maybe<Scalars["Time"]>;
  /**
   * The stage of approval of the request, e.g. created, approved, denied
   * We'll always have a value for this field (the nullability is inherited from the Request interface)
   */
  status?: Maybe<RequestStatus>;
  /** The timestamp when the submitter compliance deadline will be reached */
  submitterDeadlineAt?: Maybe<Scalars["Time"]>;
  /**
   * Will always be BANKING_TRANSACTION for a BankingTransactionRequest
   * We'll always have a value for this field (the nullability is inherited from the Request interface)
   */
  type?: Maybe<RequestType>;
}

/** A banking transaction request. */
export interface BankingTransactionRequestactionsArgs {
  filter?: InputMaybe<RequestActionFilterInput>;
  order?: InputMaybe<RequestActionOrderInput>;
  page?: InputMaybe<PaginationInput>;
}

export enum BankingTransactionStatus {
  TRANSACTION_STATUS_APPROVAL_REQUIRED = "TRANSACTION_STATUS_APPROVAL_REQUIRED",
  TRANSACTION_STATUS_DELETED = "TRANSACTION_STATUS_DELETED",
  TRANSACTION_STATUS_DRAFT = "TRANSACTION_STATUS_DRAFT",
  TRANSACTION_STATUS_FAILED = "TRANSACTION_STATUS_FAILED",
  TRANSACTION_STATUS_PROCESSED = "TRANSACTION_STATUS_PROCESSED",
  TRANSACTION_STATUS_PROCESSING = "TRANSACTION_STATUS_PROCESSING",
  TRANSACTION_STATUS_SCHEDULED = "TRANSACTION_STATUS_SCHEDULED",
}

export enum BankingTransactionType {
  TRANSACTION_TYPE_ACH = "TRANSACTION_TYPE_ACH",
  TRANSACTION_TYPE_ACH_RETURN = "TRANSACTION_TYPE_ACH_RETURN",
  TRANSACTION_TYPE_ADMIN_BALANCE_ADJUSTMENT = "TRANSACTION_TYPE_ADMIN_BALANCE_ADJUSTMENT",
  TRANSACTION_TYPE_BOOK_TRANSFER = "TRANSACTION_TYPE_BOOK_TRANSFER",
  TRANSACTION_TYPE_BREX_OPERATIONAL_TRANSFER = "TRANSACTION_TYPE_BREX_OPERATIONAL_TRANSFER",
  TRANSACTION_TYPE_CARD_COLLECTION = "TRANSACTION_TYPE_CARD_COLLECTION",
  TRANSACTION_TYPE_CHEQUE = "TRANSACTION_TYPE_CHEQUE",
  TRANSACTION_TYPE_CHEQUE_RETURN = "TRANSACTION_TYPE_CHEQUE_RETURN",
  TRANSACTION_TYPE_CRYPTO_BRIDGE = "TRANSACTION_TYPE_CRYPTO_BRIDGE",
  TRANSACTION_TYPE_DIVIDEND = "TRANSACTION_TYPE_DIVIDEND",
  TRANSACTION_TYPE_FBO_TRANSFER = "TRANSACTION_TYPE_FBO_TRANSFER",
  TRANSACTION_TYPE_INTEREST = "TRANSACTION_TYPE_INTEREST",
  TRANSACTION_TYPE_INTRA_CUSTOMER_ACCOUNT_BOOK_TRANSFER = "TRANSACTION_TYPE_INTRA_CUSTOMER_ACCOUNT_BOOK_TRANSFER",
  TRANSACTION_TYPE_PAYBACK = "TRANSACTION_TYPE_PAYBACK",
  TRANSACTION_TYPE_PAYROLL_ESTIMATE = "TRANSACTION_TYPE_PAYROLL_ESTIMATE",
  TRANSACTION_TYPE_RECEIVABLES_OFFERS_ADVANCE = "TRANSACTION_TYPE_RECEIVABLES_OFFERS_ADVANCE",
  TRANSACTION_TYPE_RECEIVABLES_OFFERS_COLLECTION = "TRANSACTION_TYPE_RECEIVABLES_OFFERS_COLLECTION",
  TRANSACTION_TYPE_RECEIVABLES_OFFERS_REPAYMENT = "TRANSACTION_TYPE_RECEIVABLES_OFFERS_REPAYMENT",
  TRANSACTION_TYPE_RECEIVABLES_OFFERS_TRANSFER = "TRANSACTION_TYPE_RECEIVABLES_OFFERS_TRANSFER",
  TRANSACTION_TYPE_REIMBURSEMENT_COLLECTION = "TRANSACTION_TYPE_REIMBURSEMENT_COLLECTION",
  TRANSACTION_TYPE_REWARDS_REDEMPTION = "TRANSACTION_TYPE_REWARDS_REDEMPTION",
  TRANSACTION_TYPE_TRANSACTION_FEES_COLLECTION = "TRANSACTION_TYPE_TRANSACTION_FEES_COLLECTION",
  TRANSACTION_TYPE_WIRE = "TRANSACTION_TYPE_WIRE",
  TRANSACTION_TYPE_WIRE_RETURN = "TRANSACTION_TYPE_WIRE_RETURN",
}

export interface BarAxisData {
  legend: GraphLegendType;
  value: Scalars["String"];
}

export interface BarMetricsGraph {
  yAxisData: Array<BarAxisData>;
  yAxisUnit: MetricUnit;
}

/**
 * With the work on BIB-108, we wanted to change a behavior in the FE that
 * fetched billing invoices and SaaS invoices separately. Since SaaS invoices have
 * a schema that is significantly different than the billing schema,
 * the chosen approach was to use an interface to abstract both invoices, rather than
 * an union, to make forward compatibility easier.
 */
export interface BaseBillingInvoice {
  /** Invoice close time */
  closesAt?: Maybe<Scalars["Time"]>;
  /** Invoice due time */
  dueAt: Scalars["Time"];
  /** Invoice Id */
  id: Scalars["ID"];
  /** invoice number */
  invoiceNumber: Scalars["String"];
  /** Invoice start time */
  startsAt?: Maybe<Scalars["Time"]>;
  /** total debits in the invoice */
  totalDebits: FinancialAsset;
}

export interface BatchAddGroupMembersInput {
  groupIdentifier: GroupIdentifier;
  members: Array<GroupMemberInput>;
}

export interface BatchAddGroupMembersResult extends MutationResult {
  errors?: Maybe<Array<GroupMemberMutationError>>;
}

export interface BatchArchiveUsersInput {
  /** List of userIds to archive. Can be cuuser_id or emp_id. */
  userIds: Array<Scalars["ID"]>;
}

export interface BatchArchiveUsersResult {
  users?: Maybe<Array<Maybe<User>>>;
}

export enum BatchCadence {
  DAILY = "DAILY",
  MONTHLY = "MONTHLY",
  SINGLE_ENTRY = "SINGLE_ENTRY",
  WEEKLY = "WEEKLY",
}

export interface BatchCreateContactsInput {
  /** The id of asset uploaded to create these contacts */
  assetId: Scalars["String"];
  clientMutationId: Scalars["String"];
  /** The contact inputs */
  vendorContactInputs: Array<VendorContactInput>;
}

export interface BatchCreateContactsPayload {
  clientMutationId: Scalars["String"];
  createdContacts?: Maybe<Array<PaymentContact>>;
}

export interface BatchCreateCostCentersInput {
  /** The names of cost centers to create. */
  costCenters: Array<Scalars["String"]>;
}

export interface BatchCreateCostCentersResult {
  costCenters?: Maybe<Array<Maybe<CostCenter>>>;
}

export interface BatchCreateDepartmentsInput {
  /** The details of the departments to create. */
  departments: Array<CreateDepartmentInput>;
}

export interface BatchCreateDepartmentsResult {
  departments?: Maybe<Array<Maybe<Department>>>;
}

export interface BatchCreateExtendedFieldOptionsInput {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** The extended field id for the options to be created. */
  extendedFieldId?: InputMaybe<Scalars["ID"]>;
  /** The extended field ID and associated options to be created */
  extendedFieldToOptionsInput?: InputMaybe<Array<ExtendedFieldToOptionsInput>>;
  /** The options to be created */
  optionInput?: InputMaybe<Array<ExtendedFieldOptionInput>>;
}

/** Response of extended field options creation */
export interface BatchCreateExtendedFieldOptionsResult {
  errors?: Maybe<Array<ExtendedFieldOptionsMutationError>>;
  extendedFieldOptions: Array<ExtendedFieldOption>;
}

/** Top-level input fields for creating multiple extended field visibility rules */
export interface BatchCreateExtendedFieldVisibilityRulesInput {
  visibilityRuleInputs: Array<ExtendedFieldVisibilityRuleCreationInput>;
}

export interface BatchCreateExtendedFieldVisibilityRulesResult
  extends MutationResult {
  errors?: Maybe<Array<ExtendedFieldVisibilityRuleMutationError>>;
  extendedFieldVisibilityRules: Array<ExtendedFieldVisibilityRule>;
}

export interface BatchCreateLegalEntitiesInput {
  /** The names of legal entities to create. */
  legalEntities: Array<Scalars["String"]>;
}

export interface BatchCreateLegalEntitiesResult {
  legalEntities?: Maybe<Array<Maybe<LegalEntity>>>;
}

export interface BatchCreateLocationsInput {
  /** The details of the locations to create. */
  locations: Array<CreateLocationInput>;
}

export interface BatchCreateLocationsResult {
  locations?: Maybe<Array<Maybe<Location>>>;
}

export interface BatchCreateMappingsInput {
  inputs: Array<CreateMappingInput>;
}

export interface BatchCreateMappingsResult {
  mappings: Array<Mapping>;
}

export interface BatchCreateReceiptsAndExpensesInput {
  /** Batch of receipts to create. */
  receipts?: InputMaybe<Array<CreateReceiptAndExpenseInput>>;
}

export interface BatchCreateReceiptsAndExpensesResult {
  /** Returns the workflowId that runs the receipt creation tasks */
  workflowId?: Maybe<Scalars["String"]>;
}

export interface BatchCreateReimbursementExpensesInput {
  /** Batch of expenses objects to create. */
  expenses?: InputMaybe<Array<CreateReimbursementExpenseInput>>;
}

export interface BatchCreateReimbursementExpensesResult {
  /** Set of results for each individual reimbursement expense to create. */
  results?: Maybe<Array<CreateReimbursementExpenseResult>>;
}

export interface BatchCreateSuggestionActionsInput {
  suggestionActions: Array<AutomationSuggestionAction>;
}

export interface BatchCreateSuggestionActionsResult extends MutationResult {
  errors?: Maybe<Array<CreateSuggestionActionError>>;
  result: AutomationSuggestionConnection;
}

export interface BatchCreateTitlesInput {
  /** The display names of titles to create. */
  titles: Array<Scalars["String"]>;
}

export interface BatchCreateTitlesResult {
  titles?: Maybe<Array<Maybe<Title>>>;
}

export interface BatchCreateUsersInput {
  users?: InputMaybe<Array<InputMaybe<CreateUserInput>>>;
}

export interface BatchCreateUsersResult {
  /** The employees that were created. */
  users?: Maybe<Array<Maybe<User>>>;
}

export interface BatchCreateVendorFileMatchesInput {
  /**
   * [oneOf] Input to create vendor file matches by vendor id for an account.
   * Only one of [vendorFileMatches, vendorFileMatchesFromImport] can be specified. An exception will be thrown if none or multiple are passed.
   */
  vendorFileMatches?: InputMaybe<Array<CreateVendorFileMatchInput>>;
  /**
   * [oneOf] Input to create vendor file matches from a spend migration import.
   * Only one of [vendorFileMatches, vendorFileMatchesFromImport] can be specified. An exception will be thrown if none or multiple are passed.
   */
  vendorFileMatchesFromImport?: InputMaybe<CreateVendorFileMatchesFromImportInput>;
}

export interface BatchCreateVendorFileMatchesResult extends MutationResult {
  errors?: Maybe<Array<VendorFileMatchMutationError>>;
  /** The vendor file matches that were created */
  result: Array<VendorFileMatch>;
}

export interface BatchCreateVendorsInput {
  vendors: Array<CreateVendorInput>;
}

export interface BatchCreateVendorsResult extends MutationResult {
  errors?: Maybe<Array<VendorMutationError>>;
  result?: Maybe<Array<VendorDetails>>;
}

/** Response of batch create VX Workflow Rule */
export interface BatchCreateWorkflowRulesResult {
  rules: Array<WorkflowRule>;
}

export interface BatchDeleteBudgetsInput {
  deleteBudgetRequests: Array<DeleteBudgetInput>;
}

export interface BatchDeleteBudgetsResult extends MutationResult {
  errors?: Maybe<Array<ClientError>>;
  task?: Maybe<Task>;
}

/** Top-level input fields for deleting an extended field visibility rule */
export interface BatchDeleteExtendedFieldVisibilityRulesInput {
  ids: Array<Scalars["ID"]>;
}

/** Response of batch extended field visibility rules deletion */
export interface BatchDeleteExtendedFieldVisibilityRulesResult
  extends MutationResult {
  deletedExtendedFieldVisibilityRules: Array<ExtendedFieldVisibilityRule>;
  errors?: Maybe<Array<ExtendedFieldVisibilityRuleMutationError>>;
}

export interface BatchDeleteUserInvitesInput {
  /** List of userIds to delete invites for. Can be cuuser_id or emp_id. */
  userIds: Array<Scalars["ID"]>;
}

export interface BatchDeleteUserInvitesResult {
  users?: Maybe<Array<Maybe<User>>>;
}

export interface BatchDisableUsersInput {
  /** List of userIds to deactivate. Can be cuuser_id or emp_id. */
  userIds: Array<Scalars["ID"]>;
}

export interface BatchDisableUsersResult {
  users?: Maybe<Array<Maybe<User>>>;
}

export enum BatchEntity {
  DEPARTMENT = "DEPARTMENT",
  LOCATION = "LOCATION",
  USER = "USER",
}

export interface BatchImportExtendedFieldOptionsInput {
  /** Asset ID of the uploaded options. */
  assetId: Scalars["ID"];
  /** The extended field id for the options to be created. */
  extendedFieldId: Scalars["ID"];
}

/** Response of bulk CSV extended field options creation */
export interface BatchImportExtendedFieldOptionsResult {
  errors?: Maybe<Array<ExtendedFieldOptionsMutationError>>;
}

export interface BatchInviteUsersInput {
  /**
   * Roles to assign to invited users.
   * WIP DO NOT USE
   */
  productAccess?: InputMaybe<Array<UserProductAccess>>;
  /** The role to assign to the invited users. */
  role?: InputMaybe<UserRole>;
  /** List of the roleIds each user will be assigned. */
  roleIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** List of userIds to invite. Can be cuuser_id or emp_id. */
  userIds: Array<Scalars["ID"]>;
}

export interface BatchInviteUsersResult {
  /**
   * Provides the same id that was specified in the input.
   * (e.g. if emp_id is provided, it will be returned encoded with the Employee typename.)
   */
  errors?: Maybe<Array<Maybe<UserError>>>;
  users?: Maybe<Array<Maybe<User>>>;
}

export interface BatchMoveBudgetsInput {
  moveBudgetRequests: Array<MoveBudgetInput>;
}

export interface BatchMoveBudgetsResult extends MutationResult {
  errors?: Maybe<Array<ClientError>>;
  task?: Maybe<Task>;
}

export interface BatchReactivateUsersInput {
  /** List of userIds to reactivate. Can be cuuser_id or emp_id. */
  userIds: Array<Scalars["ID"]>;
}

export interface BatchReactivateUsersResult {
  users?: Maybe<Array<Maybe<User>>>;
}

export interface BatchRemoveGroupMembersInput {
  groupIdentifier: GroupIdentifier;
  members: Array<GroupMemberInput>;
}

export interface BatchRemoveGroupMembersResult extends MutationResult {
  errors?: Maybe<Array<GroupMemberMutationError>>;
}

export interface BatchRestoreToHybridEmbeddedUsersInput {
  /**
   * List of customerUserIds to restore to
   * hybrid functionality
   */
  userIds: Array<Scalars["ID"]>;
}

export interface BatchRestoreToHybridEmbeddedUsersResult {
  users?: Maybe<Array<Maybe<User>>>;
}

export interface BatchSetEntityAutopayFundingSourceInput {
  setEntityAutopayFundingSourceInputs?: InputMaybe<
    Array<SetEntityAutopayFundingSourceInput>
  >;
}

export interface BatchSetUserRoleAssignmentsInput {
  roleIds: Array<Scalars["ID"]>;
  userIds: Array<Scalars["ID"]>;
}

export interface BatchSetUserRoleAssignmentsResult extends MutationResult {
  errors?: Maybe<Array<UserRoleAssignmentError>>;
  users?: Maybe<Array<User>>;
}

export interface BatchSettings {
  cadence?: Maybe<BatchCadence>;
  entity?: Maybe<BatchEntity>;
}

export interface BatchSubmitReimbursementExpensesInput {
  /** Reimbursement expense inputs to submit */
  batchSubmitExpenseInputs?: InputMaybe<Array<SubmitExpenseInput>>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
}

export interface BatchSubmitReimbursementExpensesResult {
  /** List of results for each individual reimbursement submission */
  batchSubmitExpenseResults?: Maybe<Array<SubmitExpenseResult>>;
  clientMutationId?: Maybe<Scalars["String"]>;
}

export interface BatchSubmitReimbursementInput {
  /** (OPTIONAL) Idempotency key to use for this mutation. */
  idempotencyKey?: InputMaybe<Scalars["String"]>;
  /**
   * (OPTIONAL) Reimbursement ID to submit
   * At least one of [reimbursementItemId, updatedReimbursementMetadata] must be set.
   */
  reimbursementItemId?: InputMaybe<Scalars["ID"]>;
  /**
   * (OPTIONAL) Updated reimbursement metadata
   * At least one of [reimbursementItemId, updatedReimbursementMetadata] must be set.
   */
  updatedReimbursementMetadata?: InputMaybe<ReimbursementMetadataInput>;
}

export interface BatchSubmitVerificationRequestsInput {
  analysisId: Scalars["ID"];
}

export interface BatchSubmitVerificationRequestsResult extends MutationResult {
  errors?: Maybe<Array<SubmitVerificationRequestError>>;
  result: VerificationAnalysis;
}

export interface BatchTerminateBudgetsInput {
  terminateBudgetRequests: Array<TerminateBudgetInput>;
}

export interface BatchTerminateBudgetsResult extends MutationResult {
  errors?: Maybe<Array<ClientError>>;
  task?: Maybe<Task>;
}

export interface BatchToggleRulesInput {
  clientMutationId: Scalars["String"];
  /** Integration rule ids for the toggled rule */
  integrationRuleIds: Array<InputMaybe<Scalars["ID"]>>;
  /** Source object id for the toggled rules */
  sourceObjectId: Scalars["ID"];
}

export interface BatchToggleRulesPayload {
  clientMutationId: Scalars["String"];
  /** list of integration rule ids that failed to toggle */
  failedRuleIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
}

export interface BatchUnarchiveUsersInput {
  /** List of userIds to unarchive. Can be cuuser_id or emp_id. */
  userIds: Array<Scalars["ID"]>;
}

export interface BatchUnarchiveUsersResult {
  users?: Maybe<Array<Maybe<User>>>;
}

/**  ---[ Input Types ]------------------ */
export interface BatchUpdateAccountingRecordsInput {
  /** Accounting records to be updated */
  updateAccountingRecordInputs: Array<UpdateAccountingRecordInput>;
}

export interface BatchUpdateAccountingRecordsResult extends MutationResult {
  errors?: Maybe<Array<UpdateAccountingRecordError>>;
  result?: Maybe<Array<AccountingRecord>>;
}

/**  ---[ Batch Update Inputs ]------------------- */
export interface BatchUpdateBooleanFieldInstanceInput {
  /**
   * Whether to propagate updates to other field instances that are linked to this one,
   * for example, clearing a parent field instance will clear all child field instances.
   *
   * Defaults to false if not set.
   */
  cascadeUpdate?: Scalars["Boolean"];
  input: Array<BooleanFieldInstanceInput>;
}

export interface BatchUpdateBudgetsLimitAsyncResult {
  /** Budget ids that failed to publish for update */
  errors?: Maybe<Array<UpdateBudgetsLimitAsyncPublishError>>;
  /** Budget ids that were successfully published for update */
  successes?: Maybe<Array<Scalars["ID"]>>;
}

/** Input to bulk update budget limits async. Updates are queued for processing */
export interface BatchUpdateBulkBudgetLimitAsyncInput {
  /** List of budgets to want to update and the new limits for each budget */
  fields?: InputMaybe<Array<UpdateBudgetLimitAsyncFields>>;
}

export interface BatchUpdateDateFieldInstanceInput {
  /**
   * Whether to propagate updates to other field instances that are linked to this one,
   * for example, clearing a parent field instance will clear all child field instances.
   *
   * Defaults to false if not set.
   */
  cascadeUpdate?: Scalars["Boolean"];
  input: Array<DateFieldInstanceInput>;
}

export interface BatchUpdateDecimalFieldInstanceInput {
  /**
   * Whether to propagate updates to other field instances that are linked to this one,
   * for example, clearing a parent field instance will clear all child field instances.
   *
   * Defaults to false if not set.
   */
  cascadeUpdate?: Scalars["Boolean"];
  input: Array<DecimalFieldInstanceInput>;
}

export interface BatchUpdateDepartmentsInput {
  /** The details of the locations to update. */
  departments: Array<UpdateDepartmentInput>;
}

export interface BatchUpdateDepartmentsResult {
  departments?: Maybe<Array<Maybe<Department>>>;
}

export interface BatchUpdateExpensesAuditStatusInput {
  /** clientMutationId */
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** Individual update inputs. */
  updateExpensesAuditStatusInput?: InputMaybe<
    Array<UpdateExpensesAuditStatusInput>
  >;
}

export interface BatchUpdateExpensesAuditStatusResult {
  /** List of errors when updating the expense */
  errors?: Maybe<Array<UpdateExpensesAuditStatusError>>;
  /** The expenses that were updated. */
  expenses?: Maybe<Array<Expense>>;
}

export interface BatchUpdateExportJobNotificationsResult {
  exportJobNotification: Array<ExportJobNotification>;
}

export interface BatchUpdateExtendedFieldOptionsInput {
  /** The extended field id for all options being updated. */
  extendedFieldId: Scalars["ID"];
  optionInputs: Array<UpdateExtendedFieldOptionInput>;
}

/** Response of extended field options update */
export interface BatchUpdateExtendedFieldOptionsResult {
  errors?: Maybe<Array<ExtendedFieldOptionsMutationError>>;
  extendedFieldOptions: Array<ExtendedFieldOption>;
}

/** Top-level input fields for updating multiple extended field visibility rules */
export interface BatchUpdateExtendedFieldVisibilityRulesInput {
  visibilityRuleInputs: Array<UpdateExtendedFieldVisibilityRuleInput>;
}

/** Response of extended field visibility rules update */
export interface BatchUpdateExtendedFieldVisibilityRulesResult
  extends MutationResult {
  errors?: Maybe<Array<ExtendedFieldVisibilityRuleMutationError>>;
  extendedFieldVisibilityRules: Array<ExtendedFieldVisibilityRule>;
}

/** Represents an error that occurred while updating a field instance */
export interface BatchUpdateFieldInstanceError extends StandardClientError {
  /** The client mutation id corresponding to the error */
  clientMutationId?: Maybe<Scalars["String"]>;
  code: ErrorCode;
  /** The field instance that caused the error, if it exists. */
  fieldInstance?: Maybe<ExtendedFieldInstance>;
  /**
   * The ID of the field instance that caused the error
   * @deprecated Use fieldInstance.id instead
   */
  fieldInstanceId: Scalars["ID"];
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

/** Union type representing either a successful update or an error for a single field instance */
export type BatchUpdateFieldInstanceResult =
  | BatchUpdateFieldInstanceError
  | BatchUpdateFieldInstanceSuccessResult;

/** Wrapper type for batch update results containing a list of individual results */
export interface BatchUpdateFieldInstanceResults {
  /** The results of the batch update operation, where each item can be either a success or error */
  results: Array<BatchUpdateFieldInstanceResult>;
}

/** Represents a successful update of a single field instance */
export interface BatchUpdateFieldInstanceSuccessResult {
  /** The updated field instance */
  fieldInstance: ExtendedFieldInstance;
}

export interface BatchUpdateFinancialAssetFieldInstanceInput {
  /**
   * Whether to propagate updates to other field instances that are linked to this one,
   * for example, clearing a parent field instance will clear all child field instances.
   *
   * Defaults to false if not set.
   */
  cascadeUpdate?: Scalars["Boolean"];
  input: Array<FinancialAssetFieldInstanceInput>;
}

export interface BatchUpdateLocationsInput {
  /** The details of the locations to update. */
  locations: Array<UpdateLocationInput>;
}

export interface BatchUpdateLocationsResult {
  locations?: Maybe<Array<Maybe<Location>>>;
}

export interface BatchUpdateOptionFieldInstanceInput {
  /**
   * Whether to propagate updates to other field instances that are linked to this one,
   * for example, clearing a parent field instance will clear all child field instances.
   *
   * Defaults to false if not set.
   */
  cascadeUpdate?: Scalars["Boolean"];
  input: Array<OptionFieldInstanceInput>;
}

export interface BatchUpdateStringFieldInstanceInput {
  /**
   * Whether to propagate updates to other field instances that are linked to this one,
   * for example, clearing a parent field instance will clear all child field instances.
   *
   * Defaults to false if not set.
   */
  cascadeUpdate?: Scalars["Boolean"];
  input: Array<StringFieldInstanceInput>;
}

export interface BatchUpdateTimestampFieldInstanceInput {
  /**
   * Whether to propagate updates to other field instances that are linked to this one,
   * for example, clearing a parent field instance will clear all child field instances.
   *
   * Defaults to false if not set.
   */
  cascadeUpdate?: Scalars["Boolean"];
  input: Array<TimestampFieldInstanceInput>;
}

export interface BatchUpdateToEmbeddedUsersInput {
  /** List of customerUserIds to update to EMBEDDED_USER */
  userIds: Array<Scalars["ID"]>;
}

export interface BatchUpdateToEmbeddedUsersResult {
  users?: Maybe<Array<Maybe<User>>>;
}

export interface BatchUpdateUsersInput {
  users?: InputMaybe<Array<InputMaybe<UserUpdateInput>>>;
}

/** The users that were successfully updated as part of a BatchUpdateUsers mutation. */
export interface BatchUpdateUsersResult {
  users?: Maybe<Array<Maybe<User>>>;
}

/** Response of batch update VX Workflow Rule */
export interface BatchUpdateWorkflowRulesResult {
  rules: Array<WorkflowRule>;
}

export interface BeginChannelVerificationInput {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
}

export interface BeginChannelVerificationPayload {
  channel?: Maybe<Channel>;
  clientMutationId: Scalars["String"];
}

/** Enum for beneficiary approval status. */
export enum BeneficiaryApprovalStatus {
  /** Beneficiary is approved. */
  APPROVED = "APPROVED",
  INVALID = "INVALID",
  /** Beneficiary is pending approval. */
  PENDING_APPROVAL = "PENDING_APPROVAL",
}

export type BeneficiaryDetails = VendorDetails;

export interface BeneficiaryInstitution {
  address?: Maybe<Address>;
  name?: Maybe<Scalars["String"]>;
}

export interface BeneficiaryInstitutionInput {
  address?: InputMaybe<AddressInput>;
  name: Scalars["String"];
}

/** Enum for beneficiary modification status. */
export enum BeneficiaryModificationStatus {
  /** Beneficiary has been deleted. */
  DELETED = "DELETED",
  INVALID = "INVALID",
  /** Beneficiary is new. */
  NEW = "NEW",
  /** Beneficiary has been updated. */
  UPDATED = "UPDATED",
}

export enum BeneficiaryType {
  BUSINESS = "BUSINESS",
  INDIVIDUAL = "INDIVIDUAL",
}

export interface BiWeeklyDetails {
  /**
   * Day of the week (1 is Sunday...7 is Saturday)
   * https://hexdocs.pm/elixir/1.12/Date.html#day_of_week/2
   */
  dayOfWeek?: Maybe<Scalars["Int"]>;
}

export interface Bill extends Node {
  amount?: Maybe<Scalars["Int"]>;
  billTransmission?: Maybe<BillTransmission>;
  /** If not NULL, the transaction associated with the bill. */
  cashTransaction?: Maybe<CashTransaction>;
  /** [Deprecated!] Use transferDescription instead */
  chequeMemo?: Maybe<Scalars["String"]>;
  contact?: Maybe<PaymentContact>;
  /** DEPRECATED, PLEASE USE contact/paymentInstrument INSTEAD */
  counterparty?: Maybe<Counterparty>;
  createdAt?: Maybe<Scalars["Time"]>;
  createdByUser?: Maybe<User>;
  deletedAt?: Maybe<Scalars["Time"]>;
  /** DEPRECATED. Use sourceAccount instead. */
  depositsAccount?: Maybe<DepositsAccount>;
  /** Deprecated */
  depositsPayment?: Maybe<DepositsPayment>;
  /** Aka "memo" */
  description?: Maybe<Scalars["String"]>;
  dueAmountCents?: Maybe<Scalars["Int"]>;
  dueAt?: Maybe<Scalars["Time"]>;
  /** Date to end recurring payments */
  endsAt?: Maybe<Scalars["Time"]>;
  /** If not NULL, the erp ap account */
  erpApAccount?: Maybe<UserCategory>;
  erpApAccountVxOption?: Maybe<ExtendedFieldOption>;
  /** If not NULL, the erp class */
  erpClass?: Maybe<ExternalIntegrationEntity>;
  erpClassVxOption?: Maybe<ExtendedFieldOption>;
  /** If not NULL, the erp department */
  erpDepartment?: Maybe<ExternalIntegrationEntity>;
  erpDepartmentVxOption?: Maybe<ExtendedFieldOption>;
  /** If not NULL, the erp location */
  erpLocation?: Maybe<ExternalIntegrationEntity>;
  erpLocationVxOption?: Maybe<ExtendedFieldOption>;
  /** If not NULL, the erp payment account */
  erpPaymentAccount?: Maybe<UserCategory>;
  erpPaymentAccountVxOption?: Maybe<ExtendedFieldOption>;
  expense?: Maybe<Expense>;
  externalInvoiceNumber?: Maybe<Scalars["String"]>;
  /**
   * DO NOT BATCH, WILL RESULT IN AN N+1 QUERY.
   * Extracted fields from OCR
   */
  extractedBillFields?: Maybe<ExtractedBillFields>;
  /** The ID of an object */
  id: Scalars["ID"];
  invoice?: Maybe<Asset>;
  invoiceProcessingStatus?: Maybe<BillInvoiceProcessingStatus>;
  isDraft?: Maybe<Scalars["Boolean"]>;
  /** Indicates whether the bill is a duplicate or unique */
  isDuplicate?: Maybe<Scalars["Boolean"]>;
  isErpSyncInProgress?: Maybe<Scalars["Boolean"]>;
  lastUpdatedAt?: Maybe<Scalars["Time"]>;
  merchantCategory?: Maybe<MerchantCategory>;
  /** Boolean to indicate whether payment recipient should be notified */
  notifyRecipient?: Maybe<Scalars["Boolean"]>;
  origin?: Maybe<BillOrigin>;
  originMetadata?: Maybe<OriginMetadata>;
  /** The original bill if this bill is marked as a duplicate */
  originalBill?: Maybe<Bill>;
  paymentInitiatedByUser?: Maybe<User>;
  paymentInstrument?: Maybe<PaymentInstrument>;
  /**
   * DEPRECATED.
   * Use cashTransaction { timeline { scheduledSendAt } } instead.
   */
  paymentSendAt?: Maybe<Scalars["Time"]>;
  previousExportAttempt?: Maybe<BillExportAttempt>;
  previousExportAttempts?: Maybe<Array<BillExportAttempt>>;
  /** Recurring rules for bills */
  recurringRules?: Maybe<RecurringRules>;
  /** Recurring schedule for bills */
  recurringSchedule?: Maybe<RecurringSchedule>;
  servicePerformedAt?: Maybe<Scalars["Time"]>;
  /** The account used to fund the bill payment. */
  sourceAccount?: Maybe<SourceAccount>;
  /** Bill Status */
  status: BillStatus;
  /** Optional reason for current status */
  statusReason?: Maybe<BillStatusReason>;
  /** Total number of payments to recur */
  totalNumberOfPayments?: Maybe<Scalars["Int"]>;
  /**
   * A description of the transfer used as `Payment Instructions` for `WIRE` and the `Entry Description` for `ACH`.
   * Max 90 characters for `ACH` and `WIRE` and max 40 characters for `CHEQUES`.
   */
  transferDescription?: Maybe<Scalars["String"]>;
  userErpCategory?: Maybe<UserCategory>;
  userErpCategoryVxOption?: Maybe<ExtendedFieldOption>;
}

/**
 * END REIMBURSEMENT REQUEST RELATED OBJECTS
 * BEGIN BILL BATCH RELATED OBJECTS
 */
export interface BillBatch {
  /** Last user who approved the batch, only present when the batch is approved */
  approvedBy?: Maybe<User>;
  /** Immutable sequential batch identifier name to be used in the product and transfer memos */
  batchNumber: Scalars["String"];
  /** Bills associated with the batch, represented as expenses with bill pay extension */
  bills: Array<Expense>;
  /** Earliest due date of all bills in the batch */
  earliestDueDate?: Maybe<Scalars["Time"]>;
  /** ID of the bill batch */
  id: Scalars["ID"];
  /** Payment date configured for the batch */
  paymentDate?: Maybe<Scalars["Time"]>;
  /** Pay-in source account */
  sourceAccount?: Maybe<SourceAccount>;
  /** Status of the bill batch */
  status: BillBatchStatus;
  /** Sum of all bill amounts, does not include bills that failed in pay-in or payout */
  totalAmount: FinancialAsset;
  /**
   * Setting for how to treat pay-ins at time of collection (individual collections per bill or one collection
   * for the entire batch)
   */
  withdrawalType: BillBatchWithdrawalType;
}

export interface BillBatchAddBillsInput {
  /** ID of the bill batch */
  billBatchId: Scalars["ID"];
  /** List of bill expenses IDs to be added to the batch */
  billIds: Array<Scalars["ID"]>;
  /** Idempotency key */
  clientMutationId: Scalars["String"];
}

export interface BillBatchAddBillsResult {
  /** Possible list of errors from the mutation */
  errors: Array<BillBatchMutationError>;
  /** The updated bill batch object */
  result?: Maybe<BillBatch>;
}

export interface BillBatchApproveInput {
  /** ID of the batch to be approved */
  batchId: Scalars["ID"];
  /** Idempotency key */
  clientMutationId: Scalars["String"];
}

export interface BillBatchApproveResult {
  /** Possible list of errors from the mutation */
  errors: Array<BillBatchMutationError>;
  /** The updated bill batch object */
  result?: Maybe<BillBatch>;
}

export interface BillBatchBulkCreateInput {
  /** List of bills and their source accounts to be included in the batch */
  batches: Array<BillBatchCreateInput>;
}

export interface BillBatchBulkCreateResult {
  /** Possible list of errors from the mutation */
  errors: Array<BillBatchMutationError>;
  /** The created bill batch object */
  result?: Maybe<Array<Maybe<BillBatch>>>;
}

export interface BillBatchCreateInput {
  /** List of bill expenses IDs to be included in the batch */
  billIds: Array<Scalars["ID"]>;
  /** The billing configuration ID to be used for the batch */
  billingConfigurationId: Scalars["ID"];
  /** Idempotency key */
  clientMutationId: Scalars["String"];
  /** The date when the payment should be sent for the batch */
  paymentDate?: InputMaybe<Scalars["Time"]>;
  /** Source account of the bill payment: could be BBA or EBA ID or RAD ID */
  sourceAccount: SourceAccountInput;
}

export interface BillBatchDeleteInput {
  /** Idempotency key */
  clientMutationId: Scalars["String"];
  /** The ID of the bill batch to be deleted */
  id: Scalars["String"];
}

export interface BillBatchDeleteResult {
  /** Possible list of errors from the mutation */
  errors: Array<BillBatchMutationError>;
  /** The ID of the deleted bill batch */
  result?: Maybe<Scalars["ID"]>;
}

export interface BillBatchMutationError extends StandardClientError {
  /** Error code. */
  code: ErrorCode;
  /** Error type. */
  errorType?: Maybe<BillBatchMutationErrorType>;
  /** Error message. */
  message?: Maybe<Scalars["String"]>;
  /** Optional path to field that caused error. */
  path?: Maybe<Array<Scalars["String"]>>;
}

export enum BillBatchMutationErrorType {
  BATCH_INVALID_STATUS_FOR_RETRY = "BATCH_INVALID_STATUS_FOR_RETRY",
  BILLING_CONFIGURATION_NOT_BILL_PAY = "BILLING_CONFIGURATION_NOT_BILL_PAY",
  EXPENSES_INVALID_STATUS_FOR_RETRY = "EXPENSES_INVALID_STATUS_FOR_RETRY",
  EXPENSE_IN_ANOTHER_BATCH = "EXPENSE_IN_ANOTHER_BATCH",
  EXPENSE_MUST_HAVE_ENTITY = "EXPENSE_MUST_HAVE_ENTITY",
  EXPENSE_MUST_HAVE_SAME_CURRENCY_AS_BILLING_GROUP = "EXPENSE_MUST_HAVE_SAME_CURRENCY_AS_BILLING_GROUP",
  EXPENSE_MUST_HAVE_SAME_ENTITY_AS_BILLING_GROUP = "EXPENSE_MUST_HAVE_SAME_ENTITY_AS_BILLING_GROUP",
  UNKNOWN = "UNKNOWN",
}

export interface BillBatchRemoveBillsInput {
  /** ID of the bill batch */
  billBatchId: Scalars["ID"];
  /** List of bill expenses IDs to be removed from the batch */
  billIds: Array<Scalars["ID"]>;
  /** Idempotency key */
  clientMutationId: Scalars["String"];
}

export interface BillBatchRemoveBillsResult {
  /** Possible list of errors from the mutation */
  errors: Array<BillBatchMutationError>;
  /** The updated bill batch object */
  result?: Maybe<BillBatch>;
}

export enum BillBatchStatus {
  /**
   * When approved, the batch is ready for collection and cannot be changed anymore, payment might
   * have already started for a few of the bills in the batch
   */
  APPROVED = "APPROVED",
  /** Soft delete, the batch is no longer visible in the UI */
  DELETED = "DELETED",
  /** While in draft, a bills can be added to a batch and the batch can be edited */
  DRAFT = "DRAFT",
  /** When batches fail on pay in, the entire batch moves to failed */
  FAILED = "FAILED",
  /**
   * Final state, means the batch processing has been completed, successfully or not. In case one
   * individual payout failed, the batch would be marked as processed, signaling it finished in an
   * errored state
   */
  PROCESSED = "PROCESSED",
}

export interface BillBatchUpdateInput {
  /** ID of the batch to be updated */
  batchId: Scalars["ID"];
  /** Idempotency key */
  clientMutationId: Scalars["String"];
  /** Will be truncated to date */
  paymentDate?: InputMaybe<Scalars["Time"]>;
  /** Source account of the bill payment: could be BBA or EBA ID or RAD ID */
  sourceAccount: SourceAccountInput;
  /** How the batch should be collected, individually per bill or a single collection per batch */
  withdrawalType?: InputMaybe<BillBatchWithdrawalType>;
}

export interface BillBatchUpdateResult {
  /** Possible list of errors from the mutation */
  errors: Array<BillBatchMutationError>;
  /** The updated bill batch object */
  result?: Maybe<BillBatch>;
}

export enum BillBatchWithdrawalType {
  /** Will do a single collection for the entire batch for the cummulative amount of all bills */
  PER_BATCH = "PER_BATCH",
  /** Each bill will be collected individually */
  PER_BILL = "PER_BILL",
}

export interface BillConnection extends Connection {
  edges?: Maybe<Array<Maybe<BillEdge>>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface BillDownloadUrlResult extends MutationResult {
  errors?: Maybe<Array<BillMutationError>>;
  result?: Maybe<Scalars["String"]>;
}

/**
 * ---[ External Types for Federation ]-------------------------
 * ---[ Input Types ]---------------------
 * ---[ Enums ]---------------------------
 */
export enum BillDuplicateStatus {
  SYSTEM_DUPLICATE = "SYSTEM_DUPLICATE",
  SYSTEM_UNIQUE = "SYSTEM_UNIQUE",
  USER_UNIQUE = "USER_UNIQUE",
}

export interface BillEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<Bill>;
}

export interface BillExportAttempt {
  accountingRecordId: Scalars["ID"];
  errorMessage?: Maybe<Scalars["String"]>;
  errorType?: Maybe<Scalars["String"]>;
  expenseId: Scalars["ID"];
  externalEntryId?: Maybe<Scalars["String"]>;
  externalEntryType: BillExportExternalEntryType;
  forceOverwriteType: BillExportForceOverwriteType;
  insertedAt: Scalars["Time"];
  status: BillExportStatus;
}

/** An enum representing the type of the ERP export entry */
export enum BillExportExternalEntryType {
  BILL = "BILL",
  BILL_MONEY_MOVEMENT_PAYIN = "BILL_MONEY_MOVEMENT_PAYIN",
  CARD_PAYMENT = "CARD_PAYMENT",
  PAYMENT = "PAYMENT",
}

export enum BillExportForceOverwriteType {
  IGNORE = "IGNORE",
  NOT_APPLICABLE = "NOT_APPLICABLE",
  OVERWRITE = "OVERWRITE",
}

export enum BillExportStartStatus {
  APPROVED = "APPROVED",
  SUBMITTED = "SUBMITTED",
}

/** The export status of a bill to an ERP. */
export enum BillExportStatus {
  ERROR = "ERROR",
  IN_PROGRESS = "IN_PROGRESS",
  SUCCESS = "SUCCESS",
}

/** Set of bill field values calculated, extracted from invoice processing and defaults based on previous bills. */
export interface BillFieldSuggestions {
  /** Due amount, extracted from invoice */
  dueAmount?: Maybe<RawOcrExtractedFinancial>;
  /** Due date, extracted from invoice */
  dueAt?: Maybe<RawOcrExtractedTime>;
  /** Invoice date, extracted from invoice */
  invoiceDate?: Maybe<RawOcrExtractedTime>;
  /** Invoice Number, extracted from invoice */
  invoiceNumber?: Maybe<RawOcrExtractedString>;
  /** List of matched vendors info */
  matchedVendors: Array<MatchedVendorInfo>;
  /**
   * The payment instrument matched/created after parsed from invoice
   * DEPRECATED use one of the MatchedVendorInfo in matchedVendors list
   * @deprecated No longer supported
   */
  paymentInstrument?: Maybe<PaymentInstrumentField>;
  /**
   * Date of payment, parsed from invoice and calculated by the payment instrument type
   * DEPRECATED use one of the MatchedVendorInfo in matchedVendors list
   * @deprecated No longer supported
   */
  paymentSendAt?: Maybe<Scalars["Time"]>;
  /** Purchase Order Number, extracted from invoice */
  poNumber?: Maybe<RawOcrExtractedString>;
  /** Vendor information, extracted from invoice */
  rawVendorInfo?: Maybe<RawOcrExtractedVendor>;
  /** The vendor matched/created after parsed from invoice */
  vendor?: Maybe<BillSuggestionVendor>;
}

export interface BillFieldSuggestionsResult {
  /** Whether or not the invoice processing is done and the suggestions are ready */
  status?: Maybe<BillFieldSuggestionsResultStatus>;
  /** Bill fields suggestions */
  suggestions?: Maybe<BillFieldSuggestions>;
}

export enum BillFieldSuggestionsResultStatus {
  NOT_FOUND = "NOT_FOUND",
  NOT_READY = "NOT_READY",
  READY = "READY",
}

export interface BillFilterInput {
  attachmentAssetId?: InputMaybe<Scalars["ID"]>;
  attachmentAssetIds?: InputMaybe<Array<Scalars["ID"]>>;
  contacts?: InputMaybe<Array<Scalars["ID"]>>;
  dueAtBetween?: InputMaybe<TimeIntervalInput>;
  exportStatuses?: InputMaybe<Array<BillExportStatus>>;
  integrationIds?: InputMaybe<Array<Scalars["ID"]>>;
  isPastDue?: InputMaybe<Scalars["Boolean"]>;
  isRecurring?: InputMaybe<Scalars["Boolean"]>;
  paymentSendAtBetween?: InputMaybe<TimeIntervalInput>;
  search?: InputMaybe<Scalars["String"]>;
  statuses?: InputMaybe<Array<BillStatus>>;
}

export interface BillFloat {
  /** Details relating to the bill float type */
  details: BillFloatDetails;
  /** Type of grace period granted to the journal account */
  type: BillFloatType;
}

export type BillFloatDetails =
  | ConstantBeforeNextPeriodEndBillFloatDetails
  | ConstantBillFloatDetails;

export enum BillFloatType {
  CONSTANT = "CONSTANT",
  CONSTANT_BEFORE_NEXT_PERIOD_END = "CONSTANT_BEFORE_NEXT_PERIOD_END",
  NO_FLOAT = "NO_FLOAT",
}

/** A group of Bills that will have the same payment date and source account. */
export interface BillGroupUpdatePaymentDetailsInput {
  /** The IDs of the Bills (which are Expenses) to update. */
  expenseIds: Array<Scalars["ID"]>;
  /** The payment time of the Bills. */
  paymentSendAt?: InputMaybe<Scalars["Time"]>;
  /** The source account of the Bills. */
  sourceAccount?: InputMaybe<SourceAccountInput>;
  /** The vendor payment of the Bills. */
  vendorPayment?: InputMaybe<VendorPaymentInput>;
}

export interface BillIdResult extends MutationResult {
  errors?: Maybe<Array<BillMutationError>>;
  result?: Maybe<Scalars["ID"]>;
}

export enum BillInvoiceProcessingStatus {
  AWAITING = "AWAITING",
  DONE = "DONE",
  INELIGIBLE = "INELIGIBLE",
}

export interface BillMonthlySchedule {
  /** @deprecated Use dayOfMonth or weekOfMonth + dayOfWeek instead */
  dayOccurrence?: Maybe<Scalars["Int"]>;
  dayOfMonth?: Maybe<Scalars["Int"]>;
  dayOfWeek?: Maybe<BusinessDays>;
  nMonths: Scalars["Int"];
  weekOfMonth?: Maybe<Scalars["Int"]>;
}

export interface BillMutationError extends StandardClientError {
  code: ErrorCode;
  error?: Maybe<BillMutationErrorType>;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

/**  END BILL BATCH RELATED OBJECTS */
export enum BillMutationErrorType {
  BILL_IN_INVALID_STATE = "BILL_IN_INVALID_STATE",
  BUDGET_ANCESTOR_LIMIT_EXCEEDED = "BUDGET_ANCESTOR_LIMIT_EXCEEDED",
  BUDGET_AUTHORIZATION_ERROR = "BUDGET_AUTHORIZATION_ERROR",
  BUDGET_DELETED = "BUDGET_DELETED",
  BUDGET_EXPIRED = "BUDGET_EXPIRED",
  BUDGET_LIMIT_EXCEEDED = "BUDGET_LIMIT_EXCEEDED",
  BUDGET_MISSING = "BUDGET_MISSING",
  BUDGET_MISSING_REQUIRED_INVOICE = "BUDGET_MISSING_REQUIRED_INVOICE",
  BUDGET_MISSING_REQUIRED_MEMO = "BUDGET_MISSING_REQUIRED_MEMO",
  BUDGET_NOT_APPROVED = "BUDGET_NOT_APPROVED",
  BUDGET_NOT_FOUND = "BUDGET_NOT_FOUND",
  BUDGET_NOT_YET_STARTED = "BUDGET_NOT_YET_STARTED",
  BUDGET_POLICY_MISSING_BILL_PAY_RULE = "BUDGET_POLICY_MISSING_BILL_PAY_RULE",
  BUDGET_TERMINATED = "BUDGET_TERMINATED",
  BUDGET_TRANSACTION_LIMIT_EXCEEDED = "BUDGET_TRANSACTION_LIMIT_EXCEEDED",
  ERP_CATEGORY_MISSING_NETSUITE = "ERP_CATEGORY_MISSING_NETSUITE",
  ERP_CATEGORY_MISSING_QUICKBOOKS = "ERP_CATEGORY_MISSING_QUICKBOOKS",
  ERP_CATEGORY_MISSING_UNMAPPED = "ERP_CATEGORY_MISSING_UNMAPPED",
  ERP_CATEGORY_MISSING_XERO = "ERP_CATEGORY_MISSING_XERO",
  PAYMENT_INFO_INVALID_COUNTERPARTY = "PAYMENT_INFO_INVALID_COUNTERPARTY",
  UNKNOWN = "UNKNOWN",
  USER_NOT_AUTHORIZED = "USER_NOT_AUTHORIZED",
}

export interface BillOrderInput {
  direction: OrderByDirection;
  field: SortableBillField;
}

export enum BillOrigin {
  DASHBOARD = "DASHBOARD",
  EMAIL = "EMAIL",
  RECURRING = "RECURRING",
}

export interface BillPayExtension extends ExpenseExtensionType {
  /** Auto approve bill if submitter is on approval chain */
  autoApprove?: Maybe<Scalars["Boolean"]>;
  /** @deprecated Use extension fields instead */
  bill: Bill;
  /** The id of the batch that the bill is in, if null the bill is not in a batch */
  billBatch?: Maybe<BillBatch>;
  /**
   * Payee details for this bill from either the vendor, transmission or transaction.
   * Note that this will N+1 so avoid on list calls
   */
  billPayee?: Maybe<BillPayee>;
  /**
   * The transmission associated with the bill
   * @deprecated Use billTransmissionTransfer instead
   */
  billTransmission?: Maybe<BillTransmission>;
  /** The transmission associated with the bill */
  billTransmissionInfo?: Maybe<BillTransmissionInfo>;
  /** The Brex Invoice base id (if the invoice of the bill pay is a Brex invoice) */
  brexInvoiceId?: Maybe<Scalars["String"]>;
  /** Card created for this bill */
  card?: Maybe<Card>;
  /** Whether card details will be / have been sent */
  cardDetailsSharingStatus?: Maybe<CardDetailsSharingStatus>;
  /** The transaction associated with the bill */
  cashTransaction?: Maybe<CashTransaction>;
  /**
   * Cheque external memo
   * @deprecated use transferDescription instead
   */
  chequeMemo?: Maybe<Scalars["String"]>;
  /** @deprecated Use expense customer instead */
  createdByUser?: Maybe<User>;
  /** When the bill is due. */
  dueAt?: Maybe<Scalars["Time"]>;
  /** Whether the bill is a duplicate or unique */
  duplicateStatus?: Maybe<BillDuplicateStatus>;
  /** A/P GL account for ERP integration */
  erpApAccount?: Maybe<UserCategory>;
  /** A/P GL GL account for ERP integration - Accounting 1B Stack */
  erpApAccountVxOption?: Maybe<ExtendedFieldOption>;
  /** Payment GL account for ERP integration */
  erpPaymentAccount?: Maybe<UserCategory>;
  /** Payment GL account for ERP integration - Accounting 1B Stack */
  erpPaymentAccountVxOption?: Maybe<ExtendedFieldOption>;
  /** External invoice number */
  externalInvoiceNumber?: Maybe<Scalars["String"]>;
  /** Extracted fields from the invoice */
  extractedBillFields?: Maybe<ExtractedBillFields>;
  forwardedFromEmailAddress?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  /** Invoice processing status */
  invoiceProcessingStatus?: Maybe<BillInvoiceProcessingStatus>;
  /**
   * Determines if principle protection is enabled.
   * If so the user will be safe from intermediary fees in international wires and be charged by Brex
   */
  isPrincipalProtectionEnabled?: Maybe<Scalars["Boolean"]>;
  /** Notify the recipient when payment is sent */
  notifyRecipient?: Maybe<Scalars["Boolean"]>;
  /** Owner user assigned to the card for pay by card payments. */
  oneTimeCardOwner?: Maybe<User>;
  /** Optional message to the recipient of the bill pay card. */
  oneTimeCardRecipientMessage?: Maybe<Scalars["String"]>;
  /** Where the bill was created */
  origin?: Maybe<BillOrigin>;
  /** ID of the original expense if this bill is marked as a duplicate */
  originalBillExpenseId?: Maybe<Scalars["ID"]>;
  /** Amount cleared against one time card */
  paidAmount?: Maybe<FinancialAsset>;
  /** User who initiated the payment */
  paymentInitiatorUser?: Maybe<User>;
  /** Payee directory payment instrument id */
  paymentInstrument?: Maybe<PaymentInstrument>;
  /** Method by which the bill is being paid. */
  paymentMethod?: Maybe<BillPaymentMethod>;
  /** Payment scheduling information */
  paymentSchedule?: Maybe<BillPaymentSchedule>;
  /** When the payment is scheduled to be sent */
  paymentSendAt?: Maybe<Scalars["Time"]>;
  previousExportAttempt?: Maybe<BillExportAttempt>;
  /** Previous ERP export attempts for the bill */
  previousExportAttempts?: Maybe<Array<BillExportAttempt>>;
  /** Purchase order associated with this bill */
  purchaseOrder?: Maybe<PurchaseOrder>;
  /**
   * Bill recurring schedule
   * @deprecated Use paymentSchedule instead
   */
  recurringSchedule?: Maybe<BillRecurringSchedule>;
  /** Determines whether the foreign currency bill should be paid in USD (LCW) */
  sendWireInUsd?: Maybe<Scalars["Boolean"]>;
  /** For accounting purposes, the day the service was performed and not necessarily billed or paid */
  servicePerformedAt?: Maybe<Scalars["Time"]>;
  sourceAccount?: Maybe<SourceAccount>;
  /** @deprecated Use expense statuses instead */
  status: BillStatus;
  statusReason?: Maybe<BillStatusReason>;
  /** Passed along as part of the payment */
  transferDescription?: Maybe<Scalars["String"]>;
}

export interface BillPayExtensionInput {
  /** Auto approve bill if submitter is on approval chain */
  autoApprove?: InputMaybe<Scalars["Boolean"]>;
  autoSendOneTimeCardDetails?: InputMaybe<Scalars["Boolean"]>;
  /** The Brex invoice base id if the bill pay is paying a Brex Invoice */
  brexInvoiceId?: InputMaybe<Scalars["String"]>;
  /** Payee directory contact id */
  contactId?: InputMaybe<Scalars["ID"]>;
  /** When the bill is due. */
  dueAt?: InputMaybe<Scalars["Time"]>;
  /** Duplicate Status, whether or not the bill is a duplicate */
  duplicateStatus?: InputMaybe<BillDuplicateStatus>;
  /** ERP AP account. May be a user category ID or vxOption ID. */
  erpApAccountId?: InputMaybe<Scalars["ID"]>;
  /** ERP Payment account. May be a user category ID or vxOption ID. */
  erpPaymentAccountId?: InputMaybe<Scalars["ID"]>;
  /** External invoice number */
  externalInvoiceNumber?: InputMaybe<Scalars["String"]>;
  /** Invoice processing status */
  invoiceProcessingStatus?: InputMaybe<BillInvoiceProcessingStatus>;
  /**
   * Determines if principle protection is enabled.
   * If so the user will be safe from intermediary fees in international wires and be charged by Brex
   */
  isPrincipalProtectionEnabled?: InputMaybe<Scalars["Boolean"]>;
  /** Notify the recipient when payment is sent */
  notifyRecipient?: InputMaybe<Scalars["Boolean"]>;
  /** Owner user assigned to the card for pay by card payments. */
  oneTimeCardOwnerId?: InputMaybe<Scalars["ID"]>;
  /** Optional message to the recipient of the bill pay card. */
  oneTimeCardRecipientMessage?: InputMaybe<Scalars["String"]>;
  /** Payee directory payment instrument id */
  paymentInstrumentId?: InputMaybe<Scalars["ID"]>;
  /** Method by which the bill is being paid. */
  paymentMethod?: InputMaybe<BillPaymentMethod>;
  /** Recurring scheduling information */
  paymentSchedule?: InputMaybe<RecurringScheduleInput>;
  /** Purchase order associated with this bill */
  purchaseOrderId?: InputMaybe<Scalars["ID"]>;
  /** Determines whether the foreign currency bill should be paid in USD (LCW) */
  sendWireInUsd?: InputMaybe<Scalars["Boolean"]>;
  /** For accounting purposes, the day the service was performed and not necessarily billed or paid */
  servicePerformedAt?: InputMaybe<Scalars["Time"]>;
  /** Source account of the bill payment: could be BBA or EBA ID or RAD ID */
  sourceAccount?: InputMaybe<SourceAccountInput>;
  /** Passed along as part of the payment */
  transferDescription?: InputMaybe<Scalars["String"]>;
}

export interface BillPayProductDetails {
  dummyPlaceholder?: Maybe<Scalars["String"]>;
}

/** BILL PAY OPERATIONS */
export enum BillPayResourceAttribute {
  BASIC_POLICY = "BASIC_POLICY",
  BILL = "BILL",
  CASH_PAYMENT = "CASH_PAYMENT",
  EBA_CHECK_PAYMENT = "EBA_CHECK_PAYMENT",
  EBA_DOMESTIC_WIRE_PAYMENT = "EBA_DOMESTIC_WIRE_PAYMENT",
  EBA_INTERNATIONAL_ACH_PAYMENT = "EBA_INTERNATIONAL_ACH_PAYMENT",
  EBA_INTERNATIONAL_WIRE_PAYMENT = "EBA_INTERNATIONAL_WIRE_PAYMENT",
  EBA_PAYMENT = "EBA_PAYMENT",
  EBA_WIRE_PAYMENT = "EBA_WIRE_PAYMENT",
  FORWARDING_ADDRESS = "FORWARDING_ADDRESS",
  PROCUREMENT_POLICY = "PROCUREMENT_POLICY",
  QBO_INTEGRATION = "QBO_INTEGRATION",
}

export interface BillPayResourceOperation extends ResourceOperation {
  action: ResourceAction;
  attribute?: Maybe<BillPayResourceAttribute>;
}

/** Bill pay vendor extension */
export interface BillPayVendorExtension {
  /** default budget */
  defaultBudget?: Maybe<Budget>;
  /** A/P GL account for ERP integrations. */
  erpApAccount?: Maybe<UserCategory>;
  /** A/P GL account for ERP integrations. (1bstack) */
  erpApAccountVxOption?: Maybe<ExtendedFieldOption>;
  /** Payment GL account for ERP integrations. */
  erpPaymentAccount?: Maybe<UserCategory>;
  /** Payment GL account for ERP integrations. (1bstack) */
  erpPaymentAccountVxOption?: Maybe<ExtendedFieldOption>;
  /** Last user to invite the vendor to self-service onboard */
  lastInvitedByUser?: Maybe<User>;
  /** User category for ERP integrations. */
  userErpCategory?: Maybe<UserCategory>;
  /** User category for ERP integrations. (1bstack) */
  userErpCategoryVxOption?: Maybe<ExtendedFieldOption>;
}

export interface BillPayVendorExtensionInput {
  defaultBudgetId?: InputMaybe<Scalars["ID"]>;
  erpApAccountId?: InputMaybe<Scalars["ID"]>;
  erpPaymentAccountId?: InputMaybe<Scalars["ID"]>;
  userErpCategoryId?: InputMaybe<Scalars["ID"]>;
}

export interface BillPayee {
  /** The RAD that this bill is / will be paid to */
  railAccountDetails?: Maybe<RailAccountDetails>;
  /** Will be Vendor until there is a transmission / transaction */
  source?: Maybe<BillPayeeSource>;
}

export enum BillPayeeSource {
  PAYMENT = "PAYMENT",
  VENDOR = "VENDOR",
}

export interface BillPaymentDetails extends ExpensePaymentDetails {
  /** the last 4 digits of the underlying account that was used for this transaction */
  accountLast4?: Maybe<Scalars["String"]>;
  /** the payment rails that was used for this transaction. for e.g. ACH, WIRE etc. */
  method?: Maybe<BillPaymentMethod>;
}

/** An enum representing what payment methods can be used for */
export enum BillPaymentMethod {
  ACH = "ACH",
  CHEQUE = "CHEQUE",
  DOMESTIC_WIRE = "DOMESTIC_WIRE",
  EXTERNAL = "EXTERNAL",
  INTERNATIONAL_WIRE = "INTERNATIONAL_WIRE",
  LOCAL_RAILS = "LOCAL_RAILS",
  ONE_TIME_VIRTUAL_CARD = "ONE_TIME_VIRTUAL_CARD",
}

export interface BillPaymentSchedule {
  endsAt?: Maybe<Scalars["Time"]>;
  recurringRules: RecurringRules;
  recurringSchedule: BillRecurringSchedule;
  totalNumberOfPayments?: Maybe<Scalars["Int"]>;
}

export enum BillPaymentSyncType {
  ALL_PAYMENTS = "ALL_PAYMENTS",
  NONE = "NONE",
}

export type BillRecurringSchedule = BillMonthlySchedule | BillWeeklySchedule;

export interface BillResult extends MutationResult {
  errors?: Maybe<Array<BillMutationError>>;
  result?: Maybe<Bill>;
}

export interface BillRetryPaymentInput {
  id: Scalars["ID"];
  idempotencyKey: Scalars["String"];
}

export interface BillRetryPaymentResult {
  /** The bill expense that had the payment retried. */
  bill?: Maybe<Expense>;
  /** List of errors when retrying bill payment */
  errors?: Maybe<Array<BillMutationError>>;
}

export interface BillSettings {
  /** The status in which the bill will start being exported to ERP. */
  exportStartStatus?: Maybe<BillExportStartStatus>;
  /** Which bill payments to sync to ERP. */
  paymentSyncType?: Maybe<BillPaymentSyncType>;
}

export interface BillSettingsInput {
  /**
   * The status in which the bill will start being exported to ERP.
   * Optional. Absence will leave this untouched.
   */
  exportStartStatus?: InputMaybe<BillExportStartStatus>;
  /**
   * Which bill payments to sync to ERP.
   * Optional. Absence will leave this untouched.
   */
  paymentSyncType?: InputMaybe<BillPaymentSyncType>;
}

export enum BillSortKey {
  CREATED_AT = "CREATED_AT",
  SEND_AT = "SEND_AT",
  UPDATED_AT = "UPDATED_AT",
}

export enum BillSortOrder {
  ASC = "ASC",
  DESC = "DESC",
}

export enum BillStatus {
  ADMIN_APPROVAL_REQUIRED = "ADMIN_APPROVAL_REQUIRED",
  CANCELLED = "CANCELLED",
  DELETED = "DELETED",
  DRAFT = "DRAFT",
  /** @deprecated No longer supported */
  INVALID = "INVALID",
  /** @deprecated No longer supported */
  PAYMENT_CANCELLED = "PAYMENT_CANCELLED",
  PAYMENT_PROCESSED = "PAYMENT_PROCESSED",
  PAYMENT_PROCESSING = "PAYMENT_PROCESSING",
  PAYMENT_SCHEDULED = "PAYMENT_SCHEDULED",
  /** @deprecated No longer supported */
  PAYMENT_UNDER_REVIEW = "PAYMENT_UNDER_REVIEW",
}

export enum BillStatusReason {
  DESTINATION_ACCOUNT_CLOSED = "DESTINATION_ACCOUNT_CLOSED",
  DESTINATION_ACCOUNT_INSUFFICIENT_FUNDS = "DESTINATION_ACCOUNT_INSUFFICIENT_FUNDS",
  DESTINATION_ACCOUNT_NOT_FOUND = "DESTINATION_ACCOUNT_NOT_FOUND",
  DESTINATION_ACCOUNT_OTHER = "DESTINATION_ACCOUNT_OTHER",
  DESTINATION_ACCOUNT_UNAUTHORIZED = "DESTINATION_ACCOUNT_UNAUTHORIZED",
  FAILED_ACCOUNT_VERIFICATION = "FAILED_ACCOUNT_VERIFICATION",
  FAILED_FRAUD_CHECKS = "FAILED_FRAUD_CHECKS",
  FRAUD_ANALYSIS = "FRAUD_ANALYSIS",
  /** @deprecated No longer supported */
  INVALID = "INVALID",
  PAID_EXTERNALLY = "PAID_EXTERNALLY",
  PENDING_PAID_EXTERNALLY = "PENDING_PAID_EXTERNALLY",
  SOURCE_ACCOUNT_CLOSED = "SOURCE_ACCOUNT_CLOSED",
  SOURCE_ACCOUNT_INSUFFICIENT_FUNDS = "SOURCE_ACCOUNT_INSUFFICIENT_FUNDS",
  SOURCE_ACCOUNT_NOT_FOUND = "SOURCE_ACCOUNT_NOT_FOUND",
  SOURCE_ACCOUNT_OTHER = "SOURCE_ACCOUNT_OTHER",
  SOURCE_ACCOUNT_UNAUTHORIZED = "SOURCE_ACCOUNT_UNAUTHORIZED",
  SYSTEM_CANCELED = "SYSTEM_CANCELED",
  USER_CANCELED = "USER_CANCELED",
  VERIFYING_ACCOUNT = "VERIFYING_ACCOUNT",
}

/**
 * Vendor derived out of the vendor information extracted by OCR. It may be matched with an existing vendor
 * or created in case there is not match.
 */
export interface BillSuggestionVendor {
  /** Indicates if an OCR derived field was matched, created or calculated. */
  resolution?: Maybe<DerivedFieldResolution>;
  /** Stored vendor field value. */
  value?: Maybe<VendorDetails>;
}

export interface BillSyncError extends Node {
  bill?: Maybe<Bill>;
  errorMessage?: Maybe<Scalars["String"]>;
  errorType?: Maybe<Scalars["String"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  idempotencyKey?: Maybe<Scalars["String"]>;
  insertedAt?: Maybe<Scalars["Time"]>;
  operation?: Maybe<Scalars["String"]>;
  rawResponse?: Maybe<Scalars["Json"]>;
  requestPayload?: Maybe<Scalars["Json"]>;
  status: SyncStatus;
  updatedAt?: Maybe<Scalars["Time"]>;
}

export interface BillSyncErrorConnection {
  edges?: Maybe<Array<Maybe<BillSyncErrorEdge>>>;
  pageInfo: PageInfo;
}

export interface BillSyncErrorEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<BillSyncError>;
}

export interface BillTransmission {
  returnedAmount?: Maybe<FinancialAsset>;
}

export interface BillTransmissionInfo {
  returnedAmount?: Maybe<FinancialAsset>;
  transferDetails?: Maybe<TransferDetails>;
}

/** An error that occurred when updating the payment details of a Bill. */
export interface BillUpdatePaymentDetailError extends StandardClientError {
  /** Error code. */
  code: ErrorCode;
  /** The ID of the expense that caused the error (if applicable). */
  expenseId?: Maybe<Scalars["ID"]>;
  /** Error message. */
  message: Scalars["String"];
  /** The path to the field or expense that caused the error. */
  path: Array<Scalars["String"]>;
}

/**
 * The result of updating the payment details of a Bill.
 * It can be an "Expense" (Bills are Expenses) or an "Error" (if the bill failed to update).
 */
export type BillUpdatePaymentDetailResult =
  | BillUpdatePaymentDetailError
  | Expense;

/**
 * Input for updating the payment details of Bills.
 *
 * Groups are bundles of Expenses that will have the same payment date and source account.
 */
export interface BillUpdatePaymentDetailsInput {
  /** clientMutationId */
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** The groups of Bills to update. */
  groups: Array<BillGroupUpdatePaymentDetailsInput>;
}

/**
 * The result of updating the payment details of Bills.
 *
 * We return a list of bills that were updated or errors for those updates.
 * The input for this mutation is a list of groups, but
 * we can flatten that result because what we care about is the resulting Bills (a bill in a group might fail, but, the rest could succeed.)
 */
export interface BillUpdatePaymentDetailsResult {
  /** A list of bills that were updated, with errors for those that failed to update. */
  results: Array<BillUpdatePaymentDetailResult>;
}

export interface BillWeeklySchedule {
  dayOfWeek?: Maybe<BusinessDays>;
  nWeeks: Scalars["Int"];
}

/** The billable state, ie: if the billing configuration is enabled yet */
export enum BillableState {
  /** Configuration no longer in use, spend is disabled */
  ARCHIVED = "ARCHIVED",
  /** Spend is enabled */
  ENABLED = "ENABLED",
  /** Spend is not yet enabled */
  PENDING = "PENDING",
  /** Configuration pending to archive, spend is disabled */
  PENDING_ARCHIVAL = "PENDING_ARCHIVAL",
  /** Billed entity failed verification check, spend is disabled */
  REJECTED = "REJECTED",
}

export enum BillableStatus {
  BILLABLE = "BILLABLE",
  HAS_BEEN_BILLED = "HAS_BEEN_BILLED",
  NOT_BILLABLE = "NOT_BILLABLE",
}

export interface BillingAddress {
  address1?: Maybe<Scalars["String"]>;
  address2?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  state?: Maybe<Scalars["String"]>;
  zip?: Maybe<Scalars["String"]>;
}

export enum BillingCycle {
  BI_WEEKLY = "BI_WEEKLY",
  EVERY_N_DAYS = "EVERY_N_DAYS",
  MONTHLY = "MONTHLY",
  SEMI_MONTHLY = "SEMI_MONTHLY",
  SEMI_WEEKLY = "SEMI_WEEKLY",
  WEEKLY = "WEEKLY",
}

export interface BillingCycleBiweeklyInput {
  /**
   * 1-based day of the week, with Sunday as 1
   * https://hexdocs.pm/elixir/1.12/Date.html#day_of_week/2
   */
  dayOfWeek: Scalars["Int"];
  /** When the start the cycle */
  startingAt: Scalars["Date"];
}

export interface BillingCycleEveryNDaysInput {
  /** The number of days a cycle lasts */
  numDays: Scalars["Int"];
  /** When the start the cycle */
  startingAt: Scalars["Date"];
}

export interface BillingCycleMonthlyInput {
  /** The day of the month */
  dayOfMonth: Scalars["Int"];
}

export interface BillingCycleOneOfInput {
  /** A cycle reoccurring every other week on a particular day of the week. */
  biweekly?: InputMaybe<BillingCycleBiweeklyInput>;
  /** The chosen type of cycle */
  cycleType: BillingCycle;
  /** A cycle reoccurring every N days. */
  everyNDays?: InputMaybe<BillingCycleEveryNDaysInput>;
  /** A cycle reoccurring every month on the same day of the month. */
  monthly?: InputMaybe<BillingCycleMonthlyInput>;
  /** A cycle reoccurring every month on the same two days of every month. */
  semiMonthly?: InputMaybe<BillingCycleSemiMonthlyInput>;
  /** A cycle reoccurring twice a week on two particular days. */
  semiWeekly?: InputMaybe<BillingCycleSemiWeeklyInput>;
  /** A cycle reoccurring once a week on a particular day. */
  weekly?: InputMaybe<BillingCycleWeeklyInput>;
}

export interface BillingCycleSemiMonthlyInput {
  /** The first day of the month */
  firstDay: Scalars["Int"];
  /** The second day of the month */
  secondDay: Scalars["Int"];
}

export interface BillingCycleSemiWeeklyInput {
  /**
   * The first instance as a 1-based day of the week, with Sunday as 1
   * https://hexdocs.pm/elixir/1.12/Date.html#day_of_week/2
   */
  firstDay: Scalars["Int"];
  /**
   * The second instance as a 1-based day of the week, with Sunday as 1
   * https://hexdocs.pm/elixir/1.12/Date.html#day_of_week/2
   */
  secondDay: Scalars["Int"];
}

export interface BillingCycleWeeklyInput {
  /**
   * 1-based day of the week, with Sunday as 1
   * https://hexdocs.pm/elixir/1.12/Date.html#day_of_week/2
   */
  dayOfWeek: Scalars["Int"];
}

export interface BillingDelinquency extends Node {
  asOf?: Maybe<Scalars["Time"]>;
  /** Only populated for customer level */
  customerAccountId?: Maybe<Scalars["String"]>;
  daysPastDue?: Maybe<Scalars["Int"]>;
  daysPastDueWithInflightCollections?: Maybe<Scalars["Int"]>;
  dueAmount?: Maybe<FinancialAsset>;
  dueAmountUsdCents?: Maybe<Scalars["Int"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  /** Only populated for entity level */
  journalAccountId?: Maybe<Scalars["String"]>;
}

export interface BillingFrequency {
  /** The frequency of the billing */
  billingPeriod: BillingFrequencyPeriod;
  /** When the billing happens */
  billingSchedule: BillingFrequencySchedule;
}

export enum BillingFrequencyPeriod {
  ANNUALLY = "ANNUALLY",
  MONTHLY = "MONTHLY",
  QUARTERLY = "QUARTERLY",
}

/**  ---[ Enums ]-------------------------- */
export enum BillingFrequencySchedule {
  IN_ADVANCE = "IN_ADVANCE",
  IN_ARREARS = "IN_ARREARS",
}

/**  ---[ Resource Types ]--- */
export interface BillingGroup {
  /** Account settings for the customer account and billing entity pair */
  accountSetting?: Maybe<AccountSetting>;
  /**
   * Whether funds are automatically pulled from the funding source to pay a bill.
   * Will be DISABLED if no autocollection is needed for the billing group.
   * Will be Null for invalid or unrecognized values
   */
  autoCollectionStatus?: Maybe<AutoCollectionStatus>;
  /**
   * Account used for automatic collections.
   * Resolved by Rail Account Details.
   */
  autopayAccount?: Maybe<RailAccountDetails>;
  /** Represents the state of the billing configuration */
  billableState: BillableState;
  /** The billed entity of that billing group/configuration */
  billedEntity: LegalEntity;
  /**
   * The currencies on which the billing group may be billed
   * @deprecated Deprecated, use billing financial instrument instead
   */
  billingCurrencies?: Maybe<Array<Scalars["String"]>>;
  /**
   * Utilization, in the billing currency of the billing entity, for this group's billing entity.
   * The utilization includes the credit balance and it takes pending amounts into account
   * @deprecated Deprecated, use productDetails.balances.billingCurrencyUtilization
   */
  billingCurrencyUtilization: FinancialAsset;
  /** The currencies on which the billing group may be billed */
  billingFinancialInstrument?: Maybe<FinancialInstrument>;
  /** Currently billing policy including cycle and applicable date */
  billingPolicy?: Maybe<BillingPolicy>;
  /**
   * The difference between remaining balance and pending collection amount
   * for the journal account
   */
  collectableBalance?: Maybe<FinancialAsset>;
  /** Current billing period for the journal account */
  currentBillingPeriod?: Maybe<PaymentBillingPeriod>;
  /** The delinquency related to the billing group's billable entity's journal account */
  delinquency?: Maybe<BillingGroupDelinquency>;
  /** The display name of this billing group */
  displayName?: Maybe<Scalars["String"]>;
  /**
   * Includes how much is due for next payment and when
   * it is due
   */
  estimatedUpcomingPayment: EstimatedUpcomingPayment;
  /**
   * List of estimated upcoming payments for the billing group's
   * billing entity
   */
  estimatedUpcomingPayments: Array<EstimatedUpcomingPayment>;
  /** Funding source for the billing group billing entity */
  fundingSource?: Maybe<FundingSource>;
  /** Billing Configuration id */
  id: Scalars["ID"];
  /**
   * True if underlying autopay account has been verified
   * and automatic collection has been enabled.
   */
  isAutopayActivationReady?: Maybe<Scalars["Boolean"]>;
  /** Whether this is the default billing group */
  isDefault?: Maybe<Scalars["Boolean"]>;
  /** True if the billing group requires manual push payments. */
  isPushPayments?: Maybe<Scalars["Boolean"]>;
  /** The journal account related to the billing group's billing entity */
  journalAccount?: Maybe<BillingGroupJournalAccount>;
  /** Latest bill billed to the billing group's billed entity */
  latestBill?: Maybe<LatestBill>;
  /** User initiated status indicating payment of the most recent bill */
  manualPushPaymentStatus?: Maybe<ManualPushPaymentStatus>;
  /** The most recent payment made by the billing group's billing entity */
  mostRecentCollection?: Maybe<CollectionPromise>;
  /**
   * The most recent payment made by the billing group's billing entity
   * @deprecated Deprecated, use mostRecentCollection instead
   */
  mostRecentPayment?: Maybe<PaymentIntent>;
  /** The name of this billing group */
  name?: Maybe<Scalars["String"]>;
  /**  Product specific fields related to the billing group */
  productDetails: BillingGroupProductDetails;
  /** The product type that this billing group is supporting. (CARD or REIMBURSEMENTS) */
  productType?: Maybe<BillingGroupProductType>;
  /**
   * Details on the PushPaymentsAccount associated with the billing group
   * Currently supports a single account per journal id
   */
  pushPaymentsAccount?: Maybe<PushPaymentsAccount>;
  /**
   * Remaining balance for the journal account of
   * the billing group's billing entity
   */
  remainingBalance: FinancialAsset;
  /** All entities related to that billing group/configuration */
  spendingEntities?: Maybe<LegalEntityConnection>;
  /**
   * How much that billing group owes in the billing entity's currency, includes expenses
   * that aren't due yet
   */
  totalBalance: FinancialAsset;
}

/** BillingGroup connection for pagination */
export interface BillingGroupConnection extends Connection {
  edges?: Maybe<Array<BillingGroupEdge>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
  totalCreditUsdClearedBalance?: Maybe<FinancialAsset>;
  totalReimbursementConvertedBalance?: Maybe<FinancialAsset>;
}

/** The delinquency related to the billing group's billable entity's journal account */
export interface BillingGroupDelinquency {
  /** The date on which that journal account got in the delinquent state */
  asOf?: Maybe<Scalars["Time"]>;
  /** How long since last collection, journal account is delinquent if > 0 */
  daysPastDueWithInflightCollections?: Maybe<Scalars["Int"]>;
  /** How much is owed from the latest bill */
  dueAmount?: Maybe<FinancialAsset>;
  /** The id of the least recent unpaid bill */
  leastRecentUnpaidBillId: Scalars["ID"];
  /** When the least recent unpaid bill is due */
  leastRecentUnpaidBillTime?: Maybe<Scalars["Time"]>;
  /** Least recent unpaid bill date time that considers inflight collections */
  leastRecentUnpaidBillWithInflightCollectionsTime?: Maybe<Scalars["Time"]>;
  /** The id of the most recent unpaid bill */
  mostRecentUnpaidBillId: Scalars["ID"];
  /** When the most recent unpaid bill is due */
  mostRecentUnpaidBillTime?: Maybe<Scalars["Time"]>;
}

/** BillingGroup edge */
export interface BillingGroupEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<BillingGroup>;
}

export interface BillingGroupFilterInput {
  /** Filter by billable state */
  billableStates?: InputMaybe<Array<BillableState>>;
  /** The ids to be queried */
  billingGroupsIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Filter for specific products */
  productTypes?: InputMaybe<Array<BillingGroupProductType>>;
}

/** The journal account related to the billing group's billing entity */
export interface BillingGroupJournalAccount {
  id: Scalars["ID"];
}

export type BillingGroupProductDetails =
  | BillPayProductDetails
  | CardProductDetails
  | EmployeeTrackingProductDetails
  | ReimbursementProductDetails
  | TransactionFeesProductDetails;

/** The different product types of billing groups */
export enum BillingGroupProductType {
  BILL_PAY = "BILL_PAY",
  CARD = "CARD",
  EMPLOYEE_TRACKING = "EMPLOYEE_TRACKING",
  REIMBURSEMENTS = "REIMBURSEMENTS",
  TRANSACTION_FEES = "TRANSACTION_FEES",
}

/** Invoice associated with a journal account */
export interface BillingInvoice extends BaseBillingInvoice {
  /** Invoice close time */
  closesAt?: Maybe<Scalars["Time"]>;
  /** Invoice due time */
  dueAt: Scalars["Time"];
  entryBreakdown?: Maybe<Array<BillingInvoiceEntryImpact>>;
  /** Invoice Id */
  id: Scalars["ID"];
  /** invoice number */
  invoiceNumber: Scalars["String"];
  /** journal account id */
  journalAccountId: Scalars["String"];
  nonPaymentBalance: FinancialAsset;
  /** originator id */
  originatorId: Scalars["String"];
  /** Invoice originator type */
  originatorType: BillingInvoiceOriginatorType;
  /** remaining balance in the invoice */
  remainingBalance: FinancialAsset;
  /** Invoice start time */
  startsAt?: Maybe<Scalars["Time"]>;
  /** Invoice status */
  status: BillingInvoiceStatus;
  /** total debits in the invoice */
  totalDebits: FinancialAsset;
}

/** An Invoice connection for Invoice pagination. */
export interface BillingInvoiceConnection extends Connection {
  /** The invoices in the current page of results. */
  edges: Array<BillingInvoiceEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of invoices matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

/** An Invoice edge for the Invoice connection. */
export interface BillingInvoiceEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The invoice at this edge. */
  node?: Maybe<BillingInvoice>;
}

export interface BillingInvoiceEntryImpact {
  activityOriginatorType: ActivityOriginatorType;
  numberOfEntries: Scalars["Int"];
  totalImpact?: Maybe<FinancialAsset>;
}

/** Enum for invoice originator */
export enum BillingInvoiceOriginatorType {
  CUSTOMER_USER = "CUSTOMER_USER",
  RECURRENT_BILLING_POLICY = "RECURRENT_BILLING_POLICY",
}

/** Enum for invoice status */
export enum BillingInvoiceStatus {
  CLOSED = "CLOSED",
  DUE = "DUE",
  OPEN = "OPEN",
  PAID = "PAID",
  PAST_DUE = "PAST_DUE",
}

/** An Invoice connection for Invoice pagination. */
export interface BillingInvoiceV2Connection extends Connection {
  /** The invoices in the current page of results. */
  edges: Array<BillingInvoiceV2Edge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of invoices matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

/** An Invoice edge for the Invoice connection. */
export interface BillingInvoiceV2Edge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The invoice at this edge. */
  node: BaseBillingInvoice;
}

export interface BillingInvoicesFilterInput {
  /** Invoice status */
  billingInvoiceStatus?: InputMaybe<Array<BillingInvoiceStatus>>;
  /** Journal Account ID */
  journalAccountId?: InputMaybe<Scalars["String"]>;
}

export interface BillingInvoicesFilterInputV2 {
  /** Invoice status */
  billingInvoiceStatus?: InputMaybe<Array<BillingInvoiceStatus>>;
  /** Journal Account IDs */
  journalAccountIds?: InputMaybe<Array<Scalars["String"]>>;
  /** Owner types of journal account */
  ownerTypes?: InputMaybe<Array<BillingJournalAccountOwnerType>>;
}

export interface BillingInvoicesOrderInput {
  order: OrderByDirection;
}

/** A Billing Journal Account. */
export interface BillingJournalAccount {
  /** id */
  id: Scalars["ID"];
  /** Expected next due amount and date when customer has a liability to brex */
  nextDueAmount?: Maybe<BillingUpcomingDueAmount>;
  /** Product type for journal */
  ownerType: BillingJournalAccountOwnerType;
}

/** A Journal Account connection for Journal Account pagination. */
export interface BillingJournalAccountConnection extends Connection {
  /** The fees in the current page of results. */
  edges: Array<BillingJournalAccountEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of fees matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

/** A Journal Account edge for the Journal Account connection. */
export interface BillingJournalAccountEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The Journal Account at this edge. */
  node?: Maybe<BillingJournalAccount>;
}

/** Enum for Journal Account Product Type */
export enum BillingJournalAccountOwnerType {
  CARD = "CARD",
  REIMBURSEMENT_SPENDING = "REIMBURSEMENT_SPENDING",
  SAAS_BILLING_ACCOUNT = "SAAS_BILLING_ACCOUNT",
  TRANSACTION_FEE = "TRANSACTION_FEE",
}

export interface BillingJournalAccountsFilterInput {
  /** Customer account id */
  customerAccountId?: InputMaybe<Scalars["String"]>;
  /** Journal owner type (product type) */
  journalAccountOwnerType?: InputMaybe<Array<BillingJournalAccountOwnerType>>;
}

/** The information about an attempt to make a payment */
export interface BillingPayment extends Node {
  /** The amount of this payment that has been collected */
  collectedAmount: FinancialAsset;
  /** The time at which the payment most recently completed */
  collectedAt?: Maybe<Scalars["Time"]>;
  /** The customer account id of this payment */
  customerAccountId: Scalars["String"];
  /** The cause of failure */
  failureType?: Maybe<PaymentFailureType>;
  /** The ID of an object */
  id: Scalars["ID"];
  /** The time at which the payment was initiated */
  initiatedAt?: Maybe<Scalars["Time"]>;
  /** The details of who/what initiated the payment */
  initiatedBy: InitiatedBy;
  /**
   * Whether this payment is collected from the funding source of a the parent entity
   *      when the target entity fails to send push payments or make payment on time.
   */
  isCollectedFromParentEntity?: Maybe<Scalars["Boolean"]>;
  /** The legal entity id of this payment */
  legalEntitiesLegalEntityId?: Maybe<Scalars["String"]>;
  /** The product type of this billing payment */
  productType: PaymentProductType;
  /** The backend data model id of this billing payment */
  rawId: Scalars["String"];
  /** The amount for which this payment was requested */
  requestedAmount: FinancialAsset;
  /** The amount of this payment that has been reversed */
  reversedAmount: FinancialAsset;
  /** The time the payment was scheduled for */
  scheduledFor: Scalars["Time"];
  /** The details about the source of this payment */
  source?: Maybe<BillingPaymentSource>;
  /** The life cycle status of this payment */
  status: PaymentStatus;
}

export interface BillingPaymentConnection {
  edges?: Maybe<Array<Maybe<BillingPaymentEdge>>>;
  pageInfo: PageInfo;
  /** Total number of billing payments that match the requested query. */
  totalCount: Scalars["Int"];
}

export interface BillingPaymentEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<BillingPayment>;
}

/** An intent to pay a balance towards one or more target accounts */
export interface BillingPaymentIntent extends Node {
  /** The time at which the payment most recently completed */
  collectedAt?: Maybe<Scalars["Time"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  /** The time at which the payment was initiated */
  initiatedAt?: Maybe<Scalars["Time"]>;
  /** An enum representation of the source of funds for this payment */
  sourceType: BillingPaymentIntentSourceType;
  /** The life cycle status of this payment */
  status: BillingPaymentIntentStatus;
  /** The amount for which this payment was collected */
  totalCollectedAmount?: Maybe<FinancialAsset>;
  /** The amount for which this payment was requested */
  totalRequestedAmount?: Maybe<FinancialAsset>;
  /** Integration user category */
  userCategory?: Maybe<UserCategory>;
}

export interface BillingPaymentIntentConnection {
  edges?: Maybe<Array<Maybe<BillingPaymentIntentEdge>>>;
  pageInfo: PageInfo;
}

export interface BillingPaymentIntentEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<BillingPaymentIntent>;
}

export enum BillingPaymentIntentSourceType {
  COLLECT_FUNDING_SOURCE = "COLLECT_FUNDING_SOURCE",
  DEPOSITS_ACCOUNT = "DEPOSITS_ACCOUNT",
  OFFLINE = "OFFLINE",
  PAYEE_DIRECTORY_PAYMENT_INSTRUMENT = "PAYEE_DIRECTORY_PAYMENT_INSTRUMENT",
  REWARDS_REDEMPTION = "REWARDS_REDEMPTION",
}

export enum BillingPaymentIntentStatus {
  CANCELED = "CANCELED",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  INVALID = "INVALID",
  IN_PROGRESS = "IN_PROGRESS",
  PENDING = "PENDING",
}

export type BillingPaymentSource =
  | BankingGatewayAccount
  | DepositsAccount
  | FundingSource
  | OfflineSource
  | RailAccountDetails
  | RewardsRedemptionSource;

export enum BillingPaymentStatus {
  CANCELED = "CANCELED",
  FAILED = "FAILED",
  PENDING = "PENDING",
  PROCESSED = "PROCESSED",
  SCHEDULED = "SCHEDULED",
}

export interface BillingPeriod {
  endPeriod: Scalars["Time"];
  startPeriod: Scalars["Time"];
}

/** Represents the cycle and date of a billing policy */
export interface BillingPolicy {
  /** Grace period granted to the journal account */
  billFloat?: Maybe<BillFloat>;
  /** Details relating to the cycle type */
  cycleDetails?: Maybe<CycleDetails>;
  /** Which billing cycle the journal account is on */
  cycleType?: Maybe<BillingCycle>;
}

/** A Transaction processed by Billing system */
export interface BillingTransaction {
  amount: FinancialAsset;
  id: Scalars["ID"];
  postedAt: Scalars["Time"];
  statement?: Maybe<Statement>;
  totalBalance?: Maybe<FinancialAsset>;
  transactionMetadata: TransactionMetadata;
  type: BillingTransactionType;
  user?: Maybe<User>;
}

export interface BillingTransactionConnection extends Connection {
  /** The billing transactions in the current page of results. */
  edges: Array<BillingTransactionEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of billing transactions matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface BillingTransactionEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The billing transaction at this edge. */
  node: BillingTransaction;
}

/**
 * BillingTransactionFilterInput needs to match GenerateTransactionsReportFilterInput in global_financial_services/statements_v2/src/main/resources/schema.graphqls
 * The Core Platform team advises teams to prefer duplication over shared types. https://brexhq.atlassian.net/wiki/spaces/ENGDOC/pages/1653538928/Shared+GraphQL+Types#Adding%2FChanging-Shared-types
 *
 * ATTENTION: PLEASE MAKE SURE BillingTransactionFilterInput MATCHES GenerateTransactionsReportFilterInput.
 * ANY CHANGES TO THIS TYPE SHOULD BE REFLECTED IN GenerateTransactionsReportFilterInput AND VICE VERSA.
 */
export interface BillingTransactionFilterInput {
  /** Filter for card transactions from partnership-based cards */
  cardPartnerIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Filter for transactions with a date later than this value. */
  from?: InputMaybe<Scalars["Time"]>;
  /** Filter for transactions from specific journal account */
  journalAccountId: Scalars["ID"];
  /** Filter for transactions from a list of entities */
  legalEntities?: InputMaybe<Array<Scalars["ID"]>>;
  /** Filter for transactions with an amount less than or equal to this value (in entity's currency) */
  maxAmount?: InputMaybe<Scalars["Decimal"]>;
  /** Filter for transactions from a list of merchants */
  merchants?: InputMaybe<Array<Scalars["ID"]>>;
  /** Filter for transactions with an amount greater than or equal to this value (in entity's currency) */
  minAmount?: InputMaybe<Scalars["Decimal"]>;
  /** Filter for transactions with a date earlier than this value. */
  to?: InputMaybe<Scalars["Time"]>;
  /** Filter for transactions with specific BillingTransactionStatus(es) */
  transactionStatuses?: InputMaybe<Array<BillingTransactionStatus>>;
  /** Filter for transactions with specific BillingTransactionType(s) */
  transactionTypes?: InputMaybe<Array<BillingTransactionType>>;
  /** Filter for transactions from a list of employees */
  users?: InputMaybe<Array<Scalars["ID"]>>;
}

export interface BillingTransactionOrderInput {
  direction: OrderByDirection;
  field: SortableBillingTransactionField;
}

/**
 * BillingTransactionStatus needs to match BillingTransactionType in global_financial_services/statements_v2/src/main/resources/schema.graphqls
 * The Core Platform team advises teams to prefer duplication over shared types.
 * See the section 'Adding/Changing Shared types' in https://brexhq.atlassian.net/wiki/spaces/ENGDOC/pages/1653538928/Shared+GraphQL+Types
 *
 * ATTENTION: PLEASE MAKE SURE ANY CHANGES TO THIS TYPE SHOULD BE REFLECTED IN statements_v2 AND VICE VERSA.
 */
export enum BillingTransactionStatus {
  CANCELED = "CANCELED",
  FAILED = "FAILED",
  PENDING = "PENDING",
  PROCESSED = "PROCESSED",
  SCHEDULED = "SCHEDULED",
}

/**
 * BillingTransactionType needs to match BillingTransactionType in global_financial_services/statements_v2/src/main/resources/schema.graphqls
 * The Core Platform team advises teams to prefer duplication over shared types.
 * See the section 'Adding/Changing Shared types' in https://brexhq.atlassian.net/wiki/spaces/ENGDOC/pages/1653538928/Shared+GraphQL+Types
 *
 * ATTENTION: PLEASE MAKE SURE ANY CHANGES TO THIS TYPE SHOULD BE REFLECTED IN statements_v2 AND VICE VERSA.
 */
export enum BillingTransactionType {
  /**  Payment */
  AUTO_PAYMENT = "AUTO_PAYMENT",
  CHARGEBACK_CREDIT = "CHARGEBACK_CREDIT",
  CHARGEBACK_DEBIT = "CHARGEBACK_DEBIT",
  /**  Card */
  CLEARING = "CLEARING",
  ONE_TIME_PAYMENT = "ONE_TIME_PAYMENT",
  PAYMENT_REVERSAL = "PAYMENT_REVERSAL",
  PUSH_PAYMENT = "PUSH_PAYMENT",
  REFUND = "REFUND",
  /**  Reward Redemption */
  REWARD_CASHBACK_CREDIT = "REWARD_CASHBACK_CREDIT",
  /**  Reward Redemption */
  REWARD_REDEMPTION = "REWARD_REDEMPTION",
  /**  Fee */
  TRANSACTION_FEE = "TRANSACTION_FEE",
  /**  Transferred Purchase */
  TRANSFERRED_PURCHASE = "TRANSFERRED_PURCHASE",
  WITHDRAWAL = "WITHDRAWAL",
}

export interface BillingUpcomingDueAmount {
  amountDue: FinancialAsset;
  dueAt: Scalars["Time"];
}

export interface BiweeklyClosingStrategy {
  dayOfWeek?: Maybe<Scalars["Int"]>;
}

/** Contains the details of the current application blueprint */
export interface Blueprint {
  /** Name of the blueprint type */
  name: Scalars["String"];
}

export interface BoInformationInput {
  ownershipPercentage: Scalars["Int"];
  relationship: KYCIdentityIndividualTitle;
}

export interface BookTransferDetails {
  sourceDepositsAccount?: Maybe<DepositsAccount>;
  targetDepositsAccount?: Maybe<DepositsAccount>;
}

/** Filter for whose bookings to show. It can show the bookings made by the direct reports of the current user, bookings made by the current user, or all reports of the user. */
export enum BookedBy {
  ALL_REPORTS = "ALL_REPORTS",
  DIRECT_REPORTS = "DIRECT_REPORTS",
  ME = "ME",
}

/** Status of the user who booked a trip, at the time of booking. */
export enum BookerStatus {
  REGULAR = "REGULAR",
  VIP = "VIP",
}

export interface Booking {
  /** Base price in the original currency of the booking. */
  base?: Maybe<FinancialAsset>;
  /** The approximate base amount when converted to the billing currency. */
  billingBase?: Maybe<FinancialAsset>;
  /** The approximate surcharges amount when converted to the billing currency. */
  billingSurcharges?: Maybe<FinancialAsset>;
  /** The approximate tax amount when converted to the billing currency. */
  billingTax?: Maybe<FinancialAsset>;
  /** The approximate total amount when converted to the billing currency. Does not include travel credit. */
  billingTotal?: Maybe<FinancialAsset>;
  /** ID of the user who created the trip. */
  bookerCustomerUser?: Maybe<User>;
  /** Source of the booking. */
  bookingSource?: Maybe<Scalars["String"]>;
  /** Name of the booking source, i.e. Spotnana, Group Event ID, etc. */
  bookingSourceName?: Maybe<Scalars["String"]>;
  /** Class, e.g. economy, premium etc */
  carClass?: Maybe<Scalars["String"]>;
  /** Confirmation code */
  carConfirmationCode?: Maybe<Scalars["String"]>;
  /** Address where drop off is located */
  carDropOffAddress?: Maybe<Scalars["String"]>;
  /** City where drop off is located */
  carDropOffCity?: Maybe<Scalars["String"]>;
  /** Country where drop off is located */
  carDropOffCountry?: Maybe<Scalars["String"]>;
  /** State where drop off is located */
  carDropOffState?: Maybe<Scalars["String"]>;
  /** Timezone where drop off is located */
  carDropOffTimezone?: Maybe<Scalars["String"]>;
  /** Unix Epoch drop off timestamp */
  carEpochDropOff?: Maybe<Scalars["LocalDateTime"]>;
  /** Unix Epoch pick up timestamp */
  carEpochPickUp?: Maybe<Scalars["LocalDateTime"]>;
  /** Local drop off time as iso8601 */
  carLocalDropOffTime?: Maybe<Scalars["String"]>;
  /** Local pick up time as iso8601 */
  carLocalPickUpTime?: Maybe<Scalars["String"]>;
  /** Rental car company vendor code, e.g. ZE for Hertz */
  carMerchantVendorCode?: Maybe<Scalars["String"]>;
  /** Payment type used for the car rental booking */
  carPaymentType?: Maybe<Scalars["String"]>;
  /** Address where pick up is located */
  carPickUpAddress?: Maybe<Scalars["String"]>;
  /** City where pick up is located */
  carPickUpCity?: Maybe<Scalars["String"]>;
  /** Country where pick up is located */
  carPickUpCountry?: Maybe<Scalars["String"]>;
  /** State where pick up is located */
  carPickUpState?: Maybe<Scalars["String"]>;
  /** Timezone where pick up is located */
  carPickUpTimezone?: Maybe<Scalars["String"]>;
  /** Company the trip belongs to. */
  customerAccountId?: Maybe<Scalars["String"]>;
  /** End date of the associated Trip. */
  endDate?: Maybe<Scalars["Date"]>;
  /** Flight arrival cities */
  flightArrivalCities?: Maybe<Scalars["String"]>;
  /** Flight arrival countries */
  flightArrivalCountries?: Maybe<Scalars["String"]>;
  /** Flight arrival states */
  flightArrivalStates?: Maybe<Scalars["String"]>;
  /** Flight arrival times */
  flightArrivalTimes?: Maybe<Scalars["String"]>;
  /** Flight arrival timezones */
  flightArrivalTimezones?: Maybe<Scalars["String"]>;
  /** Flight classes */
  flightClasses?: Maybe<Scalars["String"]>;
  /** Flight departure cities */
  flightDepartureCities?: Maybe<Scalars["String"]>;
  /** Flight departure countries */
  flightDepartureCountries?: Maybe<Scalars["String"]>;
  /** Flight departure states */
  flightDepartureStates?: Maybe<Scalars["String"]>;
  /** Flight departure times */
  flightDepartureTimes?: Maybe<Scalars["String"]>;
  /** Flight departure timezones */
  flightDepartureTimezones?: Maybe<Scalars["String"]>;
  /** Flight destination 3 letter IATA airport codes */
  flightDestinations?: Maybe<Scalars["String"]>;
  /** Flight durations in seconds */
  flightDurationsSeconds?: Maybe<Scalars["String"]>;
  /** Flight marketing airline codes */
  flightMarketingAirlineCodes?: Maybe<Scalars["String"]>;
  /** Flight marketing airline names */
  flightMarketingAirlineNames?: Maybe<Scalars["String"]>;
  /** Flight marketing flight numbers */
  flightMarketingFlightNumbers?: Maybe<Scalars["String"]>;
  /** Flight operating airline codes */
  flightOperatingAirlineCodes?: Maybe<Scalars["String"]>;
  /** Flight operating airline names */
  flightOperatingAirlineNames?: Maybe<Scalars["String"]>;
  /** Flight operating flight numbers */
  flightOperatingFlightNumbers?: Maybe<Scalars["String"]>;
  /** Flight origin 3 letter IATA airport codes */
  flightOrigins?: Maybe<Scalars["String"]>;
  /** Flight routes */
  flightRoutes?: Maybe<Scalars["String"]>;
  /** The booking ID */
  id: Scalars["ID"];
  /** Address where the lodging is located */
  lodgingAddress?: Maybe<Scalars["String"]>;
  /** Brand name of the lodging */
  lodgingBrandName?: Maybe<Scalars["String"]>;
  /** Chain name of the lodging */
  lodgingChainName?: Maybe<Scalars["String"]>;
  /** City where the lodging is located */
  lodgingCity?: Maybe<Scalars["String"]>;
  /** Country where the lodging is located */
  lodgingCountry?: Maybe<Scalars["String"]>;
  /** Unix Epoch check in timestamp */
  lodgingEpochCheckIn?: Maybe<Scalars["LocalDateTime"]>;
  /** Unix Epoch check out timestamp */
  lodgingEpochCheckOut?: Maybe<Scalars["LocalDateTime"]>;
  /** Local check in time as iso8601 */
  lodgingLocalCheckInTime?: Maybe<Scalars["String"]>;
  /** Local check out time as iso8601 */
  lodgingLocalCheckOutTime?: Maybe<Scalars["String"]>;
  /** Payment type used for lodging booking */
  lodgingPaymentType?: Maybe<Scalars["String"]>;
  /** Number of beds in the room */
  lodgingRoomBedCount?: Maybe<Scalars["Int"]>;
  /** Room bed type */
  lodgingRoomBedType?: Maybe<Scalars["String"]>;
  /** Room description */
  lodgingRoomDescription?: Maybe<Scalars["String"]>;
  /** Room display name */
  lodgingRoomDisplayName?: Maybe<Scalars["String"]>;
  /** State where the lodging is located */
  lodgingState?: Maybe<Scalars["String"]>;
  /** Timezone where the lodging is located */
  lodgingTimezone?: Maybe<Scalars["String"]>;
  /** Display name of the merchant of the booking. */
  merchantDisplayName?: Maybe<Scalars["String"]>;
  /** Id of the merchant of the booking. */
  merchantsMerchantId?: Maybe<Scalars["String"]>;
  /** If this booking was out of policy from our evaluation of the policy after the booking. */
  postBookingOutOfPolicy?: Maybe<Scalars["Boolean"]>;
  /** If this booking was out of policy, the reason why. */
  postBookingOutOfPolicyReason?: Maybe<Scalars["String"]>;
  /** If this booking was out of policy, a description of policies that were violated. */
  postBookingPoliciesViolated?: Maybe<Scalars["String"]>;
  /** If this booking was out of policy, a description of policies that were violated. */
  postBookingPoliciesViolatedDescription?: Maybe<Scalars["String"]>;
  /** If this booking was out of policy when the user chose this booking. */
  preBookingOutOfPolicy?: Maybe<Scalars["Boolean"]>;
  /** If this booking was out of policy, the reason why. */
  preBookingOutOfPolicyReason?: Maybe<Scalars["String"]>;
  /** If this booking was out of policy, a list of policies that were violated. */
  preBookingPoliciesViolated?: Maybe<Scalars["String"]>;
  /** If this booking was out of policy, a description of policies that were violated. */
  preBookingPoliciesViolatedDescription?: Maybe<Scalars["String"]>;
  /** Region Type of the booking. i.e. Domestic, International. */
  regionType?: Maybe<Scalars["String"]>;
  /** Id of associated Spotnana PNR. */
  spotnanaPnrId?: Maybe<Scalars["String"]>;
  /** Id of associated Spotnana trip. */
  spotnanaTripId?: Maybe<Scalars["String"]>;
  /** Start date of the associated Trip. */
  startDate?: Maybe<Scalars["Date"]>;
  /** Status of the booking. */
  status?: Maybe<Scalars["String"]>;
  /** Any surcharges are grouped into 1 money object, we can breakdown if we need it further. Represented in the original currency of the booking. */
  surcharges?: Maybe<FinancialAsset>;
  /** Tax in the original currency of the booking. */
  tax?: Maybe<FinancialAsset>;
  /** Rate information of the booking. */
  total?: Maybe<FinancialAsset>;
  /** Total flight CO2 emission in metric tonnes */
  totalFlightCo2EmissionMetricTonnes?: Maybe<Scalars["Int"]>;
  /** Credit that has been applied to a booking or ticket so the user doesn't have to pay for it. */
  travelCreditApplied?: Maybe<FinancialAsset>;
  /** Id associated with the Traveler (either cuuser or email for guests) */
  travelerId?: Maybe<Scalars["String"]>;
  /** Name of the Traveler. */
  travelerName?: Maybe<Scalars["String"]>;
  /** Type of Traveler (i.e. employee, guest etc.) */
  travelerPersona?: Maybe<Scalars["String"]>;
  /** Id of the associated trip. */
  tripId?: Maybe<Scalars["String"]>;
  /** Name of the associated trip. */
  tripName?: Maybe<Scalars["String"]>;
  /** The type of the booking */
  type: Scalars["String"];
  /** Current version of the booking. */
  version?: Maybe<Scalars["Int"]>;
}

/** A type of approval that is required for a Booking. DOES NOT apply to Expenses. */
export enum BookingApprovalType {
  /** If the Booking is not APPROVED in time, it will be automatically CANCELED. */
  HARD_APPROVAL = "HARD_APPROVAL",
  /** No approval required. */
  NONE = "NONE",
  /** If the Booking is not REJECTED in time, it will be automatically APPROVED. */
  SOFT_APPROVAL = "SOFT_APPROVAL",
}

export enum BookingBookedByFilterInput {
  ALL_REPORTS = "ALL_REPORTS",
  DIRECT_REPORTS = "DIRECT_REPORTS",
  ME = "ME",
}

/** The available fields that are queryable that relate to bookings */
export enum BookingEntityFieldKeyType {
  ALL = "ALL",
  BOOKING_TYPE = "BOOKING_TYPE",
  CAR_RENTAL_DAILY_RATE = "CAR_RENTAL_DAILY_RATE",
  CAR_RENTAL_DAYS_BOOKED = "CAR_RENTAL_DAYS_BOOKED",
  EXPENSE_PURCHASED_AT_WEEK = "EXPENSE_PURCHASED_AT_WEEK",
  LEGAL_ENTITY = "LEGAL_ENTITY",
  LODGING_AVERAGE_NIGHTLY_RATE = "LODGING_AVERAGE_NIGHTLY_RATE",
  LODGING_NIGHTS_BOOKED = "LODGING_NIGHTS_BOOKED",
  OUT_OF_POLICY_STATUS = "OUT_OF_POLICY_STATUS",
  REGION_TYPE = "REGION_TYPE",
  START_DATE_WEEK = "START_DATE_WEEK",
  STATUS = "STATUS",
  TOTAL = "TOTAL",
  TRAVELER_ID = "TRAVELER_ID",
  TRAVELER_NAME = "TRAVELER_NAME",
  TRAVELER_TYPE = "TRAVELER_TYPE",
  TRIP_DURATION = "TRIP_DURATION",
  USER_DEPARTMENT = "USER_DEPARTMENT",
}

/** Filters for the booking entity. */
export interface BookingEntityFieldMatcherInput {
  /** Matches IN whose bookings to show */
  bookedBy?: InputMaybe<BookingBookedByFilterInput>;
  /** Matches IN booker customer user ids */
  bookerUserIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Matches IN booking out of policy status */
  bookingOutOfPolicyStatuses?: InputMaybe<
    Array<BookingOutOfPolicyStatusFilterInput>
  >;
  /** Matches IN booking region types */
  bookingRegionTypes?: InputMaybe<Array<BookingRegionTypeFilterInput>>;
  /** Matches IN booking status */
  bookingStatuses?: InputMaybe<Array<BookingStatusFilterInput>>;
  /** Matches IN booking types */
  bookingTypes?: InputMaybe<Array<BookingTypeFilterInput>>;
  /** Matches IN specific budgets */
  budgetIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Filters null/non-null values for carRentalDaysBooked */
  carRentalDaysBooked?: InputMaybe<Array<Scalars["Boolean"]>>;
  /** Matches IN cost center */
  costCenterIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Matches IN departments */
  departmentIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Matches IN legal entities */
  legalEntityIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Filters null/non-null values for lodgingNightsBooked */
  lodgingNightsBooked?: InputMaybe<Array<Scalars["Boolean"]>>;
  /** Range query filter for booking expense purchase date */
  purchasedBetween?: InputMaybe<TimeIntervalInput>;
  /** Range query filter for booking travel dates */
  travelBetween?: InputMaybe<TimeIntervalInput>;
  /** Matches IN travelerId or guestEmails */
  travelerIdentifiers?: InputMaybe<BookingTravelerIdentifierFilterInput>;
  /** Matches IN traveler types */
  travelerTypes?: InputMaybe<Array<BookingTravelerTypeFilterInput>>;
}

export interface BookingFieldKeyTypeWrapper {
  key: BookingEntityFieldKeyType;
}

export enum BookingOutOfPolicyStatusFilterInput {
  IN_POLICY = "IN_POLICY",
  OUT_OF_POLICY = "OUT_OF_POLICY",
}

export enum BookingRegionTypeFilterInput {
  DOMESTIC = "DOMESTIC",
  INTERNATIONAL = "INTERNATIONAL",
}

/** A booking request. */
export interface BookingRequest extends Request {
  /**
   * Fetch actions on the Request.
   * Can be filtered e.g. to select only pending actions
   */
  actions?: Maybe<RequestActionConnection>;
  /** The approval type requested by the policy. May be null if in-policy or no policy rule applies. */
  approvalType?: Maybe<TravelBookingApprovalType>;
  /**
   * If the booking is totally non-refundable, we may override from HARD_APPROVAL to SOFT_APPROVAL.
   * Distinguishes no override from override = same as approvalType.
   */
  approvalTypeOverride?: Maybe<TravelBookingApprovalType>;
  /** The Booking which this Request was created to get approval for */
  booking?: Maybe<TravelBooking>;
  /** User that canceled the request */
  canceledBy?: Maybe<Employee>;
  /** The compliance status for the request */
  complianceStatus?: Maybe<ComplianceStatus>;
  /** When the request was created. */
  createdAt: Scalars["Time"];
  /** The employee who initiated the request. */
  createdBy?: Maybe<Employee>;
  /** Whether the current user can skip the reviewers and directly approve/deny this Booking Request. */
  currentUserCanAdminOverride?: Maybe<Scalars["Boolean"]>;
  /** The time at which the request will expire and the booking will be auto-approved or auto-rejected. */
  deadline?: Maybe<Scalars["Time"]>;
  /** The compliance status for the request that is derived from the submitter and reviewer compliance statuses. */
  derivedComplianceStatus?: Maybe<DerivedComplianceStatus>;
  /** The unique ID of the request */
  id: Scalars["ID"];
  /** The timestamp when a controller overridden the request */
  overriddenAt?: Maybe<Scalars["Time"]>;
  /** The employee who overridden the request. */
  overriddenBy?: Maybe<Employee>;
  /** User id being co-piloted when this request was overridden. */
  overriddenOnBehalfOf?: Maybe<Employee>;
  /** The employee who owns the request. */
  owner?: Maybe<Employee>;
  /**
   * The user who initiated the request
   * @deprecated Incorrect permission scoping, use requestedByEmployee instead
   */
  requestedBy?: Maybe<User>;
  /**
   * The employee who initiated the request
   * @deprecated Not clear whether this is owner or creator of request after copilot context was introduced, use owner instead
   */
  requestedByEmployee?: Maybe<Employee>;
  /** The reviewer compliance status for the request. */
  reviewerComplianceStatus?: Maybe<ComplianceStatus>;
  /** The timestamp when reviewer compliance deadline will be reached */
  reviewerDeadlineAt?: Maybe<Scalars["Time"]>;
  /** The stage of approval of the request, e.g. created, approved, denied */
  status?: Maybe<RequestStatus>;
  /** The timestamp when the submitter compliance deadline will be reached */
  submitterDeadlineAt?: Maybe<Scalars["Time"]>;
  /** Computed Request and Request Action summary for the BookingRequest */
  summary?: Maybe<RequestSummary>;
  /** Will always be BOOKING for a BookingRequest */
  type?: Maybe<RequestType>;
}

/** A booking request. */
export interface BookingRequestactionsArgs {
  filter?: InputMaybe<RequestActionFilterInput>;
  order?: InputMaybe<RequestActionOrderInput>;
  page?: InputMaybe<PaginationInput>;
}

export enum BookingRequirement {
  /** Booking is blocked for the event */
  BLOCKED = "BLOCKED",
  /** No requirements around booking (can book anywhere) */
  NONE = "NONE",
  /** Booking is already pre-booked for all guests (pre-booked data is provided in metadata) */
  PREBOOKED = "PREBOOKED",
  /** Booking is recommended, but guests can book anywhere (recommendation is provided in metadata) */
  RECOMMENDED = "RECOMMENDED",
}

/** Possible sources of a booking (e.g., internal or external). */
export enum BookingSource {
  /** Booking was made using Brex Travel */
  BREX_TRAVEL = "BREX_TRAVEL",
  /** Booking was made externally and added to trip */
  EXTERNAL = "EXTERNAL",
}

/** Status of a booking (legacy). */
export enum BookingStatus {
  CANCELED = "CANCELED",
  COMPLETED = "COMPLETED",
  CONFIRMED = "CONFIRMED",
  IN_PROGRESS = "IN_PROGRESS",
  PENDING = "PENDING",
  REFUNDED = "REFUNDED",
  VOIDED = "VOIDED",
}

export enum BookingStatusFilterInput {
  AIRLINE_CONTROL = "AIRLINE_CONTROL",
  APPROVAL_DENIED = "APPROVAL_DENIED",
  APPROVAL_REQUESTED = "APPROVAL_REQUESTED",
  CANCELED = "CANCELED",
  CANCELLATION_IN_PROGRESS = "CANCELLATION_IN_PROGRESS",
  COMPLETED = "COMPLETED",
  CONFIRMED = "CONFIRMED",
  HOLD = "HOLD",
  IN_PROGRESS = "IN_PROGRESS",
  PAYMENT_DECLINED = "PAYMENT_DECLINED",
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  REFUNDED = "REFUNDED",
  SCHEDULE_CHANGE = "SCHEDULE_CHANGE",
  UNCONFIRMED = "UNCONFIRMED",
  VOIDED = "VOIDED",
}

/** Status of a booking, including new states like PROCESSING, UNCONFIRMED, etc. */
export enum BookingStatusV2 {
  AIRLINE_CONTROL = "AIRLINE_CONTROL",
  APPROVAL_DENIED = "APPROVAL_DENIED",
  APPROVAL_REQUESTED = "APPROVAL_REQUESTED",
  CANCELED = "CANCELED",
  CANCELLATION_IN_PROGRESS = "CANCELLATION_IN_PROGRESS",
  COMPLETED = "COMPLETED",
  CONFIRMED = "CONFIRMED",
  HOLD = "HOLD",
  IN_PROGRESS = "IN_PROGRESS",
  PAYMENT_DECLINED = "PAYMENT_DECLINED",
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  REFUNDED = "REFUNDED",
  SCHEDULE_CHANGE = "SCHEDULE_CHANGE",
  UNCONFIRMED = "UNCONFIRMED",
  VOIDED = "VOIDED",
}

/** Filter for enumerating users (employees or guests) who can own or travel on the trip. */
export interface BookingTravelerIdentifierFilterInput {
  /** User IDs */
  customerUserIds?: InputMaybe<Array<Scalars["String"]>>;
  /** Raw guest emails */
  guestEmails?: InputMaybe<Array<Scalars["String"]>>;
  /** Guest IDs from the GuestTraveler object (encoded emails). */
  guestTravelerIds?: InputMaybe<Array<Scalars["String"]>>;
}

export enum BookingTravelerTypeFilterInput {
  EMPLOYEE = "EMPLOYEE",
  GUEST = "GUEST",
}

export enum BookingTypeFilterInput {
  AIR = "AIR",
  CAR_RENTAL = "CAR_RENTAL",
  LIMO = "LIMO",
  LODGING = "LODGING",
  MISC = "MISC",
  RAIL = "RAIL",
}

export interface BoolValue {
  value?: Maybe<Scalars["Boolean"]>;
}

export interface BoolValueInput {
  value?: InputMaybe<Scalars["Boolean"]>;
}

export interface BooleanFieldInstance extends ExtendedFieldInstance, Node {
  /** The instance of the value associated with this field instance. Null means unset */
  boolValue?: Maybe<Scalars["Boolean"]>;
  dependencyOfAll?: Maybe<Array<ExtendedFieldInstance>>;
  dependsOnAll?: Maybe<Array<ExtendedFieldInstance>>;
  editStatus?: Maybe<FieldEditStatus>;
  extension?: Maybe<ExtendedFieldInstanceExtension>;
  field: ExtendedField;
  /** The ID of an object */
  id: Scalars["ID"];
  updatedBy?: Maybe<ValueOriginator>;
  workflowValues?: Maybe<Array<WorkflowBooleanValue>>;
}

export interface BooleanFieldInstancedependencyOfAllArgs {
  filter?: InputMaybe<ExtendedFieldDependencyFilter>;
}

export interface BooleanFieldInstancedependsOnAllArgs {
  filter?: InputMaybe<ExtendedFieldDependencyFilter>;
}

/**  ---[ Field Instance Inputs ]------------------- */
export interface BooleanFieldInstanceInput {
  /** The client mutation id */
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fieldInstanceId: Scalars["ID"];
  /** Explicitly set this to null to clear the value */
  value?: InputMaybe<Scalars["Boolean"]>;
}

/**
 * Brazil Bank account. Includes:
 * * bank code - 3 digits.
 * * branch location where the account was opened - 5 digits.
 * * account number within the bank - 10 digits.
 * * taxpayer identifier(Cadastro de Pessoas Fisicas) - 11 digits.
 */
export interface BrLocal {
  accountNumber?: Maybe<Scalars["String"]>;
  accountType?: Maybe<BankAccountType>;
  bankCode?: Maybe<Scalars["String"]>;
  branchCode?: Maybe<Scalars["String"]>;
  cpf?: Maybe<Scalars["String"]>;
  phoneNumber?: Maybe<Scalars["String"]>;
}

/**
 * Brazil Bank account. Includes:
 * * bank code - 3 digits.
 * * branch location where the account was opened - 5 digits.
 * * account number within the bank - 10 digits.
 * * taxpayer identifier(Cadastro de Pessoas Fisicas) - 11 digits.
 */
export interface BrLocalInput {
  accountNumber?: InputMaybe<Scalars["String"]>;
  accountType?: InputMaybe<BankAccountType>;
  bankCode?: InputMaybe<Scalars["String"]>;
  branchCode?: InputMaybe<Scalars["String"]>;
  cpf?: InputMaybe<Scalars["String"]>;
  phoneNumber?: InputMaybe<Scalars["String"]>;
}

export interface BrexDataReportTemplateEntry {
  /** Data from which the data will be pulled */
  field?: Maybe<Scalars["String"]>;
}

export interface BrexDataReportTemplateEntryInput {
  /** Data from which the data will be pulled */
  field?: InputMaybe<Scalars["String"]>;
}

/** Fee we charge the customer. */
export interface BrexFee {
  /** amount charged */
  amount: FinancialAsset;
  /** Creation time */
  createdAt: Scalars["Time"];
  /** id */
  id: Scalars["ID"];
  /** Waive time (if applicable) */
  waivedAt?: Maybe<Scalars["Time"]>;
}

/** A Fee connection for Fee pagination. */
export interface BrexFeeConnection extends Connection {
  /** The fees in the current page of results. */
  edges: Array<BrexFeeEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of fees matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

/** A Fee edge for the Fee connection. */
export interface BrexFeeEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The fee at this edge. */
  node?: Maybe<BrexFee>;
}

/** Enum for Originator Type */
export enum BrexFeeOriginatorType {
  BBA_TRANSACTION = "BBA_TRANSACTION",
  TRANSMISSION = "TRANSMISSION",
}

export interface BrexFeesFilterInput {
  /** Fee originator id (transmission or transaction id) */
  feeOriginatorId?: InputMaybe<Array<Scalars["String"]>>;
  /** Fee originator type (transmission or transaction) */
  feeOriginatorType?: InputMaybe<Array<BrexFeeOriginatorType>>;
}

export interface BrexFeesOrderInput {
  order: OrderByDirection;
}

export enum BrexKycStatus {
  IN_PROGRESS = "IN_PROGRESS",
  REJECTED = "REJECTED",
  UNSUBMITTED = "UNSUBMITTED",
  UNVERIFIED = "UNVERIFIED",
  VERIFIED = "VERIFIED",
}

export interface BrexOperationalTransferDetails {
  _?: Maybe<Scalars["Boolean"]>;
}

export interface BrexOriginatedChequeDetails {
  chequeMemo?: Maybe<Scalars["String"]>;
  chequeNumber: Scalars["Int"];
  counterparty: Counterparty;
  expectedDeliveryDate?: Maybe<Scalars["Date"]>;
  initiatorCustomerUser?: Maybe<User>;
  recipientName?: Maybe<Scalars["String"]>;
  returnReason?: Maybe<ReturnReason>;
  sentAt?: Maybe<Scalars["Time"]>;
  type?: Maybe<TxType>;
}

/**  Keep this enum in sync with task-manager-dgs */
export enum BrexUserSignIn {
  /** User is able to sign in */
  ALLOWED = "ALLOWED",
  /** User has never been able to sign in */
  NONE = "NONE",
  /**
   * User previously had sign in access,
   * but it's been revoked
   */
  SUSPENDED = "SUSPENDED",
}

/** A budget to manage expenses. */
export interface Budget extends Node {
  /**
   * The Customer Account that has visibility to this budget
   * @deprecated Use bifurcated types (SpendLimit or SpendBudget)
   */
  account: Account;
  /** The action logs associated with this budget */
  actionLogs: BudgetActionLogConnection;
  /**
   * The allocation metrics of a budget (non-null only when budget_type is BUDGET).
   * This calculation may be slow, so if only the currentAllocatedAmount is needed, use that field instead.
   */
  allocation?: Maybe<AllocationMetrics>;
  /** @deprecated Use spendLimitSettings.policy.eligibleWorkflows instead */
  allowTravelBooking: Scalars["Boolean"];
  /** Budget allowed operations */
  allowedOperations: Array<Maybe<BudgetOperation>>;
  /** Ordered list of ancestors */
  ancestryPath: Array<Budget>;
  /**
   * This can represent a Target Amount for BUDGET type or a Base Limit for SPEND_LIMIT type.
   * For spend limits, this is the base limit, without any limit increases/rollovers/etc.
   */
  baseLimit?: Maybe<FinancialAsset>;
  /** The bifurcated type of this entity */
  budgetType: BudgetType;
  /** List of cards related to the Budget */
  cards: BudgetCardConnection;
  /** Returns a summary of the cards in the budget (generally a count cards by a specified field) */
  cardsSummary?: Maybe<CardsSummary>;
  /** The children of this budget, if any */
  children: BudgetConnection;
  /**
   * The Employee who created this budget
   * @deprecated Use bifurcated types (SpendLimit or SpendBudget)
   */
  creatorEmployee?: Maybe<Employee>;
  /** The current allocation amount of a budget period. */
  currentAllocatedAmount?: Maybe<FinancialAsset>;
  /** Budget period balance */
  currentPeriodBalance?: Maybe<BudgetPeriodBalance>;
  /** The descendants of this budget, if any */
  descendants: BudgetConnection;
  /**
   * Description of what the budget is used for
   * @deprecated Use bifurcated types (SpendLimit or SpendBudget)
   */
  description?: Maybe<Scalars["String"]>;
  /** Budget edit permission grant */
  editPermissionGrant?: Maybe<BudgetEditPermissionGrant>;
  /** The end date of the budget, inclusive. */
  endDate?: Maybe<Scalars["Date"]>;
  /** The inclusive end time of the budget with timezone offset in absolute UTC time. Ex: 01/31/2022 7:59AM UTC */
  endTime?: Maybe<Scalars["Time"]>;
  /** True if the budget limit is hard enforced */
  enforceLimit: Scalars["Boolean"];
  /** The percentage of the buffer on the budget limit */
  enforceLimitBufferPercentage?: Maybe<Scalars["Int"]>;
  /**
   * Determines if budget members are allowed to view other members expenses.
   * @deprecated Use the enum version of this field within SpendLimitSettings
   */
  expenseVisibilityShared: Scalars["Boolean"];
  /**
   * The ID of an object
   * @deprecated Use bifurcated types (SpendLimit or SpendBudget)
   */
  id: Scalars["ID"];
  /** Merchant category controls, including those along ancestry path. */
  inheritedMerchantCategoryControls?: Maybe<MerchantCategoryControls>;
  /**
   * Whether the legal entity is explicitly mapped to the budget
   *
   * If true, the legal entity is explicitly mapped to the budget
   * Otherwise, the legal entity is derived from the budget's ancestry
   */
  isLegalEntityExplicitlySet: Scalars["Boolean"];
  /** Indicates whether the budget is currently able to be moved within the budget structure */
  isMovable: Scalars["Boolean"];
  /**
   * Whether the transaction limit is explicitly mapped to the budget
   *
   * If true, the transaction limit is explicitly mapped to the budget
   * Otherwise, the transaction limit is derived from the budget's ancestry
   * @deprecated Use isTransactionLimitExplicitlySet within SpendLimitSettings
   */
  isTransactionLimitExplicitlySet: Scalars["Boolean"];
  /** Last status update details */
  lastStatusUpdateDetails?: Maybe<StatusUpdateDetails>;
  /** The legal entity mapped to the budget */
  legalEntity?: Maybe<LegalEntity>;
  /**
   * Limit on the budget
   * @deprecated Use bifurcated types (SpendLimit or SpendBudget)
   */
  limit?: Maybe<FinancialAsset>;
  /** If this is a SPEND_LIMIT, return the limit group associated with it, if any */
  limitGroup?: Maybe<LimitGroup>;
  /**
   * Are budget limit increase requests allowed on this budget.
   * @deprecated Use limitIncreaseRequestEnabled within SpendLimitSettings
   */
  limitIncreaseRequestEnabled: Scalars["Boolean"];
  /**
   * The policy that manages limit increase requests for this budget
   * @deprecated Use limitIncreaseRequestPolicy within SpendLimitSettings
   */
  limitIncreaseRequestPolicy?: Maybe<Policy>;
  /**
   * Budget limit increase requests
   * Takes in an active filter (to fetch limit increase requests applied to the current budget version).
   * The applied filter is deprecated and has no effect.
   * This excludes any active permanent limit increases.
   */
  limitIncreaseRequests: Array<Maybe<BudgetLimitIncreaseRequestEntity>>;
  /**
   * Determines if budget members are allowed to view the budget limit
   * @deprecated Use limitVisibility within SpendLimitSettings
   */
  limitVisibility: BudgetLimitVisibilityType;
  /**
   * Determines if the requesting user is allowed to view the budget limit
   * @deprecated Use limitVisibleForUser within SpendLimitSettings
   */
  limitVisibleForUser: Scalars["Boolean"];
  /** Limit including the buffer, NULL if the budget is flexible */
  limitWithBuffer?: Maybe<FinancialAsset>;
  /** The mapping rule that is associated with this budget */
  mappingRuleId?: Maybe<Scalars["ID"]>;
  /**
   * The employees who are considered members of this budget
   * @deprecated Use bifurcated types (SpendLimit or SpendBudget)
   */
  memberEmployees?: Maybe<BudgetEmployeeConnection>;
  /** Current user's membership on this budget */
  membership?: Maybe<BudgetMembership>;
  /**
   * Name of the budget
   * @deprecated Use bifurcated types (SpendLimit or SpendBudget)
   */
  name: Scalars["String"];
  /** The allocation metrics of a budget in the next period (non-null only when budget_type is BUDGET) */
  nextPeriodAllocation?: Maybe<AllocationMetrics>;
  /**
   * True if only provisioned cards can spend from this budget
   * @deprecated Use onlyProvisionedCardSpend within SpendLimitSettings
   */
  onlyProvisionedCardSpend: Scalars["Boolean"];
  /**
   * The employees who are considered owners of this budget
   * @deprecated Use bifurcated types (SpendLimit or SpendBudget)
   */
  ownerEmployees?: Maybe<BudgetEmployeeConnection>;
  /** The parent of this budget, if any */
  parent?: Maybe<Budget>;
  /** Per diems associated with this budget */
  perDiems?: Maybe<Array<Maybe<BudgetPerDiem>>>;
  /** The recurring period type of the budget. */
  periodType: BudgetPeriodType;
  /**
   * The policy that manages expenses for this budget
   * @deprecated Use policy within SpendLimitSettings
   */
  policy: Policy;
  /**
   * The rollover amount on the budget for the current refresh cycle (i.e. accumulated unused funds from past periods in the refresh cycle).
   * Null if rollover is disabled.
   */
  rolloverAmount?: Maybe<FinancialAsset>;
  /**
   * The rollover refresh rate for this budget (the recurrence by which all rolled over unused funds within the cycle should no longer roll over to the next period).
   * @deprecated Use rolloverRefreshRate within SpendLimitSettings
   */
  rolloverRefreshRate: BudgetRolloverRefreshRate;
  /**
   * Settings related to the Budget
   * @deprecated Use the fields directly on budget schema
   */
  settings: BudgetSettings;
  /**
   * The allocation of a spend limit in the current period of a given budget.
   * If no reference id is passed, default to the parent budget.
   * If the budget is not in spend limit's ancestry, will return an empty list.
   * If resolved for BUDGET type entity, will return an empty list.
   *
   * NOTE: This will be moved to the SpendLimit schema once that is available, and
   * returns an empty list for BUDGET types
   */
  spendLimitAllocations: Array<Maybe<SpendLimitAllocation>>;
  /** Settings pertaining only to a spend limit type (non-null when budget_type is SPEND_LIMIT) */
  spendLimitSettings?: Maybe<SpendLimitSettings>;
  /** The spendable limit of the budget (incl. base limit, any active limit increases, any rollover amounts). */
  spendableLimit?: Maybe<FinancialAsset>;
  /** The start date of the budget, inclusive. */
  startDate?: Maybe<Scalars["Date"]>;
  /** The inclusive start time of the budget with timezone offset in absolute UTC time. Ex: 01/01/2022 8:00AM UTC */
  startTime?: Maybe<Scalars["Time"]>;
  /**
   * Budget status
   * @deprecated Use bifurcated types (SpendLimit or SpendBudget)
   */
  status: BudgetStatus;
  /** The template object associated with this budget */
  template?: Maybe<BudgetTemplate>;
  /**
   * The template derived metadata used to create this budget
   * @deprecated Use templateDerivedMetadata within SpendLimitSettings
   */
  templateDerivedMetadata?: Maybe<BudgetTemplateDerivedMetadata>;
  /** The timezone of this budget */
  timezone: Scalars["String"];
  /**
   * The transaction limit mapped to the budget.
   * Null if no transaction limit is set.
   * @deprecated Use transactionLimit within SpendLimitSettings
   */
  transactionLimit?: Maybe<FinancialAsset>;
  /** @deprecated Use spendLimitSettings.policy.eligibleWorkflows instead and ownership instead */
  usableAsGroupEventBudget: Scalars["Boolean"];
  /** The user group associated with this spend limit */
  userGroup?: Maybe<Group>;
  /** Any reasons a given budget request/budget may not be able to use this as a parent */
  validationIssues?: Maybe<Array<BudgetParentingValidationErrorReason>>;
  /** Budget version */
  version: Scalars["Int"];
}

/** A budget to manage expenses. */
export interface BudgetactionLogsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
}

/** A budget to manage expenses. */
export interface BudgetcardsArgs {
  filter: CardFilterInput;
  page?: InputMaybe<PaginationInput>;
}

/** A budget to manage expenses. */
export interface BudgetcardsSummaryArgs {
  input: BudgetsCardsSummaryInput;
}

/** A budget to manage expenses. */
export interface BudgetchildrenArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<BudgetFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  order?: InputMaybe<BudgetOrderInput>;
  page?: InputMaybe<PaginationInput>;
}

/** A budget to manage expenses. */
export interface BudgetdescendantsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<BudgetFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  order?: InputMaybe<BudgetOrderInput>;
  page?: InputMaybe<PaginationInput>;
}

/** A budget to manage expenses. */
export interface BudgetlimitIncreaseRequestsArgs {
  active?: InputMaybe<Scalars["Boolean"]>;
  applied?: InputMaybe<Scalars["Boolean"]>;
}

/** A budget to manage expenses. */
export interface BudgetmemberEmployeesArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<BudgetEmployeeFilter>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  order?: InputMaybe<BudgetEmployeeOrder>;
  page?: InputMaybe<PaginationInput>;
}

/** A budget to manage expenses. */
export interface BudgetownerEmployeesArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<BudgetEmployeeFilter>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  order?: InputMaybe<BudgetEmployeeOrder>;
  page?: InputMaybe<PaginationInput>;
}

/** A budget to manage expenses. */
export interface BudgetspendLimitAllocationsArgs {
  referenceBudgetId?: InputMaybe<Scalars["ID"]>;
}

export interface BudgetActionLog {
  /** The string value of the action (ex. "Budget owners removed") */
  action: Scalars["String"];
  /** Contains additional metadata about the budget action such as the total count of items in an action value */
  actionMetadata?: Maybe<BudgetActionMetadata>;
  /** When the action occurred. */
  actionTs: Scalars["Time"];
  /** The enum type of the action (ex. BUDGET_MEMBERS_ADDED) */
  actionType: BudgetAuditLogActionType;
  /**
   * The new value being set on a budget as a result of the action. Can be either a string, a comma-delimited list of
   * employees, a comma-delimited list of MCCs, or null for some actions
   */
  actionValue?: Maybe<Scalars["String"]>;
  /** The actor that triggered the action. Could be an employee or null for actions made by internal users on Retool. */
  actor?: Maybe<BudgetActor>;
}

export interface BudgetActionLogConnection {
  /** Actions in the current page of results */
  edges: Array<BudgetActionLogEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** Total count of budget actions for given budget */
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface BudgetActionLogEdge {
  /** Cursor for the next action */
  cursor?: Maybe<Scalars["String"]>;
  /** ActionLog at this edge */
  node?: Maybe<BudgetActionLog>;
}

export interface BudgetActionMetadata {
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface BudgetActor {
  /** The mechanism that caused the action to happen e.g. a budget template */
  mechanism?: Maybe<BudgetMechanism>;
  /** If the action was made on behalf of another employee through copilot. Will be null if the action was not done through copilot */
  onBehalfOfEmployee?: Maybe<Employee>;
  /** The employee who performed the action. Can be null if the action did not originate from an employee */
  user?: Maybe<Employee>;
}

export interface BudgetAmountSpent {
  /** Amount spent is null if the budget has no account balance for the given date. */
  amountSpent?: Maybe<FinancialAsset>;
  budgetId: Scalars["ID"];
}

export type BudgetAnyRequestEntity =
  | BudgetLimitIncreaseRequestEntity
  | BudgetRequestEntity
  | LimitSourceIncreaseRequest;

/** A Budget Any-Request Entity connection for Budget Any-Request pagination. */
export interface BudgetAnyRequestEntityConnection extends Connection {
  /** The budget any-requests in the current page of results. */
  edges: Array<BudgetAnyRequestEntityEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of budget requests matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

/** A Budget Any-Request Entity edge for the Budget Request Entity connection. */
export interface BudgetAnyRequestEntityEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The budget any-request at this edge. */
  node?: Maybe<BudgetAnyRequestEntity>;
}

export interface BudgetApproachingLimitSettings {
  approachingLimitPercentage: Scalars["Int"];
}

export interface BudgetApproachingLimitSettingsInput {
  approachingLimitPercentage: Scalars["Int"];
}

/**
 * Represents a set of approval chains that can be defined for Budget Approval Chains. Today - these are mostly
 * related to static, department, and cost centers rules. But in the future, they can be more generic definitions.
 */
export interface BudgetApprovalChainDefinition {
  approvalChains?: Maybe<TemplateApprovalChains>;
}

export interface BudgetAssignmentExtension extends ExpenseExtensionType {
  autoAssigned?: Maybe<Scalars["Boolean"]>;
  confidenceLevel?: Maybe<Scalars["Int"]>;
  confirmedByUser?: Maybe<Scalars["Boolean"]>;
  id: Scalars["ID"];
}

export enum BudgetAuditLogActionType {
  BUDGET_ALLOWED_MCC_ADDED = "BUDGET_ALLOWED_MCC_ADDED",
  BUDGET_ALLOWED_MCC_REMOVED = "BUDGET_ALLOWED_MCC_REMOVED",
  BUDGET_AMOUNT_ADDED = "BUDGET_AMOUNT_ADDED",
  BUDGET_AMOUNT_DECREASED = "BUDGET_AMOUNT_DECREASED",
  BUDGET_AMOUNT_INCREASED = "BUDGET_AMOUNT_INCREASED",
  BUDGET_AMOUNT_REMOVED = "BUDGET_AMOUNT_REMOVED",
  BUDGET_ARCHIVED = "BUDGET_ARCHIVED",
  BUDGET_BLOCKED_MCC_ADDED = "BUDGET_BLOCKED_MCC_ADDED",
  BUDGET_BLOCKED_MCC_REMOVED = "BUDGET_BLOCKED_MCC_REMOVED",
  BUDGET_BLOCK_REIMBURSEMENT_AND_BUDGET_SELECTION_DISABLED = "BUDGET_BLOCK_REIMBURSEMENT_AND_BUDGET_SELECTION_DISABLED",
  BUDGET_BLOCK_REIMBURSEMENT_AND_BUDGET_SELECTION_ENABLED = "BUDGET_BLOCK_REIMBURSEMENT_AND_BUDGET_SELECTION_ENABLED",
  BUDGET_CREATED = "BUDGET_CREATED",
  BUDGET_CURRENCY_CHANGED = "BUDGET_CURRENCY_CHANGED",
  BUDGET_DELETED = "BUDGET_DELETED",
  BUDGET_DESCRIPTION_CHANGED = "BUDGET_DESCRIPTION_CHANGED",
  BUDGET_EXPIRATION_DATE_CHANGED = "BUDGET_EXPIRATION_DATE_CHANGED",
  BUDGET_EXPIRED = "BUDGET_EXPIRED",
  BUDGET_GENERIC_ACTION = "BUDGET_GENERIC_ACTION",
  BUDGET_LEGAL_ENTITY_CHANGED = "BUDGET_LEGAL_ENTITY_CHANGED",
  BUDGET_LEGAL_ENTITY_REMOVED = "BUDGET_LEGAL_ENTITY_REMOVED",
  /** @deprecated Should be using BUDGET_AMOUNT_ADDED instead */
  BUDGET_LIMIT_ADDED = "BUDGET_LIMIT_ADDED",
  BUDGET_LIMIT_DECREASED = "BUDGET_LIMIT_DECREASED",
  BUDGET_LIMIT_FLEXIBILITY_DISABLED = "BUDGET_LIMIT_FLEXIBILITY_DISABLED",
  BUDGET_LIMIT_FLEXIBILITY_ENABLED = "BUDGET_LIMIT_FLEXIBILITY_ENABLED",
  BUDGET_LIMIT_FLEXIBILITY_THRESHOLD_CHANGED = "BUDGET_LIMIT_FLEXIBILITY_THRESHOLD_CHANGED",
  BUDGET_LIMIT_INCREASED = "BUDGET_LIMIT_INCREASED",
  BUDGET_LIMIT_INCREASE_REQUESTED = "BUDGET_LIMIT_INCREASE_REQUESTED",
  BUDGET_LIMIT_INCREASE_REQUEST_APPROVED = "BUDGET_LIMIT_INCREASE_REQUEST_APPROVED",
  BUDGET_LIMIT_INCREASE_REQUEST_REJECTED = "BUDGET_LIMIT_INCREASE_REQUEST_REJECTED",
  /** @deprecated Should be using BUDGET_AMOUNT_REMOVED instead */
  BUDGET_LIMIT_REMOVED = "BUDGET_LIMIT_REMOVED",
  BUDGET_LIMIT_REQUESTS_DISABLED = "BUDGET_LIMIT_REQUESTS_DISABLED",
  BUDGET_LIMIT_REQUESTS_ENABLED = "BUDGET_LIMIT_REQUESTS_ENABLED",
  BUDGET_LIMIT_VISIBILITY_DISABLED = "BUDGET_LIMIT_VISIBILITY_DISABLED",
  BUDGET_LIMIT_VISIBILITY_ENABLED = "BUDGET_LIMIT_VISIBILITY_ENABLED",
  BUDGET_MCC_DISABLED = "BUDGET_MCC_DISABLED",
  BUDGET_MCC_ENABLED = "BUDGET_MCC_ENABLED",
  BUDGET_MEMBERS_ADDED = "BUDGET_MEMBERS_ADDED",
  BUDGET_MEMBERS_REMOVED = "BUDGET_MEMBERS_REMOVED",
  BUDGET_MEMBER_EXPENSE_VISIBILITY_DISABLED = "BUDGET_MEMBER_EXPENSE_VISIBILITY_DISABLED",
  BUDGET_MEMBER_EXPENSE_VISIBILITY_ENABLED = "BUDGET_MEMBER_EXPENSE_VISIBILITY_ENABLED",
  BUDGET_NAME_CHANGED = "BUDGET_NAME_CHANGED",
  BUDGET_OWNERS_ADDED = "BUDGET_OWNERS_ADDED",
  BUDGET_OWNERS_REMOVED = "BUDGET_OWNERS_REMOVED",
  BUDGET_PARENT_BUDGET_CHANGED = "BUDGET_PARENT_BUDGET_CHANGED",
  BUDGET_POLICY_CHANGED = "BUDGET_POLICY_CHANGED",
  BUDGET_RECURRENCE_CHANGED = "BUDGET_RECURRENCE_CHANGED",
  BUDGET_REOPENED = "BUDGET_REOPENED",
  BUDGET_REQUESTED = "BUDGET_REQUESTED",
  BUDGET_REQUEST_APPROVED = "BUDGET_REQUEST_APPROVED",
  BUDGET_ROLLOVER_SETTINGS_CHANGED = "BUDGET_ROLLOVER_SETTINGS_CHANGED",
  BUDGET_ROLLOVER_SETTINGS_DISABLED = "BUDGET_ROLLOVER_SETTINGS_DISABLED",
  BUDGET_ROLLOVER_SETTINGS_ENABLED = "BUDGET_ROLLOVER_SETTINGS_ENABLED",
  BUDGET_SPEND_CAP_ADDED = "BUDGET_SPEND_CAP_ADDED",
  BUDGET_SPEND_CAP_CHANGED = "BUDGET_SPEND_CAP_CHANGED",
  BUDGET_SPEND_CAP_REMOVED = "BUDGET_SPEND_CAP_REMOVED",
  BUDGET_START_DATE_CHANGED = "BUDGET_START_DATE_CHANGED",
  BUDGET_START_DATE_REMOVED = "BUDGET_START_DATE_REMOVED",
  BUDGET_TERMINATED = "BUDGET_TERMINATED",
  BUDGET_TRANSACTION_LIMIT_CHANGED = "BUDGET_TRANSACTION_LIMIT_CHANGED",
  BUDGET_TRANSACTION_LIMIT_REMOVED = "BUDGET_TRANSACTION_LIMIT_REMOVED",
}

export interface BudgetAutoApprovalSettings {
  /**
   * Whether or not to automatically approve budgets created from this template.
   * Auto approval will be eligible for requests if their limit + the limit of all other auto-approved requests, is less than this in the specified time frame.
   */
  autoApprovalLimit: FinancialAsset;
  /**
   * The time period this auto approval limit applies to.
   * This will be used to sum the total amount of requests that have been auto-approved in the given timeframe.
   * In other words, we evaluate each request as: "If this request's limit + all other requested budgets in the current quarter are less than $4,000, auto approve it."
   */
  periodType: AutoApprovalPeriodType;
}

export interface BudgetAutoApprovalSettingsInput {
  /** Whether or not to automatically approve budgets created from this template */
  autoApprovalLimit: FinancialAssetInput;
  /** The time period we want to calculate over */
  periodType: AutoApprovalPeriodType;
}

/** A Card connection for pagination */
export interface BudgetCardConnection extends Connection {
  /** The cards in the current page of results. */
  edges: Array<BudgetCardEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of cards matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

/** A Card edge for the Card connection. */
export interface BudgetCardEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The card at this edge. */
  node: Card;
}

export interface BudgetCardsSummaryFilterInput {
  /** Match IN specific StatusViews (null and empty list filters are ignored) */
  statusViews?: InputMaybe<Array<StatusView>>;
}

/** The budget configuration flag for an account */
export interface BudgetConfigurationFlag {
  status: BudgetConfigurationFlagStatus;
  type: BudgetConfigurationFlagType;
}

export enum BudgetConfigurationFlagStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

export enum BudgetConfigurationFlagType {
  /** Whether this account is bifurcated */
  BIFURCATION = "BIFURCATION",
  /** Whether or not this account has Limit Groups enabled */
  LIMIT_GROUPS = "LIMIT_GROUPS",
  /** Whether or not this account has multi-currency feature enabled */
  MULTI_CURRENCY = "MULTI_CURRENCY",
  /** Whether or not this account has Reusable Approval Chains enabled */
  REUSABLE_APPROVAL_CHAINS = "REUSABLE_APPROVAL_CHAINS",
  /** Whether or not this account has Templates simplification enabled */
  TEMPLATES_SIMPLIFICATION = "TEMPLATES_SIMPLIFICATION",
}

/** An Budget connection for Budget pagination. */
export interface BudgetConnection extends Connection {
  /** The budgets in the current page of results. */
  edges: Array<BudgetEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of budget matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

/** Response type for querying the descendant ids of a budget. */
export interface BudgetDescendantIdsResult {
  budgetId: Scalars["String"];
  descendantIds: Array<Scalars["ID"]>;
}

export interface BudgetDistributionByUserAttributesInput {
  /**
   * Filter chain used to exclude users with specified attributes from budget distribution. Logical "AND" will be applied
   * to all filter chains specified in the list.
   *
   * Note: the same `UserAttributeType` cannot appear in more than one `BudgetDistributionUserAttributesFilterChainInput` in the list.
   *
   * Examples:
   * `[
   * {logicalInclusiveOrUserAttributesFilters: [{userAttributeType: LOCATION, userAttributeId: "SF"}]},
   * {logicalInclusiveOrUserAttributesFilters: [{userAttributeType: TITLE, userAttributeId: "manager"}]}
   * ]` excludes all the managers in SF
   */
  exclusionFilterChain?: InputMaybe<
    Array<BudgetDistributionUserAttributesFilterChainInput>
  >;
  /**
   * The date a user must be invited on or after, considering an account's timezone, to qualify for the Budget Distribution
   * This property only applies if the userInvitationFilter is set to FUTURE
   */
  invitedOnOrAfter?: InputMaybe<Scalars["Date"]>;
  /**
   * Filter users by user attributes. Logical "AND" will be applied to all filter chains specified in the list.
   * Note the same `UserAttributeType` cannot appear in more than one `BudgetDistributionUserAttributesFilterChainInput` in the list.
   * Examples:
   * `[{logicalInclusiveOrUserAttributesFilters: [{userAttributeType: LOCATION, userAttributeId: "SF"}]}, {logicalInclusiveOrUserAttributesFilters: [{userAttributeType: TITLE, userAttributeId: "manager"}]}]` means all the managers who live in SF
   * `[]` means everyone
   */
  logicalAndUserAttributesFilterChains: Array<BudgetDistributionUserAttributesFilterChainInput>;
  /** Filter users by join time relative to when distribution settings were created. */
  userInvitationFilter: UserInvitationFilter;
}

/** Exactly one field needs to be set. The first non-null field will be used, and the rest will be ignored. */
export interface BudgetDistributionSettingsOneOfInput {
  perMemberBudgetDistributionSettings?: InputMaybe<PerMemberBudgetDistributionSettings>;
  sharedBudgetDistributionSettings?: InputMaybe<SharedBudgetDistributionSettings>;
}

export interface BudgetDistributionUserAttributeFilterInput {
  /** ID of that user attribute (e.g. `Location.id`). */
  userAttributeId: Scalars["ID"];
  /** Type of the user attribute. */
  userAttributeType: UserAttributeType;
}

export interface BudgetDistributionUserAttributesFilterChainInput {
  /**
   * Filter users by user attributes. Logical "inclusive OR" will be applied to all filters specified in the list.
   * Examples:
   * `[{userAttributeType: LOCATION, userAttributeId: "NYC"}, {userAttributeType: DEPARTMENT, userAttributeId: "design"}, {userAttributeType: DEPARTMENT, userAttributeId: "engineering"}]` means everyone in NYC (regardless of department), and everyone in Design (regardless of location), and everyone in Engineering (regardless of location), ignoring titles, cost centers, etc. since they are not mentioned.
   * `[]` means everyone
   */
  logicalInclusiveOrUserAttributesFilters: Array<BudgetDistributionUserAttributeFilterInput>;
}

/**
 * Used for determining the set of qualified users who will receive the budget.
 * At least one filter needs to be provided.
 */
export interface BudgetDistributionUserFilters {
  /**
   * Distributing the budget to users whose user attributes satisfy all the filtering conditions.
   * Set this field to null if filtering by user attributes is not needed.
   */
  byUserAttributes?: InputMaybe<BudgetDistributionByUserAttributesInput>;
  /**
   * Directly distributing the budget to the list of users specified here.
   * Set this field to null if filtering by user ID is not needed.
   */
  byUserIds?: InputMaybe<Array<Scalars["ID"]>>;
  /**
   * Skip distributing the budget to the list of users specified here.
   * Set this field to null if excluding by user ID is not needed.
   */
  excludedUserIds?: InputMaybe<Array<Scalars["ID"]>>;
}

/** A Budget edge for the Budget connection. */
export interface BudgetEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The budget at this edge. */
  node?: Maybe<Budget>;
}

export enum BudgetEditPermissionGrant {
  FULL = "FULL",
  NONE = "NONE",
  PARTIAL = "PARTIAL",
}

/** A BudgetEmployee connection for Budget owner/member pagination futureproofing */
export interface BudgetEmployeeConnection extends Connection {
  /** The items in the current page of results. */
  edges: Array<Maybe<BudgetEmployeeEdge>>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of items, across all pages, matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

/** A BudgetEmployee edge for the BudgetEmployee connection. */
export interface BudgetEmployeeEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The item at this edge. */
  node?: Maybe<Employee>;
}

export interface BudgetEmployeeFilter {
  /** filter for users by text */
  text: Scalars["String"];
}

export interface BudgetEmployeeOrder {
  /** Direction */
  direction: OrderByDirection;
  /** Which field is being sorted on */
  field: SortableBudgetEmployeeField;
}

export interface BudgetError {
  /** The budget id */
  budgetId: Scalars["ID"];
}

export interface BudgetExpenseDryRun {
  /** The budget */
  budget: Budget;
  /** The basic limit information for this budget or user limit */
  displayLimit: DisplayLimit;
  /**
   * Proactive expense indicators that indicate why a expense cannot be assigned to budget on the current edge
   * null if no error occurs during budget expense assignment
   */
  expenseAssignmentFailureError?: Maybe<ExpenseAssignmentFailureError>;
}

export interface BudgetExpenseDryRunConnection extends Connection {
  /** The budget-expense dry run edge in the current page of results. */
  edges: Array<BudgetExpenseDryRunEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of valid budget-expense dry run pairs matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface BudgetExpenseDryRunEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The BudgetExpenseDryRun node at this edge */
  node?: Maybe<BudgetExpenseDryRun>;
}

export interface BudgetExpiringSoonSettings {
  daysBeforeExpiration: Scalars["Int"];
}

export interface BudgetExpiringSoonSettingsInput {
  daysBeforeExpiration: Scalars["Int"];
}

/** Filters for the Budget entity. */
export interface BudgetFieldMatcherInput {
  /**
   * Fuzzy search by budget name. This only includes results that the budget's name contains specified search
   * substring. The returned results are sorted by similarity.
   */
  searchQuery?: InputMaybe<Scalars["String"]>;
}

export interface BudgetFilterInput {
  /**
   * List all descendant budgets belonging to an ancestor budget, excluding the ancestor budget itself
   * Will throw error if both parentBudgetId and ancestorBudgetId are specified
   */
  ancestorBudgetId?: InputMaybe<Scalars["ID"]>;
  /** Filter budgets by budgetIds */
  budgetIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Filter to include the listed template ids */
  budgetTemplateIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Filter by budget type (eg. Budget | Spend Limit), or returns all budget types if not specified or is an empty list */
  budgetTypes?: InputMaybe<Array<BudgetType>>;
  /** Filter to include/exclude limit-per-employee distribution children */
  distributionChildrenFilter?: InputMaybe<DistributionChildrenFilter>;
  /** Filter by budget policy eligible workflows, match ALL when no filter or and empty array is provided */
  eligibleWorkflows?: InputMaybe<Array<PolicyWorkflowType>>;
  /** List budgets that have no expiration date (null end date) or budgets that have end dates after this field */
  endDateNullOrAfter?: InputMaybe<Scalars["Date"]>;
  /** Determines if budget members are allowed to view other members expenses. */
  expenseVisibilityShared?: InputMaybe<Scalars["Boolean"]>;
  /** Filter to include or exclude purchasing card limits */
  filterPurchasingCardLimits?: InputMaybe<PurchasingCardLimitsFilterType>;
  /** Whether or not the budget has nested budgets */
  hasSubBudgets?: InputMaybe<Scalars["Boolean"]>;
  /** Match IN template types. If empty returns all items. */
  includeTemplateTypes?: InputMaybe<Array<BudgetTemplateType>>;
  /** Filter by automated distribution on budgets, or ignores the filter if not specified */
  isAutomationEnabled?: InputMaybe<Scalars["Boolean"]>;
  /** Amount of the financial asset limit of each Budget being filtered. Could be ALL (all budget limits), NONZERO (nonzero budget limits), etc. */
  limitAmountType?: InputMaybe<LimitAmountType>;
  /** Determines if budget members are allowed to request limit increases. */
  limitIncreaseRequestEnabled?: InputMaybe<Scalars["Boolean"]>;
  /** [Deprecated!] Only budgets with limits below this value (inclusive) */
  maxCents?: InputMaybe<Scalars["Int"]>;
  /** Match IN specific members */
  members?: InputMaybe<BudgetPersonnelInput>;
  /**
   * [Deprecated!] Use LimitAmountType
   * Only budgets with limits above this value (inclusive)
   */
  minCents?: InputMaybe<Scalars["Int"]>;
  /** Whether or not the budget has a virtual card */
  onlyProvisionedCardSpend?: InputMaybe<Scalars["Boolean"]>;
  /** Match IN specific owners */
  owners?: InputMaybe<BudgetPersonnelInput>;
  /**
   * List direct child budgets belonging to a parent budget, excluding the parent budget itself
   * Will throw error if both parentBudgetId and ancestorBudgetId are specified
   */
  parentBudgetId?: InputMaybe<Scalars["ID"]>;
  /** Filter budgets by the policy they are using. */
  policyIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Search budgets by name */
  search?: InputMaybe<Scalars["String"]>;
  /** Whether or not we want to skip the root budget */
  skipRootBudget?: InputMaybe<Scalars["Boolean"]>;
  /** List all budgets closed or deleted by a parent budget */
  statusLastUpdatedByAncestorBudgetId?: InputMaybe<Scalars["ID"]>;
  /** Budget Status IN statuses */
  statuses?: InputMaybe<Array<BudgetStatus>>;
}

/** Budget limit increase request ending strategy */
export enum BudgetIncreaseLimitRequestEndingStrategy {
  /**
   * End limit increase when the period ends
   * @deprecated Use PERIOD_END
   */
  CURRENT_PERIOD_END = "CURRENT_PERIOD_END",
  /** End limit increase when the period ends (current or future) */
  PERIOD_END = "PERIOD_END",
  /** Permanent budget limit increase */
  PERMANENT = "PERMANENT",
}

/** A request to increase a budget limit. */
export interface BudgetLimitIncreaseRequestEntity {
  /** Target budget. */
  budget: Budget;
  /** Comment thread associated with a budget limit increase request entity. */
  commentThread?: Maybe<CommentThread>;
  /** End date for the limit increase. */
  endDate?: Maybe<Scalars["Date"]>;
  /** Strategy to end the limit increase. */
  endingStrategy: BudgetIncreaseLimitRequestEndingStrategy;
  /** Budget Limit Increase Request ID (within budgets service). */
  id: Scalars["ID"];
  /** Amount to increase the limit if the request is approved.. */
  increaseAmount: FinancialAsset;
  /** Reason to increase the limit. */
  reason: Scalars["String"];
  /** The Requests service request instance. */
  request?: Maybe<BudgetRequest>;
  /** Current version of the request. */
  version: Scalars["Int"];
}

/** An approval chain, including the condition for it to be used. */
export interface BudgetLimitIncreaseRequestPolicyApprovalChainInput {
  /**
   * A condition to determine whether this approval chain should be used. A null condition is allowed
   * and is assumed to be true.
   */
  chainCondition?: InputMaybe<BudgetLimitIncreaseRequestPolicyConditionInput>;
  /** The steps in this approval chain. */
  steps: Array<PolicyApprovalStepInput>;
}

/**
 * A condition for a rule in a Budget Limit Increase Request policy.
 *
 * The condition matches if it produces a TRUE result when AND-ing the result of all inner conditions.
 * Unset or null fields are considered to be TRUE, meaning an empty condition will always be evaluated
 * as TRUE.
 */
export interface BudgetLimitIncreaseRequestPolicyCondition {
  amountCondition?: Maybe<PolicyAmountCondition>;
  employeeCostCenterIdCondition?: Maybe<PolicyEmployeeCostCenterIdCondition>;
  employeeDepartmentIdCondition?: Maybe<PolicyEmployeeDepartmentIdCondition>;
}

/**
 * A condition for a rule in a Budget Limit Increase Request policy.
 *
 * The condition matches if it produces a TRUE result when AND-ing the result of all inner conditions.
 * Unset or null fields are considered to be TRUE, meaning an empty condition will always be evaluated
 * as TRUE.
 */
export interface BudgetLimitIncreaseRequestPolicyConditionInput {
  amountCondition?: InputMaybe<PolicyAmountConditionInput>;
  employeeCostCenterIdCondition?: InputMaybe<PolicyEmployeeCostCenterIdConditionInput>;
  employeeDepartmentIdCondition?: InputMaybe<PolicyEmployeeDepartmentIdConditionInput>;
}

export enum BudgetLimitVisibilityType {
  PRIVATE = "PRIVATE",
  SHARED = "SHARED",
}

export enum BudgetLimitVisibilityTypeInput {
  /** Only owners may view the limit. */
  PRIVATE = "PRIVATE",
  /** Allow all budget/spend limit members to view the limit */
  SHARED = "SHARED",
}

export enum BudgetMappingExpiration {
  EXPIRING = "EXPIRING",
  NON_EXPIRING = "NON_EXPIRING",
}

export enum BudgetMappingType {
  EXPIRING = "EXPIRING",
  NON_EXPIRING = "NON_EXPIRING",
}

export interface BudgetMechanism {
  /** The id of the mechanism */
  id: Scalars["ID"];
  /** The type of the mechanism */
  mechanismType: BudgetMechanismType;
  /** The name of the mechanism i.e. the name of budget template */
  name: Scalars["String"];
}

export enum BudgetMechanismType {
  BUDGET_PROGRAM = "BUDGET_PROGRAM",
  BUDGET_TEMPLATE = "BUDGET_TEMPLATE",
}

/** Describes whether the current user is an owner or member of a budget. */
export interface BudgetMembership {
  isMember: Scalars["Boolean"];
  isOwner: Scalars["Boolean"];
}

/** Input type for searching for merchant categories. */
export interface BudgetMerchantCategoriesSuggestionsInput {
  /** User's input of merchant category control type. */
  controlType: MerchantCategoryControlType;
}

/** Result type for matched merchant categories. */
export interface BudgetMerchantCategoriesSuggestionsResult {
  /** Merchant categories. */
  merchantCategories?: Maybe<Array<MerchantCategory>>;
}

export enum BudgetMetricTrackingReason {
  /** Tracking by distribution group (e.g. location, department, cost center) */
  STRUCTURE_BY_DISTRIBUTION_GROUP = "STRUCTURE_BY_DISTRIBUTION_GROUP",
  /** Tracking by budget template type (e.g. stipend, procurement) */
  STRUCTURE_BY_TEMPLATE = "STRUCTURE_BY_TEMPLATE",
}

/**
 * A resource representing the movement of a budget from one part of the budget hierarchy to another another part of
 * the budget hierarchy
 */
export interface BudgetMovement {
  /** The ID of the budget being moved */
  budgetId: Scalars["ID"];
  /** When the budget movement was completed */
  completedAt?: Maybe<Scalars["Time"]>;
  /** The customer account the budget belongs to */
  customerAccountId: Scalars["ID"];
  /** The id of the budget movement */
  id: Scalars["ID"];
  /** The ID of the budget's new parent */
  newParentBudgetId: Scalars["ID"];
  /** The ID of the budget's old parent */
  oldParentBudgetId: Scalars["ID"];
}

/** A Budget Movement connection for Budget Movement pagination. */
export interface BudgetMovementConnection extends Connection {
  /** The budget movements in the current page of results. */
  edges: Array<BudgetMovementEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of budget movements matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

/** A Budget Movement edge for the Budget Movement connection. */
export interface BudgetMovementEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The Budget Movement at the current edge */
  node?: Maybe<BudgetMovement>;
}

/** Filters for querying budget movements */
export interface BudgetMovementFilterInput {
  /** Filter for complete or incomplete budget movements */
  isComplete?: InputMaybe<Scalars["Boolean"]>;
}

export enum BudgetOperation {
  DELETE = "DELETE",
  EDIT_CURRENCY = "EDIT_CURRENCY",
  EDIT_MAIN_ATTRIBUTES = "EDIT_MAIN_ATTRIBUTES",
  EDIT_MEMBERS = "EDIT_MEMBERS",
  EDIT_USERS = "EDIT_USERS",
  TERMINATE = "TERMINATE",
  UNEXPIRE = "UNEXPIRE",
  UNTERMINATE = "UNTERMINATE",
}

/**
 * Represents a BudgetOrError from another subgraph.
 * By default, resolvable=false means the owning subgraph handles resolution.
 */
export interface BudgetOrError {
  /** encode(BudgetOrError:budget_id) */
  id: Scalars["ID"];
  /** Result based on user access. */
  result: BudgetOrErrorUnion;
}

export type BudgetOrErrorUnion = Budget | BudgetError;

export interface BudgetOrderInput {
  direction: OrderByDirection;
  field: SortableBudgetField;
}

export enum BudgetParentingValidationErrorReason {
  /** The parent option's end date is before the candidate budget entity's */
  PARENT_OPTION_END_DATE_CONFLICT = "PARENT_OPTION_END_DATE_CONFLICT",
  /** The parent option has an end date but the candidate budget does not */
  PARENT_OPTION_HAS_END_DATE = "PARENT_OPTION_HAS_END_DATE",
  /** The parent option start date is after the candidate budget entity's */
  PARENT_OPTION_START_DATE_CONFLICT = "PARENT_OPTION_START_DATE_CONFLICT",
}

export interface BudgetPerDiem {
  availableSpend: FinancialAsset;
  dailyLimit: FinancialAsset;
  perDiemCategory: PerDiemCategory;
}

/** A period of time and cadence that a budget applies to. */
export interface BudgetPeriod {
  /** The end date (YYYY-MM-DD) of the budget, inclusive. Semantically end of PST midnight */
  endDate?: Maybe<Scalars["Date"]>;
  /** The end datetime of the budget, inclusive. (always 7:59am UTC the next day) */
  endTime?: Maybe<Scalars["Time"]>;
  /** The recurring period type of the budget. */
  periodType: BudgetPeriodType;
  /** The start date of the budget, inclusive. */
  startDate?: Maybe<Scalars["Date"]>;
  /** The start time of the budget, inclusive. */
  startTime?: Maybe<Scalars["Time"]>;
}

/** Budget period balance */
export interface BudgetPeriodBalance {
  /** Balance end time */
  endTime?: Maybe<Scalars["Time"]>;
  /** Balance spent amount */
  spent: FinancialAsset;
  /** Balance start time */
  startTime?: Maybe<Scalars["Time"]>;
}

export interface BudgetPeriodResettingSoonSettings {
  daysBeforeReset: Scalars["Int"];
}

export interface BudgetPeriodResettingSoonSettingsInput {
  daysBeforeReset: Scalars["Int"];
}

export enum BudgetPeriodType {
  /** Invalid */
  INVALID = "INVALID",
  /** Only once */
  ONE_TIME = "ONE_TIME",
  /** Every month */
  PER_MONTH = "PER_MONTH",
  /** Every quarter */
  PER_QUARTER = "PER_QUARTER",
  /** Every week */
  PER_WEEK = "PER_WEEK",
  /** Every year */
  PER_YEAR = "PER_YEAR",
}

export enum BudgetPeriodTypeInput {
  /** Invalid */
  INVALID = "INVALID",
  /** Only once */
  ONE_TIME = "ONE_TIME",
  /** Every month */
  PER_MONTH = "PER_MONTH",
  /** Every quarter */
  PER_QUARTER = "PER_QUARTER",
  /** Every week */
  PER_WEEK = "PER_WEEK",
  /** Every year */
  PER_YEAR = "PER_YEAR",
}

export interface BudgetPersonnel {
  users?: Maybe<Array<User>>;
}

/** A BudgetPersonnel connection for BudgetPersonnel pagination. */
export interface BudgetPersonnelConnection extends Connection {
  /** The items in the current page of results. */
  edges: Array<Maybe<BudgetPersonnelEdge>>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of items, across all pages, matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

/** A BudgetPersonnel edge for the BudgetPersonnel connection. */
export interface BudgetPersonnelEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The item at this edge. */
  node?: Maybe<BudgetPersonnel>;
}

/** Input type for specifying budget personnel (list of users or groups, or both) */
export interface BudgetPersonnelInput {
  userIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
}

/** A budget request. */
export interface BudgetRequest extends Request {
  /** Actions for the budget request. */
  actions?: Maybe<RequestActionConnection>;
  /**
   * The Budget which this Request was created to get approval for
   * The Budget's status will be 'pending_approval' while the request is 'pending'
   */
  budget?: Maybe<Budget>;
  /** User that canceled the request */
  canceledBy?: Maybe<Employee>;
  /** The compliance status for the request */
  complianceStatus?: Maybe<ComplianceStatus>;
  /** When the request was created. */
  createdAt: Scalars["Time"];
  /** The employee who initiated the request. */
  createdBy?: Maybe<Employee>;
  /** The compliance status for the request that is derived from the submitter and reviewer compliance statuses. */
  derivedComplianceStatus?: Maybe<DerivedComplianceStatus>;
  /** The unique ID of the budget request. */
  id: Scalars["ID"];
  /** The timestamp when a controller overridden the request. */
  overriddenAt?: Maybe<Scalars["Time"]>;
  /** The employee who overridden the request. */
  overriddenBy?: Maybe<Employee>;
  /** User id being co-piloted when this request was overridden. */
  overriddenOnBehalfOf?: Maybe<Employee>;
  /** The employee who owns the request. */
  owner?: Maybe<Employee>;
  /**
   * The user who requested the budget.
   * @deprecated Incorrect permission scoping, use requestedByEmployee instead
   */
  requestedBy?: Maybe<User>;
  /**
   * The employee who the request was initiated for.
   * @deprecated Not clear whether this is owner or creator of request after copilot context was introduced, use owner instead
   */
  requestedByEmployee?: Maybe<Employee>;
  /** The reviewer compliance status for the request. */
  reviewerComplianceStatus?: Maybe<ComplianceStatus>;
  /** The timestamp when reviewer compliance deadline will be reached */
  reviewerDeadlineAt?: Maybe<Scalars["Time"]>;
  /** The stage of approval of the request, e.g. created, approved, denied */
  status?: Maybe<RequestStatus>;
  /** The timestamp when the submitter compliance deadline will be reached */
  submitterDeadlineAt?: Maybe<Scalars["Time"]>;
  /** Will always map to BUDGET for a BudgetRequest. */
  type?: Maybe<RequestType>;
}

/** A budget request. */
export interface BudgetRequestactionsArgs {
  filter?: InputMaybe<RequestActionFilterInput>;
  order?: InputMaybe<RequestActionOrderInput>;
  page?: InputMaybe<PaginationInput>;
}

export enum BudgetRequestAckedByInput {
  /** Acked by the logged in user */
  ME = "ME",
}

export interface BudgetRequestActionFilterInput {
  /** Match request based on who acked the action, match ALL when none are provided */
  ackedBy?: InputMaybe<BudgetRequestAckedByInput>;
  /** Match request based on who is currently assigned to review the budget */
  assignedTo?: InputMaybe<BudgetRequestAssignedToFilterInput>;
  /** [Deprecated!] match request action based on status, match ALL when none are provided */
  status?: InputMaybe<BudgetRequestActionStatus>;
  /** Match request based on status, match ALL when none are provided */
  statuses?: InputMaybe<Array<BudgetRequestActionStatus>>;
}

/** The current status of the budget request action. */
export enum BudgetRequestActionStatus {
  /** An action which is not ready to be taken because its dependencies are unresolved */
  BLOCKED = "BLOCKED",
  /** The action's request was canceled */
  CANCELED = "CANCELED",
  /** The desired action was taken by the owner */
  COMPLETED = "COMPLETED",
  /** The action was marked as not needed */
  DISMISSED = "DISMISSED",
  /** An action which is ready to be taken (no dependencies, or all dependencies are resolved) */
  PENDING = "PENDING",
  /**
   * The owner explicitly refuses to take an action, e.g. approving a budget request.
   * Not all Request Actions can be REJECTED.
   */
  REJECTED = "REJECTED",
  /** The desired action was tentatively taken by the owner */
  TENTATIVELY_COMPLETED = "TENTATIVELY_COMPLETED",
  /**
   * The owner explicitly and tentatively refuses to take an action, e.g. approving a budget request.
   * Not all Request Actions can be TENTATIVELY_REJECTED.
   */
  TENTATIVELY_REJECTED = "TENTATIVELY_REJECTED",
}

/** The types of relationships for filtering who is assigned a budget request. */
export enum BudgetRequestAssignedToFilterInput {
  /** Assigned to anyone in the user's company */
  COMPANY = "COMPANY",
  /** Assigned to the logged in user */
  ME = "ME",
}

/** A request to create a new budget */
export interface BudgetRequestEntity {
  /** The Customer Account that has visibility to this budget */
  account: Account;
  /** Whether this request is autoApprovable */
  autoApprovable: Scalars["Boolean"];
  /** Setting for auto-transferring budget cards when their owners are either disabled or removed as members from the budget. */
  autoTransferCardsSetting?: Maybe<AutoTransferCardsSetting>;
  /** Comment thread associated with a budget request entity. */
  commentThread?: Maybe<CommentThread>;
  /** Budget that was created from this request */
  createdBudget?: Maybe<Budget>;
  /** Description of what this budget request is for */
  description: Scalars["String"];
  /** The end date of the budget, inclusive. */
  endDate?: Maybe<Scalars["Date"]>;
  /** True if the budget limit is hard enforced */
  enforceLimit: Scalars["Boolean"];
  /** The percentage of the buffer on the budget limit. */
  enforceLimitBufferPercentage?: Maybe<Scalars["Int"]>;
  /** Determines if budget members are allowed to view other members expenses. */
  expenseVisibilityShared: Scalars["Boolean"];
  /** Budget Request ID (within budgets service) */
  id: Scalars["ID"];
  /** Limit on the budget */
  limit: FinancialAsset;
  /** True if limit increase request feature is enabled */
  limitIncreaseRequestEnabled?: Maybe<Scalars["Boolean"]>;
  /** The policy that manages limit increase requests for this budget */
  limitIncreaseRequestPolicyId?: Maybe<Scalars["ID"]>;
  /** Determines if budget members are allowed to view the budget limit */
  limitVisibility: BudgetLimitVisibilityType;
  /** The employees who are considered members of this budget */
  memberEmployees: BudgetEmployeeConnection;
  /** The merchant category controls set on this budget request */
  merchantCategoryControls?: Maybe<Array<MerchantCategoryConfig>>;
  /** Name of the budget */
  name: Scalars["String"];
  /** True if only provisioned cards can spend from this budget */
  onlyProvisionedCardSpend: Scalars["Boolean"];
  /** The employees who are considered owners of this budget */
  ownerEmployees: BudgetEmployeeConnection;
  /** The parent of this budget, if any */
  parent?: Maybe<Budget>;
  /** The recurring period type of the budget. */
  periodType: BudgetPeriodType;
  /** The policy that manages expenses for this budget */
  policy?: Maybe<Policy>;
  /** The initiated request instance itself */
  request?: Maybe<BudgetRequest>;
  /** Null means no applicable restrictions */
  requestRestrictions?: Maybe<BudgetRequestEntityRestrictions>;
  /** The Employee who created this budget request as a copilot for requestedByEmployee. */
  requestedByCopilotEmployee?: Maybe<Employee>;
  /** The Employee who created this budget request */
  requestedByEmployee: Employee;
  /** The selected spend method for this request */
  spendMethod?: Maybe<BudgetRequestEntitySpendMethod>;
  /** The metadata related to the selected spend method */
  spendMethodMetadata?: Maybe<BudgetRequestEntitySpendMethodMetadataOneOf>;
  /** The start date of the budget, inclusive. */
  startDate: Scalars["Date"];
  /** The template used to create this budget request */
  template?: Maybe<BudgetTemplate>;
  /** The template derived metadata used to create this budget request */
  templateDerivedMetadata?: Maybe<BudgetTemplateDerivedMetadata>;
  /** Version of the Budget Request */
  version: Scalars["Int"];
}

/** An Budget Request Entity connection for Budget Request pagination. */
export interface BudgetRequestEntityConnection extends Connection {
  /** The budget requests in the current page of results. */
  edges: Array<BudgetRequestEntityEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of budget requests matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

/** A Budget Request Entity edge for the Budget Request Entity connection. */
export interface BudgetRequestEntityEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The budget request at this edge. */
  node?: Maybe<BudgetRequestEntity>;
}

/** Filter input for budget request entities */
export interface BudgetRequestEntityFilterInput {
  /** Match the budget ID of the request. When set, only budget limit increase requests are returned. */
  budgetId?: InputMaybe<Scalars["ID"]>;
  /** Match request based on request action filters */
  requestActionFilter?: InputMaybe<BudgetRequestActionFilterInput>;
  /** Match request based on who originally requested the budget */
  requestedBy?: InputMaybe<BudgetRequestedByFilterInput>;
  /** [Deprecated!] Match request based on status, match ALL when none are provided */
  status?: InputMaybe<Array<BudgetRequestStatus>>;
  /** Match request based on status, match ALL when none are provided */
  statuses?: InputMaybe<Array<BudgetRequestStatus>>;
}

/** Budget Request Entity restrictions */
export interface BudgetRequestEntityRestrictions {
  /**
   * Earliest possible start date for this Budget Request. This is derived from parent budget restriction rules
   * Null means no applicable start date restriction.
   */
  earliestStartDate?: Maybe<Scalars["Date"]>;
  /**
   * Latest possible end date for this Budget Request. This is derived from parent budget restriction rules
   * Null means no applicable end date restriction.
   */
  latestEndDate?: Maybe<Scalars["Date"]>;
}

/** Possible spend methods for a budget request entity */
export enum BudgetRequestEntitySpendMethod {
  PURCHASE_ORDER = "PURCHASE_ORDER",
  PURCHASING_CARD = "PURCHASING_CARD",
  SPEND_LIMIT = "SPEND_LIMIT",
}

/** Metadata related to a spend method */
export interface BudgetRequestEntitySpendMethodMetadataOneOf {
  purchaseOrderMetadata?: Maybe<BudgetRequestEntitySpendMethodPurchaseOrderMetadata>;
  purchasingCardMetadata?: Maybe<BudgetRequestEntitySpendMethodPurchasingCardMetadata>;
}

/** Input to update metadata related to a spend method */
export interface BudgetRequestEntitySpendMethodMetadataOneOfInput {
  purchaseOrderMetadata?: InputMaybe<BudgetRequestEntitySpendMethodPurchaseOrderMetadataInput>;
  purchasingCardMetadata?: InputMaybe<BudgetRequestEntitySpendMethodPurchasingCardMetadataInput>;
}

/** Purchase Order metadata */
export interface BudgetRequestEntitySpendMethodPurchaseOrderMetadata {
  vendorId: Scalars["ID"];
}

/** Input to update Purchase Order metadata */
export interface BudgetRequestEntitySpendMethodPurchaseOrderMetadataInput {
  vendorId: Scalars["ID"];
}

/** P-Card metadata */
export interface BudgetRequestEntitySpendMethodPurchasingCardMetadata {
  primaryCardUserId: Scalars["ID"];
}

/** Input to update P-Card metadata */
export interface BudgetRequestEntitySpendMethodPurchasingCardMetadataInput {
  primaryCardUserId: Scalars["ID"];
}

export interface BudgetRequestInboxTaskEntityDetails
  extends InboxTaskEntityDetails {
  /** Base64 encoded budget request template ID. */
  encodedEntityId: Scalars["String"];
  /** The budget request template ID. */
  entityId: Scalars["String"];
  /**
   * The budget request's template type. This is a string value
   * of the enum representation but can be safely casted back.
   */
  templateType: Scalars["String"];
}

/** An approval chain, including the condition for it to be used. */
export interface BudgetRequestPolicyApprovalChainInput {
  /**
   * A condition to determine whether this approval chain should be used. A null condition is allowed
   * and is assumed to be true.
   */
  chainCondition?: InputMaybe<BudgetRequestPolicyConditionInput>;
  /** The steps in this approval chain. */
  steps: Array<PolicyApprovalStepInput>;
}

/**
 * A condition for a rule in a Budget Request policy.
 *
 * The condition matches if it produces a TRUE result when AND-ing the result of all inner conditions.
 * Unset or null fields are considered to be TRUE, meaning an empty condition will always be evaluated
 * as TRUE.
 */
export interface BudgetRequestPolicyCondition {
  amountCondition?: Maybe<PolicyAmountCondition>;
  employeeCostCenterIdCondition?: Maybe<PolicyEmployeeCostCenterIdCondition>;
  employeeDepartmentIdCondition?: Maybe<PolicyEmployeeDepartmentIdCondition>;
}

/**
 * A condition for a rule in a Budget Request policy.
 *
 * The condition matches if it produces a TRUE result when AND-ing the result of all inner conditions.
 * Unset or null fields are considered to be TRUE, meaning an empty condition will always be evaluated
 * as TRUE.
 */
export interface BudgetRequestPolicyConditionInput {
  amountCondition?: InputMaybe<PolicyAmountConditionInput>;
  employeeCostCenterIdCondition?: InputMaybe<PolicyEmployeeCostCenterIdConditionInput>;
  employeeDepartmentIdCondition?: InputMaybe<PolicyEmployeeDepartmentIdConditionInput>;
}

/** The status of a Request. */
export enum BudgetRequestStatus {
  /**
   * When all request actions associated with this request are approved/dismissed,
   * or an admin directly overrode the request with an approval
   */
  APPROVED = "APPROVED",
  /** When a request was canceled by the requester */
  CANCELED = "CANCELED",
  /** Requests are created as pending */
  PENDING = "PENDING",
  /** When one of the actions was rejected */
  REJECTED = "REJECTED",
}

/** A budget request validation error. */
export interface BudgetRequestValidationError {
  /** Description of the validation error. */
  message: Scalars["String"];
  /** The validation error reason. */
  reason: BudgetRequestValidationErrorReason;
}

/** Budget request validation errors. */
export enum BudgetRequestValidationErrorReason {
  /** Conflict between parent budget and budget request currencies. */
  INVALID_CURRENCY = "INVALID_CURRENCY",
  /** The policy linked to the budget request is not valid. */
  INVALID_POLICY = "INVALID_POLICY",
  /** Budget request without an assigned parent budget. */
  MISSING_PARENT_BUDGET = "MISSING_PARENT_BUDGET",
  /** Parent budget and budget request owned by distinct customer accounts. */
  PARENT_CUSTOMER_ACCOUNT_CONFLICT = "PARENT_CUSTOMER_ACCOUNT_CONFLICT",
  /** Parent budget and budget request start data conflict. */
  PARENT_END_DATE_CONFLICT = "PARENT_END_DATE_CONFLICT",
  /** Parent budget is deleted, expired or terminated. */
  PARENT_INVALID_STATUS = "PARENT_INVALID_STATUS",
  /** Parent budget and budget request category conflict. */
  PARENT_MCC_CONFLICT = "PARENT_MCC_CONFLICT",
  /** Parent budget and budget request start data conflict. */
  PARENT_START_DATE_CONFLICT = "PARENT_START_DATE_CONFLICT",
}

/** Result of budget request validation. */
export interface BudgetRequestValidationResult {
  /** The budget request entity id. */
  budgetRequestEntityId: Scalars["String"];
  /** List of validation errors, empty if validation succeeded. */
  errors: Array<BudgetRequestValidationError>;
}

/** The types of relationships for filtering who requested a budget request. */
export enum BudgetRequestedByFilterInput {
  /** Created by anyone in the user's company */
  COMPANY = "COMPANY",
  /** Created by the logged in user */
  ME = "ME",
}

export enum BudgetRolloverRefreshRate {
  /** Rollover amount never refreshes. */
  NEVER = "NEVER",
  /** Rollover is disabled. */
  OFF = "OFF",
  /** Rollover amount within a month is not carried into the next month. */
  PER_MONTH = "PER_MONTH",
  /** Rollover amount within a quarter is not carried into the next quarter. */
  PER_QUARTER = "PER_QUARTER",
  /** Rollover amount within a year is not carried into the next year. */
  PER_YEAR = "PER_YEAR",
}

export interface BudgetSettings {
  /** True if the budget limit is hard enforced */
  enforceLimit: Scalars["Boolean"];
  /** True if only provisioned cards can spend from this budget */
  onlyProvisionedCardSpend: Scalars["Boolean"];
}

export enum BudgetStatus {
  APPROVED = "APPROVED",
  /** @deprecated No longer used */
  CLOSED = "CLOSED",
  DELETED = "DELETED",
  /** @deprecated No longer used */
  DRAFT = "DRAFT",
  EXPIRED = "EXPIRED",
  /** @deprecated No longer used */
  REJECTED = "REJECTED",
  /** @deprecated No longer used */
  SUBMITTED = "SUBMITTED",
  TERMINATED = "TERMINATED",
}

/** A recommendation to structure the budget you just created, it provides why this recommendation was triggered and the recommended child budgets. */
export interface BudgetStructureRecommendation {
  /** The associated budget metric id that triggered this recommendation. Use it when declining or accepting a recommendation. */
  budgetMetricId: Scalars["String"];
  /** Suggested child budgets under this recommended parent */
  childBudgets: Array<Budget>;
  /** They key used to track this metric (e.g. location_id, department_id) */
  trackingKey: Scalars["String"];
  /** The tracking reason for this recommendation */
  trackingReason?: Maybe<BudgetMetricTrackingReason>;
  /** The value associated with the key for tracking (usually ids) */
  trackingValue: Scalars["String"];
}

export interface BudgetSuggestionInformation {
  /** Budget being suggested */
  budget: Budget;
  /** Enum describing what method was used to generate the budget suggestion. */
  budgetSuggestionSource: BudgetSuggestionSource;
  /** Optional. The confidence score of the budget suggestion, ranging from 1-100, highest being most confident. This can be null if the confidence score is not provided by the source. */
  confidenceScore?: Maybe<Scalars["Int"]>;
  /** Data entities used to generate the content of the suggestion. */
  expenseSuggestionOriginEntities: Array<ExpenseSuggestionOriginEntity>;
}

export enum BudgetSuggestionSource {
  /** Generated by an AI model build in house. */
  IN_HOUSE_MODEL = "IN_HOUSE_MODEL",
}

/** A budget template represents an instance of a budget template, which is a set of parameters which can be used to derive budgets */
export interface BudgetTemplate extends Node {
  /** How many active budgets exist for this template */
  activeBudgetCount?: Maybe<Scalars["Int"]>;
  approvalChains?: Maybe<TemplateApprovalChains>;
  /** Auto approval rules for requests for this template. Used to calculate whether or not a request should be auto approved. */
  autoApprovalRules?: Maybe<BudgetTemplateAutoApprovalSettings>;
  /** The rules that define who can see this template */
  availability?: Maybe<BudgetTemplateAvailability>;
  /** The auto approval settings for requests from this template, if any. If null, no requests will be eligible for auto-approval. */
  budgetAutoApprovalSettings?: Maybe<BudgetAutoApprovalSettings>;
  budgetNestingRules?: Maybe<TemplateBudgetNestingRules>;
  budgetStructure: TemplateBudgetStructure;
  /** When this template was created */
  createdAt: Scalars["Time"];
  /** Unique identifier for the user who created this template */
  creatorCustomerUserId?: Maybe<Scalars["ID"]>;
  /** Employee object which created this template */
  creatorEmployee?: Maybe<Employee>;
  /** Unique identifier for the account which owns this budget template */
  customerAccountId: Scalars["ID"];
  /** Default parent budget id for requester */
  defaultParentBudgetId?: Maybe<Scalars["ID"]>;
  /** Description for this budget template */
  description?: Maybe<Scalars["String"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  /** Whether or not this template is being used */
  inUse?: Maybe<BudgetTemplateInUse>;
  /** The number of active spend limits created from requests using this template */
  limitsFromRequestWithRequestTypeCount: Scalars["Long"];
  /** Name for this budget template */
  name: Scalars["String"];
  /** Rules for parent budget assignment; first matching rule decides. */
  parentBudgetAssignmentRules: Array<BudgetTemplateParentBudgetAssignmentRule>;
  /** The set of budget properties set on this template */
  properties: BudgetTemplateProperties;
  /** Describes how a budget template was created. */
  source: BudgetTemplateSource;
  /** The status of this budget template, whether it's active or not */
  status: BudgetTemplateStatus;
  /** The type of Template this is */
  type: BudgetTemplateType;
}

export interface BudgetTemplateAutoApprovalSettings {
  /**
   * Whether or not to automatically approve budgets created from this template.
   * Auto approval will be eligible for requests if their limit + the limit of all other auto-approved requests, is less than this in the specified time frame.
   */
  autoApprovalLimit: FinancialAsset;
  /**
   * The time period this auto approval limit applies to.
   * This will be used to sum the total amount of requests that have been auto-approved in the given timeframe.
   * In other words, we evaluate each request as: "If this request's limit + all other requested budgets in the current quarter are less than $4,000, auto approve it."
   */
  periodType: BudgetPeriodType;
}

/** Represents settings that the company configures to determine what employees can see this budget template. */
export interface BudgetTemplateAvailability {
  /** only required if type is CUSTOM. This is the list of filters that determine whether a user can see this template. */
  customFilters?: Maybe<BudgetTemplateAvailabilityUserFilters>;
  /** The type of availability setting */
  type: BudgetTemplateAvailabilityType;
}

export interface BudgetTemplateAvailabilityInput {
  /** only required if type is CUSTOM. This is the list of filters that determine whether a user can see this template. */
  customFilters?: InputMaybe<BudgetTemplateAvailabilityUserFiltersInput>;
  /** The type of availability setting */
  type: BudgetTemplateAvailabilityTypeInput;
}

/** Specifies the general type of availability selected by the user */
export enum BudgetTemplateAvailabilityType {
  /** Only admins can see the template */
  ADMINS_ONLY = "ADMINS_ONLY",
  /** Custom filters define who can see the template */
  CUSTOM = "CUSTOM",
  /** Everyone at the company can see the template */
  EVERYONE = "EVERYONE",
}

/** Specifies the general type of availability selected by the user */
export enum BudgetTemplateAvailabilityTypeInput {
  /** Only admins can see the template */
  ADMINS_ONLY = "ADMINS_ONLY",
  /** Custom filters define who can see the template */
  CUSTOM = "CUSTOM",
  /** Everyone at the company can see the template */
  EVERYONE = "EVERYONE",
}

/**
 * Each attribute included in this filter is ORed together.
 * So if there are 2 costCenters specified and 3 departments, users that belong to any of those cost centers or departments are all included in the filter.
 */
export interface BudgetTemplateAvailabilityUserAttributeFilters {
  /** all members of these cost centers can see the template */
  costCenters: Array<CostCenter>;
  /** all members of these departments can see the template */
  departments: Array<Department>;
  /** all members of these legal entities can see the template */
  legalEntities: Array<LegalEntity>;
  /** all employees at these locations can see the template */
  locations: Array<Location>;
  /** all employees with these titles can see the template */
  titles: Array<Title>;
}

/**
 * Each attribute included in this filter is ORed together.
 * So if there are 2 costCenters specified and 3 departments, users that belong to any of those cost centers or departments are all included in the filter.
 */
export interface BudgetTemplateAvailabilityUserAttributeFiltersInput {
  /** all members of these cost centers can see the template */
  costCenterIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** all members of these departments can see the template */
  departmentIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** all members of these legal entities can see the template */
  legalEntityIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** all employees at these locations can see the template */
  locationIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** all employees with these titles can see the template */
  titleIds?: InputMaybe<Array<Scalars["ID"]>>;
}

/** Represents user ids and/or filters by attributes */
export interface BudgetTemplateAvailabilityUserFilters {
  /** Filters that determine what users can see the template. Each filter in the list is ANDed together */
  userAttributeFilters?: Maybe<
    Array<BudgetTemplateAvailabilityUserAttributeFilters>
  >;
  /** List of users that can see the template. These ids are always used, regardless of userAttributeFilters that are applied */
  users?: Maybe<Array<User>>;
}

/** Represents user ids and/or filters by attributes */
export interface BudgetTemplateAvailabilityUserFiltersInput {
  /** Filters that determine what users can see the template. Each filter in the list is ANDed together */
  userAttributeFilters?: InputMaybe<
    Array<BudgetTemplateAvailabilityUserAttributeFiltersInput>
  >;
  /** List of users that can see the template. These ids are always used, regardless of userAttributeFilters that are applied */
  userIds?: InputMaybe<Array<Scalars["ID"]>>;
}

/** An BudgetTemplate connection for BudgetTemplate pagination. */
export interface BudgetTemplateConnection extends Connection {
  /** The budget templates in the current page of results. */
  edges: Array<BudgetTemplateEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of budget matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface BudgetTemplateCreationGeneralMetadataInput {
  description: Scalars["String"];
  endDate?: InputMaybe<Scalars["Date"]>;
  limit: FinancialAssetInput;
  limitVisibility?: InputMaybe<BudgetLimitVisibilityType>;
  members: Array<Scalars["ID"]>;
  name: Scalars["String"];
  owners: Array<Scalars["ID"]>;
  parentBudgetId?: InputMaybe<Scalars["ID"]>;
  periodType: BudgetPeriodType;
  startDate: Scalars["Date"];
}

/** Budget Templates metadata that describes the metadata structure for each type */
export type BudgetTemplateCreationMetadata =
  | BudgetTemplateGeneralMetadata
  | BudgetTemplateOffsiteMetadata
  | BudgetTemplateProcurementMetadata
  | BudgetTemplateStipendMetadata
  | BudgetTemplateTravelMetadata;

export interface BudgetTemplateCreationOffsiteMetadataInput {
  /** A description of the spend limit being requested. */
  description: Scalars["String"];
  /** DEPRECATED: Use spendLimitEndDate and travelEndDate instead. */
  endDate?: InputMaybe<Scalars["Date"]>;
  /** The limit being requested. */
  limit: FinancialAssetInput;
  /** The location being visited for this offsite. */
  location?: InputMaybe<BudgetTemplateLocationMetadataInput>;
  /** A list of all members attending this offsite. */
  members: Array<Scalars["ID"]>;
  /** The name of the spend limit being requested. */
  name: Scalars["String"];
  /** The end date of the offsite. */
  offsiteEndDate?: InputMaybe<Scalars["Date"]>;
  /** The start date of the offsite, inclusive. */
  offsiteStartDate?: InputMaybe<Scalars["Date"]>;
  /** A list of all owners of this offsite spend limit. */
  owners?: InputMaybe<Array<Scalars["ID"]>>;
  /** The ID for the parent budget this spend limit is being created under. */
  parentBudgetId?: InputMaybe<Scalars["ID"]>;
  /** The end date for the requested spend limit. */
  spendLimitEndDate?: InputMaybe<Scalars["Date"]>;
  /** The start date of the underlying spend limit, inclusive. */
  spendLimitStartDate?: InputMaybe<Scalars["Date"]>;
  /** DEPRECATED: Use spendLimitStartDate and travelStartDate instead. */
  startDate?: InputMaybe<Scalars["Date"]>;
}

export interface BudgetTemplateCreationProcurementMetadataInput {
  description: Scalars["String"];
  endDate?: InputMaybe<Scalars["Date"]>;
  limit: FinancialAssetInput;
  limitBufferPercentage?: InputMaybe<Scalars["Int"]>;
  limitFlexibility?: InputMaybe<LimitFlexibilityType>;
  limitVisibility?: InputMaybe<BudgetLimitVisibilityType>;
  members: Array<Scalars["ID"]>;
  name: Scalars["String"];
  owners: Array<Scalars["ID"]>;
  parentBudgetId?: InputMaybe<Scalars["ID"]>;
  periodType: BudgetPeriodType;
  startDate: Scalars["Date"];
}

export interface BudgetTemplateCreationStipendMetadataInput {
  description: Scalars["String"];
  endDate?: InputMaybe<Scalars["Date"]>;
  limit: FinancialAssetInput;
  limitVisibility?: InputMaybe<BudgetLimitVisibilityType>;
  members: Array<Scalars["ID"]>;
  name: Scalars["String"];
  owners: Array<Scalars["ID"]>;
  parentBudgetId?: InputMaybe<Scalars["ID"]>;
  periodType: BudgetPeriodType;
  startDate: Scalars["Date"];
}

/** Metadata for budgets allocated for travel */
export interface BudgetTemplateCreationTravelMetadataInput {
  /** A description of the spend limit being requested. */
  description: Scalars["String"];
  /** DEPRECATED: Use spendLimitEndDate and travelEndDate instead. */
  endDate?: InputMaybe<Scalars["Date"]>;
  /**
   * The start/destination locations and flight dates
   * This is optional - the travel may not be necessarily be air travel
   */
  flightLegs?: InputMaybe<Array<BudgetTemplateFlightLegInput>>;
  /** The origin of travel. */
  fromLocation?: InputMaybe<BudgetTemplateLocationMetadataInput>;
  /** The limit being requested. */
  limit: FinancialAssetInput;
  /** The name of the spend limit being requested. */
  name: Scalars["String"];
  /** The parent budget ID for this spend limit to be created under. */
  parentBudgetId?: InputMaybe<Scalars["ID"]>;
  /** The end date for the requested spend limit. */
  spendLimitEndDate?: InputMaybe<Scalars["Date"]>;
  /** The start date of the underlying spend limit, inclusive. */
  spendLimitStartDate?: InputMaybe<Scalars["Date"]>;
  /** DEPRECATED: Use spendLimitStartDate and travelStartDate instead. */
  startDate?: InputMaybe<Scalars["Date"]>;
  /** All destinations being travel to on this trip. */
  toLocations?: InputMaybe<Array<BudgetTemplateLocationMetadataInput>>;
  /**
   * An estimate of a breakdown of travel costs
   * This is optional - if not provided, the limit field is available for the total budget limit
   */
  travelBudgetEstimate?: InputMaybe<BudgetTemplateTravelBudgetEstimateInput>;
  /** The end date of travel. */
  travelEndDate?: InputMaybe<Scalars["Date"]>;
  /** The start date of travel, inclusive. */
  travelStartDate?: InputMaybe<Scalars["Date"]>;
  /** What type of travel is being conducted for this. */
  travelType: BudgetTemplateTravelType;
}

/** A budget template derived metadata describes the template data used to generate either a budget request or budget from a specific budget template */
export interface BudgetTemplateDerivedMetadata {
  /** Budget Templates metadata that describes the metadata structure for each type. Set on creation of the Budget Request or Budget. */
  budgetTemplateCreationMetadata?: Maybe<BudgetTemplateCreationMetadata>;
  /** ID for the budget template that was referenced in the creation of the derived metadata */
  budgetTemplateId: Scalars["ID"];
  /** Type for the budget template that was referenced in the creation of the derived metadata */
  budgetTemplateType: BudgetTemplateType;
  /** Unique identifier for this Budget Template Derived Metadata */
  id: Scalars["ID"];
}

export interface BudgetTemplateDerivedMetadataOneOfInput {
  generalMetadata?: InputMaybe<BudgetTemplateCreationGeneralMetadataInput>;
  offsiteMetadata?: InputMaybe<BudgetTemplateCreationOffsiteMetadataInput>;
  procurementMetadata?: InputMaybe<BudgetTemplateCreationProcurementMetadataInput>;
  stipendMetadata?: InputMaybe<BudgetTemplateCreationStipendMetadataInput>;
  travelMetadata?: InputMaybe<BudgetTemplateCreationTravelMetadataInput>;
}

/** A BudgetTemplate edge for the BudgetTemplate connection. */
export interface BudgetTemplateEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The budget at this edge. */
  node?: Maybe<BudgetTemplate>;
}

export interface BudgetTemplateFilterInput {
  /** Budget template Status IN statuses */
  statuses?: InputMaybe<Array<BudgetTemplateStatus>>;
  /** Budget template type IN types */
  types?: InputMaybe<Array<InputMaybe<BudgetTemplateType>>>;
  /** Whether or not we want to filter the results to only templates usable by the requester */
  usableByRequester?: InputMaybe<Scalars["Boolean"]>;
}

/** A flight segment. This is informational to provide context on the budget limit requested */
export interface BudgetTemplateFlightLeg {
  /** The date of the flight */
  date?: Maybe<Scalars["Date"]>;
  /** The flight's ending location */
  destination?: Maybe<BudgetTemplateFlightTerminus>;
  /** The flight's starting location */
  origin?: Maybe<BudgetTemplateFlightTerminus>;
}

/** A flight segment. This is informational to provide context on the budget limit requested */
export interface BudgetTemplateFlightLegInput {
  /** The date of the flight */
  date?: InputMaybe<Scalars["Date"]>;
  /** The flight's ending location */
  destination?: InputMaybe<BudgetTemplateFlightTerminusInput>;
  /** The flight's starting location */
  origin?: InputMaybe<BudgetTemplateFlightTerminusInput>;
}

/** An endpoint of a flight leg */
export interface BudgetTemplateFlightTerminus {
  /** The IATA airport code, e.g. "JFK" */
  airportCode?: Maybe<Scalars["String"]>;
  /** A description of the location, e.g. "John F. Kennedy International Airport" */
  displayName?: Maybe<Scalars["String"]>;
}

/** An endpoint of a flight leg */
export interface BudgetTemplateFlightTerminusInput {
  /** The IATA airport code, e.g. "JFK" */
  airportCode?: InputMaybe<Scalars["String"]>;
  /** A description of the location, e.g. "John F. Kennedy International Airport" */
  displayName?: InputMaybe<Scalars["String"]>;
}

export interface BudgetTemplateGeneralMetadata {
  description: Scalars["String"];
  endDate?: Maybe<Scalars["Date"]>;
  limit: FinancialAsset;
  members: Array<Scalars["ID"]>;
  name: Scalars["String"];
  owners: Array<Scalars["ID"]>;
  periodType: BudgetPeriodType;
  startDate: Scalars["Date"];
}

export enum BudgetTemplateInUse {
  /** Template is being used. */
  IN_USE = "IN_USE",
  /** Template is not being used. */
  NOT_IN_USE = "NOT_IN_USE",
}

export interface BudgetTemplateLocationMetadata {
  displayName: Scalars["String"];
  googlePlacesExternalId: Scalars["ID"];
}

export interface BudgetTemplateLocationMetadataInput {
  displayName: Scalars["String"];
  googlePlacesExternalId: Scalars["ID"];
}

export interface BudgetTemplateOffsiteMetadata {
  /** A description for this spend limit request. */
  description: Scalars["String"];
  /**
   * (soon to be) DEPRECATED: Use offsiteEndDate and spendLimitEndDate instead.
   * Historically this has represented the end date of the offsite.
   */
  endDate?: Maybe<Scalars["Date"]>;
  /** The requested limit for this spend limit */
  limit: FinancialAsset;
  /** The location of the offsite. */
  location?: Maybe<BudgetTemplateLocationMetadata>;
  /** A list of member IDs for the spend limit request. */
  members: Array<Scalars["ID"]>;
  /** The name for the requested spend limit */
  name: Scalars["String"];
  /** The end date of the offsite. */
  offsiteEndDate?: Maybe<Scalars["Date"]>;
  /** The start date of the offsite, inclusive. */
  offsiteStartDate?: Maybe<Scalars["Date"]>;
  /** A list of owner IDs for the spend limit request. */
  owners?: Maybe<Array<Scalars["ID"]>>;
  /** The end date for the requested spend limit. */
  spendLimitEndDate?: Maybe<Scalars["Date"]>;
  /** The start date of the underlying spend limit, inclusive. */
  spendLimitStartDate?: Maybe<Scalars["Date"]>;
  /**
   * (soon to be) DEPRECATED: Use offsiteStartDate and spendLimitStartDate instead.
   * Historically this has represented the start date of the offsite.
   */
  startDate?: Maybe<Scalars["Date"]>;
}

export type BudgetTemplateParentBudgetAssignmentRule =
  | BudgetTemplateSpecificParentBudgetRule
  | BudgetTemplateUserCostCenterRule
  | BudgetTemplateUserDepartmentRule;

export interface BudgetTemplateParentBudgetAssignmentRuleInput {
  specificParentBudgetId?: InputMaybe<Scalars["ID"]>;
  userCostCenterRule?: InputMaybe<BudgetTemplateUserCostCenterRuleInput>;
  userDepartmentRule?: InputMaybe<BudgetTemplateUserDepartmentRuleInput>;
}

export interface BudgetTemplateProcurementMetadata {
  description: Scalars["String"];
  endDate?: Maybe<Scalars["Date"]>;
  limit: FinancialAsset;
  limitBufferPercentage?: Maybe<Scalars["Int"]>;
  limitFlexibility?: Maybe<LimitFlexibilityType>;
  members: Array<Scalars["ID"]>;
  name: Scalars["String"];
  owners: Array<Scalars["ID"]>;
  periodType: BudgetPeriodType;
  startDate: Scalars["Date"];
}

/** A set of Budget-related properties held on a template */
export interface BudgetTemplateProperties {
  /** Setting for auto-transferring budget cards when their owners are either disabled or removed as members from the budget. */
  autoTransferCardsSetting?: Maybe<AutoTransferCardsSetting>;
  /** The budget limit increase request policy associated with this budget template */
  budgetLimitIncreaseRequestPolicy?: Maybe<Policy>;
  /** The budget request policy associated with this budget template */
  budgetRequestPolicy?: Maybe<Policy>;
  /** Whether or not budgets derived from this template can inherit */
  canInherit: Scalars["Boolean"];
  /** A description about what this template represents */
  description?: Maybe<Scalars["String"]>;
  /** Default end date (if any) for budgets derived from this template */
  endDate?: Maybe<Scalars["Date"]>;
  /** Whether or not we want to budgets derived from this template to enforce limits */
  enforceLimit: Scalars["Boolean"];
  /** Default limit buffer applied to budgets derived from this template */
  enforceLimitBufferPercentage?: Maybe<Scalars["Int"]>;
  /** The expense policy associated with this budget template */
  expensePolicy: Policy;
  /** Whether or not budgets created from this will share visibility */
  expenseVisibilityShared?: Maybe<Scalars["Boolean"]>;
  /** The limit associated with this budget template */
  limit?: Maybe<FinancialAsset>;
  /** The spend limit approval policy associated with this budget template */
  limitApprovalPolicy?: Maybe<Policy>;
  /** Whether or not budgets derived from this template may have limit increase requests applied */
  limitIncreaseRequestEnabled: Scalars["Boolean"];
  /** Determines if budget members are allowed to view the budget limit */
  limitVisibility: BudgetLimitVisibilityType;
  /** Limit including the buffer, NULL if the budget is flexible */
  limitWithBuffer?: Maybe<FinancialAsset>;
  /** A list of employees who may be members of budgets created from this template */
  memberEmployees?: Maybe<Array<Maybe<Employee>>>;
  /** The name of the budget template */
  name?: Maybe<Scalars["String"]>;
  /** Whether or not only provisioned cards can spend from budgets derived from this template */
  onlyProvisionedCardSpend: Scalars["Boolean"];
  /** A list of employees who are to own budgets derived from these templates */
  ownerEmployees?: Maybe<Array<Maybe<Employee>>>;
  /** Default period type for budgets derived from this template */
  periodType?: Maybe<BudgetPeriodType>;
  /** Default start date (if any) for budgets derived from this template */
  startDate?: Maybe<Scalars["Date"]>;
  /** The policy ID for the template and all budgets derived from it */
  templatePolicyId: Scalars["ID"];
}

/**
 * Describes how a budget template was created. Used to sift "starter" templates from other templates for first-time user
 * experience.
 */
export enum BudgetTemplateSource {
  /** Template was created by user directly. */
  CREATED = "CREATED",
  /** Template was created by user by duplicating another template. */
  DUPLICATED = "DUPLICATED",
  /** Template was the result of a migration from a pre-Templates policy. */
  MIGRATED = "MIGRATED",
  /** Template is a pre-defined "starter" template */
  STARTER = "STARTER",
}

export interface BudgetTemplateSpecificParentBudgetRule {
  /** Parent budget that should be assigned based on this rule */
  parentBudget: Budget;
  /** Parent budget ID that should be assigned based on this rule */
  parentBudgetId: Scalars["ID"];
}

export enum BudgetTemplateStatus {
  ACTIVE = "ACTIVE",
  DRAFT = "DRAFT",
  INACTIVE = "INACTIVE",
  PAUSED = "PAUSED",
}

/** Types of budget template */
export enum BudgetTemplateStatusInput {
  ACTIVE = "ACTIVE",
  DRAFT = "DRAFT",
  INACTIVE = "INACTIVE",
  PAUSED = "PAUSED",
}

export interface BudgetTemplateStipendMetadata {
  description: Scalars["String"];
  endDate?: Maybe<Scalars["Date"]>;
  limit: FinancialAsset;
  members: Array<Scalars["ID"]>;
  name: Scalars["String"];
  owners: Array<Scalars["ID"]>;
  periodType: BudgetPeriodType;
  startDate: Scalars["Date"];
}

/**
 * An estimate of a breakdown of travel costs
 * All fields are optional - for example a traveller may only require lodging but not flight, or only rideshare, etc
 */
export interface BudgetTemplateTravelBudgetEstimate {
  /** An estimate of the total flight cost for the trip */
  flightBudgetEstimate?: Maybe<FinancialAsset>;
  /** An estimate of the total lodging cost for the trip */
  lodgingBudgetEstimate?: Maybe<FinancialAsset>;
  /** An estimate of the total allowance for meals */
  mealBudgetEstimate?: Maybe<FinancialAsset>;
  /** An estimate of the total allowance for rideshare */
  rideshareBudgetEstimate?: Maybe<FinancialAsset>;
}

/**
 * An estimate of a breakdown of travel costs
 * All fields are optional - for example a traveller may only require lodging but not flight, or only rideshare, etc
 */
export interface BudgetTemplateTravelBudgetEstimateInput {
  /** An estimate of the total flight cost for the trip */
  flightBudgetEstimate?: InputMaybe<FinancialAssetInput>;
  /** An estimate of the total lodging cost for the trip */
  lodgingBudgetEstimate?: InputMaybe<FinancialAssetInput>;
  /** An estimate of the total allowance for meals */
  mealBudgetEstimate?: InputMaybe<FinancialAssetInput>;
  /** An estimate of the total allowance for rideshare */
  rideshareBudgetEstimate?: InputMaybe<FinancialAssetInput>;
}

/** Metadata for budgets allocated for travel */
export interface BudgetTemplateTravelMetadata {
  /** A description for this spend limit request. */
  description: Scalars["String"];
  /**
   * (soon to be) DEPRECATED: Use travelEndDate and spendLimitEndDate instead.
   * Historically this has represented the end date of travel.
   */
  endDate?: Maybe<Scalars["Date"]>;
  /**
   * The start/destination locations and flight dates
   * This is optional - the travel may not be necessarily be air travel
   */
  flightLegs?: Maybe<Array<BudgetTemplateFlightLeg>>;
  /** The original location for travel. */
  fromLocation?: Maybe<BudgetTemplateLocationMetadata>;
  /** The requested limit for this spend limit */
  limit: FinancialAsset;
  /** The name for the requested spend limit */
  name: Scalars["String"];
  /** The end date for the requested spend limit. */
  spendLimitEndDate?: Maybe<Scalars["Date"]>;
  /** The start date of the underlying spend limit, inclusive. */
  spendLimitStartDate?: Maybe<Scalars["Date"]>;
  /**
   * (soon to be) DEPRECATED: Use travelStartDate and spendLimitStartDate instead.
   * Historically this has represented the start date of travel.
   */
  startDate?: Maybe<Scalars["Date"]>;
  /** A list of destinations for this trip */
  toLocations?: Maybe<Array<BudgetTemplateLocationMetadata>>;
  /**
   * An estimate of a breakdown of travel costs
   * This is optional - if not provided, the limit field is available for the total budget limit
   */
  travelBudgetEstimate?: Maybe<BudgetTemplateTravelBudgetEstimate>;
  /** The end date of the travel period. */
  travelEndDate?: Maybe<Scalars["Date"]>;
  /** The start date of the travel period, inclusive. */
  travelStartDate?: Maybe<Scalars["Date"]>;
  /** What type of travel this trip is. */
  travelType: BudgetTemplateTravelType;
}

/**
 * The travel type for a given Budget Template. These are specified specifically for Travel Budget
 * templates.
 */
export enum BudgetTemplateTravelType {
  FLIGHT_ONE_WAY = "FLIGHT_ONE_WAY",
  FLIGHT_ROUND_TRIP = "FLIGHT_ROUND_TRIP",
  OTHER = "OTHER",
}

export enum BudgetTemplateType {
  OFFSITE = "OFFSITE",
  OTHER = "OTHER",
  PROCUREMENT = "PROCUREMENT",
  STIPEND = "STIPEND",
  TRAVEL = "TRAVEL",
}

export interface BudgetTemplateUserCostCenterRule {
  /** The period, and limits, by which auto approval will be restricted to use. */
  autoApprovalRules?: Maybe<BudgetTemplateAutoApprovalSettings>;
  /** Parent budget that should be assigned based on this rule */
  parentBudget: Budget;
  /** Parent budget ID that should be assigned based on this rule */
  parentBudgetId: Scalars["ID"];
  /**
   * Cost center ID of the given user as defined within hierarchies
   * @deprecated use userCostCenters
   */
  userCostCenterIds: Array<Scalars["ID"]>;
  /** Cost center of the given user as defined within hierarchies */
  userCostCenters: Array<CostCenter>;
}

export interface BudgetTemplateUserCostCenterRuleInput {
  /** Parent budget ID that should be assigned based on this rule */
  parentBudgetId: Scalars["ID"];
  /** Cost center ID of the given user as defined within hierarchies */
  userCostCenterIds: Array<Scalars["ID"]>;
}

export interface BudgetTemplateUserDepartmentRule {
  /** The period, and limits, by which auto approval will be restricted to use. */
  autoApprovalRules?: Maybe<BudgetTemplateAutoApprovalSettings>;
  /** Parent budget that should be assigned based on this rule */
  parentBudget: Budget;
  /** Parent budget ID that should be assigned based on this rule */
  parentBudgetId: Scalars["ID"];
  /**
   * Department ID of the given user as defined within hierarchies
   * @deprecated use userDepartments
   */
  userDepartmentIds: Array<Scalars["ID"]>;
  /** Department of the given user as defined within hierarchies */
  userDepartments: Array<Department>;
}

export interface BudgetTemplateUserDepartmentRuleInput {
  /** Parent budget ID that should be assigned based on this rule */
  parentBudgetId: Scalars["ID"];
  /** Department ID of the given user as defined within hierarchies */
  userDepartmentIds: Array<Scalars["ID"]>;
}

export interface BudgetTreeNode {
  /**
   * The Customer Account
   * Nullable to support partial failure
   */
  account?: Maybe<Account>;
  /** The allocation metrics of the budget. */
  allocation?: Maybe<AllocationMetrics>;
  /** A list of operations that the user can perform on the spend limit */
  allowedOperations: Array<BudgetTreeNodeOperationPermission>;
  /** Amount spend in the current period */
  amountSpent?: Maybe<FinancialAsset>;
  /** The employees who are considered owners of this entity and its parent budgets (nullable for partial failure) */
  ancestralOwners?: Maybe<UserConnection>;
  /**
   * The number of budget tree nodes associated with this entity. It means the provisioned by the limit group,
   * or the budget's children, or zero for spend limits.
   * It has a filter by status. If not provided, then default statuses are used (ACTIVE).
   */
  associatedNodesCount: Scalars["Int"];
  /** Whether or not the entity is authable (Ex. Expense reports have authable=false) */
  authable?: Maybe<Scalars["Boolean"]>;
  /**
   * Authorization settings of a spend limit
   * null if user does not have permission to view these settings (based off authorizationVisibility)
   */
  authorizationSettings?: Maybe<SpendLimitAuthorizationSettings>;
  /**
   * Privacy setting whether its members are allowed to view the limit & authorization settings
   * (previously known as limit visibility)
   */
  authorizationVisibility?: Maybe<SpendLimitAuthorizationVisibility>;
  /** Setting for auto-transferring budget cards when their owners are either disabled or removed as members from the budget. */
  autoTransferCardsSetting?: Maybe<AutoTransferCardsSetting>;
  /** Time when the entity was created */
  createdAt: Scalars["Time"];
  /** Description of what the entity is used for */
  description?: Maybe<Scalars["String"]>;
  /** The optional end date of the entity, inclusive. */
  endDate?: Maybe<Scalars["Date"]>;
  /** True if the limit is hard enforced */
  enforceLimit: Scalars["Boolean"];
  /**
   * The underlying entity (SpendBudget, SpendLimit, or LimitGroup) for this budget tree node.
   * This enables direct access to the full entity data rather than only using materialized fields.
   */
  entity?: Maybe<BudgetTreeNodeEntity>;
  /** Entity ID - the spend limit or limit group ID */
  entityId: Scalars["ID"];
  /** Whether the entity is a budget, spend limit, or limit group */
  entityType: BudgetTreeNodeEntityType;
  /** Determines if members are allowed to view other members' expenses. */
  expenseVisibility?: Maybe<SpendLimitExpenseVisibility>;
  /** Determines how the user group members are synced. */
  groupSyncType?: Maybe<BudgetTreeNodeGroupSyncType>;
  /** Logical ID */
  id: Scalars["ID"];
  /** The instrument code (USD, etc.). */
  instrumentCode: Scalars["String"];
  /** True if the entity is a direct child of the root budget. */
  isRootChild: Scalars["Boolean"];
  /**
   * Whether the legal entity is explicitly mapped to the entity
   *
   * If true, the legal entity is explicitly mapped to the entity
   * Otherwise, the legal entity is derived from the entity's ancestry
   */
  legalEntityExplicitlySet: Scalars["Boolean"];
  /** [Optional] The legal entity override for the entity */
  legalEntityId?: Maybe<Scalars["String"]>;
  /**
   * The original limit value set for the entity.
   *
   * It does not include any limit increases or rollover. See spendableLimit if needed.
   */
  limit?: Maybe<FinancialAsset>;
  /** The policy that manages approval chain for limit increase requests. */
  limitApprovalPolicyId?: Maybe<Scalars["String"]>;
  /**
   * Budget limit increase requests
   * Takes in an active filter (to fetch limit increase requests currently applied to the budget).
   */
  limitIncreaseRequests: Array<Maybe<BudgetLimitIncreaseRequestEntity>>;
  /** Whether the limit increase feature is enabled for this entity */
  limitIncreaseSetting?: Maybe<LimitIncreaseSetting>;
  /** The employees who are considered members of this entity (nullable for partial failure) */
  members?: Maybe<UserConnection>;
  /** Merchant category controls, including those along ancestry path. */
  merchantCategoryControls?: Maybe<MerchantCategoryControls>;
  /** Name of the entity */
  name: Scalars["String"];
  /** The employees who are considered owners of this entity (nullable for partial failure) */
  owners?: Maybe<UserConnection>;
  /** The parent of this entity, if any */
  parentBudget?: Maybe<SpendBudget>;
  /** The recurring period type. */
  periodRecurrenceType: BudgetTreeNodePeriodType;
  /** The policy governing this entity */
  policy?: Maybe<Policy>;
  /** For a spend limit, the associated limit group, if any */
  provisionedByLimitGroup?: Maybe<LimitGroup>;
  /** For a spend limit, the ID of the associated limit group, if any */
  provisionedByLimitGroupId?: Maybe<Scalars["ID"]>;
  /** The ID of the legacy template, for spend limits */
  spendLimitTemplateId?: Maybe<Scalars["ID"]>;
  /** Allowed spend sources on a Spend Limit. */
  spendSourceSetting?: Maybe<SpendSourceSetting>;
  /**
   * For a spend limit, the total spendable limit, including limit increases and rollover
   * For a limit group, the sum of all spendable limits of its associated spend limits
   * Null if spend limits have different currencies
   */
  spendableLimit?: Maybe<FinancialAsset>;
  /** The optional end date of the entity, inclusive. */
  startDate?: Maybe<Scalars["Date"]>;
  /** Status of the entity */
  status: BudgetTreeNodeStatus;
  /** The timezone of the entity */
  timezone: Scalars["String"];
  /**
   * The transaction limit mapped to the entity.
   * Null if no transaction limit is set.
   */
  transactionLimit?: Maybe<FinancialAsset>;
  /** Time when the entity was created */
  updatedAt: Scalars["Time"];
  /** The percentage of the spendable limit that has been used this period */
  usagePercentage?: Maybe<Scalars["Int"]>;
  /** The amount spent for the current user, this is only applicable to spend limits. */
  userAmountSpent?: Maybe<FinancialAsset>;
  /** The user group associated with this entity */
  userGroup?: Maybe<Group>;
}

export interface BudgetTreeNodeallowedOperationsArgs {
  operations: Array<BudgetTreeNodeOperation>;
}

export interface BudgetTreeNodeancestralOwnersArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<BudgetTreeNodePersonnelFilter>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  order?: InputMaybe<BudgetTreeNodePersonnelOrder>;
  page?: InputMaybe<PaginationInput>;
}

export interface BudgetTreeNodeassociatedNodesCountArgs {
  statuses?: InputMaybe<Array<BudgetTreeNodeStatus>>;
}

export interface BudgetTreeNodelimitIncreaseRequestsArgs {
  active?: InputMaybe<Scalars["Boolean"]>;
}

export interface BudgetTreeNodemembersArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<BudgetTreeNodePersonnelFilter>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  order?: InputMaybe<BudgetTreeNodePersonnelOrder>;
  page?: InputMaybe<PaginationInput>;
}

export interface BudgetTreeNodeownersArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<BudgetTreeNodePersonnelFilter>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  order?: InputMaybe<BudgetTreeNodePersonnelOrder>;
  page?: InputMaybe<PaginationInput>;
}

/** Possible batch operations a user could perform on a BudgetTreeNode. */
export enum BudgetTreeNodeBatchedOperation {
  ARCHIVE = "ARCHIVE",
  DELETE = "DELETE",
  UNEXPIRE = "UNEXPIRE",
  UNTERMINATE = "UNTERMINATE",
}

/** A BudgetTreeNode connection for BudgetTreeNode pagination. */
export interface BudgetTreeNodeConnection extends Connection {
  /** The BudgetTreeNodes in the current page of results. */
  edges: Array<BudgetTreeNodeEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of BudgetTreeNodes matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

/** A BudgetTreeNode edge for the BudgetTreeNode connection. */
export interface BudgetTreeNodeEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The BudgetTreeNode at this edge. */
  node: BudgetTreeNode;
}

/** A BudgetTreeNode union for resolving the actual entity (SpendBudget, SpendLimit, or LimitGroup). */
export type BudgetTreeNodeEntity = LimitGroup | SpendBudget | SpendLimit;

/** The type of the BudgetTreeNode entity */
export enum BudgetTreeNodeEntityType {
  BUDGET = "BUDGET",
  LIMIT_GROUP = "LIMIT_GROUP",
  SPEND_LIMIT = "SPEND_LIMIT",
}

/**  ---[ Inputs ]--------------------- */
export interface BudgetTreeNodeFilterInput {
  /** Whether or not the BudgetTreeNode is authable (Ex. Expense reports have authable=false) */
  authable?: InputMaybe<Scalars["Boolean"]>;
  /** Filter by budgetIds (also works for limit group ids) */
  budgetIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Filter to include the listed template ids */
  budgetTemplateIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Filter by entity type (LIMIT_GROUP, BUDGET, or SPEND_LIMIT) */
  entityType?: InputMaybe<BudgetTreeNodeEntityType>;
  /** Exclude spend limits associated with a limit group */
  excludeProvisionedLimits?: InputMaybe<Scalars["Boolean"]>;
  /** Filter by group sync type (AUTO, AUTO_ADD, or MANUAL). It is not applicable for budgets. */
  groupSyncTypes?: InputMaybe<Array<BudgetTreeNodeGroupSyncType>>;
  /** Match IN specific members (excludes limit groups) */
  memberCustomerUserIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Search BudgetTreeNode by name */
  name?: InputMaybe<Scalars["String"]>;
  /** Whether or not the BudgetTreeNode has a virtual card */
  onlyProvisionedCardSpend?: InputMaybe<Scalars["Boolean"]>;
  /**
   * Match IN specific owners, including ancestrally owned, which means owner of a parent budget.
   * When this filter is provided without parentBudgetIds or provisionedByLimitGroupId,
   * then we will not return spend limits or nodes nested under other owned nodes.
   * Which means this will return only top level budgets or SLGs.
   */
  ownerCustomerUserIds?: InputMaybe<Array<Scalars["ID"]>>;
  /**
   * Filter by parent budget ids.
   * If this filter is not provided, and neither provisionedByLimitGroupId or ownerCustomerUserIds,
   * then it will default to the root budget.
   */
  parentBudgetIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Filter by period recurrencce types */
  periodRecurrenceTypes?: InputMaybe<Array<BudgetTreeNodePeriodType>>;
  /** Filter BudgetTreeNode by the policy they are using. */
  policyIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Only include spend limits associated with specific limit groups */
  provisionedByLimitGroupId?: InputMaybe<Array<Scalars["ID"]>>;
  /** BudgetTreeNode Status IN statuses */
  statuses?: InputMaybe<Array<BudgetTreeNodeStatus>>;
}

/** Determines how the user group members are synced. */
export enum BudgetTreeNodeGroupSyncType {
  /** The group members are synced automatically */
  AUTO = "AUTO",
  /** The group members are added automatically */
  AUTO_ADD = "AUTO_ADD",
  /** The group members are not synced automatically */
  MANUAL = "MANUAL",
}

/** Possible operations a user could perform on a BudgetTreeNode */
export enum BudgetTreeNodeOperation {
  /** Update the status to archived */
  ARCHIVE = "ARCHIVE",
  /** Convert the spend limit to a purchasing card. This operation is only available for spend limits */
  CONVERT_TO_PURCHASING_CARD = "CONVERT_TO_PURCHASING_CARD",
  /** Update the status to deleted */
  DELETE = "DELETE",
  /** Update any of the fields */
  EDIT_FULL = "EDIT_FULL",
  /** Update the owners and members */
  EDIT_USERS = "EDIT_USERS",
  /** Reassign the to a new parent */
  MOVE = "MOVE",
  /** Update the status from archived or expired to active */
  REOPEN = "REOPEN",
  /** Create a limit increase request */
  REQUEST_LIMIT_INCREASE = "REQUEST_LIMIT_INCREASE",
  /** View other member's expenses for the spend limit */
  VIEW_EXPENSES = "VIEW_EXPENSES",
  /** View the limit. Disabled for members if the limit is masked */
  VIEW_LIMIT = "VIEW_LIMIT",
  /** View the owners and members */
  VIEW_USERS = "VIEW_USERS",
}

export interface BudgetTreeNodeOperationPermission {
  allowed: Scalars["Boolean"];
  disabledReason?: Maybe<Array<Scalars["String"]>>;
  operation: BudgetTreeNodeOperation;
}

export interface BudgetTreeNodeOrderInput {
  direction: OrderByDirection;
  field: SortableBudgetTreeNodeField;
}

/** Available period types for a BudgetTreeNode */
export enum BudgetTreeNodePeriodType {
  ONE_TIME = "ONE_TIME",
  PER_MONTH = "PER_MONTH",
  PER_QUARTER = "PER_QUARTER",
  PER_WEEK = "PER_WEEK",
  PER_YEAR = "PER_YEAR",
}

export interface BudgetTreeNodePersonnelFilter {
  /** filter for users by name */
  name: Scalars["String"];
}

export interface BudgetTreeNodePersonnelOrder {
  /** Direction */
  direction: OrderByDirection;
  /** Which field is being sorted on */
  field: SortableBudgetTreeNodePersonnelField;
}

/** BudgetTreeNode statuses */
export enum BudgetTreeNodeStatus {
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
  DELETED = "DELETED",
  EXPIRED = "EXPIRED",
}

export enum BudgetType {
  /**
   * An entity that groups and tracks total spend (newly introduced by budgets bifurcation).
   * Typically the parent nodes of the budget structure tree.
   */
  BUDGET = "BUDGET",
  /**
   * An entity that you can directly spend out of with spend controls (previously known as Budget).
   * Typically the leaf node of the budget structure tree.
   */
  SPEND_LIMIT = "SPEND_LIMIT",
}

export interface BudgetUserAmountSpent {
  amountSpent?: Maybe<FinancialAsset>;
  employee?: Maybe<Employee>;
  /** @deprecated Incorrect permission scoping, use 'employee' instead */
  user?: Maybe<User>;
}

/** A BudgetUser connection for Budget owner/member pagination futureproofing */
export interface BudgetUserConnection extends Connection {
  /** The items in the current page of results. */
  edges: Array<Maybe<BudgetUserEdge>>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of items, across all pages, matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

/** A BudgetUser edge for the BudgetUser connection. */
export interface BudgetUserEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The item at this edge. */
  node?: Maybe<User>;
}

export type BudgetUserNotificationPreferenceSettings =
  | BudgetApproachingLimitSettings
  | BudgetExpiringSoonSettings
  | BudgetPeriodResettingSoonSettings;

export interface BudgetUserNotificationPreferenceSettingsOneOfInput {
  budgetApproachingLimitSettings?: InputMaybe<BudgetApproachingLimitSettingsInput>;
  budgetExpiringSoonSettings?: InputMaybe<BudgetExpiringSoonSettingsInput>;
  budgetPeriodResettingSoonSettings?: InputMaybe<BudgetPeriodResettingSoonSettingsInput>;
}

export interface BudgetUserNotificationTypePreference {
  isEnabled: Scalars["Boolean"];
  notificationPreferenceType: BudgetsNotificationPreferenceType;
  settings?: Maybe<BudgetUserNotificationPreferenceSettings>;
}

export interface BudgetUserNotificationTypePreferenceInput {
  isEnabled: Scalars["Boolean"];
  notificationPreferenceType: BudgetsNotificationPreferenceType;
  settings?: InputMaybe<BudgetUserNotificationPreferenceSettingsOneOfInput>;
}

export interface BudgetsCardsSummaryInput {
  /** Filter input to apply to the cards */
  filter?: InputMaybe<BudgetCardsSummaryFilterInput>;
  /** The field to summarize cards by */
  summarizeBy: CardsSummarizeByField;
  /** The number of cards to return in a CardsSummaryItem (max 100) */
  summaryItemCardsLimit: Scalars["Int"];
}

export enum BudgetsNotificationPreferenceType {
  APPROACHING_LIMIT = "APPROACHING_LIMIT",
  CHANGED = "CHANGED",
  EXPIRED = "EXPIRED",
  EXPIRING_SOON = "EXPIRING_SOON",
  LIMIT_EXCEEDED = "LIMIT_EXCEEDED",
  PERIOD_RESETTING_SOON = "PERIOD_RESETTING_SOON",
  TERMINATED = "TERMINATED",
}

export interface BuildAndRunPromptTemplateResult {
  error?: Maybe<BuildAndRunPromptTemplateResultError>;
  result?: Maybe<Scalars["String"]>;
}

export interface BuildAndRunPromptTemplateResultError {
  code: PromptManagerErrorCode;
  errorMessage?: Maybe<Scalars["String"]>;
}

export interface BulkActionQueryInput {
  /** Filters available to control which entities get returned. */
  entityFilter: EntityFilterInput;
  /** Pagination options. */
  page?: InputMaybe<PaginationInput>;
}

export interface BulkBudgetActionRequest {
  budgetIds: Array<Scalars["ID"]>;
}

export interface BulkDisconnectErpFeedsInput {
  clientMutationId: Scalars["String"];
  /** list of erp feed ids to disconnect */
  erpFeedIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
}

export interface BulkDisconnectErpFeedsPayload {
  clientMutationId: Scalars["String"];
  /** list of erp feeds disconnected */
  erpFeeds?: Maybe<Array<Maybe<ErpFeed>>>;
  /** Error message describing issue */
  errorMessage?: Maybe<Scalars["String"]>;
}

export interface BulkExpenseActionQueryInput {
  /** Filters available to control which expenses get returned. */
  filter: ExpenseFilterInput;
  /** Query expense options input */
  options?: InputMaybe<ExpenseRowsOptionInput>;
  /** Pagination options. */
  page?: InputMaybe<PaginationInput>;
}

export interface BulkFindOrCreateErpFeedsInput {
  clientMutationId: Scalars["String"];
  erpFeedRequests?: InputMaybe<Array<InputMaybe<ErpFeedInput>>>;
}

export interface BulkFindOrCreateErpFeedsPayload {
  clientMutationId: Scalars["String"];
  erpFeeds?: Maybe<Array<Maybe<ErpFeed>>>;
  errorMessage?: Maybe<Scalars["String"]>;
}

export interface BulkImportFieldsError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface BulkImportFieldsInput {
  /** Required, the asset we are importing. */
  assetId: Scalars["ID"];
  /**
   * The extendedFieldId we are importing field values into
   * REQUIRED for SINGLE_FIELD_CSV
   */
  extendedFieldId?: InputMaybe<Scalars["ID"]>;
  /**
   * Required, the type of import we are performing.
   * `DRAFT`: the fields will not be created but will persist in a "Draft" state
   * `PUBLISH`: the fields will be created and published
   */
  importType: ImportType;
  /** The type of template we are importing */
  templateType: FileTemplateType;
}

export interface BulkImportFieldsResult extends MutationResult {
  /** Any errors thrown - empty if parsed */
  errors?: Maybe<Array<BulkImportFieldsError>>;
  /** Job ID of the import */
  jobId?: Maybe<Scalars["ID"]>;
}

export interface BulkOperationError {
  entityId: Scalars["String"];
  entityName?: Maybe<Scalars["String"]>;
  error?: Maybe<BulkOperationErrorDetails>;
}

export interface BulkOperationErrorDetails {
  message?: Maybe<Scalars["String"]>;
}

export interface BulkOperationResponse {
  errors?: Maybe<Array<BulkOperationError>>;
  numItemsProcessed: Scalars["Int"];
  totalNumItems: Scalars["Int"];
}

export interface BulkRemoveCommentEntityAuthorizationsInput {
  /** ID of the CommentThread in which the CommentEntityAuthorizations are associated with */
  commentThreadId: Scalars["ID"];
  /** IDs of the CommentEntityAuthorizations to delete */
  ids: Array<Scalars["ID"]>;
}

export interface BulkRemoveCommentEntityAuthorizationsResult
  extends MutationResult {
  /** High-level errors that affected the entire operation */
  errors?: Maybe<Array<CommentMutationError>>;
  /** The results of the operation per CommentEntityAuthorization */
  results?: Maybe<Array<Maybe<RemoveCommentEntityAuthorizationResult>>>;
}

export interface BulkResolveSuggestionGroupsInput {
  /** The filter to use to select the affected suggestion groups. */
  filter: AutomationSuggestionGroupsFilterInput;
  /** The action to apply to the suggestion. */
  resolution: AutomationSuggestionGroupResolution;
}

export interface BulkResolveSuggestionGroupsResult {
  numSuggestionGroupsResolved: Scalars["Int"];
}

export interface BulkTransitionExpenseRequestActionsError
  extends StandardClientError {
  code: ErrorCode;
  error?: Maybe<BulkTransitionExpenseRequestActionsErrorType>;
  id?: Maybe<Scalars["ID"]>;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export enum BulkTransitionExpenseRequestActionsErrorType {
  PAYMENT_METHOD_MISSING = "PAYMENT_METHOD_MISSING",
  UNKNOWN = "UNKNOWN",
}

export interface BulkTransitionExpenseRequestActionsInput {
  /**
   * [oneOf] Entity Filter to be provided into QueriesService.executeQuery().
   * Only one of [requestActionIds, bulkExpenseActionQuery, bulkActionQuery] can be specified
   */
  bulkActionQuery?: InputMaybe<BulkActionQueryInput>;
  /**
   * [oneOf] Query input to be provided into QueriesService.executeQuery().
   * Only one of [requestActionIds, bulkExpenseActionQuery] can be specified
   */
  bulkExpenseActionQuery?: InputMaybe<BulkExpenseActionQueryInput>;
  /**
   * [oneOf] List of requestActionIds to transition to the specified request action status.
   * Only one of [requestActionIds, bulkExpenseActionQuery] can be specified
   */
  requestActionIds?: InputMaybe<Array<Scalars["ID"]>>;
  /**
   * [required] The desired request action status to transition to.
   * Note: Only REVIEW request actions can be COMPLETED or REJECTED.
   * Note: Any request action can be DISMISSED.
   */
  requestActionStatus: RequestActionStatusInput;
}

/** In the future may return either a Task or the sync result. */
export interface BulkTransitionExpenseRequestActionsResult {
  /** A list of user errors for mutation responses. Clients should always request this field when performing mutations */
  errors?: Maybe<Array<BulkTransitionExpenseRequestActionsError>>;
  /** The long running task resulting from the operation */
  task: Task;
}

/**
 * End Query expense related objects
 * BEGIN EXPENSE REQUEST RELATED OBJECTS
 */
export interface BulkTransitionExpenseRequestsInput {
  /**
   * [oneOf] Entity Filter to be provided into QueriesService.executeQuery().
   * Only one of [requestIds, bulkExpenseActionQuery, bulkActionQuery] can be specified
   */
  bulkActionQuery?: InputMaybe<BulkActionQueryInput>;
  /**
   * [oneOf] Query input to be provided into QueriesService.executeQuery().
   * Only one of [requestIds, bulkExpenseActionQuery] can be specified
   */
  bulkExpenseActionQuery?: InputMaybe<BulkExpenseActionQueryInput>;
  /**
   * [oneOf] List of requestIds to transition to the specified request status.
   * Only one of [requestIds, bulkExpenseActionQuery] can be specified
   */
  requestIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** [required] The desired request status to transition to. */
  requestStatus: RequestStatusInput;
}

/** In the future may return either a Task or the sync result. */
export interface BulkTransitionExpenseRequestsResult {
  /** The long running task resulting from the operation */
  task: Task;
}

export interface BulkUpdateBudgetsActionOneOfInput {
  addUsersAction?: InputMaybe<AddUsersActionInput>;
  setLimitAction?: InputMaybe<SetLimitActionInput>;
}

export interface BulkUpdateBudgetsInput {
  budgetIds: Array<Scalars["ID"]>;
  clientMutationId: Scalars["String"];
  updateAction: BulkUpdateBudgetsActionOneOfInput;
}

export interface BulkUpdateBudgetsResult extends MutationResult {
  errors?: Maybe<Array<ClientError>>;
  task?: Maybe<Task>;
}

export interface BulkUpdateExpensesInput {
  /**
   * [required] The desired expense object to be updated to.
   * Only the following fields are supported for update:
   * - budget
   * - memo
   */
  expense: ExpenseInput;
  /** Idempotency key */
  idempotencyKey?: InputMaybe<Scalars["String"]>;
  /** [required] Expenses target specification input */
  targetExpenses?: InputMaybe<ExpensesTargetSpecificationInput>;
}

export interface BulkUpdateExpensesResult {
  /** The long running task resulting from the operation */
  task: Task;
}

export interface BulkUpdateExtendedFieldOptionInput {
  /** The extended field option owners to be updated. */
  owners?: InputMaybe<ExtendedFieldOptionOwnerGroupInput>;
  /** The status to update options for. */
  status?: InputMaybe<ExtendedFieldOptionStatus>;
}

export interface BulkUpdateExtendedFieldOptionsInput {
  /** The filter to apply to the options to be updated. */
  filterInput: ExtendedFieldOptionsFilterInput;
  /** Input model for updating multiple extended field options */
  optionInput: BulkUpdateExtendedFieldOptionInput;
}

/** Response of extended field options bulk update */
export interface BulkUpdateExtendedFieldOptionsResult {
  extendedFieldOptions: Array<ExtendedFieldOption>;
}

export interface BulkUpdateVendorFileMatchStatusesInput {
  vendorFileMatchIds: Array<Scalars["ID"]>;
  /** The update below will be applied to all the vendor files above */
  vendorFileMatchStatusUpdate: VendorFileMatchStatusUpdate;
}

export interface BulkUpdateVendorFileMatchesInput {
  vendorFileMatchIds: Array<Scalars["ID"]>;
  /** The update below will be applied to all the vendor files above */
  vendorFileMatchUpdate: VendorFileMatchUpdate;
}

export interface BulkUpdateVendorFileMatchesResult extends MutationResult {
  errors?: Maybe<Array<VendorFileMatchMutationError>>;
  result: Array<Maybe<VendorFileMatch>>;
}

export interface BusinessCipRefreshPayloadInput {
  /** Address of the business */
  address: KYCAddressInput;
  /** Employer Identification Number */
  ein: Scalars["String"];
  /** Incorporation type of entity */
  incorporationType: KycIdentityIncorporationType;
  /** The industry of the entity */
  industry: Scalars["String"];
  /** The Business Legal Name */
  legalName: Scalars["String"];
  /** Proof of Name Change Document ID */
  nameChangeDocumentId?: InputMaybe<Scalars["String"]>;
  /** Business Website */
  website?: InputMaybe<Scalars["String"]>;
}

export interface BusinessCipRefreshRequestConfig {
  /** Address of the business */
  address: Address;
  /** Employer Identification Number */
  ein: Scalars["String"];
  /** Flag to indicate if legal name/EIN check failed */
  hasInvalidBusinessRegistration?: Maybe<Scalars["Boolean"]>;
  /** Incorporation type of entity */
  incorporationType: KycIdentityIncorporationType;
  /** The industry of the entity */
  industry: Scalars["String"];
  /** The Business Legal Name */
  legalName: Scalars["String"];
  /** Business Website */
  website?: Maybe<Scalars["String"]>;
}

export enum BusinessDay {
  FRIDAY = "FRIDAY",
  INVALID = "INVALID",
  MONDAY = "MONDAY",
  THURSDAY = "THURSDAY",
  TUESDAY = "TUESDAY",
  WEDNESDAY = "WEDNESDAY",
}

export enum BusinessDays {
  FRIDAY = "FRIDAY",
  MONDAY = "MONDAY",
  THURSDAY = "THURSDAY",
  TUESDAY = "TUESDAY",
  WEDNESDAY = "WEDNESDAY",
}

/** Business model of an entity */
export enum BusinessModel {
  B2B = "B2B",
  B2C = "B2C",
}

export interface CDaInput {
  clientMutationId: Scalars["String"];
}

export interface CDaPayload {
  clientMutationId: Scalars["String"];
  onboardingApplication: OnboardingApplication;
}

/**
 * Canadian banking code - The transit number (5 digits) identifies the branch where account was opened
 * and the institution number (3 digits) identifies the institution.
 * Combining the transit number and institution number forms a routing number.
 */
export interface CaLocal {
  accountNumber?: Maybe<Scalars["String"]>;
  accountType?: Maybe<BankAccountType>;
  institutionNumber?: Maybe<Scalars["String"]>;
  transitNumber?: Maybe<Scalars["String"]>;
}

/**
 * Canadian banking code - The transit number (5 digits) identifies the branch where account was opened
 * and the institution number (3 digits) identifies the institution.
 * Combining the transit number and institution number forms a routing number.
 */
export interface CaLocalInput {
  accountNumber?: InputMaybe<Scalars["String"]>;
  accountType?: InputMaybe<BankAccountType>;
  institutionNumber?: InputMaybe<Scalars["String"]>;
  transitNumber?: InputMaybe<Scalars["String"]>;
}

/** Input type for calculating per diem amounts */
export interface CalculatePerDiemRequestInput {
  /** The trip itinerary consisting of ordered trip segments */
  destinations: Array<PerDiemTripSegmentInput>;
  /** Daily provisions for each day of the trip */
  provisions?: InputMaybe<Array<PerDiemProvisionsInput>>;
  /** Optional user ID. If not provided, will use the current user from context */
  userId?: InputMaybe<Scalars["String"]>;
}

/** Response containing calculated per diem amounts and eligibility details */
export interface CalculatePerDiemResponse {
  /** Daily amounts for each day of the trip */
  dailyAmounts?: Maybe<Array<PerDiemDailyAmount>>;
  /** Results for each destination of the trip */
  destinationResults?: Maybe<Array<PerDiemSegmentResult>>;
  /** Overall eligibility status for the trip */
  eligibilityStatus?: Maybe<PerDiemEligibilityStatus>;
  /** Daily provisions for each day of the trip */
  provisions?: Maybe<Array<PerDiemProvisions>>;
  /** Total per diem amount across all segments */
  total?: Maybe<FinancialAsset>;
  /** Total amount converted to user's payout currency */
  totalInPayoutCurrency?: Maybe<FinancialAsset>;
}

/** Call support channel. Always enabled */
export interface Call {
  /** Phone number for this Call support channel */
  phoneNumber?: Maybe<Scalars["String"]>;
  /** Service level agreement for this support channel */
  sla?: Maybe<Scalars["Int"]>;
}

export enum CampaignStage {
  FINAL = "FINAL",
  FINAL_REMINDER = "FINAL_REMINDER",
  FIRST_REMINDER = "FIRST_REMINDER",
  INELIGIBLE = "INELIGIBLE",
  INITIAL_OUTREACH = "INITIAL_OUTREACH",
  INVALID = "INVALID",
  LANDING = "LANDING",
  LIFTOFF = "LIFTOFF",
  ONGOING = "ONGOING",
  SECOND_REMINDER = "SECOND_REMINDER",
}

export interface CanFSPUserAccessClientInput {
  clientCustomerAccountId: Scalars["ID"];
  fspCustomerUserId: Scalars["ID"];
}

export interface CanFSPUserAccessClientResult {
  canAccess: Scalars["Boolean"];
}

export interface CanOffboardResponse {
  enabled: Scalars["Boolean"];
  issues: Array<DepositsCloseAccountIssue>;
}

export interface CanWithdrawFundsResponse {
  /** Days since the last ach debit or cheque deposit settled transaction */
  daysSinceLastSettledAddFundsTransaction?: Maybe<Scalars["Int"]>;
  daysSinceLatestAchDebitSettlement?: Maybe<Scalars["Int"]>;
  enabled: Scalars["Boolean"];
  issues: Array<DepositsWithdrawFundsIssue>;
}

export interface CancelBillInput {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
}

export interface CancelBillPaymentInput {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
}

export interface CancelBillPaymentPayload {
  clientMutationId: Scalars["String"];
}

export interface CancelBillPaymentV2Input {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
}

/** Input type to cancel a budget limit increase request */
export interface CancelBudgetLimitIncreaseRequestInput {
  id: Scalars["ID"];
}

export interface CancelBudgetLimitIncreaseRequestV2Result
  extends MutationResult {
  /** The ID of the budget limit increase request. */
  budgetLimitIncreaseRequestEntityId?: Maybe<Scalars["ID"]>;
  /** A list of user errors for mutation responses. Clients should always request this field when performing mutations */
  errors?: Maybe<Array<ClientError>>;
}

/** Input type to cancel a budget request */
export interface CancelBudgetRequestInput {
  budgetRequestEntityId: Scalars["ID"];
  clientMutationId: Scalars["String"];
}

export interface CancelBulkUpdateExpensesInput {
  /** Task ID of the previous created bulkUpdateExpenses task */
  taskId: Scalars["ID"];
}

export interface CancelBulkUpdateExpensesResult {
  /** The resulting task from canceling the long running operation */
  task: Task;
}

export interface CancelCashRecurringScheduleInput {
  clientMutationId: Scalars["String"];
  /** ID of the recurring schedule */
  id: Scalars["ID"];
}

export interface CancelCashRecurringSchedulePayload {
  /** List of cancelled transactions */
  cancelledTransactions: Array<CashTransaction>;
  clientMutationId: Scalars["String"];
}

export interface CancelCashTransactionInput {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
}

export interface CancelCashTransactionPayload {
  clientMutationId: Scalars["String"];
  transaction: CashTransaction;
}

export interface CancelClawbackInput {
  /** ID of the clawback Expense to cancel a Clawback request for. */
  clawbackExpensesExpenseId?: InputMaybe<Scalars["ID"]>;
  /** ID of the Clawback to cancel. */
  clawbackId?: InputMaybe<Scalars["ID"]>;
  /** clientMutationId */
  clientMutationId: Scalars["String"];
  /** ID of the Expense to cancel a Clawback request for. */
  expensesExpenseId?: InputMaybe<Scalars["ID"]>;
}

export interface CancelClawbackResult {
  /** The clawback that was cancelled. */
  clawback: Clawback;
}

export interface CancelDisputeInput {
  disputeId: Scalars["ID"];
  expenseIds: Array<Scalars["ID"]>;
  reason: Scalars["String"];
}

export interface CancelDisputeResult {
  dispute: Dispute;
}

export interface CancelEmailChangeInput {
  /** Optional user id to cancel change for. If not set, the cancellation will be processed for the logged-in user. */
  userId?: InputMaybe<Scalars["String"]>;
}

export interface CancelEmailChangeResult extends MutationResult {
  errors?: Maybe<Array<ChangeEmailOperationError>>;
}

export interface CancelExpenseInput {
  /** clientMutationId */
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** expense ID to cancel */
  expenseId: Scalars["ID"];
}

export interface CancelExpenseResult {
  /** List of errors when cancelling the expense */
  errors?: Maybe<Array<ExpenseMutationError>>;
  /** The expense that was canceled. */
  expense?: Maybe<Expense>;
}

export interface CancelGroupEventInput {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
}

export interface CancelGroupEventResult {
  error?: Maybe<Scalars["String"]>;
  groupEvent?: Maybe<GroupEvent>;
}

export interface CancelPaymentInput {
  clientMutationId: Scalars["String"];
  recurringPaymentCancellationType?: InputMaybe<DepositsRecurringPaymentCancellationType>;
}

export interface CancelPaymentPayload {
  clientMutationId: Scalars["String"];
}

/** Input for the Purchasing Card cancellation */
export interface CancelPurchasingCardInput {
  /** The card ID associated with the Purchasing Card */
  cardId: Scalars["ID"];
  /** The idempotency key */
  clientMutationId: Scalars["String"];
  /** The description for terminating the card */
  terminationDescription?: InputMaybe<Scalars["String"]>;
  /** The reason for terminating the card */
  terminationReason?: InputMaybe<TerminationReason>;
}

export interface CancelPurchasingCardResult extends MutationResult {
  cards?: Maybe<Array<Card>>;
  errors?: Maybe<Array<PurchasingCardMutationError>>;
  spendLimit?: Maybe<SpendLimit>;
}

export interface CancelScheduledPrepaymentInput {
  paymentIntentId: Scalars["ID"];
}

export interface CancelScheduledPrepaymentPayload {
  paymentIntentId: Scalars["ID"];
}

export interface CancelledProductInput {
  cancellationDate: Scalars["Date"];
  contact?: InputMaybe<Scalars["String"]>;
  contactMode?: InputMaybe<ContactMode>;
  description: Scalars["String"];
}

export interface CancelledServiceInput {
  cancellationDate: Scalars["Date"];
  contact?: InputMaybe<Scalars["String"]>;
  contactMode?: InputMaybe<ContactMode>;
  description: Scalars["String"];
}

/** Any string intended for looking up car vendors. */
export interface CarAutocompleteFilterInput {
  queryString: Scalars["String"];
}

export interface CarAutocompleteResult {
  carVendorCode?: Maybe<Scalars["String"]>;
  carVendorName?: Maybe<Scalars["String"]>;
}

/** Results from a car vendor autocomplete query. */
export interface CarAutocompleteResults {
  /** An airport to be used as the reference point around which we will search for hotels. */
  airportResults?: Maybe<Array<AirAutocompleteResult>>;
  /** Specific hotels to be used when searching for hotels. */
  hotelResults?: Maybe<Array<Maybe<HotelAutocompleteResult>>>;
  /**
   * Arbitrary locations like cities or specific addresses to be used as reference points
   * when searching for hotels.
   */
  locationResults?: Maybe<Array<LocationAutocompleteResult>>;
  /** Specific points of interest (businesses, landmarks) to use as reference points for hotels. */
  pointsOfInterestResults?: Maybe<Array<LocationAutocompleteResult>>;
  /** @deprecated This field is not populated */
  results?: Maybe<Array<CarAutocompleteResult>>;
}

export interface CarRentalAddendum extends ExpenseAddendum {
  /** When the car was booked. */
  bookedAt?: Maybe<Scalars["Time"]>;
  /** The class of the rental car. */
  carClass?: Maybe<RentalCarClass>;
  /** Fee associated with cleaning the vehicle. */
  cleaningFee?: Maybe<FinancialAsset>;
  /** The average daily rate for the car. */
  dailyRate?: Maybe<FinancialAsset>;
  /** The location where the car will be returned. */
  dropOffLocation?: Maybe<ExpenseLocation>;
  /** When the car should be returned. */
  dropOffTime?: Maybe<Scalars["Time"]>;
  /** Charges associated with fuelling the car. */
  fuelCharge?: Maybe<FinancialAsset>;
  /** The unique ID of the expense addendum. */
  id: Scalars["ID"];
  /** Liability insurance cost. */
  liabilityInsurance?: Maybe<FinancialAsset>;
  /** Loss damage waiver insurance cost */
  lossDamageWaiverInsurance?: Maybe<FinancialAsset>;
  /** Other fees. */
  otherFees?: Maybe<FinancialAsset>;
  /** The location where the car will be picked up. */
  pickupLocation?: Maybe<ExpenseLocation>;
  /** When the car can be picked up. */
  pickupTime?: Maybe<Scalars["Time"]>;
  /** Rental agreement number. Is not necessarily a proper number. */
  rentalAgreementNumber?: Maybe<Scalars["String"]>;
  /** Renter name. */
  renterName?: Maybe<Scalars["String"]>;
  /** Toll or bridge fee. */
  tollOrBridgeFee?: Maybe<FinancialAsset>;
  /** The total rate for the whole rental excluding any incidentals. */
  totalRate?: Maybe<FinancialAsset>;
}

/** A card. */
export interface Card extends Node {
  /** Actions the user can take regarding the card */
  allowedActions: Array<CardAction>;
  applicableLimit?: Maybe<CardLimitSummary>;
  /** The bill expense this card was created for */
  billExpense?: Maybe<Expense>;
  /** Card billing address */
  billingAddress?: Maybe<Address>;
  /** Custom card branding */
  branding?: Maybe<CardBranding>;
  /** @deprecated Deprecated in favor of LimitSource */
  budget?: Maybe<Budget>;
  /** @deprecated After experimenting, we're moving away from auto assign in favor of accidental decline protection, all future assignment configurations should be derived through cardSpendLimitAssignmentSettings instead */
  cardBudgetAssignmentMode?: Maybe<CardBudgetAssignmentMode>;
  cardBudgetOwnershipType?: Maybe<CardBudgetOwnershipType>;
  /** Card provider */
  cardProvider?: Maybe<CardProvider>;
  cardSpendLimitAssignmentSettings?: Maybe<CardSpendLimitAssignmentSettings>;
  /** Card type and behaviour */
  cardType?: Maybe<CardType>;
  /** Name of company associated with the card */
  companyName?: Maybe<Scalars["String"]>;
  /** The limit source currently funding this card */
  currentLimitSource?: Maybe<LimitSource>;
  customRules?: Maybe<WorkflowRuleConnection>;
  /**
   * Card customer user id
   * @deprecated Use User.id instead.
   */
  customerUserId?: Maybe<Scalars["ID"]>;
  /**
   * Card cvv number String
   * Note: this is only needed because some customers have firewalls that block token-manager requests.
   * It should only be used as a fallback and will be deprecated once the PCI Data Tokenization project ready.
   */
  cvv?: Maybe<Scalars["String"]>;
  /** Reason for deactivation of the card. This is only not null if card is suspended/terminated. */
  deactivationReason?: Maybe<CardDeactivationReason>;
  /** The card design */
  design?: Maybe<CardDesign>;
  /** Card display name */
  displayName?: Maybe<Scalars["String"]>;
  /** Card expiration */
  expiration?: Maybe<Scalars["String"]>;
  /** The expiration date derived from the card expiration. Cards always expire on the first day of the month following the expiration month */
  expiresAt?: Maybe<Scalars["Time"]>;
  /** First 6 characters of card pan */
  first6?: Maybe<Scalars["String"]>;
  /** Represents whether the card has been transferred to a new owner */
  hasBeenTransferred?: Maybe<Scalars["Boolean"]>;
  /** Name of the holder of the card */
  holderName?: Maybe<Scalars["String"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  /** Card instrument type */
  instrumentType?: Maybe<Scalars["String"]>;
  /** Has the card been suspended by admin */
  isAdminLocked?: Maybe<Scalars["Boolean"]>;
  /** Whether Limit Source Auto Assignment is enabled for this card */
  isLimitSourceAutoAssignmentEnabled: Scalars["Boolean"];
  /** Whether or not this is a lodged card. */
  isLodged: Scalars["Boolean"];
  /** Whether the card is pin preferring */
  isPinPreferring?: Maybe<Scalars["Boolean"]>;
  isPreapproved?: Maybe<Scalars["Boolean"]>;
  /** Has the card been suspended by role */
  isRoleLocked?: Maybe<Scalars["Boolean"]>;
  /** Card issued at time */
  issuedAt?: Maybe<Scalars["Time"]>;
  /** Card issuer */
  issuer?: Maybe<Issuer>;
  /** Last 4 characters of card pan */
  last4?: Maybe<Scalars["String"]>;
  /** The legal entity this card is associated with */
  legalEntity?: Maybe<LegalEntity>;
  limit?: Maybe<CardLimitSummary>;
  /** Other limit sources that are available to the card, excluding the currentLimitSource */
  limitSources?: Maybe<LimitSourcesConnection>;
  /** Card network */
  network?: Maybe<Scalars["String"]>;
  /**
   * Card pan(primary account number) String
   * Note: this is only needed because some customers have firewalls that block token-manager requests.
   * It should only be used as a fallback and will be deprecated once the PCI Data Tokenization project ready.
   */
  pan?: Maybe<Scalars["String"]>;
  /** Pan token */
  panToken?: Maybe<Scalars["String"]>;
  /** The partner that manages the card */
  partner?: Maybe<CardPartner>;
  /**
   * Card pin number String
   * Note: this is only needed because some customers have firewalls that block token-manager requests.
   * It should only be used as a fallback and will be deprecated once the PCI Data Tokenization project ready.
   */
  pin?: Maybe<Scalars["String"]>;
  /** Card pin updated time */
  pinUpdatedAt?: Maybe<Scalars["Time"]>;
  /** The previous owner of the card, if it has been transferred */
  previousOwner?: Maybe<User>;
  /**
   * id of the card product associated with the card
   * @deprecated Use Card.design instead.
   */
  providerCardProductId?: Maybe<Scalars["String"]>;
  /** Merchants with recurring spend on the card */
  recurringMerchants?: Maybe<PerMerchantStatsConnection>;
  /** Reissuing status of the card */
  reissuingStatus?: Maybe<CardReissuingStatus>;
  /** Record containing the card that replaced this card */
  replacedBy?: Maybe<ReplacedByRecord>;
  /** List all the replaces card */
  replaces?: Maybe<ReplacesRecordConnection>;
  /** Details about a card in a shared multi-user context */
  sharedCardDetails?: Maybe<SharedCardDetails>;
  /** Card shipping address */
  shippingAddress?: Maybe<ShippingAddress>;
  /** Card Shipping Details, null if the card instrument type is not physical */
  shippingDetails?: Maybe<CardShippingDetails>;
  /** Card shipping method */
  shippingMethod?: Maybe<ShippingMethod>;
  /** Whether a card's PIN should be shown to the user */
  shouldShowPin?: Maybe<Scalars["Boolean"]>;
  /**
   * The following are classic fields migrated into cards-dgs since they are still getting traffic
   * - should be deleted once either the traffic is gone or when we confirm we can break clients still trying to resolve these fields
   */
  softExpiration?: Maybe<SoftExpirationSummary>;
  /** @deprecated Deprecated in favor of LimitSource */
  spendLimit?: Maybe<SpendLimit>;
  /** Card status */
  status?: Maybe<Scalars["String"]>;
  /** Status view of a card */
  statusView?: Maybe<StatusView>;
  /** Whether this card supports Apple Pay */
  supportsApplePay?: Maybe<Scalars["Boolean"]>;
  usage?: Maybe<Scalars["Int"]>;
  /** Card owner user object */
  user?: Maybe<User>;
  utilization?: Maybe<Scalars["Float"]>;
}

/** A card. */
export interface CardcustomRulesArgs {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
}

/** A card. */
export interface CardlimitSourcesArgs {
  after?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<LimitSourceFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
}

/** A card. */
export interface CardrecurringMerchantsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

/** A card. */
export interface CardreplacesArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

export enum CardAccountType {
  DEPOSITS_BACKED = "DEPOSITS_BACKED",
  TRADITIONAL_CHARGE = "TRADITIONAL_CHARGE",
  TRANSACTIONAL_FLOAT = "TRANSACTIONAL_FLOAT",
}

/** An action a user can take within the context of a card */
export interface CardAction {
  /** The action a user can perform on the card */
  action: CardActionValue;
  /** The type of action e.g. destructive, in the case of cancel card or otherwise */
  type: CardActionType;
}

/** The type of the action */
export enum CardActionType {
  DEFAULT = "DEFAULT",
  DESTRUCTIVE = "DESTRUCTIVE",
}

export enum CardActionValue {
  ACTIVATE_PHYSICAL_CARD = "ACTIVATE_PHYSICAL_CARD",
  ADMIN_LOCK = "ADMIN_LOCK",
  CANCEL = "CANCEL",
  CONVERT_PURCHASING_CARD_TO_SPEND_LIMIT = "CONVERT_PURCHASING_CARD_TO_SPEND_LIMIT",
  EDIT_PURCHASING_CARD = "EDIT_PURCHASING_CARD",
  EDIT_USER_LIMIT_INCREASE_REQUEST = "EDIT_USER_LIMIT_INCREASE_REQUEST",
  INCREASE_LIMIT = "INCREASE_LIMIT",
  INCREASE_LIMIT_REQUEST = "INCREASE_LIMIT_REQUEST",
  INCREASE_USER_LIMIT_REQUEST = "INCREASE_USER_LIMIT_REQUEST",
  LOCK = "LOCK",
  RENAME = "RENAME",
  REPLACE = "REPLACE",
  REPLACE_WITH_PHYSICAL = "REPLACE_WITH_PHYSICAL",
  RESET_PIN = "RESET_PIN",
  SET_PIN = "SET_PIN",
  SET_PRIMARY = "SET_PRIMARY",
  TRANSFER = "TRANSFER",
  UNLOCK = "UNLOCK",
  UPDATE_USER_LIMIT = "UPDATE_USER_LIMIT",
  VIEW_EXPENSES = "VIEW_EXPENSES",
  VIEW_SHIPPING_DETAILS = "VIEW_SHIPPING_DETAILS",
}

export interface CardAlias {
  /** Card provider for the card alias */
  cardProvider?: Maybe<Scalars["String"]>;
  /** Expiration of the card alias */
  expiration: Scalars["String"];
  id: Scalars["ID"];
  /** Last 4 characters of card pan */
  last4: Scalars["String"];
  /** Pan token for the card alias */
  panToken?: Maybe<Scalars["String"]>;
  /** The user that owns the card alias. Null indicates an error when resolving the user. */
  user?: Maybe<User>;
}

export interface CardAliasCreateInput {
  /** The id of the card to create the alias for */
  cardId: Scalars["ID"];
  /** The client mutation id */
  clientMutationId: Scalars["String"];
}

export interface CardAliasCreateMutationError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface CardAliasCreateMutationResult extends MutationResult {
  errors?: Maybe<Array<CardAliasCreateMutationError>>;
  result?: Maybe<CardAlias>;
}

export interface CardBranding {
  /** The custom card artwork */
  artwork?: Maybe<Asset>;
  /** The custom card icon artwork */
  iconArtwork?: Maybe<Asset>;
  /** The card artwork ID */
  id: Scalars["ID"];
  /** Text color applied to virtual cards in product */
  textColor?: Maybe<CardTextColor>;
}

/**
 * Specifies the budget assignment type,
 * whether the user has opted in to auto-budget assignment
 * or remained with manual assignment.
 */
export enum CardBudgetAssignmentMode {
  /**
   * This represents auto-budget assignment.
   * It reflects the user having opted in to Brex AI choosing the budget for an expense at transaction time.
   */
  AUTO = "AUTO",
  /**
   * This is the default mode.
   * It reflects the user having manually chosen a budget from the FE selector components.
   */
  MANUAL = "MANUAL",
}

/** Card Budget Mapping object type. */
export interface CardBudgetMapping {
  budget: Budget;
  budgetMappingExpiration: BudgetMappingExpiration;
  card: Card;
  cardBudgetOwnershipType: CardBudgetOwnershipType;
  effectiveRange: EffectiveRange;
  id: Scalars["ID"];
  /** @deprecated Use budgetMappingExpiration */
  type: BudgetMappingType;
}

/** The budget ownership type of the card */
export enum CardBudgetOwnershipType {
  BILL_PAY = "BILL_PAY",
  BUDGET = "BUDGET",
  USER = "USER",
}

export interface CardClientError
  extends CardSetLimitSourceAutoAssignmentErrors,
    StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface CardCollectionDetails {
  billingPayment: BillingPayment;
  collectionAttempt: CollectionAttempt;
  collectionId: Scalars["String"];
}

/** A Card connection for pagination */
export interface CardConnection extends Connection {
  /** The cards in the current page of results. */
  edges?: Maybe<Array<Maybe<CardEdge>>>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** Summary of different card aggregations. */
  summary: Summary;
  /** The total count of cards matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

export enum CardCustomerUserRole {
  ADMIN = "ADMIN",
  BOOKKEEPER = "BOOKKEEPER",
  REGULAR = "REGULAR",
}

export enum CardDeactivationReason {
  BUDGET_EXPIRED = "BUDGET_EXPIRED",
  BUDGET_TERMINATED = "BUDGET_TERMINATED",
  DISABLED_USER = "DISABLED_USER",
  OTHER = "OTHER",
  USER_RFID_BY_AIRWALLEX = "USER_RFID_BY_AIRWALLEX",
}

/** The Card design enum */
export enum CardDesign {
  BUDGET = "BUDGET",
  COPPER = "COPPER",
  GOLD = "GOLD",
  GOLD_MCO = "GOLD_MCO",
  OneB22 = "OneB22",
  PLASTIC = "PLASTIC",
  PLASTIC_MCO = "PLASTIC_MCO",
  PLATINUM = "PLATINUM",
  PLATINUM_MCO = "PLATINUM_MCO",
  VIRTUAL = "VIRTUAL",
  VIRTUAL_MCO = "VIRTUAL_MCO",
  VISA = "VISA",
}

export enum CardDetailsSharingStatus {
  AUTO_SEND_ENABLED = "AUTO_SEND_ENABLED",
  NOT_SENT = "NOT_SENT",
  SENT = "SENT",
}

export interface CardDisableLimitSourceAutoAssignmentError
  extends MutationError {
  errors?: Maybe<Array<CardSetLimitSourceAutoAssignmentErrors>>;
}

/** Input for cardDisableLimitSourceAutoAssignment */
export interface CardDisableLimitSourceAutoAssignmentInput {
  cardId: Scalars["ID"];
}

export type CardDisableLimitSourceAutoAssignmentResult =
  | Card
  | CardDisableLimitSourceAutoAssignmentError;

/** A Card edge for the Card connection. */
export interface CardEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The card at this edge. */
  node?: Maybe<Card>;
}

export interface CardEnableLimitSourceAutoAssignmentError
  extends MutationError {
  errors?: Maybe<Array<CardSetLimitSourceAutoAssignmentErrors>>;
}

/** Input for cardEnableLimitSourceAutoAssignment */
export interface CardEnableLimitSourceAutoAssignmentInput {
  cardId: Scalars["ID"];
}

export type CardEnableLimitSourceAutoAssignmentResult =
  | Card
  | CardEnableLimitSourceAutoAssignmentError;

export interface CardEstimatedDeliveryDateInput {
  /** Destination shipping address */
  destinationAddress: DestinationAddressInput;
  /** When the order was placed. Will default to using the current time if not provided */
  orderedAt?: InputMaybe<Scalars["Time"]>;
  /** Shipping method */
  shippingMethod: ShippingMethod;
}

export interface CardEstimatedDeliveryDateResponse {
  estimatedDeliveryDate: Scalars["Time"];
  /** Estimated delivery range. */
  estimatedDeliveryDaysRange?: Maybe<DeliveryDaysRange>;
}

/** The queryable fields of Card. Used for grouping/aggregations/sorting */
export enum CardFieldKeyType {
  ALL = "ALL",
  BUDGETS_BUDGET_ID = "BUDGETS_BUDGET_ID",
  CARD_BUDGET_OWNERSHIP_TYPE = "CARD_BUDGET_OWNERSHIP_TYPE",
  CUSTOMER_USER_ID = "CUSTOMER_USER_ID",
  DISPLAY_NAME = "DISPLAY_NAME",
  HOLDER_NAME = "HOLDER_NAME",
  INSTRUMENT_TYPE = "INSTRUMENT_TYPE",
  ISSUED_AT = "ISSUED_AT",
  LAST_FOUR = "LAST_FOUR",
  PARTNER_ID = "PARTNER_ID",
  STATUS = "STATUS",
  USER_DEPARTMENT_ID = "USER_DEPARTMENT_ID",
  USER_FULL_NAME = "USER_FULL_NAME",
}

export interface CardFieldKeyTypeWrapper {
  key: CardFieldKeyType;
}

/** Filters for the Card entity. */
export interface CardFieldMatcherInput {
  budgetIds?: InputMaybe<Array<Scalars["String"]>>;
  cardBudgetOwnershipTypes?: InputMaybe<Array<CardBudgetOwnershipType>>;
  central?: InputMaybe<Scalars["Boolean"]>;
  customerUserIds?: InputMaybe<Array<Scalars["String"]>>;
  departmentIds?: InputMaybe<Array<Scalars["String"]>>;
  ids?: InputMaybe<Array<Scalars["String"]>>;
  instrumentTypes?: InputMaybe<Array<InstrumentType>>;
  partnerIds?: InputMaybe<Array<Scalars["String"]>>;
  searchQuery?: InputMaybe<Scalars["String"]>;
  statusViews?: InputMaybe<Array<StatusView>>;
}

export interface CardFilterInput {
  /**
   * Expects an array of CardBudgetOwnershipTypes, which will be used to filter cards. Cannot be empty.
   * To get all cards simply pass [CardBudgetOwnershipType.USER, CardBudgetOwnershipType.BUDGET]
   */
  cardBudgetOwnershipTypes: Array<CardBudgetOwnershipType>;
  /** Customer user ids who own the card list. When no filter or empty array is provided, the user who is making the graphql request will be used as a default */
  customerUserIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Filter for transferred cards */
  hasBeenTransferred?: InputMaybe<Scalars["Boolean"]>;
  /** Filter for managed by partner cards */
  isManagedByPartner?: InputMaybe<Scalars["Boolean"]>;
}

/** A FinancialAssetMovement represents a monetary value in a specific currency */
export interface CardFinancialAssetMovement
  extends FinancialAssetMovementInterface {
  /** The billing amount of the movement */
  billingAmount: FinancialAsset;
  /** The card used for the movement */
  card: Card;
  clearedAt?: Maybe<Scalars["LocalDateTime"]>;
  customerAccount: Account;
  id: Scalars["ID"];
  initiatedAt: Scalars["LocalDateTime"];
  /** The original amount of the movement */
  originalAmount: FinancialAsset;
  rail: FinancialAssetMovementRail;
  status: FinancialAssetMovementStatus;
  type: FinancialAssetMovementType;
  /** The user of the movement */
  user?: Maybe<User>;
  /** The merchant that the movement is associated with */
  vendor: VendorDetails;
}

export interface CardLiability {
  cardLiabilityChange?: Maybe<FinancialAsset>;
  totalCardLiability?: Maybe<FinancialAsset>;
}

export enum CardLimitCategory {
  BILL_PAY_CARD = "BILL_PAY_CARD",
  CARD_SPEND_CONTROL_CARD = "CARD_SPEND_CONTROL_CARD",
  EMPLOYEE_CARD = "EMPLOYEE_CARD",
  PURCHASING_CARD = "PURCHASING_CARD",
  SPEND_LIMIT_CARD = "SPEND_LIMIT_CARD",
  USER_LIMIT_CARD = "USER_LIMIT_CARD",
}

export enum CardLimitFrequency {
  MONTHLY = "MONTHLY",
  ONE_TIME = "ONE_TIME",
  QUARTERLY = "QUARTERLY",
  YEARLY = "YEARLY",
}

/** Source of a card limit */
export enum CardLimitSource {
  SPEND_LIMIT = "SPEND_LIMIT",
  USER_LIMIT = "USER_LIMIT",
}

export interface CardLimitSummary {
  amount: Scalars["Int"];
  frequency: CardLimitFrequency;
}

export interface CardNormalizationTextReplacement {
  /** Special character to be replaced */
  from: Scalars["String"];
  /** The ascii character equivalent of the special character */
  to: Scalars["String"];
}

export interface CardNormalizationTextRules {
  /** Regex for special characters to be removed */
  regexRemovals: Array<Scalars["String"]>;
  /** List of special characters and its ASCII equivalent replacement */
  textReplacements: Array<CardNormalizationTextReplacement>;
  /** Unicode normalization form method */
  unicodeNormalization: Scalars["String"];
}

export interface CardOperationTransaction {
  cardFinancialAssetMovement?: Maybe<CardFinancialAssetMovement>;
  expenses: Array<Expense>;
  /**  Legacy field used to fetch Rewards data until they move away from ptxo as their originator */
  presentTransactionOperationId?: Maybe<Scalars["ID"]>;
  rewardsAccrualEntriesV2?: Maybe<Array<Maybe<RewardsAccrualEntryV2>>>;
  type: CardOperationTransactionType;
  /** @deprecated Use BillingTransaction.user instead. */
  user: User;
}

export enum CardOperationTransactionType {
  CHARGEBACK_CREDIT = "CHARGEBACK_CREDIT",
  CHARGEBACK_DEBIT = "CHARGEBACK_DEBIT",
  CLEARING = "CLEARING",
  REFUND = "REFUND",
  WITHDRAWAL = "WITHDRAWAL",
}

/** The reason for transferring the card */
export enum CardOwnershipTransferReason {
  AUTO_TRANSFER_USER_DISABLED = "AUTO_TRANSFER_USER_DISABLED",
  AUTO_TRANSFER_USER_REMOVED_FROM_LIMIT = "AUTO_TRANSFER_USER_REMOVED_FROM_LIMIT",
  AUTO_TRANSFER_USER_TYPE_EMBEDDED = "AUTO_TRANSFER_USER_TYPE_EMBEDDED",
  EMPLOYEE_OFFBOARDED = "EMPLOYEE_OFFBOARDED",
  OTHER = "OTHER",
}

export enum CardPartner {
  BREX_INTERNAL_TESTING = "BREX_INTERNAL_TESTING",
  COUPA_CARD = "COUPA_CARD",
  COUPA_PAY = "COUPA_PAY",
  FLATFILE = "FLATFILE",
  GEP = "GEP",
  HRS = "HRS",
  NAVAN = "NAVAN",
  NETSUITE = "NETSUITE",
  SABRE = "SABRE",
  ZIP = "ZIP",
}

export interface CardPartnerFeedCreateFilterInput {
  op: CardPartnerFeedFilterOp;
  type: CardPartnerFeedFilterType;
  /**
   * The values of the filter that are either allowed or not allowed, depending on the op.
   * It can contain nulls and "*" to match any value.
   *
   * Examples:
   * - op: IN, type: PARTNER_ID, values: ["1234", "5678"] - only cards with partner id 1234 or 5678
   * - op: IN, type: PARTNER_ID, values: ["*"] - cards with any partner id but not null
   * - op: IN, type: PARTNER_ID, values: [null] - only cards with null partner id
   */
  values: Array<InputMaybe<Scalars["String"]>>;
}

export interface CardPartnerFeedFilter {
  op: CardPartnerFeedFilterOp;
  type: CardPartnerFeedFilterType;
  /**
   * The values of the filter that are either allowed or not allowed, depending on the op.
   * It can contain nulls and "*" to match any value.
   *
   * Examples:
   * - op: IN, type: PARTNER_ID, values: ["1234", "5678"] - only cards with partner id 1234 or 5678
   * - op: IN, type: PARTNER_ID, values: ["*"] - cards with any partner id but not null
   * - op: IN, type: PARTNER_ID, values: [null] - only cards with null partner id
   */
  values: Array<Maybe<Scalars["String"]>>;
}

export enum CardPartnerFeedFilterOp {
  IN = "IN",
  NOT_IN = "NOT_IN",
}

export enum CardPartnerFeedFilterType {
  BUDGET_ID = "BUDGET_ID",
  CUSTOMER_USER_ID = "CUSTOMER_USER_ID",
  PARTNER_ID = "PARTNER_ID",
}

export interface CardPartnerFeedRule {
  /** The filters of the rule which dictate card access. */
  filters?: Maybe<Array<CardPartnerFeedFilter>>;
  id: Scalars["ID"];
}

export interface CardPartnerFeedRuleConnection extends Connection {
  edges?: Maybe<Array<Maybe<CardPartnerFeedRuleEdge>>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface CardPartnerFeedRuleCreateError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface CardPartnerFeedRuleCreateInput {
  /** The client mutation id. */
  clientMutationId: Scalars["String"];
  /** The filters of the rule which dictate card access. */
  filters: Array<CardPartnerFeedCreateFilterInput>;
  /** The partner id which this rule guards access to. */
  partnerId: Scalars["ID"];
}

export interface CardPartnerFeedRuleCreateResult extends MutationResult {
  errors?: Maybe<Array<CardPartnerFeedRuleCreateError>>;
  result?: Maybe<CardPartnerFeedRule>;
}

export interface CardPartnerFeedRuleEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<CardPartnerFeedRule>;
}

export interface CardPaymentAcceptor {
  /** The address of the acceptor. */
  address: Scalars["String"];
  /** The city of the acceptor. */
  city: Scalars["String"];
  /** The country of the acceptor. */
  country: Scalars["String"];
  /** The Merchant Category Code of the acceptor. */
  mcc: Scalars["String"];
  /** The unique ID of the Merchant that is the card acceptor. */
  mid: Scalars["String"];
  /** The name of the acceptor. */
  name: Scalars["String"];
  /** The postal code of the acceptor. */
  postalCode: Scalars["String"];
  /** The state of the acceptor. */
  state: Scalars["String"];
}

export interface CardPaymentDetails extends ExpensePaymentDetails {
  /** the last 4 digits of the underlying account that was used for this transaction */
  accountLast4?: Maybe<Scalars["String"]>;
}

export enum CardPaymentFailureSeverity {
  FATAL = "FATAL",
  NONE = "NONE",
  RECOVERABLE = "RECOVERABLE",
  UNKNOWN = "UNKNOWN",
}

export enum CardPaymentFailureType {
  ACCOUNT_CLOSED = "ACCOUNT_CLOSED",
  ACCOUNT_NOT_FOUND = "ACCOUNT_NOT_FOUND",
  GENERIC_FAILURE = "GENERIC_FAILURE",
  INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
  NOT_AUTHORIZED = "NOT_AUTHORIZED",
  NOT_SENT = "NOT_SENT",
}

export enum CardPaymentFailureTypeV2 {
  ACCOUNT_CLOSED = "ACCOUNT_CLOSED",
  ACCOUNT_NOT_FOUND = "ACCOUNT_NOT_FOUND",
  INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
  NON_TRANSACTION_ACCOUNT = "NON_TRANSACTION_ACCOUNT",
  NOT_AUTHORIZED = "NOT_AUTHORIZED",
}

export enum CardPaymentFailureTypeV3 {
  ACCOUNT_CLOSED = "ACCOUNT_CLOSED",
  ACCOUNT_NOT_FOUND = "ACCOUNT_NOT_FOUND",
  GENERIC_FAILURE = "GENERIC_FAILURE",
  INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
  NON_TRANSACTION_ACCOUNT = "NON_TRANSACTION_ACCOUNT",
  NOT_AUTHORIZED = "NOT_AUTHORIZED",
}

export enum CardPossession {
  NO_LOST = "NO_LOST",
  NO_STOLEN = "NO_STOLEN",
  NO_UNKNOWN = "NO_UNKNOWN",
  VIRTUAL_CARD = "VIRTUAL_CARD",
  YES = "YES",
}

export interface CardProductDetails {
  balances: CardProductDetailsBalances;
}

/** CardProductDetails balances */
export interface CardProductDetailsBalances {
  /**
   * Utilization, in the billing currency of the billing entity, for this group's billing entity.
   * The utilization includes the credit balance and it takes pending amounts into account
   */
  billingCurrencyUtilization: FinancialAsset;
  /**  Billing Group's card cleared balance in USD  */
  clearedBalance: FinancialAsset;
  /**  Billing Group's card pending balance in local currency  */
  pendingBalance: FinancialAsset;
  /**  Billing Group's card pending balance in USD  */
  usdPendingBalance: FinancialAsset;
  /**  Billing Group's utilized card balance in USD  */
  usdTotalBalance: FinancialAsset;
}

export enum CardProvider {
  CARD_MANAGER = "CARD_MANAGER",
  I2C = "I2C",
  MARQETA = "MARQETA",
  MASTERCARD = "MASTERCARD",
}

export enum CardPurpose {
  GENERAL = "GENERAL",
  PROCUREMENT = "PROCUREMENT",
  TRAVEL = "TRAVEL",
}

/** Reissuing status information of a card */
export interface CardReissuingStatus {
  /** The instrument types that are supported for reissuing the card. If empty, card cannot be reissued. */
  supportedInstrumentTypes: Array<InstrumentType>;
}

/** The Card Replacement Reason enum, keep in sync with Brex.Card.Common.CardReplacementReason */
export enum CardReplacementReason {
  DAMAGED = "DAMAGED",
  EXPIRATION = "EXPIRATION",
  FRAUD = "FRAUD",
  INTERNAL = "INTERNAL",
  INVALID = "INVALID",
  LOST = "LOST",
  NOT_RECEIVED = "NOT_RECEIVED",
  OTHER = "OTHER",
}

/** Search category for cards */
export enum CardSearchCategory {
  /** Brex Bill Pay cards */
  BILL_PAY = "BILL_PAY",
  /** Employee-owned cards */
  EMPLOYEE = "EMPLOYEE",
  /** Lodge cards */
  LODGE = "LODGE",
  /** Purchasing cards */
  PURCHASING = "PURCHASING",
  /** Spend limit cards */
  SPEND_LIMIT = "SPEND_LIMIT",
}

/** A Card connection for Card pagination. */
export interface CardSearchConnection extends Connection {
  /** The Cards in the current page of results. */
  edges: Array<CardEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of Cards matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

/** Filters available to control which Cards get returned. */
export interface CardSearchFilterInput {
  /** Match IN specific budgets (null and empty list filters are ignored) */
  budgetIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Match IN specific cardBudgetOwnershipTypes (null and empty list filters are ignored) */
  cardBudgetOwnershipTypes?: InputMaybe<Array<CardBudgetOwnershipType>>;
  /** Filter for central cards (default false). */
  central?: InputMaybe<Scalars["Boolean"]>;
  /** Match IN specific cost centers (null and empty list filters are ignored) */
  costCenterIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Match IN specific customerUsers (null and empty list filters are ignored) */
  customerUserIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Match IN specific departments (null and empty list filters are ignored) */
  departmentIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Match IN specific cards (null and empty list filters are ignored) */
  ids?: InputMaybe<Array<Scalars["ID"]>>;
  /** Match IN specific instrumentTypes (null and empty list filters are ignored) */
  instrumentTypes?: InputMaybe<Array<InstrumentType>>;
  /** Filter for partner managed cards */
  isManagedByPartner?: InputMaybe<Scalars["Boolean"]>;
  /** Filter for partner cards */
  isPartnerCard?: InputMaybe<Scalars["Boolean"]>;
  /** Match IN specific legal entities (null and empty list filters are ignored) */
  legalEntityIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Match IN specific locations (null and empty list filters are ignored) */
  locationIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Match IN specific managers (null and empty list filters are ignored) */
  managerIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Match IN specific partners (null and empty list filters are ignored) */
  partnerIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Match IN specific search categories (null and empty list filters are ignored) */
  searchCategory?: InputMaybe<Array<CardSearchCategory>>;
  /** Freeform text search that matches on displayName, holderName or lastFour */
  searchQuery?: InputMaybe<Scalars["String"]>;
  /** Match IN specific spend limit statuses (null filters are ignored) */
  spendLimitStatus?: InputMaybe<SpendLimitStatusFilter>;
  /** Match IN specific StatusViews (null and empty list filters are ignored) */
  statusViews?: InputMaybe<Array<StatusView>>;
  /** Match IN specific titles (null and empty list filters are ignored) */
  titleIds?: InputMaybe<Array<Scalars["ID"]>>;
}

export enum CardSetLimitSourceAutoAssignmentErrorCode {
  CARD_NOT_FOUND = "CARD_NOT_FOUND",
}

export interface CardSetLimitSourceAutoAssignmentErrors {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface CardSetLimitSourceAutoAssignmentInvalidError
  extends CardSetLimitSourceAutoAssignmentErrors,
    StandardClientError {
  code: ErrorCode;
  errorCode: CardSetLimitSourceAutoAssignmentErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

/** Card Shipping Details */
export interface CardShippingDetails {
  /** Courier */
  courier?: Maybe<Courier>;
  /** Card shipping details dismissed at, null if not dismissed from UI. */
  dismissedAt?: Maybe<Scalars["Time"]>;
  /**
   * Estimated Delivery Date.
   * Note: this is local date time, we are using the ISOz format in here due to the platform limitation.
   */
  estimatedDeliveryDate?: Maybe<Scalars["Time"]>;
  /** Estimated delivery range. */
  estimatedDeliveryDaysRange?: Maybe<DeliveryDaysRange>;
  /** Unique identifier of the Card Shipping Details */
  id: Scalars["ID"];
  /** Latest shipping event date */
  latestEventDate: Scalars["Time"];
  /** Latest location map url */
  latestLocationMapUrl?: Maybe<Scalars["String"]>;
  /** Latest shipping status */
  latestStatus: ShippingStatus;
  /** List of shipping events */
  shippingEvents?: Maybe<Array<Maybe<ShippingEvent>>>;
  /** Tracking Number */
  trackingNumber?: Maybe<Scalars["String"]>;
  /** Tracking URL */
  trackingUrl?: Maybe<Scalars["String"]>;
}

/** Colum to sort cards by */
export enum CardSortColumn {
  DISPLAY_NAME = "DISPLAY_NAME",
  HOLDER_NAME = "HOLDER_NAME",
  LAST_USED = "LAST_USED",
  LIMIT = "LIMIT",
  LOCK_DATE = "LOCK_DATE",
  STATUS_VIEW = "STATUS_VIEW",
  USAGE = "USAGE",
  UTILIZATION = "UTILIZATION",
}

/** Determines the order that Cards will be returned */
export interface CardSortInput {
  /** Field to sort Cards by */
  field: SortableCardField;
  /** Ascending or descending order */
  order: OrderByDirection;
}

/** Spend limit assignment settings for the card. */
export interface CardSpendLimitAssignmentSettings {
  /** Whether or not accidental decline protection is enabled for the card. If an expense would decline, and this was enabled, Brex AI would find a viable limit to cover the expense. */
  accidentalDeclineProtectionEnabled: Scalars["Boolean"];
}

export interface CardSpendWorkflowExtension extends ExpenseExtensionType {
  id: Scalars["ID"];
  isDisputed?: Maybe<Scalars["Boolean"]>;
  isTmcCard?: Maybe<Scalars["Boolean"]>;
  tmcMetadata?: Maybe<TmcMetadata>;
}

export enum CardStatus {
  ACTIVE = "ACTIVE",
  SUSPENDED = "SUSPENDED",
  TERMINATED = "TERMINATED",
  WAITING_ACTIVATION = "WAITING_ACTIVATION",
}

export interface CardSummaryMetadata {
  /** Legal entity name */
  legalEntityName: Scalars["String"];
  /** Sum of payments in the statement */
  totalPayments?: Maybe<FinancialAsset>;
  /** Sum of rewards in the statement */
  totalRewards?: Maybe<FinancialAsset>;
  /** Sum of spend in the statement */
  totalSpend?: Maybe<FinancialAsset>;
}

export enum CardSuspendReason {
  CARD_DAMAGED = "CARD_DAMAGED",
  CARD_LOST = "CARD_LOST",
  DO_NOT_NEED_PHYSICAL_CARD = "DO_NOT_NEED_PHYSICAL_CARD",
  DO_NOT_NEED_VIRTUAL_CARD = "DO_NOT_NEED_VIRTUAL_CARD",
  FRAUD = "FRAUD",
  OTHER = "OTHER",
}

export interface CardTerms {
  /** Version of the terms. */
  version: Scalars["String"];
}

export enum CardTextColor {
  BLACK = "BLACK",
  WHITE = "WHITE",
}

export interface CardTransaction {
  /** The Card the transaction was made on. */
  card?: Maybe<Card>;
  /** The Card Acceptor at which the transaction was made */
  cardPaymentAcceptor?: Maybe<CardPaymentAcceptor>;
  /**
   * DO NOT USE THIS FIELD WHEN LISTING EXPENSES. YOU WILL BREAK THE DASHBOARD
   * The optional dispute associated with the Card Transaction.
   */
  dispute?: Maybe<Dispute>;
  /** The unique TILL Payment ID of the Card Transaction. */
  id: Scalars["ID"];
  /** The unique present transaction ID of the Card Transaction. */
  presentTransactionId: Scalars["ID"];
  /** A reference identifier for the card transaction. */
  referenceId?: Maybe<Scalars["String"]>;
}

export interface CardTransactionFraudAlert extends Node {
  creationDate?: Maybe<Scalars["Time"]>;
  expense?: Maybe<Expense>;
  /** The ID of an object */
  id: Scalars["ID"];
  status: ConfirmationStatus;
}

export interface CardTransferError extends MutationError {
  errors?: Maybe<Array<CardTransferErrors>>;
}

export interface CardTransferErrors extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface CardTransferInput {
  /** The ID of the budget to transfer the card to */
  budgetId?: InputMaybe<Scalars["ID"]>;
  /** The client mutation id */
  clientMutationId: Scalars["String"];
  /** The embedded user ID of the user to transfer the card to */
  embeddedUserId?: InputMaybe<Scalars["ID"]>;
  /** The ID of the card to transfer */
  id: Scalars["ID"];
  /** The reason for transferring the card */
  reason: CardOwnershipTransferReason;
  /** The ID of the user to transfer the card to */
  userId: Scalars["ID"];
}

export type CardTransferResult = Card | CardTransferError;

export interface CardType {
  /** The categorization of cards based on the way they can be authorized against different limit sources */
  cardLimitCategory?: Maybe<CardLimitCategory>;
  /** Whether this is a company card */
  isCompanyCard: Scalars["Boolean"];
  /** Whether the card is managed by a partner */
  isManagedByPartner: Scalars["Boolean"];
  /** Whether Smart Data is enabled */
  isSmartDataEnabled: Scalars["Boolean"];
  /** Integration partner associated with the card */
  partner?: Maybe<IntegrationPartner>;
  /** The method of partner integration if applicable */
  partnerIntegrationMethod?: Maybe<PartnerIntegrationMethod>;
  /** The purpose of the card */
  purpose?: Maybe<CardPurpose>;
}

/** Structured data for card wallet operations */
export interface CardWalletAddedContent extends StructuredData {
  /** The type of digital wallet the card was added to */
  cardWalletType?: Maybe<Scalars["String"]>;
  /** Type discriminator value - 'CardWalletAddedContent' */
  type?: Maybe<Scalars["String"]>;
}

export enum CardsSummarizeByField {
  CARD_BUDGET_OWNERSHIP_TYPE = "CARD_BUDGET_OWNERSHIP_TYPE",
}

export interface CardsSummary {
  /** List of summary items that each represent a field value and the count of cards for that field value */
  items: Array<CardsSummaryItem>;
  /** The field that the cards are summarized by */
  summaryField: CardsSummarizeByField;
}

export interface CardsSummaryItem {
  /** A list of cards for the summarized field value */
  cards: Array<Card>;
  /**
   * The field that the cards are summarized by. Field strings will equal the enum values of the supplied
   * CardsSummarizeByField types (Example: for CardBudgetOwnershipType, the field strings would be either USER or BUDGET)
   */
  field: Scalars["String"];
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** A aggregate value for the field (generally, the count of cards for the field value) */
  value: Scalars["Int"];
}

export interface CashBalancePayloadV2 {
  centsPerPoint: Scalars["Float"];
}

export interface CashBank {
  accountType: Scalars["String"];
  city: Scalars["String"];
  name: Scalars["String"];
  state: Scalars["String"];
  street: Scalars["String"];
  suite: Scalars["String"];
  zip: Scalars["String"];
}

export interface CashCertificationsInput {
  /**
   * Is your company a registered brokerage firm or securities exchange, or an investment advisor, investment company,
   * or investment fund of any kind?
   */
  companyHasInvestmentBackground: Scalars["Boolean"];
  /**
   * Is your company or any of its beneficial owners or controlling officers a 10% or more shareholder of a public
   * company?
   */
  companyPartiallyOwnsPublicCompany: Scalars["Boolean"];
  /**
   * Will you be using your Brex Cash account to hold or process funds on behalf of anyone else (for example, on
   * behalf of your customers or employees)?
   */
  companyWillProxyMoneyMovement: Scalars["Boolean"];
}

export interface CashFlowsSummary {
  cashInflows: Scalars["Float"];
  cashOutflows: Scalars["Float"];
  date: Scalars["Time"];
  netCashFlow?: Maybe<Scalars["Float"]>;
}

export enum CashIntensiveMaxCashHandled {
  INVALID = "INVALID",
  LESS_THAN_500K = "LESS_THAN_500K",
  LESS_THAN_1000K = "LESS_THAN_1000K",
  LESS_THAN_2000K = "LESS_THAN_2000K",
  MORE_THAN_2000K = "MORE_THAN_2000K",
  NO_CASH = "NO_CASH",
}

export interface CashIntensivePayloadInput {
  expectsInternationalWire: Scalars["Boolean"];
  maxCashHandled: MaxCashHandled;
}

export interface CashRecurringSchedule extends Node {
  /**
   * The duration of the recurring schedule
   *
   * ends_at
   * Keep creating transactions until the `ends_at` date
   *
   * total_count
   * Keep creating transactions until `total_count` transactions have been scheduled.
   * We make this distinction because transactions can be cancelled which still count towards the `total_count` amount
   */
  duration?: Maybe<CashRecurringScheduleDuration>;
  /** A human readable string describing when the schedule will end. */
  durationDescription: Scalars["String"];
  /** The ID of an object */
  id: Scalars["ID"];
  /** The type of recurring schedule, defining the rules for transaction scheduling */
  type: CashRecurringScheduleType;
  /** A human readable string describing the cadence of the schedule. */
  typeDescription: Scalars["String"];
}

export type CashRecurringScheduleDuration =
  | CashRecurringScheduleDurationWithEndsAt
  | CashRecurringScheduleDurationWithTotalCount;

export interface CashRecurringScheduleDurationWithEndsAt {
  /** Keep creating transactions until the `ends_at` date */
  endsAt: Scalars["Time"];
}

export interface CashRecurringScheduleDurationWithTotalCount {
  /**
   * Keep creating transactions until `total_count` transactions have been scheduled.
   * We make this distinction because transactions can be cancelled which still count towards the `total_count` amount.
   */
  totalCount: Scalars["Int"];
}

export interface CashRecurringScheduleMonthlyByDay {
  /** Number of months between successive transactions */
  cadence: Scalars["Int"];
  /** Day of the month to schedule transactions */
  dayOfMonth: Scalars["Int"];
}

export interface CashRecurringScheduleMonthlyByWeek {
  /** Number of months between successive transactions */
  cadence: Scalars["Int"];
  /** Day of the week to schedule transactions */
  dayOfWeek: CashTransactionBusinessDay;
  /** Week of the month to schedule transactions */
  weekOfMonth: Scalars["Int"];
}

export type CashRecurringScheduleType =
  | CashRecurringScheduleMonthlyByDay
  | CashRecurringScheduleMonthlyByWeek
  | CashRecurringScheduleWeekly;

export interface CashRecurringScheduleWeekly {
  /** Number of weeks between successive transactions */
  cadence: Scalars["Int"];
  /** Day of the week to schedule transactions */
  dayOfWeek: CashTransactionBusinessDay;
}

export interface CashRecurringScheduleWithTimelines {
  /** The recurring schedule definition */
  recurringSchedule: CashRecurringSchedule;
  /** Timelines for future scheduled transactions that will be made by this recurring schedule */
  timelines: Array<CashTransactionTimeline>;
}

/** Cash Transaction externally defined by Deposit Processor's api-v1 schema. */
export interface CashTransaction extends Node {
  /** The balance across all of the customer's deposits accounts when funds were made available to the account. */
  aggregateProcessedBalanceSnapshotUsdCents?: Maybe<Scalars["Int"]>;
  /** The money movement amount this transaction is responsible for. */
  amountUsdCents: Scalars["Int"];
  /** If not NULL, the bill associated with the transaction. */
  bill?: Maybe<Bill>;
  /** If non-NULL, this field explains why a transaction reached the FAILED status */
  cancellationReason?: Maybe<CashTransactionCancellationReason>;
  /**
   * DO NOT BATCH, WILL RESULT IN AN N+1 QUERY.
   * If not NULL, the customer user that cancelled the transaction.
   */
  cancelledByUser?: Maybe<User>;
  /**
   * DO NOT BATCH, WILL RESULT IN AN N+1 QUERY.
   * Counterparty information for BREX-originated transactions.
   */
  counterpartyDetails?: Maybe<CashTransactionCounterpartyDetails>;
  /** A customer editable memo for the transaction which is not meant to be processed in any way outside of a note for the customer to view. */
  customerMemo?: Maybe<Scalars["String"]>;
  /** The deposits account of the transaction */
  depositsAccount?: Maybe<DepositsAccount>;
  /** Details related with the underlying transaction type. */
  details: CashTransactionDetails;
  /**
   * A human-readable name describing the transaction
   *
   * This field is mainly filled with the counterparty information for payment rail transactions and some standard text for other transaction types
   */
  displayName: Scalars["String"];
  /** The ID of an object */
  id: Scalars["ID"];
  /**
   * DO NOT BATCH, WILL RESULT IN AN N+1 QUERY.
   * If not NULL, the customer user that initiated the transaction.
   */
  initiatedByUser?: Maybe<User>;
  /** Associated invoice */
  invoice?: Maybe<InvoiceV1>;
  /**
   * DO NOT BATCH, WILL RESULT IN AN N+1 QUERY.
   * Whether the transaction is still cancellable.
   * Note that this does not apply any permissioning logic to declare whether the user can cancel the transaction.
   */
  isCancellable: Scalars["Boolean"];
  /** If true, the customer opted into Principal Protection for this transaction. */
  isPproEnabled?: Maybe<Scalars["Boolean"]>;
  /** If true, the transaction originated from a recurring schedule. */
  isRecurring?: Maybe<Scalars["Boolean"]>;
  /**
   * If true, notify the contact if and when the transaction moves to the processing state.
   * Ignored unless the transaction is a credit to a contact with a valid email.
   */
  notifyContactProcessing?: Maybe<Scalars["Boolean"]>;
  /**
   * Where the transaction originated from
   *
   * BREX
   * The transaction was initiated at Brex
   *
   * EXTERNAL
   * The transaction was initiated at outside of Brex
   */
  origin: CashTransactionOrigin;
  /** The account balance when funds were made available to the account. */
  processedBalanceSnapshotUsdCents?: Maybe<Scalars["Int"]>;
  /**
   * DO NOT BATCH, WILL RESULT IN AN N+1 QUERY.
   * If not NULL, the recurring schedule from which the transaction originated.
   * Optionally fetch the predicted timelines for the next `timelineCount` transactions in the schedule.
   */
  recurringSchedule?: Maybe<CashRecurringScheduleWithTimelines>;
  /**
   * Returns true when transaction is external, bank_provider is not column and customer has marked
   * account_migration_status as completed, otherwise returns false
   */
  showAccountMigrationAlertFlag?: Maybe<Scalars["Boolean"]>;
  /**
   * Where in the transaction lifecycle this transaction is at
   *
   * APPROVAL_REQUIRED
   * The transaction is pending approval from an admin in the account before we're able to begin processing or scheduling the transaction
   *
   * SCHEDULED
   * The transaction is scheduled to be initiated during its scheduled_send_at time
   *
   * PROCESSING
   * This phase begins when Brex starts to process the sending or receiving of this transaction and ends when we either PROCESS or FAIL the verification
   *
   * PROCESSED
   * The money movement has been fully complete, which could mean money sent has arrived at their destination or funds have been added to the account
   *
   * FAILED
   * A grouping of multiple terminal states that prevented the transaction from completing
   * This includes:
   * - A user cancelled the transaction
   * - An admin denied the approval
   * - Failure to send/receive the funds (e.g. insufficient funds, permissions, etc)
   * - Internal cancellation due to fraud
   */
  status: CashTransactionStatus;
  /** Timestamps for the series of events a transaction has gone through */
  timeline: CashTransactionTimeline;
  /** Extension field to surface payment tracking details for a cash transaction. */
  trackingDetails?: Maybe<TransactionTrackingObject>;
  /**
   * DO NOT BATCH, WILL RESULT IN AN N+1 QUERY.
   * If not NULL, the approval associated with the transaction.
   */
  transactionApproval?: Maybe<CashTransactionApproval>;
  /** Returns the banking transaction review request used for MSAA V3 if the transaction needs approval */
  transactionReviewRequest?: Maybe<BankingTransactionRequest>;
  /** A high-level breakdown of the possible transactions which does not exactly map 1:1 with the details. */
  type: CashTransactionType;
}

/** Cash Transaction externally defined by Deposit Processor's api-v1 schema. */
export interface CashTransactionrecurringScheduleArgs {
  timelineCount?: InputMaybe<Scalars["Int"]>;
}

export enum CashTransactionAccountClass {
  BUSINESS = "BUSINESS",
  INVALID = "INVALID",
  PERSONAL = "PERSONAL",
}

export enum CashTransactionAccountType {
  CHECKING = "CHECKING",
  CURRENT = "CURRENT",
  INVALID = "INVALID",
  SAVINGS = "SAVINGS",
}

export interface CashTransactionAchDetails {
  /** The financial account class */
  accountClass?: Maybe<CashTransactionAccountClass>;
  /** The counterparty's account number */
  accountNumber?: Maybe<Scalars["String"]>;
  /** The financial account type */
  accountType?: Maybe<CashTransactionAccountType>;
  /** The address of the recipient */
  address?: Maybe<Address>;
  /** This field contains the bank provider that the transaction occured through. */
  bankProvider?: Maybe<CashTransactionBankProvider>;
  /** The counterparty's beneficiary bank information */
  beneficiaryBank?: Maybe<CashTransactionBeneficiaryBank>;
  /** The institution's logo as a base64 PNG, if available */
  beneficiaryBankLogoBase64?: Maybe<Scalars["String"]>;
  /**
   * Output only. A 10-digit unique identifier used for identifying ACH entities
   * Only exists for externally originated counterparties
   */
  companyId?: Maybe<Scalars["String"]>;
  /** The email of the recipient */
  email?: Maybe<Scalars["String"]>;
  /**
   * This field contains the accounting reference number by which the Receiver is known to the Originator.
   * Only exists for externally originated counterparties.
   */
  identificationNumber?: Maybe<Scalars["String"]>;
  /** Whether the transaction was a debit or credit */
  paymentMethod: CashTransactionPaymentMethod;
  /** Positive pay status for company_id */
  positivePayStatus?: Maybe<PositivePayStatus>;
  /** The counterparty's routing number */
  routingNumber?: Maybe<Scalars["String"]>;
  /**
   * The unique number assigned to every ACH entry by an ODFI which identifies that entry within a specific ACH file.
   * Only available for incoming ACHs.
   */
  traceNumber?: Maybe<Scalars["String"]>;
  /** Entry description used to describe the transaction in NACHA */
  transferDescription?: Maybe<Scalars["String"]>;
}

export interface CashTransactionAchReturnDetails {
  /** Details from the transaction this return was for */
  originalDetails: CashTransactionAchDetails;
  /** The reason why the original transaction was returned */
  returnReason: CashTransactionAchReturnReason;
}

export enum CashTransactionAchReturnReason {
  ACCOUNT_CLOSED = "ACCOUNT_CLOSED",
  ACCOUNT_FROZEN = "ACCOUNT_FROZEN",
  ACCOUNT_NOT_FOUND = "ACCOUNT_NOT_FOUND",
  ACCOUNT_SOLD_TO_ANOTHER_DFI = "ACCOUNT_SOLD_TO_ANOTHER_DFI",
  ADDENDA_ERROR = "ADDENDA_ERROR",
  AMOUNT_FIELD_ERROR = "AMOUNT_FIELD_ERROR",
  AUTHORIZATION_REVOKED_BY_CUSTOMER = "AUTHORIZATION_REVOKED_BY_CUSTOMER",
  AUTOMATICALLY_RETURNED_LENDING_CLUB = "AUTOMATICALLY_RETURNED_LENDING_CLUB",
  BENEFICIARY_DECEASED = "BENEFICIARY_DECEASED",
  CHECK_TRUNCATION_ENTRY_RETURN = "CHECK_TRUNCATION_ENTRY_RETURN",
  CORPORATE_CUSTOMER_ADVISES_NOT_AUTHORIZED = "CORPORATE_CUSTOMER_ADVISES_NOT_AUTHORIZED",
  CORRECTED_RETURN = "CORRECTED_RETURN",
  CREDIT_ENTRY_REFUSED_BY_RECEIVER = "CREDIT_ENTRY_REFUSED_BY_RECEIVER",
  CUSTOMER_ADVISES_IMPROPER = "CUSTOMER_ADVISES_IMPROPER",
  CUSTOMER_ADVISES_UNAUTHORIZED = "CUSTOMER_ADVISES_UNAUTHORIZED",
  DUPLICATE_ENROLLMENT = "DUPLICATE_ENROLLMENT",
  DUPLICATE_ENTRY = "DUPLICATE_ENTRY",
  DUPLICATE_RETURN = "DUPLICATE_RETURN",
  ENTRY_NOT_PROCESSED_BY_GATEWAY = "ENTRY_NOT_PROCESSED_BY_GATEWAY",
  FIELD_ERRORS = "FIELD_ERRORS",
  FILE_RECORD_EDIT_CRITERIA = "FILE_RECORD_EDIT_CRITERIA",
  FOREIGN_RECEIVING_DFI_UNABLE_TO_SETTLE = "FOREIGN_RECEIVING_DFI_UNABLE_TO_SETTLE",
  IAT_ENTRY_CODING_ERROR = "IAT_ENTRY_CODING_ERROR",
  IMPROPER_EFFECTIVE_ENTRY_DATE = "IMPROPER_EFFECTIVE_ENTRY_DATE",
  IMPROPER_SOURCE_DOCUMENT = "IMPROPER_SOURCE_DOCUMENT",
  INCORRECTLY_CODED_OUTBOUND_INTERNATIONAL_PAYMENT = "INCORRECTLY_CODED_OUTBOUND_INTERNATIONAL_PAYMENT",
  INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
  INVALID = "INVALID",
  INVALID_ACCOUNT_NUMBER_STRUCTURE = "INVALID_ACCOUNT_NUMBER_STRUCTURE",
  INVALID_ACH_ROUTING_NUMBER = "INVALID_ACH_ROUTING_NUMBER",
  INVALID_COMPANY_IDENTIFICATION = "INVALID_COMPANY_IDENTIFICATION",
  INVALID_COMPANY_NAME = "INVALID_COMPANY_NAME",
  INVALID_DFI_ACCOUNT_NUMBER = "INVALID_DFI_ACCOUNT_NUMBER",
  INVALID_FOREIGN_RECEIVING_DFI_IDENTIFICATION = "INVALID_FOREIGN_RECEIVING_DFI_IDENTIFICATION",
  INVALID_INDIVIDUAL_ID_NUMBER = "INVALID_INDIVIDUAL_ID_NUMBER",
  INVALID_INDIVIDUAL_ID_NUMBER_2 = "INVALID_INDIVIDUAL_ID_NUMBER_2",
  INVALID_INDIVIDUAL_NAME = "INVALID_INDIVIDUAL_NAME",
  INVALID_REPRESENTATIVE_PAYEE_INDICATOR = "INVALID_REPRESENTATIVE_PAYEE_INDICATOR",
  INVALID_TRANSACTION_CODE = "INVALID_TRANSACTION_CODE",
  ITEM_AND_RCK_ENTRY_PRESENTED_FOR_PAYMENT = "ITEM_AND_RCK_ENTRY_PRESENTED_FOR_PAYMENT",
  ITEM_RELATED_TO_RCK_ENTRY_IS_IMPROPER = "ITEM_RELATED_TO_RCK_ENTRY_IS_IMPROPER",
  LIMITED_PARTICIPATION_DFI = "LIMITED_PARTICIPATION_DFI",
  MANDATORY_FIELD_ERROR = "MANDATORY_FIELD_ERROR",
  MANUALLY_CANCELLED = "MANUALLY_CANCELLED",
  MISROUTED_DISHONORED_RETURN = "MISROUTED_DISHONORED_RETURN",
  MISROUTED_RETURN = "MISROUTED_RETURN",
  NON_PARTICIPANT_IN_IAT_PROGRAM = "NON_PARTICIPANT_IN_IAT_PROGRAM",
  NON_TRANSACTION_ACCOUNT = "NON_TRANSACTION_ACCOUNT",
  NO_ERRORS_FOUND = "NO_ERRORS_FOUND",
  PAYMENT_STOPPED = "PAYMENT_STOPPED",
  PERMISSIBLE_RETURN_ENTRY = "PERMISSIBLE_RETURN_ENTRY",
  PERMISSIBLE_RETURN_ENTRY_NOT_ACCEPTED = "PERMISSIBLE_RETURN_ENTRY_NOT_ACCEPTED",
  RDFI_NON_SETTLEMENT = "RDFI_NON_SETTLEMENT",
  RDFI_NOT_PARTICIPANT_IN_CHECK_TRUNCATION_PROGRAM = "RDFI_NOT_PARTICIPANT_IN_CHECK_TRUNCATION_PROGRAM",
  REPRESENTATIVE_PAYEE_DECEASED = "REPRESENTATIVE_PAYEE_DECEASED",
  RETURN_NOT_A_DUPLICATE = "RETURN_NOT_A_DUPLICATE",
  RETURN_NOT_REQUESTED_BY_ODFI = "RETURN_NOT_REQUESTED_BY_ODFI",
  RETURN_OF_ENR_ENTRY_BY_FEDERAL_GOVERNMENT_AGENCY = "RETURN_OF_ENR_ENTRY_BY_FEDERAL_GOVERNMENT_AGENCY",
  RETURN_OF_IMPROPER_CREDIT_ENTRY = "RETURN_OF_IMPROPER_CREDIT_ENTRY",
  RETURN_OF_IMPROPER_DEBIT_ENTRY = "RETURN_OF_IMPROPER_DEBIT_ENTRY",
  RETURN_OF_XCK_ENTRY = "RETURN_OF_XCK_ENTRY",
  RETURN_PER_ODFI_REQUEST = "RETURN_PER_ODFI_REQUEST",
  ROUTING_NUMBER_CHECK_DIGIT_ERROR = "ROUTING_NUMBER_CHECK_DIGIT_ERROR",
  ROUTING_NUMBER_ERROR = "ROUTING_NUMBER_ERROR",
  SOURCE_DOCUMENT_PRESENTED_FOR_PAYMENT = "SOURCE_DOCUMENT_PRESENTED_FOR_PAYMENT",
  STATE_LAW_AFFECTING_RCK_ACCEPTANCE = "STATE_LAW_AFFECTING_RCK_ACCEPTANCE",
  STOP_PAYMENT_ON_ITEM_RELATED_TO_RCK_ENTRY = "STOP_PAYMENT_ON_ITEM_RELATED_TO_RCK_ENTRY",
  STOP_PAYMENT_ON_SOURCE_DOCUMENT = "STOP_PAYMENT_ON_SOURCE_DOCUMENT",
  TIMELY_ORIGINAL_RETURN = "TIMELY_ORIGINAL_RETURN",
  TRACE_NUMBER_ERROR = "TRACE_NUMBER_ERROR",
  UNAUTHORIZED_DEBIT_TO_CONSUMER_ACCOUNT_USING_CORPORATE_SEC_CODE = "UNAUTHORIZED_DEBIT_TO_CONSUMER_ACCOUNT_USING_CORPORATE_SEC_CODE",
  UNCOLLECTED_FUNDS = "UNCOLLECTED_FUNDS",
  UNKNOWN = "UNKNOWN",
  UNTIMELY_DISHONORED_RETURN = "UNTIMELY_DISHONORED_RETURN",
  UNTIMELY_RETURN = "UNTIMELY_RETURN",
}

export interface CashTransactionAdminBalanceAdjustmentDetails {
  /** Internal reason why the admin balance adjustment was created */
  description?: Maybe<Scalars["String"]>;
  /** Whether the transaction was a debit or credit */
  paymentMethod: CashTransactionPaymentMethod;
}

export interface CashTransactionApproval {
  approvalCondition: CashTransactionApprovalCondition;
  decidedByUser?: Maybe<User>;
  decision: CashTransactionApprovalDecision;
  /** Any notes the admin wants to fill in a free form field when processing a draft payment. */
  decisionNotes?: Maybe<Scalars["String"]>;
  decisionReason?: Maybe<CashTransactionApprovalDecisionReason>;
  transactionId?: Maybe<Scalars["String"]>;
}

export enum CashTransactionApprovalCondition {
  ANY = "ANY",
  BREX_INTERNAL_USER = "BREX_INTERNAL_USER",
  INVALID = "INVALID",
  NON_INITIATING = "NON_INITIATING",
}

export interface CashTransactionApprovalContext {
  /** Amount in USD cents */
  amountUsdCents: Scalars["Int"];
  /** Encoded Bill ID */
  billId?: Maybe<Scalars["ID"]>;
  cancellationReason?: Maybe<CashTransactionCancellationReason>;
  counterpartyName: Scalars["String"];
  externalMemo?: Maybe<Scalars["String"]>;
  initiatedByUserFirstName?: Maybe<Scalars["String"]>;
  initiatedByUserLastName?: Maybe<Scalars["String"]>;
  routingNumber?: Maybe<Scalars["String"]>;
  transactionId: Scalars["ID"];
  transactionStatus: CashTransactionStatus;
  type: CashTransactionType;
}

export enum CashTransactionApprovalDecision {
  APPROVED = "APPROVED",
  CANCELLED = "CANCELLED",
  DENIED = "DENIED",
  INVALID = "INVALID",
  PENDING = "PENDING",
}

export enum CashTransactionApprovalDecisionReason {
  FRAUDULENT = "FRAUDULENT",
  INCORRECT = "INCORRECT",
  INVALID = "INVALID",
  OTHER = "OTHER",
  UNAUTHORIZED = "UNAUTHORIZED",
}

export interface CashTransactionApprovalResponse {
  cashTransactionApproval?: Maybe<CashTransactionApproval>;
  /** Contextual information about transaction associated with the approval */
  cashTransactionApprovalContext?: Maybe<CashTransactionApprovalContext>;
}

export enum CashTransactionApprovalResult {
  ALREADY_PROCESSED = "ALREADY_PROCESSED",
  INVALID = "INVALID",
  SUCCESSFULLY_UPDATED = "SUCCESSFULLY_UPDATED",
}

export enum CashTransactionBankProvider {
  COLUMN = "COLUMN",
  CRYPTO_FTX = "CRYPTO_FTX",
  INVALID = "INVALID",
  JPM = "JPM",
  RADIUS = "RADIUS",
}

export interface CashTransactionBeneficiaryBank {
  address?: Maybe<Address>;
  info?: Maybe<Scalars["Json"]>;
  name?: Maybe<Scalars["String"]>;
}

export interface CashTransactionBookTransferDetails {
  /** The sender account */
  sourceDepositsAccount?: Maybe<DepositsAccount>;
  /** The recipient account */
  targetDepositsAccount?: Maybe<DepositsAccount>;
}

export interface CashTransactionBrexOperationalTransferDetails {
  _?: Maybe<Scalars["Boolean"]>;
}

export enum CashTransactionBusinessDay {
  FRIDAY = "FRIDAY",
  INVALID = "INVALID",
  MONDAY = "MONDAY",
  THURSDAY = "THURSDAY",
  TUESDAY = "TUESDAY",
  WEDNESDAY = "WEDNESDAY",
}

export enum CashTransactionCancellationReason {
  ACCOUNT_CLOSED = "ACCOUNT_CLOSED",
  ACCOUNT_NOT_FOUND = "ACCOUNT_NOT_FOUND",
  ACH_DEBIT_CAPABILITY_REVOKED = "ACH_DEBIT_CAPABILITY_REVOKED",
  APPROVAL_DENIED = "APPROVAL_DENIED",
  BLOCKED_BY_POSITIVE_PAY = "BLOCKED_BY_POSITIVE_PAY",
  CUSTOMER_EDITED = "CUSTOMER_EDITED",
  EXCEEDS_AUTHORIZED_VENDOR_DRAWDOWN_AMOUNT = "EXCEEDS_AUTHORIZED_VENDOR_DRAWDOWN_AMOUNT",
  FAILED_COLUMN_FX_QUOTE_BOOKING = "FAILED_COLUMN_FX_QUOTE_BOOKING",
  FAILED_VERIFICATION = "FAILED_VERIFICATION",
  INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
  INVALID = "INVALID",
  MISSED_SEND_ON = "MISSED_SEND_ON",
  SACA_BALANCE_COMMITMENT_VIOLATION = "SACA_BALANCE_COMMITMENT_VIOLATION",
  SYSTEM_CANCELLED = "SYSTEM_CANCELLED",
  UNAUTHORIZED_VENDOR_DRAWDOWN_REQUEST = "UNAUTHORIZED_VENDOR_DRAWDOWN_REQUEST",
  USER_CANCELLED = "USER_CANCELLED",
}

export interface CashTransactionCardCollectionDetails {
  billingPayment: BillingPayment;
  collectionAttempt: CollectionAttempt;
  collectionId: Scalars["String"];
}

export enum CashTransactionChequeReturnReason {
  ACCOUNT_CLOSED = "ACCOUNT_CLOSED",
  ACCOUNT_FROZEN = "ACCOUNT_FROZEN",
  ACCOUNT_NOT_FOUND = "ACCOUNT_NOT_FOUND",
  ALTERED_OR_COUNTERFEIT = "ALTERED_OR_COUNTERFEIT",
  BRANCH_SOLD = "BRANCH_SOLD",
  CORPORATE_CUSTOMER_ADVISES_NOT_AUTHORIZED = "CORPORATE_CUSTOMER_ADVISES_NOT_AUTHORIZED",
  COUNTERFEIT_WARRANTY_BREACH = "COUNTERFEIT_WARRANTY_BREACH",
  DUPLICATE_PRESENTMENT = "DUPLICATE_PRESENTMENT",
  ENDORSEMENT_IRREGULAR = "ENDORSEMENT_IRREGULAR",
  ENDORSEMENT_MISSING = "ENDORSEMENT_MISSING",
  EXCEEDS_MAX_PRESENTMENTS = "EXCEEDS_MAX_PRESENTMENTS",
  FORGERY = "FORGERY",
  INDETERMINATE_AMOUNT = "INDETERMINATE_AMOUNT",
  INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
  INVALID = "INVALID",
  ITEMS_EXCEEDS_STATED_MAX_VALUE = "ITEMS_EXCEEDS_STATED_MAX_VALUE",
  MANUALLY_CANCELLED = "MANUALLY_CANCELLED",
  NON_CASH_ITEM = "NON_CASH_ITEM",
  NOT_AUTHORIZED_RCC = "NOT_AUTHORIZED_RCC",
  ONE_OR_MORE_SIGNATURES_IRREGULAR = "ONE_OR_MORE_SIGNATURES_IRREGULAR",
  ONE_OR_MORE_SIGNATURES_MISSING = "ONE_OR_MORE_SIGNATURES_MISSING",
  PAYMENT_STOPPED = "PAYMENT_STOPPED",
  POST_DATED = "POST_DATED",
  RCC_WARRANTY_BREACH = "RCC_WARRANTY_BREACH",
  REFER_TO_IMAGE = "REFER_TO_IMAGE",
  REFER_TO_MAKER = "REFER_TO_MAKER",
  RETIRED_OR_INELIGIBLE_ROUTING_NUMBER = "RETIRED_OR_INELIGIBLE_ROUTING_NUMBER",
  STALE_DATED = "STALE_DATED",
  UNABLE_TO_PROCESS = "UNABLE_TO_PROCESS",
  UNCOLLECTED_FUNDS = "UNCOLLECTED_FUNDS",
  UNKNOWN = "UNKNOWN",
  UNUSABLE_IMAGE = "UNUSABLE_IMAGE",
  WARRANTY_BREACH = "WARRANTY_BREACH",
}

export interface CashTransactionConnection {
  edges?: Maybe<Array<Maybe<CashTransactionEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"];
}

export type CashTransactionCounterpartyDetails =
  | CashTransactionFinancialAccount
  | CashTransactionPayee;

export interface CashTransactionDepositedChequeDetails {
  /** A temporary URL pointing to an image of the back of the cheque */
  backImageUrl?: Maybe<Scalars["String"]>;
  /** Memo found in the physical cheque */
  chequeMemo?: Maybe<Scalars["String"]>;
  /** A temporary URL pointing to an image of the front of the cheque */
  frontImageUrl?: Maybe<Scalars["String"]>;
  /** Sender name found in the physical cheque */
  senderName?: Maybe<Scalars["String"]>;
}

export interface CashTransactionDepositedChequeReturnDetails {
  /** Details from the transaction this return was for */
  originalDetails: CashTransactionDepositedChequeDetails;
  /** The reason why the original transaction was returned */
  returnReason: CashTransactionChequeReturnReason;
}

export type CashTransactionDetails =
  | CashTransactionAchDetails
  | CashTransactionAchReturnDetails
  | CashTransactionAdminBalanceAdjustmentDetails
  | CashTransactionBookTransferDetails
  | CashTransactionBrexOperationalTransferDetails
  | CashTransactionCardCollectionDetails
  | CashTransactionDepositedChequeDetails
  | CashTransactionDepositedChequeReturnDetails
  | CashTransactionDividendDetails
  | CashTransactionDomesticWireDetails
  | CashTransactionDomesticWireReturnDetails
  | CashTransactionFboTransferDetails
  | CashTransactionInterestDetails
  | CashTransactionInternationalWireDetails
  | CashTransactionInternationalWireReturnDetails
  | CashTransactionIntraCuaccBookTransferDetails
  | CashTransactionOutgoingChequeDetails
  | CashTransactionOutgoingChequeReturnDetails
  | CashTransactionPaybackDetails
  | CashTransactionPayrollEstimateDetails
  | CashTransactionReceivablesOffersAdvanceDetails
  | CashTransactionReceivablesOffersCollectionDetails
  | CashTransactionReceivablesOffersRepaymentDetails
  | CashTransactionRewardsRedemptionDetails
  | CashTransactionTransactionFeesCollectionDetails;

export interface CashTransactionDividendDetails {
  /** Financial instrument the dividend was for (e.g. MMF ticker) */
  financialInstrument?: Maybe<FinancialInstrument>;
  /** When the dividend payout was initiated, which could differ from the settled_at time */
  paidOnDate?: Maybe<Scalars["Date"]>;
}

export interface CashTransactionDomesticWireDetails {
  /** Counterparty's account number */
  accountNumber?: Maybe<Scalars["String"]>;
  /** The address of the recipient */
  address?: Maybe<Address>;
  /** This field contains the bank provider that the transaction occured through. */
  bankProvider?: Maybe<CashTransactionBankProvider>;
  /** The counterparty's beneficiary bank information */
  beneficiaryBank?: Maybe<CashTransactionBeneficiaryBank>;
  /** The institution's logo as a base64 PNG, if available */
  beneficiaryBankLogoBase64?: Maybe<Scalars["String"]>;
  /** If present, this indicates this wire is a drawdown wire authorized by a drawdown_authorization referenced by this ID */
  drawdownAuthorizationId?: Maybe<Scalars["ID"]>;
  /** The email of the recipient */
  email?: Maybe<Scalars["String"]>;
  /** The fed reference number that we get on BAI2 incoming wire entries */
  fedReferenceNumber?: Maybe<Scalars["String"]>;
  /** The IMAD indicates a unique number that is assigned to a transfer upon receiving at the sending financial institution */
  imad?: Maybe<Scalars["String"]>;
  /** The OMAD indicates a unique number assigned to each transfer providing delivery-related information */
  omad?: Maybe<Scalars["String"]>;
  /** Whether the transaction was a debit or credit */
  paymentMethod: CashTransactionPaymentMethod;
  /** Counterparty's routing number */
  routingNumber?: Maybe<Scalars["String"]>;
  /** Payment instructions */
  transferDescription?: Maybe<Scalars["String"]>;
}

export interface CashTransactionDomesticWireReturnDetails {
  /** Details from the transaction this return was for */
  originalDetails: CashTransactionDomesticWireDetails;
  /**
   * For a returned wire, this is the amount of the original wire vs what was
   * actually returned back due to the beneficiary bank taking a fee.
   */
  originalTransactionAmountUsdCents?: Maybe<Scalars["Int"]>;
  /** The reason why the original transaction was returned */
  returnReason: CashTransactionWireReturnReason;
}

export interface CashTransactionEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<CashTransaction>;
}

export interface CashTransactionFboTransferDetails {
  /** FBO account type */
  fboAccountName?: Maybe<Scalars["String"]>;
}

export interface CashTransactionFinancialAccount {
  /** External financial account associated with this Transaction */
  financialAccount?: Maybe<FinancialAccount>;
}

export interface CashTransactionInterestDetails {
  /** When the interest payout was initiated, which could differ from the settled_at time */
  paidOnDate?: Maybe<Scalars["Date"]>;
}

/**
 * Only one of these fields will be set, either iban or accountNumber
 *
 * For international wires, some countries use an IBAN so we'll set the iban field.
 * For countries that explicitly don't, we'll set the accountNumber as a fallback.
 */
export interface CashTransactionInternationalWireAccountIdentifier {
  type?: Maybe<CashTransactionInternationalWireAccountIdentifierType>;
  value?: Maybe<Scalars["String"]>;
}

export enum CashTransactionInternationalWireAccountIdentifierType {
  ACCOUNT_NUMBER = "ACCOUNT_NUMBER",
  IBAN = "IBAN",
}

export interface CashTransactionInternationalWireDetails {
  /** The associated account number, which could be in the form of an IBAN or other (defaulting to account_number) */
  accountIdentifier?: Maybe<CashTransactionInternationalWireAccountIdentifier>;
  /** The address of the recipient */
  address?: Maybe<Address>;
  /**
   * Difference between the original wire amount vs what was actually returned back due to the
   * beneficiary bank taking a fee, if applicable.
   *   - when positive, it cost more (brex loses money)
   *   - when negative, it cost less (brex makes money)
   */
  amountDriftUsdCents?: Maybe<Scalars["Int"]>;
  /** This field contains the bank provider that the transaction occured through. */
  bankProvider?: Maybe<CashTransactionBankProvider>;
  /** The sending bank's reference number for this wire (F20 of the MT103) */
  bankReferenceNumber?: Maybe<Scalars["String"]>;
  /** The counterparty's beneficiary bank information */
  beneficiaryBank?: Maybe<CashTransactionBeneficiaryBank>;
  /** The 2-character country code the wire was sent to or came from (e.g. "MX" for Mexico) */
  countryCodeAlpha2?: Maybe<Scalars["String"]>;
  /**
   * Country name this wire was sent to or came from (e.g. "Mexico")
   * If we don't have the full country name, we'll fall back to the country_code_alpha2
   */
  countryName?: Maybe<Scalars["String"]>;
  /** The email of the recipient */
  email?: Maybe<Scalars["String"]>;
  /** The associated FX quote. */
  fxQuote?: Maybe<PaymentFxQuote>;
  /** The IMAD indicates a unique number that is assigned to a transfer upon receiving at the sending financial institution */
  imad?: Maybe<Scalars["String"]>;
  /** The MT103 is a standardised SWIFT payment message used as proof of payment for cross border/international wire transfers */
  mt103?: Maybe<Scalars["String"]>;
  /** The OMAD indicates a unique number assigned to each transfer providing delivery-related information */
  omad?: Maybe<Scalars["String"]>;
  /** Whether the transaction was a debit or credit */
  paymentMethod: CashTransactionPaymentMethod;
  /** Counterparty's SWIFT code */
  swiftCode?: Maybe<Scalars["String"]>;
  /** A bank-specific tracking number */
  trackingNumber?: Maybe<Scalars["String"]>;
  /** Payment instructions */
  transferDescription?: Maybe<Scalars["String"]>;
  /** The UETR, or Unique End-to-End Transaction Reference, is a globally unique identifier used in international financial messaging standards like ISO 20022 to track and identify individual cross-border transactions. */
  uetr?: Maybe<Scalars["String"]>;
}

export interface CashTransactionInternationalWireReturnDetails {
  /** Details from the transaction this return was for */
  originalDetails: CashTransactionInternationalWireDetails;
  /**
   * For a returned wire, this is the amount of the original wire vs what
   * was actually returned back due to the beneficiary bank taking a fee.
   */
  originalTransactionAmountUsdCents?: Maybe<Scalars["Int"]>;
  /** The reason why the original transaction was returned */
  returnReason: CashTransactionWireReturnReason;
}

export interface CashTransactionIntraCuaccBookTransferDetails {
  /** The sender account */
  sourceDepositsAccount?: Maybe<DepositsAccount>;
  /** The recipient account */
  targetDepositsAccount?: Maybe<DepositsAccount>;
}

export interface CashTransactionIsFirstAchDebitResponse {
  /** true if is first outgoing ACH debit to financial_account_id, false otherwise */
  isFirstAchDebit?: Maybe<Scalars["Boolean"]>;
}

export interface CashTransactionOrderBy {
  orderField?: InputMaybe<CashTransactionOrderField>;
  orderType?: InputMaybe<OrderType>;
}

export enum CashTransactionOrderField {
  FAILED_AT = "FAILED_AT",
  INITIATED_AT = "INITIATED_AT",
  INSERTED_AT = "INSERTED_AT",
  PROCESSED_AT = "PROCESSED_AT",
  SCHEDULED_SEND_AT = "SCHEDULED_SEND_AT",
}

export enum CashTransactionOrigin {
  BREX = "BREX",
  EXTERNAL = "EXTERNAL",
  INVALID = "INVALID",
}

export interface CashTransactionOutgoingChequeDetails {
  /** The address of the recipient */
  address?: Maybe<Address>;
  /** The asset id of the optional attachment to be delivered along with the cheque. */
  attachmentAssetId?: Maybe<Scalars["String"]>;
  /** The memo found on the physical cheque */
  chequeMemo?: Maybe<Scalars["String"]>;
  /** The cheque number found on the physical cheque */
  chequeNumber?: Maybe<Scalars["Int"]>;
  /** The email of the recipient */
  email?: Maybe<Scalars["String"]>;
  /** Expected delivery date provided from our 3rd party vendor that sends the physical cheques */
  expectedDeliveryDate?: Maybe<Scalars["Date"]>;
  /** When the physical cheque was mailed at by our 3rd party vendor */
  mailedAt?: Maybe<Scalars["Time"]>;
  /** The name of the recipient. This field is used, for example, when sending a cheque */
  recipientName?: Maybe<Scalars["String"]>;
}

export interface CashTransactionOutgoingChequeReturnDetails {
  /** Details from the transaction this return was for */
  originalDetails: CashTransactionOutgoingChequeDetails;
  /** The reason why the original transaction was returned */
  returnReason: CashTransactionChequeReturnReason;
}

export interface CashTransactionPaybackDetails {
  _?: Maybe<Scalars["Boolean"]>;
}

export interface CashTransactionPayee {
  /** Contact object associated with this Transaction */
  contact?: Maybe<PaymentContact>;
  /** Payment Instrument object associated with this Transaction */
  paymentInstrument?: Maybe<PaymentInstrument>;
  /** Rail account details associated with this Transaction */
  railAccountDetails?: Maybe<RailAccountDetails>;
}

export enum CashTransactionPaymentMethod {
  CREDIT = "CREDIT",
  DEBIT = "DEBIT",
  INVALID = "INVALID",
}

export interface CashTransactionPayrollEstimateDetails {
  /** When the payroll associated with this estimate will end */
  payrollEndDate: Scalars["Date"];
  /** Name of the payroll provider (e.g. "gusto") associated with this estimate */
  payrollProviderName: Scalars["String"];
  /** When the payroll associated with this estimate started */
  payrollStartDate: Scalars["Date"];
}

export interface CashTransactionReceivablesOffersAdvanceDetails {
  _?: Maybe<Scalars["Boolean"]>;
}

export interface CashTransactionReceivablesOffersCollectionDetails {
  _?: Maybe<Scalars["Boolean"]>;
}

export interface CashTransactionReceivablesOffersRepaymentDetails {
  _?: Maybe<Scalars["Boolean"]>;
}

export interface CashTransactionRewardsRedemptionDetails {
  /** Reward points redeemed for this transaction */
  pointsRedeemed: Scalars["Int"];
}

export enum CashTransactionStatus {
  APPROVAL_REQUIRED = "APPROVAL_REQUIRED",
  DELETED = "DELETED",
  DRAFT = "DRAFT",
  FAILED = "FAILED",
  INVALID = "INVALID",
  PROCESSED = "PROCESSED",
  PROCESSING = "PROCESSING",
  SCHEDULED = "SCHEDULED",
}

export interface CashTransactionTimeline {
  /** If not NULL, when the transaction was approved. */
  approvedAt?: Maybe<Scalars["Time"]>;
  /**
   * If not NULL, this field holds the maximum estimated number of business days for a transaction to process. This is equivalent to the number of business days between `estimated_settled_at_end` and `scheduled_send_at`.
   * Useful when providing estimate times for transactions that haven't been created and don't have a specified `scheduled_send_at` date
   */
  estimatedNumberBusinessDaysMax?: Maybe<Scalars["Int"]>;
  /**
   * If not NULL, this field holds the minimum estimated number of business days for a transaction to process. This is equivalent to the number of business days between `estimated_settled_at_start` and `scheduled_send_at`.
   * Useful when providing estimate times for transactions that haven't been created and don't have a specified `scheduled_send_at` date
   */
  estimatedNumberBusinessDaysMin?: Maybe<Scalars["Int"]>;
  /**
   * A SCHEDULED or PROCESSING transaction can have an estimated settled at time range of when the
   * transaction will be settled. This field stores the end of the estimated settled time range,
   * which can hold the same value as estimated_settled_at_start when we have an estimated date
   * but not estimated date range.
   * Can be NULL when providing estimates to customers in payment flows.
   */
  estimatedSettledAtEnd?: Maybe<Scalars["Time"]>;
  /**
   * A SCHEDULED or PROCESSING transaction can have an estimated settled at time range of when
   * the transaction will be settled. If not NULL, this field stores the start of the estimated
   * settled time range. This field can be NULL if the transaction is in a terminal state, whether
   * PROCESSED or FAILED.
   * Can be NULL when providing estimates to customers in payment flows
   */
  estimatedSettledAtStart?: Maybe<Scalars["Time"]>;
  /**
   * If not NULL, when the transaction entered the FAILED status,
   * Examples include: cancelled by the user, approval denied by an admin, or failed internally.
   */
  failedAt?: Maybe<Scalars["Time"]>;
  /** The ID of the transaction, if it exists. This is used for apollo caching. */
  id?: Maybe<Scalars["ID"]>;
  /**
   * If not NULL, when the transaction entered the PROCESSING status
   * This field can always be NULL if the transaction was cancelled before it was initiated.
   */
  initiatedAt?: Maybe<Scalars["Time"]>;
  /** If not NULL, when the transaction entered the PROCESSED status and impacted the customer's balance. */
  processedAt?: Maybe<Scalars["Time"]>;
  /** When the transaction was created. */
  scheduledAt?: Maybe<Scalars["Time"]>;
  /** When the transaction is scheduled to enter the PROCESSING status. */
  scheduledSendAt?: Maybe<Scalars["Time"]>;
}

export interface CashTransactionTransactionFeesCollectionDetails {
  _?: Maybe<Scalars["Boolean"]>;
}

export enum CashTransactionType {
  ACH = "ACH",
  ACH_RETURN = "ACH_RETURN",
  ADMIN_BALANCE_ADJUSTMENT = "ADMIN_BALANCE_ADJUSTMENT",
  BILL_PAY_COLLECTION = "BILL_PAY_COLLECTION",
  BOOK_TRANSFER = "BOOK_TRANSFER",
  BREX_OPERATIONAL_TRANSFER = "BREX_OPERATIONAL_TRANSFER",
  CARD_COLLECTION = "CARD_COLLECTION",
  CHEQUE = "CHEQUE",
  CHEQUE_RETURN = "CHEQUE_RETURN",
  CRYPTO_BRIDGE = "CRYPTO_BRIDGE",
  DIVIDEND = "DIVIDEND",
  FBO_TRANSFER = "FBO_TRANSFER",
  INTEREST = "INTEREST",
  INTRA_CUSTOMER_ACCOUNT_BOOK_TRANSFER = "INTRA_CUSTOMER_ACCOUNT_BOOK_TRANSFER",
  INVALID = "INVALID",
  PAYBACK = "PAYBACK",
  PAYROLL_ESTIMATE = "PAYROLL_ESTIMATE",
  RECEIVABLES_OFFERS_ADVANCE = "RECEIVABLES_OFFERS_ADVANCE",
  RECEIVABLES_OFFERS_COLLECTION = "RECEIVABLES_OFFERS_COLLECTION",
  RECEIVABLES_OFFERS_REPAYMENT = "RECEIVABLES_OFFERS_REPAYMENT",
  REIMBURSEMENT_COLLECTION = "REIMBURSEMENT_COLLECTION",
  REWARDS_REDEMPTION = "REWARDS_REDEMPTION",
  TRANSACTION_FEES_COLLECTION = "TRANSACTION_FEES_COLLECTION",
  WIRE = "WIRE",
  WIRE_RETURN = "WIRE_RETURN",
}

export enum CashTransactionWireReturnReason {
  BENEFICIARY_ACCOUNT_CLOSED = "BENEFICIARY_ACCOUNT_CLOSED",
  BENEFICIARY_ACCOUNT_FROZEN = "BENEFICIARY_ACCOUNT_FROZEN",
  BENEFICIARY_NOT_FOUND = "BENEFICIARY_NOT_FOUND",
  BENEFICIARY_RAIL_UNSUPPORTED = "BENEFICIARY_RAIL_UNSUPPORTED",
  BLOCKED_BY_FRAUD = "BLOCKED_BY_FRAUD",
  BLOCKED_BY_OFAC = "BLOCKED_BY_OFAC",
  DEADLINE_PASSED = "DEADLINE_PASSED",
  DUPLICATE_ENTRY = "DUPLICATE_ENTRY",
  INCORRECT_PAYMENT_DETAILS = "INCORRECT_PAYMENT_DETAILS",
  INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
  INVALID = "INVALID",
  INVALID_BENEFICIARY_ACCOUNT_NUMBER = "INVALID_BENEFICIARY_ACCOUNT_NUMBER",
  INVALID_BENEFICIARY_ATTRIBUTES = "INVALID_BENEFICIARY_ATTRIBUTES",
  INVALID_BENEFICIARY_ROUTING_NUMBER = "INVALID_BENEFICIARY_ROUTING_NUMBER",
  INVALID_TRANSFER_STATUS = "INVALID_TRANSFER_STATUS",
  ORIGINATOR_REQUESTED_RETURN = "ORIGINATOR_REQUESTED_RETURN",
  TRANSFER_INVALID_AMOUNT = "TRANSFER_INVALID_AMOUNT",
  TRANSFER_INVALID_CURRENCY = "TRANSFER_INVALID_CURRENCY",
  TRANSFER_NOT_AUTHORIZED = "TRANSFER_NOT_AUTHORIZED",
  TRANSFER_NOT_FOUND = "TRANSFER_NOT_FOUND",
  UNKNOWN = "UNKNOWN",
}

export interface Cashflow {
  currentMonthCashInflows: Scalars["Long"];
  currentMonthCashOutflows: Scalars["Long"];
}

export interface Category extends Node {
  customerAccount?: Maybe<Account>;
  id: Scalars["ID"];
  name: Scalars["String"];
}

/** A Category connection for Category pagination. */
export interface CategoryConnection extends Connection {
  /** The categories in the current page of results. */
  edges: Array<CategoryEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of categories matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

/** A Category edge for the Category connection. */
export interface CategoryEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The Category at this edge. */
  node?: Maybe<Category>;
}

/** Filters available to control which categories get returned. */
export interface CategoryFilterInput {
  /** Match IN specific category ids, match ALL when no filter is provided */
  categoryIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Match IN specific category names */
  categoryNames?: InputMaybe<Array<Scalars["String"]>>;
  /** Match IN specific accounts */
  customerAccountIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Match IN specific parent category ids */
  parentCategoryIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Match IN specific statuses, match ALL when no filter is provided */
  status?: InputMaybe<Array<CategoryStatus>>;
}

/** Determines the order that the categories will be returned. */
export interface CategoryOrderInput {
  field: SortableCategoryField;
  order: OrderByDirection;
}

/** The status of the category. */
export enum CategoryStatus {
  /** An active category */
  ACTIVE = "ACTIVE",
  /** A deduplicated category */
  DEDUPLICATED = "DEDUPLICATED",
  /** A deleted category */
  DELETED = "DELETED",
}

export interface Cell {
  column: Scalars["String"];
  value: CellValue;
}

export interface CellTextValue {
  value: Scalars["String"];
}

export type CellValue = CellTextValue | User;

export interface Change {
  after: Scalars["String"];
  before: Scalars["String"];
  key: Scalars["String"];
}

export interface ChangeEmailOperationError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface ChangeInvestmentPolicyInput {
  amount: Scalars["Int"];
  clientMutationId: Scalars["String"];
  depositsAccountId: Scalars["ID"];
  investmentType: InvestmentType;
}

export interface ChangeInvestmentPolicyPayload {
  clientMutationId: Scalars["String"];
}

export interface Channel extends Node {
  /** fetch the channel preferences related to this channel */
  channelPreferences?: Maybe<ChannelPreferences>;
  /** The ID of an object */
  id: Scalars["ID"];
  notificationSubscriptions?: Maybe<NotificationSubscriptionConnection>;
  options?: Maybe<ChannelOptions>;
  status?: Maybe<ChannelStatus>;
  type: ChannelType;
}

export interface ChannelnotificationSubscriptionsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

export interface ChannelAlertOptions {
  unused?: Maybe<Scalars["Int"]>;
}

export interface ChannelConnection {
  edges: Array<ChannelEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"];
}

export interface ChannelEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<Channel>;
}

export interface ChannelEmailOptions {
  email?: Maybe<Scalars["Email"]>;
}

export interface ChannelFilters {
  statuses?: InputMaybe<Array<ChannelStatus>>;
  types?: InputMaybe<Array<ChannelType>>;
}

export type ChannelOptions =
  | ChannelAlertOptions
  | ChannelEmailOptions
  | ChannelPushOptions
  | ChannelSlackOptions
  | ChannelSmsOptions
  | ChannelVoiceOptions;

export interface ChannelPreferences extends Node {
  /** The ID of an object */
  id: Scalars["ID"];
  medium?: Maybe<Medium>;
}

export interface ChannelPushOptions {
  deviceInformation?: Maybe<DeviceInformation>;
  deviceToken?: Maybe<Scalars["String"]>;
  type?: Maybe<PushProviderType>;
}

export interface ChannelSlackOptions {
  chatUserId?: Maybe<Scalars["String"]>;
}

export interface ChannelSmsOptions {
  number?: Maybe<Scalars["PhoneNumber"]>;
}

export enum ChannelStatus {
  DISABLED = "DISABLED",
  PENDING_VERIFICATION = "PENDING_VERIFICATION",
  READY = "READY",
}

export enum ChannelType {
  ALERT = "ALERT",
  EMAIL = "EMAIL",
  INVALID = "INVALID",
  PUSH = "PUSH",
  SLACK = "SLACK",
  SMS = "SMS",
}

/** Subscription information about a channel type */
export interface ChannelTypeInfo {
  /** The channel type */
  channelType: ChannelType;
  /** Boolean indicated whether the customer can control the subscribed status */
  subscribable: Scalars["Boolean"];
  /** Boolean indicating whether the channel type is subscribed or not */
  subscribed: Scalars["Boolean"];
}

export interface ChannelVoiceOptions {
  number?: Maybe<Scalars["String"]>;
}

/** Chat support channel. Specific flags to WhatsApp and default Chat */
export interface Chat {
  /** Default chat specific flag */
  chatEnabled?: Maybe<Scalars["Boolean"]>;
  /** Support channel flag */
  enabled?: Maybe<Scalars["Boolean"]>;
  /** Service level agreement for this support channel */
  sla?: Maybe<Scalars["Int"]>;
  /** WhatsApp specific flag */
  whatsappEnabled?: Maybe<Scalars["Boolean"]>;
}

export interface CheckPaymentInstrumentInput {
  address?: InputMaybe<AddressInput>;
  recipientName: Scalars["String"];
}

export interface CheckingAccount extends BankingAccount, Node {
  accountNumber?: Maybe<CheckingAccountNumber>;
  balance?: Maybe<BankingAccountBalance>;
  cashflow?: Maybe<BankingAccountCashflow>;
  displayName?: Maybe<Scalars["String"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
  priority?: Maybe<BankingAccountPriority>;
  routingNumber?: Maybe<Scalars["String"]>;
  status?: Maybe<BankingAccountStatus>;
}

export interface CheckingAccountcashflowArgs {
  endTime: Scalars["Time"];
  startTime: Scalars["Time"];
}

export interface CheckingAccountNumber {
  full?: Maybe<Scalars["String"]>;
  lastFour?: Maybe<Scalars["String"]>;
}

/** Object defining the total and remaining cheque deposit */
export interface ChequeDepositLimits {
  /** The remaining limit available for making cheque deposits */
  chequeDepositRemainingLimitUsdCents: Scalars["Int"];
  /** The total limit definited for cheque deposits */
  chequeDepositTotalLimitUsdCents: Scalars["Int"];
}

export enum ChequeImageValidationErrorSeverity {
  ERROR = "ERROR",
  IGNORE = "IGNORE",
  WARNING = "WARNING",
}

export enum ChequeImageValidationType {
  BACK_ONLY = "BACK_ONLY",
  FRONT_AND_BACK = "FRONT_AND_BACK",
  FRONT_ONLY = "FRONT_ONLY",
}

export interface ChequePaymentInstrument {
  address?: Maybe<Address>;
  recipientName?: Maybe<Scalars["String"]>;
}

export interface ChequePaymentInstrumentFindInput {
  address: AddressInput;
  recipientName: Scalars["String"];
}

export interface ChequePaymentInstrumentInput {
  address: AddressInput;
  recipientName: Scalars["String"];
}

export interface ChequeTransferDetails {
  attachmentAssetId?: Maybe<Scalars["String"]>;
  expectedDeliveryDate?: Maybe<Scalars["Time"]>;
  number?: Maybe<Scalars["String"]>;
  returnDetails?: Maybe<ReturnDetails>;
}

export interface Citation {
  /** Positions of the citation in the text. */
  citationPositions: Array<CitationPosition>;
  /** index of the citation e.g. [1], [2] */
  index: Scalars["Int"];
  /** Name describing the citation. */
  name: Scalars["String"];
}

export type CitationPosition = CitationPositionTextOffset;

export interface CitationPositionTextOffset {
  /** Citation position is described as the offset from the start of the text */
  textOffset?: Maybe<Scalars["Int"]>;
}

export type CitationSource = CitationSourcePolicy | CitationSourceSpendLimit;

export interface CitationSourcePolicy {
  /**
   * "
   * Sections of the policy that are cited
   */
  citations: Array<PolicySectionCitation>;
  /** ID of the policy referred to */
  policy: Policy;
}

export interface CitationSourceSpendLimit {
  /**
   * "
   * Sections of the spend limit that are cited
   */
  citations: Array<SpendLimitCitation>;
  /** Legacy budget id */
  spendLimit: Budget;
}

export enum Class {
  BUSINESS = "BUSINESS",
  PERSONAL = "PERSONAL",
}

export interface Clawback {
  /** The unique clawback expense that the clawback is related to. */
  clawbackExpense?: Maybe<Expense>;
  /** User that created this clawback */
  createdByEmployee: Employee;
  /** The unique ID of the clawback */
  id: Scalars["ID"];
  /** The time when the clawback was inserted into db */
  insertedAt: Scalars["Time"];
  /** The unique original expense that the clawback is related to. */
  originalExpense: Expense;
  /** Optional reasoning for why the Clawback payment failed */
  paymentFailureReason?: Maybe<ClawbackPaymentFailureReason>;
  /** Optional reasoning for why the Clawback was initiated */
  reason?: Maybe<Scalars["String"]>;
  /** The time when the clawback was last updated */
  updatedAt: Scalars["Time"];
}

export interface ClawbackHealth {
  clawbackHealthStatus: ClawbackHealthStatus;
  clawbackHealthStatusDetail: ClawbackHealthStatusDetail;
  clawbackHealthStatusDetails: Array<ClawbackHealthStatusDetail>;
}

export enum ClawbackHealthStatus {
  BLOCKED = "BLOCKED",
  INVALID = "INVALID",
  NORMAL = "NORMAL",
}

export enum ClawbackHealthStatusDetail {
  INTERNATIONAL_ACCOUNT = "INTERNATIONAL_ACCOUNT",
  INTERNATIONAL_EXPENSE = "INTERNATIONAL_EXPENSE",
  INVALID = "INVALID",
  MARK_AS_PAID_ONLY = "MARK_AS_PAID_ONLY",
  NONE = "NONE",
  NO_DESTINATION = "NO_DESTINATION",
  NO_SOURCE = "NO_SOURCE",
  PERSONAL_ACCOUNT_NOT_VERIFIED = "PERSONAL_ACCOUNT_NOT_VERIFIED",
  PUP_EDD_NEEDED = "PUP_EDD_NEEDED",
  RISK_TIER_TOO_HIGH = "RISK_TIER_TOO_HIGH",
}

export enum ClawbackPaymentFailureReason {
  CANCELLED = "CANCELLED",
  COMPANY_ACCOUNT_CLOSED = "COMPANY_ACCOUNT_CLOSED",
  COMPANY_ACCOUNT_NOT_FOUND = "COMPANY_ACCOUNT_NOT_FOUND",
  COMPANY_ACCOUNT_OTHER = "COMPANY_ACCOUNT_OTHER",
  COMPANY_ACCOUNT_UNAUTHORIZED = "COMPANY_ACCOUNT_UNAUTHORIZED",
  EMPLOYEE_ACCOUNT_CLOSED = "EMPLOYEE_ACCOUNT_CLOSED",
  EMPLOYEE_ACCOUNT_INSUFFICIENT_FUNDS = "EMPLOYEE_ACCOUNT_INSUFFICIENT_FUNDS",
  EMPLOYEE_ACCOUNT_NOT_FOUND = "EMPLOYEE_ACCOUNT_NOT_FOUND",
  EMPLOYEE_ACCOUNT_OTHER = "EMPLOYEE_ACCOUNT_OTHER",
  EMPLOYEE_ACCOUNT_UNAUTHORIZED = "EMPLOYEE_ACCOUNT_UNAUTHORIZED",
  FRAUD_CHECK = "FRAUD_CHECK",
  INVALID = "INVALID",
}

export interface ClearRecentSearchesInput {
  /** If the recent search is local, specifies which instantiationId history should be cleared. */
  instantiationId?: InputMaybe<Scalars["String"]>;
  /** Specifies the type of the recent search history to delete. */
  type: RecentSearchType;
}

export interface ClientError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

/** Represents the FSP that a client has connected or has a pending connection to */
export interface ClientFSPAccount {
  connectedUsers: Array<User>;
  description: Scalars["String"];
  detailsLink: Scalars["String"];
  fspCustomerAccountId: Scalars["ID"];
  logoLink: Scalars["String"];
  name: Scalars["String"];
  status: FspConnectionStatus;
}

export type ClosingStrategy =
  | BiweeklyClosingStrategy
  | EveryNDaysClosingStrategy
  | MonthlyClosingStrategy
  | SemiMonthlyClosingStrategy
  | SemiWeeklyClosingStrategy
  | WeeklyClosingStrategy;

export enum ClosureStatus {
  COMPLETE = "COMPLETE",
  NOT_STARTED = "NOT_STARTED",
  REFUND_PROCESSING = "REFUND_PROCESSING",
}

export interface CoInformationInput {
  relationship: KYCIdentityIndividualTitle;
}

/** Value Added Service for Coaching Payload */
export interface CoachingOfferPayloadV2 {
  /** Dummy field since graphql cannot handle empty payloads. */
  dummyField?: Maybe<Scalars["String"]>;
}

export interface Cobranding {
  enabled?: Maybe<Scalars["Boolean"]>;
  fullName?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
}

/** Payload for Codat tracking categories */
export interface CodatTrackingCategory {
  /** Category name imported from Codat */
  categoryName?: Maybe<Scalars["String"]>;
  /** Is marked inactive on Codat side */
  isInactive?: Maybe<Scalars["Boolean"]>;
}

export interface CohortSegment {
  key: Scalars["String"];
}

export interface CollectDocumentsRequestConfig {
  /** Documents the user must submit */
  requiredDocuments: Array<VerificationDocumentType>;
}

/** Input for specifying a collect funding source */
export interface CollectFundingSourceInput {
  collectFundingSourceId: Scalars["String"];
}

export interface CollectionAttempt extends Node {
  amount?: Maybe<Scalars["Int"]>;
  collectionDate?: Maybe<Scalars["Time"]>;
  collectionIntention?: Maybe<CollectionIntention>;
  errorCode?: Maybe<Scalars["String"]>;
  /** @deprecated Switch to v2 version of field including new `non_transaction_account` member */
  failureType?: Maybe<CardPaymentFailureType>;
  failureTypeV2?: Maybe<CardPaymentFailureTypeV2>;
  failureTypeV3?: Maybe<CardPaymentFailureTypeV3>;
  fundingSource?: Maybe<FundingSource>;
  /** The ID of an object */
  id: Scalars["ID"];
  originatorId?: Maybe<Scalars["String"]>;
  originatorType?: Maybe<Scalars["String"]>;
  peekDetails?: Maybe<CollectionAttemptPeekDetails>;
  presentCollectionIntentionId?: Maybe<Scalars["String"]>;
  providerCollectionId?: Maybe<Scalars["String"]>;
  providerName?: Maybe<Scalars["String"]>;
  scheduledDate?: Maybe<Scalars["Time"]>;
  statement?: Maybe<LegacyCardStatementPeriodBoundaries>;
  status?: Maybe<Scalars["String"]>;
}

export interface CollectionAttemptConnection {
  edges?: Maybe<Array<Maybe<CollectionAttemptEdge>>>;
  pageInfo: PageInfo;
}

export interface CollectionAttemptEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<CollectionAttempt>;
}

export interface CollectionAttemptPeekDetails {
  /** Journal Entries approximately leading to this payment attempt */
  cardTransactionJournalEntries: Array<Maybe<JournalEntry>>;
  periodEndTime: Scalars["Time"];
  periodStartTime?: Maybe<Scalars["Time"]>;
}

export interface CollectionAttemptPeekDetailscardTransactionJournalEntriesArgs {
  limit: Scalars["Int"];
}

export enum CollectionFrequency {
  ANNUAL = "ANNUAL",
  MONTHLY = "MONTHLY",
  NOT_APPLICABLE = "NOT_APPLICABLE",
  QUARTERLY = "QUARTERLY",
  SEMI_ANNUAL = "SEMI_ANNUAL",
}

export interface CollectionIntention extends Node {
  amount?: Maybe<Scalars["Int"]>;
  collectedAt?: Maybe<Scalars["Time"]>;
  collectionAttempts?: Maybe<CollectionAttemptConnection>;
  customerAccountId?: Maybe<Scalars["String"]>;
  fundingSource?: Maybe<FundingSource>;
  /** The ID of an object */
  id: Scalars["ID"];
  initiator?: Maybe<User>;
  insertedAt?: Maybe<Scalars["Time"]>;
  originatorType?: Maybe<Scalars["String"]>;
  scheduledForDate?: Maybe<Scalars["Time"]>;
  status?: Maybe<Scalars["String"]>;
}

export interface CollectionIntentioncollectionAttemptsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

export interface CollectionIntentionConnection {
  edges?: Maybe<Array<Maybe<CollectionIntentionEdge>>>;
  pageInfo: PageInfo;
}

export interface CollectionIntentionEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<CollectionIntention>;
}

/**
 * Collection Mode
 * INVALID and UNRECOGNIZED are mapped to null
 */
export enum CollectionMode {
  AUTO_COLLECTION = "AUTO_COLLECTION",
  DISABLED = "DISABLED",
  LOCAL_COLLECTION = "LOCAL_COLLECTION",
}

/** Represents a Collection */
export interface CollectionPromise {
  amount: FinancialAsset;
  id: Scalars["ID"];
  initiatedAt?: Maybe<Scalars["Time"]>;
  initiatedBy?: Maybe<CollectionPromiseInitiatedBy>;
  isCollectedFromParentEntity?: Maybe<Scalars["Boolean"]>;
  legacyId?: Maybe<Scalars["ID"]>;
  originatorType: CollectionPromiseOriginatorType;
  ownerType?: Maybe<CollectionPromiseOwnerType>;
  scheduledFor: Scalars["Time"];
  status: CollectionPromiseStatus;
  succeededAt?: Maybe<Scalars["Time"]>;
}

export interface CollectionPromiseConnection extends Connection {
  /** The collection promises in the current page of results. */
  edges: Array<CollectionPromiseEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of collection promises matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface CollectionPromiseEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The collection promise at this edge. */
  node: CollectionPromise;
}

export interface CollectionPromiseFilterInput {
  /** When true, inverts the filter logic (returns items that don't match the predicate) */
  negate?: InputMaybe<Scalars["Boolean"]>;
  /** Filter predicates - multiple fields are combined with AND logic */
  predicate?: InputMaybe<CollectionPromiseFilterPredicateInput>;
}

/**
 * Filter predicate input for collection promises.
 * Every field is implicitly AND-ed together if multiple are specified.
 * For example, if ownerTypes and statuses are both specified, the filter would be (ownerTypes AND statuses).
 * When a filter is not provided, it matches all values for that field.
 */
export interface CollectionPromiseFilterPredicateInput {
  /** Match collection promises for specific legal entities (IN operation) */
  legalEntityIds?: InputMaybe<Array<Scalars["String"]>>;
  /** Match collection promises with specific owner ids (IN operation) */
  ownerIds?: InputMaybe<Array<Scalars["String"]>>;
  /** Match collection promises with specific owner types (IN operation) */
  ownerTypes?: InputMaybe<Array<CollectionPromiseOwnerType>>;
  /** Match collection promises scheduled within a specific date/time range */
  scheduledForDatetime?: InputMaybe<TimeIntervalInput>;
  /** Match collection promises with specific statuses (IN operation) */
  statuses?: InputMaybe<Array<CollectionPromiseStatus>>;
}

export type CollectionPromiseInitiatedBy =
  | CollectionPromiseInitiatedByBrex
  | CollectionPromiseInitiatedByExternalCounterparty
  | CollectionPromiseInitiatedByUser;

/** Indicates that a collection was started by an internal agent from Brex or its systems */
export interface CollectionPromiseInitiatedByBrex {
  /** This field is here to allow for an "empty" type */
  _?: Maybe<Scalars["Boolean"]>;
}

/** Indicates that a collection was started by an external counterparty (eg. a push payment) */
export interface CollectionPromiseInitiatedByExternalCounterparty {
  accountHolderName?: Maybe<Scalars["String"]>;
}

/** Indicates that a collection was started by the customer */
export interface CollectionPromiseInitiatedByUser {
  user?: Maybe<User>;
}

/**
 * Specifies the sorting criteria for collection promises.
 * Multiple sort criteria can be applied to achieve complex sorting requirements.
 */
export interface CollectionPromiseOrderInput {
  /** The direction to sort (ascending or descending) */
  direction: OrderByDirection;
  /** The field to sort by */
  field: CollectionPromiseSortableField;
}

export enum CollectionPromiseOriginatorType {
  /** Trigered by automated recovery */
  AUTOMATED_RECOVERY = "AUTOMATED_RECOVERY",
  /** Trigered by autocollection */
  BILL_AUTO_COLLECTION = "BILL_AUTO_COLLECTION",
  /** Needed for one-off issue BIB-2032 */
  BREX_INTERNAL_ONE_OFF_PAYOUT = "BREX_INTERNAL_ONE_OFF_PAYOUT",
  /** Trigered by internal user (Retool) */
  BREX_INTERNAL_USER = "BREX_INTERNAL_USER",
  /** Trigered by internal user (Retool) */
  BREX_INTERNAL_USER_PAYOUT = "BREX_INTERNAL_USER_PAYOUT",
  /** Card account type conversion (Transactional Float -> Traditional Charge) */
  CARD_ACCOUNT_TYPE_CONVERSION = "CARD_ACCOUNT_TYPE_CONVERSION",
  /** Trigered by user (Dashboard) */
  CUSTOMER_USER = "CUSTOMER_USER",
  /** Deprecated */
  FUNDING_SOURCE_VERIFICATION = "FUNDING_SOURCE_VERIFICATION",
  /** Triggered by the user retrying a funding source verification */
  FUNDING_SOURCE_VERIFICATION_RETRY = "FUNDING_SOURCE_VERIFICATION_RETRY",
  /** Trigered by early pay */
  LIMIT_BASED_EARLY_AUTO_COLLECTION = "LIMIT_BASED_EARLY_AUTO_COLLECTION",
}

export enum CollectionPromiseOwnerType {
  /** Promise related to bill pay collections */
  BILL_PAY_BILLING = "BILL_PAY_BILLING",
  /** Promise owned by the card billing */
  CARD_BILLING = "CARD_BILLING",
  /** Promise owned by the reimbursement billing */
  REIMBURSEMENT_BILLING = "REIMBURSEMENT_BILLING",
  /** Psromise related to transaction fees */
  TRANSACTION_FEES = "TRANSACTION_FEES",
}

/**
 * Specifies which field to sort collection promises by.
 * This enum can be extended to support additional sortable fields in the future.
 */
export enum CollectionPromiseSortableField {
  /** Sort by the scheduled date/time of the collection promise */
  SCHEDULED_FOR_DATETIME = "SCHEDULED_FOR_DATETIME",
}

/** The status of the collection promise. */
export enum CollectionPromiseStatus {
  /** Payment canceled before initation */
  CANCELED = "CANCELED",
  /** Payment failed */
  FAILED = "FAILED",
  INVALID = "INVALID",
  /** Payment initiated but not settled */
  IN_PROGRESS = "IN_PROGRESS",
  /** Payment completed then reversed */
  REVERSED = "REVERSED",
  /** Payment not initiated */
  SCHEDULED = "SCHEDULED",
  /** Payment successfully completed */
  SUCCEEDED = "SUCCEEDED",
}

/** Response that includes the combined staleness and the entities that need to notified for for staleness */
export interface CombinedStaleness {
  campaignStage?: Maybe<CampaignStage>;
  combinedStalenessDays: Scalars["Int"];
  deadlineDate?: Maybe<Scalars["Time"]>;
  shouldAlertServicingTeam?: Maybe<Scalars["Boolean"]>;
  shouldSendEmail?: Maybe<Scalars["Boolean"]>;
  shouldSendSms?: Maybe<Scalars["Boolean"]>;
  shouldShowBanner?: Maybe<Scalars["Boolean"]>;
  shouldShowPaywall?: Maybe<Scalars["Boolean"]>;
  staleSources: Array<StaleSource>;
}

export interface CombinedTermsRequestConfig {
  requiredAgreements: Array<TermsAgreementType>;
  requiresBackupWithholding: Scalars["Boolean"];
  requiresCertifications: Scalars["Boolean"];
}

export interface CombinedTermsSubmissionPayloadInput {
  /** The attestations & terms & conditions the customer agreed to */
  agreements: Array<TermsAgreementInput>;
  /** The certifications needed to apply for Cash */
  cashCertifications?: InputMaybe<CashCertificationsInput>;
  /** If the company is subject to backup withholding. Required for Cash. */
  subjectToBackupWithholding?: InputMaybe<Scalars["Boolean"]>;
}

/** A Comment. */
export interface Comment extends Node {
  /** Author of the Comment. NULL for Brex Assistant Comment. */
  authorEmployee?: Maybe<Employee>;
  /**
   * Users that were given explicit authorization to view the CommentThread and its related entity through the Comment.
   * Also includes details if the authorization was later deleted, and by whom.
   */
  authorizations?: Maybe<Array<CommentEntityAuthorization>>;
  /**
   * Users that were given explicit authorization to view the CommentThread and its related entity through the Comment.
   * @deprecated This field is deprecated and will not include deleted authorizations. Use authorizations field instead.
   */
  authorizedEmployees?: Maybe<Array<AuthorizedEmployee>>;
  /** Whether this comment comes from normal user input or a reminder. */
  commentSource?: Maybe<CommentSource>;
  /** Text contents of the Comment, NULL if the Comment was deleted. */
  commentText?: Maybe<Scalars["String"]>;
  /** CommentThread that this Comment belongs to. */
  commentThread?: Maybe<CommentThread>;
  /** Timestamp when the Comment was created. */
  createdAt: Scalars["Time"];
  /** The ID of an object */
  id: Scalars["ID"];
  /** Delegator of the comment's author. */
  onBehalfOfEmployee?: Maybe<Employee>;
  /** The Requests for response associated with the Comment */
  requests?: Maybe<Array<CommentRequest>>;
  /** Tagged users. */
  taggedEmployees?: Maybe<Array<TaggedEmployee>>;
  /** Unformatted text contents of the Comment, can be used by frontend to render comment tags, NULL if the Comment was deleted. */
  unformattedCommentText?: Maybe<Scalars["String"]>;
}

/** Suggestion to add a comment as the entity memo. */
export interface CommentAddMemoSuggestion {
  /** ID of the comment to attach the suggestion to. */
  commentId: Scalars["ID"];
}

/** A comment connection for Comment pagination. */
export interface CommentConnection extends Connection {
  /** The requests in the current page of results. */
  edges: Array<CommentEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of Comments matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

/** A Comment edge for Comment pagination. */
export interface CommentEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The Comment at this edge. */
  node?: Maybe<Comment>;
}

export interface CommentEntityAuthorization {
  /** The Employee in which the authorization was granted to. */
  authorizedEmployee: Employee;
  /** When the authorization was removed, if removed */
  deletedAt?: Maybe<Scalars["Time"]>;
  /** Who removed the authorization, if removed */
  deletedBy?: Maybe<Employee>;
  id: Scalars["ID"];
  /** When the authorization was granted */
  insertedAt: Scalars["Time"];
  /** Who created the authorization */
  insertedBy?: Maybe<Employee>;
}

export enum CommentExternalEntityAccessLevel {
  /**
   * User does not have full or read-only access, but the tagging user has permission to grant this user read-only
   * authorization to the thread/entity and will do so if they submit a comment tagging them. Only available in the
   * context of a user being tagged.
   */
  AUTHORIZABLE = "AUTHORIZABLE",
  /** User has full access to the comment entity */
  FULL = "FULL",
  /** User cannot view the comment entity */
  NONE = "NONE",
  /** User has read-only access to the comment entity, granted through a Comment tag */
  READ_ONLY = "READ_ONLY",
}

/** Specifies the type of entity that the comment CommentThread is associated with. */
export enum CommentExternalEntityType {
  /** CommentThread is associated with a budget limit increase request entity. */
  BUDGET_LIMIT_INCREASE_REQUEST_ENTITY = "BUDGET_LIMIT_INCREASE_REQUEST_ENTITY",
  /** CommentThread is associated with a budget request entity. */
  BUDGET_REQUEST_ENTITY = "BUDGET_REQUEST_ENTITY",
  /** CommentThread is associated with an expense. */
  EXPENSE = "EXPENSE",
  /** CommentThread is associated with a group event. */
  GROUP_EVENT = "GROUP_EVENT",
  /**
   * CommentThread is associated with a insight.
   * @deprecated Insights feature has been deprecated
   */
  INSIGHT = "INSIGHT",
  /** CommentThread is associated with a limit source increase request. */
  LIMIT_SOURCE_INCREASE_REQUEST = "LIMIT_SOURCE_INCREASE_REQUEST",
}

export enum CommentFeatureFlag {
  /** Whether to show info about Tasks related to Comments */
  COMMENTING_TASK_INBOX = "COMMENTING_TASK_INBOX",
  /** Whether to show granting permissions for entities related to Comments */
  COMMENTING_TASK_PERMISSIONS = "COMMENTING_TASK_PERMISSIONS",
}

export interface CommentFeatureFlagInput {
  /** The feature flag to evaluate against. */
  featureFlag: CommentFeatureFlag;
}

export interface CommentMutationError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

/** A comment request. */
export interface CommentRequest extends Request {
  /**
   * Fetch actions on the Request.
   * Can be filtered e.g. to select only pending actions
   */
  actions?: Maybe<RequestActionConnection>;
  /** User that canceled the request */
  canceledBy?: Maybe<Employee>;
  /** The compliance status for the request */
  complianceStatus?: Maybe<ComplianceStatus>;
  /** When the request was created. */
  createdAt: Scalars["Time"];
  /** The employee who initiated the request. */
  createdBy?: Maybe<Employee>;
  /** The compliance status for the request that is derived from the submitter and reviewer compliance statuses. */
  derivedComplianceStatus?: Maybe<DerivedComplianceStatus>;
  /** The unique ID of the request */
  id: Scalars["ID"];
  /** If the Request was manually resolved by the user, this field is populated with the associated timestamp */
  manuallyResolvedAt?: Maybe<Scalars["Time"]>;
  /** The timestamp when a controller overridden the request */
  overriddenAt?: Maybe<Scalars["Time"]>;
  /** The employee who overridden the request. */
  overriddenBy?: Maybe<Employee>;
  /** User id being co-piloted when this request was overridden. */
  overriddenOnBehalfOf?: Maybe<Employee>;
  /** The employee who owns the request. */
  owner?: Maybe<Employee>;
  /**
   * The user who initiated the request
   * @deprecated Incorrect permission scoping, use requestedByEmployee instead
   */
  requestedBy?: Maybe<User>;
  /**
   * The employee who initiated the request
   * @deprecated Not clear whether this is owner or creator of request after copilot context was introduced, use owner instead
   */
  requestedByEmployee?: Maybe<Employee>;
  /** The reviewer compliance status for the request. */
  reviewerComplianceStatus?: Maybe<ComplianceStatus>;
  /** The timestamp when reviewer compliance deadline will be reached */
  reviewerDeadlineAt?: Maybe<Scalars["Time"]>;
  /** The stage of approval of the request, e.g. created, approved, denied */
  status?: Maybe<RequestStatus>;
  /** The timestamp when the submitter compliance deadline will be reached */
  submitterDeadlineAt?: Maybe<Scalars["Time"]>;
  /** Will always be COMMENT for a CommentRequest */
  type?: Maybe<RequestType>;
}

/** A comment request. */
export interface CommentRequestactionsArgs {
  filter?: InputMaybe<RequestActionFilterInput>;
  order?: InputMaybe<RequestActionOrderInput>;
  page?: InputMaybe<PaginationInput>;
}

export interface CommentResponseTaskEntityDetails
  extends InboxTaskEntityDetails {
  /** Base64 encoded comment thread ID. */
  encodedEntityId: Scalars["String"];
  /** The comment thread ID in which a response is required on. */
  entityId: Scalars["String"];
  /** The associated expense if the Comment external entity type is EXPENSE */
  expense?: Maybe<Expense>;
  /** The level of access the user has to the related Comment entity */
  externalEntityAccessLevel: CommentExternalEntityAccessLevel;
  /** The encoded ID for the external entity (e.g. expense, budget..) related to the comment thread */
  externalEntityId: Scalars["ID"];
  /** Type of entity that the Comment is associated with. */
  externalEntityType: CommentExternalEntityType;
  /** The ID of the trip associated with the Task, only applicable to GROUP_EVENT comment entities */
  tripId?: Maybe<Scalars["ID"]>;
}

/** Suggestion to send a comment reminder. */
export interface CommentSendReminderSuggestion {
  /** Text to be displayed with this suggestion, dictating what to expose. */
  commentText: Scalars["String"];
  /** Timestamp at which the last reminder was sent, if any. */
  lastReminderSentAt?: Maybe<Scalars["Time"]>;
  /** Tagged users. */
  taggedEmployees?: Maybe<Array<TaggedEmployee>>;
  /** Unformatted text contents of the Comment, can be used to render comment tags */
  unformattedCommentText?: Maybe<Scalars["String"]>;
}

/** Specifies which source triggered this comment. */
export enum CommentSource {
  /** Comment comes from Brex Assistant. */
  BREX_ASSISTANT = "BREX_ASSISTANT",
  /** Comment comes from normal user input. */
  DEFAULT = "DEFAULT",
  /** Comment comes from a reminder suggestion. */
  REMINDER_SUGGESTION = "REMINDER_SUGGESTION",
}

export type CommentSuggestion =
  | CommentAddMemoSuggestion
  | CommentSendReminderSuggestion;

export interface CommentSuggestionsInput {
  /** External Entity ID to which these suggestions apply. */
  externalEntityId: Scalars["ID"];
  /** External Entity Type to which these suggestions apply. */
  externalEntityType: CommentExternalEntityType;
}

export interface CommentSuggestionsResult {
  /** External Entity ID to which these suggestions apply. */
  externalEntityId: Scalars["ID"];
  /** External Entity Type to which these suggestions apply. */
  externalEntityType: CommentExternalEntityType;
  /** List of suggestions. */
  suggestions?: Maybe<Array<CommentSuggestion>>;
}

/** A CommentThread. */
export interface CommentThread extends Node {
  /** Fetch comments on the CommentThread. */
  comments: CommentConnection;
  /** The level of access that the requesting user has for the associated entity. */
  externalEntityAccessLevel?: Maybe<CommentExternalEntityAccessLevel>;
  /** Type of entity that the CommentThread is associated with. */
  externalEntityType: CommentExternalEntityType;
  /** Indicates if the current user (or their delegator) has any pending comment tasks in this thread. */
  hasPendingCommentTasks?: Maybe<Scalars["Boolean"]>;
  /**
   * Whether the user in context has permission to create or remove CommentEntityAuthorization's for this thread.
   * Authorizations provide the given user with read-only access to the related entity and its Comments.
   */
  hasPermissionToUpdateAuthorizations?: Maybe<Scalars["Boolean"]>;
  /** The ID of an object */
  id: Scalars["ID"];
}

/** A CommentThread. */
export interface CommentThreadcommentsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  order?: InputMaybe<CommentsOrderInput>;
  page?: InputMaybe<PaginationInput>;
}

/** Determines the order that the Comments will be returned. */
export interface CommentsOrderInput {
  field: SortableCommentField;
  order: OrderByDirection;
}

export interface CommitDraftFieldsInput {
  /** The draft Id of the drafts to commit */
  draftId: Scalars["String"];
}

export interface CommitDraftFieldsMutationError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

/** Response of commiting draft fields */
export interface CommitDraftFieldsResult extends MutationResult {
  errors?: Maybe<Array<CommitDraftFieldsMutationError>>;
}

export interface CommonDataRequirementsAddendum extends ExpenseAddendum {
  /** Card acceptor reference number */
  cardAcceptorReferenceNumber?: Maybe<Scalars["String"]>;
  /** Card acceptor tax id. */
  cardAcceptorTaxId?: Maybe<Scalars["String"]>;
  /** Customer code */
  customerCode?: Maybe<Scalars["String"]>;
  /** Freight amount */
  freightAmount?: Maybe<FinancialAsset>;
  /** The unique ID of the expense addendum. */
  id: Scalars["ID"];
  /** Total tax amount */
  totalTaxAmount?: Maybe<FinancialAsset>;
}

export enum CommsAuthIntegrationType {
  SLACK = "SLACK",
}

export interface CommsAuthMetadata {
  commsAuthIntegrationType?: Maybe<CommsAuthIntegrationType>;
}

export interface CompanyAssistantPreferences {
  enablements: AssistantEnablements;
  memoPreferences: MemoPreferences;
}

export interface CompanyAssistantPreferencesInput {
  enablements?: InputMaybe<AssistantEnablementsInput>;
  memoPreferences?: InputMaybe<MemoPreferencesInput>;
}

export interface CompanyAssistantSetting {
  mode: AssistantMode;
  preferences: CompanyAssistantPreferences;
}

/**
 * These types are used for returning fields on the Customer Account
 * We can consolidate with other definitions once we successfully decouple them from api v1
 */
export enum CompanyType {
  ECOMMERCE = "ECOMMERCE",
  LIFESCIENCE = "LIFESCIENCE",
  OTHERS = "OTHERS",
  STARTUP = "STARTUP",
}

export enum CompanyTypeV3 {
  ECOMMERCE = "ECOMMERCE",
  OTHER = "OTHER",
}

export enum ComparisonOperator {
  GT = "GT",
  GTE = "GTE",
  LT = "LT",
  LTE = "LTE",
}

export interface CompleteCashTransactionApprovalInput {
  clientMutationId: Scalars["String"];
  decision: CashTransactionApprovalDecision;
  /** Any notes the admin wants to fill in a free form field when processing a draft payment. */
  decisionNotes?: InputMaybe<Scalars["String"]>;
  decisionReason?: InputMaybe<CashTransactionApprovalDecisionReason>;
  transactionIdentifier: InputTransactionApprovalIdentifierUnion;
}

export interface CompleteCashTransactionApprovalPayload {
  clientMutationId: Scalars["String"];
  transaction: CashTransaction;
  transactionApprovalResult: CashTransactionApprovalResult;
}

export interface CompleteClawbackInput {
  /** ID of the clawback Expense to complete a Clawback for. */
  clawbackExpensesExpenseId?: InputMaybe<Scalars["ID"]>;
  /** clientMutationId */
  clientMutationId: Scalars["String"];
}

export interface CompleteClawbackResult {
  /** The clawback that was completed. */
  clawback: Clawback;
}

export interface CompleteOnboardingApplicationsInput {
  /** The client mutation id */
  clientMutationId: Scalars["String"];
  /** The products to complete onboarding for */
  productSelection: ProductSelectionInput;
}

export interface CompleteOnboardingInput {
  clientMutationId: Scalars["String"];
}

export interface CompleteOnboardingPayload {
  clientMutationId: Scalars["String"];
  user: User;
}

export interface ComplexValueInput {
  boolValue?: InputMaybe<Scalars["Boolean"]>;
  listValue?: InputMaybe<Array<InputMaybe<ComplexValueInput>>>;
  numberValue?: InputMaybe<Scalars["Float"]>;
  stringValue?: InputMaybe<Scalars["String"]>;
  structValue?: InputMaybe<StructuredValueInput>;
}

/** A metric which measures how well users stay compliant with the policies they spend against. */
export interface ComplianceRating {
  /** Cohort for this compliance rating. */
  cohort?: Maybe<ComplianceRatingCohort>;
  /** ID of this compliance rating. */
  id: Scalars["ID"];
  /** Uniformized compliance rating value in the range [0, 1]. This value will be NULL if and only if the cohort is NONE. */
  uniformValue?: Maybe<Scalars["Decimal"]>;
}

/** Users are split into cohorts based on their compliance rating. */
export enum ComplianceRatingCohort {
  /** The user has strong compliance habits. */
  HIGH = "HIGH",
  /** The user has poor compliance habits. */
  LOW = "LOW",
  /** The user has moderate compliance habits but there is room for improvement. */
  MEDIUM = "MEDIUM",
  /**
   * The user's compliance rating could not be computed for at least one of the following reasons:
   * - User doesn't have any expenses that impact compliance rating.
   * - Settings are not enabled for the given user's account.
   */
  NONE = "NONE",
}

/** Indicates the status of the compliance rating feature. */
export enum ComplianceRatingProductStatus {
  /** Compliance rating feature is disabled. */
  DISABLED = "DISABLED",
  /** Compliance rating feature is enabled. */
  ENABLED = "ENABLED",
}

/** The compliance status of a Request */
export enum ComplianceStatus {
  /** Request is compliant */
  COMPLETED = "COMPLETED",
  /** Requirements for the request to be compliant are due */
  DUE = "DUE",
  /** Requirements for the request to be compliant are overdue */
  OVERDUE = "OVERDUE",
}

export enum ComplianceStatusFilterInput {
  /** Expense is compliant */
  COMPLETED = "COMPLETED",
  /** Requirements for the expense to be compliant are due */
  DUE = "DUE",
  /** Requirements for the expense to be compliant are overdue */
  OVERDUE = "OVERDUE",
}

export enum ComplianceTypeFilterInput {
  /** Expense category type */
  EXPENSE_CATEGORY = "EXPENSE_CATEGORY",
  /**
   * Per diem violation determined outside of the expense policy evaluation flow.
   * It is determined manually by Brex Ops employee.
   * TODO: Deprecate this after we figure out https://brexhq.atlassian.net/browse/BPOL-1096
   */
  PER_DIEM_VIOLATION = "PER_DIEM_VIOLATION",
  /** Value added tax type */
  VAT = "VAT",
}

export interface CompositeCondition {
  conditions: Array<MemberConditionInput>;
  op: LogicalOperator;
}

/** The composite condition for user filtering */
export interface CompositeConditionInput {
  conditions?: InputMaybe<Array<UserConditionInput>>;
  logicalOperator: UserConditionLogicalOperator;
}

/** A special merchant category that represents a group of Present merchant categories. */
export interface CompoundMerchantCategory {
  /** The identifier for this compound merchant category */
  categoryType: CompoundMerchantCategoryType;
  /** The Present merchant categories represented by this group */
  includedCategories: Array<MerchantCategory>;
}

/** An identifier for a compound merchant category. */
export enum CompoundMerchantCategoryType {
  MEALS = "MEALS",
}

export interface ComputedExpenseEntities {
  /** The legal entity that funds this expense */
  fundingLegalEntity?: Maybe<LegalEntity>;
  /** The entity that this expense should be accounted for */
  spendingLegalEntity?: Maybe<LegalEntity>;
}

export interface ConditionalWorkflowBlock {
  /** The next key if the conditional is false. */
  elseKey?: Maybe<Scalars["String"]>;
  /** Block id */
  key: Scalars["String"];
  /** Key that will execute after then/else */
  nextKey?: Maybe<Scalars["String"]>;
  /** The next key if the conditional is true. */
  thenKey?: Maybe<Scalars["String"]>;
}

/**
 * Payload to upsert ProductSelection and regenerate open applications as needed. Partial updates not supported.
 * Only call this for accounts with status='waiting_submission'
 */
export interface ConfigureProductSelectionInput {
  clientMutationId: Scalars["String"];
  productSelection: ProductSelectionInput;
}

export interface ConfirmMfaInput {
  clientMutationId: Scalars["String"];
  deviceId: Scalars["String"];
  verificationToken: Scalars["String"];
}

export interface ConfirmMfaPayload {
  clientMutationId: Scalars["String"];
  user?: Maybe<User>;
}

export interface ConfirmPendingEmailChangeInput {
  /** The previously generated passcode associated with the pending change. */
  passcode: Scalars["String"];
  /** The ID of the change to verify & complete. */
  pendingEmailChangeId: Scalars["String"];
}

export interface ConfirmPendingEmailChangeResult extends MutationResult {
  errors?: Maybe<Array<ChangeEmailOperationError>>;
}

export enum ConfirmationStatus {
  CONFIRMATION_STATUS_CONFIRMED = "CONFIRMATION_STATUS_CONFIRMED",
  CONFIRMATION_STATUS_DISMISSED = "CONFIRMATION_STATUS_DISMISSED",
  CONFIRMATION_STATUS_INVALID = "CONFIRMATION_STATUS_INVALID",
  CONFIRMATION_STATUS_PENDING = "CONFIRMATION_STATUS_PENDING",
}

/** Input type for validating merchants and/or categories with ancestor budgets. */
export interface ConflictingAncestorBudgetMerchantCategoryControls {
  /** Merchant category control type (BLOCK or ALLOW). */
  controlType: MerchantCategoryControlType;
  /** Merchant category list. */
  merchantCategories?: InputMaybe<Array<MerchantCategoryInput>>;
  /** Merchant list. */
  merchants?: InputMaybe<Array<MerchantInput>>;
  /** Parent budget id. */
  parentBudgetId: Scalars["ID"];
}

/** Input type for validating merchants and/or categories with ancestor and descendant budgets. */
export interface ConflictingBudgetMerchantCategoryControls {
  /** Budget id. */
  budgetId: Scalars["ID"];
  /** Merchant category control type (BLOCK or ALLOW). */
  controlType: MerchantCategoryControlType;
  /** Merchant category list. */
  merchantCategories?: InputMaybe<Array<MerchantCategoryInput>>;
  /** Merchant list. */
  merchants?: InputMaybe<Array<MerchantInput>>;
}

/** Input type for validating merchants and/or categories with parent budget ID of budget request */
export interface ConflictingBudgetRequestMerchantCategoryControls {
  /** Budget request id. */
  budgetRequestId: Scalars["ID"];
  /** Merchant category control type (BLOCK or ALLOW). */
  controlType: MerchantCategoryControlType;
  /** Merchant category list. */
  merchantCategories?: InputMaybe<Array<MerchantCategoryInput>>;
  /** Merchant list. */
  merchants?: InputMaybe<Array<MerchantInput>>;
}

/** Response type for a conflicting merchant. */
export interface ConflictingMerchant {
  /** The offending budget. */
  budget?: Maybe<Budget>;
  /** The offending merchant category configs. */
  configs: Array<MerchantCategoryConfig>;
  /** ConflictingMerchant object id. */
  id: Scalars["String"];
  /** Merchant name. */
  name: Scalars["String"];
}

/** Response type for a conflicting merchant category. */
export interface ConflictingMerchantCategory {
  /** The offending budget. */
  budget?: Maybe<Budget>;
  /** The offending merchant category configs. */
  configs: Array<MerchantCategoryConfig>;
  /** ConflictingMerchantCategory object id. */
  id: Scalars["String"];
  /** Merchant category name. */
  name: Scalars["String"];
}

/** Response type for validation of merchant category controls. */
export interface ConflictingMerchantsCategoryResult {
  /** Conflicting merchant categories. */
  merchantCategories?: Maybe<Array<ConflictingMerchantCategory>>;
  /** Conflicting merchants. */
  merchants?: Maybe<Array<ConflictingMerchant>>;
}

export interface ConnectCredentialInput {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
  redirectUrl: Scalars["String"];
}

export interface ConnectCredentialPayload {
  authenticationResult?: Maybe<CredentialAuthenticationResult>;
  clientMutationId: Scalars["String"];
}

export interface ConnectInstitutionInput {
  clientMutationId: Scalars["String"];
  institutionId: Scalars["ID"];
  requestType?: InputMaybe<FinancialsConnectRequestType>;
}

export interface ConnectInstitutionPayload {
  clientMutationId: Scalars["String"];
  result?: Maybe<FinancialsSourceResult>;
}

export interface ConnectPersonalInput {
  clientMutationId: Scalars["String"];
  /** Customer User ID associated with personal source */
  customerUserId: Scalars["String"];
  /** ID of the financial institution */
  financialInstitutionId: Scalars["String"];
  /** Public token from Plaid Link */
  plaidPublicToken: Scalars["String"];
  /** Routing number for micro-deposits */
  routingNumber?: InputMaybe<Scalars["String"]>;
}

export interface ConnectPersonalPayload {
  clientMutationId: Scalars["String"];
  result: FinancialSource;
}

export interface ConnectPlaidInstitutionInput {
  clientMutationId: Scalars["String"];
  /** Plaid's id of the institution */
  plaidInstitutionId: Scalars["String"];
  /** Public token from Plaid Link */
  publicToken: Scalars["String"];
  /** Whether account details should be pulled synchronously with this request */
  shouldPullDetails?: InputMaybe<Scalars["Boolean"]>;
}

export interface ConnectPlaidInstitutionPayload {
  clientMutationId: Scalars["String"];
  result: FinancialSource;
}

export interface ConnectSessionPayload {
  sessionId: Scalars["String"];
}

export interface ConnectShopifyCredentialInput {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
  redirectUrl: Scalars["String"];
  shopName: Scalars["String"];
}

export interface ConnectShopifyCredentialPayload {
  authenticationResult?: Maybe<CredentialAuthenticationResult>;
  clientMutationId: Scalars["String"];
}

export interface ConnectTellerInstitutionInput {
  /** Access token representing customer connection (aka enrollment) */
  accessToken: Scalars["String"];
  clientMutationId: Scalars["String"];
  /** Teller enrollment (connection) ID */
  enrollmentId: Scalars["String"];
  /** Teller's name of the institution */
  tellerInstitutionName: Scalars["String"];
}

export interface ConnectTellerInstitutionPayload {
  clientMutationId: Scalars["String"];
  result: FinancialSource;
}

/**
 * The interface for paginating through collections of elements.
 * Every collection of entities not returned by a mutation result should
 * paginate through a connection. That is, `types` with a field that is
 * an `array` should be exceedingly rare.
 * We want all collections of things to be paginated.
 */
export interface Connection {
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /**
   * The total count of items matching the filter criteria specified for this connection.
   * This value may be approximate. And this value may not be provided at all. Not all connections
   * can be counted easily.
   */
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface ConnectionMutationError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface ConnectionUpdateInput {
  /** Authorization params required to update connection. Only user-modifiable fields will be updated; all other fields will remain unchanged. */
  authPayload: AuthPayloadOneOfInput;
  /** The client mutation id */
  clientMutationId: Scalars["String"];
  /** Existing credential id that we want to update */
  credentialId: Scalars["String"];
}

export type ConnectionUpdateResult =
  | ConnectionMutationError
  | ExternalConnection;

export interface ConstantBeforeNextPeriodEndBillFloatDetails {
  days: Scalars["Int"];
}

export interface ConstantBillFloatDetails {
  days: Scalars["Int"];
}

export interface Constants {
  cashBank: CashBank;
  intermediaryBank?: Maybe<IntermediaryBank>;
  wireBank: WireBank;
}

export interface ContactAddress {
  /** Address 1 */
  address1: Scalars["String"];
  /** Address 2 */
  address2?: Maybe<Scalars["String"]>;
  /** City */
  city: Scalars["String"];
  /** Country */
  country: Scalars["String"];
  /** First name */
  firstName: Scalars["String"];
  /** Last name */
  lastName: Scalars["String"];
  /** State */
  state: Scalars["String"];
  /** Zip code */
  zip: Scalars["String"];
}

export interface ContactAddressInput {
  /** Address 1 */
  address1?: InputMaybe<Scalars["String"]>;
  /** Address 2 */
  address2?: InputMaybe<Scalars["String"]>;
  /** City */
  city?: InputMaybe<Scalars["String"]>;
  /** Country */
  country?: InputMaybe<Scalars["String"]>;
  /** First name */
  firstName?: InputMaybe<Scalars["String"]>;
  /** Last name */
  lastName?: InputMaybe<Scalars["String"]>;
  /** State */
  state?: InputMaybe<Scalars["String"]>;
  /** Zip code */
  zip?: InputMaybe<Scalars["String"]>;
}

export interface ContactInput {
  email?: InputMaybe<Scalars["String"]>;
  name: Scalars["String"];
  phone?: InputMaybe<Scalars["String"]>;
}

export enum ContactMode {
  CONTACT_MODE_CHAT = "CONTACT_MODE_CHAT",
  CONTACT_MODE_EMAIL = "CONTACT_MODE_EMAIL",
  CONTACT_MODE_IN_PERSON = "CONTACT_MODE_IN_PERSON",
  CONTACT_MODE_OTHER = "CONTACT_MODE_OTHER",
  CONTACT_MODE_PHONE = "CONTACT_MODE_PHONE",
  CONTACT_MODE_WEBSITE = "CONTACT_MODE_WEBSITE",
}

/** [TEMP] for surfaces that depend on contacts but want to migrate to vendor svc */
export interface ContactToVendorMigrationDetails {
  contactId?: Maybe<Scalars["ID"]>;
  contactVersion?: Maybe<Scalars["Int"]>;
}

export enum ContactType {
  INVALID = "INVALID",
  INVOICER = "INVOICER",
  PAYER = "PAYER",
}

export interface Context {
  actorIpAddress?: Maybe<Scalars["String"]>;
  actorUserAgent?: Maybe<Scalars["String"]>;
  changes?: Maybe<Array<Maybe<Change>>>;
}

/** Answer(s) to "What types of funding sources will your Brex account have?" */
export enum ContinuedFundingSource {
  ANGEL_INVESTMENTS = "ANGEL_INVESTMENTS",
  BOOTSTRAPPING_SELF_FUNDED = "BOOTSTRAPPING_SELF_FUNDED",
  BUSINESS_REVENUE = "BUSINESS_REVENUE",
  GRANTS = "GRANTS",
  LOANS = "LOANS",
  /**  Deprecated values */
  OPERATING_CAPITAL = "OPERATING_CAPITAL",
  OTHER = "OTHER",
  PROFESSIONAL_INVESTOR = "PROFESSIONAL_INVESTOR",
}

export interface ContractResponse {
  /** Contract add-on list */
  addOns?: Maybe<Array<Maybe<AddOns>>>;
  /** Advance global country cap */
  advanceGlobalCountryCap?: Maybe<Scalars["Int"]>;
  /** Advance global overage fee */
  advanceGlobalExceedingCommitmentFee?: Maybe<FinancialAsset>;
  /** Price of advance global platform fee */
  advanceGlobalPlatformFeePrice?: Maybe<FinancialAsset>;
  /** Annual Travel Commitment */
  annualTravelCommitment?: Maybe<Scalars["Int"]>;
  /** Billing email */
  billingEmail?: Maybe<Scalars["String"]>;
  /** The billing frequency of the contract */
  billingFrequency?: Maybe<BillingFrequency>;
  /** Contract start date */
  contractStartDate?: Maybe<Scalars["Time"]>;
  /** Counterparty contact email */
  counterpartyContactEmail?: Maybe<Scalars["String"]>;
  /** Price of domestic (US) overage */
  domesticOverageFee?: Maybe<FinancialAsset>;
  /** Price of domestic (US) seats */
  domesticSeatPrice?: Maybe<FinancialAsset>;
  /** Number of domestic (US) seats */
  domesticSeatQuantity?: Maybe<Scalars["Int"]>;
  /** Contract edition type */
  editionType?: Maybe<EditionType>;
  /** Price of global overage */
  globalOverageFee?: Maybe<FinancialAsset>;
  /** Price of global seats */
  globalSeatPrice?: Maybe<FinancialAsset>;
  /** Number of global seats */
  globalSeatQuantity?: Maybe<Scalars["Int"]>;
  /** Is custom contract (tiered pricing etc.) */
  isCustom?: Maybe<Scalars["Boolean"]>;
  /** Price of metal cards */
  metalCardPrice?: Maybe<FinancialAsset>;
  /** Number of metal cards */
  metalCardQuantity?: Maybe<Scalars["Int"]>;
  /** Price of the platform fee */
  platformFee?: Maybe<FinancialAsset>;
  /** Price of premium overage */
  premiumOverageFee?: Maybe<FinancialAsset>;
  /** Price of premium seats */
  premiumSeatPrice?: Maybe<FinancialAsset>;
  /** Number of premium seats */
  premiumSeatQuantity?: Maybe<Scalars["Int"]>;
  /** Promotion end date */
  promotionEndDate?: Maybe<Scalars["Time"]>;
  /** Travel overage fee */
  travelOverageFee?: Maybe<FinancialAsset>;
  /** Travel trip fee */
  travelTripFee?: Maybe<FinancialAsset>;
}

export enum ConversionIneligibilityReason {
  MANUAL_UNDERWRITING_REQUIRED = "MANUAL_UNDERWRITING_REQUIRED",
}

export interface ConvertCardAccountTypeInput {
  bypassEligibilityChecks?: InputMaybe<Scalars["Boolean"]>;
  clientMutationId: Scalars["String"];
  isFicoUnderwriting?: InputMaybe<Scalars["Boolean"]>;
  toCardAccountType: CardAccountType;
  underwritingLimit?: InputMaybe<Scalars["Int"]>;
}

export interface ConvertCardAccountTypePayload {
  clientMutationId: Scalars["String"];
  ineligibilityReason?: Maybe<ConversionIneligibilityReason>;
}

/** Type describing a location in coordinates, such as defined on ISO-6709. */
export interface Coordinates {
  /** Angle identifying north-south position of location. */
  latitude: Scalars["Float"];
  /** Angle identifying east-west position of location. */
  longitude: Scalars["Float"];
}

/** Type describing a location in coordinates, such as defined on ISO-6709. */
export interface CoordinatesInput {
  /** Angle identifying north-south position of location. */
  latitude: Scalars["Float"];
  /** Angle identifying east-west position of location. */
  longitude: Scalars["Float"];
}

/**
 * Represents a relationship between two Employees, delegator and delegate, where the
 * delegate can be granted access to perform actions on the delegators behalf.
 */
export interface Copilot {
  /**
   * Deprecated. Use delegateUser instead.
   * @deprecated Use delegateUser instead.
   */
  delegate?: Maybe<Employee>;
  /** The User that is granted copilot access from the delegator. */
  delegateUser?: Maybe<User>;
  /**
   * Deprecated. Use delegatorUser instead.
   * @deprecated Use delegatorUser instead.
   */
  delegator?: Maybe<Employee>;
  /** The User that grants the delegate copilot access. */
  delegatorUser?: Maybe<User>;
  /** The time when the copilot relationship ends. */
  expiredAt?: Maybe<Scalars["Time"]>;
  /** The unique ID of the copilot relationship. */
  id: Scalars["ID"];
  /** The time when the copilot relationship is created. */
  insertedAt?: Maybe<Scalars["Time"]>;
  /** Delegator redirects notification to copilot. */
  notificationsSetting: CopilotNotificationsSetting;
  /** Status of the Copilot relationship. */
  status: CopilotStatus;
  /** The time when the copilot relationship is updated. */
  updatedAt?: Maybe<Scalars["Time"]>;
}

/** A copilot connection for pagination. */
export interface CopilotConnection extends Connection {
  /** The copilots in the current page of results. */
  edges: Array<CopilotEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of copilots matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

/** A Copilot edge for pagination. */
export interface CopilotEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The copilot at this edge. */
  node?: Maybe<Copilot>;
}

/** Copilot query filters. */
export interface CopilotFilterInput {
  /** Match IN conditions on delegate customer user ID. */
  delegateUserIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Match IN conditions on delegator customer user ID. */
  delegatorUserIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Match IN conditions on copilot status. */
  statuses?: InputMaybe<Array<CopilotStatus>>;
  /** Match IN conditions on either delegator or delegate customer user IDs. */
  userIds?: InputMaybe<Array<Scalars["ID"]>>;
}

export enum CopilotNotificationsSetting {
  /** The delegator has not redirected notifications to delegate. */
  NOT_REDIRECTED = "NOT_REDIRECTED",
  /** The delegator has redirected notifications to delegate. */
  REDIRECTED = "REDIRECTED",
}

export enum CopilotStatus {
  /** The delegate has access to copilot mode for the delegator. */
  APPROVED = "APPROVED",
  /** The delegate's access to copilot mode was revoked. */
  REVOKED = "REVOKED",
}

export interface CopilotUpdateInput {
  /** The time when the copilot relationship ends. */
  expiredAt?: InputMaybe<Scalars["Time"]>;
  /** Delegator redirects notification to copilot. */
  notificationsSetting?: InputMaybe<CopilotNotificationsSetting>;
  /** New copilot status */
  status?: InputMaybe<CopilotStatus>;
}

/**
 * Address of a Core Field (e.g. expense memo).
 *
 * Uses the Queries Service fieldKey format (e.g. expense.memo)
 * https://github.com/brexhq/credit_card/blob/main/protos/business_intelligence/v1/resources/query.proto#L9-L17
 *
 * See the ColumnNameMap for list of available fields
 * https://github.com/brexhq/credit_card/blob/main/spend/businessintelligence/src/main/kotlin/brex/businessintelligence/data/ColumnNameMap.kt
 */
export interface CoreFieldAddress {
  address: Scalars["String"];
}

/**
 * Input for addressing a Core Field (e.g. expense memo).
 *
 * Use the Queries Service fieldKey format (e.g. expense.memo)
 * https://github.com/brexhq/credit_card/blob/main/protos/business_intelligence/v1/resources/query.proto#L9-L17
 *
 * See the ColumnNameMap for list of available fields
 * https://github.com/brexhq/credit_card/blob/main/spend/businessintelligence/src/main/kotlin/brex/businessintelligence/data/ColumnNameMap.kt
 */
export interface CoreFieldAddressInput {
  address: Scalars["String"];
}

/** An employee's cost center defined within a company's organization hierarchy. */
export interface CostCenter {
  /** The name of the cost center defined by the customer */
  displayName: Scalars["String"];
  /** The unique ID of the cost center. */
  id: Scalars["ID"];
  /** Number of employees associated with the cost center */
  memberCount?: Maybe<Scalars["Int"]>;
}

/** Cost center connection for pagination */
export interface CostCenterConnection extends Connection {
  edges: Array<CostCenterEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

/** Cost center edge for the cost center connection. */
export interface CostCenterEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<CostCenter>;
}

export interface CostCenterIdentifier {
  displayName?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["ID"]>;
  type: CostCenterIdentifierType;
}

export enum CostCenterIdentifierType {
  DISPLAY_NAME = "DISPLAY_NAME",
  ID = "ID",
}

export interface CostCenterInput {
  /** The ID of the cost center. */
  id?: InputMaybe<Scalars["ID"]>;
  /** Name of the cost center. */
  name?: InputMaybe<Scalars["String"]>;
}

/** Filters for list cost center query. */
export interface CostCentersFilterInput {
  /** Filter by cost center ID. */
  id?: InputMaybe<Scalars["ID"]>;
  query?: InputMaybe<Scalars["String"]>;
}

export interface CountAlertsInput {
  read?: InputMaybe<Scalars["Boolean"]>;
}

export interface CountAlertsResult {
  /**
   * The number of alerts matching the filter criteria.
   *
   * This value is capped at 100 for performance reasons. If there are more than 100
   * matching alerts, this field will return 100.
   */
  count?: Maybe<Scalars["Int"]>;
}

export interface Counterparty extends Node {
  accountNumber?: Maybe<Scalars["String"]>;
  achCompanyId?: Maybe<Scalars["String"]>;
  address?: Maybe<Address>;
  approverUser?: Maybe<User>;
  beneficiaryBankAddress?: Maybe<Address>;
  beneficiaryBankInfo?: Maybe<Scalars["Json"]>;
  beneficiaryBankName?: Maybe<Scalars["String"]>;
  chequeRecipientName?: Maybe<Scalars["String"]>;
  class?: Maybe<Class>;
  email?: Maybe<Scalars["String"]>;
  financialAccount?: Maybe<FinancialAccount>;
  /** The ID of an object */
  id: Scalars["ID"];
  location: AccountLocation;
  name: Scalars["String"];
  paymentRail: PaymentRail;
  positivePayStatus?: Maybe<PositivePayStatus>;
  /**
   * Some banks return fake/virtual account numbers; we can't tell if account numbers are real or not
   * This field provides the last characters (usually four, but can vary) of the real account number
   */
  realAccountNumberEndingChars?: Maybe<Scalars["String"]>;
  routingNumber?: Maybe<Scalars["String"]>;
  type?: Maybe<Type>;
}

export interface CounterpartyAddress {
  address1?: Maybe<Scalars["String"]>;
  address2?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  firstName?: Maybe<Scalars["String"]>;
  lastName?: Maybe<Scalars["String"]>;
  state?: Maybe<Scalars["String"]>;
  zip?: Maybe<Scalars["String"]>;
}

export enum CounterpartyCategory {
  FREQUENT_TRANSACTION = "FREQUENT_TRANSACTION",
  INVALID = "INVALID",
  LARGE_TRANSACTION = "LARGE_TRANSACTION",
  RECOGNIZED = "RECOGNIZED",
}

/** Object defining counterparty category information */
export interface CounterpartyCategoryInformation {
  /** Counterparty associated with this information */
  counterparty?: Maybe<Counterparty>;
  /** Category of counterparty - generated from protobuf enum */
  counterpartyCategory?: Maybe<CounterpartyCategory>;
  /** The id of the deposits account */
  depositsAccountId: Scalars["String"];
  /** The amount in usd cents of the most recent transaction with counterparty */
  mostRecentTransactionAmountInUsdCents?: Maybe<Scalars["Int"]>;
  /** The time of the most recent transaction with counterparty */
  mostRecentTransactionTime?: Maybe<Scalars["Time"]>;
  /** The number of transactions with counterparty */
  numberOfTransactions?: Maybe<Scalars["Int"]>;
  /** The name of the recognized counterparty, empty if not recognized */
  recognizedName?: Maybe<RecognizedCounterpartyName>;
  /** The total amount of money in usd cents transacted with counterparty */
  totalAmountInUsdCents?: Maybe<Scalars["Int"]>;
}

export interface CounterpartyCategoryInformationConnection {
  edges?: Maybe<Array<Maybe<CounterpartyCategoryInformationEdge>>>;
  nextOffset: Scalars["Int"];
  pageInfo: PageInfo;
  totalCount: Scalars["Int"];
}

export interface CounterpartyCategoryInformationEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<CounterpartyCategoryInformation>;
}

export interface CounterpartyConnection {
  edges?: Maybe<Array<Maybe<CounterpartyEdge>>>;
  pageInfo: PageInfo;
}

export interface CounterpartyEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<Counterparty>;
}

export interface CounterpartyObject {
  accountClass?: Maybe<BankAccountClass>;
  accountNumberLast4?: Maybe<Scalars["String"]>;
  address?: Maybe<Address>;
  bankAccountInfo?: Maybe<BankAccountInfo>;
  beneficiaryInstitution?: Maybe<BeneficiaryInstitution>;
  countryCode?: Maybe<Scalars["String"]>;
  currencyCode?: Maybe<Scalars["String"]>;
  displayName?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  rail?: Maybe<CounterpartyPaymentRail>;
}

export interface CounterpartyObjectInput {
  accountClass?: InputMaybe<BankAccountClass>;
  address?: InputMaybe<AddressInput>;
  /** Info for only one bank account can be provided */
  bankAccountInfo?: InputMaybe<BankAccountInfoInput>;
  beneficiaryInstitution?: InputMaybe<BeneficiaryInstitutionInput>;
  countryCode: Scalars["String"];
  currencyCode: Scalars["String"];
  name?: InputMaybe<Scalars["String"]>;
  rail: CounterpartyPaymentRail;
}

export interface CounterpartyPaymentInstrument {
  counterparty?: Maybe<CounterpartyObject>;
}

export interface CounterpartyPaymentInstrumentInput {
  counterparty: CounterpartyObjectInput;
  idempotencyKey: Scalars["String"];
}

export enum CounterpartyPaymentRail {
  CA_INTERAC = "CA_INTERAC",
  GLOBAL_BANK_TRANSFER = "GLOBAL_BANK_TRANSFER",
  INTERNAL_TRANSFER = "INTERNAL_TRANSFER",
  SWIFT_WIRE = "SWIFT_WIRE",
  US_ACH = "US_ACH",
  US_CHEQUE = "US_CHEQUE",
  US_WIRE = "US_WIRE",
}

export enum CounterpartyStatus {
  EXTERNALLY_CREATED = "EXTERNALLY_CREATED",
  INVALID = "INVALID",
  NOT_VALID = "NOT_VALID",
  TRANSIENT_ISSUE = "TRANSIENT_ISSUE",
  VALID = "VALID",
}

/** Represents a trusted beneficiary for a banking counterparty. */
export interface CounterpartyTrustedBeneficiary {
  /** Whether the trusted beneficiary is APPROVED or PENDING_APPROVAL. */
  approvalStatus?: Maybe<BeneficiaryApprovalStatus>;
  /** The ID of the trusted beneficiary. */
  id: Scalars["String"];
  /** The legal entity ID associated with this trusted beneficiary. */
  legalEntityId: Scalars["String"];
  /** Whether the trusted beneficiary is NEW, UPDATED or DELETED. */
  modificationStatus?: Maybe<BeneficiaryModificationStatus>;
}

export interface CountriesListFilters {
  /** Filter to exclude sanctioned countries for card shipping */
  excludeSanctionedForCardShipping?: InputMaybe<Scalars["Boolean"]>;
  /** Filter to include enabled countries for local card collections */
  includeEnabledForLocalCardCollections?: InputMaybe<Scalars["Boolean"]>;
  /** Filter to include enabled countries for local reimbursements collections */
  includeEnabledForLocalReimbursementsCollections?: InputMaybe<
    Scalars["Boolean"]
  >;
  /** Filter to include enabled countries for reimbursements */
  includeEnabledForReimbursements?: InputMaybe<Scalars["Boolean"]>;
}

/** Country node extended from APIv1 */
export interface Country {
  /** The ISO 3166-1 alpha-2 code for the country */
  alpha2: CountryAlpha2;
  /** ISO 3166-1 alpha-3 representation of a country (ex. 'USA' for United States) */
  alpha3: CountryAlpha3;
  /** Default currency of the country */
  defaultCurrency?: Maybe<FinancialInstrument>;
  /** Human-readable name of the country */
  displayName: Scalars["String"];
  /** The test currencies for local reimbursements collections */
  localReimbursementsCollectionTestCurrencies?: Maybe<
    Array<FinancialInstrument>
  >;
  /** Official name of the country */
  name: Scalars["String"];
  /** ISO 3166-1 numeric representation of a country (ex. '840' for United States) */
  numeric: Scalars["String"];
  /** Restrictions associated with the country */
  restrictions: Restrictions;
  /**
   * The supported currencies for local card collections.
   * Only available in product if `is_enabled_for_local_card_collections` is true
   */
  supportedLocalCardCollectionCurrencies?: Maybe<Array<FinancialInstrument>>;
  /** The supported currencies for local reimbursements collections */
  supportedLocalReimbursementsCollectionCurrencies?: Maybe<
    Array<FinancialInstrument>
  >;
}

export interface CountryAddressMetadata {
  /** The regular expression corresponding to all po box formats in the country */
  poBoxRegex?: Maybe<Scalars["String"]>;
  /** The regular expression corresponding to all postal codes in the country */
  postalCodeRegex?: Maybe<Scalars["String"]>;
  /** The term used to describe the country's subregions (ex. state, province, etc.) */
  subregionLabel: Scalars["String"];
  /** The list of provinces/states */
  subregions?: Maybe<Array<Subregion>>;
}

/** Alpha2 codes for countries */
export enum CountryAlpha2 {
  AD = "AD",
  AE = "AE",
  AF = "AF",
  AG = "AG",
  AI = "AI",
  AL = "AL",
  AM = "AM",
  AO = "AO",
  AQ = "AQ",
  AR = "AR",
  AS = "AS",
  AT = "AT",
  AU = "AU",
  AW = "AW",
  AX = "AX",
  AZ = "AZ",
  BA = "BA",
  BB = "BB",
  BD = "BD",
  BE = "BE",
  BF = "BF",
  BG = "BG",
  BH = "BH",
  BI = "BI",
  BJ = "BJ",
  BL = "BL",
  BM = "BM",
  BN = "BN",
  BO = "BO",
  BQ = "BQ",
  BR = "BR",
  BS = "BS",
  BT = "BT",
  BV = "BV",
  BW = "BW",
  BY = "BY",
  BZ = "BZ",
  CA = "CA",
  CC = "CC",
  CD = "CD",
  CF = "CF",
  CG = "CG",
  CH = "CH",
  CI = "CI",
  CK = "CK",
  CL = "CL",
  CM = "CM",
  CN = "CN",
  CO = "CO",
  CR = "CR",
  CU = "CU",
  CV = "CV",
  CW = "CW",
  CX = "CX",
  CY = "CY",
  CZ = "CZ",
  DE = "DE",
  DJ = "DJ",
  DK = "DK",
  DM = "DM",
  DO = "DO",
  DZ = "DZ",
  EC = "EC",
  EE = "EE",
  EG = "EG",
  EH = "EH",
  ER = "ER",
  ES = "ES",
  ET = "ET",
  FI = "FI",
  FJ = "FJ",
  FK = "FK",
  FM = "FM",
  FO = "FO",
  FR = "FR",
  GA = "GA",
  GB = "GB",
  GD = "GD",
  GE = "GE",
  GF = "GF",
  GG = "GG",
  GH = "GH",
  GI = "GI",
  GL = "GL",
  GM = "GM",
  GN = "GN",
  GP = "GP",
  GQ = "GQ",
  GR = "GR",
  GS = "GS",
  GT = "GT",
  GU = "GU",
  GW = "GW",
  GY = "GY",
  HK = "HK",
  HM = "HM",
  HN = "HN",
  HR = "HR",
  HT = "HT",
  HU = "HU",
  ID = "ID",
  IE = "IE",
  IL = "IL",
  IM = "IM",
  IN = "IN",
  IO = "IO",
  IQ = "IQ",
  IR = "IR",
  IS = "IS",
  IT = "IT",
  JE = "JE",
  JM = "JM",
  JO = "JO",
  JP = "JP",
  KE = "KE",
  KG = "KG",
  KH = "KH",
  KI = "KI",
  KM = "KM",
  KN = "KN",
  KP = "KP",
  KR = "KR",
  KW = "KW",
  KY = "KY",
  KZ = "KZ",
  LA = "LA",
  LB = "LB",
  LC = "LC",
  LI = "LI",
  LK = "LK",
  LR = "LR",
  LS = "LS",
  LT = "LT",
  LU = "LU",
  LV = "LV",
  LY = "LY",
  MA = "MA",
  MC = "MC",
  MD = "MD",
  ME = "ME",
  MF = "MF",
  MG = "MG",
  MH = "MH",
  MK = "MK",
  ML = "ML",
  MM = "MM",
  MN = "MN",
  MO = "MO",
  MP = "MP",
  MQ = "MQ",
  MR = "MR",
  MS = "MS",
  MT = "MT",
  MU = "MU",
  MV = "MV",
  MW = "MW",
  MX = "MX",
  MY = "MY",
  MZ = "MZ",
  NA = "NA",
  NC = "NC",
  NE = "NE",
  NF = "NF",
  NG = "NG",
  NI = "NI",
  NL = "NL",
  NO = "NO",
  NP = "NP",
  NR = "NR",
  NU = "NU",
  NZ = "NZ",
  OM = "OM",
  PA = "PA",
  PE = "PE",
  PF = "PF",
  PG = "PG",
  PH = "PH",
  PK = "PK",
  PL = "PL",
  PM = "PM",
  PN = "PN",
  PR = "PR",
  PS = "PS",
  PT = "PT",
  PW = "PW",
  PY = "PY",
  QA = "QA",
  RE = "RE",
  RO = "RO",
  RS = "RS",
  RU = "RU",
  RW = "RW",
  SA = "SA",
  SB = "SB",
  SC = "SC",
  SD = "SD",
  SE = "SE",
  SG = "SG",
  SH = "SH",
  SI = "SI",
  SJ = "SJ",
  SK = "SK",
  SL = "SL",
  SM = "SM",
  SN = "SN",
  SO = "SO",
  SR = "SR",
  SS = "SS",
  ST = "ST",
  SV = "SV",
  SX = "SX",
  SY = "SY",
  SZ = "SZ",
  TC = "TC",
  TD = "TD",
  TF = "TF",
  TG = "TG",
  TH = "TH",
  TJ = "TJ",
  TK = "TK",
  TL = "TL",
  TM = "TM",
  TN = "TN",
  TO = "TO",
  TR = "TR",
  TT = "TT",
  TV = "TV",
  TW = "TW",
  TZ = "TZ",
  UA = "UA",
  UG = "UG",
  UM = "UM",
  US = "US",
  UY = "UY",
  UZ = "UZ",
  VA = "VA",
  VC = "VC",
  VE = "VE",
  VG = "VG",
  VI = "VI",
  VN = "VN",
  VU = "VU",
  WF = "WF",
  WS = "WS",
  YE = "YE",
  YT = "YT",
  ZA = "ZA",
  ZM = "ZM",
  ZW = "ZW",
}

export enum CountryAlpha3 {
  ABW = "ABW",
  AFG = "AFG",
  AGO = "AGO",
  AIA = "AIA",
  ALA = "ALA",
  ALB = "ALB",
  AND = "AND",
  ARE = "ARE",
  ARG = "ARG",
  ARM = "ARM",
  ASM = "ASM",
  ATA = "ATA",
  ATF = "ATF",
  ATG = "ATG",
  AUS = "AUS",
  AUT = "AUT",
  AZE = "AZE",
  BDI = "BDI",
  BEL = "BEL",
  BEN = "BEN",
  BES = "BES",
  BFA = "BFA",
  BGD = "BGD",
  BGR = "BGR",
  BHR = "BHR",
  BHS = "BHS",
  BIH = "BIH",
  BLM = "BLM",
  BLR = "BLR",
  BLZ = "BLZ",
  BMU = "BMU",
  BOL = "BOL",
  BRA = "BRA",
  BRB = "BRB",
  BRN = "BRN",
  BTN = "BTN",
  BVT = "BVT",
  BWA = "BWA",
  CAF = "CAF",
  CAN = "CAN",
  CCK = "CCK",
  CHE = "CHE",
  CHL = "CHL",
  CHN = "CHN",
  CIV = "CIV",
  CMR = "CMR",
  COD = "COD",
  COG = "COG",
  COK = "COK",
  COL = "COL",
  COM = "COM",
  CPV = "CPV",
  CRI = "CRI",
  CUB = "CUB",
  CUW = "CUW",
  CXR = "CXR",
  CYM = "CYM",
  CYP = "CYP",
  CZE = "CZE",
  DEU = "DEU",
  DJI = "DJI",
  DMA = "DMA",
  DNK = "DNK",
  DOM = "DOM",
  DZA = "DZA",
  ECU = "ECU",
  EGY = "EGY",
  ERI = "ERI",
  ESH = "ESH",
  ESP = "ESP",
  EST = "EST",
  ETH = "ETH",
  FIN = "FIN",
  FJI = "FJI",
  FLK = "FLK",
  FRA = "FRA",
  FRO = "FRO",
  FSM = "FSM",
  GAB = "GAB",
  GBR = "GBR",
  GEO = "GEO",
  GGY = "GGY",
  GHA = "GHA",
  GIB = "GIB",
  GIN = "GIN",
  GLP = "GLP",
  GMB = "GMB",
  GNB = "GNB",
  GNQ = "GNQ",
  GRC = "GRC",
  GRD = "GRD",
  GRL = "GRL",
  GTM = "GTM",
  GUF = "GUF",
  GUM = "GUM",
  GUY = "GUY",
  HKG = "HKG",
  HMD = "HMD",
  HND = "HND",
  HRV = "HRV",
  HTI = "HTI",
  HUN = "HUN",
  IDN = "IDN",
  IMN = "IMN",
  IND = "IND",
  IOT = "IOT",
  IRL = "IRL",
  IRN = "IRN",
  IRQ = "IRQ",
  ISL = "ISL",
  ISR = "ISR",
  ITA = "ITA",
  JAM = "JAM",
  JEY = "JEY",
  JOR = "JOR",
  JPN = "JPN",
  KAZ = "KAZ",
  KEN = "KEN",
  KGZ = "KGZ",
  KHM = "KHM",
  KIR = "KIR",
  KNA = "KNA",
  KOR = "KOR",
  KWT = "KWT",
  LAO = "LAO",
  LBN = "LBN",
  LBR = "LBR",
  LBY = "LBY",
  LCA = "LCA",
  LIE = "LIE",
  LKA = "LKA",
  LSO = "LSO",
  LTU = "LTU",
  LUX = "LUX",
  LVA = "LVA",
  MAC = "MAC",
  MAF = "MAF",
  MAR = "MAR",
  MCO = "MCO",
  MDA = "MDA",
  MDG = "MDG",
  MDV = "MDV",
  MEX = "MEX",
  MHL = "MHL",
  MKD = "MKD",
  MLI = "MLI",
  MLT = "MLT",
  MMR = "MMR",
  MNE = "MNE",
  MNG = "MNG",
  MNP = "MNP",
  MOZ = "MOZ",
  MRT = "MRT",
  MSR = "MSR",
  MTQ = "MTQ",
  MUS = "MUS",
  MWI = "MWI",
  MYS = "MYS",
  MYT = "MYT",
  NAM = "NAM",
  NCL = "NCL",
  NER = "NER",
  NFK = "NFK",
  NGA = "NGA",
  NIC = "NIC",
  NIU = "NIU",
  NLD = "NLD",
  NOR = "NOR",
  NPL = "NPL",
  NRU = "NRU",
  NZL = "NZL",
  OMN = "OMN",
  PAK = "PAK",
  PAN = "PAN",
  PCN = "PCN",
  PER = "PER",
  PHL = "PHL",
  PLW = "PLW",
  PNG = "PNG",
  POL = "POL",
  PRI = "PRI",
  PRK = "PRK",
  PRT = "PRT",
  PRY = "PRY",
  PSE = "PSE",
  PYF = "PYF",
  QAT = "QAT",
  REU = "REU",
  ROU = "ROU",
  RUS = "RUS",
  RWA = "RWA",
  SAU = "SAU",
  SDN = "SDN",
  SEN = "SEN",
  SGP = "SGP",
  SGS = "SGS",
  SHN = "SHN",
  SJM = "SJM",
  SLB = "SLB",
  SLE = "SLE",
  SLV = "SLV",
  SMR = "SMR",
  SOM = "SOM",
  SPM = "SPM",
  SRB = "SRB",
  SSD = "SSD",
  STP = "STP",
  SUR = "SUR",
  SVK = "SVK",
  SVN = "SVN",
  SWE = "SWE",
  SWZ = "SWZ",
  SXM = "SXM",
  SYC = "SYC",
  SYR = "SYR",
  TCA = "TCA",
  TCD = "TCD",
  TGO = "TGO",
  THA = "THA",
  TJK = "TJK",
  TKL = "TKL",
  TKM = "TKM",
  TLS = "TLS",
  TON = "TON",
  TTO = "TTO",
  TUN = "TUN",
  TUR = "TUR",
  TUV = "TUV",
  TWN = "TWN",
  TZA = "TZA",
  UGA = "UGA",
  UKR = "UKR",
  UMI = "UMI",
  URY = "URY",
  USA = "USA",
  UZB = "UZB",
  VAT = "VAT",
  VCT = "VCT",
  VEN = "VEN",
  VGB = "VGB",
  VIR = "VIR",
  VNM = "VNM",
  VUT = "VUT",
  WLF = "WLF",
  WSM = "WSM",
  YEM = "YEM",
  ZAF = "ZAF",
  ZMB = "ZMB",
  ZWE = "ZWE",
}

export interface CountryDetails {
  alpha2?: Maybe<Scalars["String"]>;
  alpha3?: Maybe<Scalars["String"]>;
  defaultCurrencies?: Maybe<Array<Scalars["String"]>>;
  defaultCurrency?: Maybe<Scalars["String"]>;
  displayName?: Maybe<Scalars["String"]>;
  localCardCollectionTestCurrencies?: Maybe<Array<Scalars["String"]>>;
  localReimbursementsCollectionTestCurrencies?: Maybe<Array<Scalars["String"]>>;
  name?: Maybe<Scalars["String"]>;
  numeric?: Maybe<Scalars["String"]>;
  supportedLocalCardCollectionCurrencies?: Maybe<Array<Scalars["String"]>>;
  supportedLocalReimbursementsCollectionCurrencies?: Maybe<
    Array<Scalars["String"]>
  >;
}

/** Enum for Courier */
export enum Courier {
  DEUTSCHE_POST = "DEUTSCHE_POST",
  DHL = "DHL",
  FEDEX = "FEDEX",
  POLAND_LOCAL = "POLAND_LOCAL",
  USPS = "USPS",
}

export interface CreateAccountInput {
  clientMutationId: Scalars["String"];
  dateEstablished: Scalars["Time"];
  dbaName: Scalars["String"];
  incorporationState: Scalars["String"];
  incorporationType: AccountIncorporationTypeInput;
  legalName: Scalars["String"];
  officeAddress: AddressInput;
  principalUser?: InputMaybe<AccountPrincipalUserInput>;
  taxpayerNumber: Scalars["String"];
}

export enum CreateAccountOnboardingApplicationAccountType {
  CARD = "CARD",
  CASH = "CASH",
  CASH_AND_CARD = "CASH_AND_CARD",
}

export interface CreateAccountPayload {
  account?: Maybe<Account>;
  clientMutationId: Scalars["String"];
}

export interface CreateAccountingIntegrationInput {
  /**
   * Optional, indicates how to handle customer account setup.
   * Defaults to EXISTING_ACCOUNT for backward compatibility.
   */
  accountProvisioning?: InputMaybe<AccountProvisioningType>;
  /** Optional, only used by multi-entity ERPs. */
  childSubsidiariesInput?: InputMaybe<
    Array<AccountingIntegrationSubsidiaryInput>
  >;
  /** Required, the client mutation id. */
  clientMutationId: Scalars["String"];
  /**
   * The vendor credential id. Required when accountProvisioning is EXISTING_ACCOUNT or not provided.
   * Optional when accountProvisioning is AUTO_PROVISION.
   */
  credentialId?: InputMaybe<Scalars["String"]>;
  /** Optional - integration specific creation metadata */
  metadata?: InputMaybe<CreateAccountingIntegrationMetadataOneOfInput>;
  /**
   * Optional, only multi-entity ERPs need to specify the parent subsidiary.
   * For non multi-entity ERPs, its parent subsidiary is the connected vendor account,
   * we do not need to pass it in as a parameter.
   */
  parentSubsidiaryInput?: InputMaybe<AccountingIntegrationSubsidiaryInput>;
  /** Required, the vendor type. */
  vendor: AccountingIntegrationVendor;
}

export interface CreateAccountingIntegrationMetadataOneOfInput {
  ucsvInput?: InputMaybe<AccountingIntegrationUCSVExtensionInput>;
}

export interface CreateAccountingIntegrationResult extends MutationResult {
  errors?: Maybe<Array<AccountingIntegrationMutationError>>;
  result?: Maybe<AccountingIntegration>;
}

export interface CreateAccountingJournalReportInput {
  /**
   * [oneOf] Filter to find accounting records to include in the report.
   * Exactly one of [filter, entityFilter, sourceIds, accountingRecordFilter] must be specified.
   * An exception will be thrown if none or multiple are passed.
   */
  accountingRecordFilter?: InputMaybe<AccountingRecordFilterInput>;
  /**
   * [oneOf] Entity Filter used to find entries to include in the report (UGQL)
   * the resulting filter proto will match what's created when using the same filter in UGQL entityRows() query.
   * Exactly one of [filter, entityFilter, sourceIds, accountingRecordFilter] must be specified.
   * An exception will be thrown if none or multiple are passed.
   */
  entityFilter?: InputMaybe<EntityFilterInput>;
  /**
   * [oneOf] Accounting Journal filter used to find entries to include in the report.
   * Exactly one of [filter, entityFilter, sourceIds, accountingRecordFilter] must be specified.
   * An exception will be thrown if none or multiple are passed.
   */
  filter?: InputMaybe<AccountingJournalEntryFilterInput>;
  /** The customer's integration id. */
  integrationId: Scalars["ID"];
  /** The format of the report. */
  reportFormatType: AccountingJournalReportFormatType;
  /**
   * [oneOf] AJE Source IDs to set the review status for
   * Exactly one of [filter, entityFilter, sourceIds, accountingRecordFilter] must be specified.
   * An exception will be thrown if none or multiple are passed.
   */
  sourceIds?: InputMaybe<Array<Scalars["ID"]>>;
}

export interface CreateAccountingJournalReportResult {
  asset?: Maybe<Asset>;
}

export interface CreateAndConnectCredentialInput {
  /** Authorization params required to connect to vendor */
  authPayload: AuthPayloadOneOfInput;
  /** The client mutation id */
  clientMutationId: Scalars["String"];
  /** The vendor to create credential for and connect to */
  credentialVendor: CredentialVendor;
}

export interface CreateAndConnectCredentialResult extends MutationResult {
  errors?: Maybe<Array<CredentialMutationError>>;
  redirectUrl?: Maybe<Scalars["String"]>;
  result?: Maybe<VendorCredential>;
}

export interface CreateAssetInput {
  /** Idempotency key */
  clientMutationId: Scalars["String"];
  /** The file content type */
  contentType: Scalars["String"];
  /** For Internal Use Only: Assets will not be accessible in the dashboard when this is true */
  fiuo?: InputMaybe<Scalars["Boolean"]>;
  /**
   * Strong compliance means that assets will be stored in an s3 bucket where assets cannot be deleted.
   * This is necessary for assets which are required by FINRA to be stored in a WORM compliant way.
   */
  isStrongCompliance?: InputMaybe<Scalars["Boolean"]>;
  /** The name of the file */
  name: Scalars["String"];
  /** Idempotency key for the upload request */
  uploadRequestId: Scalars["String"];
}

export interface CreateAssetPayload {
  /** The created or found asset. */
  asset?: Maybe<Asset>;
  /** Idempotency key */
  clientMutationId: Scalars["String"];
}

export interface CreateAssistantFeedbackError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

/** INPUTS */
export interface CreateAssistantFeedbackInput {
  clientMutationId: Scalars["String"];
  /** Comment of the feedback */
  comment?: InputMaybe<Scalars["String"]>;
  /**
   * Sentiment of the feedback:
   * POSITIVE ~= Thumb up
   * NEGATIVE ~= Thumb down
   * ABUSIVE ~= Flag for review
   */
  feedbackSentiment?: InputMaybe<AssistantFeedbackSentiment>;
  /** Asset id of the screenshot image */
  imageAssetId?: InputMaybe<Scalars["ID"]>;
  /** ID of the message the user is sending feedback for. */
  messageId?: InputMaybe<Scalars["ID"]>;
  /** Rating of the feedback */
  rating?: InputMaybe<Scalars["Int"]>;
  /** ID of the session the user is sending feedback for. */
  sessionId?: InputMaybe<Scalars["ID"]>;
  /** ID of the suggestion the user is sending feedback for. */
  suggestionId?: InputMaybe<Scalars["ID"]>;
}

/** FEEDBACK TYPES */
export interface CreateAssistantFeedbackResult extends MutationResult {
  /** No errors if the report is submitted successfully */
  errors?: Maybe<Array<CreateAssistantFeedbackError>>;
}

export interface CreateAttributeMappingsError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface CreateAttributeMappingsInput {
  accountId?: InputMaybe<Scalars["ID"]>;
  mappings: Array<AttributeMapping>;
}

export interface CreateAttributeMappingsResult extends MutationResult {
  errors?: Maybe<Array<CreateAttributeMappingsError>>;
  result?: Maybe<Array<MappedAttribute>>;
}

/**  ------- auto invite section --------- */
export interface CreateAutoInviteSettingInput {
  active?: InputMaybe<Scalars["Boolean"]>;
  assignments: AutoInviteAssignmentInput;
  condition: UserConditionInput;
  name: Scalars["String"];
}

export interface CreateAutomaticTransferSettingsInput {
  /** Represents either the fixed amount or threshold amount based on the type of autotransfer settings */
  amountUsdCents?: InputMaybe<Scalars["Int"]>;
  /** Type of automatic transfer configured by this setting */
  automaticTransferType?: InputMaybe<AutomaticTransferType>;
  clientMutationId: Scalars["String"];
  /** ID target deposits account for autotransfer */
  depositsAccountId: Scalars["ID"];
  /** Deprecated, use amount_usd_cents */
  minimumBalanceThresholdUsdCents?: InputMaybe<Scalars["Int"]>;
  /** Schedule of when the transfer will be executed */
  schedule: InputAutomaticTransferScheduleTypeUnion;
  /** Source account for the autotransfer funds */
  sourceAccount: InputAutomaticTransferSourceAccountUnion;
}

export interface CreateAutomaticTransferSettingsPayload {
  automaticTransferSettings: AutomaticTransferSettings;
  clientMutationId: Scalars["String"];
}

export interface CreateAutomationWorkflowSpecInput {
  cadence?: InputMaybe<AutomationWorkflowCadenceOneOfInput>;
  name: Scalars["String"];
  steps: Array<AutomationWorkflowStepInput>;
  workflowEntity: WorkflowEntity;
}

export interface CreateAutomationWorkflowSpecsResult {
  specs?: Maybe<Array<AutomationWorkflowSpec>>;
}

export interface CreateBillBatchInput {
  /** The billing configuration ID to be used for the batch */
  billingConfigurationId: Scalars["ID"];
  /** Idempotency key */
  clientMutationId: Scalars["String"];
  /** List of bill expenses IDs to be included in the batch */
  expenseIds: Array<Scalars["ID"]>;
  /** The date when the payment should be sent for the batch */
  paymentDate?: InputMaybe<Scalars["Time"]>;
  /** Source account of the bill payment: could be BBA or EBA ID or RAD ID */
  sourceAccount: SourceAccountInput;
}

export interface CreateBillBatchesInput {
  /** List of bills and their source accounts to be included in the batch */
  batches: Array<CreateBillBatchInput>;
}

export interface CreateBillBatchesResult {
  /** Possible list of errors from the mutation */
  errors?: Maybe<Array<BillBatchMutationError>>;
  /** The created bill batch object */
  result?: Maybe<Array<Maybe<BillBatch>>>;
}

export interface CreateBillFields {
  amount?: InputMaybe<Scalars["Int"]>;
  attachmentAssetId?: InputMaybe<Scalars["ID"]>;
  autoSendOneTimeCardDetails?: InputMaybe<Scalars["Boolean"]>;
  budgetId?: InputMaybe<Scalars["ID"]>;
  /** [Deprecated!] Use transferDescription instead */
  chequeMemo?: InputMaybe<Scalars["String"]>;
  contactId?: InputMaybe<Scalars["ID"]>;
  /** Aka memo */
  description?: InputMaybe<Scalars["String"]>;
  dueAt?: InputMaybe<Scalars["Time"]>;
  /** Entity ID associated with the bill. */
  entityId?: InputMaybe<Scalars["ID"]>;
  erpApAccountId?: InputMaybe<Scalars["ID"]>;
  erpApAccountVxOptionId?: InputMaybe<Scalars["ID"]>;
  erpClassId?: InputMaybe<Scalars["ID"]>;
  erpClassVxOptionId?: InputMaybe<Scalars["ID"]>;
  erpDepartmentId?: InputMaybe<Scalars["ID"]>;
  erpDepartmentVxOptionId?: InputMaybe<Scalars["ID"]>;
  erpLocationId?: InputMaybe<Scalars["ID"]>;
  erpLocationVxOptionId?: InputMaybe<Scalars["ID"]>;
  erpPaymentAccountId?: InputMaybe<Scalars["ID"]>;
  erpPaymentAccountVxOptionId?: InputMaybe<Scalars["ID"]>;
  externalInvoiceNumber?: InputMaybe<Scalars["String"]>;
  /** The OCR processing status. */
  invoiceProcessingStatus?: InputMaybe<BillInvoiceProcessingStatus>;
  notifyRecipient?: InputMaybe<Scalars["Boolean"]>;
  oneTimeCardOwnerUserId?: InputMaybe<Scalars["ID"]>;
  /** Used as message to card owner for `ONE_TIME_VIRTUAL_CARD`. */
  oneTimeCardRecipientMessage?: InputMaybe<Scalars["String"]>;
  paymentInstrumentId?: InputMaybe<Scalars["ID"]>;
  paymentMethod?: InputMaybe<BillPaymentMethod>;
  /**
   * When the payment will be initiated for EBA/BBA payments.
   * When the card will be issued for virtual card payments.
   */
  paymentSendAt?: InputMaybe<Scalars["Time"]>;
  purchaseOrderId?: InputMaybe<Scalars["ID"]>;
  /** The receipt associated with the bill */
  receiptId?: InputMaybe<Scalars["ID"]>;
  recurringSchedule?: InputMaybe<RecurringScheduleInput>;
  servicePerformedAt?: InputMaybe<Scalars["Time"]>;
  sourceAccount?: InputMaybe<SourceAccountInput>;
  /**
   * A description of the transfer used as `Payment Instructions` for `WIRE` and the `Entry Description` for `ACH`.
   * Max 90 characters for `ACH` and `WIRE` and max 40 characters for `CHEQUES`.
   */
  transferDescription?: InputMaybe<Scalars["String"]>;
  userErpCategoryId?: InputMaybe<Scalars["ID"]>;
  userErpCategoryVxOptionId?: InputMaybe<Scalars["ID"]>;
}

export interface CreateBillInput {
  attachmentAssetId?: InputMaybe<Scalars["ID"]>;
  chequeMemo?: InputMaybe<Scalars["String"]>;
  clientMutationId: Scalars["String"];
  contactId?: InputMaybe<Scalars["ID"]>;
  counterpartyId?: InputMaybe<Scalars["String"]>;
  /** DEPRECATED. Use sourceAccount field instead */
  depositsAccountId?: InputMaybe<Scalars["ID"]>;
  description?: InputMaybe<Scalars["String"]>;
  dueAmountCents?: InputMaybe<Scalars["Int"]>;
  dueAt?: InputMaybe<Scalars["Time"]>;
  endsAt?: InputMaybe<Scalars["Time"]>;
  erpApAccountId?: InputMaybe<Scalars["ID"]>;
  erpClassId?: InputMaybe<Scalars["ID"]>;
  erpDepartmentId?: InputMaybe<Scalars["ID"]>;
  erpLocationId?: InputMaybe<Scalars["ID"]>;
  erpPaymentAccountId?: InputMaybe<Scalars["ID"]>;
  externalInvoiceNumber?: InputMaybe<Scalars["String"]>;
  idempotencyKey: Scalars["String"];
  merchantCategoryId?: InputMaybe<Scalars["ID"]>;
  monthlySchedule?: InputMaybe<MonthlySchedule>;
  notifyRecipient?: InputMaybe<Scalars["Boolean"]>;
  paymentInstrumentId?: InputMaybe<Scalars["ID"]>;
  paymentSendAt?: InputMaybe<Scalars["Time"]>;
  servicePerformedAt?: InputMaybe<Scalars["Time"]>;
  sourceAccount?: InputMaybe<InputSourceAccountUnion>;
  totalNumberOfPayments?: InputMaybe<Scalars["Int"]>;
  transferDescription?: InputMaybe<Scalars["String"]>;
  userErpCategoryId?: InputMaybe<Scalars["ID"]>;
  weeklySchedule?: InputMaybe<WeeklySchedule>;
}

export interface CreateBillPayload {
  bill?: Maybe<Bill>;
  clientMutationId: Scalars["String"];
}

export interface CreateBillV2Input {
  clientMutationId: Scalars["String"];
  fields: CreateBillFields;
}

export interface CreateBudgetFields {
  /** Setting for auto-transferring budget cards when their owners are either disabled or removed as members from the budget. */
  autoTransferCardsSetting?: InputMaybe<AutoTransferCardsSetting>;
  /** The budget template to be associated with this budget */
  budgetTemplateId?: InputMaybe<Scalars["ID"]>;
  /** Description of what the budget is used for */
  description?: InputMaybe<Scalars["String"]>;
  /** The end date of the budget, inclusive. */
  endDate?: InputMaybe<Scalars["Date"]>;
  /** True if the budget limit is hard enforced */
  enforceLimit: Scalars["Boolean"];
  /** The percentage of the buffer on the budget limit */
  enforceLimitBufferPercentage?: InputMaybe<Scalars["Int"]>;
  /** Determines if budget members are allowed to view other members expenses. */
  expenseVisibilityShared?: InputMaybe<Scalars["Boolean"]>;
  /**
   * The legal entity mapping for this budget
   *
   * Defaults to the legal entity mapping of the parent budget if not specified
   */
  legalEntityMapping?: InputMaybe<LegalEntityMapping>;
  /** Limit on the budget */
  limit: FinancialAssetInput;
  /** True if limit increase request feature is enabled */
  limitIncreaseRequestEnabled?: InputMaybe<Scalars["Boolean"]>;
  /** The policy that manages limit increase requests for this budget */
  limitIncreaseRequestPolicyId?: InputMaybe<Scalars["ID"]>;
  /** Determines if budget members are allowed to view the budget limit */
  limitVisibility?: InputMaybe<BudgetLimitVisibilityType>;
  /** The employees who are considered members of this budget */
  members: Array<Scalars["ID"]>;
  /** Merchant category controls */
  merchantCategoryControls?: InputMaybe<Array<MerchantCategoryConfigInput>>;
  /** Name of the budget */
  name: Scalars["String"];
  /** True if only provisioned cards can spend from this budget */
  onlyProvisionedCardSpend: Scalars["Boolean"];
  /** The employees who are considered owners of this budget */
  owners: Array<Scalars["ID"]>;
  /** The parent of this budget, if any */
  parent: Scalars["ID"];
  /** The recurring period type of the budget. */
  periodType: BudgetPeriodType;
  /** The policy that manages expenses for this budget */
  policyId?: InputMaybe<Scalars["ID"]>;
  /** The rollover refresh rate for this budget (the recurrence by which all rolled over unused funds within the cycle should no longer roll over to the next period). */
  rolloverRefreshRate?: InputMaybe<BudgetRolloverRefreshRate>;
  /** The start date of the budget, inclusive. */
  startDate: Scalars["Date"];
  /**
   * The transaction limit for this budget
   *
   * Defaults to the transaction limit of the parent budget if not specified
   */
  transactionLimit?: InputMaybe<FinancialAssetInput>;
}

export interface CreateBudgetFromTemplateInput {
  budgetTemplateId: Scalars["ID"];
  clientMutationId: Scalars["String"];
  metadata: BudgetTemplateDerivedMetadataOneOfInput;
}

export interface CreateBudgetInput {
  clientMutationId: Scalars["String"];
  fields: CreateBudgetFields;
}

/** Fields needed to create a request for a budget. */
export interface CreateBudgetLimitIncreaseRequestFields {
  /**  If true, directly applies this budget limit increase to the budget without creating an approval request. Requires full edit access to the budget */
  bypassApproval?: InputMaybe<Scalars["Boolean"]>;
  endDate?: InputMaybe<Scalars["Date"]>;
  endingStrategy: BudgetIncreaseLimitRequestEndingStrategy;
  increaseAmount: FinancialAssetInput;
  reason: Scalars["String"];
}

/** Input to create a limit increase request for a budget. */
export interface CreateBudgetLimitIncreaseRequestInput {
  budgetId: Scalars["ID"];
  clientMutationId: Scalars["String"];
  fields: CreateBudgetLimitIncreaseRequestFields;
}

/** Fields needed to create a request for a budget. */
export interface CreateBudgetRequestFields {
  autoTransferCardsSetting?: InputMaybe<AutoTransferCardsSetting>;
  description: Scalars["String"];
  endDate?: InputMaybe<Scalars["Date"]>;
  expenseVisibilityShared?: InputMaybe<Scalars["Boolean"]>;
  limit: FinancialAssetInput;
  limitIncreaseRequestEnabled?: InputMaybe<Scalars["Boolean"]>;
  limitIncreaseRequestPolicyId?: InputMaybe<Scalars["ID"]>;
  limitVisibility?: InputMaybe<BudgetLimitVisibilityType>;
  members: Array<Scalars["ID"]>;
  merchantCategoryControls?: InputMaybe<Array<MerchantCategoryConfigInput>>;
  name: Scalars["String"];
  owners: Array<Scalars["ID"]>;
  periodType: BudgetPeriodType;
  startDate: Scalars["Date"];
}

/** Fields needed to create a request for a budget from a budget template */
export interface CreateBudgetRequestFromTemplateFields {
  budgetTemplateId: Scalars["ID"];
  merchantCategoryControls?: InputMaybe<Array<MerchantCategoryConfigInput>>;
  metadata: BudgetTemplateDerivedMetadataOneOfInput;
}

/** Input to create a request for a budget from a budget template */
export interface CreateBudgetRequestFromTemplateInput {
  clientMutationId: Scalars["String"];
  fields: CreateBudgetRequestFromTemplateFields;
}

/** Input to create a request for a budget. */
export interface CreateBudgetRequestInput {
  clientMutationId: Scalars["String"];
  fields: CreateBudgetRequestFields;
}

export interface CreateBudgetRequestResult {
  /** The budget that was created. */
  budgetRequestEntity: BudgetRequestEntity;
}

export interface CreateBudgetResult {
  /** The budget that was created. */
  budget: Budget;
  /**
   * The request that was generated when this budget was created.
   * @deprecated This field is always null. Budget Requests were moved to createBudgetRequest mutation.
   */
  request?: Maybe<BudgetRequest>;
}

/** Input to create a budget template from scratch. */
export interface CreateBudgetTemplateInput {
  budgetTemplateType: BudgetTemplateType;
}

export interface CreateBudgetTemplateResult extends MutationResult {
  /** A list of user errors for mutation responses. Clients should always request this field when performing mutations */
  errors?: Maybe<Array<ClientError>>;
  /** The result BudgetTemplate */
  result?: Maybe<BudgetTemplate>;
}

export interface CreateBudgetTemplateV2Input {
  /** Approval chains for the Spend Limit requests created from this Template */
  approvalChains?: InputMaybe<TemplateBudgetApprovalChainsInput>;
  /** The rules that define who can see this template */
  availability?: InputMaybe<BudgetTemplateAvailabilityInput>;
  /** The auto approval settings for this template */
  budgetAutoApprovalSettings?: InputMaybe<BudgetAutoApprovalSettingsInput>;
  /** Budget nesting rules for the Spend Limit requests created from this Template */
  budgetNestingRules?: InputMaybe<TemplateBudgetNestingRulesInput>;
  /** Rules for how parent budgets are assigned, who reviews budget requests, etc. */
  budgetStructure?: InputMaybe<TemplateBudgetStructureOneOfInput>;
  /** Whether or not budgets derived from this template can inherit */
  canInherit?: InputMaybe<Scalars["Boolean"]>;
  clientMutationId: Scalars["String"];
  /** A description about what this template represents */
  description?: InputMaybe<Scalars["String"]>;
  /** Default end date (if any) for budgets derived from this template */
  endDate?: InputMaybe<Scalars["Date"]>;
  /** Whether or not we want to budgets derived from this template to enforce limits */
  enforceLimit?: InputMaybe<Scalars["Boolean"]>;
  /** Default limit buffer applied to budgets derived from this template */
  enforceLimitBufferPercentage?: InputMaybe<Scalars["Int"]>;
  /** The expense policy ID associated with this budget template */
  expensePolicyId: Scalars["ID"];
  /** Whether or not budgets created from this template will share visibility */
  expenseVisibilityShared?: InputMaybe<Scalars["Boolean"]>;
  /** The limit associated with this budget template */
  limit?: InputMaybe<FinancialAssetInput>;
  /** The approval chain limit policy ID */
  limitApprovalPolicyId?: InputMaybe<Scalars["ID"]>;
  /** Whether or not budgets derived from this template may have limit increase requests applied */
  limitIncreaseRequestEnabled?: InputMaybe<Scalars["Boolean"]>;
  /** The associated limit increase request policy ID */
  limitIncreaseRequestPolicyId?: InputMaybe<Scalars["ID"]>;
  /** Determines if budget members are allowed to view the budget limit */
  limitVisibility?: InputMaybe<BudgetLimitVisibilityTypeInput>;
  /** A list of employees who may be members of budgets created from this template */
  members?: InputMaybe<Array<Scalars["ID"]>>;
  /** The name of the budget template */
  name: Scalars["String"];
  /** Whether or not only provisioned cards can spend from budgets derived from this template */
  onlyProvisionedCardSpend?: InputMaybe<Scalars["Boolean"]>;
  /** A list of employees who are to own budgets derived from these templates */
  owners?: InputMaybe<Array<Scalars["ID"]>>;
  /** Default period type for budgets derived from this template */
  periodType?: InputMaybe<BudgetPeriodTypeInput>;
  /** Default start date (if any) for budgets derived from this template */
  startDate?: InputMaybe<Scalars["Date"]>;
  /** Status of budget template. Whether it is active or inactive */
  status?: InputMaybe<BudgetTemplateStatusInput>;
  /** The type of Template this is */
  type: BudgetTemplateType;
}

export interface CreateCashTransactionInput {
  amountUsdCents: Scalars["Int"];
  /** If present, specifies the cheque attachment asset to be sent and printed */
  attachmentAsset?: InputMaybe<Scalars["String"]>;
  clientMutationId: Scalars["String"];
  /** The type of transaction to create */
  creationType: InputCashTransactionCreationArgumentUnion;
  /** Optional internal customer memo of the transaction */
  customerMemo?: InputMaybe<Scalars["String"]>;
  depositsAccountId: Scalars["ID"];
  /**
   * Optional description for transfer that will be used for the "Payment Instructions" for
   * Wires and the "Entry Description" field for Ach transactions
   */
  externalMemo?: InputMaybe<Scalars["String"]>;
  /**
   * If present, specifies the deposits account that will fund this transaction.
   * This can be the customer's Treasury account for Send From Treasury transfers for example.
   */
  fundedByDepositsAccountId?: InputMaybe<Scalars["ID"]>;
  /** If present, specifies this transaction as an international FX transaction. */
  fxQuoteId?: InputMaybe<Scalars["ID"]>;
  idempotencyKey: Scalars["String"];
  /** If true, the customer opted into Principal Protection for this transaction. */
  isPproEnabled?: InputMaybe<Scalars["Boolean"]>;
  /**
   * Notify the contact if and when the transaction moves to the processing state
   * False by default, ignored unless a credit to a contact with a valid email
   */
  notifyContactProcessing?: InputMaybe<Scalars["Boolean"]>;
  /**
   * Optional schedule to repeat the transaction on. If not set, the transaction will only be
   *  initiated once.
   */
  recurringSchedule?: InputMaybe<InputCashRecurringSchedule>;
  /**
   * Optional time to initiate the transaction. If not set, initiate the transaction as soon
   * as possible (e.g. business day)
   */
  scheduledSendAt?: InputMaybe<Scalars["Time"]>;
  /**
   * If true, emails the attachment to recipient
   * False by default
   */
  sendAttachmentEmail?: InputMaybe<Scalars["Boolean"]>;
}

export interface CreateCashTransactionPayload {
  clientMutationId: Scalars["String"];
  transaction: CashTransaction;
}

export interface CreateCashWireDetailsInput {
  clientMutationId: Scalars["String"];
  depositsAccountId?: InputMaybe<Scalars["ID"]>;
  displayTime: Scalars["Time"];
}

export interface CreateCashWireDetailsPayload {
  clientMutationId: Scalars["String"];
  report: Report;
}

export interface CreateChannelPreferencesInput {
  channelId: Scalars["ID"];
  clientMutationId: Scalars["String"];
  medium: Medium;
}

export interface CreateChannelPreferencesPayload {
  channelPreferences?: Maybe<ChannelPreferences>;
  clientMutationId: Scalars["String"];
}

export interface CreateClawbackInput {
  /** clientMutationId */
  clientMutationId: Scalars["String"];
  /** ID of the Expense being marked as a Personal Expense */
  expensesExpenseId: Scalars["ID"];
  /** Optional reasoning for why the Clawback was initiated */
  reason?: InputMaybe<Scalars["String"]>;
}

export interface CreateClawbackResult {
  /** The clawback that was created. */
  clawback: Clawback;
}

export interface CreateCommentInput {
  /** clientMutationId */
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** Whether this comment comes from normal user input or a reminder. */
  commentSource?: InputMaybe<CommentSource>;
  /** Text contents of the new Comment. */
  commentText: Scalars["String"];
  /**
   * External Entity ID.
   * For comment threads with externalEntityType=EXPENSE, this will be the Expense ID.
   */
  externalEntityId: Scalars["String"];
  /** Type of entity to associate the new comment with. */
  externalEntityType: CommentExternalEntityType;
}

export interface CreateCommentResult {
  /** Created Comment. */
  comment: Comment;
}

export interface CreateCommentsInput {
  /** clientMutationId */
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** A list of individual requests to create comments */
  createCommentInputs: Array<CreateCommentInput>;
}

export interface CreateCommentsResult {
  /** The Comments which were created */
  results: Array<CreateCommentResult>;
}

export interface CreateContactInput {
  clientMutationId: Scalars["String"];
  email?: InputMaybe<Scalars["String"]>;
  idempotencyKey: Scalars["String"];
  name: Scalars["String"];
  payeeType?: InputMaybe<PayeeType>;
  phoneNumber?: InputMaybe<Scalars["String"]>;
}

export interface CreateContactPayload {
  clientMutationId: Scalars["String"];
  contact: PaymentContact;
}

export interface CreateCopilotInput {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** Delegate user id */
  delegateUserId: Scalars["ID"];
  /** Delegator user id */
  delegatorUserId: Scalars["ID"];
  /** The time when the copilot relationship ends. */
  expiredAt?: InputMaybe<Scalars["Time"]>;
}

export interface CreateCostCenterInput {
  /** clientMutationId */
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** Name of the cost center. */
  name: Scalars["String"];
}

export interface CreateCostCenterResult {
  /** Cost center that was created. */
  costCenter: CostCenter;
}

export interface CreateCounterpartyInput {
  accountNumber?: InputMaybe<Scalars["String"]>;
  /** address is required for wire counterparties, enforced by backend service */
  address?: InputMaybe<FlexibleAddressInput>;
  approverId: Scalars["ID"];
  beneficiaryBankAddress?: InputMaybe<FlexibleAddressInput>;
  beneficiaryBankInfo?: InputMaybe<Scalars["Json"]>;
  /** International wire counterparty information */
  beneficiaryBankName?: InputMaybe<Scalars["String"]>;
  chequeRecipientName?: InputMaybe<Scalars["String"]>;
  class?: InputMaybe<Class>;
  clientMutationId: Scalars["String"];
  depositsAccountId: Scalars["ID"];
  email?: InputMaybe<Scalars["String"]>;
  location: AccountLocation;
  name: Scalars["String"];
  paymentRail: PaymentRail;
  previousCounterpartyId?: InputMaybe<Scalars["ID"]>;
  routingNumber?: InputMaybe<Scalars["String"]>;
  /** type and class are required for ach counterparties, enforce by backend service */
  type?: InputMaybe<Type>;
}

export interface CreateCounterpartyPayload {
  clientMutationId: Scalars["String"];
  counterparty: Counterparty;
}

export interface CreateCredentialInput {
  clientMutationId: Scalars["String"];
  vendor: Scalars["String"];
}

export interface CreateCredentialPayload {
  clientMutationId: Scalars["String"];
  credential?: Maybe<Credential>;
}

export interface CreateCustomRoleInput {
  capabilityKeys: Array<InputMaybe<AuthCapabilityKey>>;
  description: Scalars["String"];
  displayName: Scalars["String"];
}

export interface CreateCustomRoleResult extends MutationResult {
  errors?: Maybe<Array<AuthRoleError>>;
  result?: Maybe<AuthRole>;
}

export interface CreateCustomerSsoExclusionError extends SsoClientError {
  code?: Maybe<SsoClientErrorCode>;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export type CreateCustomerSsoExclusionResult =
  | CreateCustomerSsoExclusionError
  | CustomerSsoExclusions;

/**
 * Create a default integration field, setting the default value of the corresponding extended field to the
 * given field option, for the subsidiary in question
 */
export interface CreateDefaultIntegrationFieldMappingInput {
  clientMutationId: Scalars["String"];
  extendedFieldOptionId: Scalars["ID"];
  subsidiaryId: Scalars["ID"];
}

export interface CreateDefaultIntegrationFieldMappingResult
  extends MutationResult {
  errors?: Maybe<Array<AccountingIntegrationMutationError>>;
  result?: Maybe<DefaultIntegrationFieldMapping>;
}

export interface CreateDepartmentInput {
  clientMutationId: Scalars["String"];
  /** An optional description of the department */
  description?: InputMaybe<Scalars["String"]>;
  /** The name of the department */
  name: Scalars["String"];
}

export interface CreateDepositsApplicationInput {
  /** Cancel any existing applications of the same blueprint */
  cancelPreviousApplication?: InputMaybe<Scalars["Boolean"]>;
  clientMutationId: Scalars["String"];
  /** The specific implementation of the blueprint type. Defaults to `gemini` */
  name?: InputMaybe<Scalars["String"]>;
}

export interface CreateDepositsApplicationPayload {
  clientMutationId: Scalars["String"];
  onboardingApplication: OnboardingApplication;
}

export interface CreateDeveloperApiTokenInput {
  authorizationCode: Scalars["String"];
  clientMutationId: Scalars["String"];
  isLocalRedirect?: InputMaybe<Scalars["Boolean"]>;
  name: Scalars["String"];
}

export interface CreateDeveloperApiTokenPayload {
  clientMutationId: Scalars["String"];
  token?: Maybe<DeveloperApiToken>;
}

export interface CreateDisclosureApplicationInput {
  /** Cancel any existing applications of the same blueprint */
  cancelPreviousApplication?: InputMaybe<Scalars["Boolean"]>;
  clientMutationId: Scalars["String"];
  /** The specific implementation of the blueprint type. Defaults to `rate_fee_disclosure` */
  name?: InputMaybe<Scalars["String"]>;
}

export interface CreateDisclosureApplicationPayload {
  clientMutationId: Scalars["String"];
  onboardingApplication: OnboardingApplication;
}

export interface CreateDocumentOcrInput {
  clientMutationId: Scalars["String"];
  /** the ID of the filestore asset to be processed */
  filestoreId: Scalars["ID"];
  /** Entities to be matched in the document */
  verifyEntities?: InputMaybe<DocumentOcrVerifyEntitiesInput>;
}

export interface CreateDocumentOcrPayload {
  clientMutationId: Scalars["String"];
  /** the ID of document OCR process. This can be used to query for the OCR result. */
  documentOcrId: Scalars["ID"];
}

export interface CreateEmailChannelInput {
  clientMutationId: Scalars["String"];
  email: Scalars["Email"];
}

export interface CreateEmailChannelPayload {
  channel?: Maybe<Channel>;
  clientMutationId: Scalars["String"];
}

export interface CreateEmployeeInput {
  /** The aggregatorId for the employee. */
  aggregatorId?: InputMaybe<Scalars["String"]>;
  /** The costCenterId for the employee. */
  costCenterId?: InputMaybe<Scalars["String"]>;
  /** The departmentId for the employee. */
  departmentId?: InputMaybe<Scalars["String"]>;
  /** The email for the employee. */
  email: Scalars["String"];
  /** The employment status for the employee */
  employmentStatus?: InputMaybe<EmploymentStatus>;
  /** The employment type for the employee. */
  employmentType?: InputMaybe<EmploymentType>;
  /** An optional list of budgets to assign the user to after the user is created */
  existingBudgetIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** The first name for the employee. */
  firstName: Scalars["String"];
  /** The last name for the employee. */
  lastName: Scalars["String"];
  /** The legalEntityId for the employee. */
  legalEntityId?: InputMaybe<Scalars["String"]>;
  /** The locationId for the employee. */
  locationId?: InputMaybe<Scalars["String"]>;
  /** The manager employee id for the employee. */
  managerEmployeeId?: InputMaybe<Scalars["String"]>;
  /** An optional list of new budgets that will be created an assigned to the new user */
  newBudgets?: InputMaybe<Array<NewBudgetDetails>>;
  /** The remoteId for the employee. */
  remoteId?: InputMaybe<Scalars["String"]>;
  /** The ID of the employee's title. */
  titleId?: InputMaybe<Scalars["String"]>;
  /** The user's settings including the user role for the employee */
  userSetting?: InputMaybe<UserSetting>;
}

export interface CreateEmployeeResult {
  /** The employee that was created. */
  employee: Employee;
}

export interface CreateEmpowerCustomerInquiryInput {
  clientMutationId: Scalars["String"];
  idempotencyKey: Scalars["String"];
}

export interface CreateEmpowerCustomerInquiryPayload {
  clientMutationId: Scalars["String"];
  lead?: Maybe<LeadObject>;
}

export interface CreateEngagementSettingInput {
  /** Desired enablement of AI commenting */
  aiCommentingEnabled?: InputMaybe<Scalars["Boolean"]>;
  /** Desired ComplianceRatingProductStatus to create the setting with. */
  complianceRatingProductStatus?: InputMaybe<ComplianceRatingProductStatus>;
}

export interface CreateEngagementSettingResult {
  /** Created EngagementSetting. */
  engagementSetting: EngagementSetting;
}

/** Mapping between a entity and another value on an integration */
export interface CreateEntityMappingInput {
  /** ID of the integration. */
  integrationId: Scalars["ID"];
  /** ID of the value we are mapping from */
  mappingInputId: Scalars["ID"];
  /** ID of the extended field the value we are mapping to */
  mappingOutputFieldId?: InputMaybe<Scalars["ID"]>;
  /** ID of the value we are mapping to */
  mappingOutputId: Scalars["ID"];
  /** Type of mapping we are performing */
  mappingType: EntityMappingType;
}

export interface CreateEntityMappingResult extends MutationResult {
  errors?: Maybe<Array<AccountingIntegrationMutationError>>;
  result?: Maybe<EntityMapping>;
}

export interface CreateExpenseInput {
  /** clientMutationId */
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /**
   * The input for the expense object.
   *
   * ExpenseInput must be set.
   * It is okay to set both arguments.
   */
  expense: ExpenseInput;
  /**
   * The input for the integration fields.
   *
   * IntegrationInput is optional.
   * It is okay to set both arguments.
   */
  integration?: InputMaybe<IntegrationInput>;
  /** The receipt ids to link to the expense */
  receiptIds?: InputMaybe<Array<Scalars["ID"]>>;
}

export interface CreateExpenseNotificationInput {
  /** The specification of the expense notification to send */
  expenseNotificationDetails: ExpenseNotificationDetailsOneOf;
  /** Idempotency key for the notification attempt */
  idempotencyKey: Scalars["String"];
}

export interface CreateExpenseNotificationResult {
  /** Status of the notification attempt */
  status: CreateExpenseNotificationStatus;
}

export enum CreateExpenseNotificationStatus {
  FAILURE_INTERNAL = "FAILURE_INTERNAL",
  FAILURE_NO_CHANNEL = "FAILURE_NO_CHANNEL",
  SUCCESS = "SUCCESS",
}

export interface CreateExpenseReportInput {
  /** The idempotency key */
  clientMutationId: Scalars["String"];
  /** The expense report creation fields */
  fields: CreateExpenseReportInputFields;
}

export interface CreateExpenseReportInputFields {
  /** [Optional] Description of what the expense report is used for */
  description?: InputMaybe<Scalars["String"]>;
  /** End date of the expense report */
  endDate?: InputMaybe<Scalars["Date"]>;
  /** The ID of the expense policy for this expense report */
  expensePolicyId: Scalars["ID"];
  /** [Optional] Legal entity mapping of the expense report */
  legalEntityMapping?: InputMaybe<LegalEntityMapping>;
  /** Name of the expense report */
  name: Scalars["String"];
  /** Start date of the expense report */
  startDate?: InputMaybe<Scalars["Date"]>;
}

export interface CreateExpenseReportResult extends MutationResult {
  errors?: Maybe<Array<ExpenseReportMutationError>>;
  expenseReport?: Maybe<ExpenseReport>;
}

export interface CreateExpenseResult {
  /** List of errors when creating the expense */
  errors?: Maybe<Array<ExpenseMutationError>>;
  /** The expense that was created. */
  expense?: Maybe<Expense>;
}

export interface CreateExpensesSearchReportInput {
  /** clientMutationId */
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** Time when expenses search results were displayed. */
  displayTime?: InputMaybe<Scalars["Time"]>;
  /**
   * The expense filter input used to get the list of expenses to be exported.
   * Only one of [filter, executeQueryFilter] can be specified.
   * If both are specified, queryFilter will take precedence.
   */
  filter?: InputMaybe<ExpenseFilterInput>;
  /**
   * [oneOf] Entity Filter to be provided into QueriesService.executeQuery().
   * Only one of [filter, executeQueryFilter] can be specified.
   * If both are specified, queryFilter will take precedence.
   */
  queryFilter?: InputMaybe<ExpenseReportQueryInput>;
  /** The report format type for the exported expenses search. */
  reportFormat?: InputMaybe<ReportFormatType>;
  /** The report mode which is used to return specific columns */
  reportMode?: InputMaybe<ReportMode>;
  /** The report options for the exported expenses search. */
  reportOptions?: InputMaybe<Array<ReportOption>>;
}

export interface CreateExpensesSearchReportResult {
  /** The expenses search report. */
  report: ExpensesReport;
}

/** Top-level input fields for creating an extended field */
export interface CreateExtendedFieldInput {
  clientMutationId: Scalars["String"];
  field: ExtendedFieldCreationInput;
}

export interface CreateExtendedFieldOptionsReportInput {
  /** Format of the report */
  extendedFieldOptionReportFormat: ExtendedFieldOptionReportFormat;
  /** Filter for the EFOs to include in the report */
  filter: ExtendedFieldOptionsFilterInput;
}

export interface CreateExtendedFieldOptionsReportResult {
  asset: Asset;
}

/** Response of extended field creation */
export interface CreateExtendedFieldResult {
  extendedField: ExtendedField;
}

/** Top-level input fields for creating an extended field visibility rule */
export interface CreateExtendedFieldVisibilityRuleInput {
  visibilityRule: ExtendedFieldVisibilityRuleCreationInput;
}

/** Response of extended field visibility rule creation */
export interface CreateExtendedFieldVisibilityRuleResult
  extends MutationResult {
  errors?: Maybe<Array<ExtendedFieldVisibilityRuleMutationError>>;
  extendedFieldVisibilityRule: ExtendedFieldVisibilityRule;
}

/** Top-level input fields for creating multiple extended fields */
export interface CreateExtendedFieldsInput {
  clientMutationId: Scalars["String"];
  fieldInputs: Array<ExtendedFieldCreationInput>;
}

/** Response of extended fields creation */
export interface CreateExtendedFieldsResult {
  extendedFields: Array<ExtendedField>;
}

/** CreateFeedback input */
export interface CreateFeedbackInput {
  /** Unique identifier of this mutation */
  clientMutationId: Scalars["String"];
  /** Collection of Feedback Messages associated with Feedback */
  feedbackMessageInputs?: InputMaybe<
    Array<InputMaybe<CreateFeedbackMessageInput>>
  >;
  /** Source of Feedback */
  feedbackSource?: InputMaybe<FeedbackSource>;
  /** Type of Feedback */
  feedbackType?: InputMaybe<FeedbackType>;
  /** Subject that describes this Feedback */
  subjectLine?: InputMaybe<Scalars["String"]>;
}

/** CreateFeedbackMessage input */
export interface CreateFeedbackMessageInput {
  /** The prompt or question the user saw when submitting a response */
  prompt: Scalars["String"];
  /** Freeform text submitted by the user */
  response?: InputMaybe<Scalars["String"]>;
}

/** CreateFeedback output */
export interface CreateFeedbackPayload {
  /** Unique identifier of this mutation */
  clientMutationId: Scalars["String"];
  /** The created Feedback entity */
  feedback?: Maybe<Feedback>;
}

export interface CreateFileUploadUrlInput {
  /** Idempotency key */
  clientMutationId: Scalars["String"];
}

export interface CreateFileUploadUrlPayload {
  /** Idempotency key */
  clientMutationId: Scalars["String"];
  /** Server generated id that identifies the uploaded object key (used for idempotence) */
  uploadRequestId?: Maybe<Scalars["String"]>;
  /** The URL that can be used to upload a file. */
  uploadUrl?: Maybe<Scalars["String"]>;
}

export interface CreateFinancialBankStatementForNewAccountInput {
  assetId: Scalars["ID"];
  clientMutationId: Scalars["String"];
}

export interface CreateFinancialBankStatementForNewAccountPayload {
  clientMutationId: Scalars["String"];
}

export interface CreateFinancialBankStatementInput {
  assetId: Scalars["ID"];
  clientMutationId: Scalars["String"];
  financialAccountId: Scalars["ID"];
}

export interface CreateFinancialBankStatementPayload {
  clientMutationId: Scalars["String"];
}

export interface CreateFinancialDocumentInput {
  /** clientMutationId client-supplied idempotency key for a given mutation request. */
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** type of supporting document */
  documentType: FinancialDocumentType;
  /** Base-64 Encoded Filestore ID */
  encodedFilestoreId: Scalars["ID"];
  /** The required item ID to associate this document */
  encodedRequiredItemId?: InputMaybe<Scalars["ID"]>;
  /** The required item mapping ID to associate this document */
  encodedRequiredItemMappingId?: InputMaybe<Scalars["ID"]>;
  /** The financial statement request to associate this document */
  encodedStatementRequestId: Scalars["ID"];
}

export interface CreateFinancialDocumentResult extends MutationResult {
  errors?: Maybe<Array<LimitsExperienceMutationError>>;
  /** API response */
  result?: Maybe<FinancialDocument>;
}

export interface CreateFraudDisputeFromExpenseInput {
  cardPossession: CardPossession;
  executedByLeftEmployee?: InputMaybe<Scalars["Boolean"]>;
  executedByNonCompliantEmployee?: InputMaybe<Scalars["Boolean"]>;
  expenseIds: Array<Scalars["ID"]>;
  fraudulentDeclinedExpenseIds?: InputMaybe<Array<Scalars["ID"]>>;
  legitimateExpenseIds?: InputMaybe<Array<Scalars["ID"]>>;
  reason: Scalars["String"];
}

export interface CreateFraudDisputeFromExpenseResult {
  disputeId: Scalars["ID"];
}

export interface CreateFundingSourceForPendingMicroDepositsInput {
  clientMutationId: Scalars["String"];
  financialSourceId: Scalars["String"];
}

export interface CreateFundingSourceForPendingMicroDepositsPayload {
  clientMutationId: Scalars["String"];
  fundingSource: FundingSource;
}

export interface CreateFundingSourceInput {
  bankAccountSource: BankAccountSourceInput;
  clientMutationId: Scalars["String"];
  idempotencyKey: Scalars["String"];
  priority?: InputMaybe<FundingSourcePriority>;
  provenance?: InputMaybe<FundingSourceProvenance>;
  type: Scalars["String"];
}

export interface CreateFundingSourcePayload {
  clientMutationId: Scalars["String"];
  fundingSource: FundingSource;
}

export interface CreateGroupEventFields {
  accommodation?: InputMaybe<LocationMetadataInput>;
  agendaLink?: InputMaybe<Scalars["String"]>;
  carRequirement?: InputMaybe<BookingRequirement>;
  commsChannelLink?: InputMaybe<Scalars["String"]>;
  commsChannelTitle?: InputMaybe<Scalars["String"]>;
  coverPhotoAssetId?: InputMaybe<Scalars["String"]>;
  description?: InputMaybe<Scalars["String"]>;
  destination?: InputMaybe<LocationMetadataInput>;
  endDate?: InputMaybe<Scalars["Date"]>;
  /** pass either end time or end date. If both are passed, end time will be used. */
  endTime?: InputMaybe<Scalars["LocalDateTime"]>;
  flightRequirement?: InputMaybe<BookingRequirement>;
  hotelRequirement?: InputMaybe<BookingRequirement>;
  name: Scalars["String"];
  pointOfContact?: InputMaybe<Scalars["String"]>;
  preferredAirportCode?: InputMaybe<Scalars["String"]>;
  railRequirement?: InputMaybe<BookingRequirement>;
  startDate?: InputMaybe<Scalars["Date"]>;
  /** pass either start time or start date. If both are passed, start time will be used. */
  startTime?: InputMaybe<Scalars["LocalDateTime"]>;
  timezone?: InputMaybe<Scalars["String"]>;
}

export interface CreateGroupEventInput {
  clientMutationId: Scalars["String"];
  fields: CreateGroupEventFields;
}

export interface CreateGroupEventResult {
  /**  Error, null if no error */
  error?: Maybe<Scalars["String"]>;
  /**  Created group event entity, null if there was an error */
  groupEvent?: Maybe<GroupEvent>;
}

export interface CreateGroupInput {
  displayName: Scalars["String"];
  memberCondition?: InputMaybe<MemberConditionInput>;
  members?: InputMaybe<Array<GroupMemberInput>>;
  resources?: InputMaybe<Array<ResourceInput>>;
  status?: InputMaybe<GroupStatus>;
  syncType?: InputMaybe<GroupSyncType>;
}

export interface CreateGroupResult extends MutationResult {
  errors?: Maybe<Array<GroupsMutationError>>;
  result?: Maybe<Group>;
}

export interface CreateHrConnectionInput {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  publicToken: Scalars["String"];
}

export type CreateIdpConfigResult =
  | CreateIdpConfigResultError
  | CustomerSsoSettings;

export interface CreateIdpConfigResultError extends SsoClientError {
  code?: Maybe<SsoClientErrorCode>;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface CreateIntegrationInput {
  billsEnabled?: InputMaybe<Scalars["Boolean"]>;
  clientMutationId: Scalars["String"];
  /** Credential id to use for the new integration. Leave blank when passing vendor = 'csv' */
  credentialId?: InputMaybe<Scalars["ID"]>;
  /** List of required data to generate all subsidiares */
  erpSubsidiaryInputs?: InputMaybe<Array<InputMaybe<SubsidiaryInput>>>;
  /** Sets the parent subsidiary. Should be renamed to parent subsidiary in the future */
  netsuiteSubsidiary?: InputMaybe<SubsidiaryInput>;
  /** (Optional) Additional arguments used by the Sage Intacct integration */
  sageintacct?: InputMaybe<SageintacctInput>;
  scopes: Array<InputMaybe<IntegrationScope>>;
  /** The vendor of this Integration (e.g. :xero, :netsuite, :universal_csv) */
  vendor?: InputMaybe<IntegrationVendor>;
  version?: InputMaybe<Scalars["Int"]>;
}

export interface CreateIntegrationPayload {
  clientMutationId: Scalars["String"];
  integration?: Maybe<Integration>;
}

export interface CreateIntegrationRuleInput {
  body: Scalars["Json"];
  clientMutationId: Scalars["String"];
  integrationId: Scalars["ID"];
  name?: InputMaybe<Scalars["String"]>;
  priority: Scalars["Int"];
  type: Scalars["String"];
}

export interface CreateIntegrationRulePayload {
  clientMutationId: Scalars["String"];
  /** the integration containing new rule */
  integration?: Maybe<Integration>;
}

export interface CreateInvoiceInput {
  clientMutationId: Scalars["String"];
  depositsAccountId?: InputMaybe<Scalars["ID"]>;
  discountAmount?: InputMaybe<FinancialAssetInput>;
  discountPercent?: InputMaybe<Scalars["Float"]>;
  dueDate?: InputMaybe<Scalars["Date"]>;
  idempotencyKey: Scalars["String"];
  invoiceNumber: Scalars["String"];
  invoiceTemplateId: Scalars["ID"];
  invoicingAccountId?: InputMaybe<Scalars["ID"]>;
  lineItems?: InputMaybe<Array<InputMaybe<InvoiceLineItemInput>>>;
  memo?: InputMaybe<Scalars["String"]>;
  payerContactId?: InputMaybe<Scalars["ID"]>;
  subtotal?: InputMaybe<FinancialAssetInput>;
  totalAmount?: InputMaybe<FinancialAssetInput>;
}

export interface CreateInvoicePayload {
  clientMutationId: Scalars["String"];
  invoice?: Maybe<InvoicingInvoice>;
}

export interface CreateInvoiceTemplateInput {
  clientMutationId: Scalars["String"];
  footer?: InputMaybe<Scalars["String"]>;
  header?: InputMaybe<Scalars["String"]>;
  idempotencyKey: Scalars["String"];
  invoicerContactId?: InputMaybe<Scalars["ID"]>;
  invoicingAccountId: Scalars["ID"];
  logoAssetId?: InputMaybe<Scalars["ID"]>;
  note?: InputMaybe<Scalars["String"]>;
  setAsDefaultTemplate?: InputMaybe<Scalars["Boolean"]>;
}

export interface CreateInvoiceTemplatePayload {
  clientMutationId: Scalars["String"];
  invoiceTemplate?: Maybe<InvoiceTemplate>;
}

export interface CreateInvoiceTemplateV1Fields {
  /** Template footer */
  footer?: InputMaybe<Scalars["String"]>;
  /** Template header */
  header?: InputMaybe<Scalars["String"]>;
  /** Contact ID of the invoicer. */
  invoicerContactId?: InputMaybe<Scalars["ID"]>;
  /** File asset ID to the logo. */
  logoAssetId?: InputMaybe<Scalars["String"]>;
  /** Template note. */
  note?: InputMaybe<Scalars["String"]>;
  /** Boolean flag to indicate if this template is to be set as the default for the owning account. */
  setAsDefaultTemplate?: InputMaybe<Scalars["Boolean"]>;
}

export interface CreateInvoiceTemplateV1Input {
  /** Fields for creation. */
  fields: CreateInvoiceTemplateV1Fields;
  /** Idempotency key. */
  idempotencyKey: Scalars["String"];
  /** ID of the owning InvoicingAccount */
  invoicingAccountId: Scalars["ID"];
}

export interface CreateInvoiceV1Fields {
  /** Whether customer allows this invoice to be paid via EBA ACH - optional for backwards compatibility and defaults to Null */
  allowEbaAch?: InputMaybe<Scalars["Boolean"]>;
  /** Attachment asset IDs. */
  attachmentAssetIds?: InputMaybe<Array<Scalars["String"]>>;
  /** ID of deposits account that is expected to receive funds. */
  depositsAccountId?: InputMaybe<Scalars["ID"]>;
  /** Invoice discount. */
  discount?: InputMaybe<InvoiceDiscountV1OneOfInput>;
  /** Invoice due date. */
  dueDate?: InputMaybe<Scalars["Date"]>;
  /** ID of InvoicingAccount. */
  invoicingAccountId: Scalars["ID"];
  /**
   * Invoice issue date. Could refer to a date from the past when the service is done.
   * If no value is provided, we will use the current date.
   */
  issuedDate?: InputMaybe<Scalars["Date"]>;
  /** Invoice line items. */
  lineItems?: InputMaybe<Array<InvoiceLineItemV1Input>>;
  /** Invoice memo. */
  memo?: InputMaybe<Scalars["String"]>;
  /** ID of payer contact. i.e. the counterparty that is expected to pay this invoice. */
  payerContactId?: InputMaybe<Scalars["ID"]>;
  /** Preferred payment method. */
  paymentMethod?: InputMaybe<InvoicePaymentMethodV1>;
  /** Invoice PO number. */
  poNumber?: InputMaybe<Scalars["String"]>;
  /** ID of invoice Recipient. i.e. the invoicingCustomer that is expected to pay this invoice. */
  recipientId?: InputMaybe<Scalars["ID"]>;
  /** Recurring schedule to repeat sending these invoice details. */
  recurringSchedule?: InputMaybe<RecurringScheduleRuleOneOfInput>;
  /** Reminder types. */
  reminderTypes?: InputMaybe<Array<InvoiceReminderType>>;
  /** Whether to generate the payment link or not. */
  shouldGeneratePaymentLink?: InputMaybe<Scalars["Boolean"]>;
  /** Invoice subtotal amount. */
  subtotal?: InputMaybe<FinancialAssetInput>;
  /** Tax on the invoice. Expressed as a percentage */
  tax?: InputMaybe<Scalars["Float"]>;
  /** ID of invoice template used to generate the invoice PDF. */
  templateId?: InputMaybe<Scalars["ID"]>;
  /** Invoice total amount. */
  total?: InputMaybe<FinancialAssetInput>;
}

export interface CreateInvoiceV1Input {
  /** Creation fields. */
  fields: CreateInvoiceV1Fields;
  /** A unique idempotency key. */
  idempotencyKey: Scalars["String"];
}

export interface CreateInvoicingAccountFields {
  /** Contact address of the account. */
  address?: InputMaybe<InvoicingAddressV1Input>;
  /** Doing business as. */
  dbaName?: InputMaybe<Scalars["String"]>;
  /** Email address. */
  email?: InputMaybe<Scalars["String"]>;
  /** Invoice template footer */
  footer?: InputMaybe<Scalars["String"]>;
  /** Invoice template header. */
  header?: InputMaybe<Scalars["String"]>;
  /** Optional invoice number prefix. */
  invoiceNumberPrefix?: InputMaybe<Scalars["String"]>;
  /** File asset ID to the company logo. */
  logoAssetId?: InputMaybe<Scalars["String"]>;
  /** The invoice number to begin with. */
  nextInvoiceNumber?: InputMaybe<Scalars["Int"]>;
  /** Invoice template note. */
  note?: InputMaybe<Scalars["String"]>;
  /** Phone number. */
  phoneNumber?: InputMaybe<Scalars["String"]>;
}

export interface CreateInvoicingAccountV1Input {
  /** Creation fields. */
  fields: CreateInvoicingAccountFields;
  /** Idempotency key. */
  idempotencyKey: Scalars["String"];
}

export interface CreateInvoicingContactV1Fields {
  /** Address. */
  address?: InputMaybe<InvoicingAddressV1Input>;
  /** Type of contact. */
  contactType: InvoicingContactTypeV1;
  /** Doing Business As. */
  dbaName?: InputMaybe<Scalars["String"]>;
  /** Email address. */
  email?: InputMaybe<Scalars["String"]>;
  /** ID of InvoicingAccount. */
  invoicingAccountId: Scalars["ID"];
  /** Phone number. */
  phoneNumber?: InputMaybe<Scalars["String"]>;
}

export interface CreateInvoicingContactV1Input {
  /** Creation fields. */
  fields: CreateInvoicingContactV1Fields;
  /** A unique idempotency key. */
  idempotencyKey: Scalars["String"];
}

export interface CreateItineraryActivityFields {
  description?: InputMaybe<Scalars["String"]>;
  endDateTime: Scalars["LocalDateTime"];
  location: LocationMetadataInput;
  startDateTime: Scalars["LocalDateTime"];
  timezone: Scalars["String"];
  title: Scalars["String"];
  type: ItineraryActivityType;
}

export interface CreateItineraryActivityInput {
  clientMutationId: Scalars["String"];
  fields: CreateItineraryActivityFields;
  groupEventId: Scalars["ID"];
}

export interface CreateItineraryActivityResult {
  error?: Maybe<Scalars["String"]>;
  itineraryActivity?: Maybe<ItineraryActivity>;
}

export interface CreateLLMOAuthIntegrationError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface CreateLLMOAuthIntegrationInput {
  /** required if mobile */
  codeVerifier?: InputMaybe<Scalars["String"]>;
  oauthAuthorizationCode: Scalars["String"];
}

export interface CreateLLMOAuthIntegrationResult {
  error?: Maybe<CreateLLMOAuthIntegrationError>;
  result?: Maybe<LLMOAuthIntegration>;
}

export interface CreateLeadInput {
  attributionMetadata?: InputMaybe<LeadAttributionMetadata>;
  clientMutationId: Scalars["String"];
  idempotencyKey: Scalars["String"];
  leadDetails?: InputMaybe<LeadDetailsInput>;
  leadFormStatus: LeadFormStatus;
  leadFormType: LeadFormType;
  marketoProgramName: Scalars["String"];
}

export interface CreateLeadPayload {
  clientMutationId: Scalars["String"];
  lead?: Maybe<LeadObject>;
}

export interface CreateLegalEntityInput {
  /** clientMutationId */
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** Name of the legal entity. */
  name: Scalars["String"];
}

export interface CreateLegalEntityResult {
  /** Legal entity that was created. */
  legalEntity: LegalEntity;
}

/** Input for limit group overrides for financial asset type fields */
export interface CreateLimitGroupFinancialAssetFieldOverride {
  memberCondition: CreateLimitGroupOverrideMemberConditionInput;
  value: FinancialAssetInput;
}

/** Input for limit group creation */
export interface CreateLimitGroupInput {
  /** The idempotency key */
  clientMutationId: Scalars["String"];
  /** The spend limit group creation fields */
  fields: CreateLimitGroupInputFields;
}

export interface CreateLimitGroupInputFields {
  /** The default limit fields that are applied to all the limits of the limit group */
  defaultLimitFields: CreateSpendLimitBlueprintFields;
  /** The description of the limit group */
  description?: InputMaybe<Scalars["String"]>;
  /** The name of the limit group */
  name: Scalars["String"];
  /** Optional overrides on eligible spend limit fields for specific groups */
  spendLimitFieldOverrides?: InputMaybe<CreateLimitGroupOverrides>;
  /** User group configuration to be applied to the group associated with this limit group */
  userGroup: UserGroupInput;
}

export interface CreateLimitGroupOverrideMemberConditionInput {
  memberCondition?: InputMaybe<MemberConditionInput>;
  /** The member ids additional to the member condition */
  memberIds?: InputMaybe<Array<Scalars["ID"]>>;
}

/** Input for limit group overrides on eligible fields */
export interface CreateLimitGroupOverrides {
  /** Overrides on the limit field of a spend limit */
  limit?: InputMaybe<Array<CreateLimitGroupFinancialAssetFieldOverride>>;
}

export interface CreateLimitGroupResult {
  /** The limit group that was created. */
  limitGroup: LimitGroup;
  /** The number of members that will be added to the limit group. */
  previewMembersCount?: Maybe<Scalars["Int"]>;
}

export interface CreateLineItemInput {
  /** The idempotency key for this line item creation */
  idempotencyKey: Scalars["String"];
  /** The input for the line item object. */
  lineItem: LineItemInput;
}

export interface CreateLinkTokenInput {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  hrSystem: HrSystem;
}

export interface CreateLinkTokenResult {
  linkToken: Scalars["String"];
}

export interface CreateLocationInput {
  clientMutationId: Scalars["String"];
  /** An optional description of the location */
  description?: InputMaybe<Scalars["String"]>;
  /** The name of the location */
  name: Scalars["String"];
}

export interface CreateManualPushPaymentStatusInput {
  /** The billing entity ID that this status is being created for */
  billingEntityId: Scalars["ID"];
  status?: InputMaybe<PushPaymentStatus>;
}

export interface CreateManualPushPaymentStatusResponse {
  manualPushPaymentStatus?: Maybe<ManualPushPaymentStatus>;
}

export interface CreateMappingClassInput {
  /** The left hand side of the mapping class action. */
  actionLeft: LeftHandSideOneOfInput;
  /** Optional automatch status. Defaults to DISABLED. */
  automatchStatus?: InputMaybe<MappingClassAutomatchStatus>;
  /** The left hand side of the mapping class filter. */
  filterLeft: LeftHandSideOneOfInput;
  /**
   * The integration that this mapping class is for.
   * Leave this blank if the Mapping Class is not tied to an Integration (i.e. both fields are not tied to an integration)
   */
  integrationId?: InputMaybe<Scalars["ID"]>;
}

export interface CreateMappingClassResult {
  mappingClass: MappingClass;
}

export interface CreateMappingInput {
  /** The right hand side of the mapping action. */
  actionRight?: InputMaybe<RightHandSideSingleValueOneOfInput>;
  /** The right hand side of the mapping filter. */
  filterRight: RightHandSideSingleValueOneOfInput;
  /** The mapping class that the mapping belongs to. */
  mappingClassId: Scalars["ID"];
}

export interface CreateMappingResult {
  mapping: Mapping;
}

export interface CreateMerchantDisputeFromExpenseInput {
  additionalInput?: InputMaybe<AdditionalMerchantDisputeInput>;
  evidenceAssetIds?: InputMaybe<Array<Scalars["ID"]>>;
  expectedAmount?: InputMaybe<Scalars["Int"]>;
  expenseIds: Array<Scalars["ID"]>;
  reason: Scalars["String"];
  relatedExpenseIds?: InputMaybe<Array<Scalars["ID"]>>;
}

export interface CreateMerchantDisputeFromExpenseResult {
  disputeId: Scalars["ID"];
}

export interface CreateMilesTransferPayloadV2 {
  clientMutationId?: Maybe<Scalars["String"]>;
  /** Created miles transfer object */
  milesTransfer?: Maybe<MilesTransferV2>;
}

export interface CreateMilesTransferV2Input {
  /** ID of the mutation. Currently unused but required for backwards compatibility. */
  clientMutationId: Scalars["String"];
  /** ID of the loyalty program being used */
  loyaltyProgramId: Scalars["String"];
  /** Amount of miles being transferred */
  milesAmount: Scalars["Int"];
  /** Amount of points being transferred */
  pointsAmount: Scalars["Int"];
  /** Information about the program membership being used for the transfer */
  programMembership: ProgramMembershipPayload;
  /** ID of the redemption offer being transferred */
  redemptionOfferId: Scalars["String"];
  /** ID of the customer user receiving the transfer */
  toCustomerUserId: Scalars["String"];
}

export interface CreateNetsuiteCredentialInput {
  accountId: Scalars["String"];
  clientMutationId: Scalars["String"];
  /** Development id suffix for a user's Netsuite RESTlet SuiteScript. */
  deploymentId?: InputMaybe<Scalars["String"]>;
  /** Script id suffix for a user's Netsuite RESTlet SuiteScript. */
  scriptId?: InputMaybe<Scalars["String"]>;
  tokenId: Scalars["String"];
  tokenSecret: Scalars["String"];
  /** The name of the erp */
  vendorName?: InputMaybe<Scalars["String"]>;
}

export interface CreateNetsuiteCredentialPayload {
  /** Result of authentication - either success or failure, plus additional info */
  authenticationResult?: Maybe<CredentialAuthenticationResult>;
  clientMutationId: Scalars["String"];
}

export interface CreateNonPrimaryDepositsAccountInput {
  accountType?: InputMaybe<DepositsAccountType>;
  clientMutationId: Scalars["String"];
  displayColor: DepositsAccountsDisplayColor;
  idempotencyKey: Scalars["String"];
  nickname: Scalars["String"];
}

export interface CreateNonPrimaryDepositsAccountPayload {
  clientMutationId: Scalars["String"];
  depositsAccount: DepositsAccount;
}

export interface CreateOnboardingApplicationInput {
  financialAccountId: Scalars["ID"];
}

export interface CreateOnboardingApplicationResult {
  id?: Maybe<Scalars["String"]>;
}

export interface CreateOnboardingKycApplicationInput {
  /** Cancel any existing applications of the same named blueprint */
  cancelPreviousApplication?: InputMaybe<Scalars["Boolean"]>;
  clientMutationId: Scalars["String"];
  /** Legal entity id associated with this application */
  entityId?: InputMaybe<Scalars["String"]>;
  /** The specific implementation of the blueprint type */
  name: Scalars["String"];
}

export interface CreateOnboardingKycApplicationPayload {
  clientMutationId: Scalars["String"];
  onboardingApplication: OnboardingApplication;
}

export interface CreateOnboardingProductApplicationInput {
  /** Cancel any existing applications of the same named blueprint */
  cancelPreviousApplication?: InputMaybe<Scalars["Boolean"]>;
  clientMutationId: Scalars["String"];
  /** The specific implementation of the blueprint type */
  name: Scalars["String"];
}

export interface CreateOnboardingProductApplicationPayload {
  clientMutationId: Scalars["String"];
  onboardingApplication: OnboardingApplication;
}

export interface CreateOnboardingProductV2ApplicationInput {
  /** Cancel any existing applications of the same named blueprint */
  cancelPreviousApplication?: InputMaybe<Scalars["Boolean"]>;
  clientMutationId: Scalars["String"];
  /** The specific implementation of the blueprint type */
  name: Scalars["String"];
}

export interface CreateOnboardingProductV2ApplicationPayload {
  clientMutationId: Scalars["String"];
  onboardingApplication: OnboardingApplication;
}

export interface CreateOrUpdateAiPolicySettingError
  extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

/** Input for creating or updating AI policy settings */
export interface CreateOrUpdateAiPolicySettingInput {
  /** List of expense types that should be enabled for AI policy processing */
  expenseTypes: Array<ExpenseType>;
  /** List of spend limit IDs that should be enabled for AI policy processing */
  spendLimitIds: Array<Scalars["ID"]>;
}

export interface CreateOrUpdateAiPolicySettingResult extends MutationResult {
  errors?: Maybe<Array<CreateOrUpdateAiPolicySettingError>>;
  result?: Maybe<AiPolicySetting>;
}

export interface CreateOrUpdateApprovalChainPolicyInput {
  /** The approval chains for budget approvals */
  approvalChainDefinition?: InputMaybe<TemplateBudgetApprovalChainsInput>;
  /** Approval chain policy that should be updated with the new definition. If empty, a new policy will be created. */
  approvalChainPolicyId?: InputMaybe<Scalars["ID"]>;
  /** Currency of the policy */
  currency?: InputMaybe<Scalars["String"]>;
  /** A description that will describe this policy to users. */
  description?: InputMaybe<Scalars["String"]>;
  /** A name that will allow users to identify this policy. */
  displayName: Scalars["String"];
  /** A limit increase policy that should be updated with the new definition, will be removed soon. If empty, a new policy will be created. */
  limitIncreasePolicyId?: InputMaybe<Scalars["ID"]>;
}

export interface CreateOrUpdateAutoInviteSettingResult extends MutationResult {
  errors?: Maybe<Array<AutoInviteSettingError>>;
  result?: Maybe<AutoInviteSetting>;
}

export interface CreateOrUpdateBudgetPolicyInput {
  /** The approval chains for budget approvals */
  approvalChainDefinition?: InputMaybe<TemplateBudgetApprovalChainsInput>;
  /** Currency of the policy */
  currency?: InputMaybe<Scalars["String"]>;
  /** A description that will describe this policy to users. */
  description?: InputMaybe<Scalars["String"]>;
  /** A name that will allow users to identify this policy. */
  displayName: Scalars["String"];
  /** A policy that should be updated with the new definition. If empty, a new policy will be created. */
  policyId?: InputMaybe<Scalars["ID"]>;
}

/** Input type for creating or updating an expense policy. */
export interface CreateOrUpdateExpensePolicyInput {
  /** Parameters for generating the new policy definition. */
  generateExpensePolicyRequest: GenerateExpensePolicyRequest;
  /** A policy that should be updated with the new definition. If empty, a new policy will be created. */
  policyId?: InputMaybe<Scalars["ID"]>;
}

/**
 * Should only contain one details type
 * (@oneOf is not supported for inputs)
 */
export interface CreateOrUpdatePolicyInput {
  bankingTransactionPolicyDetails: BankingTransactionPolicyDetailsInput;
  policyEnrollmentStatus: PolicyEnrollmentStatus;
  policyType: BankingPolicyType;
}

export interface CreateOracleFusionCredentialInput {
  clientMutationId: Scalars["String"];
  /** Host URL to connect to */
  host: Scalars["String"];
  /** Password for the service user */
  password: Scalars["String"];
  /** Structure Code of the users Chart of the Accounts */
  structureCode: Scalars["String"];
  /** Username for the service user */
  username: Scalars["String"];
  /** The name of the erp */
  vendorName?: InputMaybe<Scalars["String"]>;
}

export interface CreateOracleFusionCredentialPayload {
  /** Result of authentication - either success or failure, plus additional info */
  authenticationResult?: Maybe<CredentialAuthenticationResult>;
  clientMutationId: Scalars["String"];
}

export interface CreatePayerInput {
  address?: InputMaybe<ContactAddressInput>;
  clientMutationId: Scalars["String"];
  dbaName?: InputMaybe<Scalars["String"]>;
  email?: InputMaybe<Scalars["String"]>;
  idempotencyKey: Scalars["String"];
  invoicingAccountId: Scalars["ID"];
  phoneNumber?: InputMaybe<Scalars["String"]>;
}

export interface CreatePayerPayload {
  clientMutationId: Scalars["String"];
  payer?: Maybe<InvoicingContact>;
}

export interface CreatePaymentEarlyAuthBalanceDecreaseCommitmentInput {
  clientMutationId: Scalars["String"];
}

export interface CreatePaymentEarlyAuthBalanceDecreaseCommitmentPayload {
  clientMutationId: Scalars["String"];
  paymentEarlyAuthBalanceDecreaseCommitment: PaymentEarlyAuthBalanceDecreaseCommitment;
}

export interface CreatePaymentFxQuoteInput {
  /** The bank provider handling the payment */
  bankProvider?: InputMaybe<CashTransactionBankProvider>;
  beneficiaryAmount?: InputMaybe<Scalars["Decimal"]>;
  beneficiaryCurrency: Scalars["String"];
  clientMutationId: Scalars["String"];
  /** The deposits account that is making this payment */
  depositsAccountId?: InputMaybe<Scalars["ID"]>;
  originatorAmount?: InputMaybe<Scalars["Decimal"]>;
  originatorCurrency: Scalars["String"];
  railType: PaymentFxQuoteRailType;
}

export interface CreatePaymentFxQuotePayload {
  clientMutationId: Scalars["String"];
  paymentFxQuote: PaymentFxQuote;
}

export interface CreatePaymentInstrumentInput {
  achPaymentInstrument?: InputMaybe<AchPaymentInstrumentInput>;
  /** For Banking Counterparty payment instrument */
  bankingCounterpartyPaymentInstrument?: InputMaybe<BankingCounterpartyPaymentInstrumentInput>;
  /** Payment instrument's beneficiary business name, set when beneficiary type is business */
  beneficiaryBusinessName?: InputMaybe<Scalars["String"]>;
  /** Payment instrument's beneficiary first name, set when beneficiary type is individual */
  beneficiaryFirstName?: InputMaybe<Scalars["String"]>;
  /** Payment instrument's beneficiary last name, set when beneficiary type is individual */
  beneficiaryLastName?: InputMaybe<Scalars["String"]>;
  /** Payment instrument's beneficiary name */
  beneficiaryName?: InputMaybe<Scalars["String"]>;
  /** Payment instrument's beneficiary type */
  beneficiaryType?: InputMaybe<PaymentInstrumentBeneficiaryType>;
  chequePaymentInstrument?: InputMaybe<ChequePaymentInstrumentInput>;
  clientMutationId: Scalars["String"];
  contactId: Scalars["ID"];
  counterpartyPaymentInstrument?: InputMaybe<CounterpartyPaymentInstrumentInput>;
  domesticWirePaymentInstrument?: InputMaybe<DomesticWirePaymentInstrumentInput>;
  internationalWirePaymentInstrument?: InputMaybe<InternationalWirePaymentInstrumentInput>;
  internationalWirePaymentInstrumentForBankingCounterparty?: InputMaybe<BankingCounterpartyInput>;
}

export interface CreatePaymentInstrumentPayload {
  clientMutationId: Scalars["String"];
  paymentInstrument: PaymentInstrument;
}

export interface CreatePayrollProviderInput {
  clientMutationId: Scalars["String"];
  /** Associated deposits account */
  depositsAccountId: Scalars["ID"];
  /** Idempotency key to avoid duplicate payroll provider creation */
  idempotencyKey: Scalars["String"];
  /** Type (method of connection) of integration */
  integration?: InputMaybe<PayrollProviderIntegrationType>;
  /** (Deprecated) Will be removed with the introduction of :type and :integration_type */
  name?: InputMaybe<Scalars["String"]>;
  /** A type-safe enum to represent a payroll provider */
  payrollProvider?: InputMaybe<PayrollProviderType>;
}

export interface CreatePayrollProviderPayload {
  clientMutationId: Scalars["String"];
  createdPayrollProvider?: Maybe<PayrollProviderV2>;
  payrollProvider?: Maybe<PayrollProvider>;
}

export interface CreatePeriodicReviewApplicationInput {
  clientMutationId: Scalars["String"];
  /** The specific implementation of the blueprint type. Defaults to `periodic_review_v1` */
  name?: InputMaybe<Scalars["String"]>;
}

export interface CreatePeriodicReviewApplicationPayload {
  clientMutationId: Scalars["String"];
  onboardingApplication: OnboardingApplication;
}

export interface CreatePhysicalCardV2Input {
  /** The budget to assign the card to */
  budgetId?: InputMaybe<Scalars["ID"]>;
  /** The client mutation id */
  clientMutationId: Scalars["String"];
  /** The customer to issue the card to */
  customerUserId?: InputMaybe<Scalars["ID"]>;
  /** Display name of the card */
  displayName?: InputMaybe<Scalars["String"]>;
  /** Whether to exclude individual envelope or not */
  excludeEnvelope?: InputMaybe<Scalars["Boolean"]>;
  /** The name of the card holder */
  holderName?: InputMaybe<Scalars["String"]>;
  /** The card's PIN */
  pin?: InputMaybe<Scalars["String"]>;
  /** Shipping address for delivery of the card */
  shippingAddress: ShippingAddressInput;
  /** Shipping method for delivery of the card */
  shippingMethod?: InputMaybe<ShippingMethod>;
  /** Phone number printed on the shipping label */
  shippingPhoneNumber?: InputMaybe<Scalars["String"]>;
}

export interface CreatePhysicalCardV2Payload {
  /** The card that was created */
  card?: Maybe<Card>;
  /** The client mutation id */
  clientMutationId: Scalars["String"];
}

export interface CreatePositivePayAccountSettingInput {
  achCompanyId: Scalars["String"];
  clientMutationId: Scalars["String"];
  name: Scalars["String"];
  status: PositivePayAccountSettingStatus;
}

export interface CreatePositivePayAccountSettingPayload {
  clientMutationId: Scalars["String"];
  positivePayAccountSetting: PositivePayAccountSetting;
}

export interface CreatePurchaseOrderInput {
  /** Client mutation ID for tracking */
  clientMutationId: Scalars["String"];
  /** The fields for the purchase order */
  fields: PurchaseOrderFieldsInput;
}

export interface CreatePurchaseOrderResult extends MutationResult {
  errors?: Maybe<Array<PurchaseOrderMutationError>>;
  result?: Maybe<PurchaseOrder>;
}

/** Input for the Purchasing Card creation */
export interface CreatePurchasingCardInput {
  /** The idempotency key */
  clientMutationId: Scalars["String"];
  /** The Purchasing Card creation fields. */
  fields: CreatePurchasingCardInputFields;
}

export interface CreatePurchasingCardInputFields {
  /** Authorization Settings for the Spend Limit this Purchasing Card represents. */
  authorizationSettings: SpendLimitAuthorizationSettingsInput;
  /**
   * Privacy setting whether its members are allowed to view the limit & authorization settings
   * (previously known as limit visibility)
   */
  authorizationVisibility: SpendLimitAuthorizationVisibility;
  /** Setting for auto-transferring budget cards when their owners are either disabled or removed as members from the budget. */
  autoTransferCardsSetting: AutoTransferCardsSetting;
  /** Description of what the Purchasing Card is used for */
  description?: InputMaybe<Scalars["String"]>;
  /** End date of the Purchasing Card */
  endDate?: InputMaybe<Scalars["Date"]>;
  /** The ID of the expense policy for this limit. */
  expensePolicyId?: InputMaybe<Scalars["ID"]>;
  /** Determines if Purchasing Card members are allowed to view other members expenses. */
  expenseVisibility: SpendLimitExpenseVisibility;
  /** Legal entity mapping of a Purchasing Card */
  legalEntityMapping?: InputMaybe<LegalEntityMapping>;
  /** The policy that manages limit increase requests for this limit. */
  limitApprovalPolicyId?: InputMaybe<Scalars["ID"]>;
  /** Whether the limit increase feature is enabled for this Purchasing Card */
  limitIncreaseSetting?: InputMaybe<LimitIncreaseSetting>;
  /** Merchant category controls */
  merchantCategoryControls?: InputMaybe<Array<MerchantCategoryConfigInput>>;
  /** Name of the Purchasing Card */
  name: Scalars["String"];
  /** The parent of this Purchasing Card, if any */
  parentBudgetId?: InputMaybe<Scalars["ID"]>;
  /** Recurrence type of the Purchasing Card */
  periodRecurrenceType: SpendLimitPeriodRecurrenceType;
  /** Start date of the Purchasing Card */
  startDate?: InputMaybe<Scalars["Date"]>;
  /** The transaction limit mapped to the Purchasing Card. Null for no transaction limit. */
  transactionLimit?: InputMaybe<FinancialAssetInput>;
  /** The user group to be associated with the Purchasing Card. */
  userGroup: UserGroupInput;
}

export interface CreatePurchasingCardResult extends MutationResult {
  errors?: Maybe<Array<PurchasingCardMutationError>>;
  spendLimit?: Maybe<SpendLimit>;
}

export interface CreatePushChannelInput {
  clientMutationId: Scalars["String"];
  deviceInformation: DeviceInformationInput;
  deviceToken: Scalars["String"];
  type: PushProviderType;
}

export interface CreatePushChannelPayload {
  channel?: Maybe<Channel>;
  clientMutationId: Scalars["String"];
}

export interface CreateRailAccountDetailsError extends StandardClientError {
  code: ErrorCode;
  existingId?: Maybe<Scalars["ID"]>;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface CreateRailAccountDetailsInput {
  accountHolderAddress?: InputMaybe<AddressInput>;
  bankAccountClass?: InputMaybe<BankAccountClassType>;
  beneficiaryNameInfo?: InputMaybe<Scalars["Json"]>;
  beneficiaryType?: InputMaybe<BeneficiaryType>;
  /** If customerAccountId is not provided, it will be taken from the identity context. */
  customerAccountId?: InputMaybe<Scalars["ID"]>;
  defaultCurrency?: InputMaybe<CurrencyInput>;
  /** Display name for the rail account details. If not provided, will default to the beneficiary name. */
  displayName?: InputMaybe<Scalars["String"]>;
  idempotencyKey: Scalars["String"];
  ownerId: Scalars["ID"];
  ownerType: RailAccountDetailsOwnerType;
  properties: Scalars["Json"];
  /**
   * Exactly one of railId or railType must be provided.
   * If railId is provided, the rail will be looked up by its ID.
   */
  railId?: InputMaybe<Scalars["ID"]>;
  /** If railType is provided, the rail will be looked up by its type. */
  railType?: InputMaybe<RailType>;
  verifications?: InputMaybe<
    Array<RailAccountDetailsRequiredVerificationDataInput>
  >;
}

export interface CreateRailAccountDetailsResult extends MutationResult {
  errors?: Maybe<Array<CreateRailAccountDetailsError>>;
  result?: Maybe<RailAccountDetails>;
}

export interface CreateReceiptAndExpenseInput {
  /** Asset id for the receipt to create */
  assetId: Scalars["ID"];
  /** Optional channel to create the receipt with - attempts to detect web/mobile matching if not provided */
  channel?: InputMaybe<ReceiptChannel>;
}

export interface CreateReceiptIntegrationInput {
  /**
   * Provider-specific data needed to create an integration.
   * Exactly one of the fields must be set.
   */
  uber?: InputMaybe<CreateUberReceiptIntegrationInput>;
}

export interface CreateReceiptIntegrationResponse {
  success: Scalars["Boolean"];
}

export interface CreateReceiptV2Input {
  /** Asset id for the receipt to create */
  assetId: Scalars["String"];
  /** Optional channel to create the receipt with - attempts to detect web/mobile matching if not provided */
  channel?: InputMaybe<ReceiptChannel>;
  /** Optional document type, allows differentiating between receipt and invoices. It defaults to TRANSACTION_RECEIPT. */
  documentType?: InputMaybe<DocumentType>;
}

export interface CreateReimbursementExpenseError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface CreateReimbursementExpenseInput {
  /** The input for the expense object to create. */
  expense: ExpenseInput;
  /** Idempotency key to use for this mutation. */
  idempotencyKey: Scalars["String"];
  /** The input for the integration fields. Optional. */
  integration?: InputMaybe<IntegrationInput>;
}

export interface CreateReimbursementExpenseResult extends MutationResult {
  /** List of errors from this request */
  errors?: Maybe<Array<CreateReimbursementExpenseError>>;
  /** Expense result */
  expenseResult?: Maybe<Expense>;
  /** Idempotency key used for creating this reimbursement */
  idempotencyKey: Scalars["String"];
  /**
   * Reimbursement Item result
   * @deprecated Use expenseResult instead.
   */
  result?: Maybe<ReimbursementItem>;
}

/** Input for creating a reimbursement expense for a specific booking. */
export interface CreateReimbursementForBookingInput {
  bookingId: Scalars["String"];
  tripId: Scalars["String"];
}

/** Input types */
export interface CreateReportTemplateInput {
  /** Id of a template to clone from - not cloned if null or empty */
  baseTemplateId?: InputMaybe<Scalars["String"]>;
  /** Idempotency key for create request */
  idempotencyKey: Scalars["String"];
  /** Template entries for the template to use - used if it is not null and baseTemplateId is not null */
  newTemplateEntries?: InputMaybe<Array<ReportTemplateEntryInput>>;
  /** Description for the new template */
  templateDescription?: InputMaybe<Scalars["String"]>;
  /** Name for the new template */
  templateName: Scalars["String"];
}

export interface CreateReportingDashboardScheduleInput {
  /** The ID of the report that is being scheduled */
  reportingDashboardId: Scalars["ID"];
  /** The configuration of the schedule */
  schedule: ReportingDashboardScheduleInput;
}

export interface CreateReportingDashboardScheduleResult extends MutationResult {
  errors?: Maybe<Array<ReportingClientError>>;
  /** The created scheduled report */
  result?: Maybe<ReportingDashboardSchedule>;
}

export interface CreateRequestDeadlineSettingsInput {
  /** Optional - whether cc'ing managers is enabled or disabled. Default value is false if empty. */
  ccManagersEnabled?: InputMaybe<Scalars["Boolean"]>;
  /** Optional - the number of grace period days to use. Default value is set if empty. */
  gracePeriodDays?: InputMaybe<Scalars["Int"]>;
  /** Optional - whether reminders are enabled or disabled. Default value is false if empty. */
  remindersEnabled?: InputMaybe<Scalars["Boolean"]>;
  /** Optional - whether we should send notification to users about setting change. Default to false */
  shouldSendNotification?: InputMaybe<Scalars["Boolean"]>;
  /** type of request deadline that is being created */
  type?: InputMaybe<RequestDeadlineSettingsType>;
}

export interface CreateRequestDeadlineSettingsResult {
  /** The RequestDeadlineSettings which were created */
  requestDeadlineSettings: RequestDeadlineSettings;
}

/** CreateResponseToRfi input */
export interface CreateResponseToRfiInput {
  /** The RFI associated with this RFI Response */
  arfiId: Scalars["String"];
  /** Unique identifier of this mutation */
  clientMutationId: Scalars["String"];
  /** List of document tokens for this RFI Response */
  responseItemsInput?: InputMaybe<
    Array<InputMaybe<CreateRfiResponseItemInput>>
  >;
  /** Freeform text message for this RFI Response */
  responseMessage?: InputMaybe<Scalars["String"]>;
}

/** CreateResponseToRfi output */
export interface CreateResponseToRfiPayload {
  /** Unique identifier of this mutation */
  clientMutationId: Scalars["String"];
  /** Whether the message was successfully sent or not */
  success?: Maybe<Scalars["Boolean"]>;
}

/** CreateRfiResponseItem input */
export interface CreateRfiResponseItemInput {
  /** Token for filestore, referencing the uploaded file */
  documentToken: Scalars["String"];
}

/**  These types must be shareable to allow importing between DGSs */
export interface CreateSAMLPlaceholderError extends SsoClientError {
  code?: Maybe<SsoClientErrorCode>;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

/** # Common SSO types */
export type CreateSAMLPlaceholderResult =
  | CreateSAMLPlaceholderError
  | CustomerSsoSettings;

export interface CreateSageintacctCredentialInput {
  clientMutationId: Scalars["String"];
  /** Password for the service user */
  password: Scalars["String"];
  /** Host URL to connect to */
  sageintacctCompanyId: Scalars["String"];
  /** Username for the service user */
  username: Scalars["String"];
  /** The name of the erp */
  vendorName?: InputMaybe<Scalars["String"]>;
}

export interface CreateSageintacctCredentialPayload {
  /** Result of authentication - either success or failure, plus additional info */
  authenticationResult?: Maybe<CredentialAuthenticationResult>;
  clientMutationId: Scalars["String"];
}

export interface CreateSandboxAccountActionError extends StandardClientError {
  /** error code of error */
  code: ErrorCode;
  /** error message */
  message?: Maybe<Scalars["String"]>;
  /** optional path to field that caused error */
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface CreateSandboxAccountActionInput {
  /** The client mutation id */
  clientMutationId: Scalars["String"];
  /** Which action should be triggered */
  type: SandboxAccountActionType;
}

export interface CreateSandboxAccountActionResult extends MutationResult {
  /** The list of errors if exists */
  errors?: Maybe<Array<CreateSandboxAccountActionError>>;
  /** The result set */
  result?: Maybe<SandboxAccountAction>;
}

export interface CreateSmsChannelInput {
  clientMutationId: Scalars["String"];
  number: Scalars["PhoneNumber"];
}

export interface CreateSmsChannelPayload {
  channel?: Maybe<Channel>;
  clientMutationId: Scalars["String"];
}

/** Input for the spend budget creation */
export interface CreateSpendBudgetInput {
  /** The idempotency key */
  clientMutationId: Scalars["String"];
  /** The spend budget creation fields */
  fields: CreateSpendBudgetInputFields;
}

export interface CreateSpendBudgetInputFields {
  /** Amount of the spend budget */
  amount?: InputMaybe<FinancialAssetInput>;
  /** Authorization behavior of the spend budget */
  authorizationType?: InputMaybe<SpendBudgetAuthorizationType>;
  /** Description of what the spend budget is used for */
  description?: InputMaybe<Scalars["String"]>;
  /** End date of the spend budget */
  endDate?: InputMaybe<Scalars["Date"]>;
  /** Percentage of the spend budget to enforce as a limit buffer */
  enforceLimitBufferPercentage?: InputMaybe<Scalars["Int"]>;
  /** Legal entity mapping of a spend budget */
  legalEntityMapping: LegalEntityMapping;
  /** Name of the spend budget */
  name: Scalars["String"];
  /** Owners of a spend budget */
  owners: Array<Scalars["ID"]>;
  /** The parent of this spend budget, if any */
  parentBudgetId?: InputMaybe<Scalars["ID"]>;
  /** Recurrence type of the spend budget */
  periodRecurrenceType: SpendBudgetPeriodRecurrenceType;
  /** Start date of the spend budget */
  startDate?: InputMaybe<Scalars["Date"]>;
}

export interface CreateSpendBudgetResult extends MutationResult {
  errors?: Maybe<Array<SpendBudgetMutationError>>;
  spendBudget?: Maybe<SpendBudget>;
}

export interface CreateSpendLimitBlueprintFields {
  /** Authorization behavior against the spend limit's limit. */
  authorizationType: SpendLimitAuthorizationType;
  /**
   * Privacy setting whether its members are allowed to view the limit & authorization settings
   * (previously known as limit visibility)
   */
  authorizationVisibility?: InputMaybe<SpendLimitAuthorizationVisibility>;
  /** Setting for how auto limit card creation works for members. */
  autoCreateLimitCardsSetting: AutoCreateLimitCardsSetting;
  /** Setting for auto-transferring spend limit cards when their owners are either disabled or removed as members from the budget. */
  autoTransferCardsSetting: AutoTransferCardsSetting;
  /** Description of what the spend limit is used for */
  description?: InputMaybe<Scalars["String"]>;
  /** The end date of the spend limit, inclusive. */
  endDate?: InputMaybe<Scalars["Date"]>;
  /** The ID of the expense policy that manages expenses for this spend limit */
  expensePolicyId?: InputMaybe<Scalars["ID"]>;
  /** Determines if spend limit members are allowed to view other members expenses. */
  expenseVisibility: SpendLimitExpenseVisibility;
  /** The percentage of flexible buffer on the limit as a 0-100 INT */
  flexibleBufferPercentage?: InputMaybe<Scalars["Int"]>;
  /**
   * The legal entity ID for the to-be-created spend limits
   * Defaults to the legal entity mapping of the parent budget if not specified
   */
  legalEntityId?: InputMaybe<Scalars["ID"]>;
  /** Limit on the spend limit */
  limit: FinancialAssetInput;
  /** The policy that manages approval chain for limit increase requests for this spend limit. */
  limitApprovalPolicyId?: InputMaybe<Scalars["ID"]>;
  /** Whether limit increase request feature is enabled on a spend limit */
  limitIncreaseSetting: LimitIncreaseSetting;
  /** Merchant category controls, including those along ancestry path. */
  merchantCategoryControls?: InputMaybe<Array<MerchantCategoryConfigInput>>;
  /** The name of the spend limit */
  name: Scalars["String"];
  /** Ids of the employees who are considered owners of this spend limit */
  ownerIds: Array<Scalars["ID"]>;
  /** Parent budget id */
  parentBudgetId: Scalars["ID"];
  /** Recurrence type of the spend limit */
  periodRecurrenceType: SpendLimitPeriodRecurrenceType;
  /** True if the user's name should be prepended to the spend limit name */
  prependUserNameToSpendLimitName: Scalars["Boolean"];
  /**
   * Specifies the date offset to be applied when setting the end date of the provisioned spend limit. Cannot be set if end
   * date is set
   *
   * The offset is calculated based on the time of provisioning. For instance, if the offset is set to 7 DAY and the
   * spend limit is provisioned on 2024-01-01, the end date of the provisioned spend limit will be 2024-01-08.
   */
  provisionedDateOffset?: InputMaybe<DateOffsetInput>;
  /** The rollover refresh rate for this spend limit (the recurrence by which all rolled over unused funds within the cycle should no longer roll over to the next period). */
  rolloverRefreshRate?: InputMaybe<SpendLimitRolloverRefreshRate>;
  /** Allowed spend sources on a Spend Limit. */
  spendSourceSetting: SpendSourceSettingInput;
  /** The start date of the spend limit, inclusive. */
  startDate?: InputMaybe<Scalars["Date"]>;
  /** True if the spend limits created by this blueprint should start in the next spend limit period */
  startSpendLimitNextAvailableSpendLimitPeriod?: InputMaybe<Scalars["Boolean"]>;
  /**
   * The transaction limit mapped to the spend limits provisioned by the blueprint
   * Null if no transaction limit is set.
   */
  transactionLimit?: InputMaybe<FinancialAssetInput>;
}

/** Input for the spend limit creation */
export interface CreateSpendLimitInput {
  /** The idempotency key */
  clientMutationId: Scalars["String"];
  /** The spend limit creation fields */
  fields: CreateSpendLimitInputFields;
}

export interface CreateSpendLimitInputFields {
  /** Spend Limit Authorization Settings. */
  authorizationSettings: SpendLimitAuthorizationSettingsInput;
  /**
   * Privacy setting whether its members are allowed to view the limit & authorization settings
   * (previously known as limit visibility)
   */
  authorizationVisibility: SpendLimitAuthorizationVisibility;
  /** Setting for how auto limit card creation works for members. */
  autoCreateLimitCardsSetting: AutoCreateLimitCardsSetting;
  /** Setting for auto-transferring budget cards when their owners are either disabled or removed as members from the budget. */
  autoTransferCardsSetting: AutoTransferCardsSetting;
  /** Description of what the spend limit is used for */
  description?: InputMaybe<Scalars["String"]>;
  /** End date of the spend limit */
  endDate?: InputMaybe<Scalars["Date"]>;
  /** The ID of the expense policy for this limit. */
  expensePolicyId: Scalars["ID"];
  /** Determines if spend limit members are allowed to view other members expenses. */
  expenseVisibility: SpendLimitExpenseVisibility;
  /** Legal entity mapping of a spend limit */
  legalEntityMapping?: InputMaybe<LegalEntityMapping>;
  /** The policy that manages limit increase requests for this limit, it replaces old budgets.limitIncreaseRequestPolicyId. */
  limitApprovalPolicyId?: InputMaybe<Scalars["ID"]>;
  /** Whether the limit increase feature is enabled for this spend limit */
  limitIncreaseSetting?: InputMaybe<LimitIncreaseSetting>;
  /** Merchant category controls */
  merchantCategoryControls?: InputMaybe<Array<MerchantCategoryConfigInput>>;
  /** Name of the spend limit */
  name: Scalars["String"];
  /** Owners of a spend limit */
  owners: Array<Scalars["ID"]>;
  /** The parent of this spend limit, if any */
  parentBudgetId?: InputMaybe<Scalars["ID"]>;
  /** Recurrence type of the spend limit */
  periodRecurrenceType: SpendLimitPeriodRecurrenceType;
  /** Allowed spend sources on a Spend Limit. */
  spendSourceSetting: SpendSourceSettingInput;
  /** Start date of the spend limit */
  startDate?: InputMaybe<Scalars["Date"]>;
  /** The transaction limit mapped to the spend limit. Null for no transaction limit. */
  transactionLimit?: InputMaybe<FinancialAssetInput>;
  /**
   * The user group to be associated with the spend limit when is a distribution. This mutation supports
   * only shared spend limits, that is why we don't have anymore distributionSettings.sharedBudgetDistributionSettings
   * or distributionSettings.perMemberBudgetDistributionSettings as on the old createDistributedSpendLimit
   */
  userGroup?: InputMaybe<UserGroupInput>;
}

export interface CreateSpendLimitResult extends MutationResult {
  errors?: Maybe<Array<StandardClientError>>;
  spendLimit?: Maybe<SpendLimit>;
}

export interface CreateSubscriptionInput {
  channelId: Scalars["ID"];
  clientMutationId: Scalars["String"];
  notificationType: NotificationType;
}

export interface CreateSubscriptionPayload {
  clientMutationId: Scalars["String"];
  notificationSubscription?: Maybe<NotificationSubscription>;
}

export interface CreateSubscriptionsInput {
  channelId: Scalars["ID"];
  clientMutationId: Scalars["String"];
  notificationTypes: Array<NotificationType>;
}

export interface CreateSubscriptionsPayload {
  clientMutationId: Scalars["String"];
  notificationSubscriptions: Array<Maybe<NotificationSubscription>>;
}

export interface CreateSuggestionActionError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
  suggestionId: Scalars["ID"];
}

export interface CreateTitleInput {
  /** clientMutationId */
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** Name of the title. */
  name: Scalars["String"];
}

export interface CreateTitleResult {
  /** Title that was created. */
  title: Title;
}

export interface CreateTrackingExpensePolicyInput {
  /**
   * Optional customer user id to associate the policy with, if not provided it will be associated with the current user
   * context
   */
  customerUserId?: InputMaybe<Scalars["String"]>;
  /**
   * Which expense type that policy is for.
   * Currently only REIMBURSEMENTS are supported
   */
  expenseType: ExpenseType;
  /** Idempotency key to avoid duplicate creation */
  idempotencyKey: Scalars["String"];
  /** Metadata for the policy */
  metadata?: InputMaybe<TrackingExpensePolicyMetadataOneOf>;
}

export interface CreateTransactionApprovedSubscriptionInput {
  channelId: Scalars["ID"];
  clientMutationId: Scalars["String"];
  isPhysical?: InputMaybe<Scalars["Boolean"]>;
}

export interface CreateTransactionApprovedSubscriptionPayload {
  clientMutationId: Scalars["String"];
  notificationSubscription?: Maybe<NotificationSubscription>;
}

export interface CreateTransactionRefusedSubscriptionInput {
  channelId: Scalars["ID"];
  clientMutationId: Scalars["String"];
}

export interface CreateTransactionRefusedSubscriptionPayload {
  clientMutationId: Scalars["String"];
  notificationSubscription?: Maybe<NotificationSubscription>;
}

/** Input for creating a trip. */
export interface CreateTripInput {
  budgetId?: InputMaybe<Scalars["String"]>;
  budgetRequestId?: InputMaybe<Scalars["String"]>;
  clientMutationId: Scalars["String"];
  description?: InputMaybe<Scalars["String"]>;
  idempotencyKey: Scalars["String"];
  name: Scalars["String"];
  nameSource?: InputMaybe<TripNameSource>;
  spotnanaPayloadType?: InputMaybe<TravelSpotnanaPayloadType>;
  status?: InputMaybe<TripStatus>;
}

/** Represents the result of creating a trip. */
export interface CreateTripResult {
  spotnanaPayload: SpotnanaPayload;
  spotnanaPayloadType?: Maybe<TravelSpotnanaPayloadType>;
  spotnanaTripId: Scalars["String"];
  spotnanaUserId: Scalars["String"];
  tripId: Scalars["String"];
}

export enum CreateUberAccountsEmployees {
  /**
   * Active users at time of integration creation will get an Uber account created, as well as new users as they
   * are onboarded onto the customer account.
   */
  ALL = "ALL",
  /** Only active employees at time of integration creation will get Uber accounts created. */
  CURRENT_ONLY = "CURRENT_ONLY",
  /**
   * Only new Brex users onboarded onto the customer account will have an Uber account created. Existing users
   * at time of integration creation will not get an Uber account created.
   */
  FUTURE_ONLY = "FUTURE_ONLY",
  /** No accounts for employees will be created. */
  NONE = "NONE",
}

export interface CreateUberReceiptIntegrationInput {
  /** Whether users should be removed the linked U4B when they are deactivated on Brex. */
  autoOffboardEmployees?: InputMaybe<OffboardUberEmployeesSetting>;
  /**
   * Whether the user has agreed to the required consents for creating a new U4B. Required to be True if
   * organizationUuid is blank (new U4B creation). Reach out to integration owner if you do not know what these are.
   */
  consentsAccepted?: InputMaybe<Scalars["Boolean"]>;
  /** Enum to specify how to autofill Brex employees into the Uber for Business organization. */
  createUberAccountsEmployees: CreateUberAccountsEmployees;
  /**
   * Uber for Business organization UUID. If blank, will create a new Uber for Business
   * organization using the Brex account's HRIS data.
   */
  organizationUuid?: InputMaybe<Scalars["String"]>;
}

export interface CreateUserCategoriesInput {
  clientMutationId: Scalars["String"];
  userCategoryNames: Array<UserCategoryNameInput>;
}

export interface CreateUserCategoriesPayload {
  clientMutationId: Scalars["String"];
  userCategories?: Maybe<Array<UserCategory>>;
}

export interface CreateUserInput {
  /** The user's cost center ID. */
  costCenterId?: InputMaybe<Scalars["ID"]>;
  /** The user's department ID. */
  departmentId?: InputMaybe<Scalars["ID"]>;
  /** The user's email. */
  email: Scalars["String"];
  /** The user's employment status. */
  employmentStatus?: InputMaybe<EmploymentStatus>;
  /** The user's employment type. */
  employmentType?: InputMaybe<EmploymentType>;
  /** The user's first name. */
  firstName: Scalars["String"];
  /** The user's last name. */
  lastName: Scalars["String"];
  /** The user's legal entity ID. */
  legalEntityId?: InputMaybe<Scalars["ID"]>;
  /** The user's location ID. */
  locationId?: InputMaybe<Scalars["ID"]>;
  /** A reference to this user's manager. */
  managerIdentifier?: InputMaybe<UserIdentifier>;
  /** The user's monthly limit. Currently only supported for classic accounts. */
  monthlyLimitAmount?: InputMaybe<FinancialAssetInput>;
  productAccess?: InputMaybe<Array<UserProductAccess>>;
  /** The user's role. */
  role?: InputMaybe<UserRole>;
  /** List of the roleIds each user will be assigned. */
  roleIds?: InputMaybe<Array<Scalars["ID"]>>;
  /**
   * The user's status.
   * Users can be created with roles INACTIVE, PENDING_ACTIVATION, or INVITED. All other roles will error.
   */
  status: UserStatus;
  /** The user's title ID. */
  titleId?: InputMaybe<Scalars["ID"]>;
}

export interface CreateUserManagementSettingInput {
  /** How to manage the auto-offboarding of users, if at all. */
  autoOffboardSetting?: InputMaybe<AutoOffboardSettingInput>;
  /** How to manage the auto-onboarding of users, if at all. */
  autoOnboardSetting?: InputMaybe<AutoOnboardSettingInput>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** The connection these new settings will configure. */
  connectionId: Scalars["ID"];
  /** Which kind of employees to manage */
  employmentTypes?: InputMaybe<Array<HrisEmploymentType>>;
  /** Idempotency key */
  idempotencyKey: Scalars["String"];
}

export interface CreateVendorFileMatchByNameInput {
  /** The name provided by the user to create the vendor file match for. */
  name: Scalars["String"];
}

export interface CreateVendorFileMatchByVendorIdInput {
  /** The ID of the vendor to create the vendor file match for (must be a card-on-file accepting knowledge base vendor) */
  id: Scalars["ID"];
}

export interface CreateVendorFileMatchInput {
  /**
   * [oneOf] Input to create vendor file matches by vendor name for an account.
   * Only one of [byVendorId, byName] can be specified. An exception will be thrown if none or multiple are passed.
   */
  byName?: InputMaybe<CreateVendorFileMatchByNameInput>;
  /**
   * [oneOf] Input to create vendor file matches by vendor id for an account.
   * Only one of [byVendorId, byName] can be specified. An exception will be thrown if none or multiple are passed.
   */
  byVendorId?: InputMaybe<CreateVendorFileMatchByVendorIdInput>;
}

export interface CreateVendorFileMatchesFromImportInput {
  /** The spend migration import ID to create vendor file matches from. */
  spendMigrationImportId: Scalars["ID"];
  /** The vendor inclusion configuration for the import. If not provided, all vendors from the import will be created. */
  vendorInclusion?: InputMaybe<SpendMigrationImportVendorInclusionInput>;
}

export interface CreateVendorInput {
  address?: InputMaybe<AddressInput>;
  billPayVendorExtension?: InputMaybe<BillPayVendorExtensionInput>;
  clientMutationId: Scalars["String"];
  contactName?: InputMaybe<Scalars["String"]>;
  email?: InputMaybe<Scalars["String"]>;
  extendedFieldValues?: InputMaybe<Array<ExtendedFieldValueInput>>;
  name: Scalars["String"];
  paymentConfig?: InputMaybe<VendorPaymentConfigInput>;
  phone?: InputMaybe<Scalars["String"]>;
  website?: InputMaybe<Scalars["String"]>;
}

export interface CreateVendorResult extends MutationResult {
  errors?: Maybe<Array<VendorMutationError>>;
  result?: Maybe<VendorDetails>;
}

export interface CreateVirtualCardV2Input {
  /** The budget to assign the card to */
  budgetId?: InputMaybe<Scalars["ID"]>;
  /** The client mutation id */
  clientMutationId: Scalars["String"];
  /** The customer to issue the card to */
  customerUserId?: InputMaybe<Scalars["ID"]>;
  /** Display name of the card */
  displayName?: InputMaybe<Scalars["String"]>;
  /** The name of the card holder */
  holderName?: InputMaybe<Scalars["String"]>;
  /** True if the card is a budget card */
  isBudgetCard?: InputMaybe<Scalars["Boolean"]>;
}

export interface CreateVirtualCardV2Payload {
  /** The card that was created */
  card?: Maybe<Card>;
  /** The client mutation id */
  clientMutationId: Scalars["String"];
}

export interface CreateWorkdayCredentialInput {
  clientMutationId: Scalars["String"];
  /** Host URL to connect to */
  host: Scalars["String"];
  password: Scalars["String"];
  tenant: Scalars["String"];
  /** Username for the service user */
  username: Scalars["String"];
  /** The name of the erp */
  vendorName?: InputMaybe<Scalars["String"]>;
}

export interface CreateWorkdayCredentialPayload {
  /** Result of authentication - either success or failure, plus additional info */
  authenticationResult?: Maybe<CredentialAuthenticationResult>;
  clientMutationId: Scalars["String"];
}

export interface CreateWorkflowRuleInput {
  /** Actions that will be taken when the rule applies */
  actions: Array<WorkflowRuleActionOneOfInput>;
  clientMutationId: Scalars["String"];
  /** Conditions that determine when the rule will be applied */
  conditions?: InputMaybe<Array<RuleApplicationConditionOneOfInput>>;
  /** More details about the rule */
  description?: InputMaybe<Scalars["String"]>;
  /** The user facing name for the rule */
  displayName?: InputMaybe<Scalars["String"]>;
  /** Defines the filters that need to match in order for this Rule's Actions to apply */
  filters: Array<WorkflowRuleFilterInput>;
  /**
   * The priority of the rule
   * Higher priority rules will be applied first and automatically "win" during conflicts
   */
  priority: WorkflowRulePriorityInput;
  /** The tags associated with the VX Workflow Rule. The keys must be unique. */
  tags?: InputMaybe<Array<WorkflowRuleTagFilterInput>>;
  /**
   * The specific Workflow this Rule is associated with
   * Some Workflows have required tags that must be present on all Rules in that Workflow
   */
  workflow: Workflow;
}

/** Response of create VX Workflow Rule */
export interface CreateWorkflowRuleResult {
  rule?: Maybe<WorkflowRule>;
}

export interface Credential extends Node {
  credentialPayload?: Maybe<LegacyCredentialPayload>;
  expirationDate?: Maybe<Scalars["Time"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  payload?: Maybe<CredentialPayload>;
  publicData?: Maybe<Scalars["Json"]>;
  renewalDate?: Maybe<Scalars["Time"]>;
  status?: Maybe<Scalars["String"]>;
  vendor?: Maybe<Scalars["String"]>;
}

export type CredentialAuthenticationResult =
  | CredentialRedirectResult
  | CredentialSuccessResult;

export interface CredentialConnection {
  edges?: Maybe<Array<Maybe<CredentialEdge>>>;
  pageInfo: PageInfo;
}

export interface CredentialEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<Credential>;
}

export interface CredentialMutationError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export type CredentialPayload =
  | CredentialQbdPayload
  | CredentialQuickbooksPayload
  | CredentialShopifyPayload
  | CredentialVendorPayload
  | CredentialXeroPayload
  | GoogleWorkspacePayload
  | GustoPayload
  | MS365BCPayload
  | MS365FNOPayload
  | MicrosoftGraphPayload
  | NetsuitePayload
  | OracleFusionPayload
  | PuzzlePayload
  | QbdPayload
  | QuickbooksPayload
  | SageIntacctPayload
  | ShopifyPayload
  | WorkdayPayload
  | XeroPayload;

/** QBD credential payload */
export interface CredentialQbdPayload {
  /** Company ID as generated by Codat - needed for QBD connector */
  companyId?: Maybe<Scalars["String"]>;
}

/** Quickbooks credential payload */
export interface CredentialQuickbooksPayload {
  /** Boolean describing whether the credential has the required scopes for enabling bill sync */
  hasBillSyncScopes?: Maybe<Scalars["Boolean"]>;
}

export interface CredentialRedirectResult {
  credential?: Maybe<Credential>;
  redirectUrl?: Maybe<Scalars["String"]>;
}

export interface CredentialShopifyPayload {
  shopName?: Maybe<Scalars["String"]>;
}

export enum CredentialStatus {
  DISCONNECTED = "DISCONNECTED",
  ERROR = "ERROR",
  INVALID = "INVALID",
  PENDING = "PENDING",
  SUCCESS = "SUCCESS",
}

export interface CredentialSuccessResult {
  credential?: Maybe<Credential>;
}

export enum CredentialVendor {
  GOOGLE_WORKSPACE = "GOOGLE_WORKSPACE",
  GUSTO = "GUSTO",
  MICROSOFT_GRAPH = "MICROSOFT_GRAPH",
  MS365BC = "MS365BC",
  MS365FNO = "MS365FNO",
  NETSUITE = "NETSUITE",
  ORACLE_FUSION = "ORACLE_FUSION",
  PUZZLE = "PUZZLE",
  QBD = "QBD",
  QUICKBOOKS = "QUICKBOOKS",
  SAGE_INTACCT = "SAGE_INTACCT",
  SHOPIFY = "SHOPIFY",
  WORKDAY = "WORKDAY",
  XERO = "XERO",
}

/** Default non-integration specific credential payload */
export interface CredentialVendorPayload {
  /** ID */
  id?: Maybe<Scalars["String"]>;
}

/** Xero credential payload */
export interface CredentialXeroPayload {
  /** Boolean describing whether the credential has the required scopes for enabling bill sync */
  hasBillSyncScopes?: Maybe<Scalars["Boolean"]>;
}

export interface CreditLimitOverview {
  /** Customer's cleared balance at the time of the request. This is always in USD for now */
  clearedBalance: FinancialAsset;
  /** Customer's credit limit at the time of the request. This is always in USD for now */
  globalLimit: FinancialAsset;
  /** Customer's total pending balance at the time of the request. This is always in USD for now */
  pendingBalance: FinancialAsset;
  /** Customer's remaining balance at the time of the request. This is always in USD for now */
  remainingSpend: FinancialAsset;
}

export interface CreditPolicyWarningModalResponse {
  currentCashBalance?: Maybe<Scalars["Int"]>;
  hasBrexAccounts?: Maybe<Scalars["Boolean"]>;
  hasExternalAccounts?: Maybe<Scalars["Boolean"]>;
  minimumCashBalanceAgreement?: Maybe<Scalars["Int"]>;
  modal: CreditPolicyWarningModalType;
  requiredCashBalance?: Maybe<Scalars["Int"]>;
}

export enum CreditPolicyWarningModalType {
  ESCALATED = "ESCALATED",
  FINAL = "FINAL",
  NONE = "NONE",
  OUTREACH = "OUTREACH",
}

export interface CreditTerms {
  additionalAgreements?: Maybe<Array<UnderwritingAgreement>>;
  collectionFrequency: CollectionFrequency;
  expectedNextCollectionDate?: Maybe<Scalars["Date"]>;
  /**  Deprecated in favor of collectionFrequency */
  frequency?: Maybe<UnderwritingFrequency>;
  isPublicCompany: Scalars["Boolean"];
}

export interface CryptoPayloadInput {
  dateOfLastRegistration?: InputMaybe<Scalars["Date"]>;
  facilitatesCrypto: Scalars["Boolean"];
  financialSafetyAttestation: Scalars["Boolean"];
  financialSafetyAttestationVersion: Scalars["String"];
  isRegistered: Scalars["Boolean"];
  plansToRegister: Scalars["Boolean"];
  primaryRegulator: Scalars["String"];
  registrationNumber: Scalars["String"];
  regulationExclusionExplanation: Scalars["String"];
  regulationExclusionUpload: Scalars["String"];
}

/** Csv GL account settings */
export interface CsvCategories {
  /** awx wallet user category */
  awxWalletUserCategory?: Maybe<UserCategory>;
  /** Default collections GL account */
  collectionTargetUserCategory?: Maybe<UserCategory>;
  /** personal expense user category */
  personalExpenseUserCategory?: Maybe<UserCategory>;
  /** reimbursement accrual basis accounting user category */
  reimbursementClearingUserCategory?: Maybe<UserCategory>;
  /** reimbursements user category */
  reimbursementsUserCategory?: Maybe<UserCategory>;
  /** Default rewards GL account */
  rewardsIncomeUserCategory?: Maybe<UserCategory>;
}

/** Enum type for cta display style. */
export enum CtaDisplayStyleType {
  DISABLED = "DISABLED",
  NORMAL = "NORMAL",
}

export interface CuratedCard {
  /** cta metadata for the card. */
  ctaInfo?: Maybe<AdminHomeWidgetCTA>;
  /** Full detail of the card. */
  description: Scalars["String"];
  /** Icon url for the curated for you card. */
  iconUrl?: Maybe<Scalars["String"]>;
  /** Image url when side panel is opened. */
  imageUrl?: Maybe<Scalars["String"]>;
  /** Title of the side panel when card is clicked. */
  panelTitle: Scalars["String"];
  /** Summary of the card. */
  summary: Scalars["String"];
  /** Title of the card. */
  title: Scalars["String"];
}

export interface CuratedCarouselConnection {
  curatedContents?: Maybe<Array<CuratedContent>>;
  title?: Maybe<Scalars["String"]>;
}

export type CuratedContent = CuratedCard;

export interface Currency {
  code: Scalars["String"];
}

export interface CurrencyInput {
  code: Scalars["String"];
}

/** Custom expense addendum. */
export interface CustomAddendum extends ExpenseAddendum {
  /** The unique ID of the expense addendum. */
  id: Scalars["ID"];
  /** The metadata that has a list of key value pair. */
  metadata: Array<KeyValuePair>;
}

export interface CustomBranding {
  /** The company's large svg logo, used for dark mode. */
  darkModeMainLogo?: Maybe<Asset>;
  /** The company's primary brand color hexcode, used for dark mode. */
  darkModePrimaryColor?: Maybe<Scalars["String"]>;
  /** The company's square avatar logo, used for dark mode. */
  darkModeSquareAvatarLogo?: Maybe<Asset>;
  /** Unique ID of this custom branding config */
  id: Scalars["ID"];
  /** The company's large svg logo */
  mainLogo: Asset;
  /** The company's primary brand color hexcode. */
  primaryColor: Scalars["String"];
  /** Custom product branding assets */
  productBrandingAssets?: Maybe<Array<ProductBrandingAsset>>;
  /** Human readable product name */
  productName?: Maybe<Scalars["String"]>;
  /** The company's square avatar logo */
  squareAvatarLogo: Asset;
}

export interface CustomBrandingproductBrandingAssetsArgs {
  identifiers?: InputMaybe<Array<ProductBrandingIdentifier>>;
}

/** A representation of an extended field option that will be used to create spend limits. */
export interface CustomFieldValue {
  /** The displayName of the underlying extended field value. */
  displayName: Scalars["String"];
  /** The group this value belongs to. The underlying extended field name. */
  groupName: Scalars["String"];
  /** The unique ID of the extended field option. */
  id: Scalars["ID"];
  /** The identifier of the underlying extended field value. */
  identifier: Scalars["String"];
  /** The key of the underlying extended field value, this is associated with the group the value would fall under. */
  key: Scalars["String"];
}

/** A rule group with a configured name. This can be used for custom categories, and for subcategories. */
export interface CustomRuleGroup {
  name?: Maybe<Scalars["String"]>;
}

export type CustomerIdpDetails = OidcIdpDetails | SamlIdpDetails;

/** Initiated by a Brex customer */
export interface CustomerInitiated {
  /** The external counterparty */
  externalCounterparty?: Maybe<ExternalCounterparty>;
  /** The customer user */
  user?: Maybe<User>;
}

export interface CustomerInitiatedBilling {
  user?: Maybe<User>;
}

/** Customer referral */
export interface CustomerReferral extends Node {
  /** The ID of an object */
  id: Scalars["ID"];
  /** Is customer referral */
  isCustomerReferral?: Maybe<Scalars["Boolean"]>;
}

export interface CustomerSsoExclusion {
  authUserId?: Maybe<Scalars["String"]>;
  customerAccountId: Scalars["String"];
  customerUserId?: Maybe<Scalars["String"]>;
  email: Scalars["String"];
}

export interface CustomerSsoExclusions {
  id: Scalars["ID"];
  users?: Maybe<Array<User>>;
}

export interface CustomerSsoSettings {
  id: Scalars["ID"];
  oidcServiceDetails?: Maybe<OidcServiceDetails>;
  samlServiceProvider?: Maybe<SamlServiceProvider>;
}

export enum CustomerSsoSettingsSsoStatus {
  DELETED = "DELETED",
  DISABLED = "DISABLED",
  ENABLED = "ENABLED",
}

export enum CustomerSsoSettingsSyncStatus {
  DONE = "DONE",
  FAILED = "FAILED",
  IN_PROGRESS = "IN_PROGRESS",
}

/** QBO Customer Type */
export enum CustomerType {
  CUSTOMER = "CUSTOMER",
  PROJECT = "PROJECT",
}

export type CycleDetails =
  | BiWeeklyDetails
  | EveryNDaysDetails
  | MonthlyDetails
  | SemiMonthlyDetails
  | SemiWeeklyDetails
  | WeeklyDetails;

export interface DDAMigrationState {
  customerAccountId: Scalars["ID"];
  state: MigrationState;
}

export interface DDAMigrationTimeline {
  targetedAt?: Maybe<Scalars["Time"]>;
}

export interface DailyBalanceSnapshot {
  balance: Scalars["Long"];
  date: Scalars["Date"];
  depositsAccount: DepositsAccount;
}

export interface DailyScheduleRuleInput {
  /**
   * The date when the recurring will end.
   * null means infinite (until user cancels)
   */
  endAt?: InputMaybe<Scalars["Time"]>;
  /** The number of occurrences of the schedule. If null, the schedule will continue indefinitely (until user cancels) */
  numInstances?: InputMaybe<Scalars["Int"]>;
}

export interface DailyScheduleSpec extends RecurringScheduleSpec {
  /**
   * The date when the recurring will end.
   * null means infinite (until user cancels)
   */
  endAt?: Maybe<Scalars["Time"]>;
  /** The number of occurrences of the schedule. If null, the schedule will continue indefinitely (until user cancels) */
  numInstances?: Maybe<Scalars["Int"]>;
}

export interface DashboardMetadata {
  autoApproveUserIds?: Maybe<Array<Scalars["String"]>>;
  recurrenceId: Scalars["String"];
  source: Scalars["String"];
  uploadSessionId: Scalars["String"];
}

export interface DateFieldInstance extends ExtendedFieldInstance, Node {
  /** The instance of the value associated with this field instance. Null means unset */
  dateValue?: Maybe<Scalars["Date"]>;
  dependencyOfAll?: Maybe<Array<ExtendedFieldInstance>>;
  dependsOnAll?: Maybe<Array<ExtendedFieldInstance>>;
  editStatus?: Maybe<FieldEditStatus>;
  extension?: Maybe<ExtendedFieldInstanceExtension>;
  field: ExtendedField;
  /** The ID of an object */
  id: Scalars["ID"];
  updatedBy?: Maybe<ValueOriginator>;
  workflowValues?: Maybe<Array<WorkflowDateValue>>;
}

export interface DateFieldInstancedependencyOfAllArgs {
  filter?: InputMaybe<ExtendedFieldDependencyFilter>;
}

export interface DateFieldInstancedependsOnAllArgs {
  filter?: InputMaybe<ExtendedFieldDependencyFilter>;
}

export interface DateFieldInstanceInput {
  /** The client mutation id */
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fieldInstanceId: Scalars["ID"];
  /** Explicitly set this to null to clear the value */
  value?: InputMaybe<Scalars["Date"]>;
}

export interface DateHistogramAggregationField {
  count: Scalars["Int"];
  date: Scalars["Int"];
  sum?: Maybe<Scalars["Float"]>;
}

export interface DateHistogramAggregationResult {
  name: Scalars["String"];
  series: Array<Maybe<DateHistogramAggregationField>>;
}

export interface DateInconsistency {
  externalValue?: Maybe<Scalars["Time"]>;
  scdValue?: Maybe<Scalars["Time"]>;
}

/** Contains the parameters to collect information of Date type. */
export interface DateInformation {
  /** Type of the information requirement */
  displayType: RequirementInformationFieldDisplayType;
  /** Identifier of the information requirement */
  key: Scalars["String"];
  /** Latest acceptable date for this information requirement in ISO8601 format */
  maxDate: Scalars["String"];
  /** Earliest acceptable date for this information requirement in ISO8601 format */
  minDate: Scalars["String"];
  /** Name of the information requirement to be displayed */
  name: Scalars["String"];
}

export interface DateOffset {
  /** The type of the interval e.g. DAY */
  intervalType: DateOffsetIntervalType;
  /** The number of intervals */
  intervals: Scalars["Int"];
}

export interface DateOffsetInput {
  /** The type of the interval e.g. DAY */
  intervalType: DateOffsetIntervalType;
  /** The number of intervals */
  intervals: Scalars["Int"];
}

export enum DateOffsetIntervalType {
  DAY = "DAY",
}

export interface DateRangeWithStartAndEndDates {
  dateRangeType: ValueMetricsDateRangeType;
  endDate: Scalars["Time"];
  label: Scalars["String"];
  startDate: Scalars["Time"];
}

export interface DateValue {
  value?: Maybe<Scalars["Date"]>;
}

export interface DayOfMonthScheduleRuleInput {
  /** The day of the month when the recurring schedule is triggered */
  dayOfMonth: Scalars["Int"];
  /**
   * The date when the recurring will end.
   * null means infinite (until user cancels)
   */
  endAt?: InputMaybe<Scalars["Time"]>;
  /** The number of months between being triggered e.g. every 2 months -> interval = 2 */
  interval: Scalars["Int"];
  /**
   * The number of instances of the recurring schedule that will be triggered.
   * null means infinite (until user cancels)
   */
  numInstances?: InputMaybe<Scalars["Int"]>;
}

export interface DayOfMonthScheduleSpec extends RecurringScheduleSpec {
  /** The day of the month when the recurring schedule is triggered */
  dayOfMonth: Scalars["Int"];
  /**
   * The date when the recurring will end.
   * null means infinite (until user cancels)
   */
  endAt?: Maybe<Scalars["Time"]>;
  /** Cadence of the recurring schedule, e.g. every 1 week -> interval = 1 */
  interval: Scalars["Int"];
  /**
   * The number of instances of the recurring schedule that will be triggered.
   * null means infinite (until user cancels)
   */
  numInstances?: Maybe<Scalars["Int"]>;
}

/** One of the 7 days of the week, for example Friday. */
export enum DayOfWeek {
  FRIDAY = "FRIDAY",
  MONDAY = "MONDAY",
  SATURDAY = "SATURDAY",
  SUNDAY = "SUNDAY",
  THURSDAY = "THURSDAY",
  TUESDAY = "TUESDAY",
  WEDNESDAY = "WEDNESDAY",
}

export interface DecimalFieldInstance extends ExtendedFieldInstance, Node {
  /** The instance of the value associated with this field instance. Null means unset */
  decimalValue?: Maybe<Scalars["Decimal"]>;
  dependencyOfAll?: Maybe<Array<ExtendedFieldInstance>>;
  dependsOnAll?: Maybe<Array<ExtendedFieldInstance>>;
  editStatus?: Maybe<FieldEditStatus>;
  extension?: Maybe<ExtendedFieldInstanceExtension>;
  field: ExtendedField;
  /** The ID of an object */
  id: Scalars["ID"];
  updatedBy?: Maybe<ValueOriginator>;
  workflowValues?: Maybe<Array<WorkflowDecimalValue>>;
}

export interface DecimalFieldInstancedependencyOfAllArgs {
  filter?: InputMaybe<ExtendedFieldDependencyFilter>;
}

export interface DecimalFieldInstancedependsOnAllArgs {
  filter?: InputMaybe<ExtendedFieldDependencyFilter>;
}

export interface DecimalFieldInstanceInput {
  /** The client mutation id */
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fieldInstanceId: Scalars["ID"];
  /** Explicitly set this to null to clear the value */
  value?: InputMaybe<Scalars["Decimal"]>;
}

export interface DecimalValue {
  value?: Maybe<Scalars["Decimal"]>;
}

export interface DefaultAccountingIntegrationFieldMapping {
  deletedAt?: Maybe<Scalars["Time"]>;
  extendedField?: Maybe<ExtendedField>;
  extendedFieldOption?: Maybe<ExtendedFieldOption>;
  id: Scalars["ID"];
  status: DefaultIntegrationFieldMappingStatus;
}

export interface DefaultAccountingIntegrationFieldMappingInput {
  defaultFieldId: Scalars["ID"];
  extendedFieldOptionId: Scalars["ID"];
}

export interface DefaultDenyRule {
  enabled: Scalars["Boolean"];
}

export interface DefaultInboxTaskEntityDetails extends InboxTaskEntityDetails {
  /** Base64 encoded entity ID. */
  encodedEntityId: Scalars["String"];
  /** The default entity ID. All tasks must have an entity ID. */
  entityId: Scalars["String"];
}

/** Definition of default integration entity */
export interface DefaultIntegrationEntity extends Node {
  /** time of deletion */
  deletedAt?: Maybe<Scalars["Time"]>;
  /** ID of integration entity */
  entityId: Scalars["ID"];
  /** integration entity name */
  entityName?: Maybe<Scalars["String"]>;
  /** ID of integration field that entity belongs to */
  fieldId: Scalars["ID"];
  /** integration field name */
  fieldName?: Maybe<Scalars["String"]>;
  /** integration field type */
  fieldType?: Maybe<Scalars["String"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  /** whether this entity was marked as inactive */
  isInactive?: Maybe<Scalars["Boolean"]>;
}

export interface DefaultIntegrationEntityConnection {
  edges?: Maybe<Array<Maybe<DefaultIntegrationEntityEdge>>>;
  pageInfo: PageInfo;
}

export interface DefaultIntegrationEntityEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<DefaultIntegrationEntity>;
}

export interface DefaultIntegrationFieldMapping {
  deletedAt?: Maybe<Scalars["Time"]>;
  extendedFieldId: Scalars["ID"];
  extendedFieldOptionId: Scalars["ID"];
  id: Scalars["ID"];
  status?: Maybe<DefaultIntegrationFieldMappingStatus>;
  subsidiaryId: Scalars["ID"];
}

export interface DefaultIntegrationFieldMappingConnection extends Connection {
  edges: Array<DefaultIntegrationFieldMappingConnectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"];
}

export interface DefaultIntegrationFieldMappingConnectionEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<DefaultIntegrationFieldMapping>;
}

export enum DefaultIntegrationFieldMappingStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

export interface DefaultOverridableLimitFields {
  /** Limit on the spend limit */
  limit?: InputMaybe<FinancialAssetInput>;
}

export interface DefaultRequestConfig {
  /**
   * A dummy field because objects need to have at least one field.
   * https://spec.graphql.org/October2021/#sec-Objects
   */
  _?: Maybe<Scalars["Boolean"]>;
}

export interface DelayedEINDetailsInput {
  /** Asset ID of form SS4 upload. */
  formSS4File: Scalars["String"];
  /** Whether the entity has an EIN or not. */
  hasEIN: Scalars["Boolean"];
}

/** VX Workflow Action to delete a Field */
export interface DeleteAction {
  /** The field to delete. */
  leftHandSide: LeftHandSide;
}

/** VX Workflow Action to delete a Field */
export interface DeleteActionInput {
  /** The field to delete. */
  leftHandSide: LeftHandSideOneOfInput;
}

export interface DeleteAutoInviteSettingInput {
  id: Scalars["ID"];
}

export interface DeleteAutoInviteSettingResult extends MutationResult {
  errors?: Maybe<Array<AutoInviteSettingError>>;
  result?: Maybe<Scalars["Boolean"]>;
}

export interface DeleteBillInput {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
}

export interface DeleteBillPayload {
  clientMutationId: Scalars["String"];
}

export interface DeleteBillV2Input {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
}

export interface DeleteBudgetInput {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
}

export interface DeleteBudgetResult {
  /** The result of the budget deletion - success/failure */
  budgetDeletionResult: Scalars["Boolean"];
}

/** Input to delete a budget template. */
export interface DeleteBudgetTemplateInput {
  budgetTemplateId: Scalars["ID"];
}

export interface DeleteBudgetTemplateResult extends MutationResult {
  /** A list of user errors for mutation responses. Clients should always request this field when performing mutations */
  errors?: Maybe<Array<ClientError>>;
}

export interface DeleteBudgetsResult {
  /** The result of the budget deletions - success/failure */
  budgetDeletionResults: Array<DeleteBudgetResult>;
}

export interface DeleteContactInput {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
}

export interface DeleteContactPayload {
  clientMutationId: Scalars["String"];
  contact: PaymentContact;
}

export interface DeleteCostCenterInput {
  /** clientMutationId */
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** The ID of the cost center to delete. */
  id: Scalars["ID"];
}

export interface DeleteCostCenterResult {
  /** ID of the cost center that was deleted. */
  id: Scalars["ID"];
}

export interface DeleteCustomRoleInput {
  id: Scalars["ID"];
}

export interface DeleteCustomRoleResult extends MutationResult {
  errors?: Maybe<Array<AuthRoleError>>;
  /** ID of the custom role that was deleted. */
  result?: Maybe<Scalars["Boolean"]>;
}

export interface DeleteCustomerSsoExclusionError extends SsoClientError {
  code?: Maybe<SsoClientErrorCode>;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export type DeleteCustomerSsoExclusionResult =
  | DeleteCustomerSsoExclusionError
  | DeletedCustomerSsoExclusions;

/** Deletes a default field with the given ID */
export interface DeleteDefaultIntegrationFieldMappingInput {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
}

export interface DeleteDefaultIntegrationFieldMappingResult
  extends MutationResult {
  errors?: Maybe<Array<AccountingIntegrationMutationError>>;
}

/** Delete a mapping between a entity and another value on an integration */
export interface DeleteEntityMappingInput {
  /** ID of the integration. */
  integrationId: Scalars["ID"];
  /** ID of the value mapped from that we wish to delete */
  mappingInputId: Scalars["ID"];
  /** ID of the extended field the value we are mapping to */
  mappingOutputFieldId?: InputMaybe<Scalars["ID"]>;
  /** ID of the value mapped to that we wish to delete */
  mappingOutputId: Scalars["ID"];
  /** Type of mapping we are deleting */
  mappingType: EntityMappingType;
}

export interface DeleteEntityMappingResult extends MutationResult {
  errors?: Maybe<Array<AccountingIntegrationMutationError>>;
  result?: Maybe<EntityMapping>;
}

/** Top-level input fields for deleting an extended field */
export interface DeleteExtendedFieldInput {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
}

/** Response of extended field deletion */
export interface DeleteExtendedFieldResult {
  extendedFieldDeletionResult?: Maybe<Scalars["ID"]>;
}

/** Top-level input fields for deleting an extended field visibility rule */
export interface DeleteExtendedFieldVisibilityRuleInput {
  id: Scalars["ID"];
}

/** Response of extended field visibility rule deletion */
export interface DeleteExtendedFieldVisibilityRuleResult
  extends MutationResult {
  errors?: Maybe<Array<ExtendedFieldVisibilityRuleMutationError>>;
  extendedFieldVisibilityRuleDeletionResult: Scalars["Boolean"];
}

export interface DeleteFinancialDocumentInput {
  /** clientMutationId client-supplied idempotency key for a given mutation request. */
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** ID of the financial document to delete on behalf of the user */
  encodedFinancialDocumentId: Scalars["ID"];
}

export interface DeleteFinancialDocumentResponse {
  success: Scalars["Boolean"];
}

export interface DeleteFinancialDocumentResult extends MutationResult {
  errors?: Maybe<Array<LimitsExperienceMutationError>>;
  /** API response */
  result?: Maybe<DeleteFinancialDocumentResponse>;
}

export interface DeleteGroupEventInput {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
}

export interface DeleteGroupEventResult {
  error?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["String"]>;
}

export interface DeleteGroupInput {
  id: Scalars["ID"];
}

export interface DeleteGroupResult extends MutationResult {
  errors?: Maybe<Array<GroupsMutationError>>;
}

export interface DeleteIntegrationRuleInput {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
}

export interface DeleteIntegrationRulePayload {
  clientMutationId: Scalars["String"];
}

export interface DeleteInvoiceV1Input {
  /** Idempotency key. */
  idempotencyKey: Scalars["String"];
  /** Base invoice id. */
  invoiceId: Scalars["ID"];
}

export interface DeleteInvoiceV1Result extends MutationResult {
  errors?: Maybe<Array<InvoicingV1ClientError>>;
  result?: Maybe<InvoiceV1>;
  success: Scalars["Boolean"];
}

export interface DeleteItineraryActivityInput {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
}

export interface DeleteItineraryActivityResult {
  error?: Maybe<Scalars["String"]>;
  /** ID of the itinerary activity that was deleted. */
  id?: Maybe<Scalars["String"]>;
}

export interface DeleteLegalEntityInput {
  /** clientMutationId */
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** The ID of the legal entity to delete. */
  id: Scalars["ID"];
}

export interface DeleteLegalEntityResult {
  /** ID of the legal entity that was deleted. */
  id: Scalars["ID"];
}

/** Input for the limit group deletion */
export interface DeleteLimitGroupInput {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
}

export interface DeleteLimitGroupResult extends MutationResult {
  errors?: Maybe<Array<LimitGroupMutationError>>;
}

export interface DeleteMappingClassInput {
  /** The mapping class to delete. */
  mappingClassId: Scalars["ID"];
}

export interface DeleteMappingClassResult {
  mappingClassId: Scalars["ID"];
}

export interface DeleteMappingInput {
  /** The mapping to delete. */
  mappingId: Scalars["ID"];
}

export interface DeleteMappingResult {
  mappingClass?: Maybe<MappingClass>;
  mappingId: Scalars["ID"];
}

export interface DeletePaymentInstrumentInput {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
}

export interface DeletePaymentInstrumentPayload {
  clientMutationId: Scalars["String"];
}

export interface DeletePolicySpecSectionError extends MutationError {
  errors?: Maybe<Array<DeletePolicySpecSectionErrors>>;
}

export enum DeletePolicySpecSectionErrorCode {
  FAILED_PRECONDITION = "FAILED_PRECONDITION",
  INVALID_SECTION_ID_FORMAT = "INVALID_SECTION_ID_FORMAT",
  SECTION_NOT_FOUND = "SECTION_NOT_FOUND",
}

export interface DeletePolicySpecSectionErrors {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface DeletePolicySpecSectionInput {
  /**
   * The ID of the section to repoint dependencies (such as spend limits) to
   *
   * Since this is optional, if not provided, the dependencies will be repointed to the default section
   */
  repointDependenciesToSection?: InputMaybe<Scalars["ID"]>;
  /** The ID of the section to delete */
  sectionId: Scalars["ID"];
}

export interface DeletePolicySpecSectionInvalidArgumentError
  extends DeletePolicySpecSectionErrors,
    StandardClientError {
  code: ErrorCode;
  errorCode?: Maybe<DeletePolicySpecSectionErrorCode>;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export type DeletePolicySpecSectionResult =
  | DeletePolicySpecSectionError
  | ExpensePolicySpecSectionBlock;

export interface DeletePolicySpecSectionUnmappedError
  extends DeletePolicySpecSectionErrors,
    StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface DeletePositivePayAccountSettingInput {
  achCompanyId: Scalars["ID"];
  clientMutationId: Scalars["String"];
}

export interface DeletePositivePayAccountSettingPayload {
  clientMutationId: Scalars["String"];
  positivePayAccountSetting: PositivePayAccountSetting;
}

export interface DeletePurchaseOrdersInput {
  /** Client mutation ID for tracking */
  clientMutationId: Scalars["String"];
  /** The IDs of the purchase orders to delete */
  ids: Array<Scalars["ID"]>;
}

export interface DeletePurchaseOrdersResult extends MutationResult {
  errors?: Maybe<Array<PurchaseOrderMutationError>>;
  result?: Maybe<Array<Scalars["ID"]>>;
}

export interface DeleteRailAccountDetailsError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface DeleteRailAccountDetailsInput {
  id: Scalars["ID"];
  idempotencyKey: Scalars["String"];
}

export interface DeleteRailAccountDetailsResult extends MutationResult {
  errors?: Maybe<Array<DeleteRailAccountDetailsError>>;
  result?: Maybe<RailAccountDetails>;
}

export interface DeleteReceiptInput {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
}

export interface DeleteReceiptIntegrationInput {
  /**
   * Provider-specific data needed to delete an integration.
   * Exactly one of the fields must be set.
   */
  uber?: InputMaybe<DeleteUberReceiptIntegrationInput>;
}

export interface DeleteReceiptIntegrationResponse {
  success: Scalars["Boolean"];
}

export interface DeleteReceiptPayload {
  clientMutationId: Scalars["String"];
}

export interface DeleteReimbursementInput {
  /** Mutation id */
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** Expense ID */
  expenseId: Scalars["ID"];
}

export interface DeleteReimbursementPayload {
  clientMutationId?: Maybe<Scalars["String"]>;
  /** The expense that was deleted. */
  expense?: Maybe<Expense>;
}

export interface DeleteReportTemplateInput {
  /** Template id for the template to delete */
  id: Scalars["ID"];
}

export interface DeleteReportingDashboardInput {
  /** The Dashboard to delete. */
  id: Scalars["ID"];
}

export interface DeleteReportingDashboardResult extends MutationResult {
  /** No error if the dashboard was deleted successfully */
  errors?: Maybe<Array<ReportingClientError>>;
}

/** Input for the spend budget deletion */
export interface DeleteSpendBudgetInput {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
}

export interface DeleteSpendBudgetResult extends MutationResult {
  errors?: Maybe<Array<SpendBudgetMutationError>>;
}

/** Input for the spend limit deletion */
export interface DeleteSpendLimitInput {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
}

export interface DeleteSpendLimitResult extends MutationResult {
  errors?: Maybe<Array<StandardClientError>>;
}

export interface DeleteSubscriptionInput {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
}

export interface DeleteSubscriptionPayload {
  clientMutationId: Scalars["String"];
}

export interface DeleteSubscriptionsInput {
  clientMutationId: Scalars["String"];
  ids: Array<Scalars["ID"]>;
}

export interface DeleteSubscriptionsPayload {
  clientMutationId: Scalars["String"];
}

export interface DeleteSubsidiaryDefaultEntityInput {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
}

export interface DeleteSubsidiaryDefaultEntityPayload {
  clientMutationId: Scalars["String"];
}

export interface DeleteTitleInput {
  /** clientMutationId */
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** The ID of the title to delete. */
  id: Scalars["ID"];
}

export interface DeleteTitleResult {
  /** ID of the title that was deleted. */
  id: Scalars["ID"];
}

export interface DeleteTrackingExpensePolicyInput {
  /** The id of the policy to delete */
  id: Scalars["ID"];
}

export interface DeleteUberReceiptIntegrationInput {
  /** Uber for Business organization UUID to delete. */
  organizationUuid: Scalars["String"];
}

export interface DeleteVendorsInput {
  ids: Array<Scalars["ID"]>;
}

export interface DeleteVendorsResult extends MutationResult {
  errors?: Maybe<Array<VendorMutationError>>;
  result?: Maybe<Array<Scalars["ID"]>>;
}

export interface DeleteWorkflowRuleInput {
  id: Scalars["ID"];
}

export interface DeletedCustomerSsoExclusions {
  id: Scalars["ID"];
  users?: Maybe<Array<User>>;
}

export interface DeletedValue {
  fieldName?: Maybe<Scalars["String"]>;
  key?: Maybe<Scalars["String"]>;
}

export interface DeliveryDaysRange {
  /** Maximum number of days for the delivery range */
  end: Scalars["Int"];
  /** Minimum number of days for the delivery range */
  start: Scalars["Int"];
}

export interface DemoPayload {
  demoInternalId?: Maybe<Scalars["String"]>;
}

export enum DemosceneAccountType {
  DEMO = "DEMO",
  SANDBOX = "SANDBOX",
}

export interface Department extends Node {
  deletedAt?: Maybe<Scalars["Time"]>;
  description?: Maybe<Scalars["String"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  /** Number of employees associated with the department */
  membersCount?: Maybe<Scalars["Int"]>;
  name?: Maybe<Scalars["String"]>;
}

/** Department connection for pagination */
export interface DepartmentConnection extends Connection {
  edges: Array<DepartmentEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

/** Department edge for the Department connection. */
export interface DepartmentEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<Department>;
}

/** The available fields that are queryable that relate to departments */
export enum DepartmentFieldKeyType {
  ALL = "ALL",
  NAME = "NAME",
}

export interface DepartmentFieldKeyTypeWrapper {
  key: DepartmentFieldKeyType;
}

/** Filters for the department entity. */
export interface DepartmentFieldMatcherInput {
  /**
   * Fuzzy search by department name. This only includes results that the department's name contains specified search
   * substring. The returned results are sorted by similarity.
   */
  nameSearch?: InputMaybe<Scalars["String"]>;
}

export interface DepartmentIdentifier {
  id?: InputMaybe<Scalars["ID"]>;
  name?: InputMaybe<Scalars["String"]>;
  type: DepartmentIdentifierType;
}

export enum DepartmentIdentifierType {
  ID = "ID",
  NAME = "NAME",
}

/** Filters for list departments query. */
export interface DepartmentsFilterInput {
  /** Filter by department ID. */
  id?: InputMaybe<Scalars["ID"]>;
  query?: InputMaybe<Scalars["String"]>;
}

export interface DependencyFilterInput {
  filterIdentifier: Scalars["ID"];
  filterType: GroupFilterType;
}

export interface DepositChequeInput {
  amount: Scalars["Int"];
  backImageAssetId: Scalars["ID"];
  clientMutationId: Scalars["String"];
  depositsAccountId: Scalars["ID"];
  frontImageAssetId: Scalars["ID"];
  idempotencyKey: Scalars["String"];
  memo?: InputMaybe<Scalars["String"]>;
  senderName: Scalars["String"];
}

export interface DepositChequePayload {
  amount: Scalars["Int"];
  backImageAssetId: Scalars["ID"];
  chequeNumber?: Maybe<Scalars["Int"]>;
  clientMutationId: Scalars["String"];
  expectedDeliveryDate?: Maybe<Scalars["String"]>;
  frontImageAssetId: Scalars["ID"];
  recipientName?: Maybe<Scalars["String"]>;
  senderName?: Maybe<Scalars["String"]>;
  status: Scalars["String"];
}

/** DepositsAccount represent a Brex Cash (aka BBA) account */
export interface DepositsAccount extends Node {
  /** The account number, this will be null for restricted accounts */
  accountNumber?: Maybe<Scalars["String"]>;
  /** The last four of the account number */
  accountNumberLastFour?: Maybe<Scalars["String"]>;
  /** The type of account - Legacy cash, Checking, Vault, Treasury. */
  accountType: DepositsAccountType;
  accrualsPaid?: Maybe<AccrualsPaid>;
  achDebitLimits: AchDebitLimits;
  activatedAt?: Maybe<Scalars["Time"]>;
  /** Settings that dictate when automatic transfers are initiated */
  automaticTransferSettings?: Maybe<AutomaticTransferSettings>;
  balance: Scalars["Int"];
  balanceBreakdown?: Maybe<BalanceBreakdown>;
  /** Whether the account has access to outgoing ach debits */
  canAchDebit: Scalars["Boolean"];
  /** Whether the account has access to the add funds feature */
  canAddFunds: Scalars["Boolean"];
  /** Whether this account can enter the user-initiated offboarding process */
  canOffboard: CanOffboardResponse;
  /** This is equivalent to can_add_funds */
  canSeeCashAccountDetails: Scalars["Boolean"];
  /** Whether the account has access to the international wires feature */
  canSendInternationalWires: Scalars["Boolean"];
  /** Whether the account is allowed to send outgoing ACH/Wire/Cheque */
  canSendPayment: Scalars["Boolean"];
  /** Whether funds can be withdrawn during the account closure process */
  canWithdrawFunds?: Maybe<CanWithdrawFundsResponse>;
  /**
   * Cash transactions belonging to the deposits account. Statuses is the
   * only required filter. Supports first: and after: cursor based pagination.
   */
  cashTransactions?: Maybe<CashTransactionConnection>;
  cashflow?: Maybe<Cashflow>;
  chequeDepositLimits: ChequeDepositLimits;
  constants: Constants;
  counterparties?: Maybe<CounterpartyConnection>;
  /** Category information for counterparties */
  counterpartiesCategoryInformation?: Maybe<CounterpartyCategoryInformationConnection>;
  /** The time at which the account was migrated to a DDA */
  ddaMigratedAt?: Maybe<Scalars["Time"]>;
  depositsAccountYieldRate?: Maybe<DepositsAccountYieldRate>;
  /** The color that will be associated with the account in the UI */
  displayColor: DepositsAccountsDisplayColor;
  /** Whether the account is subject to ACH payout delay */
  hasAchPayoutDelay: Scalars["Boolean"];
  /** Whether the account has a brex originated ach debit */
  hasBrexOriginatedAchDebit: Scalars["Boolean"];
  /** Deposits account id, required for BBA payments. */
  id: Scalars["ID"];
  internationalCountriesTransactedWith: Array<Scalars["String"]>;
  investmentPolicyBreakdown: InvestmentPolicyBreakdown;
  name: Scalars["String"];
  /** Nickname specified by user for the account */
  nickname: Scalars["String"];
  /** The withdrawal of the account's balance initiated during the account closure process */
  offboardingWithdrawal?: Maybe<DepositsPayment>;
  /** Whether this account is primary or non_primary */
  priority: DepositsAccountsPriority;
  restrictAchDebits: Scalars["Boolean"];
  routingNumber: Scalars["String"];
  /** SACA commitment amount for the account */
  sacaCommitmentAmount?: Maybe<FinancialAsset>;
  /** Deprecated. Use cashTransactions() field instead. */
  searchDepositsTransactions?: Maybe<DepositsTransactionConnection>;
  /** Whether points should be automatically withdrawn during the account closure process */
  shouldWithdrawPoints?: Maybe<ShouldWithdrawPointsResponse>;
  statements?: Maybe<DepositsStatementConnection>;
  status: DepositsAccountStatus;
  /** Account's status reason (optional) */
  statusReason?: Maybe<DepositsAccountStatusReason>;
  totalAccrualBalance?: Maybe<FinancialAsset>;
  /** Total amount that the account has earned from dividend payouts */
  totalInterestYield: Scalars["Int"];
  transactions?: Maybe<DepositsTransactionConnection>;
  /** Whether the account uses JPM for international wires */
  usesJpmForInternationalWires: Scalars["Boolean"];
  /** The withdrawal status of a possible offboarding process. Returns null if account is not being offboarded */
  withdrawalStatus?: Maybe<DepositsAccountsWithdrawalStatus>;
  /** @deprecated Use accrualsPaid instead */
  yieldUSDCents: Scalars["Long"];
}

/** DepositsAccount represent a Brex Cash (aka BBA) account */
export interface DepositsAccountaccrualsPaidArgs {
  endDate?: InputMaybe<Scalars["Date"]>;
  startDate?: InputMaybe<Scalars["Date"]>;
}

/** DepositsAccount represent a Brex Cash (aka BBA) account */
export interface DepositsAccountcashTransactionsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  endInitiatedAt?: InputMaybe<Scalars["Time"]>;
  endProcessedAt?: InputMaybe<Scalars["Time"]>;
  endScheduledSendAt?: InputMaybe<Scalars["Time"]>;
  first?: InputMaybe<Scalars["Int"]>;
  isRecurring?: InputMaybe<Scalars["Boolean"]>;
  last?: InputMaybe<Scalars["Int"]>;
  maxAmountUsdCents?: InputMaybe<Scalars["Int"]>;
  minAmountUsdCents?: InputMaybe<Scalars["Int"]>;
  orderBy?: InputMaybe<Array<CashTransactionOrderBy>>;
  origin?: InputMaybe<CashTransactionOrigin>;
  paymentMethod?: InputMaybe<CashTransactionPaymentMethod>;
  recurringScheduleId?: InputMaybe<Scalars["ID"]>;
  searchQuery?: InputMaybe<Scalars["String"]>;
  startInitiatedAt?: InputMaybe<Scalars["Time"]>;
  startProcessedAt?: InputMaybe<Scalars["Time"]>;
  startScheduledSendAt?: InputMaybe<Scalars["Time"]>;
  statuses: Array<CashTransactionStatus>;
  transactionTypes?: InputMaybe<Array<CashTransactionType>>;
}

/** DepositsAccount represent a Brex Cash (aka BBA) account */
export interface DepositsAccountcounterpartiesArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

/** DepositsAccount represent a Brex Cash (aka BBA) account */
export interface DepositsAccountcounterpartiesCategoryInformationArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  category?: InputMaybe<CounterpartyCategory>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

/** DepositsAccount represent a Brex Cash (aka BBA) account */
export interface DepositsAccountsearchDepositsTransactionsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  endTime?: InputMaybe<Scalars["Time"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  query?: InputMaybe<Scalars["String"]>;
  recurringPaymentId?: InputMaybe<Scalars["ID"]>;
  startTime?: InputMaybe<Scalars["Time"]>;
  status?: InputMaybe<Status>;
}

/** DepositsAccount represent a Brex Cash (aka BBA) account */
export interface DepositsAccountstatementsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  endTime?: InputMaybe<Scalars["Time"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  startTime?: InputMaybe<Scalars["Time"]>;
}

/** DepositsAccount represent a Brex Cash (aka BBA) account */
export interface DepositsAccounttransactionsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  endTime?: InputMaybe<Scalars["Time"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  origin?: InputMaybe<Origin>;
  paymentMethod?: InputMaybe<Method>;
  recurringPaymentId?: InputMaybe<Scalars["ID"]>;
  startTime?: InputMaybe<Scalars["Time"]>;
  status?: InputMaybe<Status>;
}

/** DepositsAccount represent a Brex Cash (aka BBA) account */
export interface DepositsAccountyieldUSDCentsArgs {
  endDate?: InputMaybe<Scalars["Date"]>;
  startDate?: InputMaybe<Scalars["Date"]>;
}

export enum DepositsAccountClosureReason {
  BUSINESS_IS_CLOSING = "BUSINESS_IS_CLOSING",
  DEPOSITS_TOO_SLOW = "DEPOSITS_TOO_SLOW",
  FOUND_ANOTHER_BANK = "FOUND_ANOTHER_BANK",
  INVALID = "INVALID",
  LIMITED_SAME_DAY_BALANCE = "LIMITED_SAME_DAY_BALANCE",
  MISSING_FUNCTIONALITY = "MISSING_FUNCTIONALITY",
  NOT_ENOUGH_PRODUCTS = "NOT_ENOUGH_PRODUCTS",
  OTHER = "OTHER",
  WANTED_30_DAY_CARD = "WANTED_30_DAY_CARD",
  WITHDRAWALS_TOO_SLOW = "WITHDRAWALS_TOO_SLOW",
}

export interface DepositsAccountConnection {
  edges?: Maybe<Array<Maybe<DepositsAccountEdge>>>;
  pageInfo: PageInfo;
}

export interface DepositsAccountDailySnapshot {
  date: Scalars["String"];
  endingBalanceSnapshot: Scalars["Long"];
  totalCashInflows: Scalars["Long"];
  totalCashOutflows: Scalars["Long"];
  totalTransactions: Scalars["Int"];
}

export interface DepositsAccountDailySnapshots {
  dailySnapshots: Array<DepositsAccountDailySnapshot>;
  depositsAccountId: Scalars["String"];
}

export interface DepositsAccountEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<DepositsAccount>;
}

export enum DepositsAccountStatus {
  ACTIVE = "ACTIVE",
  CLOSED = "CLOSED",
  REJECTED = "REJECTED",
  RESTRICTED = "RESTRICTED",
  SUSPENDED = "SUSPENDED",
}

export enum DepositsAccountStatusReason {
  AUTOMATED_OFFBOARDING = "AUTOMATED_OFFBOARDING",
  DACA_SUSPENSION = "DACA_SUSPENSION",
  DDA_MIGRATION = "DDA_MIGRATION",
  EIN_PENDING = "EIN_PENDING",
  FRAUD = "FRAUD",
  INVALID = "INVALID",
  LOCKBOX = "LOCKBOX",
  MANUAL_OFFBOARDING = "MANUAL_OFFBOARDING",
  OTHER = "OTHER",
  PENDING_VERIFICATION = "PENDING_VERIFICATION",
  REOPEN_RETURN_FUNDS = "REOPEN_RETURN_FUNDS",
  SACA_SUSPENSION = "SACA_SUSPENSION",
  SB_WINDDOWN_OFFBOARD = "SB_WINDDOWN_OFFBOARD",
  TOS_VIOLATION = "TOS_VIOLATION",
  USER_INITIATED = "USER_INITIATED",
}

export enum DepositsAccountType {
  CHECKING = "CHECKING",
  INVALID = "INVALID",
  LEGACY_CASH = "LEGACY_CASH",
  TREASURY = "TREASURY",
  VAULT = "VAULT",
}

export interface DepositsAccountYieldRate {
  apyBps?: Maybe<Scalars["Int"]>;
  sevenDayApyBps: Scalars["Int"];
  totalApyBps?: Maybe<Scalars["Int"]>;
  yieldRateDate: Scalars["Date"];
}

export enum DepositsAccountsDisplayColor {
  GREEN_BASELINE = "GREEN_BASELINE",
  INVALID = "INVALID",
  JAM = "JAM",
  NAVY_MID = "NAVY_MID",
  OCEAN = "OCEAN",
  ORANGE_BASELINE = "ORANGE_BASELINE",
  PURPLE_BASELINE = "PURPLE_BASELINE",
  ROYAL = "ROYAL",
  YELLOW_BASELINE = "YELLOW_BASELINE",
}

export enum DepositsAccountsPriority {
  INVALID = "INVALID",
  NON_PRIMARY = "NON_PRIMARY",
  PRIMARY = "PRIMARY",
}

export enum DepositsAccountsWithdrawalStatus {
  APPROVAL_REQUIRED = "APPROVAL_REQUIRED",
  FAILED = "FAILED",
  INVALID = "INVALID",
  NOT_STARTED = "NOT_STARTED",
  PROCESSED = "PROCESSED",
  PROCESSING = "PROCESSING",
}

export interface DepositsAdminBalanceAdjustmentDetails {
  description?: Maybe<Scalars["String"]>;
  method: Method;
}

export enum DepositsCloseAccountIssue {
  INVALID = "INVALID",
  NEGATIVE_BALANCE = "NEGATIVE_BALANCE",
  PRIMARY_CARD_FUNDING_SOURCE = "PRIMARY_CARD_FUNDING_SOURCE",
  WRONG_DEPOSITS_ACCOUNT_STATUS = "WRONG_DEPOSITS_ACCOUNT_STATUS",
}

/**  Defined in the DepositsPayment component in APIv1 */
export interface DepositsMonthlySchedule {
  dayOccurrence?: Maybe<Scalars["Int"]>;
  dayOfMonth?: Maybe<Scalars["Int"]>;
  dayOfWeek?: Maybe<BusinessDays>;
  nMonths: Scalars["Int"];
  weekOfMonth?: Maybe<Scalars["Int"]>;
}

export interface DepositsPayment extends Node {
  amount: Scalars["Int"];
  associationIds?: Maybe<Array<Maybe<Scalars["String"]>>>;
  bill?: Maybe<Bill>;
  cancellationInitiatedByUser?: Maybe<User>;
  cancelledAt?: Maybe<Scalars["Time"]>;
  /** Encoded CashTransaction ID */
  cashTransactionId: Scalars["ID"];
  consumerSettings?: Maybe<DepositsTransactionConsumerSettings>;
  contact?: Maybe<PaymentContact>;
  counterpartyName: Scalars["String"];
  createdAt: Scalars["Time"];
  createdOn: Scalars["Date"];
  /** Source deposits account */
  depositsAccount?: Maybe<DepositsAccount>;
  /** Encoded source deposits account ID */
  depositsAccountId: Scalars["ID"];
  depositsTraceId?: Maybe<Scalars["String"]>;
  details: DepositsPaymentDetails;
  endsAt?: Maybe<Scalars["Time"]>;
  endsOn?: Maybe<Scalars["Date"]>;
  externalMemo?: Maybe<Scalars["String"]>;
  fxQuote?: Maybe<PaymentFxQuote>;
  /** The ID of an object */
  id: Scalars["ID"];
  memo?: Maybe<Scalars["String"]>;
  recurringRules?: Maybe<RecurringRules>;
  recurringSchedule?: Maybe<RecurringSchedule>;
  sendAt?: Maybe<Scalars["Time"]>;
  sendOn?: Maybe<Scalars["Date"]>;
  status: DepositsPaymentStatus;
  statusReason?: Maybe<StatusReason>;
  totalNumberOfPayments?: Maybe<Scalars["Int"]>;
  /** The raw transaction_id (not encoded). */
  transactionId?: Maybe<Scalars["ID"]>;
  type: PaymentRail;
}

export type DepositsPaymentDetails =
  | AchDetails
  | BrexOriginatedChequeDetails
  | DepositsPayrollEstimateDetails
  | WireDetails;

/** Input for specifying a deposits payment source */
export interface DepositsPaymentSourceInput {
  checkBalance?: InputMaybe<Scalars["Boolean"]>;
  internalTransferType?: InputMaybe<InternalTransferType>;
  sourceDepositsAccountId: Scalars["String"];
  sourceDepositsTransactionId?: InputMaybe<Scalars["String"]>;
  targetDepositsAccountId?: InputMaybe<Scalars["String"]>;
}

export enum DepositsPaymentStatus {
  ADMIN_APPROVAL_REQUIRED = "ADMIN_APPROVAL_REQUIRED",
  APPROVAL_REQUIRED = "APPROVAL_REQUIRED",
  BILL_APPROVAL_REQUIRED = "BILL_APPROVAL_REQUIRED",
  CANCELLED = "CANCELLED",
  PAYROLL_ESTIMATE = "PAYROLL_ESTIMATE",
  PROCESSED = "PROCESSED",
  PROCESSING = "PROCESSING",
  SCHEDULED = "SCHEDULED",
  UNINITIATED = "UNINITIATED",
}

export interface DepositsPayrollEstimateDetails {
  counterparty: Counterparty;
  origin: Origin;
  paymentMethod: Method;
  payrollPeriod: Scalars["String"];
}

export enum DepositsRecurringPaymentCancellationType {
  PROCESSING_AND_RECURRING_PAYMENT = "PROCESSING_AND_RECURRING_PAYMENT",
  PROCESSING_PAYMENT = "PROCESSING_PAYMENT",
  RECURRING_PAYMENT = "RECURRING_PAYMENT",
}

export enum DepositsRole {
  ADMIN = "ADMIN",
  BOOKKEEPER = "BOOKKEEPER",
  USER = "USER",
}

export interface DepositsStatement extends Node {
  /** The ID of an object */
  id: Scalars["ID"];
  name: Scalars["String"];
  periodEndTime: Scalars["Time"];
  periodStartTime: Scalars["Time"];
}

export interface DepositsStatementConnection {
  edges?: Maybe<Array<Maybe<DepositsStatementEdge>>>;
  pageInfo: PageInfo;
}

export interface DepositsStatementEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<DepositsStatement>;
}

export interface DepositsTransaction extends Node {
  /** The snapshot of the balance across all of the customer's deposits accounts at the time this transaction was applied. */
  aggregateSnapshotBalance?: Maybe<Scalars["Int"]>;
  amount: Scalars["Int"];
  cancellationInitiatedByUser?: Maybe<User>;
  /** Encoded CashTransaction ID */
  cashTransactionId: Scalars["ID"];
  counterpartyName?: Maybe<Scalars["String"]>;
  /** Source deposits account */
  depositsAccount?: Maybe<DepositsAccount>;
  /** Encoded source deposits account ID */
  depositsAccountId: Scalars["ID"];
  depositsTraceId: Scalars["String"];
  details: DepositsTransactionDetails;
  /** The ID of an object */
  id: Scalars["ID"];
  memo?: Maybe<Scalars["String"]>;
  postedAt: Scalars["Time"];
  recurringPaymentId?: Maybe<Scalars["ID"]>;
  settledAt?: Maybe<Scalars["Time"]>;
  snapshotBalance?: Maybe<Scalars["Int"]>;
  status: Status;
  type: DepositsTransactionType;
}

export interface DepositsTransactionConnection {
  edges?: Maybe<Array<Maybe<DepositsTransactionEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"];
}

/** The transaction consumer related settings */
export interface DepositsTransactionConsumerSettings {
  /** The recipient notification setting to indicate at what stages we want to send out notifications */
  recipientNotificationSetting?: Maybe<NotificationSetting>;
}

export type DepositsTransactionDetails =
  | AchDetails
  | AchReturnDetails
  | BookTransferDetails
  | BrexOperationalTransferDetails
  | BrexOriginatedChequeDetails
  | CardCollectionDetails
  | DepositsAdminBalanceAdjustmentDetails
  | DividendDetails
  | ExternallyOriginatedChequeDetails
  | FboTransferDetails
  | InterestDetails
  | IntraCustomerAccountBookTransferDetails
  | PaybackDetails
  | PaymentDetails
  | ReceivablesOffersAdvanceDetails
  | ReceivablesOffersRepaymentDetails
  | RewardsRedemptionDetails
  | WireDetails;

export interface DepositsTransactionEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<DepositsTransaction>;
}

export enum DepositsTransactionType {
  ACH = "ACH",
  ACH_RETURN = "ACH_RETURN",
  ADMIN_BALANCE_ADJUSTMENT = "ADMIN_BALANCE_ADJUSTMENT",
  BOOK_TRANSFER = "BOOK_TRANSFER",
  BREX_OPERATIONAL_TRANSFER = "BREX_OPERATIONAL_TRANSFER",
  CARD_COLLECTION = "CARD_COLLECTION",
  CHEQUE = "CHEQUE",
  CHEQUE_RETURN = "CHEQUE_RETURN",
  DIVIDEND = "DIVIDEND",
  FBO_TRANSFER = "FBO_TRANSFER",
  INTEREST = "INTEREST",
  INTRA_CUSTOMER_ACCOUNT_BOOK_TRANSFER = "INTRA_CUSTOMER_ACCOUNT_BOOK_TRANSFER",
  PAYBACK = "PAYBACK",
  RECEIVABLES_OFFERS_ADVANCE = "RECEIVABLES_OFFERS_ADVANCE",
  RECEIVABLES_OFFERS_COLLECTION = "RECEIVABLES_OFFERS_COLLECTION",
  RECEIVABLES_OFFERS_REPAYMENT = "RECEIVABLES_OFFERS_REPAYMENT",
  REWARDS_REDEMPTION = "REWARDS_REDEMPTION",
  WIRE = "WIRE",
  WIRE_RETURN = "WIRE_RETURN",
}

/**  Defined in the DepositsPayment component in APIv1 */
export interface DepositsWeeklySchedule {
  dayOfWeek: BusinessDays;
  nWeeks: Scalars["Int"];
}

export enum DepositsWithdrawFundsIssue {
  CANNOT_VERIFY_BALANCES = "CANNOT_VERIFY_BALANCES",
  INVALID = "INVALID",
  MISSING_COLUMN_ACCOUNT_NUMBER = "MISSING_COLUMN_ACCOUNT_NUMBER",
  MULTIPLE_DEPOSITS_ACCOUNTS = "MULTIPLE_DEPOSITS_ACCOUNTS",
  NEGATIVE_BALANCE = "NEGATIVE_BALANCE",
  NONZERO_CARD_BALANCE = "NONZERO_CARD_BALANCE",
  NONZERO_MMF_BALANCE = "NONZERO_MMF_BALANCE",
  NON_PRIMARY_ACCOUNTS_HAVE_POSITIVE_BALANCE = "NON_PRIMARY_ACCOUNTS_HAVE_POSITIVE_BALANCE",
  NO_AVAILABLE_BALANCE = "NO_AVAILABLE_BALANCE",
  PROCESSING_TRANSACTIONS = "PROCESSING_TRANSACTIONS",
  RECENT_ACH_DEBITS = "RECENT_ACH_DEBITS",
  RECENT_CHEQUE_DEPOSITS = "RECENT_CHEQUE_DEPOSITS",
  WAITING_FOR_HOLD_TO_CLEAR = "WAITING_FOR_HOLD_TO_CLEAR",
  WRONG_ACCOUNT_TYPE = "WRONG_ACCOUNT_TYPE",
  WRONG_DEPOSITS_ACCOUNT_STATUS = "WRONG_DEPOSITS_ACCOUNT_STATUS",
}

/** The derived compliance status of a Request, based on submitter and reviewer compliance statuses. */
export enum DerivedComplianceStatus {
  /** Expense is both submitter and reviewer compliant */
  COMPLETED = "COMPLETED",
  /** Documentation for the expense to be compliant is due */
  DOCUMENTATION_DUE = "DOCUMENTATION_DUE",
  /** Review for the expense to be compliant is due */
  REVIEW_DUE = "REVIEW_DUE",
}

export enum DerivedComplianceStatusFilterInput {
  /** Expense is compliant */
  COMPLETED = "COMPLETED",
  /** Documentation for the expense to be compliant is due */
  DOCUMENTATION_DUE = "DOCUMENTATION_DUE",
  /** Review for the expense to be compliant is due */
  REVIEW_DUE = "REVIEW_DUE",
}

/** Indicates if an OCR derived field was matched, created or calculated. */
export enum DerivedFieldResolution {
  /** There was no matches for the extracted field. A new record was created. */
  CREATED = "CREATED",
  /** The extracted field was matched with an existing record. */
  MATCHED = "MATCHED",
}

export interface DestinationAddressInput {
  /** City of the destination address */
  city?: InputMaybe<Scalars["String"]>;
  /** The two letter country code of the destination address (ISO 3166-1 alpha-2) */
  country: Scalars["String"];
  /** State, province, or the equivalent location of the destination address */
  state?: InputMaybe<Scalars["String"]>;
  /** Zip/postal code of the destination address */
  zip?: InputMaybe<Scalars["String"]>;
}

/** Information about dev access agreement */
export interface DevAccessAgreement {
  /** Time agreement was signed at */
  signedAt?: Maybe<Scalars["Time"]>;
}

/** Information about the developer API token */
export interface DeveloperApiToken {
  /** Time the token is created */
  createdAt?: Maybe<Scalars["Time"]>;
  /** Id of the user who created the token */
  creatorUserId: Scalars["String"];
  /** Value of the token, censored for active tokens */
  displayToken: Scalars["String"];
  /** Primary key for the token */
  id: Scalars["String"];
  /** Human-readable name of the token */
  name: Scalars["String"];
  /** Time the token is revoked */
  revokedAt?: Maybe<Scalars["Time"]>;
  /** List of scopes the token is valid for */
  scopes?: Maybe<Array<Maybe<Scope>>>;
}

export interface Device {
  createdAt?: Maybe<Scalars["Time"]>;
  deviceFingerprint?: Maybe<Scalars["String"]>;
  deviceName?: Maybe<Scalars["String"]>;
  deviceType?: Maybe<DeviceType>;
  geoIpLocation?: Maybe<GeoIpLocation>;
  ip?: Maybe<Scalars["String"]>;
  userAgent?: Maybe<Scalars["String"]>;
}

export interface DeviceInformation {
  additionalInformation?: Maybe<Scalars["Json"]>;
  appVersion: Scalars["String"];
  model: Scalars["String"];
  os: Scalars["String"];
}

export interface DeviceInformationInput {
  additionalInformation?: InputMaybe<Scalars["Json"]>;
  appVersion: Scalars["String"];
  model: Scalars["String"];
  os: Scalars["String"];
}

/** Other Models */
export enum DeviceType {
  DASHBOARD = "DASHBOARD",
  MOBILE = "MOBILE",
  UNKNOWN = "UNKNOWN",
}

export interface DisableAccountingIntegrationInput {
  /** Required, the client mutation id. */
  clientMutationId: Scalars["String"];
  /** Required, the accounting integration id. */
  id: Scalars["ID"];
}

export interface DisableAccountingIntegrationResult extends MutationResult {
  errors?: Maybe<Array<AccountingIntegrationMutationError>>;
  result?: Maybe<AccountingIntegration>;
}

export interface DisableAutomaticTransferSettingsInput {
  /** ID of automatic transfer settings to disable */
  automaticTransferSettingsId?: InputMaybe<Scalars["ID"]>;
  clientMutationId: Scalars["String"];
  /** Deprecated, use automatic_transfer_settings_id */
  depositsAccountId?: InputMaybe<Scalars["ID"]>;
}

export interface DisableAutomaticTransferSettingsPayload {
  clientMutationId: Scalars["String"];
}

export interface DisableBillsInput {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
}

export interface DisableBillsPayload {
  clientMutationId: Scalars["String"];
  integration?: Maybe<Integration>;
}

export interface DisableChannelInput {
  clientMutationId: Scalars["String"];
  /** Channel id to disable */
  id: Scalars["ID"];
}

export interface DisableChannelPayload {
  /** The channel that has been disabled */
  channel?: Maybe<Channel>;
  clientMutationId: Scalars["String"];
}

export interface DisableExpensesInput {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
}

export interface DisableExpensesPayload {
  clientMutationId: Scalars["String"];
  integration?: Maybe<Integration>;
}

export interface DisableHrConnectionInput {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** The connection that is being disabled. */
  id: Scalars["ID"];
}

export interface DisableIntegrationInput {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
}

export interface DisableIntegrationPayload {
  clientMutationId: Scalars["String"];
  integration?: Maybe<Integration>;
}

export interface DisableLimitUtilizationTriggerInput {
  triggerId: Scalars["ID"];
}

export interface DisableLimitUtilizationTriggerPayload {
  limitUtilizationTrigger: LimitUtilizationTrigger;
}

export interface DisableNonPrimaryFundingSourcesInput {
  clientMutationId: Scalars["String"];
  fundingSourceIds: Array<Scalars["String"]>;
  notes: Scalars["String"];
  reason: FundingSourceStatusChangeReason;
}

export interface DisableNonPrimaryFundingSourcesPayload {
  clientMutationId: Scalars["String"];
}

export interface DisableReimbursementsInput {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
}

export interface DisableReimbursementsPayload {
  clientMutationId: Scalars["String"];
  integration?: Maybe<Integration>;
}

export interface DisconnectApiClientInput {
  clientId: Scalars["String"];
  clientMutationId: Scalars["String"];
}

export interface DisconnectApiClientPayload {
  clientMutationId: Scalars["String"];
}

export interface DisconnectCredentialInput {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
}

export interface DisconnectCredentialInputV2 {
  clientMutationId: Scalars["String"];
  credentialId: Scalars["ID"];
}

export interface DisconnectCredentialPayload {
  clientMutationId: Scalars["String"];
  credential?: Maybe<Credential>;
}

export interface DisconnectCredentialResultV2 extends MutationResult {
  errors?: Maybe<Array<CredentialMutationError>>;
  result?: Maybe<VendorCredential>;
}

export interface DisconnectErpFeedInput {
  clientMutationId: Scalars["String"];
  erpFeedId: Scalars["ID"];
}

export interface DisconnectErpFeedPayload {
  clientMutationId: Scalars["String"];
  erpFeed?: Maybe<ErpFeed>;
  errorMessage?: Maybe<Scalars["String"]>;
}

export interface DisconnectPayrollProviderIntegrationInput {
  clientMutationId: Scalars["String"];
  /** The integration the user wants to disconnect */
  payrollProviderIntegrationId: Scalars["ID"];
}

export interface DisconnectPayrollProviderIntegrationPayload {
  clientMutationId: Scalars["String"];
}

export interface DisconnectSsoIntegrationError extends SsoClientError {
  code?: Maybe<SsoClientErrorCode>;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export type DisconnectSsoIntegrationResult =
  | DisconnectSsoIntegrationError
  | DisconnectSsoIntegrationStatus;

export interface DisconnectSsoIntegrationStatus {
  id: Scalars["ID"];
  ssoSettings?: Maybe<SSOSettings>;
}

export interface DismissCardFraudAlertError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

/** Inputs for submitting a DismissCardFraudAlertWithTransaction. */
export interface DismissCardFraudAlertWithTransactionInput {
  /** The token to submit. */
  transactionId: Scalars["ID"];
}

/** The result of a DismissCardFraudAlertWithTransaction submission. */
export interface DismissCardFraudAlertWithTransactionResult
  extends MutationResult {
  /** No errors if fraud alert is dismissed successfully */
  errors?: Maybe<Array<DismissCardFraudAlertError>>;
}

export interface DismissLegalEntitySetupTaskInput {
  /** The id of the requestAction (task) */
  requestActionId?: InputMaybe<Scalars["String"]>;
}

export interface DismissLegalEntitySetupTaskResponse {
  /** The dismissed setup task */
  setupTask?: Maybe<LegalEntitySetupTask>;
}

export interface DismissLimitEscalationInput {
  clientMutationId: Scalars["String"];
  escalationId: Scalars["String"];
}

export interface DismissLimitEscalationResponse {
  success: Scalars["Boolean"];
}

export interface DismissLimitEscalationResult extends MutationResult {
  errors?: Maybe<Array<LimitsExperienceMutationError>>;
  result?: Maybe<DismissLimitEscalationResponse>;
}

/** Vendor fields simplified for presentation */
export interface DisplayFields {
  /** Business type of this vendor, as a formatted string */
  businessType?: Maybe<Scalars["String"]>;
  /** The 1099 eligibility status of the vendor, as a formatted string */
  form1099EligibilityStatus?: Maybe<Scalars["String"]>;
  /** Payment methods for this vendor, as a comma separated string */
  paymentMethods?: Maybe<Scalars["String"]>;
}

/** A basic limit type (meant to power frontend display) that represents core limit functionality shared across different limit types */
export interface DisplayLimit {
  /** Amount spent against this limit */
  amountSpent?: Maybe<FinancialAsset>;
  /** Ordered list of ancestors */
  ancestryPath: Array<SpendBudgetDisplayLimit>;
  /** Logical ID - Can be either a spendLimitId (when type is SPEND_LIMIT) or a cuUserId (when type is USER_LIMIT) */
  id: Scalars["ID"];
  /** Name of the limit */
  name: Scalars["String"];
  /** The type of limit this represents */
  type: DisplayLimitType;
}

/** The type of limit being referenced */
export enum DisplayLimitType {
  /** A spend budget organizes and tracks spend */
  SPEND_BUDGET = "SPEND_BUDGET",
  /** A spend limit that controls spend within a specific budget or category */
  SPEND_LIMIT = "SPEND_LIMIT",
  /** A user limit that controls overall user spend */
  USER_LIMIT = "USER_LIMIT",
}

/**
 * An interface for entities that are exposed to the customer.
 * It standardizes the customer-readable way to represent a
 * given entity through its `displayName` field.
 */
export interface Displayable {
  /** Customer-friendly display name */
  displayName?: Maybe<Scalars["String"]>;
}

export interface Dispute {
  activeExpenses: Array<Expense>;
  canceledExpenses: Array<Expense>;
  cardPossession?: Maybe<DisputeCardPossession>;
  id: Scalars["ID"];
  originator?: Maybe<DisputeOriginator>;
  reason: Scalars["String"];
  status?: Maybe<DisputeStatus>;
  type?: Maybe<DisputeType>;
}

/** Enums */
export enum DisputeCardPossession {
  DISPUTE_CARD_POSSESSION_NO_LOST = "DISPUTE_CARD_POSSESSION_NO_LOST",
  DISPUTE_CARD_POSSESSION_NO_STOLEN = "DISPUTE_CARD_POSSESSION_NO_STOLEN",
  DISPUTE_CARD_POSSESSION_NO_UNKNOWN = "DISPUTE_CARD_POSSESSION_NO_UNKNOWN",
  DISPUTE_CARD_POSSESSION_UNKNOWN = "DISPUTE_CARD_POSSESSION_UNKNOWN",
  DISPUTE_CARD_POSSESSION_VIRTUAL_CARD = "DISPUTE_CARD_POSSESSION_VIRTUAL_CARD",
  DISPUTE_CARD_POSSESSION_YES = "DISPUTE_CARD_POSSESSION_YES",
}

/** Dispute Originator */
export type DisputeOriginator =
  | DisputeOriginatorCopilotUser
  | DisputeOriginatorOtherUser
  | DisputeOriginatorSelf
  | DisputeOriginatorSupport;

export interface DisputeOriginatorCopilotUser {
  delegate?: Maybe<User>;
  delegator?: Maybe<User>;
}

export interface DisputeOriginatorOtherUser {
  user?: Maybe<User>;
}

export interface DisputeOriginatorSelf {
  user?: Maybe<User>;
}

export interface DisputeOriginatorSupport {
  _?: Maybe<Scalars["Boolean"]>;
}

export enum DisputeStatus {
  DISPUTE_STATUS_CLOSED = "DISPUTE_STATUS_CLOSED",
  DISPUTE_STATUS_COMPLETE = "DISPUTE_STATUS_COMPLETE",
  DISPUTE_STATUS_DRAFT = "DISPUTE_STATUS_DRAFT",
  DISPUTE_STATUS_IN_PROGRESS = "DISPUTE_STATUS_IN_PROGRESS",
  DISPUTE_STATUS_MORE_INFORMATION_NEEDED = "DISPUTE_STATUS_MORE_INFORMATION_NEEDED",
  DISPUTE_STATUS_UNKNOWN = "DISPUTE_STATUS_UNKNOWN",
}

export enum DisputeType {
  DISPUTE_TYPE_FRAUD = "DISPUTE_TYPE_FRAUD",
  DISPUTE_TYPE_MERCH_DISPUTE = "DISPUTE_TYPE_MERCH_DISPUTE",
  DISPUTE_TYPE_OTHER = "DISPUTE_TYPE_OTHER",
  DISPUTE_TYPE_UNKNOWN = "DISPUTE_TYPE_UNKNOWN",
}

export interface Distance {
  /** The travel distance. */
  quantity: Scalars["Decimal"];
  /** The unit of distance measure (ie miles). */
  unit: DistanceUnit;
}

export interface DistanceInput {
  /** The travel distance. */
  quantity: Scalars["Decimal"];
  /** The unit of distance measure (ie miles). */
  unit: DistanceUnit;
}

export enum DistanceUnit {
  KILOMETERS = "KILOMETERS",
  MILES = "MILES",
}

/** Enum filter to include or exclude limit-per-employee (LPE) distribution children */
export enum DistributionChildrenFilter {
  /** Exclude all distribution children from the query */
  EXCLUDE = "EXCLUDE",
  /** Include all distribution children from the query */
  INCLUDE = "INCLUDE",
  /** Include only limits that are distribution children of an LPE parent */
  ONLY = "ONLY",
}

export interface DividendDetails {
  forFinancialInstrument?: Maybe<FinancialInstrument>;
  paidOn?: Maybe<Scalars["Time"]>;
}

export interface DocumentOcr extends Node {
  /** The ID of an object */
  id: Scalars["ID"];
  /** The processed result. Only available when the document OCR status is COMPLETE */
  result?: Maybe<DocumentOcrResult>;
  /** The OCR status. */
  status: DocumentOcrStatus;
}

export enum DocumentOcrClassificationType {
  /** A bank statement. This may be requested to verify ownership of a bank account. */
  BANK_STATEMENT = "BANK_STATEMENT",
  /** The document classification is unknown */
  INVALID = "INVALID",
  /** A proof of EIN letter. This may be requested on demand by businesses. */
  IRS_147C = "IRS_147C",
  /** @deprecated Use irs_147c */
  IRS_147_C = "IRS_147_C",
  /** An EIN confirmation letter. Users receive this one time after applying for an EIN. */
  IRS_CP_575 = "IRS_CP_575",
}

export interface DocumentOcrParsedDetails extends Node {
  /** The Account Number extracted from the document. Not present for all documents. */
  accountNumber?: Maybe<DocumentOcrParsedDetailsDetail>;
  /** The EIN extracted from the document. Not present for all documents. */
  ein?: Maybe<DocumentOcrParsedDetailsDetail>;
  /** The ID of an object */
  id: Scalars["ID"];
  /** The Name extracted from the document. Not present for all documents. */
  name?: Maybe<DocumentOcrParsedDetailsDetail>;
}

export interface DocumentOcrParsedDetailsDetail extends Node {
  /** The ID of an object */
  id: Scalars["ID"];
  /** The value passed into the 'verify_entities' payload at the time of creation (if any). */
  input?: Maybe<Scalars["String"]>;
  /** The extracted value from the document (if any). */
  value?: Maybe<Scalars["String"]>;
  /** Indicates if the input and extracted value (if one was provided) match. */
  verified?: Maybe<Scalars["Boolean"]>;
}

export interface DocumentOcrResult extends Node {
  /** The type of document, determined based on the OCR result. */
  classificationType?: Maybe<DocumentOcrClassificationType>;
  /** The ID of an object */
  id: Scalars["ID"];
  /** The information extracted from the document */
  parsedDetails?: Maybe<DocumentOcrParsedDetails>;
}

export enum DocumentOcrStatus {
  /** The document has finished processing, and the results are available. */
  COMPLETED = "COMPLETED",
  /** The document is still being processed. */
  PENDING = "PENDING",
}

export interface DocumentOcrVerifyEntitiesInput {
  /** The type of document, determined based on the OCR result. */
  ein?: InputMaybe<Scalars["String"]>;
  /** The type of document, determined based on the OCR result. */
  name?: InputMaybe<Scalars["String"]>;
}

export interface DocumentSubmissionPayloadInput {
  documentType: VerificationDocumentType;
  filestoreId: Scalars["String"];
}

export enum DocumentType {
  /** Invoice for bill expense */
  BILLPAY_INVOICE = "BILLPAY_INVOICE",
  /** Invoice for card transaction */
  TRANSACTION_INVOICE = "TRANSACTION_INVOICE",
  /** Receipt for card transaction */
  TRANSACTION_RECEIPT = "TRANSACTION_RECEIPT",
}

export interface DocumentationStatus {
  type: DocumentationStatusType;
}

export enum DocumentationStatusType {
  /** TODO */
  COMPLETED = "COMPLETED",
  /** TODO */
  DUE = "DUE",
  /** overdue */
  OVERDUE = "OVERDUE",
}

export interface DocumentsSubmissionPayloadInput {
  documents: Array<DocumentSubmissionPayloadInput>;
}

/**  Retool only due to global rule effect, not supported in the UI */
export interface DomainMatchRule {
  domains?: Maybe<Array<Scalars["String"]>>;
  enabled: Scalars["Boolean"];
}

export interface DomesticWirePaymentInstrument {
  accountNumber?: Maybe<Scalars["String"]>;
  address?: Maybe<Address>;
  /** A small logo for the beneficiary bank in base64 format. WARNING: may cause significantly slower response times */
  beneficiaryBankLogoBase64?: Maybe<Scalars["String"]>;
  /** Not yet implemented, will always be null. Is in the schema so the app can use the URL if available, falling back to base64 */
  beneficiaryBankLogoUrl?: Maybe<Scalars["String"]>;
  beneficiaryBankName?: Maybe<Scalars["String"]>;
  routingNumber?: Maybe<Scalars["String"]>;
}

export interface DomesticWirePaymentInstrumentFindInput {
  accountNumber: Scalars["String"];
  routingNumber: Scalars["String"];
}

export interface DomesticWirePaymentInstrumentInput {
  accountNumber: Scalars["String"];
  address: AddressInput;
  routingNumber: Scalars["String"];
}

export interface DomesticWireTransferDetails {
  fedReferenceNumber?: Maybe<Scalars["String"]>;
  imad?: Maybe<Scalars["String"]>;
  omad?: Maybe<Scalars["String"]>;
  returnDetails?: Maybe<ReturnDetails>;
}

export interface DonationPayloadV2 {
  /** How many cents a point is worth in donation redemption */
  usdCentsPerPoint: Scalars["Float"];
}

export enum DoohBookingIncrementV2 {
  DAY = "DAY",
  WEEK = "WEEK",
}

/** Structure for billboard offers */
export interface DoohOffer {
  description?: Maybe<Scalars["String"]>;
  /** Image URL for the offer */
  imageUrl?: Maybe<Scalars["String"]>;
  name: Scalars["String"];
}

/** Value Added Service for Digital Out of Home Payload Pricing Entry */
export interface DoohOfferPayloadPricingEntryV2 {
  /** Customers' cost to redeem this option, in centipoints (1/100 of a point) */
  centipointsCost: Scalars["Int"];
  /** The quantity this pricing info applies to. For example if Booking Increment = DAY and quantityKey = 3, this entry contains pricing for 3 days. */
  quantityKey: Scalars["Int"];
}

/** Value Added Service for Digital Out of Home Payload */
export interface DoohOfferPayloadV2 {
  /** Whether this package can be booked in days or weeks. Values for views and pricing are relative to this value. */
  bookingIncrement: DoohBookingIncrementV2;
  /** URL for creative specs */
  creativeSpecUrl: Scalars["String"];
  /** Detailed description of the package */
  description: Scalars["String"];
  /** Textual description of unit dimensions, e.g. '(e.g. "14' H x 48' W")' */
  dimensions: Scalars["String"];
  /** Name of the location. Used to group packages by location */
  locationName: Scalars["String"];
  /** URL for Locations Map */
  locationsUrl: Scalars["String"];
  /** Main image URL */
  mainImageUrl: Scalars["String"];
  /** Title of the package, e.g. 'VC Highway' */
  name: Scalars["String"];
  /** Defines prices for each booking increment. Quantity keys determine how long a package can be booked for, and should be contiguous */
  pricing?: Maybe<Array<DoohOfferPayloadPricingEntryV2>>;
  /** Thumbnail Image URL */
  thumbnailImageUrl: Scalars["String"];
  /** How many billboards / units are in this package */
  unitCount: Scalars["Int"];
  /** Estimated number of impressions per the given booking_increment */
  views: Scalars["Int"];
}

/** Value Added Service for Digital Out of Home Payload V3 */
export interface DoohOfferPayloadV3 {
  /** Custom offer input */
  customOffer?: Maybe<Scalars["String"]>;
  /** Package description */
  description: Scalars["String"];
  /** Primary image URL */
  mainImageUrl: Scalars["String"];
  /** Package name */
  name: Scalars["String"];
  /** List of primary offers */
  offers: Array<DoohOffer>;
}

export interface DownloadJob extends Node {
  /** The id of the filestore asset containing the assembled download file. */
  assetId?: Maybe<Scalars["ID"]>;
  /** The download url. */
  downloadUrl?: Maybe<Scalars["String"]>;
  /** The export format of the job e.g. CSV/XLSX. */
  format?: Maybe<DownloadsPlatformExportFormat>;
  /** The ID of an object */
  id: Scalars["ID"];
  /** The time at which the job was requested. */
  insertedAt: Scalars["Time"];
  /** The dashboard origin of job request, ex: from reporting or datagrid. Should be unique. */
  origin?: Maybe<Scalars["String"]>;
  /** Returns job status */
  status?: Maybe<JobStatus>;
  /**
   * The total number of rows in the download job.
   * Not all jobs will have this field. E.g. Jobs that failed to start or legacy jobs before this field was introduced.
   */
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface DownloadJobConnection extends Connection {
  /** The download jobs in the current page of results. */
  edges: Array<DownloadJobEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of download jobs that match the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface DownloadJobEdge {
  /** The opaque cursor of the current edge */
  cursor?: Maybe<Scalars["String"]>;
  /** The column option at this edge */
  node?: Maybe<DownloadJob>;
}

export interface DownloadJobsDeleteError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export type DownloadJobsDeleteResult =
  | DownloadJobsDeleteError
  | DownloadJobsDeleteSuccess;

export interface DownloadJobsDeleteSuccess {
  success: Scalars["Boolean"];
}

export interface DownloadJobsFilterInput {
  /** The Ids of the download jobs. Other filters are also applied on top of the ID filter */
  jobIds?: InputMaybe<Array<Scalars["ID"]>>;
  /**
   * Filters download jobs by origin. This is the table that originated the download job (expenses, vendors, etc.)
   * Takes precedence over the deprecated origin argument in the root of the downloadJobs query.
   */
  origin?: InputMaybe<Scalars["String"]>;
}

export interface DownloadJobsMutationError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export type DownloadJobsMutationResult =
  | DownloadJobsMutationError
  | DownloadJobsMutationSuccess;

export interface DownloadJobsMutationSuccess {
  success: Scalars["Boolean"];
}

/** Standard result of async export operations performed by downloads platform */
export interface DownloadsPlatformAsyncExportResult {
  /** The ID of the async export job. Callers need to probe the job status using this ID until a download link is ready. */
  jobId?: Maybe<Scalars["String"]>;
}

/** Lists export types that are supported by downloads platform */
export enum DownloadsPlatformExportFormat {
  CSV = "CSV",
  XLSX = "XLSX",
}

export interface DraftExtendedFieldFilterWhereInput {
  /** The draft Id we are searching for */
  draftId: Scalars["String"];
}

export interface DraftExtendedFieldOption {
  /** The state of the new draft extended field option */
  draftEntity: ExtendedFieldOption;
  /** The original extended field option being modified */
  originEntity?: Maybe<ExtendedFieldOption>;
}

/** A paginated list of DraftExtendedFieldOption resources */
export interface DraftExtendedFieldOptionConnection extends Connection {
  edges: Array<Maybe<DraftExtendedFieldOptionEdge>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

/** An DraftExtendedFieldOption within a DraftExtendedFieldOptionConnection */
export interface DraftExtendedFieldOptionEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<DraftExtendedFieldOption>;
}

export interface DraftExtendedFieldOptionsFilterWhereInput {
  /** The draft Id we are searching for */
  draftId: Scalars["String"];
  /** The extended field id associated with the options. */
  extendedFieldId: Scalars["ID"];
}

export interface DrawdownAuthorization extends Node {
  caseId?: Maybe<Scalars["String"]>;
  depositsAccountId: Scalars["ID"];
  /** The ID of an object */
  id: Scalars["ID"];
  maxAuthorizationAmountUsdCents?: Maybe<Scalars["Int"]>;
  /** Logical ID of a payment instrument authorized for drawdown */
  paymentInstrumentId: Scalars["ID"];
  paymentInstrumentVersion: Scalars["Int"];
  rescindedAt?: Maybe<Scalars["Time"]>;
}

export interface DrawdownAuthorizationGeneratePdfUrlError
  extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path: Array<Scalars["String"]>;
}

export interface DrawdownAuthorizationGeneratePdfUrlInput {
  /** The drawdown authorization id to generate PDF URL for. */
  drawdownAuthorizationId: Scalars["ID"];
}

export interface DrawdownAuthorizationGeneratePdfUrlResult {
  errors?: Maybe<Array<DrawdownAuthorizationGeneratePdfUrlError>>;
  result?: Maybe<Scalars["String"]>;
}

export interface DrawdownAuthorizationRescindError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path: Array<Scalars["String"]>;
}

export interface DrawdownAuthorizationRescindInput {
  /** The drawdown authorization id to be canceled. */
  drawdownAuthorizationId: Scalars["ID"];
}

export interface DrawdownAuthorizationRescindResult {
  errors?: Maybe<Array<DrawdownAuthorizationRescindError>>;
  result?: Maybe<WireDrawdownAuthorization>;
}

export interface DrawdownAuthorizationSubmitError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface DrawdownAuthorizationSubmitInput {
  /** the deposit account id of the drawdown authorization */
  depositsAccountId: Scalars["ID"];
  /** idempotency key of the drawdown authorization */
  idempotencyKey: Scalars["String"];
  /** maximum amount of the drawdown authorization */
  maxAuthorizationAmountUsdCents?: InputMaybe<Scalars["Int"]>;
  /** the rail account details Id associated with this drawdown authorization */
  railAccountDetailsId: Scalars["ID"];
}

export interface DrawdownAuthorizationSubmitResult {
  errors?: Maybe<Array<DrawdownAuthorizationSubmitError>>;
  result?: Maybe<WireDrawdownAuthorization>;
}

export interface DuplicateBudgetTemplateInput {
  budgetTemplateId: Scalars["ID"];
}

export interface DuplicateBudgetTemplateResult {
  budgetTemplate: BudgetTemplate;
}

export interface DuplicateChargedInput {
  amount: Scalars["Int"];
  last4PaymentNumber?: InputMaybe<Scalars["String"]>;
  merchantName: Scalars["String"];
  paymentType: Scalars["String"];
  transactionDate: Scalars["Date"];
}

export interface DuplicatePolicyInput {
  clientMutationId: Scalars["String"];
  /**
   * (Optional) Description of the new policy
   * If not provided, the new policy description will be the same as the original policy
   */
  description?: InputMaybe<Scalars["String"]>;
  /**
   * (Optional) Name of the new policy
   * If not provided, the new policy name will be "Copy of [original policy name]"
   */
  name?: InputMaybe<Scalars["String"]>;
  /** ID of the policy to duplicate */
  policyId: Scalars["ID"];
}

export interface DuplicatePolicyMutationError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface DuplicatePolicyResult extends MutationResult {
  errors?: Maybe<Array<DuplicatePolicyMutationError>>;
  result?: Maybe<Policy>;
}

export interface DuplicateReportingDashboardInput {
  /** Idempotency key for the duplicate mutation */
  clientMutationId: Scalars["String"];
  /** The Dashboard to duplicate. */
  id: Scalars["ID"];
}

export interface DuplicateReportingDashboardResult extends MutationResult {
  errors?: Maybe<Array<ReportingClientError>>;
  /** The newly duplicated dashboard */
  result?: Maybe<ReportingDashboard>;
}

export interface EarlyCreditCommitment {
  /** How much is already early credited at commitment creation time */
  alreadyInflightEarlyCreditAmount: FinancialAsset;
  /** Customer Account ID of new early credit commitment */
  customerAccountId: Scalars["String"];
  /** Inflight Balance of the customer */
  customerInflightUsdBalance: FinancialAsset;
  /** Points returned by Police Engine */
  earlyCreditPoints?: Maybe<Scalars["Int"]>;
  /** When this commitment expires */
  expiresAt: Scalars["Time"];
  /** Current global limit at commitment creation time */
  globalLimit: FinancialAsset;
  /** Early Credit Commitment ID in the db */
  id: Scalars["String"];
  /** The maximum amount that can be early credited from this commitment */
  maxEarlyCreditAmount?: Maybe<FinancialAsset>;
  /** Reference the policy engine evaluation id, so we can audit the reason on decision */
  policyEvaluationId?: Maybe<Scalars["String"]>;
}

export interface EddAttestationPayloadInput {
  cashIntensivePayload?: InputMaybe<CashIntensivePayloadInput>;
  cryptoPayload?: InputMaybe<CryptoPayloadInput>;
  eddType: EddType;
  fiNbfiPayload?: InputMaybe<FiNbfiPayloadInput>;
  genericPayload?: InputMaybe<GenericPayloadInput>;
}

/** EDD type of a customer. */
export enum EddType {
  /** When business industry is missing. */
  BUSINESS_INDUSTRY_MISSING = "BUSINESS_INDUSTRY_MISSING",
  /** Cash Intensive Businesses. */
  CASH_INTENSIVE_BUSINESS = "CASH_INTENSIVE_BUSINESS",
  /** Crypto businesses. */
  CRYPTO = "CRYPTO",
  /** Financial Institutions and Non-Bank Financial Institutions. */
  FI_NBFI = "FI_NBFI",
  /** Generic EDD. */
  GENERIC = "GENERIC",
  /** Customers who do not need EDD. */
  NOT_APPLICABLE = "NOT_APPLICABLE",
}

export interface EditBillingConfigurationSettingsError
  extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface EditBillingConfigurationSettingsInput {
  /** If customer toggles from autopay from manual pay, set the autopay account id */
  autopayAccountId?: InputMaybe<Scalars["String"]>;
  /** How often bills are cut and payments are due */
  billingCycle?: InputMaybe<BillingCycleOneOfInput>;
  /** The id of the reimbursement billing group to update */
  billingGroupId: Scalars["ID"];
  /**
   * The funding source to be used for auto-collect.
   * Optional b/c some entities are push-payment accounts
   */
  fundingSourceId?: InputMaybe<Scalars["ID"]>;
  /** Idempotency key */
  idempotencyKey: Scalars["String"];
  /** If customer toggles from autopay and push pay, set the boolean to True without passing in an autopayAccountId */
  useManualPayments?: InputMaybe<Scalars["Boolean"]>;
}

export interface EditBillingConfigurationSettingsResponse
  extends MutationResult {
  /** Errors that occurred during the mutation */
  errors?: Maybe<Array<EditBillingConfigurationSettingsError>>;
  /** The updated billing configuration */
  result?: Maybe<BillingGroup>;
}

export interface EditInvoiceInput {
  clientMutationId: Scalars["String"];
  depositsAccountId?: InputMaybe<Scalars["ID"]>;
  discountAmount?: InputMaybe<FinancialAssetInput>;
  discountPercent?: InputMaybe<Scalars["Float"]>;
  dueDate?: InputMaybe<Scalars["Date"]>;
  idempotencyKey: Scalars["String"];
  invoiceId: Scalars["ID"];
  invoiceNumber: Scalars["String"];
  invoiceTemplateId: Scalars["ID"];
  lineItems?: InputMaybe<Array<InputMaybe<InvoiceLineItemInput>>>;
  memo?: InputMaybe<Scalars["String"]>;
  payerContactId?: InputMaybe<Scalars["ID"]>;
  subtotal?: InputMaybe<FinancialAssetInput>;
  totalAmount?: InputMaybe<FinancialAssetInput>;
}

export interface EditInvoicePayload {
  clientMutationId: Scalars["String"];
  invoice?: Maybe<InvoicingInvoice>;
}

export interface EditInvoiceTemplateV1Fields {
  /** Template footer */
  footer?: InputMaybe<Scalars["String"]>;
  /** Template header */
  header?: InputMaybe<Scalars["String"]>;
  /** Contact ID of the invoicer. */
  invoicerContactId?: InputMaybe<Scalars["ID"]>;
  /** File asset ID to the logo. */
  logoAssetId?: InputMaybe<Scalars["String"]>;
  /** Template note. */
  note?: InputMaybe<Scalars["String"]>;
  /** Boolean flag to indicate if this template is to be set as the default for the owning account. */
  setAsDefaultTemplate?: InputMaybe<Scalars["Boolean"]>;
}

export interface EditInvoiceTemplateV1Input {
  /** Fields to be updated. */
  fields: EditInvoiceTemplateV1Fields;
  /** Idempotency key. */
  idempotencyKey: Scalars["String"];
  /** ID of the template to be updated */
  templateId: Scalars["ID"];
}

export interface EditInvoiceV1Fields {
  /** Attachment asset IDs. */
  attachmentAssetIds?: InputMaybe<Array<Scalars["String"]>>;
  /** ID of deposits account that is expected to receive funds. */
  depositsAccountId?: InputMaybe<Scalars["ID"]>;
  /** Invoice discount. */
  discount?: InputMaybe<InvoiceDiscountV1OneOfInput>;
  /** Invoice due date. */
  dueDate?: InputMaybe<Scalars["Date"]>;
  /**
   * Invoice issue date. Could refer to a date from the past when the service is done.
   * If no value is provided, we will use the current date.
   */
  issuedDate?: InputMaybe<Scalars["Date"]>;
  /** Invoice line items. */
  lineItems?: InputMaybe<Array<InvoiceLineItemV1Input>>;
  /** Invoice memo. */
  memo?: InputMaybe<Scalars["String"]>;
  /** ID of payer contact. i.e. the counterparty that is expected to pay this invoice. */
  payerContactId?: InputMaybe<Scalars["ID"]>;
  /** Preferred payment method. */
  paymentMethod?: InputMaybe<InvoicePaymentMethodV1>;
  /** Invoice PO number. */
  poNumber?: InputMaybe<Scalars["String"]>;
  /** ID of invoice Recipient. i.e. the invoicingCustomer that is expected to pay this invoice. */
  recipientId?: InputMaybe<Scalars["ID"]>;
  /** Recurring schedule to repeat sending these invoice details. */
  recurringSchedule?: InputMaybe<RecurringScheduleRuleOneOfInput>;
  /** Reminder types. */
  reminderTypes?: InputMaybe<Array<InvoiceReminderType>>;
  /** Whether to generate the payment link or not. */
  shouldGeneratePaymentLink?: InputMaybe<Scalars["Boolean"]>;
  /** Invoice subtotal amount. */
  subtotal?: InputMaybe<FinancialAssetInput>;
  /** Tax on the invoice. Expressed as a percentage */
  tax?: InputMaybe<Scalars["Float"]>;
  /** ID of invoice template used to generate the invoice PDF. */
  templateId?: InputMaybe<Scalars["ID"]>;
  /** Invoice total amount. */
  total?: InputMaybe<FinancialAssetInput>;
}

export interface EditInvoiceV1Input {
  /** Fields to be updated. */
  fields: EditInvoiceV1Fields;
  /** A unique idempotency key. */
  idempotencyKey: Scalars["String"];
  /** ID of the invoice to be edited. */
  invoiceId: Scalars["ID"];
}

export interface EditInvoicingContactV1Fields {
  /** Address. */
  address?: InputMaybe<InvoicingAddressV1Input>;
  /** Doing Business As. */
  dbaName?: InputMaybe<Scalars["String"]>;
  /** Email address. */
  email?: InputMaybe<Scalars["String"]>;
  /** Phone number. */
  phoneNumber?: InputMaybe<Scalars["String"]>;
}

export interface EditInvoicingContactV1Input {
  /** Id of the contact to be edited. */
  contactId: Scalars["ID"];
  /** Fields to be edited. */
  fields: EditInvoicingContactV1Fields;
  /** A unique idempotency key. */
  idempotencyKey: Scalars["String"];
}

export interface EditReimbursementSettingsInput {
  /** How often bills are cut and payments are due */
  billingCycle: BillingCycleOneOfInput;
  /** The id of the reimbursement billing group to update */
  billingGroupId: Scalars["ID"];
  /**
   * The funding source to be used for auto-collect.
   * Optional b/c some entities are push-payment accounts
   */
  fundingSourceId?: InputMaybe<Scalars["ID"]>;
  /** Idempotency key */
  idempotencyKey: Scalars["String"];
}

export interface EditReimbursementSettingsResponse {
  /** The updated billing configuration */
  billingGroup: BillingGroup;
}

export enum EditionType {
  ENTERPRISE = "ENTERPRISE",
  ESSENTIALS = "ESSENTIALS",
  PREMIUM = "PREMIUM",
  P_CARD = "P_CARD",
}

/** Effective range type, used for specifying mapping start/end dates. */
export interface EffectiveRange {
  endTime?: Maybe<Scalars["Time"]>;
  startTime: Scalars["Time"];
}

/** Input for effective range. */
export interface EffectiveRangeInput {
  endTime?: InputMaybe<Scalars["Time"]>;
  startTime?: InputMaybe<Scalars["Time"]>;
}

export interface EgiroVerificationMetadata {
  authorizationRedirectUrl?: Maybe<Scalars["String"]>;
  userId: Scalars["ID"];
}

export interface EmailAsset {
  /** TODO: figure out what this is. */
  accrualTime?: Maybe<Scalars["Time"]>;
  /** 0 or more attachments on the email. */
  attachments?: Maybe<Array<Maybe<EmailAssetAttachment>>>;
  /** 0 or more email bodies for the email. */
  bodies?: Maybe<Array<Maybe<EmailAssetBody>>>;
  /** From whom/what this was forwarded by. */
  forwardedBy?: Maybe<Scalars["String"]>;
  /** From whom/what the email. */
  from?: Maybe<Scalars["String"]>;
  /** Subject line of the email. */
  subject?: Maybe<Scalars["String"]>;
}

export interface EmailAssetAttachment {
  /** Attached asset from the email. */
  asset?: Maybe<Asset>;
  /** The content type of the email attachment. */
  contentType?: Maybe<Scalars["String"]>;
  /** TODO: confirm this is bytes. */
  size?: Maybe<Scalars["Int"]>;
}

export interface EmailAssetBody {
  /** A body from the email. */
  content?: Maybe<Scalars["String"]>;
  /** The content type of the body from the email. */
  contentType?: Maybe<Scalars["String"]>;
}

/** Email support channel. Always enabled */
export interface EmailChannel {
  /** Email address for this Email support channel */
  emailAddress?: Maybe<Scalars["String"]>;
  /** Service level agreement for this support channel */
  sla?: Maybe<Scalars["Int"]>;
}

/**  We will not populate values for these as they are deprecated */
export interface EmailMatchRule {
  enabled: Scalars["Boolean"];
}

export interface EmailMetadata {
  autoApproveUserIds?: Maybe<Array<Scalars["String"]>>;
  fromEmailAddress: Scalars["String"];
  inboundMessageId?: Maybe<Scalars["String"]>;
  recurrenceId: Scalars["String"];
}

export enum EmbeddedPartnershipOrigin {
  MIGRATION = "MIGRATION",
  NEW = "NEW",
}

export interface EmbeddedReferral {
  partnershipOrigin: EmbeddedPartnershipOrigin;
  sharedBankAccounts: Array<SharedBankAccount>;
}

export interface EmbeddedUserDetail {
  email?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  legalEntity?: Maybe<LegalEntity>;
  partnerDisplayName: Scalars["String"];
  phoneNumber?: Maybe<Scalars["String"]>;
}

/** An Employee defined within a company's organization hierarchy. */
export interface Employee {
  /** Display name of the cost center. */
  costCenterDisplayName?: Maybe<Scalars["String"]>;
  /** The cost center the employee reports within. Defined in the 3rd party HRIS system. */
  costCenterId?: Maybe<Scalars["ID"]>;
  customerUserId?: Maybe<Scalars["ID"]>;
  /** Department the employee belongs to */
  department?: Maybe<Department>;
  /** Full name of the employee. */
  displayName: Scalars["String"];
  /** Email of the employee. */
  email: Scalars["String"];
  /** Employment type of the employee. */
  employmentType?: Maybe<EmploymentType>;
  id: Scalars["ID"];
  /**
   * Whether this user has corporate card access
   * @deprecated DO NOT USE: use the card permission/operation's resourceType + action instead
   */
  isCorporateCardEnabled?: Maybe<Scalars["Boolean"]>;
  /** Whether or not the employee is a manager. */
  isManager?: Maybe<Scalars["Boolean"]>;
  /** The legal entity the employee reports within. Defined in the 3rd party HRIS system. */
  legalEntity?: Maybe<LegalEntity>;
  /**
   * Display name of the legal entity.
   * @deprecated Use legalEntity instead.
   */
  legalEntityDisplayName?: Maybe<Scalars["String"]>;
  /**
   * The legal entity the employee reports within. Defined in the 3rd party HRIS system.
   * @deprecated Use legalEntity instead.
   */
  legalEntityId?: Maybe<Scalars["ID"]>;
  /** Location the employee belongs to */
  location?: Maybe<Location>;
  /** Employee's manager's full name. */
  managerDisplayName?: Maybe<Scalars["String"]>;
  /** ID of this employee's manager. */
  managerEmployeeId?: Maybe<Scalars["ID"]>;
  /** The user's managers */
  managers?: Maybe<EmployeeConnection>;
  /**
   * Nested reports for this user
   * @deprecated Use `reportsInformation` for aggregate info, and `reports` for hydrated reports
   */
  nestedReports?: Maybe<EmployeeConnection>;
  /** ID of this employee in the 3rd party HRIS system. */
  remoteId?: Maybe<Scalars["ID"]>;
  /** Information about the hierarchical structure associated with the employee. */
  reportsInformation?: Maybe<ReportsInformation>;
  /** The UserRole of the employee */
  role?: Maybe<UserRole>;
  /** Display name of this employee's title. */
  titleDisplayName?: Maybe<Scalars["String"]>;
  /** ID of this employee's title. */
  titleId?: Maybe<Scalars["ID"]>;
  /** The UserStatus of the employee */
  userStatus?: Maybe<UserStatus>;
}

/** An Employee defined within a company's organization hierarchy. */
export interface EmployeenestedReportsArgs {
  filter?: InputMaybe<ReportsFilterInput>;
  maxDepth?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
}

/** An Employee defined within a company's organization hierarchy. */
export interface EmployeereportsInformationArgs {
  filter?: InputMaybe<ReportsFilterInput>;
}

/** Employee connection for pagination */
export interface EmployeeConnection extends Connection {
  edges: Array<EmployeeEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

/**  From here https://github.com/brexhq/credit_card/blob/447fdb08bfa2c196ce0d08043e612f4cfc41d358/apps/api/lib/api/components/customer/schemas/account.ex#L658 */
export enum EmployeeCountRange {
  RANGE_1_TO_4 = "RANGE_1_TO_4",
  RANGE_5_TO_20 = "RANGE_5_TO_20",
  RANGE_21_TO_50 = "RANGE_21_TO_50",
  RANGE_21_TO_100 = "RANGE_21_TO_100",
  RANGE_51_TO_100 = "RANGE_51_TO_100",
  RANGE_101_TO_500 = "RANGE_101_TO_500",
  RANGE_501_TO_2500 = "RANGE_501_TO_2500",
  RANGE_LESS_THAN_20 = "RANGE_LESS_THAN_20",
  RANGE_MORE_THAN_2501 = "RANGE_MORE_THAN_2501",
}

export enum EmployeeCountV3 {
  FIFTY_ONE_TO_TWO_HUNDRED_FIFTY = "FIFTY_ONE_TO_TWO_HUNDRED_FIFTY",
  FIVE_TO_TWENTY = "FIVE_TO_TWENTY",
  MORE_THAN_ONE_THOUSAND = "MORE_THAN_ONE_THOUSAND",
  ONE_TO_FIFTY = "ONE_TO_FIFTY",
  ONE_TO_FOUR = "ONE_TO_FOUR",
  TWENTY_ONE_TO_FIFTY = "TWENTY_ONE_TO_FIFTY",
  TWO_HUNDRED_FIFTY_ONE_TO_ONE_THOUSAND = "TWO_HUNDRED_FIFTY_ONE_TO_ONE_THOUSAND",
}

/** Employee edge for the Employee connection. */
export interface EmployeeEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<Employee>;
}

export interface EmployeeError {
  description: Scalars["String"];
  employeeId: Scalars["ID"];
}

/** Filters for list employees query. Records returned will match ALL filters. */
export interface EmployeeFilterInput {
  employeeStatusFilter?: InputMaybe<EmployeeStatusFilter>;
  identifiers?: InputMaybe<Array<EmployeeIdentifier>>;
  managerEmployeeIds?: InputMaybe<Array<Scalars["ID"]>>;
  name?: InputMaybe<Scalars["String"]>;
  titleIds?: InputMaybe<Array<Scalars["ID"]>>;
  userRoles?: InputMaybe<Array<UserRole>>;
}

export interface EmployeeIdentifier {
  customerUserId?: InputMaybe<Scalars["ID"]>;
  email?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["ID"]>;
  remoteId?: InputMaybe<Scalars["ID"]>;
  type: EmployeeIdentifierType;
}

export enum EmployeeIdentifierType {
  CUSTOMER_USER_ID = "CUSTOMER_USER_ID",
  EMAIL = "EMAIL",
  ID = "ID",
  REMOTE_ID = "REMOTE_ID",
}

export interface EmployeeOnboardingSettings {
  id: Scalars["ID"];
  userSetting: UserSetting;
}

export enum EmployeeStatusFilter {
  CAN_ACCESS_DASHBOARD = "CAN_ACCESS_DASHBOARD",
  INVITE_PENDING = "INVITE_PENDING",
  TO_BE_DISABLED = "TO_BE_DISABLED",
  TO_BE_INVITED = "TO_BE_INVITED",
}

/** Fields exclusive for employee tracking billing groups */
export interface EmployeeTrackingProductDetails {
  /** Payment reminder cycle for exporting tracked expenses */
  paymentReminderCycle?: Maybe<BillingPolicy>;
  /** Export history of exported expenses */
  trackedExpenseExports: TrackedExpenseExportConnection;
}

export interface EmployeeUpdateInput {
  /** The new aggregatorId for the employee. */
  aggregatorId?: InputMaybe<Scalars["ID"]>;
  /** The new costCenterId for the employee. */
  costCenterId?: InputMaybe<Scalars["ID"]>;
  /** The new departmentId for the employee. */
  departmentId?: InputMaybe<Scalars["ID"]>;
  /** The new email for the employee. */
  email?: InputMaybe<Scalars["String"]>;
  /** The new employment type for the employee. */
  employmentType?: InputMaybe<EmploymentType>;
  /** The new first name for the employee. */
  firstName?: InputMaybe<Scalars["String"]>;
  /** The new last name for the employee. */
  lastName?: InputMaybe<Scalars["String"]>;
  /** The new legalEntityId for the employee. */
  legalEntityId?: InputMaybe<Scalars["ID"]>;
  /** The new locationId for the employee. */
  locationId?: InputMaybe<Scalars["ID"]>;
  /** The new manager employee id for the employee. */
  managerEmployeeId?: InputMaybe<Scalars["ID"]>;
  /** The new remoteId for the employee. */
  remoteId?: InputMaybe<Scalars["ID"]>;
  /** The new title (display value, not id) for the employee. */
  title?: InputMaybe<Scalars["String"]>;
  /** The new titleId for the employee. */
  titleId?: InputMaybe<Scalars["ID"]>;
  /** NOTE: Not currently implemented on the backend and may be deprecated entirely. */
  userSetting?: InputMaybe<UserSetting>;
}

/**  Note: shadowed in Budgets-DGS. If adding a case, add in all places. */
export enum EmploymentStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  PENDING = "PENDING",
}

/**  Note: shadowed in HRIS-DGS and Budgets-DGS. If adding a case, add in all places. */
export enum EmploymentType {
  CONTRACTOR = "CONTRACTOR",
  FREELANCE = "FREELANCE",
  FULL_TIME = "FULL_TIME",
  INTERN = "INTERN",
  PART_TIME = "PART_TIME",
  UNKNOWN = "UNKNOWN",
}

export interface EmpowerCustomerInquiryDetailsInput {
  companyName?: InputMaybe<Scalars["String"]>;
  companyWebsite?: InputMaybe<Scalars["String"]>;
  email?: InputMaybe<Scalars["Email"]>;
  firstName?: InputMaybe<Scalars["String"]>;
  lastName?: InputMaybe<Scalars["String"]>;
}

export interface EmpowerCustomerInquiryDetailsObject {
  companyName?: Maybe<Scalars["String"]>;
  companyWebsite?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["Email"]>;
  firstName?: Maybe<Scalars["String"]>;
  lastName?: Maybe<Scalars["String"]>;
}

export interface EmpowerExpensiveTransactionMetadata {
  /** The expense that triggers this spend insight. This field is null in case of partial failures. */
  triggeredExpense?: Maybe<Expense>;
}

export interface EmpowerHighSpendPerDiemMetadata {
  /** This field indicates what level or scope of the per diem stats we compare at. */
  compareAgainstAt: PerDiemStatsEntityType;
  /** A list of relevant expenses associate with this spend insight. This field is null in case of partial failures. */
  relevantExpenses?: Maybe<Array<Maybe<Expense>>>;
  /** The department level stats or company level stats we used for the calculation. */
  stats: Array<PerDiemStats>;
  /** The expense that triggers this spend insight. This field is null in case of partial failures. */
  triggeredExpense?: Maybe<Expense>;
  /** The user this insight belongs to. This field is null in case of partial failures. */
  user?: Maybe<User>;
}

export type EmpowerInsightMetadata =
  | EmpowerExpensiveTransactionMetadata
  | EmpowerHighSpendPerDiemMetadata
  | EmpowerSpendIncreaseMetadata;

export interface EmpowerIntegration {
  connectivityStatus?: Maybe<EmpowerIntegrationConnectivityStatus>;
  id: Scalars["ID"];
  integrationDetail?: Maybe<EmpowerIntegrationDetail>;
  lastSync?: Maybe<EmpowerIntegrationSync>;
}

export enum EmpowerIntegrationCategory {
  ACCOUNTING = "ACCOUNTING",
  COMMS_AUTH = "COMMS_AUTH",
  HRIS = "HRIS",
  OTHER = "OTHER",
  PRODUCTIVITY = "PRODUCTIVITY",
  RECEIPT = "RECEIPT",
  TRAVEL = "TRAVEL",
}

export interface EmpowerIntegrationConnection {
  edges: Array<EmpowerIntegrationEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export enum EmpowerIntegrationConnectivityStatus {
  CONNECTED = "CONNECTED",
  DISCONNECTED = "DISCONNECTED",
  INVALID = "INVALID",
  UNLINKED = "UNLINKED",
}

export interface EmpowerIntegrationDetail {
  categories: Array<EmpowerIntegrationCategory>;
  createdAt?: Maybe<Scalars["Time"]>;
  description?: Maybe<Scalars["String"]>;
  displayName: Scalars["String"];
  providerMetadata?: Maybe<EmpowerIntegrationProviderMetadata>;
  redirectUrl?: Maybe<Scalars["String"]>;
  refreshedAt?: Maybe<Scalars["Time"]>;
}

export interface EmpowerIntegrationEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<EmpowerIntegration>;
}

export interface EmpowerIntegrationFailedSync {
  syncError: EmpowerIntegrationSyncError;
  timestamp?: Maybe<Scalars["Time"]>;
}

export type EmpowerIntegrationProviderMetadata =
  | CommsAuthMetadata
  | ErpMetadata
  | MergeMetadata
  | PartnerMetadata
  | ReceiptMetadata;

export enum EmpowerIntegrationProviderType {
  COMMS_AUTH = "COMMS_AUTH",
  ERP = "ERP",
  MERGE = "MERGE",
  OTHER = "OTHER",
}

export interface EmpowerIntegrationSuccessfulSync {
  timestamp?: Maybe<Scalars["Time"]>;
}

export type EmpowerIntegrationSync =
  | EmpowerIntegrationFailedSync
  | EmpowerIntegrationSuccessfulSync;

export interface EmpowerIntegrationSyncError {
  errorMessage?: Maybe<Scalars["String"]>;
  errorType: EmpowerIntegrationSyncErrorType;
  retryable?: Maybe<Scalars["Boolean"]>;
}

export enum EmpowerIntegrationSyncErrorType {
  EXPORT = "EXPORT",
  IMPORT = "IMPORT",
  REFRESH = "REFRESH",
  UNKNOWN = "UNKNOWN",
}

/** List EmpowerIntegrations */
export interface EmpowerIntegrationsFilterInput {
  /** Status of the integration */
  connectivityStatus?: InputMaybe<Array<EmpowerIntegrationConnectivityStatus>>;
  /** Category for the integration */
  integrationCategories?: InputMaybe<Array<EmpowerIntegrationCategory>>;
}

export interface EmpowerSpendIncreaseMetadata {
  /** The current month spend. */
  currentMonthSpend: MonthlySpend;
  /** The entity that is associated with the insight */
  entity?: Maybe<InsightAssociatedEntity>;
  /** The previous three months' spend. Sorted in descending order. */
  previousMonthlySpends: Array<MonthlySpend>;
  /** A list of relevant expenses associate with this spend insight. This field is null in case of partial failures. */
  relevantExpenses?: Maybe<Array<Maybe<Expense>>>;
  /** The expense that triggers this spend insight. This field is null in case of partial failures. */
  triggeredExpense?: Maybe<Expense>;
}

export enum EmpowerTier {
  EMBEDDED = "EMBEDDED",
  ENTERPRISE = "ENTERPRISE",
  ESSENTIALS_V2 = "ESSENTIALS_V2",
  FREE = "FREE",
  PAID = "PAID",
  PREMIUM = "PREMIUM",
  P_CARD = "P_CARD",
}

export interface EnableBillPayBillingInput {
  /** RAD ID to be used for Autopay account */
  autopayAccountId?: InputMaybe<Scalars["ID"]>;
  /**
   * Only the first currency will be used. The array preserved optionality to configure an entity for multiple currencies,
   * but customers do not need it.
   */
  billingCurrencies?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  /** The legal entity ID that will be billed. */
  billingEntityId: Scalars["ID"];
  /**
   * The funding source bill pay bills will default to.
   * Required for USD configurations.
   * Currently, BillPay only supports USD.
   * Non-USD configurations do not need this field, set it with an empty string.
   */
  fundingSourceId: Scalars["ID"];
  /** Idempotency key for safe retries. Avoid generating it on the fly so the customer can re-try the request in the event of a network error */
  idempotencyKey: Scalars["String"];
}

export interface EnableBillingInput {
  /** RAD ID to be used for Autopay account */
  autopayAccountId?: InputMaybe<Scalars["ID"]>;
  /**
   * Currencies in which the new billing entity will be billed.
   * Defaults to USD if empty or null.
   * Only the first currency will be used. The array preserved optionality to configure an entity for multiple currencies,
   * but customers do not need it.
   */
  billingCurrencies?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  /** The legal entity ID that will be billed. */
  billingEntityId: Scalars["ID"];
  /**
   * 2 character ISO 3166-2 country code.
   * If the legal entity's country differs, it will be updated with this value, potentially triggering a KYC verification.
   */
  businessAddressCountry?: InputMaybe<Scalars["String"]>;
  /**
   * The funding source card bills will be paid with.
   * Required for USD configurations.
   * Non-USD configurations do not need this field, set it with an empty string.
   */
  fundingSourceId: Scalars["ID"];
  /** Idempotency key for safe retries. Avoid generating it on the fly so the customer can re-try the request in the event of a network error */
  idempotencyKey: Scalars["String"];
}

export interface EnableBillingResponse {
  /** The billing configuration created */
  billingGroup: BillingGroup;
}

export interface EnableBillsInput {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
}

export interface EnableBillsPayload {
  clientMutationId: Scalars["String"];
  integration?: Maybe<Integration>;
}

export interface EnableEmployeeTrackingInput {
  /**
   * Only the first currency will be used. The array preserved optionality to configure an entity for multiple currencies,
   * but customers do not need it.
   */
  billingCurrencies: Array<Scalars["String"]>;
  /** The legal entity ID that will be tracked. */
  billingEntityId: Scalars["ID"];
  /** Idempotency key for safe retries. Avoid generating it on the fly so the customer can re-try the request in the event of a network error */
  idempotencyKey: Scalars["String"];
  /** How often admins should receive a reminder of pending tracked expenses */
  paymentReminderCycle?: InputMaybe<BillingCycleOneOfInput>;
}

export interface EnableEmployeeTrackingResponse {
  /** The billing configuration created */
  billingGroup: BillingGroup;
}

export interface EnableExpensesInput {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
}

export interface EnableExpensesPayload {
  clientMutationId: Scalars["String"];
  integration?: Maybe<Integration>;
}

export interface EnableIntegrationInput {
  clientMutationId: Scalars["String"];
  /** id is integration id */
  id: Scalars["ID"];
}

export interface EnableIntegrationPayload {
  clientMutationId: Scalars["String"];
  /** The enabled integration */
  integration?: Maybe<Integration>;
}

export interface EnableLastDisabledChannelInput {
  /** Channel type to enable */
  channelType: Scalars["String"];
  clientMutationId: Scalars["String"];
}

export interface EnableLastDisabledChannelPayload {
  /** The enabled channel */
  channel?: Maybe<Channel>;
  clientMutationId: Scalars["String"];
}

export interface EnableReimbursementsBillingInput {
  /** RAD ID to be used for autopay account */
  autopayAccountId?: InputMaybe<Scalars["ID"]>;
  /**
   * Only the first currency will be used. The array preserved optionality to configure an entity for multiple currencies,
   * but customers do not need it.
   */
  billingCurrencies: Array<Scalars["String"]>;
  /** How often bills are cut and payments are due */
  billingCycle: BillingCycleOneOfInput;
  /** The legal entity ID that will be billed. */
  billingEntityId: Scalars["ID"];
  /**
   * 2 character ISO 3166-2 country code.
   * If the legal entity's country differs, it will be updated with this value, potentially triggering a KYC verification.
   */
  businessAddressCountry?: InputMaybe<Scalars["String"]>;
  /** Also creates a employee tracking (aka pay outside of brex) billing group for hybrid configurations */
  createEmployeeTracking?: InputMaybe<Scalars["Boolean"]>;
  /** Required for USD configurations, but optional for non-USD because customer will push payments. */
  fundingSourceId?: InputMaybe<Scalars["ID"]>;
  /** Idempotency key for safe retries. Avoid generating it on the fly so the customer can re-try the request in the event of a network error */
  idempotencyKey: Scalars["String"];
}

export interface EnableReimbursementsBillingResponse {
  /** The billing configuration created */
  billingGroup: BillingGroup;
}

export interface EnableReimbursementsInput {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
}

export interface EnableReimbursementsPayload {
  clientMutationId: Scalars["String"];
  integration?: Maybe<Integration>;
}

export enum EnablementState {
  DISABLED = "DISABLED",
  ENABLED = "ENABLED",
}

/** Settings used to configure engagement features. */
export interface EngagementSetting {
  /** Desired enablement of AI commenting */
  aiCommentingEnabled?: Maybe<Scalars["Boolean"]>;
  /** Compliance rating product status. */
  complianceRatingProductStatus: ComplianceRatingProductStatus;
  /** ID of this setting. */
  id: Scalars["ID"];
}

/**  | ... more */
export type Entity =
  | AccountingRecord
  | BankingInvoice
  | BankingTransaction
  | Booking
  | Budget
  | Card
  | CostCenter
  | Department
  | Expense
  | InvoiceNumber
  | LegalEntity
  | LimitGroup
  | LimitGroupOrSpendLimit
  | Location
  | Merchant
  | SpendLimit
  | Title
  | User
  | VendorCategory
  | VendorDetails;

export interface EntityAddressPayloadInput {
  city: Scalars["String"];
  countriesOperating?: InputMaybe<Array<Scalars["String"]>>;
  country: Scalars["String"];
  line1: Scalars["String"];
  line2?: InputMaybe<Scalars["String"]>;
  state: Scalars["String"];
  zip: Scalars["String"];
}

/** The aggregation function to apply to an entity */
export enum EntityAggregateFunction {
  AVG = "AVG",
  COUNT = "COUNT",
  MULTI_CURRENCY_SUM = "MULTI_CURRENCY_SUM",
  SUM = "SUM",
}

export interface EntityAggregateInput {
  /**
   * Required field key to aggregate on, e.g. "total_billing_amount" in  SUM(BILLING_AMOUNT) as total_billing_amount
   * alias is required
   */
  fieldKey: EntityFieldKeyInput;
  /** When specified, filter the aggregation, e.g. count(*) filter (where has_memo) */
  filter?: InputMaybe<EntityFilterInput>;
  /** Required aggregate function, e.g. SUM */
  function: EntityAggregateFunction;
}

/** Get autopay funding source for an entity/product type pair */
export interface EntityAutopayFundingSourceInput {
  /**
   * Legal Entity Id
   * Not passing this value will fetch the default entity for the customer.
   * This is desired for Transaction Fees and SAAS Billing which are not billed by entity
   */
  legalEntityId?: InputMaybe<Scalars["String"]>;
  /** Enum representing the product type associated with an autopay funding source */
  productType: FundingSourceProductType;
}

/** Get autopay funding source for given entity and product type filters */
export interface EntityAutopayFundingSourcesInput {
  /**
   * Legal Entity Id
   * Not passing this value will fetch the default entity for the customer.
   * This is desired for Transaction Fees and SAAS Billing which are not billed by entity
   */
  legalEntityId?: InputMaybe<Scalars["String"]>;
  /** Enum representing the product type associated with an autopay funding source */
  productTypes?: InputMaybe<Array<FundingSourceProductType>>;
}

export interface EntityConnection extends Connection {
  aggregations?: Maybe<Array<EntityField>>;
  edges: Array<EntityEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface EntityCorporateStructurePayloadInput {
  chart?: InputMaybe<Scalars["String"]>;
  description?: InputMaybe<Scalars["String"]>;
}

export interface EntityCustomersPayloadInput {
  majorityCountry?: InputMaybe<Scalars["String"]>;
  productsDescription?: InputMaybe<Scalars["String"]>;
}

export interface EntityDetailsPayloadInput {
  dba?: InputMaybe<Scalars["String"]>;
  employeeMajorityCountry?: InputMaybe<Scalars["String"]>;
  industry?: InputMaybe<Scalars["String"]>;
  isPublicCompany?: InputMaybe<Scalars["Boolean"]>;
  legalBusinessName?: InputMaybe<Scalars["String"]>;
  numberOfEmployees?: InputMaybe<Scalars["String"]>;
  website?: InputMaybe<Scalars["String"]>;
}

export interface EntityEdge {
  cursor?: Maybe<Scalars["String"]>;
  node: EntityRowOneOf;
}

export interface EntityEinPayloadInput {
  /** Entity identification number */
  companyIdentificationNumber: Scalars["String"];
}

export interface EntityField {
  key?: Maybe<EntityFieldKey>;
  /**
   * Optional name, populated when used while returning groupFields
   * e.g for key = MERCHANTS_MERCHANT_ID, name can be "Doordash"
   */
  name?: Maybe<Scalars["String"]>;
  value?: Maybe<EntityQueryValue>;
}

/** A wrapper type for the entity field key */
export interface EntityFieldKey {
  /**
   * Required when used in Aggregate! Otherwise can leave this empty
   * alias for the caller to identify the aggregate in the response
   * e.g. "expense_count" in "count(*) as expense_count"
   */
  alias?: Maybe<Scalars["String"]>;
  key: EntityFieldKeyUnion;
}

export interface EntityFieldKeyInput {
  /**
   * Required when used in Aggregate! Otherwise can leave this empty
   * alias for the caller to identify the aggregate in the response
   * e.g. "expense_count" in "count(*) as expense_count"
   */
  alias?: InputMaybe<Scalars["String"]>;
  /**
   * Field key used in filter, group by, sort or aggregation
   * e.g. "EXPENSE_BILLING_AMOUNT" for "ORDER BY expense.billing_amount DESC"
   * "EXPENSE_MERCHANTS_MERCHANT_ID" for expense's merchant id
   * "ALL" for all expense items used in aggregation "COUNT(*)"
   */
  key: EntityFieldKeyTypeOneOf;
}

/** Specifies which field key to use in the universal query API. Only one field key may be defined in this input. */
export interface EntityFieldKeyTypeOneOf {
  /** The Accounting Record field keys */
  accountingRecordFieldKey?: InputMaybe<AccountingRecordFieldKeyType>;
  /** The banking invoice field keys */
  bankingInvoiceFieldKey?: InputMaybe<BankingInvoiceEntityFieldKeyType>;
  /** The banking transaction field keys */
  bankingTransactionFieldKey?: InputMaybe<BankingTransactionEntityFieldKeyType>;
  /** The booking entity field keys */
  bookingFieldKey?: InputMaybe<BookingEntityFieldKeyType>;
  /** The Card field keys */
  cardFieldKey?: InputMaybe<CardFieldKeyType>;
  /** The department field keys */
  departmentFieldKey?: InputMaybe<DepartmentFieldKeyType>;
  /** The expense primitive field keys */
  expenseFieldKey?: InputMaybe<ExpensePrimitiveFieldKeyType>;
  /** The user field keys */
  userFieldKeyType?: InputMaybe<UserFieldKeyType>;
  /** The vendor category primitive field keys */
  vendorCategoryPrimitiveFieldKey?: InputMaybe<VendorCategoryPrimitiveFieldKeyType>;
}

export type EntityFieldKeyUnion =
  | AccountingRecordFieldKeyTypeWrapper
  | BankingInvoiceFieldKeyTypeWrapper
  | BankingTransactionFieldKeyTypeWrapper
  | BookingFieldKeyTypeWrapper
  | CardFieldKeyTypeWrapper
  | DepartmentFieldKeyTypeWrapper
  | ExpenseFieldKeyTypeWrapper
  | UserFieldKeyTypeWrapper
  | VendorCategoryFieldKeyTypeWrapper;

/**
 * Specifies the filter condition to apply to query an entity. The filter condition can be recursively defined to optionally
 * chained nested ANDs/ORs together.
 *
 * Only one of the fields may be defined in this input filter condition. If more than one field is defined, the query will fail.
 */
export interface EntityFilterConditionOneOf {
  /** The list of filters to AND together */
  and?: InputMaybe<Array<EntityFilterInput>>;
  /** The entity filter to apply */
  filterCondition?: InputMaybe<FilterConditionOneOf>;
  /** The list of filters to OR together */
  or?: InputMaybe<Array<EntityFilterInput>>;
}

/**
 * The filter input for the universal query API. The filter can be recursively defined to optionally chain nested
 * ANDs/ORs together.
 */
export interface EntityFilterInput {
  /** The filters to apply when querying for an entity */
  filter: EntityFilterConditionOneOf;
  /** Specify negate to optionally "NOT" the query filter */
  negate?: InputMaybe<Scalars["Boolean"]>;
}

export enum EntityFundingSource {
  ANGEL_INVESTMENT = "ANGEL_INVESTMENT",
  BUSINESS_REVENUE = "BUSINESS_REVENUE",
  CROWDSOURCED = "CROWDSOURCED",
  FAMILY = "FAMILY",
  GRANTS = "GRANTS",
  INITIAL_COIN_OFFERING = "INITIAL_COIN_OFFERING",
  LOAN_FUNDING = "LOAN_FUNDING",
  PARENT_COMPANY = "PARENT_COMPANY",
  PRIVATE_EQUITY = "PRIVATE_EQUITY",
  PROFESSIONAL_INVESTOR = "PROFESSIONAL_INVESTOR",
  SELF_FUNDED = "SELF_FUNDED",
  VENTURE_ACCELERATOR_GROWTH = "VENTURE_ACCELERATOR_GROWTH",
}

export interface EntityFundingSourcePayloadInput {
  sources: Array<EntityFundingSource>;
}

export interface EntityGroup {
  aggregateFields?: Maybe<Array<EntityField>>;
  groupFields?: Maybe<Array<EntityField>>;
  items?: Maybe<Array<Entity>>;
  pageInfo: PageInfo;
}

export interface EntityGroupByInput {
  /** Optional Aggregate on all items within the group regardless of the group items limit */
  aggregates?: InputMaybe<Array<EntityAggregateInput>>;
  /**
   * Required FieldKeys used in group by
   * e.g. "EXPENSES_MERCHANTS_MERCHANT_ID, EXPENSES_BUDGETS_BUDGET_ID" in "GROUP BY expense's merchant id, expense's budget id"
   */
  groupByKeys: Array<EntityFieldKeyInput>;
  /**
   * Optional. Max number of items returned in each group
   * Default value = 0 to not load any items
   */
  groupItemsLimit?: InputMaybe<Scalars["Int"]>;
  /**
   * Optional Sort for the groups.
   * Default sort is ORDER BY group_by_keys's name ASC
   */
  groupSorts?: InputMaybe<Array<EntitySortInput>>;
}

export interface EntityIncorporationDetailsPayloadInput {
  /** Entity identification number */
  companyIdentificationNumber?: InputMaybe<Scalars["String"]>;
  /** Set if entity does not have an active EIN assigned yet. */
  delayedEINDetails?: InputMaybe<DelayedEINDetailsInput>;
  /** Country where entity was incorporated */
  incorporationCountry?: InputMaybe<Scalars["String"]>;
  /** Region where entity was incorporated */
  incorporationRegion?: InputMaybe<Scalars["String"]>;
  /** Incorporation type of entity */
  incorporationType: KycIdentityIncorporationType;
  /** Year when entity was incorporated */
  incorporationYear?: InputMaybe<Scalars["Int"]>;
}

/** Mapping between an entity and another value in an integration. */
export interface EntityMapping {
  /** ID of the value we are mapping from */
  mappingInputId: Scalars["ID"];
  /** Display name that of the value we are mapping to */
  mappingInputName: Scalars["String"];
  /** ID of the extended field the value we are mapping to */
  mappingOutputFieldId?: Maybe<Scalars["ID"]>;
  /** ID of the value we have mapping to */
  mappingOutputId: Scalars["ID"];
  /** Display name that of the value we are mapping from */
  mappingOutputName: Scalars["String"];
  /** The extended field value we are mapping to */
  mappingOutputOption?: Maybe<ExtendedFieldOption>;
  /** Type of mapping we performed */
  mappingType: EntityMappingType;
}

export enum EntityMappingType {
  /** Mapping between a Brex Legal Entity and an ERP subsidiary */
  ACCOUNTING_ENTITY = "ACCOUNTING_ENTITY",
  /** Mapping between a Brex Funding Source and an GL Account */
  FUNDING_SOURCE = "FUNDING_SOURCE",
}

export interface EntityOwnershipPayloadInput {
  kycIdentityIndividuals?: InputMaybe<
    Array<InputMaybe<KYCIdentityIndividualInput>>
  >;
}

export interface EntityPublicCompanyDetailsPayloadInput {
  exchange: Scalars["String"];
  exchangeName?: InputMaybe<Scalars["String"]>;
  tickerSymbol?: InputMaybe<Scalars["String"]>;
}

export interface EntityQueryFinancialAssetValue {
  value?: Maybe<FinancialAsset>;
}

export interface EntityQueryFinancialAssetValuesList {
  values: Array<FinancialAsset>;
}

export interface EntityQueryIntValue {
  value?: Maybe<Scalars["Int"]>;
}

export interface EntityQueryStringValue {
  value?: Maybe<Scalars["String"]>;
}

export type EntityQueryValue =
  | EntityQueryFinancialAssetValue
  | EntityQueryFinancialAssetValuesList
  | EntityQueryIntValue
  | EntityQueryStringValue;

/**
 * Since Entity is already a union, we can't have union of unions in the response, so we resort
 * to a wrapper type that can either be an Entity or EntityGroup
 */
export interface EntityRowOneOf {
  entity?: Maybe<Entity>;
  entityGroup?: Maybe<EntityGroup>;
}

/** Optional input for the universal query API to control query behavior. */
export interface EntityRowsQueryOptionsInput {
  /**
   * Optional. This limits the count up to the specified limit. If the count exceeds the limit, the API will return the
   * specified limit. This is useful for performance reasons when the caller is only interested in the top N results.
   * This will only work for root level aggregations, so it will not apply to group by aggregations.
   */
  aggregationLimit?: InputMaybe<Scalars["Int"]>;
}

export interface EntitySortInput {
  direction: OrderByDirection;
  /** Required sort key, e.g  PURCHASED_AT */
  fieldKey: EntityFieldKeyInput;
  /** Indicates where the null values should go, either first or last. */
  nullsOrder?: InputMaybe<NullsOrder>;
}

/** Suggestion type for entity (ie: purchase order) based on user provided suggestion input (ie: vendor name) */
export enum EntitySuggestionType {
  /** Exact match found based on suggestion input */
  MATCH = "MATCH",
  /** Not a match or suggestion based on suggestion input */
  NONE = "NONE",
  /** Partial match found based on suggestion input */
  SUGGESTION = "SUGGESTION",
}

/**
 * All supported entity types for the universal query API
 * Because this enum is shared between multiple services, mark new values as @inaccessible, deploy it to prod, then remove the annotation
 * https://brexhq.atlassian.net/wiki/spaces/ENGDOC/pages/1653538928/Shared+GraphQL+Types#Enum%2FInterface%2FUnion%2FField-Types%2FInputs-%3A
 */
export enum EntityType {
  ACCOUNTING_RECORD = "ACCOUNTING_RECORD",
  BANKING_INVOICE = "BANKING_INVOICE",
  BANKING_TRANSACTION = "BANKING_TRANSACTION",
  BILLPAY_VENDOR = "BILLPAY_VENDOR",
  BOOKING = "BOOKING",
  BUDGET = "BUDGET",
  CARD = "CARD",
  CARD_VENDOR = "CARD_VENDOR",
  COST_CENTER = "COST_CENTER",
  DEPARTMENT = "DEPARTMENT",
  EXPENSE = "EXPENSE",
  INVOICE_NUMBER = "INVOICE_NUMBER",
  LEGAL_ENTITY = "LEGAL_ENTITY",
  LIMIT_GROUP = "LIMIT_GROUP",
  LIMIT_GROUP_OR_SPEND_LIMIT = "LIMIT_GROUP_OR_SPEND_LIMIT",
  LOCATION = "LOCATION",
  /** @deprecated Use CARD_VENDOR or BILLPAY_VENDOR */
  MERCHANT = "MERCHANT",
  /** Not currently supported in the universal query API, used for RuleBuilder */
  POLICY = "POLICY",
  SPEND_LIMIT = "SPEND_LIMIT",
  TITLE = "TITLE",
  USER = "USER",
  VENDOR_CATEGORY = "VENDOR_CATEGORY",
}

export interface EntityVendorsPayloadInput {
  description?: InputMaybe<Scalars["String"]>;
}

export interface EnumValue {
  value?: Maybe<Scalars["String"]>;
}

export interface EnumValueInput {
  value?: InputMaybe<Scalars["String"]>;
}

/**
 * Only one of these will be set.
 * You can't have a union of enums in GraphQL
 *
 * Enums are duplicated here to avoid sharing types across DGS which is brittle and tricky to work with.
 */
export interface EnumValueOneOf {
  billableStatus?: Maybe<WorkflowRuleBillableStatus>;
  expenseStatus?: Maybe<WorkflowRuleExpenseStatus>;
}

/**
 * Acts as an input union/oneOf depending on which field is not NULL
 * One field is required to be set
 *
 * Enums are duplicated here to avoid sharing types across DGS which is brittle and tricky to work with.
 */
export interface EnumValueOneOfInput {
  accountingRecordLineType?: InputMaybe<WorkflowRuleAccountingRecordLineType>;
  accountingRecordSource?: InputMaybe<WorkflowRuleAccountingRecordSource>;
  billableStatus?: InputMaybe<WorkflowRuleBillableStatus>;
  expenseStatus?: InputMaybe<WorkflowRuleExpenseStatus>;
}

/** A credit card fetched from the ERP */
export interface ErpCreditCardOutput {
  cardId: Scalars["String"];
  /** (nullable) ID of the entity to which the credit card belongs. */
  entityId?: Maybe<Scalars["String"]>;
  name: Scalars["String"];
}

export interface ErpExtension {
  apAccountId?: Maybe<Scalars["String"]>;
  erpVendorId?: Maybe<Scalars["String"]>;
  erpVendorName?: Maybe<Scalars["String"]>;
}

export interface ErpFeed extends Node {
  customerAccountId?: Maybe<Scalars["String"]>;
  exportPipeId?: Maybe<Scalars["String"]>;
  financialAccountId?: Maybe<Scalars["String"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  lastExportedAt?: Maybe<Scalars["Time"]>;
  status?: Maybe<Scalars["String"]>;
  syncFrom?: Maybe<Scalars["Time"]>;
  type?: Maybe<ErpVendorType>;
}

export interface ErpFeedConnection {
  edges?: Maybe<Array<Maybe<ErpFeedEdge>>>;
  pageInfo: PageInfo;
}

export interface ErpFeedEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<ErpFeed>;
}

export interface ErpFeedInput {
  /** financial_account_id the feed is for */
  financialAccountId: Scalars["ID"];
  /** Date to begin the sync */
  syncFrom: Scalars["Time"];
  /** Erp Vendor type */
  type: ErpVendorType;
  /** Raw json object with metadata */
  vendorOptions?: InputMaybe<Scalars["Json"]>;
}

export interface ErpMetadata {
  /** @deprecated No longer supported */
  erpIntegrationInternalId?: Maybe<Scalars["String"]>;
  integrationName: Scalars["String"];
}

/** Subscription details for an ERP integration */
export interface ErpSubscriptionDetail {
  /** The name of the subscription plan */
  subscriptionPlanName?: Maybe<Scalars["String"]>;
  /** The status of the subscription */
  subscriptionStatus?: Maybe<Scalars["String"]>;
  /** Whether the subscription plan supports bill sync */
  supportsBillSync?: Maybe<Scalars["Boolean"]>;
}

/** Definition of an ERP subsidiary */
export interface ErpSubsidiary extends Node {
  /** References the intercompany customer on the parent subsidiary */
  customer?: Maybe<ExternalIntegrationEntity>;
  /** List of subsidiary default integration entities. */
  defaultIntegrationEntities?: Maybe<DefaultIntegrationEntityConnection>;
  deletedAt?: Maybe<Scalars["Time"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  /** ID of integration that subsidiary belongs to */
  integrationId: Scalars["ID"];
  /** References the intercompany payable GL account on the child subsidiary */
  intercompanyPayableAccount?: Maybe<UserCategory>;
  /** References the intercompany receivable GL account on the parent subsidiary */
  intercompanyReceivableAccount?: Maybe<UserCategory>;
  /** Human-readable name */
  name: Scalars["String"];
  /** ID of parent subsidiary. Parent subsidiaries will have null parent ID */
  parentId?: Maybe<Scalars["ID"]>;
  /** References the subsidiary payload for multi-entity billing. */
  payload?: Maybe<SubsidiaryPayload>;
  status: SubsidiaryStatus;
  /** References the intercompany vendor on the child subsidiary */
  vendor?: Maybe<ExternalIntegrationEntity>;
  /** ID used by the external ERP vendor to identify a subsidiary */
  vendorInternalId: Scalars["String"];
}

/** Definition of an ERP subsidiary */
export interface ErpSubsidiarydefaultIntegrationEntitiesArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

export interface ErpSubsidiaryConnection {
  edges?: Maybe<Array<Maybe<ErpSubsidiaryEdge>>>;
  pageInfo: PageInfo;
}

export interface ErpSubsidiaryEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<ErpSubsidiary>;
}

/** A lightweight vendor type specifically for ERP-sourced vendors */
export interface ErpVendor {
  /** The vendor name from the ERP system */
  name: Scalars["String"];
  /** The URL that leads to the vendor in the ERP */
  url?: Maybe<Scalars["String"]>;
}

/** An ERP Vendor connection for ERP Vendor pagination. */
export interface ErpVendorConnection extends Connection {
  /** The ERP vendors in the current page of results. */
  edges: Array<ErpVendorEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of ERP vendors matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface ErpVendorDetails {
  address?: Maybe<Address>;
  email?: Maybe<Scalars["String"]>;
  erpId: Scalars["String"];
  id: Scalars["ID"];
  is1099Eligible?: Maybe<Scalars["Boolean"]>;
  name: Scalars["String"];
  phone?: Maybe<Scalars["String"]>;
  website?: Maybe<Scalars["String"]>;
}

/** An ErpVendor edge for the ErpVendor connection. */
export interface ErpVendorEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The ERP vendor at this edge. */
  node?: Maybe<ErpVendorDetails>;
}

/** Filters available to control which ERP vendors get returned. */
export interface ErpVendorFilterInput {
  /** Search for erp vendor names containing the given string */
  erpVendorNameSearch?: InputMaybe<Scalars["String"]>;
  /** Specify whether to return only unlinked ERP vendors (no corresponding vendor exists in Brex) */
  isUnlinked?: InputMaybe<Scalars["Boolean"]>;
}

export enum ErpVendorType {
  CONCUR = "CONCUR",
  CONFERMA = "CONFERMA",
  INVALID = "INVALID",
  XERO = "XERO",
}

/**
 * User-related errors mapped from gRPC status code list
 * https://grpc.github.io/grpc-java/javadoc/io/grpc/Status.html
 */
export enum ErrorCode {
  /** Some entity that we attempted to create already exists. */
  ALREADY_EXISTS = "ALREADY_EXISTS",
  /**
   * Operation was rejected because the system is not in a state required for the operation's execution.
   * Examples of domain-specific errors: AUTHORIZATION_DECISION_REASON_DECLINED_LIMIT, CONFLICTING_RULES
   */
  FAILED_PRECONDITION = "FAILED_PRECONDITION",
  /**
   * Client specified an invalid argument.
   * Examples of domain-specific errors: MISSING_REQUIRED_FIELDS, MISSING_GL_ACCOUNT, MISSING_MEMO
   */
  INVALID_ARGUMENT = "INVALID_ARGUMENT",
  /** Operation was attempted past the valid range.Operation was attempted past the valid range. */
  NOT_FOUND = "NOT_FOUND",
  /**
   * Operation was attempted past the valid range.
   * Examples of domain-specific errors: AUTHORIZATION_DECISION_REASON_DECLINED_NO_BUDGET_PERIOD
   */
  OUT_OF_RANGE = "OUT_OF_RANGE",
  /** The caller does not have permission to execute the specified operation. */
  PERMISSION_DENIED = "PERMISSION_DENIED",
  /** This is the default code used if server did not specify an error code. */
  UNMAPPED = "UNMAPPED",
}

export interface ErrorResponse {
  error?: Maybe<InternalError>;
}

/** Holds list of audit escalation reasons on group level. */
export interface EscalationSummary {
  groupEscalationReasons?: Maybe<Array<AuditGroupEscalationReason>>;
}

/** Wraps a due payment, with how much is due and when is due */
export interface EstimatedUpcomingPayment {
  /** How much is due */
  balance?: Maybe<FinancialAsset>;
  /** The billing period (the start and end time) of a given payment */
  billingPeriod?: Maybe<PaymentBillingPeriod>;
  /** When is due */
  dueAt?: Maybe<Scalars["Time"]>;
}

export interface EventAttendee {
  deletedAt?: Maybe<Scalars["LocalDateTime"]>;
  /** The user attending the event */
  employee: Employee;
  /** Attendee ID */
  id: Scalars["ID"];
  /** The invite sent to the user */
  invite?: Maybe<Invite>;
  status: AttendeeStatus;
  /** The attendee's trip */
  trip?: Maybe<TravelTrip>;
  /** The user attending the event */
  user: User;
}

export interface EventAttendeeConnection extends Connection {
  edges: Array<Maybe<EventAttendeeEdge>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface EventAttendeeEdge {
  cursor?: Maybe<Scalars["String"]>;
  node: EventAttendee;
}

export interface EventAttendeesFilterInput {
  /** Filter based in dietary & accessibility requirements */
  attendeeRequirementsFilter?: InputMaybe<AttendeeRequirementsFilter>;
  hasAccessibilityRequirements?: InputMaybe<Scalars["Boolean"]>;
  hasDietaryRestrictions?: InputMaybe<Scalars["Boolean"]>;
  /** Match IN specific attendeeIds */
  ids?: InputMaybe<Array<Scalars["ID"]>>;
  /** Match IN specific statuses */
  statuses?: InputMaybe<Array<AttendeeStatus>>;
  /** Match IN specific userIds */
  userIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** search for users by name or email */
  userSearchText?: InputMaybe<Scalars["String"]>;
}

export interface EventAttendeesOrderInput {
  direction: OrderByDirection;
  field: SortableEventAttendeesField;
}

export interface EveryNDaysClosingStrategy {
  numDays?: Maybe<Scalars["Int"]>;
}

export interface EveryNDaysDetails {
  /** Number of days between bills (1 is daily) */
  numOfDays?: Maybe<Scalars["Int"]>;
}

/** Definition of user groups for role-based exceptions */
export interface ExceptionUserGroupInput {
  /** ID of the group associated with the exception. If not filled, a group will be created. */
  groupId?: InputMaybe<Scalars["ID"]>;
  /** Control membership through condition filters */
  memberCondition?: InputMaybe<MemberConditionInput>;
  /** Control membership through explicit user IDs */
  members?: InputMaybe<Array<GroupMemberInput>>;
}

export interface ExchangeRate {
  /** The base currency is the first currency appearing in a currency pair. */
  baseCurrency: Scalars["String"];
  /** The time this exchange rate was determined. */
  determinedAt: Scalars["Time"];
  /** The quote currency (counter currency) is the second currency in a currency pair. */
  quoteCurrency: Scalars["String"];
  /** The currency exchange rate of the currency pair. */
  rate: Scalars["Decimal"];
}

/** An Expense stub entity that will be resolved by another DGS. */
export interface Expense extends ExtensibleEntity, Node {
  /** The Customer Account that has visibility to this expense */
  account: Account;
  /** Information about the accounting export status of this expense */
  accountingExportData?: Maybe<ExpenseAccountingExport>;
  /**
   * The time of accrual
   * @deprecated Use postedAt instead.
   */
  accruedAt?: Maybe<Scalars["Time"]>;
  /** The action logs on an expense */
  actionLogs?: Maybe<Array<ActionLog>>;
  /** The addendums on an expense */
  addendums?: Maybe<Array<ExpenseAddendum>>;
  /** All operations that can be performed on the expense */
  allowedOperations: ExpenseOperations;
  /**
   * Amount of the expense; may be negative
   * @deprecated Use billing_amount instead.
   */
  amount?: Maybe<FinancialAsset>;
  /** Amount of the expense from multiple different views */
  amountViews?: Maybe<ExpenseMoney>;
  /** When the expense is approved */
  approvedAt?: Maybe<Scalars["Time"]>;
  /** A list of audit decisions made on this expense. An empty list indicates that expense has been reviewed and no specific violations or actions were recorded. */
  auditDecisions?: Maybe<Array<AuditDecision>>;
  /** Current audit status of the expense */
  auditStatus?: Maybe<AuditStatus>;
  /** Suggested action from the auditing perspective */
  auditSuggestion?: Maybe<AutomationSuggestion>;
  /** Whether the memo was auto-generated or not */
  autoGeneratedMemo?: Maybe<Scalars["Boolean"]>;
  /** Get suggestions for this expense, optionally filtered by status and type */
  automationSuggestions: Array<AutomationSuggestion>;
  /**
   * Available limits (spend limits and user limits) that may be assigned for the expense, some of which may include pre-authorization errors to indicate why the expense cannot be assigned to the budget at the current time.
   * NOTE: Only run this for unary calls or in a lazy load fashion for tables / datagrids, it is not performant to run this for > 1 expense at a time in its current state. This may change in the future.
   * NOTE: Will return UserLimit as the first item if relevant to the response
   *
   * Please communicate with the budgets-and-limits team if you have a use case that requires this.
   */
  availableLimits?: Maybe<AvailableLimitConnection>;
  /**
   * Available spend limits that may be assigned for the expense, some of which may include pre-authorization errors to indicate why the expense cannot be assigned to the budget at the current time.
   * NOTE: Only run this for unary calls or in a lazy load fashion for tables / datagrids, it is not performant to run this for > 1 expense at a time in its current state. This may change in the future.
   *
   * Please communicate with the budgets-and-limits team if you have a use case that requires this.
   */
  availableSpendLimits?: Maybe<AvailableSpendLimitConnection>;
  /**
   * The budget to which this expense accrues (has customer default; optional before default budgets exist)
   * @deprecated budget is deprecated. Use spendLimit instead.
   */
  budget?: Maybe<Budget>;
  /**
   * Suggestions for Expense Category based on the customers prior expense categorization. Limited to the top 10
   *
   * Note: This property doesn't support true batch resolution and should be read on individual expenses (i.e. EDP)
   */
  categorySuggestions: Array<ExpenseCategorySuggestion>;
  /** The clawback associated with this expense */
  clawback?: Maybe<Clawback>;
  /** The original expense id associated with this expense if it was a clawback */
  clawbackOriginalExpenseId?: Maybe<Scalars["String"]>;
  /** Comment thread associated with an expense. */
  commentThread?: Maybe<CommentThread>;
  /** The time when the associated payment is expected to complete */
  completionExpectedAt?: Maybe<Scalars["Time"]>;
  /**
   * The "Compliance Flags" associated with the Expense
   * (e.g. [MISSING_MEMO, MISSING_RECEIPT] if those are required)
   */
  complianceFlags?: Maybe<Array<ExpenseComplianceFlag>>;
  /**
   * Consolidated vendor name will determine the vendor name for the expense according to the following rules:
   * If the expense has a vendor ID, it will return its name
   * If there's no vendor ID, it will look for a "Merchant Name" addendum and use it
   * If there's no "Merchant Name" addendum, it will look for a mileage addendum in the expense, if there is one, it will return "Mileage" as the consolidated vendor name.
   * If all of the above are not present, it will return null.
   * @deprecated use vendorDisplay.name instead
   */
  consolidatedVendorName?: Maybe<Scalars["String"]>;
  /** The custom merchant name that the user manually saved */
  customMerchant?: Maybe<Scalars["String"]>;
  /** The Customer User who incurred the expense */
  customer: User;
  /** The Customer Department to which the expense is attributed, auto-denormalized from User */
  department?: Maybe<Department>;
  displayLimit?: Maybe<DisplayLimit>;
  /** The display status of the expense; takes into account payment status & disputes */
  displayStatus?: Maybe<ExpenseDisplayStatus>;
  /**
   * The visible status label for the expense; provides the final display-ready status text
   * that takes into account payment status, disputes, and other factors
   */
  displayableStatus?: Maybe<Scalars["String"]>;
  /** The Employee who incurred the expense */
  employee: Employee;
  /** Status of this expense regarding eligibility for entity reassignment. */
  entityReassignmentEligibility?: Maybe<ExpenseEntityReassignmentEligibility>;
  /** The expense category information for download purposes including main category and its addendum values */
  expenseCategoryDownloadField?: Maybe<ExpenseCategoryDownloadField>;
  /** The dispute status of the expense */
  expenseDisputeStatuses?: Maybe<ExpenseDisputeStatus>;
  /** The calculated integration lens field for this expense */
  expenseLens?: Maybe<ExpenseLens>;
  /** The location where the expense occurred */
  expenseLocation?: Maybe<ExpenseLocation>;
  /** The risk data associated with this expense */
  expenseRisk?: Maybe<ExpenseRisk>;
  exportEntry?: Maybe<ExportEntry>;
  extendedFieldInstance?: Maybe<ExtendedFieldInstance>;
  extendedFieldInstances?: Maybe<ExtendedFieldInstanceConnection>;
  /**
   * The extended field values on an expense.
   *
   * An optional filter may be specified to select specific extended field values.
   * If not specified, defaults to all extended field values.
   */
  extendedFieldValues?: Maybe<Array<Maybe<ExpenseExtendedFieldValue>>>;
  /** Expense extension field. */
  extension?: Maybe<ExpenseExtensionType>;
  /** The financial asset movements associated with the expense */
  financialAssetMovements: FinancialAssetMovementConnection;
  /** The entity that funds this expense */
  fundingLegalEntity?: Maybe<LegalEntity>;
  /** The grouping associated with an expense if there is one. */
  grouping?: Maybe<ExpenseGrouping>;
  /** True if there is at least one receipt of ReceiptChannel is AUTO_GENERATED */
  hasAutoGeneratedReceipt: Scalars["Boolean"];
  /** True if there is at least one receipt of ReceiptChannel is *not* AUTO_GENERATED, UNKNOWN_CHANNEL or INVALID */
  hasUploadedReceipt: Scalars["Boolean"];
  /** Expense ID. */
  id: Scalars["ID"];
  /** When the expense was created */
  insertedAt: Scalars["Time"];
  /** Whether an invoice is required for a billpay type expense */
  isInvoiceRequired?: Maybe<Scalars["Boolean"]>;
  /** Whether a receipt is required for a billpay type expense */
  isReceiptRequired?: Maybe<Scalars["Boolean"]>;
  /**
   * Whether this expense is a recurring expense
   * Note: Currently this is only true for BillPay expenses with a recurring schedule, but can also be used for other
   * types of expenses in future.
   */
  isRecurring: Scalars["Boolean"];
  /** The status of itemization for an expense */
  itemizationStatus?: Maybe<ItemizationStatus>;
  /** Fetches the latest accounting record by inserted_at (ADJUSTING_ENTRY / DRAFT / ACTIVE) for the expense. The record that will be returned will be non-deleted */
  latestAccountingRecord?: Maybe<AccountingRecord>;
  /** Line items on this expense */
  lineItems?: Maybe<Array<Expense>>;
  /** The Customer Location to which the expense is attributed, auto-denormalized from User */
  location?: Maybe<Location>;
  /** The memo line */
  memo?: Maybe<Scalars["String"]>;
  /** The merchant counter-party */
  merchant?: Maybe<Merchant>;
  /** Merchant accuracy */
  merchantAccuracy?: Maybe<Scalars["Boolean"]>;
  /** Merchant category */
  merchantCategory?: Maybe<MerchantCategory>;
  mileageEvidences?: Maybe<Array<Maybe<Asset>>>;
  /** Expense Originator */
  originator?: Maybe<ExpenseOriginator>;
  /** The parent expense of this expense */
  parentExpense?: Maybe<Expense>;
  /** Returns details about the underlying payment rail that was used to incur this expense */
  paymentDetails?: Maybe<ExpensePaymentDetails>;
  /** The payment status reason of the expense */
  paymentStatus?: Maybe<ExpensePaymentStatus>;
  /** Extension field to surface payment tracking details for an expense. */
  paymentTrackingDetails?: Maybe<ExpensePaymentTrackingObject>;
  /** The time when the associated payment is posted */
  postedAt?: Maybe<Scalars["Time"]>;
  /** The time of purchase */
  purchasedAt?: Maybe<Scalars["Time"]>;
  /** Denormalized count of receipts for an expense */
  receiptCount: Scalars["Int"];
  /** Number of associated receipts with the given documentType */
  receiptCountPerDocumentType: Scalars["Int"];
  /** Receipt validation result */
  receiptValidationResult?: Maybe<ReceiptValidationResult>;
  /** The receipts associated with this expense */
  receipts?: Maybe<ReceiptConnection>;
  /**
   * A list of relevant suggestion groups that would apply to unset fields
   * listed in `setFields` for this expense.
   */
  relevantSuggestionGroups: Array<AutomationSuggestionGroup>;
  /** The current active request that is associated with this expense */
  request?: Maybe<ExpenseRequest>;
  /** A history of the requests associated with the expense. */
  requestHistory?: Maybe<ExpenseRequestConnection>;
  /** Returns details about the reviews that were done on this expense */
  reviewDetails?: Maybe<ExpenseReviewDetails>;
  /** The spend limit which this expense accrues to. */
  spendLimit?: Maybe<SpendLimit>;
  /** The entity that this expense should be accounted for */
  spendingLegalEntity?: Maybe<LegalEntity>;
  /** The status of the expense; if it needs to be visible to users, use `displayableStatus` instead */
  status: ExpenseStatus;
  /** When the expense is submitted */
  submittedAt?: Maybe<Scalars["Time"]>;
  /** The tax details for the expense (tax amount and tax code) */
  taxDetails?: Maybe<TaxDetails>;
  /** The booking associated with an expense if there is one. */
  travelBooking?: Maybe<TravelBooking>;
  /** The trip associated with an expense if there is one. */
  travelTrip?: Maybe<TravelTrip>;
  /** The type of the expense */
  type: ExpenseType;
  /** When the expense was last updated */
  updatedAt: Scalars["Time"];
  /** VAT metadata for this expense, including status and the extended field. */
  vat?: Maybe<VatResult>;
  /** The vendor of the expense */
  vendor?: Maybe<VendorDetails>;
  /** The vendor category of the expense */
  vendorCategory?: Maybe<Category>;
  vendorDisplay?: Maybe<VendorDisplay>;
  /** Operation permissions for the viewer on the expense */
  viewerCanApprove?: Maybe<ExpenseOperationPermission>;
  viewerCanCancel?: Maybe<ExpenseOperationPermission>;
  viewerCanCancelPayment?: Maybe<ExpenseOperationPermission>;
  viewerCanConfirmAutoAssignedLimit?: Maybe<ExpenseOperationPermission>;
  viewerCanDelete?: Maybe<ExpenseOperationPermission>;
  viewerCanDeny?: Maybe<ExpenseOperationPermission>;
  viewerCanDispute?: Maybe<ExpenseOperationPermission>;
  viewerCanEdit?: Maybe<ExpenseOperationPermission>;
  viewerCanMakeCopy?: Maybe<ExpenseOperationPermission>;
  viewerCanMarkAsPaid?: Maybe<ExpenseOperationPermission>;
  viewerCanOverrideApprove?: Maybe<ExpenseOperationPermission>;
  viewerCanRepay?: Maybe<ExpenseOperationPermission>;
  viewerCanRequestRepayment?: Maybe<ExpenseOperationPermission>;
  viewerCanResubmit?: Maybe<ExpenseOperationPermission>;
  viewerCanRetryPayment?: Maybe<ExpenseOperationPermission>;
  viewerCanRetryRepayment?: Maybe<ExpenseOperationPermission>;
  viewerCanSplit?: Maybe<ExpenseOperationPermission>;
  viewerCanUnsplit?: Maybe<ExpenseOperationPermission>;
  viewerCanViewOriginalExpense?: Maybe<ExpenseOperationPermission>;
  viewerCanViewRepayment?: Maybe<ExpenseOperationPermission>;
  /** Whether a receipt will be auto-generated by Brex */
  willGenerateReceipt?: Maybe<Scalars["Boolean"]>;
}

/** An Expense stub entity that will be resolved by another DGS. */
export interface ExpenseamountViewsArgs {
  perspectiveBudgetId?: InputMaybe<Scalars["String"]>;
}

/** An Expense stub entity that will be resolved by another DGS. */
export interface ExpenseautomationSuggestionsArgs {
  filter: AutomationSuggestionsExpenseFilterInput;
}

/** An Expense stub entity that will be resolved by another DGS. */
export interface ExpenseavailableLimitsArgs {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  input?: InputMaybe<AvailableLimitsInput>;
}

/** An Expense stub entity that will be resolved by another DGS. */
export interface ExpenseavailableSpendLimitsArgs {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  input?: InputMaybe<AvailableSpendLimitsInput>;
}

/** An Expense stub entity that will be resolved by another DGS. */
export interface ExpenseexpenseLensArgs {
  enablePrecompute?: InputMaybe<Scalars["Boolean"]>;
  facetType?: InputMaybe<FacetType>;
  integrationId: Scalars["ID"];
  omitRuleId?: InputMaybe<Scalars["ID"]>;
  ruleBody?: InputMaybe<Scalars["Json"]>;
  ruleIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
}

/** An Expense stub entity that will be resolved by another DGS. */
export interface ExpenseexportEntryArgs {
  integrationId: Scalars["ID"];
}

/** An Expense stub entity that will be resolved by another DGS. */
export interface ExpenseextendedFieldInstanceArgs {
  id: Scalars["ID"];
}

/** An Expense stub entity that will be resolved by another DGS. */
export interface ExpenseextendedFieldInstancesArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<ExtendedFieldFilterConditionInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

/** An Expense stub entity that will be resolved by another DGS. */
export interface ExpenseextendedFieldValuesArgs {
  filter?: InputMaybe<ExpenseTypeExtendedFieldValueFilterInput>;
}

/** An Expense stub entity that will be resolved by another DGS. */
export interface ExpensefinancialAssetMovementsArgs {
  filter?: InputMaybe<ExpenseFinancialAssetMovementFilterInput>;
  order?: InputMaybe<Array<ExpenseFinancialAssetMovementOrderInput>>;
  page?: InputMaybe<PaginationInput>;
}

/** An Expense stub entity that will be resolved by another DGS. */
export interface ExpensereceiptCountPerDocumentTypeArgs {
  documentType: DocumentType;
}

/** An Expense stub entity that will be resolved by another DGS. */
export interface ExpensereceiptsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

/** An Expense stub entity that will be resolved by another DGS. */
export interface ExpenserelevantSuggestionGroupsArgs {
  setFields: Array<Scalars["String"]>;
}

/** Information about how and when an expense was exported to an accounting system */
export interface ExpenseAccountingExport {
  /** Information about entities involved in the integration */
  entityInfo?: Maybe<IntegrationEntityInfo>;
  /** Information about GL accounts used in the integration */
  glAccountInfo?: Maybe<IntegrationGLAccountInfo>;
  /** Information about the export status */
  statusInfo?: Maybe<ExportStatusInfo>;
}

export interface ExpenseActivity {
  id: Scalars["ID"];
}

export interface ExpenseActivityFilterInput {
  /** ID of the expense for which to return. */
  expenseId?: InputMaybe<Scalars["ID"]>;
}

export interface ExpenseActivityGroup {
  /** Expense to which Expense Activities apply to. */
  expense: Expense;
  /** Expense Activities corresponding to Expense. */
  expenseActivities: Array<ExpenseActivity>;
  /** Whether the user has already seen the Expense Activities in the group. */
  seenStatus?: Maybe<ExpenseActivityGroupSeenStatus>;
  /** The most recent time any of the Expense Activities in the group has been executed. */
  updatedAt: Scalars["LocalDateTime"];
}

/**
 * "
 * ACTIVITY TYPES
 */
export interface ExpenseActivityGroupConnection extends Connection {
  edges: Array<ExpenseActivityGroupEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface ExpenseActivityGroupEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<ExpenseActivityGroup>;
}

export enum ExpenseActivityGroupSeenStatus {
  SEEN = "SEEN",
  UNSEEN = "UNSEEN",
}

export enum ExpenseActivityOverrideStatus {
  DEFAULT = "DEFAULT",
  OVERRIDDEN = "OVERRIDDEN",
}

/** An Expense addendum associated with an expense. */
export interface ExpenseAddendum {
  /** The unique ID of the expense addendum. */
  id: Scalars["ID"];
}

export interface ExpenseAggregateInput {
  /**
   * Required field key to aggregate on, e.g. "total_billing_amount" in  SUM(BILLING_AMOUNT) as total_billing_amount
   * alias is required
   */
  fieldKey: ExpenseFieldKeyInput;
  /** When specified, filter the aggregation, e.g. count(*) filter (where has_memo) */
  filter?: InputMaybe<ExpenseFilterInput>;
  /** Required aggregate function, e.g. SUM */
  function: AggregateFunction;
}

export type ExpenseAssignmentFailureError =
  | ExpenseAssignmentInsufficientLimitError
  | ExpenseAssignmentNoBudgetPeriodError
  | ExpenseAssignmentStatusError
  | ExpenseAssignmentTransactionLimitError;

/** if the relevant period the expense is incurred in does not have enough balance */
export interface ExpenseAssignmentInsufficientLimitError {
  /** Field is non-null if the expense cannot be assigned to the budget due to the budget's ancestor's limit */
  ancestorBudgetId?: Maybe<Scalars["ID"]>;
  budgetName: Scalars["String"];
  isLimitVisible: Scalars["Boolean"];
  overLimitAmount: FinancialAsset;
}

/** if the date the expense is incurred on is before the budget's start date or after the budget's end date */
export interface ExpenseAssignmentNoBudgetPeriodError {
  budgetEndDate?: Maybe<Scalars["Date"]>;
  budgetName: Scalars["String"];
  budgetStartDate: Scalars["Date"];
  expenseDate: Scalars["Date"];
}

/** if the expense cannot be assigned to the budget due to the budget's status */
export interface ExpenseAssignmentStatusError {
  budgetName: Scalars["String"];
  budgetStatus: BudgetStatus;
}

/** if the expense cannot be assigned to the budget due to the budget's transaction limit */
export interface ExpenseAssignmentTransactionLimitError {
  budgetName: Scalars["String"];
  transactionLimit: FinancialAsset;
}

export interface ExpenseAssistantInfo {
  /** The optional expense ID for the related expense */
  expenseId?: InputMaybe<Scalars["ID"]>;
}

export type ExpenseAttendee = InternalExpenseAttendee;

export enum ExpenseAttendeeFlagType {
  GOVERNMENT_OFFICIAL = "GOVERNMENT_OFFICIAL",
  MANAGER = "MANAGER",
}

/** [Airbnb-Demo] Attendee who is flagged as per the policy violation */
export interface ExpenseAttendeesFlag {
  attendeeId: ExpenseAttendeesIdOneOf;
  shareUrl?: Maybe<Scalars["String"]>;
  type: ExpenseAttendeeFlagType;
}

export interface ExpenseAttendeesIdOneOf {
  externalAttendeeId?: Maybe<Scalars["String"]>;
  internalAttendeeCustomerUserId?: Maybe<Scalars["String"]>;
}

export interface ExpenseBoolValue extends ExpenseFieldValue {
  id: Scalars["ID"];
  value?: Maybe<Scalars["Boolean"]>;
}

export interface ExpenseBoolValueInput {
  value?: InputMaybe<Scalars["Boolean"]>;
}

export interface ExpenseCategory {
  /** The expense category identifier */
  id: Scalars["ID"];
  /** The expense category name */
  name: Scalars["String"];
}

/**
 * Represents expense category information specifically formatted for download operations.
 * This structure provides the main expense category along with additional sub-field data
 * organized as downloadable columns for external systems and reporting platforms.
 */
export interface ExpenseCategoryDownloadField {
  /**
   * Additional sub-field categorization details formatted as downloadable columns.
   * Each addendum represents a specific sub-aspect of the expense category with its own
   * column name and value for structured export to external systems.
   */
  addendumValues?: Maybe<Array<ExpenseCategoryDownloadFieldAddendum>>;
  /**
   * The main expense category name (e.g., "Travel", "Office Supplies", "Meals")
   * Derived from the expense_type extended field's primary option value
   */
  categoryName: Scalars["String"];
}

/**
 * Represents a downloadable column derived from expense category sub-fields.
 * These addendum values provide structured data columns for expense category exports,
 * with each addendum containing both the data value and its corresponding column header.
 */
export interface ExpenseCategoryDownloadFieldAddendum {
  /**
   * The column header name used in download/export files.
   * Format: "Expense Category {categoryName} {subFieldName}" or "Expense Category {categoryName}"
   * Example: "Expense Category Travel Meals" or "Expense Category Office Supplies"
   * This provides the column name for structured data exports and reporting.
   */
  columnCompositeName: Scalars["String"];
  /**
   * The actual data value from the expense category sub-field.
   * This is the cell value that will appear in the download/export.
   * Can be null if no specific value is set for this sub-field.
   */
  columnValue: Scalars["String"];
}

export interface ExpenseCategorySuggestion {
  confidence: Scalars["Float"];
  /** The ExtendedFieldOption for the the suggested Expense Category */
  expenseCategory: ExtendedFieldOption;
  /**
   * Value identifier of the Expense Category Option
   * DEPRECATED - use expenseCategory.identifier instead
   */
  identifier: Scalars["String"];
  /**
   * Display name of the Expense Category Option
   * DEPRECATED - use expenseCategory.name instead
   */
  value: Scalars["String"];
}

export interface ExpenseCategorySuggestionConnection extends Connection {
  edges: Array<ExpenseCategorySuggestionEdge>;
  pageInfo: PageInfo;
  predictionId: Scalars["String"];
  totalCount: Scalars["Int"];
}

export interface ExpenseCategorySuggestionEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<ExpenseCategorySuggestion>;
}

export interface ExpenseCategorySuggestionInformation {
  /** Name of the category being suggested. */
  expenseCategoryName: Scalars["String"];
  /** Data entities used to generate the content of the suggestion. */
  expenseSuggestionOriginEntities: Array<ExpenseSuggestionOriginEntity>;
  /** Identifier of the category being suggested. */
  extendedFieldId: Scalars["String"];
}

/** Precomputed Expense Compliance flags */
export enum ExpenseComplianceFlag {
  /** Submitter Compliance Status is COMPLETED */
  DOCUMENTATION_COMPLETED = "DOCUMENTATION_COMPLETED",
  /** Submitter Compliance Status is OVERDUE */
  DOCUMENTATION_OVERDUE = "DOCUMENTATION_OVERDUE",
  /** Expense is missing Approval and Approval is required by Policy */
  MISSING_APPROVAL = "MISSING_APPROVAL",
  /** Expense is missing Memo and Memo is required by Policy */
  MISSING_MEMO = "MISSING_MEMO",
  /** Expense is missing Receipt and Receipt is required by Policy */
  MISSING_RECEIPT = "MISSING_RECEIPT",
}

/** An Expense connection for Expense pagination. */
export interface ExpenseConnection extends Connection {
  /** The expenses in the current page of results. */
  edges: Array<ExpenseEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of expenses matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface ExpenseDateValue extends ExpenseFieldValue {
  id: Scalars["ID"];
  value?: Maybe<Scalars["Date"]>;
}

export interface ExpenseDateValueInput {
  value?: InputMaybe<Scalars["Date"]>;
}

/** The display status of the expense; takes into account payment and disputes. */
export enum ExpenseDisplayStatus {
  /** An approved expense is evaluated to have met the policy requirements. */
  APPROVED = "APPROVED",
  /** The expense got cancelled (from a submitted reimbursement or pending charge). */
  CANCELED = "CANCELED",
  /** Payment for the expense is a chargeback. */
  CHARGEBACK = "CHARGEBACK",
  /** Payment for the expense got declined, applies to card expense only. */
  DECLINED = "DECLINED",
  /** The expense was rejected. */
  DENIED = "DENIED",
  /**
   * The expense is disputed.
   *
   * NOT YET SUPPORTED
   */
  DISPUTED = "DISPUTED",
  /** An expense that has not been submitted yet, applies to reimbursement only. */
  DRAFT = "DRAFT",
  /** Payment for the expense completed. */
  PAID = "PAID",
  /** Payment for the expense failed to go through. */
  PAYMENT_FAILED = "PAYMENT_FAILED",
  /** The expense has open action requests - can include reviews, memos, etc. */
  PENDING_APPROVAL = "PENDING_APPROVAL",
  /** Payment for the expense is processing. */
  PROCESSING = "PROCESSING",
  /** Payment for the expense is a refund. */
  REFUND = "REFUND",
}

export enum ExpenseDisputeStatus {
  DISPUTE_STATUS_CANCELLED = "DISPUTE_STATUS_CANCELLED",
  DISPUTE_STATUS_CLOSED = "DISPUTE_STATUS_CLOSED",
  DISPUTE_STATUS_COMPLETE = "DISPUTE_STATUS_COMPLETE",
  DISPUTE_STATUS_IN_PROGRESS = "DISPUTE_STATUS_IN_PROGRESS",
}

/** A Expense edge for the Expense connection. */
export interface ExpenseEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The expense at this edge. */
  node: Expense;
}

export interface ExpenseEntityFieldKeyInput {
  /**
   * Required when used in Aggregate! Otherwise can leave this empty
   * alias for the caller to identify the aggregate in the response
   * e.g. "expense_count" in "count(*) as expense_count"
   */
  alias?: InputMaybe<Scalars["String"]>;
  /**
   * Field key used in filter, group by, sort or aggregation
   * e.g. "EXPENSE_BILLING_AMOUNT" for "ORDER BY expense.billing_amount DESC"
   * "EXPENSE_MERCHANTS_MERCHANT_ID" for expense's merchant id
   * "ALL" for all expense items used in aggregation "COUNT(*)"
   */
  key: ExpensePrimitiveFieldKeyType;
}

/** Expense Entity filter */
export interface ExpenseEntityFilterConditionOneOf {
  /** The list of filters to AND together */
  and?: InputMaybe<Array<ExpenseEntityFilterInput>>;
  /** The entity filter to apply */
  filterCondition?: InputMaybe<ExpensePrimitiveFieldMatcherInput>;
  /** The list of filters to OR together */
  or?: InputMaybe<Array<ExpenseEntityFilterInput>>;
}

/**
 * The filter input for the universal query API. The filter can be recursively defined to optionally chain nested
 * ANDs/ORs together.
 */
export interface ExpenseEntityFilterInput {
  /** The filters to apply when querying for an entity */
  filter: ExpenseEntityFilterConditionOneOf;
  /** Specify negate to optionally "NOT" the query filter */
  negate?: InputMaybe<Scalars["Boolean"]>;
}

export enum ExpenseEntityReassignmentEligibility {
  CHILD_EXPENSE = "CHILD_EXPENSE",
  ELIGIBLE = "ELIGIBLE",
  EXPENSE_READY_FOR_EXPORT_OR_EXPORTED = "EXPENSE_READY_FOR_EXPORT_OR_EXPORTED",
  FEATURE_FLAG_NOT_ENABLED = "FEATURE_FLAG_NOT_ENABLED",
  NOT_A_CARD_EXPENSE = "NOT_A_CARD_EXPENSE",
  PAYMENT_NOT_PROCESSING = "PAYMENT_NOT_PROCESSING",
  RELATED_EXPENSE_CANT_BE_REASSIGNED = "RELATED_EXPENSE_CANT_BE_REASSIGNED",
  USER_NOT_AUTHORIZED = "USER_NOT_AUTHORIZED",
}

export interface ExpenseEntitySortInput {
  direction: OrderByDirection;
  /** Required sort key, e.g  PURCHASED_AT */
  fieldKey: ExpenseEntityFieldKeyInput;
}

export interface ExpenseEnumValue extends ExpenseFieldValue {
  id: Scalars["ID"];
  value?: Maybe<Scalars["String"]>;
}

export interface ExpenseEnumValueInput {
  value?: InputMaybe<Scalars["String"]>;
}

export enum ExpenseExportColumn {
  AMOUNT = "AMOUNT",
  BILLED_ENTITY = "BILLED_ENTITY",
  BOOKING_ID = "BOOKING_ID",
  BUDGET_ID = "BUDGET_ID",
  BUDGET_NAME = "BUDGET_NAME",
  CARD_LAST4 = "CARD_LAST4",
  CARD_TRANSACTION_REFERENCE_ID = "CARD_TRANSACTION_REFERENCE_ID",
  COMPLIANCE_STATUS = "COMPLIANCE_STATUS",
  COST_CENTER = "COST_CENTER",
  COUNTRY_OF_EXPENSE = "COUNTRY_OF_EXPENSE",
  CREDIT_LINE_CATEGORY_FULLY_QUALIFIED_NAME = "CREDIT_LINE_CATEGORY_FULLY_QUALIFIED_NAME",
  CREDIT_LINE_CATEGORY_NAME = "CREDIT_LINE_CATEGORY_NAME",
  CURRENCY = "CURRENCY",
  DATE_ASSIGNED_TO_ME = "DATE_ASSIGNED_TO_ME",
  DEADLINE = "DEADLINE",
  DEBIT_LINE_CATEGORY_FULLY_QUALIFIED_NAME = "DEBIT_LINE_CATEGORY_FULLY_QUALIFIED_NAME",
  DEBIT_LINE_CATEGORY_NAME = "DEBIT_LINE_CATEGORY_NAME",
  DEPARTMENT = "DEPARTMENT",
  EMPLOYEE_REPAYMENT_INITIATED_BY = "EMPLOYEE_REPAYMENT_INITIATED_BY",
  EMPLOYEE_REPAYMENT_INITIATION_DATE = "EMPLOYEE_REPAYMENT_INITIATION_DATE",
  ERP_POSTING_DATE = "ERP_POSTING_DATE",
  EXPENSE_CATEGORY = "EXPENSE_CATEGORY",
  EXPENSE_CATEGORY_ADDENDUMS = "EXPENSE_CATEGORY_ADDENDUMS",
  EXPENSE_ID = "EXPENSE_ID",
  EXPENSE_LOCATION = "EXPENSE_LOCATION",
  EXPENSE_STATUS = "EXPENSE_STATUS",
  EXPENSE_TYPE = "EXPENSE_TYPE",
  EXPENSE_URL = "EXPENSE_URL",
  EXPORTED_AS = "EXPORTED_AS",
  EXPORTED_DATETIME = "EXPORTED_DATETIME",
  EXTERNAL_ATTENDEES = "EXTERNAL_ATTENDEES",
  FINAL_APPROVAL_DATETIME = "FINAL_APPROVAL_DATETIME",
  FINAL_APPROVER = "FINAL_APPROVER",
  FINAL_COPILOT_APPROVER = "FINAL_COPILOT_APPROVER",
  FLAGGED_EXPENSES = "FLAGGED_EXPENSES",
  FLAGGED_EXPENSE_REASON = "FLAGGED_EXPENSE_REASON",
  INSERTED_AT = "INSERTED_AT",
  INTEGRATION_BILLING_ENTITY_NAME = "INTEGRATION_BILLING_ENTITY_NAME",
  INTEGRATION_EXTERNAL_ID = "INTEGRATION_EXTERNAL_ID",
  INTEGRATION_SPENDING_ENTITY_NAME = "INTEGRATION_SPENDING_ENTITY_NAME",
  INTERNAL_ATTENDEES = "INTERNAL_ATTENDEES",
  JOB_TITLE = "JOB_TITLE",
  MEMO = "MEMO",
  MERCHANT_CATEGORY = "MERCHANT_CATEGORY",
  MERCHANT_NAME = "MERCHANT_NAME",
  NEXT_APPROVER = "NEXT_APPROVER",
  ORIGINAL_AMOUNT = "ORIGINAL_AMOUNT",
  ORIGINAL_CURRENCY = "ORIGINAL_CURRENCY",
  ORIGINAL_EXPENSE_FOR_REPAYMENT_ID = "ORIGINAL_EXPENSE_FOR_REPAYMENT_ID",
  ORIGINAL_EXPENSE_FOR_REPAYMENT_URL = "ORIGINAL_EXPENSE_FOR_REPAYMENT_URL",
  PARENT_ID = "PARENT_ID",
  PARENT_SPEND_LIMIT = "PARENT_SPEND_LIMIT",
  PAYMENT_DATE = "PAYMENT_DATE",
  PAYMENT_STATUS = "PAYMENT_STATUS",
  POLICY = "POLICY",
  POSTED_DATE = "POSTED_DATE",
  PREVIOUSLY_ACCRUED = "PREVIOUSLY_ACCRUED",
  PURCHASED_AMOUNT = "PURCHASED_AMOUNT",
  PURCHASED_CURRENCY = "PURCHASED_CURRENCY",
  RECEIPT_CHANNEL = "RECEIPT_CHANNEL",
  RECEIPT_URL = "RECEIPT_URL",
  REIMBURSEMENT_PAID_ON = "REIMBURSEMENT_PAID_ON",
  REVIEW_ASSIGNED_DATETIME = "REVIEW_ASSIGNED_DATETIME",
  SPENDER_EMAIL = "SPENDER_EMAIL",
  SPENDER_LOCATION = "SPENDER_LOCATION",
  SPENDING_ENTITY = "SPENDING_ENTITY",
  STATEMENT_DESCRIPTOR = "STATEMENT_DESCRIPTOR",
  SUBMITTED_ON = "SUBMITTED_ON",
  SWIPE_TIME = "SWIPE_TIME",
  TAX_AMOUNT = "TAX_AMOUNT",
  TAX_CODE = "TAX_CODE",
  TRANSACTION_DATE = "TRANSACTION_DATE",
  TRIP_ID = "TRIP_ID",
  TRIP_NAME = "TRIP_NAME",
  USD_EQUIVALENT_AMOUNT = "USD_EQUIVALENT_AMOUNT",
  USER = "USER",
}

/**  We use a oneOf type to allow for both native and custom columns, to be passed in, preserving the same column ordering that the user configures in data grid */
export interface ExpenseExportColumnOneOf {
  /**  custom columns are extended fields that are created by the customer */
  customerCustomColum?: InputMaybe<ExpenseExportCustomFieldColumn>;
  /**  native columns are columns that are either part of the expense primitive, or that are supported by brex-created extended fields */
  nativeColumn?: InputMaybe<ExpenseExportColumn>;
}

export interface ExpenseExportCustomFieldColumn {
  id: Scalars["ID"];
  name: Scalars["String"];
}

/**
 * Subset of ExtendedField from extensible platform DGS.
 * Only the matching option will be populated and only if the
 * option can contain subfields.
 */
export interface ExpenseExtendedField {
  fieldType?: Maybe<ExpenseExtendedFieldType>;
  group?: Maybe<ExpenseExtendedFieldGroup>;
  id: Scalars["ID"];
  key?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  options?: Maybe<Array<Maybe<ExpenseExtendedFieldOption>>>;
  status?: Maybe<ExpenseExtendedFieldStatus>;
  tags?: Maybe<Array<Maybe<ExpenseExtendedFieldTag>>>;
}

export enum ExpenseExtendedFieldGroup {
  ACCOUNTING = "ACCOUNTING",
  ADDENDUM = "ADDENDUM",
  EMPLOYEE = "EMPLOYEE",
  EXPENSE_CATEGORY = "EXPENSE_CATEGORY",
  HRIS = "HRIS",
  INTEGRATION = "INTEGRATION",
  PARTNER = "PARTNER",
  PER_DIEM_LOCATION = "PER_DIEM_LOCATION",
  VAT = "VAT",
  VAT_ADDENDUM = "VAT_ADDENDUM",
}

/** The Expense tenant specific fields for extended field instances */
export interface ExpenseExtendedFieldInstanceExtension
  extends ExtendedFieldInstanceExtension,
    Node {
  /**  This should be the same ID as the Field Instance */
  id: Scalars["ID"];
}

export interface ExpenseExtendedFieldOption {
  id: Scalars["ID"];
  identifier?: Maybe<Scalars["String"]>;
  subFieldIds?: Maybe<Array<Scalars["ID"]>>;
  value?: Maybe<Scalars["String"]>;
}

export enum ExpenseExtendedFieldStatus {
  ACTIVE = "ACTIVE",
  DISABLED = "DISABLED",
}

export interface ExpenseExtendedFieldTag {
  key?: Maybe<Scalars["String"]>;
  value?: Maybe<Scalars["String"]>;
}

export enum ExpenseExtendedFieldType {
  BOOL = "BOOL",
  DATE = "DATE",
  DECIMAL = "DECIMAL",
  ENUM = "ENUM",
  FINANCIAL_ASSET = "FINANCIAL_ASSET",
  IDENTIFIER = "IDENTIFIER",
  STRING = "STRING",
}

export interface ExpenseExtendedFieldValue {
  editStatus?: Maybe<ExtendedFieldValueEditStatus>;
  /** @deprecated Use extendedFieldEntity instead */
  extendedField?: Maybe<ExpenseExtendedField>;
  extendedFieldEntity?: Maybe<ExtendedField>;
  extensibleWorkflowMetadata?: Maybe<ExtensibleWorkflowMetadata>;
  id?: Maybe<Scalars["ID"]>;
  isDeleted?: Maybe<Scalars["Boolean"]>;
  isExpenseCategoriesPrefilled?: Maybe<Scalars["Boolean"]>;
  key?: Maybe<Scalars["String"]>;
  originator?: Maybe<ExtendedFieldValueOriginator>;
  values: Array<ExpenseFieldValue>;
}

export interface ExpenseExtendedFieldValueInput {
  /**
   * Metadata for the EFV related to Extensible Workflow Rules.
   * This should be passed only when the EFV is set by a Extensible Workflow Rule (e.g. when a user manually resolves an
   * existing conflict, the ruleId should be maintained but hasConflict should be set to false)
   */
  extensibleWorkflowMetadata?: InputMaybe<ExtensibleWorkflowMetadataInput>;
  isDeleted?: InputMaybe<Scalars["Boolean"]>;
  key: Scalars["String"];
  originator?: InputMaybe<ExtendedFieldValueOriginator>;
  values?: InputMaybe<Array<InputMaybe<ExpenseFieldValueInputUnion>>>;
}

/** Type of extended field value, currently only supports IDENTIFIER */
export enum ExpenseExtendedFieldValueType {
  /** Identifier id type */
  IDENTIFIER = "IDENTIFIER",
}

export interface ExpenseExtendedFieldValuesFilterInput {
  /** Extended field key */
  key: Scalars["String"];
  /** Type of extended field value */
  type: ExpenseExtendedFieldValueType;
  /** Matches IN values for extended field key */
  values: Array<Scalars["String"]>;
}

export interface ExpenseExtension extends ExpenseFieldValue {
  extension?: Maybe<ExpenseExtensionType>;
  id: Scalars["ID"];
}

export interface ExpenseExtensionType {
  id: Scalars["ID"];
}

/** The enum representing a particular expense extension type. Used to filter expenses by extension type. */
export enum ExpenseExtensionTypeEnum {
  BILL_PAY = "BILL_PAY",
  BUDGET_ASSIGNMENT = "BUDGET_ASSIGNMENT",
  CARD_SPEND_WORKFLOW = "CARD_SPEND_WORKFLOW",
  TRACKING = "TRACKING",
  TRAVEL = "TRAVEL",
}

/**
 * Acts as an input union depending on which field is not NULL
 * One field is required to be set. For now, it's only Bill but we can include other types of extensions such as reimbursements.
 */
export interface ExpenseExtensionTypeInputUnion {
  billInput?: InputMaybe<BillPayExtensionInput>;
}

export interface ExpenseField {
  key?: Maybe<ExpenseFieldKey>;
  /**
   * Optional name, populated when used returned ExpenseGroup's groupFields
   * e.g for key = MERCHANTS_MERCHANT_ID, name can be "Doordash"
   */
  name?: Maybe<Scalars["String"]>;
  value?: Maybe<ExpenseQueryValue>;
}

/** ExpenseFieldKey for the output */
export interface ExpenseFieldKey {
  /**
   * Required when used in Aggregate! Otherwise can leave this empty
   * alias for the caller to identify the aggregate in the response
   * e.g. "expense_count" in "count(*) as expense_count"
   */
  alias?: Maybe<Scalars["String"]>;
  key: ExpenseFieldKeyType;
}

export interface ExpenseFieldKeyInput {
  /**
   * Required when used in Aggregate! Otherwise can leave this empty
   * alias for the caller to identify the aggregate in the response
   * e.g. "expense_count" in "count(*) as expense_count"
   */
  alias?: InputMaybe<Scalars["String"]>;
  /**
   * Field key used in filter, group by, sort or aggregation
   * e.g. "EXPENSE_BILLING_AMOUNT" for "ORDER BY expense.billing_amount DESC"
   * "EXPENSE_MERCHANTS_MERCHANT_ID" for expense's merchant id
   * "ALL" for all expense items used in aggregation "COUNT(*)"
   */
  key: ExpenseFieldKeyType;
}

/**
 * Available fields.
 * Also contains enums for request, request action, merchant, merchant_category
 * Doc: https://brexhq.atlassian.net/wiki/spaces/SPEND/pages/1970438145/Universal+Queries+Service
 */
export enum ExpenseFieldKeyType {
  ALL = "ALL",
  BILLING_EXPENSE_EXTENSION_ENTITY_BILLING_CONFIGURATION_ID = "BILLING_EXPENSE_EXTENSION_ENTITY_BILLING_CONFIGURATION_ID",
  BUDGET_NAME = "BUDGET_NAME",
  DISPUTE_STATUS = "DISPUTE_STATUS",
  EXPENSE_BILLING_AMOUNT = "EXPENSE_BILLING_AMOUNT",
  EXPENSE_BUDGETS_BUDGET_ID = "EXPENSE_BUDGETS_BUDGET_ID",
  EXPENSE_BUDGET_AMOUNT = "EXPENSE_BUDGET_AMOUNT",
  /** @deprecated use EXPENSE_VENDORS_CATEGORY_ID instead */
  EXPENSE_CATEGORY_NAME = "EXPENSE_CATEGORY_NAME",
  EXPENSE_COST_CENTER_ID = "EXPENSE_COST_CENTER_ID",
  EXPENSE_CUSTOMER_ACCOUNT_ID = "EXPENSE_CUSTOMER_ACCOUNT_ID",
  EXPENSE_CUSTOMER_DEPARTMENT_ID = "EXPENSE_CUSTOMER_DEPARTMENT_ID",
  EXPENSE_CUSTOMER_INVARIANT_AMOUNT = "EXPENSE_CUSTOMER_INVARIANT_AMOUNT",
  EXPENSE_CUSTOMER_LOCATION_ID = "EXPENSE_CUSTOMER_LOCATION_ID",
  EXPENSE_CUSTOMER_USER_ID = "EXPENSE_CUSTOMER_USER_ID",
  /** # EXPENSE_CONTAINS_GOVERNMENT_OFFICIAL TODO pending decision */
  EXPENSE_ENTITIES_FUNDING_ENTITY_ID = "EXPENSE_ENTITIES_FUNDING_ENTITY_ID",
  /**  Risk tier */
  EXPENSE_EXPENSE_RISK_TIER = "EXPENSE_EXPENSE_RISK_TIER",
  EXPENSE_EXPENSE_STATUS = "EXPENSE_EXPENSE_STATUS",
  EXPENSE_EXPENSE_TYPE = "EXPENSE_EXPENSE_TYPE",
  EXPENSE_ID = "EXPENSE_ID",
  EXPENSE_INSERTED_AT = "EXPENSE_INSERTED_AT",
  EXPENSE_LEGAL_ENTITY_ID = "EXPENSE_LEGAL_ENTITY_ID",
  EXPENSE_MEMO = "EXPENSE_MEMO",
  /** @deprecated use EXPENSE_VENDORS_CATEGORY_NAME instead */
  EXPENSE_MERCHANTS_CATEGORY_ID = "EXPENSE_MERCHANTS_CATEGORY_ID",
  /** @deprecated use EXPENSE_VENDORS_VENDOR_ID instead */
  EXPENSE_MERCHANTS_MERCHANT_ID = "EXPENSE_MERCHANTS_MERCHANT_ID",
  EXPENSE_ORIGINAL_AMOUNT = "EXPENSE_ORIGINAL_AMOUNT",
  EXPENSE_PARENT_ID = "EXPENSE_PARENT_ID",
  EXPENSE_PAYMENTS_PAYMENT_ID = "EXPENSE_PAYMENTS_PAYMENT_ID",
  EXPENSE_PAYMENTS_PAYMENT_POST_ID = "EXPENSE_PAYMENTS_PAYMENT_POST_ID",
  EXPENSE_PAYMENT_STATUS = "EXPENSE_PAYMENT_STATUS",
  EXPENSE_POSTED_AT = "EXPENSE_POSTED_AT",
  EXPENSE_PURCHASED_AMOUNT = "EXPENSE_PURCHASED_AMOUNT",
  EXPENSE_PURCHASED_AT = "EXPENSE_PURCHASED_AT",
  EXPENSE_PURCHASED_AT_DAY = "EXPENSE_PURCHASED_AT_DAY",
  EXPENSE_PURCHASED_AT_MONTH = "EXPENSE_PURCHASED_AT_MONTH",
  EXPENSE_PURCHASED_AT_WEEK = "EXPENSE_PURCHASED_AT_WEEK",
  EXPENSE_RECEIPT_COUNT = "EXPENSE_RECEIPT_COUNT",
  EXPENSE_REQUESTS_REQUEST_ID = "EXPENSE_REQUESTS_REQUEST_ID",
  EXPENSE_UPDATED_AT = "EXPENSE_UPDATED_AT",
  EXPENSE_USER_CATEGORY_ID = "EXPENSE_USER_CATEGORY_ID",
  EXPENSE_VENDORS_CATEGORY_ID = "EXPENSE_VENDORS_CATEGORY_ID",
  EXPENSE_VENDORS_CATEGORY_NAME = "EXPENSE_VENDORS_CATEGORY_NAME",
  EXPENSE_VENDORS_VENDOR_ID = "EXPENSE_VENDORS_VENDOR_ID",
  EXPENSE_VENDORS_VENDOR_NAME = "EXPENSE_VENDORS_VENDOR_NAME",
  /** @deprecated use EXPENSE_CATEGORY_NAME instead */
  MERCHANT_CATEGORY_NAME = "MERCHANT_CATEGORY_NAME",
  /** @deprecated use EXPENSE_VENDORS_VENDOR_NAME instead */
  MERCHANT_NAME = "MERCHANT_NAME",
  REQUEST_ACTION_ACTION_STATUS = "REQUEST_ACTION_ACTION_STATUS",
  REQUEST_ACTION_ACTION_TYPE = "REQUEST_ACTION_ACTION_TYPE",
  REQUEST_ACTION_OWNER_OWNER_USER_ID = "REQUEST_ACTION_OWNER_OWNER_USER_ID",
  REQUEST_ACTION_UPDATED_AT = "REQUEST_ACTION_UPDATED_AT",
  REQUEST_COMPLIANCE_STATUS = "REQUEST_COMPLIANCE_STATUS",
  REQUEST_CREATED_AT = "REQUEST_CREATED_AT",
  REQUEST_DERIVED_COMPLIANCE_STATUS = "REQUEST_DERIVED_COMPLIANCE_STATUS",
  REQUEST_REVIEWER_COMPLIANCE_STATUS = "REQUEST_REVIEWER_COMPLIANCE_STATUS",
  TRAVEL_EXPENSE_EXTENSION_TRIPS_BOOKING_ID = "TRAVEL_EXPENSE_EXTENSION_TRIPS_BOOKING_ID",
  TRAVEL_EXPENSE_EXTENSION_TRIPS_TRIP_ID = "TRAVEL_EXPENSE_EXTENSION_TRIPS_TRIP_ID",
  USER_FIRST_NAME = "USER_FIRST_NAME",
  USER_LAST_NAME = "USER_LAST_NAME",
}

export interface ExpenseFieldKeyTypeWrapper {
  key: ExpensePrimitiveFieldKeyType;
}

export interface ExpenseFieldValue {
  id: Scalars["ID"];
}

/**
 * Acts as an input union depending on which field is not NULL
 * One field is required to be set
 */
export interface ExpenseFieldValueInputUnion {
  expenseBoolValueInput?: InputMaybe<ExpenseBoolValueInput>;
  expenseDateValueInput?: InputMaybe<ExpenseDateValueInput>;
  expenseEnumValueInput?: InputMaybe<ExpenseEnumValueInput>;
  expenseFinancialAssetValueInput?: InputMaybe<ExpenseFinancialAssetValueInput>;
  expenseIdentifierToStringValueInput?: InputMaybe<ExpenseIdentifierToStringValueInput>;
  expenseNumberValueInput?: InputMaybe<ExpenseNumberValueInput>;
  expenseStringValueInput?: InputMaybe<ExpenseStringValueInput>;
}

/** Filters available to control which expenses get returned. */
export interface ExpenseFilterInput {
  /** Range query filter for amount. */
  amountBetween?: InputMaybe<FinancialAssetRangeInput>;
  /** Expense approved date */
  approvedBetween?: InputMaybe<TimeIntervalInput>;
  /** Matches IN reviewer user IDs. */
  approverUserIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Review assigned date */
  assignedBetween?: InputMaybe<TimeIntervalInput>;
  /** Whether the expense has an "attendees" addendum containing a government official */
  attendeesContainGovernmentOfficial?: InputMaybe<Scalars["Boolean"]>;
  /** Match IN specific billing group id */
  billingGroupIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Match IN specific budgets */
  budgetIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Matches IN specific budget template IDs */
  budgetTemplateIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Match IN specific Card IDs */
  cardIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Filter by the expense compliance status */
  complianceStatus?: InputMaybe<ComplianceStatusFilterInput>;
  /** Matches IN submitter compliance statuses */
  complianceStatuses?: InputMaybe<Array<ComplianceStatusFilterInput>>;
  /** Matches IN compliance types */
  complianceTypes?: InputMaybe<Array<ComplianceTypeFilterInput>>;
  /** Matches IN specific cost center ids */
  costCenterIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Match IN specific users */
  customerUserIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Match IN specific departments */
  departmentIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Matches IN derived compliance statuses, which are derived from submitter and reviewer compliance */
  derivedComplianceStatuses?: InputMaybe<
    Array<DerivedComplianceStatusFilterInput>
  >;
  /** Matches expenses that belong to the select budgets or their direct or indirect descendants (children, grandchildren and so on) */
  descendantFromBudgetIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Match IN specific display statuses, match ALL when no filter is provided */
  displayStatus?: InputMaybe<Array<ExpenseDisplayStatus>>;
  /** Dispute Status */
  expenseDisputeStatuses?: InputMaybe<Array<ExpenseDisputeStatus>>;
  /** Match IN specific expenses, match ALL when no filter is provided */
  expenseIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Matches IN specific budget expense policy IDs */
  expensePolicyIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Matches IN extended field values by key */
  expensePolicyViolationReasons?: InputMaybe<
    Array<ExpensePolicyViolationReason>
  >;
  /** Risk tiers */
  expenseRiskTiers?: InputMaybe<Array<ExpenseRiskTier>>;
  /**
   * Filter by extended field _values_, despite the naming
   * NOTE: only use this if the extended field value is expected to be unique across all extended fields, otherwise it
   * will return matching values from other extended fields
   */
  extendedFieldIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Matches IN extended field values by key */
  extendedFieldValues?: InputMaybe<
    Array<ExpenseExtendedFieldValuesFilterInput>
  >;
  /** Match IN specific funding entity ids */
  fundingEntityIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Whether the expense has a memo */
  hasMemo?: InputMaybe<Scalars["Boolean"]>;
  /** Whether the expense has at least one attached receipt */
  hasReceipt?: InputMaybe<Scalars["Boolean"]>;
  /**
   * Includes the expense if it is a draft reimbursement submitted for a global currency.
   * These reimbursements are filtered out by default to protect legacy mobile clients from
   * showing draft reimbursements which cannot be submitted on the mobile app.
   * See: https://docs.google.com/document/d/1HCOHzIWUzP6W7f5hOxuYezSIKvegqwnoKDfE78_Hi9A
   */
  includeGlobalDraftReimbursements?: InputMaybe<Scalars["Boolean"]>;
  /** Filter whose expenses to show. */
  incurredBy?: InputMaybe<IncurredByInput>;
  /**
   * Filter by the Project Marvel compliance status.
   *
   * Do not use. Subject to change and removal/deprecation.
   * TODO(SPC-1496): Remove this after Project Marvel is completed
   */
  isMarvelNonCompliant?: InputMaybe<Scalars["Boolean"]>;
  /** Match IN specific merchant categories */
  merchantCategoryIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Match IN specific merchants */
  merchantIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Match IN specific parent expense ids */
  parentExpenseIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Range query filter for paymentPostedAt */
  paymentPostedBetween?: InputMaybe<TimeIntervalInput>;
  /** Match IN specific payment statuses, match ALL when no filter is provided */
  paymentStatus?: InputMaybe<Array<ExpensePaymentStatusType>>;
  /** Matches if the expense is currently pending approval on yourself or others. */
  pendingApproval?: InputMaybe<PendingApprovalFilterInput>;
  /** Matches IN expenses currently pending approval on yourself and/or others. */
  pendingApprovals?: InputMaybe<Array<PendingApprovalFilterInput>>;
  /** Match IN specific user IDs for expenses pending approval from those users. */
  pendingApprovalsFromUserIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Matches IN open compliance request types */
  pendingRequestActionTypes?: InputMaybe<Array<ExpenseRequestActionType>>;
  /** Range query filter for purchaseAt */
  purchasedBetween?: InputMaybe<TimeIntervalInput>;
  /** Whether a reimbursement expense was paid outside of Brex or incurred on money movement */
  reimbursementPaymentMethod?: InputMaybe<ReimbursementPaymentMethod>;
  /** Matches IN reviewer compliance statuses */
  reviewerComplianceStatuses?: InputMaybe<Array<ComplianceStatusFilterInput>>;
  /** Search expenses across expense properties (owner name, memo, amount and etc). */
  searchQuery?: InputMaybe<Scalars["String"]>;
  /** Match IN specific spending entity ids */
  spendingEntityIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Match IN specific statuses, match ALL when no filter is provided */
  status?: InputMaybe<Array<ExpenseStatus>>;
  /** Expense submission date */
  submittedBetween?: InputMaybe<TimeIntervalInput>;
  /** Matches IN tracking statuses for tracked expenses, passing a null or an empty list value will return all expenses */
  trackingStatuses?: InputMaybe<Array<TrackingStatus>>;
  /** Whether the expense originates from a specific Travel provider (e.g. Brex Travel) */
  travelProvider?: InputMaybe<TravelProvider>;
  /** Match IN specific trip id */
  tripIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Match IN specific types, match ALL when no filter is provided */
  types?: InputMaybe<Array<ExpenseType>>;
  /** Filter by user category ids */
  userCategoryExtendedField?: InputMaybe<UserCategoryExtendedFieldFilterInput>;
  /** Filter by user category ids */
  userCategoryIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** User status */
  userStatus?: InputMaybe<Array<UserStatusFilterInput>>;
  /** Match IN specific vendor categories */
  vendorCategoryIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Match IN specific vendors */
  vendorIds?: InputMaybe<Array<Scalars["ID"]>>;
}

/** Filters available to control which financial asset movements get returned. */
export interface ExpenseFinancialAssetMovementFilterInput {
  /** Match IN specific statuses, match ALL when no filter is provided */
  status?: InputMaybe<Array<FinancialAssetMovementStatus>>;
}

/** Determines the order that the expense's financial asset movements will be returned. */
export interface ExpenseFinancialAssetMovementOrderInput {
  /** Required sort key, e.g  INITIATED_AT */
  field: SortableExpenseFinancialAssetMovementField;
  /** Required direction, i.e. ASCENDING or DESCENDING */
  order: OrderByDirection;
}

export interface ExpenseFinancialAssetValue extends ExpenseFieldValue {
  id: Scalars["ID"];
  value?: Maybe<FinancialAsset>;
}

export interface ExpenseFinancialAssetValueInput {
  value?: InputMaybe<FinancialAssetInput>;
}

export interface ExpenseGroup {
  aggregateFields?: Maybe<Array<ExpenseField>>;
  expenses?: Maybe<Array<Expense>>;
  groupFields: Array<ExpenseField>;
  /**
   * pageInfo for the primitives. Use this to fetch next page primitives in a new query with no group by clause
   * Example:
   * 1. Make a query to group by merchant
   * 2. get back DoorDash group with cursor 1
   * 3. If caller wants to load more, should use the same filter, primitives sort from the query in step and, additional filter of the group fields in the response of query 1
   * merchant ID = DoorDash ID filter, along with the cursor
   */
  pageInfo: PageInfo;
}

/** Query expense input */
export interface ExpenseGroupByInput {
  /** Optional Aggregate on all items within the group regardless of the group items limit */
  aggregates?: InputMaybe<Array<ExpenseAggregateInput>>;
  /** Required FieldKeys used in group by e.g. "MERCHANTS_MERCHANT_ID, BUDGETS_BUDGET_ID" in "GROUP BY expense's merchant id, expense's budget id" */
  groupByKeys: Array<ExpenseFieldKeyInput>;
  /**
   * Optional. Max number of items returned in each group
   * Default value = 0 to not load any items
   */
  groupItemsLimit?: InputMaybe<Scalars["Int"]>;
  /**
   * Optional Sort for the groups.
   * Default sort is ORDER BY group_by_keys's name ASC
   */
  groupSorts?: InputMaybe<Array<ExpenseSortInput>>;
}

/** An ExpenseGroup connection for ExpenseGroup pagination. */
export interface ExpenseGroupConnection extends Connection {
  /** The expenses groups in the current page of results. */
  edges: Array<ExpenseGroupEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of expenses matching the filter criteria specified for this connection. */
  totalCount: Scalars["Int"];
}

/** A ExpenseGroup edge for the ExpenseGroup connection. */
export interface ExpenseGroupEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The expense group at this edge. */
  node: ExpenseGroupV2;
}

export interface ExpenseGroupField {
  key: ExpensePrimitiveFieldKeyType;
  /**
   * Optional name, populated when used while returning groupFields
   * e.g for key = MERCHANTS_MERCHANT_ID, name can be "Doordash"
   * not all fields that can be grouped by are currently supported
   */
  name?: Maybe<Scalars["String"]>;
  /**
   * The grouped by value, e.g. for key MERCHANTS_MERCHANT_ID, value can be the merchant ID
   * this field is nullable because all entries that don't have an associated merchant will be grouped together
   * in a group row where this value is null
   */
  value?: Maybe<EntityQueryValue>;
}

export interface ExpenseGroupV2 {
  /**
   * A connection to the expenses in the group.
   * ExpenseConnection is being used here purely for future proofing, we do not currently support pagination inside groups,
   * so all of group the expenses will always be returned as a single page in here.
   */
  expenses: ExpenseConnection;
  /**
   * Contains the data that was grouped upon.
   * e.g. if grouping by expense budget, this will contain the budget ID for the expenses in this group.
   */
  groupFields: Array<ExpenseGroupField>;
  /**
   * The unique ID of the expense group -- will vary depending on which field is being grouped upon.
   * e.g, if grouped by vendor, this will be a custom prefix + the vendor ID, like "expense_groupedby_vendor_vendor_12345"
   */
  id: Scalars["ID"];
}

/**  BEGIN EXPENSE GROUPING RELATED OBJECTS */
export interface ExpenseGrouping {
  name?: Maybe<Scalars["String"]>;
}

export interface ExpenseGroupingConnection extends Connection {
  /** The trips in the current page of results. */
  edges: Array<ExpenseGroupingEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of trips matching the filter criteria specified for this connection. */
  totalCount: Scalars["Int"];
}

export interface ExpenseGroupingEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The trip at this edge. */
  node: ExpenseGrouping;
}

/** The interface for standard trip pagination input. */
export interface ExpenseGroupingFilterInput {
  /** trip IDs */
  tripIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Filter for trips by trip name (fuzzy, case insensitive). */
  tripName?: InputMaybe<Scalars["String"]>;
}

/** Defines how a trip can be sorted. */
export enum ExpenseGroupingOrderField {
  INSERTED_AT = "INSERTED_AT",
  START_DATE = "START_DATE",
  START_TIMESTAMP = "START_TIMESTAMP",
}

export interface ExpenseGroupingOrderInput {
  direction: OrderByDirection;
  field: ExpenseGroupingOrderField;
}

export interface ExpenseIdentifierToStringValue extends ExpenseFieldValue {
  displayName?: Maybe<Scalars["String"]>;
  fieldOption?: Maybe<ExtendedFieldOption>;
  id: Scalars["ID"];
  identifier?: Maybe<Scalars["String"]>;
  subFieldIds?: Maybe<Array<Scalars["ID"]>>;
}

export interface ExpenseIdentifierToStringValueInput {
  displayName?: InputMaybe<Scalars["String"]>;
  identifier?: InputMaybe<Scalars["String"]>;
}

export interface ExpenseInboxTaskEntityDetails extends InboxTaskEntityDetails {
  /** Base64 encoded expense ID. */
  encodedEntityId: Scalars["String"];
  /** The expense ID. */
  entityId: Scalars["String"];
  expense?: Maybe<Expense>;
  /** Optional subtype of expense (e.g. missing memo and/or receipt for documentation EXPENSE_MISSING_INFORMATION) */
  expenseSubtype?: Maybe<InboxExpenseEntitySubtype>;
  /** Type of expense (e.g. reimbursement, card) */
  expenseType: InboxExpenseEntityType;
  /**
   * DEPRECATED: Base64 encoded expense ID.
   * @deprecated No longer supported
   */
  id: Scalars["String"];
}

export interface ExpenseInput {
  /** The attendees addendum to add to this expense. */
  addedAttendeesAddendum?: InputMaybe<AttendeesAddendumInput>;
  /** The mileage addendums to add to this expense. */
  addedMileageAddendums?: InputMaybe<Array<MileageAddendumInput>>;
  /** The receipt affidavit addendum to add to this expense */
  addedReceiptAffidavitAddendum?: InputMaybe<ReceiptAffidavitAddendumInput>;
  /** The receipt assets to which the expense will create a receipt for and be linked to */
  addedReceiptAssetIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Amount of the expense; may be negative */
  amount?: InputMaybe<FinancialAssetInput>;
  /** If expense type is BILLPAY, input for bill pay extended field values */
  billPayExtension?: InputMaybe<BillPayExtensionInput>;
  /** Amount of the expense in billing currency; may be negative */
  billingAmount?: InputMaybe<FinancialAssetInput>;
  /** The budget to which this expense accrues (has customer default; optional before default budgets exist) */
  budgetId?: InputMaybe<Scalars["ID"]>;
  /** The Customer Department to which the expense is attributed, auto-denormalized from User */
  departmentId?: InputMaybe<Scalars["ID"]>;
  /** The extended field values */
  extendedFieldValueInputs?: InputMaybe<
    Array<InputMaybe<ExpenseExtendedFieldValueInput>>
  >;
  /** Expense extension field. For now, it's only Bill but we can include other types of extensions such as reimbursements. */
  extension?: InputMaybe<ExpenseExtensionTypeInputUnion>;
  /** The legal entity that funds this expense */
  fundingEntityId?: InputMaybe<Scalars["ID"]>;
  /** The legal entity to which this expenses is attributed */
  legalEntityId?: InputMaybe<Scalars["ID"]>;
  /** The Customer Location to which the expense is attributed, auto-denormalized from User */
  locationId?: InputMaybe<Scalars["ID"]>;
  /**
   * The memo line
   *
   * Updating an expense's memo will resolve any associated Memo Request Action.
   */
  memo?: InputMaybe<Scalars["String"]>;
  /** The category to which this expense belongs to, auto-denormalized from Merchant */
  merchantCategoryId?: InputMaybe<Scalars["ID"]>;
  /** The merchant counter-party */
  merchantId?: InputMaybe<Scalars["ID"]>;
  /** The merchant name */
  merchantName?: InputMaybe<Scalars["String"]>;
  /** Amount of the expense in original currency; may be negative */
  originalAmount?: InputMaybe<FinancialAssetInput>;
  /** Amount of the purchase from the perspective of the merchant/vendor; may be negative */
  purchasedAmount?: InputMaybe<FinancialAssetInput>;
  /** The time of purchase */
  purchasedAt?: InputMaybe<Scalars["Time"]>;
  /** The receipts to be unlinked from the expense */
  removedReceiptIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** The type of the expense */
  type?: InputMaybe<ExpenseType>;
  /** The vendor id of this expense */
  vendorId?: InputMaybe<Scalars["ID"]>;
}

/** The computed integration lens field from integration rule engine for expenses. */
export interface ExpenseLens extends Node {
  billableStatus?: Maybe<Scalars["Boolean"]>;
  disabledIntegrationRules?: Maybe<Array<Maybe<IntegrationRule>>>;
  disabledRuleIds?: Maybe<Array<Maybe<Scalars["String"]>>>;
  erpSubsidiary?: Maybe<ErpSubsidiary>;
  expenseId?: Maybe<Scalars["String"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  integrationFields?: Maybe<Array<Maybe<IntegrationField>>>;
  integrationRuleEvaluations?: Maybe<Array<Maybe<RuleEvaluation>>>;
  /** Whether the expense is exported */
  isExported?: Maybe<Scalars["Boolean"]>;
  userCategory?: Maybe<UserCategory>;
  userCategoryId?: Maybe<Scalars["String"]>;
}

export interface ExpenseLensFilterInput {
  /** Optional field, when set only the expenses with expense lens of this facet type will be returned. */
  facetType?: InputMaybe<FacetType>;
  /** Optional field, when set only the expenses with expense lens matches these rules will be returned. */
  ruleIds?: InputMaybe<Array<Scalars["ID"]>>;
}

/** Location where an expense occurred */
export interface ExpenseLocation {
  /** Address line 1 of the expense location */
  addressLine1?: Maybe<Scalars["String"]>;
  /** Address line 2 of the expense location */
  addressLine2?: Maybe<Scalars["String"]>;
  /** City of the expense location */
  city?: Maybe<Scalars["String"]>;
  /** Country of the expense location */
  country?: Maybe<Scalars["String"]>;
  /** Country of the expense location in iso2 format */
  countryIso2?: Maybe<Scalars["String"]>;
  /** Latitude of the expense location */
  latitude?: Maybe<Scalars["Decimal"]>;
  /** Longitude of the expense location */
  longitude?: Maybe<Scalars["Decimal"]>;
  /** Postal code of the expense location */
  postalCode?: Maybe<Scalars["String"]>;
  /** State of the expense location */
  state?: Maybe<Scalars["String"]>;
  /** Time zone of the expense location */
  timeZone?: Maybe<Scalars["String"]>;
}

export interface ExpenseMoney {
  /** Amount of the expense; From the perspective and currency of the Company */
  billingAmount?: Maybe<FinancialAsset>;
  /**
   * Amount of the expense; From the perspective and currency of the requested Budget id.
   * Defaults to leaf Budget perspective if not specified or null.
   */
  budgetAmount?: Maybe<FinancialAsset>;
  /** Amount in Customer Invariant Currency (same currency customer wide) */
  customerInvariantAmount?: Maybe<FinancialAsset>;
  /** Amount of the expense; From the perspective and currency of the User */
  originalAmount?: Maybe<FinancialAsset>;
  /** Amount of the purchase from the perspective of the merchant/vendor */
  purchasedAmount?: Maybe<FinancialAsset>;
}

export interface ExpenseMutationError extends StandardClientError {
  code: ErrorCode;
  error?: Maybe<ExpenseMutationErrorType>;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export enum ExpenseMutationErrorType {
  BUDGET_ANCESTOR_LIMIT_EXCEEDED = "BUDGET_ANCESTOR_LIMIT_EXCEEDED",
  BUDGET_AUTHORIZATION_ERROR = "BUDGET_AUTHORIZATION_ERROR",
  BUDGET_DELETED = "BUDGET_DELETED",
  BUDGET_EXPIRED = "BUDGET_EXPIRED",
  BUDGET_LIMIT_EXCEEDED = "BUDGET_LIMIT_EXCEEDED",
  BUDGET_MISSING = "BUDGET_MISSING",
  BUDGET_MISSING_REQUIRED_INVOICE = "BUDGET_MISSING_REQUIRED_INVOICE",
  BUDGET_MISSING_REQUIRED_MEMO = "BUDGET_MISSING_REQUIRED_MEMO",
  BUDGET_NOT_APPROVED = "BUDGET_NOT_APPROVED",
  BUDGET_NOT_FOUND = "BUDGET_NOT_FOUND",
  BUDGET_NOT_YET_STARTED = "BUDGET_NOT_YET_STARTED",
  BUDGET_POLICY_MISSING_BILL_PAY_RULE = "BUDGET_POLICY_MISSING_BILL_PAY_RULE",
  BUDGET_TERMINATED = "BUDGET_TERMINATED",
  BUDGET_TRANSACTION_LIMIT_EXCEEDED = "BUDGET_TRANSACTION_LIMIT_EXCEEDED",
  ERP_CATEGORY_MISSING_NETSUITE = "ERP_CATEGORY_MISSING_NETSUITE",
  ERP_CATEGORY_MISSING_QUICKBOOKS = "ERP_CATEGORY_MISSING_QUICKBOOKS",
  ERP_CATEGORY_MISSING_UNMAPPED = "ERP_CATEGORY_MISSING_UNMAPPED",
  ERP_CATEGORY_MISSING_XERO = "ERP_CATEGORY_MISSING_XERO",
  PAYMENT_METHOD_MISSING = "PAYMENT_METHOD_MISSING",
  UNKNOWN = "UNKNOWN",
}

/** The specification of the expense notification to send. Exactly 1 field should be set. */
export interface ExpenseNotificationDetailsOneOf {
  /** Details for a mobile push notification prompting user to add a receipt to an expense */
  receiptUploadPushNotification?: InputMaybe<ReceiptPushNotificationDetailsInput>;
}

export interface ExpenseNumberValue extends ExpenseFieldValue {
  id: Scalars["ID"];
  value?: Maybe<Scalars["Decimal"]>;
}

export interface ExpenseNumberValueInput {
  value?: InputMaybe<Scalars["Decimal"]>;
}

/** Represents an operation that can be performed on an expense */
export interface ExpenseOperation {
  /** Reason why this operation is disabled, if any */
  disabledReason?: Maybe<ExpenseOperationDisabledReason>;
  /** Whether the operation should be visible in the UI */
  isVisible: Scalars["Boolean"];
}

/** Represents why an operation is disabled */
export enum ExpenseOperationDisabledReason {
  PAYOUT_STARTED = "PAYOUT_STARTED",
}

export interface ExpenseOperationPermission {
  allowed: Scalars["Boolean"];
  reason?: Maybe<ExpenseOperationPermissionReason>;
  visible: Scalars["Boolean"];
}

export enum ExpenseOperationPermissionReason {
  CANT_APPROVE_OWN_EXPENSE = "CANT_APPROVE_OWN_EXPENSE",
  CANT_CANCEL_PROCESSED_REPAYMENT = "CANT_CANCEL_PROCESSED_REPAYMENT",
  CANT_CANCEL_PROCESSING_REPAYMENT = "CANT_CANCEL_PROCESSING_REPAYMENT",
  DISPUTE_TIME_EXPIRED = "DISPUTE_TIME_EXPIRED",
  EXPENSE_SAVING = "EXPENSE_SAVING",
  EXPENSE_STATUS_NOT_VALID = "EXPENSE_STATUS_NOT_VALID",
  HAS_OPEN_DISPUTE = "HAS_OPEN_DISPUTE",
  MISSING_GL_ACCOUNT = "MISSING_GL_ACCOUNT",
  MISSING_REQUIRED_FIELDS = "MISSING_REQUIRED_FIELDS",
  MONEY_MOVEMENT_NOT_SUPPORTED = "MONEY_MOVEMENT_NOT_SUPPORTED",
  NOT_ALLOWED_BY_EXPENSE_STATE = "NOT_ALLOWED_BY_EXPENSE_STATE",
  NOT_ALLOWED_BY_USER_ROLE = "NOT_ALLOWED_BY_USER_ROLE",
  NOT_ALLOWED_BY_USER_SETTINGS = "NOT_ALLOWED_BY_USER_SETTINGS",
  NOT_EDITABLE = "NOT_EDITABLE",
  NOT_OWNER = "NOT_OWNER",
  NO_BILLPAY_APPROVER_ACCESS = "NO_BILLPAY_APPROVER_ACCESS",
  NO_DELETE_PERMISSIONS = "NO_DELETE_PERMISSIONS",
  NO_DISPUTE_PERMISSIONS = "NO_DISPUTE_PERMISSIONS",
  NO_PREPARE_ACCOUNTING_EXPORT_PERMISSION = "NO_PREPARE_ACCOUNTING_EXPORT_PERMISSION",
  NO_REVIEW_PERMISSIONS = "NO_REVIEW_PERMISSIONS",
  NO_SELECTED_LIMIT = "NO_SELECTED_LIMIT",
  NO_SELF_APPROVAL_PERMISSIONS = "NO_SELF_APPROVAL_PERMISSIONS",
  PAYMENT_DECLINED = "PAYMENT_DECLINED",
  PAYMENT_NOT_CLEARED = "PAYMENT_NOT_CLEARED",
  PAYOUT_STARTED = "PAYOUT_STARTED",
  SANDBOX_MODE_DISABLED = "SANDBOX_MODE_DISABLED",
  UNSPLIT_EXPORTED = "UNSPLIT_EXPORTED",
  UNSPLIT_OUT_OF_POLICY = "UNSPLIT_OUT_OF_POLICY",
  UNSPLIT_READY_FOR_EXPORT = "UNSPLIT_READY_FOR_EXPORT",
  UNSUPPORTED_ACTUAL_SELECTED = "UNSUPPORTED_ACTUAL_SELECTED",
}

/** Represents all operations that can be performed on an expense */
export interface ExpenseOperations {
  /** Deny operation availability for the expense */
  denyPayment: ExpenseOperation;
}

/** Determines the order that the expenses will be returned. */
export interface ExpenseOrderInput {
  field: SortableExpenseField;
  order: OrderByDirection;
}

export type ExpenseOriginator =
  | Bill
  | CardTransaction
  | Clawback
  | ReimbursementItem;

/** Additional tracking step data specific to ACH transfers. */
export interface ExpensePaymentAchAddenda
  extends ExpensePaymentTrackingAddenda {
  /** The ACH trace number for the transaction, if available. */
  traceNumber?: Maybe<Scalars["String"]>;
  /** The rail type for this addenda. Always ACH for this type. */
  type: ExpensePaymentTrackingRail;
}

export interface ExpensePaymentDetails {
  /** the last 4 digits of the underlying account that was used for this transaction */
  accountLast4?: Maybe<Scalars["String"]>;
}

export interface ExpensePaymentStatus {
  /**
   * DO NOT INCLUDE THIS FIELD IN ANY expenses() (ListExpenses) call. Can be used only for expense() (GetExpense).
   *
   * The reason for the payment status reason
   */
  reason?: Maybe<ExpensePaymentStatusReason>;
  /**
   * Contains a UI-friendly label for the payment status.
   * Will generate different labels depending on the status type as well as the expense type.
   */
  statusLabel?: Maybe<Scalars["String"]>;
  /** The expense's payment status. */
  statusType?: Maybe<ExpensePaymentStatusType>;
}

/**
 * Payment Status reasons common across all rails
 *
 * Reimbursement Payment Status Reasons: TODO
 */
export enum ExpensePaymentStatusReason {
  ACCOUNT_SUSPENDED = "ACCOUNT_SUSPENDED",
  /** Common across Payment Types */
  APPROVED = "APPROVED",
  /** @deprecated No longer used */
  BUDGET_ARCHIVED = "BUDGET_ARCHIVED",
  BUDGET_CATEGORY_RESTRICTION = "BUDGET_CATEGORY_RESTRICTION",
  BUDGET_EXPIRED = "BUDGET_EXPIRED",
  BUDGET_MERCHANT_CATEGORY_CODE_RESTRICTION = "BUDGET_MERCHANT_CATEGORY_CODE_RESTRICTION",
  BUDGET_MERCHANT_RESTRICTION = "BUDGET_MERCHANT_RESTRICTION",
  BUDGET_NOT_APPROVED = "BUDGET_NOT_APPROVED",
  BUDGET_NOT_YET_STARTED = "BUDGET_NOT_YET_STARTED",
  BUDGET_TERMINATED = "BUDGET_TERMINATED",
  CARD_EXPIRED = "CARD_EXPIRED",
  CARD_NOT_ACTIVE = "CARD_NOT_ACTIVE",
  CARD_SUSPENDED = "CARD_SUSPENDED",
  CARD_TERMINATED = "CARD_TERMINATED",
  COMPLIANCE_BLOCKED = "COMPLIANCE_BLOCKED",
  EXCEEDED_ANCESTOR_BUDGET_LIMIT = "EXCEEDED_ANCESTOR_BUDGET_LIMIT",
  EXCEEDED_BUDGET_LIMIT = "EXCEEDED_BUDGET_LIMIT",
  EXCEEDED_BUDGET_TRANSACTION_LIMIT = "EXCEEDED_BUDGET_TRANSACTION_LIMIT",
  EXCEEDED_CARD_LIMIT = "EXCEEDED_CARD_LIMIT",
  EXCEEDED_CASH_ADVANCE_GLOBAL_LIMIT = "EXCEEDED_CASH_ADVANCE_GLOBAL_LIMIT",
  EXCEEDED_CASH_ADVANCE_USER_LIMIT = "EXCEEDED_CASH_ADVANCE_USER_LIMIT",
  EXCEEDED_GLOBAL_LIMIT = "EXCEEDED_GLOBAL_LIMIT",
  EXCEEDED_PIN_ATTEMPTS = "EXCEEDED_PIN_ATTEMPTS",
  EXCEEDED_USER_LIMIT = "EXCEEDED_USER_LIMIT",
  INSIDE_SANCTIONED_COUNTRY = "INSIDE_SANCTIONED_COUNTRY",
  INVALID_BILLING_ADDRESS = "INVALID_BILLING_ADDRESS",
  INVALID_CARD_CREDENTIALS = "INVALID_CARD_CREDENTIALS",
  INVALID_CVV = "INVALID_CVV",
  /** Card Payment Status Reasons */
  INVALID_EXPIRATION_DATE = "INVALID_EXPIRATION_DATE",
  INVALID_PIN = "INVALID_PIN",
  INVALID_SPENDING_ENTITY = "INVALID_SPENDING_ENTITY",
  MCC_BLOCKED = "MCC_BLOCKED",
  NO_BUDGET = "NO_BUDGET",
  OTHER = "OTHER",
  SOFT_EXPIRATION = "SOFT_EXPIRATION",
  SUSPECTED_FRAUD = "SUSPECTED_FRAUD",
  TOS_BLOCKED = "TOS_BLOCKED",
  /** Payment was declined because a transferred card cannot be used with new merchants */
  TRANSFERRED_CARD_NEW_MERCHANT = "TRANSFERRED_CARD_NEW_MERCHANT",
  USER_SUSPENDED = "USER_SUSPENDED",
}

/** The status of the expense's payment. */
export enum ExpensePaymentStatusType {
  /** Payment started, awaiting payment status */
  AWAITING_PAYMENT = "AWAITING_PAYMENT",
  /** Payment is canceled. */
  CANCELED = "CANCELED",
  /**
   * Payment is a withdrawal, which represents a cash advance.
   * This corresponds to both WITHDRAWING & WITHDREW on the back-end.
   */
  CASH_ADVANCE = "CASH_ADVANCE",
  /** Payment cleared. */
  CLEARED = "CLEARED",
  /**
   * Payment is a credit to the user.
   * Currently, this means chargebacks.
   */
  CREDITED = "CREDITED",
  /** Payment failed or got declined. */
  DECLINED = "DECLINED",
  /** Payment is not started yet. */
  NOT_STARTED = "NOT_STARTED",
  /** Payment is processing. */
  PROCESSING = "PROCESSING",
  /** Payment is a cleared refund. */
  REFUNDED = "REFUNDED",
  /** Payment is a refund in progress. */
  REFUNDING = "REFUNDING",
  /** Payment is scheduled. */
  SCHEDULED = "SCHEDULED",
}

/**
 * Interface representing additional data specific to the rail type for a tracking step.
 * Concrete implementations will contain rail-specific details (e.g., ACH trace number).
 */
export interface ExpensePaymentTrackingAddenda {
  /** The rail type for this addenda. Determines the concrete type of the addenda. */
  type: ExpensePaymentTrackingRail;
}

/** Data class to represent a transfer attachment. */
export interface ExpensePaymentTrackingAttachment {
  /** The download URL for the attachment. */
  attachmentDownloadUrl?: Maybe<Scalars["String"]>;
  /** The type of attachment. */
  attachmentType: ExpensePaymentTrackingAttachmentType;
  /** Timestamp of when this attachment will expire and become unavailable. */
  expiresAt?: Maybe<Scalars["Time"]>;
  /** The status of the attachment. */
  status: ExpensePaymentTrackingAttachmentStatus;
  /** The transfer type of which the attachment relates to. */
  transferType?: Maybe<ExpensePaymentTrackingTransferType>;
}

/** Enum to represent the status of the downloadable attachment. */
export enum ExpensePaymentTrackingAttachmentStatus {
  /** Attachment status is available, meaning it can be download by the user. */
  AVAILABLE = "AVAILABLE",
  /**
   * Attachment status is expired, meaning that the attachment is no longer available for download
   * and the customer should reach out to support to get a new one.
   */
  EXPIRED = "EXPIRED",
  /** Attachment status is not available, meaning that an attachment doesn't exist for the transfer. */
  NOT_AVAILABLE = "NOT_AVAILABLE",
  /** Attachment status is not ready, meaning that the attachment is not ready for download yet. */
  NOT_READY = "NOT_READY",
}

/** Enum to represent the type of the downloadable attachment. */
export enum ExpensePaymentTrackingAttachmentType {
  /** Attachment type indicating a domestic wire message. */
  DOMESTIC_WIRE = "DOMESTIC_WIRE",
  /** Attachment type indicating a SWIFT MT103 message. */
  SWIFT_MT103 = "SWIFT_MT103",
  /** Attachment type indicating a SWIFT PACS message. */
  SWIFT_PACS = "SWIFT_PACS",
}

/** Enum to represent the reason for a tracking event failure. */
export enum ExpensePaymentTrackingFailureReason {
  /** Failure reason indicating a blocked account. */
  ACCOUNT_BLOCKED = "ACCOUNT_BLOCKED",
  /** Failure reason indicating a closed account. */
  ACCOUNT_CLOSED = "ACCOUNT_CLOSED",
  /** Failure reason indicating a country not supported. */
  COUNTRY_NOT_SUPPORTED = "COUNTRY_NOT_SUPPORTED",
  /** Failure reason indicating a generic failure. */
  GENERIC = "GENERIC",
  /** Failure reason indicating missing or invalid information. */
  INFORMATION_MISSING_OR_INVALID = "INFORMATION_MISSING_OR_INVALID",
  /** Failure reason indicating an invalid account number. */
  INVALID_ACCOUNT_NUMBER = "INVALID_ACCOUNT_NUMBER",
  /** Failure reason indicating an invalid BIC. */
  INVALID_BIC = "INVALID_BIC",
  /** Failure reason indicating an invalid payment currency. */
  INVALID_PAYMENT_CURRENCY = "INVALID_PAYMENT_CURRENCY",
  /** Failure reason indicating a missing correspondent bank. */
  MISSING_CORRESPONDENT_BANK = "MISSING_CORRESPONDENT_BANK",
  /** Failure reason indicating a missing purpose code. */
  MISSING_PURPOSE_CODE = "MISSING_PURPOSE_CODE",
  /** Failure reason indicating an account mismatch. */
  NAME_ACCOUNT_MISMATCH = "NAME_ACCOUNT_MISMATCH",
  /** Failure reason indicating a reason returned by the request. */
  RETURNED_BY_REQUEST = "RETURNED_BY_REQUEST",
  /** Failure reason indicating a transfer above the maximum amount. */
  TRANSFER_ABOVE_MAX_AMOUNT = "TRANSFER_ABOVE_MAX_AMOUNT",
  /** Failure reason indicating a transfer under the minimum amount. */
  TRANSFER_UNDER_MIN_AMOUNT = "TRANSFER_UNDER_MIN_AMOUNT",
}

/** Data class to represent a transfer fee. This will be associated to a particular tracking step. */
export interface ExpensePaymentTrackingFee {
  /** Monetary amount the was charged as a fee. */
  amount: FinancialAsset;
  /** Monetary amount the was charged as a fee. */
  feeType: ExpensePaymentTrackingFeeType;
}

/** Enum to represent the type of fee that was charged on a transfer. */
export enum ExpensePaymentTrackingFeeType {
  /** Fee type indicating a regular processing fee. */
  PROCESSING = "PROCESSING",
  /** Fee type indicating a return fee. */
  RETURN = "RETURN",
}

/** Representation of a payment tracking object. */
export interface ExpensePaymentTrackingObject {
  /** The attachments of the tracking object. */
  attachments: Array<ExpensePaymentTrackingAttachment>;
  /** The steps of the tracking object. */
  steps: Array<ExpensePaymentTrackingStep>;
}

/** Enum to represent the rail used for the transfer. */
export enum ExpensePaymentTrackingRail {
  /** Fintech-powered international transfer, like the ones offered by Wise, Airwallex and others. */
  GLOBAL_BANK_TRANSFER = "GLOBAL_BANK_TRANSFER",
  /** Internal book transfer within Brex. */
  INTERNAL_TRANSFER = "INTERNAL_TRANSFER",
  /** Manual execution by Ops. */
  MANUAL = "MANUAL",
  /** SWIFT international Wire. */
  SWIFT_WIRE = "SWIFT_WIRE",
  /** Trading transfer, used for MMF trading. */
  TRADING = "TRADING",
  /** As an input, signals banking_gateway that it should decide on the best approach/s. */
  UNSPECIFIED = "UNSPECIFIED",
  /** US ACH. */
  US_ACH = "US_ACH",
  /** US Cheque for withdrawal, externally originated incoming debit. */
  US_CHEQUE = "US_CHEQUE",
  /** US Cheque for deposit, Brex originated outgoing debit. */
  US_CHEQUE_DEPOSIT = "US_CHEQUE_DEPOSIT",
  /** US Wire. */
  US_WIRE = "US_WIRE",
}

/** A payment tracking step encapsulating all the necessary information about a transfer event. */
export interface ExpensePaymentTrackingStep {
  /**
   * The addenda information for the tracking step that is specific to the rail type.
   * e.g., For ACH rail type, it will contain the transfer's trace number.
   */
  addenda?: Maybe<ExpensePaymentTrackingAddenda>;
  /**
   * The effective date and time of the tracking step.
   * If update status is AWAITING then this will indicate the ETA.
   */
  effectiveAt: Scalars["Time"];
  /** The effective bank of the tracking step. */
  effectiveBank?: Maybe<Scalars["String"]>;
  /** The identifier of the effective bank of the tracking step, such as BIC or routing number. */
  effectiveBankIdentifier?: Maybe<Scalars["String"]>;
  /**
   * The reason for the tracking event failure.
   * Only available if the update_status is FAILURE.
   */
  failureReason?: Maybe<ExpensePaymentTrackingFailureReason>;
  /** The fees associated with the tracking step. */
  fees: Array<ExpensePaymentTrackingFee>;
  /**
   * The raw message from the partner for the tracking step.
   * Possibly available with GENERIC failure reason.
   */
  partnerRawMessage?: Maybe<Scalars["String"]>;
  /** The rail used for the transfer. */
  rail: ExpensePaymentTrackingRail;
  /** The settled amount of the tracking step. */
  settledAmount?: Maybe<FinancialAsset>;
  /** The type of the transfer of the tracking event. */
  transferType?: Maybe<ExpensePaymentTrackingTransferType>;
  /** The status of the tracking update. */
  updateStatus: ExpensePaymentTrackingUpdateStatus;
  /** The type of update for the tracking event. */
  updateType: ExpensePaymentTrackingUpdateType;
}

/** Enum to represent the type of the transfer being tracked. */
export enum ExpensePaymentTrackingTransferType {
  /** Transfer type indicating a collection, normally used for pay-ins. */
  COLLECTION = "COLLECTION",
  /** Transfer type indicating a payment, normally used for pay-outs. */
  PAYMENT = "PAYMENT",
}

/** Enum to represent the status of a tracking event. */
export enum ExpensePaymentTrackingUpdateStatus {
  /** Tracking update indicating a step that is awaiting completion. */
  AWAITING = "AWAITING",
  /** Tracking update indicating a completed step. */
  COMPLETED = "COMPLETED",
  /** Tracking update indicating a failed step. */
  FAILED = "FAILED",
  /** Tracking update indicating a step that is processing. */
  PROCESSING = "PROCESSING",
}

/** Enum to represent the type of update for a tracking event. */
export enum ExpensePaymentTrackingUpdateType {
  /** Tracking update indicating a cancellation. */
  CANCELLATION = "CANCELLATION",
  /** Tracking update indicating a cancellation request. */
  CANCELLATION_REQUEST = "CANCELLATION_REQUEST",
  /** Tracking update indicating the delivery at destination. */
  DELIVERY_AT_DESTINATION = "DELIVERY_AT_DESTINATION",
  /** Tracking update indicating the process at Brex. */
  PROCESS_AT_BREX = "PROCESS_AT_BREX",
  /** Tracking update indicating the process at intermediary. */
  PROCESS_AT_INTERMEDIARY = "PROCESS_AT_INTERMEDIARY",
  /** Tracking update indicating the initiation at partner. */
  PROCESS_AT_PARTNER = "PROCESS_AT_PARTNER",
  /** Tracking update indicating the step which funds the transfer. */
  PROCESS_FUNDING = "PROCESS_FUNDING",
  /** Tracking update indicating a return. */
  RETURN = "RETURN",
  /** Indication that tracking updates are unavailable. */
  UNAVAILABLE = "UNAVAILABLE",
}

/** An optional perspective to view the expense from. */
export interface ExpensePerspectiveInput {
  /**
   * Optional field. Queries the expense from the lens of the perspective of the inputted budget - the budget amount of
   * the Expense will be in the currency of the requested budget.
   */
  perspectiveBudgetId?: InputMaybe<Scalars["ID"]>;
}

/**
 * Represents a policy that can be created or displayed through the Policy Creator. This is more restrictive than the
 * general Policy type, which represents policies that can be converted into policy-engine policies but which might not
 * necessarily be supported in other parts of our product.
 */
export interface ExpensePolicy {
  /** Accounting fields required on expense */
  accountingExtendedFieldsRequirement?: Maybe<ExpensePolicyAccountingExtendedFieldsRequirement>;
  /**
   * "
   * Policy rules that only apply to bill pay expenses
   */
  billPay: ExpensePolicyBillPaySpecificRules;
  /** More advanced rules for flights, lodging, etc. that have Brex Travel/Spotnana integrations. */
  brexTravel: ExpensePolicyBrexTravelRules;
  /** Policy rules that only apply to card expenses */
  card: ExpensePolicyExpenseTypeSpecificRules;
  /** If this expense was created by an user or set from one of our presets */
  creationType?: Maybe<ExpensePolicyCreationType>;
  /**
   * Policies have at most one currency. If this value is set, then every Decimal type in this message should be
   * interpreted as a FinancialAsset with this currency. However, it's possible to have a policy with no amount-based
   * rules at all, in which case this field may be null.
   */
  currency?: Maybe<Scalars["String"]>;
  /** Whether or not the user should be required to document an "expense category" (categorization defined by the company) */
  expenseCategoryRequirement: ExpensePolicyExpenseCategoryRequirement;
  /** Merchant- and category-based review rules, which apply regardless of expense type. */
  merchantAndCategory: ExpensePolicyMerchantAndCategoryRules;
  /** [Airbnb-Demo] Review rules based on receipt attributes such as items, tip, etc */
  receiptReview?: Maybe<ReceiptReviewRules>;
  /** Policy rules that only apply to reimbursement expenses */
  reimbursement: ExpensePolicyExpenseTypeSpecificRules;
  /** Whether or not the user should be required to document an expense's VAT eligibility/rate. */
  vatRequirement: ExpensePolicyVatRequirement;
}

export interface ExpensePolicyAccountingExtendedFieldsRequirement {
  extendedFields: Array<ExtendedField>;
}

export interface ExpensePolicyAccountingExtendedFieldsRequirementInput {
  extendedFieldIds: Array<Scalars["ID"]>;
}

/** Rules and restrictions governing flight bookings */
export interface ExpensePolicyAirlineRules {
  /**
   * Rules about allowed cabin classes. One can either set rules by flight duration, or by destination type (domestic or
   * international) *and* duration. Null = no limits
   */
  allowedCabinClasses?: Maybe<ExpensePolicyMaxCabinClassRules>;
  /** Rules about the amount one may spend on a flight based on its duration. Null = no limits */
  amountLimitsByDuration?: Maybe<ExpensePolicyAmountLimitByFlightDurationRules>;
  /** The kind of approval that flights booked via Brex Travel will be subject to. The default should be NONE. */
  bookingApprovalType?: Maybe<BookingApprovalType>;
  /**
   * Variants of these settings that apply to specific users.
   *
   * NOTE: If the ExpensePolicy contains exceptions in its non-Brex-Travel "Airline expenses" rule (i.e. in
   * ExpensePolicy.merchantAndCategory.categoryRules), then we guarantee that this list contains the same number and
   * order of exceptions as the category-level exceptions list.
   */
  exceptions: Array<ExpensePolicyAirlineRulesException>;
  /**
   * Amount limit based on percentage above the lowest logical fare. Valid values in [0, 1000]
   * Cannot be set if maxPercentAboveMedianPrice is set.
   */
  maxPercentAboveLowestLogicalFare?: Maybe<Scalars["Int"]>;
  /**
   * Amount limit based on percentage above the median price. Valid values in [-100, 1000]
   * Cannot be set if maxPercentAboveLowestLogicalFare is set.
   */
  maxPercentAboveMedianPrice?: Maybe<Scalars["Int"]>;
  /** Minimum number of days in advance that a flight must be booked. Null = no limits */
  minDaysInAdvance?: Maybe<Scalars["Int"]>;
  /** What changeability conditions are allowed on a user's flight booking. Null = no limits */
  ticketChangeability?: Maybe<ExpensePolicyAllowedTicketChangeability>;
  /** What refundability conditions are allowed on a user's flight booking. Null = no limits */
  ticketRefundability?: Maybe<ExpensePolicyAllowedTicketRefundability>;
}

/**
 * This is identical to ExpensePolicyAirlineRules, except it does not contain a list of exceptions, and instead contains an
 * ExceptionScope to identify which users this exception should apply to. For field documentation, refer to the
 * non-exception type.
 */
export interface ExpensePolicyAirlineRulesException {
  allowedCabinClasses?: Maybe<ExpensePolicyMaxCabinClassRules>;
  amountLimitsByDuration?: Maybe<ExpensePolicyAmountLimitByFlightDurationRules>;
  bookingApprovalType?: Maybe<BookingApprovalType>;
  exceptionScope: PolicyExceptionScope;
  maxPercentAboveLowestLogicalFare?: Maybe<Scalars["Int"]>;
  maxPercentAboveMedianPrice?: Maybe<Scalars["Int"]>;
  minDaysInAdvance?: Maybe<Scalars["Int"]>;
  /** Preview group for migration of role-based exceptions */
  previewUserGroup?: Maybe<PreviewUserGroup>;
  ticketChangeability?: Maybe<ExpensePolicyAllowedTicketChangeability>;
  ticketRefundability?: Maybe<ExpensePolicyAllowedTicketRefundability>;
  /** Group of users that this exception applies to. */
  userGroup?: Maybe<Group>;
}

/**
 * This is identical to ExpensePolicyAirlineRulesInput, except it does not contain a list of exceptions, and instead
 * contains an ExceptionScope to identify which users this exception should apply to. For field documentation, refer to the
 * non-exception type.
 */
export interface ExpensePolicyAirlineRulesExceptionInput {
  allowedCabinClasses?: InputMaybe<ExpensePolicyMaxCabinClassRulesOneOfInput>;
  amountLimitsByDuration?: InputMaybe<ExpensePolicyAmountLimitByFlightDurationRulesInput>;
  bookingApprovalType?: InputMaybe<BookingApprovalType>;
  exceptionScope: PolicyExceptionScopeInput;
  maxPercentAboveLowestLogicalFare?: InputMaybe<Scalars["Int"]>;
  maxPercentAboveMedianPrice?: InputMaybe<Scalars["Int"]>;
  minDaysInAdvance?: InputMaybe<Scalars["Int"]>;
  ticketChangeability?: InputMaybe<ExpensePolicyAllowedTicketChangeability>;
  ticketRefundability?: InputMaybe<ExpensePolicyAllowedTicketRefundability>;
  userGroup?: InputMaybe<ExceptionUserGroupInput>;
}

/** Rules and restrictions governing flight bookings */
export interface ExpensePolicyAirlineRulesInput {
  /**
   * Rules about allowed cabin classes. One can either set rules by flight duration, or by destination type (domestic or
   * international) *and* duration. Null = no limits
   */
  allowedCabinClasses?: InputMaybe<ExpensePolicyMaxCabinClassRulesOneOfInput>;
  /** Rules about the amount one may spend on a flight based on its duration. Null = no limits */
  amountLimitsByDuration?: InputMaybe<ExpensePolicyAmountLimitByFlightDurationRulesInput>;
  /** The kind of approval that flights booked via Brex Travel will be subject to. The default should be NONE. */
  bookingApprovalType?: InputMaybe<BookingApprovalType>;
  /**
   * Variants of these settings that apply to specific users.
   *
   * NOTE: If the ExpensePolicyInput contains exceptions in its non-Brex-Travel "Airline expenses" rule (i.e. in
   * ExpensePolicyInput.merchantAndCategory.categoryRules), then this list MUST contain the same number and
   * order of exceptions as the category-level exceptions list. If there are no Brex Travel rules at all, then
   * ExpensePolicyBrexTravelRulesInput.airline may be null, or this list may be empty.
   */
  exceptions?: InputMaybe<Array<ExpensePolicyAirlineRulesExceptionInput>>;
  /**
   * Amount limit based on percentage above the lowest logical fare
   * Cannot be set if maxPercentAboveMedianPrice is set.
   */
  maxPercentAboveLowestLogicalFare?: InputMaybe<Scalars["Int"]>;
  /**
   * Amount limit based on percentage above the median price; may be negative!
   * Cannot be set if maxPercentAboveLowestLogicalFare is set.
   */
  maxPercentAboveMedianPrice?: InputMaybe<Scalars["Int"]>;
  /** Minimum number of days in advance that a flight must be booked. Null = no limits */
  minDaysInAdvance?: InputMaybe<Scalars["Int"]>;
  /** What changeability conditions are allowed on a user's flight booking. Null = no limits */
  ticketChangeability?: InputMaybe<ExpensePolicyAllowedTicketChangeability>;
  /** What refundability conditions are allowed on a user's flight booking. Null = no limits */
  ticketRefundability?: InputMaybe<ExpensePolicyAllowedTicketRefundability>;
}

/**
 * A category "allow" rule. If [ReviewRules.allOthers == REVIEW], then this rule makes an exception for this category.
 * However, this type is somewhat misnamed, as it contains other configuration that may trigger review for expenses in this
 * category; see [maximumSpend] and [byMerchantConfig].
 */
export interface ExpensePolicyAllowCategory
  extends ExpensePolicyCategoryReviewRule {
  /**
   * If provided, configures the maximum amount that can be spent in this category before requiring review, either
   * on a per-transaction or a per-day basis (the latter only supported for Meals right now).
   */
  amountLimits?: Maybe<ExpensePolicyCategoryAmountLimitRules>;
  category: ExtendedMerchantCategory;
  exceptions: Array<ExpensePolicyCategoryException>;
  /**
   * If provided, allows more-granular merchant-level allow/review exceptions within this category. Note that
   * [merchantExceptions] contains its own "all other merchants: allow/review" configuration, which can make this
   * so-named "category allow" rule actually require review for most expenses with this merchant category.
   *
   * Note: we expect to phase this functionality out at some point; as of Nov 2023, only 16 (!) customers use this
   * functionality, and those policies can be expressed without this.
   */
  merchantExceptions?: Maybe<ExpensePolicyCategoryMerchantExceptions>;
  notes: Scalars["String"];
}

/**
 * A category "allow" rule. If [ReviewRules.allOthers == REVIEW], then this rule makes an exception for this category.
 * However, this type is somewhat misnamed, as it contains other configuration that may trigger review for expenses in this
 * category; see [maximumSpend] and [byMerchantConfig].
 */
export interface ExpensePolicyAllowCategoryInput {
  /**
   * If provided, configures the maximum amount that can be spent in this category before requiring review, either
   * on a per-transaction or a per-day basis (the latter only supported for Meals right now).
   */
  amountLimits?: InputMaybe<ExpensePolicyCategoryAmountLimitRulesInput>;
  category: ExtendedMerchantCategoryOneOfInput;
  exceptions?: InputMaybe<Array<ExpensePolicyCategoryExceptionInput>>;
  /**
   * If provided, allows more-granular merchant-level allow/review exceptions within this category. Note that
   * [merchantExceptions] contains its own "all other merchants: allow/review" configuration, which can make this
   * so-named "category allow" rule actually require review for most expenses with this merchant category.
   *
   * Note: we expect to phase this functionality out at some point; as of Nov 2023, only 16 (!) customers use this
   * functionality, and those policies can be expressed without this.
   */
  merchantExceptions?: InputMaybe<ExpensePolicyCategoryMerchantExceptionsInput>;
  notes: Scalars["String"];
}

/**
 * A merchant "allow" rule. If [ReviewRules.allOthers == REVIEW], then this rule makes an exception for this merchant.
 * All transactions over maximumSpend (if provided) require review, however.
 */
export interface ExpensePolicyAllowMerchant
  extends ExpensePolicyMerchantReviewRule {
  /** Amount over which expenses for this merchant require review. If null, no maximum. */
  amountLimit?: Maybe<Scalars["Decimal"]>;
  /** Alternate versions of this rule that may be in force for specific users */
  exceptions: Array<ExpensePolicyMerchantException>;
  name: Scalars["String"];
  notes: Scalars["String"];
}

/**
 * A merchant "allow" rule. If [ReviewRules.allOthers == REVIEW], then this rule makes an exception for this merchant.
 * All transactions over maximumSpend (if provided) require review, however.
 */
export interface ExpensePolicyAllowMerchantInput {
  /** Amount over which expenses for this merchant require review. If null, no maximum. */
  amountLimit?: InputMaybe<Scalars["Decimal"]>;
  exceptions?: InputMaybe<Array<ExpensePolicyMerchantExceptionInput>>;
  name: Scalars["String"];
  notes: Scalars["String"];
}

/** What changeability conditions are allowed on a user's flight booking. */
export enum ExpensePolicyAllowedTicketChangeability {
  CHANGEABLE_ONLY_ADDITIONAL_FEES_ALLOWED = "CHANGEABLE_ONLY_ADDITIONAL_FEES_ALLOWED",
  CHANGEABLE_ONLY_NO_ADDITIONAL_FEES = "CHANGEABLE_ONLY_NO_ADDITIONAL_FEES",
  NON_CHANGEABLE_ONLY = "NON_CHANGEABLE_ONLY",
}

/** What refundability conditions are allowed on a user's flight booking. */
export enum ExpensePolicyAllowedTicketRefundability {
  NON_REFUNDABLE_ONLY = "NON_REFUNDABLE_ONLY",
  REFUNDABLE_ONLY_ADDITIONAL_FEES_ALLOWED = "REFUNDABLE_ONLY_ADDITIONAL_FEES_ALLOWED",
  REFUNDABLE_ONLY_NO_ADDITIONAL_FEES = "REFUNDABLE_ONLY_NO_ADDITIONAL_FEES",
}

/** An amount limit paired with a flight duration under which that limit applies */
export interface ExpensePolicyAmountLimitByFlightDurationRule {
  amountLimit: Scalars["Decimal"];
  maxDurationHours: Scalars["Int"];
}

/** An amount limit paired with a flight duration under which that limit applies */
export interface ExpensePolicyAmountLimitByFlightDurationRuleInput {
  amountLimit: Scalars["Decimal"];
  maxDurationHours: Scalars["Int"];
}

/** Rules about the amount one may spend on a flight based on its duration. */
export interface ExpensePolicyAmountLimitByFlightDurationRules {
  /** Amount limit for flights above the maximum duration listed in [durationLimits] */
  allOthers: Scalars["Decimal"];
  /** Amount limits paired with flight durations under which those limits apply */
  durationRules: Array<ExpensePolicyAmountLimitByFlightDurationRule>;
}

/** Rules about the amount one may spend on a flight based on its duration. */
export interface ExpensePolicyAmountLimitByFlightDurationRulesInput {
  /** Amount limit for flights above the maximum duration listed in [durationLimits] */
  allOthers: Scalars["Decimal"];
  /** Amount limits paired with flight durations under which those limits apply */
  durationRules: Array<ExpensePolicyAmountLimitByFlightDurationRuleInput>;
}

/** Whether a maximum spend threshold should be evaluated on a per-transaction or per-day basis */
export enum ExpensePolicyAmountLimitType {
  PER_DAY = "PER_DAY",
  PER_TRANSACTION = "PER_TRANSACTION",
}

/** Configuration stating what reviewers are required for expenses over a certain amount */
export interface ExpensePolicyApprovalChainRule {
  /** Expense amount over which this approval chain is in effect */
  minAmount: Scalars["Decimal"];
  /** Approval steps */
  steps: Array<PolicyApprovalStep>;
}

/** Configuration stating what reviewers are required for expenses over a certain amount */
export interface ExpensePolicyApprovalChainRuleInput {
  /** Expense amount over which this approval chain is in effect */
  minAmount: Scalars["Decimal"];
  /** Approval steps */
  steps: Array<PolicyApprovalStepInput>;
}

export interface ExpensePolicyApprovalChainsException {
  approvalChains: Array<ExpensePolicyApprovalChainRule>;
  defaultApprovalChain: Array<PolicyApprovalStep>;
  exceptionScope: PolicyExceptionScope;
  /** Preview group for migration of role-based exceptions */
  previewUserGroup?: Maybe<PreviewUserGroup>;
  /** Group of users that this exception applies to. */
  userGroup?: Maybe<Group>;
}

export interface ExpensePolicyApprovalChainsExceptionInput {
  approvalChains: Array<ExpensePolicyApprovalChainRuleInput>;
  defaultApprovalChain?: InputMaybe<Array<PolicyApprovalStepInput>>;
  exceptionScope: PolicyExceptionScopeInput;
  userGroup?: InputMaybe<ExceptionUserGroupInput>;
}

/** Configuration about which bill pay expenses require invoices */
export interface ExpensePolicyBillPayInvoiceRules {
  /** If provided, invoices are required above this amount. If null, invoices not required. */
  requiredAbove?: Maybe<Scalars["Decimal"]>;
}

/** Configuration about which bill pay expenses require invoices */
export interface ExpensePolicyBillPayInvoiceRulesInput {
  /** If provided, invoices are required above this amount. If null, invoices not required. */
  requiredAbove?: InputMaybe<Scalars["Decimal"]>;
}

/** Configuration about which bill expenses require memos */
export interface ExpensePolicyBillPayMemoRules {
  /** If provided, memos are required above this amount. If null, memos not required. */
  requiredAbove?: Maybe<Scalars["Decimal"]>;
}

/** Configuration about which bill expenses require memos */
export interface ExpensePolicyBillPayMemoRulesInput {
  /** If provided, memos are required above this amount. If null, memos not required. */
  requiredAbove?: InputMaybe<Scalars["Decimal"]>;
}

/** Policy configuration for bill pay expenses */
export interface ExpensePolicyBillPaySpecificRules {
  /**
   * approvalChains ties together two concepts:
   * 1. Amount-based review requirement rules
   * 2. Amount-based approval chain rules
   *
   * If at least one ApprovalChainThreshold is provided here, then any expense whose amount matches or exceeds the
   * minimum threshold will require review. If multiple ApprovalChainThresholds are provided, then the approval chain
   * (i.e. list of reviewers and their review order) will be determined by the ApprovalChainThreshold with the highest
   * threshold value less than or equal to the expense amount.
   */
  approvalChains: Array<ExpensePolicyApprovalChainRule>;
  /**
   * Sets a custom approval chain for expenses that require review but are under the minimum amount specified in
   * [approvalChains].
   */
  defaultApprovalChain: Array<PolicyApprovalStep>;
  /** Configuration about which expenses require invoices */
  invoices: ExpensePolicyBillPayInvoiceRules;
  /** Configuration about which bill expenses require memos */
  memos: ExpensePolicyBillPayMemoRules;
}

/** Policy configuration for bill pay expenses */
export interface ExpensePolicyBillPaySpecificRulesInput {
  /**
   * approvalChains ties together two concepts:
   * 1. Amount-based review requirement rules
   * 2. Amount-based approval chain rules
   *
   * If at least one ApprovalChainThreshold is provided here, then any expense whose amount matches or exceeds the
   * minimum threshold will require review. If multiple ApprovalChainThresholds are provided, then the approval chain
   * (i.e. list of reviewers and their review order) will be determined by the ApprovalChainThreshold with the highest
   * threshold value less than or equal to the expense amount.
   *
   * One important subtlety: some expenses below the minimum threshold may require review for non-amount-related reasons
   * (e.g. a merchant or category exception in ReviewRules). In this case, the ApprovalChainThreshold with the minimum
   * threshold value is used to determine the approval chain, unless [defaultApprovalChain] is set, in which case that
   * approval chain will be used.
   */
  approvalChains: Array<ExpensePolicyApprovalChainRuleInput>;
  /**
   * Sets a custom approval chain for expenses that require review but are under the minimum amount specified in
   * [approvalChains]. (If not specified, the [approvalChain] with the lowest expense threshold will be used.)
   */
  defaultApprovalChain?: InputMaybe<Array<PolicyApprovalStepInput>>;
  /** Configuration about which bill expenses require invoices */
  invoices: ExpensePolicyBillPayInvoiceRulesInput;
  /** Configuration about which bill expenses require memos */
  memos: ExpensePolicyBillPayMemoRulesInput;
}

/**
 * A merchant category "block" rule. Card expenses with this merchant category require review, and reimbursements for
 * expenses with this merchant category cannot be submitted at all.
 */
export interface ExpensePolicyBlockCategory
  extends ExpensePolicyCategoryReviewRule {
  category: ExtendedMerchantCategory;
  notes: Scalars["String"];
}

/**
 * A merchant category "block" rule. Card expenses with this merchant category require review, and reimbursements for
 * expenses with this merchant category cannot be submitted at all.
 */
export interface ExpensePolicyBlockCategoryInput {
  category: ExtendedMerchantCategoryOneOfInput;
  notes: Scalars["String"];
}

/**
 * A merchant "block" rule. Card expenses at this merchant require review, and reimbursements for expenses at this merchant
 * cannot be submitted at all.
 */
export interface ExpensePolicyBlockMerchant
  extends ExpensePolicyMerchantReviewRule {
  name: Scalars["String"];
  notes: Scalars["String"];
}

/**
 * A merchant "block" rule. Card expenses at this merchant require review, and reimbursements for expenses at this merchant
 * cannot be submitted at all.
 */
export interface ExpensePolicyBlockMerchantInput {
  name: Scalars["String"];
  notes: Scalars["String"];
}

/** More advanced rules for flights, lodging, etc. that have Brex Travel/Spotnana integrations. */
export interface ExpensePolicyBrexTravelRules {
  /** Rules and restrictions governing flight bookings */
  airline: ExpensePolicyAirlineRules;
  /** Rules and restrictions governing car rentals */
  carRental: ExpensePolicyCarRentalRules;
  /** An approval chain to be used for Booking Requests. */
  defaultApprovalChain?: Maybe<Array<PolicyApprovalStep>>;
  /** Rules and restrictions governing lodging bookings */
  lodging: ExpensePolicyLodgingRules;
  /** Rules and restrictions governing rail travel */
  rail: ExpensePolicyRailRules;
}

/** More advanced rules for flights, lodging, etc. that have Brex Travel/Spotnana integrations. */
export interface ExpensePolicyBrexTravelRulesInput {
  /** Rules and restrictions governing flight bookings */
  airline?: InputMaybe<ExpensePolicyAirlineRulesInput>;
  /** Rules and restrictions governing car rentals */
  carRental?: InputMaybe<ExpensePolicyCarRentalRulesInput>;
  /** An approval chain to be used for Booking Requests. */
  defaultApprovalChain?: InputMaybe<Array<PolicyApprovalStepInput>>;
  /** Rules and restrictions governing lodging bookings */
  lodging?: InputMaybe<ExpensePolicyLodgingRulesInput>;
  /** Rules and restrictions governing rail travel */
  rail?: InputMaybe<ExpensePolicyRailRulesInput>;
}

/** Rules and restrictions governing car rentals */
export interface ExpensePolicyCarRentalRules {
  /** The set of allowed rental car classes. Null = no restrictions */
  allowedClasses?: Maybe<Array<PolicyRentalCarClass>>;
  /** The kind of approval that car rentals booked via Brex Travel will be subject to. The default should be NONE. */
  bookingApprovalType?: Maybe<BookingApprovalType>;
  /**
   * Variants of these settings that apply to specific users.
   *
   * NOTE: If the ExpensePolicy contains exceptions in its non-Brex-Travel "Car rental" rule (i.e. in
   * ExpensePolicy.merchantAndCategory.categoryRules), then we guarantee that this list contains the same number and
   * order of exceptions as the category-level exceptions list.
   */
  exceptions: Array<ExpensePolicyCarRentalRulesException>;
  /** Maximum allowed daily rate. Null = no limit */
  maxDailyRate?: Maybe<Scalars["Decimal"]>;
}

/**
 * This is identical to ExpensePolicyCarRentalRules, except it does not contain a list of exceptions, and instead contains
 * an ExceptionScope to identify which users this exception should apply to. For field documentation, refer to the
 * non-exception type.
 */
export interface ExpensePolicyCarRentalRulesException {
  allowedClasses?: Maybe<Array<PolicyRentalCarClass>>;
  bookingApprovalType?: Maybe<BookingApprovalType>;
  exceptionScope: PolicyExceptionScope;
  maxDailyRate?: Maybe<Scalars["Decimal"]>;
  /** Preview group for migration of role-based exceptions */
  previewUserGroup?: Maybe<PreviewUserGroup>;
  /** Group of users that this exception applies to. */
  userGroup?: Maybe<Group>;
}

/**
 * This is identical to ExpensePolicyCarRentalRulesInput, except it does not contain a list of exceptions, and instead
 * contains an ExceptionScope to identify which users this exception should apply to. For field documentation, refer to the
 * non-exception type.
 */
export interface ExpensePolicyCarRentalRulesExceptionInput {
  allowedClasses?: InputMaybe<Array<PolicyRentalCarClass>>;
  bookingApprovalType?: InputMaybe<BookingApprovalType>;
  exceptionScope: PolicyExceptionScopeInput;
  maxDailyRate?: InputMaybe<Scalars["Decimal"]>;
  userGroup?: InputMaybe<ExceptionUserGroupInput>;
}

/** Rules and restrictions governing car rentals */
export interface ExpensePolicyCarRentalRulesInput {
  /** The set of allowed rental car classes. Null = no restrictions */
  allowedClasses?: InputMaybe<Array<PolicyRentalCarClass>>;
  /** The kind of approval that car rentals booked via Brex Travel will be subject to. The default should be NONE. */
  bookingApprovalType?: InputMaybe<BookingApprovalType>;
  /**
   * Variants of these settings that apply to specific users.
   *
   * NOTE: If the ExpensePolicyInput contains exceptions in its non-Brex-Travel "Car rental" rule (i.e. in
   * ExpensePolicyInput.merchantAndCategory.categoryRules), then this list MUST contain the same number and
   * order of exceptions as the category-level exceptions list. If there are no Brex Travel rules at all, then
   * ExpensePolicyBrexTravelRulesInput.carRental may be null, or this list may be empty..
   */
  exceptions?: InputMaybe<Array<ExpensePolicyCarRentalRulesExceptionInput>>;
  /** Maximum allowed daily rate. Null = no limit */
  maxDailyRate?: InputMaybe<Scalars["Decimal"]>;
}

/**
 * Category maximum spend configuration, including attendee requirements (which are only ever required when a spending
 * threshold has been crossed, hence their inclusion here)
 */
export interface ExpensePolicyCategoryAmountLimitRules {
  /** The threshold over which review is required */
  amountLimit: Scalars["Decimal"];
  /**
   * If not null, spending that triggers review for this category will also require the user to list attendees (with
   * metadata requirements listed in the [PolicyActionRequireAttendees] object)
   */
  attendeesRequired?: Maybe<PolicyActionRequireAttendees>;
  /** If not null, rules for reviewing attendees, specifically manager checks and government official checks. */
  attendeesReviewRules?: Maybe<AttendeesReviewRules>;
  /**
   * Whether this [threshold] applies to individual expenses or all expenses for a category in a day. [PER_DAY] is
   * currently only supported for the "Meals" compound merchant category.
   */
  limitType: ExpensePolicyAmountLimitType;
}

/**
 * Category maximum spend configuration, including attendee requirements (which are only ever required when a spending
 * threshold has been crossed, hence their inclusion here)
 */
export interface ExpensePolicyCategoryAmountLimitRulesInput {
  /** The threshold over which review is required */
  amountLimit: Scalars["Decimal"];
  /**
   * If not null, spending that triggers review for this category will also require the user to list attendees (with
   * metadata requirements listed in the [PolicyActionRequireAttendees] object)
   */
  attendeesRequired?: InputMaybe<PolicyRequireAttendeesInput>;
  /** If not null, rules for reviewing attendees, specifically manager checks and government official checks. */
  attendeesReviewRules?: InputMaybe<AttendeesReviewRulesInput>;
  /**
   * Whether this [threshold] applies to individual expenses or all expenses for a category in a day. [PER_DAY] is
   * currently only supported for the "Meals" compound merchant category.
   */
  limitType: ExpensePolicyAmountLimitType;
}

/**
 * Similar to an "allow" category rule, but specified as an "exception." (Also, without merchantExceptions, which we are
 * trying to phase out.) In this case, the category is known from context.
 */
export interface ExpensePolicyCategoryException {
  amountLimits?: Maybe<ExpensePolicyCategoryAmountLimitRules>;
  exceptionScope: PolicyExceptionScope;
  notes: Scalars["String"];
  /** Preview group for migration of role-based exceptions */
  previewUserGroup?: Maybe<PreviewUserGroup>;
  /** Group of users that this exception applies to. */
  userGroup?: Maybe<Group>;
}

/**
 * Similar to an "allow" category rule, but specified as an "exception." (Also, without merchantExceptions, which we are
 * trying to phase out.) In this case, the category is known from context.
 */
export interface ExpensePolicyCategoryExceptionInput {
  amountLimits?: InputMaybe<ExpensePolicyCategoryAmountLimitRulesInput>;
  exceptionScope: PolicyExceptionScopeInput;
  notes?: Scalars["String"];
  userGroup?: InputMaybe<ExceptionUserGroupInput>;
}

/** Merchant category-level memo configuration */
export interface ExpensePolicyCategoryMemoException {
  /** Merchant category */
  category: ExtendedMerchantCategory;
  /** If provided, memos are required above this amount. If null, memos not required. */
  requiredAbove?: Maybe<Scalars["Decimal"]>;
}

/** Merchant category-level memo configuration */
export interface ExpensePolicyCategoryMemoExceptionInput {
  /** Merchant category */
  category: ExtendedMerchantCategoryOneOfInput;
  /** If provided, memos are required above this amount. If null, memos not required. */
  requiredAbove?: InputMaybe<Scalars["Decimal"]>;
}

/** A single merchant-specific exception within an "allow category" configuration. */
export interface ExpensePolicyCategoryMerchantException {
  /** Merchant name */
  name: Scalars["String"];
  /** Whether expenses at this merchant should be allowed, reviewed, or blocked */
  reviewAction: ExpensePolicyReviewActionType;
}

/** A single merchant-specific exception within an "allow category" configuration. */
export interface ExpensePolicyCategoryMerchantExceptionInput {
  /** Merchant name */
  name: Scalars["String"];
  /** Whether expenses at this merchant should be allowed, reviewed, or blocked */
  reviewAction: ExpensePolicyReviewActionType;
}

/** Merchant-specific exceptions within an "allow category" configuration. */
export interface ExpensePolicyCategoryMerchantExceptions {
  /** Whether expenses at merchants not listed (in this category) should be allowed, reviewed, or blocked */
  allOthers: ExpensePolicyReviewActionType;
  /** Configuration for individual merchants */
  merchantExceptions: Array<ExpensePolicyCategoryMerchantException>;
}

/** Merchant-specific exceptions within an "allow category" configuration. */
export interface ExpensePolicyCategoryMerchantExceptionsInput {
  /** Whether expenses at merchants not listed (in this category) should be allowed, reviewed, or blocked */
  allOthers: ExpensePolicyReviewActionType;
  /** Configuration for individual merchants */
  merchantExceptions: Array<ExpensePolicyCategoryMerchantExceptionInput>;
}

/** Merchant category-level receipts configuration */
export interface ExpensePolicyCategoryReceiptException {
  /** Merchant category */
  category: ExtendedMerchantCategory;
  /** Itemization requirement. Guaranteed to be non-null if requiredAbove is non-null */
  itemizationRequirement?: Maybe<ExpensePolicyReceiptExceptionItemizationRequirement>;
  /** If provided, receipts are required above this amount. If null, receipts not required. */
  requiredAbove?: Maybe<Scalars["Decimal"]>;
}

/** Merchant category-level receipts configuration */
export interface ExpensePolicyCategoryReceiptExceptionInput {
  /** Merchant category */
  category: ExtendedMerchantCategoryOneOfInput;
  /** Itemization requirement. If null, we use the requirement on the top-level ExpensePolicyReceiptRequirementRulesInput */
  itemizationRequirement?: InputMaybe<ExpensePolicyReceiptExceptionItemizationRequirement>;
  /** If provided, receipts are required above this amount. If null, receipts not required. */
  requiredAbove?: InputMaybe<Scalars["Decimal"]>;
}

/** A category-specific review rule. May be "Allow," "Review," or "Block," but all share a merchant category and notes. */
export interface ExpensePolicyCategoryReviewRule {
  category: ExtendedMerchantCategory;
  notes: Scalars["String"];
}

/** A category-specific review rule. May be "Allow," "Review," or "Block," but all share a merchant category and notes. */
export interface ExpensePolicyCategoryReviewRuleOneOfInput {
  allow?: InputMaybe<ExpensePolicyAllowCategoryInput>;
  block?: InputMaybe<ExpensePolicyBlockCategoryInput>;
  review?: InputMaybe<ExpensePolicyReviewCategoryInput>;
}

/**
 * A condition for a rule.
 *
 * The condition matches if it produces a TRUE result when AND-ing the result of all inner conditions.
 * Unset or null fields are considered to be TRUE, meaning an empty condition will always be evaluated
 * as TRUE.
 */
export interface ExpensePolicyCondition {
  addendumTypeCondition?: Maybe<PolicyAddendumTypeCondition>;
  amountCondition?: Maybe<PolicyAmountCondition>;
  bookingDaysInAdvanceCondition?: Maybe<PolicyBookingDaysInAdvanceCondition>;
  bookingOutOfPolicyCondition?: Maybe<PolicyBookingOutOfPolicyCondition>;
  bookingTypeCondition?: Maybe<PolicyBookingTypeCondition>;
  employeeCostCenterIdCondition?: Maybe<PolicyEmployeeCostCenterIdCondition>;
  employeeDepartmentIdCondition?: Maybe<PolicyEmployeeDepartmentIdCondition>;
  employeeLegalEntityIdCondition?: Maybe<PolicyEmployeeLegalEntityIdCondition>;
  employeeTitleIdCondition?: Maybe<PolicyEmployeeTitleIdCondition>;
  employmentStatusCondition?: Maybe<PolicyEmploymentStatusCondition>;
  employmentTypeCondition?: Maybe<PolicyEmploymentTypeCondition>;
  expenseTypeCondition?: Maybe<PolicyExpenseTypeCondition>;
  extendedFieldCondition?: Maybe<PolicyExtendedFieldCondition>;
  flightCabinClassCondition?: Maybe<PolicyFlightCabinClassCondition>;
  flightTicketChangeRulesCondition?: Maybe<PolicyFlightTicketChangeRulesCondition>;
  flightTicketRefundRulesCondition?: Maybe<PolicyFlightTicketRefundRulesCondition>;
  govOfficialAsAttendeeCondition?: Maybe<PolicyGovOfficialAsAttendeeCondition>;
  lodgingAdministrativeAreaCondition?: Maybe<PolicyLodgingAdministrativeAreaCondition>;
  lodgingAverageNightlyRateCondition?: Maybe<PolicyLodgingAverageNightlyRateCondition>;
  lodgingCityCondition?: Maybe<PolicyLodgingCityCondition>;
  lodgingStarRatingCondition?: Maybe<PolicyLodgingStarRatingCondition>;
  managerAsAttendeeCondition?: Maybe<PolicyManagerAsAttendeeCondition>;
  mealPerDiemCondition?: Maybe<PolicyMealPerDiemCondition>;
  merchantCategoryCondition?: Maybe<PolicyMerchantCategoryCondition>;
  merchantCondition?: Maybe<PolicyMerchantCondition>;
  percentDifferenceFromLowestLogicalFareCondition?: Maybe<PolicyPercentDifferenceFromLowestLogicalFareCondition>;
  percentDifferenceFromMedianPriceCondition?: Maybe<PolicyPercentDifferenceFromMedianPriceCondition>;
  receiptItemCategoryCondition?: Maybe<PolicyReceiptItemCategoryCondition>;
  receiptValidationResultCondition?: Maybe<PolicyReceiptValidationResultCondition>;
  rentalCarAverageDailyRateCondition?: Maybe<PolicyRentalCarAverageDailyRateCondition>;
  rentalCarClassCondition?: Maybe<PolicyRentalCarClassCondition>;
  secondsSincePurchaseCondition?: Maybe<PolicySecondsSincePurchaseCondition>;
  trainCabinClassCondition?: Maybe<PolicyTrainCabinClassCondition>;
  travelDestinationCountryCodeCondition?: Maybe<PolicyTravelDestinationCountryCodeCondition>;
  travelDestinationTypeCondition?: Maybe<PolicyTravelDestinationTypeCondition>;
  tripLegFlightDurationCondition?: Maybe<PolicyTripLegFlightDurationCondition>;
  tripLegTrainDurationCondition?: Maybe<PolicyTripLegTrainDurationCondition>;
  vatEligibilityCondition?: Maybe<PolicyVatEligibilityCondition>;
  vatInputValueEligibilityCondition?: Maybe<PolicyVatInputValueEligibilityCondition>;
}

/**
 * A condition for a rule.
 *
 * The condition matches if it produces a TRUE result when AND-ing the result of all inner conditions.
 * Unset or null fields are considered to be TRUE, meaning an empty condition will always be evaluated
 * as TRUE.
 */
export interface ExpensePolicyConditionInput {
  addendumTypeCondition?: InputMaybe<PolicyAddendumTypeConditionInput>;
  amountCondition?: InputMaybe<PolicyAmountConditionInput>;
  bookingDaysInAdvanceCondition?: InputMaybe<PolicyBookingDaysInAdvanceConditionInput>;
  bookingOutOfPolicyCondition?: InputMaybe<PolicyBookingOutOfPolicyConditionInput>;
  bookingTypeCondition?: InputMaybe<PolicyBookingTypeConditionInput>;
  employeeCostCenterIdCondition?: InputMaybe<PolicyEmployeeCostCenterIdConditionInput>;
  employeeDepartmentIdCondition?: InputMaybe<PolicyEmployeeDepartmentIdConditionInput>;
  employeeLegalEntityIdCondition?: InputMaybe<PolicyEmployeeLegalEntityIdConditionInput>;
  employeeTitleIdCondition?: InputMaybe<PolicyEmployeeTitleIdConditionInput>;
  employmentStatusCondition?: InputMaybe<PolicyEmploymentStatusConditionInput>;
  employmentTypeCondition?: InputMaybe<PolicyEmploymentTypeConditionInput>;
  expenseTypeCondition?: InputMaybe<PolicyExpenseTypeConditionInput>;
  extendedFieldCondition?: InputMaybe<PolicyExtendedFieldConditionInput>;
  flightCabinClassCondition?: InputMaybe<PolicyFlightCabinClassConditionInput>;
  flightTicketChangeRulesCondition?: InputMaybe<PolicyFlightTicketChangeRulesConditionInput>;
  flightTicketRefundRulesCondition?: InputMaybe<PolicyFlightTicketRefundRulesConditionInput>;
  govOfficialAsAttendeeCondition?: InputMaybe<PolicyGovOfficialAsAttendeeConditionInput>;
  lodgingAdministrativeAreaCondition?: InputMaybe<PolicyLodgingAdministrativeAreaConditionInput>;
  lodgingAverageNightlyRateCondition?: InputMaybe<PolicyLodgingAverageNightlyRateConditionInput>;
  lodgingCityCondition?: InputMaybe<PolicyLodgingCityConditionInput>;
  lodgingStarRatingCondition?: InputMaybe<PolicyLodgingStarRatingConditionInput>;
  managerAsAttendeeCondition?: InputMaybe<PolicyManagerAsAttendeeConditionInput>;
  mealPerDiemCondition?: InputMaybe<PolicyMealPerDiemConditionInput>;
  merchantCategoryCondition?: InputMaybe<PolicyMerchantCategoryConditionInput>;
  merchantCondition?: InputMaybe<PolicyMerchantConditionInput>;
  percentDifferenceFromLowestLogicalFareCondition?: InputMaybe<PolicyPercentDifferenceFromLowestLogicalFareConditionInput>;
  percentDifferenceFromMedianPriceCondition?: InputMaybe<PolicyPercentDifferenceFromMedianPriceConditionInput>;
  receiptItemCategoryCondition?: InputMaybe<PolicyReceiptItemCategoryConditionInput>;
  receiptValidationResultCondition?: InputMaybe<PolicyReceiptValidationResultConditionInput>;
  rentalCarAverageDailyRateCondition?: InputMaybe<PolicyRentalCarAverageDailyRateConditionInput>;
  rentalCarClassCondition?: InputMaybe<PolicyRentalCarClassConditionInput>;
  secondsSincePurchaseCondition?: InputMaybe<PolicySecondsSincePurchaseConditionInput>;
  trainCabinClassCondition?: InputMaybe<PolicyTrainCabinClassConditionInput>;
  travelDestinationCountryCodeCondition?: InputMaybe<PolicyTravelDestinationCountryCodeConditionInput>;
  travelDestinationTypeCondition?: InputMaybe<PolicyTravelDestinationTypeConditionInput>;
  tripLegFlightDurationCondition?: InputMaybe<PolicyTripLegFlightDurationConditionInput>;
  tripLegTrainDurationCondition?: InputMaybe<PolicyTripLegTrainDurationConditionInput>;
  vatEligibilityCondition?: InputMaybe<PolicyVatEligibilityConditionInput>;
  vatInputValueEligibilityCondition?: InputMaybe<PolicyVatInputValueEligibilityConditionInput>;
}

export enum ExpensePolicyCreationType {
  /** Policy that has been customized by user */
  CUSTOM = "CUSTOM",
  /** Policy based on a preset set by us */
  PRESET = "PRESET",
}

export enum ExpensePolicyExpenseCategoryRequirement {
  EXPENSE_CATEGORY_NOT_REQUIRED = "EXPENSE_CATEGORY_NOT_REQUIRED",
  EXPENSE_CATEGORY_REQUIRED = "EXPENSE_CATEGORY_REQUIRED",
}

/** Policy configuration which may differ depending on expense type (e.g. card or reimbursement) */
export interface ExpensePolicyExpenseTypeSpecificRules {
  /**
   * approvalChains ties together two concepts:
   * 1. Amount-based review requirement rules
   * 2. Amount-based approval chain rules
   *
   * If at least one ApprovalChainThreshold is provided here, then any expense whose amount matches or exceeds the
   * minimum threshold will require review. If multiple ApprovalChainThresholds are provided, then the approval chain
   * (i.e. list of reviewers and their review order) will be determined by the ApprovalChainThreshold with the highest
   * threshold value less than or equal to the expense amount.
   */
  approvalChains: Array<ExpensePolicyApprovalChainRule>;
  /** Role based exceptions for approval chains */
  approvalChainsExceptions: Array<ExpensePolicyApprovalChainsException>;
  /**
   * Sets a custom approval chain for expenses that require review but are under the minimum amount specified in
   * [approvalChains].
   */
  defaultApprovalChain: Array<PolicyApprovalStep>;
  /** If not null, configures auto-memo generation */
  generateAutoMemo?: Maybe<PolicyActionGenerateAutoMemo>;
  /** Configuration about which expenses require memos */
  memos: ExpensePolicyMemoRules;
  /** Configuration about which expenses require receipts, itemization, etc. */
  receipts: ExpensePolicyReceiptRules;
}

/** Policy configuration which may differ depending on expense type (e.g. card or reimbursement) */
export interface ExpensePolicyExpenseTypeSpecificRulesInput {
  /**
   * approvalChains ties together two concepts:
   * 1. Amount-based review requirement rules
   * 2. Amount-based approval chain rules
   *
   * If at least one ApprovalChainThreshold is provided here, then any expense whose amount matches or exceeds the
   * minimum threshold will require review. If multiple ApprovalChainThresholds are provided, then the approval chain
   * (i.e. list of reviewers and their review order) will be determined by the ApprovalChainThreshold with the highest
   * threshold value less than or equal to the expense amount.
   *
   * One important subtlety: some expenses below the minimum threshold may require review for non-amount-related reasons
   * (e.g. a merchant or category exception in ReviewRules). In this case, the ApprovalChainThreshold with the minimum
   * threshold value is used to determine the approval chain, unless [defaultApprovalChain] is set, in which case that
   * approval chain will be used.
   */
  approvalChains: Array<ExpensePolicyApprovalChainRuleInput>;
  /** Role based exceptions for approval chains */
  approvalChainsExceptions?: InputMaybe<
    Array<ExpensePolicyApprovalChainsExceptionInput>
  >;
  /**
   * Sets a custom approval chain for expenses that require review but are under the minimum amount specified in
   * [approvalChains]. (If not specified, the [approvalChain] with the lowest expense threshold will be used.)
   */
  defaultApprovalChain?: InputMaybe<Array<PolicyApprovalStepInput>>;
  /** If not null, configures auto-memo generation */
  generateAutoMemo?: InputMaybe<PolicyGenerateAutoMemoInput>;
  /** Configuration about which expenses require memos */
  memos: ExpensePolicyMemoRulesInput;
  /** Configuration about which expenses require receipts, itemization, etc. */
  receipts: ExpensePolicyReceiptRulesInput;
}

/**
 * Represents a policy that can be created or displayed through the Policy Creator. This is more restrictive than the
 * general Policy type, which represents policies that can be converted into policy-engine policies but which might not
 * necessarily be supported in other parts of our product.
 *
 * Notes: Policies have at most one currency. Every Decimal type in this message should be interpreted as a FinancialAsset
 * with the currency passed into the GenerateExpensePolicyRequest currency.
 */
export interface ExpensePolicyInput {
  accountingExtendedFieldsRequirement?: InputMaybe<ExpensePolicyAccountingExtendedFieldsRequirementInput>;
  /** Policy rules that only apply to bill pay expenses */
  billPay: ExpensePolicyBillPaySpecificRulesInput;
  /** More advanced rules for flights, lodging, etc. that have Brex Travel/Spotnana integrations. */
  brexTravel: ExpensePolicyBrexTravelRulesInput;
  /** Policy rules that only apply to card expenses */
  card: ExpensePolicyExpenseTypeSpecificRulesInput;
  /** Whether or not the user should be required to document an "expense category" (categorization defined by the company) */
  expenseCategoryRequirement: ExpensePolicyExpenseCategoryRequirement;
  /** Merchant- and category-based review rules, which apply regardless of expense type. */
  merchantAndCategory: ExpensePolicyMerchantAndCategoryRulesInput;
  /** [Airbnb-Demo] Review rules based on receipt attributes such as items, tip, etc */
  receiptReview?: InputMaybe<ReceiptReviewRulesInput>;
  /** Policy rules that only apply to reimbursement expenses */
  reimbursement: ExpensePolicyExpenseTypeSpecificRulesInput;
  /** Whether or not the user should be required to document an expense's VAT eligibility/rate. */
  vatRequirement: ExpensePolicyVatRequirement;
}

/** Lodging daily rate limit for a specific location */
export interface ExpensePolicyLodgingDailyRateByLocationRule {
  /** City name */
  city?: Maybe<Scalars["String"]>;
  /** Two-letter country code */
  countryCode?: Maybe<Scalars["String"]>;
  /** Google Places API ID used for FE purposes. Not used in rule evaluation. */
  googlePlacesId?: Maybe<Scalars["String"]>;
  /** Amount limit */
  maxDailyRate: Scalars["Decimal"];
  /** Two-letter state code */
  stateCode?: Maybe<Scalars["String"]>;
}

/** Lodging daily rate limit for a specific location */
export interface ExpensePolicyLodgingDailyRateByLocationRuleInput {
  /** City name */
  city?: InputMaybe<Scalars["String"]>;
  /** Two-letter country code */
  countryCode?: InputMaybe<Scalars["String"]>;
  /** Google Places API ID used for FE purposes. Not used in rule evaluation. */
  googlePlacesId?: InputMaybe<Scalars["String"]>;
  /** Amount limit */
  maxDailyRate: Scalars["Decimal"];
  /** Two-letter state code */
  stateCode?: InputMaybe<Scalars["String"]>;
}

/** Limits on the amount that may be spent for lodging on a daily basis, optionally by location. */
export interface ExpensePolicyLodgingDailyRateRules {
  /** Daily rate limit for lodging outside of listed locations */
  allOthers: Scalars["Decimal"];
  /** Location-based lodging rate limits */
  locationRules: Array<ExpensePolicyLodgingDailyRateByLocationRule>;
}

/** Limits on the amount that may be spent for lodging on a daily basis, optionally by location. */
export interface ExpensePolicyLodgingDailyRateRulesInput {
  /** Daily rate limit for lodging outside of listed locations */
  allOthers: Scalars["Decimal"];
  /** Location-based lodging rate limits */
  locationRules: Array<ExpensePolicyLodgingDailyRateByLocationRuleInput>;
}

/**
 * ######################
 *  Lodging configuration
 * ######################
 */
export interface ExpensePolicyLodgingRules {
  /** The kind of approval that hotels booked via Brex Travel will be subject to. The default should be NONE. */
  bookingApprovalType?: Maybe<BookingApprovalType>;
  /** Limits on the amount that may be spent for lodging on a daily basis, optionally by location. Null = no limits */
  dailyRateRules?: Maybe<ExpensePolicyLodgingDailyRateRules>;
  /**
   * Variants of these settings that apply to specific users.
   *
   * NOTE: If the ExpensePolicy contains exceptions in its non-Brex-Travel "Lodging" rule (i.e. in
   * ExpensePolicy.merchantAndCategory.categoryRules), then we guarantee that this list contains the same number and
   * order of exceptions as the category-level exceptions list.
   */
  exceptions: Array<ExpensePolicyLodgingRulesException>;
  /** The max star rating allowed for lodging bookings. Null = no limit */
  maxStars?: Maybe<Scalars["Int"]>;
  /** Minimum number of days in advance that lodging must be booked. Null = no limits */
  minDaysInAdvance?: Maybe<Scalars["Int"]>;
}

/**
 * This is identical to ExpensePolicyLodgingRules, except it does not contain a list of exceptions, and instead contains an
 * ExceptionScope to identify which users this exception should apply to. For field documentation, refer to the
 * non-exception type.
 */
export interface ExpensePolicyLodgingRulesException {
  bookingApprovalType?: Maybe<BookingApprovalType>;
  dailyRateRules?: Maybe<ExpensePolicyLodgingDailyRateRules>;
  exceptionScope: PolicyExceptionScope;
  maxStars?: Maybe<Scalars["Int"]>;
  minDaysInAdvance?: Maybe<Scalars["Int"]>;
  /** Preview group for migration of role-based exceptions */
  previewUserGroup?: Maybe<PreviewUserGroup>;
  /** Group of users that this exception applies to. */
  userGroup?: Maybe<Group>;
}

/**
 * This is identical to ExpensePolicyLodgingRulesInput, except it does not contain a list of exceptions, and instead
 * contains an ExceptionScope to identify which users this exception should apply to. For field documentation, refer to the
 * non-exception type.
 */
export interface ExpensePolicyLodgingRulesExceptionInput {
  bookingApprovalType?: InputMaybe<BookingApprovalType>;
  dailyRateRules?: InputMaybe<ExpensePolicyLodgingDailyRateRulesInput>;
  exceptionScope: PolicyExceptionScopeInput;
  maxStars?: InputMaybe<Scalars["Int"]>;
  minDaysInAdvance?: InputMaybe<Scalars["Int"]>;
  userGroup?: InputMaybe<ExceptionUserGroupInput>;
}

/**
 * ######################
 *  Lodging configuration
 * ######################
 */
export interface ExpensePolicyLodgingRulesInput {
  /** The kind of approval that hotels booked via Brex Travel will be subject to. The default should be NONE. */
  bookingApprovalType?: InputMaybe<BookingApprovalType>;
  /** Limits on the amount that may be spent for lodging on a daily basis, optionally by location. Null = no limits */
  dailyRateRules?: InputMaybe<ExpensePolicyLodgingDailyRateRulesInput>;
  /**
   * Variants of these settings that apply to specific users.
   *
   * NOTE: If the ExpensePolicyInput contains exceptions in its non-Brex-Travel "Lodging" rule (i.e. in
   * ExpensePolicyInput.merchantAndCategory.categoryRules), then this list MUST contain the same number and
   * order of exceptions as the category-level exceptions list. If there are no Brex Travel rules at all, then
   * ExpensePolicyBrexTravelRulesInput.lodging may be null, or this list may be empty..
   */
  exceptions?: InputMaybe<Array<ExpensePolicyLodgingRulesExceptionInput>>;
  /** The max star rating allowed for lodging bookings. Null = no limit */
  maxStars?: InputMaybe<Scalars["Int"]>;
  /** Minimum number of days in advance that lodging must be booked. Null = no limits */
  minDaysInAdvance?: InputMaybe<Scalars["Int"]>;
}

/** Cabin class restrictions by destination type. At least one of [domestic] and [international] will be not null. */
export interface ExpensePolicyMaxCabinClassByDestinationTypeRules {
  /** Cabin class restrictions for domestic flights */
  domestic?: Maybe<ExpensePolicyMaxCabinClassByFlightDurationRules>;
  /** Cabin class restrictions for international flights */
  international?: Maybe<ExpensePolicyMaxCabinClassByFlightDurationRules>;
}

/** Cabin class restrictions by destination type. At least one of [domestic] and [international] will be not null. */
export interface ExpensePolicyMaxCabinClassByDestinationTypeRulesInput {
  /** Cabin class restrictions for domestic flights */
  domestic?: InputMaybe<ExpensePolicyMaxCabinClassByFlightDurationRulesInput>;
  /** Cabin class restrictions for international flights */
  international?: InputMaybe<ExpensePolicyMaxCabinClassByFlightDurationRulesInput>;
}

/** An maximum cabin class paired with a flight duration under which that restriction applies */
export interface ExpensePolicyMaxCabinClassByFlightDurationRule {
  maxCabinClass: PolicyFlightCabinClass;
  maxDurationHours: Scalars["Int"];
}

/** An maximum cabin class paired with a flight duration under which that restriction applies */
export interface ExpensePolicyMaxCabinClassByFlightDurationRuleInput {
  maxCabinClass: PolicyFlightCabinClass;
  maxDurationHours: Scalars["Int"];
}

/** Rules about the cabin classes that may be booked for a flight depending on its duration. */
export interface ExpensePolicyMaxCabinClassByFlightDurationRules {
  /** Maximum cabin classes for flights above the maximum duration listed in [durationClasses] */
  allOthers: PolicyFlightCabinClass;
  /** Maximum cabin classes paired with flight durations under which those limits apply */
  durationRules: Array<ExpensePolicyMaxCabinClassByFlightDurationRule>;
}

/** Rules about the cabin classes that may be booked for a flight depending on its duration. */
export interface ExpensePolicyMaxCabinClassByFlightDurationRulesInput {
  /** Maximum cabin classes for flights above the maximum duration listed in [durationClasses] */
  allOthers: PolicyFlightCabinClass;
  /** Maximum cabin classes paired with flight durations under which those limits apply */
  durationRules: Array<ExpensePolicyMaxCabinClassByFlightDurationRuleInput>;
}

/**
 * Rules about allowed cabin classes. One can either set rules by flight duration, or by destination type (domestic or
 * international) *and* duration.
 */
export type ExpensePolicyMaxCabinClassRules =
  | ExpensePolicyMaxCabinClassByDestinationTypeRules
  | ExpensePolicyMaxCabinClassByFlightDurationRules;

/**
 * Rules about allowed cabin classes. One can either set rules by flight duration, or by destination type (domestic or
 * international) *and* duration.
 */
export interface ExpensePolicyMaxCabinClassRulesOneOfInput {
  byDestinationType?: InputMaybe<ExpensePolicyMaxCabinClassByDestinationTypeRulesInput>;
  byDuration?: InputMaybe<ExpensePolicyMaxCabinClassByFlightDurationRulesInput>;
}

/** A maximum rail class paired with a journey duration under which that restriction applies */
export interface ExpensePolicyMaxRailClassByJourneyDurationRule {
  maxDurationHours: Scalars["Int"];
  maxRailClass: PolicyTrainCabinClass;
}

/** A maximum rail class paired with a journey duration under which that restriction applies */
export interface ExpensePolicyMaxRailClassByJourneyDurationRuleInput {
  maxDurationHours: Scalars["Int"];
  maxRailClass: PolicyTrainCabinClass;
}

/** Rules about the rail classes that may be booked for a journey depending on its duration. */
export interface ExpensePolicyMaxRailClassByJourneyDurationRules {
  /** Maximum rail classes for journeys above the maximum duration listed in [durationClasses] */
  allOthers: PolicyTrainCabinClass;
  /** Maximum rail classes paired with journey durations under which those limits apply */
  durationRules: Array<ExpensePolicyMaxRailClassByJourneyDurationRule>;
}

/** Rules about the rail classes that may be booked for a journey depending on its duration. */
export interface ExpensePolicyMaxRailClassByJourneyDurationRulesInput {
  /** Maximum rail classes for journeys above the maximum duration listed in [durationClasses] */
  allOthers: PolicyTrainCabinClass;
  /** Maximum rail classes paired with journey durations under which those limits apply */
  durationRules: Array<ExpensePolicyMaxRailClassByJourneyDurationRuleInput>;
}

/** Configuration about which expenses require memos */
export interface ExpensePolicyMemoRules {
  /** Category exceptions to general memo requirements */
  categoryExceptions: Array<ExpensePolicyCategoryMemoException>;
  /** Role based exceptions for memo requirements */
  exceptions: Array<ExpensePolicyMemoRulesException>;
  /** Merchant exceptions to general memo requirements */
  merchantExceptions: Array<ExpensePolicyMerchantMemoException>;
  /** If provided, memos are required above this amount. If null, memos not required. */
  requiredAbove?: Maybe<Scalars["Decimal"]>;
}

export interface ExpensePolicyMemoRulesException {
  categoryExceptions: Array<ExpensePolicyCategoryMemoException>;
  exceptionScope: PolicyExceptionScope;
  merchantExceptions: Array<ExpensePolicyMerchantMemoException>;
  /** Preview group for migration of role-based exceptions */
  previewUserGroup?: Maybe<PreviewUserGroup>;
  requiredAbove?: Maybe<Scalars["Decimal"]>;
  /** Group of users that this exception applies to. */
  userGroup?: Maybe<Group>;
}

export interface ExpensePolicyMemoRulesExceptionInput {
  categoryExceptions: Array<ExpensePolicyCategoryMemoExceptionInput>;
  exceptionScope: PolicyExceptionScopeInput;
  merchantExceptions: Array<ExpensePolicyMerchantMemoExceptionInput>;
  requiredAbove?: InputMaybe<Scalars["Decimal"]>;
  userGroup?: InputMaybe<ExceptionUserGroupInput>;
}

/** Configuration about which expenses require memos */
export interface ExpensePolicyMemoRulesInput {
  /** Category exceptions to general memo requirements */
  categoryExceptions: Array<ExpensePolicyCategoryMemoExceptionInput>;
  /** Role based memo exceptions */
  exceptions?: Array<ExpensePolicyMemoRulesExceptionInput>;
  /** Merchant exceptions to general memo requirements */
  merchantExceptions: Array<ExpensePolicyMerchantMemoExceptionInput>;
  /** If provided, memos are required above this amount. If null, memos not required. */
  requiredAbove?: InputMaybe<Scalars["Decimal"]>;
}

/** Merchant- and category-based review rules, which apply regardless of expense type. */
export interface ExpensePolicyMerchantAndCategoryRules {
  /** Whether expenses for merchants and categories not listed require review. */
  allOthers: ExpensePolicyReviewDefaultActionType;
  /** Category-specific rules, which may include merchant-based sub-rules. */
  categoryRules: Array<ExpensePolicyCategoryReviewRule>;
  /** Merchant-specific rules */
  merchantRules: Array<ExpensePolicyMerchantReviewRule>;
}

/** Merchant- and category-based review rules, which apply regardless of expense type. */
export interface ExpensePolicyMerchantAndCategoryRulesInput {
  /** Whether expenses for merchants and categories not listed require review. */
  allOthers: ExpensePolicyReviewDefaultActionType;
  /** Category-specific rules, which may include merchant-based sub-rules. */
  categoryRules: Array<ExpensePolicyCategoryReviewRuleOneOfInput>;
  /** Merchant-specific rules */
  merchantRules: Array<ExpensePolicyMerchantReviewRuleOneOfInput>;
}

/**
 * Similar to an "allow" merchant rule, but specified as an "exception." In this case, the merchant name is known from
 * context.
 */
export interface ExpensePolicyMerchantException {
  amountLimit?: Maybe<Scalars["Decimal"]>;
  exceptionScope: PolicyExceptionScope;
  notes: Scalars["String"];
  /** Preview group for migration of role-based exceptions */
  previewUserGroup?: Maybe<PreviewUserGroup>;
  /** Group of users that this exception applies to. */
  userGroup?: Maybe<Group>;
}

/**
 * Similar to an "allow" merchant rule, but specified as an "exception." In this case, the merchant name is known from
 * context.
 */
export interface ExpensePolicyMerchantExceptionInput {
  amountLimit?: InputMaybe<Scalars["Decimal"]>;
  exceptionScope: PolicyExceptionScopeInput;
  notes?: Scalars["String"];
  userGroup?: InputMaybe<ExceptionUserGroupInput>;
}

/** Merchant-level memo configuration */
export interface ExpensePolicyMerchantMemoException {
  /** Merchant name */
  name: Scalars["String"];
  /** If provided, memos are required above this amount. If null, memos not required. */
  requiredAbove?: Maybe<Scalars["Decimal"]>;
}

/** Merchant-level memo configuration */
export interface ExpensePolicyMerchantMemoExceptionInput {
  /** Merchant name */
  name: Scalars["String"];
  /** If provided, memos are required above this amount. If null, memos not required. */
  requiredAbove?: InputMaybe<Scalars["Decimal"]>;
}

/** Merchant-level receipts configuration */
export interface ExpensePolicyMerchantReceiptException {
  /** Itemization requirement. Guaranteed to be non-null if requiredAbove is non-null */
  itemizationRequirement?: Maybe<ExpensePolicyReceiptExceptionItemizationRequirement>;
  /** Merchant name */
  name: Scalars["String"];
  /** If provided, receipts are required above this amount. If null, receipts not required. */
  requiredAbove?: Maybe<Scalars["Decimal"]>;
}

/** Merchant-level receipts configuration */
export interface ExpensePolicyMerchantReceiptExceptionInput {
  /** Itemization requirement. If null, we use the requirement on the top-level ExpensePolicyReceiptRequirementRulesInput */
  itemizationRequirement?: InputMaybe<ExpensePolicyReceiptExceptionItemizationRequirement>;
  /** Merchant name */
  name: Scalars["String"];
  /** If provided, receipts are required above this amount. If null, receipts not required. */
  requiredAbove?: InputMaybe<Scalars["Decimal"]>;
}

/** A merchant-specific review rule. May be "Review," "Block," or "Allow," but all share a merchant name and notes. */
export interface ExpensePolicyMerchantReviewRule {
  /** Merchant name */
  name: Scalars["String"];
  /** User-provided notes */
  notes: Scalars["String"];
}

/** A merchant-specific review rule. May be "Review," "Block," or "Allow," but all share a merchant name and notes. */
export interface ExpensePolicyMerchantReviewRuleOneOfInput {
  allow?: InputMaybe<ExpensePolicyAllowMerchantInput>;
  block?: InputMaybe<ExpensePolicyBlockMerchantInput>;
  review?: InputMaybe<ExpensePolicyReviewMerchantInput>;
}

/** Rules and restrictions governing car rentals */
export interface ExpensePolicyRailRules {
  /** Rules about the rail classes that may be booked for a journey depending on its duration. */
  allowedRailClassesByDuration?: Maybe<ExpensePolicyMaxRailClassByJourneyDurationRules>;
  /** Rules about the amount one may spend on rail travel based on its duration. Null = no limits */
  amountLimitsByDuration?: Maybe<ExpensePolicyAmountLimitByFlightDurationRules>;
  /** The kind of approval that rail travel booked via Brex Travel will be subject to. The default should be NONE. */
  bookingApprovalType?: Maybe<BookingApprovalType>;
  /**
   * Variants of these settings that apply to specific users.
   *
   * NOTE: If the ExpensePolicy contains exceptions in its non-Brex-Travel "Public transportation" rule (i.e. in
   * ExpensePolicy.merchantAndCategory.categoryRules), then we guarantee that this list contains the same number and
   * order of exceptions as the category-level exceptions list.
   */
  exceptions: Array<ExpensePolicyRailRulesException>;
  /** Minimum number of days in advance that rail travel must be booked. Null = no limits */
  minDaysInAdvance?: Maybe<Scalars["Int"]>;
  /** What refundability conditions are allowed on a user's flight booking. Null = no limits */
  ticketRefundability?: Maybe<ExpensePolicyAllowedTicketRefundability>;
}

/**
 * This is identical to ExpensePolicyRailRules, except it does not contain a list of exceptions, and instead contains an
 * ExceptionScope to identify which users this exception should apply to. For field documentation, refer to the
 * non-exception type.
 */
export interface ExpensePolicyRailRulesException {
  allowedRailClassesByDuration?: Maybe<ExpensePolicyMaxRailClassByJourneyDurationRules>;
  amountLimitsByDuration?: Maybe<ExpensePolicyAmountLimitByFlightDurationRules>;
  bookingApprovalType?: Maybe<BookingApprovalType>;
  exceptionScope: PolicyExceptionScope;
  minDaysInAdvance?: Maybe<Scalars["Int"]>;
  /** Preview group for migration of role-based exceptions */
  previewUserGroup?: Maybe<PreviewUserGroup>;
  ticketRefundability?: Maybe<ExpensePolicyAllowedTicketRefundability>;
  /** Group of users that this exception applies to. */
  userGroup?: Maybe<Group>;
}

export interface ExpensePolicyRailRulesExceptionInput {
  allowedRailClassesByDuration?: InputMaybe<ExpensePolicyMaxRailClassByJourneyDurationRulesInput>;
  amountLimitsByDuration?: InputMaybe<ExpensePolicyAmountLimitByFlightDurationRulesInput>;
  bookingApprovalType?: InputMaybe<BookingApprovalType>;
  exceptionScope: PolicyExceptionScopeInput;
  minDaysInAdvance?: InputMaybe<Scalars["Int"]>;
  ticketRefundability?: InputMaybe<ExpensePolicyAllowedTicketRefundability>;
  userGroup?: InputMaybe<ExceptionUserGroupInput>;
}

/** Rules and restrictions governing rail travel */
export interface ExpensePolicyRailRulesInput {
  /** Rules about the rail classes that may be booked for a journey depending on its duration. */
  allowedRailClassesByDuration?: InputMaybe<ExpensePolicyMaxRailClassByJourneyDurationRulesInput>;
  /** Rules about the amount one may spend on rail travel based on its duration. Null = no limits */
  amountLimitsByDuration?: InputMaybe<ExpensePolicyAmountLimitByFlightDurationRulesInput>;
  /** The kind of approval that rail travel booked via Brex Travel will be subject to. The default should be NONE. */
  bookingApprovalType?: InputMaybe<BookingApprovalType>;
  /**
   * Variants of these settings that apply to specific users.
   *
   * NOTE: If the ExpensePolicy contains exceptions in its non-Brex-Travel "Public transportation" rule (i.e. in
   * ExpensePolicy.merchantAndCategory.categoryRules), then we guarantee that this list contains the same number and
   * order of exceptions as the category-level exceptions list.
   */
  exceptions?: InputMaybe<Array<ExpensePolicyRailRulesExceptionInput>>;
  /** Minimum number of days in advance that rail travel must be booked. Null = no limits */
  minDaysInAdvance?: InputMaybe<Scalars["Int"]>;
  /** What refundability conditions are allowed on a user's rail booking. Null = no limits */
  ticketRefundability?: InputMaybe<ExpensePolicyAllowedTicketRefundability>;
}

export enum ExpensePolicyReason {
  CATEGORY_VIOLATION = "CATEGORY_VIOLATION",
  MERCHANT_VIOLATION = "MERCHANT_VIOLATION",
  PER_DIEM_VIOLATION = "PER_DIEM_VIOLATION",
}

export interface ExpensePolicyReasonV3 {
  description: Scalars["String"];
  reasonType: Scalars["String"];
}

/** Receipt itemization requirement for specific merchant/category exceptions */
export enum ExpensePolicyReceiptExceptionItemizationRequirement {
  NOT_REQUIRED = "NOT_REQUIRED",
  REQUIRED = "REQUIRED",
}

/** Receipt itemization requirement. */
export enum ExpensePolicyReceiptItemizationRequirement {
  ALWAYS_REQUIRED = "ALWAYS_REQUIRED",
  NOT_REQUIRED = "NOT_REQUIRED",
  /**
   * REQUIRED_FOR_TAX_COMPLIANCE effectively means required for a Brex-managed list of recommended categories. We don't
   * currently support itemization settings on individual category exceptions.
   */
  REQUIRED_FOR_TAX_COMPLIANCE = "REQUIRED_FOR_TAX_COMPLIANCE",
}

/** Configuration that is necessary when receipts are required on a non-exception basis */
export interface ExpensePolicyReceiptRequirementRules {
  /** Itemization requirement */
  itemizedRequirement: ExpensePolicyReceiptItemizationRequirement;
  /** The threshold amount over which receipts are required */
  requiredAbove: Scalars["Decimal"];
}

/** Configuration that is necessary when receipts are required on a non-exception basis */
export interface ExpensePolicyReceiptRequirementRulesInput {
  /** Itemization requirement */
  itemizedRequirement: ExpensePolicyReceiptItemizationRequirement;
  /** The threshold amount over which receipts are required */
  requiredAbove: Scalars["Decimal"];
}

/** Configuration about which expenses require receipts, itemization, etc. */
export interface ExpensePolicyReceiptRules {
  /** Category exceptions to general receipt requirements */
  categoryExceptions: Array<ExpensePolicyCategoryReceiptException>;
  /** Role based exceptions for receipt requirements */
  exceptions: Array<ExpensePolicyReceiptRulesException>;
  /** Merchant exceptions to general receipt requirements */
  merchantExceptions: Array<ExpensePolicyMerchantReceiptException>;
  /**
   * Configuration of "general" receipt requirements (including thresholds, itemization, etc.) If this field is absent,
   * then receipts are not required except for listed merchant and category exceptions.
   */
  receiptsRequired?: Maybe<ExpensePolicyReceiptRequirementRules>;
}

export interface ExpensePolicyReceiptRulesException {
  categoryExceptions: Array<ExpensePolicyCategoryReceiptException>;
  exceptionScope: PolicyExceptionScope;
  merchantExceptions: Array<ExpensePolicyMerchantReceiptException>;
  /** Preview group for migration of role-based exceptions */
  previewUserGroup?: Maybe<PreviewUserGroup>;
  receiptsRequired?: Maybe<ExpensePolicyReceiptRequirementRules>;
  /** Group of users that this exception applies to. */
  userGroup?: Maybe<Group>;
}

export interface ExpensePolicyReceiptRulesExceptionInput {
  categoryExceptions: Array<ExpensePolicyCategoryReceiptExceptionInput>;
  exceptionScope: PolicyExceptionScopeInput;
  merchantExceptions: Array<ExpensePolicyMerchantReceiptExceptionInput>;
  receiptsRequired?: InputMaybe<ExpensePolicyReceiptRequirementRulesInput>;
  userGroup?: InputMaybe<ExceptionUserGroupInput>;
}

/** Configuration about which expenses require receipts, itemization, etc. */
export interface ExpensePolicyReceiptRulesInput {
  /** Category exceptions to general receipt requirements */
  categoryExceptions: Array<ExpensePolicyCategoryReceiptExceptionInput>;
  /** Role-based receipt exceptions */
  exceptions?: Array<ExpensePolicyReceiptRulesExceptionInput>;
  /** Merchant exceptions to general receipt requirements */
  merchantExceptions: Array<ExpensePolicyMerchantReceiptExceptionInput>;
  /**
   * Configuration of "general" receipt requirements (including thresholds, itemization, etc.) If this field is absent,
   * then receipts are not required except for listed merchant and category exceptions.
   */
  receiptsRequired?: InputMaybe<ExpensePolicyReceiptRequirementRulesInput>;
}

/** An enum expressing whether some kind of expense should be allowed, reviewed, or blocked */
export enum ExpensePolicyReviewActionType {
  ALLOW = "ALLOW",
  BLOCK = "BLOCK",
  REVIEW = "REVIEW",
}

/** A merchant category "review" rule. Expenses with this merchant category require review. */
export interface ExpensePolicyReviewCategory
  extends ExpensePolicyCategoryReviewRule {
  category: ExtendedMerchantCategory;
  notes: Scalars["String"];
}

/** A merchant category "review" rule. Expenses with this merchant category require review. */
export interface ExpensePolicyReviewCategoryInput {
  category: ExtendedMerchantCategoryOneOfInput;
  notes: Scalars["String"];
}

/**
 * An enum expressing whether some kind of expense should be allowed or reviewed. This is distinct from ReviewActionType
 * because we don't allow all expenses to be blocked at the top level.
 */
export enum ExpensePolicyReviewDefaultActionType {
  ALLOW = "ALLOW",
  BLOCK = "BLOCK",
  REVIEW = "REVIEW",
}

/** A merchant "review" rule. Expenses at this merchant require review. */
export interface ExpensePolicyReviewMerchant
  extends ExpensePolicyMerchantReviewRule {
  name: Scalars["String"];
  notes: Scalars["String"];
}

/** A merchant "review" rule. Expenses at this merchant require review. */
export interface ExpensePolicyReviewMerchantInput {
  name: Scalars["String"];
  notes: Scalars["String"];
}

/** An expense policy specification that includes custom textual blocks and workflow blocks. */
export interface ExpensePolicySpec {
  /** The blocks that compose this policy specification. */
  blocks: Array<ExpensePolicySpecSectionBlock>;
  /** Whether expense category is enabled for this cuacc */
  isExpenseCategoryEnabled: Scalars["Boolean"];
  /** Whether VAT is enabled for this cuacc */
  isVatEnabled: Scalars["Boolean"];
  /** The modification date of this policy. Effectively the `createdAt` of this version */
  updatedAt: Scalars["LocalDateTime"];
}

export interface ExpensePolicySpecFilterInput {
  /**
   * By default, returns policy rules in the same currencies they are written
   * If provided, returns all rules converted to the displayCurrency
   */
  displayCurrency?: InputMaybe<Scalars["String"]>;
  /** Whether to include all policy rules or only those relevant to the requester */
  rulesFilter: PolicyRulesFilter;
  /** The ID of the policy section to get, in addition to General */
  sectionId?: InputMaybe<Scalars["ID"]>;
  /**
   * Whether to return whole policy builder or just sections that apply
   * If viewFilter = APPLIED_POLICY and sectionId is provided, it returns PolicySection + GeneralSection
   * If viewFilter = APPLIED_POLICY and sectionId is provided, it returns GeneralSection
   */
  viewFilter: PolicyViewFilter;
}

/** All possible expense policy blocks */
export type ExpensePolicySpecInnerBlock =
  | ExpensePolicySpecSectionBlock
  | ExpensePolicyWorkflowContainerBlock;

export interface ExpensePolicySpecInnerBlockInput {
  expensePolicySpecSectionBlock?: InputMaybe<ExpensePolicySpecSectionBlockInput>;
  expensePolicyWorkflowContainerBlock?: InputMaybe<ExpensePolicyWorkflowContainerBlockInput>;
}

/** An expense policy specification that includes custom textual blocks and workflow blocks. */
export interface ExpensePolicySpecInput {
  /** The blocks that compose this policy specification. */
  blocks: Array<ExpensePolicySpecSectionBlockInput>;
}

export interface ExpensePolicySpecSectionBlock {
  blocks: Array<ExpensePolicySpecInnerBlock>;
  description?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["ID"]>;
  /** Whether expense category is required for this section */
  isExpenseCategoryRequired?: Maybe<Scalars["Boolean"]>;
  /** Whether VAT is required for this section */
  isVatRequired?: Maybe<Scalars["Boolean"]>;
  policy?: Maybe<Policy>;
  position?: Maybe<Scalars["Int"]>;
  /** Preconditions applied to this block. Null means no preconditions */
  precondition?: Maybe<ExpensePolicySpecSectionPrecondition>;
  relatedFeatures?: Maybe<Array<RelatedFeature>>;
  status?: Maybe<PolicySpecSectionStatus>;
  title: Scalars["String"];
  type: ExpensePolicySpecSectionType;
  version?: Maybe<Scalars["Int"]>;
}

export interface ExpensePolicySpecSectionBlockInput {
  blocks: Array<ExpensePolicySpecInnerBlockInput>;
  description?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["ID"]>;
  /** Whether or not expense category is required for this section */
  isExpenseCategoryRequired?: InputMaybe<Scalars["Boolean"]>;
  /** Whether or not VAT is required for this section */
  isVatRequired?: InputMaybe<Scalars["Boolean"]>;
  position?: Scalars["Int"];
  /** Conditions prepended to this section */
  precondition?: InputMaybe<ExpensePolicySpecSectionPreconditionInput>;
  relatedFeatures?: Array<RelatedFeature>;
  title: Scalars["String"];
  type: ExpensePolicySpecSectionType;
}

export interface ExpensePolicySpecSectionPrecondition {
  conditions: Array<IMatchCondition>;
  operator: WorkflowBlockLogicOperator;
}

/** Definition of the section prepended conditions */
export interface ExpensePolicySpecSectionPreconditionInput {
  conditions: Array<ExpensePolicySpecSectionPreconditionOneOfInput>;
  operator: WorkflowBlockLogicOperator;
}

export interface ExpensePolicySpecSectionPreconditionOneOfInput {
  booleanMatchCondition?: InputMaybe<WorkflowBooleanMatchConditionInput>;
  durationMatchCondition?: InputMaybe<WorkflowDurationMatchConditionInput>;
  enumeratedListMatchCondition?: InputMaybe<WorkflowEnumeratedListMatchConditionInput>;
  enumeratedMatchCondition?: InputMaybe<WorkflowEnumeratedMatchConditionInput>;
  financialAssetMatchCondition?: InputMaybe<WorkflowFinancialAssetMatchConditionInput>;
  identifierMatchCondition?: InputMaybe<WorkflowIdentifierMatchConditionInput>;
  locationMatchCondition?: InputMaybe<WorkflowLocationMatchConditionInput>;
  numberMatchCondition?: InputMaybe<WorkflowNumberMatchConditionInput>;
  stringMatchCondition?: InputMaybe<WorkflowStringMatchConditionInput>;
}

export enum ExpensePolicySpecSectionType {
  BILL_PAY = "BILL_PAY",
  CUSTOM = "CUSTOM",
  GENERAL = "GENERAL",
  /** Indicating that the section was migrated from legacy policy */
  LEGACY = "LEGACY",
  /** Indicates that the section has preset defined rules and cannot be deleted. */
  OPINIONATED = "OPINIONATED",
  TRAVEL = "TRAVEL",
  TRAVEL_AIR = "TRAVEL_AIR",
  TRAVEL_CAR_RENTAL = "TRAVEL_CAR_RENTAL",
  TRAVEL_EXPENSE = "TRAVEL_EXPENSE",
  TRAVEL_LODGING = "TRAVEL_LODGING",
  TRAVEL_RAIL = "TRAVEL_RAIL",
}

export enum ExpensePolicyVatRequirement {
  VAT_NOT_REQUIRED = "VAT_NOT_REQUIRED",
  VAT_REQUIRED = "VAT_REQUIRED",
}

export enum ExpensePolicyViolationReason {
  AMOUNT = "AMOUNT",
  CAR_RENTAL = "CAR_RENTAL",
  FLIGHTS = "FLIGHTS",
  LODGING = "LODGING",
  MEALS = "MEALS",
  MERCHANT_OR_CATEGORY = "MERCHANT_OR_CATEGORY",
  MILEAGE = "MILEAGE",
  OTHERS = "OTHERS",
  TRAINS = "TRAINS",
}

export interface ExpensePolicyWorkflowAttributeDescriptor {
  /** If the attribute is AI-powered */
  isAI: Scalars["Boolean"];
}

/**  ----------- WORKFLOW BLOCKS ----------------- */
export type ExpensePolicyWorkflowBlock =
  | WorkflowBookingAllowActionBlock
  | WorkflowBookingFlagOutOfPolicyActionBlock
  | WorkflowBookingRequireApprovalActionBlock
  | WorkflowBookingSendNotificationActionBlock
  | WorkflowBooleanMatchCondition
  | WorkflowDurationMatchCondition
  | WorkflowEnumeratedListMatchCondition
  | WorkflowEnumeratedMatchCondition
  | WorkflowExpenseBlockSpendActionBlock
  | WorkflowExpenseDoNotRequireActionBlock
  | WorkflowExpenseGenerateAutoMemoActionBlock
  | WorkflowExpenseReceiptCategorizationActionBlock
  | WorkflowExpenseRequestReviewActionBlock
  | WorkflowExpenseRequireAttendeesActionBlock
  | WorkflowExpenseRequireExtendedFieldsActionBlock
  | WorkflowExpenseRequireInvoiceActionBlock
  | WorkflowExpenseRequireMemoActionBlock
  | WorkflowExpenseRequireReceiptActionBlock
  | WorkflowFinancialAssetFunctionMatchCondition
  | WorkflowFinancialAssetMatchCondition
  | WorkflowIdentifierMatchCondition
  | WorkflowLocationMatchCondition
  | WorkflowLogicOperatorConditionBlock
  | WorkflowNumberMatchCondition
  | WorkflowParallelBlock
  | WorkflowStringMatchCondition;

/** An expense-specific workflow container. */
export interface ExpensePolicyWorkflowContainerBlock {
  /**
   * A flat list of workflow blocks. A flat list is used here because
   * blocks can have children and GraphQL cannot do infinitely
   * recursive queries.
   */
  blocks: Array<ExpensePolicyWorkflowBlock>;
  description?: Maybe<Scalars["String"]>;
  /** The key of the start block. */
  startKey: Scalars["String"];
}

/** An expense-specific workflow container. */
export interface ExpensePolicyWorkflowContainerBlockInput {
  /**
   * A flat list of workflow blocks. A flat list is used here because
   * blocks can have children and GraphQL cannot do infinitely
   * recursive queries.
   */
  blocks: Array<WorkflowBlockOneOfInput>;
  description?: InputMaybe<Scalars["String"]>;
  /** The key of the start block. */
  startKey: Scalars["String"];
}

export interface ExpensePrice {
  exchangeRate?: Maybe<Scalars["String"]>;
  expiresAt?: Maybe<Scalars["Time"]>;
  fees?: Maybe<Array<Maybe<Fee>>>;
  id: Scalars["ID"];
  sourceAmount?: Maybe<FinancialAsset>;
  targetAmount?: Maybe<FinancialAsset>;
}

/** The display status of the expense; takes into account payment and disputes. */
export enum ExpensePrimitiveDisplayStatus {
  /** An approved expense is evaluated to have met the policy requirements. */
  APPROVED = "APPROVED",
  /** The expense got cancelled (from a submitted reimbursement or pending charge). */
  CANCELED = "CANCELED",
  /** Payment for the expense is a chargeback. */
  CHARGEBACK = "CHARGEBACK",
  /** Payment for the expense got declined, applies to card expense only. */
  DECLINED = "DECLINED",
  /** The expense was rejected. */
  DENIED = "DENIED",
  /**
   * The expense is disputed.
   *
   * NOT YET SUPPORTED
   */
  DISPUTED = "DISPUTED",
  /** An expense that has not been submitted yet, applies to reimbursement only. */
  DRAFT = "DRAFT",
  /** Payment for the expense completed. */
  PAID = "PAID",
  /** Payment for the expense failed to go through. */
  PAYMENT_FAILED = "PAYMENT_FAILED",
  /** The expense has open action requests - can include reviews, memos, etc. */
  PENDING_APPROVAL = "PENDING_APPROVAL",
  /** Payment for the expense is processing. */
  PROCESSING = "PROCESSING",
  /** Payment for the expense is a refund. */
  REFUND = "REFUND",
}

export enum ExpensePrimitiveDisputeStatuses {
  DISPUTE_STATUS_CANCELLED = "DISPUTE_STATUS_CANCELLED",
  DISPUTE_STATUS_CLOSED = "DISPUTE_STATUS_CLOSED",
  DISPUTE_STATUS_COMPLETE = "DISPUTE_STATUS_COMPLETE",
  DISPUTE_STATUS_IN_PROGRESS = "DISPUTE_STATUS_IN_PROGRESS",
}

/** Type of extended field value, currently only supports IDENTIFIER */
export enum ExpensePrimitiveExtendedFieldValueType {
  /** Identifier id type */
  IDENTIFIER = "IDENTIFIER",
}

export interface ExpensePrimitiveExtendedFieldValuesFilterInput {
  /** Extended field key */
  key: Scalars["String"];
  /** Type of extended field value */
  type: ExpensePrimitiveExtendedFieldValueType;
  /** Matches IN values for extended field key */
  values: Array<Scalars["String"]>;
}

/** The available fields that are queryable that relate to expenses */
export enum ExpensePrimitiveFieldKeyType {
  ALL = "ALL",
  BUDGET_NAME = "BUDGET_NAME",
  BUDGET_TEMPLATE_ID = "BUDGET_TEMPLATE_ID",
  EXPENSE_ADDENDUM_CONTAINS_GOVERNMENT_OFFICIAL = "EXPENSE_ADDENDUM_CONTAINS_GOVERNMENT_OFFICIAL",
  EXPENSE_BILLING_AMOUNT = "EXPENSE_BILLING_AMOUNT",
  EXPENSE_BUDGETS_BUDGET_ID = "EXPENSE_BUDGETS_BUDGET_ID",
  EXPENSE_BUDGET_AMOUNT = "EXPENSE_BUDGET_AMOUNT",
  EXPENSE_CARD_ID = "EXPENSE_CARD_ID",
  /** @deprecated use EXPENSE_VENDORS_CATEGORY_NAME instead */
  EXPENSE_CATEGORY_NAME = "EXPENSE_CATEGORY_NAME",
  EXPENSE_COST_CENTER_ID = "EXPENSE_COST_CENTER_ID",
  EXPENSE_CUSTOMER_ACCOUNT_ID = "EXPENSE_CUSTOMER_ACCOUNT_ID",
  EXPENSE_CUSTOMER_DEPARTMENT_ID = "EXPENSE_CUSTOMER_DEPARTMENT_ID",
  EXPENSE_CUSTOMER_INVARIANT_AMOUNT = "EXPENSE_CUSTOMER_INVARIANT_AMOUNT",
  EXPENSE_CUSTOMER_LOCATION_ID = "EXPENSE_CUSTOMER_LOCATION_ID",
  EXPENSE_CUSTOMER_USER_ID = "EXPENSE_CUSTOMER_USER_ID",
  /** # EXPENSE_CONTAINS_GOVERNMENT_OFFICIAL TODO pending decision */
  EXPENSE_ENTITIES_FUNDING_ENTITY_ID = "EXPENSE_ENTITIES_FUNDING_ENTITY_ID",
  /**  Risk tier */
  EXPENSE_EXPENSE_RISK_TIER = "EXPENSE_EXPENSE_RISK_TIER",
  EXPENSE_EXPENSE_STATUS = "EXPENSE_EXPENSE_STATUS",
  EXPENSE_EXPENSE_TYPE = "EXPENSE_EXPENSE_TYPE",
  EXPENSE_ID = "EXPENSE_ID",
  EXPENSE_INSERTED_AT = "EXPENSE_INSERTED_AT",
  EXPENSE_LEGAL_ENTITY_ID = "EXPENSE_LEGAL_ENTITY_ID",
  EXPENSE_MEMO = "EXPENSE_MEMO",
  /** @deprecated use EXPENSE_VENDORS_CATEGORY_ID instead */
  EXPENSE_MERCHANTS_CATEGORY_ID = "EXPENSE_MERCHANTS_CATEGORY_ID",
  /** @deprecated use EXPENSE_VENDORS_VENDOR_ID instead */
  EXPENSE_MERCHANTS_MERCHANT_ID = "EXPENSE_MERCHANTS_MERCHANT_ID",
  EXPENSE_ORIGINAL_AMOUNT = "EXPENSE_ORIGINAL_AMOUNT",
  EXPENSE_PARENT_ID = "EXPENSE_PARENT_ID",
  EXPENSE_PAYMENTS_PAYMENT_ID = "EXPENSE_PAYMENTS_PAYMENT_ID",
  EXPENSE_PAYMENTS_PAYMENT_POST_ID = "EXPENSE_PAYMENTS_PAYMENT_POST_ID",
  EXPENSE_PAYMENT_STATUS = "EXPENSE_PAYMENT_STATUS",
  EXPENSE_POLICY_VIOLATION_REASON = "EXPENSE_POLICY_VIOLATION_REASON",
  EXPENSE_POSTED_AT = "EXPENSE_POSTED_AT",
  EXPENSE_PURCHASED_AMOUNT = "EXPENSE_PURCHASED_AMOUNT",
  EXPENSE_PURCHASED_AT = "EXPENSE_PURCHASED_AT",
  EXPENSE_PURCHASED_AT_DAY = "EXPENSE_PURCHASED_AT_DAY",
  EXPENSE_PURCHASED_AT_MONTH = "EXPENSE_PURCHASED_AT_MONTH",
  EXPENSE_PURCHASED_AT_WEEK = "EXPENSE_PURCHASED_AT_WEEK",
  EXPENSE_RECEIPT_COUNT = "EXPENSE_RECEIPT_COUNT",
  EXPENSE_REQUESTS_REQUEST_ID = "EXPENSE_REQUESTS_REQUEST_ID",
  EXPENSE_STATUS_AT = "EXPENSE_STATUS_AT",
  EXPENSE_UPDATED_AT = "EXPENSE_UPDATED_AT",
  EXPENSE_USER_CATEGORY_ID = "EXPENSE_USER_CATEGORY_ID",
  EXPENSE_VENDORS_CATEGORY_ID = "EXPENSE_VENDORS_CATEGORY_ID",
  EXPENSE_VENDORS_CATEGORY_NAME = "EXPENSE_VENDORS_CATEGORY_NAME",
  EXPENSE_VENDORS_VENDOR_ID = "EXPENSE_VENDORS_VENDOR_ID",
  EXPENSE_VENDORS_VENDOR_NAME = "EXPENSE_VENDORS_VENDOR_NAME",
  EXTENDED_FIELD_VALUE_KEY = "EXTENDED_FIELD_VALUE_KEY",
  EXTENDED_FIELD_VALUE_VALUE = "EXTENDED_FIELD_VALUE_VALUE",
  MANAGER_RELATIONSHIP_CUSTOMER_USER_ID = "MANAGER_RELATIONSHIP_CUSTOMER_USER_ID",
  MANAGER_RELATIONSHIP_DEPTH = "MANAGER_RELATIONSHIP_DEPTH",
  /** @deprecated use EXPENSE_VENDORS_CATEGORY_NAME instead */
  MERCHANT_CATEGORY_NAME = "MERCHANT_CATEGORY_NAME",
  /** @deprecated use EXPENSE_VENDORS_VENDOR_NAME instead */
  MERCHANT_NAME = "MERCHANT_NAME",
  REQUEST_ACTION_ACTION_STATUS = "REQUEST_ACTION_ACTION_STATUS",
  REQUEST_ACTION_ACTION_TYPE = "REQUEST_ACTION_ACTION_TYPE",
  REQUEST_ACTION_OWNER_INSERTED_AT = "REQUEST_ACTION_OWNER_INSERTED_AT",
  REQUEST_ACTION_OWNER_OWNER_USER_ID = "REQUEST_ACTION_OWNER_OWNER_USER_ID",
  REQUEST_ACTION_UPDATED_AT = "REQUEST_ACTION_UPDATED_AT",
  REQUEST_COMPLIANCE_STATUS = "REQUEST_COMPLIANCE_STATUS",
  REQUEST_CREATED_AT = "REQUEST_CREATED_AT",
  REQUEST_DERIVED_COMPLIANCE_STATUS = "REQUEST_DERIVED_COMPLIANCE_STATUS",
  REQUEST_REVIEWER_COMPLIANCE_STATUS = "REQUEST_REVIEWER_COMPLIANCE_STATUS",
  TRAVEL_EXPENSE_EXTENSION_TRIPS_BOOKING_ID = "TRAVEL_EXPENSE_EXTENSION_TRIPS_BOOKING_ID",
  TRAVEL_EXPENSE_EXTENSION_TRIPS_TRIP_ID = "TRAVEL_EXPENSE_EXTENSION_TRIPS_TRIP_ID",
  USER_FIRST_NAME = "USER_FIRST_NAME",
  USER_LAST_NAME = "USER_LAST_NAME",
  USER_STATUS = "USER_STATUS",
}

/**
 * Filters for the expense primitive. Similar in style to current dgs filters, where the filterable fields are explicit fields in the schema.
 * Every field matcher is implicitly AND-ed together if specified in this input.
 * For example, if idsMatcher and amountMatcher are both specified, the filter would be (idsMatcher AND amountMatcher)
 * When a filter is not provided, it matches all values for that field
 */
export interface ExpensePrimitiveFieldMatcherInput {
  /** Matcher to get expenses having the given request status */
  activeRequestStatuses?: InputMaybe<Array<RequestStatus>>;
  /** Reasons for why an expense was flagged as violating */
  allExpensePolicyReasons?: InputMaybe<Array<ExpensePolicyReason>>;
  /** Range query filter for amount. */
  amountBetween?: InputMaybe<FinancialAssetRangeInput>;
  /** Matcher to get approved expenses overridden by the given users */
  approvalOverriddenBy?: InputMaybe<Array<Scalars["ID"]>>;
  /** Time range matcher for expense approved date */
  approvedBetween?: InputMaybe<TimeIntervalInput>;
  /** Matches IN reviewer user IDs. */
  approverUserIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Time range matcher for review assigned date */
  assignedBetween?: InputMaybe<TimeIntervalInput>;
  /** Whether the expense has an "attendees" addendum containing a government official */
  attendeesContainGovernmentOfficial?: InputMaybe<AttendeesContainGovernmentOfficialStatus>;
  /** Whether the expense has an "attendees" addendum containing a government official */
  attendeesContainGovernmentOfficialStatus?: InputMaybe<AttendeesContainGovernmentOfficialStatus>;
  /** Matcher for Expense's Bill Pay batch ID */
  billBatchIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Matcher for Bill Export integration ID */
  billExportIntegrationIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Matcher for Bill Export Status */
  billExportStatuses?: InputMaybe<Array<BillExportStatus>>;
  /** Matcher for Bill Pay origin */
  billOrigins?: InputMaybe<Array<BillOrigin>>;
  /** Matcher for Expense's Bill Pay status reason */
  billStatusReasons?: InputMaybe<Array<BillStatusReason>>;
  /** Match IN specific budgets */
  budgetIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Matches IN specific budget template IDs */
  budgetTemplateIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Match IN specific Card IDs */
  cardIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Matcher for Bill Pay Card Sharing Status */
  cardSharingStatuses?: InputMaybe<Array<CardDetailsSharingStatus>>;
  /** Matches IN submitter compliance statuses */
  complianceStatuses?: InputMaybe<Array<ComplianceStatusFilterInput>>;
  /** Matches IN compliance types */
  complianceTypes?: InputMaybe<Array<ComplianceTypeFilterInput>>;
  /** Matches IN specific cost center ids */
  costCenterIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Match IN specific users */
  customerUserIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Match IN specific departments */
  departmentIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Matches IN derived compliance statuses, which are derived from submitter and reviewer compliance */
  derivedComplianceStatuses?: InputMaybe<
    Array<DerivedComplianceStatusFilterInput>
  >;
  /** Match expenses with that belong to specific budgets or budgets that are descendants of the specified budgets */
  descendantFromBudgetIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Match IN specific display statuses */
  displayStatuses?: InputMaybe<Array<ExpensePrimitiveDisplayStatus>>;
  /** Time range matcher for Bill Pay due at */
  dueBetween?: InputMaybe<TimeIntervalInput>;
  /** Dummy field */
  dummyField?: InputMaybe<Scalars["String"]>;
  /** Matcher for Expense's Bill Pay duplicate status */
  duplicateStatuses?: InputMaybe<Array<BillDuplicateStatus>>;
  /** Match IN expenseDisputeStatuses */
  expenseDisputeStatuses?: InputMaybe<Array<ExpensePrimitiveDisputeStatuses>>;
  /** Matches IN extended field values by key */
  expenseExtendedFieldValues?: InputMaybe<
    Array<ExpensePrimitiveExtendedFieldValuesFilterInput>
  >;
  /** Match IN specific expenses */
  expenseIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Matches IN specific budget expense policy IDs */
  expensePolicyIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Matches IN policy violation reasons */
  expensePolicyViolationReasons?: InputMaybe<
    Array<ExpensePrimitivePolicyViolationReason>
  >;
  /** Matches IN risk tiers. */
  expenseRiskTiers?: InputMaybe<Array<ExpenseRiskTier>>;
  /**
   * Filter by extended field _values_, despite the naming
   * NOTE: only use this if the extended field value is expected to be unique across all extended fields, otherwise it
   * will return matching values from other extended fields
   */
  extendedFieldIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Matcher for Expense's Bill Pay invoice number */
  externalInvoiceNumbers?: InputMaybe<Array<Scalars["String"]>>;
  /** Match IN specific funding entity ids */
  fundingEntityIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Matcher for Expense's Legal Entity names */
  fundingLegalEntityNames?: InputMaybe<Array<Scalars["String"]>>;
  /** Matches if the BillPay has the autoApprove enabled or not */
  hasAutoApprove?: InputMaybe<Scalars["Boolean"]>;
  /** Matches if the BillPay has a paymentInstrument or not */
  hasPaymentInstrument?: InputMaybe<Scalars["Boolean"]>;
  /** Matcher for Expense's Bill Pay has a payment schedule or not */
  hasPaymentSchedule?: InputMaybe<Scalars["Boolean"]>;
  /** Matcher to get expenses which have a vendor or not */
  hasVendor?: InputMaybe<Scalars["Boolean"]>;
  /**
   * Includes the expense if it is a draft reimbursement submitted for a global currency.
   * These reimbursements are filtered out by default to protect legacy mobile clients from
   * showing draft reimbursements which cannot be submitted on the mobile app.
   * See: https://docs.google.com/document/d/1HCOHzIWUzP6W7f5hOxuYezSIKvegqwnoKDfE78_Hi9A
   */
  includeGlobalDraftReimbursements?: InputMaybe<GlobalDraftReimbursementsStatus>;
  /** Matches IN whose expenses to show. */
  incurredBy?: InputMaybe<IncurredByInput>;
  /** Matcher to get expenses for the last request review action by status */
  lastRequestReviewActionStatuses?: InputMaybe<Array<RequestActionStatus>>;
  /** Whether the expense has a memo */
  memoStatus?: InputMaybe<MemoStatus>;
  /** Match IN specific merchant categories */
  merchantCategoryIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Match IN specific merchants */
  merchantIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Matcher to get expenses with the given number of review action */
  numberOfReviewActionBetween?: InputMaybe<IntegerIntervalInput>;
  /** Match IN specific parent expense ids */
  parentExpenseIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Range query filter for paymentPostedAt */
  paymentPostedBetween?: InputMaybe<TimeIntervalInput>;
  /** Time range matcher for Bill Pay payment send at */
  paymentSendBetween?: InputMaybe<TimeIntervalInput>;
  /** Match IN specific payment statuses */
  paymentStatus?: InputMaybe<Array<ExpensePaymentStatusType>>;
  /** Match IN specific payment statuses */
  paymentStatuses?: InputMaybe<Array<ExpensePrimitivePaymentStatusType>>;
  /** Matches IN expenses currently pending approval on yourself and/or others. */
  pendingApprovals?: InputMaybe<Array<PendingApprovalFilterInput>>;
  /** Match IN specific user IDs for expenses pending approval from those users. */
  pendingApprovalsFromUserIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Matches IN open compliance request types */
  pendingRequestActionTypes?: InputMaybe<Array<ExpenseRequestActionType>>;
  /** Match IN specific purchase order IDs */
  purchaseOrderIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Range query filter for purchaseAt */
  purchasedBetween?: InputMaybe<TimeIntervalInput>;
  /** Whether the expense has at least one attached receipt */
  receiptStatus?: InputMaybe<ReceiptStatus>;
  /** Time range matcher for reimbursementPaymentCompletedBetween */
  reimbursementPaymentCompletedBetween?: InputMaybe<TimeIntervalInput>;
  /** Whether a reimbursement expense was paid outside of Brex or incurred on money movement */
  reimbursementPaymentMethod?: InputMaybe<ReimbursementPaymentMethod>;
  /** Matches IN reviewer compliance statuses */
  reviewerComplianceStatuses?: InputMaybe<Array<ComplianceStatusFilterInput>>;
  /** Matches IN risk tiers. */
  riskTiers?: InputMaybe<Array<ExpensePrimitiveRiskTier>>;
  /** Search expenses across expense properties (owner name, memo, amount, merchant, department, legal entity, cost center and etc). */
  searchQuery?: InputMaybe<Scalars["String"]>;
  /** Time range matcher for Bill Pay service performed at */
  servicePerformedBetween?: InputMaybe<TimeIntervalInput>;
  /** Matcher for Expense's Bill Pay source account IDs */
  sourceAccountIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Match expenses by spend limit types for limit groups or spend limits */
  spendLimitsLimitTypes?: InputMaybe<Array<LimitType>>;
  /** Match IN specific spending entity ids */
  spendingEntityIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Match IN specific statuses */
  status?: InputMaybe<Array<ExpenseStatus>>;
  /** Match IN specific statuses */
  statuses?: InputMaybe<Array<ExpensePrimitiveStatus>>;
  /** Time range matcher for expense submission date */
  submittedBetween?: InputMaybe<TimeIntervalInput>;
  /** Matches IN tracking statuses for tracked expenses, passing a null or an empty list value will return all expenses */
  trackingStatuses?: InputMaybe<Array<TrackingStatus>>;
  /** Whether the expense originates from a specific Travel provider (e.g. Brex Travel) */
  travelProvider?: InputMaybe<TravelProvider>;
  /** Match IN specific trip id */
  tripIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Match IN specific types */
  types?: InputMaybe<Array<ExpenseType>>;
  /** Matches IN user category ids */
  userCategoryIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Matches IN user statuses. */
  userStatus?: InputMaybe<Array<UserStatusFilterInput>>;
  /** Match IN specific categories */
  vendorCategoryIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Match IN specific vendors */
  vendorIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Matcher for Expense's Vendor names */
  vendorNames?: InputMaybe<Array<Scalars["String"]>>;
}

/** The status of the expense's payment. */
export enum ExpensePrimitivePaymentStatusType {
  /** Payment started, awaiting payment status */
  AWAITING_PAYMENT = "AWAITING_PAYMENT",
  /** Payment is canceled. */
  CANCELED = "CANCELED",
  /**
   * Payment is a withdrawal, which represents a cash advance.
   * This corresponds to both WITHDRAWING & WITHDREW on the back-end.
   */
  CASH_ADVANCE = "CASH_ADVANCE",
  /** Payment cleared. */
  CLEARED = "CLEARED",
  /**
   * Payment is a credit to the user.
   * Currently, this means chargebacks.
   */
  CREDITED = "CREDITED",
  /** Payment failed or got declined. */
  DECLINED = "DECLINED",
  /** Payment is not started yet. */
  NOT_STARTED = "NOT_STARTED",
  /** Payment is processing. */
  PROCESSING = "PROCESSING",
  /** Payment is a cleared refund. */
  REFUNDED = "REFUNDED",
  /** Payment is a refund in progress. */
  REFUNDING = "REFUNDING",
  /** Payment is scheduled. */
  SCHEDULED = "SCHEDULED",
}

export enum ExpensePrimitivePolicyViolationReason {
  AMOUNT = "AMOUNT",
  CAR_RENTAL = "CAR_RENTAL",
  FLIGHTS = "FLIGHTS",
  LODGING = "LODGING",
  MEALS = "MEALS",
  MERCHANT_OR_CATEGORY = "MERCHANT_OR_CATEGORY",
  MILEAGE = "MILEAGE",
  OTHERS = "OTHERS",
  TRAINS = "TRAINS",
}

export enum ExpensePrimitiveRiskTier {
  HIGH = "HIGH",
  LOW = "LOW",
  MEDIUM = "MEDIUM",
  NONE = "NONE",
}

/** The status of the expense. */
export enum ExpensePrimitiveStatus {
  /** An approved expense is public, with a request evaluated to have met the policy requirements */
  APPROVED = "APPROVED",
  /** A canceled expense is a public expense that does not accrue */
  CANCELED = "CANCELED",
  /** A draft expense is private and not ready for policy evaluation */
  DRAFT = "DRAFT",
  /** An out of policy expense is public, with a request evaluated to have not met the policy requirements */
  OUT_OF_POLICY = "OUT_OF_POLICY",
  /** A settled expense is an approved expense terminally locked from mutation */
  SETTLED = "SETTLED",
  /** A split expense was a single expense, now the non-accruing parent of many submitted children summing to the same amount. */
  SPLIT = "SPLIT",
  /** A submitted expense is public, with a request submitted for policy evaluation */
  SUBMITTED = "SUBMITTED",
  /** A void expense is a hidden expense that does not accrue (soft-delete) */
  VOID = "VOID",
}

export interface ExpenseQueryFinancialAssetValue {
  /** @deprecated bad field name */
  val?: Maybe<FinancialAsset>;
  value?: Maybe<FinancialAsset>;
}

export interface ExpenseQueryFinancialAssetValuesList {
  values: Array<FinancialAsset>;
}

export interface ExpenseQueryIntValue {
  /** @deprecated bad field name */
  val?: Maybe<Scalars["Int"]>;
  value?: Maybe<Scalars["Int"]>;
}

export interface ExpenseQueryStringValue {
  /** @deprecated bad field name */
  val?: Maybe<Scalars["String"]>;
  value?: Maybe<Scalars["String"]>;
}

export type ExpenseQueryValue =
  | ExpenseQueryFinancialAssetValue
  | ExpenseQueryFinancialAssetValuesList
  | ExpenseQueryIntValue
  | ExpenseQueryStringValue;

/** An expense report is a grouping of expenses for a specific purpose */
export interface ExpenseReport extends Node {
  /**
   * The Customer Account
   * Nullable to support partial failure
   */
  account?: Maybe<Account>;
  /** A list of operations that the user can perform on the expense report */
  allowedOperations: Array<ExpenseReportOperationPermission>;
  /** The limit for this expense report */
  baseLimit: FinancialAsset;
  /** Expense report period balance */
  currentPeriodBalance?: Maybe<ExpenseReportPeriodBalance>;
  /** The description of the expense report */
  description?: Maybe<Scalars["String"]>;
  /** The end date of the expense report, inclusive. */
  endDate?: Maybe<Scalars["Date"]>;
  /** The ID of the expense report */
  id: Scalars["ID"];
  /**
   * Whether the legal entity is explicitly mapped to the expense report
   *
   * If true, the legal entity is explicitly mapped to the expense report
   * Otherwise, the legal entity is derived from the expense report's ancestry
   */
  isLegalEntityExplicitlySet: Scalars["Boolean"];
  /** [Optional] The legal entity override for the expense report */
  legalEntity?: Maybe<LegalEntity>;
  /** The employees who are considered members of this expense report (nullable for partial failure) */
  members?: Maybe<UserConnection>;
  /** The name of the expense report */
  name: Scalars["String"];
  /** The employees who are considered owners of this expense report (nullable for partial failure) */
  owners?: Maybe<UserConnection>;
  /**
   * The policy governing this expense report
   * (nullable to support partial error cross resolving)
   */
  policy?: Maybe<Policy>;
  /** The start date of the expense report, inclusive. */
  startDate?: Maybe<Scalars["Date"]>;
  /** The status of the expense report */
  status: ExpenseReportStatus;
}

/** An expense report is a grouping of expenses for a specific purpose */
export interface ExpenseReportallowedOperationsArgs {
  operations: Array<ExpenseReportOperation>;
}

/** An expense report is a grouping of expenses for a specific purpose */
export interface ExpenseReportmembersArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
}

/** An expense report is a grouping of expenses for a specific purpose */
export interface ExpenseReportownersArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
}

export interface ExpenseReportMutationError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

/** Possible operations a user could perform on an expense report */
export enum ExpenseReportOperation {
  /** Close the expense report */
  ARCHIVE = "ARCHIVE",
  /** Update any of the expense report's fields */
  EDIT_FULL = "EDIT_FULL",
  /** Update the expense report's status from archived to active */
  REOPEN = "REOPEN",
}

/** Expense report permissions */
export interface ExpenseReportOperationPermission {
  allowed: Scalars["Boolean"];
  disabledReason?: Maybe<Array<Scalars["String"]>>;
  operation: ExpenseReportOperation;
}

/** Expense report period balance */
export interface ExpenseReportPeriodBalance {
  /** Amount spend in the current period */
  amountSpent?: Maybe<FinancialAsset>;
  /** End date of the current period */
  endDate?: Maybe<Scalars["Date"]>;
  /** End time of the current period (adjusted for timezone) */
  endTime?: Maybe<Scalars["Time"]>;
  /** Start date of the current period */
  startDate?: Maybe<Scalars["Date"]>;
  /** Start time of the current period (adjusted for timezone) */
  startTime?: Maybe<Scalars["Time"]>;
}

export interface ExpenseReportQueryInput {
  /** Filters available to control which entities get returned. */
  entityFilter: EntityFilterInput;
}

export enum ExpenseReportStatus {
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
}

/** An expense request. */
export interface ExpenseRequest extends Request {
  /** Actions for the expense request. */
  actions?: Maybe<RequestActionConnection>;
  /** User that canceled the request */
  canceledBy?: Maybe<Employee>;
  /** The compliance status for the request */
  complianceStatus?: Maybe<ComplianceStatus>;
  /** When the request was created. */
  createdAt: Scalars["Time"];
  /** The employee who initiated the request. */
  createdBy?: Maybe<Employee>;
  /** The compliance status for the request that is derived from the submitter and reviewer compliance statuses. */
  derivedComplianceStatus?: Maybe<DerivedComplianceStatus>;
  /** The display-friendly compliance status label for the request */
  displayComplianceStatus?: Maybe<Scalars["String"]>;
  /**
   * The Expense which this Request was created to get approval for
   * The Expense's status will be 'submitted' or 'out_of_policy' while the request is 'pending'
   */
  expense?: Maybe<Expense>;
  /** The unique ID of the expense request. */
  id: Scalars["ID"];
  /** The memo action for the expense request. Null if memo isn't required. */
  memoAction?: Maybe<RequestAction>;
  /** The timestamp when a controller overridden the request */
  overriddenAt?: Maybe<Scalars["Time"]>;
  /** The employee who overridden the request. */
  overriddenBy?: Maybe<Employee>;
  /** User id being co-piloted when this request was overridden. */
  overriddenOnBehalfOf?: Maybe<Employee>;
  /** The employee who owns the request. */
  owner?: Maybe<Employee>;
  /** The receipt action for the expense request. Null if a receipt isn't required. */
  receiptAction?: Maybe<RequestAction>;
  /**
   * The user who initiated the request - generally the user who created the expense.
   * @deprecated Incorrect permission scoping, use requestedByEmployee instead
   */
  requestedBy?: Maybe<User>;
  /**
   * The employee who initiated the request
   * @deprecated Not clear whether this is owner or creator of request after copilot context was introduced, use owner instead
   */
  requestedByEmployee?: Maybe<Employee>;
  /** The reviewer compliance status for the request. */
  reviewerComplianceStatus?: Maybe<ComplianceStatus>;
  /** The timestamp when reviewer compliance deadline will be reached */
  reviewerDeadlineAt?: Maybe<Scalars["Time"]>;
  /** The stage of approval of the request, e.g. created, approved, denied */
  status?: Maybe<RequestStatus>;
  /** The timestamp when the submitter compliance deadline will be reached */
  submitterDeadlineAt?: Maybe<Scalars["Time"]>;
  /** Computed Request and Request Action summary for the ExpenseRequest */
  summary?: Maybe<RequestSummary>;
  /** Will always map to EXPENSE for an ExpenseRequest. */
  type?: Maybe<RequestType>;
}

/** An expense request. */
export interface ExpenseRequestactionsArgs {
  filter?: InputMaybe<RequestActionFilterInput>;
  order?: InputMaybe<RequestActionOrderInput>;
  page?: InputMaybe<PaginationInput>;
}

/** The type of the request action. */
export enum ExpenseRequestActionType {
  /** A notification is requested. */
  NOTIFY = "NOTIFY",
  /** A list of attendees is required */
  REQUIRE_ATTENDEES = "REQUIRE_ATTENDEES",
  /** An extended field is required. */
  REQUIRE_EXTENDED_FIELD = "REQUIRE_EXTENDED_FIELD",
  /** An invoice is required. */
  REQUIRE_INVOICE = "REQUIRE_INVOICE",
  /** A justification is requested. */
  REQUIRE_JUSTIFICATION = "REQUIRE_JUSTIFICATION",
  /** A memo is requested. */
  REQUIRE_MEMO = "REQUIRE_MEMO",
  /** A receipt is requested. */
  REQUIRE_RECEIPT = "REQUIRE_RECEIPT",
  /** Receipts must go through a validation process. */
  REQUIRE_RECEIPT_VALIDATION = "REQUIRE_RECEIPT_VALIDATION",
  /** A manager (or other) review is requested. */
  REQUIRE_REVIEW = "REQUIRE_REVIEW",
}

/** An expense request connection for the expense request pagination. */
export interface ExpenseRequestConnection extends Connection {
  /** The requests in the current page of results. */
  edges: Array<ExpenseRequestEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of requests matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

/** A Request edge for Request pagination. */
export interface ExpenseRequestEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The request at this edge. */
  node?: Maybe<ExpenseRequest>;
}

export interface ExpenseReviewDetails {
  /** The moment in which the final person that approved the expense made the action */
  finalApprovalAt?: Maybe<Scalars["Time"]>;
  /** The employee that represents the final person that approved the expense */
  finalApprover?: Maybe<User>;
  /** A label describing the final approver status: approver name, auto-approval, not approved, or not applicable */
  finalApproverLabel?: Maybe<Scalars["String"]>;
  /** The copilot that approved the expense on behalf of the finalApprover */
  finalCopilotApprover?: Maybe<User>;
  /** The copilot that last reviewed the expense on behalf of the finalReviewer */
  finalCopilotReviewer?: Maybe<User>;
  /** The moment in which the final person that reviewed the expense made the action */
  finalReviewAt?: Maybe<Scalars["Time"]>;
  /** The employee that represents the final person that reviewed the expense */
  finalReviewer?: Maybe<User>;
}

export interface ExpenseRisk {
  /**
   * The reasons why the expense is considered risky.
   * @deprecated Use reasonsV2 instead for human readable reasons.
   */
  reasons: Array<ExpenseRiskReason>;
  /** The reasons why the expense is considered risky together with its human-readable format */
  reasonsV2: Array<ExpenseRiskReasonDetails>;
  /** The risk tier of the expense. */
  tier: ExpenseRiskTier;
}

/** See https://docs.google.com/document/d/14dFEA657rAAhDnvUhuKc6HYwAlWwfeRCn33pGQSl6Xg/edit#bookmark=id.5et592knth02 for context */
export enum ExpenseRiskReason {
  /** For a card expense, the expense amount that Brex has from the card swipe does not match the amount on the receipt uploaded by the employee */
  CARD_AMOUNT_MISMATCH_CARD_RECEIPT_AMOUNT = "CARD_AMOUNT_MISMATCH_CARD_RECEIPT_AMOUNT",
  /**
   * Reimbursement amount as changed to a higher amount (by either the submitter or a reviewer) after initial submission
   * This will naturally re-start the review chain, but we should still show a banner giving a heads up of what happened
   */
  REIMBURSEMENT_AMOUNT_CHANGED_HIGHER_THAN_SUBMITTED = "REIMBURSEMENT_AMOUNT_CHANGED_HIGHER_THAN_SUBMITTED",
  /** Reimbursement amount input by submitter is different than what OCR picked up from the receipt. */
  REIMBURSEMENT_AMOUNT_MISMATCH_OCR_AMOUNT = "REIMBURSEMENT_AMOUNT_MISMATCH_OCR_AMOUNT",
  /** Reimbursement looks like a duplicate from a previously submitted or approved reimbursement, based on merchant, date, amount, and receipt that had been used before. */
  REIMBURSEMENT_DUPLICATE = "REIMBURSEMENT_DUPLICATE",
  /** Card or reimbursement didn't have an actual receipt and instead user filled out a receipt affidavit */
  REIMBURSEMENT_ONLY_RECEIPT_AFFIDAVIT = "REIMBURSEMENT_ONLY_RECEIPT_AFFIDAVIT",
}

/**
 * type ExpenseRiskReasonDetails {
 *     reasonDetails: []
 * }
 */
export interface ExpenseRiskReasonDetails {
  /** The reason why the expense is considered risky, in a human-readable format. */
  humanReadableReason: Scalars["String"];
  /** The reason why the expense is considered risky */
  reason?: Maybe<ExpenseRiskReason>;
}

export enum ExpenseRiskTier {
  HIGH = "HIGH",
  LOW = "LOW",
  MEDIUM = "MEDIUM",
  NONE = "NONE",
}

export enum ExpenseRole {
  INVALID = "INVALID",
  VENDOR_OWNER = "VENDOR_OWNER",
}

export type ExpenseRow = Expense | ExpenseGroup;

export interface ExpenseRowConnection extends Connection {
  edges: Array<ExpenseRowEdge>;
  pageInfo: PageInfo;
  summarizations?: Maybe<Array<ExpenseField>>;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface ExpenseRowEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<ExpenseRow>;
}

/** Query expense options input */
export interface ExpenseRowsOptionInput {
  expensePerspective?: InputMaybe<ExpensePerspectiveInput>;
}

export interface ExpenseRuleEvaluation {
  expense: Expense;
  ruleActions: Array<ExpenseWorkflowRuleAction>;
}

export interface ExpenseRuleEvaluationConnection extends Connection {
  edges: Array<ExpenseRuleEvaluationEdge>;
  numExpensesSimulated: Scalars["Int"];
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface ExpenseRuleEvaluationEdge {
  cursor?: Maybe<Scalars["String"]>;
  node: ExpenseRuleEvaluation;
}

export interface ExpenseSortInput {
  order: OrderByDirection;
  /** Required sort key, e.g  PURCHASED_AT */
  sortKey: ExpenseFieldKeyInput;
}

/** The status of the expense. */
export enum ExpenseStatus {
  /** An approved expense is public, with a request evaluated to have met the policy requirements */
  APPROVED = "APPROVED",
  /** A canceled expense is a public expense that does not accrue */
  CANCELED = "CANCELED",
  /** A draft expense is private and not ready for policy evaluation */
  DRAFT = "DRAFT",
  /** An out of policy expense is public, with a request evaluated to have not met the policy requirements */
  OUT_OF_POLICY = "OUT_OF_POLICY",
  /** A settled expense is an approved expense terminally locked from mutation */
  SETTLED = "SETTLED",
  /** A split expense was a single expense, now the non-accruing parent of many submitted children summing to the same amount. */
  SPLIT = "SPLIT",
  /** A submitted expense is public, with a request submitted for policy evaluation */
  SUBMITTED = "SUBMITTED",
  /** A void expense is a hidden expense that does not accrue (soft-delete) */
  VOID = "VOID",
}

export interface ExpenseStringValue extends ExpenseFieldValue {
  id: Scalars["ID"];
  value?: Maybe<Scalars["String"]>;
}

export interface ExpenseStringValueInput {
  value?: InputMaybe<Scalars["String"]>;
}

export enum ExpenseSuggestionDataOrigin {
  /** The budget details such as budget name. */
  BUDGET = "BUDGET",
  /** Data from a Calendar integration was used to generate the suggestion. We do not expose the specific calendar provider. */
  CALENDAR = "CALENDAR",
  /** Data from expense addendums were used when generating the suggestion (ex travel addendums, attendees) */
  EXPENSE_ADDENDUM = "EXPENSE_ADDENDUM",
  /** Fundamental attributes of an expense (ex Date, Amount, Merchant Name) */
  EXPENSE_DETAILS = "EXPENSE_DETAILS",
  /**
   * User provided rules which the LLM stores in it's memory and referenced for suggestion generation.
   * Example: can you set all future Google Ads expenses to [memo]?
   */
  GUIDANCE = "GUIDANCE",
  /** The trip details, such as trip name and id */
  TRIP = "TRIP",
}

export interface ExpenseSuggestionOriginEntity {
  /** Optional brief description of the origin entity. For example, title of calendar event, content of user guidance. */
  description?: Maybe<Scalars["String"]>;
  /** Optional ID of the data entity used to generate the content of the expense suggestion. */
  entityId?: Maybe<Scalars["ID"]>;
  /** Enum describing the data source of the suggestion. */
  origin: ExpenseSuggestionDataOrigin;
}

/** A trip record that describes an expense trip */
export interface ExpenseTrip extends ExpenseGrouping, Node {
  id: Scalars["ID"];
  name: Scalars["String"];
}

/** The type of the Expense. */
export enum ExpenseType {
  /** A bill pay expense. */
  BILLPAY = "BILLPAY",
  /** A card expense. */
  CARD = "CARD",
  /** A clawback expense */
  CLAWBACK = "CLAWBACK",
  /** A reimbursement expense. */
  REIMBURSEMENT = "REIMBURSEMENT",
}

/** Input Expense Type fields */
export interface ExpenseTypeExtendedFieldInput {
  addendumOptionNames: Scalars["String"];
  expenseAddendumName: Scalars["String"];
  expenseTypeName: Scalars["String"];
}

/**
 * A optional filter to specify which extended field values we want to query from the Expense object.
 * All filters inside this input are OR filters with each other.
 */
export interface ExpenseTypeExtendedFieldValueFilterInput {
  /**
   * The optional list of extension types to filter on. Works as an OR filter, so any extension types matching this
   * list will be returned.
   */
  expenseExtensionTypes?: InputMaybe<Array<ExpenseExtensionTypeEnum>>;
  /**
   * The optional list of extended field value IDs to filter for. Works as an OR filter, so any ids matching this
   * list will be returned.
   */
  extendedFieldIds?: InputMaybe<Array<Scalars["ID"]>>;
}

/** Error from unsplitting an expense */
export interface ExpenseUnsplitError extends MutationError {
  errors?: Maybe<Array<ExpenseMutationError>>;
}

export interface ExpenseUnsplitInput {
  /** The ID of the parent expense to un-split. */
  parentExpenseId: Scalars["ID"];
}

/** Result of the expense unsplit operation */
export type ExpenseUnsplitResult = Expense | ExpenseUnsplitError;

export interface ExpenseUpdatePurposeError extends MutationError {
  errors?: Maybe<Array<ExpenseMutationError>>;
}

export interface ExpenseUpdatePurposeInput {
  /** The ID of the expense to update. */
  expenseId: Scalars["ID"];
  /** The new memo for the expense. Passing an empty string will remove the memo. */
  memo?: InputMaybe<Scalars["String"]>;
  /** The new trip ID for the expense. */
  tripId?: InputMaybe<Scalars["ID"]>;
}

export type ExpenseUpdatePurposeResult = Expense | ExpenseUpdatePurposeError;

export interface ExpenseWorkflowRuleAction {
  hasConflict: Scalars["Boolean"];
  /** The rule that causes this action. `null` if caused by a simulated rule. */
  rule?: Maybe<WorkflowRule>;
  ruleAction: WorkflowRuleAction;
}

export interface ExpensesByBillingConfigurationGroup {
  /** The billing configuration to which this group is billed. */
  billingGroup: BillingGroup;
  /** List of bill expenses in the group. */
  expenses: Array<Expense>;
  /** Total amount of all expenses in the group. */
  totalAmount: FinancialAsset;
}

export interface ExpensesExportRequest {
  /** The expense filter input used to get the list of expenses to be exported. */
  filter: TaskManagerExpenseFilter;
  /** The number of expenses */
  numExpenses: Scalars["Int"];
  /** The report format type for the exported expenses search. */
  reportFormat: TaskManagerReportFormatType;
  /** Flag to indicate if email notification should be sent upon task completion. */
  sendNotification: Scalars["Boolean"];
}

export interface ExpensesExportResponse {
  downloadUrl: Scalars["String"];
  fileStoreId: Scalars["String"];
}

/** The report incurred by a customer. */
export interface ExpensesReport {
  /** The file of the report */
  file: ExpensesReportFile;
}

export interface ExpensesReportFile {
  /** The file download url of the report. */
  downloadUrl: Scalars["String"];
  /** The unique ID of the report file. */
  id: Scalars["ID"];
}

export interface ExpensesTargetSpecificationInput {
  /**
   * [oneOf] Entity Filter to be provided into QueriesService.executeQuery().
   * Only one of [expenseIds, bulkExpenseActionQuery, bulkActionQuery] can be specified
   */
  bulkActionQuery?: InputMaybe<BulkActionQueryInput>;
  /**
   * [oneOf] Query input to be provided into QueriesService.executeQuery().
   * Only one of [expenseIds, bulkExpenseActionQuery] can be specified
   */
  bulkExpenseActionQuery?: InputMaybe<BulkExpenseActionQueryInput>;
  /**
   * [oneOf] List of expenseIds to be updated to the specified request obj.
   * Only one of [expenseIds, bulkExpenseActionQuery] can be specified
   */
  expenseIds?: InputMaybe<Array<Scalars["ID"]>>;
}

export interface ExpensifyCategories {
  vendorName?: Maybe<Scalars["String"]>;
}

export interface ExpensifySetupInstructions {
  copilotEmail?: Maybe<Scalars["String"]>;
}

/** Metadata for the EXPENSIVE_TRANSACTION insight setting */
export interface ExpensiveTransactionSettingMetadata {
  /** The amount threshold above which an insight should be triggered */
  threshold: FinancialAsset;
}

/** Metadata input for the EXPENSIVE_TRANSACTION insight setting */
export interface ExpensiveTransactionSettingMetadataInput {
  /** The amount threshold above which an insight should be triggered */
  threshold: FinancialAssetInput;
}

export interface ExpiringUrl {
  /** expiry time in UTC */
  expiresAt?: Maybe<Scalars["LocalDateTime"]>;
  url?: Maybe<Scalars["String"]>;
}

export interface Export extends Node {
  errorMessage?: Maybe<Scalars["String"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  insertedAt: Scalars["Time"];
  status: Scalars["String"];
}

export interface ExportBillsInput {
  clientMutationId: Scalars["String"];
  dueAt?: InputMaybe<Scalars["Time"]>;
  endTime?: InputMaybe<Scalars["Time"]>;
  /** If provided, only bills with these invoice processing statuses will be returned. */
  invoiceProcessingStatuses?: InputMaybe<
    Array<InputMaybe<BillInvoiceProcessingStatus>>
  >;
  isDueSoon?: InputMaybe<Scalars["Boolean"]>;
  isRecurring?: InputMaybe<Scalars["Boolean"]>;
  searchQuery?: InputMaybe<Scalars["String"]>;
  sortKey?: InputMaybe<BillSortKey>;
  sortOrder?: InputMaybe<BillSortOrder>;
  startTime?: InputMaybe<Scalars["Time"]>;
  /** If provided, only bills with these bill statuses will be returned. */
  statuses?: InputMaybe<Array<InputMaybe<BillStatus>>>;
}

export interface ExportBillsPayload {
  clientMutationId: Scalars["String"];
  downloadUrl?: Maybe<Scalars["String"]>;
}

export interface ExportBillsToErpSyncInput {
  clientMutationId: Scalars["String"];
  expenseIds: Array<Scalars["ID"]>;
  forceOverwriteType?: InputMaybe<BillExportForceOverwriteType>;
}

export interface ExportBillsToErpSyncResult extends MutationResult {
  errors?: Maybe<Array<BillMutationError>>;
  result?: Maybe<Array<BillExportAttempt>>;
}

export interface ExportBillsV2Input {
  clientMutationId: Scalars["String"];
  filter?: InputMaybe<BillFilterInput>;
}

export interface ExportConnection {
  edges?: Maybe<Array<Maybe<ExportEdge>>>;
  pageInfo: PageInfo;
}

export interface ExportEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<Export>;
}

/** The export entry for expenses. */
export interface ExportEntry extends Node {
  entryPostedAt?: Maybe<Scalars["Time"]>;
  /** The ID of an object */
  id: Scalars["ID"];
}

export interface ExportEntryDetailsInput {
  /** Details for a failed export */
  failure?: InputMaybe<ExportEntryFailureInput>;
  /** Details for a successful export */
  success?: InputMaybe<ExportEntrySuccessInput>;
}

export interface ExportEntryFailureInput {
  /** Human-readable explanation of the failure */
  errorMessage: Scalars["String"];
  /**
   * Timestamp when the export attempt failed.
   * If omitted, the current timestamp will be used.
   */
  failedAt?: InputMaybe<Scalars["Time"]>;
}

/** Union type for possible sources of an export entry */
export type ExportEntrySource = AccountingRecord;

/** Status of an individual export entry */
export enum ExportEntryStatus {
  /** Entry failed to export */
  FAILED = "FAILED",
  /** Entry has not been exported yet */
  INVALID = "INVALID",
  /** Entry is currently being exported */
  IN_PROGRESS = "IN_PROGRESS",
  /** Entry was reverted/un-exported */
  REVERTED = "REVERTED",
  /** Entry was successfully exported */
  SUCCESS = "SUCCESS",
}

export interface ExportEntrySuccessInput {
  /**
   * Timestamp when the export succeeded.
   * If omitted, the current timestamp will be used.
   */
  exportedAt?: InputMaybe<Scalars["Time"]>;
  /** External system identifier assigned to the exported record */
  externalReferenceId: Scalars["String"];
  /** URL pointing to the record in the external system */
  externalReferenceUrl?: InputMaybe<Scalars["String"]>;
}

export interface ExportExpensesInput {
  columns?: InputMaybe<Array<ExpenseExportColumn>>;
  columnsV2?: InputMaybe<Array<ExpenseExportColumnOneOf>>;
  exportFormat: DownloadsPlatformExportFormat;
  filter: ExpenseEntityFilterInput;
  idempotencyKey: Scalars["String"];
  includeReceipts: Scalars["Boolean"];
  order: Array<ExpenseEntitySortInput>;
}

export interface ExportItem extends Node {
  /** The ID of an object */
  id: Scalars["ID"];
  insertedAt: Scalars["Time"];
  status: Scalars["String"];
}

export interface ExportJob {
  /** Accounting integration associated with export pipe id */
  accountingIntegration?: Maybe<AccountingIntegration>;
  /** Optional field that will include the download links for CSV and other downloadable of export job */
  assets?: Maybe<Array<Asset>>;
  /** The identity context type that created the export job (e.g. Customer, Internal User, Service, etc.) */
  createdByIdentityType: ExportJobIdentityContextType;
  /** The user who created the export job. Only set for CUSTOMER account types */
  createdByUser?: Maybe<User>;
  /** Metadata associated with the export job */
  exportJobMetadata?: Maybe<ExportJobMetadata>;
  /** The id of the export job */
  id: Scalars["ID"];
  /** When the export job was created */
  insertedAt: Scalars["Time"];
  /**
   * The messages of export job that describes the status to customers.
   * Each message associates with a sub task within a job and it would be success message or error message.
   * e.g. "100 Gl accounts are imported" for success message.
   * Note: the message could be empty list if export job status is pending or in progress.
   */
  messages?: Maybe<Array<Maybe<ExportJobMessage>>>;
  /** The export method */
  method: ExportMethod;
  /** Optional field that includes non-templated CSV assets for the original export job */
  nonTemplatedAssets?: Maybe<Array<Asset>>;
  /** The domain originator of the export job (e.g. Accounting, BILL_PAY, etc.) */
  originator?: Maybe<ExportJobOriginator>;
  /** The pipe associated with the export job */
  pipe: ExportPipe;
  /** Optional field set if a template was used for the export job */
  reportTemplate?: Maybe<ReportTemplate>;
  /** The status of export job */
  status: ExportJobStatus;
  /**
   * Optional field that includes ERP target data associated with the job. There could potentially be one link per entry
   * so it's recommended to pass in a max limit. Defaults to max limit of 5.
   */
  targetData?: Maybe<Array<ExportTargetData>>;
  /** When the export job was most recently updated */
  updatedAt: Scalars["Time"];
}

export interface ExportJobtargetDataArgs {
  maxLimit?: InputMaybe<Scalars["Int"]>;
}

export interface ExportJobConnection extends Connection {
  edges: Array<ExportJobEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface ExportJobEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<ExportJob>;
}

export enum ExportJobFieldKeyType {
  EXPORTED_AT = "EXPORTED_AT",
}

export enum ExportJobIdentityContextType {
  CUSTOMER = "CUSTOMER",
  INTERNAL_USER = "INTERNAL_USER",
  SERVICE = "SERVICE",
}

export interface ExportJobMessage {
  /** Message for customer display */
  message: Scalars["String"];
}

export interface ExportJobMetadata {
  exportEntriesAttemptedCount?: Maybe<Scalars["Int"]>;
  exportEntriesSucceededCount?: Maybe<Scalars["Int"]>;
  id: Scalars["ID"];
}

export interface ExportJobNotification {
  /** Export job associated with the job notification */
  exportJob: ExportJob;
  /** The id of the export job notification */
  id: Scalars["ID"];
  /** Count of source data entries for the export job */
  sourceDataCount?: Maybe<Scalars["Int"]>;
  /** The state of export job notification */
  state: ExportJobNotificationState;
}

export interface ExportJobNotificationConnection extends Connection {
  edges: Array<ExportJobNotificationEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface ExportJobNotificationEdge {
  cursor?: Maybe<Scalars["String"]>;
  node: ExportJobNotification;
}

export enum ExportJobNotificationState {
  /** Export job notification is ready to display to user */
  ACTIVE = "ACTIVE",
  /** Export job notification is acknowledged by user */
  DISMISSED = "DISMISSED",
}

export interface ExportJobNotificationsFilterInput {
  /** The originator of the job. If not provided, jobs of any originator will be fetched. */
  exportJobOriginators?: InputMaybe<Array<ExportJobOriginator>>;
  /** The export method of the job. If not provided, jobs of any export method will be fetched. */
  methods?: InputMaybe<Array<ExportMethod>>;
  /** State of export job notification. Defaults to active notifications. */
  states?: InputMaybe<Array<ExportJobNotificationState>>;
  /** The users who created export jobs. Defaults to the current user. */
  userIds?: InputMaybe<Array<Scalars["ID"]>>;
}

export enum ExportJobOriginator {
  /** Originated from the Accounting Journal product. */
  ACCOUNTING_JOURNAL = "ACCOUNTING_JOURNAL",
  /** Originated from the Bill Pay product. */
  BILL_PAY = "BILL_PAY",
  /** Originated from the Procurement domain. */
  PROCUREMENT = "PROCUREMENT",
  /** Originated from the Sync Platform. */
  SYNC_PLATFORM = "SYNC_PLATFORM",
}

export enum ExportJobStatus {
  /** Export job is marked as failed and all target data is marked as failed. */
  FAILED = "FAILED",
  /** Export job is in progress. */
  IN_PROGRESS = "IN_PROGRESS",
  /** Export job is marked as failed but has some successful target data. */
  PARTIAL_SUCCESS = "PARTIAL_SUCCESS",
  /** Export job is pending to start. */
  PENDING = "PENDING",
  /** Export job has all target data marked as reverted. */
  REVERTED = "REVERTED",
  /** Export job is successful. */
  SUCCESS = "SUCCESS",
}

export interface ExportJobsFilterInput {
  /** Filters for export jobs with insertedAt LTE this value. If not provided, jobs will be fetched with no upper limit on insertedAt. */
  endTime?: InputMaybe<Scalars["Time"]>;
  /** The originator of the job. If not provided, jobs of any originator will be fetched. */
  exportJobOriginators?: InputMaybe<Array<ExportJobOriginator>>;
  /** The status of the job. If not provided, jobs of any status will be fetched. */
  exportJobStatuses?: InputMaybe<Array<ExportJobStatus>>;
  /** The export method (CSV, Direct, etc) of the job. If not provided, jobs of any export method will be fetched. */
  exportMethods?: InputMaybe<Array<ExportMethod>>;
  /** The ids of the jobs to fetch. If not provided, jobs of any id that belong to the customer can be fetched. */
  jobIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** The id of the source originators of the job. If not provided, jobs will be fetched with no source originator id filter. */
  searchQuery?: InputMaybe<Scalars["String"]>;
  /** The id of the source originators of the job. If not provided, jobs will be fetched with no source originator id filter. */
  sourceOriginatorId?: InputMaybe<Scalars["ID"]>;
  /** Filters for export jobs with insertedAt GTE this value. If not provided, jobs will be fetched with no lower limit on insertedAt. */
  startTime?: InputMaybe<Scalars["Time"]>;
  /** The ids of users that created or updated the job. If not provided, jobs from any user will be fetched. */
  userIds?: InputMaybe<Array<Scalars["String"]>>;
}

export interface ExportJobsSortInput {
  order: OrderByDirection;
  sortKey: ExportJobFieldKeyType;
}

export interface ExportMappingsToCsvInput {
  /** Mapping Class ID of the mappings being exported */
  mappingClassId: Scalars["ID"];
}

/** Response of exporting mappings to CSV */
export interface ExportMappingsToCsvResult {
  csv?: Maybe<Asset>;
  mappingClass?: Maybe<MappingClass>;
}

export enum ExportMethod {
  /** Transactions will be exported to a CSV file */
  CSV = "CSV",
  /** Transactions will be exported directly to ERP */
  DIRECT = "DIRECT",
  /**
   * Export in a draft state, changes will not be fully committed to the target
   * but instead persist in a draft state
   */
  DRAFT = "DRAFT",
  /** Transactions will be exported to a IIF file */
  IIF = "IIF",
  /** Transactions will be exported to a SFTP server */
  SFTP = "SFTP",
}

export enum ExportNotificationMethod {
  /** Notification will be sent to user via default in-app method */
  DEFAULT = "DEFAULT",
  /** Notification will be sent to user via email */
  EMAIL = "EMAIL",
}

export enum ExportNotificationType {
  EMAIL = "EMAIL",
  INVALID = "INVALID",
}

export interface ExportObjectsToErpInput {
  clientMutationId: Scalars["String"];
  expenseIds: Array<Scalars["ID"]>;
  externalEntryType: BillExportExternalEntryType;
  forceOverwriteType?: InputMaybe<BillExportForceOverwriteType>;
}

export interface ExportObjectsToErpResult extends MutationResult {
  errors?: Maybe<Array<BillMutationError>>;
  result?: Maybe<Array<BillExportAttempt>>;
}

export interface ExportPipe {
  /** The id of the export pipe */
  id: Scalars["ID"];
}

export interface ExportRecord {
  /** Optional field that will include the download link for CSV and other downloadable export records */
  asset?: Maybe<Asset>;
  /** The user who created the export attempt */
  createdByUser?: Maybe<User>;
  /** Optional error type on failed exports */
  error?: Maybe<ExportRecordError>;
  /** The state of the export (EXPORTED, ERROR, etc.) */
  exportStatus?: Maybe<ExportStatus>;
  /** Indicates if the user has acknowledged/dismissed an export banner from Accounting Journal */
  hasStatusAcknowledgedByUser: Scalars["Boolean"];
  /** The id of the export attempt the export record is referencing */
  id: Scalars["ID"];
  /** The time the export attempt was made */
  insertedAt: Scalars["Time"];
}

/**  ---[ Resource Types ]------------------ */
export interface ExportRecordConnection extends Connection {
  edges: Array<ExportRecordEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface ExportRecordEdge {
  node: ExportRecord;
}

export interface ExportRecordError {
  /** Human readable error message */
  displayMessage?: Maybe<Scalars["String"]>;
}

export enum ExportRecordSortableField {
  INSERTED_AT = "INSERTED_AT",
}

/**  ---[ Input Types ]--------------------- */
export interface ExportRecordsFilterInput {
  /** The user who created the export attempt */
  createdByUserId?: InputMaybe<Scalars["ID"]>;
  /** The state of the export (EXPORTED, ERROR, etc.) */
  exportStatus?: InputMaybe<ExportStatus>;
  /** Indicates if the user has acknowledged/dismissed an export banner from Accounting Journal */
  hasStatusAcknowledgedByUser?: InputMaybe<Scalars["Boolean"]>;
}

export interface ExportRecordsSortOrderInput {
  field: ExportRecordSortableField;
  order: OrderByDirection;
}

/**
 * Represents an individual export entry result within an export job.
 *
 * Note: This type is named ExportResultEntry instead of ExportEntry to avoid
 * naming conflicts with the ExportEntry defined in the api-v1 GraphQL schema.
 * The ExportEntry defined in api-v1 is a legacy data model (mirrors the
 * protos/export_server/tracker/v1/resources/object.proto) which we no longer
 * use. The ExportResultEntry defined here mirrors the
 * protos/spend/exports/v1/resources/export_entry.proto data model.
 *
 * This type is primarily used in the reportExportResults mutation to allow
 * external systems to report export outcomes back to Brex.
 */
export interface ExportResultEntry {
  /** The export job this entry belongs to */
  exportJob: ExportJob;
  /** Unique identifier for this export entry */
  id: Scalars["ID"];
  /** The source being exported (e.g., accounting record) */
  source?: Maybe<ExportEntrySource>;
  /** Current status of this export entry */
  status: ExportEntryStatus;
  /** Target data if export was successful */
  targetData?: Maybe<ExportTargetData>;
}

export interface ExportResultInput {
  /** The ID of the export entry's source this result applies to (e.g., accounting record ID) */
  exportEntrySourceId: Scalars["ID"];
  /**
   * The result of the export attempt (success or failure details)
   * Must provide exactly one of: success or failure
   */
  result: ExportEntryDetailsInput;
}

/** Detailed error information for export results */
export interface ExportResultsErrorDetails {
  /** List of export entry source IDs that are duplicated across results */
  duplicateExportEntrySourceIds?: Maybe<Array<Scalars["ID"]>>;
  /** List of export entry source IDs that have export entries not in the correct status for export */
  invalidStatusExportEntrySourceIds?: Maybe<Array<Scalars["ID"]>>;
}

export enum ExportRewardsPointsHistoryColumn {
  AMOUNT = "AMOUNT",
  CATEGORY = "CATEGORY",
  CURRENCY = "CURRENCY",
  DATE = "DATE",
  MERCHANT = "MERCHANT",
  MERCHANT_CATEGORY = "MERCHANT_CATEGORY",
  MULTIPLIER = "MULTIPLIER",
  POINTS = "POINTS",
  RATE_MODIFIER = "RATE_MODIFIER",
  TYPE = "TYPE",
  USER = "USER",
}

/**  ---[ Enums ]--------------------------- */
export enum ExportStatus {
  ERROR = "ERROR",
  EXPORTED = "EXPORTED",
  EXPORTING = "EXPORTING",
  INVALID = "INVALID",
}

/** Information about the export status of an expense */
export interface ExportStatusInfo {
  /** The date when the expense was posted in the ERP system */
  erpPostingDate?: Maybe<Scalars["Time"]>;
  /** The type of accounting method to be used (ACTUAL or ACCRUAL) */
  exportedAs?: Maybe<AccountingMethodType>;
  /** The date when the expense was exported to the accounting system */
  exportedAt?: Maybe<Scalars["Time"]>;
  /** Whether the expense was previously accrued in accounting */
  previouslyAccrued?: Maybe<Scalars["Boolean"]>;
}

export interface ExportTargetData {
  /** ERP external id. If not set, then no associated external id exists. */
  externalReferenceId?: Maybe<Scalars["String"]>;
  /** ERP target link. If not set, then no associated link exists. */
  externalReferenceLink?: Maybe<Scalars["String"]>;
  /** The id of the export target data */
  id: Scalars["ID"];
}

export interface ExportTeamInput {
  columns?: InputMaybe<Array<TeamUserColumn>>;
  exportFormat: DownloadsPlatformExportFormat;
  /** Additional dynamic columns for extended fields */
  extendedFieldIds?: InputMaybe<Array<Scalars["String"]>>;
  filter?: InputMaybe<UserFilterInput>;
  idempotencyKey: Scalars["String"];
  orderBy?: InputMaybe<Array<UserSortOrder>>;
}

export interface ExportTrackedExpensesError extends StandardClientError {
  code: ErrorCode;
  errorSubtype: ApproveBeneficiariesErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface ExportTrackedExpensesInput {
  /** Which billing group the expenses belong to */
  billingGroupId: Scalars["ID"];
  /** Expenses to be exported, if this is null or empty all non-exported expenses will be exported */
  expensesIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Idempotency key for safe retries. Avoid generating it on the fly so the customer can re-try the request in the event of a network error */
  idempotencyKey: Scalars["String"];
}

export interface ExportTrackedExpensesResult extends MutationResult {
  errors: Array<ExportTrackedExpensesError>;
  /** The generated export */
  result: TrackedExpenseExport;
}

/** Input for exporting travel bookings to a file. */
export interface ExportTravelBookingsInput {
  exportFormat: DownloadsPlatformExportFormat;
  filter?: TravelBookingFilterInput;
  idempotencyKey: Scalars["String"];
  order?: TravelBookingOrder;
}

export enum ExportType {
  CSV = "CSV",
  CSV_INTACCT_JE = "CSV_INTACCT_JE",
  DIRECT = "DIRECT",
  IIF = "IIF",
}

export interface ExportValidationInput {
  /**
   * [oneOf] Filter to find accounting records to validate.
   * Exactly one of [entityFilter, sourceOriginatorIds, accountingRecordFilter] must be specified.
   * An exception will be thrown if none or multiple are passed.
   */
  accountingRecordFilter?: InputMaybe<AccountingRecordFilterInput>;
  /**
   * [oneOf] Entity Filter to use when querying against UGQL (queries service) for the entries to export
   * Exactly one of [entityFilter, sourceOriginatorIds, accountingRecordFilter] must be specified.
   * An exception will be thrown if none or multiple are passed.
   */
  entityFilter?: InputMaybe<EntityFilterInput>;
  /** Required, the accounting integration id. */
  integrationId: Scalars["ID"];
  /**
   * [oneOf] List of source originator ids.
   * Exactly one of [entityFilter, sourceOriginatorIds, accountingRecordFilter] must be specified.
   * An exception will be thrown if none or multiple are passed.
   */
  sourceOriginatorIds?: InputMaybe<Array<Scalars["ID"]>>;
}

export interface ExportValidationResult {
  invalidIntegrationSettings?: Maybe<InvalidIntegrationSettings>;
  invalidSubsidiarySettings?: Maybe<Array<InvalidSubsidiarySettings>>;
  unmappedLegalEntityIds?: Maybe<Array<Scalars["ID"]>>;
}

export interface ExportVendorsInput {
  columns?: InputMaybe<Array<VendorExportColumn>>;
  exportFormat: DownloadsPlatformExportFormat;
  filter?: InputMaybe<VendorFilterInput>;
  idempotencyKey: Scalars["String"];
  order?: InputMaybe<VendorOrderInput>;
}

/**  ---[ Extended Types ]------------------ */
export interface ExtendedField extends Node {
  /** The accounting integration associated with this field, if any. */
  accountingIntegration?: Maybe<AccountingIntegration>;
  /**
   * Extended fields whose options are dependent on the values of this extended field.
   * Child Extended fields will not reference parent/child
   */
  children?: Maybe<Array<ExtendedField>>;
  /** The default value of the extended field when not set */
  defaultValue?: Maybe<Scalars["String"]>;
  /** List of core fields or extended fields IDs which this extended field depends on */
  dependsOn?: Maybe<Array<Scalars["String"]>>;
  /** The description of the extended field */
  description?: Maybe<Scalars["String"]>;
  /** The draft ID - if the field is in a draft state. */
  draftId?: Maybe<Scalars["String"]>;
  /** The user role that can edit the extended field */
  editableBy?: Maybe<ExtendedFieldUserRole>;
  /** @deprecated Use editableBy instead */
  employeeEditable?: Maybe<Scalars["Boolean"]>;
  /** The entity requiring this field for export, if any. */
  exportFieldRequiredBy?: Maybe<RequirementType>;
  /** Mapping name on external source for the extended field */
  externalMappingName?: Maybe<Scalars["String"]>;
  /** The type of the extended field */
  fieldType?: Maybe<ExtendedFieldType>;
  /** The group that the extended field belongs to */
  group?: Maybe<ExtendedFieldGroup>;
  /** The HRIS Connection associated with this extended field (null if not associated to an HRIS connection) */
  hrConnection?: Maybe<HrConnection>;
  /** The ID of an object */
  id: Scalars["ID"];
  /** Optional, the extension for the integration field */
  integrationExtendedFieldExtension?: Maybe<IntegrationExtendedFieldExtension>;
  /** Whether this field has a Netsuite default field value set up */
  isDefaultIntegrationField?: Maybe<Scalars["Boolean"]>;
  isReferenceable?: Maybe<Scalars["Boolean"]>;
  isTargetable?: Maybe<Scalars["Boolean"]>;
  /**
   * A string version of the field, unique per source object.
   * If the key is NOT provided by customer, the snake case name will be used as the key.
   */
  key?: Maybe<Scalars["String"]>;
  /** The timestamp of the last update to the extended field. */
  lastUpdatedAt: Scalars["Time"];
  /** The legal entity that the extended field belongs to */
  legalEntityId?: Maybe<Scalars["ID"]>;
  /** The display name of the extended field */
  name?: Maybe<Scalars["String"]>;
  /** The options that are available for the extended field */
  options?: Maybe<ExtendedFieldOptionConnection>;
  /** The number of options that have subfields */
  optionsWithSubfieldsCount?: Maybe<Scalars["Int"]>;
  /** If the field is a draft field updating some origin field, this is the origin. */
  originField?: Maybe<ExtendedField>;
  /**
   * Extended field which the extended field options are dependent on
   * Parent Extended fields will not reference parent/child
   */
  parents?: Maybe<Array<ExtendedField>>;
  /** The ID of the field in the remote system. */
  remoteId?: Maybe<Scalars["String"]>;
  /**
   * The type of resource that the extended field is attached to
   * @deprecated Use sourceObjectTypes instead
   */
  sourceObjectType?: Maybe<SourceObjectType>;
  /** List of types of resource that the extended field is attached to */
  sourceObjectTypes: Array<SourceObjectType>;
  /** Whether the status of extended field is active, disabled */
  status?: Maybe<ExtendedFieldStatus>;
  /**
   * Optional. If this field syncs a field from an external system, this contains information to sync, such as permissions.
   * Null if this field was not created to sync a field in an external system.
   */
  syncMetadata?: Maybe<ExternalFieldSyncMetadata>;
  /** The value of the single tag with a matching key or null if there's no such tag. */
  tag?: Maybe<Scalars["String"]>;
  /** The tags associated with the extended field. The keys are unique. */
  tags?: Maybe<Array<ExtendedFieldTag>>;
  /** Whether the extended field is used in at least one group */
  usedInUserGroups?: Maybe<Scalars["Boolean"]>;
  /** Visibility rules for the field that configures how the fields/options can be displayed */
  visibilityRules?: Maybe<Array<ExtendedFieldVisibilityRule>>;
}

/**  ---[ Extended Types ]------------------ */
export interface ExtendedFieldchildrenArgs {
  filter?: InputMaybe<ExtendedFieldDependencyFilter>;
}

/**  ---[ Extended Types ]------------------ */
export interface ExtendedFieldoptionsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<ExtendedFieldOptionFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
  query?: InputMaybe<Scalars["String"]>;
  sort?: InputMaybe<ExtendedFieldOptionSortInput>;
}

/**  ---[ Extended Types ]------------------ */
export interface ExtendedFieldparentsArgs {
  filter?: InputMaybe<ExtendedFieldDependencyFilter>;
}

/**  ---[ Extended Types ]------------------ */
export interface ExtendedFieldtagArgs {
  key: Scalars["String"];
}

/** Address of an Extended Field (e.g. extended_field_foo123) */
export interface ExtendedFieldAddress {
  extendedField?: Maybe<ExtendedField>;
  id: Scalars["ID"];
}

/** Input for addressing Extended Fields (e.g. extended_field_foo123) */
export interface ExtendedFieldAddressInput {
  id: Scalars["ID"];
}

/** A paginated list of ExtendedField resources */
export interface ExtendedFieldConnection extends Connection {
  edges: Array<Maybe<ExtendedFieldEdge>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface ExtendedFieldCreateCSVTemplateInput {
  clientMutationId: Scalars["String"];
  /** The extended field identifier to create a CSV template for. */
  id: Scalars["ID"];
}

export type ExtendedFieldCreateCSVTemplateResult =
  | ExtendedFieldCreateCsvTemplateError
  | TemplateGenerationOperation;

export interface ExtendedFieldCreateCsvTemplateError
  extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface ExtendedFieldCreateDraftInput {
  /** The draft ID of the draft to create */
  draftId: Scalars["String"];
}

export interface ExtendedFieldCreateDraftMutationError
  extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

/** Response of creating draft fields */
export type ExtendedFieldCreateDraftResult =
  | ExtendedFieldCreateDraftMutationError
  | ExtendedFieldDraft;

/** Specific input fields for creating an extended field */
export interface ExtendedFieldCreationInput {
  /** Default value of the field. Can be null. */
  defaultValue?: InputMaybe<Scalars["String"]>;
  /** Description of the field. Can be null. */
  description?: InputMaybe<Scalars["String"]>;
  /** Draft ID for the field. Can be null. Used to stage changes, that won't show up explicitly. */
  draftId?: InputMaybe<Scalars["String"]>;
  editableBy?: InputMaybe<ExtendedFieldUserRole>;
  employeeEditable?: InputMaybe<Scalars["Boolean"]>;
  fieldType: ExtendedFieldType;
  group: ExtendedFieldGroup;
  isReferenceable?: InputMaybe<Scalars["Boolean"]>;
  isTargetable?: InputMaybe<Scalars["Boolean"]>;
  key?: InputMaybe<Scalars["String"]>;
  /** Legal Entity Id associated with the field. Can be null if there's no specified legal entity. */
  legalEntityId?: InputMaybe<Scalars["ID"]>;
  name: Scalars["String"];
  options?: InputMaybe<Array<InputMaybe<ExtendedFieldOptionInput>>>;
  /** The ID of the field in the remote system. */
  remoteId?: InputMaybe<Scalars["String"]>;
  /** Whether to return options or not. Defaults to include */
  returnOptions?: InputMaybe<ExtendedFieldReturnOptions>;
  sourceObjectType?: InputMaybe<SourceObjectType>;
  sourceObjectTypes?: InputMaybe<Array<SourceObjectType>>;
  /** The status of the field. Defaults to active. */
  status?: InputMaybe<ExtendedFieldStatus>;
  /** Tags associated with the field. The keys must be unique. */
  tags?: InputMaybe<Array<ExtendedFieldTagInput>>;
  /** Visibility rule for the field. Can be null. */
  visibilityRule?: InputMaybe<ExtendedFieldVisibilityRuleCreationInput>;
}

/** Input for filtering extended field dependencies by origin */
export interface ExtendedFieldDependencyFilter {
  /** Filter by dependency origin types */
  origins?: InputMaybe<Array<ExtendedFieldDependencyOrigin>>;
}

/** The origin of extended field dependencies */
export enum ExtendedFieldDependencyOrigin {
  EXTERNAL = "EXTERNAL",
  USER = "USER",
}

export interface ExtendedFieldDraft {
  draftId: Scalars["String"];
}

/** An ExtendedField within a ExtendedFieldConnection */
export interface ExtendedFieldEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<ExtendedField>;
}

/** Extended Fields filter condition to be applied */
export interface ExtendedFieldFilterConditionInput {
  /** The filters to apply when querying for an extended field */
  condition: ExtendedFieldFilterConditionOneOf;
  /** Specify negate to optionally "NOT" the query filter */
  negate?: InputMaybe<Scalars["Boolean"]>;
}

/** Extended Fields filter condition one of to be applied */
export interface ExtendedFieldFilterConditionOneOf {
  /** The list of filters to AND together */
  and?: InputMaybe<Array<ExtendedFieldFilterConditionInput>>;
  /** The extended field matcher to apply */
  matcher?: InputMaybe<ExtendedFieldMatcherInput>;
  /** The list of filters to OR together */
  or?: InputMaybe<Array<ExtendedFieldFilterConditionInput>>;
}

/** Pagination filter to be applied to extendedFields query */
export interface ExtendedFieldFilterInput {
  customerAccountId?: InputMaybe<Scalars["ID"]>;
  customerAccountIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** The IDs of specific fields to fetch (return all extended fields under other conditions if not specified). */
  extendedFieldIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
  /** Specific input fields for filtering extended field options */
  fieldOptionFilterInput?: InputMaybe<ExtendedFieldOptionFilterInput>;
  /** The filters to apply when querying for an extended fields */
  filter?: InputMaybe<ExtendedFieldFilterConditionInput>;
  /** The list of extended field groups to filter by */
  groups?: InputMaybe<Array<InputMaybe<ExtendedFieldGroup>>>;
  /** The list of extended field keys to filter by */
  keys?: InputMaybe<Array<Scalars["String"]>>;
  /** The list of legal entity IDs to filter by */
  legalEntityIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** The list of source object types to filter by */
  sourceObjectTypes?: InputMaybe<Array<InputMaybe<SourceObjectType>>>;
  /** Tags to filter for. Will be AND'd together. */
  tags?: InputMaybe<Array<ExtendedFieldTagFilterInput>>;
  /** The view surface where extended fields will be displayed. To apply rules accordingly (e.g.: visualization, ordering) */
  viewSurface?: InputMaybe<ExtendedFieldViewSurface>;
}

/** The group that the extended field belongs to */
export enum ExtendedFieldGroup {
  ACCOUNTING = "ACCOUNTING",
  ADDENDUM = "ADDENDUM",
  EMPLOYEE = "EMPLOYEE",
  EXPENSE_CATEGORY = "EXPENSE_CATEGORY",
  HRIS = "HRIS",
  INTEGRATION = "INTEGRATION",
  PARTNER = "PARTNER",
  PER_DIEM_LOCATION = "PER_DIEM_LOCATION",
  VAT = "VAT",
  VAT_ADDENDUM = "VAT_ADDENDUM",
}

/**
 * This is an interface covering all types of fields.
 *
 * Each type is a wrapper type for field + value + whatever else that is related to the field instance for an object.
 * It is specific to each (Source Object ID, Field ID).
 */
export interface ExtendedFieldInstance {
  /** All the field instances that depend on this field for visibility reasons (the child fields) */
  dependencyOfAll?: Maybe<Array<ExtendedFieldInstance>>;
  /** All the field instances that this field depends on for visibility reasons (the parent fields) */
  dependsOnAll?: Maybe<Array<ExtendedFieldInstance>>;
  /** Whether this field's values are editable */
  editStatus?: Maybe<FieldEditStatus>;
  /** Specialized fields for extended field instances live in extensions */
  extension?: Maybe<ExtendedFieldInstanceExtension>;
  /** The extended field definition representing this field instance */
  field: ExtendedField;
  /**
   * Uniquely represents the field instance for a given source object and field definition.
   * Derived from the source object ID and field definition ID.
   */
  id: Scalars["ID"];
  /** Who last updated the field's value */
  updatedBy?: Maybe<ValueOriginator>;
  /** The potential values suggested as part of an automated workflow mapping rule */
  workflowValues?: Maybe<Array<WorkflowValue>>;
}

/**
 * This is an interface covering all types of fields.
 *
 * Each type is a wrapper type for field + value + whatever else that is related to the field instance for an object.
 * It is specific to each (Source Object ID, Field ID).
 */
export interface ExtendedFieldInstancedependencyOfAllArgs {
  filter?: InputMaybe<ExtendedFieldDependencyFilter>;
}

/**
 * This is an interface covering all types of fields.
 *
 * Each type is a wrapper type for field + value + whatever else that is related to the field instance for an object.
 * It is specific to each (Source Object ID, Field ID).
 */
export interface ExtendedFieldInstancedependsOnAllArgs {
  filter?: InputMaybe<ExtendedFieldDependencyFilter>;
}

export interface ExtendedFieldInstanceConnection extends Connection {
  edges: Array<ExtendedFieldInstanceEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface ExtendedFieldInstanceEdge {
  /**  Should support proper pagination here, so the cursor needs to encode source_object_type + field id */
  cursor?: Maybe<Scalars["String"]>;
  node: ExtendedFieldInstance;
}

/** The interface for all extended field instances. They should all share the same id as the field instance. */
export interface ExtendedFieldInstanceExtension {
  id: Scalars["ID"];
}

export interface ExtendedFieldKeyValueQuery {
  displayName: Scalars["String"];
  identifier: Scalars["String"];
  key: Scalars["String"];
  parity: ParityOperator;
}

/**
 * Matcher for Extended Fields.
 *
 * If multiple fields are provided, they are ANDed together. Every list element is ORed together.
 */
export interface ExtendedFieldMatcherInput {
  /** Field display name to filter by. Uses an ILIKE query */
  displayName?: InputMaybe<Scalars["String"]>;
  /** The draft ID for extended field */
  draftId?: InputMaybe<Scalars["String"]>;
  /** The extended field ids to filter by */
  extendedFieldIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** The extended field groups to filter by */
  groups?: InputMaybe<Array<ExtendedFieldGroup>>;
  /** The field refereceability to filter by */
  isReferenceable?: InputMaybe<Scalars["Boolean"]>;
  /** The extended field keys to filter by */
  keys?: InputMaybe<Array<Scalars["String"]>>;
  /** The legal entity ids to filter by */
  legalEntityIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** The source object types to filter by */
  sourceObjectTypes?: InputMaybe<Array<SourceObjectType>>;
  /** The extended field statuses to filter by (ACTIVE & DISABLED are both returned by default) */
  statuses?: InputMaybe<Array<InputMaybe<ExtendedFieldStatus>>>;
  /** Tags to filter for. Will be AND'd together. */
  tags?: InputMaybe<Array<ExtendedFieldTagFilterInput>>;
  /** The extended field type to filter by */
  types?: InputMaybe<Array<ExtendedFieldType>>;
}

/** Extended field mutation error */
export interface ExtendedFieldMutationError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

/** Extended field options are configurable options within an extended field */
export interface ExtendedFieldOption extends Node {
  /**
   * The subfields associated with the option.
   * WARNING PDP-2239: This is currently unable to return DELETED fields, even when explicitly requested
   */
  allSubfields?: Maybe<Array<ExtendedField>>;
  /** The description of the option. */
  description?: Maybe<Scalars["String"]>;
  /** The extension of the option */
  extension?: Maybe<ExtendedFieldOptionExtension>;
  /** The extended field definition for the option. */
  field?: Maybe<ExtendedField>;
  /** The ID of an object */
  id: Scalars["ID"];
  /**
   * A stable, external identifier for the option that is unique per field. It serves multiple purposes:
   * - Maintains a stable way to identify the option even if the display value changes
   * - Used for integration with external systems as a foreign key, providing a consistent way to track options across systems
   */
  identifier?: Maybe<Scalars["String"]>;
  /** @deprecated Use status instead */
  isDisabled?: Maybe<Scalars["Boolean"]>;
  /** The timestamp of the last update to the option. */
  lastUpdatedAt: Scalars["Time"];
  /** Optional, the legal entity if applicable. */
  legalEntities?: Maybe<Array<LegalEntity>>;
  /** If the option is a draft option updating some origin option, this is the origin. */
  originOption?: Maybe<ExtendedFieldOption>;
  /** The extended field option owners */
  owners?: Maybe<Group>;
  /** The ID of the field in the remote system. */
  remoteId?: Maybe<Scalars["String"]>;
  /** Whether the option is active, disabled, or deleted. */
  status: ExtendedFieldOptionStatus;
  /**
   * The subfields associated with the option.
   * @deprecated Use allSubfields.id instead
   */
  subFieldIds?: Maybe<Array<Scalars["ID"]>>;
  /** Optional, the extension of the vx option. */
  userCategoryExtension?: Maybe<ExtendedFieldOptionUserCategoryExtension>;
  /** The display name of the option. */
  value?: Maybe<Scalars["String"]>;
  /** Value ID of the field option; Usually it is a unique identifier for the field option in the remote system. */
  valueId?: Maybe<Scalars["String"]>;
  /** Whether or not the option in visible in the given context. */
  visibilityStatus?: Maybe<ExtendedFieldOptionVisibilityStatus>;
}

/** Extended field options are configurable options within an extended field */
export interface ExtendedFieldOptionallSubfieldsArgs {
  statuses?: InputMaybe<Array<ExtendedFieldStatus>>;
}

/** Extended field options are configurable options within an extended field */
export interface ExtendedFieldOptionvisibilityStatusArgs {
  visibilityRuleData: VisibilityRuleData;
}

/** A paginated list of ExtendedFieldOption resources */
export interface ExtendedFieldOptionConnection extends Connection {
  edges: Array<Maybe<ExtendedFieldOptionEdge>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface ExtendedFieldOptionCreateInput {
  clientMutationId: Scalars["String"];
  /** The extended field id for the option to be created. */
  extendedFieldId: Scalars["ID"];
  /** The option to be created */
  optionInput: ExtendedFieldOptionInput;
}

export type ExtendedFieldOptionCreateResult =
  | ExtendedFieldOption
  | ExtendedFieldOptionsMutationError;

export interface ExtendedFieldOptionDeleteInput {
  /** The extended field id for the options to be deleted. */
  extendedFieldId: Scalars["ID"];
  /** The option id to be deleted. */
  optionId: Scalars["ID"];
}

/** An ExtendedFieldOption within a ExtendedFieldOptionConnection */
export interface ExtendedFieldOptionEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<ExtendedFieldOption>;
}

/** Tag belonging to an extended field option */
export interface ExtendedFieldOptionExtension {
  integrationFieldOptionExtension?: Maybe<IntegrationFieldOptionExtension>;
}

/** Specific input fields for creating an extended field option extension */
export interface ExtendedFieldOptionExtensionInput {
  integrationFieldOptionExtension?: InputMaybe<IntegrationFieldOptionExtensionInput>;
}

/** Specific input fields for filtering extended field options */
export interface ExtendedFieldOptionFilterInput {
  /** Display name to query for. Is an ilike query. */
  displayName?: InputMaybe<Scalars["String"]>;
  fieldOptionViews?: InputMaybe<Array<InputMaybe<ExtendedFieldOptionView>>>;
  /** Optional: option ids to query for. */
  optionIds?: InputMaybe<Array<Scalars["ID"]>>;
  returnOptions?: InputMaybe<ExtendedFieldReturnOptions>;
  /**
   * What options to include based on disabled/deleted status. If not set, defaults to return all options: active, inactive and deleted.
   * If multiple statuses are set, acts as an OR.
   */
  statuses?: InputMaybe<Array<ExtendedFieldOptionStatus>>;
}

/** Specific input fields for creating an extended field option */
export interface ExtendedFieldOptionInput {
  /** The description of the option */
  description?: InputMaybe<Scalars["String"]>;
  /** Draft ID for the option. Can be null. Used to stage changes, that won't show up explicitly. */
  draftId?: InputMaybe<Scalars["String"]>;
  /** Option Extension */
  extension?: InputMaybe<ExtendedFieldOptionExtensionInput>;
  /** The identifier id associated with the option. */
  identifier?: InputMaybe<Scalars["String"]>;
  isDisabled?: InputMaybe<Scalars["Boolean"]>;
  /** The ID of the field in the remote system. */
  remoteId?: InputMaybe<Scalars["String"]>;
  /** The status of the option. Defaults to active. */
  status?: InputMaybe<ExtendedFieldOptionStatus>;
  /** The subfield extended field ids of the option. */
  subFieldIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** The display name of the option. */
  value?: InputMaybe<Scalars["String"]>;
  /** Value ID of the field option; Usually it is a unique identifier for the field option in the remote system. */
  valueId?: InputMaybe<Scalars["String"]>;
}

export interface ExtendedFieldOptionOwnerGroupInput {
  /** Add by property (e.g. department, title, etc.) */
  memberCondition?: InputMaybe<MemberConditionInput>;
  /** Add by UserID directly */
  memberIds?: InputMaybe<Array<Scalars["ID"]>>;
}

export enum ExtendedFieldOptionReportFormat {
  CSV = "CSV",
  XLSX = "XLSX",
}

export interface ExtendedFieldOptionRuleResult {
  conditionsMetResult: OptionVisibilityRuleConditionalResult;
  conditionsNotMetResult: OptionVisibilityRuleConditionalResult;
}

/** If the conditions are met, then apply conditions_met_result otherwise apply conditions_not_met_result. */
export interface ExtendedFieldOptionRuleResultInput {
  conditionsMetResult?: InputMaybe<OptionVisibilityRuleConditionalResultInput>;
  conditionsNotMetResult?: InputMaybe<OptionVisibilityRuleConditionalResultInput>;
}

export interface ExtendedFieldOptionSortInput {
  order: OrderByDirection;
  /** Required sort key */
  sortKey: ExtendedFieldOptionSortKeyType;
}

/** The sort key for the extended field options. */
export enum ExtendedFieldOptionSortKeyType {
  /** Sorts by option name */
  OPTION_NAME = "OPTION_NAME",
  /** Sorts by option updated at */
  OPTION_UPDATED_AT = "OPTION_UPDATED_AT",
}

/** The status of the extended field option */
export enum ExtendedFieldOptionStatus {
  ACTIVE = "ACTIVE",
  DELETED = "DELETED",
  DISABLED = "DISABLED",
}

export interface ExtendedFieldOptionSuggestionInformation {
  /** Confidence score for the suggestion */
  confidence: Scalars["Float"];
  /** Suggested option for the extended field */
  suggestedOption: ExtendedFieldOption;
}

export interface ExtendedFieldOptionUpdateInput {
  /** The extended field id for the option to be created. */
  extendedFieldId: Scalars["ID"];
  /** The option id to be updated. */
  optionId: Scalars["ID"];
  /** The option data to be updated */
  optionInput: ExtendedFieldOptionInput;
}

export type ExtendedFieldOptionUpdateResult =
  | ExtendedFieldOption
  | ExtendedFieldOptionsMutationError;

export interface ExtendedFieldOptionUserCategoryExtension {
  /** Optional, the parent option if this GL account has a parent. */
  parentOption?: Maybe<ExtendedFieldOption>;
  /**
   * Optional, the identifier id of the parent option, identifier is a field in ExtendedFieldOption.
   * @deprecated Use parentOption.identifier instead
   */
  parentOptionIdentifierId?: Maybe<Scalars["String"]>;
  /**
   * Optional - whether or not payments to this account are enabled.
   * Some GL account selections must have payments enabled (ex. GL on Xero bills)
   * This field is used for filtering valid accounts only
   */
  paymentsToAccountEnabled?: Maybe<Scalars["Boolean"]>;
  /** Required, the type of the GL account. */
  type: UserCategoryType;
}

/** The view configuration of filtering the extended field options */
export enum ExtendedFieldOptionView {
  INCLUDE_DELETED = "INCLUDE_DELETED",
  INCLUDE_DISABLED = "INCLUDE_DISABLED",
}

/** The visibility of extended field options after rule based filtering. */
export enum ExtendedFieldOptionVisibilitySetting {
  /** All the extended field option is visible */
  ALL = "ALL",
  /** None of the extended field option is visible */
  NONE = "NONE",
  /** Only the extended field option that is not filtered by rule is visible */
  RULE_FILTER = "RULE_FILTER",
}

export enum ExtendedFieldOptionVisibilityStatus {
  NOT_VISIBLE = "NOT_VISIBLE",
  VISIBLE = "VISIBLE",
}

/** Filter ANDs the different set fields together. */
export interface ExtendedFieldOptionsFilterInput {
  /** The extended field id associated with the options. */
  extendedFieldId: Scalars["ID"];
  /** The extended field keys associated with the options. These are OR'd together. */
  extendedFieldKeys?: InputMaybe<Array<Scalars["String"]>>;
  /**
   * What options to include based on disabled/deleted status. If not set, defaults to return only active options.
   * If multiple statuses are set, acts as an OR.
   */
  fieldOptionStatus?: InputMaybe<Array<ExtendedFieldOptionStatus>>;
  /** The identifiers of the options to include. Should be a decoded string. */
  identifierIds?: InputMaybe<Array<Scalars["String"]>>;
  /** Display name to query for. Is an ilike query. */
  optionDisplayName?: InputMaybe<Scalars["String"]>;
  /** The IDs of the options to include. */
  optionIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Filter options by Visibility Rule ID and Apply Condition. */
  optionVisibilityRuleFilter?: InputMaybe<OptionVisibilityRuleFilterInput>;
  /** Filter options by remote Ids, where remote ID is the ID generated by the external system (e.g. ERP or HRIS system). */
  remoteIds?: InputMaybe<Array<Scalars["String"]>>;
  /**
   * Filter options by User Category (GL Account) extension values.
   * Setting this filter will exclude all options that do not contain a UserCategoryOptionExtension.
   */
  userCategoryOptionExtensionFilter?: InputMaybe<UserCategoryOptionExtensionFilterInput>;
  /** Filter options by value Ids, where value ID is a globally unique identifier across all remote systems (eg. EPR or HRIS system). */
  valueIds?: InputMaybe<Array<Scalars["String"]>>;
}

export interface ExtendedFieldOptionsMutationError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

/** Whether to include options with fields or not */
export enum ExtendedFieldReturnOptions {
  EXCLUDE = "EXCLUDE",
  INCLUDE = "INCLUDE",
}

export interface ExtendedFieldRuleResult {
  conditionsMetResult: FieldVisibilityRuleConditionalResult;
  conditionsNotMetResult: FieldVisibilityRuleConditionalResult;
}

/** If the conditions are met, then apply conditions_met_result otherwise apply conditions_not_met_result. */
export interface ExtendedFieldRuleResultInput {
  conditionsMetResult?: InputMaybe<FieldVisibilityRuleConditionalResultInput>;
  conditionsNotMetResult?: InputMaybe<FieldVisibilityRuleConditionalResultInput>;
}

export interface ExtendedFieldSingleValue {
  value?: Maybe<ExtendedFieldSingleValueUnion>;
}

export type ExtendedFieldSingleValueUnion =
  | BoolValue
  | DateValue
  | DecimalValue
  | EnumValue
  | IdentifierToStringValue
  | StringValue
  | TimestampValue;

/** The extended field sort by type */
export enum ExtendedFieldSortBy {
  /** Sort by logical order, i.e, according to field visibility rules dependency */
  LOGICAL_ORDER = "LOGICAL_ORDER",
  /** Sort the extended fields by name alphabetically */
  NAME = "NAME",
}

/** Extended field sort input */
export interface ExtendedFieldSortByInput {
  /** The extended field to sort by type */
  sort_by: ExtendedFieldSortBy;
}

/** The status of the extended field */
export enum ExtendedFieldStatus {
  ACTIVE = "ACTIVE",
  DELETED = "DELETED",
  DISABLED = "DISABLED",
  DRAFT = "DRAFT",
}

/** Tag belonging to an extended field */
export interface ExtendedFieldTag {
  key: Scalars["String"];
  value: Scalars["String"];
}

/** Specific input fields for filtering by an extended field tag */
export interface ExtendedFieldTagFilterInput {
  key: Scalars["String"];
  value: Scalars["String"];
}

/** Specific input fields for creating an extended field tag */
export interface ExtendedFieldTagInput {
  key: Scalars["String"];
  value: Scalars["String"];
}

export interface ExtendedFieldToOptionsInput {
  /** The extended field id for the options to be created. */
  extendedFieldId: Scalars["ID"];
  /** The options to be created */
  optionInput: Array<ExtendedFieldOptionInput>;
}

/** The type of the extended field */
export enum ExtendedFieldType {
  BOOL = "BOOL",
  DATE = "DATE",
  DECIMAL = "DECIMAL",
  ENUM = "ENUM",
  FINANCIAL_ASSET = "FINANCIAL_ASSET",
  IDENTIFIER = "IDENTIFIER",
  STRING = "STRING",
}

/** Specific input fields for updating an extended field */
export interface ExtendedFieldUpdateInput {
  /** Description of the field */
  description?: InputMaybe<Scalars["String"]>;
  /** Draft ID for the change. Can be null. Used to stage changes, that won't show up explicitly. */
  draftId?: InputMaybe<Scalars["String"]>;
  editableBy?: InputMaybe<ExtendedFieldUserRole>;
  employeeEditable?: InputMaybe<Scalars["Boolean"]>;
  /** Required only for batch update endpoint to identify the field to be updated */
  id?: InputMaybe<Scalars["ID"]>;
  name?: InputMaybe<Scalars["String"]>;
  options?: InputMaybe<Array<InputMaybe<ExtendedFieldOptionInput>>>;
  /** Whether to return options or not. Defaults to include */
  returnOptions?: InputMaybe<ExtendedFieldReturnOptions>;
  /** The status of the field. Defaults to active. */
  status?: InputMaybe<ExtendedFieldStatus>;
  /** Tags associated with the field. The keys must be unique. */
  tags?: InputMaybe<Array<ExtendedFieldTagInput>>;
}

/** The role that can edit the extended field */
export enum ExtendedFieldUserRole {
  ADMIN = "ADMIN",
  EMPLOYEE = "EMPLOYEE",
}

export interface ExtendedFieldValue {
  extendedField?: Maybe<ExtendedField>;
  key?: Maybe<Scalars["String"]>;
  value?: Maybe<ExtendedFieldValueUnion>;
}

export interface ExtendedFieldValueConnection extends Connection {
  edges: Array<ExtendedFieldValueEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface ExtendedFieldValueEdge {
  cursor?: Maybe<Scalars["String"]>;
  node: ExtendedFieldValue;
}

export enum ExtendedFieldValueEditStatus {
  /** The value is locked */
  LOCKED = "LOCKED",
  /** The value is unlocked */
  UNLOCKED = "UNLOCKED",
}

/** Input for creating a new extended field value */
export interface ExtendedFieldValueInput {
  key: Scalars["String"];
  value?: InputMaybe<ExtendedFieldValueOneOfInput>;
}

/** Acts as an input union depending on which field is not NULL */
export interface ExtendedFieldValueOneOfInput {
  boolValue?: InputMaybe<BoolValueInput>;
  boolValues?: InputMaybe<Array<BoolValueInput>>;
  enumValue?: InputMaybe<EnumValueInput>;
  enumValues?: InputMaybe<Array<EnumValueInput>>;
  identifierToStringValue?: InputMaybe<IdentifierToStringValueInput>;
  identifierToStringValues?: InputMaybe<Array<IdentifierToStringValueInput>>;
  numberValue?: InputMaybe<NumberValueInput>;
  numberValues?: InputMaybe<Array<NumberValueInput>>;
  /**  single values */
  stringValue?: InputMaybe<StringValueInput>;
  /**  multi values */
  stringValues?: InputMaybe<Array<StringValueInput>>;
}

export enum ExtendedFieldValueOriginator {
  /** The value was automatically set by computing its value based on other data or Extensible Workflow Rules. */
  AUTOMATED = "AUTOMATED",
  /** The value was manually set by a user */
  MANUAL = "MANUAL",
}

/**
 * TODO: Add documentation
 * TODO: Add MultipleValue support when needed
 */
export type ExtendedFieldValueUnion = ExtendedFieldSingleValue;

export interface ExtendedFieldValuesFilterInput {
  identifiers: Array<Scalars["String"]>;
  key: Scalars["String"];
}

/** The extended field view surface */
export enum ExtendedFieldViewSurface {
  ACCOUNTING_DETAILS_PANE = "ACCOUNTING_DETAILS_PANE",
  /** Rules for displaying the Bills fields on the expense details pane and the Bills form */
  BILLS_ON_DETAILS_PANE_AND_FORM = "BILLS_ON_DETAILS_PANE_AND_FORM",
}

/** A Visibility Rule for an Extended Field or Extended Field Option */
export interface ExtendedFieldVisibilityRule {
  condition: VisibilityRuleCondition;
  conditions: Array<VisibilityRuleCondition>;
  extendedField: ExtendedField;
  id: Scalars["ID"];
  lastUpdatedAt: Scalars["Time"];
  operator?: Maybe<LogicalOperator>;
  origin?: Maybe<ExtendedFieldVisibilityRuleOrigin>;
  priority?: Maybe<Scalars["Int"]>;
  result: VisibilityRuleResult;
  status: ExtendedFieldVisibilityRuleStatus;
  visibilityRuleLevel: ExtendedFieldVisibilityRuleLevel;
}

/** The visibility Rule Apply Condition */
export enum ExtendedFieldVisibilityRuleApplyCondition {
  CONDITION_MET = "CONDITION_MET",
  CONDITION_NOT_MET = "CONDITION_NOT_MET",
}

/** Specific input fields for creating an extended field visibility rule */
export interface ExtendedFieldVisibilityRuleCreationInput {
  /** The conditions that must be met for this rule to apply. */
  conditions: Array<VisibilityRuleConditionInput>;
  /** The extended field id associated with the visibility rule. */
  extendedFieldId?: InputMaybe<Scalars["String"]>;
  /** How to join the rules */
  operator?: InputMaybe<LogicalOperator>;
  /** Rule priority */
  priority?: InputMaybe<Scalars["Int"]>;
  /** The result of the conditions. */
  result: VisibilityRuleResultOneOfInput;
  /** The visibility level of this rule. */
  visibilityRuleLevel: ExtendedFieldVisibilityRuleLevel;
}

/** The visibility level of this rule */
export enum ExtendedFieldVisibilityRuleLevel {
  /** The visibility rule is applied at the extended field level */
  FIELD = "FIELD",
  /** The visibility rule is applied at the extended field option level */
  OPTION = "OPTION",
}

export interface ExtendedFieldVisibilityRuleMutationError
  extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

/** The origin of visibility for an Extended Field Visibility Rule */
export enum ExtendedFieldVisibilityRuleOrigin {
  EXTERNAL = "EXTERNAL",
  USER = "USER",
}

/** The role that visibility rules are being evaluated for. */
export enum ExtendedFieldVisibilityRuleRole {
  ADMIN = "ADMIN",
  EMPLOYEE = "EMPLOYEE",
}

/** The status of an Extended Field Visibility Rule */
export enum ExtendedFieldVisibilityRuleStatus {
  ACTIVE = "ACTIVE",
  DELETED = "DELETED",
  DISABLED = "DISABLED",
}

/** Specific input fields for updating an extended field visibility rule */
export interface ExtendedFieldVisibilityRuleUpdateInput {
  /** The conditions that must be met for this rule to apply. */
  conditions?: InputMaybe<Array<VisibilityRuleConditionInput>>;
  /** How to join the rules */
  operator?: InputMaybe<LogicalOperator>;
  /** Rule priority */
  priority?: InputMaybe<Scalars["Int"]>;
  /** The result of the conditions. */
  result?: InputMaybe<VisibilityRuleResultOneOfInput>;
  /** The status of the visibility rule. Defaults to active. */
  status?: InputMaybe<ExtendedFieldVisibilityRuleStatus>;
}

/** The visibility of extended fields after rule based filtering. */
export enum ExtendedFieldVisibilitySetting {
  /** The extended field is hidden */
  HIDDEN = "HIDDEN",
  /** The extended field is visible */
  VISIBLE = "VISIBLE",
}

/**
 * The expense policy ecosystem currently uses an extended notion of "merchant category." We allow the use of standard
 * Present merchant categories, but we also allow various rules to target "Meals," which is a sort of "compound" merchant
 * category that represents a group of Present categories including "Groceries," "Restaurants," "Bars & Nightlife," and
 * "Food delivery." We represent this as a [CompoundMerchantCategory].
 */
export type ExtendedMerchantCategory =
  | CompoundMerchantCategory
  | ExpenseCategory
  | MerchantCategory;

/**
 * The expense policy ecosystem currently uses an extended notion of "merchant category." We allow the use of standard
 * Present merchant categories, but we also allow various rules to target "Meals," which is a sort of "compound" merchant
 * category that represents a group of Present categories including "Groceries," "Restaurants," "Bars & Nightlife," and
 * "Food delivery." We represent this as a [CompoundMerchantCategory].
 */
export interface ExtendedMerchantCategoryOneOfInput {
  compoundMerchantCategoryType?: InputMaybe<CompoundMerchantCategoryType>;
  expenseCategoryId?: InputMaybe<Scalars["ID"]>;
  merchantCategoryId?: InputMaybe<Scalars["ID"]>;
}

/** An interface which any object that provides custom fields must implement */
export interface ExtensibleEntity {
  /** Returns a specific extended field instance by ID */
  extendedFieldInstance?: Maybe<ExtendedFieldInstance>;
  /** Returns a paginated list of extended field instances for this entity */
  extendedFieldInstances?: Maybe<ExtendedFieldInstanceConnection>;
}

/** An interface which any object that provides custom fields must implement */
export interface ExtensibleEntityextendedFieldInstanceArgs {
  id: Scalars["ID"];
}

/** An interface which any object that provides custom fields must implement */
export interface ExtensibleEntityextendedFieldInstancesArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<ExtendedFieldFilterConditionInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

/** Metadata for Extended Field Values related to Extensible Workflows */
export interface ExtensibleWorkflowMetadata {
  /** Whether the ExtendedFieldValue is in conflict with another ExtendedFieldValue for the same ExtendedField. */
  hasConflict: Scalars["Boolean"];
  /** The rule that set this value. */
  rule?: Maybe<WorkflowRule>;
  /**
   * The Extensible Workflow Rule ID that set this value.
   * If unset then this field was not set by a Extensible Workflow Rule
   * @deprecated Use rule.id instead
   */
  ruleId: Scalars["String"];
}

export interface ExtensibleWorkflowMetadataInput {
  /**
   * Whether the ExtendedFieldValue is in conflict with another ExtendedFieldValue for the same ExtendedField.
   *
   * This should be FALSE when set during conflict resolution (i.e. user picked this EFV as the winner of a conflict)
   */
  hasConflict: Scalars["Boolean"];
  /** The Extensible Workflow Rule ID that set this value. */
  ruleId: Scalars["String"];
}

export interface ExternalApiMetadata {
  autoApproveUserIds?: Maybe<Array<Scalars["String"]>>;
  recurrenceId: Scalars["String"];
  source: Scalars["String"];
}

export interface ExternalAttendee {
  /** The company at which this attendee works */
  companyName?: Maybe<Scalars["String"]>;
  /** An id for this external attendee */
  id: Scalars["ID"];
  /** Whether or not this attendee is flagged as a government official by the user */
  isGovernmentOfficial?: Maybe<Scalars["Boolean"]>;
  /** The name of this attendee */
  name: Scalars["String"];
  /** The job title of this attendee */
  title?: Maybe<Scalars["String"]>;
}

export interface ExternalAttendeeInput {
  /** The company at which this attendee works */
  companyName?: InputMaybe<Scalars["String"]>;
  /** An id for this external attendee */
  id?: InputMaybe<Scalars["ID"]>;
  /** Whether or not this attendee is flagged as a government official by the user */
  isGovernmentOfficial?: InputMaybe<Scalars["Boolean"]>;
  /** The name of this attendee */
  name: Scalars["String"];
  /** The job title of this attendee */
  title?: InputMaybe<Scalars["String"]>;
}

export interface ExternalAttendeeSuggestion extends AttendeeSuggestion {
  /** Company */
  company?: Maybe<Scalars["String"]>;
  /** Overall confidence level i.e. whether we should auto-apply */
  confidenceLevel: SuggestionConfidenceLevel;
  /** ID of associated external attendee, present if suggestion is auto-applied */
  externalAttendeeId?: Maybe<Scalars["ID"]>;
  /** Government Employment Details */
  governmentEmployee?: Maybe<Scalars["Boolean"]>;
  /** Full Name (required) */
  name: Scalars["String"];
  /** Job Title */
  title?: Maybe<Scalars["String"]>;
}

export interface ExternalConnection {
  credential?: Maybe<VendorCredential>;
  redirectUrl?: Maybe<Scalars["String"]>;
}

/** Most likely initiated by a Brex customer but externally such that we can't identify them */
export interface ExternalCounterparty {
  /** The external counterparty's account holder name */
  accountHolderName?: Maybe<Scalars["String"]>;
}

export interface ExternalFieldSyncCheck {
  /** Foreseen errors that may arise if trying to sync the field. */
  errors?: Maybe<Array<ExternalFieldSyncError>>;
  /** If successful, the field and its values can be read from the external system. */
  result?: Maybe<ExternalFieldSyncCheckResult>;
}

export enum ExternalFieldSyncCheckResult {
  FAILURE = "FAILURE",
  SUCCESS = "SUCCESS",
}

export interface ExternalFieldSyncError {
  /** If a field cannot be synced, what foreseen errors, known or unknown, that will cause a field sync to fail. */
  cause?: Maybe<ExternalFieldSyncErrorCause>;
  /** User-visible error message. */
  userDisplayMessage?: Maybe<Scalars["String"]>;
}

/** What issue will cause the field to fail sync. */
export enum ExternalFieldSyncErrorCause {
  MISSING_PERMISSIONS = "MISSING_PERMISSIONS",
  UNKNOWN_ERROR = "UNKNOWN_ERROR",
}

export interface ExternalFieldSyncMetadata {
  /**
   * Whether the field is required to be synced. Without this field, features of the integration are known to malfunction.
   * Examples of required fields required by the integration are GL accounts, Subsidiary.
   */
  requirement?: Maybe<ExternalFieldSyncRequirement>;
  /**
   * If the field syncs a field from an external system, this is the result from checking the ability to sync.
   * Null if this field is not synced against an external system.
   */
  syncCheck?: Maybe<ExternalFieldSyncCheck>;
}

export enum ExternalFieldSyncRequirement {
  /** The field is not required, and the integration will function correctly without it. */
  OPTIONAL = "OPTIONAL",
  /** Indicates the field is required for the integration. */
  REQUIRED = "REQUIRED",
}

export interface ExternalIntegrationEntity extends Node {
  /** Time of deletion, either if explicitly deleted in the ERP or not found in refetch */
  deletedAt?: Maybe<Scalars["Time"]>;
  /** ID that references an entity's parent integration field, i.e. Netsuite Class */
  externalIntegrationFieldId: Scalars["ID"];
  /** The ID of an object */
  id: Scalars["ID"];
  integration?: Maybe<Integration>;
  /** Flag that denotes whether this entity was marked as inactive on the ERP side */
  isInactive?: Maybe<Scalars["Boolean"]>;
  /** Human-readable name */
  name?: Maybe<Scalars["String"]>;
  /** Entities are arranged in a tree structure */
  parentEntity?: Maybe<ExternalIntegrationEntity>;
  /** Soft deprecated, will delete soon - use external_integration_field_id */
  payload?: Maybe<ExternalIntegrationEntityPayload>;
  /** ID used by the external ERP to uniquely identify an entity */
  vendorInternalId?: Maybe<Scalars["String"]>;
}

export interface ExternalIntegrationEntityConnection {
  edges?: Maybe<Array<Maybe<ExternalIntegrationEntityEdge>>>;
  pageInfo: PageInfo;
}

export interface ExternalIntegrationEntityEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<ExternalIntegrationEntity>;
}

export type ExternalIntegrationEntityPayload =
  | CodatTrackingCategory
  | Generic
  | IntacctClass
  | IntacctCustom
  | IntacctCustomer
  | IntacctDepartment
  | IntacctLocation
  | IntacctVendor
  | NetsuiteClass
  | NetsuiteCustom
  | NetsuiteCustomer
  | NetsuiteDepartment
  | NetsuiteLocation
  | NetsuiteProject
  | NetsuiteSegment
  | NetsuiteTaxCode
  | NetsuiteVendor
  | QbdClass
  | QbdCustomer
  | QuickbooksClass
  | QuickbooksCustomer
  | QuickbooksLocation
  | QuickbooksVendor
  | XeroTrackingCategory;

/** Schema for external integration fields */
export interface ExternalIntegrationField extends Node {
  deletedAt?: Maybe<Scalars["Time"]>;
  /** Key used in the ERP for custom fields */
  externalKey?: Maybe<Scalars["String"]>;
  /** Extra metadata specified for custom fields, i.e. { field_type: 'string' } */
  externalMetadata?: Maybe<Scalars["Json"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  integrationId: Scalars["ID"];
  isInactive?: Maybe<Scalars["Boolean"]>;
  /** Most recent of: (last refresh on ERP Integration or creation of integration field) [not to be confused with updated_at] */
  lastUpdatedAt?: Maybe<Scalars["Time"]>;
  /** Human-readable name used for custom fields, i.e. Colour, City */
  name?: Maybe<Scalars["String"]>;
  /** Count of all the non-deleted external integration entities given an integration field */
  totalEntityCount?: Maybe<Scalars["Int"]>;
  type: IntegrationFieldType;
}

export interface ExternalIntegrationFieldConnection {
  edges?: Maybe<Array<Maybe<ExternalIntegrationFieldEdge>>>;
  pageInfo: PageInfo;
  /** Total number of integration fields. */
  totalCount: Scalars["Int"];
}

export interface ExternalIntegrationFieldEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<ExternalIntegrationField>;
}

export interface ExternalLegalEntitiesFilterInput {
  hasMappedValue: Scalars["Boolean"];
}

/** Legal Entity synced from HRIS that may or may not map to a legal entity in Brex */
export interface ExternalLegalEntity {
  displayName: Scalars["String"];
  id: Scalars["ID"];
  mappedLegalEntity?: Maybe<MappedLegalEntity>;
  /** @deprecated Prefer mappedLegalEntity */
  mappedValue?: Maybe<LegalEntity>;
}

/** ExternalLegalEntity connection for pagination */
export interface ExternalLegalEntityConnection extends Connection {
  edges: Array<ExternalLegalEntityEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

/** ExternalLegalEntity edge for the ExternalLegalEntity connection. */
export interface ExternalLegalEntityEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<ExternalLegalEntity>;
}

export interface ExternalLegalEntityMappingBatchCreateInput {
  mappings: Array<ExternalLegalEntityMappingCreateInput>;
}

export interface ExternalLegalEntityMappingBatchCreateResult {
  results?: Maybe<Array<ExternalLegalEntityMappingCreateResult>>;
}

export interface ExternalLegalEntityMappingBatchUpdateInput {
  mappings: Array<ExternalLegalEntityMappingUpdateInput>;
}

export interface ExternalLegalEntityMappingBatchUpdateResult {
  results?: Maybe<Array<ExternalLegalEntityMappingUpdateResult>>;
}

export interface ExternalLegalEntityMappingCreateError
  extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface ExternalLegalEntityMappingCreateInput {
  /**
   * The legal entity in Brex to map the
   * external legal entity to
   */
  brexLegalEntityId: Scalars["ID"];
  /** The external legal entity's ID */
  externalLegalEntityId: Scalars["ID"];
}

export type ExternalLegalEntityMappingCreateResult =
  | ExternalLegalEntity
  | ExternalLegalEntityMappingCreateError;

export interface ExternalLegalEntityMappingUpdateError
  extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface ExternalLegalEntityMappingUpdateInput {
  /**
   * The legal entity in Brex to map the
   * external legal entity to
   */
  brexLegalEntityId: Scalars["ID"];
  /**
   * The mapping's ID (for update)
   * This is the ID of the MappedLegalEntity type
   */
  mappedLegalEntityId: Scalars["ID"];
}

export type ExternalLegalEntityMappingUpdateResult =
  | ExternalLegalEntity
  | ExternalLegalEntityMappingUpdateError;

export interface ExternallyOriginatedChequeDetails {
  backImageSrc?: Maybe<Scalars["String"]>;
  chequeMemo?: Maybe<Scalars["String"]>;
  frontImageSrc?: Maybe<Scalars["String"]>;
  initiatorCustomerUser?: Maybe<User>;
  returnReason?: Maybe<ReturnReason>;
  senderName?: Maybe<Scalars["String"]>;
  type?: Maybe<TxType>;
}

export interface ExtractedBillFields {
  contact?: Maybe<PaymentContact>;
  contactCreated?: Maybe<Scalars["Boolean"]>;
  dueAmountCents?: Maybe<Scalars["Int"]>;
  dueAt?: Maybe<Scalars["Time"]>;
  externalInvoiceNumber?: Maybe<Scalars["String"]>;
  paymentInstrument?: Maybe<PaymentInstrument>;
  paymentSendAt?: Maybe<Scalars["Time"]>;
  transferDescription?: Maybe<Scalars["String"]>;
}

export interface FAM {
  id: Scalars["ID"];
}

export interface FSPAccount {
  description: Scalars["String"];
  detailsLink: Scalars["String"];
  fspCustomerAccountId: Scalars["ID"];
  logoLink: Scalars["String"];
  name: Scalars["String"];
}

/** Represents the client that an FSP has */
export interface FSPClientAccount {
  account?: Maybe<Account>;
  connectedUsers: Array<User>;
  connectedUsersConnection?: Maybe<FspClientAccountConnectedUsersConnection>;
  contact: Scalars["String"];
  customerAccountId: Scalars["ID"];
  id: Scalars["ID"];
  name: Scalars["String"];
  status: FspConnectionStatus;
  /**
   * Whether or not the viewer can manage this client account. "Managing" an account means being able to log in as a
   * bookkeeper or other role.
   */
  viewerCanManage?: Maybe<Scalars["Boolean"]>;
}

/** Represents the client that an FSP has */
export interface FSPClientAccountconnectedUsersArgs {
  roles?: InputMaybe<Array<FSPUserRole>>;
}

/** Represents the client that an FSP has */
export interface FSPClientAccountconnectedUsersConnectionArgs {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  where?: InputMaybe<FspClientAccountConnectedUsersWhereInput>;
}

export interface FSPClientAccountEdge {
  cursor: Scalars["String"];
  node: FSPClientAccount;
}

export interface FSPUser {
  customerUserId: Scalars["ID"];
  fspRoles: Array<FSPUserRole>;
}

/**  Note: Only includes valid FSP user roles, should be updated if additional FSP user roles are added */
export enum FSPUserRole {
  BILL_PAY_DRAFTER = "BILL_PAY_DRAFTER",
  BOOKKEEPER = "BOOKKEEPER",
}

/** The type of rule facet. */
export enum FacetType {
  /** Conflicting rule type facet. */
  CONFLICTING = "CONFLICTING",
  /** Custom rule type facet. */
  CUSTOM = "CUSTOM",
  /** Invalid facet type. */
  INVALID = "INVALID",
  /** Merchant rule type facet. */
  MERCHANT = "MERCHANT",
  /** Manual override rule type facet. */
  OVERRIDE = "OVERRIDE",
}

export interface FakeMutationDoNotUseInput {
  cashIntensiveMaxCashHandled?: InputMaybe<CashIntensiveMaxCashHandled>;
  clientMutationId: Scalars["String"];
  fiNbfiRegistrationStatus?: InputMaybe<FiNbfiRegistrationStatus>;
}

export interface FakeMutationDoNotUsePayload {
  clientMutationId: Scalars["String"];
}

export interface FboTransferDetails {
  fboAccountName?: Maybe<Scalars["String"]>;
}

export interface FeatureFlagResponse {
  enabled: Scalars["Boolean"];
  name: Scalars["String"];
}

export interface FeatureFlagsRequest {
  flags?: InputMaybe<Array<Scalars["String"]>>;
}

export interface FeatureFlagsResponse {
  flags?: Maybe<Array<FeatureFlagResponse>>;
}

/** Represents a participant in the FedACH system. */
export interface FedachParticipant {
  /** The date of the last change to the participant's information. */
  changeDate: Scalars["String"];
  /** The address of the customer. */
  customerAddress: Scalars["String"];
  /** The area code of the customer's phone number. */
  customerAreaCode: Scalars["String"];
  /** The city where the customer is located. */
  customerCity: Scalars["String"];
  /** The institution's logo as a base64 PNG, if available. */
  customerLogoBase64?: Maybe<Scalars["String"]>;
  /** The name of the customer. */
  customerName: Scalars["String"];
  /** The prefix of the customer's phone number. */
  customerPhonePrefix: Scalars["String"];
  /** The suffix of the customer's phone number. */
  customerPhoneSuffix: Scalars["String"];
  /** The state where the customer is located. */
  customerState: Scalars["String"];
  /** The ZIP code of the customer's location. */
  customerZip: Scalars["String"];
  /** The extension of the customer's ZIP code. */
  customerZipExt: Scalars["String"];
  /** The data view code of the participant. */
  dataViewCode: Scalars["String"];
  /** The ID of the participant object. */
  id: Scalars["ID"];
  /** The status code of the institution. */
  institutionStatusCode: Scalars["String"];
  /** The new routing number of the participant, if it has been changed. */
  newRoutingNumber: Scalars["String"];
  /** The office code of the participant. */
  officeCode: Scalars["String"];
  /** The record type code of the participant. */
  recordTypeCode: Scalars["String"];
  /** The routing number of the participant. */
  routingNumber: Scalars["String"];
  /** The servicing FRB number of the participant. */
  servicingFrbNumber: Scalars["String"];
}

/** Represents a participant in the Fedwire system. */
export interface FedwireParticipant {
  /** The date of the last change to the participant's information. */
  changeDate?: Maybe<Scalars["String"]>;
  /** The city where the customer is located. */
  customerCity: Scalars["String"];
  /** The institution's logo as a base64 PNG, if available. */
  customerLogoBase64?: Maybe<Scalars["String"]>;
  /** The name of the customer. */
  customerName: Scalars["String"];
  /** The state where the customer is located. */
  customerState: Scalars["String"];
  /** The eligibility of the participant for funds. */
  fundsEligibility: Scalars["String"];
  /** The settlement only status of the participant for funds. */
  fundsSettlementOnlyStatus?: Maybe<Scalars["String"]>;
  /** The ID of the participant object. */
  id: Scalars["ID"];
  /** The routing number of the participant. */
  routingNumber: Scalars["String"];
  /** The eligibility of the participant for securities. */
  securitiesEligibility: Scalars["String"];
  /** The telegraphic name of the participant. */
  telegraphicName: Scalars["String"];
}

export interface Fee {
  amount?: Maybe<FinancialAsset>;
  label?: Maybe<Scalars["String"]>;
}

export interface FeeTransaction {
  associatedTransactionId?: Maybe<Scalars["ID"]>;
}

/**
 * A piece of Feedback. It consists of feedback provided by a customer, broader
 * context for how the feedback was submitted, as well as reviews done by Brex
 * internal users.
 */
export interface Feedback {
  /** Internal ID if submitted by a Brex employee on behalf of a customer */
  brexInternalReporter?: Maybe<Scalars["String"]>;
  /** Cuacc for the customer who submitted this feedback */
  customerAccountId: Scalars["String"];
  /** Cuuser for the customer who submitted this feedback */
  customerUserId: Scalars["String"];
  /** Salesforce ID for the related case */
  feedbackCaseId?: Maybe<Scalars["String"]>;
  /** Salesforce number for the related case */
  feedbackCaseNumber?: Maybe<Scalars["String"]>;
  /** List of related escalation links (Salesforce cases or Jira tickets) */
  feedbackEscalationLinks: Array<Scalars["String"]>;
  /** Prompts and freeform text responses from the customer */
  feedbackMessages: Array<FeedbackMessage>;
  /** Where in product this feedback was submitted from */
  feedbackSource: FeedbackSource;
  /** Current status of this feedback */
  feedbackStatus?: Maybe<FeedbackStatus>;
  /** What type of feedback this is */
  feedbackType: FeedbackType;
  /** Feedback primary key */
  id: Scalars["ID"];
  insertedAt: Scalars["Time"];
  /** Subject entered by the customer */
  subjectLine?: Maybe<Scalars["String"]>;
  updatedAt: Scalars["Time"];
}

/** Each Feedback Message represents one question & response submitted as feedback */
export interface FeedbackMessage {
  /** The prompt or question the user saw when submitting a response */
  prompt: Scalars["String"];
  /** Freeform text submitted by the user */
  response?: Maybe<Scalars["String"]>;
}

/** Source that feedback was submitted from */
export enum FeedbackSource {
  /** Unset value for this enumeration */
  FEEDBACK_SOURCE_INVALID = "FEEDBACK_SOURCE_INVALID",
  /** Feedback source is Retool */
  FEEDBACK_SOURCE_RETOOL = "FEEDBACK_SOURCE_RETOOL",
  /** Feedback source is the Support Hub */
  FEEDBACK_SOURCE_SUPPORT_HUB = "FEEDBACK_SOURCE_SUPPORT_HUB",
}

/** Current status of a Feedback */
export enum FeedbackStatus {
  /** Unset value for this enumeration */
  FEEDBACK_STATUS_INVALID = "FEEDBACK_STATUS_INVALID",
  /** The delegate's access to copilot mode was revoked. */
  FEEDBACK_STATUS_NEW = "FEEDBACK_STATUS_NEW",
  /** This Feedback has been fully processed; end status */
  FEEDBACK_STATUS_PROCESSED = "FEEDBACK_STATUS_PROCESSED",
  /** Salesforce Case for this Feedback has been created */
  FEEDBACK_STATUS_SFDC_CASE_CREATED = "FEEDBACK_STATUS_SFDC_CASE_CREATED",
}

/** Type of Feedback */
export enum FeedbackType {
  /** Unset value for this enumeration */
  FEEDBACK_TYPE_INVALID = "FEEDBACK_TYPE_INVALID",
  /** Feedback is of type Suggestion */
  FEEDBACK_TYPE_SUGGESTION = "FEEDBACK_TYPE_SUGGESTION",
}

export interface FiNbfiPayloadInput {
  businessAttestation: Scalars["Boolean"];
  businessAttestationVersion: Scalars["String"];
  dateOfLastRegistration?: InputMaybe<Scalars["Date"]>;
  directlyProvidesRegulatedServices: Scalars["Boolean"];
  explanationForRegulationExclusion: Scalars["String"];
  operateInCountries?: InputMaybe<Array<Scalars["String"]>>;
  primaryRegulator: Scalars["String"];
  registrationNumber: Scalars["String"];
  registrationStatus: RegistrationStatus;
}

export enum FiNbfiRegistrationStatus {
  APPLIED_AND_REJECTED = "APPLIED_AND_REJECTED",
  APPLIED_AND_WAITING_ON_A_DECISION = "APPLIED_AND_WAITING_ON_A_DECISION",
  CURRENTLY_REGISTERED = "CURRENTLY_REGISTERED",
  DO_NOT_PLAN_TO_REGISTER = "DO_NOT_PLAN_TO_REGISTER",
  INVALID = "INVALID",
  PLAN_TO_REGISTER = "PLAN_TO_REGISTER",
}

export enum Field {
  CONTRACT_END_DATE = "CONTRACT_END_DATE",
  CONTRACT_START_DATE = "CONTRACT_START_DATE",
  DOMESTIC_OVERAGE_FEE = "DOMESTIC_OVERAGE_FEE",
  DOMESTIC_UNIT_PRICE = "DOMESTIC_UNIT_PRICE",
  GLOBAL_OVERAGE_FEE = "GLOBAL_OVERAGE_FEE",
  GLOBAL_UNIT_PRICE = "GLOBAL_UNIT_PRICE",
  IMPLEMENTATION_FEE = "IMPLEMENTATION_FEE",
  N_DOMESTIC_SEATS = "N_DOMESTIC_SEATS",
  N_GLOBAL_SEATS = "N_GLOBAL_SEATS",
  SUBSCRIPTION_END_DATE = "SUBSCRIPTION_END_DATE",
  SUBSCRIPTION_LINES = "SUBSCRIPTION_LINES",
  SUBSCRIPTION_LINE_PRICE = "SUBSCRIPTION_LINE_PRICE",
  SUBSCRIPTION_LINE_QUANTITY = "SUBSCRIPTION_LINE_QUANTITY",
  SUBSCRIPTION_START_DATE = "SUBSCRIPTION_START_DATE",
  SUBSCRIPTION_TERM = "SUBSCRIPTION_TERM",
  TRAVEL_BOOKINGS = "TRAVEL_BOOKINGS",
  TRAVEL_BOOKINGS_TRUE_UP = "TRAVEL_BOOKINGS_TRUE_UP",
}

/** Defines how the calculate the points (X1, Y1), (X1, Y2), (X2, Y1), (X2, Y2) */
export enum FieldCoordinateType {
  /**
   * The coordinates are decimal values representing the positioning relative to the image dimensions, between 0 and 1.
   * Calculate the four points as follows: (X1, Y1), (X1, Y2), (X2, Y1), (X2, Y2)
   * X1 = image width * Xmin
   * X2 = image width * Xmax
   * Y1 = image height * Ymin
   * Y2 = image height * Ymax
   */
  RELATIVE = "RELATIVE",
}

/** Enum to control how UI display a requirement field */
export enum FieldDisplayType {
  /** For address input */
  ADDRESS = "ADDRESS",
  /** For date input */
  DATE = "DATE",
  /** Invalid enum value */
  INVALID = "INVALID",
  /** For phone input */
  PHONE = "PHONE",
  /** Pick only one out all possible options */
  RADIO = "RADIO",
  /** For UI Dropdowns */
  SELECT = "SELECT",
  /** Default value, plain text */
  TEXT = "TEXT",
}

export enum FieldEditStatus {
  LOCKED = "LOCKED",
  UNLOCKED = "UNLOCKED",
}

export interface FieldSuggestionInformation {
  /** ID of the extended field this suggestion applies to */
  extendedFieldId: Scalars["String"];
  /** The suggested extended field option */
  suggestedOption: ExtendedFieldOption;
  /** ID of the suggested option */
  suggestedOptionId: Scalars["String"];
}

export interface FieldVisibilityRuleConditionalResult {
  visibilitySetting: ExtendedFieldVisibilitySetting;
}

/** Specific input fields for creating an extended field visibility rule conditional result */
export interface FieldVisibilityRuleConditionalResultInput {
  visibilitySetting: ExtendedFieldVisibilitySetting;
}

export interface FieldsRequiredForExportConnection extends Connection {
  edges?: Maybe<Array<Maybe<FieldsRequiredForExportEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"];
}

export interface FieldsRequiredForExportEdge {
  cursor: Scalars["ID"];
  node?: Maybe<ExtendedField>;
}

export interface FileAsset {
  /** The content type of the file. */
  contentType?: Maybe<Scalars["String"]>;
  /** The name of the file. */
  name?: Maybe<Scalars["String"]>;
}

/** Structured data for file sharing operations */
export interface FileShareContent extends StructuredData {
  /** The name of the shared file */
  fileName?: Maybe<Scalars["String"]>;
  /** The type of file shared */
  fileType?: Maybe<Scalars["String"]>;
  /** Type discriminator value - 'FileShareContent' */
  type?: Maybe<Scalars["String"]>;
}

/** External File template type for the integration used for importing fields */
export enum FileTemplateType {
  IIF = "IIF",
  MULTI_FIELD_CSV = "MULTI_FIELD_CSV",
  SINGLE_FIELD_CSV = "SINGLE_FIELD_CSV",
}

export interface FilestoreIdToType {
  filestoreId: Scalars["ID"];
  type: FinancialStatementType;
}

/**
 * Specifies which entity filter to apply. Only one filter may be defined in this input, and it has to be the entity
 * selected, otherwise it will fail.
 */
export interface FilterConditionOneOf {
  accountingRecordFieldMatcher?: InputMaybe<AccountingJournalEntryFilterInput>;
  bankingInvoiceFieldMatcher?: InputMaybe<BankingInvoiceEntityFieldMatcherInput>;
  bankingTransactionFieldMatcher?: InputMaybe<BankingTransactionEntityFieldMatcherInput>;
  bookingFieldMatcher?: InputMaybe<BookingEntityFieldMatcherInput>;
  budgetFieldMatcher?: InputMaybe<BudgetFieldMatcherInput>;
  cardFieldMatcher?: InputMaybe<CardFieldMatcherInput>;
  departmentFieldMatcher?: InputMaybe<DepartmentFieldMatcherInput>;
  expenseFieldMatcher?: InputMaybe<ExpensePrimitiveFieldMatcherInput>;
  userFieldMatcher?: InputMaybe<UserFieldMatcherInput>;
  vendorCategoryFieldMatcher?: InputMaybe<VendorCategoryPrimitiveFieldMatcherInput>;
}

export type FilterMetadata = NestedBudgetMetadata;

/**
 * Acts as an input union/oneOf depending on which field is not NULL
 * One field is required to be set
 */
export interface FilterMetadataOneOfInput {
  nestedBudgetMetadata?: InputMaybe<NestedBudgetMetadataInput>;
}

/** The operator for the filter */
export enum FilterOperator {
  EQUALS = "EQUALS",
  GREATER_THAN = "GREATER_THAN",
  GREATER_THAN_EQUAL = "GREATER_THAN_EQUAL",
  /**
   * The leftHandSide string matches the right hand side ILIKE pattern (case insensitive)
   * https://docs.snowflake.com/en/sql-reference/functions/ilike.html
   */
  ILIKE = "ILIKE",
  /** The leftHandSide value is in a list of rightHandSide values or contained within a String/Int rightHandSide value */
  IN = "IN",
  /**
   * Unary operator.
   *
   * Check that the value of leftHandSide field is "empty". Additional checks based on the type of the leftHandSide:
   * String -> value should be an empty string if not null
   * List (MultipleValues) -> value should be an empty list of not null
   * Everything else -> value should be null
   *
   * The rightHandSide value should be left empty and will be ignored if set.
   */
  IS_EMPTY = "IS_EMPTY",
  /** The inverse of the IS_EMPTY operator */
  IS_NOT_EMPTY = "IS_NOT_EMPTY",
  /** The inverse of the IS_NULL operator */
  IS_NOT_NULL = "IS_NOT_NULL",
  /**
   * Unary operator.
   *
   * Check if the leftHandSide value is null.
   * The rightHandSide value should be left empty and will be ignored if set.
   */
  IS_NULL = "IS_NULL",
  LESS_THAN = "LESS_THAN",
  LESS_THAN_EQUAL = "LESS_THAN_EQUAL",
  NOT_EQUALS = "NOT_EQUALS",
  /** Inverse of the ILIKE operator */
  NOT_ILIKE = "NOT_ILIKE",
  /** Inverse of the IN operator */
  NOT_IN = "NOT_IN",
}

export interface FinancialAccount extends Node {
  /** Whether the account can make Cash outgoing ach debits or not */
  achDebitCapability: AchDebitCapability;
  description?: Maybe<Scalars["String"]>;
  details?: Maybe<FinancialAccountDetails>;
  /**
   * Soft-deletion of funding resources is represented using a disabled status.
   * We don't want to expose this implementation details to clients. There is currently
   * no known use case in the UI for showing additional status information, but they
   * could be included here as needed.
   */
  fundingSource?: Maybe<FundingSource>;
  /** The ID of an object */
  id: Scalars["ID"];
  /** If Financial Account has routing and account number, or if account is MD */
  isDepository?: Maybe<Scalars["Boolean"]>;
  latestBalance?: Maybe<FinancialBalance>;
  name?: Maybe<Scalars["String"]>;
  nickname?: Maybe<Scalars["String"]>;
  /** customer_user_id who created the connection hence created the account */
  ownershipCustomerUserId?: Maybe<Scalars["String"]>;
  /** POAO ownership verification status */
  ownershipVerificationStatus?: Maybe<OwnershipVerificationStatus>;
  priority?: Maybe<FundingSourcePriority>;
  /** self-attestation account type collected after account creation */
  selfAttestationAccountType?: Maybe<SelfAttestationAccountType>;
  source?: Maybe<FinancialSource>;
  /** If account is used in Underwriting. Currently only resolvable through financialAccounts query in financials-v2 */
  underwritingEligibility?: Maybe<UnderwritingEligibility>;
  /** If account is used in Underwriting. Currently only resolvable through financialAccounts query in financials-v2 */
  usedInUnderwriting?: Maybe<UsedInUnderwriting>;
  /** If Financial Account is a micro-deposit, this is their verification status */
  verificationStatus?: Maybe<VerificationStatusType>;
}

export interface FinancialAccountConnection {
  edges?: Maybe<Array<Maybe<FinancialAccountEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"];
  totalLatestBalance: FinancialAsset;
}

export interface FinancialAccountDetails {
  /** Last 4 digits of account number if it exists. */
  accountNumberLast4?: Maybe<Scalars["String"]>;
  /** Last 4 digits of routing number if it exists. */
  routingNumberLast4?: Maybe<Scalars["String"]>;
  type?: Maybe<FinancialAccountType>;
}

export interface FinancialAccountEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<FinancialAccount>;
}

export enum FinancialAccountType {
  CHECKING = "CHECKING",
  CREDIT_CARD = "CREDIT_CARD",
  INVESTMENT = "INVESTMENT",
  LINE_OF_CREDIT = "LINE_OF_CREDIT",
  LOAN = "LOAN",
  MONEY_MARKET = "MONEY_MARKET",
  MORTGAGE = "MORTGAGE",
  SAVINGS = "SAVINGS",
}

/** Financial Asset wrapper */
export interface FinancialAsset {
  /**
   * The instrument code enum (USD, etc.).
   * @deprecated Deprecated instrumentCode enum. Use instrumentCodeString instead.
   */
  instrumentCode: FinancialInstrumentCode;
  /** The instrument code (USD, etc.). */
  instrumentCodeString: Scalars["String"];
  /** The quantity in the base unit (ie: dollars, not cents). */
  quantity: Scalars["Decimal"];
  /**
   * The amount in cents if the currency is USD, otherwise throws an error.
   * @deprecated quantityCents is USD specific. Use quantity instead.
   */
  quantityCents: Scalars["Int"];
}

export interface FinancialAssetFieldInstance
  extends ExtendedFieldInstance,
    Node {
  dependencyOfAll?: Maybe<Array<ExtendedFieldInstance>>;
  dependsOnAll?: Maybe<Array<ExtendedFieldInstance>>;
  editStatus?: Maybe<FieldEditStatus>;
  extension?: Maybe<ExtendedFieldInstanceExtension>;
  field: ExtendedField;
  /** The instance of the value associated with this field instance. Null means unset */
  financialAssetValue?: Maybe<FinancialAsset>;
  /** The ID of an object */
  id: Scalars["ID"];
  updatedBy?: Maybe<ValueOriginator>;
  workflowValues?: Maybe<Array<WorkflowFinancialAssetValue>>;
}

export interface FinancialAssetFieldInstancedependencyOfAllArgs {
  filter?: InputMaybe<ExtendedFieldDependencyFilter>;
}

export interface FinancialAssetFieldInstancedependsOnAllArgs {
  filter?: InputMaybe<ExtendedFieldDependencyFilter>;
}

export interface FinancialAssetFieldInstanceInput {
  /** The client mutation id */
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fieldInstanceId: Scalars["ID"];
  /** Explicitly set this to null to clear the value */
  value?: InputMaybe<FinancialAssetInput>;
}

export interface FinancialAssetInconsistency {
  externalValue?: Maybe<FinancialAsset>;
  scdValue?: Maybe<FinancialAsset>;
}

/**
 * From APIv1
 * https://github.com/brexhq/credit_card/blob/main/apps/api/lib/api/web/schema/financial_asset.ex#L13
 */
export interface FinancialAssetInput {
  /** (Deprecated) The instrument code (USD, etc.). Use instrumentCodeString instead. */
  instrumentCode?: InputMaybe<FinancialInstrumentCode>;
  /** The instrument code (USD, etc.). */
  instrumentCodeString?: InputMaybe<Scalars["String"]>;
  /** The quantity in the base unit (ie: dollars, not cents). */
  quantity?: InputMaybe<Scalars["Decimal"]>;
  /** (Deprecated) The amount in cents if the currency is USD. Use quantity instead. */
  quantityCents?: InputMaybe<Scalars["Int"]>;
}

export type FinancialAssetMovement = CardFinancialAssetMovement;

/** A FinancialAssetMovement connection for FinancialAssetMovement pagination. */
export interface FinancialAssetMovementConnection extends Connection {
  /** The financial asset movements in the current page of results. */
  edges: Array<FinancialAssetMovementEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of financial asset movements matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

/** A FinancialAssetMovement edge for the FinancialAssetMovement connection. */
export interface FinancialAssetMovementEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The financial asset movement at this edge. */
  node?: Maybe<FinancialAssetMovement>;
}

export interface FinancialAssetMovementInterface {
  /** Time when the movement was cleared */
  clearedAt?: Maybe<Scalars["LocalDateTime"]>;
  /** The customer account that the movement is associated with */
  customerAccount: Account;
  /** The unique id of the movement, generated by the backend */
  id: Scalars["ID"];
  /** Time when the movement was initiated */
  initiatedAt: Scalars["LocalDateTime"];
  /** The status of the movement, e.g. PENDING, DECLINED, CLEARED etc. */
  status: FinancialAssetMovementStatus;
  /** The type of the movement, e.g. CARD etc. */
  type: FinancialAssetMovementType;
}

export enum FinancialAssetMovementRail {
  CARD = "CARD",
}

/**
 * ---[ External Types for Federation ]-------------------------
 * ---[ Input Types ]---------------------
 * ---[ Enums ]---------------------------
 */
export enum FinancialAssetMovementStatus {
  CANCELED = "CANCELED",
  CLEARED = "CLEARED",
  CREDITED = "CREDITED",
  DECLINED = "DECLINED",
  PENDING = "PENDING",
  REFUNDED = "REFUNDED",
  REFUNDING = "REFUNDING",
  WITHDRAWING = "WITHDRAWING",
  WITHDREW = "WITHDREW",
}

export enum FinancialAssetMovementType {
  CARD = "CARD",
}

export interface FinancialAssetRangeInput {
  /** Exclusive, only considers given currency, required to have same currency when minAmount is provided. */
  maxAmount?: InputMaybe<FinancialAssetInput>;
  /** Inclusive, only considers given currency, required to have same currency when maxAmount is provided. */
  minAmount?: InputMaybe<FinancialAssetInput>;
}

export interface FinancialAssetValue {
  value?: Maybe<FinancialAsset>;
}

/**  This is currently only resolvable on APIv1. */
export interface FinancialBalance extends Node {
  /** Time of balance */
  accrualTime: Scalars["Time"];
  /** Amount of balance in cents */
  amount: Scalars["Int"];
  /** Amount of balance in cents */
  amountLong: Scalars["Long"];
  /** The ID of an object */
  id: Scalars["ID"];
}

export interface FinancialBalanceV2 extends Node {
  accountBalanceType?: Maybe<AccountBalanceType>;
  accountId?: Maybe<Scalars["String"]>;
  availableBalance?: Maybe<BalanceWithTimestamp>;
  currentBalance?: Maybe<BalanceWithTimestamp>;
  /** The ID of an object */
  id: Scalars["ID"];
}

export interface FinancialBalanceV2Connection {
  edges?: Maybe<Array<Maybe<FinancialBalanceV2Edge>>>;
  pageInfo: PageInfo;
}

export interface FinancialBalanceV2Edge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<FinancialBalanceV2>;
}

/** A financial_document representing specifically a bank statement */
export interface FinancialBankStatementDocument extends Node {
  /** The last digits of the bank account number for display */
  accountNumberLastFour?: Maybe<Scalars["String"]>;
  /** Asset/Filestore ID of statement document */
  assetId: Scalars["String"];
  bankAccountNumber?: Maybe<Scalars["String"]>;
  /** Bank/Financial institution & account number associated with the statement account */
  bankName?: Maybe<Scalars["String"]>;
  /** First & last name of user who uploaded the statement */
  firstName?: Maybe<Scalars["String"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  lastName?: Maybe<Scalars["String"]>;
  /** The month of the requested statement */
  requestedMonth: Scalars["Int"];
  /** Status of uploaded statement document */
  status: FinancialDocumentStatus;
  /** Upload timestamp of the statement document */
  uploadedAt: Scalars["Time"];
}

export interface FinancialBankStatementDocumentConnection {
  edges?: Maybe<Array<Maybe<FinancialBankStatementDocumentEdge>>>;
  pageInfo: PageInfo;
}

export interface FinancialBankStatementDocumentEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<FinancialBankStatementDocument>;
}

export interface FinancialDocument {
  encodedFilestoreId: Scalars["ID"];
  encodedFinancialStatementRequestId: Scalars["ID"];
  encodedRequiredItemId?: Maybe<Scalars["ID"]>;
  encodedRequiredItemMappingId?: Maybe<Scalars["ID"]>;
  fileName: Scalars["String"];
  financialSpreadId?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  status: FinancialStatementDocumentStatus;
  type: FinancialDocumentType;
  uploadedBy?: Maybe<Employee>;
  uploadedDate: Scalars["Time"];
}

export enum FinancialDocumentStatus {
  ACCEPTED = "ACCEPTED",
  DUPLICATE = "DUPLICATE",
  /** Uploaded statements are defaulted to `processing` status */
  PROCESSING = "PROCESSING",
  REJECTED = "REJECTED",
}

export enum FinancialDocumentType {
  BALANCE_SHEET = "BALANCE_SHEET",
  BANK_STATEMENT = "BANK_STATEMENT",
  INCOME_STATEMENT = "INCOME_STATEMENT",
  STATEMENT_OF_CASH_FLOWS = "STATEMENT_OF_CASH_FLOWS",
}

export interface FinancialInstitution extends Node {
  /** The ID of an object */
  id: Scalars["ID"];
  imageUrls?: Maybe<FinancialInstitutionImageUrls>;
  loginFields?: Maybe<Array<Maybe<FinancialLoginField>>>;
  loginInstructions?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  nameRegex?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["Int"]>;
  status?: Maybe<FinancialInstitutionStatus>;
  vendorsMapping?: Maybe<Array<Maybe<VendorInstitution>>>;
  website?: Maybe<Scalars["String"]>;
}

export interface FinancialInstitutionConnection {
  edges?: Maybe<Array<Maybe<FinancialInstitutionEdge>>>;
  pageInfo: PageInfo;
}

export interface FinancialInstitutionEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<FinancialInstitution>;
}

export interface FinancialInstitutionImageUrls {
  icon?: Maybe<Scalars["String"]>;
  logo?: Maybe<Scalars["String"]>;
}

export enum FinancialInstitutionStatus {
  DISABLED = "DISABLED",
  ENABLED = "ENABLED",
  INTERNAL = "INTERNAL",
  PENDING = "PENDING",
}

/** Financial instrument node extended from APIv1 */
export interface FinancialInstrument {
  /**
   * Subset of the instrument code enum used exclusively for deposits
   * @deprecated Deprecated subset of the instrument code enum used exclusively for deposits. Use instrumentCodeString instead.
   */
  code?: Maybe<InstrumentCode>;
  /** The countries where the instrument is the default currency */
  defaultCountries: Array<Country>;
  /** The emoji flag of the instrument code */
  emoji?: Maybe<Scalars["String"]>;
  /**
   * The instrument code enum (USD, etc.).
   * @deprecated The instrument code enum (USD, etc.). Use instrumentCodeString instead.
   */
  instrumentCode: FinancialInstrumentCode;
  /** The instrument code (USD, etc.). */
  instrumentCodeString: Scalars["String"];
  /** The instrument code name (US Dollars, etc.). */
  name?: Maybe<Scalars["String"]>;
  /** Restrictions associated with the country */
  restrictions: FinancialInstrumentRestrictions;
  /** The ticker symbol of the instrument code (USD, etc.). */
  tickerSymbol?: Maybe<Scalars["String"]>;
}

/**
 * From APIv1
 * https://github.com/brexhq/credit_card/blob/main/apps/api/lib/api/web/schema/financial_asset.ex#L7
 * https://github.com/brexhq/credit_card/blob/main/libraries/brex_financial_asset/lib/financial_instrument_constants.ex#L962
 */
export enum FinancialInstrumentCode {
  AED = "AED",
  AFN = "AFN",
  ALL = "ALL",
  AMD = "AMD",
  ANG = "ANG",
  AOA = "AOA",
  ARS = "ARS",
  AUD = "AUD",
  AWG = "AWG",
  AZN = "AZN",
  BAM = "BAM",
  BBD = "BBD",
  BDT = "BDT",
  BGN = "BGN",
  BHD = "BHD",
  BIF = "BIF",
  BMD = "BMD",
  BND = "BND",
  BOB = "BOB",
  BOV = "BOV",
  BRL = "BRL",
  BSD = "BSD",
  BTN = "BTN",
  BWP = "BWP",
  BYN = "BYN",
  BZD = "BZD",
  CAD = "CAD",
  CDF = "CDF",
  CHE = "CHE",
  CHF = "CHF",
  CHW = "CHW",
  CLF = "CLF",
  CLP = "CLP",
  CNH = "CNH",
  CNY = "CNY",
  COP = "COP",
  COU = "COU",
  CRC = "CRC",
  CRYPTO_BTC = "CRYPTO_BTC",
  CRYPTO_ETH = "CRYPTO_ETH",
  CRYPTO_USDC = "CRYPTO_USDC",
  CUC = "CUC",
  CUP = "CUP",
  CVE = "CVE",
  CZK = "CZK",
  DJF = "DJF",
  DKK = "DKK",
  DOP = "DOP",
  DZD = "DZD",
  EGP = "EGP",
  ERN = "ERN",
  ETB = "ETB",
  EUR = "EUR",
  FJD = "FJD",
  FKP = "FKP",
  GBP = "GBP",
  GEL = "GEL",
  GHS = "GHS",
  GIP = "GIP",
  GMD = "GMD",
  GNF = "GNF",
  GTQ = "GTQ",
  GYD = "GYD",
  HKD = "HKD",
  HNL = "HNL",
  HRK = "HRK",
  HTG = "HTG",
  HUF = "HUF",
  IDR = "IDR",
  ILS = "ILS",
  INR = "INR",
  IQD = "IQD",
  IRR = "IRR",
  ISK = "ISK",
  JMD = "JMD",
  JOD = "JOD",
  JPY = "JPY",
  KES = "KES",
  KGS = "KGS",
  KHR = "KHR",
  KMF = "KMF",
  KPW = "KPW",
  KRW = "KRW",
  KWD = "KWD",
  KYD = "KYD",
  KZT = "KZT",
  LAK = "LAK",
  LBP = "LBP",
  LKR = "LKR",
  LRD = "LRD",
  LSL = "LSL",
  LYD = "LYD",
  MAD = "MAD",
  MDL = "MDL",
  MGA = "MGA",
  MKD = "MKD",
  MMK = "MMK",
  MNT = "MNT",
  MOP = "MOP",
  MRU = "MRU",
  MUR = "MUR",
  MVR = "MVR",
  MWK = "MWK",
  MXN = "MXN",
  MXV = "MXV",
  MYR = "MYR",
  MZN = "MZN",
  NAD = "NAD",
  NASDAQ_DAGXX = "NASDAQ_DAGXX",
  NASDAQ_DGCXX = "NASDAQ_DGCXX",
  NASDAQ_DGVXX = "NASDAQ_DGVXX",
  NASDAQ_DPGXX = "NASDAQ_DPGXX",
  NASDAQ_GGBXX = "NASDAQ_GGBXX",
  NASDAQ_GGDXX = "NASDAQ_GGDXX",
  NASDAQ_GGSXX = "NASDAQ_GGSXX",
  NASDAQ_GSBXX = "NASDAQ_GSBXX",
  NGN = "NGN",
  NIO = "NIO",
  NOK = "NOK",
  NPR = "NPR",
  NZD = "NZD",
  OMR = "OMR",
  PAB = "PAB",
  PEN = "PEN",
  PGK = "PGK",
  PHP = "PHP",
  PKR = "PKR",
  PLN = "PLN",
  PYG = "PYG",
  QAR = "QAR",
  RON = "RON",
  RSD = "RSD",
  RUB = "RUB",
  RWF = "RWF",
  SAR = "SAR",
  SBD = "SBD",
  SCR = "SCR",
  SDG = "SDG",
  SEK = "SEK",
  SGD = "SGD",
  SHP = "SHP",
  SLL = "SLL",
  SOS = "SOS",
  SRD = "SRD",
  SSP = "SSP",
  STN = "STN",
  SVC = "SVC",
  SYP = "SYP",
  SZL = "SZL",
  THB = "THB",
  TJS = "TJS",
  TMT = "TMT",
  TND = "TND",
  TOP = "TOP",
  TRY = "TRY",
  TTD = "TTD",
  TWD = "TWD",
  TZS = "TZS",
  UAH = "UAH",
  UGX = "UGX",
  USD = "USD",
  USN = "USN",
  UYI = "UYI",
  UYU = "UYU",
  UYW = "UYW",
  UZS = "UZS",
  VES = "VES",
  VND = "VND",
  VUV = "VUV",
  WST = "WST",
  XAF = "XAF",
  XAG = "XAG",
  XAU = "XAU",
  XBA = "XBA",
  XBB = "XBB",
  XBC = "XBC",
  XBD = "XBD",
  XCD = "XCD",
  XDR = "XDR",
  XOF = "XOF",
  XPD = "XPD",
  XPF = "XPF",
  XPT = "XPT",
  XSU = "XSU",
  XTS = "XTS",
  XUA = "XUA",
  XXX = "XXX",
  YER = "YER",
  ZAR = "ZAR",
  ZMW = "ZMW",
  ZWL = "ZWL",
}

export interface FinancialInstrumentRestrictions {
  /** Indicates if the financial instrument is enabled for international wires */
  isEnabledForInternationalWires: Scalars["Boolean"];
  /** Indicates if the financial instrument is supported for historical fx rates */
  isSupportedForHistoricalFxRates: Scalars["Boolean"];
}

/**  Financial Asset Schemas */
export interface FinancialInstrumentsListFilters {
  /** Filter to include enabled financial instruments for international reimbursements */
  includeEnabledForInternationalWires?: InputMaybe<Scalars["Boolean"]>;
  includeSupportedForHistoricalFxRates?: InputMaybe<Scalars["Boolean"]>;
}

export interface FinancialLoginField {
  contentType?: Maybe<FinancialLoginFieldContentType>;
  description?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["String"]>;
  masked?: Maybe<Scalars["Boolean"]>;
  name?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["Int"]>;
}

export enum FinancialLoginFieldContentType {
  IMAGE = "IMAGE",
  PASSWORD = "PASSWORD",
  TEXT = "TEXT",
  UNKNOWN = "UNKNOWN",
  USERNAME = "USERNAME",
}

export enum FinancialPeriod {
  APRIL = "APRIL",
  AUGUST = "AUGUST",
  DECEMBER = "DECEMBER",
  FEBRUARY = "FEBRUARY",
  FY = "FY",
  JANUARY = "JANUARY",
  JULY = "JULY",
  JUNE = "JUNE",
  MARCH = "MARCH",
  MAY = "MAY",
  NOVEMBER = "NOVEMBER",
  OCTOBER = "OCTOBER",
  Q1 = "Q1",
  Q2 = "Q2",
  Q3 = "Q3",
  Q4 = "Q4",
  SEPTEMBER = "SEPTEMBER",
}

/**  From here https://github.com/brexhq/credit_card/blob/main/apps/customer_common/lib/models/conversion/account.ex#L15 */
export enum FinancialProductType {
  ECOMMERCE = "ECOMMERCE",
  LIFESCIENCES = "LIFESCIENCES",
  STARTUP = "STARTUP",
}

/** The business's expected financial services usage on Brex. */
export enum FinancialServiceType {
  ACH_OUTSIDE_US = "ACH_OUTSIDE_US",
  ACH_US = "ACH_US",
  CARD = "CARD",
  CHECK = "CHECK",
  WIRE_OUTSIDE_US = "WIRE_OUTSIDE_US",
  WIRE_US = "WIRE_US",
}

/**  This is currently only resolvable on APIv1. */
export interface FinancialSource extends Node {
  accounts?: Maybe<FinancialAccountConnection>;
  disconnectReason?: Maybe<Scalars["String"]>;
  fixRequired?: Maybe<Scalars["Boolean"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  institution?: Maybe<FinancialInstitution>;
  lastSyncTime?: Maybe<Scalars["Time"]>;
  payload: FinancialSourcePayload;
  status: FinancialSourceStatus;
  vendor: FinancialsVendor;
}

/**  This is currently only resolvable on APIv1. */
export interface FinancialSourceaccountsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

export interface FinancialSourceConnection {
  edges?: Maybe<Array<Maybe<FinancialSourceEdge>>>;
  pageInfo: PageInfo;
}

export interface FinancialSourceEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<FinancialSource>;
}

export type FinancialSourcePayload =
  | DemoPayload
  | FinicityPayload
  | PlaidPayload
  | TellerPayload;

export enum FinancialSourceStatus {
  ACTIVE = "ACTIVE",
  CONNECTING = "CONNECTING",
  ERROR = "ERROR",
  INVALID = "INVALID",
  PENDING = "PENDING",
  USER_ACTION = "USER_ACTION",
}

export interface FinancialSourceVendorOverride {
  institutionId?: Maybe<Scalars["String"]>;
  overriddenVendorInternalId?: Maybe<Scalars["String"]>;
  overrideVendor?: Maybe<FinancialsVendor>;
}

export interface FinancialSourceVendorOverrideConnection {
  edges?: Maybe<Array<Maybe<FinancialSourceVendorOverrideEdge>>>;
  pageInfo: PageInfo;
}

export interface FinancialSourceVendorOverrideEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<FinancialSourceVendorOverride>;
}

/** An account which we require statement update from the customer */
export interface FinancialStatementAccount extends Node {
  /** The last digits of the bank account number for display */
  accountNumberLastFour?: Maybe<Scalars["String"]>;
  /** account number associated with the statement account */
  bankAccountNumber?: Maybe<Scalars["String"]>;
  /** Bank/Financial institution */
  bankName?: Maybe<Scalars["String"]>;
  /** Financial Account ID */
  financialAccountId: Scalars["String"];
  /** The ID of an object */
  id: Scalars["ID"];
}

export interface FinancialStatementAccountConnection {
  edges?: Maybe<Array<Maybe<FinancialStatementAccountEdge>>>;
  pageInfo: PageInfo;
}

export interface FinancialStatementAccountEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<FinancialStatementAccount>;
}

export enum FinancialStatementDocumentStatus {
  ACCEPTED = "ACCEPTED",
  PENDING = "PENDING",
  REJECTED = "REJECTED",
}

export enum FinancialStatementRejectionReason {
  BALANCE_SHEET_NOT_BALANCED = "BALANCE_SHEET_NOT_BALANCED",
  CASH_BASIS_ACCOUNTING = "CASH_BASIS_ACCOUNTING",
  ENCRYPTED_FILE_WITHOUT_PASSWORD = "ENCRYPTED_FILE_WITHOUT_PASSWORD",
  FOREIGN_CURRENCY = "FOREIGN_CURRENCY",
  INCORRECT_PERIOD = "INCORRECT_PERIOD",
  INVALID_DOCUMENT_TYPE = "INVALID_DOCUMENT_TYPE",
  LINE_ITEM_CUT_OFF = "LINE_ITEM_CUT_OFF",
  MISSING_ACCOUNT_NUMBER = "MISSING_ACCOUNT_NUMBER",
  MISSING_BANK_NAME = "MISSING_BANK_NAME",
  MISSING_COMPANY_NAME = "MISSING_COMPANY_NAME",
  MISSING_DOCUMENT = "MISSING_DOCUMENT",
  MISSING_INTEREST_EXPENSE = "MISSING_INTEREST_EXPENSE",
  MISSING_PAGES = "MISSING_PAGES",
  NON_FDIC_INSURED_INSTITUTION = "NON_FDIC_INSURED_INSTITUTION",
  NON_OPERATIONAL_ACCOUNT = "NON_OPERATIONAL_ACCOUNT",
  OTHER = "OTHER",
  PERSONAL_BANK_ACCOUNT = "PERSONAL_BANK_ACCOUNT",
  REDACTED_STATEMENT = "REDACTED_STATEMENT",
  TOO_FEW_LINE_ITEMS = "TOO_FEW_LINE_ITEMS",
  TOO_MANY_COLUMNS = "TOO_MANY_COLUMNS",
}

export interface FinancialStatementRequest {
  documents?: Maybe<Array<Maybe<FinancialDocument>>>;
  dueDate: Scalars["Time"];
  id: Scalars["ID"];
  lastSubmittedAt?: Maybe<Scalars["Time"]>;
  requiredItems: Array<RequiredItem>;
  status: FinancialStatementRequestStatus;
  submissionFrequency: SubmissionFrequency;
  supportingDetails?: Maybe<Scalars["String"]>;
  type?: Maybe<FinancialStatementRequestType>;
}

export enum FinancialStatementRequestStatus {
  CANCELLED = "CANCELLED",
  COMPLETED = "COMPLETED",
  PENDING = "PENDING",
  RESUBMISSION_REQUIRED = "RESUBMISSION_REQUIRED",
  SUBMITTED = "SUBMITTED",
}

export enum FinancialStatementRequestType {
  BANK_STATEMENT = "BANK_STATEMENT",
  FINANCIAL_STATEMENT = "FINANCIAL_STATEMENT",
}

/** An account which we require statement update from the customer */
export interface FinancialStatementRequestedAccount extends Node {
  /** The last digits of the bank account number for display */
  accountNumberLastFour?: Maybe<Scalars["String"]>;
  bankAccountNumber?: Maybe<Scalars["String"]>;
  /** Bank/Financial institution & account number associated with the statement account */
  bankName?: Maybe<Scalars["String"]>;
  /** Due date for a statement update, typically end of month */
  dueDate: Scalars["Time"];
  financialAccountId: Scalars["String"];
  /** The ID of an object */
  id: Scalars["ID"];
  /** The month of the requested statement */
  requestedMonth: Scalars["Int"];
}

export interface FinancialStatementRequestedAccountConnection {
  edges?: Maybe<Array<Maybe<FinancialStatementRequestedAccountEdge>>>;
  pageInfo: PageInfo;
}

export interface FinancialStatementRequestedAccountEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<FinancialStatementRequestedAccount>;
}

export enum FinancialStatementType {
  BALANCE_SHEET = "BALANCE_SHEET",
  INCOME_STATEMENT = "INCOME_STATEMENT",
  STATEMENT_OF_CASH_FLOWS = "STATEMENT_OF_CASH_FLOWS",
  UNSET = "UNSET",
}

export interface FinancialsAccountV2 extends Node {
  accountNumberLastFour?: Maybe<Scalars["String"]>;
  balancePolarity?: Maybe<BalancePolarity>;
  category?: Maybe<AccountCategory>;
  customerAccountId?: Maybe<Scalars["String"]>;
  customerUserId?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  details?: Maybe<AccountInstitutionDetails>;
  financialSourceId?: Maybe<Scalars["String"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
  nickname?: Maybe<Scalars["String"]>;
  status?: Maybe<AccountStatus>;
  subcategory?: Maybe<AccountSubcategory>;
  vendor?: Maybe<Vendor>;
  verificationStatus?: Maybe<VerificationStatus>;
}

export interface FinancialsAccountV2Connection {
  edges?: Maybe<Array<Maybe<FinancialsAccountV2Edge>>>;
  pageInfo: PageInfo;
}

export interface FinancialsAccountV2Edge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<FinancialsAccountV2>;
}

export enum FinancialsConnectRequestType {
  FINICITY_CONNECT = "FINICITY_CONNECT",
}

export type FinancialsSourceResult = FinancialSource;

export enum FinancialsVendor {
  DEMO = "DEMO",
  DEPOSITS = "DEPOSITS",
  FINICITY = "FINICITY",
  MANUAL = "MANUAL",
  OCROLUS = "OCROLUS",
  PLAID = "PLAID",
  TELLER = "TELLER",
}

/**
 * An input union for filtering find_contact
 * Only one field is meant to be set since GraphQL doesn't support input unions
 */
export interface FindContactIdentifierInputUnion {
  name?: InputMaybe<Scalars["String"]>;
  paymentInstrumentId?: InputMaybe<Scalars["ID"]>;
  recipientCustomerUserId?: InputMaybe<Scalars["ID"]>;
}

export interface FindOrCreateErpFeedInput {
  clientMutationId: Scalars["String"];
  financialAccountId: Scalars["ID"];
  syncFrom: Scalars["Time"];
  type: ErpVendorType;
  vendorOptions?: InputMaybe<Scalars["Json"]>;
}

export interface FindOrCreateErpFeedPayload {
  clientMutationId: Scalars["String"];
  erpFeed?: Maybe<ErpFeed>;
  errorMessage?: Maybe<Scalars["String"]>;
}

export interface FinicityConnectGenerateFixUrlInput {
  clientMutationId: Scalars["String"];
  financialSourceId: Scalars["ID"];
}

export interface FinicityConnectGenerateFixUrlPayload {
  clientMutationId: Scalars["String"];
  url: Scalars["String"];
}

export interface FinicityConnectGenerateLiteUrlInput {
  clientMutationId: Scalars["String"];
  institutionId: Scalars["ID"];
}

export interface FinicityConnectGenerateLiteUrlPayload {
  clientMutationId: Scalars["String"];
  url: Scalars["String"];
}

export interface FinicityConnectMigrateAccountsInput {
  clientMutationId: Scalars["String"];
  financialSourceId: Scalars["ID"];
}

export interface FinicityConnectMigrateAccountsPayload {
  clientMutationId: Scalars["String"];
  updatedSource?: Maybe<FinancialSource>;
}

export interface FinicityMetadata {
  isOauth?: Maybe<Scalars["Boolean"]>;
}

export interface FinicityPayload {
  needsMigration: Scalars["Boolean"];
}

export interface FinishChannelVerificationInput {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
  verificationToken: Scalars["String"];
}

export interface FinishChannelVerificationPayload {
  channel?: Maybe<Channel>;
  clientMutationId: Scalars["String"];
}

export interface FlexibleAddressInput {
  address1: Scalars["String"];
  address2?: InputMaybe<Scalars["String"]>;
  city: Scalars["String"];
  country: Scalars["String"];
  state?: InputMaybe<Scalars["String"]>;
  zip?: InputMaybe<Scalars["String"]>;
}

export enum FlightClass {
  BUSINESS = "BUSINESS",
  ECONOMY = "ECONOMY",
  ECONOMY_PLUS = "ECONOMY_PLUS",
  FIRST = "FIRST",
}

export interface FlightNumber {
  /** IATA airline code (e.g. DL for Delta). */
  airlineCode?: Maybe<Scalars["String"]>;
  /** Marketing name of airline (e.g. Delta Air Lines). */
  airlineName?: Maybe<Scalars["String"]>;
  /** Flight number (e.g. 3586). */
  number?: Maybe<Scalars["String"]>;
}

export enum FlightRestrictions {
  POST_BOOKING_SEAT_NOT_ALLOWED = "POST_BOOKING_SEAT_NOT_ALLOWED",
  PRE_BOOKING_SEAT_NOT_ALLOWED = "PRE_BOOKING_SEAT_NOT_ALLOWED",
  SEAT_BOOKING_NOT_ALLOWED = "SEAT_BOOKING_NOT_ALLOWED",
  SEAT_BOOKING_NOT_ALLOWED_DUE_TO_CODESHARE = "SEAT_BOOKING_NOT_ALLOWED_DUE_TO_CODESHARE",
  SEAT_BOOKING_NOT_ALLOWED_OPEN_SEATING = "SEAT_BOOKING_NOT_ALLOWED_OPEN_SEATING",
  SEAT_NOT_ALLOWED_DUE_TO_BRAND = "SEAT_NOT_ALLOWED_DUE_TO_BRAND",
  SEAT_NOT_GUARANTEED_WARNING = "SEAT_NOT_GUARANTEED_WARNING",
}

export interface ForceApproveApplicationInput {
  /** The application Id */
  applicationId: Scalars["String"];
  /** The client mutation id */
  clientMutationId: Scalars["String"];
}

/** ForgetDevice */
export interface ForgetDeviceInput {
  deviceFingerprint?: InputMaybe<Scalars["String"]>;
}

export interface ForgetDeviceResult {
  status?: Maybe<ForgetDeviceResultStatus>;
}

export enum ForgetDeviceResultStatus {
  ERROR = "ERROR",
  SUCCESS = "SUCCESS",
}

export interface FormationDocumentInput {
  assetId: Scalars["String"];
  documentType?: InputMaybe<FormationDocumentType>;
}

export enum FormationDocumentType {
  ARTICLES_OF_INCORPORATION = "ARTICLES_OF_INCORPORATION",
  COMPANY_TAX_RETURN = "COMPANY_TAX_RETURN",
  GOVERNMENT_ISSUED_BUSINESS_LICENSE = "GOVERNMENT_ISSUED_BUSINESS_LICENSE",
  PARTNERSHIP_AGREEMENT = "PARTNERSHIP_AGREEMENT",
  TRUST_INSTRUMENT_OR_OTHER_FORMAL_DOCUMENTS_FROM_THE_IRS = "TRUST_INSTRUMENT_OR_OTHER_FORMAL_DOCUMENTS_FROM_THE_IRS",
}

export type FraudAlert = CardTransactionFraudAlert;

export interface FraudAlertConnection {
  edges?: Maybe<Array<Maybe<FraudAlertEdge>>>;
  pageInfo: PageInfo;
}

export interface FraudAlertEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<FraudAlert>;
}

export interface FrbMigrationBannerResponse {
  frbFinancialSourceIds: Array<Scalars["ID"]>;
  shouldShowBanner: Scalars["Boolean"];
}

/** FSP account object */
export interface FspAccount {
  /** customer account id */
  customerAccountId: Scalars["String"];
  /** a short description of the company */
  description?: Maybe<Scalars["String"]>;
  /** a link to view more details of the company */
  detailsLink?: Maybe<Scalars["String"]>;
  /** the group urn created by Medusa */
  groupUrn?: Maybe<Scalars["String"]>;
  /** a link to the company logo */
  logoLink?: Maybe<Scalars["String"]>;
  /** company name */
  name: Scalars["String"];
}

export interface FspClientAccount {
  contact?: Maybe<Scalars["String"]>;
  customerAccountId: Scalars["String"];
  name?: Maybe<Scalars["String"]>;
}

export interface FspClientAccountConnectedUsersConnection extends Connection {
  edges: Array<FspClientAccountConnectedUsersEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface FspClientAccountConnectedUsersEdge {
  cursor: Scalars["String"];
  node: User;
  roles: Array<FSPUserRole>;
}

export interface FspClientAccountConnectedUsersInput {
  /** If `roles` is empty, consider all roles */
  roles?: InputMaybe<Array<FSPUserRole>>;
  userIds: Array<Scalars["ID"]>;
}

export interface FspClientAccountConnectedUsersWhereInput {
  roles?: InputMaybe<Array<FSPUserRole>>;
}

export interface FspClientAccountConnection extends Connection {
  edges: Array<FSPClientAccountEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export enum FspClientAccountOrderField {
  CONTACT = "CONTACT",
  NAME = "NAME",
  STATUS = "STATUS",
}

export interface FspClientAccountOrderInput {
  direction?: InputMaybe<OrderByDirection>;
  field: FspClientAccountOrderField;
}

export interface FspClientAccountWhereInput {
  /** This list behaves like an AND connector. */
  connectedUsers?: InputMaybe<Array<FspClientAccountConnectedUsersInput>>;
  contactContains?: InputMaybe<Scalars["String"]>;
  nameContains?: InputMaybe<Scalars["String"]>;
  statuses?: InputMaybe<Array<FspConnectionStatus>>;
  /** If any of the text related to this account contains the string. */
  textContains?: InputMaybe<Scalars["String"]>;
}

export enum FspConnectionStatus {
  CONNECTED = "CONNECTED",
  DISCONNECTED = "DISCONNECTED",
  PENDING = "PENDING",
  REJECTED = "REJECTED",
}

export interface FullAccountRule {
  enabled: Scalars["Boolean"];
}

export interface FullName {
  /** First name of the individual */
  firstName?: Maybe<Scalars["String"]>;
  /** Last name of the individual */
  lastName?: Maybe<Scalars["String"]>;
}

export interface FullNameInput {
  /** First name of the individual */
  firstName: Scalars["String"];
  /** Last name of the individual */
  lastName: Scalars["String"];
}

export enum FundingRound {
  PRE_SEED = "PRE_SEED",
  SEED = "SEED",
  SERIES_A = "SERIES_A",
  SERIES_B = "SERIES_B",
  SERIES_C_AND_BEYOND = "SERIES_C_AND_BEYOND",
}

/**
 * This shared temp file is getting hard to move back to the shared common file.
 * So many things use shared common, but, also define things like Deposits Account.
 * But, it's not clear to me that this version of Expenses DGS schema's deposits account should be used for all definitions of Deposits Accounts
 *
 * Right now, this shared schema represents things that bill pay and expenses use.
 */
export interface FundingSource extends Node {
  data?: Maybe<FundingSourceData>;
  disabledOnTimestamp?: Maybe<Scalars["Time"]>;
  /** Load financial account when provenance of funding source. Null for other provenance types. */
  financialAccount?: Maybe<FinancialAccount>;
  /** Contains relevant information determining the health of a funding source (errors, warnings, etc.) */
  health: FundingSourceHealth;
  /** Funding source id, required for EBA payments. */
  id: Scalars["ID"];
  isBrexCash?: Maybe<Scalars["Boolean"]>;
  /** Whether this funding source is disabled by servicing team, meaning we can no longer collect from here */
  isManuallyDisabledByServicing: Scalars["Boolean"];
  priority?: Maybe<FundingSourcePriority>;
  provenance?: Maybe<FundingSourceProvenance>;
  provenanceId?: Maybe<Scalars["String"]>;
  type?: Maybe<Scalars["String"]>;
}

/** A map of funding source IDs to their latest collection promise */
export interface FundingSourceCollectionPromiseMapping {
  /** The latest collection promise for this funding source */
  collectionPromise: CollectionPromise;
  /** The funding source that was used for the penny pull verification attempt */
  fundingSource: FundingSource;
}

export interface FundingSourceConnection {
  edges?: Maybe<Array<Maybe<FundingSourceEdge>>>;
  pageInfo: PageInfo;
}

export interface FundingSourceData {
  accountName?: Maybe<Scalars["String"]>;
  accountNumberLastFour?: Maybe<Scalars["String"]>;
  accountType?: Maybe<Scalars["String"]>;
  routingNumber?: Maybe<Scalars["String"]>;
}

export interface FundingSourceEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<FundingSource>;
}

export enum FundingSourceEntityPriorityProductType {
  BILL_PAY = "BILL_PAY",
  CARD_COLLECTIONS = "CARD_COLLECTIONS",
  INVALID = "INVALID",
  REIMBURSEMENTS = "REIMBURSEMENTS",
  SAAS_BILLING = "SAAS_BILLING",
  TRANSACTION_FEES = "TRANSACTION_FEES",
}

/** object containing information describing the health of a funding source */
export interface FundingSourceHealth {
  /** Whether this account has any 'successful' or 'failed' collections */
  hasSettledCollections: Scalars["Boolean"];
  /** The most recent failure severity */
  mostRecentFailureSeverity?: Maybe<CardPaymentFailureSeverity>;
  /** The most recent failure type */
  mostRecentFailureType?: Maybe<CardPaymentFailureTypeV3>;
  /** The timestamp of the most recently settled collection */
  mostRecentSettledAt?: Maybe<Scalars["Time"]>;
}

export enum FundingSourcePriority {
  ALTERNATIVE = "ALTERNATIVE",
  PRIMARY = "PRIMARY",
}

/** Enum representing the product type associated with an autopay funding source */
export enum FundingSourceProductType {
  SAAS_BILLING = "SAAS_BILLING",
  TRANSACTION_FEE = "TRANSACTION_FEE",
}

export enum FundingSourceProvenance {
  DEPOSITS_ACCOUNT = "DEPOSITS_ACCOUNT",
  EMBEDDED_PARTNER = "EMBEDDED_PARTNER",
  FINANCIAL_ACCOUNT = "FINANCIAL_ACCOUNT",
  MANUAL_INTERNAL = "MANUAL_INTERNAL",
  MANUAL_USER = "MANUAL_USER",
  TEMPORARY_MICRO_DEPOSITS_ACCOUNT = "TEMPORARY_MICRO_DEPOSITS_ACCOUNT",
}

export enum FundingSourceStatusChangeReason {
  ACCOUNT_CLOSED = "ACCOUNT_CLOSED",
  ACCOUNT_NOT_FOUND = "ACCOUNT_NOT_FOUND",
  BACKFILL = "BACKFILL",
  CREATED = "CREATED",
  DEPOSITS_ACCOUNT_NOT_ACTIVE = "DEPOSITS_ACCOUNT_NOT_ACTIVE",
  FINANCIAL_SOURCE_DELETED = "FINANCIAL_SOURCE_DELETED",
  INVALID_ACCOUNT_NUMBER = "INVALID_ACCOUNT_NUMBER",
  MANUAL = "MANUAL",
  MARKED_AS_PRIMARY = "MARKED_AS_PRIMARY",
  NON_TRANSACTION_ACCOUNT = "NON_TRANSACTION_ACCOUNT",
  VERIFICATION_COLLECTION_SUCCEEDED = "VERIFICATION_COLLECTION_SUCCEEDED",
}

export enum FundingSourceV2 {
  ANGEL_INVESTMENT = "ANGEL_INVESTMENT",
  BUSINESS_REVENUE = "BUSINESS_REVENUE",
  CROWDSOURCED = "CROWDSOURCED",
  FAMILY = "FAMILY",
  GRANTS = "GRANTS",
  INITIAL_COIN_OFFERING = "INITIAL_COIN_OFFERING",
  INVALID = "INVALID",
  LOAN_FUNDING = "LOAN_FUNDING",
  PARENT_COMPANY = "PARENT_COMPANY",
  PRIVATE_EQUITY = "PRIVATE_EQUITY",
  /**  Legacy values */
  PROFESSIONAL_INVESTOR = "PROFESSIONAL_INVESTOR",
  SELF_FUNDED = "SELF_FUNDED",
  VENTURE_ACCELERATOR_GROWTH = "VENTURE_ACCELERATOR_GROWTH",
}

export enum FundingSourceV3 {
  ANGEL_INVESTMENT = "ANGEL_INVESTMENT",
  BUSINESS_REVENUE = "BUSINESS_REVENUE",
  LOAN_FUNDING = "LOAN_FUNDING",
  PARENT_COMPANY = "PARENT_COMPANY",
  PRIVATE_EQUITY = "PRIVATE_EQUITY",
  SELF_FUNDED = "SELF_FUNDED",
  VENTURE_ACCELERATOR_GROWTH = "VENTURE_ACCELERATOR_GROWTH",
}

export interface FundsAllocation {
  depositsAccountId: Scalars["ID"];
  intendedAmountUsdCents: Scalars["Long"];
}

export interface FundsAllocationRecommendation {
  checkingAccountAllocations: Array<AllocationRecommendation>;
  treasuryAllocation: AllocationRecommendation;
  vaultAllocation: AllocationRecommendation;
}

export interface FuzzySearchConnection extends Connection {
  edges: Array<FuzzySearchEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

/** Fuzzy search edge for fuzzy search connection. */
export interface FuzzySearchEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<FuzzySearchNode>;
}

export interface FuzzySearchFilterInput {
  operator: QueryListOperator;
  /** The primitive types we want to filter by in fuzzy search. */
  types: Array<FuzzySearchType>;
}

export type FuzzySearchNode = CustomFieldValue | Primitive;

export enum FuzzySearchType {
  COST_CENTER = "COST_CENTER",
  CUSTOM_FIELD = "CUSTOM_FIELD",
  DEPARTMENT = "DEPARTMENT",
  LEGAL_ENTITY = "LEGAL_ENTITY",
  LOCATION = "LOCATION",
  MANAGER = "MANAGER",
  TITLE = "TITLE",
  USER = "USER",
}

export enum GLAccountSetting {
  ACCOUNTS_PAYABLE = "ACCOUNTS_PAYABLE",
  ACCRUALS_LIABILITY = "ACCRUALS_LIABILITY",
  ACCRUALS_LIABILITY_REIMBURSEMENT = "ACCRUALS_LIABILITY_REIMBURSEMENT",
  AWX_WALLET = "AWX_WALLET",
  BREX_REIMBURSEMENT_CLEARING = "BREX_REIMBURSEMENT_CLEARING",
  CARD_EXPENSE_CLEARING = "CARD_EXPENSE_CLEARING",
  CARD_INTERCOMPANY_CUSTOMER = "CARD_INTERCOMPANY_CUSTOMER",
  CARD_INTERCOMPANY_PAYABLE = "CARD_INTERCOMPANY_PAYABLE",
  CARD_INTERCOMPANY_RECEIVABLE = "CARD_INTERCOMPANY_RECEIVABLE",
  CARD_INTERCOMPANY_VENDOR = "CARD_INTERCOMPANY_VENDOR",
  COLLECTION_TARGET = "COLLECTION_TARGET",
  EXTENSION_SETTINGS = "EXTENSION_SETTINGS",
  MANUAL_PAYMENTS = "MANUAL_PAYMENTS",
  PERSONAL_EXPENSE = "PERSONAL_EXPENSE",
  PHYSICAL_ITEM_INCOME = "PHYSICAL_ITEM_INCOME",
  REIMBURSEMENTS = "REIMBURSEMENTS",
  REIMBURSEMENTS_INTERCOMPANY_CUSTOMER = "REIMBURSEMENTS_INTERCOMPANY_CUSTOMER",
  REIMBURSEMENTS_INTERCOMPANY_PAYABLE = "REIMBURSEMENTS_INTERCOMPANY_PAYABLE",
  REIMBURSEMENTS_INTERCOMPANY_RECEIVABLE = "REIMBURSEMENTS_INTERCOMPANY_RECEIVABLE",
  REIMBURSEMENTS_INTERCOMPANY_VENDOR = "REIMBURSEMENTS_INTERCOMPANY_VENDOR",
  REIMBURSEMENT_CLEARING = "REIMBURSEMENT_CLEARING",
  REWARDS_INCOME = "REWARDS_INCOME",
  SAGE_INTACCT_SUBSIDIARY_CREDIT_CARD_ID = "SAGE_INTACCT_SUBSIDIARY_CREDIT_CARD_ID",
  SERVICE_ITEM_INCOME = "SERVICE_ITEM_INCOME",
}

export interface GaugeData {
  liveFillPercent?: Maybe<Scalars["Float"]>;
  nextTier?: Maybe<AdditionalReturnTier>;
  order?: Maybe<Scalars["Int"]>;
  postedFillPercent?: Maybe<Scalars["Float"]>;
  tier?: Maybe<AdditionalReturnTier>;
}

/** Fields applicable to any type of receipt */
export interface GeneralReceiptFields {
  /** Purchase amount, parsed from receipt */
  amount?: Maybe<FinancialAsset>;
  /** Receipt line items, parsed from receipt */
  discounts?: Maybe<Array<ReceiptDiscountItem>>;
  /** True if this file appears to actually be a receipt; false otherwise */
  isReceipt: Scalars["Boolean"];
  /** Receipt line items, parsed from receipt */
  lineItems?: Maybe<Array<ReceiptLineItem>>;
  /** Name of merchant, parsed from receipt */
  merchantName?: Maybe<Scalars["String"]>;
  /** Date of purchase, parsed from receipt */
  purchasedAt?: Maybe<Scalars["Date"]>;
  /** Receipt line items, parsed from receipt */
  taxes?: Maybe<Array<ReceiptTaxItem>>;
}

export interface GeneralTicketInformationAddendum extends ExpenseAddendum {
  /** The unique ID of the expense addendum. */
  id: Scalars["ID"];
  /** The issuing carrier for the ticket. */
  issuingCarrier?: Maybe<Scalars["String"]>;
  /** Passenger name on the ticket. */
  passengerName?: Maybe<Scalars["String"]>;
  /** Number of the ticket */
  ticketNumber?: Maybe<Scalars["String"]>;
}

export interface GenerateAirwallexKycLinkInput {
  /** Where the user should be redirected to if an error occurs during the KYC process */
  errorUrl?: InputMaybe<Scalars["String"]>;
  /** The legal entity ID that the KYC link is being generated for */
  legalEntityId: Scalars["ID"];
  /** Where the user should be redirected to after the KYC process is completed */
  returnUrl?: InputMaybe<Scalars["String"]>;
}

export interface GenerateAirwallexKycLinkResponse {
  /** The KYC link */
  kycLink: Scalars["String"];
}

export interface GenerateBankingProviderKycHostedFlowLinkInput {
  /** The analysis ID. */
  analysisId: Scalars["ID"];
}

export interface GenerateBankingProviderKycHostedFlowLinkResult {
  /** The KYC hosted flow link. */
  hostedFlowLink: Scalars["String"];
}

export interface GenerateBillPaymentReceiptDownloadUrlInput {
  billId: Scalars["ID"];
  clientMutationId: Scalars["String"];
}

export interface GenerateBillPaymentReceiptDownloadUrlPayload {
  clientMutationId: Scalars["String"];
  downloadUrl: Scalars["String"];
}

export interface GenerateBillPaymentReceiptDownloadUrlV2Input {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
}

export interface GenerateBulkStatementsZipDownloadUrlInput {
  depositsAccountId: Scalars["String"];
  periodEndTime: Scalars["LocalDateTime"];
  periodStartTime: Scalars["LocalDateTime"];
}

export interface GenerateBulkStatementsZipDownloadUrlResult {
  zipUrl?: Maybe<Scalars["String"]>;
}

export interface GenerateCounterpartyCategoryInfoExportInput {
  clientMutationId: Scalars["String"];
  /** a list of deposits account ids for which to produce an extract file of counterparty category information */
  depositsProcessorAccountIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
}

export interface GenerateCounterpartyCategoryInfoExportPayload {
  clientMutationId: Scalars["String"];
  /** the download url for the generated extract */
  downloadUrl: Scalars["String"];
}

export interface GenerateCustomStatementDownloadUrlInput {
  /** The journal account id to be queried */
  journalAccountId?: InputMaybe<Scalars["ID"]>;
  /** Statement end date time */
  periodEndTime?: InputMaybe<Scalars["Time"]>;
  /** Statement start date time */
  periodStartTime?: InputMaybe<Scalars["Time"]>;
}

export interface GenerateCustomStatementFromPaymentDownloadUrlInput {
  /** The journal account id to be queried */
  journalAccountId?: InputMaybe<Scalars["ID"]>;
  /** Payment ID to use as a starting period */
  paymentId?: InputMaybe<Scalars["ID"]>;
}

export interface GenerateDepositsStatementDocumentDownloadUrlInput {
  clientMutationId: Scalars["String"];
  depositsStatementId: Scalars["ID"];
}

export interface GenerateDepositsStatementDocumentDownloadUrlPayload {
  clientMutationId: Scalars["String"];
  depositsStatementPdfDownloadUrl?: Maybe<Scalars["String"]>;
  fileName?: Maybe<Scalars["String"]>;
}

export interface GenerateDepositsTransactionConfirmationDownloadUrlInput {
  clientMutationId: Scalars["String"];
  /** transaction id */
  depositsTransactionId: Scalars["ID"];
  /** Json formatted string with transaction detail  */
  transactionDetailString: Scalars["String"];
}

export interface GenerateDepositsTransactionConfirmationDownloadUrlPayload {
  clientMutationId: Scalars["String"];
  /** url to download confirmation */
  depositsTransactionConfirmationDownloadUrl?: Maybe<Scalars["String"]>;
}

export interface GenerateDepositsVerificationLetterDownloadUrlInput {
  clientMutationId: Scalars["String"];
  depositsAccountId?: InputMaybe<Scalars["ID"]>;
}

export interface GenerateDepositsVerificationLetterDownloadUrlPayload {
  clientMutationId: Scalars["String"];
  depositsVerificationLetterDownloadUrl: Scalars["String"];
}

export interface GenerateDownloadUrlForInvoiceV1Input {
  /** Base invoice id. */
  invoiceId: Scalars["ID"];
}

export interface GenerateDownloadUrlForInvoiceV1Result extends MutationResult {
  asset?: Maybe<Asset>;
  assetId?: Maybe<Scalars["String"]>;
  assetName?: Maybe<Scalars["String"]>;
  downloadUrl?: Maybe<Scalars["String"]>;
  errors?: Maybe<Array<InvoicingV1ClientError>>;
  presignedDownloadUrl?: Maybe<Scalars["String"]>;
}

export interface GenerateDrawdownAuthorizationPdfUrlInput {
  clientMutationId: Scalars["String"];
  drawdownAuthorizationId: Scalars["ID"];
}

export interface GenerateDrawdownAuthorizationPdfUrlPayload {
  clientMutationId: Scalars["String"];
  drawdownAuthorizationUrl: Scalars["String"];
}

export interface GenerateExpensePolicyRequest {
  /**
   * The list of approval chains that should be used. The conditions are evaluated in the order they are given and the
   * first one that matches the expense will be used if a review is requested.
   */
  approvalChains: Array<PolicyApprovalChainInput>;
  /** If this expense was created by an user or set from one of our presets */
  creationType?: ExpensePolicyCreationType;
  /** Currency of the policy */
  currency?: InputMaybe<Scalars["String"]>;
  /**
   * `definition`presents the same info as `ruleGroup` and `rules`, but in a much easier-to-understand format.
   * If this field is provided, then it overwrites `ruleGroup` and `rules`.
   */
  definition?: InputMaybe<ExpensePolicyInput>;
  /** A description that will describe this policy to users. */
  description?: InputMaybe<Scalars["String"]>;
  /** A name that will allow users to identify this policy. */
  displayName: Scalars["String"];
  /** Which types the policy is eligible for */
  eligibleWorkflows?: InputMaybe<Array<PolicyWorkflowType>>;
  /** Whether the policy is eligible for travel */
  isTravelEligible?: InputMaybe<Scalars["Boolean"]>;
  /** The rules in the policy. Soon to be deprecated in favor of `definition`. */
  rules?: InputMaybe<Array<PolicyRuleSetInput>>;
  /** Whether the generated policy should become the default. If not set, is assumed to be false. */
  setAsDefault?: InputMaybe<Scalars["Boolean"]>;
}

/**  ---[ Input Types ]--------------------- */
export interface GenerateIntegrationFtuxSuggestionsInput {
  integrationId: Scalars["String"];
}

/**  ---[ Resource Types ]------------------ */
export interface GenerateIntegrationFtuxSuggestionsResult {
  integrationId: Scalars["String"];
}

export interface GenerateMultiAccountBulkStatementsZipDownloadUrlInput {
  depositsAccountIds?: InputMaybe<Array<Scalars["String"]>>;
  periodEndTime: Scalars["LocalDateTime"];
  periodStartTime: Scalars["LocalDateTime"];
}

export interface GeneratePersonalPlaidLinkTokenInput {
  additionalConsentedProducts?: InputMaybe<Array<InputMaybe<PlaidProduct>>>;
  androidPackageName?: InputMaybe<Scalars["String"]>;
  authTypeSelectEnabled?: InputMaybe<Scalars["Boolean"]>;
  clientMutationId: Scalars["String"];
  linkCustomizationName?: InputMaybe<Scalars["String"]>;
  migrateFinancialSourceId?: InputMaybe<Scalars["ID"]>;
  products?: InputMaybe<Array<InputMaybe<PlaidProduct>>>;
  redirectUri?: InputMaybe<Scalars["String"]>;
}

export interface GeneratePersonalPlaidLinkTokenPayload {
  clientMutationId: Scalars["String"];
  linkToken: Scalars["String"];
}

export interface GeneratePlaidLinkTokenInput {
  androidPackageName?: InputMaybe<Scalars["String"]>;
  authTypeSelectEnabled?: InputMaybe<Scalars["Boolean"]>;
  clientMutationId: Scalars["String"];
  linkCustomizationName?: InputMaybe<Scalars["String"]>;
  migrateFinancialSourceId?: InputMaybe<Scalars["ID"]>;
  products?: InputMaybe<Array<InputMaybe<PlaidProduct>>>;
  redirectUri?: InputMaybe<Scalars["String"]>;
}

export interface GeneratePlaidLinkTokenPayload {
  clientMutationId: Scalars["String"];
  linkToken: Scalars["String"];
}

/** Result of generating a Spotnana OAuth token (backend token exchange). */
export interface GenerateSpotnanaOauthTokenResult {
  accessToken: Scalars["String"];
  expiresIn?: Maybe<Scalars["Int"]>;
  refreshToken?: Maybe<Scalars["String"]>;
  scope?: Maybe<Scalars["String"]>;
  tokenType: Scalars["String"];
}

export interface GenerateStatementDownloadUrlInput {
  invoiceId?: InputMaybe<Scalars["ID"]>;
  statementId?: InputMaybe<Scalars["ID"]>;
}

export interface GenerateStatementDownloadUrlResponse {
  downloadUrl: Scalars["String"];
}

export interface GenerateTransactionConfirmationDownloadUrlInput {
  clientMutationId: Scalars["String"];
  /** Json formatted string with transaction detail */
  transactionDetailString: Scalars["String"];
  /** transaction id */
  transactionId: Scalars["ID"];
}

export interface GenerateTransactionConfirmationDownloadUrlPayload {
  clientMutationId: Scalars["String"];
  /** url to download confirmation */
  transactionConfirmationDownloadUrl?: Maybe<Scalars["String"]>;
}

export interface GenerateTransactionsReportAsyncResponse {
  /** Request ID for the asynchronous transactions report generation */
  requestId: Scalars["String"];
}

/**
 * GenerateTransactionsReportFilterInput is originally defined as BillingTransactionFilterInput in //global_financial_services/billing_lifecycle/src/main/resources/schema.graphqls
 * The Core Platform team advises teams to prefer duplication over shared types. https://brexhq.atlassian.net/wiki/spaces/ENGDOC/pages/1653538928/Shared+GraphQL+Types#Adding%2FChanging-Shared-types
 *
 * ATTENTION: PLEASE MAKE SURE GenerateTransactionsReportFilterInput MATCHES BillingTransactionFilterInput.
 * ANY CHANGES TO THIS TYPE SHOULD BE REFLECTED IN BillingTransactionFilterInput AND VICE VERSA.
 */
export interface GenerateTransactionsReportFilterInput {
  /** Filter for card transactions from partnership-based cards */
  cardPartnerIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Filter for transactions with a date later than this value. */
  from?: InputMaybe<Scalars["Time"]>;
  /** Filter for transactions from specific journal account */
  journalAccountId: Scalars["ID"];
  /** Filter for transactions from a list of entities */
  legalEntities?: InputMaybe<Array<Scalars["ID"]>>;
  /** Filter for transactions with an amount less than or equal to this value (in entity's currency) */
  maxAmount?: InputMaybe<Scalars["Decimal"]>;
  /** Filter for transactions from a list of merchants */
  merchants?: InputMaybe<Array<Scalars["ID"]>>;
  /** Filter for transactions with an amount greater than or equal to this value (in entity's currency) */
  minAmount?: InputMaybe<Scalars["Decimal"]>;
  /** Filter for transactions with a date earlier than this value. */
  to?: InputMaybe<Scalars["Time"]>;
  /** Filter for transactions with specific BillingTransactionStatus(es) */
  transactionStatuses?: InputMaybe<Array<BillingTransactionStatus>>;
  /** Filter for transactions with specific BillingTransactionType(s) */
  transactionTypes?: InputMaybe<Array<BillingTransactionType>>;
  /** Filter for transactions from a list of employees */
  users?: InputMaybe<Array<Scalars["ID"]>>;
}

export interface GenerateTransactionsReportInput {
  /** Filters to be applied to the report's data. */
  filters: GenerateTransactionsReportFilterInput;
  /** Format for the requested report */
  format: ReportFormat;
}

export interface GenerateTransactionsReportResponse {
  downloadUrl?: Maybe<Scalars["String"]>;
}

export interface GeneratedAutoReceiptExpenseActivity extends ExpenseActivity {
  id: Scalars["ID"];
  overrideStatus: ExpenseActivityOverrideStatus;
  receipt?: Maybe<Receipt>;
}

/** Generic payload for entities with no special fields */
export interface Generic {
  isInactive?: Maybe<Scalars["Boolean"]>;
  name?: Maybe<Scalars["String"]>;
}

export interface GenericPayloadInput {
  businessAttestation?: InputMaybe<Scalars["Boolean"]>;
  businessAttestationExplanation?: InputMaybe<Scalars["String"]>;
  businessAttestationVersion?: InputMaybe<Scalars["String"]>;
  explanationForRegulationExclusion?: InputMaybe<Scalars["String"]>;
  formationDocuments?: InputMaybe<Array<FormationDocumentInput>>;
  primaryRegulator?: InputMaybe<Scalars["String"]>;
  registrationNumber?: InputMaybe<Scalars["String"]>;
  regulatedServicesProvided?: InputMaybe<Array<Scalars["String"]>>;
  regulatoryAuthorities?: InputMaybe<Array<RegulatoryAuthorityInput>>;
}

export interface GeoIpLocation {
  countryName?: Maybe<Scalars["String"]>;
}

export interface GetAccountStalenessInput {
  customerAccountId: Scalars["ID"];
}

export interface GetAccountStalenessResult {
  cadence: SubmissionFrequency;
  daysOverdue: Scalars["Int"];
}

export interface GetActiveSessionsEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<ActiveSession>;
}

export interface GetAutoInviteSettingInput {
  id: Scalars["ID"];
}

export interface GetExportAttemptStateInput {
  clientMutationId: Scalars["String"];
  /** export_attempt_id is returned by start_integration_export response */
  exportAttemptId?: InputMaybe<Scalars["String"]>;
}

export interface GetExportAttemptStatePayload {
  clientMutationId: Scalars["String"];
  /** Report download URL (for CSV exports) */
  downloadUrl?: Maybe<Scalars["String"]>;
  /** Status of export attempt */
  status?: Maybe<Scalars["String"]>;
}

export interface GetOrCreateLegalEntitySubsidiaryInput {
  clientMutationId: Scalars["String"];
  /** integration field id */
  integrationId: Scalars["ID"];
  /** Encoded legal entity id for the subsidiary that is being mapped to. */
  legalEntityId: Scalars["ID"];
  /** Name of subsidiary to be created if there is no mapped subsidiary for the inputted legal entity. */
  subsidiaryName: Scalars["String"];
}

export interface GetOrCreateLegalEntitySubsidiaryPayload {
  clientMutationId: Scalars["String"];
  /** Returns subsidiary */
  subsidiary?: Maybe<ErpSubsidiary>;
}

/** GetRfi input */
export interface GetRfiInput {
  /** Type of provided value */
  type: GetRfiInputType;
  /** Value of this input */
  value: Scalars["String"];
}

export enum GetRfiInputType {
  /** Get the RFI with its Salesforce Case ID */
  ARFI_CASE_ID = "ARFI_CASE_ID",
  /** Get the RFI with its Salesforce Case Number */
  ARFI_CASE_NUMBER = "ARFI_CASE_NUMBER",
  /** Get the RFI with its ID */
  ID = "ID",
}

export interface GiftCardPayloadV2 {
  /** How many cents a point is worth in donation redemption */
  usdCentsPerPoint: Scalars["Float"];
}

export enum GlobalDraftReimbursementsStatus {
  GLOBAL_DRAFT_REIMBURSEMENTS_EXCLUDED = "GLOBAL_DRAFT_REIMBURSEMENTS_EXCLUDED",
  GLOBAL_DRAFT_REIMBURSEMENTS_INCLUDED = "GLOBAL_DRAFT_REIMBURSEMENTS_INCLUDED",
}

export interface GlobalLimitHitWarningMetadata {
  percentageThreshold: Scalars["Int"];
}

export interface GlobalRecentSearchItem extends RecentSearchItem {
  lastTimeSearched: Scalars["Time"];
  searchItem: SearchItem;
}

export enum GlobalSearchIntentGroup {
  /** The intent should be handled as a Banking Scope search. */
  BANKING_SCOPE_SEARCH = "BANKING_SCOPE_SEARCH",
  /** The intent should be handled as a Budget. */
  BUDGET_PRIMITIVE = "BUDGET_PRIMITIVE",
  /** The intent should be handled as a Card. */
  CARD_PRIMITIVE = "CARD_PRIMITIVE",
  /** The intent should be handled as a Command. */
  COMMAND = "COMMAND",
  /** The intent should be handled as an Expense Scope search. */
  EXPENSE_SCOPE_SEARCH = "EXPENSE_SCOPE_SEARCH",
  /** The intent should be handled as a Help Center article. */
  HELP_CENTER = "HELP_CENTER",
  /** The intent should be handled as a Limit Group. */
  LIMIT_GROUP_PRIMITIVE = "LIMIT_GROUP_PRIMITIVE",
  /** The intent should be handled as a Navigation intent */
  NAVIGATION = "NAVIGATION",
  /** The intent should be handled as a Smart Card. */
  SMART_CARD = "SMART_CARD",
  /** The intent should be handled as a User. */
  USER_PRIMITIVE = "USER_PRIMITIVE",
  /** The intent should be handled as a Vendor. */
  VENDOR_PRIMITIVE = "VENDOR_PRIMITIVE",
}

export enum GlobalTransferPaymentMethod {
  AED_AE_LOCAL = "AED_AE_LOCAL",
  ARS_AR_LOCAL = "ARS_AR_LOCAL",
  AUD_AU_LOCAL = "AUD_AU_LOCAL",
  BDT_BD_LOCAL = "BDT_BD_LOCAL",
  BGN_BG_LOCAL = "BGN_BG_LOCAL",
  BRL_BR_LOCAL = "BRL_BR_LOCAL",
  BWP_BW_LOCAL = "BWP_BW_LOCAL",
  CAD_CA_LOCAL = "CAD_CA_LOCAL",
  CHF_CH_LOCAL = "CHF_CH_LOCAL",
  CHF_LI_LOCAL = "CHF_LI_LOCAL",
  CLP_CL_LOCAL = "CLP_CL_LOCAL",
  CNY_CN_LOCAL = "CNY_CN_LOCAL",
  COP_CO_LOCAL = "COP_CO_LOCAL",
  CRC_CR_LOCAL = "CRC_CR_LOCAL",
  CZK_CZ_LOCAL = "CZK_CZ_LOCAL",
  DKK_DK_LOCAL = "DKK_DK_LOCAL",
  EGP_EG_LOCAL = "EGP_EG_LOCAL",
  EUR_AD_SEPA = "EUR_AD_SEPA",
  EUR_AT_SEPA = "EUR_AT_SEPA",
  EUR_BE_SEPA = "EUR_BE_SEPA",
  EUR_CH_SEPA = "EUR_CH_SEPA",
  EUR_CY_SEPA = "EUR_CY_SEPA",
  EUR_DE_SEPA = "EUR_DE_SEPA",
  EUR_EE_SEPA = "EUR_EE_SEPA",
  EUR_ES_SEPA = "EUR_ES_SEPA",
  EUR_FI_SEPA = "EUR_FI_SEPA",
  EUR_FR_SEPA = "EUR_FR_SEPA",
  EUR_GR_SEPA = "EUR_GR_SEPA",
  EUR_HR_SEPA = "EUR_HR_SEPA",
  EUR_IE_SEPA = "EUR_IE_SEPA",
  EUR_IT_SEPA = "EUR_IT_SEPA",
  EUR_LT_SEPA = "EUR_LT_SEPA",
  EUR_LU_SEPA = "EUR_LU_SEPA",
  EUR_LV_SEPA = "EUR_LV_SEPA",
  EUR_MC_SEPA = "EUR_MC_SEPA",
  EUR_MT_SEPA = "EUR_MT_SEPA",
  EUR_NL_SEPA = "EUR_NL_SEPA",
  EUR_PT_SEPA = "EUR_PT_SEPA",
  EUR_SI_SEPA = "EUR_SI_SEPA",
  EUR_SK_SEPA = "EUR_SK_SEPA",
  FJD_FJ_LOCAL_MOBILE = "FJD_FJ_LOCAL_MOBILE",
  GBP_GB_SORT_CODE = "GBP_GB_SORT_CODE",
  GEL_GE_LOCAL = "GEL_GE_LOCAL",
  GHS_GH_LOCAL = "GHS_GH_LOCAL",
  GTQ_GT_LOCAL = "GTQ_GT_LOCAL",
  HKD_HK_LOCAL = "HKD_HK_LOCAL",
  HRK_HR_LOCAL = "HRK_HR_LOCAL",
  HUF_HU_IBAN = "HUF_HU_IBAN",
  HUF_HU_LOCAL = "HUF_HU_LOCAL",
  IDR_ID_LOCAL = "IDR_ID_LOCAL",
  ILS_IL_LOCAL = "ILS_IL_LOCAL",
  INR_IN_LOCAL = "INR_IN_LOCAL",
  INVALID = "INVALID",
  JPY_JP_LOCAL = "JPY_JP_LOCAL",
  KES_KE_LOCAL = "KES_KE_LOCAL",
  KRW_KR_LOCAL = "KRW_KR_LOCAL",
  LKR_LR_LOCAL = "LKR_LR_LOCAL",
  MAD_MA_LOCAL = "MAD_MA_LOCAL",
  MXN_MX_LOCAL = "MXN_MX_LOCAL",
  MYR_MY_LOCAL = "MYR_MY_LOCAL",
  NOK_NO_LOCAL = "NOK_NO_LOCAL",
  NPR_NP_LOCAL = "NPR_NP_LOCAL",
  NZD_NZ_LOCAL = "NZD_NZ_LOCAL",
  PHP_PH_LOCAL = "PHP_PH_LOCAL",
  PKR_PK_LOCAL = "PKR_PK_LOCAL",
  PLN_PL_LOCAL = "PLN_PL_LOCAL",
  RON_RO_LOCAL = "RON_RO_LOCAL",
  SEK_SE_LOCAL = "SEK_SE_LOCAL",
  SGD_SG_LOCAL = "SGD_SG_LOCAL",
  THB_TH_LOCAL = "THB_TH_LOCAL",
  TRY_TR_LOCAL = "TRY_TR_LOCAL",
  TZS_TZ_LOCAL = "TZS_TZ_LOCAL",
  UAH_UA_LOCAL = "UAH_UA_LOCAL",
  UGX_UG_LOCAL = "UGX_UG_LOCAL",
  USD_US_LOCAL = "USD_US_LOCAL",
  UYU_UY_LOCAL = "UYU_UY_LOCAL",
  VND_VN_LOCAL = "VND_VN_LOCAL",
  ZAR_ZA_LOCAL = "ZAR_ZA_LOCAL",
  ZMW_ZM_LOCAL = "ZMW_ZM_LOCAL",
}

export interface GoogleWorkspaceAuthPayloadInput {
  /**
   * Defines if credential can be refreshed without user interaction.
   *     - online    Needs user interaction
   *     - offline   Can refresh without user interaction
   */
  accessType: Scalars["String"];
  /** Which Brex Google Workspace client to create this credential for */
  clientName: GoogleWorkspaceClientName;
  /** Set to user's email or google id to simplify login flow */
  loginHint?: InputMaybe<Scalars["String"]>;
  /**
   * A space-delimited, case-sensitive list of prompts to present the user. If you don't specify this parameter,
   * the user will be prompted only the first time your project requests access.
   * Possible values are:
   *     - none              Do not display any authentication or consent screens. Must not be specified with other values.
   *     - consent	        Prompt the user for consent.
   *     - select_account	Prompt the user to select an account.
   */
  prompt?: InputMaybe<Scalars["String"]>;
  redirectUri: Scalars["String"];
  /** Space separated list of api permissions */
  scope: Scalars["String"];
}

export enum GoogleWorkspaceClientName {
  TRAVEL_CALENDAR_CLIENT = "TRAVEL_CALENDAR_CLIENT",
}

export interface GoogleWorkspacePayload {
  accessToken?: Maybe<Scalars["String"]>;
  clientName?: Maybe<GoogleWorkspaceClientName>;
  refreshToken?: Maybe<Scalars["String"]>;
}

export interface GrantFSPUsersClientAccessInput {
  clientCustomerAccountId: Scalars["String"];
  fspCustomerAccountId: Scalars["String"];
  fspCustomerUserIds: Array<Scalars["String"]>;
}

export interface GrantFSPUsersClientAccessResult {
  connectedFspCustomerUserIds?: Maybe<Array<Scalars["String"]>>;
}

/** Enum type for graph legend. */
export enum GraphLegendType {
  LARGER_COMPANY = "LARGER_COMPANY",
  OTHER_COMPANY = "OTHER_COMPANY",
  SIMILAR_COMPANY = "SIMILAR_COMPANY",
  YOUR_COMPANY = "YOUR_COMPANY",
}

/** Custom user group */
export interface Group {
  createdAt?: Maybe<Scalars["Time"]>;
  createdBy?: Maybe<User>;
  displayName: Scalars["String"];
  id: Scalars["ID"];
  /**
   * Member condition serialized as JSON. Callers don't know the structure of the member condition ahead of time, so we
   * need to return this field as a String instead of a GraphQL type.
   */
  memberCondition?: Maybe<Scalars["String"]>;
  memberCount?: Maybe<Scalars["Int"]>;
  /** Group Members resolved through this field will be sequentially fetched. Please refrain from using this field if a large list of groups is expected. */
  members?: Maybe<GroupMemberConnection>;
  resources: Array<Resource>;
  status: GroupStatus;
  syncType: GroupSyncType;
  updatedAt?: Maybe<Scalars["Time"]>;
  updatedBy?: Maybe<User>;
}

/** Custom user group */
export interface GroupmembersArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<GroupMemberFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
}

export interface GroupAggregationField {
  count: Scalars["Int"];
  key: Scalars["String"];
  sum: Scalars["Float"];
}

export interface GroupAggregationResult {
  name: Scalars["String"];
  values?: Maybe<Array<Maybe<GroupAggregationField>>>;
}

export enum GroupAssignmentType {
  MANUAL_EXCLUDE = "MANUAL_EXCLUDE",
  MANUAL_INCLUDE = "MANUAL_INCLUDE",
  MEMBER_CONDITION = "MEMBER_CONDITION",
}

export interface GroupAssignmentTypeFilterInput {
  assignmentTypes: Array<GroupAssignmentType>;
  op: ListOperator;
}

export interface GroupAttribute {
  employeeCount: Scalars["Int"];
  /**
   * A group attribute, i.e. a cost center, legal entity, title, etc. The type is defined on the Primitive type that
   * wraps this type.
   */
  id: Scalars["ID"];
  name: Scalars["String"];
}

export enum GroupCadence {
  /** Group transactions by day */
  DAILY = "DAILY",
  /** Group transactions by month */
  MONTHLY = "MONTHLY",
  /** Group transactions by entry */
  SINGLE_ENTRY = "SINGLE_ENTRY",
  /** Group transactions by week */
  WEEKLY = "WEEKLY",
}

/** Input for performing a group comparison, should have either an identifier or a configuration, but not both */
export interface GroupComparisonOperandOneOfInput {
  /** A group identifier */
  groupIdentifier?: InputMaybe<GroupIdentifier>;
  /** A group configuration */
  groupMembershipConfiguration?: InputMaybe<GroupMembershipConfigurationInput>;
}

export interface GroupConnection extends Connection {
  edges: Array<GroupEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface GroupEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<Group>;
}

export interface GroupEvent {
  /** Group event accommodation */
  accommodation?: Maybe<LocationMetadata>;
  /** Link to agenda */
  agendaLink?: Maybe<Scalars["String"]>;
  /** Group event attendees */
  attendees?: Maybe<EventAttendeeConnection>;
  /** Budget [DEPRECATED: use BudgetOrError] */
  budget?: Maybe<Budget>;
  /** Budget if user has permission to see it */
  budgetOrError?: Maybe<BudgetOrError>;
  /** Budget request */
  budgetRequest?: Maybe<BudgetRequestEntity>;
  /** Describes how the car renting is required for attendees (e.g. none, recommended, prebooked, blocked) */
  carRequirement?: Maybe<BookingRequirement>;
  /** Comment thread associated with a group event. */
  commentThread?: Maybe<CommentThread>;
  /** Link to comms channel */
  commsChannelLink?: Maybe<Scalars["String"]>;
  /** Title of comms channel */
  commsChannelTitle?: Maybe<Scalars["String"]>;
  /** Cover Photo for the group event */
  coverPhoto?: Maybe<Asset>;
  /** Description of the group event */
  description?: Maybe<Scalars["String"]>;
  /** Group event destination */
  destination: LocationMetadata;
  /** The end date of the group event, inclusive. */
  endDate?: Maybe<Scalars["Date"]>;
  /** The end date time of the group event, inclusive. */
  endTime?: Maybe<Scalars["LocalDateTime"]>;
  /** The user that created the group event */
  eventCreatorEmployee: Employee;
  /** Describes how flight is required for attendees (e.g. none, recommended, prebooked, blocked) */
  flightRequirement?: Maybe<BookingRequirement>;
  /** Describes how hotel is required for attendees (e.g. none, recommended, prebooked, blocked) */
  hotelRequirement?: Maybe<BookingRequirement>;
  /** Group event ID */
  id: Scalars["ID"];
  /** Group event itinerary */
  itineraryActivities?: Maybe<ItineraryActivityConnection>;
  /** Limit Group if user has permission to see it [DEPRECATED: use limitGroupOrSpendLimit] */
  limitGroup?: Maybe<LimitGroup>;
  /** Limit Group if user has permission to see it */
  limitGroupOrSpendLimit?: Maybe<LimitGroupOrSpendLimit>;
  /** Describes why limit group or spend limit is present or not */
  limitGroupOrSpendLimitAccess: LimitGroupOrSpendLimitAccess;
  /** Name of the group event */
  name: Scalars["String"];
  /** The customer_user_id to contact for information about the event */
  pointOfContact?: Maybe<Scalars["String"]>;
  /** The user to contact for information about the event */
  pointOfContactEmployee?: Maybe<Employee>;
  /** Preferred airport code for the group event */
  preferredAirportCode?: Maybe<Scalars["String"]>;
  /** Describes how rail travel is required for attendees (e.g. none, recommended, prebooked, blocked) */
  railRequirement?: Maybe<BookingRequirement>;
  /** The start date of the group event, inclusive. */
  startDate?: Maybe<Scalars["Date"]>;
  /** The start date of the group event, inclusive. */
  startTime?: Maybe<Scalars["LocalDateTime"]>;
  /** Group event status */
  status: GroupEventStatus;
  /** Timezone of the destination */
  timezone: Scalars["String"];
  /** Group event version */
  version: Scalars["Int"];
}

export interface GroupEventattendeesArgs {
  filter?: InputMaybe<EventAttendeesFilterInput>;
  order?: InputMaybe<EventAttendeesOrderInput>;
  page?: InputMaybe<PaginationInput>;
}

export interface GroupEventitineraryActivitiesArgs {
  page?: InputMaybe<PaginationInput>;
}

export interface GroupEventConnection extends Connection {
  edges: Array<Maybe<GroupEventEdge>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface GroupEventEdge {
  cursor?: Maybe<Scalars["String"]>;
  node: GroupEvent;
}

export enum GroupEventStatus {
  /** @deprecated will be removed */
  APPROVED = "APPROVED",
  CANCELED = "CANCELED",
  COMPLETED = "COMPLETED",
  DELETED = "DELETED",
  /** @deprecated will be removed */
  DRAFT = "DRAFT",
  IN_PROGRESS = "IN_PROGRESS",
  /** @deprecated will be removed */
  PENDING = "PENDING",
  SCHEDULED = "SCHEDULED",
}

export enum GroupEventSubBudgetSetting {
  NONE = "NONE",
  SPECIFIC_AMOUNT = "SPECIFIC_AMOUNT",
  SPLIT_EVENLY = "SPLIT_EVENLY",
}

export interface GroupEventsFilterInput {
  budgetIds?: InputMaybe<Array<Scalars["String"]>>;
  /** Search for group events by name */
  search?: InputMaybe<Scalars["String"]>;
  statuses?: InputMaybe<Array<GroupEventStatus>>;
}

export interface GroupEventsOrderInput {
  direction: OrderByDirection;
  field: SortableGroupEventField;
}

export interface GroupExpensesByBillingConfigurationResult {
  groups: Array<ExpensesByBillingConfigurationGroup>;
}

export interface GroupFilterInput {
  /** Get group by ID or registered resources */
  identifiers?: InputMaybe<Array<GroupIdentifier>>;
  searchText?: InputMaybe<Scalars["String"]>;
  /** Filter groups by status. By default, only returns ACTIVE groups. */
  statuses?: InputMaybe<Array<GroupStatus>>;
  /** Filter groups by sync type. By default, returns all sync types. */
  syncTypes?: InputMaybe<Array<GroupSyncType>>;
  /** Shows all the groups this user is a member of */
  userId?: InputMaybe<Scalars["ID"]>;
}

export enum GroupFilterType {
  COST_CENTER = "COST_CENTER",
  DEPARTMENT = "DEPARTMENT",
  EXTENDED_FIELD_KEY_VALUE = "EXTENDED_FIELD_KEY_VALUE",
  GROUP = "GROUP",
  INVITED_AT = "INVITED_AT",
  LEGAL_ENTITY = "LEGAL_ENTITY",
  LOCATION = "LOCATION",
  TITLE = "TITLE",
  USER = "USER",
}

/** Identify a group using the ID or registered resource. This is a @oneOf input; either ID or resource should be provided. */
export interface GroupIdentifier {
  id?: InputMaybe<Scalars["ID"]>;
  resource?: InputMaybe<ResourceInput>;
}

export interface GroupMember {
  assignmentType: GroupAssignmentType;
  user: User;
}

export interface GroupMemberChange {
  membershipOperation: GroupMembershipOperation;
  user: User;
}

export interface GroupMemberChangeConnection extends Connection {
  edges: Array<GroupMemberChangeEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface GroupMemberChangeEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<GroupMemberChange>;
}

export interface GroupMemberConnection extends Connection {
  edges: Array<GroupMemberEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface GroupMemberEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<GroupMember>;
}

export interface GroupMemberFilterInput {
  assignmentTypeFilter?: InputMaybe<GroupAssignmentTypeFilterInput>;
}

export interface GroupMemberInput {
  assignmentType: GroupAssignmentType;
  userId: Scalars["ID"];
}

export interface GroupMemberMutationError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
  userId?: Maybe<Scalars["ID"]>;
}

export interface GroupMembershipConfigurationInput {
  memberCondition: MemberConditionInput;
  members?: InputMaybe<Array<GroupMemberInput>>;
}

export enum GroupMembershipOperation {
  ADDED = "ADDED",
  REMOVED = "REMOVED",
}

export interface GroupResourceOperation extends ResourceOperation {
  action: ResourceAction;
}

export interface GroupSettings {
  /**
   * Transactions that fall within a same time period are grouped together on exports.
   * These are the time periods to consider when grouping transactions.
   */
  groupCadence: GroupCadence;
}

export interface GroupSettingsInput {
  /**
   * Transactions that fall within a same time period are grouped together on exports.
   * These are the time periods to consider when grouping transactions.
   */
  groupCadence: GroupCadence;
}

export interface GroupSortOrderInput {
  field: GroupSortableFields;
  order: SortOrder;
}

export enum GroupSortableFields {
  DISPLAY_NAME = "DISPLAY_NAME",
}

export enum GroupStatus {
  ACTIVE = "ACTIVE",
  DELETED = "DELETED",
  HIDDEN = "HIDDEN",
}

export enum GroupSyncType {
  AUTO = "AUTO",
  AUTO_ADD = "AUTO_ADD",
  MANUAL = "MANUAL",
}

export interface GroupsMutationError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface GtmRepresentative {
  schedulingLink: Scalars["String"];
}

export interface GuestTraveler {
  /** email of guest traveler */
  email?: Maybe<Scalars["String"]>;
  /** Guest Traveler ID is encoded email */
  id: Scalars["ID"];
  /** name of guest traveler */
  name?: Maybe<TravelerName>;
}

export interface GustoAuthPayloadInput {
  accessToken?: InputMaybe<Scalars["String"]>;
}

export interface GustoPayload {
  accessToken?: Maybe<Scalars["String"]>;
  refreshToken?: Maybe<Scalars["String"]>;
  tokenType?: Maybe<Scalars["String"]>;
}

export interface GustoPayrollInfo {
  accountClaimUrl?: Maybe<Scalars["String"]>;
}

export enum HasRaisedFunds {
  NO = "NO",
  NO_BUT_PLAN_TO = "NO_BUT_PLAN_TO",
  YES = "YES",
}

export enum HealthStatus {
  BLOCKED = "BLOCKED",
  INVALID = "INVALID",
  NORMAL = "NORMAL",
}

export enum HealthStatusDetail {
  ACCOUNT_CLOSED = "ACCOUNT_CLOSED",
  ACCOUNT_PENDING_ACTIVATION = "ACCOUNT_PENDING_ACTIVATION",
  BILLING_CONFIGURATION_MISSING = "BILLING_CONFIGURATION_MISSING",
  FUNDING_SOURCE_NOT_SETUP = "FUNDING_SOURCE_NOT_SETUP",
  FUNDING_SOURCE_NOT_VERIFIED = "FUNDING_SOURCE_NOT_VERIFIED",
  INVALID = "INVALID",
  KYC_NOT_SETUP = "KYC_NOT_SETUP",
  KYC_NOT_VERIFIED = "KYC_NOT_VERIFIED",
  LFR_MIGRATION_NEEDED = "LFR_MIGRATION_NEEDED",
  NONE = "NONE",
  PAYMENT_INSTRUMENT_NOT_SETUP = "PAYMENT_INSTRUMENT_NOT_SETUP",
  PAYMENT_INSTRUMENT_NOT_VERIFIED = "PAYMENT_INSTRUMENT_NOT_VERIFIED",
  QUOTE_EXCEPTION = "QUOTE_EXCEPTION",
  RISK_TIER_TOO_HIGH = "RISK_TIER_TOO_HIGH",
}

export interface HeartbeatInput {
  sessionId: Scalars["String"];
}

export interface HeartbeatPayload {
  ack?: Maybe<Scalars["Boolean"]>;
}

/**
 * A Help Center Article contains useful information to help and guide
 * customers with a given issue. Belongs to a Help Center Category
 */
export interface HelpCenterArticle {
  /** Help Center Category which the article belongs to */
  category: HelpCenterCategoryType;
  /** Name of the Help Center Article */
  name: Scalars["String"];
  /** URL path to the Help Center Article */
  path: Scalars["String"];
}

/**
 * Help Center Category defines a group of Support related issues or subjects.
 * Each contains name, path, main articles and available Support Channels
 */
export interface HelpCenterCategory {
  /** Name of the Help Center Category */
  name: Scalars["String"];
  /** URL path to the Help Center Category */
  path: Scalars["String"];
  /** Information about available Support Channels for this Category */
  supportChannels?: Maybe<SupportChannels>;
  /** Most important Help Center Articles for this Category */
  topArticles?: Maybe<Array<Maybe<HelpCenterArticle>>>;
  /** Enumeration of Help Center Categories */
  type: HelpCenterCategoryType;
}

/** Enumerates all possible Help Center Categories */
export enum HelpCenterCategoryType {
  ACCOUNT_AND_USER_MANAGEMENT = "ACCOUNT_AND_USER_MANAGEMENT",
  APPLICATIONS = "APPLICATIONS",
  BANK_CONNECTIONS = "BANK_CONNECTIONS",
  BREX_API = "BREX_API",
  BREX_CASH = "BREX_CASH",
  CARDHOLDER_PERKS = "CARDHOLDER_PERKS",
  CARD_MANAGEMENT = "CARD_MANAGEMENT",
  CREDIT_LIMITS = "CREDIT_LIMITS",
  CRYPTO_REWARDS = "CRYPTO_REWARDS",
  EXPENSE_MANAGEMENT = "EXPENSE_MANAGEMENT",
  EXPENSIFY = "EXPENSIFY",
  FRAUD_AND_SECURITY = "FRAUD_AND_SECURITY",
  INTEGRATIONS = "INTEGRATIONS",
  INVALID = "INVALID",
  MOBILE_APP = "MOBILE_APP",
  NETSUITE = "NETSUITE",
  QUICKBOOKS_ONLINE = "QUICKBOOKS_ONLINE",
  REFERRAL_PROGRAM = "REFERRAL_PROGRAM",
  REWARDS = "REWARDS",
  TRANSACTIONS_AND_PAYMENTS = "TRANSACTIONS_AND_PAYMENTS",
  TRAVEL = "TRAVEL",
  XERO = "XERO",
}

/** Copied from BudgetPeriodType in Budgets DGS. Update when support for new fields are added in the UI */
export enum HierarchiesBudgetPeriodType {
  /** Invalid */
  INVALID = "INVALID",
  /** Only once */
  ONE_TIME = "ONE_TIME",
  /** Every month */
  PER_MONTH = "PER_MONTH",
  /** Every quarter */
  PER_QUARTER = "PER_QUARTER",
  /** Every week */
  PER_WEEK = "PER_WEEK",
  /** Every year */
  PER_YEAR = "PER_YEAR",
}

/** Input criteria to determine if customer is high risk for IDV. */
export interface HighRiskIDVInput {
  incorporationType: KycIdentityIncorporationType;
  industry: Scalars["String"];
}

/** Any string intended for looking up hotels. */
export interface HotelAutocompleteFilterInput {
  queryString: Scalars["String"];
}

export interface HotelAutocompleteResult {
  hotelCode?: Maybe<Scalars["String"]>;
  hotelName?: Maybe<Scalars["String"]>;
  location?: Maybe<TravelLocation>;
}

/** Results from a hotel autocomplete query. */
export interface HotelAutocompleteResults {
  /** An airport to be used as the reference point around which to search for hotels. */
  airportResults?: Maybe<Array<AirAutocompleteResult>>;
  /** Specific hotels to be used when searching for hotels. */
  hotelResults?: Maybe<Array<Maybe<HotelAutocompleteResult>>>;
  /** Arbitrary locations (cities, addresses) to be used as reference points for searching hotels. */
  locationResults?: Maybe<Array<LocationAutocompleteResult>>;
  /** Specific points of interest (businesses, landmarks) to be used as reference points for hotels. */
  pointsOfInterestResults?: Maybe<Array<LocationAutocompleteResult>>;
  /** @deprecated Use `hotelResults` instead */
  results?: Maybe<Array<HotelAutocompleteResult>>;
}

export interface HotelRoomBlockInput {
  /** Check-in date time */
  checkInTime?: InputMaybe<Scalars["LocalDateTime"]>;
  /** Check-out date time */
  checkOutTime?: InputMaybe<Scalars["LocalDateTime"]>;
  /** Confirmation code from Hotel */
  confirmationCode?: InputMaybe<Scalars["String"]>;
  /** Either customerUserId or userEmail is required */
  customerUserId?: InputMaybe<Scalars["ID"]>;
  /** A row identifier for error handling */
  rowId: Scalars["String"];
  /** Either customerUserId or userEmail is required */
  userEmail?: InputMaybe<Scalars["String"]>;
}

/** The 3rd party aggregator Brex uses to standardize employee data syncing. */
export enum HrAggregatorVendor {
  MERGE = "MERGE",
}

/** A connection to the customers HR system. */
export interface HrConnection {
  /** How to present auto-offboarding settings */
  autoOffboardingAvailability: AutoOffboardingAvailability;
  /** How to present auto-onboarding settings */
  autoOnboardingAvailability: AutoOnboardingAvailability;
  hrisAggregatorVendor: HrAggregatorVendor;
  hrisStatus: HrConnectionStatus;
  hrisSystem: HrSystem;
  hrisSystemName?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  /**
   * The last time, if any, we synced employee data.
   * Will be null when the customer sets up the connection.
   */
  lastSyncAt?: Maybe<Scalars["Time"]>;
  syncStatus?: Maybe<HrSyncStatus>;
  /**
   * The user management settings, if any, specifying how to onboard synced employees.
   * Note: this is a list but there should only ever be 1 or 0 settings at this time.
   */
  userManagementSettings: Array<UserManagementSettings>;
}

/** HRIS Connection connection for pagination */
export interface HrConnectionConnection extends Connection {
  edges: Array<HrConnectionEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

/** HRIS Connection edge. */
export interface HrConnectionEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<HrConnection>;
}

/** Filter for querying many HRIS connections. */
export interface HrConnectionFilterInput {
  /**
   * The hrSystems filter is temporarily being removed to allow for re-federating the associated enum.
   *    hrSystems: [HrSystem!]
   */
  statuses?: InputMaybe<Array<HrConnectionStatus>>;
  vendors?: InputMaybe<Array<HrAggregatorVendor>>;
}

/** What state the connection is in re: the aggregator. */
export enum HrConnectionStatus {
  DISABLED = "DISABLED",
  ENABLED = "ENABLED",
  UNLINKED = "UNLINKED",
}

export enum HrSyncStatus {
  /** Not currently in use. */
  AUTO_IMPORTING = "AUTO_IMPORTING",
  /** Sync has completed sync and eligible employee data has been updated in Hierarchies. */
  DONE = "DONE",
  /** Indicates something went wrong during sync. */
  FAILED = "FAILED",
  /**
   * Employee data has been retrieved from the aggregator, however no employees will be on/offboarded as there are no
   * import settings specified. The admin should be emailed to specify invite settings if they haven't done so.
   */
  PULLED_FROM_HRIS = "PULLED_FROM_HRIS",
  /**
   * Data is actively flowing between the aggregator (Merge) and Hierarchies.
   * Syncs that are pulling can take anywhere from a couple of minutes to an hour.
   */
  PULLING_FROM_HRIS = "PULLING_FROM_HRIS",
  /**
   * Waiting for aggregator (Merge) to sync with the HRIS platform (e.g. Workday).
   * This sync time can take up to an hour depending on the complexity of the data.
   */
  WAITING = "WAITING",
}

/** HR systems */
export enum HrSystem {
  ADP_WORKFORCE_NOW = "ADP_WORKFORCE_NOW",
  BAMBOOHR = "BAMBOOHR",
  CERIDIAN_DAYFORCE = "CERIDIAN_DAYFORCE",
  CHARLIE = "CHARLIE",
  CHARTHOP = "CHARTHOP",
  DEEL = "DEEL",
  FRESHTEAM = "FRESHTEAM",
  GUSTO = "GUSTO",
  HIBOB = "HIBOB",
  HR_CLOUD = "HR_CLOUD",
  HR_PARTNER = "HR_PARTNER",
  HUMAANSIO = "HUMAANSIO",
  JUSTWORKS = "JUSTWORKS",
  LANO = "LANO",
  LATTICE_HRIS = "LATTICE_HRIS",
  NAMELY = "NAMELY",
  NMBRS = "NMBRS",
  ORACLE_HCM = "ORACLE_HCM",
  PAYCHEX = "PAYCHEX",
  PAYCOR = "PAYCOR",
  PAYLOCITY = "PAYLOCITY",
  PERSONIO = "PERSONIO",
  PROLIANT = "PROLIANT",
  RIPPLING = "RIPPLING",
  SAGE_HR = "SAGE_HR",
  SAPLING = "SAPLING",
  SAP_SUCCESSFACTORS = "SAP_SUCCESSFACTORS",
  SQUARE_PAYROLL = "SQUARE_PAYROLL",
  TRINET = "TRINET",
  UKG_PRO = "UKG_PRO",
  UKG_READY = "UKG_READY",
  WORKDAY = "WORKDAY",
  ZENEFITS = "ZENEFITS",
}

export enum HrisAggregatorVendor {
  MERGE = "MERGE",
}

/** Describes an HRIS connection with the hris vendor */
export interface HrisConnection extends Node {
  /** The HRIS vendor this connection is established w/ */
  hrisAggregatorVendor?: Maybe<HrisAggregatorVendor>;
  /** The status of the user's connection with the hris vendor */
  hrisStatus?: Maybe<HrisStatus>;
  /** The HRIS system the user is connecting to via this connection */
  hrisSystem?: Maybe<HrisSystem>;
  /** The display name of the HRIS system the user is connecting to */
  hrisSystemName?: Maybe<Scalars["String"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  /** The last time that the hris sync with the vendor and into Brex completed/failed */
  lastSyncAt?: Maybe<Scalars["Time"]>;
  /** The (most recent) syncing status of the connection with the hris vendor */
  syncStatus?: Maybe<HrisSyncStatus>;
}

/** What kind of employment the person has. */
export enum HrisEmploymentType {
  CONTRACTOR = "CONTRACTOR",
  FREELANCE = "FREELANCE",
  FULL_TIME = "FULL_TIME",
  INTERN = "INTERN",
  PART_TIME = "PART_TIME",
  UNKNOWN = "UNKNOWN",
}

/** HRIS Job run metadata */
export interface HrisJobRun {
  finishedSyncAt?: Maybe<Scalars["Time"]>;
  id: Scalars["ID"];
  insertedAt: Scalars["Time"];
  status: HrisJobRunStatus;
}

export interface HrisJobRunConnection extends Connection {
  edges: Array<HrisJobRunEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface HrisJobRunEdge {
  node?: Maybe<HrisJobRun>;
}

/** Current status of the HRIS Job run */
export enum HrisJobRunStatus {
  DONE = "DONE",
  FAILED = "FAILED",
  SKIPPED = "SKIPPED",
  SYNCING = "SYNCING",
  UNKNOWN = "UNKNOWN",
}

/** Filter for querying HRIS job runs */
export interface HrisJobRunsFilterInput {
  hrisConnectionId: Scalars["ID"];
}

/** Describes a link token object */
export interface HrisLinkToken {
  /** The link token we want to pass back to the FE */
  linkToken: Scalars["String"];
}

export enum HrisStatus {
  DISABLED = "DISABLED",
  ENABLED = "ENABLED",
  UNLINKED = "UNLINKED",
}

export interface HrisSyncEvent {
  hrConnection?: Maybe<HrConnection>;
  hrisJobRunId: Scalars["String"];
  syncedAt?: Maybe<Scalars["Time"]>;
}

export enum HrisSyncStatus {
  DONE = "DONE",
  FAILED = "FAILED",
  PULLED_FROM_HRIS = "PULLED_FROM_HRIS",
  PULLING_FROM_HRIS = "PULLING_FROM_HRIS",
  SYNCING = "SYNCING",
  WAITING = "WAITING",
}

export enum HrisSystem {
  ADP_WORKFORCE_NOW = "ADP_WORKFORCE_NOW",
  ALEXIS_HR = "ALEXIS_HR",
  ALTERA_PAYROLL = "ALTERA_PAYROLL",
  BAMBOOHR = "BAMBOOHR",
  BIZ_MERLIN_HR = "BIZ_MERLIN_HR",
  BREATHE = "BREATHE",
  CERIDIAN_DAYFORCE = "CERIDIAN_DAYFORCE",
  CHARLIE = "CHARLIE",
  CHARTHOP = "CHARTHOP",
  DEEL = "DEEL",
  FRESHTEAM = "FRESHTEAM",
  GUSTO = "GUSTO",
  HIBOB = "HIBOB",
  HR_CLOUD = "HR_CLOUD",
  HR_PARTNER = "HR_PARTNER",
  HUMAANSIO = "HUMAANSIO",
  INTELLI_HR = "INTELLI_HR",
  INVALID = "INVALID",
  JUSTWORKS = "JUSTWORKS",
  LANO = "LANO",
  LATTICE_HRIS = "LATTICE_HRIS",
  LUCCA = "LUCCA",
  NAMELY = "NAMELY",
  NMBRS = "NMBRS",
  OFFICIENT = "OFFICIENT",
  ORACLE_HCM = "ORACLE_HCM",
  PAYCHEX = "PAYCHEX",
  PAYCOR = "PAYCOR",
  PAYLOCITY = "PAYLOCITY",
  PEOPLE_HR = "PEOPLE_HR",
  PERSONIO = "PERSONIO",
  PROLIANT = "PROLIANT",
  RIPPLING = "RIPPLING",
  SAGE_HR = "SAGE_HR",
  SAPLING = "SAPLING",
  SAP_SUCCESSFACTORS = "SAP_SUCCESSFACTORS",
  SESAME = "SESAME",
  SQUARE_PAYROLL = "SQUARE_PAYROLL",
  TRINET = "TRINET",
  UKG_PRO = "UKG_PRO",
  UKG_READY = "UKG_READY",
  WORKDAY = "WORKDAY",
  ZENEFITS = "ZENEFITS",
}

/** What role an employee should have as a Brex user. */
export enum HrisUserRole {
  ACCOUNT_ADMIN = "ACCOUNT_ADMIN",
  AP_CLERK = "AP_CLERK",
  BOOKKEEPER = "BOOKKEEPER",
  CARD_ADMIN = "CARD_ADMIN",
  EMPLOYEE = "EMPLOYEE",
  EMPLOYEE_WITHOUT_CORP_CARDS = "EMPLOYEE_WITHOUT_CORP_CARDS",
}

export interface HrisUserSetting {
  /** Monthly limit for the employee, if any. */
  monthlyLimitAmount?: Maybe<FinancialAsset>;
  /** Role that employees will be invited as. */
  role: HrisUserRole;
}

export interface HrisUserSettingInput {
  /** Monthly limit for the employee, if any. */
  monthlyLimitAmount?: InputMaybe<FinancialAssetInput>;
  /** Role that employees will be invited as. */
  role: HrisUserRole;
}

/** Hungary bank account. */
export interface HuLocal {
  accountNumber?: Maybe<Scalars["String"]>;
}

/** Hungary bank account. */
export interface HuLocalInput {
  accountNumber?: InputMaybe<Scalars["String"]>;
}

/** Structured data for Identity Provider errors */
export interface IDPErrorContent extends StructuredData {
  /** Additional error details */
  errorDetails?: Maybe<Scalars["String"]>;
  /** Reason for the error */
  errorReason?: Maybe<Scalars["String"]>;
  /** Outcome status of the operation */
  outcome?: Maybe<OutcomeStatus>;
  /** Type discriminator value - 'IDPErrorContent' */
  type?: Maybe<Scalars["String"]>;
}

export interface IDValueQuery {
  parity: ParityOperator;
  val: Scalars["ID"];
}

export interface IMatchCondition {
  /** The condition key for this condition */
  conditionKey: Scalars["String"];
}

/**
 * Common type for all workflow blocks.
 *
 * Note that since a deeply nested structure isn't really manageable in GraphQL queries the current approach
 * is having the blocks refer to each other by their keys, and as such certain limitations aren't properly modeled.
 *
 * For instance, a WorkflowParallelBlock may only have other blocks (denoted by the Block suffix) referenced, whilst
 * the WorkflowLogicOperatorConditionBlock may only reference condition blocks (denoted by the Condition suffix).
 */
export interface IWorkflowBlock {
  /** Block id */
  key: Scalars["String"];
  /** Reference to the next block */
  nextKey?: Maybe<Scalars["String"]>;
}

/**
 * International Bank Account Number - unique cross-border identifier of a bank account.
 * Format is up to 34 alphanumeric characters consisting of:
 * * country code using ISO 3166-1 alpha-2 - two letters.
 * * check digits - two digits to perform sanity check on the destination.
 * * Basic Bank Account Number (BBAN) - up to 30 alphanumeric characters that are country-specific.
 */
export interface Iban {
  value?: Maybe<Scalars["String"]>;
}

/**
 * International Bank Account Number - unique cross-border identifier of a bank account.
 * Format is up to 34 alphanumeric characters consisting of:
 * * country code using ISO 3166-1 alpha-2 - two letters.
 * * check digits - two digits to perform sanity check on the destination.
 * * Basic Bank Account Number (BBAN) - up to 30 alphanumeric characters that are country-specific.
 */
export interface IbanInput {
  value?: InputMaybe<Scalars["String"]>;
}

export interface IdFilterInput {
  in?: InputMaybe<Array<Scalars["ID"]>>;
  notIn?: InputMaybe<Array<Scalars["ID"]>>;
}

export interface IdentifierToStringValue {
  displayName?: Maybe<Scalars["String"]>;
  encodedIdentifier?: Maybe<Scalars["String"]>;
  identifier?: Maybe<Scalars["String"]>;
}

export interface IdentifierToStringValueInput {
  displayName?: InputMaybe<Scalars["String"]>;
  identifier?: InputMaybe<Scalars["String"]>;
}

export interface IdentityActivity {
  device?: Maybe<Device>;
  eventType?: Maybe<Scalars["String"]>;
  geo?: Maybe<Scalars["String"]>;
  outcome?: Maybe<Scalars["String"]>;
  outcomeReason?: Maybe<Scalars["String"]>;
  publishedAt?: Maybe<Scalars["String"]>;
}

/** IdentitySuspiciousActivities */
export interface IdentitySuspiciousActivitiesConnection extends Connection {
  edges?: Maybe<Array<Maybe<IdentitySuspiciousActivitiesEdge>>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface IdentitySuspiciousActivitiesEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<IdentitySuspiciousActivity>;
}

export interface IdentitySuspiciousActivity {
  activity?: Maybe<IdentityActivity>;
  message?: Maybe<Scalars["String"]>;
  type?: Maybe<IdentitySuspiciousActivityType>;
}

export enum IdentitySuspiciousActivityType {
  UNUSUAL_LOGIN = "UNUSUAL_LOGIN",
}

export enum IdpType {
  OIDC = "OIDC",
  SAML2 = "SAML2",
}

export interface IgnoreSyncErrorsInput {
  clientMutationId: Scalars["String"];
  expenseIds: Array<Scalars["ID"]>;
  externalEntryType: BillExportExternalEntryType;
}

export interface IgnoreSyncErrorsResult extends MutationResult {
  errors?: Maybe<Array<BillMutationError>>;
  result?: Maybe<Array<BillExportAttempt>>;
}

/** Contains the parameters to collect information of Image type. */
export interface ImageInformation {
  /** Type of the information requirement */
  displayType: RequirementInformationFieldDisplayType;
  /** Identifier of the information requirement */
  key: Scalars["String"];
  /** Name of the information requirement to be displayed */
  name: Scalars["String"];
}

export interface ImportEmployeeInput {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  connectionId: Scalars["ID"];
  rule: ImportRule;
  setting: UserSetting;
}

export interface ImportEmployeeResult {
  errors: Array<EmployeeError>;
}

export interface ImportRule {
  employmentTypes?: InputMaybe<Array<EmploymentType>>;
  ids?: InputMaybe<Array<Scalars["ID"]>>;
  type: ImportRuleType;
}

export enum ImportRuleType {
  AUTO = "AUTO",
  MANUAL = "MANUAL",
}

export enum ImportType {
  DRAFT = "DRAFT",
  PUBLISH = "PUBLISH",
}

/**
 * Indian Financial System Code - identifies a bank branch in India.
 * Format is an 11-character code consisting of:
 * * bank identifier - 4 characters.
 * * branch identifier - 6 characters.
 * * reserved for future use - 1 character.
 */
export interface InLocal {
  accountNumber?: Maybe<Scalars["String"]>;
  ifsc?: Maybe<Scalars["String"]>;
}

/**
 * Indian Financial System Code - identifies a bank branch in India.
 * Format is an 11-character code consisting of:
 * * bank identifier - 4 characters.
 * * branch identifier - 6 characters.
 * * reserved for future use - 1 character.
 */
export interface InLocalInput {
  accountNumber?: InputMaybe<Scalars["String"]>;
  ifsc?: InputMaybe<Scalars["String"]>;
}

export enum InboxExpenseEntitySubtype {
  EXPENSE_SUBTYPE_MISSING_MEMO = "EXPENSE_SUBTYPE_MISSING_MEMO",
  EXPENSE_SUBTYPE_MISSING_MEMO_AND_RECEIPT = "EXPENSE_SUBTYPE_MISSING_MEMO_AND_RECEIPT",
  EXPENSE_SUBTYPE_MISSING_RECEIPT = "EXPENSE_SUBTYPE_MISSING_RECEIPT",
}

export enum InboxExpenseEntityType {
  EXPENSE_TYPE_BILLPAY = "EXPENSE_TYPE_BILLPAY",
  EXPENSE_TYPE_CARD = "EXPENSE_TYPE_CARD",
  EXPENSE_TYPE_CLAWBACK = "EXPENSE_TYPE_CLAWBACK",
  EXPENSE_TYPE_EXTENDED = "EXPENSE_TYPE_EXTENDED",
  EXPENSE_TYPE_REIMBURSEMENT = "EXPENSE_TYPE_REIMBURSEMENT",
}

/** Displayed in the user's Inbox, a task represents an action that a user needs to take. */
export interface InboxTask {
  /** The optional task badge */
  badge?: Maybe<InboxTaskBadge>;
  /** The task's criticality */
  criticality: InboxTaskCriticality;
  /** DEPRECATED: Use ctas below given that it supports multiples. */
  cta?: Maybe<InboxTaskCta>;
  ctas: InboxTaskCtas;
  /** The raw task creation date. Useful for clientside sorting, filtering, and apply date section headers. */
  date: Scalars["Time"];
  /**
   * DEPRECATED: Display category that mobile clients can use to organize tasks in list display. Based on criticality and type.
   * @deprecated No longer supported
   */
  displaySection: InboxTaskDisplaySection;
  /** Name of the display section that the task belongs to */
  displaySectionName: Scalars["String"];
  /** Base64 encoded task ID. */
  encodedId: Scalars["ID"];
  /** Base64 encoded ID of the Request associated with the Task. Null for Draft Reimbursements only */
  encodedRequestId?: Maybe<Scalars["String"]>;
  /**
   * The local Metal icon, e.g.,. a "checkmark," or the URL of the remote icon that the client must load. The remote icon
   * takes precedence over the local icon if both are present.
   */
  icon: InboxTaskIcon;
  /**
   * The unique task ID leveraged for caching. entityId reflect the expense,
   * budget, etc. that requires action.
   */
  id: Scalars["ID"];
  /** A list of request actions assoicated with the task */
  requestActions?: Maybe<Array<RequestAction>>;
  /** The task subtitle, e.g., "Starbucks ��� $9.99". */
  subtitle: Scalars["String"];
  /**
   * Task entity details. At minimum this includes the entity ID, e.g. "expense_123," but can be extended to include more
   * fields like the expense entity.
   */
  taskEntityDetails: InboxTaskEntityDetails;
  /** State of this task, currently RESOLVED or UNRESOLVED */
  taskState: InboxTaskState;
  /**
   * The task type. Used as the source of truth for building tables on dashboard, and informing mobile task completion
   * actions.
   */
  taskType: InboxTaskType;
  /** The task title, e.g., "Missing memo". */
  title: Scalars["String"];
}

/** Defines the label and style (for severity) of the badge displayed with the task in the inbox. */
export interface InboxTaskBadge {
  /** The text contained in the badge. */
  label: Scalars["String"];
  /** The style of the badge. This is used for different levels of priority/severity of tasks. */
  style: InboxTaskBadgeStyle;
}

/** Style and color of the badge (for criticality, due date) displayed with the task. */
export enum InboxTaskBadgeStyle {
  DANGER = "DANGER",
  DEFAULT = "DEFAULT",
  WARNING = "WARNING",
}

/** Input filters for task. Only one should be provided depending on the client */
export interface InboxTaskClientFilter {
  entityIds?: InputMaybe<Array<Scalars["String"]>>;
  insertedAtBetween?: InputMaybe<TimeIntervalInput>;
  mobileFilter?: InputMaybe<InboxTaskFilterType>;
  taskIds?: InputMaybe<Array<Scalars["String"]>>;
  taskStates?: InputMaybe<Array<InboxTaskState>>;
  taskTypesFilter?: InputMaybe<Array<InputMaybe<InboxTaskType>>>;
  webFilter?: InputMaybe<InboxTaskWebFilterType>;
}

export interface InboxTaskConnection extends Connection {
  /** The items in the current page of results. */
  edges: Array<InboxTaskEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of items, across all pages, matching the filter criteria specified for this connection. */
  totalCount: Scalars["Int"];
}

export interface InboxTaskConnectionV2 extends Connection {
  /** The items in the current page of results. */
  edges: Array<InboxTaskEdgeV2>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of items, across all pages, matching the filter criteria specified for this connection. */
  totalCount: Scalars["Int"];
}

/** Represents the total count of inbox tasks and a breakdown of counts by task type. */
export interface InboxTaskCounts {
  /**
   * The count of each task type for mobile client sections. When new tasks are added they will be appended to the list
   * for clients to display how they choose.
   */
  counts: Array<InboxTaskFilterTypeCount>;
  /** The total number of tasks and activity notifications. */
  total: Scalars["Int"];
  /**
   * The count of each task type for web client sections. When new tasks are added they will be appended to the list for
   * clients to display how they choose.
   */
  webCounts: Array<InboxTaskWebFilterTypeCount>;
}

/** Task criticality. */
export enum InboxTaskCriticality {
  CRITICAL = "CRITICAL",
  OPTIONAL = "OPTIONAL",
  REQUIRED = "REQUIRED",
}

/**
 * DEPRECATED: Had to deprecate it and create a new type because on mobile we do an check for all
 * possible types so it's not possible to just add a new enum.
 */
export interface InboxTaskCta {
  /** The CTA label, e.g., "RSVP". The client will look to the task type and entity to inform what action to take. */
  label: Scalars["String"];
  /** The CTA style/colour. */
  style?: Maybe<InboxTaskCtaStyle>;
}

/** DEPRECATED: Style and color of the task's CTA (e.g. for criticality) displayed with the task. */
export enum InboxTaskCtaStyle {
  DANGER = "DANGER",
  DEFAULT = "DEFAULT",
}

/** Style and color of the task's CTA (e.g. for criticality) displayed with the task. */
export enum InboxTaskCtaStyleV2 {
  DANGER = "DANGER",
  DEFAULT = "DEFAULT",
  GHOST = "GHOST",
}

export interface InboxTaskCtaV2 {
  /** The CTA label, e.g., "RSVP". The client will look to the task type and entity to inform what action to take. */
  label: Scalars["String"];
  /** The CTA style/colour. */
  style?: Maybe<InboxTaskCtaStyleV2>;
}

export interface InboxTaskCtas {
  /** Dismiss cta for a task. Only returned for tasks that are dismissible. */
  dismiss?: Maybe<InboxTaskCtaV2>;
  /** Primary cta for a task. Should always be returned. */
  primary: InboxTaskCtaV2;
  /** Resolve cta for a task. Only returned for tasks that are resolvable by the user. */
  resolve?: Maybe<InboxTaskCtaV2>;
}

/** Display category that mobile clients can use to organize tasks in list display. Based on criticality and type. */
export enum InboxTaskDisplaySection {
  CRITICAL = "CRITICAL",
  DRAFTS = "DRAFTS",
  DUE_SOON = "DUE_SOON",
  OTHER = "OTHER",
  OVERDUE = "OVERDUE",
}

export interface InboxTaskEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The InboxTask at this edge. */
  node: InboxTask;
}

export interface InboxTaskEdgeV2 {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The InboxTask at this edge. */
  node?: Maybe<InboxTask>;
}

/**
 * Interface for entity details. All entity detail types require these variables in addition to whatever entity-specific
 * info is required for the client in the inbox.
 */
export interface InboxTaskEntityDetails {
  encodedEntityId: Scalars["String"];
  entityId: Scalars["String"];
}

export interface InboxTaskFilter {
  /** The filter label. E.g. "All". */
  label: Scalars["String"];
  /** The filter type, which can map to invidual tasks or a collection of tasks. */
  type: InboxTaskFilterType;
}

export interface InboxTaskFilterConnection extends Connection {
  edges: Array<InboxTaskFilterEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"];
}

export interface InboxTaskFilterEdge {
  cursor?: Maybe<Scalars["String"]>;
  node: InboxTaskFilter;
}

/** Task filters for mobile client. */
export enum InboxTaskFilterType {
  ALL = "ALL",
  BUDGET_REQUESTS = "BUDGET_REQUESTS",
  COMMENTS = "COMMENTS",
  COMPANY_REPAYMENTS = "COMPANY_REPAYMENTS",
  DRAFTS = "DRAFTS",
  EXPENSE_REQUESTS = "EXPENSE_REQUESTS",
  MISSING_ATTENDEES = "MISSING_ATTENDEES",
  MISSING_DOCUMENTATION = "MISSING_DOCUMENTATION",
  TEAM_APPROVALS = "TEAM_APPROVALS",
  TRAVEL = "TRAVEL",
}

/** Represents the count of inbox tasks for a specific task type for mobile client display */
export interface InboxTaskFilterTypeCount {
  /** Total count of inbox tasks related to this type. */
  total: Scalars["Int"];
  /** The type of inbox task to which the count refers to. */
  type: InboxTaskFilterType;
}

/** Defines which icon is displayed next to the task in the inbox. */
export interface InboxTaskIcon {
  /** The icon's accessibility text that is announced for vision impaired users. *\/ */
  accessibilityText: Scalars["String"];
  /** A local Metal icon string constant. */
  localMetalIcon?: Maybe<Scalars["String"]>;
  /** A remote icon that the client is responsible for loading via the URL. *\/ */
  remoteIcon?: Maybe<InboxTaskRemoteIcon>;
}

/** URL(s) for the remote icon that will be displayed next to the task in the inbox. */
export interface InboxTaskRemoteIcon {
  /**
   * The optional URL of the remote icon that the clients with dark themes should use. Depending on the color palette,
   * some icons will have enough contrast in both light and dark themes. This is thus optional.
   */
  darkUrl?: Maybe<Scalars["String"]>;
  /** The URL of the remote icon that the clients with light themes should use. */
  lightUrl: Scalars["String"];
}

/** Sort order filter for web and mobile clients */
export enum InboxTaskSortFilter {
  CRITICALITY = "CRITICALITY",
  INSERTED_AT = "INSERTED_AT",
}

export enum InboxTaskState {
  BLOCKED = "BLOCKED",
  CANCELED = "CANCELED",
  HIDDEN = "HIDDEN",
  RESOLVED = "RESOLVED",
  UNRESOLVED = "UNRESOLVED",
}

/** Type of task (i.e. related entity type). */
export enum InboxTaskType {
  ACTIVATE_CARD = "ACTIVATE_CARD",
  ADD_YOUR_VENDORS = "ADD_YOUR_VENDORS",
  ALLOCATE_BANKING_DDA_FUNDS = "ALLOCATE_BANKING_DDA_FUNDS",
  ARFI_DISPUTES = "ARFI_DISPUTES",
  ARFI_EMISSARY = "ARFI_EMISSARY",
  ARFI_FINANCIAL_STATEMENT_REQUEST = "ARFI_FINANCIAL_STATEMENT_REQUEST",
  ARFI_HELD_WIRE = "ARFI_HELD_WIRE",
  ARFI_RISK_PERIODIC = "ARFI_RISK_PERIODIC",
  /** @deprecated No longer supported */
  AUTOMATED_REQUEST_FOR_INFORMATION = "AUTOMATED_REQUEST_FOR_INFORMATION",
  BANKING_TRANSACTION_APPROVAL = "BANKING_TRANSACTION_APPROVAL",
  /**
   *  Deprecated
   * @deprecated No longer supported
   */
  BANK_CONNECTION = "BANK_CONNECTION",
  BOOKING_REVIEW = "BOOKING_REVIEW",
  /** @deprecated No longer supported */
  BREX_BUSINESS_ACCOUNT = "BREX_BUSINESS_ACCOUNT",
  /** @deprecated No longer supported */
  BREX_CARD = "BREX_CARD",
  BUDGET_LIMIT_INCREASE = "BUDGET_LIMIT_INCREASE",
  BUDGET_REQUEST = "BUDGET_REQUEST",
  /** @deprecated No longer supported */
  CARD_ACTIVATION = "CARD_ACTIVATION",
  /** @deprecated No longer supported */
  CARD_EXPENSE_MEMO = "CARD_EXPENSE_MEMO",
  /** @deprecated No longer supported */
  CARD_EXPENSE_RECEIPT = "CARD_EXPENSE_RECEIPT",
  /** @deprecated No longer supported */
  CARD_EXPENSE_RECEIPT_AND_MEMO = "CARD_EXPENSE_RECEIPT_AND_MEMO",
  /** @deprecated No longer supported */
  CASH_TRANSACTION_APPROVAL = "CASH_TRANSACTION_APPROVAL",
  CIP_REFRESH = "CIP_REFRESH",
  CLAWBACK_APPROVAL = "CLAWBACK_APPROVAL",
  CLAWBACK_POB_APPROVAL = "CLAWBACK_POB_APPROVAL",
  COMMENT_RESPONSE = "COMMENT_RESPONSE",
  COMPLETE_ENTITY_SETUP = "COMPLETE_ENTITY_SETUP",
  COMPLETE_INTEGRATION_WITH_PARTNER = "COMPLETE_INTEGRATION_WITH_PARTNER",
  COMPLETE_VENDOR_MIGRATION = "COMPLETE_VENDOR_MIGRATION",
  CONNECT_ACCOUNTING_SOFTWARE = "CONNECT_ACCOUNTING_SOFTWARE",
  /** @deprecated No longer supported */
  CONNECT_BANK_ACCOUNT = "CONNECT_BANK_ACCOUNT",
  CONSENT_TO_AIRWALLEX = "CONSENT_TO_AIRWALLEX",
  CREATE_SPEND_MIGRATION_TARGETS = "CREATE_SPEND_MIGRATION_TARGETS",
  CUSTOMIZE_SPENDING_POLICIES = "CUSTOMIZE_SPENDING_POLICIES",
  ENABLE_CHAT_PLATFORM = "ENABLE_CHAT_PLATFORM",
  ENABLE_ENTERPRISE_IDP = "ENABLE_ENTERPRISE_IDP",
  EXPENSE_APPROVALS = "EXPENSE_APPROVALS",
  EXPENSE_ATTENDEE = "EXPENSE_ATTENDEE",
  EXPENSE_MISSING_INFORMATION = "EXPENSE_MISSING_INFORMATION",
  EXPENSE_REQUIRE_EXTENDED_FIELD = "EXPENSE_REQUIRE_EXTENDED_FIELD",
  EXPENSIVE_TRANSACTION_INSIGHT = "EXPENSIVE_TRANSACTION_INSIGHT",
  FUND_YOUR_ACCOUNT = "FUND_YOUR_ACCOUNT",
  GENERATE_VIRTUAL_CARDS = "GENERATE_VIRTUAL_CARDS",
  GET_YOUR_FIRST_CARD = "GET_YOUR_FIRST_CARD",
  /** @deprecated No longer supported */
  GET_YOUR_FIRST_CARD_1D = "GET_YOUR_FIRST_CARD_1D",
  /** @deprecated No longer supported */
  GET_YOUR_FIRST_CARD_30D = "GET_YOUR_FIRST_CARD_30D",
  /** @deprecated No longer supported */
  GET_YOUR_PRODUCTS_OBJECTIVE = "GET_YOUR_PRODUCTS_OBJECTIVE",
  HIGH_PER_DIEM_MEALS_INSIGHT = "HIGH_PER_DIEM_MEALS_INSIGHT",
  HIGH_PER_DIEM_RIDESHARE_INSIGHT = "HIGH_PER_DIEM_RIDESHARE_INSIGHT",
  INVITE_RSVP = "INVITE_RSVP",
  INVITE_TEAM_MEMBER = "INVITE_TEAM_MEMBER",
  LIMITS_EXPERIENCE_UPLOAD_BANK_STATEMENTS = "LIMITS_EXPERIENCE_UPLOAD_BANK_STATEMENTS",
  LIMITS_EXPERIENCE_UPLOAD_FINANCIAL_STATEMENTS = "LIMITS_EXPERIENCE_UPLOAD_FINANCIAL_STATEMENTS",
  MIGRATE_OR_ASSIGN_VENDORS = "MIGRATE_OR_ASSIGN_VENDORS",
  REIMBURSEMENT_DRAFT = "REIMBURSEMENT_DRAFT",
  REORDER_CARD = "REORDER_CARD",
  REPLACE_CARD = "REPLACE_CARD",
  REVIEW_AUTO_ASSIGNED_SPEND_LIMIT = "REVIEW_AUTO_ASSIGNED_SPEND_LIMIT",
  REVIEW_BANKING_DDA_TERMS = "REVIEW_BANKING_DDA_TERMS",
  /** @deprecated No longer supported */
  REVIEW_SPENDING_POLICIES = "REVIEW_SPENDING_POLICIES",
  SAME_DAY_MICRODEPOSITS_REVERSAL_COMPANY = "SAME_DAY_MICRODEPOSITS_REVERSAL_COMPANY",
  SAME_DAY_MICRODEPOSITS_REVERSAL_PERSONAL = "SAME_DAY_MICRODEPOSITS_REVERSAL_PERSONAL",
  SAME_DAY_MICRODEPOSITS_VERIFICATION_COMPANY = "SAME_DAY_MICRODEPOSITS_VERIFICATION_COMPANY",
  SAME_DAY_MICRODEPOSITS_VERIFICATION_PERSONAL = "SAME_DAY_MICRODEPOSITS_VERIFICATION_PERSONAL",
  SELECT_PRODUCTS = "SELECT_PRODUCTS",
  SETUP_AUTOPAY = "SETUP_AUTOPAY",
  SETUP_AUTOPAY_EMBEDDED = "SETUP_AUTOPAY_EMBEDDED",
  SETUP_BILL_PAY = "SETUP_BILL_PAY",
  SETUP_PAYROLL = "SETUP_PAYROLL",
  SETUP_REIMBURSEMENTS = "SETUP_REIMBURSEMENTS",
  SETUP_REIMBURSEMENTS_REQUIRED = "SETUP_REIMBURSEMENTS_REQUIRED",
  SET_PAYMENT_APPROVALS = "SET_PAYMENT_APPROVALS",
  SPEND_INCREASE_DEPARTMENT_INSIGHT = "SPEND_INCREASE_DEPARTMENT_INSIGHT",
  SPEND_INCREASE_MERCHANT_CATEGORY_INSIGHT = "SPEND_INCREASE_MERCHANT_CATEGORY_INSIGHT",
  SPEND_INCREASE_MERCHANT_INSIGHT = "SPEND_INCREASE_MERCHANT_INSIGHT",
  SPEND_INCREASE_USER_INSIGHT = "SPEND_INCREASE_USER_INSIGHT",
  SUBMIT_BBA_APPLICATION = "SUBMIT_BBA_APPLICATION",
  SUBMIT_CARD_APPLICATION = "SUBMIT_CARD_APPLICATION",
  SUBMIT_EIN = "SUBMIT_EIN",
  SUBMIT_UNIFIED_APPLICATION = "SUBMIT_UNIFIED_APPLICATION",
  SUBMIT_UNIFIED_APPLICATION_EMBEDDED = "SUBMIT_UNIFIED_APPLICATION_EMBEDDED",
  UPGRADE_SUPER_ADMIN = "UPGRADE_SUPER_ADMIN",
  /** @deprecated No longer supported */
  UPLOAD_BANK_STATEMENTS = "UPLOAD_BANK_STATEMENTS",
  VERIFY_BUSINESS = "VERIFY_BUSINESS",
}

/** Task filters for web client. */
export enum InboxTaskWebFilterType {
  BANKING = "BANKING",
  CLOSE_YOUR_BOOKS = "CLOSE_YOUR_BOOKS",
  COMPANY_REPAYMENTS = "COMPANY_REPAYMENTS",
  DRAFTS = "DRAFTS",
  EMPOWER_YOUR_TEAM = "EMPOWER_YOUR_TEAM",
  /**  Account Management Surface (AMS) Objectives */
  GET_YOUR_PRODUCTS = "GET_YOUR_PRODUCTS",
  PAY_YOUR_VENDORS = "PAY_YOUR_VENDORS",
  REQUESTS = "REQUESTS",
  SETUP_EMBEDDED_ACCOUNT = "SETUP_EMBEDDED_ACCOUNT",
  SPEND_INSIGHTS = "SPEND_INSIGHTS",
  /** @deprecated No longer supported */
  START_MOVING_MONEY = "START_MOVING_MONEY",
  START_SPENDING = "START_SPENDING",
  TASKS_COMPANY = "TASKS_COMPANY",
  TASKS_PERSONAL = "TASKS_PERSONAL",
}

/** Represents the count of inbox tasks for a specific task type for web client display. */
export interface InboxTaskWebFilterTypeCount {
  /** Total count of inbox tasks related to this type. */
  total: Scalars["Int"];
  /** The web type of inbox task to which the count refers to. */
  type: InboxTaskWebFilterType;
}

/** Incentive placement. Used only for ID translation right now. */
export interface IncentivePlacement extends Node {
  /** The ID of an object */
  id: Scalars["ID"];
}

export enum IncentivePlacementType {
  CASH_ADD_FUNDS_FLOW_BANNER = "CASH_ADD_FUNDS_FLOW_BANNER",
}

export type IncentivePlacementViewData =
  IncentivePlacementViewDataCashAddFundsFlowBanner;

/** View data for cash add funds flow banner */
export interface IncentivePlacementViewDataCashAddFundsFlowBanner {
  /** CTA text  */
  cta: Scalars["String"];
  /** Icon type optional - potentially useful in the future */
  iconType?: Maybe<Scalars["String"]>;
  /** Placement */
  placement: IncentivePlacement;
  /** Title of banner */
  title: Scalars["String"];
}

export interface IncentivePlacementViewDataConnection {
  edges?: Maybe<Array<Maybe<IncentivePlacementViewDataEdge>>>;
  pageInfo: PageInfo;
}

export interface IncentivePlacementViewDataEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<IncentivePlacementViewData>;
}

export type InconsistencyData =
  | DateInconsistency
  | FinancialAssetInconsistency
  | IntInconsistency
  | MissingContractInconsistency
  | MissingCuaccInconsistency
  | MissingSubscriptionsInconsistency
  | StringInconsistency;

export interface InconsistencyEdge {
  node?: Maybe<InconsistencyEntry>;
}

export interface InconsistencyEntriesConnection extends Connection {
  edges: Array<InconsistencyEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface InconsistencyEntry {
  companyName?: Maybe<Scalars["String"]>;
  contractInformationId?: Maybe<Scalars["String"]>;
  customerAccountId?: Maybe<Scalars["String"]>;
  field?: Maybe<Field>;
  id?: Maybe<Scalars["String"]>;
  inconsistencyData?: Maybe<InconsistencyData>;
  insertedAt?: Maybe<Scalars["LocalDateTime"]>;
  ironcladWorkflowId?: Maybe<Scalars["String"]>;
  isResolved?: Maybe<Scalars["Boolean"]>;
  netsuiteSubscriptionLineId?: Maybe<Scalars["String"]>;
  origin?: Maybe<InconsistencyOrigin>;
  salesforceOpportunityId?: Maybe<Scalars["String"]>;
  updatedAt?: Maybe<Scalars["LocalDateTime"]>;
}

export enum InconsistencyOrigin {
  IRONCLAD = "IRONCLAD",
  NETSUITE = "NETSUITE",
  SALESFORCE = "SALESFORCE",
}

/** Determines whose expenses to show. */
export enum IncurredByInput {
  /** Show my nested direct reports' expenses */
  ALL_REPORTS = "ALL_REPORTS",
  /** Only show my expenses. */
  ME = "ME",
  /** Show my direct reports' expenses. */
  REPORTS = "REPORTS",
}

export interface IndiaBankInfoSubmissionPayloadInput {
  bankAccountNumber: Scalars["String"];
  bankIFSC: Scalars["String"];
  bankName: Scalars["String"];
}

export interface IndiaBusinessInfoSubmissionPayloadInput {
  businessCategory: Scalars["String"];
  businessModel: Array<BusinessModel>;
  businessSubCategory: Scalars["String"];
  corporationType: IndiaCorporationType;
}

/** The corporation type of an Indian entity */
export enum IndiaCorporationType {
  EDUCATIONAL_INSTITUTES = "EDUCATIONAL_INSTITUTES",
  INDIVIDUAL = "INDIVIDUAL",
  LLP = "LLP",
  NGO = "NGO",
  NOT_YET_REGISTERED = "NOT_YET_REGISTERED",
  OTHER = "OTHER",
  PARTNERSHIP = "PARTNERSHIP",
  PRIVATE_LIMITED = "PRIVATE_LIMITED",
  PROPRIETORSHIP = "PROPRIETORSHIP",
  PUBLIC_LIMITED = "PUBLIC_LIMITED",
  SOCIETY = "SOCIETY",
  TRUST = "TRUST",
}

export interface IndividualDocument {
  /** Boolean flag indicating if the individual has no Social Security Number */
  hasNoSsn?: Maybe<Scalars["Boolean"]>;
  /** Social Security Number of the individual */
  ssn?: Maybe<Scalars["String"]>;
}

export interface IndividualDocumentInput {
  /** Boolean flag indicating if the individual has no Social Security Number */
  hasNoSsn: Scalars["Boolean"];
  /** Social Security Number of the individual */
  ssn?: InputMaybe<Scalars["String"]>;
  /** Last 4 digits of Social Security Number of the individual */
  ssnLast4?: InputMaybe<Scalars["String"]>;
}

/** State ID card */
export interface IndividualIdentityDocumentIdentityCard {
  /** Country of issuance */
  countryOfIssuance?: Maybe<Scalars["String"]>;
  /** ID number */
  number?: Maybe<Scalars["String"]>;
}

export interface IndividualIdentityDocumentPassport {
  /** Country of issuance */
  countryOfIssuance?: Maybe<Scalars["String"]>;
  /** Passport number */
  number?: Maybe<Scalars["String"]>;
}

export interface IndividualIdentityDocumentPersona {
  error?: Maybe<Scalars["String"]>;
  /** Persona's inquiry ID */
  inquiryId?: Maybe<Scalars["String"]>;
}

export interface IndividualIdentityDocumentSsn {
  /** SSN number */
  number?: Maybe<Scalars["String"]>;
}

export interface IndividualSubmissionPayloadInput {
  individual: KYCIndividual;
}

export enum IndividualTitle {
  /**  C suite executive */
  C_EXECUTIVE = "C_EXECUTIVE",
  /**  Deprecated */
  EXECUTIVE = "EXECUTIVE",
  FOUNDER = "FOUNDER",
  LEADERSHIP = "LEADERSHIP",
  OTHER = "OTHER",
  PRESIDENT = "PRESIDENT",
  TREASURER = "TREASURER",
}

/** Brex supported industries */
export interface Industry extends Node {
  /** Name displayed in UI */
  displayName: Scalars["String"];
  /** The ID of an object */
  id: Scalars["ID"];
  /** Name used internally and shouldn't change */
  internalName: Scalars["String"];
}

/** The individual result for an industry search */
export interface IndustrySearchResultEntry extends Node {
  /** The ID of an object */
  id: Scalars["ID"];
  /** The industry for each result */
  industry: Industry;
}

export interface IndustrySearchResultEntryConnection {
  edges?: Maybe<Array<Maybe<IndustrySearchResultEntryEdge>>>;
  pageInfo: PageInfo;
}

export interface IndustrySearchResultEntryEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<IndustrySearchResultEntry>;
}

export interface InitializeSunlightMutationError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface InitializeVendorFileMatchSunlightMigrationInput {
  vendorFileMatchId: Scalars["ID"];
}

export interface InitializeVendorFileMatchSunlightMigrationResult {
  errors?: Maybe<Array<InitializeSunlightMutationError>>;
  result?: Maybe<SunlightSDKConfig>;
}

export type InitiatedBy =
  | AutoInitiated
  | AutoInitiatedBilling
  | CustomerInitiated
  | CustomerInitiatedBilling
  | InternalInitiated
  | InternalInitiatedBilling;

export interface InputAutomaticTransferDailySchedule {
  /** Not used, placeholder to create input_object */
  cadence?: InputMaybe<Scalars["Int"]>;
}

export interface InputAutomaticTransferMonthlySchedule {
  /** Day of the month to schedule transactions */
  dayOfMonth: Scalars["Int"];
}

export interface InputAutomaticTransferScheduleTypeUnion {
  daily?: InputMaybe<InputAutomaticTransferDailySchedule>;
  monthly?: InputMaybe<InputAutomaticTransferMonthlySchedule>;
  weekly?: InputMaybe<InputAutomaticTransferWeeklySchedule>;
}

export interface InputAutomaticTransferSourceAccountUnion {
  /** Deposits account ID if the source is an internal deposits account */
  depositsAccountId?: InputMaybe<Scalars["ID"]>;
  /** Financial account ID if the source is an external financial account */
  financialAccountId?: InputMaybe<Scalars["ID"]>;
}

export interface InputAutomaticTransferWeeklySchedule {
  /**
   * 1 = Every week on dayOfWeek
   * 2 = Every other week on dayOfWeek
   */
  cadence: Scalars["Int"];
  /** Day of the week to schedule transactions */
  dayOfWeek: BusinessDay;
}

export interface InputCashRecurringSchedule {
  /** If duration is set to NULL, we will assume the schedule is for an indefinite amount of time */
  duration?: InputMaybe<InputCashRecurringScheduleDurationUnion>;
  type: InputCashRecurringScheduleTypeUnion;
}

export interface InputCashRecurringScheduleDurationUnion {
  endsAt?: InputMaybe<Scalars["Time"]>;
  totalCount?: InputMaybe<Scalars["Int"]>;
}

export interface InputCashRecurringScheduleMonthlyByDay {
  cadence: Scalars["Int"];
  dayOfMonth: Scalars["Int"];
}

export interface InputCashRecurringScheduleMonthlyByWeek {
  cadence: Scalars["Int"];
  dayOfWeek: CashTransactionBusinessDay;
  weekOfMonth: Scalars["Int"];
}

export interface InputCashRecurringScheduleTypeUnion {
  monthlyByDay?: InputMaybe<InputCashRecurringScheduleMonthlyByDay>;
  monthlyByWeek?: InputMaybe<InputCashRecurringScheduleMonthlyByWeek>;
  weekly?: InputMaybe<InputCashRecurringScheduleWeekly>;
}

export interface InputCashRecurringScheduleWeekly {
  cadence: Scalars["Int"];
  dayOfWeek: CashTransactionBusinessDay;
}

export interface InputCashTransactionAchDebitArguments {
  /** ID of a connected external bank account to pull funds from */
  financialAccountId: Scalars["ID"];
  /** ID of a connected rail account details to pull funds from */
  railAccountDetailsId?: InputMaybe<Scalars["ID"]>;
}

export interface InputCashTransactionBookTransferArguments {
  /** The target cash account to move funds to */
  targetDepositsAccountId: Scalars["ID"];
}

export interface InputCashTransactionCreationArgumentUnion {
  /** Pull funds via ACH from an external account to a cash account */
  achDebit?: InputMaybe<InputCashTransactionAchDebitArguments>;
  /**
   * Move funds from a cash account to another cash account
   * Note: book_tranfers can not be scheduled or repeated currently
   */
  bookTransfer?: InputMaybe<InputCashTransactionBookTransferArguments>;
  /** Push funds from a cash account to an external account */
  credit?: InputMaybe<InputCashTransactionCreditArguments>;
}

export interface InputCashTransactionCreditArguments {
  /** Contact and payment instrument of the external account to push funds to */
  payee: Payee;
}

export interface InputCashTransactionUpdateArgumentUnion {
  achDebit?: InputMaybe<InputCashTransactionAchDebitArguments>;
  credit?: InputMaybe<InputCashTransactionCreditArguments>;
}

export interface InputPrepayConfigurationMetadata {
  fundingSourceId?: InputMaybe<Scalars["ID"]>;
  percentageThreshold: Scalars["Int"];
}

export interface InputSendCommsConfigurationMetadata {
  percentageThreshold: Scalars["Int"];
  sendCommsType: LimitUtilizationTriggerConfigurationSendCommsType;
}

export interface InputSourceAccountUnion {
  depositsAccountId?: InputMaybe<Scalars["ID"]>;
  fundingSourceId?: InputMaybe<Scalars["ID"]>;
}

export interface InputTransactionApprovalIdentifierUnion {
  /** The id of the transaction associated with the approval */
  id?: InputMaybe<Scalars["ID"]>;
}

export interface InputTriggerConfigurationMetadataUnion {
  prepayMetadata?: InputMaybe<InputPrepayConfigurationMetadata>;
  sendCommsMetadata?: InputMaybe<InputSendCommsConfigurationMetadata>;
}

export enum InputType {
  DROPDOWN = "DROPDOWN",
  TEXT = "TEXT",
  TYPEAHEAD = "TYPEAHEAD",
}

export interface Insight {
  /** The Customer Account this insight belongs to */
  account: Account;
  /**
   * Comment thread associated with an insight.
   * @deprecated Insights feature has been deprecated
   */
  commentThread?: Maybe<CommentThread>;
  /** Insight ID */
  id: Scalars["ID"];
  /** The type of the insight. */
  insightType: InsightType;
  /** The insight metadata */
  metadata?: Maybe<EmpowerInsightMetadata>;
}

export type InsightAssociatedEntity =
  | Department
  | Merchant
  | MerchantCategory
  | User;

export interface InsightSetting {
  /** Whether or not the insight setting should be enabled for the account */
  enabled: Scalars["Boolean"];
  id: Scalars["ID"];
  /** The type of the insight controlled by the setting */
  insightType: InsightType;
  /** Metadata for the insight setting */
  metadata?: Maybe<InsightSettingMetadata>;
  /** The muting configuration */
  muteConfiguration?: Maybe<MuteConfiguration>;
  /** The current version for the insight setting */
  version: Scalars["Int"];
}

export interface InsightSettingInput {
  /** Whether or not the insight setting should be enabled for the account */
  enabled?: InputMaybe<Scalars["Boolean"]>;
  /** Metadata for the insight setting */
  metadata?: InputMaybe<InsightSettingMetadataOneOfInput>;
  /** The muting input. */
  muteConfiguration?: InputMaybe<MuteConfigurationInput>;
}

export type InsightSettingMetadata = ExpensiveTransactionSettingMetadata;

/** [oneof] Metadata input for an insight setting */
export interface InsightSettingMetadataOneOfInput {
  /** Metadata input for the EXPENSIVE_TRANSACTION insight setting */
  expensiveTransactionSettingMetadata?: InputMaybe<ExpensiveTransactionSettingMetadataInput>;
}

/** Concrete implementation of StandardClientError for the InsightSettings schema */
export interface InsightSettingsClientError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface InsightTaskEntityDetails extends InboxTaskEntityDetails {
  /** Base64 encoded insight ID. */
  encodedEntityId: Scalars["String"];
  /** The insight ID. */
  entityId: Scalars["String"];
  /** The insight associates with the task. */
  insight: Insight;
}

/** All supported insight types */
export enum InsightType {
  EXPENSIVE_TRANSACTION = "EXPENSIVE_TRANSACTION",
  HIGH_PER_DIEM_MEALS = "HIGH_PER_DIEM_MEALS",
  HIGH_PER_DIEM_RIDESHARE = "HIGH_PER_DIEM_RIDESHARE",
  SPEND_INCREASE_DEPARTMENT = "SPEND_INCREASE_DEPARTMENT",
  SPEND_INCREASE_MERCHANT = "SPEND_INCREASE_MERCHANT",
  SPEND_INCREASE_MERCHANT_CATEGORY = "SPEND_INCREASE_MERCHANT_CATEGORY",
  SPEND_INCREASE_USER = "SPEND_INCREASE_USER",
}

/**
 * Time bucketting strategy
 * - START: Buckets start at the startsAt timestamp
 * - END: Buckets start at the endsAt timestamp
 * - CALENDAR: Buckets are aligned with the calendar units (e.g. WEEKS) but can include
 * partial buckets based on the startsAt and endsAt timebuckets
 */
export enum InsightsTimeBucketStrategy {
  CALENDAR = "CALENDAR",
  END = "END",
  START = "START",
}

/** Generic time unit */
export enum InsightsTimeUnit {
  DAY = "DAY",
  MONTH = "MONTH",
  QUARTER = "QUARTER",
  WEEK = "WEEK",
  YEAR = "YEAR",
}

export interface InstantPayoutsFeePayloadV2 {
  usdCentsPerPoint: Scalars["Float"];
}

export interface InstitutionAddress {
  /** Address 1 info */
  address1?: Maybe<Scalars["String"]>;
  /** Address 2 info */
  address2?: Maybe<Scalars["String"]>;
  /** City name */
  city?: Maybe<Scalars["String"]>;
  /** Country name */
  country?: Maybe<Scalars["String"]>;
  /** State name */
  state?: Maybe<Scalars["String"]>;
  /** Zip or Portal code */
  zip?: Maybe<Scalars["String"]>;
}

export enum InstrumentCode {
  NASDAQ_DAGXX = "NASDAQ_DAGXX",
  NASDAQ_DGCXX = "NASDAQ_DGCXX",
  NASDAQ_DGVXX = "NASDAQ_DGVXX",
  NASDAQ_DPGXX = "NASDAQ_DPGXX",
  NASDAQ_GGBXX = "NASDAQ_GGBXX",
  NASDAQ_GGDXX = "NASDAQ_GGDXX",
  NASDAQ_GGSXX = "NASDAQ_GGSXX",
  NASDAQ_GSBXX = "NASDAQ_GSBXX",
  USD = "USD",
}

/** The instrument type of a card` */
export enum InstrumentType {
  PHYSICAL = "PHYSICAL",
  VIRTUAL = "VIRTUAL",
}

export interface IntInconsistency {
  externalValue?: Maybe<Scalars["Int"]>;
  scdValue?: Maybe<Scalars["Int"]>;
}

/** Intacct GL account settings */
export interface IntacctCategories {
  /** Default accounts payable GL account */
  accountsPayableUserCategory?: Maybe<UserCategory>;
  /** Default collections GL account */
  collectionTargetUserCategory?: Maybe<UserCategory>;
  /** reimbursements user category */
  reimbursementsUserCategory?: Maybe<UserCategory>;
  /** Default rewards GL account */
  rewardsIncomeUserCategory?: Maybe<UserCategory>;
}

export interface IntacctClass {
  isInactive?: Maybe<Scalars["Boolean"]>;
  name?: Maybe<Scalars["String"]>;
}

export interface IntacctCustom {
  isInactive?: Maybe<Scalars["Boolean"]>;
  name?: Maybe<Scalars["String"]>;
}

export interface IntacctCustomer {
  isInactive?: Maybe<Scalars["Boolean"]>;
  name?: Maybe<Scalars["String"]>;
}

export interface IntacctDepartment {
  isInactive?: Maybe<Scalars["Boolean"]>;
  name?: Maybe<Scalars["String"]>;
}

export interface IntacctLocation {
  isInactive?: Maybe<Scalars["Boolean"]>;
  name?: Maybe<Scalars["String"]>;
}

export interface IntacctVendor {
  isInactive?: Maybe<Scalars["Boolean"]>;
  name?: Maybe<Scalars["String"]>;
}

export interface IntegerIntervalInput {
  /** Exclusive */
  maxAmount?: InputMaybe<Scalars["Int"]>;
  /** Inclusive */
  minAmount?: InputMaybe<Scalars["Int"]>;
}

export interface IntegerRangeInput {
  maxAmount?: InputMaybe<Scalars["Int"]>;
  minAmount?: InputMaybe<Scalars["Int"]>;
}

/** DEPRECATED for 1B-enabled accounts. Migration by ERP is in progress. See go/accounting-devex for more info. */
export interface Integration extends Node {
  accountCategories?: Maybe<AccountCategories>;
  /** The capabilities of the integration */
  capabilities?: Maybe<Array<VendorCapabilities>>;
  createdAt?: Maybe<Scalars["Time"]>;
  credential?: Maybe<Credential>;
  /** List of default integration entities. */
  defaultIntegrationEntities?: Maybe<DefaultIntegrationEntityConnection>;
  /** Version of ERP subscription the integration corresponds to. */
  erpSubscriptionDetail?: Maybe<ErpSubscriptionDetail>;
  /** List of subsidiaries associated with this integration. */
  erpSubsidiaries?: Maybe<ErpSubsidiaryConnection>;
  errorDetails?: Maybe<Array<Maybe<IntegrationErrorDetails>>>;
  exports?: Maybe<ExportConnection>;
  /** The ID of an object */
  id: Scalars["ID"];
  /** List of available integration entities. Searchable by prefix and integration field */
  integrationEntities?: Maybe<ExternalIntegrationEntityConnection>;
  /** List of available mappable integration fields for an integration */
  integrationFields?: Maybe<ExternalIntegrationFieldConnection>;
  integrationRules?: Maybe<IntegrationRuleConnection>;
  /** Ledger type */
  ledgerType?: Maybe<Scalars["String"]>;
  refreshedAt?: Maybe<Scalars["Time"]>;
  scopes?: Maybe<Array<Maybe<IntegrationScope>>>;
  settings?: Maybe<IntegrationSettings>;
  setupInstructions?: Maybe<SetupInstructions>;
  status?: Maybe<Scalars["String"]>;
  /** Current state of the user's ERP subscription status. */
  subscriptionStatus?: Maybe<Scalars["String"]>;
  userCategories?: Maybe<UserCategoryConnection>;
  vendor?: Maybe<Scalars["String"]>;
}

/** DEPRECATED for 1B-enabled accounts. Migration by ERP is in progress. See go/accounting-devex for more info. */
export interface IntegrationdefaultIntegrationEntitiesArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

/** DEPRECATED for 1B-enabled accounts. Migration by ERP is in progress. See go/accounting-devex for more info. */
export interface IntegrationerpSubsidiariesArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

/** DEPRECATED for 1B-enabled accounts. Migration by ERP is in progress. See go/accounting-devex for more info. */
export interface IntegrationexportsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

/** DEPRECATED for 1B-enabled accounts. Migration by ERP is in progress. See go/accounting-devex for more info. */
export interface IntegrationintegrationEntitiesArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  entityType?: InputMaybe<Scalars["String"]>;
  fieldId?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  filterDeleted?: InputMaybe<Scalars["Boolean"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  query?: InputMaybe<Scalars["String"]>;
}

/** DEPRECATED for 1B-enabled accounts. Migration by ERP is in progress. See go/accounting-devex for more info. */
export interface IntegrationintegrationFieldsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  lastUpdatedAt?: InputMaybe<Scalars["Boolean"]>;
  totalEntityCount?: InputMaybe<Scalars["Boolean"]>;
}

/** DEPRECATED for 1B-enabled accounts. Migration by ERP is in progress. See go/accounting-devex for more info. */
export interface IntegrationintegrationRulesArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  query?: InputMaybe<Scalars["String"]>;
  ruleBodyEnriched?: InputMaybe<Scalars["Boolean"]>;
  type?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
}

/** DEPRECATED for 1B-enabled accounts. Migration by ERP is in progress. See go/accounting-devex for more info. */
export interface IntegrationuserCategoriesArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  lastUpdatedAt?: InputMaybe<Scalars["Boolean"]>;
  query?: InputMaybe<Scalars["String"]>;
}

export enum IntegrationCapability {
  /** Can do accrual accounting */
  ACCRUAL_ACCOUNTING = "ACCRUAL_ACCOUNTING",
  /** Can automatically create vendors for expenses. */
  AUTO_CREATE_VENDORS_FOR_EXPENSES = "AUTO_CREATE_VENDORS_FOR_EXPENSES",
  /** Can enable auto refresh for all fields via the integration settings */
  AUTO_ERP_REFRESH_BASIC = "AUTO_ERP_REFRESH_BASIC",
  /** Can enable auto refresh per field on integration settings */
  AUTO_ERP_REFRESH_FIELDS = "AUTO_ERP_REFRESH_FIELDS",
  /** Can auto export vendors on creation. */
  AUTO_EXPORT_VENDORS = "AUTO_EXPORT_VENDORS",
  /** Can auto sync bills, vendors, GL accounts, and payments. */
  AUTO_SYNC_BILLS = "AUTO_SYNC_BILLS",
  /** Can auto sync invoices and customers. */
  AUTO_SYNC_INVOICES = "AUTO_SYNC_INVOICES",
  /** Sync transactions from Xero and QBO integrations. */
  BANK_FEED_SYNC = "BANK_FEED_SYNC",
  /** Can direct sync to ERP */
  DIRECT_EXPORT = "DIRECT_EXPORT",
  /** Can export accrual-accounting reimbursements (approval + payment) */
  EXPORT_ACCRUAL_ACCOUNTING_FOR_REIMBURSEMENTS = "EXPORT_ACCRUAL_ACCOUNTING_FOR_REIMBURSEMENTS",
  /** Can configure and export card expenses as credit card transactions. */
  EXPORT_CARD_EXPENSE_AS_CREDIT_CARD_TRANSACTION = "EXPORT_CARD_EXPENSE_AS_CREDIT_CARD_TRANSACTION",
  /** Can configure and export credit cards as vendor bills. */
  EXPORT_CARD_TRANSACTION_AS_VENDOR_BILLS = "EXPORT_CARD_TRANSACTION_AS_VENDOR_BILLS",
  /** Can configure and export reimbursements as vendor bills. */
  EXPORT_REIMBURSEMENTS_AS_VENDOR_BILLS = "EXPORT_REIMBURSEMENTS_AS_VENDOR_BILLS",
  /** Can export repayment expenses (reimbursement + card) */
  EXPORT_REPAYMENTS = "EXPORT_REPAYMENTS",
  /** Can do bill matching. */
  IMPORT_PURCHASE_ORDERS = "IMPORT_PURCHASE_ORDERS",
  /** Can change the grouping cadence of journal entries. */
  JOURNAL_ENTRIES_BATCHING = "JOURNAL_ENTRIES_BATCHING",
  /** Can pull in multiple ERP entities (e.g. multiple Netsuite subsidiaries) and perform various actions with them (e.g. GL account mappings on a subsidiary level) */
  MULTIPLE_ERP_ENTITIES = "MULTIPLE_ERP_ENTITIES",
  /**
   * Supports basic multi-entity use cases where the parent entity is billed for all expenses.
   * Does not handle complex cases like child-to-child or parent-to-child billing.
   * A company may have multiple spending Brex entities but only one entity (subsidiary) in the ERP
   */
  MULTI_ENTITY_BASIC = "MULTI_ENTITY_BASIC",
  /** Can handle child billing entity for card expenses */
  MULTI_ENTITY_CARD_CHILD_BILLING = "MULTI_ENTITY_CARD_CHILD_BILLING",
  /** Can handle child billing entity for reimbursement expenses */
  MULTI_ENTITY_REIMBURSEMENT_CHILD_BILLING = "MULTI_ENTITY_REIMBURSEMENT_CHILD_BILLING",
  /** Can map field to be exported as the Name field. */
  NAME_FIELD_TARGETING = "NAME_FIELD_TARGETING",
  /** Can import and export basic VAT tax codes for expenses */
  VAT_BASIC = "VAT_BASIC",
}

export interface IntegrationConnection {
  edges?: Maybe<Array<Maybe<IntegrationEdge>>>;
  pageInfo: PageInfo;
}

export interface IntegrationEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<Integration>;
}

/** Information about entities involved in the integration */
export interface IntegrationEntityInfo {
  /** The billing entity used for the integration */
  integrationBillingEntityName?: Maybe<Scalars["String"]>;
  /** The external ID used in the integration system */
  integrationExternalId?: Maybe<Scalars["String"]>;
  /** The spending entity used for the integration */
  integrationSpendingEntityName?: Maybe<Scalars["String"]>;
}

/** Integration error object that gets consumed by graphql */
export interface IntegrationErrorDetails extends Node {
  /** The error message on the integration for display to user */
  errorDisplayMessage?: Maybe<Scalars["String"]>;
  /** The error message on the integration  */
  errorMessage?: Maybe<Scalars["String"]>;
  /** The type of error that occurred */
  errorSubtype?: Maybe<Scalars["String"]>;
  /** Currently error_type is either refresh_error or export_error */
  errorType: Scalars["String"];
  /** The ID of an object */
  id: Scalars["ID"];
  /** Informs if the error is coming from vendor or not */
  isVendorError?: Maybe<Scalars["Boolean"]>;
  /** The name of the erp that the integration is connected */
  vendorName?: Maybe<Scalars["String"]>;
}

export type IntegrationExtendedFieldExtension =
  | NetsuiteIntegrationExtendedFieldExtension
  | OracleFusionIntegrationExtendedFieldExtension
  | SageIntacctIntegrationExtendedFieldExtension;

/** A integration field is a mapping from an integration field to an integration entity. */
export interface IntegrationField extends Node {
  externalIntegrationEntity?: Maybe<ExternalIntegrationEntity>;
  externalIntegrationField?: Maybe<ExternalIntegrationField>;
  fieldId?: Maybe<Scalars["String"]>;
  fieldValue?: Maybe<Scalars["String"]>;
  /** The ID of an object */
  id: Scalars["ID"];
}

export interface IntegrationFieldInput {
  /** Required field, external integration field ID. */
  fieldId: Scalars["ID"];
  /** Required field, external integration entity ID. */
  fieldValue: Scalars["ID"];
}

export interface IntegrationFieldOptionExtension {
  amortizationType?: Maybe<Scalars["String"]>;
  parentOptionIdentifierId?: Maybe<Scalars["String"]>;
  vendorInternalId: Scalars["String"];
}

export interface IntegrationFieldOptionExtensionInput {
  parentOptionIdentifierId?: InputMaybe<Scalars["String"]>;
  vendorInternalId: Scalars["String"];
}

/** Default set of integration field types */
export enum IntegrationFieldType {
  CLASS = "CLASS",
  CODAT_TRACKING_CATEGORY = "CODAT_TRACKING_CATEGORY",
  CUSTOM = "CUSTOM",
  CUSTOMER = "CUSTOMER",
  DEPARTMENT = "DEPARTMENT",
  EMPLOYEE = "EMPLOYEE",
  INTACCT_CLASS = "INTACCT_CLASS",
  INTACCT_CUSTOM = "INTACCT_CUSTOM",
  INTACCT_CUSTOMER = "INTACCT_CUSTOMER",
  INTACCT_DEPARTMENT = "INTACCT_DEPARTMENT",
  INTACCT_LOCATION = "INTACCT_LOCATION",
  INTACCT_PROJECT = "INTACCT_PROJECT",
  INTACCT_VENDOR = "INTACCT_VENDOR",
  LOCATION = "LOCATION",
  NETSUITE_CLASS = "NETSUITE_CLASS",
  NETSUITE_CUSTOM = "NETSUITE_CUSTOM",
  NETSUITE_CUSTOMER = "NETSUITE_CUSTOMER",
  NETSUITE_DEPARTMENT = "NETSUITE_DEPARTMENT",
  NETSUITE_LOCATION = "NETSUITE_LOCATION",
  NETSUITE_PROJECT = "NETSUITE_PROJECT",
  NETSUITE_SEGMENT = "NETSUITE_SEGMENT",
  NETSUITE_TAX_CODE = "NETSUITE_TAX_CODE",
  NETSUITE_VENDOR = "NETSUITE_VENDOR",
  PROJECT = "PROJECT",
  QBD_CLASS = "QBD_CLASS",
  QBD_CUSTOMER = "QBD_CUSTOMER",
  QUICKBOOKS_CLASS = "QUICKBOOKS_CLASS",
  QUICKBOOKS_CUSTOMER = "QUICKBOOKS_CUSTOMER",
  QUICKBOOKS_LOCATION = "QUICKBOOKS_LOCATION",
  QUICKBOOKS_VENDOR = "QUICKBOOKS_VENDOR",
  SUBSIDIARY = "SUBSIDIARY",
  VENDOR = "VENDOR",
  XERO_TRACKING_CATEGORY = "XERO_TRACKING_CATEGORY",
}

/** Information about GL accounts used in the integration */
export interface IntegrationGLAccountInfo {
  /** The fully qualified name of the credit line category */
  creditLineCategoryFullyQualifiedName?: Maybe<Scalars["String"]>;
  /** The credit line category used for the integration */
  creditLineCategoryName?: Maybe<Scalars["String"]>;
  /** The fully qualified name of the debit line category */
  debitLineCategoryFullyQualifiedName?: Maybe<Scalars["String"]>;
  /** The debit line category used for the integration */
  debitLineCategoryName?: Maybe<Scalars["String"]>;
}

export interface IntegrationInput {
  /**
   * Optional field, billable status.
   *
   * One or more of these fields (integrationField, userCategoryId, billableStatus and subsidiaryId) must be set.
   */
  billableStatus?: InputMaybe<Scalars["Boolean"]>;
  /**
   * Optional field, integration fields.
   *
   * One or more of these fields (integrationField, userCategoryId, billableStatus and subsidiaryId) must be set.
   */
  integrationFields?: InputMaybe<Array<IntegrationFieldInput>>;
  /**
   * Optional field, subsidiary ID.
   *
   * One or more of these fields (integrationField, userCategoryId, billableStatus and subsidiaryId) must be set.
   */
  subsidiaryId?: InputMaybe<Scalars["ID"]>;
  /**
   * Optional field, user category ID.
   *
   * One or more of these fields(integrationField, userCategoryId, billableStatus and subsidiaryId) must be set.
   */
  userCategoryId?: InputMaybe<Scalars["ID"]>;
}

export interface IntegrationPartner {
  cardPartnerFeedRules?: Maybe<CardPartnerFeedRuleConnection>;
  id: Scalars["ID"];
  name: Scalars["String"];
  shortName?: Maybe<Scalars["String"]>;
}

export interface IntegrationPartnercardPartnerFeedRulesArgs {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
}

export interface IntegrationPartnerConnection extends Connection {
  edges: Array<IntegrationPartnerEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface IntegrationPartnerEdge {
  cursor?: Maybe<Scalars["String"]>;
  node: IntegrationPartner;
}

export interface IntegrationRule extends Node {
  body?: Maybe<Scalars["Json"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
  priority?: Maybe<Scalars["Int"]>;
  type?: Maybe<Scalars["String"]>;
  /** The time the integration rule was last updated */
  updatedAt?: Maybe<Scalars["Time"]>;
}

export interface IntegrationRuleConnection {
  edges?: Maybe<Array<Maybe<IntegrationRuleEdge>>>;
  pageInfo: PageInfo;
}

export interface IntegrationRuleEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<IntegrationRule>;
}

export interface IntegrationRuleEvaluation extends Node {
  /** The ID of an object */
  id: Scalars["ID"];
  key?: Maybe<Scalars["String"]>;
  rule?: Maybe<IntegrationRule>;
  value?: Maybe<Scalars["String"]>;
}

/** Filter facet for integration rules (only used for statement entries) */
export interface IntegrationRulesFilterFacet extends Node {
  /** The ID of an object */
  id: Scalars["ID"];
  /** A list of rules matches this filter facet type (only returned by unexported_statement_entry_filter_facets) */
  rules?: Maybe<Array<Maybe<IntegrationRule>>>;
  /** Filter facet type */
  type?: Maybe<IntegrationRulesFilterFacetType>;
}

export enum IntegrationRulesFilterFacetType {
  CONFLICTING = "CONFLICTING",
  CUSTOM = "CUSTOM",
  MERCHANT = "MERCHANT",
  OVERRIDE = "OVERRIDE",
}

export enum IntegrationScope {
  COLLECTIONS = "COLLECTIONS",
  EXPENSES = "EXPENSES",
  REWARDS_REDEMPTIONS = "REWARDS_REDEMPTIONS",
}

export enum IntegrationSettingErrorType {
  MISSING_LEDGER_NAME = "MISSING_LEDGER_NAME",
}

export interface IntegrationSettings {
  batchSettings?: Maybe<BatchSettings>;
  billsEnabled?: Maybe<Scalars["Boolean"]>;
  expensesEnabled?: Maybe<Scalars["Boolean"]>;
  netsuiteSubsidiary?: Maybe<NetsuiteSubsidiary>;
  /** Auto sync reimbursement data to netsuite */
  reimbursementsEnabled?: Maybe<Scalars["Boolean"]>;
  syncDateRangeEnd?: Maybe<Scalars["Time"]>;
  syncDateRangeStart?: Maybe<Scalars["Time"]>;
  syncFrom?: Maybe<Scalars["Time"]>;
  transactionExportType?: Maybe<TransactionExportType>;
  version?: Maybe<Scalars["Int"]>;
}

export enum IntegrationVendor {
  EXPENSIFY = "EXPENSIFY",
  INTACCT = "INTACCT",
  INVALID = "INVALID",
  NETSUITE = "NETSUITE",
  ORACLE_FUSION = "ORACLE_FUSION",
  QUICKBOOKS_DESKTOP = "QUICKBOOKS_DESKTOP",
  QUICKBOOKS_ONLINE = "QUICKBOOKS_ONLINE",
  SAGE_INTACCT = "SAGE_INTACCT",
  TEST = "TEST",
  UNIVERSAL_CSV = "UNIVERSAL_CSV",
  WORKDAY = "WORKDAY",
  XERO = "XERO",
}

export enum IntentType {
  BANKING_SCOPED_SEARCH = "BANKING_SCOPED_SEARCH",
  BUDGET = "BUDGET",
  CARD = "CARD",
  EXPENSE_SCOPED_SEARCH = "EXPENSE_SCOPED_SEARCH",
  HELP_CENTER = "HELP_CENTER",
  LIMIT_GROUP = "LIMIT_GROUP",
  NAVIGATION = "NAVIGATION",
  USER = "USER",
  VENDOR = "VENDOR",
}

export interface InterestDetails {
  paidOn?: Maybe<Scalars["Time"]>;
}

export interface IntermediaryBank {
  city: Scalars["String"];
  name: Scalars["String"];
  state: Scalars["String"];
  street: Scalars["String"];
  swiftCode: Scalars["String"];
  zip: Scalars["String"];
}

/** Brex Support (eg internal users in retool) */
export interface InternalActor extends Displayable {
  displayName: Scalars["String"];
}

export interface InternalAttendeeInput {
  /** Customer user ID of the attendee */
  customerUserId: Scalars["ID"];
}

export interface InternalAttendeeSuggestion extends AttendeeSuggestion {
  confidenceLevel: SuggestionConfidenceLevel;
  user: User;
}

export interface InternalEntitySyncError extends Node {
  bill?: Maybe<Bill>;
  errorMessage?: Maybe<Scalars["String"]>;
  errorType?: Maybe<Scalars["String"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  idempotencyKey?: Maybe<Scalars["String"]>;
  insertedAt?: Maybe<Scalars["Time"]>;
  operation?: Maybe<Scalars["String"]>;
  rawResponse?: Maybe<Scalars["Json"]>;
  requestPayload?: Maybe<Scalars["Json"]>;
  status: InternalEntitySyncStatus;
  updatedAt?: Maybe<Scalars["Time"]>;
}

export interface InternalEntitySyncErrorConnection {
  edges?: Maybe<Array<Maybe<InternalEntitySyncErrorEdge>>>;
  pageInfo: PageInfo;
}

export interface InternalEntitySyncErrorEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<InternalEntitySyncError>;
}

export enum InternalEntitySyncStatus {
  ERROR = "ERROR",
  PENDING = "PENDING",
}

export interface InternalError {
  message: Scalars["String"];
}

export interface InternalExpenseAttendee {
  user: User;
}

/** Internally initiated by a Brex employee */
export interface InternalInitiated {
  /** A placeholder always true field to make the object queryable */
  internal?: Maybe<Scalars["Boolean"]>;
}

export interface InternalInitiatedBilling {
  internal?: Maybe<Scalars["Boolean"]>;
}

/** Type of internal transfer */
export enum InternalTransferType {
  COLLECTION = "COLLECTION",
  RECEIVABLES_OFFERS_COLLECTION = "RECEIVABLES_OFFERS_COLLECTION",
  RECEIVABLES_OFFERS_REPAYMENT = "RECEIVABLES_OFFERS_REPAYMENT",
}

/** Represents international bank information. */
export interface InternationalBankInformation {
  /** The address of the bank. */
  address: Address;
  /** The name of the bank. */
  name?: Maybe<Scalars["String"]>;
  /** The abbreviated name of the bank. */
  nameAbbrev?: Maybe<Scalars["String"]>;
  /** List of possible issues with the bank. */
  possibleIssues: Array<Scalars["String"]>;
}

export interface InternationalWireConfig {
  countryConfigs: Array<InternationalWireCountryConfig>;
  deprecatedInputFields: Array<InternationalWireInputField>;
  highRiskInputFields: Array<InternationalWireInputField>;
}

export interface InternationalWireCountryConfig {
  addressRequiresZipCode: Scalars["Boolean"];
  /** The associated country object for this country, useful for retrieving the default currency */
  country: Country;
  countryCodeAlpha2: Scalars["String"];
  countryName: Scalars["String"];
  iban: Scalars["Boolean"];
  inputFields: Array<InternationalWireInputField>;
  /** Indicates if beneficiary bank address is required or not */
  isBeneficiaryBankAddressRequired: Scalars["Boolean"];
  isHighRisk: Scalars["Boolean"];
  recipientTypes?: Maybe<Array<RecipientType>>;
}

export interface InternationalWireInputField {
  displayName: Scalars["String"];
  dropdownOptions?: Maybe<Array<Maybe<InternationalWireOption>>>;
  forRecipientTypes?: Maybe<Array<RecipientType>>;
  format?: Maybe<Scalars["String"]>;
  maxLength: Scalars["Int"];
  minLength: Scalars["Int"];
  name: Scalars["String"];
  /** This input field is optional if this value is true, and required if this value is nil/false. */
  optional: Scalars["Boolean"];
  requiredPerTransaction: Scalars["Boolean"];
  tooltip?: Maybe<Scalars["String"]>;
  type: InputType;
}

/** Object representing an option in a dropdown */
export interface InternationalWireOption {
  /** The display name of the option */
  displayName: Scalars["String"];
  /** The display subtext of the option */
  displaySubtext?: Maybe<Scalars["String"]>;
  /** A list of associated options */
  subOptions?: Maybe<InternationalWireInputField>;
  /** The internal value of the option */
  value: Scalars["String"];
}

export interface InternationalWirePaymentInstrument {
  address?: Maybe<Address>;
  beneficiaryBankAddress?: Maybe<Address>;
  beneficiaryBankInfo?: Maybe<Scalars["Json"]>;
  beneficiaryBankName?: Maybe<Scalars["String"]>;
  counterparty?: Maybe<BankingCounterparty>;
  iban?: Maybe<Scalars["String"]>;
  swiftCode?: Maybe<Scalars["String"]>;
}

export interface InternationalWirePaymentInstrumentFindInput {
  iban: Scalars["String"];
  swiftCode: Scalars["String"];
}

export interface InternationalWirePaymentInstrumentInput {
  address: AddressInput;
  beneficiaryBankAddress?: InputMaybe<AddressInput>;
  beneficiaryBankInfo?: InputMaybe<Scalars["Json"]>;
  beneficiaryBankName?: InputMaybe<Scalars["String"]>;
  iban: Scalars["String"];
  swiftCode: Scalars["String"];
}

export interface InternationalWireTransferDetails {
  mt103?: Maybe<Scalars["String"]>;
  returnDetails?: Maybe<ReturnDetails>;
  trackingNumber?: Maybe<Scalars["String"]>;
  uetr?: Maybe<Scalars["String"]>;
}

export interface IntraCustomerAccountBookTransferDetails {
  initiatedByCustomerUser?: Maybe<User>;
  sourceDepositsAccount?: Maybe<DepositsAccount>;
  targetDepositsAccount?: Maybe<DepositsAccount>;
}

export interface InvalidArgumentError
  extends StandardClientError,
    UpsertExpensePolicySpecErrors {
  code: ErrorCode;
  errorCode?: Maybe<UpsertExpensePolicySpecErrorCode>;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface InvalidIntegrationSettings {
  errors?: Maybe<Array<IntegrationSettingErrorType>>;
  settings?: Maybe<AccountingIntegrationSettings>;
}

export interface InvalidSubsidiarySettings {
  errors?: Maybe<Array<SubsidiarySettingErrorType>>;
  settings: AccountingIntegrationSubsidiarySettings;
}

export interface InvestmentPolicyBreakdown {
  amount: Scalars["Int"];
  investmentType: InvestmentType;
  isOperative: Scalars["Boolean"];
}

/**  From here https://github.com/brexhq/credit_card/blob/447fdb08bfa2c196ce0d08043e612f4cfc41d358/apps/api/lib/api/components/customer/schemas/account.ex#L642 */
export enum InvestmentSource {
  ANGEL_INVESTMENT = "ANGEL_INVESTMENT",
  BUSINESS_REVENUE = "BUSINESS_REVENUE",
  CROWDSOURCED = "CROWDSOURCED",
  FAMILY = "FAMILY",
  GRANTS = "GRANTS",
  INITIAL_COIN_OFFERING = "INITIAL_COIN_OFFERING",
  LOAN_FUNDING = "LOAN_FUNDING",
  PARENT_COMPANY = "PARENT_COMPANY",
  PRIVATE_EQUITY = "PRIVATE_EQUITY",
  PROFESSIONAL_INVESTOR = "PROFESSIONAL_INVESTOR",
  SELF_FUNDED = "SELF_FUNDED",
  VC = "VC",
  VENTURE_ACCELERATOR_GROWTH = "VENTURE_ACCELERATOR_GROWTH",
}

export enum InvestmentType {
  CASH = "CASH",
  PERCENTAGE_MMF = "PERCENTAGE_MMF",
  TARGET_CASH_IN_CENTS = "TARGET_CASH_IN_CENTS",
  TARGET_MMF_IN_CENTS = "TARGET_MMF_IN_CENTS",
}

export interface Invite {
  /** Accessibility requirements */
  accessibilityRequirements?: Maybe<Scalars["String"]>;
  /** When the invite was sent */
  createdOnDate: Scalars["Date"];
  /** Reason for not attending */
  declineReason?: Maybe<Scalars["String"]>;
  /** Dietary restrictions */
  dietaryRestrictions?: Maybe<Scalars["String"]>;
  /** Event this invite is for */
  groupEvent: GroupEvent;
  /** Invite ID */
  id: Scalars["ID"];
  /** Whether the invitee needs a car */
  needsCar: Scalars["Boolean"];
  /** Whether the invitee needs a flight */
  needsFlight: Scalars["Boolean"];
  /** Whether the invitee needs a hotel */
  needsHotel: Scalars["Boolean"];
  /** Whether the invitee needs rail */
  needsRail: Scalars["Boolean"];
  /** Invite status */
  status: InviteStatus;
  /** Trip associated with this group event */
  trip?: Maybe<TravelTrip>;
}

export interface InviteConnection extends Connection {
  edges: Array<Maybe<InviteEdge>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface InviteEdge {
  cursor?: Maybe<Scalars["String"]>;
  node: Invite;
}

export enum InviteStatus {
  ATTENDING = "ATTENDING",
  CANCELED = "CANCELED",
  EXPIRED = "EXPIRED",
  NOT_ATTENDING = "NOT_ATTENDING",
  PENDING = "PENDING",
}

export interface InviteVendorInput {
  clientMutationId: Scalars["String"];
  vendorId: Scalars["ID"];
}

export interface InviteVendorResult extends MutationResult {
  errors?: Maybe<Array<VendorMutationError>>;
  result?: Maybe<VendorDetails>;
}

export interface InvitesFilterInput {
  statuses?: InputMaybe<Array<InviteStatus>>;
}

export interface Invoice {
  /** ACH routing number */
  achRoutingNumber?: Maybe<Scalars["String"]>;
  /** Amount */
  amount: FinancialAsset;
  /** Bank account number */
  bankAccountNumber?: Maybe<Scalars["String"]>;
  /** Credit memo amount */
  creditMemoAmount?: Maybe<FinancialAsset>;
  /** Invoice due date */
  dueDate?: Maybe<Scalars["Time"]>;
  /** Billing period end date */
  endDate?: Maybe<Scalars["Time"]>;
  /** Invoice Id */
  id: Scalars["String"];
  /** Netsuite Invoice Id */
  invoiceId: Scalars["String"];
  /** Invoice number */
  invoiceNumber?: Maybe<Scalars["String"]>;
  /** Invoice issued date */
  issuedDate?: Maybe<Scalars["Date"]>;
  /** Invoice line items V2 */
  lineItemsV2?: Maybe<Array<LineItemPair>>;
  /** Invoice payment date */
  paymentDate?: Maybe<Scalars["Date"]>;
  /** Invoice pdf url */
  pdfUrl?: Maybe<Scalars["String"]>;
  /** Enum on whether we auto pull */
  pullPaymentEligibility?: Maybe<PullPaymentEligibility>;
  /** Billing period start date */
  startDate?: Maybe<Scalars["Time"]>;
  /** Payment Status */
  status?: Maybe<InvoicePaymentStatus>;
  /** Wire transfer swift code */
  swiftCode?: Maybe<Scalars["String"]>;
  /** Tax amount */
  taxAmount?: Maybe<FinancialAsset>;
  /** Address for wire transfer */
  wireAddress?: Maybe<Scalars["String"]>;
  /** Wire transfer routing number */
  wireRoutingNumber?: Maybe<Scalars["String"]>;
}

export interface InvoiceAccountSubmitPupInput {
  /**
   * Expected monthly invoicing transaction volume
   * Current buckets are: $0-100K, $100K-500K, $500K-1M, $1M+
   */
  expectedVolume: TransactionAmountRange;
  /** InvoiceAccountId */
  invoiceAccountId: Scalars["String"];
}

export interface InvoiceAmountRangeInput {
  max?: InputMaybe<FinancialAssetInput>;
  min?: InputMaybe<FinancialAssetInput>;
}

export interface InvoiceConnectExternalBankAccountInput {
  /** A unique idempotency key. */
  clientMutationId: Scalars["String"];
  /** ID of the invoice to the external bank account is being connected to. */
  invoiceId: Scalars["ID"];
  /** Plaid public token needed to exchange account details by RAD */
  plaidPublicToken: Scalars["String"];
}

export interface InvoiceConnectExternalBankAccountResult
  extends MutationResult {
  errors?: Maybe<Array<InvoicingV1ClientError>>;
  result?: Maybe<RailAccountDetails>;
}

/** An InvoiceConnection for Invoice pagination. */
export interface InvoiceConnection extends Connection {
  /** The invoices in the current page of results. */
  edges: Array<InvoiceEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of invoices matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface InvoiceDiscountV1OneOf {
  /** Absolute discount amount applied to the whole invoice. */
  discountAmount?: Maybe<FinancialAsset>;
  /** Discount percentage applied to the whole invoice. Range [0, 100] */
  discountPercent?: Maybe<Scalars["Float"]>;
}

export interface InvoiceDiscountV1OneOfInput {
  /** Absolute discount amount applied to the whole invoice. */
  discountAmount?: InputMaybe<FinancialAssetInput>;
  /** Discount percentage applied to the whole invoice. Range [0, 100] */
  discountPercent?: InputMaybe<Scalars["Float"]>;
}

/** An Invoice edge for the Invoice connection. */
export interface InvoiceEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The Invoice at this edge. */
  node?: Maybe<Invoice>;
}

/** A rectangular region that encloses an object within an invoice file (PDF, image, etc) */
export interface InvoiceFieldCoordinates {
  /** Defines how the calculate the points (X1, Y1), (X1, Y2), (X2, Y1), (X2, Y2) */
  coordinateType?: Maybe<FieldCoordinateType>;
  /** The right X coordinate. */
  maxX?: Maybe<Scalars["Float"]>;
  /** The lower Y coordinate. */
  maxY?: Maybe<Scalars["Float"]>;
  /** The left X coordinate. */
  minX?: Maybe<Scalars["Float"]>;
  /** The upper Y coordinate. */
  minY?: Maybe<Scalars["Float"]>;
  /** The page number from where the field was extracted. */
  page?: Maybe<Scalars["Int"]>;
}

export enum InvoiceItemType {
  PHYSICAL_GOOD = "PHYSICAL_GOOD",
  SERVICE = "SERVICE",
}

export interface InvoiceLineItem {
  /** Description item. e.g. product / service. */
  description: Scalars["String"];
  /** Quantity of the description item. */
  quantity: Scalars["Int"];
  /** Total amount of the line item */
  totalAmount: FinancialAsset;
  /** Unit price of the description item. */
  unitPrice: FinancialAsset;
}

export interface InvoiceLineItemInput {
  /** Description item. e.g. product / service. */
  description: Scalars["String"];
  /** Quantity of the description item. */
  quantity: Scalars["Int"];
  /** Subtotal of the line item. */
  subtotal?: InputMaybe<FinancialAssetInput>;
  /** Total Amount of the line item */
  totalAmount?: InputMaybe<FinancialAssetInput>;
  /** Unit price of the description item. */
  unitPrice: FinancialAssetInput;
}

export interface InvoiceLineItemV1 {
  /** Description of the item. e.g. product / service. */
  description: Scalars["String"];
  /** Reference to the Item from expenses service */
  item?: Maybe<Item>;
  /** Item type. e.g. physical good or service */
  itemType?: Maybe<InvoiceItemType>;
  /** Quantity of the description item. */
  quantity?: Maybe<Scalars["Float"]>;
  /** Unit price of the description item. */
  unitPrice: FinancialAsset;
}

export interface InvoiceLineItemV1Input {
  /** Description of the item. e.g. product / service. */
  description: Scalars["String"];
  /** Extended field values for the item (e.g. GL account) */
  extendedFieldValues?: InputMaybe<Array<ExtendedFieldValueInput>>;
  /** ID of the item. */
  itemId?: InputMaybe<Scalars["ID"]>;
  /** Type of the item (e.g. physical good or service) */
  itemType?: InputMaybe<InvoiceItemType>;
  /** Quantity of the description item. */
  quantity: Scalars["Float"];
  /** Unit price of the description item. */
  unitPrice: FinancialAssetInput;
}

/**  | ... more */
export interface InvoiceNumber {
  id: Scalars["ID"];
  /** The invoice number value */
  invoiceNumber: Scalars["String"];
}

export interface InvoiceOcrFieldMetadata {
  /** A measure of how confident the OCR provider is in the accuracy of the recognized text. */
  confidenceScore?: Maybe<Scalars["Float"]>;
  /** The field coordinates where it was extracted from the invoice document. */
  coordinates?: Maybe<InvoiceFieldCoordinates>;
}

export interface InvoicePaymentInstructionsV1 {
  accountNumber?: Maybe<Scalars["String"]>;
  bankAddress: InvoicingAddressV1;
  bankName: Scalars["String"];
  intermediaryBankAddress: InvoicingAddressV1;
  intermediaryBankName: Scalars["String"];
  intermediaryBankSwiftCode: Scalars["String"];
  referenceCode: Scalars["String"];
  routingNumber?: Maybe<Scalars["String"]>;
  swiftABACode?: Maybe<Scalars["String"]>;
  swiftCode: Scalars["String"];
}

export enum InvoicePaymentMethodV1 {
  INTERNATIONAL_WIRE = "INTERNATIONAL_WIRE",
  US_BANK_TRANSFER = "US_BANK_TRANSFER",
}

export enum InvoicePaymentStatus {
  CANCELLED = "CANCELLED",
  PAID = "PAID",
  PAYMENT_DUE = "PAYMENT_DUE",
  PAYMENT_IN_PROGRESS = "PAYMENT_IN_PROGRESS",
  REJECTED = "REJECTED",
}

export interface InvoiceProcessingInput {
  /** The invoice asset id */
  invoiceAssetId?: InputMaybe<Scalars["ID"]>;
  /** Where the invoice processing was originated from */
  origin?: InputMaybe<InvoiceProcessingOrigin>;
}

export enum InvoiceProcessingOrigin {
  BILL_FORM = "BILL_FORM",
  BULK_INVOICE_UPLOAD = "BULK_INVOICE_UPLOAD",
}

export interface InvoiceProcessingResponse extends MutationResult {
  errors?: Maybe<Array<BillMutationError>>;
  result?: Maybe<Scalars["ID"]>;
}

export interface InvoiceReminder {
  sendDate: Scalars["Date"];
  type: InvoiceReminderType;
}

export enum InvoiceReminderType {
  AFTER_DUE_1_DAY = "AFTER_DUE_1_DAY",
  AFTER_DUE_7_DAYS = "AFTER_DUE_7_DAYS",
  AFTER_DUE_14_DAYS = "AFTER_DUE_14_DAYS",
  AFTER_DUE_30_DAYS = "AFTER_DUE_30_DAYS",
  BEFORE_DUE_1_DAY = "BEFORE_DUE_1_DAY",
}

export enum InvoiceStatus {
  AUTOMATED_MATCH_PAID = "AUTOMATED_MATCH_PAID",
  AUTOMATED_MATCH_PARTIALLY_PAID = "AUTOMATED_MATCH_PARTIALLY_PAID",
  AWAITING_PAYMENT = "AWAITING_PAYMENT",
  DELETED = "DELETED",
  DRAFTING = "DRAFTING",
  INVALID = "INVALID",
  PAID = "PAID",
  PARTIALLY_PAID = "PARTIALLY_PAID",
  PAYMENT_SCHEDULED = "PAYMENT_SCHEDULED",
  SCHEDULED = "SCHEDULED",
  UNCOLLECTIBLE = "UNCOLLECTIBLE",
  VOIDED = "VOIDED",
}

export interface InvoiceStatusLog {
  /** inserted_at timestamp */
  insertedAt: Scalars["Time"];
  /** Note about this change log. */
  note?: Maybe<Scalars["String"]>;
  /** Invoice status. */
  status: InvoiceStatus;
  /** Updated by */
  updatedBy: Scalars["String"];
}

export enum InvoiceStatusV1 {
  /** When Brex is able to match a payment that fully pays an existing invoice */
  AUTOMATED_MATCH_PAID = "AUTOMATED_MATCH_PAID",
  /** When Brex is able to match a payment that partially pays an existing invoice */
  AUTOMATED_MATCH_PARTIALLY_PAID = "AUTOMATED_MATCH_PARTIALLY_PAID",
  /** When invoice is sent and no payment is received/matched yet. */
  AWAITING_PAYMENT = "AWAITING_PAYMENT",
  /** When user deletes an invoice that was in a drafting stage. */
  DELETED = "DELETED",
  /** When invoice detail is editable. */
  DRAFTING = "DRAFTING",
  /** Invalid. */
  INVALID = "INVALID",
  /** When invoice is awaiting payment and the due date has passed. */
  OVERDUE = "OVERDUE",
  /** When user considers it paid in full. */
  PAID = "PAID",
  /** When user considers it paid partially. */
  PARTIALLY_PAID = "PARTIALLY_PAID",
  /** When payer has submitted a payment from EBA bank account. */
  PAYMENT_SCHEDULED = "PAYMENT_SCHEDULED",
  /** When user schedules an invoice to be sent at a later time. */
  SCHEDULED = "SCHEDULED",
  /** When user considers the invoice cannot be collected. */
  UNCOLLECTIBLE = "UNCOLLECTIBLE",
  /** When user cancels an invoice in a collecting stage. */
  VOIDED = "VOIDED",
}

export interface InvoiceSubmitEbaPaymentInput {
  /** Amount in USD cents */
  amountUsdCents: Scalars["Int"];
  /** A unique idempotency key. */
  clientMutationId: Scalars["String"];
  /** ID of the invoice for which payment is being submitted. */
  invoiceId: Scalars["ID"];
  /** RAD ID */
  railAccountDetailsId: Scalars["ID"];
  /** Scheduled send at */
  scheduledSendAt: Scalars["LocalDateTime"];
}

export interface InvoiceSubmitEbaPaymentResult extends MutationResult {
  errors?: Maybe<Array<InvoicingV1ClientError>>;
  result?: Maybe<InvoiceV1>;
}

export interface InvoiceTemplate extends Node {
  /** Company contact info of the invoice template. */
  contact?: Maybe<InvoicingContact>;
  /** footer */
  footer?: Maybe<Scalars["String"]>;
  /** Header */
  header?: Maybe<Scalars["String"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  /** Idempotency key. */
  idempotencyKey?: Maybe<Scalars["String"]>;
  /** Logo uri. */
  logoUri?: Maybe<Scalars["String"]>;
  /** Logo url. */
  logoUrl?: Maybe<Scalars["String"]>;
  /** note */
  note?: Maybe<Scalars["String"]>;
}

/**  TODO(P1): expose type Asset for logoAsset, instead of logoAssetId: String. */
export interface InvoiceTemplateV1 {
  /** Invoice template footer */
  footer?: Maybe<Scalars["String"]>;
  /** Invoice template header. */
  header?: Maybe<Scalars["String"]>;
  /** ID of invoice template. */
  id: Scalars["ID"];
  /** Invoicer contact. */
  invoicerContact?: Maybe<InvoicingContactV1>;
  /** File asset ID to the company logo. */
  logoAssetId?: Maybe<Scalars["String"]>;
  /** Invoice template note. */
  note?: Maybe<Scalars["String"]>;
}

export interface InvoiceTemplateV1Result extends MutationResult {
  errors?: Maybe<Array<InvoicingV1ClientError>>;
  result?: Maybe<InvoiceTemplateV1>;
}

export interface InvoiceV1 {
  /** Whether customer allows this invoice to be paid via EBA ACH - optional for backwards compatibility and defaults to Null */
  allowEbaAch?: Maybe<Scalars["Boolean"]>;
  /** Attachment assets. */
  attachmentAssets?: Maybe<Array<Asset>>;
  /** Associated transaction. */
  cashTransaction?: Maybe<CashTransaction>;
  /** Creation date. */
  createdAt: Scalars["Time"];
  /** CreatedBy user. */
  createdByUser: User;
  /** Deposits account. */
  depositsAccount?: Maybe<DepositsAccount>;
  /** Discount of the invoice. */
  discount?: Maybe<InvoiceDiscountV1OneOf>;
  /** Invoice due date. */
  dueDate?: Maybe<Scalars["Date"]>;
  /** Invoice ID. This is the global id of the baseInvoiceId from the data layer. */
  id: Scalars["ID"];
  /** Invoice number. */
  invoiceNumber: Scalars["String"];
  /**
   * Invoice issued date. Could refer to a date from the past when the service is done.
   * If no value is provided, we will use the current date.
   */
  issuedDate?: Maybe<Scalars["Date"]>;
  /** Invoice line items. */
  lineItems?: Maybe<Array<InvoiceLineItemV1>>;
  /** Invoice memo. */
  memo?: Maybe<Scalars["String"]>;
  /** Payer contact. */
  payerContact?: Maybe<InvoicingContactV1>;
  /** Payment instructions for the invoice. */
  paymentInstructions: InvoicePaymentInstructionsV1;
  /** Payment link auth token. */
  paymentLinkAuthToken?: Maybe<Scalars["String"]>;
  /** Whether the payment link is enabled. */
  paymentLinkEnabled: Scalars["Boolean"];
  /** Preferred payment method. */
  paymentMethod?: Maybe<InvoicePaymentMethodV1>;
  /** Invoice PO number. */
  poNumber?: Maybe<Scalars["String"]>;
  /** Invoice Recipient */
  recipient?: Maybe<InvoicingCustomer>;
  /** The recurring instance number, if this invoice is in a recurring invoice series. */
  recurringInstanceNumber?: Maybe<Scalars["Int"]>;
  /** Recurring schedule of invoice, if any. */
  recurringScheduleV1?: Maybe<RecurringScheduleDetails>;
  /** Associated reminders. */
  reminders?: Maybe<Array<InvoiceReminder>>;
  /**
   * If a schedule invoice, the time the invoice is supposed to be sent out
   * @deprecated No longer supported
   */
  scheduledTime?: Maybe<Scalars["Time"]>;
  /** The time when an invoice was sent, or is scheduled to be sent. */
  sendTime?: Maybe<Scalars["Time"]>;
  /** Invoice status. */
  status: InvoiceStatusV1;
  /** Subtotal amount of the invoice. */
  subtotal?: Maybe<FinancialAsset>;
  /** Tax on the invoice. Expressed as a percentage */
  tax?: Maybe<Scalars["Float"]>;
  /** Invoice template. */
  template?: Maybe<InvoiceTemplateV1>;
  /** Total amount of the invoice. */
  total?: Maybe<FinancialAsset>;
}

export interface InvoiceV1Connection extends Connection {
  /** The invoices in the current page of results. */
  edges: Array<InvoiceV1Edge>;
  /** Page info for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** Total count of invoices matching the filter. */
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface InvoiceV1Edge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The InvoiceV1 at this edge. */
  node?: Maybe<InvoiceV1>;
}

export interface InvoiceV1Order {
  direction?: InputMaybe<OrderByDirection>;
  field?: InputMaybe<InvoiceV1OrderField>;
}

export enum InvoiceV1OrderField {
  SEND_TIME = "SEND_TIME",
}

export interface InvoiceV1Result extends MutationResult {
  errors?: Maybe<Array<InvoicingV1ClientError>>;
  result?: Maybe<InvoiceV1>;
}

export interface InvoicesV1WhereInput {
  amount?: InputMaybe<InvoiceAmountRangeInput>;
  dueDate?: InputMaybe<TimeIntervalInput>;
  searchQuery?: InputMaybe<Scalars["String"]>;
  sendTime?: InputMaybe<TimeIntervalInput>;
  statuses?: InputMaybe<Array<InvoiceStatusV1>>;
}

export interface InvoicingAccount extends Node {
  /** The customer_account_id of the invoicing account. */
  customerAccountId: Scalars["String"];
  /** The default invoice template used to generate a formatted invoice document. */
  defaultInvoiceTemplate?: Maybe<InvoiceTemplate>;
  /** The ID of an object */
  id: Scalars["ID"];
  /** The prefix for the invoice number. */
  invoiceNumberPrefix?: Maybe<Scalars["String"]>;
  /** Invoices for this account */
  invoices?: Maybe<InvoicingInvoiceConnection>;
  /** The next invoice number for creating a new invoice. */
  nextInvoiceNumber: Scalars["Int"];
  /** The status of the invoicing account (e.g., `ACTIVE`, `SUSPENDED`, `DEACTIVATED`). */
  status: InvoicingAccountStatus;
}

export interface InvoicingAccountinvoicesArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  status?: InputMaybe<Array<InputMaybe<InvoiceStatus>>>;
}

export enum InvoicingAccountStatus {
  ACTIVE = "ACTIVE",
  DEACTIVATED = "DEACTIVATED",
  INVALID = "INVALID",
  SUSPENDED = "SUSPENDED",
}

export enum InvoicingAccountStatusV1 {
  ACTIVE = "ACTIVE",
  DEACTIVATED = "DEACTIVATED",
  INVALID = "INVALID",
  SUSPENDED = "SUSPENDED",
}

export interface InvoicingAccountV1 {
  /** Default invoice template. */
  defaultInvoiceTemplate?: Maybe<InvoiceTemplateV1>;
  /** Whether customer has submitted PUP for expected monthly txn volume */
  hasSubmittedPupData?: Maybe<Scalars["Boolean"]>;
  /** InvoiceAccount ID. */
  id: Scalars["ID"];
  /** Invoicing recipients with pagination and optional filtering. */
  invoicingRecipients?: Maybe<InvoicingCustomerConnection>;
  /** Invoice stats breakdown. */
  statsBreakdown?: Maybe<StatsBreakdown>;
  /** Account status. */
  status: InvoicingAccountStatusV1;
}

export interface InvoicingAccountV1invoicingRecipientsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  order?: InputMaybe<InvoicingCustomerOrderInput>;
  where?: InputMaybe<InvoicingCustomerFilterInput>;
}

export interface InvoicingAccountV1Result extends MutationResult {
  errors?: Maybe<Array<InvoicingV1ClientError>>;
  result?: Maybe<InvoicingAccountV1>;
}

export interface InvoicingAddressV1 {
  address1?: Maybe<Scalars["String"]>;
  address2?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  firstName?: Maybe<Scalars["String"]>;
  lastName?: Maybe<Scalars["String"]>;
  state?: Maybe<Scalars["String"]>;
  zip?: Maybe<Scalars["String"]>;
}

export interface InvoicingAddressV1Input {
  address1?: InputMaybe<Scalars["String"]>;
  address2?: InputMaybe<Scalars["String"]>;
  city?: InputMaybe<Scalars["String"]>;
  country?: InputMaybe<Scalars["String"]>;
  firstName?: InputMaybe<Scalars["String"]>;
  lastName?: InputMaybe<Scalars["String"]>;
  state?: InputMaybe<Scalars["String"]>;
  zip?: InputMaybe<Scalars["String"]>;
}

export interface InvoicingContact extends Node {
  /** Address */
  address?: Maybe<ContactAddress>;
  /** Type of contact. e.g. Invoicer, Payer */
  contactType: ContactType;
  /** Doing Business As */
  dbaName?: Maybe<Scalars["String"]>;
  /** Email */
  email?: Maybe<Scalars["String"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  /** Phone number */
  phone?: Maybe<Scalars["String"]>;
}

export enum InvoicingContactTypeV1 {
  /** The party that sends invoices. */
  INVOICER = "INVOICER",
  /** The party that receives invoices. */
  PAYER = "PAYER",
}

export interface InvoicingContactV1 {
  /** Address. */
  address?: Maybe<InvoicingAddressV1>;
  /** Type of contact. */
  contactType: InvoicingContactTypeV1;
  /** Doing Business As. */
  dbaName?: Maybe<Scalars["String"]>;
  /** Email address. */
  email?: Maybe<Scalars["String"]>;
  /** Contact ID. */
  id: Scalars["ID"];
  /** Phone number. */
  phoneNumber?: Maybe<Scalars["String"]>;
}

export interface InvoicingContactV1Result extends MutationResult {
  errors?: Maybe<Array<InvoicingV1ClientError>>;
  result?: Maybe<InvoicingContactV1>;
}

export interface InvoicingCustomer extends Node {
  active?: Maybe<Scalars["Boolean"]>;
  address?: Maybe<Address>;
  customerAccountId?: Maybe<Scalars["ID"]>;
  email?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  invoicingAccountId?: Maybe<Scalars["ID"]>;
  name: Scalars["String"];
}

/** A InvoicingCustomer connection for InvoicingCustomer pagination. */
export interface InvoicingCustomerConnection extends Connection {
  /** The invoicing customers in the current page of results. */
  edges: Array<InvoicingCustomerEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of invoicing customers matching the filter criteria specified for this connection. */
  totalCount: Scalars["Int"];
}

export interface InvoicingCustomerCreateInput {
  address?: InputMaybe<AddressInput>;
  clientMutationId: Scalars["String"];
  email?: InputMaybe<Scalars["String"]>;
  invoicingAccountId: Scalars["ID"];
  name: Scalars["String"];
}

/** A InvoicingCustomer edge for the InvoicingCustomer connection. */
export interface InvoicingCustomerEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The invoicing customer at this edge. */
  node?: Maybe<InvoicingCustomer>;
}

export interface InvoicingCustomerFilterInput {
  /** Search for names containing the given string */
  nameSearch?: InputMaybe<Scalars["String"]>;
  /** Match IN specific invoicing customer names */
  names?: InputMaybe<Array<Scalars["String"]>>;
}

export interface InvoicingCustomerOrderInput {
  field: SortableInvoicingCustomerField;
  order: OrderByDirection;
}

export interface InvoicingCustomerResult extends MutationResult {
  errors?: Maybe<Array<InvoicingV1ClientError>>;
  result?: Maybe<InvoicingCustomer>;
}

export interface InvoicingCustomerSetMetadataInput {
  address?: InputMaybe<AddressInput>;
  clientMutationId: Scalars["String"];
  email?: InputMaybe<Scalars["String"]>;
  id: Scalars["ID"];
}

export interface InvoicingInvoice extends Node {
  /** Creator of the invoice. */
  createdBy: Scalars["String"];
  /** Discount amount of the invoice. If any, this is applied to subtotal to calculate the total_amount. */
  discountAmount?: Maybe<FinancialAsset>;
  /** Discount percent of the invoice. If any, this is applied to subtotal to calculate the total_amount.  */
  discountPercent?: Maybe<Scalars["Float"]>;
  /** Due date of the invoice */
  dueDate?: Maybe<Scalars["Date"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  /** Idempotency key. */
  idempotencyKey: Scalars["String"];
  /** The invoice number. */
  invoiceNumber: Scalars["String"];
  /** The invoicing account ID of the invoice. */
  invoicingAccountId: Scalars["String"];
  /** Issued date of the invoice */
  issuedDate?: Maybe<Scalars["Date"]>;
  /** Invoice line items. */
  lineItems?: Maybe<Array<Maybe<InvoiceLineItem>>>;
  /** The memo of the invoice. */
  memo?: Maybe<Scalars["String"]>;
  /** Payer contact */
  payer?: Maybe<InvoicingContact>;
  /** The payment terms of the invoice. */
  paymentTerms?: Maybe<Scalars["String"]>;
  /** The status of the invoice. */
  status: InvoiceStatus;
  /** A list of status change logs. */
  statusLogs?: Maybe<Array<Maybe<InvoiceStatusLog>>>;
  /** Subtotal of the invoice. This is the amount before any discount is applied. */
  subtotal?: Maybe<FinancialAsset>;
  /** Invoice template. */
  template?: Maybe<InvoiceTemplate>;
  /** The title of the invoice. */
  title?: Maybe<Scalars["String"]>;
  /** The total amount of the invoice. This is the final amount after any discount is applied. */
  totalAmount?: Maybe<FinancialAsset>;
  /** Last updator of the invoice. */
  updatedBy: Scalars["String"];
}

export interface InvoicingInvoiceConnection {
  edges?: Maybe<Array<Maybe<InvoicingInvoiceEdge>>>;
  /** Next offset. If next_offset < total_count, there are additional results to query. */
  nextOffset: Scalars["Int"];
  pageInfo: PageInfo;
  /** Total count of invoices. */
  totalCount: Scalars["Int"];
}

export interface InvoicingInvoiceEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<InvoicingInvoice>;
}

export interface InvoicingV1ClientError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export enum IrsForm1099EligibilityStatus {
  ELIGIBLE = "ELIGIBLE",
  INELIGIBLE = "INELIGIBLE",
}

export interface IsAccounting1BStackEnabledResult {
  isEnabled: Scalars["Boolean"];
}

export interface IsSocialLoginsEnabledResult {
  accountId?: Maybe<Scalars["String"]>;
  enabled?: Maybe<Scalars["Boolean"]>;
}

export enum IssueType {
  /** DSS support issue type */
  DSS_SUPPORT = "DSS_SUPPORT",
  /** Expense management related issue */
  EXPENSE_MANAGEMENT = "EXPENSE_MANAGEMENT",
  /** Default issue type */
  GENERAL_SUPPORT = "GENERAL_SUPPORT",
  /** Transaction related issue */
  TRANSACTION = "TRANSACTION",
}

export enum Issuer {
  AIRWALLEX = "AIRWALLEX",
  EMIGRANT = "EMIGRANT",
  FIFTH_THIRD = "FIFTH_THIRD",
  INVALID = "INVALID",
  SUTTON = "SUTTON",
}

export interface IssuerTransactionPayloadV2 {
  exchangeRate: Scalars["Int"];
}

/**  Add Item as a federated entity */
export interface Item extends ExtensibleEntity, Node {
  customerAccountId: Scalars["String"];
  description?: Maybe<Scalars["String"]>;
  extendedFieldInstance?: Maybe<ExtendedFieldInstance>;
  extendedFieldInstances?: Maybe<ExtendedFieldInstanceConnection>;
  id: Scalars["ID"];
  name: Scalars["String"];
  type: ItemType;
}

/**  Add Item as a federated entity */
export interface ItemextendedFieldInstanceArgs {
  id: Scalars["ID"];
}

/**  Add Item as a federated entity */
export interface ItemextendedFieldInstancesArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<ExtendedFieldFilterConditionInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

export interface ItemConnection extends Connection {
  edges: Array<ItemEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of items matching the filter criteria specified for this connection. */
  totalCount: Scalars["Int"];
}

export interface ItemCreateInput {
  clientMutationId: Scalars["String"];
  customerAccountId: Scalars["String"];
  description?: InputMaybe<Scalars["String"]>;
  name: Scalars["String"];
  type: ItemType;
}

export interface ItemEdge {
  cursor: Scalars["String"];
  node: Item;
}

export interface ItemFilterInput {
  name?: InputMaybe<Array<Scalars["String"]>>;
  nameSearch?: InputMaybe<Scalars["String"]>;
}

export interface ItemMutationError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export enum ItemOrderField {
  NAME = "NAME",
}

export interface ItemOrderInput {
  direction: OrderByDirection;
  field: ItemOrderField;
}

export type ItemResult = Item | ItemMutationError;

export interface ItemSetTypeInput {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
  type: ItemType;
}

export enum ItemType {
  PHYSICAL_GOOD = "PHYSICAL_GOOD",
  SERVICE = "SERVICE",
}

export enum ItemizationStatus {
  /** The expense is a line item */
  CHILD = "CHILD",
  /** The expense is not itemized */
  NONE = "NONE",
  /** The expense is itemized */
  PARENT = "PARENT",
}

export interface ItemizeExpenseInput {
  /** clientMutationId */
  clientMutationId: Scalars["String"];
  /** The ID of the expense to itemize. */
  id: Scalars["ID"];
  /** The input for the itemized expense. */
  itemizedExpenses: Array<ItemizedExpense>;
}

export interface ItemizeExpenseResult {
  /** The itemized expenses that were created. */
  expenses: Array<Expense>;
}

export interface ItemizedExpense {
  /** Amount of the expense; may be negative */
  amount?: InputMaybe<FinancialAssetInput>;
  /** The category to which this expense belongs to */
  merchantCategoryId?: InputMaybe<Scalars["ID"]>;
}

export type ItemizedPrimitive = Expense;

export interface ItineraryActivity {
  /** Description of the activity */
  description?: Maybe<Scalars["String"]>;
  /** End date and time in local time. */
  endDateTime?: Maybe<Scalars["LocalDateTime"]>;
  /** ItineraryActivity ID */
  id: Scalars["ID"];
  location?: Maybe<LocationMetadata>;
  /** Start date and time in local time. */
  startDateTime?: Maybe<Scalars["LocalDateTime"]>;
  /** Timezone of the destination */
  timezone: Scalars["String"];
  /** Name of the activity */
  title: Scalars["String"];
  /** Type of the activity */
  type: ItineraryActivityType;
  /** Version of activity */
  version: Scalars["Int"];
}

export interface ItineraryActivityConnection extends Connection {
  edges: Array<Maybe<ItineraryActivityEdge>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface ItineraryActivityEdge {
  cursor?: Maybe<Scalars["String"]>;
  node: ItineraryActivity;
}

export enum ItineraryActivityType {
  EVENT = "EVENT",
  LODGING = "LODGING",
}

export enum JobStatus {
  /** @deprecated This status has the same meaning as READY_FOR_DOWNLOAD and is deprecated avoid ambiguity */
  COMPLETED = "COMPLETED",
  DOWNLOADED = "DOWNLOADED",
  FAILED = "FAILED",
  READY_FOR_DOWNLOAD = "READY_FOR_DOWNLOAD",
  RUNNING = "RUNNING",
}

/** An account representing activity corresponding to a set of loan terms */
export interface JournalAccount extends Node {
  /** The ID of an object */
  id: Scalars["ID"];
  /** The raw identifier for a journal account */
  rawId: Scalars["String"];
}

export enum JournalAccountOwnerType {
  CARD = "CARD",
  REIMBURSEMENT_SPENDING = "REIMBURSEMENT_SPENDING",
}

export interface JournalEntry {
  amountUsdCents?: Maybe<Scalars["Int"]>;
  id?: Maybe<Scalars["String"]>;
  originator?: Maybe<JournalEntryOriginator>;
  originatorType?: Maybe<JournalOriginatorType>;
}

export type JournalEntryOriginator = RewardsRefund;

export enum JournalOriginatorType {
  PRESENT_TRANSACTION_OPERATION = "PRESENT_TRANSACTION_OPERATION",
}

export enum JpBankAccountType {
  CHECKING = "CHECKING",
  CURRENT = "CURRENT",
  SAVINGS = "SAVINGS",
}

/**
 * WIP
 * Japanese Banking code.
 */
export interface JpLocal {
  accountNumber?: Maybe<Scalars["String"]>;
  accountType?: Maybe<JpBankAccountType>;
  bankCode?: Maybe<Scalars["String"]>;
  branchCode?: Maybe<Scalars["String"]>;
}

/**
 * WIP
 * Japanese Banking code.
 */
export interface JpLocalInput {
  accountNumber?: InputMaybe<Scalars["String"]>;
  accountType?: InputMaybe<JpBankAccountType>;
  bankCode?: InputMaybe<Scalars["String"]>;
  branchCode?: InputMaybe<Scalars["String"]>;
}

export interface JsonSchemaRequestConfig {
  content?: Maybe<Scalars["Json"]>;
}

export interface JsonSchemaSubmissionPayloadInput {
  formData?: InputMaybe<Scalars["Json"]>;
}

export interface KYCAddress {
  city?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  line1: Scalars["String"];
  line2?: Maybe<Scalars["String"]>;
  state?: Maybe<Scalars["String"]>;
  zip?: Maybe<Scalars["String"]>;
}

export interface KYCAddressInput {
  city: Scalars["String"];
  country: Scalars["String"];
  line1: Scalars["String"];
  line2?: InputMaybe<Scalars["String"]>;
  state: Scalars["String"];
  zip: Scalars["String"];
}

export interface KYCIdentificationDetailsInput {
  identificationNumber: Scalars["String"];
  identificationType?: InputMaybe<KYCIdentityIdentificationType>;
}

/** Identification type as defined in kyc identity. */
export enum KYCIdentityIdentificationType {
  PASSPORT = "PASSPORT",
  SSN = "SSN",
}

export interface KYCIdentityIndividualInput {
  birthDate?: InputMaybe<Scalars["Date"]>;
  countryOfCitizenship?: InputMaybe<Scalars["String"]>;
  firstName?: InputMaybe<Scalars["String"]>;
  identificationInformation?: InputMaybe<Array<KYCIdentificationDetailsInput>>;
  individualAddress?: InputMaybe<KYCAddressInput>;
  individualRoles?: InputMaybe<Array<KYCIdentityIndividualRole>>;
  knowledgeBaseNodeId?: InputMaybe<Scalars["String"]>;
  lastName?: InputMaybe<Scalars["String"]>;
  phoneNumber?: InputMaybe<Scalars["String"]>;
  roleInformation?: InputMaybe<
    Array<KYCIdentityIndividualRoleInformationInput>
  >;
}

/** Role name as present in the KYC Identity Service. */
export enum KYCIdentityIndividualRole {
  ADMIN_USER = "ADMIN_USER",
  BENEFICIAL_OWNER = "BENEFICIAL_OWNER",
  CONTROLLING_OFFICER = "CONTROLLING_OFFICER",
}

export interface KYCIdentityIndividualRoleInformationInput {
  boInformation?: InputMaybe<BoInformationInput>;
  coInformation?: InputMaybe<CoInformationInput>;
}

/** Title as present in the KYC Identity Service. */
export enum KYCIdentityIndividualTitle {
  CEO = "CEO",
  CFO = "CFO",
  COO = "COO",
  EXECUTIVE = "EXECUTIVE",
  FOUNDER = "FOUNDER",
  LEADERSHIP = "LEADERSHIP",
  OTHER = "OTHER",
}

export interface KYCIndividual {
  /** Address of the individual */
  address?: InputMaybe<KYCAddressInput>;
  /** Country of citizenship of the individual */
  countryOfCitizenship?: InputMaybe<Scalars["String"]>;
  /** Date of birth of the individual */
  dob?: InputMaybe<Scalars["Date"]>;
  /** Full name of the individual */
  fullName?: InputMaybe<FullNameInput>;
  /** Document details of the individual */
  individualDocument?: InputMaybe<IndividualDocumentInput>;
  /** Ownership percentage of the individual */
  ownershipPercentage?: InputMaybe<Scalars["Int"]>;
  /** Persona inquiry, if collected */
  persona?: InputMaybe<PersonaSubmissionPayloadInput>;
  /** Phone number of the individual */
  phoneNumber?: InputMaybe<Scalars["String"]>;
  /** Description of this individual's role. Provide if title=OTHER */
  roleDescription?: InputMaybe<Scalars["String"]>;
  /** List of roles associated with the individual */
  roles?: InputMaybe<Array<ObjectNodeType>>;
  /** Title of the individual */
  title?: InputMaybe<IndividualTitle>;
}

/** A key value entry in a custom addendum metadata. */
export interface KeyValuePair {
  /** A unique key in the custom addendum. */
  key: Scalars["String"];
  /** Value for the key. */
  value: Scalars["String"];
}

export interface KeyValuePairInput {
  key: Scalars["String"];
  value: ComplexValueInput;
}

export interface KnowledgeBaseVendor {
  /** Display icon for knowledge base vendor. */
  icon?: Maybe<Asset>;
  /** ID */
  id: Scalars["ID"];
  /** Name */
  name?: Maybe<Scalars["String"]>;
  /**
   * Arbitrary groups that can be used to display suggested vendors. For display/UI purposes only. Do not correspond
   * to meaningful vendor categories.
   */
  suggestionGroups: Array<KnowledgeBaseVendorSuggestionGroup>;
  /** The Vendor(s) linked to this KnowledgeBaseVendor. Will typically be a single Vendor. */
  vendors: Array<VendorDetails>;
}

export interface KnowledgeBaseVendorConnection extends Connection {
  /** The knowledge base vendors in the current page of results. */
  edges: Array<KnowledgeBaseVendorEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of knowledge base vendors matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

/** A KnowledgeBaseVendor edge for the KnowledgeBaseVendor connection. */
export interface KnowledgeBaseVendorEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The KnowledgeBaseVendor at this edge. */
  node?: Maybe<KnowledgeBaseVendor>;
}

/** Filters available to control which knowledge base vendors get returned. */
export interface KnowledgeBaseVendorFilterInput {
  /** Match IN specific suggestion groups, match ALL when none is provided */
  suggestionGroups?: InputMaybe<Array<KnowledgeBaseVendorSuggestionGroup>>;
}

export enum KnowledgeBaseVendorSuggestionGroup {
  COMMUNICATIONS = "COMMUNICATIONS",
  CONSULTANTS = "CONSULTANTS",
  ELECTRONICS = "ELECTRONICS",
  GENERAL = "GENERAL",
  MARKETING = "MARKETING",
  POPULAR = "POPULAR",
  SERVERS = "SERVERS",
  SOFTWARE = "SOFTWARE",
  TRAVEL = "TRAVEL",
}

/** The number of employees in this business. */
export enum KycIdentityEmployeeCount {
  FIFTY_ONE_TO_ONE_HUNDRED = "FIFTY_ONE_TO_ONE_HUNDRED",
  FIVE_HUNDRED_ONE_TO_TWO_THOUSAND_FIVE_HUNDRED = "FIVE_HUNDRED_ONE_TO_TWO_THOUSAND_FIVE_HUNDRED",
  FIVE_TO_TWENTY = "FIVE_TO_TWENTY",
  MORE_THAN_TWO_THOUSAND_FIVE_HUNDRED = "MORE_THAN_TWO_THOUSAND_FIVE_HUNDRED",
  ONE_HUNDRED_ONE_TO_FIVE_HUNDRED = "ONE_HUNDRED_ONE_TO_FIVE_HUNDRED",
  ONE_TO_FOUR = "ONE_TO_FOUR",
  TWENTY_ONE_TO_FIFTY = "TWENTY_ONE_TO_FIFTY",
}

/** The funding source for this business. */
export enum KycIdentityFundingSource {
  ANGEL_INVESTMENT = "ANGEL_INVESTMENT",
  BUSINESS_REVENUE = "BUSINESS_REVENUE",
  CROWDSOURCED = "CROWDSOURCED",
  FAMILY = "FAMILY",
  GRANTS = "GRANTS",
  INITIAL_COIN_OFFERING = "INITIAL_COIN_OFFERING",
  LOAN_FUNDING = "LOAN_FUNDING",
  PARENT_COMPANY = "PARENT_COMPANY",
  PRIVATE_EQUITY = "PRIVATE_EQUITY",
  PROFESSIONAL_INVESTOR = "PROFESSIONAL_INVESTOR",
  SELF_FUNDED = "SELF_FUNDED",
  VENTURE_ACCELERATOR_GROWTH = "VENTURE_ACCELERATOR_GROWTH",
}

/** Incorporation type of the business. */
export enum KycIdentityIncorporationType {
  ANY_CORP = "ANY_CORP",
  B_CORP = "B_CORP",
  C_CORP = "C_CORP",
  INVALID = "INVALID",
  LLC = "LLC",
  LLP = "LLP",
  LP = "LP",
  ORG_501C3 = "ORG_501C3",
  OTHER = "OTHER",
  SOLE_PROP = "SOLE_PROP",
  S_CORP = "S_CORP",
  TAX_EXEMPT = "TAX_EXEMPT",
}

export enum KycStatus {
  IN_PROGRESS = "IN_PROGRESS",
  REJECTED = "REJECTED",
  UNSUBMITTED = "UNSUBMITTED",
  UNVERIFIED = "UNVERIFIED",
  VERIFIED = "VERIFIED",
}

export interface KycUpdateUserInput {
  /** Address to update KYC User with */
  address?: InputMaybe<FlexibleAddressInput>;
  clientMutationId: Scalars["String"];
  /** Persona Inquiry ID to update KYC User with */
  personaInquiryId?: InputMaybe<Scalars["String"]>;
}

export interface KycUpdateUserPayload {
  clientMutationId: Scalars["String"];
  /** The updated KYC User */
  kycUser?: Maybe<KycUser>;
}

export interface KycUser {
  /** Address */
  address?: Maybe<Address>;
  /** Citizenship (ISO 2 country code) */
  citizenship?: Maybe<Scalars["String"]>;
  /** Customer user ID */
  customerUserId?: Maybe<Scalars["String"]>;
  /** Date of birth */
  dateOfBirth?: Maybe<Scalars["Date"]>;
  /** First name. Derived from Customer service */
  firstName?: Maybe<Scalars["String"]>;
  /** Local ID card */
  id?: Maybe<IndividualIdentityDocumentIdentityCard>;
  /** Last name. Derived from Customer service */
  lastName?: Maybe<Scalars["String"]>;
  /** Passport */
  passport?: Maybe<IndividualIdentityDocumentPassport>;
  /** Persona inquiry for ID verification */
  personaInquiry?: Maybe<IndividualIdentityDocumentPersona>;
  /** 9-digit US social security number */
  ssn?: Maybe<IndividualIdentityDocumentSsn>;
}

export interface LLMOAuthIntegration {
  id: Scalars["ID"];
  integrationProvider: LLMOAuthIntegrationProvider;
  integrationStatus: LLMOAuthIntegrationStatus;
}

export interface LLMOAuthIntegrationConnection extends Connection {
  edges: Array<LLMOAuthIntegrationEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface LLMOAuthIntegrationEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<LLMOAuthIntegration>;
}

export enum LLMOAuthIntegrationProvider {
  GOOGLE = "GOOGLE",
}

export enum LLMOAuthIntegrationStatus {
  ACTIVE = "ACTIVE",
  REVOKED = "REVOKED",
}

/** ---[ Local Shared Types ]------------ */
export interface LatLong {
  latitude: Scalars["Float"];
  longitude: Scalars["Float"];
}

/** Latest bill entity containing amount that a billed entity may be due */
export interface LatestBill {
  /** How much the billed entity owes */
  due?: Maybe<FinancialAsset>;
  /** The date and time the bill is due */
  dueAt?: Maybe<Scalars["Time"]>;
  /** The bill's cut date and time */
  maxPostedAt?: Maybe<Scalars["Time"]>;
  /** Remainder of what the entity still owes */
  remainingDue?: Maybe<FinancialAsset>;
}

export interface LeadAttributionMetadata {
  brexFeature?: InputMaybe<LeadBrexFeature>;
  brexSolution?: InputMaybe<LeadBrexSolution>;
  contentTag?: InputMaybe<LeadContentTag>;
  contentType?: InputMaybe<LeadContentType>;
  edition?: InputMaybe<EmpowerTier>;
  eventId?: InputMaybe<Scalars["String"]>;
  fbc?: InputMaybe<Scalars["String"]>;
  fbp?: InputMaybe<Scalars["String"]>;
  fullUrl?: InputMaybe<Scalars["String"]>;
  gclid?: InputMaybe<Scalars["String"]>;
  liFatId?: InputMaybe<Scalars["String"]>;
  pageSegment?: InputMaybe<LeadPageSegment>;
  referralCode?: InputMaybe<Scalars["String"]>;
  salesforceCampaign?: InputMaybe<Scalars["String"]>;
  segmentAnonymousId?: InputMaybe<Scalars["String"]>;
  videoId?: InputMaybe<Scalars["String"]>;
  webinarId?: InputMaybe<Scalars["String"]>;
}

export enum LeadBrexFeature {
  API_INTEGRATION = "API_INTEGRATION",
  BILL_PAY = "BILL_PAY",
  BREX_BRAND = "BREX_BRAND",
  BUDGETS = "BUDGETS",
  CASH_ACCOUNT = "CASH_ACCOUNT",
  DDA = "DDA",
  EMPOWER_FREE = "EMPOWER_FREE",
  EMPOWER_LITE = "EMPOWER_LITE",
  FINANCIAL_MODELING = "FINANCIAL_MODELING",
  GLOBAL = "GLOBAL",
  SPEND_MANAGEMENT = "SPEND_MANAGEMENT",
  TRAVEL = "TRAVEL",
  VENTURE_DEBT = "VENTURE_DEBT",
}

export enum LeadBrexSolution {
  BREX_BRAND = "BREX_BRAND",
  BUSINESS_ACCOUNT = "BUSINESS_ACCOUNT",
  CARD = "CARD",
  CARD_AND_CASH = "CARD_AND_CASH",
  CASH = "CASH",
  DDA = "DDA",
  EMPOWER = "EMPOWER",
  PRY = "PRY",
  VENTURE_DEBT = "VENTURE_DEBT",
}

export enum LeadContentTag {
  BECOME_A_PARTNER = "BECOME_A_PARTNER",
  BREX_CUSTOMERS = "BREX_CUSTOMERS",
  BREX_PRODUCT = "BREX_PRODUCT",
  BREX_THOUGHT_LEADERSHIP = "BREX_THOUGHT_LEADERSHIP",
  CONTACT_SALES = "CONTACT_SALES",
  CREATE_ACCOUNT = "CREATE_ACCOUNT",
  CREATE_ACCOUNT_NO_GATEKEEP = "CREATE_ACCOUNT_NO_GATEKEEP",
  CREATE_ACCOUNT_NO_WAITLIST = "CREATE_ACCOUNT_NO_WAITLIST",
  DEMO_REQUESTS = "DEMO_REQUESTS",
  PARTNER_INTEGRATION_INTEREST = "PARTNER_INTEGRATION_INTEREST",
  PRICING = "PRICING",
  SOLUTIONS_THOUGHT_LEADERSHIP = "SOLUTIONS_THOUGHT_LEADERSHIP",
  SOLUTION_OVERVIEW = "SOLUTION_OVERVIEW",
}

export enum LeadContentType {
  ARTICLE = "ARTICLE",
  BLOG_POST = "BLOG_POST",
  BROCHURE = "BROCHURE",
  CASE_STUDY = "CASE_STUDY",
  CUSTOMER_TESTIMONIAL_VIDEO = "CUSTOMER_TESTIMONIAL_VIDEO",
  DEMO_VIDEO = "DEMO_VIDEO",
  EBOOK = "EBOOK",
  EVENT = "EVENT",
  HIGH_VALUE_FORM = "HIGH_VALUE_FORM",
  PRODUCT_OVERVIEW_VIDEO = "PRODUCT_OVERVIEW_VIDEO",
  ROI_CALCULATOR = "ROI_CALCULATOR",
  WEBINAR = "WEBINAR",
  WEBINAR_RECORDING = "WEBINAR_RECORDING",
  WHITEPAPER = "WHITEPAPER",
}

export interface LeadDetailsInput {
  empowerCustomerInquiry?: InputMaybe<EmpowerCustomerInquiryDetailsInput>;
  lodgeCardRequest?: InputMaybe<LodgeCardRequestLeadDetailsInput>;
  marketo?: InputMaybe<MarketoLeadDetailsInput>;
  multiPageVbMmV0?: InputMaybe<VbMmSalesLeadDetailsInput>;
  singlePageVbMmV0?: InputMaybe<VbMmSalesLeadDetailsInput>;
}

export type LeadDetailsObject =
  | EmpowerCustomerInquiryDetailsObject
  | LodgeCardRequestLeadDetailsObject
  | MarketoLeadDetailsObject
  | VbMmSalesLeadDetailsObject;

export enum LeadFormStatus {
  BAD_LEAD = "BAD_LEAD",
  COMPLETED = "COMPLETED",
  PENDING = "PENDING",
}

export enum LeadFormType {
  EMPOWER_CUSTOMER_INQUIRY = "EMPOWER_CUSTOMER_INQUIRY",
  LODGE_CARD_REQUEST = "LODGE_CARD_REQUEST",
  MARKETO = "MARKETO",
  MULTI_PAGE_VB_MM_V0 = "MULTI_PAGE_VB_MM_V0",
  SINGLE_PAGE_VB_MM_V0 = "SINGLE_PAGE_VB_MM_V0",
}

export interface LeadObject extends Node {
  /** The ID of an object */
  id: Scalars["ID"];
  leadDetails?: Maybe<LeadDetailsObject>;
  leadFormStatus: LeadFormStatus;
  leadFormType: LeadFormType;
  leadToken: Scalars["String"];
  salesSegment?: Maybe<SalesSegment>;
}

export enum LeadPageSegment {
  BD = "BD",
  MM_ENT = "MM_ENT",
  PRY = "PRY",
  VB = "VB",
  VB_MM_ENT = "VB_MM_ENT",
}

export enum LeadSelfAttestedType {
  ECOMMERCE = "ECOMMERCE",
  OTHER = "OTHER",
}

export interface LeaveCommentInformation {
  /** The comment that will be sent to the owner of the expense */
  message?: Maybe<Scalars["String"]>;
}

/**
 * The left hand side operand of the filter or action.
 *
 * Can be used to address either a Primitive Core Field or an Extended Field.
 */
export type LeftHandSide = CoreFieldAddress | ExtendedFieldAddress;

/**
 * The left hand side operand of the filter or action.
 *
 * Can be used to address either a Primitive Core Field or an Extended Field.
 */
export interface LeftHandSideOneOfInput {
  coreFieldAddress?: InputMaybe<CoreFieldAddressInput>;
  extendedFieldAddress?: InputMaybe<ExtendedFieldAddressInput>;
}

export enum LegRestrictions {
  KTN_EDIT_NOT_ALLOWED = "KTN_EDIT_NOT_ALLOWED",
  LOYALTY_EDIT_NOT_ALLOWED = "LOYALTY_EDIT_NOT_ALLOWED",
  OSI_EDIT_NOT_ALLOWED = "OSI_EDIT_NOT_ALLOWED",
  REDRESS_EDIT_NOT_ALLOWED = "REDRESS_EDIT_NOT_ALLOWED",
  SEAT_EDIT_NOT_ALLOWED = "SEAT_EDIT_NOT_ALLOWED",
  SSR_EDIT_NOT_ALLOWED = "SSR_EDIT_NOT_ALLOWED",
}

export interface LegacyCardStatementPeriodBoundaries {
  id?: Maybe<Scalars["ID"]>;
  periodEndDate: Scalars["Time"];
  periodStartDate?: Maybe<Scalars["Time"]>;
}

export type LegacyCredentialPayload =
  | CredentialQbdPayload
  | CredentialQuickbooksPayload
  | CredentialShopifyPayload
  | CredentialVendorPayload
  | CredentialXeroPayload;

export interface LegalAgreementInput {
  /** legal agreement name */
  name: Scalars["String"];
  /** legal agreement version */
  version: Scalars["String"];
}

export interface LegalAgreementReference {
  name: Scalars["String"];
  version: Scalars["String"];
}

/** Filters for list employees query. Records returned will match ALL filters. */
export interface LegalEntitiesFilterInput {
  /** Filter by legal entity ID */
  id?: InputMaybe<Scalars["ID"]>;
  /** Whether to include deleted legal entities */
  includeDeleted?: InputMaybe<Scalars["Boolean"]>;
  /** Filter by entity KYC status */
  kycStatuses?: InputMaybe<Array<KycStatus>>;
  /** Query string to filter results by display name */
  query?: InputMaybe<Scalars["String"]>;
}

/** An employee's legal entity defined within a company's organization hierarchy. */
export interface LegalEntity {
  /** Information regarding the requirements to issue Airwallex card products. */
  airwallexCardsRequirements?: Maybe<AirwallexCardsRequirements>;
  /** The KYC status from Airwallex. May be null when entity is not using local reimbursements */
  airwallexKycStatus?: Maybe<AirwallexKycStatus>;
  /** The billing address for a legal entity */
  billingAddress?: Maybe<BillingAddress>;
  /**
   * Returns the Card billing group for the legal entity.
   * Reimbursements supported in https://brexhq.atlassian.net/browse/GACCT-581
   * @deprecated Only Card group is returned. Use billingGroups
   */
  billingGroup?: Maybe<BillingGroup>;
  /** Returns the billing groups of specified product types for the legal entity. */
  billingGroups?: Maybe<Array<BillingGroup>>;
  /** The KYC status of a legal entity, has less granularity than latestOnboardingApplication */
  brexKycStatus: BrexKycStatus;
  /** @deprecated Deprecated, use country field */
  businessAddressCountry?: Maybe<Scalars["String"]>;
  country?: Maybe<Country>;
  /** When the legal entity was deleted */
  deletedAt?: Maybe<Scalars["Time"]>;
  /** The name of the legal entity defined by the customer */
  displayName: Scalars["String"];
  id: Scalars["ID"];
  isDefault: Scalars["Boolean"];
  /** The latest KYC application for the entity */
  latestOnboardingApplication?: Maybe<OnboardingApplication>;
  /** Tasks related to the billing and kyc setup of a legal entity */
  legalEntitySetup?: Maybe<LegalEntitySetup>;
  legalName?: Maybe<Scalars["String"]>;
  locale?: Maybe<Locale>;
  /** Number of employees associated with the legal entity */
  memberCount?: Maybe<Scalars["Int"]>;
  /** The latest onboarding application for a legal entity */
  mostRecentOnboardingApplication?: Maybe<LegalEntityApplication>;
  /** Whether reimbursement feature is available for users tied to a legal entity. */
  reimbursementFeatureAvailability?: Maybe<ReimbursementFeatureAvailabilityV2>;
  /** Optional, the subsidiary the legal entity is associated with */
  subsidiaryOption?: Maybe<ExtendedFieldOption>;
  /**
   * The legal entity trusted beneficiaries list for expenses that need 2FA authorization
   * such as EU reimbursements
   */
  trustedBeneficiaries?: Maybe<Array<Maybe<TrustedBeneficiary>>>;
  /** Optional, the VAT field associated with this legal entity. */
  vatField?: Maybe<ExtendedField>;
}

/** An employee's legal entity defined within a company's organization hierarchy. */
export interface LegalEntitybillingGroupsArgs {
  billableStates?: InputMaybe<Array<BillableState>>;
  productTypes?: InputMaybe<Array<BillingGroupProductType>>;
}

/** An employee's legal entity defined within a company's organization hierarchy. */
export interface LegalEntitytrustedBeneficiariesArgs {
  filters?: InputMaybe<TrustedBeneficiariesFilterInput>;
}

export interface LegalEntityApplication {
  createdBy?: Maybe<User>;
  id: Scalars["ID"];
  status: OnboardingApplicationStatus;
}

/** Legal entity connection for pagination */
export interface LegalEntityConnection extends Connection {
  edges: Array<LegalEntityEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

/** Legal entity edge for the billing group connection. */
export interface LegalEntityEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<LegalEntity>;
}

/** Filters for get legal entity query */
export interface LegalEntityFilterInput {
  /** True by default. */
  includeDeleted?: InputMaybe<Scalars["Boolean"]>;
}

export interface LegalEntityIdentifier {
  displayName?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["ID"]>;
  type: LegalEntityIdentifierType;
}

export enum LegalEntityIdentifierType {
  DISPLAY_NAME = "DISPLAY_NAME",
  ID = "ID",
}

export interface LegalEntityInput {
  /** Country of the entity */
  businessAddressCountry?: InputMaybe<CountryAlpha2>;
  /** Name of the legal entity. */
  name?: InputMaybe<Scalars["String"]>;
}

export interface LegalEntityMapping {
  /** The id of the legal entity the budget should map to */
  legalEntityId?: InputMaybe<Scalars["ID"]>;
  /**
   * Option to use the budget ancestry's legal entity mapping. Defaults to false.
   * If true, the legalEntityId value will be ignored
   */
  useAncestryLegalEntity?: InputMaybe<Scalars["Boolean"]>;
}

export enum LegalEntityResourceAttribute {
  BILLING_CONFIGURATION = "BILLING_CONFIGURATION",
  KYC = "KYC",
}

export interface LegalEntityResourceOperation extends ResourceOperation {
  action: ResourceAction;
  attribute?: Maybe<LegalEntityResourceAttribute>;
}

export interface LegalEntitySetup {
  /** Id for the LEGAL_ENTITY_SETUP request */
  id: Scalars["ID"];
  /** Count of the unresolved legal entity setup tasks for this request */
  resolvedTaskCount?: Maybe<Scalars["Int"]>;
  /** List of legal entity setup tasks */
  setupTasks?: Maybe<LegalEntitySetupTaskConnection>;
  /** Status of the LEGAL_ENTITY_SETUP request */
  status?: Maybe<LegalEntitySetupStatus>;
  /** Count of all legal entity setup tasks for this request */
  totalTaskCount?: Maybe<Scalars["Int"]>;
}

export enum LegalEntitySetupStatus {
  APPROVED = "APPROVED",
  CANCELED = "CANCELED",
  INVALID = "INVALID",
  PENDING = "PENDING",
  REJECTED = "REJECTED",
}

export interface LegalEntitySetupTask {
  /** Id for the request action of a legal entity setup task */
  id: Scalars["ID"];
  /** Status of the legal entity setup task */
  status?: Maybe<LegalEntitySetupTaskStatus>;
  /** Type of legal entity setup task */
  type?: Maybe<LegalEntitySetupTaskType>;
}

export interface LegalEntitySetupTaskConnection extends Connection {
  edges: Array<LegalEntitySetupTaskEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface LegalEntitySetupTaskEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<LegalEntitySetupTask>;
}

export enum LegalEntitySetupTaskStatus {
  BLOCKED = "BLOCKED",
  CANCELED = "CANCELED",
  COMPLETED = "COMPLETED",
  DISMISSED = "DISMISSED",
  PENDING = "PENDING",
  REJECTED = "REJECTED",
  TENTATIVELY_COMPLETED = "TENTATIVELY_COMPLETED",
  TENTATIVELY_REJECTED = "TENTATIVELY_REJECTED",
}

export enum LegalEntitySetupTaskType {
  BILL_PAY_BILLING_SETUP = "BILL_PAY_BILLING_SETUP",
  CARD_BILLING_SETUP = "CARD_BILLING_SETUP",
  REIMBURSEMENT_BILLING_SETUP = "REIMBURSEMENT_BILLING_SETUP",
}

export interface LendingDisclosurePayloadInput {
  accepted: Scalars["Boolean"];
}

export enum LikeOperator {
  LIKE = "LIKE",
  UNLIKE = "UNLIKE",
}

/** Limit amount types for filtering the budget. Could be all, or nonzero (excludes zero dollar budgets) */
export enum LimitAmountType {
  /** Include all limit types for budgets filtered */
  ALL = "ALL",
  /** Include only budgets with non-zero limits */
  NONZERO = "NONZERO",
}

export type LimitAssignmentFailureError =
  | SpendLimitAssignmentInsufficientAncestorLimitError
  | SpendLimitAssignmentInsufficientLimitError
  | SpendLimitAssignmentSpendLimitExpiredError
  | SpendLimitAssignmentSpendLimitNotStartedError
  | SpendLimitAssignmentSpendLimitTerminatedError
  | SpendLimitAssignmentTransactionLimitError
  | UserLimitAssignmentInsufficientLimitError;

/** Controls whether spenders can request limit changes */
export enum LimitChangeRequestSettings {
  /** Spenders can request limit changes */
  ALLOW_REQUESTS = "ALLOW_REQUESTS",
  /** Spenders cannot request limit changes */
  DISABLED = "DISABLED",
}

/** Settings that control how users can request and receive approval for limit changes */
export interface LimitChangeSettings {
  /**
   * The policy used for approving limit changes. If null, the default settings are to request from:
   * 1. The user's direct manager, then
   * 2. Any admin
   */
  limitApprovalPolicy?: Maybe<Policy>;
  /** Controls whether spenders can request for limit changes */
  limitChangeRequestSettings?: Maybe<LimitChangeRequestSettings>;
}

/** The total limit and balances. Only available when visibility allows */
export interface LimitDetails {
  /** The base amount for the period without any temporary increases or rollovers */
  base?: Maybe<FinancialAsset>;
  /** The remaining limit for this period. Derived from total and spent amounts */
  remaining?: Maybe<FinancialAsset>;
  /** The maximum amount that can be spent for the period. Includes the base amount, permanent + temporary increases and rollovers */
  total?: Maybe<FinancialAsset>;
}

/** Settings that control how the limit is enforced */
export interface LimitEnforcementSettings {
  /** The type of limit enforcement */
  enforcementType: LimitEnforcementType;
  /**
   * Percentage over limit that can be spent as a 0-100 INT.
   * Only applicable when enforcementType is FLEXIBLE_LIMIT
   */
  flexibleBufferPercentage?: Maybe<Scalars["Int"]>;
}

/**  ---[ Input Types ]--------------------- */
export interface LimitEnforcementSettingsInput {
  /** The type of limit enforcement */
  enforcementType?: LimitEnforcementType;
  /**
   * Percentage over limit that can be spent as a 0-100 INT.
   * Only applicable when enforcementType is FLEXIBLE_LIMIT
   */
  flexibleBufferPercentage?: InputMaybe<Scalars["Int"]>;
}

/** The type of limit enforcement */
export enum LimitEnforcementType {
  FLEXIBLE_LIMIT = "FLEXIBLE_LIMIT",
  HARD_LIMIT = "HARD_LIMIT",
  UNLIMITED = "UNLIMITED",
}

export interface LimitEscalation {
  concludedAt?: Maybe<Scalars["Time"]>;
  createdAt: Scalars["Time"];
  id: Scalars["ID"];
  payload: LimitEscalationPayload;
}

/** LimitEscalation connection */
export interface LimitEscalationConnection extends Connection {
  /** The items in the current page of results. */
  edges: Array<Maybe<LimitEscalationEdge>>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of items, across all pages, matching the filter criteria specified for this connection. */
  totalCount: Scalars["Int"];
}

/** LimitEscalationEdge edge */
export interface LimitEscalationEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The scenario at this edge. */
  node: LimitEscalation;
}

export type LimitEscalationPayload = OutflowDetection;

export enum LimitFlexibilityType {
  /** Soft limit, a percentage of the limit can be overspent */
  FLEXIBLE = "FLEXIBLE",
  /** Hard limit, any spend over the limit will be declined */
  HARD = "HARD",
  /** No limit, will approve as long as the company's credit limit allows it */
  UNLIMITED = "UNLIMITED",
}

/** A limit group for organizing spend limits */
export interface LimitGroup {
  /** A list of operations that the user can perform on the limit group */
  allowedOperations: Array<LimitGroupOperationPermission>;
  /**
   * The amounts spent in all spend limits in the limit group in the current period
   * Null if spend limits have different currencies
   */
  amountSpent?: Maybe<FinancialAsset>;
  /** The IDs of spend limits associated with this limit group */
  associatedSpendLimitIds: Array<Scalars["ID"]>;
  /** The blueprint of the limit group. It contains the default limit fields that are applied to all the limits of the limit group. */
  blueprint: SpendLimitBlueprint;
  /** Time when the limitgroup was created */
  createdAt?: Maybe<Scalars["Time"]>;
  /** The description of the limit group */
  description?: Maybe<Scalars["String"]>;
  /** The ID of the limit group */
  id: Scalars["ID"];
  /** The name of the limit group */
  name: Scalars["String"];
  /** The count of SpendLimits within the LimitGroup that have an active limit increase */
  numberOfSpendLimitsWithIncreases?: Maybe<Scalars["Int"]>;
  /** Most recent propagation job id */
  propagationJobId?: Maybe<Scalars["String"]>;
  /** Most recent propagation job status */
  propagationStatus?: Maybe<LimitGroupPropagationStatus>;
  /** Optional overrides on eligible spend limit fields for specific groups */
  spendLimitFieldOverrides?: Maybe<LimitGroupOverrides>;
  /**
   * The spendable limits of all spend limits in the limit group in the current period
   * Includes limit increases and rollover
   * Null if spend limits have different currencies
   */
  spendableLimit?: Maybe<FinancialAsset>;
  /** The status of the limit group */
  status: LimitGroupStatus;
  /** The timezone of this limit group */
  timezone?: Maybe<Scalars["String"]>;
  /** The user group associated with this limit group */
  userGroup?: Maybe<Group>;
}

/** A limit group for organizing spend limits */
export interface LimitGroupallowedOperationsArgs {
  operations: Array<LimitGroupOperation>;
}

/** A limit group for organizing spend limits */
export interface LimitGroupassociatedSpendLimitIdsArgs {
  statuses?: InputMaybe<Array<SpendLimitStatus>>;
}

/** A Limit Group connection for pagination. */
export interface LimitGroupConnection extends Connection {
  /** The limit groups in the current page of results. */
  edges: Array<LimitGroupEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of limit groups matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

/** A limit group edge for the limit group connection. */
export interface LimitGroupEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The limit group at this edge. */
  node?: Maybe<LimitGroup>;
}

export interface LimitGroupFilterInput {
  /** Search limit groups by name */
  name?: InputMaybe<Scalars["String"]>;
  /** List limit groups that target a certain parent spend budget */
  parentBudgetId?: InputMaybe<Scalars["ID"]>;
  /** Limit group Status IN statuses */
  statuses?: InputMaybe<Array<LimitGroupStatus>>;
}

/** Limit group overrides for financial asset type fields */
export interface LimitGroupFinancialAssetFieldOverride {
  memberCondition: LimitGroupOverrideMemberCondition;
  value: FinancialAsset;
}

export interface LimitGroupMember {
  amount: FinancialAsset;
  user: User;
}

export interface LimitGroupMemberConnection extends Connection {
  edges: Array<LimitGroupMemberEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface LimitGroupMemberEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<LimitGroupMember>;
}

export interface LimitGroupMemberFilterInput {
  /** Search limit group members by name */
  name?: InputMaybe<Scalars["String"]>;
}

export interface LimitGroupMutationError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

/** Possible operations a user could perform on a limit group */
export enum LimitGroupOperation {
  /** Update the limit group's status to archived */
  ARCHIVE = "ARCHIVE",
  /** Update the limit group's status to deleted */
  DELETE = "DELETE",
  /** Update any of the limit group's fields */
  EDIT_FULL = "EDIT_FULL",
  /** Reassign the limit group to a new parent budget */
  MOVE = "MOVE",
  /** Update the limit group's status from archived or expired to active */
  REOPEN = "REOPEN",
  /** View other member's expenses for the limit group */
  VIEW_EXPENSES = "VIEW_EXPENSES",
  /** View the limit group's limit. Disabled for members if the group is masked */
  VIEW_LIMIT = "VIEW_LIMIT",
}

export interface LimitGroupOperationPermission {
  allowed: Scalars["Boolean"];
  disabledReasons?: Maybe<Array<Scalars["String"]>>;
  operation: LimitGroupOperation;
}

export interface LimitGroupOrSpendLimit {
  /**
   * The Customer Account
   * Nullable to support partial failure
   */
  account?: Maybe<Account>;
  /** A list of operations that the user can perform on the spend limit */
  allowedOperations: Array<LimitGroupOrSpendLimitOperationPermission>;
  /** Amount spend in the current period */
  amountSpent?: Maybe<FinancialAsset>;
  /** The employees who are considered owners of this entity and its parent budgets (nullable for partial failure) */
  ancestralOwners?: Maybe<UserConnection>;
  /** The number of active spend limits associated with this limit group (0 for spend limits) */
  associatedSpendLimitsCount?: Maybe<Scalars["Int"]>;
  /**
   * Authorization settings of a spend limit
   * null if user does not have permission to view these settings (based off authorizationVisibility)
   */
  authorizationSettings?: Maybe<SpendLimitAuthorizationSettings>;
  /**
   * Privacy setting whether its members are allowed to view the limit & authorization settings
   * (previously known as limit visibility)
   */
  authorizationVisibility?: Maybe<SpendLimitAuthorizationVisibility>;
  /** Setting for auto-transferring budget cards when their owners are either disabled or removed as members from the budget. */
  autoTransferCardsSetting?: Maybe<AutoTransferCardsSetting>;
  /** Returns a summary of the cards in the spend limit (generally a count cards by a specified field) */
  cardsSummary?: Maybe<CardsSummary>;
  /** Time when the entity was created */
  createdAt?: Maybe<Scalars["Time"]>;
  /** Description of what the entity is used for */
  description?: Maybe<Scalars["String"]>;
  /** The optional end date of the entity, inclusive. */
  endDate?: Maybe<Scalars["Date"]>;
  /**
   * The resolved entity - either a SpendLimit or LimitGroup based on entityType.
   * This enables direct access to the full entity data rather than only using materialized fields.
   */
  entity?: Maybe<LimitGroupOrSpendLimitEntity>;
  /** Entity ID - the spend limit or limit group ID */
  entityId: Scalars["ID"];
  /** Whether the entity is a spend limit or limit group */
  entityType: LimitGroupOrSpendLimitEntityType;
  /** Determines if members are allowed to view other members' expenses. */
  expenseVisibility?: Maybe<SpendLimitExpenseVisibility>;
  /** Logical ID */
  id: Scalars["ID"];
  /**
   * Whether the legal entity is explicitly mapped to the entity
   *
   * If true, the legal entity is explicitly mapped to the entity
   * Otherwise, the legal entity is derived from the entity's ancestry
   */
  legalEntityExplicitlySet?: Maybe<Scalars["Boolean"]>;
  /** [Optional] The legal entity override for the entity */
  legalEntityId?: Maybe<Scalars["String"]>;
  /** The policy that manages approval chain for limit increase requests. */
  limitApprovalPolicyId?: Maybe<Scalars["String"]>;
  /**
   * Budget limit increase requests
   * Takes in an active filter (to fetch limit increase requests currently applied to the budget).
   */
  limitIncreaseRequests: Array<Maybe<BudgetLimitIncreaseRequestEntity>>;
  /** Whether the limit increase feature is enabled for this entity */
  limitIncreaseSetting?: Maybe<LimitIncreaseSetting>;
  /** The employees who are considered members of this entity (nullable for partial failure) */
  members?: Maybe<UserConnection>;
  /** Merchant category controls, including those along ancestry path. */
  merchantCategoryControls?: Maybe<MerchantCategoryControls>;
  /** Name of the entity */
  name?: Maybe<Scalars["String"]>;
  /** The employees who are considered owners of this entity (nullable for partial failure) */
  owners?: Maybe<UserConnection>;
  /** The parent of this entity, if any */
  parentBudget?: Maybe<SpendBudget>;
  /** The recurring period type. */
  periodRecurrenceType?: Maybe<SpendLimitPeriodType>;
  /** The policy governing this entity */
  policy?: Maybe<Policy>;
  /** For a spend limit, the ID of the associated limit group, if any */
  provisionedBy?: Maybe<Scalars["ID"]>;
  /** For a spend limit, the associated limit group, if any */
  provisionedByLimitGroup?: Maybe<LimitGroup>;
  /** The ID of the legacy template, for spend limits */
  spendLimitTemplateId?: Maybe<Scalars["ID"]>;
  /** Allowed spend sources on a Spend Limit. */
  spendSourceSetting?: Maybe<SpendSourceSetting>;
  /**
   * For a spend limit, the total spendable limit, including limit increases and rollover
   * For a limit group, the sum of all spendable limits of its associated spend limits
   * Null if spend limits have different currencies
   */
  spendableLimit?: Maybe<FinancialAsset>;
  /** The optional end date of the entity, inclusive. */
  startDate?: Maybe<Scalars["Date"]>;
  /** Status of the entity */
  status?: Maybe<LimitGroupOrSpendLimitStatus>;
  /** The timezone of the entity */
  timezone?: Maybe<Scalars["String"]>;
  /**
   * The transaction limit mapped to the entity.
   * Null if no transaction limit is set.
   */
  transactionLimit?: Maybe<FinancialAsset>;
  /** Time when the entity was created */
  updatedAt?: Maybe<Scalars["Time"]>;
  /** The percentage of the spendable limit that has been used this period */
  usagePercentage?: Maybe<Scalars["Int"]>;
  /** The amount spent for the current user, this is only applicable to spend limits. */
  userAmountSpent?: Maybe<FinancialAsset>;
  /** The user group associated with this entity */
  userGroup?: Maybe<Group>;
}

export interface LimitGroupOrSpendLimitallowedOperationsArgs {
  operations: Array<LimitGroupOrSpendLimitOperation>;
}

export interface LimitGroupOrSpendLimitancestralOwnersArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<SpendLimitPersonnelFilter>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  order?: InputMaybe<SpendLimitPersonnelOrder>;
  page?: InputMaybe<PaginationInput>;
}

export interface LimitGroupOrSpendLimitcardsSummaryArgs {
  input: BudgetsCardsSummaryInput;
}

export interface LimitGroupOrSpendLimitlimitIncreaseRequestsArgs {
  active?: InputMaybe<Scalars["Boolean"]>;
}

export interface LimitGroupOrSpendLimitmembersArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<SpendLimitPersonnelFilter>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  order?: InputMaybe<SpendLimitPersonnelOrder>;
  page?: InputMaybe<PaginationInput>;
}

export interface LimitGroupOrSpendLimitownersArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<SpendLimitPersonnelFilter>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  order?: InputMaybe<SpendLimitPersonnelOrder>;
  page?: InputMaybe<PaginationInput>;
}

export enum LimitGroupOrSpendLimitAccess {
  /** Limit group or spend limit is set and current user has access to it */
  ACCESSIBLE = "ACCESSIBLE",
  /** Limit group or spend limit is set and current user does not have access due to permissions */
  NOT_ACCESSIBLE = "NOT_ACCESSIBLE",
  /** Limit group or spend limit is missing */
  NOT_SET = "NOT_SET",
}

/** A LimitGroupOrSpendLimit connection for LimitGroupOrSpendLimit pagination. */
export interface LimitGroupOrSpendLimitConnection extends Connection {
  /** The LG/SLs in the current page of results. */
  edges: Array<LimitGroupOrSpendLimitEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of LG/SLs matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

/** A LimitGroupOrSpendLimit edge for the LimitGroupOrSpendLimit connection. */
export interface LimitGroupOrSpendLimitEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The LimitGroupOrSpendLimit at this edge. */
  node: LimitGroupOrSpendLimit;
}

/** A union representing either a SpendLimit or LimitGroup entity */
export type LimitGroupOrSpendLimitEntity = LimitGroup | SpendLimit;

export enum LimitGroupOrSpendLimitEntityType {
  LIMIT_GROUP = "LIMIT_GROUP",
  SPEND_LIMIT = "SPEND_LIMIT",
}

export interface LimitGroupOrSpendLimitFilterInput {
  /** Whether or not the LimitGroupOrSpendLimit is authable (Ex. Expense reports have authable=false) */
  authable?: InputMaybe<Scalars["Boolean"]>;
  /** Filter by budgetIds (also works for limit group ids) */
  budgetIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Filter to include the listed template ids */
  budgetTemplateIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Match IN specific associated cards */
  cardIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Filter by entity type (LIMIT_GROUP or SPEND_LIMIT) */
  entityType?: InputMaybe<LimitGroupOrSpendLimitEntityType>;
  /** Exclude spend limits associated with a limit group */
  excludeProvisionedLimits?: InputMaybe<Scalars["Boolean"]>;
  /** Match IN specific members (excludes limit groups) */
  memberCustomerUserIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Search LimitGroupOrSpendLimit by name */
  name?: InputMaybe<Scalars["String"]>;
  /** Whether or not the LimitGroupOrSpendLimit has a virtual card */
  onlyProvisionedCardSpend?: InputMaybe<Scalars["Boolean"]>;
  /** Match IN specific owners, including ancestrally owned, which means owner of a parent budget. */
  ownerCustomerUserIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Filter by parent budget ids */
  parentBudgetIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Filter by period recurrencce types */
  periodRecurrenceTypes?: InputMaybe<Array<SpendLimitPeriodRecurrenceType>>;
  /** Filter LimitGroupOrSpendLimit by the policy they are using. */
  policyIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Only include spend limits associated with specific limit groups */
  provisionedBy?: InputMaybe<Array<Scalars["ID"]>>;
  /** Search spend limits by name or associated cards' last four */
  search?: InputMaybe<Scalars["String"]>;
  /** LimitGroupOrSpendLimit Status IN statuses */
  statuses?: InputMaybe<Array<SpendLimitStatus>>;
}

export enum LimitGroupOrSpendLimitOperation {
  /** Update the entity's status to archived */
  ARCHIVE = "ARCHIVE",
  /** Convert the spend limit to a purchasing card. This operation is only available for spend limits */
  CONVERT_TO_PURCHASING_CARD = "CONVERT_TO_PURCHASING_CARD",
  /** Update the entity's status to deleted */
  DELETE = "DELETE",
  /** Update any of the entity's fields */
  EDIT_FULL = "EDIT_FULL",
  /** Update the entity's owners and members */
  EDIT_USERS = "EDIT_USERS",
  /** Reassign the entity to a new parent */
  MOVE = "MOVE",
  /** Update the entity's status from archived or expired to active */
  REOPEN = "REOPEN",
  /** Create a limit increase request */
  REQUEST_LIMIT_INCREASE = "REQUEST_LIMIT_INCREASE",
  /** View other member's expenses for the entity */
  VIEW_EXPENSES = "VIEW_EXPENSES",
  /** View the entity's limit. Disabled for members if the limit is masked */
  VIEW_LIMIT = "VIEW_LIMIT",
  /** View the entity's owners and members */
  VIEW_USERS = "VIEW_USERS",
}

export interface LimitGroupOrSpendLimitOperationPermission {
  allowed: Scalars["Boolean"];
  disabledReason?: Maybe<Array<Scalars["String"]>>;
  operation: LimitGroupOrSpendLimitOperation;
}

export interface LimitGroupOrSpendLimitOrderInput {
  direction: OrderByDirection;
  field: SortableLimitGroupOrSpendLimitField;
}

/** Possible statuses for a LimitGroupOrSpendLimit */
export enum LimitGroupOrSpendLimitStatus {
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
  DELETED = "DELETED",
  EXPIRED = "EXPIRED",
}

export interface LimitGroupOrderInput {
  direction: OrderByDirection;
  field: SortableLimitGroupField;
}

/** Limit group member condition for overrides */
export interface LimitGroupOverrideMemberCondition {
  /**
   * Member condition serialized as JSON. Callers don't know the structure of the member condition ahead of time, so we
   * need to return this field as a String instead of a GraphQL type.
   */
  memberCondition?: Maybe<Scalars["String"]>;
  /** Additional members of the overridden group. When this field is set it will be unioned with the member condition. */
  members?: Maybe<UserConnection>;
}

/** Limit group member condition for overrides */
export interface LimitGroupOverrideMemberConditionmembersArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
}

/** Limit group overrides on eligible fields */
export interface LimitGroupOverrides {
  /** Overrides on the limit field of a spend limit */
  limit?: Maybe<Array<LimitGroupFinancialAssetFieldOverride>>;
}

export interface LimitGroupPreviewMember {
  limit: FinancialAsset;
  membershipStatus: LimitGroupPreviewMembershipStatus;
  user: User;
}

export interface LimitGroupPreviewMemberConnection extends Connection {
  edges: Array<LimitGroupPreviewMemberEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface LimitGroupPreviewMemberEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<LimitGroupPreviewMember>;
}

export enum LimitGroupPreviewMembershipStatus {
  /** User wasn't part of the group and was added */
  ADDED = "ADDED",
  /** User is part of the group, and some fields were overridden */
  OVERRIDDEN = "OVERRIDDEN",
  /** User was part of the group and was removed */
  REMOVED = "REMOVED",
  /** User is part of the group, and no changes happened */
  UNCHANGED = "UNCHANGED",
}

/** Possible statuses for a limit group propagation job */
export enum LimitGroupPropagationStatus {
  /** Status indicating that limit group propagation has been completed successfully */
  COMPLETED = "COMPLETED",
  /** Status indicating that limit group propagation has been enqueued but not yet started */
  ENQUEUED = "ENQUEUED",
  /** Status indicating that limit group propagation to budgets has failed */
  FAILED = "FAILED",
  /** Status indicating that limit group propagation is currently in progress */
  IN_PROGRESS = "IN_PROGRESS",
}

/** Possible statuses for a limit group */
export enum LimitGroupStatus {
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
  DELETED = "DELETED",
  EXPIRED = "EXPIRED",
}

/** User attributes fields for querying qualifying limit groups. */
export interface LimitGroupUserAttributesInput {
  /** The costCenterId for the user. */
  costCenterId?: InputMaybe<Scalars["String"]>;
  /** The departmentId for the user. */
  departmentId?: InputMaybe<Scalars["String"]>;
  /** The time the user was invited to Brex. Defaults to the current timestamp if not provided */
  invitedAt?: InputMaybe<Scalars["Time"]>;
  /** The legalEntityId for the user. */
  legalEntityId?: InputMaybe<Scalars["String"]>;
  /** The locationId for the user. */
  locationId?: InputMaybe<Scalars["String"]>;
  /** The ID of the user's manager. */
  managerId?: InputMaybe<Scalars["String"]>;
  /** The ID of the user's title. */
  titleId?: InputMaybe<Scalars["String"]>;
}

export interface LimitIncreaseRequest {
  concludedAt?: Maybe<Scalars["Time"]>;
  createdAt?: Maybe<Scalars["Time"]>;
  customerAccountId: Scalars["String"];
  expectedMonthlyCreditUsage: FinancialAsset;
  id: Scalars["ID"];
  limitAtRequestTime?: Maybe<FinancialAsset>;
  otherReason?: Maybe<Scalars["String"]>;
  pendingRfi?: Maybe<LimitIncreaseRequestRfi>;
  reason: LimitIncreaseRequestReason;
  requestedBy?: Maybe<Employee>;
  result?: Maybe<LimitIncreaseRequestResult>;
  status: LimitIncreaseRequestStatus;
}

export interface LimitIncreaseRequestEligibilityResponse {
  eligible: Scalars["Boolean"];
  ineligibilityReasons?: Maybe<Array<LimitIncreaseRequestIneligibilityReason>>;
}

export enum LimitIncreaseRequestIneligibilityReason {
  CUSTOMER_IN_MANUAL_REVIEW = "CUSTOMER_IN_MANUAL_REVIEW",
  OUTSTANDING_LIMIT_INCREASE_REQUEST = "OUTSTANDING_LIMIT_INCREASE_REQUEST",
  RECENT_LIMIT_INCREASE_REQUEST_EXISTS = "RECENT_LIMIT_INCREASE_REQUEST_EXISTS",
  SPEND_BASED_LIMIT_LESS_THAN_CURRENT_LIMIT = "SPEND_BASED_LIMIT_LESS_THAN_CURRENT_LIMIT",
  UNDERWRITING_MODEL_INELIGIBLE = "UNDERWRITING_MODEL_INELIGIBLE",
}

export enum LimitIncreaseRequestReason {
  HIGHER_EXPENSE_EXPECTED = "HIGHER_EXPENSE_EXPECTED",
  INCREASE_IN_CASH_BALANCE = "INCREASE_IN_CASH_BALANCE",
  LIMIT_TOO_LOW = "LIMIT_TOO_LOW",
  OTHER = "OTHER",
  REDUCE_CREDIT_UTILIZATION = "REDUCE_CREDIT_UTILIZATION",
}

export interface LimitIncreaseRequestResult {
  explanation: LimitIncreaseRequestResultExplanation;
  grantedLimit?: Maybe<FinancialAsset>;
}

export enum LimitIncreaseRequestResultExplanation {
  APPROVED_GENERIC = "APPROVED_GENERIC",
  PARTIAL_APPROVED_LOW_HISTORIC_SPEND = "PARTIAL_APPROVED_LOW_HISTORIC_SPEND",
  PARTIAL_APPROVED_NOT_SUFFICIENT_FUNDS = "PARTIAL_APPROVED_NOT_SUFFICIENT_FUNDS",
  REJECTED_CONTACT_SUPPORT = "REJECTED_CONTACT_SUPPORT",
  REJECTED_GENERIC = "REJECTED_GENERIC",
  REJECTED_LOW_HISTORIC_SPEND = "REJECTED_LOW_HISTORIC_SPEND",
  REJECTED_NOT_SUFFICIENT_FUNDS = "REJECTED_NOT_SUFFICIENT_FUNDS",
  REJECTED_NO_RESPONSE = "REJECTED_NO_RESPONSE",
}

export interface LimitIncreaseRequestRfi {
  caseNumber: Scalars["String"];
  id: Scalars["ID"];
}

export enum LimitIncreaseRequestStatus {
  GRANTED = "GRANTED",
  PENDING = "PENDING",
  REJECTED = "REJECTED",
}

/**
 * Whether limit increase request feature is enabled on a spend limit
 * (Replaces limitIncreaseRequestEnabled boolean)
 */
export enum LimitIncreaseSetting {
  DISABLED = "DISABLED",
  ENABLED = "ENABLED",
}

/** Frequency at which the limit amount resets to its original value and spent amounts are zeroed */
export enum LimitResetFrequency {
  /** Limit never resets */
  ONE_TIME = "ONE_TIME",
  /** Limit resets on the first day of each month */
  PER_MONTH = "PER_MONTH",
  /** Limit resets every three months */
  PER_QUARTER = "PER_QUARTER",
  /** Limit resets every week on Monday */
  PER_WEEK = "PER_WEEK",
  /** Limit resets annually */
  PER_YEAR = "PER_YEAR",
}

/** The exact settings that control how limits are configured and enforced */
export interface LimitSettings {
  /** Limit amounts and balances. Null if visibility is HIDDEN */
  limitDetails?: Maybe<LimitDetails>;
  /** Settings that control how the limit is enforced and any flexibility in enforcement */
  limitEnforcementSettings?: Maybe<LimitEnforcementSettings>;
  /**
   * The date that this limit resets based on the limitResetFrequency
   * Null if the limit has not started yet
   */
  limitResetDate?: Maybe<Scalars["Date"]>;
  /** The cadence in which this limit resets */
  limitResetFrequency?: Maybe<LimitResetFrequency>;
  /** Controls whether spenders can see the limit amounts and authorization settings */
  limitVisibility: LimitVisibility;
  /**
   * Maximum amount allowed for a single transaction/expense.
   * Any transaction exceeding this amount will be declined, regardless of available balance.
   * Null if no per-transaction limit is set.
   */
  perTransactionLimit?: Maybe<FinancialAsset>;
}

/** The source of a limit that controls and restricts expenditures, making sure they stay within periodic thresholds */
export interface LimitSource {
  /** The exact settings that govern authorizations.  */
  authSettings?: Maybe<AuthorizationSettings>;
  /** Logical ID */
  id: Scalars["ID"];
  /** The exact settings that govern whether users can request for limit changes */
  limitChangeSettings?: Maybe<LimitChangeSettings>;
  /** Name of the LimitSource */
  name: Scalars["String"];
  /** The policy used for authorizing spend */
  policy?: Maybe<Policy>;
  /** Amount spent in the period defined by the reset frequency */
  spent?: Maybe<FinancialAsset>;
  /** Amount spent by the requesting user in the period defined by the reset frequency */
  userSpent?: Maybe<FinancialAsset>;
}

export interface LimitSourceEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The limit source */
  node: LimitSource;
}

export interface LimitSourceFilterInput {
  /** Filter to only show limit sources that allow limit change requests */
  allowsLimitChangeRequests?: InputMaybe<Scalars["Boolean"]>;
  /** Search limit sources by name */
  name?: InputMaybe<Scalars["String"]>;
  /** Filter by the type of LimitSource */
  type?: InputMaybe<Array<LimitSourceType>>;
}

export interface LimitSourceIncrease {
  /** The date when the increase will expire and be removed from the limit */
  expiresAt: Scalars["Date"];
  /** The amount of the increase */
  increaseAmount: FinancialAsset;
}

/** A request to increase a limit source. */
export interface LimitSourceIncreaseRequest extends Node {
  /** Comment thread associated with a limit source increase request. */
  commentThread?: Maybe<CommentThread>;
  /** When the limit increase expires. */
  endDate?: Maybe<Scalars["Date"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  /** Amount to increase the limit if the request is approved. */
  increaseAmount: FinancialAsset;
  /** The limit source targeted by this increase. */
  limitSource?: Maybe<LimitSource>;
  /** Reason to increase the limit. */
  reason?: Maybe<Scalars["String"]>;
  /** The Requests service request instance. */
  request?: Maybe<BudgetRequest>;
  /** Current version of the request. */
  version?: Maybe<Scalars["Int"]>;
}

/** Input to approve a limit increase request. */
export interface LimitSourceIncreaseRequestApproveInput {
  isAdminOverride?: InputMaybe<Scalars["Boolean"]>;
  limitSourceIncreaseRequestId: Scalars["ID"];
  version: Scalars["Int"];
}

/** Input type to cancel a limit increase request */
export interface LimitSourceIncreaseRequestCancelInput {
  limitSourceIncreaseRequestId: Scalars["ID"];
}

/** Input to create a limit source increase request. */
export interface LimitSourceIncreaseRequestCreateInput {
  /** The unique ID of the mutation, used as idempotency key. */
  clientMutationId: Scalars["String"];
  /** When the limit increase expires. */
  endDate?: InputMaybe<Scalars["Date"]>;
  /** The amount to increase the limit. */
  increaseAmount: FinancialAssetInput;
  /** The reason of the limit increase. Optional. */
  reason?: InputMaybe<Scalars["String"]>;
  /**
   * The ID of the target.
   * For now this could be the ID of a spend limit or the user ID for user limits.
   */
  targetId: Scalars["String"];
  /** The type of limit source targeted by this limit increase. */
  targetType: LimitSourceIncreaseRequestTargetType;
}

/** Errors that occur for mutations for limit increase requests */
export interface LimitSourceIncreaseRequestMutationError extends MutationError {
  errors?: Maybe<Array<LimitSourceIncreaseRequestMutationValidationError>>;
}

/** Result of the mutation of a limit increase request */
export type LimitSourceIncreaseRequestMutationResult =
  | LimitSourceIncreaseRequest
  | LimitSourceIncreaseRequestMutationError;

/** Error that occur when validating inputs for mutations for limit increase requests */
export interface LimitSourceIncreaseRequestMutationValidationError
  extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
  validationErrorCode?: Maybe<LimitSourceIncreaseRequestMutationValidationErrorCode>;
}

/** Validation error codes that can occur when validating limit increases during mutations */
export enum LimitSourceIncreaseRequestMutationValidationErrorCode {
  STALE_VERSION_BEING_MUTATED = "STALE_VERSION_BEING_MUTATED",
}

/** Input type to reject a limit increase request */
export interface LimitSourceIncreaseRequestRejectInput {
  limitSourceIncreaseRequestId: Scalars["ID"];
}

export enum LimitSourceIncreaseRequestTargetType {
  SPEND_LIMIT = "SPEND_LIMIT",
  USER_LIMIT = "USER_LIMIT",
}

/** Input to update the end date of the limit increase request. */
export interface LimitSourceIncreaseRequestUpdateEndDateInput {
  /** When the limit increase expires. */
  endDate?: InputMaybe<Scalars["Date"]>;
  /** The ID of the limit increase request. */
  limitSourceIncreaseRequestId: Scalars["ID"];
}

/** Input to update the increase amount of the limit increase request. */
export interface LimitSourceIncreaseRequestUpdateIncreaseAmountInput {
  /** The amount to increase the limit. */
  increaseAmount: FinancialAssetInput;
  /** The ID of the limit increase request. */
  limitSourceIncreaseRequestId: Scalars["ID"];
}

/** Input to update the reason of the limit increase request. */
export interface LimitSourceIncreaseRequestUpdateReasonInput {
  /** The ID of the limit increase request. */
  limitSourceIncreaseRequestId: Scalars["ID"];
  /** The reason of the limit increase. Optional. */
  reason?: InputMaybe<Scalars["String"]>;
}

export enum LimitSourceType {
  PURCHASING_LIMIT = "PURCHASING_LIMIT",
  SPEND_LIMIT = "SPEND_LIMIT",
  USER_LIMIT = "USER_LIMIT",
}

export interface LimitSourcesConnection extends Connection {
  /** The limits sources in the current page of results. */
  edges: Array<LimitSourceEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of limits sources specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

/**
 * The type of spend limit for filtering expenses by limit groups or spend limits.
 * SPEND limits control general spending, while PURCHASING limits control purchasing card transactions.
 */
export enum LimitType {
  PURCHASING = "PURCHASING",
  SPEND = "SPEND",
}

export enum LimitUtilizationSurvey {
  UPSELL_OPTED_OUT = "UPSELL_OPTED_OUT",
}

export interface LimitUtilizationTrigger extends Node {
  activeConfiguration: LimitUtilizationTriggerConfiguration;
  customerAccountId: Scalars["String"];
  evaluatedAt?: Maybe<Scalars["Time"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  insertedAt: Scalars["Time"];
  updatedAt?: Maybe<Scalars["Time"]>;
}

export interface LimitUtilizationTriggerConfiguration extends Node {
  action: LimitUtilizationTriggerConfigurationAction;
  /** The ID of an object */
  id: Scalars["ID"];
  insertedAt: Scalars["Time"];
  metadata: LimitUtilizationTriggerConfigurationMetadata;
  status: LimitUtilizationTriggerConfigurationStatus;
  triggerId: Scalars["ID"];
}

export enum LimitUtilizationTriggerConfigurationAction {
  GLOBAL_LIMIT_HIT_WARNING = "GLOBAL_LIMIT_HIT_WARNING",
  INVALID = "INVALID",
  PREPAY = "PREPAY",
  SEND_COMMS = "SEND_COMMS",
}

export type LimitUtilizationTriggerConfigurationMetadata =
  | GlobalLimitHitWarningMetadata
  | PrepayMetadata
  | SendCommsMetadata;

export enum LimitUtilizationTriggerConfigurationSendCommsType {
  EMAIL = "EMAIL",
  EMAIL_AND_SMS = "EMAIL_AND_SMS",
  INVALID = "INVALID",
}

export enum LimitUtilizationTriggerConfigurationStatus {
  DISABLED = "DISABLED",
  ENABLED = "ENABLED",
  INVALID = "INVALID",
}

/** Controls whether limit amounts and settings are visible to members using the limit */
export enum LimitVisibility {
  /** Members cannot see limit amounts or settings, but can still spend */
  HIDDEN = "HIDDEN",
  /** Members can see their limit amounts, balances, and authorization settings */
  VISIBLE_TO_MEMBERS = "VISIBLE_TO_MEMBERS",
}

export interface LimitsExperienceMutationError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface LineAxisData {
  legend: GraphLegendType;
  xValues: Array<Scalars["String"]>;
  yValues: Array<Scalars["String"]>;
}

export enum LineItemCategory {
  ACID = "ACID",
  ALCOHOL = "ALCOHOL",
  CIGARETTES = "CIGARETTES",
  FLIGHT_UPGRADE = "FLIGHT_UPGRADE",
  GIFT_CARD = "GIFT_CARD",
  LAWNMOWERS = "LAWNMOWERS",
  LOTTERY_TICKET = "LOTTERY_TICKET",
  NO_SALES_TAX = "NO_SALES_TAX",
  POLITICAL_SPEND = "POLITICAL_SPEND",
}

export interface LineItemData {
  /** End date */
  endDate?: Maybe<Scalars["Date"]>;
  /** Quantity */
  quantity?: Maybe<Scalars["Int"]>;
  /** Start date */
  startDate?: Maybe<Scalars["Date"]>;
  /** Unit price */
  unitPrice?: Maybe<FinancialAsset>;
}

export interface LineItemDetail {
  /** The description of the line item */
  description?: Maybe<Scalars["String"]>;
  /** The item net adjustment (eg. discount). */
  netAdjustment?: Maybe<FinancialAsset>;
  /** The product code */
  productCode?: Maybe<Scalars["String"]>;
  /** The quantity of the line item */
  quantity?: Maybe<Scalars["Decimal"]>;
  /** The sub total amount. */
  subtotalAmount?: Maybe<FinancialAsset>;
  /** The tax amount of the line item */
  taxAmount?: Maybe<FinancialAsset>;
  /** The total amount. */
  totalAmount?: Maybe<FinancialAsset>;
  /** The unit amount of the line item */
  unitAmount?: Maybe<FinancialAsset>;
}

export interface LineItemInput {
  /** The extended field values */
  extendedFieldValueInputs?: InputMaybe<Array<ExpenseExtendedFieldValueInput>>;
  /** Line item memo/description */
  memo?: InputMaybe<Scalars["String"]>;
  /** Amount of line item */
  purchasedAmount?: InputMaybe<FinancialAssetInput>;
}

export interface LineItemPair {
  /** Line item data */
  items?: Maybe<Array<Maybe<LineItemData>>>;
  /** Line item name */
  key?: Maybe<Scalars["String"]>;
}

export interface LineItemsAddendum extends ExpenseAddendum {
  /** The unique ID of the expense addendum. */
  id: Scalars["ID"];
  /** The line item details */
  lineItems: Array<LineItemDetail>;
}

export interface LineMetricsGraph {
  data: Array<LineAxisData>;
  xAxisUnit: MetricUnit;
  yAxisUnit: MetricUnit;
}

export interface LinkExistingUberOrganizationData {
  /** External Uber URL used to link the existing Uber for Business organization. */
  url: Scalars["String"];
}

export interface LinkExistingUberOrganizationDataInput {
  /** Brex landing page which the Uber website will redirect back to when linking is complete. */
  redirectUrl: Scalars["String"];
}

export enum LinkedVendorErpName {
  NETSUITE = "NETSUITE",
  QBO = "QBO",
}

export interface ListAccountingSubsidiarySettingsFilterInput {
  /** Optional, The name of the subsidiary to filter by. */
  name?: InputMaybe<Scalars["String"]>;
  /** Optional, The statuses of the subsidiary to filter by. */
  statuses?: InputMaybe<Array<SubsidiaryConnectionStatus>>;
  /** Optional, The IDs of the subsidiary to filter by. */
  subsidiaryIds?: InputMaybe<Array<Scalars["ID"]>>;
}

export interface ListAlertsFilterInput {
  read?: InputMaybe<Scalars["Boolean"]>;
}

export interface ListAlertsInput {
  filter?: InputMaybe<ListAlertsFilterInput>;
  page?: InputMaybe<PaginationInput>;
}

export interface ListAttendeesSuggestionInformation {
  attendees: Array<AttendeeSuggestion>;
  /** Data entities used to generate the content of the suggestion. */
  expenseSuggestionOriginEntities: Array<ExpenseSuggestionOriginEntity>;
}

export interface ListCredentialFilterInput {
  credentialIds?: InputMaybe<Array<Scalars["ID"]>>;
  credentialStatus?: InputMaybe<Array<CredentialStatus>>;
  credentialVendors?: InputMaybe<Array<CredentialVendor>>;
  customerAccountIds?: InputMaybe<Array<Scalars["ID"]>>;
  customerUserIds?: InputMaybe<Array<Scalars["ID"]>>;
}

export interface ListCredentialsInput {
  filter: ListCredentialFilterInput;
  paginationInput?: InputMaybe<PaginationInput>;
}

export interface ListCredentialsResult extends Connection {
  edges?: Maybe<Array<Maybe<VendorCredentialEdge>>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface ListOfStatementsWithDownloadUrls {
  edges?: Maybe<Array<StatementWithDownloadUrlEdge>>;
}

/** Specifies the type of operation to apply to a list of values in the universal query matcher */
export enum ListOperator {
  /** Match if any of the values in the list match */
  IN = "IN",
  /** Match if none of the values in the list match */
  NOT_IN = "NOT_IN",
}

export interface ListPartnerCodesInput {
  types?: InputMaybe<Array<PartnerCodeType>>;
}

export interface ListReferralRecordsConnection extends Connection {
  /** referral record at this edge */
  edges: Array<ListReferralRecordsEdge>;
  /** page information */
  pageInfo: PageInfo;
  /** total count across all page matching the filter criteria */
  totalCount: Scalars["Int"];
}

export interface ListReferralRecordsEdge {
  /** opaque cursor of the current edge */
  cursor?: Maybe<Scalars["String"]>;
  /** referral at this edge */
  node: ReferralRecordEntry;
}

export enum ListReferralRecordsOrderField {
  INSERTED_AT = "INSERTED_AT",
}

export interface ListReferralRecordsOrderInput {
  /** direction */
  direction: OrderByDirection;
  /** What field is being ordered on */
  field: ListReferralRecordsOrderField;
}

export interface ListSandboxAccountActionsEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The sandbox account action at this edge. */
  node: SandboxAccountAction;
}

export interface ListSandboxAccountActionsFilterInput {
  /** Match IN specific statuses, match ALL when no filter is provided */
  statuses?: InputMaybe<Array<SandboxAccountActionStatus>>;
  /** Match IN specific types, match ALL when no filter is provided */
  types?: InputMaybe<Array<SandboxAccountActionType>>;
}

export enum ListSandboxAccountActionsOrderField {
  INSERTED_AT = "INSERTED_AT",
  TYPE = "TYPE",
}

export interface ListSandboxAccountActionsOrderInput {
  /** Direction */
  direction: OrderByDirection;
  /** Which field is being sorted on */
  field: ListSandboxAccountActionsOrderField;
}

export interface ListSandboxAccountActionsResult extends Connection {
  /** The request sandbox account actions in the current page of results. */
  edges: Array<ListSandboxAccountActionsEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of sandbox account actions matching the filter criteria specified for this connection. */
  totalCount: Scalars["Int"];
}

/** Filter is ANDed together for listing rules */
export interface ListWorkflowRulesFilterInput {
  /**
   * Display name to query for (ILIKE).
   * Will be ignored if no display name is provided.
   */
  displayName?: InputMaybe<Scalars["String"]>;
  /** Evaluation statuses to filter for. Will be ignored if null or empty */
  evaluationStatuses?: InputMaybe<Array<WorkflowRuleEvaluationStatus>>;
  /**
   * Rule IDs to filter for (IN)
   * Will be ignored if null or empty
   */
  ruleIds?: InputMaybe<Array<Scalars["ID"]>>;
  /**
   * Tags will be AND'd together
   * The AND will include the set of `tagsOr` if both are provided
   * i.e. AND(...tags, OR(...tagsOr))
   */
  tags?: InputMaybe<Array<WorkflowRuleTagFilterInput>>;
  /**
   * Tags will be OR'd together
   * The entire set will be included in the `tags` AND if both are provided
   * i.e. AND(...tags, OR(...tagsOr))
   */
  tagsOr?: InputMaybe<Array<WorkflowRuleTagFilterInput>>;
  /**
   * Value references will be AND'd together
   * The AND will include the set of `valueReferencesOr` if both are provided
   * i.e. AND(...valueReferences, OR(...valueReferencesOr))
   */
  valueReferences?: InputMaybe<Array<WorkflowRuleValueReferenceFilterInput>>;
  /**
   * Value references will be OR'd together
   * The entire set will be included in the `valueReferences` AND if both are provided
   * i.e. AND(...valueReferences, OR(...valueReferencesOr))
   */
  valueReferencesOr?: InputMaybe<Array<WorkflowRuleValueReferenceFilterInput>>;
  /** Workflow types to filter for. Will be ignored if null or empty */
  workflows?: InputMaybe<Array<Workflow>>;
}

export interface LocalRecentSearchItem extends RecentSearchItem {
  lastTimeSearched: Scalars["Time"];
  searchItem: RecentLocalSearch;
}

/**
 * A locale is the combination of language, region and optionally script that together define the language preferences and conventions for a particular entity.
 *
 * Follows the IETF BCP 47 standard, e.g. "en-US", "pt-BR", "fr", etc.
 */
export interface Locale {
  /** The full locale tag, including the language tag and optional subtags (e.g., region). */
  languageTag: Scalars["String"];
}

export interface Location extends Node {
  deletedAt?: Maybe<Scalars["Time"]>;
  description?: Maybe<Scalars["String"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  /** Number of employees associated with the location */
  membersCount?: Maybe<Scalars["Int"]>;
  name?: Maybe<Scalars["String"]>;
}

/**
 * Represents an arbitrary location (city, address, or point of interest)
 * returned by hotel or car searches.
 */
export interface LocationAutocompleteResult {
  location: TravelLocation;
  name: Scalars["String"];
}

/** Location connection for pagination */
export interface LocationConnection extends Connection {
  edges: Array<LocationEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

/** Location edge for the Location connection. */
export interface LocationEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<Location>;
}

export interface LocationIdentifier {
  id?: InputMaybe<Scalars["ID"]>;
  name?: InputMaybe<Scalars["String"]>;
  type: LocationIdentifierType;
}

export enum LocationIdentifierType {
  ID = "ID",
  NAME = "NAME",
}

export interface LocationMetadata {
  address?: Maybe<Scalars["String"]>;
  displayName: Scalars["String"];
  googlePlaceId?: Maybe<Scalars["String"]>;
}

export interface LocationMetadataInput {
  address?: InputMaybe<Scalars["String"]>;
  displayName: Scalars["String"];
  googlePlaceId?: InputMaybe<Scalars["String"]>;
}

/** Filters for list locations query. */
export interface LocationsFilterInput {
  /** Filter by location ID. */
  id?: InputMaybe<Scalars["ID"]>;
  query?: InputMaybe<Scalars["String"]>;
}

/** Input for locking the Purchasing Card */
export interface LockPurchasingCardInput {
  /** The card ID associated with the Purchasing Card */
  cardId: Scalars["ID"];
  /** The idempotency key */
  clientMutationId: Scalars["String"];
}

export interface LockPurchasingCardResult extends MutationResult {
  cards?: Maybe<Array<Card>>;
  errors?: Maybe<Array<PurchasingCardMutationError>>;
  spendLimit?: Maybe<SpendLimit>;
}

export interface LodgeCardRequestLeadDetailsInput {
  companyName?: InputMaybe<Scalars["String"]>;
  currentlyPayForTravel?: InputMaybe<Scalars["String"]>;
  expenseDataReconciliation?: InputMaybe<Scalars["String"]>;
  monthlyTravelSpend?: InputMaybe<Scalars["String"]>;
  travelManagementCompany?: InputMaybe<Scalars["String"]>;
}

export interface LodgeCardRequestLeadDetailsObject {
  companyName?: Maybe<Scalars["String"]>;
  currentlyPayForTravel?: Maybe<Scalars["String"]>;
  expenseDataReconciliation?: Maybe<Scalars["String"]>;
  monthlyTravelSpend?: Maybe<Scalars["String"]>;
  travelManagementCompany?: Maybe<Scalars["String"]>;
}

export enum LodgeCardStatus {
  LODGE_CARD = "LODGE_CARD",
  NOT_LODGE_CARD = "NOT_LODGE_CARD",
}

export interface LodgingAddendum extends ExpenseAddendum {
  /** The check-in time. */
  checkInTime?: Maybe<Scalars["Time"]>;
  /** A time zone offset for the check-in time in seconds. */
  checkInTimezoneOffsetSeconds?: Maybe<Scalars["Int"]>;
  /** The check-out time. */
  checkoutTime?: Maybe<Scalars["Time"]>;
  /** A time zone offset for the checkout time in seconds. */
  checkoutTimezoneOffsetSeconds?: Maybe<Scalars["Int"]>;
  /** The Folio number. */
  folioNumber?: Maybe<Scalars["String"]>;
  /** The unique ID of the expense addendum. */
  id: Scalars["ID"];
  /** The phone number of the hotel. */
  propertyPhoneNumber?: Maybe<Scalars["String"]>;
}

/**
 * Describes filtering by logical OR at multiple attributes. For example, users with certain titles or who belong
 * to certain departments.
 */
export interface LogicalInclusiveOrUserAttributes {
  logicalInclusiveOrCostCenters: Array<Scalars["ID"]>;
  logicalInclusiveOrDepartments: Array<Scalars["ID"]>;
  logicalInclusiveOrLegalEntities: Array<Scalars["ID"]>;
  logicalInclusiveOrLocations: Array<Scalars["ID"]>;
  logicalInclusiveOrTitles: Array<Scalars["ID"]>;
}

export enum LogicalOperator {
  AND = "AND",
  OR = "OR",
}

export enum LoyaltyProgramAllianceV2 {
  /**  Was not snakecase and so will leave like this. */
  EMIRATES_SKYWARDS = "EMIRATES_SKYWARDS",
  ONE_WORLD = "ONE_WORLD",
  SKY_TEAM = "SKY_TEAM",
  STAR_ALLIANCE = "STAR_ALLIANCE",
  TRUEBLUE = "TRUEBLUE",
}

/** A resource representing a loyalty program config. */
export interface LoyaltyProgramConfigV2 {
  /** The airline associated with the loyalty program */
  alliance?: Maybe<LoyaltyProgramAllianceV2>;
  /** The membership id regex of the loyalty program, e.g ^[0-9]{8}$ */
  membershipIdRegex: Scalars["String"];
  /** The minimum number of miles needed for conversion */
  minimumMiles: Scalars["Int"];
}

/** A resource representing a loyalty program with an airline, e.g Asia Miles. */
export interface LoyaltyProgramV2 {
  /** An object containing the loyalty program details. */
  ascendaDetails: AscendaDetailsV2;
  /** The id of the loyalty program, e.g CXASIAMILES */
  ascendaProgramId: Scalars["String"];
  /** The config of the loyalty program, such as minimum miles transferable and whether the program is enabled. */
  config?: Maybe<LoyaltyProgramConfigV2>;
  /** The id of the loyalty program in db, e.g alp_dummyidofprogram */
  id: Scalars["ID"];
  /** The TransferConnect(Ascenda External) url of the airline's logo. */
  imageUrl: Scalars["String"];
  /** The quote of the loyalty program containing the exchange rate. */
  quote?: Maybe<MilesTransferQuoteV2>;
}

/** A Loyalty Program Connection for Loyalty Program pagination. */
export interface LoyaltyProgramV2Connection {
  /** The loyalty programs in the current page of results. */
  edges: Array<LoyaltyProgramV2Edge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of loyalty programs matching the filter criteria specified for this connection. */
  totalCount: Scalars["Int"];
}

export interface LoyaltyProgramV2Edge {
  /** The opaque cursor of the current edge. */
  cursor: Scalars["String"];
  /** The Loyalty Program at the current edge */
  node?: Maybe<LoyaltyProgramV2>;
}

export interface MS365BCAuthPayloadInput {
  clientId: Scalars["String"];
  clientSecret: Scalars["String"];
  companyId: Scalars["String"];
  tenantId: Scalars["String"];
}

export interface MS365BCPayload {
  clientId?: Maybe<Scalars["String"]>;
  clientSecret?: Maybe<Scalars["String"]>;
  companyId?: Maybe<Scalars["String"]>;
  tenantId?: Maybe<Scalars["String"]>;
}

export interface MS365FNOAuthPayloadInput {
  clientId: Scalars["String"];
  clientSecret: Scalars["String"];
  host: Scalars["String"];
  tenantId: Scalars["String"];
}

export interface MS365FNOPayload {
  clientId?: Maybe<Scalars["String"]>;
  clientSecret?: Maybe<Scalars["String"]>;
  host?: Maybe<Scalars["String"]>;
  tenantId?: Maybe<Scalars["String"]>;
}

export interface MainEntityCustomersPayloadInput {
  /** Description of the entity */
  businessDescription: Scalars["String"];
}

export interface MainEntityDetailsPayloadInput {
  /** Estimated monthly card spend */
  estimatedMonthlyCardSpend?: InputMaybe<Scalars["Float"]>;
  /** The industry of the entity */
  industry: Scalars["String"];
  /** Whether this is a public company (deprecated) */
  isPublicCompany?: InputMaybe<Scalars["Boolean"]>;
  /** Legal name of entity */
  legalBusinessName: Scalars["String"];
}

export interface MainEntityDetailsRequestConfig {
  /** Whether to ask the customer for their estimated card spend */
  shouldCollectEstimatedSpend: Scalars["Boolean"];
}

export interface MainEntityOwnershipPayloadInput {
  /** Details about the individuals. */
  individuals?: InputMaybe<Array<KYCIndividual>>;
}

export interface MakeFieldRequiredForExportError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface MakeFieldRequiredForExportInput {
  extendedFieldId: Scalars["ID"];
}

export type MakeFieldRequiredForExportResult =
  | ExtendedField
  | MakeFieldRequiredForExportError;

export interface MandateMetadata {
  mandateId: Scalars["ID"];
  signerCustomerUserId: Scalars["ID"];
}

export interface MandateMetadataInput {
  mandateId: Scalars["ID"];
  signerCustomerUserId: Scalars["ID"];
}

/** User marked payment status for most recent bill */
export interface ManualPushPaymentStatus {
  fullName?: Maybe<Scalars["String"]>;
  insertedAt?: Maybe<Scalars["Time"]>;
  status?: Maybe<PushPaymentStatus>;
}

/** Type describing a global address. */
export interface MapAddress {
  /** The city or town of the location. */
  city?: Maybe<Scalars["String"]>;
  /** 2 digit code for the country/region, in the ISO-3166 Alpha-2 format. */
  countryCode?: Maybe<Scalars["String"]>;
  postalCode?: Maybe<Scalars["String"]>;
  /** Primary address information, such as street. */
  primaryLine?: Maybe<Scalars["String"]>;
  /** Secondary address information, such as house number. */
  secondaryLine?: Maybe<Scalars["String"]>;
  /**
   * Code identifying the highest administrative subdivision of the region, usually a state or province.
   * Follows the ISO-3166-2 format.
   */
  stateCode?: Maybe<Scalars["String"]>;
}

/** Type describing a global address. */
export interface MapAddressInput {
  /** The city or town of the location. */
  city?: InputMaybe<Scalars["String"]>;
  /** 2 digit code for the country/region, in the ISO-3166 Alpha-2 format. */
  countryCode?: InputMaybe<Scalars["String"]>;
  postalCode?: InputMaybe<Scalars["String"]>;
  /** Primary address information, such as street. */
  primaryLine?: InputMaybe<Scalars["String"]>;
  /** Secondary address information, such as house number. */
  secondaryLine?: InputMaybe<Scalars["String"]>;
  /**
   * Code identifying the highest administrative subdivision of the region, usually a state or province.
   * Follows the ISO-3166-2 format.
   */
  stateCode?: InputMaybe<Scalars["String"]>;
}

export interface MapDisplay {
  mapProvider: Scalars["String"];
  mapUrl: Scalars["String"];
}

export interface MapDisplayInput {
  mapProvider: Scalars["String"];
  mapUrl: Scalars["String"];
}

/** Type describing a Location. Will always contain at least one of address or coordinates. */
export interface MapLocation {
  /** Textual address description of the map location. */
  address?: Maybe<MapAddress>;
  /** Numerical coordinates description of map location. */
  coordinates?: Maybe<Coordinates>;
  /**
   * Google's Places API Location Id, as found on Id of the location
   * reference: https://developers.google.com/maps/documentation/places/web-service/place-id
   */
  googlePlaceId?: Maybe<Scalars["String"]>;
  /** IANA Time Zone database time zone name */
  timezoneName?: Maybe<Scalars["String"]>;
}

/** Input type for creating a MapLocation. Requires at least one of "address" or "coordinates" to be present. */
export interface MapLocationInput {
  /** Textual address description of the map location. */
  address?: InputMaybe<MapAddressInput>;
  /** Numerical coordinates description of map location. */
  coordinates?: InputMaybe<CoordinatesInput>;
  /**
   * Google's Places API Location Id, as found on Id of the location
   * reference: https://developers.google.com/maps/documentation/places/web-service/place-id
   */
  googlePlaceId?: InputMaybe<Scalars["String"]>;
  /** IANA Time Zone database time zone name */
  timezoneName?: InputMaybe<Scalars["String"]>;
}

/** The saved mapped attribute */
export interface MappedAttribute {
  id: Scalars["ID"];
  sourceValue: Scalars["String"];
}

export interface MappedLegalEntity extends MappedAttribute {
  id: Scalars["ID"];
  legalEntity: LegalEntity;
  sourceValue: Scalars["String"];
}

/** A mapping from one value to another. A veneer over simple workflow rules. */
export interface Mapping {
  /** The left hand side of this mapping's action. */
  actionLeft: MappingLeft;
  /** The right hand side of this mapping's action. */
  actionRight?: Maybe<MappingRight>;
  /** The left hand side of this mapping's filter. */
  filterLeft: MappingLeft;
  /** The right hand side of this mapping's filter. */
  filterRight: MappingRight;
  id: Scalars["ID"];
  /** The class of mappings that this mapping belongs to. */
  mappingClass: MappingClass;
  /** The underlying workflow rule for this mapping. */
  rule: WorkflowRule;
}

/**
 * A class of mappings, i.e. a group of mappings that all share the same filter left hand side and action left hand side.
 * All matching mappings for a customer will belong to the same mapping class.
 */
export interface MappingClass {
  /** The left hand side of this class's mappings' actions. */
  actionLeft: MappingLeft;
  /**
   * The automatch status of this mapping. This is whether or not rule suggestions matching this mapping class are
   * automatically accepted.
   */
  automatchStatus: MappingClassAutomatchStatus;
  /** The automatch type when the automatch feature is enabled. */
  automatchType?: Maybe<AutomatchType>;
  /** The left hand side of this class's mappings' filters. */
  filterLeft: MappingLeft;
  id: Scalars["ID"];
  /** The mappings that belong to this mapping class. */
  mappings: MappingConnection;
  /** When this mapping class or one of its mappings were last modified. */
  modifiedAt: Scalars["Time"];
  suggestionGroups?: Maybe<AutomationSuggestionGroupConnection>;
  /** A CSV template for performing bulk mapping uploads */
  templateCsv?: Maybe<Asset>;
}

/**
 * A class of mappings, i.e. a group of mappings that all share the same filter left hand side and action left hand side.
 * All matching mappings for a customer will belong to the same mapping class.
 */
export interface MappingClassmappingsArgs {
  after?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<MappingFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  sort?: InputMaybe<MappingSortInput>;
}

/**
 * A class of mappings, i.e. a group of mappings that all share the same filter left hand side and action left hand side.
 * All matching mappings for a customer will belong to the same mapping class.
 */
export interface MappingClasssuggestionGroupsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<AutomationSuggestionGroupsFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<AutomationSuggestionGroupsSortInput>;
}

export enum MappingClassAutomatchStatus {
  DISABLED = "DISABLED",
  ENABLED = "ENABLED",
}

export interface MappingClassConnection extends Connection {
  edges: Array<MappingClassEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"];
}

export interface MappingClassEdge {
  cursor?: Maybe<Scalars["String"]>;
  node: MappingClass;
}

export interface MappingClassFilterInput {
  /** When specified, the left hand side of the mapping class action. */
  actionLeft?: InputMaybe<LeftHandSideOneOfInput>;
  /** When specified, the left hand side of the mapping class filter. */
  filterLeft?: InputMaybe<LeftHandSideOneOfInput>;
  /** When specified, search text that should be matched against the filter and action left hand display names. */
  searchText?: InputMaybe<Scalars["String"]>;
}

export interface MappingClassSortInput {
  key: MappingClassSortKey;
  /** Sort order defaulting to ascending. */
  order?: InputMaybe<OrderByDirection>;
}

export enum MappingClassSortKey {
  ACTION_LEFT_NAME = "ACTION_LEFT_NAME",
  FILTER_LEFT_NAME = "FILTER_LEFT_NAME",
  MODIFIED_AT = "MODIFIED_AT",
}

export interface MappingConnection extends Connection {
  edges: Array<MappingEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"];
}

export interface MappingEdge {
  cursor?: Maybe<Scalars["String"]>;
  node: Mapping;
}

export interface MappingFilterInput {
  /** When specified, search text that should be matched against the filter and action right hand display names. */
  searchText?: InputMaybe<Scalars["String"]>;
}

export type MappingLeft = CoreFieldAddress | ExtendedField;

export interface MappingRight {
  budget?: Maybe<Budget>;
  card?: Maybe<Card>;
  category?: Maybe<Category>;
  costCenter?: Maybe<CostCenter>;
  department?: Maybe<Department>;
  extendedFieldOption?: Maybe<ExtendedFieldOption>;
  legalEntity?: Maybe<LegalEntity>;
  location?: Maybe<Location>;
  type: MappingRightType;
  user?: Maybe<User>;
  vendorDetails?: Maybe<VendorDetails>;
}

export enum MappingRightType {
  BUDGET = "BUDGET",
  CARD = "CARD",
  CATEGORY = "CATEGORY",
  COST_CENTER = "COST_CENTER",
  DEPARTMENT = "DEPARTMENT",
  EXTENDED_FIELD_OPTION = "EXTENDED_FIELD_OPTION",
  LEGAL_ENTITY = "LEGAL_ENTITY",
  LOCATION = "LOCATION",
  USER = "USER",
  VENDOR_DETAILS = "VENDOR_DETAILS",
}

export interface MappingSortInput {
  key: MappingSortKey;
  /** Sort order defaulting to ascending. */
  order?: InputMaybe<OrderByDirection>;
}

export enum MappingSortKey {
  ACTION_RIGHT_NAME = "ACTION_RIGHT_NAME",
  FILTER_RIGHT_NAME = "FILTER_RIGHT_NAME",
}

export interface MarkAllAlertsAsReadInput {
  clientMutationId: Scalars["String"];
  lastFetchedAt: Scalars["Time"];
}

export interface MarkAllAlertsAsReadResult {
  clientMutationId: Scalars["String"];
}

export interface MarkAsReviewedInformation {
  /** The request action ID being suggested to mark the expense as reviewed */
  requestActionId?: Maybe<Scalars["String"]>;
}

export interface MarkBillPaidInput {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
}

export interface MarkBillPaidPayload {
  bill: Bill;
  clientMutationId: Scalars["String"];
}

export interface MarkBillPaidV2Input {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
}

export interface MarkInvoiceInput {
  clientMutationId: Scalars["String"];
  idempotencyKey: Scalars["String"];
  invoiceId: Scalars["ID"];
  newStatus: InvoiceStatus;
}

export interface MarkInvoicePayload {
  clientMutationId: Scalars["String"];
  invoice?: Maybe<InvoicingInvoice>;
}

/** ## INPUTS ### */
export interface MarkInvoiceV1Input {
  /** A unique idempotency key. */
  idempotencyKey: Scalars["String"];
  /** ID of the invoice to be sent. */
  invoiceId: Scalars["ID"];
  /** New invoice status. */
  newStatus: InvoiceStatusV1;
}

export interface MarkOfferSeenInput {
  clientMutationId: Scalars["String"];
  offerType: OfferType;
}

export interface MarkOfferSeenPayload {
  clientMutationId: Scalars["String"];
}

export interface MarkSeenExpenseActivitiesError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface MarkSeenExpenseActivitiesResult extends MutationResult {
  /** No errors if Expense Activities are marked seen successfully */
  errors?: Maybe<Array<MarkSeenExpenseActivitiesError>>;
}

export interface MarketingMetadataInput {
  /** ad id */
  adId?: InputMaybe<Scalars["String"]>;
  /** ad group id */
  adgroupId?: InputMaybe<Scalars["String"]>;
  /** adset id */
  adsetId?: InputMaybe<Scalars["String"]>;
  /** campaign id */
  campaignId?: InputMaybe<Scalars["String"]>;
  /** creative */
  creative?: InputMaybe<Scalars["String"]>;
  /** device */
  device?: InputMaybe<Scalars["String"]>;
  /** feeditem id */
  feeditemId?: InputMaybe<Scalars["String"]>;
  /** google click id */
  gclid?: InputMaybe<Scalars["String"]>;
  /** group code */
  groupCode?: InputMaybe<Scalars["String"]>;
  /** keyword */
  keyword?: InputMaybe<Scalars["String"]>;
  /** locInterestMs */
  locInterestMs?: InputMaybe<Scalars["String"]>;
  /** locPhysicalMs */
  locPhysicalMs?: InputMaybe<Scalars["String"]>;
  /** matchtype */
  matchtype?: InputMaybe<Scalars["String"]>;
  /** microsoft click id */
  msclkid?: InputMaybe<Scalars["String"]>;
  /** network */
  network?: InputMaybe<Scalars["String"]>;
  /** placement */
  placement?: InputMaybe<Scalars["String"]>;
  /** rc */
  rc?: InputMaybe<Scalars["String"]>;
  /** refCode */
  refCode?: InputMaybe<Scalars["String"]>;
  /** refSrc */
  refSrc?: InputMaybe<Scalars["String"]>;
  /** refcode user self-attested to */
  selfAttestedRefCode?: InputMaybe<Scalars["String"]>;
  /** softSignupFromWebsite */
  softSignupFromWebsite?: InputMaybe<Scalars["Boolean"]>;
  /** targetId */
  targetId?: InputMaybe<Scalars["String"]>;
}

export interface MarketoLeadDetailsInput {
  formId?: InputMaybe<Scalars["String"]>;
  lead?: InputMaybe<Scalars["String"]>;
  lookupField?: InputMaybe<Scalars["String"]>;
  reason?: InputMaybe<Scalars["String"]>;
  source?: InputMaybe<Scalars["String"]>;
}

export interface MarketoLeadDetailsObject {
  formId?: Maybe<Scalars["String"]>;
  lead?: Maybe<Scalars["String"]>;
  lookupField?: Maybe<Scalars["String"]>;
  reason?: Maybe<Scalars["String"]>;
  source?: Maybe<Scalars["String"]>;
}

export interface MarketoLeadForm extends Node {
  formId: Scalars["String"];
  formJson: Scalars["String"];
  /** The ID of an object */
  id: Scalars["ID"];
}

/** The vendor info matched/created after parsed from invoice */
export interface MatchedVendorInfo {
  /** The payment instrument matched/created after parsed from invoice */
  paymentInstrument?: Maybe<PaymentInstrumentField>;
  /** Date of payment, parsed from invoice and calculated by the payment instrument type */
  paymentSendAt?: Maybe<Scalars["Time"]>;
  /** The vendor matched/created after parsed from invoice */
  vendor?: Maybe<BillSuggestionVendor>;
}

/** Filter facet for integration rules (only used for expenses) */
export interface MatchingRulesFilterFacet extends Node {
  /** Filter facet type */
  facetType?: Maybe<FacetType>;
  /** The ID of an object */
  id: Scalars["ID"];
  /** A list of rule IDs matches this filter facet type */
  ruleIds?: Maybe<Array<Maybe<Scalars["String"]>>>;
  /** A list of rules matches this filter facet type */
  rules?: Maybe<Array<Maybe<IntegrationRule>>>;
}

/** Average amount of cash the customer handles each year. */
export enum MaxCashHandled {
  /** Less than $500,000. */
  LESS_THAN_500K = "LESS_THAN_500K",
  /** $500,000 to $999,999. */
  LESS_THAN_1000K = "LESS_THAN_1000K",
  /** $1,000,000 to $1,999,999. */
  LESS_THAN_2000K = "LESS_THAN_2000K",
  /** More than $2,000,000. */
  MORE_THAN_2000K = "MORE_THAN_2000K",
  /** Customer does not accept cash. */
  NO_CASH = "NO_CASH",
}

export interface MedianAbsoluteDeviationStats {
  /** The average spend. */
  average: FinancialAsset;
  /** The median spend. */
  median: FinancialAsset;
  /** The median absolute deviation. */
  medianAbsoluteDeviation: Scalars["Decimal"];
  /**
   * This the pre-calculated threshold that we use to determine if the spend is an outlier.
   * The formula is (median + median_absolute_deviation * 10)
   */
  medianAbsoluteDeviationThreshold: FinancialAsset;
  /** The p25 percentile amount. */
  p25Percentile: FinancialAsset;
  /** The p75 percentile amount. */
  p75Percentile: FinancialAsset;
  /** The p90 percentile amount. */
  p90Percentile: FinancialAsset;
}

export enum Medium {
  INVALID = "INVALID",
  SMS = "SMS",
  WHATSAPP = "WHATSAPP",
}

/**
 * The filter condition for which users should be members of a group. This is a @oneOf input; either unary condition or
 * composite condition should be provided.
 */
export interface MemberConditionInput {
  compositeCondition?: InputMaybe<CompositeCondition>;
  unaryCondition?: InputMaybe<UnaryCondition>;
}

/** Additional fields to include in the memo. It is either general field and extended field. */
export interface MemoAdditionalField {
  /** Option, the id of the extended field. */
  extendedFieldId?: Maybe<Scalars["String"]>;
  /** Optional, the type of the additional field. */
  generalField?: Maybe<MemoGeneralAdditionalField>;
}

/** Additional fields to include in the memo. It is either general field and extended field. */
export interface MemoAdditionalFieldInput {
  /** Option, the id of the extended field. */
  extendedFieldId?: InputMaybe<Scalars["String"]>;
  /** Optional, the type of the additional field. */
  generalField?: InputMaybe<MemoGeneralAdditionalField>;
}

export enum MemoGeneralAdditionalField {
  BUDGET_NAME = "BUDGET_NAME",
  CARD_HOLDER_EMAIL = "CARD_HOLDER_EMAIL",
  CARD_HOLDER_NAME = "CARD_HOLDER_NAME",
  DESCRIPTOR = "DESCRIPTOR",
  LAST_4 = "LAST_4",
  POSTED_DATE = "POSTED_DATE",
}

export interface MemoPreferences {
  requirements: Array<Maybe<Requirements>>;
}

export interface MemoPreferencesInput {
  requirements?: InputMaybe<Array<InputMaybe<Requirements>>>;
}

export interface MemoSettings {
  /** Delimiter to use between fields in the memo. */
  delimiter: MemoSettingsDelimiter;
  /** Additional fields to include in the memo. */
  memoAdditionalFields: Array<MemoAdditionalField>;
  /** Position of the original memo in the memo text. */
  originalMemoPosition: OriginalMemoPosition;
  /** Whether to show the field name in the memo text. */
  showFieldName: Scalars["Boolean"];
}

export enum MemoSettingsDelimiter {
  /** New line "\n" */
  NEW_LINE = "NEW_LINE",
  /** Pipe "|" */
  PIPE = "PIPE",
  /** Pipe with spaces " | " */
  PIPE_WITH_SPACES = "PIPE_WITH_SPACES",
}

export interface MemoSettingsInput {
  /** Delimiter to use between fields in the memo. */
  delimiter: MemoSettingsDelimiter;
  /** Additional fields to include in the memo. */
  memoAdditionalFields: Array<MemoAdditionalFieldInput>;
  /** Position of the original memo in the memo text. */
  originalMemoPosition: OriginalMemoPosition;
  /** Whether to show the field name in the memo text. */
  showFieldName: Scalars["Boolean"];
}

export enum MemoStatus {
  MEMO_ABSENT = "MEMO_ABSENT",
  MEMO_PRESENT = "MEMO_PRESENT",
}

export interface MemoSuggestionInformation {
  /**
   * Enum describing what data was primarily used to generate the content of the suggestion.
   * @deprecated Use expenseSuggestionOriginEntities
   */
  expenseSuggestionDataOrigins: Array<ExpenseSuggestionDataOrigin>;
  /** Data entities used to generate the content of the suggestion. */
  expenseSuggestionOriginEntities: Array<ExpenseSuggestionOriginEntity>;
  /** Text of the memo being suggested. */
  memo: Scalars["String"];
  /** Enum describing what method was used to generate the memo suggestion (ex LLM, Static Rules, etc). */
  memoSuggestionSource: MemoSuggestionSource;
}

export enum MemoSuggestionSource {
  /** Generated by an AI model build in house. */
  IN_HOUSE_MODEL = "IN_HOUSE_MODEL",
  /** Generated via an LLM. */
  LLM = "LLM",
  /** Generated via a static rule mapping. */
  STATIC_RULES = "STATIC_RULES",
}

export interface MentalHealthOfferPayloadV2 {
  /** Dummy field since graphql cannot handle empty payloads. */
  dummyField?: Maybe<Scalars["String"]>;
}

/** Merchant. */
export interface Merchant extends Node {
  /** The ID of an object */
  id: Scalars["ID"];
  merchantCategory?: Maybe<MerchantCategory>;
  merchantIcon?: Maybe<MerchantIcon>;
  name?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  /** The vendor corresponding to this merchant. This is a 1-to-1 relationship. */
  vendor?: Maybe<VendorDetails>;
  website?: Maybe<Scalars["String"]>;
}

/** Merchant category. */
export interface MerchantCategory extends Node {
  description?: Maybe<Scalars["String"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  isDefault?: Maybe<Scalars["Boolean"]>;
  name?: Maybe<Scalars["String"]>;
}

/** Merchant category code control reference. */
export interface MerchantCategoryCodeControlReference {
  merchantCategoryCode: Scalars["String"];
  merchantCategoryCodeDescription?: Maybe<Scalars["String"]>;
}

/** Merchant category config. */
export interface MerchantCategoryConfig {
  controlReference: MerchantCategoryControlReference;
  controlType: MerchantCategoryControlType;
}

/** Input for merchant category config. */
export interface MerchantCategoryConfigInput {
  controlReference: MerchantControlReferenceInput;
  controlType: MerchantCategoryControlType;
}

export interface MerchantCategoryConnection {
  edges?: Maybe<Array<Maybe<MerchantCategoryEdge>>>;
  pageInfo: PageInfo;
}

/** Merchant category controls reference. */
export type MerchantCategoryControlReference =
  | MerchantCategoryCodeControlReference
  | MerchantCategoryIdControlReference
  | MerchantNameControlReference;

/** Merchant category control type. */
export enum MerchantCategoryControlType {
  ALLOW = "ALLOW",
  BLOCK = "BLOCK",
}

/** Merchant category controls from root budget, ancestor budgets and current budget. */
export interface MerchantCategoryControls {
  ancestorBudgetsConfigs?: Maybe<Array<Maybe<MerchantCategoryConfig>>>;
  currentBudgetConfigs?: Maybe<Array<Maybe<MerchantCategoryConfig>>>;
  globalBudgetConfigs?: Maybe<Array<Maybe<MerchantCategoryConfig>>>;
}

export interface MerchantCategoryEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<MerchantCategory>;
}

/** Merchant category id control reference. */
export interface MerchantCategoryIdControlReference {
  merchantCategoryId: Scalars["String"];
  merchantCategoryName: Scalars["String"];
}

/** Input for validating a single merchant or merchant category. */
export interface MerchantCategoryInput {
  /** Merchant category id. */
  id: Scalars["String"];
  /** Merchant category name. */
  name: Scalars["String"];
}

/** Merchant control reference input. */
export interface MerchantControlReferenceInput {
  merchantCategoryCode?: InputMaybe<Scalars["String"]>;
  merchantCategoryId?: InputMaybe<Scalars["String"]>;
  merchantName?: InputMaybe<Scalars["String"]>;
}

export interface MerchantIcon extends Node {
  asset?: Maybe<Asset>;
  /** The ID of an object */
  id: Scalars["ID"];
}

/** Input for validating a single merchant or merchant category. */
export interface MerchantInput {
  /** Merchant category. */
  category?: InputMaybe<MerchantCategoryInput>;
  /** Merchant id. */
  id?: InputMaybe<Scalars["String"]>;
  /** Merchant name. */
  name: Scalars["String"];
}

/** Merchant name control reference. */
export interface MerchantNameControlReference {
  categoryId?: Maybe<Scalars["String"]>;
  categoryName?: Maybe<Scalars["String"]>;
  merchantName: Scalars["String"];
}

export interface MergeMetadata {
  connectionId?: Maybe<Scalars["String"]>;
  hrisSystem?: Maybe<HrSystem>;
  integrationId: Scalars["String"];
}

export enum Method {
  CREDIT = "CREDIT",
  DEBIT = "DEBIT",
}

/** Enum type for metric category. */
export enum MetricCategoryType {
  ACCOUNT_BALANCE = "ACCOUNT_BALANCE",
  AUTOMATION = "AUTOMATION",
  AUTOMATION_OVERVIEW = "AUTOMATION_OVERVIEW",
  AVG_TIME_TO_COMPLIANCE = "AVG_TIME_TO_COMPLIANCE",
  AVG_TIME_TO_COMPLIANCE_DETAILS = "AVG_TIME_TO_COMPLIANCE_DETAILS",
  AVG_TIME_TO_REVIEW_DETAILS = "AVG_TIME_TO_REVIEW_DETAILS",
  AVG_TIME_TO_SUBMIT_DETAILS = "AVG_TIME_TO_SUBMIT_DETAILS",
  COMPLIANCE = "COMPLIANCE",
  COMPLIANCE_OVERVIEW = "COMPLIANCE_OVERVIEW",
  CREDIT_LIMIT = "CREDIT_LIMIT",
  CREDIT_LIMIT_DETAILS = "CREDIT_LIMIT_DETAILS",
  EARNED_FROM_YIELD = "EARNED_FROM_YIELD",
  EMPLOYEE_TIME_SAVED_DETAILS = "EMPLOYEE_TIME_SAVED_DETAILS",
  EXPENSES_MISSING_DOCUMENTATION = "EXPENSES_MISSING_DOCUMENTATION",
  EXPENSES_MISSING_DOCUMENTATION_DETAILS = "EXPENSES_MISSING_DOCUMENTATION_DETAILS",
  EXPENSES_MISSING_REVIEW = "EXPENSES_MISSING_REVIEW",
  EXPENSES_MISSING_REVIEW_DETAILS = "EXPENSES_MISSING_REVIEW_DETAILS",
  /** @deprecated No longer supported */
  EXPENSES_NOT_REQUIRED_REVIEW_DETAILS = "EXPENSES_NOT_REQUIRED_REVIEW_DETAILS",
  /** @deprecated No longer supported */
  EXPENSES_NOT_REQUIRING_DOCUMENTATION_DETAILS = "EXPENSES_NOT_REQUIRING_DOCUMENTATION_DETAILS",
  EXPENSES_PREPARED_WITH_AUTOMATION = "EXPENSES_PREPARED_WITH_AUTOMATION",
  /** @deprecated No longer supported */
  EXPENSES_REQUIRED_REVIEW_DETAILS = "EXPENSES_REQUIRED_REVIEW_DETAILS",
  /** @deprecated No longer supported */
  EXPENSES_REQUIRING_DOCUMENTATION = "EXPENSES_REQUIRING_DOCUMENTATION",
  /** @deprecated No longer supported */
  EXPENSES_REQUIRING_DOCUMENTATION_DETAILS = "EXPENSES_REQUIRING_DOCUMENTATION_DETAILS",
  EXPENSES_REQUIRING_MANUAL_PREP = "EXPENSES_REQUIRING_MANUAL_PREP",
  EXPENSES_REQUIRING_MANUAL_PREP_DETAILS = "EXPENSES_REQUIRING_MANUAL_PREP_DETAILS",
  /** @deprecated No longer supported */
  EXPENSES_REQUIRING_REVIEW = "EXPENSES_REQUIRING_REVIEW",
  OPTIMIZE_FINANCE = "OPTIMIZE_FINANCE",
  OPTIMIZE_FINANCE_OVERVIEW = "OPTIMIZE_FINANCE_OVERVIEW",
  PAYING_AND_CODING_BILLS = "PAYING_AND_CODING_BILLS",
  REVIEWING_DOCUMENTATION = "REVIEWING_DOCUMENTATION",
  REVIEWING_DOCUMENTATION_TIME_SAVED = "REVIEWING_DOCUMENTATION_TIME_SAVED",
  REVIEWING_DOCUMENTATION_TIME_SPENT = "REVIEWING_DOCUMENTATION_TIME_SPENT",
  REWARDS = "REWARDS",
  REWARDS_FROM_CARD = "REWARDS_FROM_CARD",
  REWARDS_FROM_INVOICE = "REWARDS_FROM_INVOICE",
  SAVINGS_FROM_ACH_FEES = "SAVINGS_FROM_ACH_FEES",
  SAVINGS_FROM_FX_FEES = "SAVINGS_FROM_FX_FEES",
  SAVINGS_FROM_SOFTWARE = "SAVINGS_FROM_SOFTWARE",
  SAVINGS_FROM_WIRE_FEES = "SAVINGS_FROM_WIRE_FEES",
  SAVINGS_ON_FEES = "SAVINGS_ON_FEES",
  SPEND_IN_POLICY_DETAILS = "SPEND_IN_POLICY_DETAILS",
  /**
   *   DEPRECATED
   * @deprecated No longer supported
   */
  SPEND_OUT_OF_POLICY = "SPEND_OUT_OF_POLICY",
  /** @deprecated No longer supported */
  SPEND_OUT_OF_POLICY_DETAILS = "SPEND_OUT_OF_POLICY_DETAILS",
  SUBMITTING_DOCUMENTATION = "SUBMITTING_DOCUMENTATION",
  SUBMITTING_DOCUMENTATION_TIME_SAVED = "SUBMITTING_DOCUMENTATION_TIME_SAVED",
  SUBMITTING_DOCUMENTATION_TIME_SPENT = "SUBMITTING_DOCUMENTATION_TIME_SPENT",
  TIME_SAVED_AI_COMMENTING = "TIME_SAVED_AI_COMMENTING",
  TIME_SAVED_AI_MOMENTS = "TIME_SAVED_AI_MOMENTS",
  TIME_SAVED_AUTO_MEMO = "TIME_SAVED_AUTO_MEMO",
  TIME_SAVED_AUTO_RECEIPTS = "TIME_SAVED_AUTO_RECEIPTS",
  TIME_SAVED_CLOSING_THE_BOOKS = "TIME_SAVED_CLOSING_THE_BOOKS",
  TIME_SAVED_CLOSING_THE_BOOKS_DETAILS = "TIME_SAVED_CLOSING_THE_BOOKS_DETAILS",
  TIME_SAVED_EMPLOYEE_EXPENSES = "TIME_SAVED_EMPLOYEE_EXPENSES",
  TIME_SAVED_MEMO_SUGGESTIONS = "TIME_SAVED_MEMO_SUGGESTIONS",
  TIME_SAVED_PAYING_BILLS = "TIME_SAVED_PAYING_BILLS",
  TIME_SAVED_USER_MANAGEMENT = "TIME_SAVED_USER_MANAGEMENT",
  TIME_SAVED_WITH_AUTOMATION = "TIME_SAVED_WITH_AUTOMATION",
  TIME_SPENT_ON_EXPENSES = "TIME_SPENT_ON_EXPENSES",
  TIME_SPENT_ON_EXPENSES_DETAILS = "TIME_SPENT_ON_EXPENSES_DETAILS",
  TIME_SPENT_ON_EXPENSES_TOTAL_REVIEW_TIME = "TIME_SPENT_ON_EXPENSES_TOTAL_REVIEW_TIME",
  TIME_SPENT_ON_EXPENSES_TOTAL_SUBMISSION_TIME = "TIME_SPENT_ON_EXPENSES_TOTAL_SUBMISSION_TIME",
  TOTAL_MONEY_EARNED = "TOTAL_MONEY_EARNED",
  TOTAL_REWARDS = "TOTAL_REWARDS",
  TOTAL_SAVINGS = "TOTAL_SAVINGS",
  TOTAL_TIME_SAVED = "TOTAL_TIME_SAVED",
  TOTAL_TIME_SPENT = "TOTAL_TIME_SPENT",
  USER_MANAGEMENT = "USER_MANAGEMENT",
  YIELD_ON_CASH = "YIELD_ON_CASH",
}

export interface MetricUnit {
  /**  if unitType is currency, this indicates instrument code */
  instrumentCodeString?: Maybe<Scalars["String"]>;
  unitType: MetricUnitType;
}

/** Enum type for axis unit. */
export enum MetricUnitType {
  CURRENCY = "CURRENCY",
  PERCENTAGE = "PERCENTAGE",
  PLAIN_TEXT = "PLAIN_TEXT",
  TIMESTAMP = "TIMESTAMP",
  TIME_DAY = "TIME_DAY",
  TIME_HOUR = "TIME_HOUR",
  TIME_HOUR_SAVED = "TIME_HOUR_SAVED",
  TIME_HOUR_SPENT = "TIME_HOUR_SPENT",
  TIME_MINUTE = "TIME_MINUTE",
  TIME_MONTH = "TIME_MONTH",
  TIME_WEEK = "TIME_WEEK",
  TIME_YEAR = "TIME_YEAR",
}

export interface MetricValue {
  unit: MetricUnit;
  value: Scalars["String"];
}

/** Explanation to how the category metrics are calculated */
export interface MetricsCategoryExplanation {
  categoryTitle?: Maybe<Scalars["String"]>;
  individualMetricExplanations?: Maybe<Array<MetricsIndividualExplanation>>;
}

export type MetricsGraph = ArcMetricsGraph | BarMetricsGraph | LineMetricsGraph;

/** Explanation to how individual metrics in the category are calculated */
export interface MetricsIndividualExplanation {
  explanation: Scalars["String"];
  sectionTitle?: Maybe<Scalars["String"]>;
}

export interface MetricsTable {
  columns: Array<MetricsTableColumn>;
  rows: Array<MetricsTableRow>;
}

export interface MetricsTableColumn {
  name: Scalars["String"];
}

export interface MetricsTableRow {
  values: Array<Cell>;
}

export enum MfaPrimaryMethod {
  MFA_SMS = "MFA_SMS",
  MFA_TOTP = "MFA_TOTP",
}

/**
 * MFA status
 * ENABLED -- The user has an enabled primary (TOTP/SMS) MFA
 * PENDING_RESET -- The user got a reset code from Brex recently (within 30 minutes)
 * DISABLED -- The user's MFA has been disabled
 */
export enum MfaStatus {
  DISABLED = "DISABLED",
  ENABLED = "ENABLED",
  PENDING_RESET = "PENDING_RESET",
}

export interface MicroDepositsUserAttempts {
  firstAmount: Scalars["Decimal"];
  secondAmount: Scalars["Decimal"];
  userId: Scalars["ID"];
}

export interface MicroDepositsValidationInput {
  firstAmount: Scalars["Decimal"];
  secondAmount: Scalars["Decimal"];
}

/** type PennyPullVerificationMetadata {} */
export interface MicroDepositsVerificationMetadata {
  notificationIds?: Maybe<Array<Scalars["String"]>>;
  remainingAttempts?: Maybe<Scalars["Int"]>;
  userAttempts?: Maybe<Array<Maybe<MicroDepositsUserAttempts>>>;
}

export interface MicrosoftGraphAuthPayloadInput {
  /** Which Brex Microsoft Graph client to create this credential for */
  clientName: MicrosoftGraphClientName;
  redirectUri: Scalars["String"];
  /** Space separated list of api permissions */
  scope: Scalars["String"];
  /**
   * Controls who can sign into the application.
   *     - common        for both Microsoft accounts and work or school accounts
   *     - organizations for work or school accounts only
   *     - consumers     for Microsoft accounts only
   *     - tenant        identifiers such as the tenant ID or domain name.
   */
  tenant: Scalars["String"];
}

export enum MicrosoftGraphClientName {
  TRAVEL_CALENDAR = "TRAVEL_CALENDAR",
}

export interface MicrosoftGraphPayload {
  accessToken?: Maybe<Scalars["String"]>;
  clientName: MicrosoftGraphClientName;
  refreshToken?: Maybe<Scalars["String"]>;
  scope: Scalars["String"];
  tenant: Scalars["String"];
}

export interface MigratedAccount {
  billPayOnEmpowerEnabled?: Maybe<Scalars["Boolean"]>;
  customerAccountId?: Maybe<Scalars["String"]>;
  /** @deprecated Will always return true. Leaving in until mobile stops calling this */
  multipleBudgetsEnabled?: Maybe<Scalars["Boolean"]>;
}

export interface MigratedUser {
  customerUserId?: Maybe<Scalars["String"]>;
  requiresLimitTooltip?: Maybe<Scalars["Boolean"]>;
  requiresLimitUpdate?: Maybe<Scalars["Boolean"]>;
}

export interface MigratedUserInput {
  customerUserId: Scalars["String"];
  requiresLimitTooltip?: InputMaybe<Scalars["Boolean"]>;
  requiresLimitUpdate?: InputMaybe<Scalars["Boolean"]>;
}

export interface MigratedUsersFilterInput {
  requiresLimitUpdate?: InputMaybe<Scalars["Boolean"]>;
}

export enum MigrationState {
  COMPLETED = "COMPLETED",
  HAS_ACCEPTED_TERMS = "HAS_ACCEPTED_TERMS",
  HAS_ALLOCATED_FUNDS = "HAS_ALLOCATED_FUNDS",
  HAS_VERIFIED_DETAILS = "HAS_VERIFIED_DETAILS",
  INITIATED = "INITIATED",
  NOT_INITIATED = "NOT_INITIATED",
}

/** Mileage expense addendum. */
export interface MileageAddendum extends ExpenseAddendum {
  /** The total distance travelled. */
  distance: Distance;
  /** The unique ID of the expense addendum. */
  id: Scalars["ID"];
  /** Map used to display routes */
  mapDisplay?: Maybe<MapDisplay>;
  /** The evidence for the mileage */
  mileageEvidences: Array<Asset>;
  /** The mileage rate associated with the addendum */
  mileageRate?: Maybe<MileageRate>;
  /** The routes travelled. */
  routes: Array<Route>;
}

export interface MileageAddendumInput {
  /** The total distance travelled. */
  distance: DistanceInput;
  /** The IDs of the evidence for this travel. */
  evidenceAssetIds: Array<Scalars["ID"]>;
  /** Map used to display routes */
  mapDisplay?: InputMaybe<MapDisplayInput>;
  /** Id of the mileage rate used to calculate this mileage Addendum */
  mileageRateId?: InputMaybe<Scalars["ID"]>;
  /** The routes travelled. */
  routes: Array<RouteInput>;
}

export interface MileageAmount {
  /** Amount using the bank account currency. */
  amount: FinancialAsset;
  /** Inner mileage rate description. */
  mileageRate: MileageRate;
  /** Amount using the mileage rate currency. */
  purchasedAmount: FinancialAsset;
}

export interface MileageAuxiliaryMetadata {
  distance: ReimbursementDistance;
  evidenceAssetIds?: Maybe<Array<Scalars["ID"]>>;
  routes?: Maybe<Array<ReimbursementRoute>>;
}

export interface MileageAuxiliaryMetadataInput {
  /** Reimbursement distance */
  distance: ReimbursementDistanceInput;
  /** The IDs of evidence asset */
  evidenceAssetIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** The display of mileage reimbursement map */
  mileageMapDisplay?: InputMaybe<MileageMapDisplayInput>;
  /** The ID of mileage rate */
  mileageRateId?: InputMaybe<Scalars["ID"]>;
  /** The routes */
  routes?: InputMaybe<Array<ReimbursementRouteInput>>;
}

export interface MileageMapDisplayInput {
  mapProvider: Scalars["String"];
  mapUrl: Scalars["String"];
}

export interface MileageRate {
  effectiveAt?: Maybe<Scalars["Date"]>;
  expiresAt?: Maybe<Scalars["Date"]>;
  /** The unique ID of the MileageRate */
  id: Scalars["ID"];
  specification: MileageRateSpecification;
}

export interface MileageRateAmountPerDistance {
  distanceUnit: DistanceUnit;
  rate: FinancialAsset;
}

export interface MileageRateAmountPerDistanceInput {
  distanceUnit: DistanceUnit;
  rate: FinancialAssetInput;
}

export interface MileageRateInputUnion {
  amountPerDistance?: InputMaybe<MileageRateAmountPerDistanceInput>;
  effectiveAt?: InputMaybe<Scalars["Date"]>;
  expiresAt?: InputMaybe<Scalars["Date"]>;
}

export type MileageRateSpecification = MileageRateAmountPerDistance;

/** An country specific mileage rate */
export interface MileageSetting {
  /** Country associated with the mileage rate */
  countryAlpha2: Scalars["String"];
  /** The unique ID of the MileageSetting */
  id: Scalars["ID"];
  /** Boolean for if user is enabled for mileage reimbursements */
  isMileageReimbursementEnabled: Scalars["Boolean"];
  /** Definition of a mileage rate */
  mileageRates?: Maybe<Array<MileageRate>>;
  /** The scope of the mileage setting */
  scopeType?: Maybe<MileageSettingScopeType>;
}

/** InsightsScenarios connection */
export interface MileageSettingConnection extends Connection {
  /** The items in the current page of results. */
  edges: Array<MileageSettingEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of items, across all pages, matching the filter criteria specified for this connection. */
  totalCount: Scalars["Int"];
}

/** InsightsScenarioConnection edge */
export interface MileageSettingEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The scenario at this edge. */
  node: MileageSetting;
}

/** Input for a country specific mileage rate */
export interface MileageSettingInput {
  countryAlpha2: Scalars["String"];
  idempotencyKey?: InputMaybe<Scalars["String"]>;
  mileageRate: Array<MileageRateInputUnion>;
  scopeType?: InputMaybe<MileageSettingScopeType>;
}

export enum MileageSettingScopeType {
  ACCOUNT = "ACCOUNT",
  DEFAULT = "DEFAULT",
}

/** Enumeration of the possible reasons for a miles transfer failure */
export enum MilesTransferFailureReasonV2 {
  CUSTOM_FIELDS_EXCEEDED = "CUSTOM_FIELDS_EXCEEDED",
  DUPLICATE_CREATE_CREDIT_REQUEST = "DUPLICATE_CREATE_CREDIT_REQUEST",
  FRAUD = "FRAUD",
  GENERIC_ERROR = "GENERIC_ERROR",
  INVALID_CUSTOMER_INFORMATION = "INVALID_CUSTOMER_INFORMATION",
  INVALID_CUSTOM_DATA = "INVALID_CUSTOM_DATA",
  INVALID_DESCRIPTOR = "INVALID_DESCRIPTOR",
  INVALID_MEMBER_INFORMATION_ID = "INVALID_MEMBER_INFORMATION_ID",
  INVALID_REFERENCE = "INVALID_REFERENCE",
  INVALID_REWARDS_AMOUNT = "INVALID_REWARDS_AMOUNT",
  LOYALTY_PROGRAM_NOT_FOUND = "LOYALTY_PROGRAM_NOT_FOUND",
  MALFORMED_JSON = "MALFORMED_JSON",
  MEMBER_ACCOUNT_INELEGIBLE = "MEMBER_ACCOUNT_INELEGIBLE",
  MEMBER_NAME_NOT_MATCHING = "MEMBER_NAME_NOT_MATCHING",
  MEMBER_NAME_REQUIRED = "MEMBER_NAME_REQUIRED",
  MISSING_LOYALTY_PROGRAM_ID = "MISSING_LOYALTY_PROGRAM_ID",
  MISSING_MEMBER_INFORMATION = "MISSING_MEMBER_INFORMATION",
  MISSING_TRANSACTION_DATE = "MISSING_TRANSACTION_DATE",
  UNKNOWN = "UNKNOWN",
  UNSUPPORTED_CREDIT_TYPE = "UNSUPPORTED_CREDIT_TYPE",
}

/** A resource representing a miles transfer quote. */
export interface MilesTransferQuoteV2 {
  /** The exchange rate from Brex points to airline miles. */
  exchangeRate: Scalars["Int"];
  /** The id of the miles transfer quote. */
  redemptionOfferId: Scalars["String"];
}

/** Enumeration of the possible statuses for a miles transfer */
export enum MilesTransferStatusV2 {
  FAILED = "FAILED",
  PROCESSING = "PROCESSING",
  SUCCEEDED = "SUCCEEDED",
  UNKNOWN = "UNKNOWN",
}

export interface MilesTransferV2 {
  /** The reasons why the miles transfer may have failed */
  failureReasons?: Maybe<Array<Maybe<MilesTransferFailureReasonV2>>>;
  /** The miles transfers id */
  id: Scalars["ID"];
  /** The user who initiated the miles transfer */
  initiatedByUser?: Maybe<User>;
  /** The date and time the miles transfer was created */
  insertedAt?: Maybe<Scalars["Time"]>;
  /** The loyalty program associated with the miles transfer */
  loyaltyProgram?: Maybe<LoyaltyProgramV2>;
  /** The number of miles transferred */
  milesAmount?: Maybe<Scalars["Int"]>;
  /** The number of points transferred */
  pointsAmount?: Maybe<Scalars["Int"]>;
  /** The program membership associated with the miles transfer */
  programMembership?: Maybe<ProgramMembershipV2>;
  /** A unique identifier for the miles transfer */
  referenceId: Scalars["String"];
  /** The status of the miles transfer */
  status?: Maybe<MilesTransferStatusV2>;
  /** The user the miles transfer was sent to */
  toUser?: Maybe<User>;
}

/** A connection object for the MilesTransfer type */
export interface MilesTransferV2Connection {
  /** A list of edges, each representing a MilesTransfer */
  edges?: Maybe<Array<Maybe<MilesTransferV2Edge>>>;
  /** Information about pagination in a connection */
  pageInfo: PageInfo;
  /** The total count of miles transfers matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

/** An edge object for the MilesTransfer type */
export interface MilesTransferV2Edge {
  /** A cursor for use in pagination */
  cursor: Scalars["String"];
  /** The node representing a MilesTransfer */
  node?: Maybe<MilesTransferV2>;
}

export interface MilesTransfersSortOrderInput {
  field: MilesTransfersSortableField;
  order: OrderByDirection;
}

export enum MilesTransfersSortableField {
  INSERTED_AT = "INSERTED_AT",
}

export interface MissingContractInconsistency {
  type?: Maybe<MissingContractInconsistencyType>;
}

export interface MissingContractInconsistencyType {
  exists?: Maybe<Scalars["String"]>;
}

export interface MissingCuaccInconsistency {
  type?: Maybe<MissingCuaccInconsistencyType>;
}

export interface MissingCuaccInconsistencyType {
  exists?: Maybe<Scalars["String"]>;
}

export interface MissingSubscriptionsInconsistency {
  type?: Maybe<MissingSubscriptionsInconsistencyType>;
}

export interface MissingSubscriptionsInconsistencyType {
  exists?: Maybe<Scalars["String"]>;
}

/** Mobile referral information */
export interface MobileReferralInformation extends Node {
  /** The ID of an object */
  id: Scalars["ID"];
  /** Landing screen description */
  landingScreenDescription?: Maybe<Scalars["String"]>;
  /** Landing screen title */
  landingScreenTitle?: Maybe<Scalars["String"]>;
}

/** Mobile summary schema */
export interface MobileReferralsSummary extends Node {
  /** Title for entry point */
  entryPointTitle?: Maybe<Scalars["String"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  /** Landing screen description */
  landingScreenDescription?: Maybe<Scalars["String"]>;
  /** Landing screen title */
  landingScreenTitle?: Maybe<Scalars["String"]>;
  /** Terms and conditions */
  termsAndConditions?: Maybe<Scalars["String"]>;
}

/** The type of modification action to perform */
export enum ModificationAction {
  ADD = "ADD",
  REMOVE = "REMOVE",
}

export enum ModificationStatus {
  NEW = "NEW",
  UPDATED = "UPDATED",
}

/** The business's expected total monthly transaction amount on Brex. */
export enum MonthlyActivityVolume {
  FIVE_HUNDRED_K_TO_ONE_MM = "FIVE_HUNDRED_K_TO_ONE_MM",
  MORE_THAN_ONE_MM = "MORE_THAN_ONE_MM",
  ONE_HUNDRED_K_TO_FIVE_HUNDRED_K = "ONE_HUNDRED_K_TO_FIVE_HUNDRED_K",
  UNDER_ONE_HUNDRED_K = "UNDER_ONE_HUNDRED_K",
}

export interface MonthlyClosingStrategy {
  dayOfMonth?: Maybe<Scalars["Int"]>;
}

export interface MonthlyDetails {
  /** Day of the month */
  dayOfMonth?: Maybe<Scalars["Int"]>;
}

export interface MonthlySchedule {
  dayOfMonth?: InputMaybe<Scalars["Int"]>;
  dayOfWeek?: InputMaybe<BusinessDays>;
  nMonths: Scalars["Int"];
  weekOfMonth?: InputMaybe<Scalars["Int"]>;
}

export interface MonthlyScheduleInput {
  dayOfMonth?: InputMaybe<Scalars["Int"]>;
  dayOfWeek?: InputMaybe<BusinessDays>;
  nMonths: Scalars["Int"];
  weekOfMonth?: InputMaybe<Scalars["Int"]>;
}

export interface MonthlySpend {
  /** The amount for the month. */
  amount: FinancialAsset;
  /** The timestamp indicates the beginning of a month in UTC. */
  monthStart: Scalars["Time"];
}

export interface MostRecentlyUsedCurrency {
  currency?: Maybe<Scalars["String"]>;
}

export enum MoveBudgetConflictReason {
  /** Conflict scenario where the budget or its descendants' MCCs conflict with the parent budget or any ancestral MCCs. */
  CONFLICTING_MERCHANT_CATEGORY_CONTROL = "CONFLICTING_MERCHANT_CATEGORY_CONTROL",
  /** Conflict scenario where the specified parent budget is one of the budget's descendants. */
  CONFLICTING_PARENT_BUDGET = "CONFLICTING_PARENT_BUDGET",
  /** Conflict scenario where a budget in the new ancestral path has a currency that differs from the budget's currency. */
  CONFLICTING_PARENT_BUDGET_CURRENCY = "CONFLICTING_PARENT_BUDGET_CURRENCY",
  /** Conflict scenario where the spend of the budget's settled expenses plus parent budget's balance exceeds the parent budget's hard limit. */
  CONFLICTING_PARENT_BUDGET_LIMIT = "CONFLICTING_PARENT_BUDGET_LIMIT",
  /** Conflict scenario where the budget's start/end dates are not within the range of the parent budget's start/end dates. */
  CONFLICTING_START_END_TIME = "CONFLICTING_START_END_TIME",
}

export interface MoveBudgetInput {
  budgetId: Scalars["ID"];
  clientMutationId: Scalars["String"];
  newParentBudgetId: Scalars["ID"];
}

export interface MoveBudgetResult {
  /** The budget that was moved. Nullable for now. TODO: Update to non-nullable. */
  budget?: Maybe<Budget>;
  /** The list of conflict reasons that blocked the parent budget reassignment. Empty list if it went through successfully. */
  conflictReasons: Array<MoveBudgetConflictReason>;
}

/** Input for the limit group move */
export interface MoveLimitGroupInput {
  clientMutationId: Scalars["String"];
  limitGroupId: Scalars["ID"];
  newParentBudgetId: Scalars["ID"];
}

export interface MoveLimitGroupResult extends MutationResult {
  errors?: Maybe<Array<LimitGroupMutationError>>;
}

/** Possible conflict reasons when moving a spend budget */
export enum MoveSpendBudgetConflictReason {
  /** Conflict scenario where the specified parent budget is one of the budget's descendants. */
  CONFLICTING_PARENT_BUDGET = "CONFLICTING_PARENT_BUDGET",
  /** Conflict scenario where a budget in the new ancestral path has a currency that differs from the budget's currency. */
  CONFLICTING_PARENT_BUDGET_CURRENCY = "CONFLICTING_PARENT_BUDGET_CURRENCY",
  /** Conflict scenario where the spend of the budget's settled expenses plus parent budget's balance exceeds the parent budget's hard limit. */
  CONFLICTING_PARENT_BUDGET_LIMIT = "CONFLICTING_PARENT_BUDGET_LIMIT",
  /** Conflict scenario where the budget's start/end dates are not within the range of the parent budget's start/end dates. */
  CONFLICTING_START_END_TIME = "CONFLICTING_START_END_TIME",
}

/** Input for the spend budget movement */
export interface MoveSpendBudgetInput {
  clientMutationId: Scalars["String"];
  newParentBudgetId: Scalars["ID"];
  spendBudgetId: Scalars["ID"];
}

export interface MoveSpendBudgetResult {
  /** The list of conflict reasons that blocked the parent budget reassignment. Empty list if it went through successfully. */
  conflictReasons: Array<MoveSpendBudgetConflictReason>;
  /** The spend budget that was moved. */
  spendBudget?: Maybe<SpendBudget>;
}

/** Possible conflict reasons when moving a spend limit */
export enum MoveSpendLimitConflictReason {
  /** Conflict scenario where the specified parent budget is one of the budget's descendants. */
  CONFLICTING_PARENT_BUDGET = "CONFLICTING_PARENT_BUDGET",
  /** Conflict scenario where a budget in the new ancestral path has a currency that differs from the budget's currency. */
  CONFLICTING_PARENT_BUDGET_CURRENCY = "CONFLICTING_PARENT_BUDGET_CURRENCY",
  /** Conflict scenario where the spend of the budget's settled expenses plus parent budget's balance exceeds the parent budget's hard limit. */
  CONFLICTING_PARENT_BUDGET_LIMIT = "CONFLICTING_PARENT_BUDGET_LIMIT",
  /** Conflict scenario where the budget's start/end dates are not within the range of the parent budget's start/end dates. */
  CONFLICTING_START_END_TIME = "CONFLICTING_START_END_TIME",
}

/** Input for the spend limit movement */
export interface MoveSpendLimitInput {
  clientMutationId: Scalars["String"];
  newParentBudgetId: Scalars["ID"];
  spendLimitId: Scalars["ID"];
}

export interface MoveSpendLimitResult {
  /** The list of conflict reasons that blocked the parent budget reassignment. Empty list if it went through successfully. */
  conflictReasons: Array<MoveSpendLimitConflictReason>;
  /** The spend limit that was moved. */
  spendLimit?: Maybe<SpendLimit>;
}

export interface MultiEntity {
  /**
   * `Enabled` if:
   * 1. Integration has the capability "MULTIPLE_ERP_ENTITIES"
   * 2. User is allowed to edit integrations
   */
  status: MultiEntityStatus;
}

export enum MultiEntityStatus {
  DISABLED = "DISABLED",
  ENABLED = "ENABLED",
}

export interface MutateItemizedPrimitiveError extends StandardClientError {
  /** Error code. */
  code: ErrorCode;
  /** Error message. */
  message?: Maybe<Scalars["String"]>;
  /** Optional path to field that caused error. */
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface MutateItemizedPrimitiveInput {
  /** clientMutationId */
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** New line items to be added to the parent primitive. */
  lineItemsAdded?: InputMaybe<Array<CreateLineItemInput>>;
  /** The line items to be removed from the parent primitive. */
  lineItemsRemoved?: InputMaybe<Array<Scalars["ID"]>>;
  /** Existing line items on the parent primitive to be updated. */
  lineItemsUpdated?: InputMaybe<Array<UpdateLineItemInput>>;
  /** The parent primitive to update */
  updateParentPrimitiveInput: UpdatePrimitiveInputOneOf;
}

export interface MutateItemizedPrimitiveResult extends MutationResult {
  /** No errors if the itemized primitive is mutated successfully. */
  errors?: Maybe<Array<MutateItemizedPrimitiveError>>;
  /** Mutated primitive containing line items. */
  parentPrimitive?: Maybe<ItemizedPrimitive>;
}

export type MutatingActor = InternalActor | OAuthClient | ServiceActor | User;

/**  Base Mutation type which allows other schema files to extend it */
export interface Mutation {
  acceptCompanyPolicyAgreement?: Maybe<AcceptCompanyPolicyAgreementPayload>;
  /** Accepts devportal access agreement */
  acceptDevAccessAgreement?: Maybe<AcceptDevAccessAgreementPayload>;
  acceptOffer?: Maybe<AcceptOfferPayload>;
  /** Copy of legacy startIntegrationExport mutation that supports bulk exports. */
  accountingJournalStartIntegrationExport?: Maybe<AccountingJournalStartIntegrationExportPayload>;
  /** Update accounting records in bulk based on an accounting journal filter. */
  accountingJournalUpdateAccountingRecords?: Maybe<AccountingJournalUpdateAccountingRecordsResult>;
  /** Update expenses in bulk based on an accounting journal filter. */
  accountingJournalUpdateExpenses?: Maybe<AccountingJournalUpdateExpensesResult>;
  /** Activate a card and set its pin */
  activateCard?: Maybe<ActivateCardPayload>;
  activateIntegration?: Maybe<ActivateIntegrationPayload>;
  activateUserSimulator?: Maybe<WorkflowResult>;
  /** Activate a user */
  activateUserV2?: Maybe<ActivateUserPayloadV2>;
  /** Add attendees to a group event. */
  addAttendees: AddAttendeesResult;
  /** Adds the current user ID to the bill's list of user IDs to auto-approve */
  addAutoApproveUserId: BillResult;
  /**
   * Add bills to batch
   * @deprecated Use billBatchAddBills instead
   */
  addBillsToBatch: AddBillsToBatchResult;
  /** Adds a policy granting access for a FSP account to a tenant account */
  addFspBookkeeper?: Maybe<AddFspBookkeeperPayload>;
  /** Add a user to the bookkeeper group, granting access to tenants available to the group */
  addFspBookkeeperUser?: Maybe<AddFspBookkeeperUserPayload>;
  addSubsidiaryDefaultEntity?: Maybe<AddSubsidiaryDefaultEntityPayload>;
  addToCohort?: Maybe<AddToCohortResult>;
  advanceToNextStep?: Maybe<AdvanceToNextStepPayload>;
  /** Given a set of beneficiaries and a OTP code, approves the beneficiaries as trusted for SCA */
  approveBeneficiaries: ApproveBeneficiariesResult;
  /**
   * Approve a budget limit increase request.
   * @deprecated Use approveLimitIncreaseRequest instead
   */
  approveBudgetLimitIncreaseRequest: Scalars["ID"];
  /**
   * Approve a budget limit increase request.
   * @deprecated Use approveLimitIncreaseRequest instead
   */
  approveBudgetLimitIncreaseRequestV2: ApproveBudgetLimitIncreaseRequestV2Result;
  /** Approve a request for a new budget */
  approveBudgetRequestV2: ApproveBudgetRequestV2Result;
  /** Archive a limit group */
  archiveLimitGroup: ArchiveLimitGroupResult;
  /** Archive a spend budget */
  archiveSpendBudget: ArchiveSpendBudgetResult;
  /** Archive a spend limit */
  archiveSpendLimit: ArchiveSpendLimitResult;
  /** Assign a budget to a card */
  assignBudgetToCard: AssignBudgetToCardResult;
  assignFSPUsersRoles: AssignFSPUsersRolesResult;
  /** Kick off a workflow to bulk create default user limits for the given user set */
  asyncCreateDefaultUserSpendLimits: AsyncCreateDefaultUserSpendLimitsResult;
  /** Async exports expenses from given expenses filter search report by request file type */
  asyncCreateExpensesSearchReport: AsyncCreateExpensesSearchReportResult;
  /** Authorize drawdown request */
  authorizeDrawdownRequest?: Maybe<AuthorizeDrawdownRequestPayload>;
  bankConnectionGenerateUrl?: Maybe<BankConnectionGenerateUrlResult>;
  /** Batch add group members */
  batchAddGroupMembers: BatchAddGroupMembersResult;
  /** Archive users in bulk. */
  batchArchiveUsers: BatchArchiveUsersResult;
  /** Bulk create contacts */
  batchCreateContacts?: Maybe<BatchCreateContactsPayload>;
  /** Create cost centers in bulk */
  batchCreateCostCenters: BatchCreateCostCentersResult;
  /** Create departments in bulk */
  batchCreateDepartments: BatchCreateDepartmentsResult;
  /** Batch creates Extended Field Options */
  batchCreateExtendedFieldOptions: BatchCreateExtendedFieldOptionsResult;
  /** Batch create VX Extended Field Visibility Rules. Not atomic. */
  batchCreateExtendedFieldVisibilityRules: BatchCreateExtendedFieldVisibilityRulesResult;
  /** Create legal entities in bulk */
  batchCreateLegalEntities: BatchCreateLegalEntitiesResult;
  /** Create locations in bulk */
  batchCreateLocations: BatchCreateLocationsResult;
  /** Create mappings and corresponding workflow rules. */
  batchCreateMappings: BatchCreateMappingsResult;
  /** Batch create receipts for expense report */
  batchCreateReceiptsAndExpenses: BatchCreateReceiptsAndExpensesResult;
  /** Create a batch of reimbursement expenses (in draft state) */
  batchCreateReimbursementExpenses: BatchCreateReimbursementExpensesResult;
  /** Batch create actions for suggestions. ACCEPTED suggestions can be optionally applied to their corresponding entities. */
  batchCreateSuggestionActions: BatchCreateSuggestionActionsResult;
  /** Create titles in bulk */
  batchCreateTitles: BatchCreateTitlesResult;
  /** Create users in bulk */
  batchCreateUsers: BatchCreateUsersResult;
  /** Batch create vendor file matches */
  batchCreateVendorFileMatches: BatchCreateVendorFileMatchesResult;
  /** Batch create vendors */
  batchCreateVendors: BatchCreateVendorsResult;
  /** Batch create VX Workflow Rules */
  batchCreateWorkflowRules: BatchCreateWorkflowRulesResult;
  /** Batch Delete Budget */
  batchDeleteBudgets: BatchDeleteBudgetsResult;
  /** Batch delete VX Extended Field Visibility Rules */
  batchDeleteExtendedFieldVisibilityRule: BatchDeleteExtendedFieldVisibilityRulesResult;
  /** Batch delete VX Workflow Rules */
  batchDeleteRules: Array<Scalars["ID"]>;
  /** Delete user invites in bulk. */
  batchDeleteUserInvites: BatchDeleteUserInvitesResult;
  /** Disable users in bulk. */
  batchDisableUsers: BatchDisableUsersResult;
  /** Batch creates Extended Field Options from uploaded CSV file */
  batchImportExtendedFieldOptions: BatchImportExtendedFieldOptionsResult;
  /** Invite users in bulk. */
  batchInviteUsers: BatchInviteUsersResult;
  /** Batch Move Budget */
  batchMoveBudgets: BatchMoveBudgetsResult;
  /** Reactivate users in bulk. */
  batchReactivateUsers: BatchReactivateUsersResult;
  /** Batch remove group members */
  batchRemoveGroupMembers: BatchRemoveGroupMembersResult;
  /**
   * Restore embedded user sign in capabilities in bulk.
   * This can be called on ACTIVE users with SUSPENDED signIn,
   * and their signIn will be updated to ALLOWED.
   */
  batchRestoreToHybridEmbeddedUsers: BatchRestoreToHybridEmbeddedUsersResult;
  /** Batch sets the Users' Account-level ACCESS Role Assignments */
  batchSetAccessRoleAssignments?: Maybe<BatchSetUserRoleAssignmentsResult>;
  /** Batch set autopay funding source for multiple entity/product type pairs */
  batchSetEntityAutopayFundingSource?: Maybe<AutopayFundingSourceConnection>;
  /** Batch sets the Users' Account-level FUNCTIONAL Role Assignments */
  batchSetFunctionalRoleAssignments?: Maybe<BatchSetUserRoleAssignmentsResult>;
  /** Batch sets the Users' Account-level Role Assignments */
  batchSetUserRoleAssignments?: Maybe<BatchSetUserRoleAssignmentsResult>;
  /** Batch submit reimbursement expense */
  batchSubmitReimbursementExpenses: BatchSubmitReimbursementExpensesResult;
  /** Submits all requests on an analysis that are ready to submit. */
  batchSubmitVerificationRequests: BatchSubmitVerificationRequestsResult;
  /** Batch Terminate Budget */
  batchTerminateBudgets: BatchTerminateBudgetsResult;
  batchToggleRules?: Maybe<BatchToggleRulesPayload>;
  /** Unarchive users in bulk. */
  batchUnarchiveUsers: BatchUnarchiveUsersResult;
  /** Update accounting records. Support batch size up to 50 records. */
  batchUpdateAccountingRecords: BatchUpdateAccountingRecordsResult;
  /**
   * Batch upserts a list of extended field boolean value instances for a given object type.
   * Can optionally cascade updates of the instances (in the case of field dependencies).
   * Returns a list of results where each item can be either a success or error.
   */
  batchUpdateBooleanFieldInstance: BatchUpdateFieldInstanceResults;
  /** Endpoint to asynchronously update budget limits */
  batchUpdateBudgetLimitsAsync: BatchUpdateBudgetsLimitAsyncResult;
  /**
   * Batch upserts a list of extended field date value instances for a given object type.
   * Can optionally cascade updates of the instances (in the case of field dependencies).
   * Returns a list of results where each item can be either a success or error.
   */
  batchUpdateDateFieldInstance: BatchUpdateFieldInstanceResults;
  /**
   * Batch upserts a list of extended field decimal value instances for a given object type.
   * Can optionally cascade updates of the instances (in the case of field dependencies).
   * Returns a list of results where each item can be either a success or error.
   */
  batchUpdateDecimalFieldInstance: BatchUpdateFieldInstanceResults;
  /** Update departments in bulk */
  batchUpdateDepartments: BatchUpdateDepartmentsResult;
  /** Bulk update audit expense's status */
  batchUpdateExpensesAuditStatus?: Maybe<BatchUpdateExpensesAuditStatusResult>;
  /** Batch updates export job notifications */
  batchUpdateExportJobNotifications: BatchUpdateExportJobNotificationsResult;
  /** Batch updates Extended Field Options of a given extended field. */
  batchUpdateExtendedFieldOptions: BatchUpdateExtendedFieldOptionsResult;
  /** Batch update VX Extended Field Visibility Rules. Not atomic. */
  batchUpdateExtendedFieldVisibilityRules: BatchUpdateExtendedFieldVisibilityRulesResult;
  /**
   * Batch upserts a list of extended field financial asset value instances for a given object type.
   * Can optionally cascade updates of the instances (in the case of field dependencies).
   * Returns a list of results where each item can be either a success or error.
   */
  batchUpdateFinancialAssetFieldInstance: BatchUpdateFieldInstanceResults;
  /** Update locations in bulk */
  batchUpdateLocations: BatchUpdateLocationsResult;
  /**
   * Batch upserts a list of extended field option instances for a given object type.
   * Can optionally cascade updates of the instances (in the case of field dependencies).
   * Returns a list of results where each item can be either a success or error.
   */
  batchUpdateOptionFieldInstance: BatchUpdateFieldInstanceResults;
  /**
   * Batch upserts a list of extended field string value instances for a given object type.
   * Can optionally cascade updates of the instances (in the case of field dependencies).
   * Returns a list of results where each item can be either a success or error.
   */
  batchUpdateStringFieldInstance: BatchUpdateFieldInstanceResults;
  /**
   * Batch upserts a list of extended field timestamp value instances for a given object type.
   * Can optionally cascade updates of the instances (in the case of field dependencies).
   * Returns a list of results where each item can be either a success or error.
   */
  batchUpdateTimestampFieldInstance: BatchUpdateFieldInstanceResults;
  /**
   * Batch update HYBRID_EMBEDDED_USERs to EMBEDDED_USERs
   * in bulk. Users remain active, but signIn will
   * become SUSPENDED.
   */
  batchUpdateToEmbeddedUsers: BatchUpdateToEmbeddedUsersResult;
  /** Batch update user properties. */
  batchUpdateUsers?: Maybe<BatchUpdateUsersResult>;
  /** Batch update VX Workflow Rules */
  batchUpdateWorkflowRules: BatchUpdateWorkflowRulesResult;
  beginChannelVerification?: Maybe<BeginChannelVerificationPayload>;
  /** Add bills to batch */
  billBatchAddBills: BillBatchAddBillsResult;
  /** Approve the bill batch */
  billBatchApprove: BillBatchApproveResult;
  /** Create a bill batch with status of DRAFT and the assigned bills */
  billBatchBulkCreate: BillBatchBulkCreateResult;
  /** Delete bill batch, receives the ID of the bill batch to be deleted */
  billBatchDelete: BillBatchDeleteResult;
  /** Remove bills from batch */
  billBatchRemoveBills: BillBatchRemoveBillsResult;
  /** Retry a failed bill batch */
  billBatchRetry?: Maybe<RetryFailedBillBatchResult>;
  /** Update bill batch */
  billBatchUpdate: BillBatchUpdateResult;
  /** Retry payment for a declined bill expense */
  billRetryPayment: BillRetryPaymentResult;
  /**
   * Updates a Bill's payment date and source account.
   * If a Bill is part of a batch, the bill will be removed from that batch as the intention is to update it to individual billing.
   */
  billUpdatePaymentDetails: BillUpdatePaymentDetailsResult;
  bulkDisconnectErpFeeds?: Maybe<BulkDisconnectErpFeedsPayload>;
  bulkFindOrCreateErpFeeds?: Maybe<BulkFindOrCreateErpFeedsPayload>;
  /** Imports fields from external files (CSV, IIF) into Brex. */
  bulkImportFields: BulkImportFieldsResult;
  /**
   * Remove existing authorization(s) grant that allowed a user to view a comment thread and its entity. The user will
   * no longer be able to view the entity unless they have permission through another stream.
   */
  bulkRemoveCommentEntityAuthorizations: BulkRemoveCommentEntityAuthorizationsResult;
  /** Bulk resolve suggestion groups. Will act on suggestions in those groups based on the resolution chosen. */
  bulkResolveSuggestionGroups: BulkResolveSuggestionGroupsResult;
  /** Bulk transitions expense's request actions to a specified state. */
  bulkTransitionExpenseRequestActions: BulkTransitionExpenseRequestActionsResult;
  /** Bulk transitions an expense's request to a specified state. CURRENTLY THE EQUIVALENT OF ADMIN OVERRIDE. */
  bulkTransitionExpenseRequests: BulkTransitionExpenseRequestsResult;
  /** Bulk Update Budgets */
  bulkUpdateBudgets: BulkUpdateBudgetsResult;
  /**
   * Bulk update expenses.
   * Only budget and memo are supported to be bulk updated
   */
  bulkUpdateExpenses: BulkUpdateExpensesResult;
  /** Bulk updates Extended Field Options of a given extended field. */
  bulkUpdateExtendedFieldOptions: BulkUpdateExtendedFieldOptionsResult;
  /** Update the status of vendor file match(es) */
  bulkUpdateVendorFileMatchStatuses: BulkUpdateVendorFileMatchesResult;
  /** Update vendor file match(es) */
  bulkUpdateVendorFileMatches: BulkUpdateVendorFileMatchesResult;
  /** @deprecated Use 'onboardingCreateApplication' instead, passing in the blueprint name:'gemini' */
  cDa?: Maybe<CDaPayload>;
  /** Cancel a submitted bill expense. */
  cancelBill: BillResult;
  /** Cancel a bill transmission (does not support cash transactions) */
  cancelBillPayment?: Maybe<CancelBillPaymentPayload>;
  /**
   * Cancel a bill transmission (does not support cash transactions).
   * Does not return the bill as it is updated asynchronously.
   */
  cancelBillPaymentV2: BillIdResult;
  /**
   * Cancel a budget limit increase request
   * @deprecated Use cancelLimitIncreaseRequest instead
   */
  cancelBudgetLimitIncreaseRequest: Scalars["ID"];
  /**
   * Cancel a budget limit increase request
   * @deprecated Use cancelLimitIncreaseRequest instead
   */
  cancelBudgetLimitIncreaseRequestV2: CancelBudgetLimitIncreaseRequestV2Result;
  /** Cancel a request for a new budget */
  cancelBudgetRequest: Scalars["ID"];
  /** Cancel bulk update expenses execution in a best-effort manner. */
  cancelBulkUpdateExpenses: CancelBulkUpdateExpensesResult;
  cancelCashRecurringSchedule?: Maybe<CancelCashRecurringSchedulePayload>;
  cancelCashTransaction?: Maybe<CancelCashTransactionPayload>;
  /** Cancel a Clawback request */
  cancelClawback: CancelClawbackResult;
  /** Cancel a dispute with expense IDs */
  cancelDispute: CancelDisputeResult;
  /** Cancel a user's in-progress email change. */
  cancelEmailChange: CancelEmailChangeResult;
  /**
   * Cancel an expense
   * The operation isn't guaranteed to be atomic, and should be retried until it succeeds.
   */
  cancelExpense?: Maybe<CancelExpenseResult>;
  /** Cancel a new group event. */
  cancelGroupEvent: CancelGroupEventResult;
  cancelPayment?: Maybe<CancelPaymentPayload>;
  /** Cancel an existing purchasing card */
  cancelPurchasingCard: CancelPurchasingCardResult;
  cancelScheduledPrepayment?: Maybe<CancelScheduledPrepaymentPayload>;
  /** Create a card alias for a card */
  cardAliasCreate?: Maybe<CardAliasCreateMutationResult>;
  /** Disables auto assignment on the employee card. */
  cardDisableLimitSourceAutoAssignment?: Maybe<CardDisableLimitSourceAutoAssignmentResult>;
  /** Enables auto assignment on the employee card. */
  cardEnableLimitSourceAutoAssignment?: Maybe<CardEnableLimitSourceAutoAssignmentResult>;
  /** Create a card partner feed rule. */
  cardPartnerFeedRuleCreate?: Maybe<CardPartnerFeedRuleCreateResult>;
  /** Transfer a card to a new owner */
  cardTransfer?: Maybe<CardTransferResult>;
  changeInvestmentPolicy?: Maybe<ChangeInvestmentPolicyPayload>;
  /** Remove all searched entries for the specified search location */
  clearRecentSearches?: Maybe<RecentSearchError>;
  /** Commits draft fields - saves changes from the draft to the origin */
  commitDraftFields?: Maybe<CommitDraftFieldsResult>;
  completeCashTransactionApproval?: Maybe<CompleteCashTransactionApprovalPayload>;
  /**
   * Complete the clawback request.
   * Allowed roles: admin, bookkeeper, manager
   */
  completeClawback: CompleteClawbackResult;
  /** Completes onboarding for the current user. */
  completeOnboarding?: Maybe<CompleteOnboardingPayload>;
  completeOnboardingApplications?: Maybe<WorkflowResult>;
  /**
   * Create or update the products a customer selected, and regenerate open applications as needed.
   * Only call this for accounts with status='waiting_submission'
   */
  configureProductSelection: ProductSelectionResult;
  confirmMfa?: Maybe<ConfirmMfaPayload>;
  /** Confirm a pending email change, updating the email. */
  confirmPendingEmailChange: ConfirmPendingEmailChangeResult;
  connectCredential?: Maybe<ConnectCredentialPayload>;
  connectInstitution?: Maybe<ConnectInstitutionPayload>;
  connectPersonal?: Maybe<ConnectPersonalPayload>;
  connectPlaidInstitution?: Maybe<ConnectPlaidInstitutionPayload>;
  connectShopifyCredential?: Maybe<ConnectShopifyCredentialPayload>;
  connectTellerInstitution?: Maybe<ConnectTellerInstitutionPayload>;
  /** Updates an existing connection. Only supported for Netsuite, Oracle Fusion, and Workday vendors. Other vendors will result in an error. */
  connectionUpdate: ConnectionUpdateResult;
  convertCardAccountType?: Maybe<ConvertCardAccountTypePayload>;
  createAccount?: Maybe<CreateAccountPayload>;
  /**
   * Create a new accounting integration.
   * If a disabled accounting integration with the same vendor account id(stored in vendor credential) exist,
   * we will re-enable the existing integration and automatically trigger a refresh job.
   */
  createAccountingIntegration: CreateAccountingIntegrationResult;
  /** Creates a report of transactions in the accounting journal. Only supported for 1B. */
  createAccountingJournalReport: CreateAccountingJournalReportResult;
  /** Writes a credential entry into database table and connects to vendor given vendor defined Auth params. */
  createAndConnectCredential: CreateAndConnectCredentialResult;
  /** Create (and store) an asset in the backend. */
  createAsset?: Maybe<CreateAssetPayload>;
  createAssistantFeedback: CreateAssistantFeedbackResult;
  /**
   * Create attribute mappings
   * @deprecated Prefer ExternalLegalEntityMappingBatchCreate
   */
  createAttributeMappings: CreateAttributeMappingsResult;
  /** Create auto invite setting */
  createAutoInviteSetting: CreateOrUpdateAutoInviteSettingResult;
  createAutomaticTransferSettings?: Maybe<CreateAutomaticTransferSettingsPayload>;
  createAutomationWorkflowSpecs?: Maybe<CreateAutomationWorkflowSpecsResult>;
  createBill?: Maybe<CreateBillPayload>;
  /**
   * Create a bill batch with status of DRAFT and the assigned bills
   * @deprecated Use billBatchBulkCreate instead
   */
  createBillBatches: CreateBillBatchesResult;
  /** Create a new bill. */
  createBillV2: BillResult;
  /**
   * Create Budget
   * @deprecated Use createBudgetFromTemplate - this will be repurposed for bifurcated Budget creation
   */
  createBudget: CreateBudgetResult;
  /**
   * Create a new budget limit increase request
   * @deprecated Use createLimitIncreaseRequest instead
   */
  createBudgetLimitIncreaseRequest: BudgetLimitIncreaseRequestEntity;
  /** Create a request for a new Budget */
  createBudgetRequest: CreateBudgetRequestResult;
  /** Create a request for a new Budget from a Budget Template */
  createBudgetRequestFromTemplate: CreateBudgetRequestResult;
  /** Create a Budget Template */
  createBudgetTemplate: CreateBudgetTemplateResult;
  /** Create a budget template */
  createBudgetTemplateV2: BudgetTemplate;
  createCashTransaction?: Maybe<CreateCashTransactionPayload>;
  createCashWireDetails?: Maybe<CreateCashWireDetailsPayload>;
  createChannelPreferences?: Maybe<CreateChannelPreferencesPayload>;
  /**
   * "
   * Create a Clawback request
   */
  createClawback: CreateClawbackResult;
  /** Create a Comment. */
  createComment: CreateCommentResult;
  /** Create multiple Comments at once. */
  createComments: CreateCommentsResult;
  createContact?: Maybe<CreateContactPayload>;
  /** Create a Copilot */
  createCopilot?: Maybe<Copilot>;
  /** Create a cost center */
  createCostCenter?: Maybe<CreateCostCenterResult>;
  createCounterparty?: Maybe<CreateCounterpartyPayload>;
  createCredential?: Maybe<CreateCredentialPayload>;
  /** Create a new role, unique to the logged in user's account. */
  createCustomRole?: Maybe<CreateCustomRoleResult>;
  /**  Exceptions list */
  createCustomerSsoExclusion?: Maybe<CreateCustomerSsoExclusionResult>;
  /**
   * Creates a default field for a given subsidiary and extended field
   *
   * Will throw an error if we attempt to create a new default field for the same subsidiary
   * and extended field as an existing default field
   */
  createDefaultIntegrationFieldMapping: CreateDefaultIntegrationFieldMappingResult;
  createDepositsApplication?: Maybe<CreateDepositsApplicationPayload>;
  /** Creates a new developer API token */
  createDeveloperApiToken?: Maybe<CreateDeveloperApiTokenPayload>;
  createDisclosureApplication?: Maybe<CreateDisclosureApplicationPayload>;
  /** Creates a DocumentOCR entry, and initiates the OCR process on the document. */
  createDocumentOcr?: Maybe<CreateDocumentOcrPayload>;
  /** Create an early commitment if it doesn't exist or get the existing commitment from the customer */
  createEarlyCreditCommitment?: Maybe<EarlyCreditCommitment>;
  createEmailChannel?: Maybe<CreateEmailChannelPayload>;
  createEmpowerCustomerInquiry?: Maybe<CreateEmpowerCustomerInquiryPayload>;
  /** Creates engagement settings for the account of the user in context. */
  createEngagementSetting: CreateEngagementSettingResult;
  /**
   * Create an entity mapping on the integration settings.
   *
   * These are the legal entity to subsidiary mappings.
   */
  createEntityMapping: CreateEntityMappingResult;
  /**
   * Create an expense
   * The operation isn't guaranteed to be atomic, and should be retried until it succeeds.
   */
  createExpense?: Maybe<CreateExpenseResult>;
  /** Create a notification related to an expense, based on the expense notification details provided (e.g. receipt push) */
  createExpenseNotification: CreateExpenseNotificationResult;
  /** Create an expense report */
  createExpenseReport: CreateExpenseReportResult;
  /** Exports expenses from given expenses filter search report by request file type */
  createExpensesSearchReport: CreateExpensesSearchReportResult;
  /** Create Extended Field */
  createExtendedField: CreateExtendedFieldResult;
  createExtendedFieldOptionsReport: CreateExtendedFieldOptionsReportResult;
  /** Create a VX Extended Field Visibility Rule */
  createExtendedFieldVisibilityRule: CreateExtendedFieldVisibilityRuleResult;
  /** Create multiple Extended Fields */
  createExtendedFields?: Maybe<CreateExtendedFieldsResult>;
  /** Creates a new piece of Feedback */
  createFeedback?: Maybe<CreateFeedbackPayload>;
  /** Create a URL that can be used to upload a file asset. */
  createFileUploadUrl?: Maybe<CreateFileUploadUrlPayload>;
  createFinancialBankStatement?: Maybe<CreateFinancialBankStatementPayload>;
  createFinancialBankStatementForNewAccount?: Maybe<CreateFinancialBankStatementForNewAccountPayload>;
  /** Create financial document uploaded by customer */
  createFinancialDocument?: Maybe<CreateFinancialDocumentResult>;
  /** Create a fraud dispute with an expense input */
  createFraudDisputeFromExpense: CreateFraudDisputeFromExpenseResult;
  createFundingSource?: Maybe<CreateFundingSourcePayload>;
  createFundingSourceForPendingMicroDeposits?: Maybe<CreateFundingSourceForPendingMicroDepositsPayload>;
  /** Create group */
  createGroup: CreateGroupResult;
  /** Create a new group event. */
  createGroupEvent: CreateGroupEventResult;
  /** Create an HRIS connection. */
  createHrConnection?: Maybe<HrConnection>;
  createIntegration?: Maybe<CreateIntegrationPayload>;
  createIntegrationRule?: Maybe<CreateIntegrationRulePayload>;
  createInvoice?: Maybe<CreateInvoicePayload>;
  createInvoiceTemplate?: Maybe<CreateInvoiceTemplatePayload>;
  /**  Create invoice template. */
  createInvoiceTemplateV1: InvoiceTemplateV1Result;
  /**  Create invoice. */
  createInvoiceV1: InvoiceV1Result;
  /**  Create invoicing account. */
  createInvoicingAccountV1: InvoicingAccountV1Result;
  /**  Create contact for payer or invoicer. */
  createInvoicingContactV1: InvoicingContactV1Result;
  /** Add ItineraryActivity to a group event. */
  createItineraryActivity: CreateItineraryActivityResult;
  createLLMOAuthIntegration: CreateLLMOAuthIntegrationResult;
  createLead?: Maybe<CreateLeadPayload>;
  /** Create a legal entity */
  createLegalEntity?: Maybe<CreateLegalEntityResult>;
  /** Create a limit group */
  createLimitGroup: CreateLimitGroupResult;
  /** Creates a Merge link token to be used when linking a new end user. */
  createLinkToken?: Maybe<CreateLinkTokenResult>;
  /** Creates a manual push payment status to mark a push payment as initiated or reset */
  createManualPushPaymentStatus: CreateManualPushPaymentStatusResponse;
  /** Create a mapping and a corresponding workflow rule. */
  createMapping: CreateMappingResult;
  /** Create a mapping class */
  createMappingClass: CreateMappingClassResult;
  /** Create a merchant dispute with an expense input */
  createMerchantDisputeFromExpense: CreateMerchantDisputeFromExpenseResult;
  /** Creates a new miles transfer */
  createMilesTransferV2?: Maybe<CreateMilesTransferPayloadV2>;
  /** Note: creates and connects NetSuite credential, no need to call connect_credential afterwards */
  createNetsuiteCredential?: Maybe<CreateNetsuiteCredentialPayload>;
  createNonPrimaryDepositsAccount?: Maybe<CreateNonPrimaryDepositsAccountPayload>;
  createOIDCIdpConfig?: Maybe<CreateIdpConfigResult>;
  createOnboardingApplication?: Maybe<CreateOnboardingApplicationResult>;
  /** Creates a kyc onboarding application following a blueprint of the given name */
  createOnboardingKycApplication?: Maybe<CreateOnboardingKycApplicationPayload>;
  /** Creates a product onboarding application following a blueprint of the given name */
  createOnboardingProductApplication?: Maybe<CreateOnboardingProductApplicationPayload>;
  /** Creates a product v2 application (decoupled financial product from kyc) following a blueprint of the given name */
  createOnboardingProductV2Application?: Maybe<CreateOnboardingProductV2ApplicationPayload>;
  /** Create or update AI policy settings for a customer account */
  createOrUpdateAiPolicySetting?: Maybe<CreateOrUpdateAiPolicySettingResult>;
  createOrUpdateApprovalChainPolicy: ApprovalChainResult;
  createOrUpdateBudgetLimitIncreasePolicy: Policy;
  createOrUpdateExpensePolicy: Policy;
  /** Creates or updates a banking policy. */
  createOrUpdatePolicy: BankingPolicy;
  /** Creates and connects Oracle Fusion credential, no need to call connect_credential afterwards */
  createOracleFusionCredential?: Maybe<CreateOracleFusionCredentialPayload>;
  createPayer?: Maybe<CreatePayerPayload>;
  createPaymentEarlyAuthBalanceDecreaseCommitment?: Maybe<CreatePaymentEarlyAuthBalanceDecreaseCommitmentPayload>;
  createPaymentFxQuote?: Maybe<CreatePaymentFxQuotePayload>;
  createPaymentInstrument?: Maybe<CreatePaymentInstrumentPayload>;
  createPayrollProvider?: Maybe<CreatePayrollProviderPayload>;
  createPeriodicReviewApplication?: Maybe<CreatePeriodicReviewApplicationPayload>;
  /** Create a physical card */
  createPhysicalCardV2?: Maybe<CreatePhysicalCardV2Payload>;
  createPositivePayAccountSetting?: Maybe<CreatePositivePayAccountSettingPayload>;
  /** Creates a new positive pay account setting. */
  createPositivePayAccountSettingV2?: Maybe<CreatePositivePayAccountSettingPayload>;
  /** Create a purchase order */
  createPurchaseOrder: CreatePurchaseOrderResult;
  /** Create a new purchasing card */
  createPurchasingCard: CreatePurchasingCardResult;
  createPushChannel?: Maybe<CreatePushChannelPayload>;
  /**
   * Creates new rail account details for external banking accounts.
   * This establishes the configuration needed to send or receive payments
   * through various payment rails (ACH, WIRE, SWIFT, etc.).
   *
   * The creation process may initiate required verifications based on the rail type
   * and regulatory requirements. Returns the created rail account details with
   * any associated verification processes.
   */
  createRailAccountDetails: CreateRailAccountDetailsResult;
  /** Creates an integration with one of our receipts partners. */
  createReceiptIntegration: CreateReceiptIntegrationResponse;
  /** Creates an Empower receipt and sends to matching */
  createReceiptV2?: Maybe<Receipt>;
  /** Submit a draft reimbursement expense requests for a booking. */
  createReimbursementExpenseForBooking: Expense;
  /**
   * Create a template
   * @deprecated No longer supported
   */
  createReportTemplate?: Maybe<Scalars["Boolean"]>;
  /** Create a scheduled report */
  createReportingDashboardSchedule: CreateReportingDashboardScheduleResult;
  /** Creates request deadline settings for the caller's account. */
  createRequestDeadlineSettings: CreateRequestDeadlineSettingsResult;
  /** Submits a response to an existing RFI. */
  createResponseToRfi?: Maybe<CreateResponseToRfiPayload>;
  /**  SSO setup (multi-step wizard) */
  createSAMLPlaceholder?: Maybe<CreateSAMLPlaceholderResult>;
  /** Creates and connects a SageIntacct credential, no need to call connect_credential afterwards */
  createSageintacctCredential?: Maybe<CreateSageintacctCredentialPayload>;
  /** Triggers a new action for the current sandbox account. */
  createSandboxAccountAction: CreateSandboxAccountActionResult;
  createSmsChannel?: Maybe<CreateSmsChannelPayload>;
  /** Create a new spend budget */
  createSpendBudget: CreateSpendBudgetResult;
  /** Create a spend limit */
  createSpendLimit: CreateSpendLimitResult;
  createSubscription?: Maybe<CreateSubscriptionPayload>;
  createSubscriptions?: Maybe<CreateSubscriptionsPayload>;
  /** Creates a new task */
  createTask: Task;
  /** Create a title */
  createTitle?: Maybe<CreateTitleResult>;
  /** Creates a tracking expense policy for a user */
  createTrackingExpensePolicy: TrackingExpensePolicyResult;
  createTransactionApprovedSubscription?: Maybe<CreateTransactionApprovedSubscriptionPayload>;
  createTransactionRefusedSubscription?: Maybe<CreateTransactionRefusedSubscriptionPayload>;
  /** Create a new trip record in the Travel Service / Spotnana. */
  createTrip: CreateTripResult;
  createUserCategories?: Maybe<CreateUserCategoriesPayload>;
  /** Create a user management setting for an HRIS connection. */
  createUserManagementSettings?: Maybe<UserManagementSettings>;
  /** Create a vendor */
  createVendor: CreateVendorResult;
  /** Create a virtual card */
  createVirtualCardV2?: Maybe<CreateVirtualCardV2Payload>;
  /** Creates and connects Workday credential, no need to call connect_credential afterwards */
  createWorkdayCredential?: Maybe<CreateWorkdayCredentialPayload>;
  /** Create a VX Workflow Rule */
  createWorkflowRule: CreateWorkflowRuleResult;
  /** Delete auto invite setting */
  deleteAutoInviteSetting: DeleteAutoInviteSettingResult;
  deleteBill?: Maybe<DeleteBillPayload>;
  /** Delete a draft bill. */
  deleteBillV2: BillIdResult;
  /** Delete Budget */
  deleteBudget: Scalars["ID"];
  /** Delete a Budget Template */
  deleteBudgetTemplate: DeleteBudgetTemplateResult;
  deleteContact?: Maybe<DeleteContactPayload>;
  /** Delete a cost center */
  deleteCostCenter?: Maybe<DeleteCostCenterResult>;
  /**
   * Delete an existing role.
   * Deletion of Brex's standard roles, e.g. Card Admin, is not supported.
   */
  deleteCustomRole?: Maybe<DeleteCustomRoleResult>;
  deleteCustomerSsoExclusion?: Maybe<DeleteCustomerSsoExclusionResult>;
  /** Deletes a default field */
  deleteDefaultIntegrationFieldMapping: DeleteDefaultIntegrationFieldMappingResult;
  /** Delete a draft trip. */
  deleteDraftTrip: Scalars["Boolean"];
  /** Delete an entity mapping on the integration settings. */
  deleteEntityMapping: DeleteEntityMappingResult;
  /** Delete Extended Field */
  deleteExtendedField?: Maybe<DeleteExtendedFieldResult>;
  /** Delete a VX Extended Field Visibility Rule */
  deleteExtendedFieldVisibilityRule: DeleteExtendedFieldVisibilityRuleResult;
  /** Delete financial document uploaded by customer */
  deleteFinancialDocument?: Maybe<DeleteFinancialDocumentResult>;
  /** Delete group */
  deleteGroup: DeleteGroupResult;
  /** Delete a canceled group event. */
  deleteGroupEvent: DeleteGroupEventResult;
  deleteIntegrationRule?: Maybe<DeleteIntegrationRulePayload>;
  /**  Delete invoice. */
  deleteInvoiceV1: DeleteInvoiceV1Result;
  /** Delete ItineraryActivity from a group event. */
  deleteItineraryActivity: DeleteItineraryActivityResult;
  /** Delete a legal entity */
  deleteLegalEntity?: Maybe<DeleteLegalEntityResult>;
  /** Delete a limit group */
  deleteLimitGroup: DeleteLimitGroupResult;
  /** Delete a mapping and the corresponding workflow rule. */
  deleteMapping: DeleteMappingResult;
  /** Delete a mapping class. Required the mapping class to not have any mappings. */
  deleteMappingClass: DeleteMappingClassResult;
  deletePaymentInstrument?: Maybe<DeletePaymentInstrumentPayload>;
  /** Soft delete payment instrument association for the given payment instrument logical id. */
  deletePaymentInstrumentAssociation: PaymentInstrumentAssociationId;
  /**
   * Delete a policy spec section
   *
   * Note that this is a soft delete, so the section will still be available in the DB
   * but marked as deleted.
   */
  deletePolicySpecSection: DeletePolicySpecSectionResult;
  deletePositivePayAccountSetting?: Maybe<DeletePositivePayAccountSettingPayload>;
  /** Deletes a positive pay account setting. */
  deletePositivePayAccountSettingV2?: Maybe<DeletePositivePayAccountSettingPayload>;
  /** Delete purchase orders */
  deletePurchaseOrders: DeletePurchaseOrdersResult;
  /**
   * Soft-deletes rail account details by marking them as deleted.
   * This prevents future use while preserving historical transaction data.
   *
   * Deleted rail account details cannot be used for new transactions
   * but remain accessible for reporting and audit purposes.
   */
  deleteRailAccountDetails: DeleteRailAccountDetailsResult;
  deleteReceipt?: Maybe<DeleteReceiptPayload>;
  /**
   * Mutation to delete integration received from revoke redirect.
   * Will delete whatever integration is associated with the caller's customer account.
   */
  deleteReceiptIntegration: DeleteReceiptIntegrationResponse;
  /** Delete reimbursement */
  deleteReimbursement?: Maybe<DeleteReimbursementPayload>;
  /**
   * Delete a template
   * @deprecated No longer supported
   */
  deleteReportTemplate?: Maybe<Scalars["Boolean"]>;
  /** Delete a report */
  deleteReportingDashboard: DeleteReportingDashboardResult;
  /** Delete a spend budget */
  deleteSpendBudget: DeleteSpendBudgetResult;
  /** Delete a spend limit */
  deleteSpendLimit: DeleteSpendLimitResult;
  deleteSubscription?: Maybe<DeleteSubscriptionPayload>;
  deleteSubscriptions?: Maybe<DeleteSubscriptionsPayload>;
  deleteSubsidiaryDefaultEntity?: Maybe<DeleteSubsidiaryDefaultEntityPayload>;
  /** Delete a title */
  deleteTitle?: Maybe<DeleteCostCenterResult>;
  /** Soft deletes a tracking expense policy for a user */
  deleteTrackingExpensePolicy: TrackingExpensePolicyResult;
  /** Deletes the vendors */
  deleteVendors: DeleteVendorsResult;
  /** Delete a VX Workflow Rule */
  deleteWorkflowRule: Scalars["ID"];
  depositCheque?: Maybe<DepositChequePayload>;
  dgsProcessInvoice: ExtractedBillFields;
  dgsProcessInvoiceAndCreateBill: BillResult;
  /** Disable an accounting integration. */
  disableAccountingIntegration: DisableAccountingIntegrationResult;
  disableAutomaticTransferSettings?: Maybe<DisableAutomaticTransferSettingsPayload>;
  disableBills?: Maybe<DisableBillsPayload>;
  /** API call to disable a channel for a user */
  disableChannel?: Maybe<DisableChannelPayload>;
  disableExpenses?: Maybe<DisableExpensesPayload>;
  /** Disable an HRIS connection. Returns the connection that was deleted on success. */
  disableHrConnection?: Maybe<HrConnection>;
  disableIntegration?: Maybe<DisableIntegrationPayload>;
  disableLimitUtilizationTrigger?: Maybe<DisableLimitUtilizationTriggerPayload>;
  disableNonPrimaryFundingSources?: Maybe<DisableNonPrimaryFundingSourcesPayload>;
  /**
   * Disables a policy. This means the policy will appear to customers as Archived. When a customer
   * is creating or editing a budget, this policy will no longer appear as an option to be associated
   * with that budget. Existing budgets are not affected by this change, meaning that the policy will
   * still be used to evaluate expenses in any budgets that are currently associated with it.
   */
  disablePolicy: Policy;
  disableReimbursements?: Maybe<DisableReimbursementsPayload>;
  /**
   * Disables a toggle for the current account
   * @deprecated use productConfigToggleDisable instead
   */
  disableToggle: ToggleMutationResponse;
  disconnectApiClient?: Maybe<DisconnectApiClientPayload>;
  disconnectCredential?: Maybe<DisconnectCredentialPayload>;
  /** Disconnects the credential in database and revokes access to vendor. */
  disconnectCredentialV2: DisconnectCredentialResultV2;
  disconnectErpFeed?: Maybe<DisconnectErpFeedPayload>;
  /** Disconnect a connected payroll provider integration */
  disconnectPayrollProviderIntegration?: Maybe<DisconnectPayrollProviderIntegrationPayload>;
  /**  SSO configuration (details pane) */
  disconnectSsoIntegration?: Maybe<DisconnectSsoIntegrationResult>;
  dismissCardFraudAlertWithTransaction?: Maybe<DismissCardFraudAlertWithTransactionResult>;
  /** Dismisses the legal entity setup task based on product type */
  dismissLegalEntitySetupTask: DismissLegalEntitySetupTaskResponse;
  /** Dismisses the Resolution Center for a given User for a given Escalation for a period of time (24 hours) */
  dismissLimitEscalation?: Maybe<DismissLimitEscalationResult>;
  /**
   * Soft-deletes all download jobs with the given ids. Actual export files in filestore are still preserved.
   * This mutation checks if the jobs exist before deletion. If any of the provided job IDs does not exist, an error will be returned and no jobs will be deleted.
   */
  downloadJobsDeleteById?: Maybe<DownloadJobsDeleteResult>;
  /**
   * Marks the specified download jobs as downloaded, changing their status from READY_FOR_DOWNLOAD or COMPLETED(deprecated) to DOWNLOADED.
   * If any of the provided IDs do not exist, an error will be returned and no jobs will be marked as downloaded.
   * If any of the provided jobs are not in the READY_FOR_DOWNLOAD or COMPLETED state, an error will be returned and no jobs will be marked as downloaded.
   */
  downloadJobsMarkAsDownloaded?: Maybe<DownloadJobsMutationResult>;
  /** Generate PDF URL for a drawdown authorization. */
  drawdownAuthorizationGeneratePdfUrl?: Maybe<DrawdownAuthorizationGeneratePdfUrlResult>;
  /** Rescind a drawdown authorization for a deposit account. */
  drawdownAuthorizationRescind: DrawdownAuthorizationRescindResult;
  /** Create a drawdown authorization for a deposit account. */
  drawdownAuthorizationSubmit: DrawdownAuthorizationSubmitResult;
  /** Duplicate a Budget Template */
  duplicateBudgetTemplate: DuplicateBudgetTemplateResult;
  /** Duplicates a policy */
  duplicatePolicy: DuplicatePolicyResult;
  /** Duplicate a report with a new name. */
  duplicateReportingDashboard: DuplicateReportingDashboardResult;
  /** Edits the billing configuration settings for an entity */
  editBillingConfigurationSettings: EditBillingConfigurationSettingsResponse;
  editInvoice?: Maybe<EditInvoicePayload>;
  /**  Edit invoice template. */
  editInvoiceTemplateV1: InvoiceTemplateV1Result;
  /**  Edit invoice. */
  editInvoiceV1: InvoiceV1Result;
  /**  Edit contact for payer or invoicer. */
  editInvoicingContactV1: InvoicingContactV1Result;
  /**
   * Edits the reimbursement settings for an entity
   * @deprecated Use editBillingConfigurationSettings instead
   */
  editReimbursementSettings: EditReimbursementSettingsResponse;
  /**
   * Creates a bill pay configuration for a legal entity. Optionally also
   * sets:
   * - configuration funding source and billing currencies
   */
  enableBillPayBilling: EnableBillingResponse;
  /**
   * Creates a card billing configuration for a legal entity. Optionally also
   * sets:
   * - configuration funding source and billing currencies
   * - legal entity country
   */
  enableBilling: EnableBillingResponse;
  enableBills?: Maybe<EnableBillsPayload>;
  /**
   * Creates a reimbursements billing configuration for a legal entity. Optionally also
   * sets:
   * - legal entity country
   */
  enableEmployeeTracking: EnableEmployeeTrackingResponse;
  enableExpenses?: Maybe<EnableExpensesPayload>;
  /** Enable an integration */
  enableIntegration?: Maybe<EnableIntegrationPayload>;
  /** This will find the user's last disabled channel for the given channel type and re-enable it. This is useful for opt-in and opt-out management */
  enableLastDisabledChannel?: Maybe<EnableLastDisabledChannelPayload>;
  /**
   * Enables a policy. This means the policy will no longer appear as Archived. When creating or
   * editing a budget, it will be possible to associate this policy with it.
   */
  enablePolicy: Policy;
  enableReimbursements?: Maybe<EnableReimbursementsPayload>;
  /**
   * Creates a reimbursements billing configuration for a legal entity. Optionally also
   * sets:
   * - configuration funding source and billing currencies
   * - legal entity country
   */
  enableReimbursementsBilling: EnableReimbursementsBillingResponse;
  /**
   * Enables a toggle for the current account
   * @deprecated use productConfigToggleEnable instead
   */
  enableToggle: ToggleMutationResponse;
  /** Unsplit an expense */
  expenseUnsplit?: Maybe<ExpenseUnsplitResult>;
  /**
   * Updates the purpose of an expense (e.g. trip, conference, etc.).
   * Also updates the memo of the expense to reflect the purpose.
   */
  expenseUpdatePurpose: ExpenseUpdatePurposeResult;
  exportBills?: Maybe<ExportBillsPayload>;
  /** Exports bills synchronously to an external ERP. Results are available immediately. */
  exportBillsToErpSync?: Maybe<ExportBillsToErpSyncResult>;
  /** Exports bill data as a CSV */
  exportBillsV2: BillDownloadUrlResult;
  /** WIP - Export expenses using downloads platform */
  exportExpenses: DownloadsPlatformAsyncExportResult;
  /** Exports mappings to a CSV in filestore */
  exportMappingsToCsv?: Maybe<ExportMappingsToCsvResult>;
  /** Exports bill pay objects synchronously to an external ERP. Results are available immediately. */
  exportObjectsToErp?: Maybe<ExportObjectsToErpResult>;
  /** Export rewards points history to file asynchronously */
  exportRewardsPointsHistory?: Maybe<DownloadsPlatformAsyncExportResult>;
  /** Export using downloads platform. */
  exportTeam?: Maybe<DownloadsPlatformAsyncExportResult>;
  /** Marks expenses as tracked and generate an export with those expenses data */
  exportTrackedExpenses: ExportTrackedExpensesResult;
  /** Export travel bookings to file asynchronously */
  exportTravelBookings: DownloadsPlatformAsyncExportResult;
  /** Export vendors to file asynchronously */
  exportVendors?: Maybe<DownloadsPlatformAsyncExportResult>;
  /** Create a CSV template for an extended field, the generated asset is a CSV file pre populated with all options for the extended field. */
  extendedFieldCreateCSVTemplate?: Maybe<ExtendedFieldCreateCSVTemplateResult>;
  /** Initialize a draft - required to start allowing updates / creates to a given draft ID */
  extendedFieldCreateDraft?: Maybe<ExtendedFieldCreateDraftResult>;
  /** Update an Extended Field Options of a given Extended Field */
  extendedFieldOptionCreate: ExtendedFieldOptionCreateResult;
  /** Delete an Extended Field Option */
  extendedFieldOptionDelete?: Maybe<ExtendedFieldOptionsMutationError>;
  /** Update an Extended Field Options of a given Extended Field */
  extendedFieldOptionUpdate: ExtendedFieldOptionUpdateResult;
  /** Map upstream HR legal entities to Brex legal entities */
  externalLegalEntityMappingBatchCreate: ExternalLegalEntityMappingBatchCreateResult;
  /** Update mapping from upstream HR legal entity to Brex legal entity */
  externalLegalEntityMappingBatchUpdate: ExternalLegalEntityMappingBatchUpdateResult;
  /** @deprecated DO NOT USE. This exist just so the enum types can be auto generated in global types file. */
  fakeMutationDoNotUse?: Maybe<FakeMutationDoNotUsePayload>;
  findOrCreateErpFeed?: Maybe<FindOrCreateErpFeedPayload>;
  finicityConnectGenerateFixUrl?: Maybe<FinicityConnectGenerateFixUrlPayload>;
  finicityConnectGenerateLiteUrl?: Maybe<FinicityConnectGenerateLiteUrlPayload>;
  finicityConnectMigrateAccounts?: Maybe<FinicityConnectMigrateAccountsPayload>;
  finishChannelVerification?: Maybe<FinishChannelVerificationPayload>;
  forceApproveApplication?: Maybe<WorkflowResult>;
  forgetDevice?: Maybe<ForgetDeviceResult>;
  /** Generates an Airwallex KYC link for a legal entity */
  generateAirwallexKycLink: GenerateAirwallexKycLinkResponse;
  /** Generates a KYC hosted flow link for a banking provider entity. */
  generateBankingProviderKycHostedFlowLink: GenerateBankingProviderKycHostedFlowLinkResult;
  generateBillPaymentReceiptDownloadUrl?: Maybe<GenerateBillPaymentReceiptDownloadUrlPayload>;
  generateBillPaymentReceiptDownloadUrlV2: BillDownloadUrlResult;
  /** Generates a URL to download a ZIP file containing all the statements for a given deposits account. */
  generateBulkStatementsZipDownloadUrl?: Maybe<GenerateBulkStatementsZipDownloadUrlResult>;
  /** Generate custom download url for statement */
  generateCustomStatementDownloadUrl: GenerateStatementDownloadUrlResponse;
  /** Generates a custom download URL for a statement based on a payment ID */
  generateCustomStatementFromPaymentDownloadUrl: GenerateStatementDownloadUrlResponse;
  generateDepositsStatementDocumentDownloadUrl?: Maybe<GenerateDepositsStatementDocumentDownloadUrlPayload>;
  generateDepositsTransactionConfirmationDownloadUrl?: Maybe<GenerateDepositsTransactionConfirmationDownloadUrlPayload>;
  generateDepositsVerificationLetterDownloadUrl?: Maybe<GenerateDepositsVerificationLetterDownloadUrlPayload>;
  /**  Generate download url for invoice. */
  generateDownloadUrlForInvoiceV1: GenerateDownloadUrlForInvoiceV1Result;
  generateDrawdownAuthorizationPdfUrl?: Maybe<GenerateDrawdownAuthorizationPdfUrlPayload>;
  /** Synchronously generates FTUX suggestions for the given Integration. Returns just the integration ID. */
  generateIntegrationFtuxSuggestions: GenerateIntegrationFtuxSuggestionsResult;
  /** Generates a URL to download a ZIP file containing all the statements for a given deposits account. */
  generateMultiAccountBulkStatementsZipDownloadUrl?: Maybe<GenerateBulkStatementsZipDownloadUrlResult>;
  /** Use to initiate personal Plaid Link */
  generatePersonalPlaidLinkToken?: Maybe<GeneratePersonalPlaidLinkTokenPayload>;
  /** Use to initiate Plaid Link */
  generatePlaidLinkToken?: Maybe<GeneratePlaidLinkTokenPayload>;
  /** Fetch Oauth token from Spotnana by doing backend token exchange. */
  generateSpotnanaOauthToken: GenerateSpotnanaOauthTokenResult;
  /**
   * Get Payload for Spotnana IFrame and prepare the API for incoming expenses for a trip.
   * Requires either tripID or SpotnanaID but not both.
   */
  generateSpotnanaPayload: SpotnanaPayload;
  /** Generate download url for statement */
  generateStatementDownloadUrl: GenerateStatementDownloadUrlResponse;
  generateTransactionConfirmationDownloadUrl?: Maybe<GenerateTransactionConfirmationDownloadUrlPayload>;
  /** Generate a download URL for a report with specified filters and format */
  generateTransactionsReport: GenerateTransactionsReportResponse;
  /** Initiates an async generation of a transactions report and returns a request ID */
  generateTransactionsReportAsync: GenerateTransactionsReportAsyncResponse;
  /** Gets or creates a subsidiary mapped to the inputted legal entity */
  getOrCreateLegalEntitySubsidiary?: Maybe<GetOrCreateLegalEntitySubsidiaryPayload>;
  /** Grant FSP user(s) access to the client */
  grantFSPUsersClientAccess: GrantFSPUsersClientAccessResult;
  heartbeat?: Maybe<HeartbeatPayload>;
  /** Ignore sync errors for the given bills. This will remove the sync error from the user's dashboard. */
  ignoreSyncErrors?: Maybe<IgnoreSyncErrorsResult>;
  /** Import employees from an HRIS connection. */
  importEmployees: ImportEmployeeResult;
  initializeSAMLIdpConfig?: Maybe<CreateIdpConfigResult>;
  /**
   * Initialize a vendor file match migration via sunlight API by finding or creating required card, user, and session ids
   * that are required to initialize the client SDK.
   */
  initializeVendorFileMatchSunlightMigration: InitializeVendorFileMatchSunlightMigrationResult;
  /** Invites vendor to self-service onboard */
  inviteVendor: InviteVendorResult;
  /**  Invoicing customer submits PUP data for invoicing monthly transaction volume */
  invoiceAccountSubmitPup?: Maybe<InvoicingV1ClientError>;
  /**  Connect to External bank accounts for an invoice */
  invoiceConnectExternalBankAccount: InvoiceConnectExternalBankAccountResult;
  /**  Submit Payment for invoice via external bank account ACH Debit */
  invoiceSubmitEbaPayment: InvoiceSubmitEbaPaymentResult;
  /** create an invoicing customer with the provided details. */
  invoicingCustomerCreate?: Maybe<InvoicingCustomerResult>;
  /** Updating the metadata of the customer, i.e. email, address. */
  invoicingCustomerSetMetadata?: Maybe<InvoicingCustomerResult>;
  itemCreate?: Maybe<ItemResult>;
  itemSetType?: Maybe<ItemResult>;
  /** Itemize expense */
  itemizeExpense: ItemizeExpenseResult;
  /**
   * Updates an User in the Knowledge Base service with the given
   * Persona Inquiry ID then starts KYC analysis for the upserted User
   */
  kycUpdateUser?: Maybe<KycUpdateUserPayload>;
  /** Approve a limit increase request. */
  limitSourceIncreaseRequestApprove: LimitSourceIncreaseRequestMutationResult;
  /** Cancel a limit increase request */
  limitSourceIncreaseRequestCancel: LimitSourceIncreaseRequestMutationResult;
  /** Create a new limit increase request */
  limitSourceIncreaseRequestCreate?: Maybe<LimitSourceIncreaseRequestMutationResult>;
  /** Reject a limit increase request */
  limitSourceIncreaseRequestReject: LimitSourceIncreaseRequestMutationResult;
  /** Update the end date of limit increase request */
  limitSourceIncreaseRequestSetEndDate?: Maybe<LimitSourceIncreaseRequestMutationResult>;
  /** Update the reason of limit increase request */
  limitSourceIncreaseRequestSetReason?: Maybe<LimitSourceIncreaseRequestMutationResult>;
  /** Update the increase amount of limit increase request */
  limitSourceIncreaseRequestUpdateIncreaseAmount?: Maybe<LimitSourceIncreaseRequestMutationResult>;
  /** Lock an existing purchasing card */
  lockPurchasingCard: LockPurchasingCardResult;
  /** Make the given field a required field for accounting export */
  makeFieldRequiredForExport: MakeFieldRequiredForExportResult;
  /** Mark all of a user's alerts as read */
  markAllAlertsAsRead: MarkAllAlertsAsReadResult;
  markBillPaid?: Maybe<MarkBillPaidPayload>;
  /** Mark a draft bill as paid externally. */
  markBillPaidV2: BillResult;
  markInvoice?: Maybe<MarkInvoicePayload>;
  /**  Mark invoice to new status. */
  markInvoiceV1: InvoiceV1Result;
  markOfferSeen?: Maybe<MarkOfferSeenPayload>;
  /** Mark seen all unseen Expense Activities for user. */
  markSeenExpenseActivities: MarkSeenExpenseActivitiesResult;
  /** Move a budget under a different parent budget */
  moveBudget: MoveBudgetResult;
  /** Move a limit group */
  moveLimitGroup: MoveLimitGroupResult;
  /** Moves a spend budget */
  moveSpendBudget: MoveSpendBudgetResult;
  /** Moves a spend limit */
  moveSpendLimit: MoveSpendLimitResult;
  /** Can be used to update a parent expense, its line items, or both in an atomic manner. */
  mutateItemizedPrimitive: MutateItemizedPrimitiveResult;
  /** Notifies an user that they've been selected to setup accounting */
  notifySelectedAccountingSetupUser: NotifySelectedAccountingSetupUserResult;
  notifyUserOfCardRequest?: Maybe<NotifyUserOfCardRequestPayload>;
  /** Links objects by creating mappings between them */
  objectMappingBatchLink?: Maybe<ObjectMappingBatchLinkResult>;
  /** Updates multiple object mappings in bulk */
  objectMappingsBatchUnlink?: Maybe<ObjectMappingBatchUnlinkResult>;
  /** Invite employees onto Brex as users. */
  onboardEmployees?: Maybe<OnboardEmployeesResult>;
  onboardingApplicationCancel?: Maybe<OnboardingApplicationCancelPayload>;
  onboardingInformationRequest?: Maybe<OnboardingInformationRequest>;
  /** Override expense review by updating the request directly instead of the requestAction */
  overrideExpenseReview: OverrideExpenseReviewResult;
  processInvoice?: Maybe<ProcessInvoicePayload>;
  processInvoiceAndCreateBill?: Maybe<ProcessInvoiceAndCreateBillPayload>;
  /** Process a request */
  processRequest: ProcessRequestResult;
  /**
   * Process a free text message sent to the assistant by a user.
   * This mutation MAY update primitives on a users account (expense, budget, ect)
   * This mutation WILL ONLY return new messages to the client
   */
  processUserMessageViaAssistant: ProcessUserMessageViaAssistantResult;
  /** Disables a toggle for the current account. Response schema updated for Relay cache patterns. */
  productConfigToggleDisable?: Maybe<ToggleMutationResponseV2>;
  /** Enables a toggle for the current account. Response schema updated for Relay cache patterns. */
  productConfigToggleEnable?: Maybe<ToggleMutationResponseV2>;
  /** Provision card to Apple Pay */
  provisionApplePay?: Maybe<ProvisionApplePayPayload>;
  /** Provision card to Google Pay */
  provisionGooglePay?: Maybe<ProvisionGooglePayPayload>;
  pullDataAsync?: Maybe<PullDataAsyncPayload>;
  /** Sends the purchase order PDF to the vendor via email. */
  purchaseOrdersSendToVendor: PurchaseOrdersSendToVendorResult;
  /** Issue a purchasing card */
  purchasingCardIssue?: Maybe<PurchasingCardIssueResult>;
  pushMarketoLeads?: Maybe<PushMarketoLeadsPayload>;
  reconnectErpFeed?: Maybe<ReconnectErpFeedPayload>;
  /** Redeems for balance */
  redeemCashBalance?: Maybe<RedeemCashBalanceResult>;
  /** Redeems for a donation */
  redeemDonationV2?: Maybe<RedeemDonationResult>;
  redeemForBalance?: Maybe<RedeemForBalancePayload>;
  /** Redeems for a gift card */
  redeemGiftCard?: Maybe<RedeemGiftCardResult>;
  /** Redeems for statement credit */
  redeemStatementCreditV2?: Maybe<RedeemStatementCreditResult>;
  /** Redeems for VAS Coaching */
  redeemValueAddedServiceCoachingV2?: Maybe<RewardsRedeemValueAddedServiceResult>;
  /** Redeems for VAS DOOH */
  redeemValueAddedServiceDoohV2?: Maybe<RewardsRedeemValueAddedServiceResult>;
  /** Redeems for VAS DOOH V3 */
  redeemValueAddedServiceDoohV3?: Maybe<RewardsRedeemValueAddedServiceResult>;
  /** Redeems for VAS Mental Health */
  redeemValueAddedServiceMentalHealthV2?: Maybe<RewardsRedeemValueAddedServiceResult>;
  /** Redeems for VAS Offsite */
  redeemValueAddedServiceOffsiteV2?: Maybe<RewardsRedeemValueAddedServiceResult>;
  referUser?: Maybe<ReferUserPayload>;
  /** Update fx rates with newest rates for account policy currencies */
  refreshAccountPolicyCurrenciesFxRates: RefreshAccountPolicyCurrenciesFxRatesResult;
  /** Refresh an accounting integration. */
  refreshAccountingIntegration: RefreshAccountingIntegrationResult;
  /** For all credentials that match the filters, tests connectivity with vendor and updates the credentials status. */
  refreshCredential: RefreshCredentialResult;
  /** Refresh a single entity from an integration. */
  refreshEntityFromAccountingIntegration: RefreshEntityFromAccountingIntegrationResult;
  /** @deprecated Do not use, this mutation isn't supported anymored and does nothing */
  refreshFinancialSource?: Maybe<RefreshFinancialSourcePayload>;
  refreshIntegration?: Maybe<RefreshIntegrationPayload>;
  /** For all integrations that match the filters, tests connectivity with integration vendor and updates credential status. */
  refreshIntegrationCredentials?: Maybe<RefreshIntegrationCredentialsPayload>;
  refreshPersonalSource?: Maybe<RefreshPersonalSourcePayload>;
  /**
   * Fetches the most recent trip data from Spotnana.
   * @deprecated Use refreshTripInformationWithPnr instead
   */
  refreshTripInformation: RefreshTripInformationResult;
  /** Fetches the most recent trip data from Spotnana, ensuring a PNR is present. */
  refreshTripInformationWithPnr: RefreshTripInformationResult;
  refreshVerificationStatus?: Maybe<RefreshVerificationStatusPayload>;
  /** Register group */
  registerGroup: RegisterGroupResult;
  /**
   * Rejects an APPROVED reimbursement expense.
   *
   * After rejection, the expense status will change to OUT_OF_POLICY.
   * Only REIMBURSEMENT type expenses in APPROVED status can be rejected.
   */
  reimbursementDeny?: Maybe<ReimbursementDenyResult>;
  /**
   * Reject a budget limit increase request
   * @deprecated Use rejectLimitIncreaseRequest instead
   */
  rejectBudgetLimitIncreaseRequest: Scalars["ID"];
  /**
   * Reject a budget limit increase request
   * @deprecated Use rejectLimitIncreaseRequest instead
   */
  rejectBudgetLimitIncreaseRequestV2: RejectBudgetLimitIncreaseRequestV2Result;
  /** Remove attendees from a group event. */
  removeAttendees: RemoveAttendeesResult;
  /** Removes the current user ID from the bill's list of user IDs to auto-approve */
  removeAutoApproveUserId: BillResult;
  /**
   * Remove an existing authorization grant that allowed a user to view a comment thread and its entity. The user will
   * no longer be able to view the entity unless they have permission through another stream.
   * @deprecated This mutation is deprecated and unimplemented. Use bulkRemoveCommentEntityAuthorizations instead
   */
  removeCommentEntityAuthorization: RemoveCommentEntityAuthorizationResult;
  /** Remove a department */
  removeDepartment?: Maybe<RemoveDepartmentResult>;
  /** Remove an existing requirement on this field for accounting export */
  removeFieldRequiredForExport: RemoveFieldRequiredForExportResult;
  removeFinancialSource?: Maybe<RemoveFinancialSourcePayload>;
  /** Removes the policy granting access for a FSP account to a tenant account */
  removeFspBookkeeper?: Maybe<RemoveFspBookkeeperPayload>;
  /** Remove a user from the bookkeeper group, revoking access to the tenants available to the group */
  removeFspBookkeeperUser?: Maybe<RemoveFspBookkeeperUserPayload>;
  /** Remove a budget for a group event. */
  removeGroupEventBudget: RemoveGroupEventBudgetResult;
  /** Removes the escalation for the entire customer account and marks it as ignored by the calling user */
  removeLimitEscalation?: Maybe<RemoveLimitEscalationResult>;
  /** Remove a location */
  removeLocation?: Maybe<RemoveLocationResult>;
  removePersonalSource?: Maybe<RemovePersonalSourcePayload>;
  /** Reopens a spend limit */
  reopenSpendLimit: ReopenSpendLimitResult;
  /** Replaces a card */
  replaceCard?: Maybe<ReplaceCardPayload>;
  /** Replace a card with a physical card */
  replaceCardWithPhysical?: Maybe<ReplaceCardWithPhysicalPayload>;
  /** Replace a card with a virtual card */
  replaceCardWithVirtual?: Maybe<ReplaceCardWithVirtualPayload>;
  /** disable provided funding source and create a new one with new payload */
  replaceFundingSource?: Maybe<ReplaceFundingSourcePayload>;
  /**
   * Report export results (success or failure) for export entries.
   * This mutation is used by external systems (via Brex external API) to report the outcome of export job back to Brex.
   */
  reportExportResults?: Maybe<ReportExportResultsResult>;
  /** Create a template - V2 */
  reportTemplateCreate?: Maybe<ReportTemplateCreateResult>;
  /** Delete a template */
  reportTemplateDelete?: Maybe<ReportTemplateDeleteResult>;
  /** Duplicate a template */
  reportTemplateDuplicate?: Maybe<ReportTemplateDuplicateResult>;
  /** Update template */
  reportTemplateUpdate?: Maybe<ReportTemplateUpdateResult>;
  /**
   * Endpoint to reevaluate if manual action is still required to offboard a deactivated user. Also triggers
   * finalizing actions such as reprocessing outstanding requests being reviewed by the user to the updated approval chain
   */
  reprocessBudgetOffboardingActions: OffboardingActionPayload;
  requestFSPConnection: RequestFSPConnectionResult;
  /** Request a new budget for a group event. */
  requestGroupEventBudget: RequestGroupEventBudgetResult;
  /** Rescind existing drawdown authorization */
  rescindDrawdownAuthorization?: Maybe<RescindDrawdownAuthorizationPayload>;
  /** Re-send Uber 4 Business invite to employee */
  resendEmployeeUberBusinessInvite: ResendEmployeeUberBusinessInviteResponse;
  /** Resends a gift card order */
  resendGiftCard?: Maybe<ResendGiftCardResult>;
  /** Resends the user welcome/activation email */
  resendWelcomeEmail?: Maybe<ResendWelcomeEmailPayload>;
  resetBackupCodes?: Maybe<ResetBackupCodesPayload>;
  resetUser?: Maybe<ResetUserPayload>;
  /** Mark the request associated with a comment as resolved. The associated Request and Task will be resolved. */
  resolveCommentRequest: ResolveCommentRequestResult;
  /** Resolves the escalation for the entire customer account with a newly connected financial source */
  resolveLimitEscalationWithFinancialSource?: Maybe<ResolveLimitEscalationWithFinancialSourceResult>;
  /** Resolve a spend migration import. Can be resolved if import has a status of FAILED or COMPLETED. */
  resolveSpendMigrationImport: SpendMigrationImport;
  resyncBills?: Maybe<ResyncBillsPayload>;
  resyncReimbursementItems?: Maybe<ResyncReimbursementItemsPayload>;
  /** Retry clawback payment */
  retryClawbackPayment: RetryClawbackPaymentResult;
  /** Retry a penny pull for a funding source */
  retryPennyPull?: Maybe<CollectionPromise>;
  /** Retry reimbursement payment */
  retryReimbursementPayment: RetryReimbursementPaymentResult;
  /**
   * Retries a failed or expired verification process for rail account details.
   * This is used when previous verification attempts failed or timed out.
   *
   * Creates a new verification instance with the same type and updated metadata.
   * Common for micro-deposits, POAO (Proof of Account Ownership), and mandate verifications.
   */
  retryVerification: RetryVerificationResult;
  revertCancelledBill?: Maybe<RevertCancelledBillPayload>;
  /** Revert a cancelled bill back to draft */
  revertCancelledBillV2: BillResult;
  /** Reverts exported export entries */
  revertExportEntries: RevertExportEntriesResult;
  /** Revert a bill marked as paid externally back to draft */
  revertMarkedPaidBill: BillResult;
  revertPaidBill?: Maybe<RevertPaidBillPayload>;
  /** Updates the given policy review status. */
  reviewPolicy: BankingPolicy;
  revokeActiveOauthApplication?: Maybe<RevokeActiveOauthApplicationResult>;
  /** Revokes a developer API token */
  revokeDeveloperApiToken?: Maybe<RevokeDeveloperApiTokenPayload>;
  revokeFSPUsersClientAccess: RevokeFSPUsersClientAccessResult;
  revokeFSPUsersRoles: RevokeFSPUsersRolesResult;
  revokeLLMOAuthIntegration: RevokeLLMOAuthIntegrationResult;
  /** Revokes a previous resolution or rejection, marking the action as pending */
  revokeRequestActionStatus: RevokeRequestActionStatusResult;
  revokeSession?: Maybe<RevokeSessionResult>;
  /**
   * Submits a RFI for review.
   * This endpoint should validate if a RFI is ready for review (if it has a valid response).
   * And then switch the state of the RFI so that Ops can action it
   */
  rfiSubmitForReview: RfiSubmitForReviewResponse;
  saveOnboardingInformationRequest?: Maybe<SaveOnboardingInformationRequestPayload>;
  /**
   * Saves the response for a set of RFI Items
   * This endpoint should be used send the response to the RFI in parts,
   * allowing us to break the request to the customer in multiple steps and
   * save each one accordingly
   */
  saveResponseToRfiItem: SaveResponseToRfiItemResponse;
  /** Save the specified recent search to user history */
  saveToRecentSearch?: Maybe<RecentSearchError>;
  /**
   * Save arbitrary in-progress client payload on a request.
   * Operation is fail open; client may overwrite latest payload in subsequent save request.
   */
  saveVerificationRequest: SaveVerificationRequestResult;
  /**
   * Create a new Saved View.
   * Saved view labels must be unique for a given user and table.
   * If a saved view with the same label already exists, will return an ALREADY_EXISTS error.
   */
  savedViewCreate: savedViewCreateResult;
  /** Delete a Saved View. Will return a NOT_FOUND error if the ID is not found. */
  savedViewDelete: SavedViewDeleteResult;
  /**
   * Update a Saved View's label. Will return a NOT_FOUND error if the ID is not found.
   * Saved view labels must be unique for a given user and table.
   * If a saved view with the same label already exists, will return an ALREADY_EXISTS error.
   */
  savedViewRename: SavedViewUpdateResult;
  /** Update a Saved View's data grid URL params. Will return a NOT_FOUND error if the ID is not found. */
  savedViewUpdateDataGridSettings: SavedViewUpdateResult;
  /** Schedule a new collection promise for payment processing */
  scheduleCollectionPromise?: Maybe<ScheduleCollectionPromisePayload>;
  schedulePayment?: Maybe<SchedulePaymentPayload>;
  /** Self-initiate a financial document request for bank statements (used for onboarding new accounts) */
  selfInitiateBankStatementRequest?: Maybe<FinancialStatementRequest>;
  /** Generates a OTP code for SCA and sends it as an SMS to the admin's phone number and email */
  sendBeneficiaryOtpCode: SendBeneficiaryOtpCodeResult;
  sendBillPayment?: Maybe<SendBillPaymentPayload>;
  /** Initiate a bill payment. */
  sendBillPaymentV2: BillResult;
  /** Remind attendees who are attending to book if they haven't */
  sendBookingReminders: SendBookingRemindersResult;
  /** Send one-time-card details to vendor */
  sendCardToVendor: SendCardToVendorResult;
  /** Invite uninvited attendees to group event */
  sendInvites: SendInvitesResult;
  sendInvoice?: Maybe<SendInvoicePayload>;
  /**  Send invoice reminder. */
  sendInvoiceReminderV1: SendInvoiceReminderV1Result;
  /**
   * A request to send an invoice. Only the emails provided in the cc recipients will be added to the cc list
   * of the invoice email. If no cc recipients are provided, the invoice will only be sent to the payer contact email.
   */
  sendInvoiceV1: InvoiceV1Result;
  /**
   * Sends message to Support and Creates SFDC Case with Email Receipt
   * Brex Object ID must be encoded
   */
  sendMessageToRepresentative?: Maybe<SendMessageToRepresentativePayload>;
  sendMfaResetToken?: Maybe<SendMfaResetTokenResult>;
  sendMobileChequeDepositNotification?: Maybe<SendMobileChequeDepositNotificationPayload>;
  /** Remind invited attendees to RSVP */
  sendRsvpReminders: SendRsvpRemindersResult;
  /** Send an email to an invited user to activate their account. */
  sendUserInviteEmails: SendUserInviteEmailsResult;
  /** Set the preferred locale for an account. */
  setAccountLocale: Account;
  setAccountRestrictAchDebits?: Maybe<SetAccountRestrictAchDebitsPayload>;
  /**
   * User Rules
   * Simple on/off rule
   */
  setAccountRule?: Maybe<SetSsoUserRulesResult>;
  /** Set the account time zone */
  setAccountTimezoneV2: SetAccountSettingsResult;
  /**
   * Batch sets the review status of the Accounting Journal entries.
   * Sets all the statuses to the same status.
   */
  setAccountingJournalEntriesReviewStatus?: Maybe<SetAccountingJournalEntriesReviewStatusResult>;
  /** Sets the review status of the Accounting Journal entry */
  setAccountingJournalEntryReviewStatus?: Maybe<SetAccountingJournalEntryReviewStatusResult>;
  setApprovalsUnsafeFlag?: Maybe<SetApprovalsUnsafeFlagPayload>;
  setAutomationWorkflowSpecStatuses?: Maybe<SetAutomationWorkflowSpecStatusesResult>;
  /** Set card limit source on the employee card. */
  setCardLimitSource: SetCardLimitSourceMutationResult;
  /**
   * Sets corporate card access for a user. The user must have user role EMPLOYEE or EMPLOYEE_WITHOUT_CORP_CARD. This
   * endpoint will not work for other roles. When revoking corporate card access, this mutation will terminate a user's
   * existing cards.
   */
  setCorporateCardAccess?: Maybe<SetCorporateCardAccessResult>;
  /**
   * Sets a policy as the default for the account. The default policy is used to pre-populate the
   * form when a user is creating another policy. Updating the default policy *DOES NOT* change any
   * other existing policy.
   */
  setDefaultPolicy: Policy;
  setDepositsTransactionPaymentMemo?: Maybe<SetDepositsTransactionPaymentMemoPayload>;
  /** Set autopay funding source for an entity/product type pair */
  setEntityAutopayFundingSource?: Maybe<FundingSource>;
  setFinancialAccountNickname?: Maybe<SetFinancialAccountNicknameResult>;
  setFundingSourceAsPrimaryForEntity?: Maybe<SetFundingSourceAsPrimaryForEntityPayload>;
  setFundsAllocation?: Maybe<DDAMigrationState>;
  setInitialAutopayFundingSource?: Maybe<SetInitialAutopayFundingSourcePayload>;
  /** Set inactive status for an external integration field. */
  setIntegrationFieldInactive?: Maybe<SetIntegrationFieldInactivePayload>;
  /** Set the preferred locale for a legal entity. */
  setLegalEntityLocale: LegalEntity;
  setManager?: Maybe<SetManagerPayload>;
  /** Set a single countries mileage rate */
  setMileageSetting: MileageSetting;
  /** Set the account mileage rates */
  setMileageSettings: SetMileageSettingsResult;
  setPrimaryFundingSource?: Maybe<SetPrimaryFundingSourcePayload>;
  /** Set self-serve email update access at the account level. */
  setSelfServeEmailUpdateAccess: SetSelfServeEmailUpdateAccessResult;
  /** Set whether a user wishes to use their device time zone */
  setUseDeviceTimezone?: Maybe<Scalars["Boolean"]>;
  /**  If this is empty, we'll create a default deny rule. */
  setUserListRule?: Maybe<SetSsoUserRulesResult>;
  /** Set the preferred locale for a user. */
  setUserLocale: User;
  /** Set a user's primary card */
  setUserPrimaryCard?: Maybe<SetUserPrimaryCardPayload>;
  /**
   * Set the user time zone
   * @deprecated Use setUserTimezoneV2 instead
   */
  setUserTimezone?: Maybe<Scalars["Boolean"]>;
  /** Set the user time zone */
  setUserTimezoneV2: SetUserSettingsResult;
  setupMfa?: Maybe<SetupMfaPayload>;
  setupMfaV2?: Maybe<SetupMfaPayload>;
  /** Signup initial user */
  signupInitialUser: SignupInitialUserResult;
  simulateRequest: SimulateRequestResults;
  skipVendorFileMatchAutoMigration: SkipVendorFileMatchAutoMigrationResult;
  /** Modify spend limit membership by adding or removing specific owners and members */
  spendLimitModifyMembership?: Maybe<SpendLimitModifyMembershipResult>;
  /** Start an accounting integration export. */
  startAccountingIntegrationExport: StartAccountingIntegrationExportResult;
  startDepositsOffboarding?: Maybe<StartDepositsOffboardingPayload>;
  /** Starts an asynchronous integration export */
  startIntegrationExport?: Maybe<StartIntegrationExportPayload>;
  startResetUser?: Maybe<StartResetUserPayload>;
  startResetUserV2?: Maybe<StartResetUserPayload>;
  /** Persist an uploaded vendor file and kick off the vendor file match process */
  startSpendMigrationImport: StartSpendMigrationImportResult;
  /** Create a pending email change for a given user. Requires the user performing the action to have completed step-up MFA. */
  startUpdateUserEmail: StartUpdateUserEmailResult;
  /** Start analysis. */
  startVerificationAnalysis?: Maybe<VerificationAnalysis>;
  /** Submits consent for data sharing with Airwallex for cards */
  submitAirwallexCardsConsent?: Maybe<SubmitAirwallexCardsConsentPayload>;
  submitApplicationInfo?: Maybe<WorkflowResult>;
  /** Submit a bill for approval (and eventually payment initiation) */
  submitBill: BillResult;
  submitDocuments?: Maybe<SubmitDocumentsResult>;
  /**
   * Submit an expense
   * The operation isn't guaranteed to be atomic, and should be retried until it succeeds.
   */
  submitExpense?: Maybe<SubmitExpenseResult>;
  /** Submit all financial documents uploaded by customer */
  submitFinancialStatements?: Maybe<SubmitFinancialStatementsResult>;
  /** Submits a new limit increase request */
  submitLimitIncreaseRequest?: Maybe<LimitIncreaseRequest>;
  submitNotApplicableOnboardingInformationRequest?: Maybe<SubmitNotApplicableOnboardingInformationRequestPayload>;
  submitOnboardingApplication?: Maybe<SubmitOnboardingApplicationPayload>;
  submitOnboardingInformationRequest?: Maybe<SubmitOnboardingInformationRequestPayload>;
  /** Update the reason & comment for disabling receipt auto generation */
  submitReceiptAutogenDisabledRationale: ReceiptAutogenDisabledRationale;
  /**
   * Submits UserReviewTasks.
   * Only the user that owns the review task is allowed to submit it.
   */
  submitUserReviewTasks?: Maybe<SubmitUserReviewTasksResult>;
  /** Submit payload on a request. */
  submitVerificationRequest: SubmitVerificationRequestResult;
  subscribeToGroup?: Maybe<SubscribeToGroupPayload>;
  /** Create default field values for extended fields for a given subsidiary */
  subsidiarySettingsCreateDefaultIntegrationFieldMapping: UpdateAccountingIntegrationSubsidiarySettingsResult;
  /** Delete default field values for extended fields for a given subsidiary */
  subsidiarySettingsDeleteDefaultIntegrationFieldMapping: UpdateAccountingIntegrationSubsidiarySettingsResult;
  /** Delete entity mappings on the integration settings. */
  subsidiarySettingsDeleteEntityMapping: UpdateAccountingIntegrationSubsidiarySettingsResult;
  /** Update default field values for extended fields for a given subsidiary */
  subsidiarySettingsUpdateDefaultIntegrationFieldMapping: UpdateAccountingIntegrationSubsidiarySettingsResult;
  /** Update entity mappings on the integration settings. */
  subsidiarySettingsUpdateEntityMapping: UpdateAccountingIntegrationSubsidiarySettingsResult;
  /** Suspend a card */
  suspendCardV2?: Maybe<SuspendCardV2Payload>;
  /** Suspend users */
  suspendUsers?: Maybe<SuspendUsersResult>;
  /** Sync an HRIS connection. This kicks off an async process so simply returns the id if there are no errors. */
  syncHrConnection?: Maybe<Scalars["String"]>;
  syncIntegration?: Maybe<SyncIntegrationPayload>;
  /**
   * Trigger a sync for a list of objects, and return the IDs of the objects synced.
   * The response does not contain the full object, because this request will run asynchronously.
   */
  syncObjects?: Maybe<SyncObjectsResult>;
  /** Terminate Budget */
  terminateBudget: Scalars["ID"];
  /** Terminate a card */
  terminateCard?: Maybe<TerminateCardPayload>;
  testAsyncJob: Task;
  toggleRule?: Maybe<ToggleRulePayload>;
  toggleRuleForStatementEntry?: Maybe<ToggleRuleForStatementEntryPayload>;
  /**
   * Toggle self-serve email update access at the account level.
   * @deprecated Use setSelfServeEmailUpdateAccess instead.
   */
  toggleSelfServeEmailUpdateAccess: ToggleSelfServeEmailUpdateAccessResult;
  toggleSocialLogins?: Maybe<ToggleSocialLoginsResult>;
  /**
   * Transfer a card to a new owner
   * @deprecated Use cardTransfer instead.
   */
  transferCard?: Maybe<TransferCardPayload>;
  /** Transfer an existing purchasing card to a different user */
  transferPurchasingCard: TransferPurchasingCardResult;
  /** Batch sets the review status of the Accounting Journal entries and accrual status of Accounting Records. */
  transitionAccountingJournalEntries?: Maybe<TransitionAccountingJournalEntriesResult>;
  triggerErpFeedSync?: Maybe<TriggerErpFeedSyncPayload>;
  /** Trigger OCR processing for an assetId */
  triggerInvoiceProcessing: InvoiceProcessingResponse;
  /** Triggers a limit utilization survey for a customer */
  triggerLimitUtilizationSurvey?: Maybe<TriggerLimitUtilizationSurveyResponse>;
  /** Toggles flag boolean value off */
  turnOffSeenFlag?: Maybe<TurnOffSeenFlagPayload>;
  /** Toggles flag boolean value on */
  turnOnSeenFlag?: Maybe<TurnOnSeenFlagPayload>;
  /** Unarchive a limit group */
  unarchiveLimitGroup: UnarchiveLimitGroupResult;
  /** Unarchives a spend budget */
  unarchiveSpendBudget: UnarchiveSpendBudgetResult;
  /**
   * Unarchives a spend limit
   * @deprecated Use reopenSpendLimit
   */
  unarchiveSpendLimit: UnarchiveSpendLimitResult;
  /** Unassign a budget from a card */
  unassignBudgetFromCard: UnassignBudgetFromCardResult;
  /** Unexpire an expired budget with a new end date */
  unexpireBudget: UnexpireBudgetResult;
  /** Unlock an existing purchasing card */
  unlockPurchasingCard: UnlockPurchasingCardResult;
  /** Unregister group */
  unregisterGroup: UnregisterGroupResult;
  unsubscribeFromGroup?: Maybe<UnsubscribeFromGroupPayload>;
  /** Unsuspend a card */
  unsuspendCard?: Maybe<UnsuspendCardPayload>;
  /** Unterminate a terminated budget with a new end date */
  unterminateBudget: UnterminateBudgetResult;
  updateAccountAddress?: Maybe<UpdateAccountAddressPayload>;
  /** Update an accounting integration. */
  updateAccountingIntegration: UpdateAccountingIntegrationResult;
  /** Update accounting integration subsidiary setting */
  updateAccountingIntegrationSubsidiarySettings: UpdateAccountingIntegrationSubsidiarySettingsResult;
  /** Update User Admin Home Setting. */
  updateAdminHomeSetting: UpdateAdminHomeSettingResult;
  /** Update an alert's read status */
  updateAlertReadStatus: UpdateAlertReadStatusResult;
  updateAssignedRoleForFSPUser: UpdateAssignedRoleForFSPUserResult;
  /**
   * Update attribute mappings
   * @deprecated Prefer ExternalLegalEntityMappingBatchUpdate
   */
  updateAttributeMappings: UpdateAttributeMappingsResult;
  /** Update audit group's status */
  updateAuditGroupStatus?: Maybe<UpdateAuditGroupStatusResult>;
  /** Update auto invite setting */
  updateAutoInviteSetting: CreateOrUpdateAutoInviteSettingResult;
  updateAutomaticTransferSettings?: Maybe<UpdateAutomaticTransferSettingsPayload>;
  updateAutomationWorkflowSpecs?: Maybe<UpdateAutomationWorkflowSpecsResult>;
  updateBill?: Maybe<UpdateBillPayload>;
  /** Update an existing bill. */
  updateBillV2: BillResult;
  /**
   * Update Budget
   * @deprecated Deprecated by template, use updateBudgetFromTemplate
   */
  updateBudget: UpdateBudgetResult;
  /**
   * Update a budget limit increase request
   * @deprecated Use updateLimitIncreaseRequest instead
   */
  updateBudgetLimitIncreaseRequest: BudgetLimitIncreaseRequestEntity;
  /** Update a budget request */
  updateBudgetRequest: UpdateBudgetRequestResult;
  /** Update a budget request from a Budget Template Derived Budget Request */
  updateBudgetRequestFromTemplate: UpdateBudgetRequestResult;
  /** Update a budget template */
  updateBudgetTemplate: BudgetTemplate;
  /** Update the ordering of budget templates on an account */
  updateBudgetTemplatesOrder: UpdateBudgetTemplatesOrderResult;
  /** Update Budget User Notification Preference */
  updateBudgetUserNotificationPreference: UpdateBudgetUserNotificationPreferenceResult;
  /** Update a card's display name */
  updateCardDisplayName?: Maybe<UpdateCardDisplayNamePayload>;
  /** Update a card's pin */
  updateCardPin?: Maybe<UpdateCardPinPayload>;
  /** Update a card shipping order's dismiss time */
  updateCardShippingOrderDismiss?: Maybe<CardShippingDetails>;
  /** Update the spend limit assignment settings for a card */
  updateCardSpendLimitAssignmentSettings: UpdateCardSpendLimitAssignmentSettingsResult;
  updateCashTransaction?: Maybe<UpdateCashTransactionPayload>;
  updateChannelPreferences?: Maybe<UpdateChannelPreferencesPayload>;
  /** Update Company Assistant Setting, only accessible to admins. */
  updateCompanyAssistantSetting: UpdateCompanyAssistantSettingResult;
  /** Update Company Preference, only accessible to admins. */
  updateCompanyPreference: UpdateCompanyPreferenceResult;
  updateConnectionStatus: UpdateConnectionStatusResult;
  updateContact?: Maybe<UpdateContactPayload>;
  /** Sets the default accounting category for a given contact on a given integration. */
  updateContactDefaultErpCategory?: Maybe<UpdateContactDefaultErpCategoryPayload>;
  /** Update an existing Copilot */
  updateCopilot?: Maybe<Copilot>;
  /** Update a cost center */
  updateCostCenter?: Maybe<UpdateCostCenterResult>;
  /**
   * Update an existing role. The logged in user will only be able to edit roles unique (custom) to their account.
   * Updates to Brex's standard roles, e.g. Card Admin, are not supported.
   */
  updateCustomRole?: Maybe<UpdateCustomRoleResult>;
  updateDDAMigrationState?: Maybe<DDAMigrationState>;
  /**
   * Updates a default field for a given subsidiary and extended field
   *
   * Will throw an error if the new extended field option belongs to a different extended field
   * than the current extended field option for the given default field
   */
  updateDefaultIntegrationFieldMapping: UpdateDefaultIntegrationFieldMappingResult;
  updateDepositsAccount?: Maybe<UpdateDepositsAccountPayload>;
  /** Update a list of currencies that are enabled for account policies */
  updateEnabledAccountPolicyCurrencies: UpdateEnabledAccountPolicyCurrenciesResult;
  /** Updates engagement settings for the account of the user in context. */
  updateEngagementSetting: UpdateEngagementSettingResult;
  /**
   * Update an entity mapping on the integration settings.
   *
   * These are the legal entity to subsidiary mappings.
   */
  updateEntityMapping: UpdateEntityMappingResult;
  /**
   * Update an expense
   * The operation isn't guaranteed to be atomic, and should be retried until it succeeds.
   */
  updateExpense?: Maybe<UpdateExpenseResult>;
  /** Update an expense report */
  updateExpenseReport: UpdateExpenseReportResult;
  /** Update a request action and attempt to approve/deny an expense in a single mutation */
  updateExpenseReview: UpdateExpenseReviewResult;
  /** Update multiple expenses */
  updateExpenses: UpdateExpensesResult;
  /** Updates an export record */
  updateExportRecord?: Maybe<UpdateExportRecordResult>;
  /** Update Extended Field */
  updateExtendedField?: Maybe<UpdateExtendedFieldResult>;
  /** Update a VX Extended Field Visibility Rule */
  updateExtendedFieldVisibilityRule: UpdateExtendedFieldVisibilityRuleResult;
  /** Update multiple Extended Fields */
  updateExtendedFields: Array<Maybe<UpdateExtendedFieldResultOrError>>;
  /** Update group */
  updateGroup: UpdateGroupResult;
  /** Update a new group event. */
  updateGroupEvent: UpdateGroupEventResult;
  /**
   * Swap the trip for a user on a group event
   * If the user is not an attendee, they will be added as an attendee
   */
  updateGroupEventTrip: Scalars["Boolean"];
  /**
   * Update an existing HRIS Connection. Currently, the only supported action is to re-enable an HRIS connection if
   * its status is UNLINKED.
   */
  updateHrConnection?: Maybe<HrConnection>;
  /** Batch update insight settings */
  updateInsightSettings: UpdateInsightSettingsResult;
  updateInstitutionLogin?: Maybe<UpdateInstitutionLoginPayload>;
  updateIntegrationCredential?: Maybe<UpdateIntegrationCredentialPayload>;
  updateIntegrationRule?: Maybe<UpdateIntegrationRulePayload>;
  updateIntegrationSettings?: Maybe<UpdateIntegrationSettingsPayload>;
  updateIntegrationSyncSettings?: Maybe<UpdateIntegrationSyncSettingsPayload>;
  /** Update the RSVP response on an Invite */
  updateInviteResponse: UpdateInviteResponseResult;
  /** Update an ItineraryActivity. */
  updateItineraryActivity: UpdateItineraryActivityResult;
  /** Update KYC information for a user. */
  updateKYCIndividual: UpdateKYCIndividualResult;
  updateLead?: Maybe<UpdateLeadPayload>;
  /** Update a legal entity */
  updateLegalEntity?: Maybe<UpdateLegalEntityResult>;
  /** Update a limit group */
  updateLimitGroup: UpdateLimitGroupResult;
  /** Update a mapping and the corresponding workflow rule. */
  updateMapping: UpdateMappingResult;
  /** Update a mapping class */
  updateMappingClass: UpdateMappingClassResult;
  /** Update migrated users fields */
  updateMigratedUsers: Array<MigratedUser>;
  /** Updates the most recently used currency for the given payment instrument logical id. */
  updateMostRecentlyUsedCurrency: PaymentInstrumentAssociationId;
  updateOIDCClientConfig?: Maybe<UpdateIdpConfigResult>;
  updateOIDCIdpConfig?: Maybe<UpdateIdpConfigResult>;
  /** Update a budget request's parent budget and approve it */
  updateParentBudgetAndApproveBudgetRequest: UpdateParentBudgetAndApproveBudgetRequestResult;
  updatePartnershipIntegration: PartnershipIntegration;
  updatePaymentInstrument?: Maybe<UpdatePaymentInstrumentPayload>;
  /** Updates the funding source designated for reimbursement payouts */
  updatePaymentSource: UpdatePaymentSourcePayload;
  /** Use to initiate personal Plaid Link in update mode */
  updatePersonalPlaidLinkToken?: Maybe<UpdatePersonalPlaidLinkTokenPayload>;
  /** Use to initiate Plaid Link in update mode */
  updatePlaidLinkToken?: Maybe<UpdatePlaidLinkTokenPayload>;
  /** Updates a positive pay account setting with the given id, with the provided fields */
  updatePositivePayAccountSetting?: Maybe<UpdatePositivePayAccountSettingPayload>;
  /** Updates a positive pay account setting. */
  updatePositivePayAccountSettingV2?: Maybe<UpdatePositivePayAccountSettingPayload>;
  /** Update a purchase order */
  updatePurchaseOrder: UpdatePurchaseOrderResult;
  /** Update an existing purchasing card */
  updatePurchasingCard: UpdatePurchasingCardResult;
  /**
   * Updates existing rail account details with new information.
   * Supports partial updates to modify specific fields while preserving others.
   *
   * Can update display name, account properties, beneficiary information,
   * and other mutable fields. Some fields like rail type cannot be changed
   * after creation and require creating new rail account details.
   */
  updateRailAccountDetails: UpdateRailAccountDetailsResult;
  /** Update the receipt auto generation disabled setting for a customer account */
  updateReceiptAutogenSetting: ReceiptAutogenSetting;
  /** Update an existing integration for a customer account. */
  updateReceiptIntegration: UpdateReceiptIntegrationResponse;
  /** Update the receipt validation setting for a customer account */
  updateReceiptValidationSetting: ReceiptValidationSetting;
  /**
   * Update the template data for a template
   * @deprecated No longer supported
   */
  updateReportTemplateData?: Maybe<Scalars["Boolean"]>;
  /**
   * Update the template info for a template
   * @deprecated No longer supported
   */
  updateReportTemplateInfo?: Maybe<Scalars["Boolean"]>;
  /** Update an existing report */
  updateReportingDashboard: UpdateReportingDashboardResult;
  /**
   * Update a Request.
   * @deprecated Use updateRequestV2 instead, which gracefully handles errors
   */
  updateRequest: UpdateRequestResult;
  /**
   * Update a request action.
   * @deprecated Use updateRequestActionV2 instead, which gracefully handles errors
   */
  updateRequestAction: UpdateRequestActionResult;
  /** Update a request action. */
  updateRequestActionV2: UpdateRequestActionResultV2;
  /**
   * Update multiple request actions at once.
   * @deprecated Use updateRequestActionsV2 instead, which gracefully handles errors
   */
  updateRequestActions: UpdateRequestActionResults;
  /** Update multiple request actions at once. */
  updateRequestActionsV2: UpdateRequestActionResultsV2;
  /** Updates request deadline settings for the caller's account. */
  updateRequestDeadlineSettings: UpdateRequestDeadlineSettingsResult;
  /** Update a Request. */
  updateRequestV2: UpdateRequestResultV2;
  /**
   * Update multiple Requests at once.
   * @deprecated Use updateRequestsV2 instead, which gracefully handles errors
   */
  updateRequests: UpdateRequestResults;
  /** Update multiple Requests at once. */
  updateRequestsV2: UpdateRequestResultsV2;
  /** Update employees' roles */
  updateRoles?: Maybe<UpdateRolesResult>;
  updateSAMLIdpConfig?: Maybe<UpdateIdpConfigResult>;
  updateSelfAttestationAccountType?: Maybe<UpdateSelfAttestationAccountTypeResult>;
  /** Update an existing spend budget */
  updateSpendBudget: UpdateSpendBudgetResult;
  /** Update a spend limit */
  updateSpendLimit: UpdateSpendLimitResult;
  updateSsoEnabled?: Maybe<UpdateSsoEnabledResult>;
  /** Update a subsidiary */
  updateSubsidiary?: Maybe<UpdateSubsidiaryPayload>;
  /** Updates an existing task. */
  updateTask: Task;
  /**
   * Update the state of given Task(s). This will transitively update the status of the associated Request Actions.
   * Can only be executed on Tasks in non-terminal states.
   */
  updateTaskStates: UpdateTaskStatesResult;
  /**
   * Update individual tax code statuses for a specific subsidiary.
   *
   * Allows updating the enabled/disabled status of multiple tax codes in a single operation.
   * Assumes the currently active accounting integration.
   */
  updateTaxCodeSettings?: Maybe<UpdateTaxCodeSettingsResult>;
  /** Update a title */
  updateTitle?: Maybe<UpdateTitleResult>;
  /** Update travelSupportSessionId for a user. */
  updateTravelSupportSessionId: Scalars["Boolean"];
  /** Update a trip record in the Travel Service / Spotnana. */
  updateTrip: Scalars["Boolean"];
  updateUser?: Maybe<UpdateUserPayload>;
  /** Update User Assistant Setting. */
  updateUserAssistantSetting: UpdateUserAssistantSettingResult;
  updateUserCategories?: Maybe<UpdateUserCategoriesPayload>;
  updateUserCategory?: Maybe<UpdateUserCategoryPayload>;
  /** Update a user's email address. */
  updateUserEmail?: Maybe<UpdateUserEmailResult>;
  updateUserGlanceVisitorId: UpdateUserGlanceVisitorIdResult;
  /** Create a user management setting for an HRIS connection. */
  updateUserManagementSettings?: Maybe<UserManagementSettings>;
  /** Update permission for user in Medusa */
  updateUserPermission?: Maybe<UpdateUserPermissionPayload>;
  /**
   * Update VAT settings for a specific a subsidiary.
   *
   * Assumes the currently active accounting integration.
   */
  updateVatSettings?: Maybe<UpdateVatSettingsResult>;
  /** Update a vendor */
  updateVendor: UpdateVendorResult;
  /** Updates vendor contact and payment instrument details */
  updateVendorFromMagicLink: UpdateVendorFromMagicLinkResult;
  /** Updates the status of a Verification Notification, triggering downstream effects based on status */
  updateVerificationNotification?: Maybe<UpdateVerificationNotificationPayload>;
  /** Update a VX Workflow Rule */
  updateWorkflowRule: UpdateWorkflowRuleResult;
  /** Temporary mutation for supporting Super Admin role release. This mutation will be removed once the role is supported on all accounts. */
  upgradeToSuperAdmin: UpgradeToSuperAdminResult;
  /** Upload a template for bulk mappings upload */
  uploadBulkMappingsTemplate?: Maybe<UploadBulkMappingsTemplateResult>;
  /** Uploads mapping rules from a CSV uploaded to filestore */
  uploadCsvAndCreateMappings?: Maybe<UploadCsvAndCreateMappingsResult>;
  /** Upload a room block to a group event */
  uploadHotelRoomBlock: UploadHotelRoomBlockResult;
  upsertExpensePolicySpec: UpsertExpensePolicySpecResult;
  /** Upserts Expense Type Extended Fields */
  upsertExpenseTypeExtendedFields: UpsertExpenseTypeExtendedFieldsResult;
  upsertLimitUtilizationTrigger?: Maybe<UpsertLimitUtilizationTriggerPayload>;
  /** Upsert user limit */
  upsertUserLimit: UpsertUserLimitResult;
  /** Upserts value rules for dependency list from a CSV uploaded to filestore. */
  upsertValueRulesForDependencyCsv: UpsertValueRulesForDependencyCsvResult;
  validateChequeImages?: Maybe<ValidateChequeImagesPayload>;
  validateEmail?: Maybe<ValidateEmailPayload>;
  /**
   * Validates micro-deposit amounts provided by the user to complete account verification.
   * This is part of the micro-deposits verification flow where small amounts
   * are sent to the account and the user must verify the received amounts.
   *
   * Successful validation completes the verification process and enables
   * the rail account details for use.
   */
  validateMicroDepositsAmounts: ValidateMicroDepositsAmountsResult;
  validateSms?: Maybe<ValidateSmsPayload>;
  /** Validates and formats dependency CSV uploaded in FileStore for upsert to VX visibility rules. */
  validateValueRulesForDependencyCsv: ValidateValueRulesForDependencyCsvResult;
  /**
   * Validates and completes various types of account verifications.
   * This is a generic verification validation endpoint that handles different
   * verification types including micro-deposits, eGIRO, and others.
   *
   * The specific validation logic depends on the verification type specified.
   */
  validateVerification: ValidateVerificationResult;
  /** Add vendor documents and optionally perform OCR */
  vendorAddDocuments: VendorAddDocumentsResult;
  /**
   * Mark a vendor file match as blocked from using Sunlight, typically based on authentication failures. Updates the
   * sunlightMigrationStatus.
   */
  vendorFileMatchSunlightBlocked: VendorFileMatchSunlightBlockedResult;
  /** Remove vendor documents */
  vendorRemoveDocuments: VendorRemoveDocumentsResult;
  /** Starts KYC analysis for the given subject */
  verificationStartAnalysis?: Maybe<VerificationStartAnalysisPayload>;
  withdrawFunds?: Maybe<WithdrawFundsPayload>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationacceptCompanyPolicyAgreementArgs {
  input: AcceptCompanyPolicyAgreementInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationacceptDevAccessAgreementArgs {
  input: AcceptDevAccessAgreementInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationacceptOfferArgs {
  input: AcceptOfferInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationaccountingJournalStartIntegrationExportArgs {
  input?: InputMaybe<AccountingJournalStartIntegrationExportInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationaccountingJournalUpdateAccountingRecordsArgs {
  input?: InputMaybe<AccountingJournalUpdateAccountingRecordsInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationaccountingJournalUpdateExpensesArgs {
  input?: InputMaybe<AccountingJournalUpdateExpensesInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationactivateCardArgs {
  input: ActivateCardInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationactivateIntegrationArgs {
  input: ActivateIntegrationInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationactivateUserV2Args {
  input: ActivateUserInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationaddAttendeesArgs {
  input: AddAttendeesInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationaddAutoApproveUserIdArgs {
  input?: InputMaybe<AddAutoApproveUserIdInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationaddBillsToBatchArgs {
  input: AddBillsToBatchInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationaddFspBookkeeperArgs {
  input: AddFspBookkeeperInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationaddFspBookkeeperUserArgs {
  input: AddFspBookkeeperUserInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationaddSubsidiaryDefaultEntityArgs {
  input: AddSubsidiaryDefaultEntityInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationaddToCohortArgs {
  input: AddToCohortInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationadvanceToNextStepArgs {
  input: AdvanceToNextStepInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationapproveBeneficiariesArgs {
  input?: InputMaybe<ApproveBeneficiariesInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationapproveBudgetLimitIncreaseRequestArgs {
  input: ApproveBudgetLimitIncreaseRequestInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationapproveBudgetLimitIncreaseRequestV2Args {
  input: ApproveBudgetLimitIncreaseRequestInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationapproveBudgetRequestV2Args {
  input: ApproveBudgetRequestInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationarchiveLimitGroupArgs {
  input: ArchiveLimitGroupInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationarchiveSpendBudgetArgs {
  input: ArchiveSpendBudgetInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationarchiveSpendLimitArgs {
  input: ArchiveSpendLimitInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationassignBudgetToCardArgs {
  input: AssignBudgetToCardInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationassignFSPUsersRolesArgs {
  input: AssignFSPUsersRolesInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationasyncCreateDefaultUserSpendLimitsArgs {
  input: AsyncCreateDefaultUserSpendLimitsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationasyncCreateExpensesSearchReportArgs {
  input: AsyncCreateExpensesSearchReportInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationauthorizeDrawdownRequestArgs {
  input: AuthorizeDrawdownRequestInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbankConnectionGenerateUrlArgs {
  input: BankConnectionGenerateUrlInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchAddGroupMembersArgs {
  input: BatchAddGroupMembersInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchArchiveUsersArgs {
  input: BatchArchiveUsersInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchCreateContactsArgs {
  input: BatchCreateContactsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchCreateCostCentersArgs {
  input: BatchCreateCostCentersInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchCreateDepartmentsArgs {
  input: BatchCreateDepartmentsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchCreateExtendedFieldOptionsArgs {
  input: BatchCreateExtendedFieldOptionsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchCreateExtendedFieldVisibilityRulesArgs {
  input: BatchCreateExtendedFieldVisibilityRulesInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchCreateLegalEntitiesArgs {
  input: BatchCreateLegalEntitiesInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchCreateLocationsArgs {
  input: BatchCreateLocationsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchCreateMappingsArgs {
  input: BatchCreateMappingsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchCreateReceiptsAndExpensesArgs {
  input: BatchCreateReceiptsAndExpensesInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchCreateReimbursementExpensesArgs {
  input: BatchCreateReimbursementExpensesInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchCreateSuggestionActionsArgs {
  input: BatchCreateSuggestionActionsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchCreateTitlesArgs {
  input: BatchCreateTitlesInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchCreateUsersArgs {
  input: BatchCreateUsersInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchCreateVendorFileMatchesArgs {
  input: BatchCreateVendorFileMatchesInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchCreateVendorsArgs {
  input: BatchCreateVendorsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchCreateWorkflowRulesArgs {
  input: Array<CreateWorkflowRuleInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchDeleteBudgetsArgs {
  input: BatchDeleteBudgetsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchDeleteExtendedFieldVisibilityRuleArgs {
  input: BatchDeleteExtendedFieldVisibilityRulesInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchDeleteRulesArgs {
  input: Array<DeleteWorkflowRuleInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchDeleteUserInvitesArgs {
  input: BatchDeleteUserInvitesInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchDisableUsersArgs {
  input: BatchDisableUsersInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchImportExtendedFieldOptionsArgs {
  input: BatchImportExtendedFieldOptionsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchInviteUsersArgs {
  input: BatchInviteUsersInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchMoveBudgetsArgs {
  input: BatchMoveBudgetsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchReactivateUsersArgs {
  input: BatchReactivateUsersInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchRemoveGroupMembersArgs {
  input: BatchRemoveGroupMembersInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchRestoreToHybridEmbeddedUsersArgs {
  input: BatchRestoreToHybridEmbeddedUsersInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchSetAccessRoleAssignmentsArgs {
  input: BatchSetUserRoleAssignmentsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchSetEntityAutopayFundingSourceArgs {
  input: BatchSetEntityAutopayFundingSourceInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchSetFunctionalRoleAssignmentsArgs {
  input: BatchSetUserRoleAssignmentsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchSetUserRoleAssignmentsArgs {
  input: BatchSetUserRoleAssignmentsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchSubmitReimbursementExpensesArgs {
  input: BatchSubmitReimbursementExpensesInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchSubmitVerificationRequestsArgs {
  input: BatchSubmitVerificationRequestsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchTerminateBudgetsArgs {
  input: BatchTerminateBudgetsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchToggleRulesArgs {
  input: BatchToggleRulesInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchUnarchiveUsersArgs {
  input: BatchUnarchiveUsersInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchUpdateAccountingRecordsArgs {
  input: BatchUpdateAccountingRecordsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchUpdateBooleanFieldInstanceArgs {
  input: BatchUpdateBooleanFieldInstanceInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchUpdateBudgetLimitsAsyncArgs {
  input?: InputMaybe<BatchUpdateBulkBudgetLimitAsyncInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchUpdateDateFieldInstanceArgs {
  input: BatchUpdateDateFieldInstanceInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchUpdateDecimalFieldInstanceArgs {
  input: BatchUpdateDecimalFieldInstanceInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchUpdateDepartmentsArgs {
  input: BatchUpdateDepartmentsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchUpdateExpensesAuditStatusArgs {
  input: BatchUpdateExpensesAuditStatusInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchUpdateExportJobNotificationsArgs {
  input: Array<UpdateExportJobNotificationInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchUpdateExtendedFieldOptionsArgs {
  input: BatchUpdateExtendedFieldOptionsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchUpdateExtendedFieldVisibilityRulesArgs {
  input: BatchUpdateExtendedFieldVisibilityRulesInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchUpdateFinancialAssetFieldInstanceArgs {
  input: BatchUpdateFinancialAssetFieldInstanceInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchUpdateLocationsArgs {
  input: BatchUpdateLocationsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchUpdateOptionFieldInstanceArgs {
  input: BatchUpdateOptionFieldInstanceInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchUpdateStringFieldInstanceArgs {
  input: BatchUpdateStringFieldInstanceInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchUpdateTimestampFieldInstanceArgs {
  input: BatchUpdateTimestampFieldInstanceInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchUpdateToEmbeddedUsersArgs {
  input: BatchUpdateToEmbeddedUsersInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchUpdateUsersArgs {
  input: BatchUpdateUsersInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbatchUpdateWorkflowRulesArgs {
  input: Array<UpdateWorkflowRuleInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbeginChannelVerificationArgs {
  input: BeginChannelVerificationInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbillBatchAddBillsArgs {
  input: BillBatchAddBillsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbillBatchApproveArgs {
  input: BillBatchApproveInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbillBatchBulkCreateArgs {
  input: BillBatchBulkCreateInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbillBatchDeleteArgs {
  input: BillBatchDeleteInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbillBatchRemoveBillsArgs {
  input: BillBatchRemoveBillsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbillBatchRetryArgs {
  input: RetryFailedBillBatchInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbillBatchUpdateArgs {
  input: BillBatchUpdateInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbillRetryPaymentArgs {
  input?: InputMaybe<BillRetryPaymentInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbillUpdatePaymentDetailsArgs {
  input: BillUpdatePaymentDetailsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbulkDisconnectErpFeedsArgs {
  input: BulkDisconnectErpFeedsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbulkFindOrCreateErpFeedsArgs {
  input: BulkFindOrCreateErpFeedsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbulkImportFieldsArgs {
  input: BulkImportFieldsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbulkRemoveCommentEntityAuthorizationsArgs {
  input: BulkRemoveCommentEntityAuthorizationsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbulkResolveSuggestionGroupsArgs {
  input: BulkResolveSuggestionGroupsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbulkTransitionExpenseRequestActionsArgs {
  input: BulkTransitionExpenseRequestActionsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbulkTransitionExpenseRequestsArgs {
  input: BulkTransitionExpenseRequestsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbulkUpdateBudgetsArgs {
  input: BulkUpdateBudgetsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbulkUpdateExpensesArgs {
  input: BulkUpdateExpensesInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbulkUpdateExtendedFieldOptionsArgs {
  input: BulkUpdateExtendedFieldOptionsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbulkUpdateVendorFileMatchStatusesArgs {
  input: BulkUpdateVendorFileMatchStatusesInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationbulkUpdateVendorFileMatchesArgs {
  input: BulkUpdateVendorFileMatchesInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcDaArgs {
  input: CDaInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcancelBillArgs {
  input: CancelBillInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcancelBillPaymentArgs {
  input: CancelBillPaymentInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcancelBillPaymentV2Args {
  input: CancelBillPaymentV2Input;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcancelBudgetLimitIncreaseRequestArgs {
  input: CancelBudgetLimitIncreaseRequestInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcancelBudgetLimitIncreaseRequestV2Args {
  input: CancelBudgetLimitIncreaseRequestInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcancelBudgetRequestArgs {
  input: CancelBudgetRequestInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcancelBulkUpdateExpensesArgs {
  input: CancelBulkUpdateExpensesInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcancelCashRecurringScheduleArgs {
  input: CancelCashRecurringScheduleInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcancelCashTransactionArgs {
  input: CancelCashTransactionInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcancelClawbackArgs {
  input: CancelClawbackInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcancelDisputeArgs {
  input: CancelDisputeInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcancelEmailChangeArgs {
  input?: InputMaybe<CancelEmailChangeInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcancelExpenseArgs {
  input: CancelExpenseInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcancelGroupEventArgs {
  input: CancelGroupEventInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcancelPaymentArgs {
  input: CancelPaymentInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcancelPurchasingCardArgs {
  input: CancelPurchasingCardInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcancelScheduledPrepaymentArgs {
  input: CancelScheduledPrepaymentInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcardAliasCreateArgs {
  input: CardAliasCreateInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcardDisableLimitSourceAutoAssignmentArgs {
  input: CardDisableLimitSourceAutoAssignmentInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcardEnableLimitSourceAutoAssignmentArgs {
  input: CardEnableLimitSourceAutoAssignmentInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcardPartnerFeedRuleCreateArgs {
  input: CardPartnerFeedRuleCreateInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcardTransferArgs {
  input: CardTransferInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationchangeInvestmentPolicyArgs {
  input: ChangeInvestmentPolicyInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationclearRecentSearchesArgs {
  input: ClearRecentSearchesInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcommitDraftFieldsArgs {
  input: CommitDraftFieldsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcompleteCashTransactionApprovalArgs {
  input: CompleteCashTransactionApprovalInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcompleteClawbackArgs {
  input: CompleteClawbackInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcompleteOnboardingArgs {
  input: CompleteOnboardingInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcompleteOnboardingApplicationsArgs {
  input: CompleteOnboardingApplicationsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationconfigureProductSelectionArgs {
  input: ConfigureProductSelectionInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationconfirmMfaArgs {
  input: ConfirmMfaInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationconfirmPendingEmailChangeArgs {
  input: ConfirmPendingEmailChangeInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationconnectCredentialArgs {
  input: ConnectCredentialInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationconnectInstitutionArgs {
  input: ConnectInstitutionInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationconnectPersonalArgs {
  input: ConnectPersonalInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationconnectPlaidInstitutionArgs {
  input: ConnectPlaidInstitutionInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationconnectShopifyCredentialArgs {
  input: ConnectShopifyCredentialInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationconnectTellerInstitutionArgs {
  input: ConnectTellerInstitutionInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationconnectionUpdateArgs {
  input: ConnectionUpdateInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationconvertCardAccountTypeArgs {
  input: ConvertCardAccountTypeInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateAccountArgs {
  input: CreateAccountInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateAccountingIntegrationArgs {
  input: CreateAccountingIntegrationInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateAccountingJournalReportArgs {
  input: CreateAccountingJournalReportInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateAndConnectCredentialArgs {
  input: CreateAndConnectCredentialInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateAssetArgs {
  input: CreateAssetInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateAssistantFeedbackArgs {
  input: CreateAssistantFeedbackInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateAttributeMappingsArgs {
  input: CreateAttributeMappingsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateAutoInviteSettingArgs {
  input: CreateAutoInviteSettingInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateAutomaticTransferSettingsArgs {
  input: CreateAutomaticTransferSettingsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateAutomationWorkflowSpecsArgs {
  inputs: Array<CreateAutomationWorkflowSpecInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateBillArgs {
  input: CreateBillInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateBillBatchesArgs {
  input: CreateBillBatchesInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateBillV2Args {
  input: CreateBillV2Input;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateBudgetArgs {
  input: CreateBudgetInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateBudgetLimitIncreaseRequestArgs {
  input: CreateBudgetLimitIncreaseRequestInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateBudgetRequestArgs {
  input: CreateBudgetRequestInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateBudgetRequestFromTemplateArgs {
  input: CreateBudgetRequestFromTemplateInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateBudgetTemplateArgs {
  input: CreateBudgetTemplateInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateBudgetTemplateV2Args {
  input: CreateBudgetTemplateV2Input;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateCashTransactionArgs {
  input: CreateCashTransactionInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateCashWireDetailsArgs {
  input: CreateCashWireDetailsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateChannelPreferencesArgs {
  input: CreateChannelPreferencesInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateClawbackArgs {
  input: CreateClawbackInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateCommentArgs {
  input: CreateCommentInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateCommentsArgs {
  input: CreateCommentsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateContactArgs {
  input: CreateContactInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateCopilotArgs {
  input: CreateCopilotInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateCostCenterArgs {
  input: CreateCostCenterInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateCounterpartyArgs {
  input: CreateCounterpartyInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateCredentialArgs {
  input: CreateCredentialInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateCustomRoleArgs {
  input: CreateCustomRoleInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateCustomerSsoExclusionArgs {
  customerUserId?: InputMaybe<Scalars["String"]>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateDefaultIntegrationFieldMappingArgs {
  input: CreateDefaultIntegrationFieldMappingInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateDepositsApplicationArgs {
  input: CreateDepositsApplicationInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateDeveloperApiTokenArgs {
  input: CreateDeveloperApiTokenInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateDisclosureApplicationArgs {
  input: CreateDisclosureApplicationInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateDocumentOcrArgs {
  input: CreateDocumentOcrInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateEarlyCreditCommitmentArgs {
  input: createEarlyCreditCommitmentInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateEmailChannelArgs {
  input: CreateEmailChannelInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateEmpowerCustomerInquiryArgs {
  input: CreateEmpowerCustomerInquiryInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateEngagementSettingArgs {
  input: CreateEngagementSettingInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateEntityMappingArgs {
  input: CreateEntityMappingInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateExpenseArgs {
  input: CreateExpenseInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateExpenseNotificationArgs {
  input: CreateExpenseNotificationInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateExpenseReportArgs {
  input: CreateExpenseReportInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateExpensesSearchReportArgs {
  input: CreateExpensesSearchReportInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateExtendedFieldArgs {
  input: CreateExtendedFieldInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateExtendedFieldOptionsReportArgs {
  input: CreateExtendedFieldOptionsReportInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateExtendedFieldVisibilityRuleArgs {
  input: CreateExtendedFieldVisibilityRuleInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateExtendedFieldsArgs {
  input: CreateExtendedFieldsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateFeedbackArgs {
  input: CreateFeedbackInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateFileUploadUrlArgs {
  input: CreateFileUploadUrlInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateFinancialBankStatementArgs {
  input: CreateFinancialBankStatementInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateFinancialBankStatementForNewAccountArgs {
  input: CreateFinancialBankStatementForNewAccountInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateFinancialDocumentArgs {
  input: CreateFinancialDocumentInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateFraudDisputeFromExpenseArgs {
  input: CreateFraudDisputeFromExpenseInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateFundingSourceArgs {
  input: CreateFundingSourceInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateFundingSourceForPendingMicroDepositsArgs {
  input: CreateFundingSourceForPendingMicroDepositsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateGroupArgs {
  input: CreateGroupInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateGroupEventArgs {
  input: CreateGroupEventInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateHrConnectionArgs {
  input: CreateHrConnectionInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateIntegrationArgs {
  input: CreateIntegrationInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateIntegrationRuleArgs {
  input: CreateIntegrationRuleInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateInvoiceArgs {
  input: CreateInvoiceInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateInvoiceTemplateArgs {
  input: CreateInvoiceTemplateInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateInvoiceTemplateV1Args {
  input: CreateInvoiceTemplateV1Input;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateInvoiceV1Args {
  input: CreateInvoiceV1Input;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateInvoicingAccountV1Args {
  input: CreateInvoicingAccountV1Input;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateInvoicingContactV1Args {
  input: CreateInvoicingContactV1Input;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateItineraryActivityArgs {
  input: CreateItineraryActivityInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateLLMOAuthIntegrationArgs {
  input: CreateLLMOAuthIntegrationInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateLeadArgs {
  input: CreateLeadInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateLegalEntityArgs {
  input: CreateLegalEntityInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateLimitGroupArgs {
  input: CreateLimitGroupInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateLinkTokenArgs {
  input: CreateLinkTokenInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateManualPushPaymentStatusArgs {
  input?: InputMaybe<CreateManualPushPaymentStatusInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateMappingArgs {
  input: CreateMappingInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateMappingClassArgs {
  input: CreateMappingClassInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateMerchantDisputeFromExpenseArgs {
  input: CreateMerchantDisputeFromExpenseInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateMilesTransferV2Args {
  input: CreateMilesTransferV2Input;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateNetsuiteCredentialArgs {
  input: CreateNetsuiteCredentialInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateNonPrimaryDepositsAccountArgs {
  input: CreateNonPrimaryDepositsAccountInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateOIDCIdpConfigArgs {
  config: OIDCConfigInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateOnboardingApplicationArgs {
  input: CreateOnboardingApplicationInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateOnboardingKycApplicationArgs {
  input: CreateOnboardingKycApplicationInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateOnboardingProductApplicationArgs {
  input: CreateOnboardingProductApplicationInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateOnboardingProductV2ApplicationArgs {
  input: CreateOnboardingProductV2ApplicationInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateOrUpdateAiPolicySettingArgs {
  input: CreateOrUpdateAiPolicySettingInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateOrUpdateApprovalChainPolicyArgs {
  input: CreateOrUpdateApprovalChainPolicyInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateOrUpdateBudgetLimitIncreasePolicyArgs {
  input: CreateOrUpdateBudgetPolicyInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateOrUpdateExpensePolicyArgs {
  input: CreateOrUpdateExpensePolicyInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateOrUpdatePolicyArgs {
  input: CreateOrUpdatePolicyInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateOracleFusionCredentialArgs {
  input: CreateOracleFusionCredentialInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreatePayerArgs {
  input: CreatePayerInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreatePaymentEarlyAuthBalanceDecreaseCommitmentArgs {
  input: CreatePaymentEarlyAuthBalanceDecreaseCommitmentInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreatePaymentFxQuoteArgs {
  input: CreatePaymentFxQuoteInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreatePaymentInstrumentArgs {
  input: CreatePaymentInstrumentInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreatePayrollProviderArgs {
  input: CreatePayrollProviderInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreatePeriodicReviewApplicationArgs {
  input: CreatePeriodicReviewApplicationInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreatePhysicalCardV2Args {
  input: CreatePhysicalCardV2Input;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreatePositivePayAccountSettingArgs {
  input: CreatePositivePayAccountSettingInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreatePositivePayAccountSettingV2Args {
  input: CreatePositivePayAccountSettingInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreatePurchaseOrderArgs {
  input: CreatePurchaseOrderInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreatePurchasingCardArgs {
  input: CreatePurchasingCardInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreatePushChannelArgs {
  input: CreatePushChannelInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateRailAccountDetailsArgs {
  input: CreateRailAccountDetailsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateReceiptIntegrationArgs {
  input: CreateReceiptIntegrationInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateReceiptV2Args {
  input: CreateReceiptV2Input;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateReimbursementExpenseForBookingArgs {
  input: CreateReimbursementForBookingInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateReportTemplateArgs {
  input?: InputMaybe<CreateReportTemplateInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateReportingDashboardScheduleArgs {
  input: CreateReportingDashboardScheduleInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateRequestDeadlineSettingsArgs {
  input: CreateRequestDeadlineSettingsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateResponseToRfiArgs {
  input: CreateResponseToRfiInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateSageintacctCredentialArgs {
  input: CreateSageintacctCredentialInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateSandboxAccountActionArgs {
  input: CreateSandboxAccountActionInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateSmsChannelArgs {
  input: CreateSmsChannelInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateSpendBudgetArgs {
  input: CreateSpendBudgetInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateSpendLimitArgs {
  input: CreateSpendLimitInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateSubscriptionArgs {
  input: CreateSubscriptionInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateSubscriptionsArgs {
  input: CreateSubscriptionsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateTaskArgs {
  task: TaskInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateTitleArgs {
  input: CreateTitleInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateTrackingExpensePolicyArgs {
  input: CreateTrackingExpensePolicyInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateTransactionApprovedSubscriptionArgs {
  input: CreateTransactionApprovedSubscriptionInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateTransactionRefusedSubscriptionArgs {
  input: CreateTransactionRefusedSubscriptionInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateTripArgs {
  input: CreateTripInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateUserCategoriesArgs {
  input: CreateUserCategoriesInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateUserManagementSettingsArgs {
  input: CreateUserManagementSettingInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateVendorArgs {
  input: CreateVendorInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateVirtualCardV2Args {
  input: CreateVirtualCardV2Input;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateWorkdayCredentialArgs {
  input: CreateWorkdayCredentialInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationcreateWorkflowRuleArgs {
  input: CreateWorkflowRuleInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdeleteAutoInviteSettingArgs {
  input: DeleteAutoInviteSettingInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdeleteBillArgs {
  input: DeleteBillInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdeleteBillV2Args {
  input: DeleteBillV2Input;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdeleteBudgetArgs {
  input: DeleteBudgetInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdeleteBudgetTemplateArgs {
  input: DeleteBudgetTemplateInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdeleteContactArgs {
  input: DeleteContactInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdeleteCostCenterArgs {
  input: DeleteCostCenterInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdeleteCustomRoleArgs {
  input: DeleteCustomRoleInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdeleteCustomerSsoExclusionArgs {
  customerUserId?: InputMaybe<Scalars["String"]>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdeleteDefaultIntegrationFieldMappingArgs {
  input: DeleteDefaultIntegrationFieldMappingInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdeleteDraftTripArgs {
  tripId: Scalars["ID"];
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdeleteEntityMappingArgs {
  input: DeleteEntityMappingInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdeleteExtendedFieldArgs {
  input: DeleteExtendedFieldInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdeleteExtendedFieldVisibilityRuleArgs {
  input: DeleteExtendedFieldVisibilityRuleInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdeleteFinancialDocumentArgs {
  input: DeleteFinancialDocumentInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdeleteGroupArgs {
  input: DeleteGroupInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdeleteGroupEventArgs {
  input: DeleteGroupEventInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdeleteIntegrationRuleArgs {
  input: DeleteIntegrationRuleInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdeleteInvoiceV1Args {
  input: DeleteInvoiceV1Input;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdeleteItineraryActivityArgs {
  input: DeleteItineraryActivityInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdeleteLegalEntityArgs {
  input: DeleteLegalEntityInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdeleteLimitGroupArgs {
  input: DeleteLimitGroupInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdeleteMappingArgs {
  input: DeleteMappingInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdeleteMappingClassArgs {
  input: DeleteMappingClassInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdeletePaymentInstrumentArgs {
  input: DeletePaymentInstrumentInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdeletePaymentInstrumentAssociationArgs {
  input: PaymentInstrumentLogicalIdInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdeletePolicySpecSectionArgs {
  input?: InputMaybe<DeletePolicySpecSectionInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdeletePositivePayAccountSettingArgs {
  input: DeletePositivePayAccountSettingInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdeletePositivePayAccountSettingV2Args {
  input: DeletePositivePayAccountSettingInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdeletePurchaseOrdersArgs {
  input: DeletePurchaseOrdersInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdeleteRailAccountDetailsArgs {
  input: DeleteRailAccountDetailsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdeleteReceiptArgs {
  input: DeleteReceiptInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdeleteReceiptIntegrationArgs {
  input: DeleteReceiptIntegrationInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdeleteReimbursementArgs {
  input: DeleteReimbursementInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdeleteReportTemplateArgs {
  input?: InputMaybe<DeleteReportTemplateInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdeleteReportingDashboardArgs {
  input: DeleteReportingDashboardInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdeleteSpendBudgetArgs {
  input: DeleteSpendBudgetInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdeleteSpendLimitArgs {
  input: DeleteSpendLimitInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdeleteSubscriptionArgs {
  input: DeleteSubscriptionInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdeleteSubscriptionsArgs {
  input: DeleteSubscriptionsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdeleteSubsidiaryDefaultEntityArgs {
  input: DeleteSubsidiaryDefaultEntityInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdeleteTitleArgs {
  input: DeleteTitleInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdeleteTrackingExpensePolicyArgs {
  input: DeleteTrackingExpensePolicyInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdeleteVendorsArgs {
  input: DeleteVendorsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdeleteWorkflowRuleArgs {
  input: DeleteWorkflowRuleInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdepositChequeArgs {
  input: DepositChequeInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdgsProcessInvoiceArgs {
  input: ProcessInvoiceInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdgsProcessInvoiceAndCreateBillArgs {
  input: ProcessInvoiceAndCreateBillInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdisableAccountingIntegrationArgs {
  input: DisableAccountingIntegrationInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdisableAutomaticTransferSettingsArgs {
  input: DisableAutomaticTransferSettingsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdisableBillsArgs {
  input: DisableBillsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdisableChannelArgs {
  input: DisableChannelInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdisableExpensesArgs {
  input: DisableExpensesInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdisableHrConnectionArgs {
  input: DisableHrConnectionInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdisableIntegrationArgs {
  input: DisableIntegrationInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdisableLimitUtilizationTriggerArgs {
  input: DisableLimitUtilizationTriggerInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdisableNonPrimaryFundingSourcesArgs {
  input: DisableNonPrimaryFundingSourcesInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdisablePolicyArgs {
  id: Scalars["ID"];
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdisableReimbursementsArgs {
  input: DisableReimbursementsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdisableToggleArgs {
  input: ToggleMutationInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdisconnectApiClientArgs {
  input: DisconnectApiClientInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdisconnectCredentialArgs {
  input: DisconnectCredentialInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdisconnectCredentialV2Args {
  input: DisconnectCredentialInputV2;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdisconnectErpFeedArgs {
  input: DisconnectErpFeedInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdisconnectPayrollProviderIntegrationArgs {
  input: DisconnectPayrollProviderIntegrationInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdismissCardFraudAlertWithTransactionArgs {
  input: DismissCardFraudAlertWithTransactionInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdismissLegalEntitySetupTaskArgs {
  input?: InputMaybe<DismissLegalEntitySetupTaskInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdismissLimitEscalationArgs {
  input: DismissLimitEscalationInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdownloadJobsDeleteByIdArgs {
  ids: Array<Scalars["ID"]>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdownloadJobsMarkAsDownloadedArgs {
  ids: Array<Scalars["ID"]>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdrawdownAuthorizationGeneratePdfUrlArgs {
  input: DrawdownAuthorizationGeneratePdfUrlInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdrawdownAuthorizationRescindArgs {
  input: DrawdownAuthorizationRescindInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationdrawdownAuthorizationSubmitArgs {
  input: DrawdownAuthorizationSubmitInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationduplicateBudgetTemplateArgs {
  input: DuplicateBudgetTemplateInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationduplicatePolicyArgs {
  input: DuplicatePolicyInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationduplicateReportingDashboardArgs {
  input: DuplicateReportingDashboardInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationeditBillingConfigurationSettingsArgs {
  input?: InputMaybe<EditBillingConfigurationSettingsInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationeditInvoiceArgs {
  input: EditInvoiceInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationeditInvoiceTemplateV1Args {
  input: EditInvoiceTemplateV1Input;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationeditInvoiceV1Args {
  input: EditInvoiceV1Input;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationeditInvoicingContactV1Args {
  input: EditInvoicingContactV1Input;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationeditReimbursementSettingsArgs {
  input?: InputMaybe<EditReimbursementSettingsInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationenableBillPayBillingArgs {
  input?: InputMaybe<EnableBillPayBillingInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationenableBillingArgs {
  input?: InputMaybe<EnableBillingInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationenableBillsArgs {
  input: EnableBillsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationenableEmployeeTrackingArgs {
  input?: InputMaybe<EnableEmployeeTrackingInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationenableExpensesArgs {
  input: EnableExpensesInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationenableIntegrationArgs {
  input: EnableIntegrationInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationenableLastDisabledChannelArgs {
  input: EnableLastDisabledChannelInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationenablePolicyArgs {
  id: Scalars["ID"];
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationenableReimbursementsArgs {
  input: EnableReimbursementsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationenableReimbursementsBillingArgs {
  input?: InputMaybe<EnableReimbursementsBillingInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationenableToggleArgs {
  input: ToggleMutationInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationexpenseUnsplitArgs {
  input: ExpenseUnsplitInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationexpenseUpdatePurposeArgs {
  input: ExpenseUpdatePurposeInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationexportBillsArgs {
  input: ExportBillsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationexportBillsToErpSyncArgs {
  input?: InputMaybe<ExportBillsToErpSyncInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationexportBillsV2Args {
  input: ExportBillsV2Input;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationexportExpensesArgs {
  input?: InputMaybe<ExportExpensesInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationexportMappingsToCsvArgs {
  input: ExportMappingsToCsvInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationexportObjectsToErpArgs {
  input?: InputMaybe<ExportObjectsToErpInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationexportRewardsPointsHistoryArgs {
  columns?: InputMaybe<Array<ExportRewardsPointsHistoryColumn>>;
  exportFormat: DownloadsPlatformExportFormat;
  filter: RewardsPointHistoryEntriesInputV2;
  idempotencyKey: Scalars["String"];
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationexportTeamArgs {
  input?: InputMaybe<ExportTeamInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationexportTrackedExpensesArgs {
  input?: InputMaybe<ExportTrackedExpensesInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationexportTravelBookingsArgs {
  input: ExportTravelBookingsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationexportVendorsArgs {
  input?: InputMaybe<ExportVendorsInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationextendedFieldCreateCSVTemplateArgs {
  input: ExtendedFieldCreateCSVTemplateInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationextendedFieldCreateDraftArgs {
  input: ExtendedFieldCreateDraftInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationextendedFieldOptionCreateArgs {
  input: ExtendedFieldOptionCreateInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationextendedFieldOptionDeleteArgs {
  input: ExtendedFieldOptionDeleteInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationextendedFieldOptionUpdateArgs {
  input: UpdateSingleExtendedFieldOptionInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationexternalLegalEntityMappingBatchCreateArgs {
  input: ExternalLegalEntityMappingBatchCreateInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationexternalLegalEntityMappingBatchUpdateArgs {
  input: ExternalLegalEntityMappingBatchUpdateInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationfakeMutationDoNotUseArgs {
  input: FakeMutationDoNotUseInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationfindOrCreateErpFeedArgs {
  input: FindOrCreateErpFeedInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationfinicityConnectGenerateFixUrlArgs {
  input: FinicityConnectGenerateFixUrlInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationfinicityConnectGenerateLiteUrlArgs {
  input: FinicityConnectGenerateLiteUrlInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationfinicityConnectMigrateAccountsArgs {
  input: FinicityConnectMigrateAccountsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationfinishChannelVerificationArgs {
  input: FinishChannelVerificationInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationforceApproveApplicationArgs {
  input: ForceApproveApplicationInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationforgetDeviceArgs {
  input: ForgetDeviceInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationgenerateAirwallexKycLinkArgs {
  input?: InputMaybe<GenerateAirwallexKycLinkInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationgenerateBankingProviderKycHostedFlowLinkArgs {
  input: GenerateBankingProviderKycHostedFlowLinkInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationgenerateBillPaymentReceiptDownloadUrlArgs {
  input: GenerateBillPaymentReceiptDownloadUrlInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationgenerateBillPaymentReceiptDownloadUrlV2Args {
  input: GenerateBillPaymentReceiptDownloadUrlV2Input;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationgenerateBulkStatementsZipDownloadUrlArgs {
  input?: InputMaybe<GenerateBulkStatementsZipDownloadUrlInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationgenerateCustomStatementDownloadUrlArgs {
  input?: InputMaybe<GenerateCustomStatementDownloadUrlInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationgenerateCustomStatementFromPaymentDownloadUrlArgs {
  input?: InputMaybe<GenerateCustomStatementFromPaymentDownloadUrlInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationgenerateDepositsStatementDocumentDownloadUrlArgs {
  input: GenerateDepositsStatementDocumentDownloadUrlInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationgenerateDepositsTransactionConfirmationDownloadUrlArgs {
  input: GenerateDepositsTransactionConfirmationDownloadUrlInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationgenerateDepositsVerificationLetterDownloadUrlArgs {
  input: GenerateDepositsVerificationLetterDownloadUrlInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationgenerateDownloadUrlForInvoiceV1Args {
  input: GenerateDownloadUrlForInvoiceV1Input;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationgenerateDrawdownAuthorizationPdfUrlArgs {
  input: GenerateDrawdownAuthorizationPdfUrlInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationgenerateIntegrationFtuxSuggestionsArgs {
  input: GenerateIntegrationFtuxSuggestionsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationgenerateMultiAccountBulkStatementsZipDownloadUrlArgs {
  input?: InputMaybe<GenerateMultiAccountBulkStatementsZipDownloadUrlInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationgeneratePersonalPlaidLinkTokenArgs {
  input: GeneratePersonalPlaidLinkTokenInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationgeneratePlaidLinkTokenArgs {
  input: GeneratePlaidLinkTokenInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationgenerateSpotnanaPayloadArgs {
  idempotencyKey: Scalars["String"];
  spotnanaTripId?: InputMaybe<Scalars["ID"]>;
  tripId?: InputMaybe<Scalars["ID"]>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationgenerateStatementDownloadUrlArgs {
  input?: InputMaybe<GenerateStatementDownloadUrlInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationgenerateTransactionConfirmationDownloadUrlArgs {
  input: GenerateTransactionConfirmationDownloadUrlInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationgenerateTransactionsReportArgs {
  input: GenerateTransactionsReportInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationgenerateTransactionsReportAsyncArgs {
  input: GenerateTransactionsReportInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationgetOrCreateLegalEntitySubsidiaryArgs {
  input: GetOrCreateLegalEntitySubsidiaryInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationgrantFSPUsersClientAccessArgs {
  input: GrantFSPUsersClientAccessInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationheartbeatArgs {
  input?: InputMaybe<HeartbeatInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationignoreSyncErrorsArgs {
  input?: InputMaybe<IgnoreSyncErrorsInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationimportEmployeesArgs {
  input: ImportEmployeeInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationinitializeSAMLIdpConfigArgs {
  config: SAMLConfigInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationinitializeVendorFileMatchSunlightMigrationArgs {
  input: InitializeVendorFileMatchSunlightMigrationInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationinviteVendorArgs {
  input: InviteVendorInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationinvoiceAccountSubmitPupArgs {
  input?: InputMaybe<InvoiceAccountSubmitPupInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationinvoiceConnectExternalBankAccountArgs {
  input?: InputMaybe<InvoiceConnectExternalBankAccountInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationinvoiceSubmitEbaPaymentArgs {
  input?: InputMaybe<InvoiceSubmitEbaPaymentInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationinvoicingCustomerCreateArgs {
  input: InvoicingCustomerCreateInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationinvoicingCustomerSetMetadataArgs {
  input: InvoicingCustomerSetMetadataInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationitemCreateArgs {
  input: ItemCreateInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationitemSetTypeArgs {
  input: ItemSetTypeInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationitemizeExpenseArgs {
  input: ItemizeExpenseInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationkycUpdateUserArgs {
  input: KycUpdateUserInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationlimitSourceIncreaseRequestApproveArgs {
  input: LimitSourceIncreaseRequestApproveInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationlimitSourceIncreaseRequestCancelArgs {
  input: LimitSourceIncreaseRequestCancelInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationlimitSourceIncreaseRequestCreateArgs {
  input: LimitSourceIncreaseRequestCreateInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationlimitSourceIncreaseRequestRejectArgs {
  input: LimitSourceIncreaseRequestRejectInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationlimitSourceIncreaseRequestSetEndDateArgs {
  input: LimitSourceIncreaseRequestUpdateEndDateInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationlimitSourceIncreaseRequestSetReasonArgs {
  input: LimitSourceIncreaseRequestUpdateReasonInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationlimitSourceIncreaseRequestUpdateIncreaseAmountArgs {
  input: LimitSourceIncreaseRequestUpdateIncreaseAmountInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationlockPurchasingCardArgs {
  input: LockPurchasingCardInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationmakeFieldRequiredForExportArgs {
  input: MakeFieldRequiredForExportInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationmarkAllAlertsAsReadArgs {
  input: MarkAllAlertsAsReadInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationmarkBillPaidArgs {
  input: MarkBillPaidInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationmarkBillPaidV2Args {
  input: MarkBillPaidV2Input;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationmarkInvoiceArgs {
  input: MarkInvoiceInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationmarkInvoiceV1Args {
  input: MarkInvoiceV1Input;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationmarkOfferSeenArgs {
  input: MarkOfferSeenInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationmoveBudgetArgs {
  input: MoveBudgetInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationmoveLimitGroupArgs {
  input: MoveLimitGroupInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationmoveSpendBudgetArgs {
  input: MoveSpendBudgetInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationmoveSpendLimitArgs {
  input: MoveSpendLimitInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationmutateItemizedPrimitiveArgs {
  input: MutateItemizedPrimitiveInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationnotifySelectedAccountingSetupUserArgs {
  input: NotifySelectedAccountingSetupUserInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationnotifyUserOfCardRequestArgs {
  input: NotifyUserOfCardRequestInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationobjectMappingBatchLinkArgs {
  input: ObjectMappingBatchLinkInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationobjectMappingsBatchUnlinkArgs {
  input: ObjectMappingBatchUnlinkInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationonboardEmployeesArgs {
  input: OnboardEmployeesInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationonboardingApplicationCancelArgs {
  input: OnboardingApplicationCancelInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationonboardingInformationRequestArgs {
  id: Scalars["ID"];
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationoverrideExpenseReviewArgs {
  input: UpdateRequestInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationprocessInvoiceArgs {
  input: ProcessInvoiceInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationprocessInvoiceAndCreateBillArgs {
  input: ProcessInvoiceAndCreateBillInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationprocessRequestArgs {
  input: ProcessRequestInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationprocessUserMessageViaAssistantArgs {
  input: ProcessUserMessageViaAssistantInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationproductConfigToggleDisableArgs {
  input: ToggleMutationInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationproductConfigToggleEnableArgs {
  input: ToggleMutationInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationprovisionApplePayArgs {
  input: ProvisionApplePayInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationprovisionGooglePayArgs {
  input: ProvisionGooglePayInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationpullDataAsyncArgs {
  input: PullDataAsyncInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationpurchaseOrdersSendToVendorArgs {
  input: PurchaseOrdersSendToVendorInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationpurchasingCardIssueArgs {
  input: PurchasingCardIssueInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationpushMarketoLeadsArgs {
  input: PushMarketoLeadsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationreconnectErpFeedArgs {
  input: ReconnectErpFeedInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationredeemCashBalanceArgs {
  input: RedeemCashBalanceInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationredeemDonationV2Args {
  input: RedeemDonationInputV2;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationredeemForBalanceArgs {
  input: RedeemForBalanceInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationredeemGiftCardArgs {
  input: RedeemGiftCardInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationredeemStatementCreditV2Args {
  input: RedeemStatementCreditInputV2;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationredeemValueAddedServiceCoachingV2Args {
  input?: InputMaybe<RewardsRedeemValueAddedServiceCoachingInputV2>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationredeemValueAddedServiceDoohV2Args {
  input?: InputMaybe<RewardsRedeemValueAddedServiceDoohInputV2>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationredeemValueAddedServiceDoohV3Args {
  input: RewardsRedeemValueAddedServiceDoohInputV3;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationredeemValueAddedServiceMentalHealthV2Args {
  input?: InputMaybe<RewardsRedeemValueAddedServiceMentalHealthInputV2>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationredeemValueAddedServiceOffsiteV2Args {
  input?: InputMaybe<RewardsRedeemValueAddedServiceOffsiteInputV2>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationreferUserArgs {
  input: ReferUserInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationrefreshAccountingIntegrationArgs {
  input: RefreshAccountingIntegrationInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationrefreshCredentialArgs {
  input: RefreshCredentialInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationrefreshEntityFromAccountingIntegrationArgs {
  input: RefreshEntityFromAccountingIntegrationInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationrefreshFinancialSourceArgs {
  input: RefreshFinancialSourceInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationrefreshIntegrationArgs {
  input: RefreshIntegrationInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationrefreshIntegrationCredentialsArgs {
  input: RefreshIntegrationCredentialsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationrefreshPersonalSourceArgs {
  input: RefreshPersonalSourceInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationrefreshTripInformationArgs {
  input?: InputMaybe<RefreshTripInformationInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationrefreshTripInformationWithPnrArgs {
  input?: InputMaybe<RefreshTripInformationWithPnrInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationrefreshVerificationStatusArgs {
  input: RefreshVerificationStatusInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationregisterGroupArgs {
  input: RegisterGroupInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationreimbursementDenyArgs {
  input: ReimbursementDenyInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationrejectBudgetLimitIncreaseRequestArgs {
  input: RejectBudgetLimitIncreaseRequestInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationrejectBudgetLimitIncreaseRequestV2Args {
  input: RejectBudgetLimitIncreaseRequestInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationremoveAttendeesArgs {
  input: RemoveAttendeesInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationremoveAutoApproveUserIdArgs {
  input?: InputMaybe<RemoveAutoApproveUserIdInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationremoveCommentEntityAuthorizationArgs {
  input: RemoveCommentEntityAuthorizationInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationremoveDepartmentArgs {
  input: RemoveDepartmentInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationremoveFieldRequiredForExportArgs {
  input: RemoveFieldRequiredForExportInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationremoveFinancialSourceArgs {
  input: RemoveFinancialSourceInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationremoveFspBookkeeperArgs {
  input: RemoveFspBookkeeperInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationremoveFspBookkeeperUserArgs {
  input: RemoveFspBookkeeperUserInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationremoveGroupEventBudgetArgs {
  input: RemoveGroupEventBudgetInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationremoveLimitEscalationArgs {
  input: RemoveLimitEscalationInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationremoveLocationArgs {
  input: RemoveLocationInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationremovePersonalSourceArgs {
  input: RemovePersonalSourceInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationreopenSpendLimitArgs {
  input: ReopenSpendLimitInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationreplaceCardArgs {
  input: ReplaceCardInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationreplaceCardWithPhysicalArgs {
  input: ReplaceCardWithPhysicalInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationreplaceCardWithVirtualArgs {
  input: ReplaceCardWithVirtualInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationreplaceFundingSourceArgs {
  input: ReplaceFundingSourceInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationreportExportResultsArgs {
  input: ReportExportResultsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationreportTemplateCreateArgs {
  input?: InputMaybe<ReportTemplateCreateInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationreportTemplateDeleteArgs {
  input?: InputMaybe<ReportTemplateDeleteInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationreportTemplateDuplicateArgs {
  input?: InputMaybe<ReportTemplateDuplicateInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationreportTemplateUpdateArgs {
  input?: InputMaybe<ReportTemplateUpdateInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationreprocessBudgetOffboardingActionsArgs {
  input?: InputMaybe<OffboardingActionInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationrequestFSPConnectionArgs {
  input: RequestFSPConnectionInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationrequestGroupEventBudgetArgs {
  input: RequestGroupEventBudgetInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationrescindDrawdownAuthorizationArgs {
  input: RescindDrawdownAuthorizationInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationresendGiftCardArgs {
  input: ResendGiftCardInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationresendWelcomeEmailArgs {
  input: ResendWelcomeEmailInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationresetBackupCodesArgs {
  input: ResetBackupCodesInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationresetUserArgs {
  input: ResetUserInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationresolveCommentRequestArgs {
  input: ResolveCommentRequestInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationresolveLimitEscalationWithFinancialSourceArgs {
  input: ResolveLimitEscalationWithFinancialSourceInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationresolveSpendMigrationImportArgs {
  importId: Scalars["ID"];
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationresyncBillsArgs {
  input: ResyncBillsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationresyncReimbursementItemsArgs {
  input: ResyncReimbursementItemsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationretryClawbackPaymentArgs {
  input: RetryClawbackPaymentInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationretryPennyPullArgs {
  input: RetryPennyPullInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationretryReimbursementPaymentArgs {
  input: RetryReimbursementPaymentInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationretryVerificationArgs {
  input: RetryVerificationInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationrevertCancelledBillArgs {
  input: RevertCancelledBillInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationrevertCancelledBillV2Args {
  input: RevertCancelledBillV2Input;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationrevertExportEntriesArgs {
  input: RevertExportEntriesInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationrevertMarkedPaidBillArgs {
  input: RevertMarkedPaidBillInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationrevertPaidBillArgs {
  input: RevertPaidBillInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationreviewPolicyArgs {
  input: ReviewPolicyInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationrevokeActiveOauthApplicationArgs {
  input: RevokeActiveOauthApplicationInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationrevokeDeveloperApiTokenArgs {
  input: RevokeDeveloperApiTokenInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationrevokeFSPUsersClientAccessArgs {
  input: RevokeFSPUsersClientAccessInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationrevokeFSPUsersRolesArgs {
  input: RevokeFSPUsersRolesInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationrevokeLLMOAuthIntegrationArgs {
  input: RevokeLLMOAuthIntegrationInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationrevokeRequestActionStatusArgs {
  input: RevokeRequestActionStatusInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationrevokeSessionArgs {
  input?: InputMaybe<RevokeSessionInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationrfiSubmitForReviewArgs {
  input: RfiSubmitForReviewInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsaveOnboardingInformationRequestArgs {
  input: SaveOnboardingInformationRequestInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsaveResponseToRfiItemArgs {
  input: SaveResponseToRfiItemInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsaveToRecentSearchArgs {
  input: SaveSearchToRecentInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsaveVerificationRequestArgs {
  input: SaveVerificationRequestInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsavedViewCreateArgs {
  savedView: SavedViewInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsavedViewDeleteArgs {
  id: Scalars["ID"];
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsavedViewRenameArgs {
  id: Scalars["ID"];
  label: Scalars["String"];
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsavedViewUpdateDataGridSettingsArgs {
  dataGridSettings: Scalars["Json"];
  id: Scalars["ID"];
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationscheduleCollectionPromiseArgs {
  input: ScheduleCollectionPromiseInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationschedulePaymentArgs {
  input: SchedulePaymentInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationselfInitiateBankStatementRequestArgs {
  input: SelfInitiateBankStatementRequestInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsendBeneficiaryOtpCodeArgs {
  input?: InputMaybe<SendBeneficiaryOtpCodeInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsendBillPaymentArgs {
  input: SendBillPaymentInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsendBillPaymentV2Args {
  input: SendBillPaymentV2Input;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsendBookingRemindersArgs {
  input: SendBookingRemindersInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsendCardToVendorArgs {
  input: SendCardToVendorInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsendInvitesArgs {
  input: SendInvitesInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsendInvoiceArgs {
  input: SendInvoiceInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsendInvoiceReminderV1Args {
  input: SendInvoiceReminderV1Input;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsendInvoiceV1Args {
  input: SendInvoiceV1Input;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsendMessageToRepresentativeArgs {
  input: SendMessageToRepresentativeInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsendMfaResetTokenArgs {
  input: SendMfaResetTokenInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsendMobileChequeDepositNotificationArgs {
  input: SendMobileChequeDepositNotificationInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsendRsvpRemindersArgs {
  input: SendRsvpRemindersInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsendUserInviteEmailsArgs {
  input: SendUserInviteEmailsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsetAccountLocaleArgs {
  input: SetAccountLocaleInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsetAccountRestrictAchDebitsArgs {
  input: SetAccountRestrictAchDebitsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsetAccountTimezoneV2Args {
  input: TimezoneInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsetAccountingJournalEntriesReviewStatusArgs {
  input: SetEntriesReviewStatusInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsetAccountingJournalEntryReviewStatusArgs {
  input: SetEntryReviewStatusInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsetApprovalsUnsafeFlagArgs {
  input: SetApprovalsUnsafeFlagInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsetAutomationWorkflowSpecStatusesArgs {
  inputs: Array<SetAutomationWorkflowSpecStatusInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsetCardLimitSourceArgs {
  input: SetCardLimitSourceInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsetCorporateCardAccessArgs {
  input: SetCorporateCardAccessInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsetDefaultPolicyArgs {
  id: Scalars["ID"];
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsetDepositsTransactionPaymentMemoArgs {
  input: SetDepositsTransactionPaymentMemoInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsetEntityAutopayFundingSourceArgs {
  input: SetEntityAutopayFundingSourceInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsetFinancialAccountNicknameArgs {
  input: SetFinancialAccountNicknameInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsetFundingSourceAsPrimaryForEntityArgs {
  input: SetFundingSourceAsPrimaryForEntityInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsetFundsAllocationArgs {
  input: SetFundsAllocationInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsetInitialAutopayFundingSourceArgs {
  input: SetInitialAutopayFundingSourceInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsetIntegrationFieldInactiveArgs {
  input: SetIntegrationFieldInactiveInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsetLegalEntityLocaleArgs {
  input: SetLegalEntityLocaleInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsetManagerArgs {
  input: SetManagerInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsetMileageSettingArgs {
  input: MileageSettingInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsetMileageSettingsArgs {
  input?: InputMaybe<Array<MileageSettingInput>>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsetPrimaryFundingSourceArgs {
  input: SetPrimaryFundingSourceInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsetSelfServeEmailUpdateAccessArgs {
  input: SetSelfServeEmailUpdateAccessInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsetUseDeviceTimezoneArgs {
  input: UseDeviceTimezoneInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsetUserListRuleArgs {
  input?: InputMaybe<SetUserListRuleInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsetUserLocaleArgs {
  input: SetUserLocaleInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsetUserPrimaryCardArgs {
  input: SetUserPrimaryCardInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsetUserTimezoneArgs {
  input: TimezoneInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsetUserTimezoneV2Args {
  input: TimezoneInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsetupMfaArgs {
  input: SetupMfaInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsetupMfaV2Args {
  input: SetupMfaInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsignupInitialUserArgs {
  input: SignupInitialUserInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsimulateRequestArgs {
  input: SimulateExpenseRequestInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationskipVendorFileMatchAutoMigrationArgs {
  input: SkipVendorFileMatchAutoMigrationInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationspendLimitModifyMembershipArgs {
  input: SpendLimitModifyMembershipInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationstartAccountingIntegrationExportArgs {
  input: StartAccountingIntegrationExportInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationstartDepositsOffboardingArgs {
  input: StartDepositsOffboardingInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationstartIntegrationExportArgs {
  input: StartIntegrationExportInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationstartResetUserArgs {
  input?: InputMaybe<StartResetUserInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationstartResetUserV2Args {
  input: StartResetUserInputV2;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationstartSpendMigrationImportArgs {
  input: StartSpendMigrationImportInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationstartUpdateUserEmailArgs {
  input: StartUpdateUserEmailInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationstartVerificationAnalysisArgs {
  input: StartVerificationAnalysisInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsubmitAirwallexCardsConsentArgs {
  input: SubmitAirwallexCardsConsentInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsubmitApplicationInfoArgs {
  input: SubmitApplicationInfoInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsubmitBillArgs {
  input: SubmitBillInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsubmitDocumentsArgs {
  input: SubmitDocumentsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsubmitExpenseArgs {
  input: SubmitExpenseInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsubmitFinancialStatementsArgs {
  input: SubmitFinancialStatementsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsubmitLimitIncreaseRequestArgs {
  input: SubmitLimitIncreaseRequestInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsubmitNotApplicableOnboardingInformationRequestArgs {
  input: SubmitNotApplicableOnboardingInformationRequestInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsubmitOnboardingApplicationArgs {
  input: SubmitOnboardingApplicationInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsubmitOnboardingInformationRequestArgs {
  input: SubmitOnboardingInformationRequestInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsubmitReceiptAutogenDisabledRationaleArgs {
  input: SubmitReceiptAutogenDisabledRationaleInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsubmitUserReviewTasksArgs {
  input: SubmitUserReviewTasksInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsubmitVerificationRequestArgs {
  input: SubmitVerificationRequestInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsubscribeToGroupArgs {
  input: SubscribeToGroupInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsubsidiarySettingsCreateDefaultIntegrationFieldMappingArgs {
  input: SubsidiarySettingsCreateDefaultIntegrationFieldMappingInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsubsidiarySettingsDeleteDefaultIntegrationFieldMappingArgs {
  input: SubsidiarySettingsDeleteDefaultIntegrationFieldMappingInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsubsidiarySettingsDeleteEntityMappingArgs {
  input: SubsidiarySettingsDeleteEntityMappingInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsubsidiarySettingsUpdateDefaultIntegrationFieldMappingArgs {
  input: SubsidiarySettingsUpdateDefaultIntegrationFieldMappingInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsubsidiarySettingsUpdateEntityMappingArgs {
  input: SubsidiarySettingsUpdateEntityMappingInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsuspendCardV2Args {
  input: SuspendCardV2Input;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsuspendUsersArgs {
  input: SuspendUsersInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsyncHrConnectionArgs {
  id: Scalars["ID"];
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsyncIntegrationArgs {
  input: SyncIntegrationInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationsyncObjectsArgs {
  input: SyncObjectsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationterminateBudgetArgs {
  input: TerminateBudgetInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationterminateCardArgs {
  input: TerminateCardInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationtestAsyncJobArgs {
  foo: Scalars["String"];
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationtoggleRuleArgs {
  input: ToggleRuleInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationtoggleRuleForStatementEntryArgs {
  input: ToggleRuleForStatementEntryInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationtoggleSocialLoginsArgs {
  input: ToggleSocialLoginsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationtransferCardArgs {
  input: TransferCardInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationtransferPurchasingCardArgs {
  input: TransferPurchasingCardInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationtransitionAccountingJournalEntriesArgs {
  input: SetEntriesReviewStatusInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationtriggerErpFeedSyncArgs {
  input: TriggerErpFeedSyncInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationtriggerInvoiceProcessingArgs {
  input: InvoiceProcessingInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationtriggerLimitUtilizationSurveyArgs {
  input: TriggerLimitUtilizationSurveyInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationturnOffSeenFlagArgs {
  input: TurnOffSeenFlagInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationturnOnSeenFlagArgs {
  input: TurnOnSeenFlagInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationunarchiveLimitGroupArgs {
  input: UnarchiveLimitGroupInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationunarchiveSpendBudgetArgs {
  input: UnarchiveSpendBudgetInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationunarchiveSpendLimitArgs {
  input: UnarchiveSpendLimitInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationunassignBudgetFromCardArgs {
  input: UnassignBudgetFromCardInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationunexpireBudgetArgs {
  input: UnexpireBudgetInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationunlockPurchasingCardArgs {
  input: UnlockPurchasingCardInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationunregisterGroupArgs {
  input: UnregisterGroupInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationunsubscribeFromGroupArgs {
  input: UnsubscribeFromGroupInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationunsuspendCardArgs {
  input: UnsuspendCardInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationunterminateBudgetArgs {
  input: UnterminateBudgetInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateAccountAddressArgs {
  input: UpdateAccountAddressInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateAccountingIntegrationArgs {
  input: UpdateAccountingIntegrationInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateAccountingIntegrationSubsidiarySettingsArgs {
  input: UpdateAccountingIntegrationSubsidiarySettingsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateAdminHomeSettingArgs {
  input: UpdateAdminHomeSettingInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateAlertReadStatusArgs {
  input: UpdateAlertReadStatusInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateAssignedRoleForFSPUserArgs {
  input: UpdateAssignedRoleForFSPUserInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateAttributeMappingsArgs {
  input: UpdateAttributeMappingsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateAuditGroupStatusArgs {
  input: UpdateAuditGroupStatusInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateAutoInviteSettingArgs {
  input: UpdateAutoInviteSettingInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateAutomaticTransferSettingsArgs {
  input: UpdateAutomaticTransferSettingsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateAutomationWorkflowSpecsArgs {
  inputs: Array<UpdateAutomationWorkflowSpecInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateBillArgs {
  input: UpdateBillInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateBillV2Args {
  input: UpdateBillV2Input;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateBudgetArgs {
  input: UpdateBudgetInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateBudgetLimitIncreaseRequestArgs {
  input: UpdateBudgetLimitIncreaseRequestInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateBudgetRequestArgs {
  input: UpdateBudgetRequestInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateBudgetRequestFromTemplateArgs {
  input: UpdateBudgetRequestFromTemplateInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateBudgetTemplateArgs {
  input: UpdateBudgetTemplateInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateBudgetTemplatesOrderArgs {
  input: UpdateBudgetTemplatesOrderInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateBudgetUserNotificationPreferenceArgs {
  input: UpdateBudgetUserNotificationPreferenceInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateCardDisplayNameArgs {
  input: UpdateCardDisplayNameInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateCardPinArgs {
  input: UpdateCardPinInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateCardShippingOrderDismissArgs {
  input: UpdateCardShippingOrderDismissInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateCardSpendLimitAssignmentSettingsArgs {
  input: UpdateCardSpendLimitAssignmentSettingsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateCashTransactionArgs {
  input: UpdateCashTransactionInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateChannelPreferencesArgs {
  input: UpdateChannelPreferencesInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateCompanyAssistantSettingArgs {
  input: UpdateCompanyAssistantSettingInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateCompanyPreferenceArgs {
  input: UpdateCompanyPreferenceInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateConnectionStatusArgs {
  input: UpdateConnectionStatusInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateContactArgs {
  input: UpdateContactInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateContactDefaultErpCategoryArgs {
  input: UpdateContactDefaultErpCategoryInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateCopilotArgs {
  input: UpdateCopilotInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateCostCenterArgs {
  input: UpdateCostCenterInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateCustomRoleArgs {
  input: UpdateCustomRoleInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateDDAMigrationStateArgs {
  input: UpdateDDAMigrationStateInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateDefaultIntegrationFieldMappingArgs {
  input: UpdateDefaultIntegrationFieldMappingInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateDepositsAccountArgs {
  input: UpdateDepositsAccountInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateEnabledAccountPolicyCurrenciesArgs {
  input: UpdateEnabledAccountPolicyCurrenciesInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateEngagementSettingArgs {
  input: UpdateEngagementSettingInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateEntityMappingArgs {
  input: UpdateEntityMappingInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateExpenseArgs {
  input: UpdateExpenseInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateExpenseReportArgs {
  input: UpdateExpenseReportInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateExpenseReviewArgs {
  input: UpdateRequestActionInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateExpensesArgs {
  input: UpdateExpensesInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateExportRecordArgs {
  input: UpdateExportRecordInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateExtendedFieldArgs {
  input: UpdateExtendedFieldInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateExtendedFieldVisibilityRuleArgs {
  input: UpdateExtendedFieldVisibilityRuleInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateExtendedFieldsArgs {
  input: UpdateExtendedFieldsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateGroupArgs {
  input: UpdateGroupInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateGroupEventArgs {
  input: UpdateGroupEventInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateGroupEventTripArgs {
  input: UpdateGroupEventTripInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateHrConnectionArgs {
  input: UpdateHrConnectionInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateInsightSettingsArgs {
  input: UpdateInsightSettingsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateInstitutionLoginArgs {
  input: UpdateInstitutionLoginInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateIntegrationCredentialArgs {
  input: UpdateIntegrationCredentialInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateIntegrationRuleArgs {
  input: UpdateIntegrationRuleInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateIntegrationSettingsArgs {
  input: UpdateIntegrationSettingsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateIntegrationSyncSettingsArgs {
  input: UpdateIntegrationSyncSettingsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateInviteResponseArgs {
  input: UpdateInviteResponseInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateItineraryActivityArgs {
  input: UpdateItineraryActivityInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateKYCIndividualArgs {
  input: UpdateKYCIndividualInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateLeadArgs {
  input: UpdateLeadInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateLegalEntityArgs {
  input: UpdateLegalEntityInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateLimitGroupArgs {
  input: UpdateLimitGroupInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateMappingArgs {
  input: UpdateMappingInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateMappingClassArgs {
  input: UpdateMappingClassInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateMigratedUsersArgs {
  input?: InputMaybe<UpdateMigratedUsersInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateMostRecentlyUsedCurrencyArgs {
  input: UpdateMostRecentlyUsedCurrencyInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateOIDCClientConfigArgs {
  config: OIDCUpdateValuesInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateOIDCIdpConfigArgs {
  config: OIDCConfigInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateParentBudgetAndApproveBudgetRequestArgs {
  input: UpdateParentBudgetAndApproveBudgetRequestInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdatePartnershipIntegrationArgs {
  input: UpdatePartnershipIntegrationInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdatePaymentInstrumentArgs {
  input: UpdatePaymentInstrumentInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdatePaymentSourceArgs {
  input: UpdatePaymentSourceInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdatePersonalPlaidLinkTokenArgs {
  input: UpdatePersonalPlaidLinkTokenInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdatePlaidLinkTokenArgs {
  input: UpdatePlaidLinkTokenInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdatePositivePayAccountSettingArgs {
  input: UpdatePositivePayAccountSettingInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdatePositivePayAccountSettingV2Args {
  input: UpdatePositivePayAccountSettingInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdatePurchaseOrderArgs {
  input: UpdatePurchaseOrderInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdatePurchasingCardArgs {
  input: UpdatePurchasingCardInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateRailAccountDetailsArgs {
  input: UpdateRailAccountDetailsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateReceiptAutogenSettingArgs {
  input: UpdateReceiptAutogenSettingInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateReceiptIntegrationArgs {
  input: UpdateReceiptIntegrationOneOfInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateReceiptValidationSettingArgs {
  input: UpdateReceiptValidationSettingInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateReportTemplateDataArgs {
  input?: InputMaybe<UpdateReportTemplateDataInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateReportTemplateInfoArgs {
  input?: InputMaybe<UpdateReportTemplateInfoInput>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateReportingDashboardArgs {
  input: UpdateReportingDashboardInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateRequestArgs {
  input: UpdateRequestInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateRequestActionArgs {
  input: UpdateRequestActionInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateRequestActionV2Args {
  input: UpdateRequestActionInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateRequestActionsArgs {
  input: UpdateRequestActionsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateRequestActionsV2Args {
  input: UpdateRequestActionsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateRequestDeadlineSettingsArgs {
  input: UpdateRequestDeadlineSettingsInput;
  type?: InputMaybe<RequestDeadlineSettingsType>;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateRequestV2Args {
  input: UpdateRequestInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateRequestsArgs {
  input: UpdateRequestsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateRequestsV2Args {
  input: UpdateRequestsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateRolesArgs {
  input: UpdateRolesInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateSAMLIdpConfigArgs {
  config: SAMLUpdateValuesInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateSelfAttestationAccountTypeArgs {
  input: UpdateSelfAttestationAccountTypeInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateSpendBudgetArgs {
  input: UpdateSpendBudgetInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateSpendLimitArgs {
  input: UpdateSpendLimitInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateSsoEnabledArgs {
  enabled: Scalars["Boolean"];
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateSubsidiaryArgs {
  input: UpdateSubsidiaryInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateTaskArgs {
  input: UpdateTaskInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateTaskStatesArgs {
  input: UpdateTaskStatesInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateTaxCodeSettingsArgs {
  input: UpdateTaxCodeSettingsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateTitleArgs {
  input: UpdateTitleInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateTravelSupportSessionIdArgs {
  input: UpdateTravelSupportSessionIdInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateTripArgs {
  input: UpdateTripInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateUserArgs {
  input: UpdateUserInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateUserAssistantSettingArgs {
  input: UpdateUserAssistantSettingInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateUserCategoriesArgs {
  input: UpdateUserCategoriesInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateUserCategoryArgs {
  input: UpdateUserCategoryInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateUserEmailArgs {
  input: UpdateUserEmailInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateUserGlanceVisitorIdArgs {
  input: UpdateUserGlanceVisitorIdInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateUserManagementSettingsArgs {
  input: UpdateUserManagementSettingInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateUserPermissionArgs {
  input: UpdateUserPermissionInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateVatSettingsArgs {
  input: UpdateVatSettingsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateVendorArgs {
  input: UpdateVendorInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateVendorFromMagicLinkArgs {
  input: UpdateVendorFromMagicLinkInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateVerificationNotificationArgs {
  input: UpdateVerificationNotificationInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupdateWorkflowRuleArgs {
  input: UpdateWorkflowRuleInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupgradeToSuperAdminArgs {
  input: UpgradeToSuperAdminInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationuploadBulkMappingsTemplateArgs {
  input: UploadBulkMappingsTemplateInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationuploadCsvAndCreateMappingsArgs {
  input: UploadCsvAndCreateMappingsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationuploadHotelRoomBlockArgs {
  input: UploadHotelRoomBlockInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupsertExpensePolicySpecArgs {
  input: ExpensePolicySpecInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupsertExpenseTypeExtendedFieldsArgs {
  input: UpsertExpenseTypeExtendedFieldInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupsertLimitUtilizationTriggerArgs {
  input: UpsertLimitUtilizationTriggerInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupsertUserLimitArgs {
  input: UpsertUserLimitInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationupsertValueRulesForDependencyCsvArgs {
  input: UpsertValueRulesForDependencyCsvInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationvalidateChequeImagesArgs {
  input: ValidateChequeImagesInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationvalidateEmailArgs {
  input: ValidateEmailInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationvalidateMicroDepositsAmountsArgs {
  input: ValidateMicroDepositsAmountsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationvalidateSmsArgs {
  input: ValidateSmsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationvalidateValueRulesForDependencyCsvArgs {
  input: ValidateValueRulesForDependencyCsvInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationvalidateVerificationArgs {
  input: ValidateVerificationInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationvendorAddDocumentsArgs {
  input: VendorAddDocumentsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationvendorFileMatchSunlightBlockedArgs {
  input: VendorFileMatchSunlightBlockedInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationvendorRemoveDocumentsArgs {
  input: VendorRemoveDocumentsInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationverificationStartAnalysisArgs {
  input: VerificationStartAnalysisInput;
}

/**  Base Mutation type which allows other schema files to extend it */
export interface MutationwithdrawFundsArgs {
  input: WithdrawFundsInput;
}

/**
 * The interface for mutation errors. Every mutation should implement this
 * interface to return errors, including for custom errors.
 *
 * Example usage:
 * ```graphql
 * type Mutation {
 *     expenseSetBudget(input: ExpenseSetBudgetInput!): ExpenseSetBudgetResult
 * }
 *
 * union ExpenseSetBudgetResult = Expense | ExpenseSetBudgetError
 *
 * type ExpenseSetBudgetError implements MutationError {
 *     errors: [ExpenseSetBudgetErrors!]!
 * }
 *
 * interface ExpenseSetBudgetErrors implements StandardClientError {
 *     code: ErrorCode!
 *     message: String
 *     path: [String!]
 * }
 *
 * enum BudgetPreconditionErrorCode {
 *     USE_PARENT
 *     LIMIT_EXCEEDED
 *     LOCKED
 * }
 *
 * # Custom error with extended fields
 * type BudgetPreconditionsError implements ExpenseSetBudgetErrors & StandardClientError {
 *     code: ErrorCode!
 *     message: String
 *     path: [String!]
 *     errorCode: BudgetPreconditionErrorCode!
 * }
 *
 * # A standard error that's available in the library
 * type InvalidFieldError implements StandardClientError {
 *     code: ErrorCode!
 *     message: String
 *     path: [String!]
 * }
 * ```
 */
export interface MutationError {
  /** A list of user errors for mutation responses */
  errors?: Maybe<Array<StandardClientError>>;
}

/**
 * The interface for mutation responses. Every mutation payload should implement this
 * interface in defining its mutation, including for custom errors.
 *
 * Example usage:
 * type Mutation {
 *     updateExpense: (input: UpdateExpenseInput!): UpdateExpenseResult
 * }
 *
 * type UpdateExpenseResult implements MutationResult {
 *     result: ExpenseConnection
 *     errors: [StandardClientError!]
 * }
 */
export interface MutationResult {
  /**
   * We expect the following field too, where T is the type of the result
   * result: T
   *
   * A list of user errors for mutation responses. Clients should always request this
   * field when performing mutations
   */
  errors?: Maybe<Array<StandardClientError>>;
}

export interface MuteConfiguration {
  /** A list of muted departments */
  mutedDepartments?: Maybe<Array<Department>>;
  /** A list of muted merchant categories */
  mutedMerchantCategories?: Maybe<Array<MerchantCategory>>;
  /** A list of muted merchants */
  mutedMerchants?: Maybe<Array<Merchant>>;
  /** A list of muted users */
  mutedUsers?: Maybe<Array<User>>;
}

export interface MuteConfigurationInput {
  /** A list of users to mute. */
  customerUserIds?: InputMaybe<Array<Scalars["String"]>>;
  /** A list of departments to mute. */
  departmentIds?: InputMaybe<Array<Scalars["String"]>>;
  /** A list of merchant categories to mute. */
  merchantCategoryIds?: InputMaybe<Array<Scalars["String"]>>;
  /** A list of merchants to mute. */
  merchantIds?: InputMaybe<Array<Scalars["String"]>>;
}

/**
 * Clave Bancaria Estandarizada - Mexico's standardized banking code and identifies the bank branch and the individual account.
 * Format is 18 digits consisting of:
 * * bank identifier - 3 digits.
 * * branch location where the account was opened - 3 digits.
 * * account number within the bank - 11 digits.
 * * check digit - 1 digit to ensure the full CLABE is valid.
 */
export interface MxLocal {
  clabe?: Maybe<Scalars["String"]>;
}

/**
 * Clave Bancaria Estandarizada - Mexico's standardized banking code and identifies the bank branch and the individual account.
 * Format is 18 digits consisting of:
 * * bank identifier - 3 digits.
 * * branch location where the account was opened - 3 digits.
 * * account number within the bank - 11 digits.
 * * check digit - 1 digit to ensure the full CLABE is valid.
 */
export interface MxLocalInput {
  clabe?: InputMaybe<Scalars["String"]>;
}

/**
 * Metadata used to create a "Nested Budget" Filter
 *
 * Nested Budget Filters apply to the specified budgetIds AND all of their descendants
 */
export interface NestedBudgetMetadata {
  /**
   * Budget IDs who's descendants will also match the Filter
   * The budget IDs in this list MUST also be in the rightHandSide of the Filter
   */
  applyNestedBudgetIds: Array<Scalars["ID"]>;
  /**
   * Budget IDs explicitly excluded from matching the Filter
   * e.g. budget hierarchy A->B->C->D (applyNested: [B], exclude: [C]) will match B and D
   */
  excludeBudgetIds: Array<Scalars["ID"]>;
}

/**
 * Metadata used to create a "Nested Budget" Filter
 *
 * Nested Budget Filters apply to the specified budgetIds AND all of their descendants
 */
export interface NestedBudgetMetadataInput {
  /**
   * Budget IDs who's descendants will also match the Filter
   * The budget IDs in this list MUST also be in the rightHandSide of the Filter
   */
  applyNestedBudgetIds: Array<Scalars["ID"]>;
  /**
   * Budget IDs to explicitly exclude from matching the Filter
   * e.g. budget hierarchy A->B->C->D (applyNested: [B], exclude: [C]) will match B and D
   */
  excludeBudgetIds: Array<Scalars["ID"]>;
}

export interface NetsuiteAuthPayloadInput {
  /** Identifier for user account */
  accountId: Scalars["String"];
  /** Deployment Id of Brex bundle credit card export Restlet */
  deploymentId?: InputMaybe<Scalars["String"]>;
  /** Script Id of Brex bundle credit card export Restlet */
  scriptId?: InputMaybe<Scalars["String"]>;
  /** Token ID for user Netsuite account */
  tokenId: Scalars["String"];
  /** Token Secret for user Netsuite account */
  tokenSecret: Scalars["String"];
}

export interface NetsuiteCategories {
  accountsPayableUserCategory?: Maybe<UserCategory>;
  /** awx wallet user category */
  awxWalletUserCategory?: Maybe<UserCategory>;
  collectionTargetUserCategory?: Maybe<UserCategory>;
  /** credit card transactions vendor */
  creditCardTransactionsVendor?: Maybe<ExternalIntegrationEntity>;
  /** personal expense user category */
  personalExpenseUserCategory?: Maybe<UserCategory>;
  /** reimbursement accrual basis accounting user category */
  reimbursementClearingUserCategory?: Maybe<UserCategory>;
  /** reimbursements user category */
  reimbursementsUserCategory?: Maybe<UserCategory>;
  rewardsIncomeUserCategory?: Maybe<UserCategory>;
  vendorName?: Maybe<Scalars["String"]>;
}

export interface NetsuiteClass {
  isInactive?: Maybe<Scalars["Boolean"]>;
  name?: Maybe<Scalars["String"]>;
}

/** deprecated */
export interface NetsuiteCustom {
  isInactive?: Maybe<Scalars["Boolean"]>;
  name?: Maybe<Scalars["String"]>;
}

export interface NetsuiteCustomer {
  isInactive?: Maybe<Scalars["Boolean"]>;
  name?: Maybe<Scalars["String"]>;
}

export interface NetsuiteDepartment {
  isInactive?: Maybe<Scalars["Boolean"]>;
  name?: Maybe<Scalars["String"]>;
}

export interface NetsuiteIntegrationExtendedFieldExtension {
  id: Scalars["ID"];
  scriptId?: Maybe<Scalars["String"]>;
}

export interface NetsuiteLocation {
  isInactive?: Maybe<Scalars["Boolean"]>;
  name?: Maybe<Scalars["String"]>;
}

export interface NetsuitePayload {
  accountId?: Maybe<Scalars["String"]>;
  deploymentId?: Maybe<Scalars["String"]>;
  scriptId?: Maybe<Scalars["String"]>;
  tokenId?: Maybe<Scalars["String"]>;
  tokenSecret?: Maybe<Scalars["String"]>;
}

export interface NetsuiteProject {
  isInactive?: Maybe<Scalars["Boolean"]>;
  name?: Maybe<Scalars["String"]>;
}

/** deprecated */
export interface NetsuiteSegment {
  isInactive?: Maybe<Scalars["Boolean"]>;
  name?: Maybe<Scalars["String"]>;
}

/** Setting to represent the parent subsidiary selected in an integration */
export interface NetsuiteSubsidiary {
  name: Scalars["String"];
  /** Stores vendor internal ID as a unique identifier when reconnecting an integration. */
  vendorInternalId: Scalars["String"];
}

/** Metadata associated with a subsidiary's tax code */
export interface NetsuiteTaxCode {
  /** Identified if tax code is no longer active */
  isInactive?: Maybe<Scalars["Boolean"]>;
  /** Name of tax code */
  name?: Maybe<Scalars["String"]>;
  /** Intenal ID of purchase account assigned to the tax code */
  purchaseAccountInternalId?: Maybe<Scalars["String"]>;
  /** Subsidiary tax code is assigned to */
  subsidiaryIds?: Maybe<Array<Maybe<Scalars["String"]>>>;
  /** Percentage rate used to compute tax amount */
  taxRate?: Maybe<Scalars["Float"]>;
}

/** Payload for Netsuite vendors */
export interface NetsuiteVendor {
  isInactive?: Maybe<Scalars["Boolean"]>;
  name?: Maybe<Scalars["String"]>;
}

export interface NewBudgetDetails {
  /** An amount the members can spend */
  limit: FinancialAssetInput;
  /** The name of the budget */
  name: Scalars["String"];
  /**
   * If this a top level budget, the root budget ID should be used.
   * Otherwise, the budget ID this new budget would be nested under
   */
  parentBudgetId: Scalars["ID"];
  /** When this budget resets, if at all */
  periodType: HierarchiesBudgetPeriodType;
}

export interface NextExpectedPaymentInfo {
  nextExpectedPaymentAmount: FinancialAsset;
  nextExpectedPaymentAt: Scalars["Time"];
}

export interface Node {
  /** The id of the object. */
  id: Scalars["ID"];
}

export interface NotAsDescribedProductInput {
  attemptedResolutionDate: Scalars["Date"];
  contact?: InputMaybe<Scalars["String"]>;
  contactMode?: InputMaybe<ContactMode>;
  description: Scalars["String"];
  explanation: Scalars["String"];
}

export interface NotAsDescribedServiceInput {
  attemptedResolutionDate: Scalars["Date"];
  contact?: InputMaybe<Scalars["String"]>;
  contactMode?: InputMaybe<ContactMode>;
  description: Scalars["String"];
  explanation: Scalars["String"];
}

export interface NotReceivedInput {
  attemptedResolutionDate: Scalars["Date"];
  contact?: InputMaybe<Scalars["String"]>;
  contactMode?: InputMaybe<ContactMode>;
  description: Scalars["String"];
  expectedDate: Scalars["Date"];
}

/** A representation of a notification category */
export interface NotificationCategory {
  /** The external facing description for this category */
  externalDescription: Scalars["String"];
  /** The external facing name for this category */
  externalName: Scalars["String"];
  /** notification category id */
  id: Scalars["ID"];
}

export type NotificationFilter = TransactionPresenceNotificationFilter;

/** A representation of a notification group */
export interface NotificationGroup {
  /** The category id this group belongs to */
  categoryId: Scalars["ID"];
  /** The external facing description for this group */
  externalDescription: Scalars["String"];
  /** The external facing name for this group */
  externalName: Scalars["String"];
  /** notification group id */
  id: Scalars["ID"];
  /** Boolean indicating whether the notifications in the group can be delegated */
  isDelegatable: Scalars["Boolean"];
}

export enum NotificationSetting {
  INVALID = "INVALID",
  PROCESSING = "PROCESSING",
  PROCESSING_PROCESSED = "PROCESSING_PROCESSED",
}

export interface NotificationSubscription extends Node {
  channel?: Maybe<Channel>;
  filters?: Maybe<Array<Maybe<NotificationFilter>>>;
  /** The ID of an object */
  id: Scalars["ID"];
  notificationType?: Maybe<NotificationType>;
}

export interface NotificationSubscriptionConnection {
  edges?: Maybe<Array<Maybe<NotificationSubscriptionEdge>>>;
  pageInfo: PageInfo;
}

export interface NotificationSubscriptionEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<NotificationSubscription>;
}

export enum NotificationType {
  BUDGET_DELETED = "BUDGET_DELETED",
  BUDGET_LIMIT_INCREASE_REQUEST_APPROVED = "BUDGET_LIMIT_INCREASE_REQUEST_APPROVED",
  BUDGET_LIMIT_INCREASE_REQUEST_CREATED = "BUDGET_LIMIT_INCREASE_REQUEST_CREATED",
  BUDGET_LIMIT_INCREASE_REQUEST_REJECTED = "BUDGET_LIMIT_INCREASE_REQUEST_REJECTED",
  BUDGET_LIMIT_INCREASE_REQUEST_UPDATED = "BUDGET_LIMIT_INCREASE_REQUEST_UPDATED",
  BUDGET_LIMIT_INCREASE_REVIEW_REQUESTED = "BUDGET_LIMIT_INCREASE_REVIEW_REQUESTED",
  BUDGET_REQUEST_REVIEW_REQUESTED = "BUDGET_REQUEST_REVIEW_REQUESTED",
  BUDGET_TERMINATED = "BUDGET_TERMINATED",
  CARD_DELIVERED = "CARD_DELIVERED",
  CARD_DELIVERY_ISSUE = "CARD_DELIVERY_ISSUE",
  CARD_OUT_FOR_DELIVERY = "CARD_OUT_FOR_DELIVERY",
  CARD_SHIPPED = "CARD_SHIPPED",
  CARD_WAS_SHIPPED_NO_TRACKING = "CARD_WAS_SHIPPED_NO_TRACKING",
  COLLECTION_FAILED = "COLLECTION_FAILED",
  DELINQUENT = "DELINQUENT",
  DEPOSITS_BOOK_TRANSFER = "DEPOSITS_BOOK_TRANSFER",
  DEPOSITS_PAYMENT_APPROVAL_REQUEST = "DEPOSITS_PAYMENT_APPROVAL_REQUEST",
  DEPOSITS_PAYMENT_APPROVAL_RESPONSE = "DEPOSITS_PAYMENT_APPROVAL_RESPONSE",
  DEPOSITS_PAYMENT_STATUS = "DEPOSITS_PAYMENT_STATUS",
  DEPOSITS_TRANSACTION_APPROVAL_REQUEST = "DEPOSITS_TRANSACTION_APPROVAL_REQUEST",
  DEPOSITS_TRANSACTION_APPROVAL_RESPONSE = "DEPOSITS_TRANSACTION_APPROVAL_RESPONSE",
  DEPOSITS_TRANSACTION_BLOCKED_BY_POSITIVE_PAY = "DEPOSITS_TRANSACTION_BLOCKED_BY_POSITIVE_PAY",
  DEPOSITS_TRANSACTION_STATUS = "DEPOSITS_TRANSACTION_STATUS",
  DISCONNECTED_BANK_ACCOUNTS = "DISCONNECTED_BANK_ACCOUNTS",
  DISCONNECTED_BANK_ACCOUNTS_SMS = "DISCONNECTED_BANK_ACCOUNTS_SMS",
  EXPENSES_REVIEWER = "EXPENSES_REVIEWER",
  FUNDING_SOURCE_VERIFICATION_FAILED = "FUNDING_SOURCE_VERIFICATION_FAILED",
  GLOBAL_LIMIT_REACHED = "GLOBAL_LIMIT_REACHED",
  GLOBAL_LIMIT_WARNING = "GLOBAL_LIMIT_WARNING",
  LIMIT_DROP = "LIMIT_DROP",
  LIMIT_WARNING = "LIMIT_WARNING",
  LIMIT_WARNING_LOW_CASH_BALANCE = "LIMIT_WARNING_LOW_CASH_BALANCE",
  NEW_EXPENSE_COMMENT = "NEW_EXPENSE_COMMENT",
  PRIMITIVES_CARD_TRANSACTION_APPROVED = "PRIMITIVES_CARD_TRANSACTION_APPROVED",
  PRIMITIVES_EXPENSES_NEW_POLICY = "PRIMITIVES_EXPENSES_NEW_POLICY",
  PRIMITIVES_EXPENSES_REVIEWER = "PRIMITIVES_EXPENSES_REVIEWER",
  PRIMITIVES_EXPENSES_SPENDER = "PRIMITIVES_EXPENSES_SPENDER",
  PRIMITIVES_EXPENSES_UPDATE_POLICY = "PRIMITIVES_EXPENSES_UPDATE_POLICY",
  RECEIPT_AUTOGENERATED = "RECEIPT_AUTOGENERATED",
  RECEIPT_NOT_MATCHED_EMPOWER_EMAIL = "RECEIPT_NOT_MATCHED_EMPOWER_EMAIL",
  RECEIPT_NOT_MATCHED_EMPOWER_SMS = "RECEIPT_NOT_MATCHED_EMPOWER_SMS",
  STATEMENT_REQUEST = "STATEMENT_REQUEST",
  TRANSACTION_APPROVED = "TRANSACTION_APPROVED",
  TRANSACTION_APPROVED_V2 = "TRANSACTION_APPROVED_V2",
  TRANSACTION_REFUSED = "TRANSACTION_REFUSED",
}

/** Notifies the selected user */
export interface NotifySelectedAccountingSetupUserInput {
  clientMutationId: Scalars["String"];
  selectedUserId: Scalars["ID"];
}

export interface NotifySelectedAccountingSetupUserResult
  extends MutationResult {
  errors?: Maybe<Array<AccountingIntegrationMutationError>>;
}

export interface NotifyUserOfCardRequestInput {
  clientMutationId: Scalars["String"];
  customerUserId: Scalars["ID"];
}

export interface NotifyUserOfCardRequestPayload {
  clientMutationId: Scalars["String"];
}

export enum NullValue {
  IS_NOT_NULL = "IS_NOT_NULL",
  IS_NULL = "IS_NULL",
}

export enum NullsOrder {
  FIRST = "FIRST",
  LAST = "LAST",
}

export interface NumberValueInput {
  value?: InputMaybe<Scalars["Decimal"]>;
}

/**
 * New Zealand bank account number.
 * Format is 16 digits consisting of:
 * bank code - 2 digits
 * branch code - 4 digits
 * account number within the bank - 7 digits
 * product/account type - 3 digits
 */
export interface NzLocal {
  accountNumber?: Maybe<Scalars["String"]>;
}

/**
 * New Zealand bank account number.
 * Format is 16 digits consisting of:
 * bank code - 2 digits
 * branch code - 4 digits
 * account number within the bank - 7 digits
 * product/account type - 3 digits
 */
export interface NzLocalInput {
  accountNumber?: InputMaybe<Scalars["String"]>;
}

/**  Extended type from identity-dgs */
export interface OAuthClient extends Displayable, Node {
  displayName: Scalars["String"];
  id: Scalars["ID"];
}

export interface OIDCConfigInput {
  oauth2ClientId: Scalars["String"];
  oauth2ClientSecret: Scalars["String"];
  oauth2Issuer: Scalars["String"];
  ssoProviderName?: InputMaybe<SsoProviderName>;
}

export interface OIDCUpdateValuesInput {
  oauth2ClientId?: InputMaybe<Scalars["String"]>;
  oauth2ClientSecret?: InputMaybe<Scalars["String"]>;
  oauth2Issuer?: InputMaybe<Scalars["String"]>;
  ssoProviderName?: InputMaybe<SsoProviderName>;
}

/** Client that current user has active grants with */
export interface OauthApplication {
  clientId: Scalars["String"];
  clientName: Scalars["String"];
  labels?: Maybe<Array<Maybe<Scalars["String"]>>>;
  lastGrantedAt?: Maybe<Scalars["Time"]>;
  logoUri?: Maybe<Scalars["String"]>;
  revokeOption?: Maybe<RevokeOption>;
  scopes?: Maybe<Array<Maybe<Scalars["String"]>>>;
}

/** Object mapping representing connection between Brex objects and ERP objects */
export interface ObjectMapping extends Node {
  brexObjectId: Scalars["String"];
  erpLink?: Maybe<Scalars["String"]>;
  erpObjectId?: Maybe<Scalars["String"]>;
  errorMessage?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  lastSyncedAt?: Maybe<Scalars["Time"]>;
  objectType: ObjectMappingObjectType;
  syncStatus: ObjectMappingSyncStatus;
  typeMetadata?: Maybe<ObjectMappingMetadata>;
}

export interface ObjectMappingBatchLinkInput {
  input: Array<ObjectMappingLinkInput>;
}

export interface ObjectMappingBatchLinkResult {
  errors?: Maybe<Array<ObjectMappingMutationError>>;
  responses: Array<ObjectMapping>;
}

export interface ObjectMappingBatchUnlinkInput {
  input: Array<ObjectMappingUnlinkInput>;
}

export interface ObjectMappingBatchUnlinkResult {
  errors?: Maybe<Array<ObjectMappingMutationError>>;
  responses: Array<ObjectMapping>;
}

export interface ObjectMappingConnection extends Connection {
  edges: Array<ObjectMappingEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"];
}

export interface ObjectMappingEdge {
  cursor?: Maybe<Scalars["String"]>;
  node: ObjectMapping;
}

export interface ObjectMappingLinkInput {
  brexObjectId: Scalars["String"];
  erpObjectId?: InputMaybe<Scalars["String"]>;
  objectType: ObjectMappingObjectType;
}

export type ObjectMappingMetadata = VendorMetadata;

export interface ObjectMappingMutationError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export enum ObjectMappingObjectType {
  BILL = "BILL",
  BILL_PAYMENT = "BILL_PAYMENT",
  CUSTOMER = "CUSTOMER",
  INVALID = "INVALID",
  INVOICE = "INVOICE",
  INVOICE_PAYMENT = "INVOICE_PAYMENT",
  ITEM = "ITEM",
  PURCHASE_ORDER = "PURCHASE_ORDER",
  VENDOR = "VENDOR",
}

export enum ObjectMappingSyncStatus {
  COMPLETED = "COMPLETED",
  ERROR = "ERROR",
  IN_PROGRESS = "IN_PROGRESS",
  NOT_STARTED = "NOT_STARTED",
  SKIP_SYNC = "SKIP_SYNC",
}

export interface ObjectMappingUnlinkInput {
  id: Scalars["ID"];
}

export interface ObjectMappingsFilters {
  brexObjectIds?: InputMaybe<Array<Scalars["ID"]>>;
  objectTypes?: InputMaybe<Array<ObjectMappingObjectType>>;
}

export enum ObjectNodeType {
  ADMIN = "ADMIN",
  BENEFICIAL_OWNER = "BENEFICIAL_OWNER",
  COMPANY = "COMPANY",
  CONTROLLING_OFFICER = "CONTROLLING_OFFICER",
  DEPOSITS_ADMIN = "DEPOSITS_ADMIN",
  DEPOSITS_APPLICANT = "DEPOSITS_APPLICANT",
  DEPOSITS_USER = "DEPOSITS_USER",
  EMPLOYEE = "EMPLOYEE",
}

export interface OffboardDataResult {
  closingDate?: Maybe<Scalars["Time"]>;
  hasWinddown?: Maybe<Scalars["Boolean"]>;
  offboardType?: Maybe<OffboardType>;
}

export enum OffboardType {
  COMPLIANCE = "COMPLIANCE",
  FRAUD = "FRAUD",
}

export enum OffboardUberEmployeesSetting {
  DISABLED = "DISABLED",
  ENABLED = "ENABLED",
}

export interface OffboardingActionConnection extends Connection {
  /** The offboarding action edge */
  edges: Array<OffboardingActionEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count */
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface OffboardingActionEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The offboarding action at this edge. */
  node?: Maybe<OffboardingActionRequired>;
}

export interface OffboardingActionError {
  message: Scalars["String"];
  userId: Scalars["ID"];
}

export interface OffboardingActionInput {
  /** The ids of the offboarded user that needs to be reprocessed */
  userIds: Array<Scalars["ID"]>;
}

export interface OffboardingActionPayload {
  /** Errors encountered when reprocessing a manual action that was required */
  errors: Array<OffboardingActionError>;
}

export interface OffboardingActionRequired {
  /** Number of broken approval chains on templates */
  brokenApprovalChainCount?: Maybe<Scalars["Int"]>;
  /** Cards with transferable spend */
  cards: Array<Card>;
  /** Expense Policies that need offboarding action */
  expensePolicies: Array<Policy>;
  /** limitIncreaseRequest Policies that need offboarding action */
  limitIncreaseRequestPolicies: Array<Policy>;
  /** spend limit approval request Policies that need offboarding action */
  spendLimitApprovalRequestPolicies: Array<Policy>;
  /** Templates that need offboarding action */
  templates: Array<BudgetTemplate>;
  /** User that requires manual action to be completely offboarded */
  user?: Maybe<Employee>;
}

export interface OfferSetupStep {
  /** Whether or not this step has been completed */
  completed: Scalars["Boolean"];
  /** A step in the offer flow */
  step: OfferSetupStepType;
}

export enum OfferSetupStepType {
  ADD_FUNDS = "ADD_FUNDS",
  AUTOPAY = "AUTOPAY",
  REVENUE_ACCESS = "REVENUE_ACCESS",
}

export enum OfferState {
  ACCEPTED = "ACCEPTED",
  DECISION = "DECISION",
  DECLINED = "DECLINED",
  IGNORED = "IGNORED",
  INELIGIBLE = "INELIGIBLE",
  INITIALIZED = "INITIALIZED",
  REJECTED = "REJECTED",
}

export enum OfferType {
  CASH_FORWARD = "CASH_FORWARD",
  SB30 = "SB30",
  SDC = "SDC",
  UNKNOWN = "UNKNOWN",
}

/** The source of funds was an unknown offline source */
export interface OfflineSource {
  /** A placeholder always true field to make the object queryable */
  offline?: Maybe<Scalars["Boolean"]>;
}

export interface OffsiteOfferPayloadV2 {
  /** Dummy field since graphql cannot handle empty payloads. */
  dummyField?: Maybe<Scalars["String"]>;
}

export interface OidcIdpDetails {
  issuer?: Maybe<Scalars["String"]>;
  oauth2ClientId?: Maybe<Scalars["String"]>;
}

export interface OidcServiceDetails {
  signInRedirectUrl: Scalars["String"];
}

export interface OnBehalfOf {
  displayName: Scalars["String"];
  email?: Maybe<Scalars["String"]>;
  onBehalfOfId?: Maybe<Scalars["String"]>;
}

export interface OnboardEmployeesInput {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  connectionId: Scalars["ID"];
  settings: Array<EmployeeOnboardingSettings>;
}

export interface OnboardEmployeesResult {
  errors: Array<EmployeeError>;
}

/** A legal entity's KYC application */
export interface OnboardingApplication extends Node {
  /** The blueprint that this application will follow */
  blueprint: OnboardingBlueprint;
  /** The application creator, null when applicant is not an admin */
  createdByUser?: Maybe<User>;
  /** the id of the entity associated with this application */
  entityId?: Maybe<Scalars["String"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  /** Information requests to be completed by the applicant */
  informationRequests?: Maybe<OnboardingInformationRequestConnection>;
  /** The total number of information requests */
  informationRequestsCount: Scalars["Int"];
  /** the timestamp of when this application is inserted into DB */
  insertedAt?: Maybe<Scalars["Time"]>;
  /** For risk evaluation applications this will be true when ready_for_review_at is not empty */
  isEvidenceResubmission?: Maybe<Scalars["Boolean"]>;
  /** Flag that says if the application is submitted or not */
  isSubmitted: Scalars["Boolean"];
  /** Extra state values for an application, for product applications this contains cash/card outcomes */
  state: OnboardingApplicationState;
  /** The status of the application */
  status: OnboardingApplicationStatus;
  /** the submitted timestamp */
  submittedAt?: Maybe<Scalars["Time"]>;
}

/** A legal entity's KYC application */
export interface OnboardingApplicationinformationRequestsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

export interface OnboardingApplicationCancelInput {
  applicationId: Scalars["String"];
  clientMutationId: Scalars["String"];
}

export interface OnboardingApplicationCancelPayload {
  clientMutationId: Scalars["String"];
}

export interface OnboardingApplicationConnection {
  edges?: Maybe<Array<Maybe<OnboardingApplicationEdge>>>;
  pageInfo: PageInfo;
}

export interface OnboardingApplicationEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<OnboardingApplication>;
}

export interface OnboardingApplicationInput {
  /** The ID of the financial account this application refers to */
  financialAccountId?: InputMaybe<Scalars["ID"]>;
}

/** Extra state values for an application, for product applications this contains cash/card outcomes */
export type OnboardingApplicationState =
  | OnboardingApplicationStateDisclosure
  | OnboardingApplicationStateEmpty
  | OnboardingApplicationStateProductV1
  | OnboardingApplicationStateRiskEvaluation;

/** Additional data for disclosure applications */
export interface OnboardingApplicationStateDisclosure {
  /** The address US state the disclosure is required for */
  disclosureState?: Maybe<Scalars["String"]>;
}

export interface OnboardingApplicationStateEmpty {
  _?: Maybe<Scalars["Boolean"]>;
}

export interface OnboardingApplicationStateProductV1 {
  /** The state of the card portion of the product application */
  card?: Maybe<OnboardingApplicationStateProductV1Value>;
  /** The state of the cash portion of the product application */
  cash?: Maybe<OnboardingApplicationStateProductV1Value>;
}

export enum OnboardingApplicationStateProductV1Value {
  /** The application was approved for this product */
  APPROVED = "APPROVED",
  /** The user did not apply for this product as part of their application */
  NOT_REQUESTED = "NOT_REQUESTED",
  /** Either the application is incomplete or it's being reviewed */
  PROCESSING = "PROCESSING",
}

export interface OnboardingApplicationStateRiskEvaluation {
  /** The state of the compliance portion of the risk evaluation application */
  compliance?: Maybe<OnboardingApplicationStateRiskEvaluationValue>;
  /** The state of the fraud portion of the risk evaluation application */
  fraud?: Maybe<OnboardingApplicationStateRiskEvaluationValue>;
  /** Date by which all requests must be completed, else the account is offboarded */
  offboardDueDate?: Maybe<Scalars["Time"]>;
  /** Date by which all requests must be completed, else the account is suspended */
  suspendDueDate?: Maybe<Scalars["Time"]>;
}

export enum OnboardingApplicationStateRiskEvaluationValue {
  /** The application section was approved */
  APPROVED = "APPROVED",
  /** The application section is processing, i.e. pending evidence or manual review */
  PROCESSING = "PROCESSING",
  /** The application section was rejected */
  REJECTED = "REJECTED",
}

export enum OnboardingApplicationStatus {
  /** Application approved */
  APPROVED = "APPROVED",
  /** User needs to submit evidence requests (before application submission) */
  IN_PROGRESS = "IN_PROGRESS",
  /** User needs to submit evidence requests (after application submission) */
  PENDING_EVIDENCE = "PENDING_EVIDENCE",
  PENDING_REVIEW = "PENDING_REVIEW",
  PROCESSING = "PROCESSING",
  /** Same as processing. Will be deprecated. */
  PROCESSING_EVIDENCES = "PROCESSING_EVIDENCES",
  /** Application rejected */
  REJECTED = "REJECTED",
  /** Application submitted by user */
  SUBMITTED = "SUBMITTED",
}

export interface OnboardingBlueprint extends Node {
  /** The ID of an object */
  id: Scalars["ID"];
  /** The specific implementation of the blueprint type */
  name: Scalars["String"];
  /** Determines which application handler will be used to process the application */
  type: OnboardingBlueprintType;
}

export enum OnboardingBlueprintType {
  /** Bank Connection applications */
  BANK_CONNECTION = "BANK_CONNECTION",
  /** Applications to change the user's cash role */
  CHANGE_ROLE = "CHANGE_ROLE",
  /** Cash upsell applications */
  DEPOSITS = "DEPOSITS",
  /** Disclosure applications */
  DISCLOSURE = "DISCLOSURE",
  /** KYC applications */
  KYC = "KYC",
  /** Application to collect/review account details for periodic review */
  PERIODIC_REVIEW = "PERIODIC_REVIEW",
  /** Net-new product applications */
  PRODUCT_V1 = "PRODUCT_V1",
  /** Decoupled cash or card financial application */
  PRODUCT_V2 = "PRODUCT_V2",
  /** Onboarding flows to determine a customer's risk tier */
  RISK_EVALUATION = "RISK_EVALUATION",
  /** Onboarding flows to set up a user's account */
  USER_SETUP = "USER_SETUP",
}

export interface OnboardingFormBlocking {
  _?: Maybe<Scalars["Boolean"]>;
}

export interface OnboardingFormBnplEcommerceSalesPlatformConnection {
  _?: Maybe<Scalars["Boolean"]>;
}

export interface OnboardingFormBnplFinancialsDocumentCollection {
  _?: Maybe<Scalars["Boolean"]>;
}

export interface OnboardingFormEmpty {
  _?: Maybe<Scalars["Boolean"]>;
}

export interface OnboardingFormJsonSchema {
  /** extra data that the information request may supply */
  extraData?: Maybe<Scalars["Json"]>;
  jsonSchema: Scalars["Json"];
  /** Metadata to supplement the form schema */
  metadata?: Maybe<Scalars["Json"]>;
  uiSchema?: Maybe<Scalars["Json"]>;
}

export interface OnboardingFormPeriodicReview {
  business?: Maybe<Scalars["Json"]>;
  individuals?: Maybe<Scalars["Json"]>;
}

/** Payload for Persona information request */
export interface OnboardingFormPersona {
  /** Name of individual for whom ID is requested */
  individual?: Maybe<Scalars["String"]>;
  /** Indicates if individual is the applicant */
  isApplicant?: Maybe<Scalars["Boolean"]>;
  /** Risk level associated with the account */
  riskLevel?: Maybe<Scalars["String"]>;
  /** List of user roles to identify BO/CO etc. */
  roles?: Maybe<Array<Maybe<Scalars["String"]>>>;
  /** Template ID */
  templateId?: Maybe<Scalars["String"]>;
}

export interface OnboardingFormTerms {
  _?: Maybe<Scalars["Boolean"]>;
}

export interface OnboardingFormUwBankConnection {
  _?: Maybe<Scalars["Boolean"]>;
}

export interface OnboardingFormUwEcommerceConnection {
  _?: Maybe<Scalars["Boolean"]>;
}

/** This field represents the form data for the source of funds */
export interface OnboardingFormUwQuarterlyBalanceSheets {
  /**
   * A filler field.
   * Note: GraphQL cannot currently represent empty objects: https://github.com/graphql/graphql-js/issues/937
   * A filler field is needed.
   */
  _?: Maybe<Scalars["Boolean"]>;
}

/** This field represents the form data for the source of funds */
export interface OnboardingFormUwQuarterlyIncomeStatements {
  /**
   * A filler field.
   * Note: GraphQL cannot currently represent empty objects: https://github.com/graphql/graphql-js/issues/937
   * A filler field is needed.
   */
  _?: Maybe<Scalars["Boolean"]>;
}

/** This field represents the form data for the source of funds */
export interface OnboardingFormUwQuarterlyStatementsOfCashFlow {
  /**
   * A filler field.
   * Note: GraphQL cannot currently represent empty objects: https://github.com/graphql/graphql-js/issues/937
   * A filler field is needed.
   */
  _?: Maybe<Scalars["Boolean"]>;
}

/** This field represents the form data for the source of funds */
export interface OnboardingFormUwSourceOfFunds {
  /**
   * A filler field.
   * Note: GraphQL cannot currently represent empty objects: https://github.com/graphql/graphql-js/issues/937
   * A filler field is needed.
   */
  _?: Maybe<Scalars["Boolean"]>;
}

export interface OnboardingInformationRequest extends Node {
  application: OnboardingApplication;
  beforePages: Array<OnboardingNonSubmittablePage>;
  canResubmit: Scalars["Boolean"];
  /** @deprecated Use contentPage.content instead */
  content: OnboardingInformationRequestContent;
  contentPage: OnboardingSubmittablePage;
  data?: Maybe<Scalars["Json"]>;
  /**
   * This field is a machine-readble identifier of the information request.
   * It's used by the frontend to match the footer to show to the customer.
   * It was added quickly as a stop-gap solution, so please use it carefully.
   */
  description: OnboardingInformationRequestDescription;
  /** The ID of an object */
  id: Scalars["ID"];
  status: OnboardingInformationRequestStatus;
  /** The reason for the status of the information request */
  statusReason?: Maybe<Scalars["String"]>;
  type: OnboardingInformationRequestType;
}

export interface OnboardingInformationRequestConnection {
  edges?: Maybe<Array<Maybe<OnboardingInformationRequestEdge>>>;
  pageInfo: PageInfo;
}

export type OnboardingInformationRequestContent =
  | OnboardingFormBlocking
  | OnboardingFormBnplEcommerceSalesPlatformConnection
  | OnboardingFormBnplFinancialsDocumentCollection
  | OnboardingFormEmpty
  | OnboardingFormJsonSchema
  | OnboardingFormPeriodicReview
  | OnboardingFormPersona
  | OnboardingFormTerms
  | OnboardingFormUwBankConnection
  | OnboardingFormUwEcommerceConnection
  | OnboardingFormUwQuarterlyBalanceSheets
  | OnboardingFormUwQuarterlyIncomeStatements
  | OnboardingFormUwQuarterlyStatementsOfCashFlow
  | OnboardingFormUwSourceOfFunds;

export enum OnboardingInformationRequestDescription {
  AUTOPAY_SETUP = "AUTOPAY_SETUP",
  BNPL_ECOMMERCE_SALES_PLATFORM_CONNECTION = "BNPL_ECOMMERCE_SALES_PLATFORM_CONNECTION",
  BNPL_FINANCIALS_DOCUMENT_COLLECTION = "BNPL_FINANCIALS_DOCUMENT_COLLECTION",
  BUSINESS_ADDRESS = "BUSINESS_ADDRESS",
  BUSINESS_ATTRIBUTES_CONFIRMATION = "BUSINESS_ATTRIBUTES_CONFIRMATION",
  BUSINESS_DETAILS = "BUSINESS_DETAILS",
  BUSINESS_DETAILS_V2 = "BUSINESS_DETAILS_V2",
  BUSINESS_LEADERSHIP = "BUSINESS_LEADERSHIP",
  BUSINESS_LEADERSHIP_V2 = "BUSINESS_LEADERSHIP_V2",
  BUSINESS_LEADERSHIP_V3 = "BUSINESS_LEADERSHIP_V3",
  BUSINESS_OWNERSHIP = "BUSINESS_OWNERSHIP",
  CERTIFICATE_OF_GOOD_STANDING_UPLOAD = "CERTIFICATE_OF_GOOD_STANDING_UPLOAD",
  CORPORATE_AUTHORIZATION_DOCUMENT_UPLOAD = "CORPORATE_AUTHORIZATION_DOCUMENT_UPLOAD",
  EDD_ATTESTATION_CASH_INTENSIVE = "EDD_ATTESTATION_CASH_INTENSIVE",
  EDD_ATTESTATION_CRYPTO = "EDD_ATTESTATION_CRYPTO",
  EDD_ATTESTATION_FI_NBFI = "EDD_ATTESTATION_FI_NBFI",
  EIN_OCR = "EIN_OCR",
  EIN_OCR_VERIFICATION = "EIN_OCR_VERIFICATION",
  EMAIL_VERIFICATION = "EMAIL_VERIFICATION",
  ENTITY_ADDRESS = "ENTITY_ADDRESS",
  ENTITY_ATTESTATION_CASH_INTENSIVE = "ENTITY_ATTESTATION_CASH_INTENSIVE",
  ENTITY_CORPORATE_STRUCTURE = "ENTITY_CORPORATE_STRUCTURE",
  ENTITY_CUSTOMERS = "ENTITY_CUSTOMERS",
  ENTITY_DETAILS = "ENTITY_DETAILS",
  ENTITY_EDD_ATTESTATION_CRYPTO = "ENTITY_EDD_ATTESTATION_CRYPTO",
  ENTITY_EDD_ATTESTATION_FI_NBFI = "ENTITY_EDD_ATTESTATION_FI_NBFI",
  ENTITY_INCORPORATION_DETAILS = "ENTITY_INCORPORATION_DETAILS",
  ENTITY_OWNERSHIP = "ENTITY_OWNERSHIP",
  ENTITY_PRODUCT_USAGE_PROFILE = "ENTITY_PRODUCT_USAGE_PROFILE",
  ENTITY_SOURCE_OF_FUNDS = "ENTITY_SOURCE_OF_FUNDS",
  ENTITY_VENDORS = "ENTITY_VENDORS",
  FORM_990_DOCUMENT_UPLOAD = "FORM_990_DOCUMENT_UPLOAD",
  FUNDING_SOURCE_SELECTION = "FUNDING_SOURCE_SELECTION",
  INDIVIDUAL_ACCOUNT_ADMIN = "INDIVIDUAL_ACCOUNT_ADMIN",
  INDIVIDUAL_ADDITIONAL_DETAILS = "INDIVIDUAL_ADDITIONAL_DETAILS",
  INDIVIDUAL_ADDRESS = "INDIVIDUAL_ADDRESS",
  INDIVIDUAL_AP_CLERK = "INDIVIDUAL_AP_CLERK",
  INDIVIDUAL_CONTACT_DETAILS = "INDIVIDUAL_CONTACT_DETAILS",
  ISSUE_CARD = "ISSUE_CARD",
  LEADERSHIP_DOCUMENTS_DATA_REQUEST = "LEADERSHIP_DOCUMENTS_DATA_REQUEST",
  MAIN_ENTITY_CUSTOMERS = "MAIN_ENTITY_CUSTOMERS",
  MAIN_ENTITY_DETAILS = "MAIN_ENTITY_DETAILS",
  MFA = "MFA",
  MFA_NEW = "MFA_NEW",
  OTHER = "OTHER",
  PERIODIC_REVIEW = "PERIODIC_REVIEW",
  PERSONA_ID_VERIFICATION = "PERSONA_ID_VERIFICATION",
  PHOTO_ID_UPLOAD = "PHOTO_ID_UPLOAD",
  PHOTO_ID_VERIFICATION_CONFIRMATION = "PHOTO_ID_VERIFICATION_CONFIRMATION",
  PI_SOURCE_OF_FUNDS = "PI_SOURCE_OF_FUNDS",
  PRODUCT_SUITABILITY = "PRODUCT_SUITABILITY",
  PRODUCT_USAGE_PROFILE = "PRODUCT_USAGE_PROFILE",
  PROOF_OF_EIN_DOCUMENT_UPLOAD = "PROOF_OF_EIN_DOCUMENT_UPLOAD",
  PROOF_OF_SSN_UPLOAD = "PROOF_OF_SSN_UPLOAD",
  PUBLIC_COMPANY_DETAILS = "PUBLIC_COMPANY_DETAILS",
  TERMS = "TERMS",
  UNDERWRITING_CARD_BANK_CONNECTION = "UNDERWRITING_CARD_BANK_CONNECTION",
  UNDERWRITING_CARD_ECOMMERCE_CONNECTION = "UNDERWRITING_CARD_ECOMMERCE_CONNECTION",
  UNDERWRITING_CARD_LINK_ACCOUNTS = "UNDERWRITING_CARD_LINK_ACCOUNTS",
  UNDERWRITING_CASH_BANK_CONNECTION = "UNDERWRITING_CASH_BANK_CONNECTION",
  UNDERWRITING_CONSOLIDATED_FINANCIALS = "UNDERWRITING_CONSOLIDATED_FINANCIALS",
  UNDERWRITING_EXPECTED_SPEND = "UNDERWRITING_EXPECTED_SPEND",
  UNDERWRITING_QUARTERLY_BALANCE_SHEETS = "UNDERWRITING_QUARTERLY_BALANCE_SHEETS",
  UNDERWRITING_QUARTERLY_INCOME_STATEMENTS = "UNDERWRITING_QUARTERLY_INCOME_STATEMENTS",
  UNDERWRITING_QUARTERLY_STATEMENTS_OF_CASH_FLOW = "UNDERWRITING_QUARTERLY_STATEMENTS_OF_CASH_FLOW",
  UNDERWRITING_SALES_VOLUME = "UNDERWRITING_SALES_VOLUME",
  UNDERWRITING_SOURCE_OF_FUNDS = "UNDERWRITING_SOURCE_OF_FUNDS",
  UNDERWRITING_SUPPORTING_DETAILS = "UNDERWRITING_SUPPORTING_DETAILS",
  W9_ATTESTATION = "W9_ATTESTATION",
}

export interface OnboardingInformationRequestEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<OnboardingInformationRequest>;
}

export enum OnboardingInformationRequestStatus {
  COMPLETE = "COMPLETE",
  IN_PROGRESS = "IN_PROGRESS",
  NEW = "NEW",
  NOT_APPLICABLE = "NOT_APPLICABLE",
}

export enum OnboardingInformationRequestType {
  EXTRA = "EXTRA",
  INITIAL = "INITIAL",
}

export type OnboardingNonSubmittablePage = OnboardingPagePhotoIdIntro;

export interface OnboardingPageBnplEcommerceSalesPlatformConnection {
  _?: Maybe<Scalars["Boolean"]>;
  content: OnboardingFormBnplEcommerceSalesPlatformConnection;
}

export interface OnboardingPageBnplFinancialsDocumentCollection {
  _?: Maybe<Scalars["Boolean"]>;
  content: OnboardingFormBnplFinancialsDocumentCollection;
}

export interface OnboardingPageDSuitability {
  _?: Maybe<Scalars["Boolean"]>;
  content: OnboardingFormEmpty;
}

export interface OnboardingPageDTerms {
  _?: Maybe<Scalars["Boolean"]>;
  content: OnboardingFormEmpty;
}

export interface OnboardingPageEmailVerification {
  _?: Maybe<Scalars["Boolean"]>;
  content: OnboardingFormBlocking;
}

export interface OnboardingPageForm {
  _?: Maybe<Scalars["Boolean"]>;
  content: OnboardingFormJsonSchema;
}

export interface OnboardingPageFundingSource {
  _?: Maybe<Scalars["Boolean"]>;
  content: OnboardingFormEmpty;
}

export interface OnboardingPageMfa {
  _?: Maybe<Scalars["Boolean"]>;
  content: OnboardingFormEmpty;
}

export interface OnboardingPagePeriodicReview {
  _?: Maybe<Scalars["Boolean"]>;
  content: OnboardingPagePeriodicReview;
}

export interface OnboardingPagePersona {
  _?: Maybe<Scalars["Boolean"]>;
  content: OnboardingFormPersona;
}

export interface OnboardingPagePhotoIdIntro {
  _?: Maybe<Scalars["Boolean"]>;
  content: OnboardingFormJsonSchema;
}

export interface OnboardingPageTerms {
  card?: Maybe<Scalars["Boolean"]>;
  cash?: Maybe<Scalars["Boolean"]>;
  content: OnboardingFormTerms;
}

export interface OnboardingPageUwBankConnection {
  amountNeededConnectedBank?: Maybe<Scalars["Int"]>;
  amountNeededStatements?: Maybe<Scalars["Int"]>;
  canSkipStatements: Scalars["Boolean"];
  content: OnboardingFormUwBankConnection;
  financialProductType?: Maybe<FinancialProductType>;
  requestReason?: Maybe<OnboardingUnderwritingBankConnectionRequestReason>;
  shouldPromptStatements: Scalars["Boolean"];
}

export interface OnboardingPageUwEcommerceConnection {
  _?: Maybe<Scalars["Boolean"]>;
  content: OnboardingFormUwEcommerceConnection;
}

/** This field represents the data associated with the source of funds upload page */
export interface OnboardingPageUwQuarterlyBalanceSheets {
  /** assets uploaded */
  assets?: Maybe<Array<Maybe<UnderwritingAssets>>>;
  /** content is the payload for the form in order to upload the source of funds */
  content: OnboardingFormUwQuarterlyBalanceSheets;
}

/** This field represents the data associated with the source of funds upload page */
export interface OnboardingPageUwQuarterlyIncomeStatements {
  /** assets uploaded */
  assets?: Maybe<Array<Maybe<UnderwritingAssets>>>;
  /** content is the payload for the form in order to upload the source of funds */
  content: OnboardingFormUwQuarterlyIncomeStatements;
}

/** This field represents the data associated with the source of funds upload page */
export interface OnboardingPageUwQuarterlyStatementsOfCashFlow {
  /** assets uploaded */
  assets?: Maybe<Array<Maybe<UnderwritingAssets>>>;
  /** content is the payload for the form in order to upload the source of funds */
  content: OnboardingFormUwQuarterlyStatementsOfCashFlow;
}

/** This field represents the data associated with the source of funds upload page */
export interface OnboardingPageUwSourceOfFunds {
  /** content is the payload for the form in order to upload the source of funds */
  content: OnboardingFormUwSourceOfFunds;
}

export type OnboardingSubmittablePage =
  | OnboardingPageBnplEcommerceSalesPlatformConnection
  | OnboardingPageBnplFinancialsDocumentCollection
  | OnboardingPageDSuitability
  | OnboardingPageDTerms
  | OnboardingPageEmailVerification
  | OnboardingPageForm
  | OnboardingPageFundingSource
  | OnboardingPageMfa
  | OnboardingPagePeriodicReview
  | OnboardingPagePersona
  | OnboardingPageTerms
  | OnboardingPageUwBankConnection
  | OnboardingPageUwEcommerceConnection
  | OnboardingPageUwQuarterlyBalanceSheets
  | OnboardingPageUwQuarterlyIncomeStatements
  | OnboardingPageUwQuarterlyStatementsOfCashFlow
  | OnboardingPageUwSourceOfFunds;

export enum OnboardingUnderwritingBankConnectionRequestReason {
  BANK_CONNECTION_ISSUE = "BANK_CONNECTION_ISSUE",
  BANK_STATEMENT_ISSUE = "BANK_STATEMENT_ISSUE",
  INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
}

export interface Operation {
  action: AuthAction;
  actionName: Scalars["String"];
  key: Scalars["String"];
  resourceType: AuthResourceType;
}

export interface OptionFieldInstance extends ExtendedFieldInstance, Node {
  dependencyOfAll?: Maybe<Array<ExtendedFieldInstance>>;
  dependsOnAll?: Maybe<Array<ExtendedFieldInstance>>;
  editStatus?: Maybe<FieldEditStatus>;
  extension?: Maybe<ExtendedFieldInstanceExtension>;
  field: ExtendedField;
  /** The ID of an object */
  id: Scalars["ID"];
  /** The selected option. Null means unset. */
  optionValue?: Maybe<ExtendedFieldOption>;
  /**
   * Whether or not the option (if there is a selected option) is visible in the given context.
   * If the context is not passed in, it will attempt to automatically derive it for the particular field instance.
   */
  selectedOptionVisibilityStatus?: Maybe<ExtendedFieldOptionVisibilityStatus>;
  /**
   * DEPRECATED: List of suggestions for the extended field options. It can contain three or fewer suggestions
   * @deprecated Use suggestions instead
   */
  suggestedOptions?: Maybe<Array<ExtendedFieldOptionSuggestionInformation>>;
  /** List of suggestions for the extended field options, optionally filtered by status. It can contain three or fewer suggestions */
  suggestions?: Maybe<Array<AutomationSuggestion>>;
  updatedBy?: Maybe<ValueOriginator>;
  /**
   * The possible options for this field instance which takes visibility logic into account.
   * If the context is not passed in, it will attempt to automatically derive it for the particular field instance.
   *
   * Optionally specify a filter to limit the options returned.
   */
  visibleOptions?: Maybe<ExtendedFieldOptionConnection>;
  workflowValues?: Maybe<Array<WorkflowOptionValue>>;
}

export interface OptionFieldInstancedependencyOfAllArgs {
  filter?: InputMaybe<ExtendedFieldDependencyFilter>;
}

export interface OptionFieldInstancedependsOnAllArgs {
  filter?: InputMaybe<ExtendedFieldDependencyFilter>;
}

export interface OptionFieldInstanceselectedOptionVisibilityStatusArgs {
  context?: InputMaybe<VisibilityRuleData>;
}

export interface OptionFieldInstancesuggestionsArgs {
  where?: InputMaybe<AutomationSuggestionsOptionFieldInstanceWhereInput>;
}

export interface OptionFieldInstancevisibleOptionsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  context?: InputMaybe<VisibilityRuleData>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  orderBy?: InputMaybe<ExtendedFieldOptionSortInput>;
  where?: InputMaybe<VisibleOptionsFilterInput>;
}

export interface OptionFieldInstanceInput {
  /** The client mutation id */
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fieldInstanceId: Scalars["ID"];
  /**
   * Sets the chosen option for the field instance from the ID of the ExtendedFieldOption.
   * Explicitly set this to null to clear the value
   */
  optionId?: InputMaybe<Scalars["ID"]>;
}

export interface OptionPartialVisibility {
  /** Preview of extended field options in this rule limited to 100 options, for the full list use extendedFieldOptions passing rule id as filter */
  extendedFieldOptionsPreview?: Maybe<Array<ExtendedFieldOption>>;
  /** If there are more than 100 options in this rule */
  hasMore?: Maybe<Scalars["Boolean"]>;
}

export interface OptionPartialVisibilityInput {
  /** Required if the visibility rule is being created with the extended field */
  displayNames?: InputMaybe<Array<Scalars["String"]>>;
  /**
   * Required if the visibility rule is created after the extended field and its options are created.
   * This takes higher priority if both extended_field_option_ids and display_names are provided.
   */
  extendedFieldOptionIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** List of extended field options in this rule */
  extendedFieldOptions?: InputMaybe<
    Array<VisibilityRuleExtendedFieldOptionInput>
  >;
}

export interface OptionVisibilityRuleConditionalResult {
  /** Required if visibility_setting is RULE_FILTER. */
  partialVisibility?: Maybe<OptionPartialVisibility>;
  /** The visibility setting to apply to the extended field option. */
  visibilitySetting: ExtendedFieldOptionVisibilitySetting;
}

export interface OptionVisibilityRuleConditionalResultInput {
  /** Required if visibility_setting is RULE_FILTER. */
  partialVisibility?: InputMaybe<OptionPartialVisibilityInput>;
  /** The visibility setting to apply to the extended field option. */
  visibilitySetting: ExtendedFieldOptionVisibilitySetting;
}

/** Filter options by Visibility Rule ID and Apply Condition. */
export interface OptionVisibilityRuleFilterInput {
  /** The Apply Condition to filter by. */
  applyCondition?: InputMaybe<ExtendedFieldVisibilityRuleApplyCondition>;
  /** The Visibility Rule ID to filter by. */
  visibilityRuleId?: InputMaybe<Scalars["ID"]>;
}

export interface OracleFusionAuthPayloadInput {
  host?: InputMaybe<Scalars["String"]>;
  password?: InputMaybe<Scalars["String"]>;
  structureCode?: InputMaybe<Scalars["String"]>;
  username?: InputMaybe<Scalars["String"]>;
}

/** user categories in Oracle Fusion payload */
export interface OracleFusionCategories {
  /** accounts payable required segments */
  accountsPayableAdditionalRequiredSegments?: Maybe<
    Array<Maybe<RequiredSegment>>
  >;
  /** Accounts Payable */
  accountsPayableUserCategory?: Maybe<UserCategory>;
  /** awx wallet account required segments */
  awxWalletAdditionalRequiredSegments?: Maybe<Array<Maybe<RequiredSegment>>>;
  /** awx wallet user category */
  awxWalletUserCategory?: Maybe<UserCategory>;
  /** Cash/Bank Account for collections */
  collectionTargetUserCategory?: Maybe<UserCategory>;
  /** cash/bank account required segments */
  collectionsAdditionalRequiredSegments?: Maybe<Array<Maybe<RequiredSegment>>>;
  /** personal expense account required segments */
  personalExpenseAdditionalRequiredSegments?: Maybe<
    Array<Maybe<RequiredSegment>>
  >;
  /** personal expense user category */
  personalExpenseUserCategory?: Maybe<UserCategory>;
  /** reimbursement accrual basis accounting account required segments */
  reimbursementClearingAdditionalRequiredSegments?: Maybe<
    Array<Maybe<RequiredSegment>>
  >;
  /** reimbursement accrual basis accounting user category */
  reimbursementClearingUserCategory?: Maybe<UserCategory>;
  /** reimbursements account required segments */
  reimbursementsAdditionalRequiredSegments?: Maybe<
    Array<Maybe<RequiredSegment>>
  >;
  /** reimbursements user category */
  reimbursementsUserCategory?: Maybe<UserCategory>;
  /** rewards account required segments */
  rewardsAdditionalRequiredSegments?: Maybe<Array<Maybe<RequiredSegment>>>;
  /** Rewards */
  rewardsIncomeUserCategory?: Maybe<UserCategory>;
  /** vendor name - always 'oracle_fusion' */
  vendorName?: Maybe<Scalars["String"]>;
}

/** Oracle Fusion Integration Field Metadata to provide additional information about the field */
export interface OracleFusionIntegrationExtendedFieldExtension {
  id: Scalars["ID"];
  /** If the field is required or not in Oracle */
  isRequired?: Maybe<Scalars["Boolean"]>;
  /**
   * "
   * The fields unique code in Oracle for the chart of the account
   */
  segmentCode?: Maybe<Scalars["String"]>;
  /** Order of the field when creating a JE in Oracle */
  sequence?: Maybe<Scalars["Int"]>;
}

export interface OracleFusionPayload {
  host?: Maybe<Scalars["String"]>;
  password?: Maybe<Scalars["String"]>;
  structureCode?: Maybe<Scalars["String"]>;
  username?: Maybe<Scalars["String"]>;
}

export enum OrderBy {
  ASC = "ASC",
  DESC = "DESC",
  INVALID = "INVALID",
}

export enum OrderByDirection {
  ASCENDING = "ASCENDING",
  DESCENDING = "DESCENDING",
}

export interface OrderByInput {
  direction: OrderDirection;
  sort: Scalars["String"];
}

/**  ---[ Common Types ]----------------------- */
export enum OrderDirection {
  ASC = "ASC",
  DESC = "DESC",
}

export enum OrderType {
  ASC = "ASC",
  DESC = "DESC",
}

export interface OrganizationMutationEvent {
  changeSet?: Maybe<Array<OrganizationMutationEventChangeSet>>;
  createdAt: Scalars["Time"];
  id: Scalars["ID"];
  mutationTarget?: Maybe<OrganizationMutationTarget>;
  mutationType: OrganizationMutationType;
  mutator: OrganizationMutationEventMutator;
}

export interface OrganizationMutationEventChangeSet {
  after?: Maybe<Scalars["String"]>;
  attribute: Scalars["String"];
  before?: Maybe<Scalars["String"]>;
}

export interface OrganizationMutationEventConnection extends Connection {
  edges: Array<OrganizationMutationEventEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface OrganizationMutationEventEdge {
  cursor?: Maybe<Scalars["String"]>;
  node: OrganizationMutationEvent;
}

export type OrganizationMutationEventMutator = HrisSyncEvent | User;

export interface OrganizationMutationEventsFilterInput {
  mutatorTargetId?: InputMaybe<Scalars["String"]>;
  mutators: Array<OrganizationMutationEventsMutatorFilterInput>;
}

/**  --------- OrganizationMutationEvents -------- */
export enum OrganizationMutationEventsFilterMutatorType {
  HRIS = "HRIS",
  USER = "USER",
}

export interface OrganizationMutationEventsMutatorFilterInput {
  hrisJobRunIds?: InputMaybe<Array<Scalars["String"]>>;
  mutatorType: OrganizationMutationEventsFilterMutatorType;
  userIds?: InputMaybe<Array<Scalars["String"]>>;
}

export type OrganizationMutationTarget = User;

export enum OrganizationMutationType {
  CREATE = "CREATE",
  DELETE = "DELETE",
  UPDATE = "UPDATE",
}

export enum OrganizationResourceAttribute {
  AUDIT = "AUDIT",
  HRIS = "HRIS",
  SSO = "SSO",
}

export interface OrganizationResourceOperation extends ResourceOperation {
  action: ResourceAction;
  attribute?: Maybe<OrganizationResourceAttribute>;
}

export enum Origin {
  BREX = "BREX",
  EXTERNAL = "EXTERNAL",
}

export type OriginMetadata =
  | DashboardMetadata
  | EmailMetadata
  | RecurringMetadata;

export enum OriginalMemoPosition {
  /** Original memo is placed at the beginning of the memo */
  BEGINNING = "BEGINNING",
  /** Original memo is placed at the end of the memo */
  END = "END",
}

/** Status of an operation outcome */
export enum OutcomeStatus {
  FAILURE = "FAILURE",
  SUCCESS = "SUCCESS",
}

export interface OutflowDetection {
  withdrawalAmount: FinancialAsset;
}

export interface OverChargedInput {
  amount: Scalars["Int"];
}

export interface OverrideExpenseReviewResult {
  /** A list of user errors for mutation responses. Clients should always request this field when performing mutations */
  errors?: Maybe<Array<ExpenseMutationError>>;
  /** The expense that was updated. */
  expense?: Maybe<Expense>;
}

export interface OwnershipRequestConfig {
  /** If we should collect the full SSN or just the last 4 digits */
  collectLast4SSN: Scalars["Boolean"];
}

export enum OwnershipVerificationStatus {
  APPROVED = "APPROVED",
  CANCELED = "CANCELED",
  EXEMPT = "EXEMPT",
  INVALID = "INVALID",
  NON_DEPOSITORY = "NON_DEPOSITORY",
  NOT_SUBMITTED = "NOT_SUBMITTED",
  PENDING_EVIDENCE = "PENDING_EVIDENCE",
  REJECTED = "REJECTED",
  VERIFYING = "VERIFYING",
}

export interface PHLFRDLocalPayloadInput {
  articlesOfIncorporation?: InputMaybe<Scalars["String"]>;
  certificateOfIncorporation?: InputMaybe<Scalars["String"]>;
  certificateOfRegistration?: InputMaybe<Scalars["String"]>;
  idsOfBeneficiaryOwners?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  mayorPermit?: InputMaybe<Scalars["String"]>;
  ownershipStructure?: InputMaybe<Scalars["String"]>;
}

export interface PageInfo {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars["String"]>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars["Boolean"];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars["Boolean"];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars["String"]>;
}

/**
 * Pagination parameters for enumerating items in a connection.
 * Only {first, after} OR {last, before} pairs can be set.
 * e.g. If {first, before} is set, that will cause a validation error.
 * The cursors are optional. Without a specified cursor, it is assumed to start at
 * the first item (for `first`) or last item (for `last`) of the collection.
 */
export interface PaginationInput {
  /** The cursor to start the page at (exclusive). */
  after?: InputMaybe<Scalars["String"]>;
  /** The cursor to end the page at (exclusive). */
  before?: InputMaybe<Scalars["String"]>;
  /** The number of items to return in a page after the `after` cursor. */
  first?: InputMaybe<Scalars["Int"]>;
  /** The number of items to return in a page prior to the `before` cursor. */
  last?: InputMaybe<Scalars["Int"]>;
}

export interface Parameter {
  key: Scalars["String"];
  value?: Maybe<Scalars["String"]>;
}

export interface ParameterInput {
  key: Scalars["String"];
  value?: InputMaybe<Scalars["String"]>;
}

/**
 * TODO when necessary
 * input FinancialAssetValueInput {
 *     value: FinancialAssetInput
 * }
 */
export enum ParityOperator {
  EQ = "EQ",
  NE = "NE",
}

export interface PartnerCode {
  /** The partner code */
  code: Scalars["String"];
  /** Redemption URL with code embedded */
  redemptionUrl: Scalars["String"];
  /** The type of partner code */
  type: PartnerCodeType;
}

export enum PartnerCodeType {
  DASH_PASS = "DASH_PASS",
}

export enum PartnerIntegrationMethod {
  API = "API",
  CONFERMA = "CONFERMA",
  EMBEDDED_API = "EMBEDDED_API",
  ICCP = "ICCP",
  NETSUITE = "NETSUITE",
}

export enum PartnerIntegrationStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  INVALID = "INVALID",
  PENDING = "PENDING",
}

export enum PartnerIntegrationType {
  CREATE_BREX_EXPENSES = "CREATE_BREX_EXPENSES",
  CREATE_BREX_USERS = "CREATE_BREX_USERS",
  EXPENSE = "EXPENSE",
  INVALID = "INVALID",
  MANAGE_CARDS = "MANAGE_CARDS",
  MANAGE_EMBEDDED_USERS = "MANAGE_EMBEDDED_USERS",
  P_CARD = "P_CARD",
  READ_ALL_CARDS = "READ_ALL_CARDS",
  TRAVEL = "TRAVEL",
}

export interface PartnerMetadata {
  integrationShortName: Scalars["String"];
}

export interface PartnershipIntegration {
  id: Scalars["ID"];
  integrationTypes: Array<PartnerIntegrationType>;
  name?: Maybe<Scalars["String"]>;
  partner: IntegrationPartner;
  status?: Maybe<PartnerIntegrationStatus>;
}

export interface PartnershipIntegrationConnection extends Connection {
  edges: Array<PartnershipIntegrationEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface PartnershipIntegrationEdge {
  cursor?: Maybe<Scalars["String"]>;
  node: PartnershipIntegration;
}

export interface PartnershipIntegrationFilterInput {
  /** Match IN specific StatPartnerIntegrationStatus (null and empty list filters are ignored) */
  statuses?: InputMaybe<Array<PartnerIntegrationStatus>>;
}

export interface PaybackDetails {
  _?: Maybe<Scalars["Boolean"]>;
}

export interface Payee {
  contactId: Scalars["ID"];
  contactVersion: Scalars["Int"];
  paymentInstrumentId: Scalars["ID"];
  paymentInstrumentVersion: Scalars["Int"];
}

export enum PayeeType {
  USER = "USER",
  VENDOR = "VENDOR",
}

/** Not an extended type from TILL DGS. In the future if TILL exposes this we can change this to be an extended entity */
export interface Payment {
  id: Scalars["ID"];
}

/** Represents a start and time for a period for a given payment */
export interface PaymentBillingPeriod {
  /** When the period ends */
  endTime?: Maybe<Scalars["Time"]>;
  /** When the period starts */
  startTime?: Maybe<Scalars["Time"]>;
}

export interface PaymentContact extends Node {
  billPayDefaultBudgetId?: Maybe<Scalars["ID"]>;
  email?: Maybe<Scalars["String"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
  paymentInstruments?: Maybe<Array<PaymentInstrument>>;
  phoneNumber?: Maybe<Scalars["String"]>;
  railAccountDetails?: Maybe<Array<RailAccountDetails>>;
  version: Scalars["Int"];
}

export interface PaymentContactConnection {
  edges?: Maybe<Array<Maybe<PaymentContactEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"];
}

export interface PaymentContactEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<PaymentContact>;
}

export interface PaymentDetails {
  /** For a returned wire, this is the difference between the original wire amount vs what was actually returned back due to the beneficiary bank taking a fee. */
  amountDriftUsdCents?: Maybe<Scalars["Int"]>;
  /** The sending bank's reference number for this wire (F20 of the MT103) */
  bankReferenceNumber?: Maybe<Scalars["String"]>;
  counterparty: Counterparty;
  endToEndId?: Maybe<Scalars["String"]>;
  estimatedOn?: Maybe<Scalars["Time"]>;
  estimatedOnLatest?: Maybe<Scalars["Time"]>;
  fedReferenceNumber?: Maybe<Scalars["String"]>;
  imad?: Maybe<Scalars["String"]>;
  initiatorCustomerUser?: Maybe<User>;
  method: Method;
  mt103?: Maybe<Scalars["String"]>;
  omad?: Maybe<Scalars["String"]>;
  origin: Origin;
  /**
   * For a returned wire, this is the amount of the original wire.
   * This amount can be different from the return amount due to the beneficiary bank
   * taking a fee.
   */
  originalAmountUsdCents?: Maybe<Scalars["Int"]>;
  paymentRail?: Maybe<TxPaymentRail>;
  returnReason?: Maybe<ReturnReason>;
  transferDescription?: Maybe<Scalars["String"]>;
  type?: Maybe<TxType>;
}

export interface PaymentEarlyAuthBalanceDecreaseCommitment extends Node {
  expiresAt: Scalars["Time"];
  fundingSourceCommitments: Array<PaymentFundingSourceBalanceDecreaseCommitment>;
  /** The ID of an object */
  id: Scalars["ID"];
}

export enum PaymentFailureType {
  ACCOUNT_CLOSED = "ACCOUNT_CLOSED",
  ACCOUNT_NOT_FOUND = "ACCOUNT_NOT_FOUND",
  GENERIC_FAILURE = "GENERIC_FAILURE",
  INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
  NON_TRANSACTION_ACCOUNT = "NON_TRANSACTION_ACCOUNT",
  NOT_AUTHORIZED = "NOT_AUTHORIZED",
}

export interface PaymentFundingSourceBalanceDecreaseCommitment {
  collectFundingSourceId: Scalars["ID"];
  fundingSource: FundingSource;
  maxBalanceDecreaseAmount: FinancialAsset;
}

export interface PaymentFxQuote extends Node {
  beneficiaryAmount: FinancialAsset;
  exchangeRate?: Maybe<Scalars["Decimal"]>;
  /** Timestamp of when the quote was cancelled. If null, the quote is not cancelled. Only applicable for Column quotes. */
  expiresAt?: Maybe<Scalars["Time"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  insertedAt: Scalars["Time"];
  originatorAmount: FinancialAsset;
  quoteGuarantee: PaymentFxQuoteGuarantee;
  railType: PaymentFxQuoteRailType;
}

export enum PaymentFxQuoteGuarantee {
  BENEFICIARY = "BENEFICIARY",
  ORIGINATOR = "ORIGINATOR",
}

export enum PaymentFxQuoteRailType {
  INTERNATIONAL_WIRE = "INTERNATIONAL_WIRE",
}

export interface PaymentInstrument extends Node {
  /** Payment instrument's beneficiary business name, set when beneficiary type is business */
  beneficiaryBusinessName?: Maybe<Scalars["String"]>;
  /** Payment instrument's beneficiary first name, set when beneficiary type is individual */
  beneficiaryFirstName?: Maybe<Scalars["String"]>;
  /** Payment instrument's beneficiary last name, set when beneficiary type is individual */
  beneficiaryLastName?: Maybe<Scalars["String"]>;
  /** Payment instrument's beneficiary name */
  beneficiaryName?: Maybe<Scalars["String"]>;
  /** Payment instrument's beneficiary type */
  beneficiaryType?: Maybe<PaymentInstrumentBeneficiaryType>;
  /** List of drawdown authoriztions */
  drawdownAuthorizations?: Maybe<Array<Maybe<DrawdownAuthorization>>>;
  /** The ID of an object */
  id: Scalars["ID"];
  /** Insertion timestamp */
  insertedAt: Scalars["Time"];
  paymentInstrumentType: PaymentInstrumentType;
  /** Nullable Financials PersonalAccount associated to this payment instrument */
  personalAccount?: Maybe<FinancialsAccountV2>;
  version: Scalars["Int"];
}

export interface PaymentInstrumentAssociationId {
  paymentInstrumentAssociationId?: Maybe<Scalars["String"]>;
}

export enum PaymentInstrumentBeneficiaryType {
  BUSINESS = "BUSINESS",
  INDIVIDUAL = "INDIVIDUAL",
  INVALID = "INVALID",
}

/**
 * Payment Instrument derived out of bank info extracted by OCR. It may be matched with an existing payment instrument
 * or created in case there is not match.
 */
export interface PaymentInstrumentField {
  /** Indicates if an OCR derived field was matched, created or calculated. */
  resolution?: Maybe<DerivedFieldResolution>;
  /** Stored payment instrument field value. */
  value?: Maybe<PaymentInstrument>;
}

/** Only beneficiary info and one payment instrument should be set per call. The other four should be null. */
export interface PaymentInstrumentInput {
  /**  one-of */
  achPaymentInstrumentInput?: InputMaybe<AchPaymentInstrumentInput>;
  beneficiaryBusinessName?: InputMaybe<Scalars["String"]>;
  beneficiaryFirstName?: InputMaybe<Scalars["String"]>;
  beneficiaryLastName?: InputMaybe<Scalars["String"]>;
  beneficiaryType?: InputMaybe<BeneficiaryType>;
  checkPaymentInstrumentInput?: InputMaybe<CheckPaymentInstrumentInput>;
  domesticWirePaymentInstrumentInput?: InputMaybe<DomesticWirePaymentInstrumentInput>;
  internationalWirePaymentInstrumentForBankingCounterpartyInput?: InputMaybe<BankingCounterpartyInput>;
  internationalWirePaymentInstrumentInput?: InputMaybe<InternationalWirePaymentInstrumentInput>;
}

export interface PaymentInstrumentLogicalIdInput {
  paymentInstrumentLogicalId: Scalars["String"];
}

export type PaymentInstrumentType =
  | AchPaymentInstrument
  | BankingCounterpartyPaymentInstrument
  | ChequePaymentInstrument
  | CounterpartyPaymentInstrument
  | DomesticWirePaymentInstrument
  | InternationalWirePaymentInstrument;

/** Represents a payment */
export interface PaymentIntent {
  isCollectedFromParentEntity: Scalars["Boolean"];
  originatorType: PaymentIntentOriginator;
  status: PaymentIntentStatus;
  totalRequestedAmount: FinancialAsset;
}

/** Originator Type of the payment */
export enum PaymentIntentOriginator {
  AUTOMATED_BILLING = "AUTOMATED_BILLING",
  CUSTOMER = "CUSTOMER",
  INVALID = "INVALID",
}

/** Status of the payment */
export enum PaymentIntentStatus {
  CANCELED = "CANCELED",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  INVALID = "INVALID",
  IN_PROGRESS = "IN_PROGRESS",
  PENDING = "PENDING",
}

/**
 * Answer(s) to "Do you plan to use a third party payment processor like stripe, Venmo, Wise, etc.?"
 * "Yes, and I plan to use it for:"
 */
export enum PaymentProcessorUsageType {
  FX_TRANSACTIONS_IN = "FX_TRANSACTIONS_IN",
  FX_TRANSACTIONS_OUT = "FX_TRANSACTIONS_OUT",
  OTHER = "OTHER",
  PAYROLL = "PAYROLL",
  REIMBURSEMENTS = "REIMBURSEMENTS",
  REVENUE_GENERATION_COLLECTION = "REVENUE_GENERATION_COLLECTION",
}

export enum PaymentProductType {
  CARD_COLLECTION = "CARD_COLLECTION",
  INVALID = "INVALID",
  SAAS_BILLING = "SAAS_BILLING",
  TRANSMISSION_BILLING = "TRANSMISSION_BILLING",
  TRANSMISSION_MOVEMENT = "TRANSMISSION_MOVEMENT",
}

export enum PaymentRail {
  ACH = "ACH",
  CHEQUE = "CHEQUE",
  WIRE = "WIRE",
}

/**
 * Returns timeline estimates, keyed by the different payment_rails.
 * Supported payment rails include: `ach`, `internationalWire`, `domesticWire`, `cheque`
 * If an estimate for a given payment rail is not supported, the value is null.
 */
export interface PaymentRailTimeline {
  /**
   * The transaction timeline for ACH
   * null if origin = `EXTERNAL`
   */
  ach?: Maybe<CashTransactionTimeline>;
  /**
   * The transaction timeline for cheque
   * null if payment_method = `DEBIT`
   */
  cheque?: Maybe<CashTransactionTimeline>;
  /**
   * The transaction timeline for domestic wire
   * non-null only for origin = `BREX` and payment_method = `CREDIT`
   */
  domesticWire?: Maybe<CashTransactionTimeline>;
  /**
   * The transaction timeline for international wire
   * non-null only for origin = `BREX` and payment_method = `CREDIT`
   */
  internationalWire?: Maybe<CashTransactionTimeline>;
}

export type PaymentSource =
  | DepositsAccount
  | FundingSource
  | RailAccountDetails;

/** Input for specifying a payment source. @oneOf. */
export interface PaymentSourceInput {
  /** Details when using a collect funding source */
  collectFundingSource?: InputMaybe<CollectFundingSourceInput>;
  /** Details when using a deposits payment source */
  depositsPaymentSource?: InputMaybe<DepositsPaymentSourceInput>;
  /** Details when using rail account details */
  railAccountDetailsSource?: InputMaybe<RailAccountDetailsSourceInput>;
}

export enum PaymentStatus {
  CANCELED = "CANCELED",
  FAILED = "FAILED",
  PROCESSING = "PROCESSING",
  REVERSED = "REVERSED",
  SCHEDULED = "SCHEDULED",
  SUCCESSFUL = "SUCCESSFUL",
}

export interface PaymentTransaction {
  canceledAt?: Maybe<Scalars["Time"]>;
  collectedAt?: Maybe<Scalars["Time"]>;
  failedAt?: Maybe<Scalars["Time"]>;
  failureType?: Maybe<PaymentFailureType>;
  /** @deprecated Use paymentSource instead. */
  fundingSource: FundingSource;
  initiatedAt?: Maybe<Scalars["Time"]>;
  initiatedBy: InitiatedBy;
  /**  Identifies when a payment is manually wired in by a customer and is manually acknowledged by servicing (rare) */
  isOfflinePayment: Scalars["Boolean"];
  /**  Whether this payment is collected from the funding source of the parent entity. This generally happens when the child entity fail to make their payment on time */
  isPaymentFromParentEntity: Scalars["Boolean"];
  paymentSource?: Maybe<PaymentSource>;
  scheduledFor: Scalars["Time"];
  status: BillingPaymentStatus;
  type: PaymentTransactionType;
}

export enum PaymentTransactionType {
  AUTO_PAYMENT = "AUTO_PAYMENT",
  ONE_TIME_PAYMENT = "ONE_TIME_PAYMENT",
  PAYMENT_REVERSAL = "PAYMENT_REVERSAL",
  PUSH_PAYMENT = "PUSH_PAYMENT",
}

export enum PaymentTypes {
  ACH = "ACH",
  CHEQUE = "CHEQUE",
  DOMESTIC_WIRE = "DOMESTIC_WIRE",
  INTERNATIONAL_WIRE = "INTERNATIONAL_WIRE",
}

export type PayrollInfo = GustoPayrollInfo;

/** Metadata for GUSTO integrations */
export interface PayrollIntegrationGustoInfo {
  /** Gusto redirect URL for signup and reconnect */
  accountClaimUrl?: Maybe<Scalars["String"]>;
}

export interface PayrollProvider {
  name?: Maybe<Scalars["String"]>;
  payrollInfo?: Maybe<PayrollInfo>;
  source?: Maybe<PayrollSource>;
  status?: Maybe<PayrollStatus>;
}

/** The account funding source for the payroll provider */
export interface PayrollProviderFundingSource {
  /**
   * The account id of the funding source
   * Note: If account_id is missing, we haven't keept track of which account is funding payroll
   */
  accountId?: Maybe<Scalars["ID"]>;
  /** The type of funding source */
  accountType: PayrollProviderFundingSourceAccountType;
}

/**
 * The funding source type for a payroll provider.
 * - deposits_account: Funded by a deposits account (Brex Cash)
 * - financial_account: Funded by an external financial account
 * - unknown: An unknown external source
 */
export enum PayrollProviderFundingSourceAccountType {
  DEPOSITS_ACCOUNT = "DEPOSITS_ACCOUNT",
  FINANCIAL_ACCOUNT = "FINANCIAL_ACCOUNT",
  UNKNOWN = "UNKNOWN",
}

/** Describes the type, status and active tasks for a single payroll provider integration */
export interface PayrollProviderIntegration extends Node {
  /** Info for GUSTO integrations */
  gustoInfo?: Maybe<PayrollIntegrationGustoInfo>;
  /** The ID of an object */
  id: Scalars["ID"];
  /** The status of the connection: processing, connected, disconnected, invalid */
  status: PayrollProviderIntegrationStatus;
  /** Type (method of connection) of integration: Gusto, or invalid */
  type: PayrollProviderIntegrationType;
  /** Timestamp when the integration was last updated */
  updatedAt: Scalars["Time"];
}

export enum PayrollProviderIntegrationStatus {
  CONNECTED = "CONNECTED",
  DISCONNECTED = "DISCONNECTED",
  INVALID = "INVALID",
  PROCESSING = "PROCESSING",
}

export enum PayrollProviderIntegrationType {
  GUSTO = "GUSTO",
  INVALID = "INVALID",
}

export enum PayrollProviderType {
  ADP = "ADP",
  BAMBOO_HR = "BAMBOO_HR",
  GUSTO = "GUSTO",
  INVALID = "INVALID",
  JUSTWORKS = "JUSTWORKS",
  PAYCHEX = "PAYCHEX",
  PAYLOCITY = "PAYLOCITY",
  QUICKBOOKS = "QUICKBOOKS",
  RIPPLING = "RIPPLING",
  TRINET = "TRINET",
  ZENEFITS = "ZENEFITS",
}

/**
 * Represents an updated model for payroll provider supported by the payroll v2 service migration. When the migration is complete, the original
 * payroll_provider object will be deprecated and removed
 */
export interface PayrollProviderV2 {
  /**
   * The account id of the funding source for payroll.
   * There are three options: a Brex deposits account, a confirmed external institution, or a detected financial account
   */
  fundingSource: PayrollProviderFundingSource;
  /** Represents a single integration with the payroll provider */
  integration?: Maybe<PayrollProviderIntegration>;
  /** Timestamp of last updated at record for detected or integrated provider */
  lastVerifiedAt?: Maybe<Scalars["Time"]>;
  /** A type-safe enum to represent a payroll provider */
  type: PayrollProviderType;
}

export enum PayrollSource {
  CASH = "CASH",
  FINANCIALS = "FINANCIALS",
  USER = "USER",
}

export enum PayrollStatus {
  AUTHENTICATED = "AUTHENTICATED",
  DATA = "DATA",
  INITIATED = "INITIATED",
}

/** Answer(s) to "What types of payroll transactions do you expect to make?" */
export enum PayrollTransactionType {
  DIRECT = "DIRECT",
  REIMBURSEMENT = "REIMBURSEMENT",
  SERVICE_PROVIDER = "SERVICE_PROVIDER",
}

/** The types of relationships for filtering who an expense is pending approval on. */
export enum PendingApprovalFilterInput {
  /** Pending approval on the logged in user */
  ME = "ME",
  /** Pending approval on anyone else but the logged in user */
  OTHER = "OTHER",
}

export interface PendingAutoReceiptExpenseActivity extends ExpenseActivity {
  id: Scalars["ID"];
}

export interface PendingEmailChange {
  /** If the change is expired. */
  expired: Scalars["Boolean"];
  /** The new email address to update to. */
  newEmail: Scalars["String"];
}

export interface PendingUpgradeDetail {
  /** What status the upgrade is in. */
  status: SuperAdminUpgradeStatus;
}

export enum PerDiemCategory {
  MEALS = "MEALS",
}

/** Per diem amount for a specific day */
export interface PerDiemDailyAmount {
  /** The per diem amount for this date */
  amount?: Maybe<FinancialAsset>;
  /** The date for this daily amount */
  date?: Maybe<Scalars["Time"]>;
  /** The date for this daily amount in UTC */
  dateUtc?: Maybe<Scalars["Time"]>;
}

/** Overall eligibility status for per diem */
export enum PerDiemEligibilityStatus {
  /** All segments are eligible for per diem */
  ELIGIBLE = "ELIGIBLE",
  /** No segments are eligible for per diem */
  INELIGIBLE = "INELIGIBLE",
  /** Some segments are eligible, others are not */
  PARTIALLY_ELIGIBLE = "PARTIALLY_ELIGIBLE",
}

/** Reasons why a trip segment might be ineligible for per diem */
export enum PerDiemIneligibilityReason {
  /** Combined trip duration across all segments is too short */
  COMBINED_TRIP_DURATION_TOO_SHORT = "COMBINED_TRIP_DURATION_TOO_SHORT",
  /** Domestic travel is not allowed for per diem */
  DOMESTIC_TRAVEL_NOT_ALLOWED = "DOMESTIC_TRAVEL_NOT_ALLOWED",
  /** International travel is not allowed for per diem */
  INTERNATIONAL_TRAVEL_NOT_ALLOWED = "INTERNATIONAL_TRAVEL_NOT_ALLOWED",
  /** No travel is allowed for per diem */
  NO_TRAVEL_ALLOWED = "NO_TRAVEL_ALLOWED",
  /** Overnight stay is required but not met */
  OVERNIGHT_STAY_REQUIRED = "OVERNIGHT_STAY_REQUIRED",
  /** No rates found for this trip */
  RATES_NOT_AVAILABLE = "RATES_NOT_AVAILABLE",
  /** Traveled distance is too short to qualify for per diem */
  TRAVELED_DISTANCE_TOO_SHORT = "TRAVELED_DISTANCE_TOO_SHORT",
  /** Trip duration is too short to qualify for per diem */
  TRIP_DURATION_TOO_SHORT = "TRIP_DURATION_TOO_SHORT",
}

/** Daily meal provisions for per diem calculation */
export interface PerDiemProvisions {
  /** Whether breakfast is provided */
  breakfast?: Maybe<Scalars["Boolean"]>;
  /** The date for these provisions */
  date?: Maybe<Scalars["Time"]>;
  /** The date for these provisions in UTC */
  dateUtc?: Maybe<Scalars["Time"]>;
  /** Whether dinner is provided */
  dinner?: Maybe<Scalars["Boolean"]>;
  /** Whether lunch is provided */
  lunch?: Maybe<Scalars["Boolean"]>;
}

/** Daily meal provisions for per diem calculation */
export interface PerDiemProvisionsInput {
  /** Whether breakfast is provided */
  breakfast?: InputMaybe<Scalars["Boolean"]>;
  /** The date for these provisions */
  date?: InputMaybe<Scalars["Time"]>;
  /** Whether dinner is provided */
  dinner?: InputMaybe<Scalars["Boolean"]>;
  /** Whether lunch is provided */
  lunch?: InputMaybe<Scalars["Boolean"]>;
}

/** Results for a specific trip segment */
export interface PerDiemSegmentResult {
  /** Reasons why this segment might be ineligible */
  ineligibilityReasons?: Maybe<Array<PerDiemIneligibilityReason>>;
  /** Whether this segment is eligible for per diem */
  isEligible?: Maybe<Scalars["Boolean"]>;
  /** The trip segment these results apply to */
  segment?: Maybe<PerDiemTripSegment>;
}

export interface PerDiemStats {
  /**
   * The entity. ie. if the entity_type is account, this is the account entity. This field is null in case of partial
   * failures.
   */
  entity?: Maybe<PerDiemStatsAssociatedEntity>;
  /** The scope of the per diem stats. */
  entityType: PerDiemStatsEntityType;
  /** The median absolute deviation stats */
  medianAbsoluteDeviationStats: MedianAbsoluteDeviationStats;
}

export type PerDiemStatsAssociatedEntity = Account | Department;

/** All supported PerDiem Stats entity type */
export enum PerDiemStatsEntityType {
  ACCOUNT = "ACCOUNT",
  DEPARTMENT = "DEPARTMENT",
}

/** A segment of the trip with location and time details */
export interface PerDiemTripSegment {
  /** The end time of this trip segment */
  endTime?: Maybe<Scalars["Time"]>;
  /** The end time of this trip segment in UTC */
  endTimeUtc?: Maybe<Scalars["Time"]>;
  /** The location for this segment of the trip */
  location?: Maybe<MapLocation>;
  /** The start time of this trip segment */
  startTime?: Maybe<Scalars["Time"]>;
  /** The start time of this trip segment in UTC */
  startTimeUtc?: Maybe<Scalars["Time"]>;
}

/** A segment of the trip with location and time details */
export interface PerDiemTripSegmentInput {
  /** The end time of this trip segment */
  endTime: Scalars["Time"];
  /** The location for this segment of the trip */
  location: MapLocationInput;
  /** The start time of this trip segment */
  startTime: Scalars["Time"];
}

/** Each qualified user will receive an individual budget with their own limit. */
export interface PerMemberBudgetDistributionSettings {
  /** The limit to be assigned to each per-member budget. */
  childBudgetLimit: FinancialAssetInput;
  /**
   * Specifies the date offset to be applied when setting the end date of the provisioned budget.
   *
   * The offset is calculated based on the time of provisioning. For instance, if the offset is set to 7 DAY and the
   * budget is provisioned on 2024-01-01, the end date of the provisioned budget will be 2024-01-08.
   */
  provisionedDateOffset?: InputMaybe<DateOffsetInput>;
  /** True if the to-be-created budgets should start in the next budget period */
  startBudgetNextAvailableBudgetPeriod: Scalars["Boolean"];
  /** User Filters. */
  userFilters: BudgetDistributionUserFilters;
  /** The user group to be associated with this distribution. If null, will convert from the user filters. */
  userGroup?: InputMaybe<UserGroupInput>;
}

/** Merchant stats on a card */
export interface PerMerchantStats {
  /** The merchant's ID */
  id: Scalars["ID"];
  /** Time of the last purchase on this merchant */
  lastPurchaseTime?: Maybe<Scalars["Time"]>;
  /** The Merchant */
  merchant?: Maybe<Merchant>;
}

export interface PerMerchantStatsConnection {
  /** The edges of this connection */
  edges?: Maybe<Array<Maybe<PerMerchantStatsEdge>>>;
  /**
   * Pagination information
   * Currently, this will always be null for this connection
   */
  pageInfo: PageInfo;
  /**
   * The total count of stats
   * Currently, this will always be null for this connection
   */
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface PerMerchantStatsEdge {
  /** The cursor */
  cursor: Scalars["String"];
  /** The PerMerchantStats node */
  node?: Maybe<PerMerchantStats>;
}

/** Represents a billing period. */
export interface Period {
  /** The end time. */
  endTime: Scalars["Time"];
  /** The start time. */
  startTime: Scalars["Time"];
}

export interface PeriodicReview extends Node {
  /** Due date by which review should be completed, else dashboard forces a blocking experience */
  dueAt?: Maybe<Scalars["Time"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  /** State of the periodic review ie. active/succeeded etc. */
  state?: Maybe<PeriodicReviewState>;
}

export enum PeriodicReviewState {
  ACTIVE = "ACTIVE",
  CANCELLED = "CANCELLED",
  ERROR = "ERROR",
  FAILED = "FAILED",
  INVALID = "INVALID",
  MANUAL_REVIEW = "MANUAL_REVIEW",
  SUCCEEDED = "SUCCEEDED",
}

export interface PermissionsSummary {
  capabilityKeys?: Maybe<Array<AuthCapabilityKey>>;
  displayRole?: Maybe<Scalars["String"]>;
  operations?: Maybe<Array<Operation>>;
}

/** Contains the parameters to collect information of Persona type. */
export interface PersonaInformation {
  /** Name of the information requirement to be displayed */
  displayType: RequirementInformationFieldDisplayType;
  /** Identifier of the information requirement */
  key: Scalars["String"];
  /** Identifier of the Persona template to be used for this information requirement */
  templateId: Scalars["String"];
}

export interface PersonaRequestConfig {
  individual?: Maybe<Scalars["String"]>;
  roles?: Maybe<Array<ObjectNodeType>>;
  templateId: Scalars["String"];
}

export interface PersonaSubmissionPayloadInput {
  error?: InputMaybe<Scalars["String"]>;
  inquiryId: Scalars["String"];
}

/** Philippines bank account. */
export interface PhLocal {
  accountNumber?: Maybe<Scalars["String"]>;
  bankCode?: Maybe<Scalars["String"]>;
  recipientAddress?: Maybe<Scalars["String"]>;
}

/** Philippines bank account. */
export interface PhLocalInput {
  accountNumber?: InputMaybe<Scalars["String"]>;
  bankCode?: InputMaybe<Scalars["String"]>;
  recipientAddress?: InputMaybe<Scalars["String"]>;
}

/** Poland bank account. */
export interface PlLocal {
  accountNumber?: Maybe<Scalars["String"]>;
}

/** Poland bank account. */
export interface PlLocalInput {
  accountNumber?: InputMaybe<Scalars["String"]>;
}

export interface Place {
  /**
   * The external place id.
   * https://developers.google.com/maps/documentation/places/web-service/details#Place-place_id
   */
  externalPlaceId?: Maybe<Scalars["String"]>;
  /** The human readable address of the place */
  formattedAddress?: Maybe<Scalars["String"]>;
  /** The latitude of the place. */
  latitude: Scalars["Decimal"];
  /** The longitude of the place. */
  longitude: Scalars["Decimal"];
  /** The name of the place. */
  name?: Maybe<Scalars["String"]>;
}

export interface PlaceInput {
  /**
   * The external place id.
   * https://developers.google.com/maps/documentation/places/web-service/details#Place-place_id
   */
  externalPlaceId?: InputMaybe<Scalars["String"]>;
  /** The human readable address of the place */
  formattedAddress?: InputMaybe<Scalars["String"]>;
  /** The latitude of the place. */
  latitude: Scalars["Decimal"];
  /** The longitude of the place. */
  longitude: Scalars["Decimal"];
  /** The name of the place. */
  name?: InputMaybe<Scalars["String"]>;
}

export interface PlaidInstitutionMapping {
  fallbackInstitution: FinancialInstitution;
  plaidInstitutionId: Scalars["String"];
}

export interface PlaidPayload {
  plaidInstitutionId: Scalars["String"];
}

export enum PlaidProduct {
  AUTH = "AUTH",
  BALANCE = "BALANCE",
  IDENTITY = "IDENTITY",
  INCOME = "INCOME",
  INVESTMENTS = "INVESTMENTS",
  TRANSACTIONS = "TRANSACTIONS",
}

export enum Platform {
  DASHBOARD = "DASHBOARD",
  MOBILE = "MOBILE",
}

export interface PoaoVerificationMetadata {
  reviewedBy?: Maybe<Array<Maybe<Scalars["String"]>>>;
  statementUpload?: Maybe<Array<Maybe<StatementUpload>>>;
}

export interface PoaoVerificationMetadataInput {
  fileUploadedBy: Scalars["ID"];
  uploadFileId: Scalars["ID"];
}

/** External types for federation */
export interface Policy {
  /** How many active spend limits exist for this policy */
  activeSpendLimitCount?: Maybe<Scalars["Int"]>;
  /** `approvalChainDefinition` presents the same info as `approvalChains`, but in an easier-to-understand format */
  approvalChainDefinition?: Maybe<ApprovalChainDefinition>;
  /** A string describing summarizing the approval chains set up by admins */
  approvalChainSummary?: Maybe<Scalars["String"]>;
  /** Approval chains associated with this policy. */
  approvalChains?: Maybe<Array<PolicyApprovalChain>>;
  /** The currency that the policy supports */
  currency?: Maybe<Scalars["String"]>;
  /** `definition` presents the same info as `ruleDetails` and `rules`, but in a much easier-to-understand format. */
  definition?: Maybe<PolicyDefinition>;
  /** An optional customer specified description */
  description?: Maybe<Scalars["String"]>;
  /** An optional customer specified display name */
  displayName?: Maybe<Scalars["String"]>;
  /** Which workflow types the policy is eligible for (Travel, BillPay, etc) */
  eligibleWorkflows?: Maybe<Array<PolicyWorkflowType>>;
  /** PolicySpec object of the given policy with relevant filters */
  expensePolicySpec?: Maybe<ExpensePolicySpec>;
  /** PolicySpecSection object of the given policy */
  expensePolicySpecSection?: Maybe<ExpensePolicySpecSectionBlock>;
  /** Whether the policy has been updated by the customer */
  hasBeenUpdatedByCustomer?: Maybe<Scalars["Boolean"]>;
  /** The policy's unique ID */
  id: Scalars["ID"];
  /** Whether this is the default policy for its request type. */
  isDefault: Scalars["Boolean"];
  /**
   * Whether the policy is eligible for travel
   * @deprecated Deprecated. Use eligibleWorkflows instead.
   */
  isTravelEligible?: Maybe<Scalars["Boolean"]>;
  /** `isUsed` parameter determines if the policy is used in any active Spend Limit, SL request, template or budget distribution */
  isUsed?: Maybe<PolicyIsUsed>;
  /** Specifies the type of request which this policy operates on */
  requestType: RequestType;
  /**
   * The actual content of the policy, which can be used to render the policy for a user to read.
   * @deprecated This is a legacy format. Use `rules` instead.
   */
  ruleDetails?: Maybe<PolicyDocument>;
  /** The rules contained in this policy. */
  rules?: Maybe<Array<PolicyRuleSet>>;
  /** The status of this policy (e.g. whether it is disabled) */
  status: PolicyStatus;
  /** Whether the policy is a legacy policy or a section */
  type: PolicyType;
}

/** External types for federation */
export interface PolicydefinitionArgs {
  displayCurrency?: InputMaybe<Scalars["String"]>;
  rulesFilter?: PolicyRulesFilter;
}

/** External types for federation */
export interface PolicyexpensePolicySpecArgs {
  input: ExpensePolicySpecFilterInput;
}

/** An action that can be required as the output of a policy. */
export type PolicyAction =
  | PolicyActionGenerateAutoMemo
  | PolicyActionRequireAttendees
  | PolicyActionRequireBookingHardApproval
  | PolicyActionRequireBookingSoftApproval
  | PolicyActionRequireExpenseMemo
  | PolicyActionRequireExpenseReceipt
  | PolicyActionRequireExpenseReceiptValidation
  | PolicyActionRequireExtendedField
  | PolicyActionRequireInvoice
  | PolicyActionRequireReview;

/** An action that means that a memo will be auto-generated. */
export interface PolicyActionGenerateAutoMemo {
  /** The type of auto-memo that will be generated. */
  autoMemoType: AutoMemoType;
  /** The pre-defined custom text if the AutoMemoType is CUSTOM_TEXT. */
  customText?: Maybe<Scalars["String"]>;
}

/**
 * Policy action metadata that aligns with Requests proto definition of action metadata.
 *
 * Can add more request-specific fields in the future corresponding to Requests PolicyAction proto if needed
 */
export interface PolicyActionMetadataOneOf {
  requireAttendees?: Maybe<RequireAttendeesPolicyAction>;
  requireExtendedField?: Maybe<RequireExtendedFieldPolicyAction>;
}

/** An action that means a list of attendees must be added to the expense. */
export interface PolicyActionRequireAttendees {
  /** Whether or not the user should be required to input a company name for external attendees. */
  requireCompanyName: Scalars["Boolean"];
  /** Whether or not the user should be required to specify whether or not external attendees are government officials */
  requireIsGovernmentOfficial: Scalars["Boolean"];
  /** Whether or not the user should be required to input a job title for external attendees. */
  requireTitle: Scalars["Boolean"];
}

/**
 * An action that means a Booking can be APPROVED before a given deadline. If not, it is automatically CANCELED.
 * DOES NOT apply to Expenses.
 */
export interface PolicyActionRequireBookingHardApproval {
  /**
   * A dummy field because objects need to have at least one field.
   * https://spec.graphql.org/October2021/#sec-Objects
   */
  _?: Maybe<Scalars["Boolean"]>;
}

/**
 * An action that means a Booking can be REJECTED before a given deadline. If not, it is automatically APPROVED.
 * DOES NOT apply to Expenses.
 */
export interface PolicyActionRequireBookingSoftApproval {
  /**
   * A dummy field because objects need to have at least one field.
   * https://spec.graphql.org/October2021/#sec-Objects
   */
  _?: Maybe<Scalars["Boolean"]>;
}

/** An action that means a memo must be added to the expense. */
export interface PolicyActionRequireExpenseMemo {
  /**
   * A dummy field because objects need to have at least one field.
   * https://spec.graphql.org/October2021/#sec-Objects
   */
  _?: Maybe<Scalars["Boolean"]>;
}

/** An action that means a receipt must be added to the expense. */
export interface PolicyActionRequireExpenseReceipt {
  /** A possibly empty set of requirements about the receipt. Currently, these cannot be enforced. */
  requirements?: Maybe<Array<PolicyReceiptRequirement>>;
}

/** An action that means uploaded receipts must be validated. */
export interface PolicyActionRequireExpenseReceiptValidation {
  /**
   * A dummy field because objects need to have at least one field.
   * https://spec.graphql.org/October2021/#sec-Objects
   */
  _?: Maybe<Scalars["Boolean"]>;
}

/** An action that an extended field must be added to the expense. */
export interface PolicyActionRequireExtendedField {
  /** The extended field. */
  field: ExtendedField;
  /** ID of the extended field. */
  fieldId: Scalars["ID"];
}

/** An action that means an invoice must be added to the expense. */
export interface PolicyActionRequireInvoice {
  /**
   * A dummy field because objects need to have at least one field.
   * https://spec.graphql.org/October2021/#sec-Objects
   */
  _?: Maybe<Scalars["Boolean"]>;
}

/** An action that means a request (such as an expense request) will have to go through a review process. */
export interface PolicyActionRequireReview {
  /**
   * A dummy field because objects need to have at least one field.
   * https://spec.graphql.org/October2021/#sec-Objects
   */
  _?: Maybe<Scalars["Boolean"]>;
}

/**
 * Actions that can be requested by a policy.
 *
 * All fields are optional and an empty action set implies no action should be taken. This allows us to
 * write rules to short-circuit evaluation and avoid that other rules will be triggered.
 *
 * NOTE: Actions cannot be made a union because we cannot make an "input union", which would make input
 * types and output types different.
 */
export interface PolicyActionSet {
  /**
   * An OPTIONAL set of actions descriptions for legacy compatibility.
   * @deprecated Not used anymore. Replaced by evaluation trail.
   */
  descriptions?: Maybe<Array<Scalars["String"]>>;
  generateAutoMemo?: Maybe<PolicyActionGenerateAutoMemo>;
  requireAttendees?: Maybe<PolicyActionRequireAttendees>;
  requireExtendedFields?: Maybe<Array<PolicyActionRequireExtendedField>>;
  requireHardApproval?: Maybe<PolicyActionRequireBookingHardApproval>;
  requireInvoice?: Maybe<PolicyActionRequireInvoice>;
  requireMemo?: Maybe<PolicyActionRequireExpenseMemo>;
  requireReceipt?: Maybe<PolicyActionRequireExpenseReceipt>;
  requireReceiptValidation?: Maybe<PolicyActionRequireExpenseReceiptValidation>;
  requireReview?: Maybe<PolicyActionRequireReview>;
  requireSoftApproval?: Maybe<PolicyActionRequireBookingSoftApproval>;
}

/**
 * An action set to be returned by a rule.
 *
 * All fields are optional and an empty action set implies no action should be taken. This allows us to
 * write rules to short-circuit evaluation and avoid that other rules will be triggered.
 */
export interface PolicyActionSetInput {
  /** An OPTIONAL set of actions descriptions for legacy compatibility. */
  descriptions?: InputMaybe<Array<Scalars["String"]>>;
  generateAutoMemo?: InputMaybe<PolicyGenerateAutoMemoInput>;
  requireAttendees?: InputMaybe<PolicyRequireAttendeesInput>;
  requireExtendedFields?: InputMaybe<Array<PolicyRequireExtendedFieldInput>>;
  requireHardApproval?: InputMaybe<PolicyRequireBookingHardApprovalInput>;
  requireInvoice?: InputMaybe<PolicyRequireInvoiceInput>;
  requireMemo?: InputMaybe<PolicyRequireExpenseMemoInput>;
  requireReceipt?: InputMaybe<PolicyRequireExpenseReceiptInput>;
  requireReceiptValidation?: InputMaybe<PolicyRequireExpenseReceiptValidationInput>;
  requireReview?: InputMaybe<PolicyRequireReviewInput>;
  requireSoftApproval?: InputMaybe<PolicyRequireBookingSoftApprovalInput>;
}

/** A user (or set of users) that are the target of an action. */
export interface PolicyActionTarget {
  budgetRole?: Maybe<Scalars["String"]>;
  customerUser?: Maybe<Employee>;
  /** @deprecated use customerUser instead */
  customerUserId?: Maybe<Scalars["ID"]>;
  hierarchiesHierarchyLevelId?: Maybe<Scalars["ID"]>;
  hierarchiesTitleId?: Maybe<Scalars["ID"]>;
  managerLevelDifference?: Maybe<Scalars["Int"]>;
  requiredUserRole?: Maybe<Scalars["String"]>;
}

/** A user (or set of users) that are the target of an action. */
export interface PolicyActionTargetInput {
  budgetRole?: InputMaybe<Scalars["String"]>;
  customerUserId?: InputMaybe<Scalars["ID"]>;
  hierarchiesHierarchyLevelId?: InputMaybe<Scalars["ID"]>;
  hierarchiesTitleId?: InputMaybe<Scalars["ID"]>;
  managerLevelDifference?: InputMaybe<Scalars["Int"]>;
  requiredUserRole?: InputMaybe<Scalars["String"]>;
}

/** Type of expense addendum. */
export enum PolicyAddendumType {
  ATTENDEES = "ATTENDEES",
  CAR_RENTAL = "CAR_RENTAL",
  COMMON_DATA_REQUIREMENTS = "COMMON_DATA_REQUIREMENTS",
  CONFERENCE = "CONFERENCE",
  CUSTOM = "CUSTOM",
  /** @deprecated Deprecated. Use FLIGHTS instead. */
  FLIGHT = "FLIGHT",
  FLIGHTS = "FLIGHTS",
  FOOD_DELIVERY = "FOOD_DELIVERY",
  GENERAL_TICKET_INFORMATION = "GENERAL_TICKET_INFORMATION",
  LINE_ITEMS = "LINE_ITEMS",
  LODGING = "LODGING",
  MEAL = "MEAL",
  MILEAGE = "MILEAGE",
  RAIL_TRAVEL = "RAIL_TRAVEL",
  RECEIPT_AFFIDAVIT = "RECEIPT_AFFIDAVIT",
  RIDESHARE = "RIDESHARE",
  SHIPPING_SERVICES = "SHIPPING_SERVICES",
  TRIP_LEG_DATA = "TRIP_LEG_DATA",
}

/**
 * A condition regarding existing addendum types of an expense.
 * It should be read as `addendumTypes ${operator} ${addendumTypes}`. Examples:
 * - addendumTypes CONTAINS_ANY_OF [LODGING, MEAL, MILEAGE]
 * - addendumTypes CONTAINS_NONE_OF [LODGING, MILEAGE]
 */
export interface PolicyAddendumTypeCondition {
  addendumTypes: Array<PolicyAddendumType>;
  operator: PolicySetOperator;
}

/**
 * A condition regarding existing addendum types of an expense.
 * It should be read as `addendumTypes ${operator} ${addendumTypes}`. Examples:
 * - addendumTypes CONTAINS_ANY_OF [LODGING, MEAL, MILEAGE]
 * - addendumTypes CONTAINS_NONE_OF [LODGING, MILEAGE]
 */
export interface PolicyAddendumTypeConditionInput {
  addendumTypes: Array<PolicyAddendumType>;
  operator: PolicySetOperator;
}

/**
 * A condition regarding the amount of an expense.
 * It should be read as `expenseAmount ${operator} ${amount}`. Example:
 * - expenseAmount GREATER_THAN $20
 */
export interface PolicyAmountCondition {
  amount: FinancialAsset;
  operator: PolicyNumberOperator;
}

/**
 * A condition regarding the amount of an expense.
 * It should be read as `expenseAmount ${operator} ${amount}`. Example:
 * - expenseAmount GREATER_THAN $20
 */
export interface PolicyAmountConditionInput {
  amount: FinancialAssetInput;
  operator: PolicyNumberOperator;
}

/** An approval chain, including the condition for it to be used. */
export interface PolicyApprovalChain {
  /**
   * A condition to determine whether this approval chain should be used. A null condition is allowed
   * and is assumed to be true.
   */
  chainCondition?: Maybe<PolicyCondition>;
  /**
   * A rule to determine whether this approval chain should be used. If null, the approval chain will apply to any
   * expense.
   * @deprecated Legacy format. Use `chainCondition` instead.
   */
  ruleCondition?: Maybe<PolicyRule>;
  /** The steps in this approval chain. */
  steps: Array<PolicyApprovalStep>;
}

/** An approval chain, including the condition for it to be used. */
export interface PolicyApprovalChainInput {
  /**
   * A condition to determine whether this approval chain should be used. A null condition is allowed
   * and is assumed to be true.
   */
  chainCondition?: InputMaybe<PolicyConditionInput>;
  /** The steps in this approval chain. */
  steps: Array<PolicyApprovalStepInput>;
}

/**
 * A step in the approval process consisting of reviews that can be requested in parallel. The step is only completed once
 * ALL reviews are completed.
 */
export interface PolicyApprovalStep {
  /** The reviews that must be performed before the next review step. */
  reviews: Array<PolicyReview>;
}

/**
 * A step in the approval process consisting of reviews that can be requested in parallel. The step is only completed once
 * ALL reviews are completed.
 */
export interface PolicyApprovalStepInput {
  /** The reviews that must be performed before the next review step. */
  reviews: Array<PolicyReviewInput>;
}

/**
 * A condition regarding the time in advance a booking has been made.
 * It should be read as `bookingDaysInAdvance ${operator} ${daysInAdvance}`. Example:
 * - bookingDaysInAdvance LESS_THAN 15
 */
export interface PolicyBookingDaysInAdvanceCondition {
  daysInAdvance: Scalars["Int"];
  operator: PolicyNumberOperator;
}

/**
 * A condition regarding the time in advance a booking has been made.
 * It should be read as `bookingDaysInAdvance ${operator} ${daysInAdvance}`. Example:
 * - bookingDaysInAdvance LESS_THAN 15
 */
export interface PolicyBookingDaysInAdvanceConditionInput {
  daysInAdvance: Scalars["Int"];
  operator: PolicyNumberOperator;
}

/**
 * A condition on whether a Booking is out of policy. Only used to signal a rule relates only to out-of-policy Bookings.
 * DOES NOT apply to Expenses.
 * It should be read as `bookingIsOutOfPolicy is ${bookingIsOutOfPolicy}`. Example:
 * - bookingIsOutOfPolicy is true
 */
export interface PolicyBookingOutOfPolicyCondition {
  bookingIsOutOfPolicy: Scalars["Boolean"];
}

/**
 * A condition on whether a Booking is out of policy. Only used to signal a rule relates only to out-of-policy Bookings.
 * DOES NOT apply to Expenses.
 * It should be read as `bookingIsOutOfPolicy is ${bookingIsOutOfPolicy}`. Example:
 * - bookingIsOutOfPolicy is true
 */
export interface PolicyBookingOutOfPolicyConditionInput {
  bookingIsOutOfPolicy: Scalars["Boolean"];
}

/** Possible kinds of Booking on Brex Travel. */
export enum PolicyBookingType {
  AIR = "AIR",
  CAR_RENTAL = "CAR_RENTAL",
  LODGING = "LODGING",
}

/**
 * A condition on the Booking Type. DOES NOT apply to Expenses.
 * It should be read as `bookingType ${operator} ${bookingTypes}`. Example:
 * - bookingType IN [AIR, LODGING]
 */
export interface PolicyBookingTypeCondition {
  bookingTypes?: Maybe<Array<Maybe<PolicyBookingType>>>;
  operator: PolicySetElementOperator;
}

/**
 * A condition on the Booking Type. DOES NOT apply to Expenses.
 * It should be read as `bookingType ${operator} ${bookingTypes}`. Example:
 * - bookingType IN [AIR, LODGING]
 */
export interface PolicyBookingTypeConditionInput {
  bookingTypes?: InputMaybe<Array<InputMaybe<PolicyBookingType>>>;
  operator: PolicySetElementOperator;
}

export interface PolicyBoolValue {
  value?: Maybe<Scalars["Boolean"]>;
}

export interface PolicyBoolValueInput {
  value?: InputMaybe<Scalars["Boolean"]>;
}

/**
 * A condition that can be used in a rule. Encapsulates specific types of condition according to the
 * type of policy and the attributes that can be used in it.
 */
export interface PolicyCondition {
  /** A condition based on attributes from an Budget Limit Increase Request. */
  budgetLimitIncreaseRequestPolicyCondition?: Maybe<BudgetLimitIncreaseRequestPolicyCondition>;
  /** A condition based on attributes from an Budget Request. */
  budgetRequestPolicyCondition?: Maybe<BudgetRequestPolicyCondition>;
  /** A condition based on attributes from an Expense Request. */
  expensePolicyCondition?: Maybe<ExpensePolicyCondition>;
}

/**
 * A condition that can be used in a rule. Encapsulates specific types of condition according to the
 * type of policy and the attributes that can be used in it.
 */
export interface PolicyConditionInput {
  /** A condition based on attributes from an Expense Request. */
  expensePolicyCondition?: InputMaybe<ExpensePolicyConditionInput>;
}

/** A policy connection for policy pagination. */
export interface PolicyConnection extends Connection {
  /** The policies in the current page of results. */
  edges: Array<PolicyEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of policies matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

/** Describes whether a currency is enabled or disabled for the account policies */
export enum PolicyCurrencyEnablementStatus {
  DISABLED = "DISABLED",
  ENABLED = "ENABLED",
}

/** Describes whether a currency is used in any of the Spend Limits */
export enum PolicyCurrencyUsageStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

/** Optional user-provided descriptions. Can be used in any type that requires this kind of information. */
export interface PolicyCustomDescription {
  additionalNotes?: Maybe<Scalars["String"]>;
  autoDescriptionOverride?: Maybe<Scalars["String"]>;
}

/** Optional user-provided descriptions. Can be used in any type that requires this kind of information. */
export interface PolicyCustomDescriptionInput {
  additionalNotes?: InputMaybe<Scalars["String"]>;
  autoDescriptionOverride?: InputMaybe<Scalars["String"]>;
}

/** A rule for which we will not generate the description. Instead, we rely on a hardcoded one. */
export interface PolicyCustomRuleDefinition {
  policyDescription: Scalars["String"];
}

/**
 * A representation of a policy that hides backend implementation details that clients should not care about (e.g.
 * "RuleSets").
 *
 * This is currently defined as a union encompassing only `ExpensePolicy`. We may decide to add `BudgetRequestPolicy`
 * and/or `BudgetLimitIncreaseRequestPolicy` types at some later point, but there is currently no immediate need for such a
 * thing given that equivalent information is provided through `BudgetTemplate.budgetStructure`.
 */
export type PolicyDefinition = ExpensePolicy;

/**
 * The basis for all message segment types besides currency.
 * At minimum, clients need to be able to render the text, and know whether to redact it.
 * Any features on top of that are optional.
 */
export interface PolicyDescriptionBaseTextSegment {
  sensitive: Scalars["Boolean"];
  text: Scalars["String"];
}

/** A segment that hold expense category information */
export interface PolicyDescriptionExpenseCategorySegment {
  expenseCategories: Array<ExpenseCategory>;
}

/**
 * A currency parameter in a policy message, e.g. $100 USD.
 * The lack of a 'text' parameter forces clients to format the currency themselves.
 */
export interface PolicyDescriptionFinancialAssetSegment {
  amount: FinancialAsset;
}

/** A segment that holds merchant category information */
export interface PolicyDescriptionMerchantCategorySegment {
  merchantCategories: Array<MerchantCategory>;
}

/** This represents segments of a message that are composed together */
export type PolicyDescriptionSegment =
  | PolicyDescriptionExpenseCategorySegment
  | PolicyDescriptionFinancialAssetSegment
  | PolicyDescriptionMerchantCategorySegment
  | PolicyDescriptionTextSegment;

/** The basic text type, used when we have no need to let the client know any other details about the text. */
export interface PolicyDescriptionTextSegment
  extends PolicyDescriptionBaseTextSegment {
  sensitive: Scalars["Boolean"];
  text: Scalars["String"];
}

/** Policy Translations to human readable format, for various contexts */
export interface PolicyDescriptions {
  education: Array<Maybe<PolicyDescriptionSegment>>;
  outOfPolicyReason: Array<Maybe<PolicyDescriptionSegment>>;
  requiredReason: Array<Maybe<PolicyDescriptionSegment>>;
  reviewReason: Array<Maybe<PolicyDescriptionSegment>>;
  transactionDescription: Array<Maybe<PolicyDescriptionSegment>>;
}

export interface PolicyDocument extends PolicyNode {
  /**
   * The 'root nodes' of the Policy Document.
   * When used to represent a Policy, there will usually have multiple nodes, e.g. one for each category of rules.
   * When used to represent a single Rule, there will usually be just a single root node.
   */
  childIds: Array<Scalars["ID"]>;
  /** The unique ID of the node in this root node. */
  nodeId: Scalars["ID"];
  /**
   * The list of Policy elements which describe a policy (or policy fragment).
   * Since each node has an ID and a list of childIds, they form an Adjacency List graph.
   */
  nodes: Array<PolicyNode>;
}

/** A Policy edge for Policy pagination. */
export interface PolicyEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The policy at this edge. */
  node?: Maybe<Policy>;
}

/**
 * A condition regarding the cost center the employee reports to.
 * It should be read as `cost_center_id ${operator} ${cost_center_ids}`.
 */
export interface PolicyEmployeeCostCenterIdCondition {
  costCenterIds: Array<Scalars["String"]>;
  operator: PolicySetElementOperator;
}

/**
 * A condition regarding the cost center the employee reports to.
 * It should be read as `cost_center_id ${operator} ${cost_center_ids}`.
 */
export interface PolicyEmployeeCostCenterIdConditionInput {
  costCenterIds: Array<Scalars["String"]>;
  operator: PolicySetElementOperator;
}

/**
 * A condition regarding the department the employee belongs to.
 * It should be read as `department_id ${operator} ${department_ids}`.
 */
export interface PolicyEmployeeDepartmentIdCondition {
  departmentIds: Array<Scalars["String"]>;
  operator: PolicySetElementOperator;
}

/**
 * A condition regarding the department the employee belongs to.
 * It should be read as `department_id ${operator} ${department_ids}`.
 */
export interface PolicyEmployeeDepartmentIdConditionInput {
  departmentIds: Array<Scalars["String"]>;
  operator: PolicySetElementOperator;
}

/**
 * A condition regarding the legal entity id the employee reports to.
 * It should be read as `legal_entity_id ${operator} ${legal_entities}`.
 */
export interface PolicyEmployeeLegalEntityIdCondition {
  legalEntityIds: Array<Scalars["String"]>;
  operator: PolicySetElementOperator;
}

/**
 * A condition regarding the legal entity id the employee reports to.
 * It should be read as `legal_entity_id ${operator} ${legal_entities}`.
 */
export interface PolicyEmployeeLegalEntityIdConditionInput {
  legalEntityIds: Array<Scalars["String"]>;
  operator: PolicySetElementOperator;
}

/**
 * A condition regarding the employee title id.
 * It should be read as `employee_title_id ${operator} ${employee_title_ids}`.
 */
export interface PolicyEmployeeTitleIdCondition {
  employeeTitleIds: Array<Scalars["String"]>;
  operator: PolicySetElementOperator;
}

/**
 * A condition regarding the employee title id.
 * It should be read as `employee_title_id ${operator} ${employee_title_ids}`.
 */
export interface PolicyEmployeeTitleIdConditionInput {
  employeeTitleIds: Array<Scalars["String"]>;
  operator: PolicySetElementOperator;
}

export enum PolicyEmploymentStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  PENDING = "PENDING",
  UNKNOWN = "UNKNOWN",
}

/**
 * A condition regarding the employment status.
 * It should be read as `employment_status ${operator} ${employment_statuses}`.
 */
export interface PolicyEmploymentStatusCondition {
  employmentStatuses: Array<PolicyEmploymentStatus>;
  operator: PolicySetElementOperator;
}

/**
 * A condition regarding the employment status.
 * It should be read as `employment_status ${operator} ${employment_statuses}`.
 */
export interface PolicyEmploymentStatusConditionInput {
  employmentStatuses: Array<PolicyEmploymentStatus>;
  operator: PolicySetElementOperator;
}

export enum PolicyEmploymentType {
  CONTRACTOR = "CONTRACTOR",
  FREELANCE = "FREELANCE",
  FULL_TIME = "FULL_TIME",
  INTERN = "INTERN",
  PART_TIME = "PART_TIME",
  UNKNOWN = "UNKNOWN",
}

/**
 * A condition regarding the employment type.
 * It should be read as `employment_type ${operator} ${employment_types}`.
 */
export interface PolicyEmploymentTypeCondition {
  employmentTypes: Array<PolicyEmploymentType>;
  operator: PolicySetElementOperator;
}

/**
 * A condition regarding the employment type.
 * It should be read as `employment_type ${operator} ${employment_types}`.
 */
export interface PolicyEmploymentTypeConditionInput {
  employmentTypes: Array<PolicyEmploymentType>;
  operator: PolicySetElementOperator;
}

export enum PolicyEnrollmentStatus {
  DISABLED = "DISABLED",
  ENABLED = "ENABLED",
}

/**
 * A policy rule may be configured that is an "exception" to another rule that only applies to a specific group of users.
 * This type represents such a group.
 */
export interface PolicyExceptionScope {
  costCenters: Array<CostCenter>;
  departments: Array<Department>;
  legalEntities: Array<LegalEntity>;
  locations: Array<Location>;
  titles: Array<Title>;
  userGroups: Array<Group>;
  users: Array<User>;
}

/**
 * A policy rule may be configured that is an "exception" to another rule that only applies to a specific group of users.
 * This type represents such a group.
 */
export interface PolicyExceptionScopeInput {
  costCenterIds?: InputMaybe<Array<Scalars["ID"]>>;
  departmentIds?: InputMaybe<Array<Scalars["ID"]>>;
  legalEntityIds?: InputMaybe<Array<Scalars["ID"]>>;
  locationIds?: InputMaybe<Array<Scalars["ID"]>>;
  titleIds?: InputMaybe<Array<Scalars["ID"]>>;
  userGroupIds?: InputMaybe<Array<Scalars["ID"]>>;
  userIds?: InputMaybe<Array<Scalars["ID"]>>;
}

/**
 * A condition regarding the type of an expense.
 * It should be read as `expenseType ${operator} ${expenseTypes}`. Examples:
 * - expenseType IN [CARD]
 * - expenseType NOT_IN [REIMBURSEMENT, BILL_PAY]
 */
export interface PolicyExpenseTypeCondition {
  expenseTypes: Array<ExpenseType>;
  operator: PolicySetElementOperator;
}

/**
 * A condition regarding the type of an expense.
 * It should be read as `expenseType ${operator} ${expenseTypes}`. Examples:
 * - expenseType IN [CARD]
 * - expenseType NOT_IN [REIMBURSEMENT, BILL_PAY]
 */
export interface PolicyExpenseTypeConditionInput {
  expenseTypes: Array<ExpenseType>;
  operator: PolicySetElementOperator;
}

export type PolicyExtendedFieldComparisonValue =
  | PolicyMultipleComparisonValues
  | PolicySingleComparisonValue;

export interface PolicyExtendedFieldComparisonValueOneOfInput {
  multipleComparisonValues?: InputMaybe<PolicyMultipleComparisonValuesInput>;
  singleComparisonValue?: InputMaybe<PolicySingleComparisonValueInput>;
}

/**
 * A condition based on extendedField value
 * It should be read as `extendedFieldInput[extendedFieldId] ${operator} ${value}`
 */
export interface PolicyExtendedFieldCondition {
  extendedFieldId: Scalars["ID"];
  operator: PolicyOperatorOneOf;
  value: PolicyExtendedFieldComparisonValue;
}

/**
 * A condition based on extendedField value
 * It should be read as `extendedFieldInput[extendedFieldId] ${operator} ${value}`
 */
export interface PolicyExtendedFieldConditionInput {
  extendedFieldId: Scalars["ID"];
  operator: PolicyOperatorOneOfInput;
  value: PolicyExtendedFieldComparisonValueOneOfInput;
}

export type PolicyFieldValue =
  | PolicyBoolValue
  | PolicyIdentifierToStringValue
  | PolicyNumberValue
  | PolicyStringValue;

export interface PolicyFieldValueOneOfInput {
  boolValueInput?: InputMaybe<PolicyBoolValueInput>;
  identifierToStringValueInput?: InputMaybe<PolicyIdentifierToStringValueInput>;
  numberValueInput?: InputMaybe<PolicyNumberValueInput>;
  stringValueInput?: InputMaybe<PolicyStringValueInput>;
}

/** Filters available to control which policies get returned. */
export interface PolicyFilterInput {
  /** Match IN specific currency, match ALL when no filter is provided */
  currencies?: InputMaybe<Array<Scalars["String"]>>;
  /** Match IN specific eligible types, match ALL when no filter is provided */
  eligibleWorkflows?: InputMaybe<Array<PolicyWorkflowType>>;
  /**
   * Optional filter isDefault, match ALL when no filter is provided
   * match only default policies when isDefault is true and only non-default when false
   */
  isDefault?: InputMaybe<Scalars["Boolean"]>;
  /** Match IN specific types, match ALL when no filter is provided */
  requestTypes?: InputMaybe<Array<RequestType>>;
  /** Match IN specific statuses, match ALL when no filter is provided */
  statuses?: InputMaybe<Array<PolicyStatus>>;
  /** Match IN specific policy type, match ALL when no filter is provided */
  types?: InputMaybe<Array<PolicyType>>;
}

/** Flight cabin classes that can be used in policies. */
export enum PolicyFlightCabinClass {
  BUSINESS = "BUSINESS",
  ECONOMY = "ECONOMY",
  FIRST_CLASS = "FIRST_CLASS",
  PREMIUM_ECONOMY = "PREMIUM_ECONOMY",
}

/**
 * A condition regarding a flight cabin class.
 * It should be read as `flightCabinClass ${operator} ${cabinClasses}`. Examples:
 * - flightCabinClass IN [ECONOMY, PREMIUM_ECONOMY]
 * - flightCabinClass NOT_IN [FIRST_CLASS, BUSINESS]
 */
export interface PolicyFlightCabinClassCondition {
  cabinClasses: Array<PolicyFlightCabinClass>;
  operator: PolicySetElementOperator;
}

/**
 * A condition regarding a flight cabin class.
 * It should be read as `flightCabinClass ${operator} ${cabinClasses}`. Examples:
 * - flightCabinClass IN [ECONOMY, PREMIUM_ECONOMY]
 * - flightCabinClass NOT_IN [FIRST_CLASS, BUSINESS]
 */
export interface PolicyFlightCabinClassConditionInput {
  cabinClasses: Array<PolicyFlightCabinClass>;
  operator: PolicySetElementOperator;
}

/**
 * A condition regarding the duration of a flight.
 * It should be read as `flightDuration ${operator} ${duration}`. Example:
 * - flightDuration LESS_THAN 360 minutes
 */
export interface PolicyFlightDurationCondition {
  durationMinutes: Scalars["Int"];
  operator: PolicyNumberOperator;
}

/**
 * A condition regarding the duration of a flight.
 * It should be read as `flightDuration ${operator} ${duration}`. Example:
 * - flightDuration LESS_THAN 360 minutes
 */
export interface PolicyFlightDurationConditionInput {
  durationMinutes: Scalars["Int"];
  operator: PolicyNumberOperator;
}

/**
 * A condition regarding the conditions to change a flight ticket.
 * It should be read as `flightTicketChangeRules ${operator} ${changeRules}`. Example:
 * - flightTicketChangeRules IN [NON_CHANGEABLE, CHANGEABLE_WITH_FEE]
 */
export interface PolicyFlightTicketChangeRulesCondition {
  changeRules: Array<PolicyTicketChangeRules>;
  operator: PolicySetElementOperator;
}

/**
 * A condition regarding the conditions to change a flight ticket.
 * It should be read as `flightTicketChangeRules ${operator} ${changeRules}`. Example:
 * - flightTicketChangeRules IN [NON_CHANGEABLE, CHANGEABLE_WITH_FEE]
 */
export interface PolicyFlightTicketChangeRulesConditionInput {
  changeRules: Array<PolicyTicketChangeRules>;
  operator: PolicySetElementOperator;
}

/**
 * A condition regarding the conditions to request a refund for a flight.
 * It should be read as `flightTicketRefundRules ${operator} ${refund_rules}`. Example:
 * - flightTicketRefundRules IN [NON_REFUNDABLE, REFUNDABLE_WITH_FEE]
 */
export interface PolicyFlightTicketRefundRulesCondition {
  operator: PolicySetElementOperator;
  refundRules: Array<PolicyTicketChangeRules>;
}

/**
 * A condition regarding the conditions to request a refund for a flight.
 * It should be read as `flightTicketRefundRules ${operator} ${refund_rules}`. Example:
 * - flightTicketRefundRules IN [NON_REFUNDABLE, REFUNDABLE_WITH_FEE]
 */
export interface PolicyFlightTicketRefundRulesConditionInput {
  operator: PolicySetElementOperator;
  refundRules: Array<PolicyTicketChangeRules>;
}

/** An action meaning a memo will be auto-generated. */
export interface PolicyGenerateAutoMemoInput {
  /** The type of auto-memo that will be generated. */
  autoMemoType: AutoMemoType;
  /** The pre-defined custom text if the AutoMemoType is CUSTOM_TEXT. */
  customText?: InputMaybe<Scalars["String"]>;
}

/** [Airbnb-Demo] A condition on whether an is out of policy based on whether an attendee is a government official */
export interface PolicyGovOfficialAsAttendeeCondition {
  /**
   * A dummy field because objects need to have at least one field.
   * https://spec.graphql.org/October2021/#sec-Objects
   */
  _?: Maybe<Scalars["Boolean"]>;
}

/** [Airbnb-Demo] A input for the condition on whether an is out of policy based on whether an attendee is a government official */
export interface PolicyGovOfficialAsAttendeeConditionInput {
  /**
   * A dummy field because objects need to have at least one field.
   * https://spec.graphql.org/October2021/#sec-Objects
   */
  _?: InputMaybe<Scalars["Boolean"]>;
}

export interface PolicyIdentifierToStringValue {
  displayName?: Maybe<Scalars["String"]>;
  identifier?: Maybe<Scalars["String"]>;
}

export interface PolicyIdentifierToStringValueInput {
  displayName?: InputMaybe<Scalars["String"]>;
  identifier?: InputMaybe<Scalars["String"]>;
}

export enum PolicyIsUsed {
  /** Policy is not being used. */
  IS_NOT_USED = "IS_NOT_USED",
  /** Policy is being used. */
  IS_USED = "IS_USED",
}

/**
 * A condition regarding the state/province/administrative area where accommodations have been booked.
 * It should be read as `lodgingAdministrativeArea ${operator} ${states}`. Examples:
 * - lodgingAdministrativeArea IN ["CA", "PR"]
 * - lodgingAdministrativeArea NOT_IN ["QC", "SP"]
 */
export interface PolicyLodgingAdministrativeAreaCondition {
  operator: PolicySetElementOperator;
  states: Array<Scalars["String"]>;
}

/**
 * A condition regarding the state/province/administrative area where accommodations have been booked.
 * It should be read as `lodgingAdministrativeArea ${operator} ${states}`. Examples:
 * - lodgingAdministrativeArea IN ["CA", "PR"]
 * - lodgingAdministrativeArea NOT_IN ["QC", "SP"]
 */
export interface PolicyLodgingAdministrativeAreaConditionInput {
  operator: PolicySetElementOperator;
  states: Array<Scalars["String"]>;
}

/**
 * A condition regarding the average nightly rate for some accommodation.
 * It should be read as `lodgingAverageNightlyRage ${operator} ${rate}`. Example:
 * - lodgingAverageNightlyRate GREATER_THAN $200
 */
export interface PolicyLodgingAverageNightlyRateCondition {
  operator: PolicyNumberOperator;
  rate: FinancialAsset;
}

/**
 * A condition regarding the average nightly rate for some accommodation.
 * It should be read as `lodgingAverageNightlyRage ${operator} ${rate}`. Example:
 * - lodgingAverageNightlyRate GREATER_THAN $200
 */
export interface PolicyLodgingAverageNightlyRateConditionInput {
  operator: PolicyNumberOperator;
  rate: FinancialAssetInput;
}

/**
 * A condition regarding the city where accommodations have been booked.
 * It should be read as `lodgingCity ${operator} ${cities}`. Examples:
 * - lodgingCity IN ["New York", "Rio de Janeiro"]
 * - lodgingCity NOT_IN ["Paris", "London"]
 */
export interface PolicyLodgingCityCondition {
  cities: Array<Scalars["String"]>;
  operator: PolicySetElementOperator;
}

/**
 * A condition regarding the city where accommodations have been booked.
 * It should be read as `lodgingCity ${operator} ${cities}`. Examples:
 * - lodgingCity IN ["New York", "Rio de Janeiro"]
 * - lodgingCity NOT_IN ["Paris", "London"]
 */
export interface PolicyLodgingCityConditionInput {
  cities: Array<Scalars["String"]>;
  operator: PolicySetElementOperator;
}

/**
 * A condition regarding the star rating of booked accommodations.
 * It should be read as `lodgingStarRating ${operator} ${starRating}`. Example:
 * - lodgingStarRating GREATER_THAN 3
 */
export interface PolicyLodgingStarRatingCondition {
  operator: PolicyNumberOperator;
  starRating: Scalars["Int"];
}

/**
 * A condition regarding the star rating of booked accommodations.
 * It should be read as `lodgingStarRating ${operator} ${starRating}`. Example:
 * - lodgingStarRating GREATER_THAN 3
 */
export interface PolicyLodgingStarRatingConditionInput {
  operator: PolicyNumberOperator;
  starRating: Scalars["Int"];
}

/** [Airbnb-Demo] A condition on whether an is out of policy based on whether an attendee is a manager of the expense owner */
export interface PolicyManagerAsAttendeeCondition {
  /**
   * A dummy field because objects need to have at least one field.
   * https://spec.graphql.org/October2021/#sec-Objects
   */
  _?: Maybe<Scalars["Boolean"]>;
}

/** [Airbnb-Demo] A input for the condition on whether an is out of policy based on whether an attendee is a manager of the expense owner */
export interface PolicyManagerAsAttendeeConditionInput {
  /**
   * A dummy field because objects need to have at least one field.
   * https://spec.graphql.org/October2021/#sec-Objects
   */
  _?: InputMaybe<Scalars["Boolean"]>;
}

/**
 * A condition regarding the total amount spent with meals in a day.
 * It should be read as `mealPerDiemAmount ${operator} ${amount}`. Example:
 * - mealPerDiemAmount GREATER_THAN $75
 */
export interface PolicyMealPerDiemCondition {
  amount: FinancialAsset;
  operator: PolicyNumberOperator;
}

/**
 * A condition regarding the total amount spent with meals in a day.
 * It should be read as `mealPerDiemAmount ${operator} ${amount}`. Example:
 * - mealPerDiemAmount GREATER_THAN $75
 */
export interface PolicyMealPerDiemConditionInput {
  amount: FinancialAssetInput;
  operator: PolicyNumberOperator;
}

/**
 * A condition regarding the merchant category of an expense. Comparisons are always done using the
 * category IDs.
 * It should be read as `expenseMerchantCategory ${operation} ${merchantCategories}`. Example:
 * - expenseMerchantCategory IN [Electronics, Software]
 */
export interface PolicyMerchantCategoryCondition {
  merchantCategories: Array<MerchantCategory>;
  operator: PolicySetElementOperator;
}

/**
 * A condition regarding the merchant category of an expense. Comparisons are always done using the
 * category IDs.
 * It should be read as `expenseMerchantCategory ${operation} ${merchantCategories}`. Example:
 * - expenseMerchantCategory IN [Electronics, Software]
 */
export interface PolicyMerchantCategoryConditionInput {
  merchantCategoryIds: Array<Scalars["ID"]>;
  operator: PolicySetElementOperator;
}

/** A 'virtual' group of merchant categories, which combines multiple underlying merchant categories. */
export interface PolicyMerchantCategoryGroup {
  ids?: Maybe<Array<Scalars["ID"]>>;
  name: Scalars["String"];
}

/** A 'virtual' group of merchant categories, which combines multiple underlying merchant categories. */
export interface PolicyMerchantCategoryGroupInput {
  ids?: InputMaybe<Array<Scalars["ID"]>>;
  name: Scalars["String"];
}

/**
 * A condition regarding the merchant of an expense. The comparison is done by exactly matching the
 * name of the merchant.
 * It should be read as `expenseMerchant ${operator} ${merchants}`. Example:
 * - expenseMerchant IN [Apple, Amazon, Microsoft, Samsung]
 */
export interface PolicyMerchantCondition {
  merchantNames: Array<Scalars["String"]>;
  operator: PolicySetElementOperator;
}

/**
 * A condition regarding the merchant of an expense. The comparison is done by exactly matching the
 * name of the merchant.
 * It should be read as `expenseMerchant ${operator} ${merchants}`. Example:
 * - expenseMerchant IN [Apple, Amazon, Microsoft, Samsung]
 */
export interface PolicyMerchantConditionInput {
  merchantNames: Array<Scalars["String"]>;
  operator: PolicySetElementOperator;
}

/** A 'virtual' group of merchants, which combines multiple underlying merchants with a single name. */
export interface PolicyMerchantGroup {
  ids?: Maybe<Array<Scalars["ID"]>>;
  name: Scalars["String"];
}

export interface PolicyMultipleComparisonValues {
  values: Array<PolicyFieldValue>;
}

export interface PolicyMultipleComparisonValuesInput {
  values: Array<PolicyFieldValueOneOfInput>;
}

/** A single node in a policy graph. This interface is implemented by rules, rule groups. */
export interface PolicyNode {
  /**
   * The child nodes of this rule ( may be rules or more groups)
   * IDs are used so that clients don't have to make recursive queries.
   */
  childIds?: Maybe<Array<Scalars["ID"]>>;
  /** The unique ID of the node in this policy document */
  nodeId: Scalars["ID"];
}

/** Operators that can be applied to a pair of numbers. */
export enum PolicyNumberOperator {
  EQUALS = "EQUALS",
  GREATER_THAN = "GREATER_THAN",
  GREATER_THAN_OR_EQUAL = "GREATER_THAN_OR_EQUAL",
  LESS_THAN = "LESS_THAN",
  LESS_THAN_OR_EQUAL = "LESS_THAN_OR_EQUAL",
}

export interface PolicyNumberValue {
  value?: Maybe<Scalars["Decimal"]>;
}

export interface PolicyNumberValueInput {
  value?: InputMaybe<Scalars["Decimal"]>;
}

export interface PolicyOperatorOneOf {
  numberOperator?: Maybe<PolicyNumberOperator>;
  setElementOperator?: Maybe<PolicySetElementOperator>;
  setOperator?: Maybe<PolicySetOperator>;
}

export interface PolicyOperatorOneOfInput {
  numberOperator?: InputMaybe<PolicyNumberOperator>;
  setElementOperator?: InputMaybe<PolicySetElementOperator>;
  setOperator?: InputMaybe<PolicySetOperator>;
}

/** Available fields to order the PolicyConnection by. */
export interface PolicyOrderInput {
  field: SortablePolicyField;
  order: OrderByDirection;
}

/** A rule which limit's a user's per-day spending in specific categories */
export interface PolicyPerDiemRuleDefinition {
  /** If the threshold applies only to a set of merchant categories, they are listed here */
  includedMerchantCategories: Array<PolicyMerchantCategoryGroup>;
  /** If the threshold applies only to a set of merchants, they are listed here */
  includedMerchants: Array<PolicyMerchantGroup>;
  /** The rule is triggered if the user's expenses in a single day exceed this amount */
  limit: FinancialAsset;
}

/**
 * A condition on the percentage difference between a lowest logical fare and a booking.
 * It should be read as `percentDifferenceFromLowestLogicalFare ${operator} ${percentDifference}`.
 * Example:
 * - percentDifferenceFromLowestLogicalFare GREATER_THAN 20
 */
export interface PolicyPercentDifferenceFromLowestLogicalFareCondition {
  operator: PolicyNumberOperator;
  percentDifference: Scalars["Int"];
}

export interface PolicyPercentDifferenceFromLowestLogicalFareConditionInput {
  operator: PolicyNumberOperator;
  percentDifference: Scalars["Int"];
}

/**
 * A condition on the percentage difference between a median price and a booking.
 * It should be read as `percentDifferenceFromMedianPrice ${operator} ${percentDifference}`. Example:
 * - percentDifferenceFromMedianPrice GREATER_THAN 20
 */
export interface PolicyPercentDifferenceFromMedianPriceCondition {
  operator: PolicyNumberOperator;
  percentDifference: Scalars["Int"];
}

export interface PolicyPercentDifferenceFromMedianPriceConditionInput {
  operator: PolicyNumberOperator;
  percentDifference: Scalars["Int"];
}

/** A rule group with a set 'type' which corresponds to preset descriptions in clients */
export interface PolicyPredefinedRuleGroup {
  /** The 'type' of the rule group. Each type generally corresponds to a single kind of RequestAction. */
  type?: Maybe<PolicyRuleGroupType>;
}

export interface PolicyPreview {
  /** The rules contained in this policy. */
  rules?: Maybe<Array<PolicyRuleSet>>;
}

export interface PolicyPreviewInput {
  rules: Array<PolicyRuleSetInput>;
}

export interface PolicyQAInfo {
  /** The spend limit ID for the related budget */
  spendLimitId: Scalars["ID"];
}

export type PolicyReason = PolicyDocument;

/** Wrapper type to hold rules that have caused an action to be required. */
export interface PolicyReasonV2 {
  /**
   * Policy Rule Sets and Rules that have caused the action to be required.
   *
   * All Rule Sets and Rules that are not directly related to the action are filtered out. If a Rule
   * Set Set is returned and it is empty, that means the action resulted from no Rule matching and
   * the Rule Set's default action being output.
   */
  ruleSets?: Maybe<Array<PolicyRuleSet>>;
}

/** [Airbnb-Demo] A condition on whether an is out of policy based on whether the receipt has specific line item categories */
export interface PolicyReceiptItemCategoryCondition {
  lineItemCategories: Array<LineItemCategory>;
}

/** [Airbnb-Demo] A input for the condition on whether an is out of policy based on whether the receipt has specific line item categories */
export interface PolicyReceiptItemCategoryConditionInput {
  lineItemCategories: Array<LineItemCategory>;
}

/** A receipt requirement such as requiring the receipt to be itemized. */
export enum PolicyReceiptRequirement {
  ITEMIZED = "ITEMIZED",
  NONE = "NONE",
  /** @deprecated Deprecated. Use PolicyActionRequireExpenseReceiptValidation instead. */
  VALIDATED = "VALIDATED",
}

/** A condition concerning the result of validating an expense's receipt. */
export interface PolicyReceiptValidationCondition {
  /** The kinds of result to be allowed by the rule. */
  resultTypes: Array<PolicyReceiptValidationResultType>;
}

/** A condition that requires a specific set of fields to match. */
export interface PolicyReceiptValidationFieldCondition {
  matchesAmount?: Maybe<Scalars["Boolean"]>;
  matchesDate?: Maybe<Scalars["Boolean"]>;
  matchesMerchant?: Maybe<Scalars["Boolean"]>;
}

/**
 * A condition regarding the result of validating the receipts attached to an expense.
 * It should be read as `receiptValidationResult ${operator} ${resultTypes}`. Examples:
 * - receiptValidationResult IN [VALID, SKIPPED]
 * - receiptValidationResult NOT_IN [RECEIPTS_NOT_VALID, PROCESSING]
 */
export interface PolicyReceiptValidationResultCondition {
  operator?: Maybe<PolicySetElementOperator>;
  resultTypes: Array<PolicyReceiptValidationResultType>;
}

/**
 * A condition regarding the result of validating the receipts attached to an expense.
 * It should be read as `receiptValidationResult ${operator} ${resultTypes}`. Examples:
 * - receiptValidationResult IN [VALID, SKIPPED]
 * - receiptValidationResult NOT_IN [RECEIPTS_NOT_VALID, PROCESSING]
 */
export interface PolicyReceiptValidationResultConditionInput {
  operator: PolicySetElementOperator;
  resultTypes: Array<PolicyReceiptValidationResultType>;
}

export enum PolicyReceiptValidationResultType {
  PROCESSING = "PROCESSING",
  RECEIPTS_NOT_VALID = "RECEIPTS_NOT_VALID",
  SKIPPED = "SKIPPED",
  VERIFIED = "VERIFIED",
}

/** A rule that describes a condition based on the result of validating an expense's receipt. */
export interface PolicyReceiptValidationRuleDefinition {
  /**
   * A condition based on the result of specific fields. It is true if ANY element in the list matches
   * the validation output.
   */
  fieldConditions?: Maybe<Array<PolicyReceiptValidationFieldCondition>>;
  /** A condition based on the result of the validation as received from Receipts v2. */
  validationResult?: Maybe<PolicyReceiptValidationCondition>;
}

/**
 * A rule that deals with reimbursement submission.
 * Example: Reimbursements must be submitted up to 60 days after the purchase.
 */
export interface PolicyReimbursementRuleDefinition {
  submissionDeadlineDaysAfterPurchase?: Maybe<Scalars["Int"]>;
}

/**
 * A condition on the average daily rate for a rental car.
 * It should be read as `rentalCarAverageDailyRate ${operator} ${rate}`. Example:
 * - rentalCarAverageDailyRate GREATER_THAN $100
 */
export interface PolicyRentalCarAverageDailyRateCondition {
  operator: PolicyNumberOperator;
  rate: FinancialAsset;
}

/**
 * A condition on the average daily rate for a rental car.
 * It should be read as `rentalCarAverageDailyRate ${operator} ${rate}`. Example:
 * - rentalCarAverageDailyRate GREATER_THAN $100
 */
export interface PolicyRentalCarAverageDailyRateConditionInput {
  operator: PolicyNumberOperator;
  rate: FinancialAssetInput;
}

/** Known car classes when renting a car. */
export enum PolicyRentalCarClass {
  ANY = "ANY",
  COMPACT = "COMPACT",
  CONVERTIBLE = "CONVERTIBLE",
  ECONOMY = "ECONOMY",
  FULL_SIZE = "FULL_SIZE",
  LUXURY = "LUXURY",
  MID_SIZE = "MID_SIZE",
  MINI = "MINI",
  MINIVAN = "MINIVAN",
  OTHER = "OTHER",
  PICKUP = "PICKUP",
  PREMIUM = "PREMIUM",
  RECREATIONAL_VEHICLE = "RECREATIONAL_VEHICLE",
  SPECIAL = "SPECIAL",
  SPORTS = "SPORTS",
  STANDARD = "STANDARD",
  SUV = "SUV",
  VAN = "VAN",
}

/**
 * A condition regarding the class of a rental car.
 * It should be read as `rentalCarClass ${operator} ${carClasses}`. Example:
 * - rentalCarClass NOT_IN [ECONOMY, MINI, COMPACT]
 */
export interface PolicyRentalCarClassCondition {
  carClasses: Array<PolicyRentalCarClass>;
  operator: PolicySetElementOperator;
}

/**
 * A condition regarding the class of a rental car.
 * It should be read as `rentalCarClass ${operator} ${carClasses}`. Example:
 * - rentalCarClass NOT_IN [ECONOMY, MINI, COMPACT]
 */
export interface PolicyRentalCarClassConditionInput {
  carClasses: Array<PolicyRentalCarClass>;
  operator: PolicySetElementOperator;
}

/** An action meaning a list of attendees must be added to the expense. */
export interface PolicyRequireAttendeesInput {
  /** Whether or not the user should be required to input a company name for external attendees (default: false) */
  requireCompanyName?: InputMaybe<Scalars["Boolean"]>;
  /** Whether or not the user should be required to specify whether or not external attendees are government officials (default: false) */
  requireIsGovernmentOfficial?: InputMaybe<Scalars["Boolean"]>;
  /** Whether or not the user should be required to input a job title for external attendees (default: false) */
  requireTitle?: InputMaybe<Scalars["Boolean"]>;
}

/**
 * An action that means a Booking can be APPROVED before a given deadline. If not, it is automatically CANCELED.
 * DOES NOT apply to Expenses.
 */
export interface PolicyRequireBookingHardApprovalInput {
  /**
   * A dummy field because input objects must have at least one input field.
   * https://spec.graphql.org/October2021/#sec-Input-Objects
   */
  _?: InputMaybe<Scalars["Boolean"]>;
}

/**
 * An action that means a Booking can be REJECTED before a given deadline. If not, it is automatically APPROVED.
 * DOES NOT apply to Expenses.
 */
export interface PolicyRequireBookingSoftApprovalInput {
  /**
   * A dummy field because input objects must have at least one input field.
   * https://spec.graphql.org/October2021/#sec-Input-Objects
   */
  _?: InputMaybe<Scalars["Boolean"]>;
}

/** An action meaning a memo must be added to the expense. */
export interface PolicyRequireExpenseMemoInput {
  /**
   * A dummy field because input objects must have at least one input field.
   * https://spec.graphql.org/October2021/#sec-Input-Objects
   */
  _?: InputMaybe<Scalars["Boolean"]>;
}

/** An action meaning a receipt must be added to the expense. */
export interface PolicyRequireExpenseReceiptInput {
  /** Requirements about the receipt that must be provided to the customer. */
  requirements?: InputMaybe<Array<PolicyReceiptRequirement>>;
}

/** An action meaning uploaded receipts must be validated. */
export interface PolicyRequireExpenseReceiptValidationInput {
  /**
   * A dummy field because input objects must have at least one input field.
   * https://spec.graphql.org/October2021/#sec-Input-Objects
   */
  _?: InputMaybe<Scalars["Boolean"]>;
}

/** An action meaning an extended field must be added to the expense. */
export interface PolicyRequireExtendedFieldInput {
  /** The ID of the extended field. */
  fieldId?: InputMaybe<Scalars["ID"]>;
}

/** An action meaning an invoice must be added to the expense. */
export interface PolicyRequireInvoiceInput {
  /**
   * A dummy field because input objects must have at least one input field.
   * https://spec.graphql.org/October2021/#sec-Input-Objects
   */
  _?: InputMaybe<Scalars["Boolean"]>;
}

/** An action meaning a review is required. The object has no fields because the reviewers are to be specified in the review chain. */
export interface PolicyRequireReviewInput {
  /**
   * A dummy field because input objects must have at least one input field.
   * https://spec.graphql.org/October2021/#sec-Input-Objects
   */
  _?: InputMaybe<Scalars["Boolean"]>;
}

/** A set of reviewers that can perform a given review. An approval by ANY of them will cause the review to be completed. */
export interface PolicyReview {
  reviewerSet: Array<PolicyActionTarget>;
}

/** A set of reviewers that can perform a given review. An approval by ANY of them will cause the review to be completed. */
export interface PolicyReviewInput {
  reviewerSet: Array<PolicyActionTargetInput>;
}

export enum PolicyReviewStatus {
  APPROVED = "APPROVED",
  PENDING_REVIEW = "PENDING_REVIEW",
  REJECTED = "REJECTED",
}

/** A PolicyRule describes a Policy Engine Rule, which performs actions when expenses meet particular conditions. */
export interface PolicyRule extends PolicyNode {
  /** The actions that will be returned if the rule condition matches. */
  actions: Array<PolicyAction>;
  /**
   * The child nodes of this rule (may be rules or more groups).
   * Note that sub-rules are not implemented yet (dec-2021), even though the API supports them.
   */
  childIds?: Maybe<Array<Scalars["ID"]>>;
  /** if set, this description will override the metadata-generated rule description in the frontend. */
  customDescription?: Maybe<PolicyRuleDescription>;
  /** An object which defines the rule's conditions */
  definition?: Maybe<PolicyRuleDefinition>;
  /** When specified, this rule only applies to the specific types of expense. */
  expenseTypes: Array<ExpenseType>;
  /**
   * When true, this rule should be displayed as a "prohibition" (i.e. you may not spend)
   * instead of advisory (i.e. these will be flagged for review)
   */
  isProhibition?: Maybe<Scalars["Boolean"]>;
  /** The unique ID of the node in this policy document. May also be the ID of the Rule. */
  nodeId: Scalars["ID"];
}

/** All possible forms of metadata-based rule-definition */
export type PolicyRuleDefinition =
  | PolicyCustomRuleDefinition
  | PolicyPerDiemRuleDefinition
  | PolicyReceiptValidationRuleDefinition
  | PolicyReimbursementRuleDefinition
  | PolicyStandardRuleDefinition
  | PolicyVendorsForCategoryRuleDefinition;

/** A hardcoded rule description. */
export interface PolicyRuleDescription {
  /** A hardcoded description to explain a rule to the user. */
  overrideDescription?: Maybe<Scalars["String"]>;
}

/** A PolicyRuleGroup references rules and sub-groups. PolicyRuleGroups are used both for top-level categories, and for subcategories. */
export interface PolicyRuleGroup extends PolicyNode {
  /** The child nodes of this group (may be rules or more groups) */
  childIds: Array<Scalars["ID"]>;
  /** The type of group, or null */
  description?: Maybe<PolicyRuleGroupDescription>;
  /**
   * The unique ID of the node in this policy document.
   * May be the ID of a Rule, or a Policy, or even a generated ID, depending
   * on how Groups are implemented.
   */
  nodeId: Scalars["ID"];
}

/** PolicyRuleGroups either have a predefined type, or a custom name */
export type PolicyRuleGroupDescription =
  | CustomRuleGroup
  | PolicyPredefinedRuleGroup;

export enum PolicyRuleGroupType {
  /** A group that is completely defined by the caller. Used only for input. */
  CUSTOM = "CUSTOM",
  /** A group for rules which define when memos are required */
  MEMOS = "MEMOS",
  /** A group for rules which define when receipts are required */
  RECEIPTS = "RECEIPTS",
  /** A group for rules prohibit certain kinds of expenses */
  RESTRICTIONS = "RESTRICTIONS",
  /** A group for rules which flag expenses for review */
  REVIEW = "REVIEW",
  /** A group to represent a root policy that calls many others */
  ROOT = "ROOT",
  /** A group for rules which monitor travel expenses */
  TRAVEL = "TRAVEL",
}

/** Additional information about a rule. */
export interface PolicyRuleMetadata {
  /** Additional description information to be set by and shown to users. */
  customDescription?: Maybe<PolicyCustomDescription>;
  /** Google Places API ID used for FE purposes. Not used in rule evaluation. */
  googlePlacesId?: Maybe<Scalars["String"]>;
  /**
   * When true, this rule should be displayed as a "prohibition" (i.e. you may not spend)
   * instead of advisory (i.e. these will be flagged for review).
   */
  isProhibition?: Maybe<Scalars["Boolean"]>;
}

/** Additional information about a rule. */
export interface PolicyRuleMetadataInput {
  /** Additional description information to be set by and shown to users. */
  customDescription?: InputMaybe<PolicyCustomDescriptionInput>;
  /** Google Places API ID used for FE purposes. Not used in rule evaluation. */
  googlePlacesId?: InputMaybe<Scalars["String"]>;
  /**
   * When true, this rule should be displayed as a "prohibition" (i.e. you may not spend)
   * instead of advisory (i.e. these will be flagged for review).
   */
  isProhibition?: InputMaybe<Scalars["Boolean"]>;
}

/**
 * A logical grouping of rules. Rules in a set will be evaluated in order and are match-first. If no
 * rule matches, a rule set will output its default actions. A PolicyRuleSet with no rules is allowed
 * and will always output its default action.
 */
export interface PolicyRuleSet {
  defaultActions: PolicyActionSet;
  /** Additional information about this rule set that needs to be stored and retrieved with it. */
  metadata?: Maybe<PolicyRuleSetMetadata>;
  rules?: Maybe<Array<PolicyRuleV2>>;
}

/**
 * A logical grouping of rules. Rules in a set will be evaluated in order and are match-first. If no
 * rule matches, a rule set will output its default actions. A PolicyRuleSet with no rules is allowed
 * and will always output its default action.
 */
export interface PolicyRuleSetInput {
  defaultActions: PolicyActionSetInput;
  /** Additional information about this rule set that needs to be stored and retrieved with it. */
  metadata?: InputMaybe<PolicyRuleSetMetadataInput>;
  rules?: InputMaybe<Array<PolicyRuleV2Input>>;
}

/** Additional information about a rule set. */
export interface PolicyRuleSetMetadata {
  /** Additional description information to be set by and shown to users. */
  customDescription?: Maybe<PolicyCustomDescription>;
  /**
   * An opaque string that is set by the client that creates the policy to identify the kind of rule
   * set. The frontend uses this as a hint to determine whether it understands the rules in the rule
   * set, but the backend does not interpret this value in any way.
   */
  ruleSetKind?: Maybe<Scalars["String"]>;
}

/** Additional information about a rule set. */
export interface PolicyRuleSetMetadataInput {
  /** Additional description information to be set by and shown to users. */
  customDescription?: InputMaybe<PolicyCustomDescriptionInput>;
  /**
   * An opaque string that is set by the creator of the policy to identify the kind of rule set. The
   * frontend uses this as a hint to determine whether it understands the rules in the rule set, but
   * the backend does not interpret this value in any way.
   */
  ruleSetKind?: InputMaybe<Scalars["String"]>;
}

/**
 * A rule of the policy. It is composed of a condition and a set of actions to be applied in case the
 * condition is satisfied.
 */
export interface PolicyRuleV2 {
  /** The actions that should be performed if the rule condition matches. */
  actions: PolicyActionSet;
  /** The condition that determines if some actions should be performed. */
  condition: PolicyCondition;
  /** Human readable messages for a rule in various contexts */
  descriptionMessages?: Maybe<PolicyDescriptions>;
  /** Additional information about this rule that needs to be stored and retrieved with it. */
  metadata?: Maybe<PolicyRuleMetadata>;
}

/**
 * A rule of the policy. It is composed of a condition and a set of actions to be applied in case the
 * condition is satisfied.
 */
export interface PolicyRuleV2Input {
  /** The actions that should be requested if the rule condition matches. */
  actions: PolicyActionSetInput;
  /** The condition that determines if some actions should be performed. */
  condition: PolicyConditionInput;
  /** Additional information about this rule that needs to be stored and retrieved with it. */
  metadata?: InputMaybe<PolicyRuleMetadataInput>;
}

/**
 * Policies may have rules with "exceptions" for different users, roles, etc. In some contexts, we may want to fetch all
 * the rules (e.g. an admin updating the policy), while in other contexts we may want to filter out rules and exceptions
 * that aren't relevant for an individual user (e.g. a user viewing their own spend limit's policy).
 */
export enum PolicyRulesFilter {
  ALL_RULES = "ALL_RULES",
  /**
   * Passing [ONLY_RELEVANT_FOR_REQUESTER] to queries like [Policy.definition] will yield [ExpensePolicy] values with no
   * references to [PolicyExceptionScope]. For example, any returned [ExpensePolicyMerchantReviewRule] will have an empty
   * [exceptions] list, and the "top-level" [ExpensePolicyMerchantReviewRule] will be filled in with values most relevant
   * to the requesting user.
   */
  ONLY_RELEVANT_FOR_REQUESTER = "ONLY_RELEVANT_FOR_REQUESTER",
}

/**
 * A condition regarding the number of seconds that have passed since an expense has happened.
 * It should be read as `secondsSincePurchase ${operator} ${value}. Example:
 * - secondsSincePurchase GREATER_THAN 2,592,000    # 2,592,000 seconds = 30 days
 */
export interface PolicySecondsSincePurchaseCondition {
  operator?: Maybe<PolicyNumberOperator>;
  value?: Maybe<Scalars["Int"]>;
}

/**
 * A condition regarding the number of seconds that have passed since an expense has happened.
 * It should be read as `secondsSincePurchase ${operator} ${value}. Example:
 * - secondsSincePurchase GREATER_THAN 2,592,000    # 2,592,000 seconds = 30 days
 */
export interface PolicySecondsSincePurchaseConditionInput {
  operator: PolicyNumberOperator;
  value: Scalars["Int"];
}

export interface PolicySectionCitation extends Citation {
  /** Positions of the policy citation in the text. */
  citationPositions: Array<CitationPosition>;
  /** index of the policy citation e.g. [1], [2] */
  index: Scalars["Int"];
  /** Name describing the policy citation. */
  name: Scalars["String"];
  /**
   * Name(s) of nested section(s) used to identify the lowest-level section cited. This is a list to allow variable
   * levels of depth and specificity of the citation.
   */
  policySectionNames: Array<Scalars["String"]>;
}

/** Operators that can be applied to an element and a set. */
export enum PolicySetElementOperator {
  IN = "IN",
  NOT_IN = "NOT_IN",
}

/** Operators that can be applied to two sets. */
export enum PolicySetOperator {
  CONTAINS_ALL_OF = "CONTAINS_ALL_OF",
  CONTAINS_ANY_OF = "CONTAINS_ANY_OF",
  CONTAINS_NONE_OF = "CONTAINS_NONE_OF",
}

export interface PolicySingleComparisonValue {
  value: PolicyFieldValue;
}

export interface PolicySingleComparisonValueInput {
  value: PolicyFieldValueOneOfInput;
}

export enum PolicySpecSectionStatus {
  DELETED = "DELETED",
  DRAFT = "DRAFT",
  PUBLISHED = "PUBLISHED",
}

/** An operation to be used for a list of subjects. */
export enum PolicyStandardRuleConditionOperator {
  ALL_OF = "ALL_OF",
  ANY_OF = "ANY_OF",
  NONE_OF = "NONE_OF",
}

/** A rule which results in an action when all of its conditions are met */
export interface PolicyStandardRuleDefinition {
  /** If the threshold applies only to a set of merchant categories, they are listed here */
  merchantCategories: Array<PolicyMerchantCategoryGroup>;
  /** Which operation to apply for the list of merchant categories. */
  merchantCategoriesCondition: PolicyStandardRuleConditionOperator;
  /** If the threshold applies only to a set of merchant, they are listed here */
  merchants: Array<PolicyMerchantGroup>;
  /** Which operation to apply for the list of merchants. */
  merchantsCondition: PolicyStandardRuleConditionOperator;
  /** The rule is triggered if an expense amount is over this amount */
  threshold?: Maybe<FinancialAsset>;
}

export enum PolicyStatus {
  CREATED = "CREATED",
  DISABLED = "DISABLED",
}

export interface PolicyStringValue {
  value?: Maybe<Scalars["String"]>;
}

export interface PolicyStringValueInput {
  value?: InputMaybe<Scalars["String"]>;
}

/** Possible change/refund rules for a ticket (usually a flight ticket) to be used within a policy. */
export enum PolicyTicketChangeRules {
  ALLOWED_WITHOUT_FEE = "ALLOWED_WITHOUT_FEE",
  ALLOWED_WITH_FEE = "ALLOWED_WITH_FEE",
  NOT_ALLOWED = "NOT_ALLOWED",
}

/** Known cabin classes for train trips. */
export enum PolicyTrainCabinClass {
  BUSINESS = "BUSINESS",
  FIRST = "FIRST",
  STANDARD = "STANDARD",
}

/**
 * A condition regarding the cabin class of a train ticket.
 * It should be read as `trainCabinClass ${operator} ${cabinClasses}`. Example:
 * - trainCabinClass IN [FIRST]
 */
export interface PolicyTrainCabinClassCondition {
  cabinClasses: Array<PolicyTrainCabinClass>;
  operator: PolicySetElementOperator;
}

/**
 * A condition regarding the cabin class of a train ticket.
 * It should be read as `trainCabinClass ${operator} ${cabinClasses}`. Example:
 * - trainCabinClass IN [FIRST]
 */
export interface PolicyTrainCabinClassConditionInput {
  cabinClasses: Array<PolicyTrainCabinClass>;
  operator: PolicySetElementOperator;
}

/**
 * A condition regarding the duration of a train trip.
 * It should be read as `trainTripDuration ${operator} ${duration}`. Example:
 * - trainTripDuration LESS_THAN 360 minutes
 */
export interface PolicyTrainTripDurationCondition {
  durationMinutes: Scalars["Int"];
  operator: PolicyNumberOperator;
}

/**
 * A condition regarding the duration of a train trip.
 * It should be read as `trainTripDuration ${operator} ${duration}`. Example:
 * - trainTripDuration LESS_THAN 360 minutes
 */
export interface PolicyTrainTripDurationConditionInput {
  durationMinutes: Scalars["Int"];
  operator: PolicyNumberOperator;
}

/**
 * A condition regarding the destination country of a trip, flight, train, etc.
 * It should be read as `travelDestinationCountryCode ${operator} ${destinationCountryCodes}`. Example:
 * - travelDestinationCountryCode IN ["CHN", "RUS"]
 */
export interface PolicyTravelDestinationCountryCodeCondition {
  destinationCountryCodes: Array<Scalars["String"]>;
  operator: PolicySetElementOperator;
}

/**
 * A condition regarding the destination country of a trip, flight, train, etc.
 * It should be read as `travelDestinationCountryCode ${operator} ${destinationCountryCodes}`. Example:
 * - travelDestinationCountryCode IN ["CHN", "RUS"]
 */
export interface PolicyTravelDestinationCountryCodeConditionInput {
  destinationCountryCodes: Array<Scalars["String"]>;
  operator: PolicySetElementOperator;
}

/** Types of destination based on whether the trip crosses national borders. */
export enum PolicyTravelDestinationType {
  DOMESTIC = "DOMESTIC",
  INTERNATIONAL = "INTERNATIONAL",
}

/**
 * A condition regarding the kind of destination in a trip, flight, train, etc.
 * It should be read as `travelDestinationType IS ${destinationType}`. Example:
 * - travelDestinationType IS DOMESTIC
 */
export interface PolicyTravelDestinationTypeCondition {
  destinationType: PolicyTravelDestinationType;
}

/**
 * A condition regarding the kind of destination in a trip, flight, train, etc.
 * It should be read as `travelDestinationType IS ${destinationType}`. Example:
 * - travelDestinationType IS DOMESTIC
 */
export interface PolicyTravelDestinationTypeConditionInput {
  destinationType: PolicyTravelDestinationType;
}

/**
 * A condition regarding the added duration of all flights in a trip leg.
 * It should be read as `tripLegFlightDuration ${operator} ${durationMinutes}`. Example:
 * - tripLegFlightDuration LESS_THAN 360
 */
export interface PolicyTripLegFlightDurationCondition {
  durationMinutes: Scalars["Int"];
  operator: PolicyNumberOperator;
}

/**
 * A condition regarding the added duration of all flights in a trip leg.
 * It should be read as `tripLegFlightDuration ${operator} ${durationMinutes}`. Example:
 * - tripLegFlightDuration LESS_THAN 360
 */
export interface PolicyTripLegFlightDurationConditionInput {
  durationMinutes: Scalars["Int"];
  operator: PolicyNumberOperator;
}

/**
 * A condition regarding the added duration of all trains in a trip leg.
 * It should be read as `tripLegTrainTripDuration ${operator} ${durationMinutes}`. Example:
 * - tripLegTrainTripDuration LESS_THAN 360
 */
export interface PolicyTripLegTrainDurationCondition {
  durationMinutes: Scalars["Int"];
  operator: PolicyNumberOperator;
}

/**
 * A condition regarding the added duration of all trains in a trip leg.
 * It should be read as `tripLegTrainTripDuration ${operator} ${durationMinutes}`. Example:
 * - tripLegTrainTripDuration LESS_THAN 360
 */
export interface PolicyTripLegTrainDurationConditionInput {
  durationMinutes: Scalars["Int"];
  operator: PolicyNumberOperator;
}

export enum PolicyType {
  /** Legacy policy type */
  RAW = "RAW",
  /** Policies 3.0 section type */
  SECTION = "SECTION",
}

/** Possible options of expense VAT eligibility */
export enum PolicyVatEligibility {
  ELIGIBLE = "ELIGIBLE",
  INELIGIBLE = "INELIGIBLE",
}

/**
 * Condition that checks expenses eligibility to be VAT reclaimable based on
 * automated systems opinion (that considers expense location and spending entity)
 */
export interface PolicyVatEligibilityCondition {
  eligibility: PolicyVatEligibility;
}

export interface PolicyVatEligibilityConditionInput {
  eligibility: PolicyVatEligibility;
}

/** Possible options of expense VAT eligibility based on the input (tax) value */
export enum PolicyVatInputValueEligibility {
  ELIGIBLE = "ELIGIBLE",
  INELIGIBLE = "INELIGIBLE",
}

/**
 * Condition that checks expenses eligibility to be VAT reclaimable
 * based on the user's VAT tax value input
 */
export interface PolicyVatInputValueEligibilityCondition {
  eligibility: PolicyVatInputValueEligibility;
}

export interface PolicyVatInputValueEligibilityConditionInput {
  eligibility: PolicyVatInputValueEligibility;
}

/**
 * A rule which specifies permitted merchants for specific categories.
 * E.g. Airfare must be booked in TravelBank.
 */
export interface PolicyVendorsForCategoryRuleDefinition {
  /** The rule's actions are triggered when expenses in the categories are made with merchants not in this list */
  allowedMerchantsForCategory: Array<PolicyMerchantGroup>;
  /** The category for which we are specifying merchants */
  merchantCategory?: Maybe<PolicyMerchantCategoryGroup>;
}

export enum PolicyViewFilter {
  /** Passing [APPLIED_POLICY] to queries will return PolicySpec with the sections and rules that apply to expenses */
  APPLIED_POLICY = "APPLIED_POLICY",
  /**
   * Passing [POLICY_BUILDER] to queries will return all the information about PolicySpec that is viewable from
   * policy builder
   */
  POLICY_BUILDER = "POLICY_BUILDER",
}

/** Workflow types which a policy can be eligible for */
export enum PolicyWorkflowType {
  /** Policy is eligible for Bill pay */
  BILLPAY_BILLS = "BILLPAY_BILLS",
  /** Policy is eligible for Brex travel */
  TRAVEL = "TRAVEL",
}

export interface PositivePayAccountSetting extends Node {
  achCompanyId: Scalars["String"];
  deletedAt?: Maybe<Scalars["Time"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  name: Scalars["String"];
  status: PositivePayAccountSettingStatus;
}

export interface PositivePayAccountSettingConnection {
  edges?: Maybe<Array<Maybe<PositivePayAccountSettingEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"];
}

export interface PositivePayAccountSettingEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<PositivePayAccountSetting>;
}

export enum PositivePayAccountSettingStatus {
  BLOCKED = "BLOCKED",
  FAVORITE = "FAVORITE",
}

export enum PositivePayStatus {
  BLOCKED = "BLOCKED",
  FAVORITE = "FAVORITE",
  REGULAR = "REGULAR",
}

export interface PrepayMetadata {
  fundingSourceId?: Maybe<Scalars["String"]>;
  percentageThreshold: Scalars["Int"];
}

export interface PreviewLimitGroupMembersInput {
  /** The default fields for all members of the limit group */
  defaultFields?: InputMaybe<DefaultOverridableLimitFields>;
  /** The member condition of the limit group */
  memberCondition?: InputMaybe<MemberConditionInput>;
  /** The members of the limit group */
  members?: InputMaybe<Array<GroupMemberInput>>;
  /** The overrides of the limit group on eligible fields */
  overrides?: InputMaybe<CreateLimitGroupOverrides>;
}

/** Input for previewing a limit group membership and its override changes */
export interface PreviewLimitGroupMembershipInput {
  /** The default limit fields from the creation/edit form */
  defaultLimitFields: CreateSpendLimitBlueprintFields;
  /** Flag if there are membership changes. */
  hasMembershipChanges: Scalars["Boolean"];
  /** Flag if there are override changes */
  hasOverrideChanges: Scalars["Boolean"];
  /** The limit group id. Should be passed if this is an update, so existing membership can be compared */
  id?: InputMaybe<Scalars["ID"]>;
  /** The override rules being set. If null, will default to existing limit group overrides, or none if it's a new limit group */
  limitGroupOverrideRules?: InputMaybe<CreateLimitGroupOverrides>;
  /** The new member condition of the limit group. */
  memberCondition?: InputMaybe<MemberConditionInput>;
  /** The new manual members of the limit group */
  members?: InputMaybe<Array<GroupMemberInput>>;
}

/** Custom user group used during the migration of role-based exceptions */
export interface PreviewUserGroup {
  /**
   * Member condition serialized as JSON. Callers don't know the structure of the member condition ahead of time, so we
   * need to return this field as a String instead of a GraphQL type.
   */
  memberCondition?: Maybe<Scalars["String"]>;
  /** Group members */
  members?: Maybe<PreviewUserGroupMemberConnection>;
}

export enum PreviewUserGroupAssignmentType {
  MANUAL_EXCLUDE = "MANUAL_EXCLUDE",
  MANUAL_INCLUDE = "MANUAL_INCLUDE",
  MEMBER_CONDITION = "MEMBER_CONDITION",
}

export interface PreviewUserGroupMember {
  assignmentType: PreviewUserGroupAssignmentType;
  user: User;
}

export interface PreviewUserGroupMemberConnection extends Connection {
  edges: Array<PreviewUserGroupMemberEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface PreviewUserGroupMemberEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<PreviewUserGroupMember>;
}

export interface PreviewVendorFileMatchesFilterInput {
  /** The spend migration import ID to preview vendor file matches for. */
  spendMigrationImportId: Scalars["ID"];
}

export interface PreviousBudget {
  budget: Budget;
}

export type PreviousExpenseData = PreviousBudget;

export interface Primitive {
  groupAttribute?: Maybe<GroupAttribute>;
  /** A primitive that is returned from a fuzzy search. */
  type: PrimitiveType;
  user?: Maybe<User>;
}

/** Primitive connection for pagination */
export interface PrimitiveConnection extends Connection {
  edges: Array<PrimitiveEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

/** Primitive edge for primitive connection */
export interface PrimitiveEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<Primitive>;
}

export interface PrimitiveFuzzySearchFilterInput {
  /** The primitive types we want to filter by in primitive fuzzy search. */
  primitiveTypes?: InputMaybe<Array<PrimitiveType>>;
  /**  defaults to NOT_IN */
  primitiveTypesOperator?: InputMaybe<QueryListOperator>;
}

export enum PrimitiveType {
  COST_CENTER = "COST_CENTER",
  DEPARTMENT = "DEPARTMENT",
  LEGAL_ENTITY = "LEGAL_ENTITY",
  LOCATION = "LOCATION",
  MANAGER = "MANAGER",
  /** The type of the primitive we are returning or querying for. */
  TITLE = "TITLE",
  USER = "USER",
}

export interface ProcessAssistantMessageError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface ProcessInvoiceAndCreateBillInput {
  assetId: Scalars["ID"];
  clientMutationId: Scalars["String"];
  uploadSessionId: Scalars["String"];
}

export interface ProcessInvoiceAndCreateBillPayload {
  bill: Bill;
  clientMutationId: Scalars["String"];
}

export interface ProcessInvoiceInput {
  assetId: Scalars["ID"];
  billId?: InputMaybe<Scalars["ID"]>;
  clientMutationId: Scalars["String"];
}

export interface ProcessInvoicePayload {
  clientMutationId: Scalars["String"];
  extractedBillFields: ExtractedBillFields;
}

export interface ProcessRequestInput {
  /** clientMutationId, used as idempotency key */
  clientMutationId: Scalars["String"];
  /** The ID of the request to process. */
  id: Scalars["ID"];
}

export interface ProcessRequestResult extends MutationResult {
  /** A list of user errors for mutation responses. Clients should always request this field when performing mutations */
  errors?: Maybe<Array<RequestMutationError>>;
}

export interface ProcessUserMessageViaAssistantInput {
  /**
   * The unique ID of the chat session.
   * Set to null to initiate a new session.
   */
  chatSessionId?: InputMaybe<Scalars["ID"]>;
  /** The free-text message sent by the user. */
  message: Scalars["String"];
  /**
   * The details in `userMessageInfo` are used to decide
   * which agent the message should be routed to.
   */
  userMessageInfo?: InputMaybe<UserMessageInfo>;
}

export interface ProcessUserMessageViaAssistantResponse {
  /** The unique ID of the chat session. Generated by the server */
  chatSessionId: Scalars["ID"];
  /** A list of NEW messages to be shown to the user in the order they should be displayed. */
  messages: Array<AssistantMessage>;
}

export interface ProcessUserMessageViaAssistantResult extends MutationResult {
  errors?: Maybe<Array<ProcessAssistantMessageError>>;
  result?: Maybe<ProcessUserMessageViaAssistantResponse>;
}

export interface ProductBrandingAsset {
  id: Scalars["ID"];
  identifier: ProductBrandingIdentifier;
  resource?: Maybe<Asset>;
}

export enum ProductBrandingIdentifier {
  APPLICATION_SUBMITTED_IMAGE = "APPLICATION_SUBMITTED_IMAGE",
  DASHBOARD_SETUP_AUTO_PAY_CARD_IMAGE = "DASHBOARD_SETUP_AUTO_PAY_CARD_IMAGE",
  DATAGRID_EMPTY_CARDS_LIST_IMAGE = "DATAGRID_EMPTY_CARDS_LIST_IMAGE",
  ONBOARDING_WELCOME_IMAGE = "ONBOARDING_WELCOME_IMAGE",
}

export interface ProductConfig {
  /**
   * Data relevant to the Configuration Home surface.
   * This should NOT be used for gating
   */
  configurationHome?: Maybe<ProductConfigurationHome>;
  /** DEPRECATED - Use featuresV2 instead */
  features: ProductConfigFeatures;
  /** Feature enablement data that can be used to gate feature access */
  featuresV2: ProductConfigFeaturesV2;
  /** List of toggle enablement statuses */
  toggles?: Maybe<Array<ProductConfigToggleEnablementV2>>;
}

export interface ProductConfigtogglesArgs {
  betaOnly?: InputMaybe<Scalars["Boolean"]>;
  toggles?: InputMaybe<Array<ProductConfigToggle>>;
}

export interface ProductConfigAuditLogFeatures {
  /**  Access to audit trail page */
  auditLogs: ProductConfigFeatureEnablement;
}

export interface ProductConfigBankingFeatures {
  /** Access to adding funds */
  addFunds: ProductConfigFeatureEnablement;
  /** Access to creating an account */
  createAccount: ProductConfigFeatureEnablement;
  /** Access to depositing cheques */
  depositCheques: ProductConfigFeatureEnablement;
  /** Access to sending funds */
  sendFunds: ProductConfigFeatureEnablement;
}

export interface ProductConfigBillPayFeatures {
  /** Access to the Bill Pay batch payment feature */
  payableBatchPayment: ProductConfigFeatureEnablement;
  /** Basic billpay access including bill CRUD, basic policies and sending BBA payment */
  payableBillAccess: ProductConfigFeatureEnablement;
  /** Paying bills via check from external bank account */
  payablePaymentEbaCheck: ProductConfigFeatureEnablement;
  /** Paying bills via domestic ACH from external bank account */
  payablePaymentEbaDomesticAch: ProductConfigFeatureEnablement;
  /** Paying bills via domestic wire from external bank account */
  payablePaymentEbaDomesticWire: ProductConfigFeatureEnablement;
  /** Paying bills via international ACH from external bank account */
  payablePaymentEbaInternationalAch: ProductConfigFeatureEnablement;
  /** Paying bills via international wire from external bank account */
  payablePaymentEbaInternationalWire: ProductConfigFeatureEnablement;
  /** (DEPRECATED) Paying bills via domestic wire from external bank account */
  payablePaymentEbaWire: ProductConfigFeatureEnablement;
  /** Accessing to procurement policy including vendor rules, multi-step approvals etc */
  payableProcurementPolicy: ProductConfigFeatureEnablement;
  /** Spend limit requirement for bill submission */
  payableSpendLimitRequirement: ProductConfigFeatureEnablement;
}

export interface ProductConfigCardFeatures {
  /** Co-Branded Cards */
  coBrandedCards: ProductConfigFeatureEnablement;
  /** Expedited shipping on card shipments */
  employeeExpeditedShipping: ProductConfigFeatureEnablement;
  /** Internal card access */
  internalCardAccess: ProductConfigFeatureEnablement;
  /** Spend Migration */
  spendMigration: ProductConfigFeatureEnablement;
}

/**
 * IMPORTANT: DO NOT USE THIS FOR GATING FEATURES. Please use `featuresV2` to gate based on entitlements instead.
 * See https://brexhq.atlassian.net/wiki/spaces/ENGDOC/pages/2084569810/Empower+Feature+Gating+-+Quick+Start+Guide for more info
 */
export enum ProductConfigEmpowerTier {
  EMBEDDED = "EMBEDDED",
  ENTERPRISE = "ENTERPRISE",
  ESSENTIALS = "ESSENTIALS",
  ESSENTIALS_V2 = "ESSENTIALS_V2",
  PLUS = "PLUS",
  PREMIUM = "PREMIUM",
  P_CARD = "P_CARD",
}

export enum ProductConfigEnablementStatus {
  DISABLED = "DISABLED",
  ENABLED = "ENABLED",
  PENDING = "PENDING",
}

export interface ProductConfigExpenseManagementFeatures {
  /** Enables users to opt in to accidental decline protection */
  accidentalDeclineProtection: ProductConfigFeatureEnablement;
  /** Access Accounting tab */
  accountingAccess: ProductConfigFeatureEnablement;
  /** Enables viewing and editing accrual date of expenses */
  accountingAccrualDate: ProductConfigFeatureEnablement;
  /** Enables accounting accruals */
  accountingAccruals: ProductConfigFeatureEnablement;
  /** Custom accounting fields set-up and employee editing */
  accountingCustomFields: ProductConfigFeatureEnablement;
  /** Advanced accounting mapping rules (customized rules, expense types + addendums + automation) */
  accountingCustomRules: ProductConfigFeatureEnablement;
  /** Enables users to customize fields values visibility */
  accountingFieldValueVisibility: ProductConfigFeatureEnablement;
  /** Enables bulk triggered AJ suggestions, AI powered suggestions in AJ, and AI powered suggestions in FTUX mappings */
  accountingSuggestions: ProductConfigFeatureEnablement;
  /** Accounting Integrations: Netsuite, Quickbooks Desktop */
  advancedAccountingIntegrations: ProductConfigFeatureEnablement;
  /** Enables users to use approval chains advanced features like auto approve and nested chains */
  advancedApprovalChains: ProductConfigFeatureEnablement;
  /** Auto-generated memos */
  advancedAutoGeneratedMemos: ProductConfigFeatureEnablement;
  /** Advanced auto-generated receipts (Ethoca) */
  advancedAutoGeneratedReceipts: ProductConfigFeatureEnablement;
  /** The settings grouped under "Advanced budget controls" in the budget create/edit flow */
  advancedBudgetControls: ProductConfigFeatureEnablement;
  /** Budget advanced restrictions (e.g., budget card only spend) */
  advancedBudgetRestrictions: ProductConfigFeatureEnablement;
  /** Advanced budget templates for spend / travel workflows Eg: Stipend, Travel, procurement templates */
  advancedBudgetTemplates: ProductConfigFeatureEnablement;
  /** Access to advanced filtering options in Expenses tab */
  advancedExpenseFilters: ProductConfigFeatureEnablement;
  /** Advanced policy customization (eg per diem, hotel dailies, purchase categories) */
  advancedPolicyCustomization: ProductConfigFeatureEnablement;
  /** Can use AI assisted review */
  aiAssistedReview: ProductConfigFeatureEnablement;
  /** Use natural language to filter/group expenses in the expenses table */
  aiSmartFiltering: ProductConfigFeatureEnablement;
  /** Auto-compliance checks for purchases (eg check receipts have no alcohol) */
  autoComplianceChecks: ProductConfigFeatureEnablement;
  /** Enables users to set up rules to automatically invite users based on user attributes */
  autoInviteSettings: ProductConfigFeatureEnablement;
  /** Enables users to opt in to auto-limit assignment of expenses */
  autoLimitAssignment: ProductConfigFeatureEnablement;
  /** Basic Expense Management */
  basicExpenseManagement: ProductConfigFeatureEnablement;
  /** Has the Brex Assistant product enabled */
  brexAssistant: ProductConfigFeatureEnablement;
  /** Has the Brex Assistant product default on */
  brexAssistantDefaultOn: ProductConfigFeatureEnablement;
  /** Budget nesting / budget hierarchy / parent budgets */
  budgetNesting: ProductConfigFeatureEnablement;
  /** Request a new budget */
  budgetRequests: ProductConfigFeatureEnablement;
  /** Bulk budget management */
  bulkBudgetManagement: ProductConfigFeatureEnablement;
  /** Bulk Invite */
  bulkInvite: ProductConfigFeatureEnablement;
  /** Access Cards & Limits tab */
  cardsAndLimitsAccess: ProductConfigFeatureEnablement;
  /** Compliance Rating user-facing feature, allows users to see a score on how compliant they are being with expenses */
  complianceRating: ProductConfigFeatureEnablement;
  /** Compliance Reporting */
  complianceReporting: ProductConfigFeatureEnablement;
  /** Custom budget templates, including customized templates */
  customBudgetTemplates: ProductConfigFeatureEnablement;
  /** Customized approval chains - Card expenses */
  customCardExpensesApprovalChains: ProductConfigFeatureEnablement;
  /** Deadlines */
  deadlines: ProductConfigFeatureEnablement;
  /** Delegated Budget management (selecting a budget owner) */
  delegatedBudgetManagement: ProductConfigFeatureEnablement;
  /**
   * Enterprise ERP Integrations:
   * Workday, Fusion, D365, SAP, Coupa Expense, Microsoft Dynamics
   */
  enterpriseErpIntegrations: ProductConfigFeatureEnablement;
  /** The settings for entity override grouped under 'Advanced budget controls' in the spend limit create/edit flow */
  entitySpendLimitOverrideControls: ProductConfigFeatureEnablement;
  /** Integration with HRIS to with automated budget and policy provisioning rules for new users */
  hrisIntegration: ProductConfigFeatureEnablement;
  /** Enables users to flag attendees */
  listAttendees: ProductConfigFeatureEnablement;
  /** Local card issuance (ie no FX on local currency transactions + local currency card billing) */
  localCardIssuance: ProductConfigFeatureEnablement;
  /** Auto generated suggestions for expense memos */
  memoSuggestions: ProductConfigFeatureEnablement;
  /** Access Metrics tab */
  metricsAccess: ProductConfigFeatureEnablement;
  /** Allows use of a policy in multiple currencies */
  multipleCurrencyPolicy: ProductConfigFeatureEnablement;
  /** Collect all required HCP data attributes to meet Federal Open Payments on Brex */
  openPayments: ProductConfigFeatureEnablement;
  /** Enables OCR-powered policy rules for line items on receipts */
  policyReceiptLineItemOCR: ProductConfigFeatureEnablement;
  /** Receipt validation */
  receiptValidation: ProductConfigFeatureEnablement;
  /** Access Reports tab */
  reportsAccess: ProductConfigFeatureEnablement;
  /** Self-approval guardrails enabled on requests (owners replaced by admins) */
  selfApprovalGuardrails: ProductConfigFeatureEnablement;
  /** Enables spend limits */
  spendLimits: ProductConfigFeatureEnablement;
  /** Enables advanced group configuration for spend limit membership using user groups */
  spendLimitsAdvancedTargeting: ProductConfigFeatureEnablement;
  /** Enables Spend 3.0 user limits for employees */
  userLimits?: Maybe<ProductConfigFeatureEnablement>;
  /** Creates user limits upon inviting users to Brex, enabling quick spending activation */
  userSpendLimit: ProductConfigFeatureEnablement;
  /** Automated VAT Tracking */
  vatTracking: ProductConfigFeatureEnablement;
  /** Access wallet tab */
  walletAccess: ProductConfigFeatureEnablement;
}

/** Enablement details for a feature */
export interface ProductConfigFeatureEnablement {
  /**
   * This the overall enablement value, meaning when this is true the customer should be able to access the feature
   * and false otherwise. If `entitled` is false, this is always false.
   */
  enabled: Scalars["Boolean"];
  /**
   * This value is specific to entitlement. This is true when the customer is contractually entitled to use the feature
   * and false otherwise. When this is true, it DOES NOT necessarily mean that the customer should be able to access
   * the feature (i.e. the customer may be entitled to the feature but may not have it enabled in their Configuration
   * Home settings).
   */
  entitled: Scalars["Boolean"];
}

/** DEPRECATED */
export interface ProductConfigFeatures {
  accountingCustomRules: ProductConfigFeatureEnablement;
  accountingIntegrations: ProductConfigFeatureEnablement;
  advancedExpenseManagement: ProductConfigFeatureEnablement;
  budgetManagement: ProductConfigFeatureEnablement;
  employeeExpeditedShipping: ProductConfigFeatureEnablement;
  multiEntity: ProductConfigFeatureEnablement;
  reimbursements: ProductConfigFeatureEnablement;
}

/** Feature enablement data that can be used to gate feature access */
export interface ProductConfigFeaturesV2 {
  /** Root field for audit log features */
  audit: ProductConfigAuditLogFeatures;
  /** Root field for Banking related features */
  banking: ProductConfigBankingFeatures;
  /** Root field for Bill Pay related features */
  billPay: ProductConfigBillPayFeatures;
  /** Root field for Card related features (card shipping, co-branded cards, etc.) */
  card: ProductConfigCardFeatures;
  /** Root field for all expense management related features (expenses, budgets, accounting, etc.) */
  expenseManagement: ProductConfigExpenseManagementFeatures;
  /** Root field for loyalty features (rewards, referrals, etc.) */
  loyalty?: Maybe<ProductConfigLoyaltyFeatures>;
  /** Root field for Multi-Entity related features */
  multiEntity: ProductConfigMultiEntityFeatures;
  /** Root field for miscellaneous platform features */
  platform: ProductConfigPlatformFeatures;
  /** Root field for procurement features */
  procurement: ProductConfigProcurementFeatures;
  /** Root field for reimbursements related features */
  reimbursements: ProductConfigReimbursementsFeatures;
  /** Root field for Support related features */
  support: ProductConfigSupportFeatures;
  /** Root field for Travel related features */
  travel: ProductConfigTravelFeatures;
}

export interface ProductConfigLoyaltyFeatures {
  /** Access to plans upsell page in the dashboard */
  plansUpsellAccess: ProductConfigFeatureEnablement;
  /** Access to referrals tab */
  referralsAccess: ProductConfigFeatureEnablement;
  /** Access to rewards tab */
  rewardsAccess: ProductConfigFeatureEnablement;
}

export interface ProductConfigMultiEntityFeatures {
  /** ME: Customer allowed to add 1 non-primary entity */
  addEntitiesRestricted: ProductConfigFeatureEnablement;
  /** ME: Customer allowed to add unlimited # of non-primary entities */
  addEntitiesUnlimited: ProductConfigFeatureEnablement;
  /**
   * - Manage multiple entities within spend management platform
   * - US entity onboarding + KYC
   */
  basicMultiEntity: ProductConfigFeatureEnablement;
  /** Multi-entity billing */
  globalBilling: ProductConfigFeatureEnablement;
  /** ME: Customer allowed to bill a limited # of countries in local currency before overage fees apply */
  locallyBilledCountriesLimited: ProductConfigFeatureEnablement;
  /** ME: Customer allowed to bill 1 country in local currency */
  locallyBilledCountriesRestricted: ProductConfigFeatureEnablement;
  /** ME: Customer allowed to bill unlimited # of countries in local currency */
  locallyBilledCountriesUnlimited: ProductConfigFeatureEnablement;
  /** ME: Non-US entity and individual KYC / KYB */
  nonUsKycAndKyb: ProductConfigFeatureEnablement;
  /** ME: Non-US entity onboarding */
  nonUsOnboarding: ProductConfigFeatureEnablement;
  /** ME: Customer allowed to bill unlimited # of entities in USD */
  usdBilling: ProductConfigFeatureEnablement;
}

export interface ProductConfigPlatformFeatures {
  /** Access account setup tasks (AMS and Implementation Panel) */
  accountSetupTasks: ProductConfigFeatureEnablement;
  /** Access to admin home */
  adminHomeAccess?: Maybe<ProductConfigFeatureEnablement>;
  /** Advanced/Custom Roles & Permissions */
  advancedAndCustomRolesPermissions: ProductConfigFeatureEnablement;
  /** Access to the billing tab in company settings */
  companySettingsBillingTab: ProductConfigFeatureEnablement;
  /** Access to Copilot */
  copilot: ProductConfigFeatureEnablement;
  /** Ability to create custom user groups (e.g. can be referenced in approval flows) */
  customUserGroups: ProductConfigFeatureEnablement;
  /** Access to fields library page */
  fieldsLibrary?: Maybe<ProductConfigFeatureEnablement>;
  /** Access to global search */
  globalSearch: ProductConfigFeatureEnablement;
  /** Access to integrations home dashboard (ERP, accounting, and other external integrations) */
  integrationsHomeAccess?: Maybe<ProductConfigFeatureEnablement>;
  /** Access to LLM */
  llm: ProductConfigFeatureEnablement;
  /** Access to manage big 4 user attributes */
  manageBig4UserAttributes: ProductConfigFeatureEnablement;
}

export interface ProductConfigProcurementFeatures {
  /**  Ability to import from ERP and select purchase orders when paying a bill */
  purchaseOrders: ProductConfigFeatureEnablement;
}

export interface ProductConfigReimbursementsFeatures {
  /** Basic Reimbursements - US */
  basicReimbursements: ProductConfigFeatureEnablement;
  /** Customized approval chains - Reimbursements */
  customReimbursementsApprovalChains: ProductConfigFeatureEnablement;
  /**
   * Global reimbursements (USD and non-USD funded)
   * Allow employees to request reimbursements to intl bank accounts
   */
  internationalReimbursements: ProductConfigFeatureEnablement;
  /** Spend limit requirement for all reimbursement submissions */
  reimbursementsSpendLimitRequirement: ProductConfigFeatureEnablement;
}

export interface ProductConfigSelfServeSsoFeatures {
  /** Access to Self-serve sso settings */
  selfServeSso: ProductConfigFeatureEnablement;
}

export interface ProductConfigSupportFeatures {
  /** Admin and end user support with multi-language support - priority and 24/7 */
  premiumSupport: ProductConfigFeatureEnablement;
  /** Implementation consultant for complex deployments */
  professionalServices: ProductConfigFeatureEnablement;
}

export enum ProductConfigToggle {
  /** Entitlements-backed toggles */
  ACCIDENTAL_DECLINE_PROTECTION = "ACCIDENTAL_DECLINE_PROTECTION",
  ACCOUNTING_CUSTOM_RULES = "ACCOUNTING_CUSTOM_RULES",
  /** Cohorts-backed toggles */
  ACCOUNT_FUNDAMENTALS = "ACCOUNT_FUNDAMENTALS",
  AUTO_LIMIT_ASSIGNMENT = "AUTO_LIMIT_ASSIGNMENT",
  BILLPAY = "BILLPAY",
  BILLPAY_EBA = "BILLPAY_EBA",
  BUDGET_REQUESTS = "BUDGET_REQUESTS",
  CUSTOM_ROLES = "CUSTOM_ROLES",
  GROUP_EVENTS_DATAGRID = "GROUP_EVENTS_DATAGRID",
  HRIS_PROFILE_PICTURES = "HRIS_PROFILE_PICTURES",
  LLM = "LLM",
  MEMO_SUGGESTIONS = "MEMO_SUGGESTIONS",
  OPEN_PAYMENTS = "OPEN_PAYMENTS",
  PAYABLE_SPEND_LIMIT_REQUIREMENT = "PAYABLE_SPEND_LIMIT_REQUIREMENT",
  PURCHASE_ORDERS = "PURCHASE_ORDERS",
  REIMBURSEMENTS = "REIMBURSEMENTS",
  REIMBURSEMENTS_SPEND_LIMIT_REQUIREMENT = "REIMBURSEMENTS_SPEND_LIMIT_REQUIREMENT",
  SELF_APPROVAL_GUARDRAILS = "SELF_APPROVAL_GUARDRAILS",
  TRAVEL = "TRAVEL",
  USER_LIMITS = "USER_LIMITS",
}

/** Enablement related toggles */
export interface ProductConfigToggleEnablement {
  /** Whether this toggle is currently enabled, disabled or pending setup */
  status: ProductConfigEnablementStatus;
  /** Unique enum value associated with this toggle type */
  toggle: ProductConfigToggle;
}

/** Enablement related toggles - versioned to prevent FE breakage */
export interface ProductConfigToggleEnablementV2 {
  /** Display name for this toggle */
  displayName?: Maybe<Scalars["String"]>;
  /** Unique identifier for this toggle */
  id: Scalars["ID"];
  /** Whether this toggle is currently enabled, disabled or pending setup */
  status?: Maybe<ProductConfigEnablementStatus>;
  /** Unique enum value associated with this toggle type */
  toggle?: Maybe<ProductConfigToggle>;
}

/** Describes the feature toggles available to a given account */
export interface ProductConfigToggles {
  accidentalDeclineProtection?: Maybe<ProductConfigToggleEnablement>;
  accountingCustomRules?: Maybe<ProductConfigToggleEnablement>;
  autoLimitAssignment?: Maybe<ProductConfigToggleEnablement>;
  billpay?: Maybe<ProductConfigToggleEnablement>;
  billpayEba?: Maybe<ProductConfigToggleEnablement>;
  openPayments?: Maybe<ProductConfigToggleEnablement>;
  payableSpendLimitRequirement?: Maybe<ProductConfigToggleEnablement>;
  reimbursementsSpendLimitRequirement?: Maybe<ProductConfigToggleEnablement>;
  travel?: Maybe<ProductConfigToggleEnablement>;
  userLimit?: Maybe<ProductConfigToggleEnablement>;
}

export interface ProductConfigTravelFeatures {
  /** Enables admins to manage travel access for other users */
  travelAccessManagement: ProductConfigFeatureEnablement;
  /**  Allows access to the safety module within the trips tab which allows permissioned users to see the location of all traveling users based on their trip itinerary */
  travelDutyOfCare: ProductConfigFeatureEnablement;
  /** Provides access to the Travel tab which allows users to create group events which coordinate business travel across multiple employees */
  travelGroupEvents: ProductConfigFeatureEnablement;
  /**  Allows completing travel bookings inside the trips tab by manually filling in a personal card's payment information instead of using a budget */
  travelPersonalCardBooking: ProductConfigFeatureEnablement;
  /** Access to the reporting module inside the trips tab, view statistics on flight booking expenditures */
  travelReporting: ProductConfigFeatureEnablement;
  /**  Access to the Trips tab, allows making hotel, car, flight bookings */
  travelTrips: ProductConfigFeatureEnablement;
  /** Allows offline travel bookings and exclusive support. Comes with an additional fee */
  travelVipBooking: ProductConfigFeatureEnablement;
}

/**
 * Exposes data relevant to the Configuration Home surface
 * This data should NOT be used for gating
 */
export interface ProductConfigurationHome {
  /**
   * IMPORTANT: DO NOT USE THIS FOR GATING FEATURES. Please use `featuresV2` to gate based on entitlements instead.
   * See https://brexhq.atlassian.net/wiki/spaces/ENGDOC/pages/2084569810/Empower+Feature+Gating+-+Quick+Start+Guide for more info
   */
  gtmRepresentative?: Maybe<GtmRepresentative>;
  tierV2: ProductConfigEmpowerTier;
  toggles: ProductConfigToggles;
}

export interface ProductOffer {
  /** Any offer-specific context */
  context?: Maybe<Scalars["Json"]>;
  /** The sequence in which to present this offer */
  order: Scalars["Int"];
  /** The state of the offer */
  state: OfferState;
  /** List of steps to take associated with this offer */
  steps?: Maybe<Array<Maybe<OfferSetupStep>>>;
  /** The type of offer */
  type: OfferType;
}

/** Enum type for admin home product segment. */
export enum ProductSegmentType {
  CARD_AND_BANKING = "CARD_AND_BANKING",
  CARD_ONLY = "CARD_ONLY",
  SDC_BANKING_ONLY = "SDC_BANKING_ONLY",
}

export interface ProductSelection {
  bankingSelection: SelectionState;
  billPaySelection: SelectionState;
  cardSelection: SelectionState;
  reimbursementsSelection: SelectionState;
  /** Optional, not set for legacy product selections */
  travelSelection?: Maybe<SelectionState>;
}

export interface ProductSelectionError extends StandardClientError {
  /** Error code. */
  code: ErrorCode;
  /** Error message. */
  message?: Maybe<Scalars["String"]>;
  /** Optional path to field that caused error. */
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface ProductSelectionInput {
  bankingSelection: SelectionState;
  billPaySelection: SelectionState;
  cardSelection: SelectionState;
  reimbursementsSelection: SelectionState;
  travelSelection: SelectionState;
}

export interface ProductSelectionResult extends MutationResult {
  /** List of errors if any. */
  errors?: Maybe<Array<ProductSelectionError>>;
  /** The latest ProductSelection state, if the request succeeded */
  result?: Maybe<ProductSelection>;
}

export interface ProductUsageProfileSubmissionPayloadInput {
  /** How the business plans to use Brex Account. */
  accountUsages?: InputMaybe<Array<AccountUsageType>>;
  /** Required if ContinuedFundingSource.OTHER is selected. */
  continuedFundingSourceOther?: InputMaybe<Scalars["String"]>;
  /** Expected sources of funding for their Brex account. */
  continuedFundingSources?: InputMaybe<Array<ContinuedFundingSource>>;
  /** Only populated when the business selected a financial service outside the US. */
  countries?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  /** Countries this company has employees or contractors in. */
  countriesEmploying?: InputMaybe<Array<Scalars["String"]>>;
  /** Countries this company operates or provides services in. */
  countriesOperating?: InputMaybe<Array<Scalars["String"]>>;
  /** The business's expected financial services usage on Brex. */
  financialServices?: InputMaybe<Array<FinancialServiceType>>;
  /** The business's expected total monthly transaction amount on Brex. */
  monthlyActivityVolume: MonthlyActivityVolume;
  /** Expected usage of payment processors i.e. Stripe. Empty list if no usage is expected. */
  paymentProcessorUsage?: InputMaybe<Array<PaymentProcessorUsageType>>;
  /** Required if PaymentProcessorUsageType.OTHER is selected */
  paymentProcessorUsageOther?: InputMaybe<Scalars["String"]>;
  /** Expected types of payroll transactions. */
  payrollTransactionTypes?: InputMaybe<Array<PayrollTransactionType>>;
}

export interface ProgramMembershipPayload {
  /** First name of the member */
  firstName?: InputMaybe<Scalars["String"]>;
  /** Last name of the member */
  lastName?: InputMaybe<Scalars["String"]>;
  /** ID of the membership */
  membershipId?: InputMaybe<Scalars["String"]>;
}

/** A resource representing the program membership. */
export interface ProgramMembershipV2 {
  /** First name of the member. */
  firstName?: Maybe<Scalars["String"]>;
  /** The id of the program membership, e.g. 'apm_1234567890' */
  id: Scalars["ID"];
  /** Last name of the member. */
  lastName?: Maybe<Scalars["String"]>;
  /** Loyalty program mapped to this membership. */
  loyaltyProgram?: Maybe<LoyaltyProgramV2>;
  /** ID of the program membership. */
  membershipId?: Maybe<Scalars["String"]>;
}

/** A Program Membership Connection for Program Membership pagination. */
export interface ProgramMembershipV2Connection {
  /** The programs memberships in the current page of results. */
  edges?: Maybe<Array<Maybe<ProgramMembershipV2Edge>>>;
}

export interface ProgramMembershipV2Edge {
  /** The Program Membership at the current edge */
  node?: Maybe<ProgramMembershipV2>;
}

export interface ProgramMembershipsSortOrderInput {
  field: ProgramMembershipsSortableField;
  order: OrderByDirection;
}

export enum ProgramMembershipsSortableField {
  INSERTED_AT = "INSERTED_AT",
}

export interface PromisedByMerchantInput {
  amount: Scalars["Int"];
  contact: Scalars["String"];
  contactMode: ContactMode;
  promisedDate: Scalars["Date"];
}

export enum PromptManagerErrorCode {
  /** Formatting error thrown by Jinja. */
  JINJA_FORMATTING_ERROR = "JINJA_FORMATTING_ERROR",
  /** Error from OpenAI when trying to make an LLM call. */
  OPENAI_ERROR = "OPENAI_ERROR",
  /** Any other errors. */
  OTHER = "OTHER",
}

export interface ProvisionApplePayInput {
  /** The ID of the card to provision to Apple Pay */
  cardId: Scalars["ID"];
  /** An array of base64 encoded objects. Each object contains a DER encoded X.509 certificate, with the leaf first and root last */
  certificates?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  /** The client mutation id */
  clientMutationId: Scalars["String"];
  /** A one-time nonce value generated by Apple's servers (base64 encoded) */
  nonce: Scalars["String"];
  /** The device-specific signature for the nonce (base64 encoded) */
  nonceSignature: Scalars["String"];
}

export interface ProvisionApplePayPayload {
  /** The client mutation id */
  clientMutationId: Scalars["String"];
  /** An encrypted JSON file containing the information needed to add a card to Apple Pay */
  encryptedPassData: Scalars["String"];
  /** The ephemeral public key used by elliptic curve cryptography (ECC) */
  ephemeralPublicKey: Scalars["String"];
  otp: Scalars["String"];
}

export interface ProvisionGooglePayInput {
  /** The ID of the card to provision to Google Pay */
  cardId: Scalars["ID"];
  /** The client mutation id */
  clientMutationId: Scalars["String"];
}

export interface ProvisionGooglePayPayload {
  /** The client mutation id */
  clientMutationId: Scalars["String"];
  /** Encrypted object passed to Google Pay during provisioning */
  opaquePaymentCard: Scalars["String"];
}

export interface PullDataAsyncInput {
  clientMutationId: Scalars["String"];
  financialSourceId: Scalars["ID"];
}

export interface PullDataAsyncPayload {
  clientMutationId: Scalars["String"];
  updatedSource?: Maybe<FinancialSource>;
}

export enum PullPaymentEligibility {
  AUTO_PULL_PAYMENT = "AUTO_PULL_PAYMENT",
  MANUAL_PULL_PAYMENT = "MANUAL_PULL_PAYMENT",
  PULL_PAYMENT_BLOCKED = "PULL_PAYMENT_BLOCKED",
}

export interface PurchaseOrder extends Node {
  asset?: Maybe<Asset>;
  /** The budget request associated with this purchase order. */
  budgetRequest?: Maybe<BudgetRequestEntity>;
  /** The creator of the purchase order - either a User or a BudgetRequestEntity. */
  creator?: Maybe<PurchaseOrderCreator>;
  dateOfIssue: Scalars["Date"];
  /**
   * The end date of the purchase order's validity period.
   * Note: This field may be null for purchase orders imported from ERP systems.
   */
  endDate?: Maybe<Scalars["Date"]>;
  erpLink?: Maybe<Scalars["String"]>;
  extendedFieldValues?: Maybe<PurchaseOrderExtendedFieldValue>;
  id: Scalars["ID"];
  legalEntity?: Maybe<LegalEntity>;
  lineItems?: Maybe<Array<PurchaseOrderLineItem>>;
  memo?: Maybe<Scalars["String"]>;
  number: Scalars["String"];
  openAmount: FinancialAsset;
  /**
   * Whether to show the bill forwarding email for this purchase order, used in asset and template
   * generation.
   */
  showBillForwardingEmail?: Maybe<Scalars["Boolean"]>;
  source?: Maybe<PurchaseOrderSource>;
  /**
   * The start date of the purchase order's validity period.
   * Note: This field may be null for purchase orders imported from ERP systems.
   */
  startDate?: Maybe<Scalars["Date"]>;
  status: PurchaseOrderStatus;
  /** Suggestion type (match, suggestion, none) based on provided suggestion input, used for PO Matching */
  suggestionType?: Maybe<EntitySuggestionType>;
  totalAmount: FinancialAsset;
  url?: Maybe<Scalars["String"]>;
  /**
   * The vendor associated with this purchase order.
   * Returns VendorDetails for internal POs and ErpVendor for ERP-sourced POs.
   */
  vendor?: Maybe<PurchaseOrderVendor>;
  vendorUrl?: Maybe<Scalars["String"]>;
  version: Scalars["Int"];
}

/** A Purchase Order connection for Purchase Order pagination. */
export interface PurchaseOrderConnection extends Connection {
  /** The purchase orders in the current page of results. */
  edges: Array<PurchaseOrderEdge>;
  /** The date that the most recent purchase order import job completed for this customer. */
  lastImportedFromErpAt?: Maybe<Scalars["Time"]>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of purchase orders matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

/** Represents the creator of a purchase order - either a User or a BudgetRequestEntity. */
export type PurchaseOrderCreator = BudgetRequestEntity | User;

/** A PurchaseOrder edge for the PurchaseOrder connection. */
export interface PurchaseOrderEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The purchase order at this edge. */
  node?: Maybe<PurchaseOrder>;
}

export type PurchaseOrderExtendedFieldValue = ErpExtension;

export interface PurchaseOrderFieldsInput {
  /** The date of issue */
  dateOfIssue?: InputMaybe<Scalars["Date"]>;
  /** The end date (inclusive) */
  endDate?: InputMaybe<Scalars["Date"]>;
  /** Purchase Order line items */
  lineItems?: InputMaybe<Array<InputMaybe<PurchaseOrderLineItemInput>>>;
  /** Whether to show the bill forwarding email for this purchase order, used in asset and template generation. */
  showBillForwardingEmail?: InputMaybe<Scalars["Boolean"]>;
  /** The start date (inclusive) */
  startDate?: InputMaybe<Scalars["Date"]>;
  /** The status of the purchase order */
  status: PurchaseOrderStatus;
  /** The vendor ID */
  vendorId?: InputMaybe<Scalars["ID"]>;
  /** The vendor memo */
  vendorMemo?: InputMaybe<Scalars["String"]>;
}

/** Filters available to control which purchase orders get returned. */
export interface PurchaseOrderFilterInput {
  /** The list of filters to AND together. If multiple filters are passed in the same filter object, they will automatically be ANDed together. */
  and?: InputMaybe<Array<InputMaybe<PurchaseOrderFilterInput>>>;
  /** Matches AP account ID. Cannot be ANDed with vendorName. */
  apAccountId?: InputMaybe<Scalars["String"]>;
  /** The list of filters to OR together */
  or?: InputMaybe<Array<InputMaybe<PurchaseOrderFilterInput>>>;
  /** Match LIKE specific purchase order number */
  poNumber?: InputMaybe<Scalars["String"]>;
  /** Match IN specific status, match ALL when no filter provided */
  status?: InputMaybe<Array<PurchaseOrderStatus>>;
  /** Match exact vendor ID */
  vendorId?: InputMaybe<Scalars["ID"]>;
  /** Match LIKE specific vendor name. Currently compares vendor name on connected ERP. Cannot be ANDed with apAccountId. */
  vendorName?: InputMaybe<Scalars["String"]>;
}

export interface PurchaseOrderLineItem {
  id: Scalars["ID"];
  /** The description of the item */
  itemDescription?: Maybe<Scalars["String"]>;
  /** The name of the item */
  itemName: Scalars["String"];
  /** The type of the item */
  itemType: ItemType;
  /** The quantity of items */
  quantity: Scalars["Int"];
  /** The rate per item */
  rate: FinancialAsset;
}

export interface PurchaseOrderLineItemInput {
  /** ID of the PurchaseOrderLineItem. This should only be passed in if updating an existing line item. If empty a new line item will be created. */
  id?: InputMaybe<Scalars["ID"]>;
  /** The description of the item */
  itemDescription?: InputMaybe<Scalars["String"]>;
  /** The name of the item */
  itemName: Scalars["String"];
  /** The type of the item */
  itemType: ItemType;
  /** The quantity of items */
  quantity: Scalars["Int"];
  /** The rate per item */
  rate: FinancialAssetInput;
}

export interface PurchaseOrderMutationError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

/** Union used to provide a result for purchase order mutations. PurchaseOrder if successful, PurchaseOrderMutationError if not */
export type PurchaseOrderMutationResult =
  | PurchaseOrder
  | PurchaseOrderMutationError;

/** Determines the order that the purchase orders will be returned. */
export interface PurchaseOrderSortInput {
  field: SortablePurchaseOrderField;
  order: OrderByDirection;
}

export enum PurchaseOrderSource {
  INTERNAL = "INTERNAL",
  NETSUITE = "NETSUITE",
  QBO = "QBO",
}

export enum PurchaseOrderStatus {
  ARCHIVED = "ARCHIVED",
  CLOSED = "CLOSED",
  DRAFT = "DRAFT",
  OPEN = "OPEN",
}

/** Input type for searching suggested purchase orders */
export interface PurchaseOrderSuggestionsInput {
  /** Purchase order open amount to which these suggestions apply */
  openAmount?: InputMaybe<FinancialAssetInput>;
  /** Purchase order number to which these suggestions apply */
  poNumber?: InputMaybe<Scalars["String"]>;
  /** Vendor name to which these suggestions apply */
  vendorName?: InputMaybe<Scalars["String"]>;
}

/** Represents either a full Brex vendor or a lightweight ERP vendor */
export type PurchaseOrderVendor = ErpVendor | VendorDetails;

export interface PurchaseOrdersSendToVendorInput {
  /** Client mutation ID for tracking */
  clientMutationId: Scalars["String"];
  /** The IDs of the purchase orders to send */
  purchaseOrderIds: Array<Scalars["ID"]>;
}

export interface PurchaseOrdersSendToVendorResult {
  /** Results of sending POs to vendor. PurchaseOrder if successful, PurchaseOrderMutationError if not */
  purchaseOrderMutationResults: Array<PurchaseOrderMutationResult>;
}

/** @deprecated(reason: "use Cards and Cards.limitSource instead") */
export interface PurchasingCard extends Node {
  /** The limit minus amount spent in the current period. */
  amountRemaining?: Maybe<FinancialAsset>;
  /** The amount spent in the current period. */
  amountSpent?: Maybe<FinancialAsset>;
  /** The card itself */
  card?: Maybe<Card>;
  /** The date at which this card will expire. */
  expirationDate?: Maybe<Scalars["Date"]>;
  /** Logical ID */
  id: Scalars["ID"];
  /** The total limit amount that can be spent. */
  limit?: Maybe<FinancialAsset>;
  /** The source of authorization and controls for this PurchasingCard */
  limitSource?: Maybe<LimitSource>;
  /** Name for the card. */
  name?: Maybe<Scalars["String"]>;
  /** Parent Budget if it exists. */
  parentBudget?: Maybe<SpendBudget>;
  /** Period recurrence type of the card (eg. 'per week | per month | per quarter | per year | one time'). */
  periodRecurrenceType?: Maybe<PurchasingCardRecurrenceType>;
  /** The current status of the card. */
  status?: Maybe<CardStatus>;
  /** The amount spent divided by the spendable limit, represented as an integer percentage. */
  usagePercentage?: Maybe<Scalars["Int"]>;
  /** The customer user to which the card belongs. */
  user?: Maybe<User>;
}

/** A Purchasing Card connection for pagination. */
export interface PurchasingCardConnection extends Connection {
  /** The purchasing cards in the current page of results. */
  edges: Array<PurchasingCardEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of purchasing cards matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

/** A Purchasing Card edge for the Purchasing Card connection. */
export interface PurchasingCardEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The purchasing card at this edge. */
  node?: Maybe<PurchasingCard>;
}

export interface PurchasingCardFilterInput {
  amountRemaining?: InputMaybe<FinancialAssetRangeInput>;
  amountSpent?: InputMaybe<FinancialAssetRangeInput>;
  /** The ID of the card. */
  cardId?: InputMaybe<Array<Scalars["ID"]>>;
  /** The ID of the user associated with the card. */
  customerUserId?: InputMaybe<Array<Scalars["ID"]>>;
  /** The type of card instrument, e.g., virtual or physical. */
  instrumentType?: InputMaybe<InstrumentType>;
  limit?: InputMaybe<FinancialAssetRangeInput>;
  /** The ID of the spend limit's parent, if it exists. */
  parentBudgetId?: InputMaybe<Array<Scalars["ID"]>>;
  /** The ID of the card partner, if it exists. */
  partnerId?: InputMaybe<Array<Scalars["ID"]>>;
  /** Period recurrence type of the card (eg. 'per week | per month | per quarter | per year | one time'). */
  periodRecurrenceType?: InputMaybe<Array<PurchasingCardRecurrenceType>>;
  /** The ID of the spend limit mapped to the card. */
  spendLimitId?: InputMaybe<Array<Scalars["ID"]>>;
  /** The current status of the card. */
  status?: InputMaybe<Array<CardStatus>>;
  /** The current status view of the card. */
  statusView?: InputMaybe<Array<StatusView>>;
  /** Subtype of the card. */
  subtype?: InputMaybe<Array<PurchasingCardSubtype>>;
  /** Search by text (last 4, name, cardholder, etc.) */
  text?: InputMaybe<Scalars["String"]>;
}

export interface PurchasingCardIssueError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface PurchasingCardIssueErrors extends MutationError {
  errors?: Maybe<Array<PurchasingCardIssueError>>;
}

export interface PurchasingCardIssueInput {
  /** The conditions for the group of users that will have access to this card (authorized users). */
  authorizedUsers?: InputMaybe<UserGroupInput>;
  /** Base limit of the purchasing card (without limit increases) */
  baseLimit: FinancialAssetInput;
  /** Whether the card's users can request limit increases (default: false). */
  canUsersRequestLimitIncrease?: InputMaybe<Scalars["Boolean"]>;
  /** Client-provided idempotency key for the mutation */
  clientMutationId: Scalars["String"];
  /** Description of the purchasing card */
  description?: InputMaybe<Scalars["String"]>;
  /** The end date of the purchasing card. Transactions cannot be made on or after this date. */
  endDate?: InputMaybe<Scalars["Date"]>;
  /** Expense policy ID to associate with the purchasing card. */
  expensePolicyId: Scalars["ID"];
  /** Whether the card will automatically be transferred when the primary user no longer has access to the card (default: false). */
  isAutoTransferredEnabled?: InputMaybe<Scalars["Boolean"]>;
  /** Whether the card's limit amount is visible to all the card's users (default: false). */
  isLimitPrivate?: InputMaybe<Scalars["Boolean"]>;
  /** The legal entity that this card belongs to (defaults to the user's legal entity) */
  legalEntityId?: InputMaybe<Scalars["ID"]>;
  /** Approval policy ID to associate with the purchasing card. */
  limitApprovalPolicyId?: InputMaybe<Scalars["ID"]>;
  /** Settings that control limit flexibility and how it should be enforced */
  limitEnforcementSettings?: InputMaybe<LimitEnforcementSettingsInput>;
  /** Reset frequency type for the associated limit. */
  limitResetFrequency: LimitResetFrequency;
  /** The maximum transaction amount enforced by the card (default: no maximum). */
  maximumTransactionLimit?: InputMaybe<FinancialAssetInput>;
  /** Merchant category controls for the purchasing card. */
  merchantCategoryControls?: InputMaybe<PurchasingCardMerchantCategoryConfigInput>;
  /** Name of the purchasing card */
  name: Scalars["String"];
  /** The ID of the primary user of the purchasing card (card owner) */
  primaryUserId: Scalars["ID"];
  /** The start date of the purchasing card. Transactions can be made on or after this date. */
  startDate?: InputMaybe<Scalars["Date"]>;
}

export type PurchasingCardIssueResult = Card | PurchasingCardIssueErrors;

/** Filter type for filtering purchasing card limits */
export enum PurchasingCardLimitsFilterType {
  /** Exclude purchasing card limits from the results */
  EXCLUDE = "EXCLUDE",
  /** Include purchasing card limits in the results (default) */
  INCLUDE = "INCLUDE",
}

/** Input for merchant category config. */
export interface PurchasingCardMerchantCategoryConfigInput {
  /** A list of merchant category controls to apply to the purchasing card. */
  controlReferences: Array<MerchantControlReferenceInput>;
  /** The type of control to apply to the purchasing card. */
  controlType: MerchantCategoryControlType;
}

export interface PurchasingCardMutationError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface PurchasingCardOrderInput {
  direction: OrderByDirection;
  field: SortablePurchasingCardField;
}

export enum PurchasingCardRecurrenceType {
  ONE_TIME = "ONE_TIME",
  PER_DAY = "PER_DAY",
  PER_MONTH = "PER_MONTH",
  PER_QUARTER = "PER_QUARTER",
  PER_TRANSACTION = "PER_TRANSACTION",
  PER_WEEK = "PER_WEEK",
  PER_YEAR = "PER_YEAR",
}

/** Subtype of the card */
export enum PurchasingCardSubtype {
  /** Brex Bill Pay cards */
  BILL_PAY = "BILL_PAY",
  /** Non-shared Brex purchasing cards */
  INDIVIDUAL = "INDIVIDUAL",
  /** Lodge cards */
  LODGE = "LODGE",
  /** Cards created by Brex's partners */
  PARTNER = "PARTNER",
}

/** The backing limit for a Brex managed purchasing card */
export interface PurchasingLimit extends LimitSource, Node {
  /** The exact settings that govern authorizations. */
  authSettings?: Maybe<AuthorizationSettings>;
  /** Setting for auto-transferring cards when the cardOwner loses access to the card. */
  autoTransferCardsSetting: AutoTransferCardsSetting;
  /** Description of what this is meant to be used for */
  description?: Maybe<Scalars["String"]>;
  /** Logical ID */
  id: Scalars["ID"];
  /** Override that associates all transactions to this legal entity instead of the default */
  legalEntity?: Maybe<LegalEntity>;
  /** The exact settings that govern whether users can request for limit changes */
  limitChangeSettings?: Maybe<LimitChangeSettings>;
  /** Name */
  name: Scalars["String"];
  /** ID of the workflow that changes the default metadata (location, cost center, department) for expenses */
  overridesWorkflowId?: Maybe<Scalars["ID"]>;
  /** The policy used for authorizing spend */
  policy?: Maybe<Policy>;
  /** Amount spent in the period defined by the reset frequency */
  spent?: Maybe<FinancialAsset>;
  /** Amount spent by the requesting user in the period defined by the reset frequency */
  userSpent?: Maybe<FinancialAsset>;
}

export interface PushMarketoLeadsInput {
  clientMutationId: Scalars["String"];
  formId: Scalars["String"];
  leadAttributionMetadata?: InputMaybe<LeadAttributionMetadata>;
  leads?: InputMaybe<Array<Scalars["String"]>>;
  lookupField?: InputMaybe<Scalars["String"]>;
  programName: Scalars["String"];
  reason?: InputMaybe<Scalars["String"]>;
  source?: InputMaybe<Scalars["String"]>;
}

export interface PushMarketoLeadsPayload {
  clientMutationId: Scalars["String"];
  success?: Maybe<Scalars["Boolean"]>;
}

export interface PushPaymentMethod {
  /** List of payment details for the given rail */
  methodDetails?: Maybe<PushPaymentsAccountDetailConnection>;
  /** The rail for the included payment account details */
  rail?: Maybe<AccountAddressRail>;
  /** The supported clearing systems for the included payment account details */
  supportedClearingSystems?: Maybe<Array<Maybe<Scalars["String"]>>>;
}

export interface PushPaymentMethodConnection extends Connection {
  edges: Array<PushPaymentMethodEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface PushPaymentMethodEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<PushPaymentMethod>;
}

/** User marked status of the push payment */
export enum PushPaymentStatus {
  PAYMENT_INITIATED = "PAYMENT_INITIATED",
  RESET_BY_USER = "RESET_BY_USER",
}

/** Customer-facing data on a PushPaymentsAccount */
export interface PushPaymentsAccount {
  /** List of payment details for the given rail */
  accountDetails?: Maybe<PushPaymentsAccountDetailConnection>;
  /** Information about 3rd party KYC status */
  accountKycInformation?: Maybe<AccountKycInformation>;
  /** The banking partner associated with the push payments account */
  bankingPartner?: Maybe<PushPaymentsAccountBankingPartner>;
  /** Randomly generated string as this is not passed through from transmission */
  id?: Maybe<Scalars["String"]>;
  /** Details of the physical institution associated with the account */
  institution?: Maybe<PushPaymentsAccountInstitution>;
  /** List of payment rails, supported clearing systems and their given details */
  pushPaymentMethods?: Maybe<PushPaymentMethodConnection>;
  /** The rail for the included payment account details */
  rail?: Maybe<AccountAddressRail>;
  /** The status of the banking gateway account associated with the push payments account */
  status?: Maybe<PushPaymentsAccountStatus>;
  /** The supported clearing systems for the included payment account details */
  supportedClearingSystems?: Maybe<Array<Maybe<Scalars["String"]>>>;
}

/** Enum for push payments account banking provider */
export enum PushPaymentsAccountBankingPartner {
  AIRWALLEX = "AIRWALLEX",
  COLUMN = "COLUMN",
  DLOCAL = "DLOCAL",
  DREYFUS = "DREYFUS",
  JPM = "JPM",
  RAZORPAY = "RAZORPAY",
  WISE = "WISE",
}

export interface PushPaymentsAccountDetail {
  /** Customer-facing display name for the particular instruction detail */
  displayName?: Maybe<Scalars["String"]>;
  /** Customer-facing value of the instruction detail */
  value?: Maybe<Scalars["String"]>;
}

export interface PushPaymentsAccountDetailConnection extends Connection {
  edges: Array<PushPaymentsAccountDetailEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface PushPaymentsAccountDetailEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<PushPaymentsAccountDetail>;
}

export interface PushPaymentsAccountInstitution {
  /** Institution's physical address */
  address?: Maybe<InstitutionAddress>;
  /** Name of Institution's branch */
  branchName?: Maybe<Scalars["String"]>;
  /** Name of institution */
  name?: Maybe<Scalars["String"]>;
}

/** Enum for push payments account status */
export enum PushPaymentsAccountStatus {
  ACTIVE = "ACTIVE",
  CLOSED = "CLOSED",
  INVALID = "INVALID",
  PENDING = "PENDING",
}

export enum PushProviderType {
  APNS = "APNS",
  FCM = "FCM",
}

export interface PuzzleAuthPayloadInput {
  redirectUrl?: InputMaybe<Scalars["String"]>;
}

export interface PuzzlePayload {
  companyId?: Maybe<Scalars["String"]>;
  oauth2AccessToken?: Maybe<Scalars["String"]>;
  oauth2RefreshToken?: Maybe<Scalars["String"]>;
}

export interface QbdAuthPayloadInput {
  /** Brex page where Qbd website will redirect back to when linking is complete. */
  redirectUrl?: InputMaybe<Scalars["String"]>;
}

/** Quickbooks Desktop GL account settings */
export interface QbdCategories {
  /** Default accounts payable GL account */
  accountsPayableUserCategory?: Maybe<UserCategory>;
  /** Default collections GL account */
  collectionTargetUserCategory?: Maybe<UserCategory>;
  /** reimbursements user category */
  reimbursementsUserCategory?: Maybe<UserCategory>;
  /** Default rewards GL account */
  rewardsIncomeUserCategory?: Maybe<UserCategory>;
}

export interface QbdClass {
  isInactive?: Maybe<Scalars["Boolean"]>;
  name?: Maybe<Scalars["String"]>;
}

/** QBD Customer Category Fetched from Codat */
export interface QbdCustomer {
  isInactive?: Maybe<Scalars["Boolean"]>;
  name?: Maybe<Scalars["String"]>;
}

export interface QbdPayload {
  companyId?: Maybe<Scalars["String"]>;
  connectionId?: Maybe<Scalars["String"]>;
  linkUrl?: Maybe<Scalars["String"]>;
  organizationId?: Maybe<Scalars["String"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface Query {
  account?: Maybe<Account>;
  accountClosureStatus?: Maybe<ClosureStatus>;
  accountConnectedApiClient?: Maybe<ApiClient>;
  accountConnectedApiClients?: Maybe<Array<Maybe<ApiClient>>>;
  /** Internal query supporting federation. Do not use in client calls. */
  accountEntity: Account;
  /** Get account level policy currencies in the alphabetical order */
  accountPolicyCurrencies?: Maybe<Array<AccountPolicyCurrency>>;
  /** Get account level receipt line item categories that are eligible for the user */
  accountReceiptLineItemCategories?: Maybe<Array<LineItemCategory>>;
  /** Get Account's super admin status (active, missing or pending) */
  accountSuperAdminStatus?: Maybe<AccountSuperAdminStatus>;
  /**
   * Lists accounting integrations.
   * Default sorting behavior: connection status asc (i.e. active before inactive), followed by inserted at desc.
   */
  accountingIntegrations?: Maybe<AccountingIntegrationConnection>;
  /** Lists the Accounting Journal entries based on the given filters. */
  accountingJournalEntries?: Maybe<AccountingJournalEntryConnection>;
  /**
   * Lists Accounting Records.
   * By default lists Accounting Records of ACTIVE or DRAFT status if the current Accounting Integration has Accruals V2
   * enabled.
   */
  accountingRecords?: Maybe<AccountingRecordConnection>;
  /** Returns the list of accounts used for underwriting for a customer */
  accountsUsedInUnderwriting?: Maybe<AccountsUsedInUnderwritingResponse>;
  /** Get the active accounting integration if it exists. */
  activeAccountingIntegration?: Maybe<AccountingIntegration>;
  /** Returns an active Financial Statement Request and its supporting documents */
  activeFinancialStatementRequest?: Maybe<FinancialStatementRequest>;
  /** List the active Limit Escalations for the customer */
  activeLimitEscalations?: Maybe<LimitEscalationConnection>;
  /**
   * Spend migration imports are globally scoped to an account and there can only be one active import at a time.
   * Returns the active import if one exists. An active import is defined as an import that has "resolved" as false.
   * It can be in a PROCESSING, COMPLETED, or FAILED state.
   */
  activeSpendMigrationImport?: Maybe<SpendMigrationImport>;
  /** Query for actual data for widget */
  adminHomeWidget?: Maybe<AdminHomeWidget>;
  /**
   * Query for retrieving list of widgets and its metadata
   * @deprecated Use adminHomeWidgetsByProductSegment instead
   */
  adminHomeWidgetDefinitions?: Maybe<AdminHomeWidgetDefinitionConnection>;
  /** Query for list of eligible widgets based on product segment derived from customer's context */
  adminHomeWidgetsByProductSegment?: Maybe<AdminHomeWidgetsByProductSegmentConnection>;
  /**
   * Returns airports matching the input query string.
   * 2023-02-28: This depends on Spotnana's API:
   * https://apis.spotnana.com/api/version2.html#get-/v2/air-autocomplete
   */
  airAutocomplete?: Maybe<AirAutocompleteResults>;
  /** Gets a list of all timezones from the built-in Postgres table `pg_timezone_names` */
  allTimezones?: Maybe<Array<Timezone>>;
  anonymousSession?: Maybe<ApplicationSession>;
  applicationSession?: Maybe<ApplicationSession>;
  approvalsUnsafeFlag?: Maybe<ApprovalsUnsafeFlag>;
  /** Query any asset by id  */
  asset?: Maybe<Asset>;
  /** Internal query supporting federation. Do not use in client calls. */
  assetEntity: Asset;
  /**
   * The capabilities the logged in user can use when composing role definitions.
   * This response is not paginated, as the total number of capabilities is expected to remain small.
   */
  assignableCapabilities?: Maybe<Array<Maybe<AuthCapability>>>;
  /** The roles the logged in user can assign to others, based on their permissions and the account's configuration. */
  assignableRoles?: Maybe<AuthRoleConnection>;
  /**
   * Fetch all messages for a single session ID.
   * This returns both Assistant and User messages sorted newest to oldest in paginated format.
   *
   * Set chatSessionId to null to initiate a new session.
   */
  assistantMessages: QueryAssistantMessagesResponse;
  auditGroups?: Maybe<AuditGroupConnection>;
  authRole?: Maybe<AuthRole>;
  authzRules?: Maybe<Array<Maybe<RoleRule>>>;
  /** Get auto invite setting by identifier */
  autoInviteSetting?: Maybe<AutoInviteSetting>;
  /**
   * Query only used for testing purposes, will be removed.
   * @deprecated only for testing
   */
  autogenSettingTest?: Maybe<ReceiptAutogenSettingTest>;
  /** Query a single suggestion. */
  automationSuggestion?: Maybe<AutomationSuggestion>;
  /** List suggestion groups. */
  automationSuggestionGroups?: Maybe<AutomationSuggestionGroupConnection>;
  /** List suggestions. */
  automationSuggestions?: Maybe<AutomationSuggestionConnection>;
  automationWorkflowSpec?: Maybe<AutomationWorkflowSpec>;
  automationWorkflowSpecs?: Maybe<AutomationWorkflowSpecConnection>;
  availableProductOffers?: Maybe<Array<ProductOffer>>;
  /** Returns the average monthly spend for a customer */
  averageMonthlySpend?: Maybe<AverageMonthlySpendResponse>;
  /** Staleness info for customer */
  bankAccountsAnomalySignals?: Maybe<BankAccountsAnomalySignals>;
  /** Get daily balance snapshots for a banking account */
  bankingAccountDailyBalanceSnapshots?: Maybe<BankingAccountDailyBalanceSnapshotsResponse>;
  /**
   * Gets daily account snapshots
   * @deprecated use bankingAccountDailyBalanceSnapshots instead
   */
  bankingDailyAccountSnapshots?: Maybe<BankingDailyAccountsSnapshotsResponse>;
  /** List Banking Policies */
  bankingPolicies?: Maybe<Array<BankingPolicy>>;
  /** List Banking Statements */
  bankingStatements?: Maybe<BankingStatementConnection>;
  /** List Banking Tax Statements */
  bankingTaxStatements?: Maybe<BankingTaxStatementsResponse>;
  /**
   * This is only exposed as an entity so that we can actually resolve it in a requests dgs.
   * This resolver should never be used.
   */
  bankingTransactionRequestEntity?: Maybe<BankingTransactionRequest>;
  /** Internal query supporting federation. Do not use in client calls. */
  batchBudgetTemplates: Array<BudgetTemplate>;
  /** Internal query supporting federation. Do not use in client calls. */
  batchCashTransactions: Array<CashTransaction>;
  /** Internal query supporting federation. Do not use in client calls. */
  batchCounterparties: Array<Counterparty>;
  /** Internal query supporting federation. Do not use in client calls. */
  batchCountries: Array<Country>;
  /** Internal query supporting federation. Do not use in client calls. */
  batchDepositsAccounts: Array<DepositsAccount>;
  /** Internal query supporting federation. Do not use in client calls. */
  batchDownloadJobs: Array<DownloadJob>;
  /** Internal query supporting federation. Do not use in client calls. */
  batchExpenseEntityExtension: Array<Expense>;
  /** Internal query supporting federation. Do not use in client calls. */
  batchExtendedFields: Array<ExtendedField>;
  /** Internal query supporting federation. Do not use in client calls. */
  batchExternalIntegrationEntities: Array<ExternalIntegrationEntity>;
  /** Internal query supporting federation. Do not use in client calls. */
  batchFinancialAccounts: Array<FinancialAccount>;
  /** Internal query supporting federation. Do not use in client calls. */
  batchFinancialInstitutions: Array<FinancialInstitution>;
  /** Internal query supporting federation. Do not use in client calls. */
  batchMerchantCategoryEntities: Array<MerchantCategory>;
  /** Internal query supporting federation. Do not use in client calls. */
  batchMerchantEntities: Array<Merchant>;
  /** Internal query supporting federation. Do not use in client calls. */
  batchPaymentContacts: Array<PaymentContact>;
  /** Internal query supporting federation. Do not use in client calls. */
  batchPaymentFxQuotes: Array<PaymentFxQuote>;
  /** Internal query supporting federation. Do not use in client calls. */
  batchPaymentInstruments: Array<PaymentInstrument>;
  /** Internal query supporting federation. Do not use in client calls. */
  batchRailAccountDetails: Array<RailAccountDetails>;
  /** Internal query supporting federation. Do not use in client calls. */
  batchSpendLimits: Array<SpendLimit>;
  /** Internal query supporting federation. Do not use in client calls. */
  batchStatementEntryEntities: Array<StatementEntry>;
  /** Internal query supporting federation. Do not use in client calls. */
  batchUserCategories: Array<UserCategory>;
  /** Internal query supporting federation. Do not use in client calls. */
  batchUserEntities: Array<User>;
  /** Internal query supporting federation. Do not use in client calls. */
  batchVendorDetails: Array<VendorDetails>;
  /** Get a bill by id */
  bill?: Maybe<Bill>;
  /** Get bill batch by ID */
  billBatch?: Maybe<BillBatch>;
  /** Suggested fields to fill in the Bill based on OCR extraction. */
  billFieldSuggestions?: Maybe<BillFieldSuggestionsResult>;
  billSyncErrors?: Maybe<BillSyncErrorConnection>;
  billingDelinquencies?: Maybe<Array<Maybe<BillingDelinquency>>>;
  /** Retrieves all billing groups of a particular customer */
  billingGroups?: Maybe<BillingGroupConnection>;
  /** Get a list of invoices */
  billingInvoices?: Maybe<BillingInvoiceConnection>;
  /** Get a list of invoices. Includes SaaS payment invoices */
  billingInvoicesV2?: Maybe<BillingInvoiceV2Connection>;
  /** List Journal Accounts */
  billingJournalAccounts?: Maybe<BillingJournalAccountConnection>;
  billingPayment?: Maybe<BillingPayment>;
  /** Internal query supporting federation. Do not use in client calls. */
  billingPaymentIntentEntity: BillingPaymentIntent;
  /** Get billing transaction */
  billingTransaction?: Maybe<BillingTransaction>;
  /** List billing transactions */
  billingTransactions?: Maybe<BillingTransactionConnection>;
  bills?: Maybe<BillConnection>;
  /** List bills */
  billsV2?: Maybe<BillConnection>;
  brexFees?: Maybe<BrexFeeConnection>;
  /**
   * Get a budget by id
   * @deprecated Use bifurcated queries (spendLimit or spendBudget)
   */
  budget?: Maybe<Budget>;
  /** List Any Budget Requests, up to 32,000 results */
  budgetAnyRequestEntities?: Maybe<BudgetAnyRequestEntityConnection>;
  /** Get the budget configuration (rollout) flags for a given customer account */
  budgetConfigurationFlags?: Maybe<Array<BudgetConfigurationFlag>>;
  /** Get the total number of users that match the search filters selected for budget distribution */
  budgetDistributionTotalEmployeeCount?: Maybe<Scalars["Int"]>;
  /** Internal query supporting federation. Do not use in client calls. */
  budgetEntityExtension: Budget;
  /** Get a Budget Limit Increase Request by id */
  budgetLimitIncreaseRequestEntity?: Maybe<BudgetLimitIncreaseRequestEntity>;
  /** Search merchant categories for merchant category controls. */
  budgetMerchantCategoriesSuggestions?: Maybe<BudgetMerchantCategoriesSuggestionsResult>;
  /** List budget movements */
  budgetMovements?: Maybe<BudgetMovementConnection>;
  /** List Budget Requests */
  budgetRequestEntities?: Maybe<BudgetRequestEntityConnection>;
  /** Get a Budget Request by id */
  budgetRequestEntity?: Maybe<BudgetRequestEntity>;
  /** Validate budget requests before firing approval */
  budgetRequestsValidation?: Maybe<Array<BudgetRequestValidationResult>>;
  /** Get Budget Template */
  budgetTemplate?: Maybe<BudgetTemplate>;
  /** List Budget Template */
  budgetTemplates?: Maybe<BudgetTemplateConnection>;
  /** List BudgetTreeNode entities */
  budgetTreeNodes?: Maybe<BudgetTreeNodeConnection>;
  /** Get notification type preferences for a given user-budget pair given budget ID and user ID */
  budgetUserNotificationTypePreferences?: Maybe<
    Array<BudgetUserNotificationTypePreference>
  >;
  /** Get a budget's member and owner spend */
  budgetUsersAmountSpent?: Maybe<Array<Maybe<BudgetUserAmountSpent>>>;
  /**
   * List Budgets
   * @deprecated Use bifurcated queries (spendLimits or spendBudgets)
   */
  budgets?: Maybe<BudgetConnection>;
  /** List the period amount spent for budgets at a given date. */
  budgetsAmountSpent?: Maybe<Array<BudgetAmountSpent>>;
  /** List Budgets as parent options. This handles some common validation logic and adds in error information alongside the parent candidates. */
  budgetsAsParents?: Maybe<BudgetConnection>;
  /** List multiple budgets' descendant ids by id */
  budgetsDescendantIds?: Maybe<Array<Maybe<BudgetDescendantIdsResult>>>;
  /** Used for proactive expense indicators that indicate why an existing expense cannot be assigned to the current budget */
  budgetsExpenseDryRunInformation?: Maybe<BudgetExpenseDryRunConnection>;
  /** List manual actions required to offboard users from budgets and budget-adjacent features */
  budgetsOffboardingActions?: Maybe<OffboardingActionConnection>;
  /** Get the total spend across all the budgets in their current periods that fit a certain filter */
  budgetsTotalSpendAcrossCurrentPeriods?: Maybe<FinancialAsset>;
  buildAndRunPromptTemplate?: Maybe<BuildAndRunPromptTemplateResult>;
  /** Calculates amount based on mileage settings, route and caller's bank account currency */
  calculateMileageAmount?: Maybe<MileageAmount>;
  /** Calculate per diem amounts for a trip itinerary */
  calculatePerDiem?: Maybe<CalculatePerDiemResponse>;
  canFSPUserAccessClient?: Maybe<CanFSPUserAccessClientResult>;
  /** whether account can import accounting data from live to sandbox */
  canImportLiveAccountingDataToSandbox?: Maybe<Scalars["Boolean"]>;
  /**
   * Returns car vendors matching the input query string.
   * 2023-08-04: This depends on Spotnana's API:
   * https://apis.spotnana.com/api/version2.html#get-/v2/car-vendor-autocomplete
   */
  carAutocomplete?: Maybe<CarAutocompleteResults>;
  /** Get card */
  card?: Maybe<Card>;
  /** Get the estimated delivery date of a potential card shipment */
  cardEstimatedDeliveryDate?: Maybe<CardEstimatedDeliveryDateResponse>;
  cardNormalizationTextRules?: Maybe<CardNormalizationTextRules>;
  /** Lists all integration partners that have created cards. */
  cardPartners?: Maybe<IntegrationPartnerConnection>;
  /** List cards */
  cardSearch?: Maybe<CardSearchConnection>;
  /** Get list of cards */
  cards?: Maybe<CardConnection>;
  /**
   * Get the future transaction timelines for a recurring schedule
   * that has not been created yet.
   */
  cashRecurringSchedule?: Maybe<CashRecurringScheduleWithTimelines>;
  cashTransaction?: Maybe<CashTransaction>;
  /**
   * Get the decision and the decision details of an approval for a given
   * transaction, given its identifier - either its id of approval token.
   */
  cashTransactionApproval?: Maybe<CashTransactionApprovalResponse>;
  /**
   * returns whether there are previous ach debits successfully initiated against
   * the financial_account_id
   */
  cashTransactionIsFirstAchDebit?: Maybe<CashTransactionIsFirstAchDebitResponse>;
  /** Gets a timeline with the estimated transaction time */
  cashTransactionTimelineEstimate?: Maybe<CashTransactionTimeline>;
  /** Gets a timeline with the estimated transaction time for a payment rail */
  cashTransactionTimelineEstimates?: Maybe<PaymentRailTimeline>;
  /** List categories */
  categories?: Maybe<CategoryConnection>;
  /** Gets category by id */
  category?: Maybe<Category>;
  cohorts?: Maybe<Array<CohortSegment>>;
  /** List collection promises for a customer */
  collectionPromises?: Maybe<CollectionPromiseConnection>;
  combinedStaleness?: Maybe<CombinedStaleness>;
  commentFeatureFlag?: Maybe<Scalars["Boolean"]>;
  /** Gets comment suggestions for a given entity. */
  commentSuggestions?: Maybe<Array<CommentSuggestionsResult>>;
  /** Query Company Assistant Setting, only accessible to admins. */
  companyAssistantSetting: CompanyAssistantSetting;
  /** Compare group memberships */
  compareGroupMemberships?: Maybe<GroupMemberChangeConnection>;
  /** Gets the compliance rating of the user in context. */
  complianceRating?: Maybe<ComplianceRating>;
  /**
   * Get the legal entity (aka spend entity) and the funding entity (aka billing entity) for the expense
   * if its spend entity or budget were to be updated.
   */
  computeExpenseEntities?: Maybe<ComputedExpenseEntities>;
  /** Validate conflicting merchants or categories with ancestor budgets. */
  conflictingAncestorBudgetMerchantCategoryControls?: Maybe<ConflictingMerchantsCategoryResult>;
  /** Validate conflicting merchants or categories with ancestor and descendant budgets. */
  conflictingBudgetMerchantCategoryControls?: Maybe<ConflictingMerchantsCategoryResult>;
  /** Validate conflicting merchants or categories for a budget request based on parent budget ID. */
  conflictingBudgetRequestMerchantCategoryControls?: Maybe<ConflictingMerchantsCategoryResult>;
  connectHasEncounteredFailure?: Maybe<Scalars["Boolean"]>;
  connectSession?: Maybe<ConnectSessionPayload>;
  contact?: Maybe<PaymentContact>;
  /** Fetch structured contract. */
  contract?: Maybe<ContractResponse>;
  /** Get a list of Copilot relationships. */
  copilots?: Maybe<CopilotConnection>;
  /** Get cost center by identifier */
  costCenter?: Maybe<CostCenter>;
  /** List cost centers */
  costCenters?: Maybe<CostCenterConnection>;
  /** Fetches the counts of entries separated by review status type. */
  countAccountingJournalEntries?: Maybe<AccountingJournalEntriesCount>;
  /**
   * Get a count of all alerts matching input filter
   *
   * Note: Count is capped at 100 for performance reasons. If you have more than 100
   * matching alerts, this will return 100.
   */
  countAlerts?: Maybe<CountAlertsResult>;
  /**
   * Given a list of budget node IDs returns the count of budget nodes including descendants that
   * will be affected by the specified batched operation (ARCHIVE, DELETE, UNEXPIRE, or UNTERMINATE).
   * The count includes both the provided IDs and their eligible descendants.
   */
  countBudgetNodesToBeProcessed?: Maybe<Scalars["Int"]>;
  /** Get expenses totalCount */
  countExpenses?: Maybe<Scalars["Int"]>;
  countries?: Maybe<Array<Country>>;
  /**
   * Get list of countries available for money movement
   * TODO: This query should be moved to the Money Movement DGS when available
   */
  countriesV2?: Maybe<Array<Maybe<CountryDetails>>>;
  countryAddressMetadata?: Maybe<CountryAddressMetadata>;
  credential?: Maybe<Credential>;
  credentials?: Maybe<CredentialConnection>;
  /** Returns if we should display the credit policy banner or not */
  creditPolicyWarningModal?: Maybe<CreditPolicyWarningModalResponse>;
  /** Credit terms for customer */
  creditTerms?: Maybe<CreditTerms>;
  /** Query for contents to display under curated for you section */
  curatedCarousel?: Maybe<CuratedCarouselConnection>;
  /** Customer account's current servicing policy */
  currentServicingPolicy?: Maybe<ServicingPolicy>;
  /** User's Underwriting Features */
  currentUnderwritingParameters?: Maybe<UnderwritingParameters>;
  customerReferral?: Maybe<CustomerReferral>;
  ddaMigrationState?: Maybe<DDAMigrationState>;
  ddaMigrationTimeline?: Maybe<DDAMigrationTimeline>;
  debugError?: Maybe<Scalars["Boolean"]>;
  /** Internal */
  debugException?: Maybe<Scalars["Boolean"]>;
  /** Internal */
  debugExit?: Maybe<Scalars["Boolean"]>;
  /** Fetches the default field mappings for the given subsidiary */
  defaultIntegrationFieldMappings?: Maybe<DefaultIntegrationFieldMappingConnection>;
  /**
   * Get the default policy for the given request type.
   * @deprecated Default Policy is not applicable.
   */
  defaultPolicy?: Maybe<Policy>;
  /** Get department by identifier */
  department?: Maybe<Department>;
  depositsTransaction?: Maybe<DepositsTransaction>;
  /** Return devportal related information */
  devAccessAgreementStatus?: Maybe<DevAccessAgreement>;
  /** Return a list of tokens for the current user's account */
  developerApiTokens?: Maybe<Array<Maybe<DeveloperApiToken>>>;
  dispute?: Maybe<Dispute>;
  /** Query for a documentOcr entity by ID */
  documentOcr?: Maybe<DocumentOcr>;
  /** Returns document deadline status */
  documentationStatus?: Maybe<Array<DocumentationStatus>>;
  /**
   * Used as fallback to grant access to travel support in case the user
   * is not travel enabled but does have existing trips.
   */
  doesUserHaveTrips?: Maybe<Scalars["Boolean"]>;
  /** List all download jobs available to the requesting user sorted by most-recent-first, optionally filtering by origin */
  downloadJobs?: Maybe<DownloadJobConnection>;
  /** Get extended field options by extended field id and filters */
  draftExtendedFieldOptions?: Maybe<DraftExtendedFieldOptionConnection>;
  /** Get draft extended fields by filters */
  draftExtendedFields?: Maybe<ExtendedFieldConnection>;
  /**
   * Fetches the egress files for the given customer account id
   * Support case:
   * 1. Download the zip file of dependent lists in CSV templates that customer can manage their dependent lists
   */
  egressFiles?: Maybe<Array<Maybe<Asset>>>;
  /** Check if a customer is eligible for a limit increase request */
  eligibilityForLimitIncreaseRequest?: Maybe<LimitIncreaseRequestEligibilityResponse>;
  /**
   * Get an employee by id or customer user id.
   * Or, if no id is provided, get the employee associated with the current BrexContext.
   */
  employee?: Maybe<Employee>;
  /** List employees */
  employees?: Maybe<EmployeeConnection>;
  empowerIntegration?: Maybe<EmpowerIntegration>;
  empowerIntegrations?: Maybe<EmpowerIntegrationConnection>;
  /** Gets engagement setting for the account of the user in context. */
  engagementSetting?: Maybe<EngagementSetting>;
  /** Get autopay funding source for an entity/product type pair */
  entityAutopayFundingSource?: Maybe<FundingSource>;
  /** Get all autopay funding source given entity and product type filters */
  entityAutopayFundingSources?: Maybe<AutopayFundingSourceConnection>;
  /** Queries entity mappings for the integration. */
  entityMappings?: Maybe<Array<Maybe<EntityMapping>>>;
  /**
   * A universal entity querying API that can be used to query any entity type onboarded to the platform.
   * The API specifies a standard filtering/sorting/grouping/aggregation interface that can be used in the query.
   */
  entityRows?: Maybe<EntityConnection>;
  /** Fetches list of subsidiaries using credentials id */
  erpCreditCards?: Maybe<Array<Maybe<ErpCreditCardOutput>>>;
  erpFeeds?: Maybe<ErpFeedConnection>;
  erpVendors?: Maybe<ErpVendorConnection>;
  /** Get an expense by id */
  expense?: Maybe<Expense>;
  /** Query Expense Activities for user. */
  expenseActivities: ExpenseActivityGroupConnection;
  /** [Airbnb-Demo] Fetches relevant attendees flags for a given expense ID */
  expenseAttendeesFlags?: Maybe<Array<ExpenseAttendeesFlag>>;
  /** Internal query supporting federation. Do not use in client calls. */
  expenseEntityExtension: Expense;
  /** Get the policy reasons for all request actions of a given expense */
  expensePolicyReasonsV3?: Maybe<Array<ExpensePolicyReasonV3>>;
  /** Get a specific policy spec. */
  expensePolicySpec?: Maybe<ExpensePolicySpec>;
  /** Get expense report */
  expenseReport?: Maybe<ExpenseReport>;
  /**
   * Lists expenses using using query platform. -- DEPRECATED
   * Returns the data as received from the query platform database, meaning the data could potentially be outdated.
   * @deprecated use expensesV2 or groupedExpenses instead
   */
  expenseRows?: Maybe<ExpenseRowConnection>;
  /**
   * List expenses
   * @deprecated use expensesV2 instead
   */
  expenses?: Maybe<ExpenseConnection>;
  /** New Expense listing API - This is the preferred method for listing expenses */
  expensesV2?: Maybe<ExpenseConnection>;
  /** Get the export job by id */
  exportJob?: Maybe<ExportJob>;
  /**
   * List export job notifications based on given filters order by created time.
   *
   * The notification delivers the export job related information to FE that FE can render the notification for customers.
   * For example, when export job failed, we will propagate failure messages and potential solution if any to customer
   * so they know what happens and what to do. Then the customer could dismiss the notification after consuming.
   */
  exportJobNotifications?: Maybe<ExportJobNotificationConnection>;
  /** Get the export pipe by id */
  exportPipe?: Maybe<ExportPipe>;
  /** Lists export records based on given filters */
  exportRecords?: Maybe<ExportRecordConnection>;
  /**
   * Check for any issues that would cause export problems.
   * For example, unmapped legal entities, invalid integration settings, invalid subsidiary settings.
   */
  exportValidation?: Maybe<ExportValidationResult>;
  /** Get an extended field by id */
  extendedField?: Maybe<ExtendedField>;
  /** Get extended field options by extended field id and filters */
  extendedFieldOptions?: Maybe<ExtendedFieldOptionConnection>;
  /** Get an extended field visibility rule by id */
  extendedFieldVisibilityRule?: Maybe<ExtendedFieldVisibilityRule>;
  /** Get extended fields by filters */
  extendedFields?: Maybe<ExtendedFieldConnection>;
  externalLegalEntities?: Maybe<ExternalLegalEntityConnection>;
  /** Returns the list of feature flags evaluated for a customer */
  featureFlags?: Maybe<FeatureFlagsResponse>;
  /** Fetches a FedachParticipant based on the given routing number. */
  fedachParticipant?: Maybe<FedachParticipant>;
  /** Fetches a FedwireParticipant based on the given routing number. */
  fedwireParticipant?: Maybe<FedwireParticipant>;
  /** Fetch expense price */
  fetchExpensePrice?: Maybe<ExpensePrice>;
  /** Fetches list of subsidiaries using credentials id */
  fetchSubsidiariesFromErp?: Maybe<Array<Maybe<NetsuiteSubsidiary>>>;
  /**
   * Fetch subsidiaries from vendors.
   *
   * The backend connects to the Vendor API to fetch the list of subsidiaries.
   * This is used in the integration setup screen, before an integration is created;
   * hence the parameter is the credentialId instead of the integrationId.
   */
  fetchSubsidiariesFromVendor?: Maybe<VendorSubsidiaryConnection>;
  /** Institutions enabled for use on Finicity */
  financialAccount?: Maybe<FinancialAccount>;
  financialAccounts?: Maybe<FinancialAccountConnection>;
  /** Gets financial asset movement by id */
  financialAssetMovement?: Maybe<FinancialAssetMovementInterface>;
  /** The documents for financials data (mainly used for bank statement collection) */
  financialBankStatements?: Maybe<FinancialBankStatementDocumentConnection>;
  financialDocuments?: Maybe<FinancialBankStatementDocumentConnection>;
  financialInstitution?: Maybe<FinancialInstitution>;
  financialInstitutions?: Maybe<FinancialInstitutionConnection>;
  /**  FinancialAsset Queries */
  financialInstrument?: Maybe<FinancialInstrument>;
  /** Internal query supporting federation. Do not use in client calls. */
  financialInstrumentEntity: FinancialInstrument;
  financialInstruments?: Maybe<Array<FinancialInstrument>>;
  financialSource?: Maybe<FinancialSource>;
  /** Internal query supporting federation. Do not use in client calls. */
  financialSourceEntity: FinancialSource;
  financialSources?: Maybe<FinancialSourceConnection>;
  financialStatementAccounts?: Maybe<FinancialStatementAccountConnection>;
  financialStatementRequestedAccounts?: Maybe<FinancialStatementRequestedAccountConnection>;
  findContact?: Maybe<PaymentContact>;
  findContactByPaymentInstrumentInfo?: Maybe<PaymentContact>;
  /** These are institutions for which we should fallback to using Finicity */
  finicityEnabledInstitutions?: Maybe<Array<FinancialInstitution>>;
  fraudAlert?: Maybe<FraudAlert>;
  fraudAlerts?: Maybe<FraudAlertConnection>;
  /** Returns wether or not we should display the FRB -> Chase migration banner and for what financial source(s). */
  frbMigrationBanner?: Maybe<FrbMigrationBannerResponse>;
  /** List all registered FSP accounts */
  fspAccounts?: Maybe<Array<Maybe<FspAccount>>>;
  fspClientAccount?: Maybe<FSPClientAccount>;
  /**
   * List the client accounts for the current financial service partner. Client accounts are ones that the FSP is able to
   * access and do bookkeeping and bill pay drafting for. FSP is the old name for Pro Access.
   */
  fspClientAccounts?: Maybe<FspClientAccountConnection>;
  /** Internal query supporting federation. Do not use in client calls. */
  fundingSourceEntity: FundingSource;
  /**
   * Part of DDA migration wizard experience
   * Get funds allocation recommendation for all deposits accounts under a customer account
   * Currently returns stubbed data
   */
  fundsAllocationRecommendation?: Maybe<FundsAllocationRecommendation>;
  /**
   * Fuzzy search for any primitive (which can be a title, cost center, legal entity, location, department, or user)
   * or extended field option.
   *
   * NOTE: pagination is not implemented currently. It will return 10 results for each primitive type and 10 options
   * for each extended field.
   */
  fuzzySearch?: Maybe<FuzzySearchConnection>;
  /** Input field to provide when generating an export of the deposits account counterparty category information */
  generateCounterpartyCategoryInfoExport?: Maybe<GenerateCounterpartyCategoryInfoExportPayload>;
  getAccountStaleness?: Maybe<GetAccountStalenessResult>;
  getAuditActorTypesFilterOptions?: Maybe<AuditActorTypesFilterOptionsConnection>;
  getAuditLogs?: Maybe<AuditLogsConnection>;
  getAuditLogsTotalCount?: Maybe<AuditLogsTotalCount>;
  getAuditOperationNameFilterOptions?: Maybe<AuditOperationNameFilterOptionsConnection>;
  getAuditTargetTypesFilterOptions?: Maybe<AuditTargetTypesFilterOptionsConnection>;
  getAvailableFSPs?: Maybe<Array<FSPAccount>>;
  getBankingHolidays?: Maybe<BankingHolidays>;
  /** Given an FSP, lists all of its external bookkeepers */
  getBookkeepersForFsp?: Maybe<Array<Maybe<Scalars["String"]>>>;
  /** Get clawback health status for the user account */
  getClawbackHealth?: Maybe<ClawbackHealth>;
  /** Given an FSP, lists all client accounts connected to it */
  getClientAcctsForFsp?: Maybe<Array<Maybe<FspClientAccount>>>;
  getClientFSPs?: Maybe<Array<ClientFSPAccount>>;
  /** Queries for a vendor credential by id */
  getCredential?: Maybe<VendorCredential>;
  getExpenseCategorySuggestions?: Maybe<ExpenseCategorySuggestionConnection>;
  /**
   * Get expense exchange rate
   * If customerUserId is not passed, will use the context of the caller
   */
  getExpenseExchangeRate?: Maybe<Scalars["Decimal"]>;
  /**
   * Get expense price for reimbursements
   * Deprecated - please use fetchExpensePrice
   */
  getExpensePrice?: Maybe<ExpensePrice>;
  /** Get status and result of an export attempt */
  getExportAttemptState?: Maybe<GetExportAttemptStatePayload>;
  getFSPClients?: Maybe<Array<FSPClientAccount>>;
  getFSPDetails?: Maybe<FSPAccount>;
  /** Fetch financial statement request by id */
  getFinancialStatementRequest?: Maybe<FinancialStatementRequest>;
  /** Get the first statement for the account by periodStartTime */
  getFirstStatement?: Maybe<Statement>;
  /** Get a link token from HRIS aggregator vendor and return back to the client */
  getLinkToken?: Maybe<HrisLinkToken>;
  /** Get a requirement for a selected rail. */
  getRailRequirement?: Maybe<RailRequirement>;
  /**
   * Get the report entry data from the given ids
   * @deprecated No longer supported
   */
  getReportEntryData?: Maybe<ReportEntryDataConnection>;
  /** Gets a single RFI by RFI ID, Salesforce Case ID or Case Number */
  getRfi?: Maybe<Rfi>;
  /** Get Servicing State for a given Journal Account Id */
  getServicingState?: Maybe<ServicingState>;
  /** Get statements and respective download urls for the given journal account id */
  getStatementsWithDownloadUrls?: Maybe<ListOfStatementsWithDownloadUrls>;
  /** list paginated user categories */
  getUserCategoriesPaginated?: Maybe<UserCategoriesPaginated>;
  getUserCategoryForIntegrationMerchantCategory?: Maybe<UserCategory>;
  /** Return the workflow execution status associated with the supplied workflow Id */
  getWorkflowStatus?: Maybe<WorkflowStatus>;
  /** Get root budget for account */
  globalBudget?: Maybe<Budget>;
  /** A global search API searches across all Brex entities such as routes, actions, primitives. */
  globalSearch?: Maybe<SearchResults>;
  /** Get a group event entity by id */
  groupEvent?: Maybe<GroupEvent>;
  /** List group events */
  groupEvents?: Maybe<GroupEventConnection>;
  /** Split bills into batches depending on the Entity Billing Configuration */
  groupExpensesByBillingConfiguration?: Maybe<GroupExpensesByBillingConfigurationResult>;
  /** List group members */
  groupMembers?: Maybe<GroupMemberConnection>;
  /** New grouped expense listing API -- this is the preferred way to list expenses with grouping */
  groupedExpenses?: Maybe<ExpenseGroupConnection>;
  /** Retrieves travel bookings grouped by specified attributes such as trip ID, booking type, or traveler ID. */
  groupedTravelBookings?: Maybe<TravelBookingGroupConnection>;
  /** List groups */
  groups?: Maybe<GroupConnection>;
  /** Return true if the requester has access to Sandbox */
  hasAccessToSandbox?: Maybe<Scalars["Boolean"]>;
  /** Determines if an account has offboarding actions to take */
  hasBudgetsOffboardingActions?: Maybe<Scalars["Boolean"]>;
  /** Lists all available Help Center Categories */
  helpCenterCategories?: Maybe<Array<Maybe<HelpCenterCategory>>>;
  /**
   * Fetch historical FX rate.
   * If exchangeRateTime is not provided - return the latest.
   */
  historicalExchangeRate?: Maybe<ExchangeRate>;
  /**
   * Returns hotels matching the input query string.
   * 2023-03-14: This depends on Spotnana's API:
   * https://apis.spotnana.com/api/version2.html#get-/v1/hotel-autocomplete
   * The v1 is intentional - there is a v2 available but it only returns empty responses.
   */
  hotelAutocomplete?: Maybe<HotelAutocompleteResults>;
  /** Retrieve details about the HRIS connection. Preferred over soon-to-be-deprecated hrisConnection. */
  hrConnection?: Maybe<HrConnection>;
  /** List many HRIS Connections. Preferred over soon-to-be-deprecated hrisConnections. */
  hrConnections?: Maybe<HrConnectionConnection>;
  /** List all connections for a customer account id given some filter criterion */
  hrisConnections?: Maybe<Array<HrisConnection>>;
  /** List HRIS job runs */
  hrisJobRuns?: Maybe<HrisJobRunConnection>;
  identitySuspiciousActivities?: Maybe<IdentitySuspiciousActivitiesConnection>;
  /** List user's task counts, separate by types for mobile vs. web clients. */
  inboxTaskCounts?: Maybe<InboxTaskCounts>;
  /**
   * Returns available mobile inbox task filters. Filters
   * are dynamically served by the task types available
   * to the customer.
   */
  inboxTaskFilters?: Maybe<InboxTaskFilterConnection>;
  /** List InboxTasks based on input criteria */
  inboxTasks?: Maybe<InboxTaskConnection>;
  /** List InboxTasks based on input criteria */
  inboxTasksV2?: Maybe<InboxTaskConnectionV2>;
  inconsistencies?: Maybe<InconsistencyEntriesConnection>;
  /** Query for list of insight settings for the account */
  insightSettings?: Maybe<Array<InsightSetting>>;
  integration?: Maybe<Integration>;
  integrationEntities?: Maybe<ExternalIntegrationEntityConnection>;
  /** DEPRECATED for 1B-enabled accounts. Migration by ERP is in progress. See go/accounting-devex for more info. */
  integrationEntity?: Maybe<ExternalIntegrationEntity>;
  integrationRule?: Maybe<IntegrationRule>;
  /** DEPRECATED for 1B-enabled accounts. Migration ERP-by-ERP is in progress. See go/accounting-devex for more info. */
  integrations?: Maybe<IntegrationConnection>;
  /** internal entity sync errors */
  internalEntitySyncErrors?: Maybe<InternalEntitySyncErrorConnection>;
  /** Fetches international bank information based on the given SWIFT code and IBAN. */
  internationalBankInformation?: Maybe<InternationalBankInformation>;
  internationalWireConfig?: Maybe<InternationalWireConfig>;
  /** Get the count of invitable users by complex conditions (uses Query Platform). */
  invitableUserCount?: Maybe<Scalars["Int"]>;
  /** Search or list invitable users with complex conditions (uses Query Platform). */
  invitableUserSearch?: Maybe<UserConnection>;
  /** Get an invite by id */
  invite?: Maybe<Invite>;
  /** List invites */
  invites?: Maybe<InviteConnection>;
  /** Fetch invoice details by id */
  invoiceDetails?: Maybe<Invoice>;
  /**  Get invoice by id. */
  invoiceV1?: Maybe<InvoiceV1>;
  /** Fetch invoices for customer */
  invoices?: Maybe<InvoiceConnection>;
  /**  List invoices. */
  invoicesV1?: Maybe<InvoiceV1Connection>;
  invoicingAccount?: Maybe<InvoicingAccount>;
  /**  Get invoicing account */
  invoicingAccountV1?: Maybe<InvoicingAccountV1>;
  invoicingInvoice?: Maybe<InvoicingInvoice>;
  /**
   * Check if a customer is enabled for accounting 1BStack.
   *
   * `vendorToEnable` is an optional field. Set it to the vendor you want to enable for the customer only when customer does
   * not have any active integration.
   *
   * This check assumes that customer can have a single active integration.
   * We would need to revise this check if we introduce multiple active integration when the 1BStack migration is in
   * progress.
   */
  isAccounting1BStackEnabled?: Maybe<IsAccounting1BStackEnabledResult>;
  /**
   * Returns a boolean indicating whether criticality and deadlines are enabled for a user via feature flag
   * @deprecated This feature flag is always enabled now
   * @deprecated This feature flag is always enabled now
   */
  isCriticalityAndDeadlinesEnabled?: Maybe<Scalars["Boolean"]>;
  isEarlyPayEligible?: Maybe<Scalars["Boolean"]>;
  /**
   * Check if empower LD segments are in sync with TILL configuration.
   * @deprecated Will always return true. Leaving in until mobile stops calling this
   */
  isEmpowerSynced?: Maybe<Scalars["Boolean"]>;
  /** Returns true if the user is an external bookkeeper of the FSP, false otherwise */
  isExternalBookkeeper?: Maybe<Scalars["Boolean"]>;
  /** Returns true if an account is a financial service provider (i.e. FSP), false otherwise */
  isFsp?: Maybe<Scalars["Boolean"]>;
  /** Whether a customer should see the high risk applicant ID verification flow. */
  isHighRiskIDV?: Maybe<Scalars["Boolean"]>;
  isIntegrationReadyToSync?: Maybe<SyncReadyStatus>;
  /**
   * Check if a customer is enabled for payment accounts mapping 1BStack.
   *
   * `vendorToEnable` is an optional field. Set it to the vendor you want to enable for the customer only when customer does
   * not have any active integration.
   *
   * This check assumes that customer can have a single active integration.
   */
  isPaymentAccountsMappingEnabled?: Maybe<isPaymentAccountsMappingEnabledResult>;
  /** Whether screening for personal trial is approved. Specific requirement for that experience only. */
  isPersonalTrialScreeningApproved?: Maybe<Scalars["Boolean"]>;
  /** Whether the user is in the targeted referrals experiment */
  isReferrals500Reward8KSpendEnabled?: Maybe<Scalars["Boolean"]>;
  /** Whether user sanction screening is approved. Required by all users to complete onboarding. */
  isScreeningApproved?: Maybe<Scalars["Boolean"]>;
  isSocialLoginsEnabled?: Maybe<IsSocialLoginsEnabledResult>;
  /** Check if account has the super admin feature enabled */
  isSuperAdminEnabled?: Maybe<Scalars["Boolean"]>;
  /** Returns a boolean indicating whether the task inbox is enabled or not via a feature flag */
  isTaskInboxEnabled?: Maybe<Scalars["Boolean"]>;
  /** Is the user whitelisted for auto-pay? */
  isWhiteListedForAutoPay?: Maybe<Scalars["Boolean"]>;
  knowledgeBaseVendors?: Maybe<KnowledgeBaseVendorConnection>;
  lastScheduledPrepayment?: Maybe<ScheduledPrepayment>;
  /** Get the latest limit increase request for a customer */
  latestLimitIncreaseRequest?: Maybe<LimitIncreaseRequest>;
  /** Get the latest FundingSourceVerificationRetry CollectionPromise for each funding source for the current customer */
  latestPennyPullRetryCollections?: Maybe<
    Array<FundingSourceCollectionPromiseMapping>
  >;
  /** Returns the latest statement request for a customer */
  latestStatementRequest?: Maybe<FinancialStatementRequest>;
  lead?: Maybe<LeadObject>;
  /** List legal entities */
  legalEntities?: Maybe<LegalEntityConnection>;
  /** Get legal entity by identifier */
  legalEntity?: Maybe<LegalEntity>;
  /** Get a limit group by id */
  limitGroup?: Maybe<LimitGroup>;
  /** List limit group/spend limit entities */
  limitGroupOrSpendLimits?: Maybe<LimitGroupOrSpendLimitConnection>;
  /** List limit groups */
  limitGroups?: Maybe<LimitGroupConnection>;
  limitUtilizationTriggers?: Maybe<Array<LimitUtilizationTrigger>>;
  /** Fetch data needed to link an existing Uber for Business organization. */
  linkExistingUberOrganizationData?: Maybe<LinkExistingUberOrganizationData>;
  /** Lists all the export entries associated with an accounting record source id. */
  listAccountingRecordSourceExportEntries?: Maybe<AccountingRecordSourceExportEntriesConnection>;
  /** Get a list with all existing user alerts */
  listAlerts?: Maybe<AlertConnection>;
  /** List auto invite settings */
  listAutoInviteSettings?: Maybe<AutoInviteSettingConnection>;
  /** Queries a list of vendor integration credentials. */
  listCredentials?: Maybe<ListCredentialsResult>;
  /** List departments */
  listDepartments?: Maybe<DepartmentConnection>;
  /** List export jobs based on given filters. */
  listExportJobs?: Maybe<ExportJobConnection>;
  /** List groups by a condition dependency */
  listGroupsByDependency?: Maybe<GroupConnection>;
  /** List locations */
  listLocations?: Maybe<LocationConnection>;
  /** Gets partner codes assigned to the current user */
  listPartnerCodes?: Maybe<Array<PartnerCode>>;
  /** List all requirements for all available rails */
  listRailRequirements?: Maybe<Array<RailRequirement>>;
  /**
   * List referral records
   *
   * @page defaults to first 100 entries if no pagination is set
   * @order defaults to order by insertedAt DESC
   */
  listReferralRecords?: Maybe<ListReferralRecordsConnection>;
  /**
   * List the column options for any template for the current user - pagination not implemented. Will select first
   * integration returned
   */
  listReportColumnOptions?: Maybe<ReportColumnOptionConnection>;
  /**
   * List the template info for templates accessible for the current user - pagination not implemented
   * @deprecated No longer supported
   */
  listReportTemplates?: Maybe<ReportTemplateConnection>;
  /**
   * Lists all RFI's (regardless of workflow) of a certain Status sent to an Account
   * Defaults to first 10 and can be further narrowed down to RFIs sent to a specific user
   */
  listRfisForAccountByStatus?: Maybe<RfiConnection>;
  /**
   * List sandbox actions.
   *
   * @page pagination settings, if not set it'll get the first page and the first 100 records
   * @filter The filter to be applied to the listing, if not set it will bring all records
   * @order The order of the records, if not set it will return by descending insertion date
   */
  listSandboxAccountActions?: Maybe<ListSandboxAccountActionsResult>;
  llmOAuthIntegrations?: Maybe<LLMOAuthIntegrationConnection>;
  /** Get location by identifier */
  location?: Maybe<Location>;
  /** Lists all enabled loyalty programs. */
  loyaltyProgramsV2?: Maybe<LoyaltyProgramV2Connection>;
  /** Get a specific mapping class by ID. */
  mappingClass?: Maybe<MappingClass>;
  /**
   * List mapping classes with pagination and filters.
   * Only mapping classes associated with either (1) the active integration or (2) no integration will be returned.
   */
  mappingClasses?: Maybe<MappingClassConnection>;
  marketoLeadForm?: Maybe<MarketoLeadForm>;
  /**
   * The max transaction amount a user can spend given the spend limits they're a member of
   * Returns null if the spend limit with the max transaction amount has limit visibility = PRIVATE
   */
  maxTransactionAmount?: Maybe<FinancialAsset>;
  merchant?: Maybe<Merchant>;
  merchantCategories?: Maybe<MerchantCategoryConnection>;
  merchantCategory?: Maybe<MerchantCategory>;
  /** Internal query supporting federation. Do not use in client calls. */
  merchantCategoryEntity: MerchantCategory;
  /** Internal query supporting federation. Do not use in client calls. */
  merchantEntity: Merchant;
  /** Get the migration metadata for the current account */
  migratedAccount?: Maybe<MigratedAccount>;
  /** Get the current user's migrated user data */
  migratedUser?: Maybe<MigratedUser>;
  /** List of migrated users from an account */
  migratedUsers?: Maybe<Array<MigratedUser>>;
  /** Get user. If no id is provided, get the user associated with the current BrexContext. */
  migrationTargetUser?: Maybe<User>;
  migrationTargetUsers?: Maybe<UserConnection>;
  /** Gets the active mileage rate for a caller, date and distance */
  mileageRate?: Maybe<MileageRate>;
  /** Gets the active mileage setting for a specific country and caller */
  mileageSetting?: Maybe<MileageSetting>;
  /** Gets a list of all mileage settings for caller */
  mileageSettings?: Maybe<MileageSettingConnection>;
  /** Lists all miles transfer. */
  milesTransfersV2?: Maybe<MilesTransferV2Connection>;
  /** Gets the most recently used currency for the given payment instrument logical id. */
  mostRecentlyUsedCurrency?: Maybe<MostRecentlyUsedCurrency>;
  /** Whether the user should be in the product onboarding flow */
  mustSeeProductOnboarding?: Maybe<Scalars["Boolean"]>;
  node?: Maybe<Node>;
  nodes?: Maybe<Array<Maybe<Node>>>;
  /**
   * List object mappings based on filters.
   *
   * Object Mappings represent a 1:1 connection between a Brex object and an ERP object
   */
  objectMappings?: Maybe<ObjectMappingConnection>;
  /** offboardData */
  offboardData?: Maybe<OffboardDataResult>;
  onboardingApplication?: Maybe<OnboardingApplication>;
  /** Internal query supporting federation. Do not use in client calls. */
  onboardingApplicationEntity: OnboardingApplication;
  onboardingApplications?: Maybe<OnboardingApplicationConnection>;
  /** Get an opinionated section template for a related feature. */
  opinionatedSectionTemplate?: Maybe<ExpensePolicySpecSectionBlock>;
  /** Query for mutation events and filter by mutator type */
  organizationMutationEvents?: Maybe<OrganizationMutationEventConnection>;
  /** Check if account has started adding users to Brex */
  organizationSetupComplete?: Maybe<Scalars["Boolean"]>;
  passwordLastUpdated?: Maybe<Scalars["Time"]>;
  /** Fetch all linked payroll providers for account */
  payrollProviders?: Maybe<Array<PayrollProviderV2>>;
  /** Query for periodic review by customer account ID */
  periodicReview?: Maybe<PeriodicReview>;
  permissionsSummary?: Maybe<PermissionsSummary>;
  personalAccounts?: Maybe<FinancialsAccountV2Connection>;
  personalCurrentBalances?: Maybe<FinancialBalanceV2Connection>;
  personalSources?: Maybe<FinancialSourceConnection>;
  /** Get incentive placements to display to user. */
  placements?: Maybe<IncentivePlacementViewDataConnection>;
  plaidInstitutionFallbacks?: Maybe<Array<Maybe<PlaidInstitutionMapping>>>;
  /** Gets the maximum amount for points redemption towards Brex Cash */
  pointsBalanceAsCashRedemptionAmount?: Maybe<Scalars["Int"]>;
  /** List Policies */
  policies?: Maybe<PolicyConnection>;
  /** Get an policy by id */
  policy?: Maybe<Policy>;
  /** Generate rules with description strings from rule inputs (for policy live-preview panel) */
  policyPreview?: Maybe<PolicyPreview>;
  /** Preview expense lenses with a new integration rule */
  previewExpenseLenses?: Maybe<ExpenseConnection>;
  /** Preview group members */
  previewGroupMembers?: Maybe<GroupMemberConnection>;
  previewIntegrationRule?: Maybe<StatementEntryLensConnection>;
  /** Preview limit group members */
  previewLimitGroupMembers?: Maybe<LimitGroupMemberConnection>;
  /** Preview a limit group membership, with applicable overrides */
  previewLimitGroupMembership?: Maybe<LimitGroupPreviewMemberConnection>;
  /**
   * Returns a preview of the vendorFileMatches to be created from a spend migration import.
   * As this is a preview before creation, the encoded ID returned at the graphql layer is the vendorId, as
   * the vendorFileMatch ID is not yet created.
   */
  previewVendorFileMatches?: Maybe<VendorFileMatchConnection>;
  /** User's primary card */
  primaryCard?: Maybe<Card>;
  /**
   * Fuzzy search for any primitive, which can be a title, cost center, legal entity, location, department, or user.
   *
   * NOTE: pagination is not implemented currently. By default, it will return 10 results for each primitive type.
   */
  primitiveFuzzySearch?: Maybe<PrimitiveConnection>;
  /**
   * Get product configurations for current account
   * (i.e. which features are enabled for this account)
   */
  productConfig?: Maybe<ProductConfig>;
  /**
   * Get the products a customer selected, if it exists.
   * Null if they did not select products on the `product-selection-reimbursements-billpay` flow.
   */
  productSelection?: Maybe<ProductSelection>;
  /** Lists all program memberships. */
  programMembershipsV2?: Maybe<ProgramMembershipV2Connection>;
  /** Gets purchase order by id */
  purchaseOrder?: Maybe<PurchaseOrder>;
  /** List purchase orders */
  purchaseOrders?: Maybe<PurchaseOrderConnection>;
  /** List purchasing cards */
  purchasingCards?: Maybe<PurchasingCardConnection>;
  /** List qualifying Limit Groups for user attributes */
  qualifyingLimitGroups?: Maybe<LimitGroupConnection>;
  /** Query for a list of available quick actions */
  quickActions?: Maybe<QueryQuickActionsResponse>;
  /**
   * Retrieves rail account details with pagination support.
   * Rail account details represent external banking account configurations
   * used for various payment rails (ACH, Wire, SWIFT, etc.).
   *
   * Returns a connection with edges containing individual rail account details,
   * along with pagination information and total count.
   */
  railAccountDetails?: Maybe<RailAccountDetailsConnection>;
  /**
   * Validates multiple rail account details without persisting them to the database.
   * This is useful for real-time form validation before submission.
   *
   * Performs the same validations as creation but returns validation results
   * instead of creating records. Batch operation for efficiency.
   */
  railAccountDetailsBatchValidate?: Maybe<
    Array<RailAccountDetailsBatchValidateResult>
  >;
  /**
   * Returns rail stations matching the input query string.
   * This depends on Spotnana's API:
   * https://apis.spotnana.com/api/version2.html#get-/v2/rail-autocomplete
   */
  railAutocomplete?: Maybe<RailAutocompleteResults>;
  /**
   * Retrieves the required fields and validation rules for specific payment rails.
   * This query helps determine what information must be collected to create
   * rail account details for different rail types and jurisdictions.
   *
   * Use this to dynamically generate forms for different payment rails
   * based on source/target currencies, countries, and capabilities.
   */
  railRequirements?: Maybe<Array<RailRequirements>>;
  /**
   * Retrieves available payment rails that can be used for money movement.
   * Rails represent different payment networks and methods (e.g., ACH, Wire, SWIFT).
   *
   * Each rail has specific capabilities, supported currencies, and countries.
   * Use this to display available payment options to users.
   */
  rails?: Maybe<Array<Rail>>;
  /** Fetch a receipt. */
  receipt?: Maybe<Receipt>;
  /** Get the receipt auto generation settings for a customer account */
  receiptAutogenSetting?: Maybe<ReceiptAutogenSetting>;
  /** Get statistics about receipt auto generation for a customer account */
  receiptAutogenStatistics?: Maybe<ReceiptAutogenStatistics>;
  receiptIntegration?: Maybe<ReceiptIntegration>;
  /**
   * Get the user level status of a receipt integration. For instance, with Uber, an admin enables
   * the integration for the entire customer account, but each individual user still needs to then
   * connect individually.
   */
  receiptIntegrationUserConnectionStatus?: Maybe<ReceiptIntegrationUserConnectionStatus>;
  /** Get the receipt validation settings for a customer account */
  receiptValidationSetting?: Maybe<ReceiptValidationSetting>;
  /** Get information about the receipts workflow, which holds stateful business logic (state, associations) */
  receiptWorkflow?: Maybe<ReceiptWorkflow>;
  /**
   * Fetch a list of receipts.
   * This query imposes a timeout on Easy Upload receipts, where if a receipt is fetched from this query
   * and enough time has passed between receipt creation and time of query, we store a match failure for the receipt.
   */
  receipts?: Maybe<ReceiptConnection>;
  referralInformation?: Maybe<ReferralInformation>;
  referralRecords?: Maybe<Array<Maybe<ReferralRecord>>>;
  referralRecordsPaginated?: Maybe<ReferralRecordsPaginated>;
  referralsSummary?: Maybe<ReferralsSummary>;
  /** @deprecated Use User.reimbursementFeatureAvailability instead */
  reimbursementHealth?: Maybe<ReimbursementHealth>;
  /** Internal query supporting federation. Do not use in client calls. */
  reimbursementItemEntity: ReimbursementItem;
  reimbursementPaymentSource?: Maybe<ReimbursementPaymentSource>;
  reimbursementVat?: Maybe<VatResult>;
  /**
   * Query to release notes for customer metrics dashboard
   * @deprecated Use curatedCarousel instead
   */
  releaseNotes?: Maybe<QueryReleaseNotesResponse>;
  /** Get remaining balance of a journal account */
  remainingBalance?: Maybe<FinancialAsset>;
  /** Get the report entry data from the given ids */
  reportEntries?: Maybe<Array<ReportEntry>>;
  /** Get a template by id */
  reportTemplate?: Maybe<ReportTemplate>;
  /** List Report Templates - default sorting by last used time */
  reportTemplates?: Maybe<ReportTemplateConnection>;
  /** Query for a dashboard by its ID */
  reportingDashboard?: Maybe<ReportingDashboard>;
  /** List dashboards available to the user */
  reportingDashboards?: Maybe<ReportingDashboardConnection>;
  /** List direct and nested reports */
  reports?: Maybe<EmployeeConnection>;
  /** Gets current account's Representative */
  representative?: Maybe<Representative>;
  /** Get a single Request Action by ID */
  requestAction?: Maybe<RequestAction>;
  /** Gets request deadline settings for the caller's account. */
  requestDeadlineSettings?: Maybe<RequestDeadlineSettings>;
  resourceOperations?: Maybe<Array<ResourceOperation>>;
  /** Fetch data needed to revoke an Uber for Business organization. */
  revokeUberOrganizationData?: Maybe<RevokeUberOrganizationData>;
  /** Gets rewards campaigns and triggers */
  rewardsCampaignsV2?: Maybe<RewardsCampaignV2Connection>;
  /** Gets rewards gift card catalog */
  rewardsGiftCardCatalog?: Maybe<RewardsGiftCardCatalog>;
  /** Gets rewards gift card redemptions */
  rewardsGiftCardRedemptions?: Maybe<RewardsGiftCardRedemptionsConnection>;
  /** Gets points histories */
  rewardsPointHistoryEntriesV2?: Maybe<RewardsPointsHistoryEntryV2Connection>;
  /** Gets a rewards redemption instance by ID */
  rewardsRedemption?: Maybe<RewardsRedemption>;
  /** Gets redemption programs and offers */
  rewardsRedemptionProgramsV2?: Maybe<RewardsRedemptionProgramsV2Connection>;
  /** Available account-level roles. */
  roles?: Maybe<AuthRoleConnection>;
  /** Get the logged in customer account's root policy for the given request type */
  rootPolicy?: Maybe<Policy>;
  /**
   * Retrieve all saved views available to the user for the given table.
   * Entries will be sorted alphabetically by label.
   */
  savedViews?: Maybe<SavedViewConnection>;
  /** List many SCIM connections for the logged-in user's account. */
  scimConnections?: Maybe<ScimConnectionConnection>;
  /** Return a list of OAuth scopes the customer can request */
  scopes?: Maybe<Array<Maybe<ScopeWrapper>>>;
  search?: Maybe<SearchResult>;
  /** This API searches across all entities. The returned results will be ranked across all entities. */
  searchEntities?: Maybe<EntityConnection>;
  searchIndustries?: Maybe<IndustrySearchResultEntryConnection>;
  /** Search merchants */
  searchMerchants?: Maybe<Array<Maybe<Merchant>>>;
  searchUsers?: Maybe<UserConnection>;
  /**
   * This is only exposed as an entity so that we resolve it in the
   * acceptCompanyPolicyAgreement mutation. The SeenFlagKey entity makes this
   * difficult to resolve in multiple DGS. In the long run we should consider
   * changing the return type of this mutation, or leveraging the SeenFlag
   * mutations directly. Do not use in client calls.
   */
  seenFlagEntity?: Maybe<SeenFlag>;
  segmentationAttributesQuery?: Maybe<Scalars["Json"]>;
  segmentationQuery?: Maybe<SegmentQueryResult>;
  /** Returns whether or not an account has self-approval guardrails enabled */
  selfApprovalGuardrailsEnabled?: Maybe<Scalars["Boolean"]>;
  /** Whether birth date should be collected from the user. */
  shouldCollectBirthDate?: Maybe<Scalars["Boolean"]>;
  /** Returns true if a given user should have access to the Financial Statement Experience */
  shouldDisplayFinancialStatementExperience?: Maybe<ShouldDisplayFinancialStatementExperienceResponse>;
  /** Gets if we need to request beneficial owners and controlling officers for the company */
  shouldRequestBOCO?: Maybe<Scalars["Boolean"]>;
  /** Gets if we need to request financial details for the company */
  shouldRequestFinancialDetails?: Maybe<Scalars["Boolean"]>;
  /** Determines whether user should see platform and/or privacy agreements on 'set password' page */
  shouldSeeLegalAgreements?: Maybe<ShouldSeeLegalAgreementsResponse>;
  /** Whether the user should be shown a company policy agreement */
  shouldShowCompanyPolicyAgreement?: Maybe<Scalars["Boolean"]>;
  /** Get signup payload for a particular customer. */
  signupPayload?: Maybe<Signup>;
  /** Simulate running a new or modified expense workflow rule, returning matching expenses and would-be rule actions. */
  simulateExpenseWorkflowRule?: Maybe<ExpenseRuleEvaluationConnection>;
  /** Get spend budget */
  spendBudget?: Maybe<SpendBudget>;
  /** List spend budgets */
  spendBudgets?: Maybe<SpendBudgetConnection>;
  /** Get spend limit */
  spendLimit?: Maybe<SpendLimit>;
  /** List spend limits */
  spendLimits?: Maybe<SpendLimitConnection>;
  /** Get spend limits where user can request increase */
  spendLimitsUserCanRequestIncrease?: Maybe<SpendLimitConnection>;
  /**
   * Top-level query supporting fetching data for page load to avoid waterfalls in the client.
   * Implicitly scoped to account from identity context
   */
  spendMigration?: Maybe<SpendMigration>;
  ssoMeta?: Maybe<SsoMetaResult>;
  /** Fetch ssu prefill data for partner referrals */
  ssuPrefillData?: Maybe<SsuPrefillData>;
  statementEntries?: Maybe<StatementEntryConnection>;
  statementEntry?: Maybe<StatementEntry>;
  /** Internal query supporting federation. Do not use in client calls. */
  statementEntryEntity: StatementEntry;
  /** Get a paginated list of statements */
  statements?: Maybe<StatementsConnection>;
  stepUpMfaConditions?: Maybe<StepUpMfaConditionOutcomes>;
  suggest?: Maybe<Array<Maybe<Suggestion>>>;
  /** Gets current user's default Support Channels */
  supportChannels?: Maybe<SupportChannels>;
  /** Gets a list of all the locales supported by Brex. */
  supportedLocales?: Maybe<Array<Locale>>;
  supportedRoles?: Maybe<Array<Maybe<Scalars["String"]>>>;
  surfaceTaskCounts?: Maybe<SurfaceTaskCounts>;
  /** List Tasks based on surface and groups */
  surfaceTasks?: Maybe<SurfaceTaskConnection>;
  /** Find permission of tagged users */
  taggedEmployeePermission?: Maybe<TaggedEmployee>;
  /** Get task and its status. This endpoint should be polled by the frontend. */
  task?: Maybe<Task>;
  /** Get the max size for a given task */
  taskMaxSize?: Maybe<Scalars["Long"]>;
  /** List tasks */
  tasks?: Maybe<TaskConnection>;
  /** List titles */
  titles?: Maybe<TitleConnection>;
  /** Retrieves all tracking expense policies of a customer user */
  trackingExpensePolicies?: Maybe<TrackingExpensePolicyConnection>;
  transactedMerchants?: Maybe<Array<Maybe<Merchant>>>;
  /** Query for a single booking. */
  travelBooking?: Maybe<TravelBooking>;
  /** List bookings */
  travelBookings?: Maybe<TravelBookingConnection>;
  /** Gets an estimate of the cost of a trip. */
  travelCostEstimates?: Maybe<TravelCostEstimates>;
  /** Given a user ID from Brex or from our travel partner, returns both IDs. */
  travelPartnerUserAssociation?: Maybe<TravelPartnerUserAssociation>;
  /**
   * Get the permission status for the current user.
   * @deprecated Use IAM service for permission checks instead
   */
  travelPermissionStatus?: Maybe<TravelPermissionStatus>;
  /** Query for a single trip. */
  travelTrip?: Maybe<TravelTrip>;
  /** List trips. */
  travelTrips?: Maybe<TravelTripConnection>;
  /** Get the Brex Trip Id given a partner trip ID (default: Spotnana). */
  tripIdFromPartnerId?: Maybe<Scalars["String"]>;
  /** List trips. */
  trips?: Maybe<ExpenseGroupingConnection>;
  /** Check if should show embedded experience password screen or not */
  unauthenticatedUserPasswordScreen?: Maybe<UnauthenticatedUserPasswordScreenResponse>;
  /** Query underwriting model class name. */
  underwritingModelClassName?: Maybe<UnderwritingModelName>;
  /** Get underwriting policy. */
  underwritingPolicy?: Maybe<UnderwritingPolicy>;
  unexportedExpenseCount?: Maybe<UnexportedExpenseCount>;
  /** Get matching rules filter facets for unexported expenses */
  unexportedExpenseFilterFacets?: Maybe<Array<Maybe<MatchingRulesFilterFacet>>>;
  /** List unexported Expenses */
  unexportedExpenses?: Maybe<ExpenseConnection>;
  unexportedStatementEntries?: Maybe<StatementEntryConnection>;
  unexportedStatementEntryCount?: Maybe<UnexportedStatementEntryCount>;
  unexportedStatementEntryFilterFacets?: Maybe<
    Array<Maybe<IntegrationRulesFilterFacet>>
  >;
  /** Returns all uploaded documents for the customer, split into current and prior batches */
  uploadedFinancialDocuments?: Maybe<UploadedFinancialDocumentsResponse>;
  /** Fetch usage measurements for client. */
  usageMeasurements?: Maybe<UsageResponse>;
  /**
   * Get the user associated with the current BrexContext.
   *
   * NOTE: This query ignores the ID field, its there for backwards compatibility only, and will eventually be removed.  Do not use it.
   */
  user?: Maybe<User>;
  userActiveOauthApplications?: Maybe<ActiveOauthApplicationsConnection>;
  userActiveSessions?: Maybe<ActiveSessionsConnection>;
  userActivityHistory?: Maybe<ActivityHistoryConnection>;
  /** Query User Assistant Setting */
  userAssistantSetting: UserAssistantSetting;
  userCategories?: Maybe<UserCategoryConnection>;
  userCategory?: Maybe<UserCategory>;
  /**
   * userGroupOptions returns options that can be used to construct groups. The types of the
   * options that can be returned are specified by the UserGroupOptionsType enum.
   * NOTE: pagination is not currently implemented. It will return 10 results for each type.
   */
  userGroupOptions?: Maybe<UserGroupOptionsSearchResultConnection>;
  /**
   * Deprecated - User Limits should be resolved through the User entity instead or global id node queries
   * Get a user limit by customer user id. Will default to the current user if no customer user id is provided.
   * @deprecated Refrain from directly fetching a userLimit through this query. You should resolve userLimit through the user entity or global id node queries.
   */
  userLimit?: Maybe<UserLimit>;
  /**
   * Deprecated - User Limits should be resolved through User entity edges instead
   * List user limits
   * @deprecated Refrain from directly fetching a userLimit through this query. You should resolve userLimit through the user entity.
   */
  userLimits?: Maybe<UserLimitConnection>;
  /** Retrieves the most recent search queries made by a user. */
  userMostRecentSearches?: Maybe<RecentSearchResult>;
  /**
   * Gets UserReviewTasks.
   * Results are always filtered by the customerUserId obtained from the context.
   */
  userReviewTasks?: Maybe<UserReviewTaskConnection>;
  userTrustedDevices?: Maybe<TrustedDevicesConnection>;
  /** Get user, ignoring any active delegation in the session. */
  userWithoutDelegator?: Maybe<User>;
  /** @deprecated Use migrationTargetUsers instead. This query will be removed in the future. */
  users?: Maybe<UserConnection>;
  /** Validate user with token is active (not deleted) and the user's SSO issuer if SSO is enabled */
  validateActivation?: Maybe<ValidateActivation>;
  /** Query to validate contact inputs */
  validatedVendorContactInputs?: Maybe<ValidatedVendorContactInputConnection>;
  /** Query to get value metrics */
  valueMetrics?: Maybe<QueryValueMetricsResponse>;
  /** Query to get date selections with start and end dates */
  valueMetricsDateRanges?: Maybe<QueryValueMetricsDateRangesResponse>;
  /** Query for explanations on how value metrics are calculated */
  valueMetricsExplanations?: Maybe<QueryValueMetricsExplanationsResponse>;
  /** Gets vendor by id */
  vendor?: Maybe<VendorDetails>;
  vendorDocument?: Maybe<VendorDocument>;
  /** Get the vendor file match. */
  vendorFileMatch?: Maybe<VendorFileMatch>;
  /** Lists all the vendor file matches from vendor file(s) associated with a given customer account ID */
  vendorFileMatches?: Maybe<VendorFileMatchConnection>;
  /** Get vendor one-time-card for a single bill expense */
  vendorOneTimeCard?: Maybe<VendorOneTimeCardDetails>;
  /** List vendors */
  vendors?: Maybe<VendorConnection>;
  /** Gets the verification requirements for a given customer account and context. */
  verification?: Maybe<VerificationResult>;
  /** List analyses. */
  verificationAnalyses?: Maybe<VerificationAnalysisConnection>;
  /** Get an analysis by ID. */
  verificationAnalysis?: Maybe<VerificationAnalysis>;
  /** List Verification Notifications */
  verificationNotifications?: Maybe<VerificationNotificationConnection>;
  verifyAddress?: Maybe<VerifyAddressResponse>;
  /** Verify an address using the Lob API */
  verifyAddressV2?: Maybe<VerifyAddressResult>;
  workflowActions?: Maybe<Array<WorkflowActionDescriptor>>;
  /**
   * Gets a list of workflow attribute groups, with pagination support and the associated workflow attributes. This API
   * is intended to power the multi-select panel in the workflow builder.
   */
  workflowAttributeGroups?: Maybe<WorkflowAttributeGroupConnection>;
  workflowAttributes?: Maybe<Array<WorkflowAttribute>>;
  /**
   * Fetch attributes associated with the group. This should be the default query for workflow attributes, unfortunately
   * we'd need to make client migrations to use relay here, so we're creating this versioned property.
   */
  workflowAttributesV2?: Maybe<WorkflowAttributeConnection>;
  workflowFunctions?: Maybe<Array<WorkflowFunctionDescriptor>>;
  /** Get the Workflow Rules by filters */
  workflowRules?: Maybe<WorkflowRuleConnection>;
  /**
   * Get a search facet based on a filter and a facet tag.
   *
   * A facet typically refers to those neat filters on the left side of Amazon/DataDog/whatever with the list of options
   * and counts.
   *
   * For example, a facet for service on the DataDog monitors page starts like this:
   * - graphql - 1396
   * - dashboard - 737
   * - identity - 241
   *
   * For rules, we'll specify filters like cuacc = X, pick a tag key like "gl_account", and get a facet back like this:
   * - EPD Expenses GL - 23
   * - Leadership Travel GL - 3
   * - Office Expenses GL - 2
   *
   * In practice, the tag is usually an extended field ID and the values are option identifiers.
   */
  workflowRulesFacetConnection?: Maybe<WorkflowRulesFacetBucketConnection>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryaccountEntityArgs {
  id?: InputMaybe<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryaccountingIntegrationsArgs {
  after?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<AccountingIntegrationFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryaccountingJournalEntriesArgs {
  after?: InputMaybe<Scalars["String"]>;
  entityFilter?: InputMaybe<EntityFilterInput>;
  filter?: InputMaybe<AccountingJournalEntryFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  integrationId: Scalars["ID"];
  page?: InputMaybe<PaginationInput>;
  sorts?: InputMaybe<Array<AccountingJournalSortInput>>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryaccountingRecordsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<AccountingRecordFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  sorts?: InputMaybe<Array<AccountingRecordSortInput>>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryactiveLimitEscalationsArgs {
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryadminHomeWidgetArgs {
  id?: InputMaybe<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryadminHomeWidgetsByProductSegmentArgs {
  filter?: InputMaybe<WidgetTemplatesFilter>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryairAutocompleteArgs {
  filter?: InputMaybe<AirAutocompleteFilterInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryanonymousSessionArgs {
  suspendable?: InputMaybe<Scalars["Boolean"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryapplicationSessionArgs {
  suspendable?: InputMaybe<Scalars["Boolean"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryapprovalsUnsafeFlagArgs {
  flagName: Scalars["String"];
  keyType: ApprovalsUnsafeFlagKeyType;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryassetArgs {
  id?: InputMaybe<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryassetEntityArgs {
  id?: InputMaybe<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryassignableRolesArgs {
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryassistantMessagesArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  chatSessionId?: InputMaybe<Scalars["ID"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryauditGroupsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  where?: InputMaybe<AuditGroupWhereInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryauthRoleArgs {
  id?: InputMaybe<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryautoInviteSettingArgs {
  identifier: AutoInviteSettingIdentifier;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryautogenSettingTestArgs {
  cuacc?: InputMaybe<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryautomationSuggestionArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryautomationSuggestionGroupsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<AutomationSuggestionGroupsFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<AutomationSuggestionGroupsSortInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryautomationSuggestionsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter: AutomationSuggestionsFilterInput;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryautomationWorkflowSpecArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryautomationWorkflowSpecsArgs {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybankingAccountDailyBalanceSnapshotsArgs {
  input: BankingAccountDailyBalanceSnapshotsInput;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybankingDailyAccountSnapshotsArgs {
  input: BankingDailyAccountsSnapshotsInput;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybankingPoliciesArgs {
  input: BankingPoliciesFilterInput;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybankingStatementsArgs {
  after?: InputMaybe<Scalars["String"]>;
  depositsAccountIds?: InputMaybe<Array<Scalars["String"]>>;
  endDate?: InputMaybe<Scalars["Date"]>;
  first?: InputMaybe<Scalars["Int"]>;
  startDate?: InputMaybe<Scalars["Date"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybankingTransactionRequestEntityArgs {
  id?: InputMaybe<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybatchBudgetTemplatesArgs {
  ids: Array<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybatchCashTransactionsArgs {
  ids: Array<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybatchCounterpartiesArgs {
  ids: Array<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybatchCountriesArgs {
  keys: Array<CountryAlpha2>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybatchDepositsAccountsArgs {
  ids: Array<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybatchDownloadJobsArgs {
  ids: Array<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybatchExpenseEntityExtensionArgs {
  ids: Array<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybatchExtendedFieldsArgs {
  ids: Array<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybatchExternalIntegrationEntitiesArgs {
  ids: Array<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybatchFinancialAccountsArgs {
  ids: Array<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybatchFinancialInstitutionsArgs {
  ids: Array<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybatchMerchantCategoryEntitiesArgs {
  ids: Array<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybatchMerchantEntitiesArgs {
  ids: Array<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybatchPaymentContactsArgs {
  ids: Array<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybatchPaymentFxQuotesArgs {
  ids: Array<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybatchPaymentInstrumentsArgs {
  ids: Array<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybatchRailAccountDetailsArgs {
  ids: Array<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybatchSpendLimitsArgs {
  ids: Array<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybatchStatementEntryEntitiesArgs {
  ids: Array<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybatchUserCategoriesArgs {
  ids: Array<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybatchUserEntitiesArgs {
  ids: Array<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybatchVendorDetailsArgs {
  ids: Array<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybillArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybillBatchArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybillFieldSuggestionsArgs {
  receiptId: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybillSyncErrorsArgs {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  integrationId: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybillingDelinquenciesArgs {
  journalAccountIds?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybillingGroupsArgs {
  filters?: InputMaybe<BillingGroupFilterInput>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybillingInvoicesArgs {
  filter?: InputMaybe<BillingInvoicesFilterInput>;
  order?: InputMaybe<BillingInvoicesOrderInput>;
  page: PaginationInput;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybillingInvoicesV2Args {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<BillingInvoicesFilterInputV2>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  order?: InputMaybe<BillingInvoicesOrderInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybillingJournalAccountsArgs {
  filter?: InputMaybe<BillingJournalAccountsFilterInput>;
  page: PaginationInput;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybillingPaymentArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybillingPaymentIntentEntityArgs {
  id?: InputMaybe<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybillingTransactionArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybillingTransactionsArgs {
  filter?: InputMaybe<BillingTransactionFilterInput>;
  order?: InputMaybe<BillingTransactionOrderInput>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybillsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  dueAt?: InputMaybe<Scalars["Time"]>;
  endTime?: InputMaybe<Scalars["Time"]>;
  first?: InputMaybe<Scalars["Int"]>;
  invoiceProcessingStatuses?: InputMaybe<
    Array<InputMaybe<BillInvoiceProcessingStatus>>
  >;
  isDueSoon?: InputMaybe<Scalars["Boolean"]>;
  isRecurring?: InputMaybe<Scalars["Boolean"]>;
  last?: InputMaybe<Scalars["Int"]>;
  searchQuery?: InputMaybe<Scalars["String"]>;
  servicePerformedAt?: InputMaybe<Scalars["Time"]>;
  sortKey?: InputMaybe<BillSortKey>;
  sortOrder?: InputMaybe<BillSortOrder>;
  startTime?: InputMaybe<Scalars["Time"]>;
  statuses?: InputMaybe<Array<InputMaybe<BillStatus>>>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybillsV2Args {
  filter?: InputMaybe<BillFilterInput>;
  order?: InputMaybe<BillOrderInput>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybrexFeesArgs {
  filter?: InputMaybe<BrexFeesFilterInput>;
  order?: InputMaybe<BrexFeesOrderInput>;
  page: PaginationInput;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybudgetArgs {
  id?: InputMaybe<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybudgetAnyRequestEntitiesArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<BudgetRequestEntityFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybudgetConfigurationFlagsArgs {
  flags: Array<BudgetConfigurationFlagType>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybudgetDistributionTotalEmployeeCountArgs {
  userFilters: BudgetDistributionUserFilters;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybudgetEntityExtensionArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybudgetLimitIncreaseRequestEntityArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybudgetMerchantCategoriesSuggestionsArgs {
  suggestionsInput?: InputMaybe<
    Array<BudgetMerchantCategoriesSuggestionsInput>
  >;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybudgetMovementsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<BudgetMovementFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybudgetRequestEntitiesArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<BudgetRequestEntityFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybudgetRequestEntityArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybudgetRequestsValidationArgs {
  budgetRequestEntityIds?: InputMaybe<Array<Scalars["ID"]>>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybudgetTemplateArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybudgetTemplatesArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<BudgetTemplateFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybudgetTreeNodesArgs {
  after?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<BudgetTreeNodeFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  order?: InputMaybe<BudgetTreeNodeOrderInput>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybudgetUserNotificationTypePreferencesArgs {
  budgetId: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybudgetUsersAmountSpentArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybudgetsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<BudgetFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  order?: InputMaybe<BudgetOrderInput>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybudgetsAmountSpentArgs {
  at: Scalars["Date"];
  budgetIds: Array<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybudgetsAsParentsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  candidateFor: budgetEntityIDOneOfInput;
  filter?: InputMaybe<BudgetFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  order?: InputMaybe<BudgetOrderInput>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybudgetsDescendantIdsArgs {
  ids: Array<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybudgetsExpenseDryRunInformationArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  expenseId: Scalars["ID"];
  filter?: InputMaybe<BudgetFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  order?: InputMaybe<BudgetOrderInput>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybudgetsOffboardingActionsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybudgetsTotalSpendAcrossCurrentPeriodsArgs {
  filter?: InputMaybe<BudgetFilterInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerybuildAndRunPromptTemplateArgs {
  promptTemplateName: Scalars["String"];
  templatedVariables: Array<TemplatedVariable>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerycalculateMileageAmountArgs {
  countryCode?: InputMaybe<Scalars["String"]>;
  distance: DistanceInput;
  expenseOwnerUserId?: InputMaybe<Scalars["String"]>;
  purchasedAt?: InputMaybe<Scalars["Date"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerycalculatePerDiemArgs {
  input: CalculatePerDiemRequestInput;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerycanFSPUserAccessClientArgs {
  input: CanFSPUserAccessClientInput;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerycarAutocompleteArgs {
  filter?: InputMaybe<CarAutocompleteFilterInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerycardArgs {
  id: Scalars["ID"];
  showPan?: InputMaybe<Scalars["Boolean"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerycardEstimatedDeliveryDateArgs {
  input: CardEstimatedDeliveryDateInput;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerycardPartnersArgs {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerycardSearchArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<CardSearchFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
  sorts?: InputMaybe<Array<CardSortInput>>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerycardsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  central?: InputMaybe<Scalars["Boolean"]>;
  customerUserId?: InputMaybe<Array<Scalars["ID"]>>;
  departmentIds?: InputMaybe<Array<Scalars["String"]>>;
  first?: InputMaybe<Scalars["Int"]>;
  hasActiveLimitIncrease?: InputMaybe<Scalars["Boolean"]>;
  instrumentType?: InputMaybe<InstrumentType>;
  isManagedByPartner?: InputMaybe<Scalars["Boolean"]>;
  isPreapproved?: InputMaybe<Scalars["Boolean"]>;
  last?: InputMaybe<Scalars["Int"]>;
  searchQuery?: InputMaybe<Scalars["String"]>;
  sortBy?: InputMaybe<CardSortColumn>;
  status?: InputMaybe<Array<Scalars["String"]>>;
  statusViews?: InputMaybe<Array<StatusView>>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerycashRecurringScheduleArgs {
  paymentMethod?: InputMaybe<CashTransactionPaymentMethod>;
  paymentRail: PaymentRail;
  recurringSchedule: InputCashRecurringSchedule;
  startsAt?: InputMaybe<Scalars["Time"]>;
  timelineCount?: InputMaybe<Scalars["Int"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerycashTransactionArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerycashTransactionApprovalArgs {
  approvalToken: Scalars["String"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerycashTransactionIsFirstAchDebitArgs {
  depositsAccountId: Scalars["String"];
  financialAccountId: Scalars["String"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerycashTransactionTimelineEstimateArgs {
  location?: InputMaybe<AccountLocation>;
  origin: CashTransactionOrigin;
  paymentMethod: CashTransactionPaymentMethod;
  paymentRail: PaymentRail;
  scheduledSendAt?: InputMaybe<Scalars["Time"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerycashTransactionTimelineEstimatesArgs {
  origin: CashTransactionOrigin;
  paymentMethod: CashTransactionPaymentMethod;
  scheduledSendAt?: InputMaybe<Scalars["Time"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerycategoriesArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<CategoryFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  order?: InputMaybe<CategoryOrderInput>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerycategoryArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerycollectionPromisesArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<CollectionPromiseFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  order?: InputMaybe<Array<CollectionPromiseOrderInput>>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerycommentFeatureFlagArgs {
  input: CommentFeatureFlagInput;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerycommentSuggestionsArgs {
  commentSuggestionsInputList?: InputMaybe<Array<CommentSuggestionsInput>>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerycompareGroupMembershipsArgs {
  after?: InputMaybe<Scalars["String"]>;
  baseGroup: GroupComparisonOperandOneOfInput;
  before?: InputMaybe<Scalars["String"]>;
  comparisonGroup: GroupComparisonOperandOneOfInput;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerycomputeExpenseEntitiesArgs {
  budgetId?: InputMaybe<Scalars["ID"]>;
  expenseId: Scalars["ID"];
  legalEntityId?: InputMaybe<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryconflictingAncestorBudgetMerchantCategoryControlsArgs {
  merchantCategoryControls?: InputMaybe<
    Array<ConflictingAncestorBudgetMerchantCategoryControls>
  >;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryconflictingBudgetMerchantCategoryControlsArgs {
  merchantCategoryControls?: InputMaybe<
    Array<ConflictingBudgetMerchantCategoryControls>
  >;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryconflictingBudgetRequestMerchantCategoryControlsArgs {
  merchantCategoryControls?: InputMaybe<
    Array<ConflictingBudgetRequestMerchantCategoryControls>
  >;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryconnectHasEncounteredFailureArgs {
  vendor: FinancialsVendor;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryconnectSessionArgs {
  platform: Platform;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerycontactArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerycopilotsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<CopilotFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerycostCenterArgs {
  identifier: CostCenterIdentifier;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerycostCentersArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<CostCentersFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerycountAccountingJournalEntriesArgs {
  endDate?: InputMaybe<Scalars["Time"]>;
  startDate?: InputMaybe<Scalars["Time"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerycountAlertsArgs {
  input?: InputMaybe<CountAlertsInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerycountBudgetNodesToBeProcessedArgs {
  ids?: InputMaybe<Array<Scalars["ID"]>>;
  operation: BudgetTreeNodeBatchedOperation;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerycountExpensesArgs {
  countLimit?: InputMaybe<Scalars["Int"]>;
  filter?: InputMaybe<ExpenseFilterInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerycountriesArgs {
  filters?: InputMaybe<CountriesListFilters>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerycountryAddressMetadataArgs {
  alpha2: CountryAlpha2;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerycredentialArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerycredentialsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  vendor?: InputMaybe<Array<Scalars["String"]>>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerycustomerReferralArgs {
  referralCode?: InputMaybe<Scalars["String"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryddaMigrationStateArgs {
  customerAccountId: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerydebugErrorArgs {
  trigger?: InputMaybe<Scalars["Boolean"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerydebugExceptionArgs {
  trigger?: InputMaybe<Scalars["Boolean"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerydebugExitArgs {
  trigger?: InputMaybe<Scalars["Boolean"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerydefaultIntegrationFieldMappingsArgs {
  page?: InputMaybe<PaginationInput>;
  subsidiaryId: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerydefaultPolicyArgs {
  requestType: RequestType;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerydepartmentArgs {
  identifier: DepartmentIdentifier;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerydepositsTransactionArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerydisputeArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerydocumentOcrArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerydocumentationStatusArgs {
  type?: InputMaybe<RequestDeadlineSettingsType>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerydownloadJobsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<DownloadJobsFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  origin?: InputMaybe<Scalars["String"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerydraftExtendedFieldOptionsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  sort?: InputMaybe<ExtendedFieldOptionSortInput>;
  where: DraftExtendedFieldOptionsFilterWhereInput;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerydraftExtendedFieldsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  sort?: InputMaybe<ExtendedFieldSortByInput>;
  where: DraftExtendedFieldFilterWhereInput;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryegressFilesArgs {
  customerAccountId: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryemployeeArgs {
  identifier?: InputMaybe<EmployeeIdentifier>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryemployeesArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<EmployeeFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  orderBy?: InputMaybe<Array<UserSortOrder>>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryempowerIntegrationArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryempowerIntegrationsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<EmpowerIntegrationsFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryentityAutopayFundingSourceArgs {
  input: EntityAutopayFundingSourceInput;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryentityAutopayFundingSourcesArgs {
  input: EntityAutopayFundingSourcesInput;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryentityMappingsArgs {
  integrationId: Scalars["ID"];
  mappingType: EntityMappingType;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryentityRowsArgs {
  after?: InputMaybe<Scalars["String"]>;
  aggregations?: InputMaybe<Array<EntityAggregateInput>>;
  before?: InputMaybe<Scalars["String"]>;
  entityType: EntityType;
  filter?: InputMaybe<EntityFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  groupBy?: InputMaybe<EntityGroupByInput>;
  last?: InputMaybe<Scalars["Int"]>;
  options?: InputMaybe<EntityRowsQueryOptionsInput>;
  page?: InputMaybe<PaginationInput>;
  sorts?: InputMaybe<Array<EntitySortInput>>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryerpCreditCardsArgs {
  credentialId: Scalars["String"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryerpFeedsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryerpVendorsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<ErpVendorFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryexpenseArgs {
  expensePerspective?: InputMaybe<ExpensePerspectiveInput>;
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryexpenseActivitiesArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<ExpenseActivityFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryexpenseAttendeesFlagsArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryexpenseEntityExtensionArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryexpensePolicyReasonsV3Args {
  expenseId: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryexpensePolicySpecArgs {
  input?: InputMaybe<ExpensePolicySpecFilterInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryexpenseReportArgs {
  id?: InputMaybe<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryexpenseRowsArgs {
  filter?: InputMaybe<ExpenseFilterInput>;
  groupBy?: InputMaybe<ExpenseGroupByInput>;
  options?: InputMaybe<ExpenseRowsOptionInput>;
  page?: InputMaybe<PaginationInput>;
  sorts?: InputMaybe<Array<ExpenseSortInput>>;
  summarizations?: InputMaybe<Array<ExpenseAggregateInput>>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryexpensesArgs {
  countLimit?: InputMaybe<Scalars["Int"]>;
  expensePerspective?: InputMaybe<ExpensePerspectiveInput>;
  filter?: InputMaybe<ExpenseFilterInput>;
  order?: InputMaybe<ExpenseOrderInput>;
  page?: InputMaybe<PaginationInput>;
  skipCount?: InputMaybe<Scalars["Boolean"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryexpensesV2Args {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<ExpenseEntityFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  sorts?: InputMaybe<Array<ExpenseEntitySortInput>>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryexportJobArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryexportJobNotificationsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<ExportJobNotificationsFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  order: OrderByDirection;
  pagination?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryexportPipeArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryexportRecordsArgs {
  filter?: InputMaybe<ExportRecordsFilterInput>;
  orderBy?: InputMaybe<Array<ExportRecordsSortOrderInput>>;
  pagination?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryexportValidationArgs {
  input: ExportValidationInput;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryextendedFieldArgs {
  id?: InputMaybe<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryextendedFieldOptionsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter: ExtendedFieldOptionsFilterInput;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<ExtendedFieldOptionSortInput>;
  visibilityRuleData?: InputMaybe<VisibilityRuleData>;
  visibilityRuleInputs?: InputMaybe<VisibilityRuleInputs>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryextendedFieldVisibilityRuleArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryextendedFieldsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter: ExtendedFieldFilterInput;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<ExtendedFieldSortByInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryexternalLegalEntitiesArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<ExternalLegalEntitiesFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryfeatureFlagsArgs {
  input: FeatureFlagsRequest;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryfedachParticipantArgs {
  routingNumber: Scalars["String"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryfedwireParticipantArgs {
  routingNumber: Scalars["String"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryfetchExpensePriceArgs {
  expenseId: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryfetchSubsidiariesFromErpArgs {
  credentialId: Scalars["String"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryfetchSubsidiariesFromVendorArgs {
  credentialId?: InputMaybe<Scalars["String"]>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryfinancialAccountArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryfinancialAccountsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  excludeCustomerHidden?: InputMaybe<Scalars["Boolean"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  underwritingEligibleAccounts?: InputMaybe<Scalars["Boolean"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryfinancialAssetMovementArgs {
  id?: InputMaybe<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryfinancialBankStatementsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryfinancialDocumentsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryfinancialInstitutionArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryfinancialInstitutionsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  mappedToVendor?: InputMaybe<FinancialsVendor>;
  preferredVendorNotInList?: InputMaybe<Array<InputMaybe<FinancialsVendor>>>;
  withNameRegex?: InputMaybe<Scalars["Boolean"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryfinancialInstrumentArgs {
  instrumentCodeString: Scalars["String"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryfinancialInstrumentEntityArgs {
  instrumentCodeString: Scalars["String"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryfinancialInstrumentsArgs {
  filters?: InputMaybe<FinancialInstrumentsListFilters>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryfinancialSourceArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryfinancialSourceEntityArgs {
  id?: InputMaybe<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryfinancialSourcesArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryfinancialStatementAccountsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryfinancialStatementRequestedAccountsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryfindContactArgs {
  identifier?: InputMaybe<FindContactIdentifierInputUnion>;
  name?: InputMaybe<Scalars["String"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryfindContactByPaymentInstrumentInfoArgs {
  achPaymentInstrument?: InputMaybe<AchPaymentInstrumentFindInput>;
  chequePaymentInstrument?: InputMaybe<ChequePaymentInstrumentFindInput>;
  domesticWirePaymentInstrument?: InputMaybe<DomesticWirePaymentInstrumentFindInput>;
  internationalWirePaymentInstrument?: InputMaybe<InternationalWirePaymentInstrumentFindInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryfraudAlertArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryfraudAlertsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  customerUserId: Scalars["ID"];
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryfspClientAccountArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryfspClientAccountsArgs {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  orderBy?: InputMaybe<FspClientAccountOrderInput>;
  where?: InputMaybe<FspClientAccountWhereInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryfundingSourceEntityArgs {
  id?: InputMaybe<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryfundsAllocationRecommendationArgs {
  customerAccountId: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryfuzzySearchArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<FuzzySearchFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  searchText?: InputMaybe<Scalars["String"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerygenerateCounterpartyCategoryInfoExportArgs {
  input: GenerateCounterpartyCategoryInfoExportInput;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerygetAccountStalenessArgs {
  input: GetAccountStalenessInput;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerygetAuditLogsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filters?: InputMaybe<AuditLogsFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
  sorts?: InputMaybe<Array<InputMaybe<AuditLogSort>>>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerygetAuditLogsTotalCountArgs {
  filters?: InputMaybe<AuditLogsFilterInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerygetAuditOperationNameFilterOptionsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filters?: InputMaybe<AuditOperationNameFilterOptionsInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerygetBankingHolidaysArgs {
  endDate?: InputMaybe<Scalars["Date"]>;
  startDate?: InputMaybe<Scalars["Date"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerygetBookkeepersForFspArgs {
  accountId: Scalars["String"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerygetClawbackHealthArgs {
  originalExpensesExpenseId: Scalars["ID"];
  userId?: InputMaybe<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerygetClientAcctsForFspArgs {
  accountId: Scalars["String"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerygetCredentialArgs {
  id?: InputMaybe<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerygetExpenseCategorySuggestionsArgs {
  after?: InputMaybe<Scalars["String"]>;
  budgetId?: InputMaybe<Scalars["ID"]>;
  expenseId?: InputMaybe<Scalars["ID"]>;
  first?: InputMaybe<Scalars["Int"]>;
  merchantCategoryId?: InputMaybe<Scalars["ID"]>;
  page?: InputMaybe<PaginationInput>;
  vendorId?: InputMaybe<Scalars["ID"]>;
  vendorName?: InputMaybe<Scalars["String"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerygetExpenseExchangeRateArgs {
  customerUserId?: InputMaybe<Scalars["ID"]>;
  sourceCurrencyCode: Scalars["String"];
  targetCurrencyCode: Scalars["String"];
  type: ExpenseType;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerygetExpensePriceArgs {
  sourceCurrency: FinancialInstrumentCode;
  targetAmount: FinancialAssetInput;
  type?: InputMaybe<ExpenseType>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerygetExportAttemptStateArgs {
  input: GetExportAttemptStateInput;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerygetFSPClientsArgs {
  fspUserId?: InputMaybe<Scalars["ID"]>;
  status?: InputMaybe<FspConnectionStatus>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerygetFinancialStatementRequestArgs {
  id?: InputMaybe<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerygetFirstStatementArgs {
  includeCustomPeriodStatements?: InputMaybe<Scalars["Boolean"]>;
  journalAccountId: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerygetLinkTokenArgs {
  hrisAggregatorVendor: HrisAggregatorVendor;
  hrisSystem?: InputMaybe<HrisSystem>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerygetRailRequirementArgs {
  id: Scalars["ID"];
  properties: Scalars["Json"];
  targetAmount?: InputMaybe<Scalars["Int"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerygetReportEntryDataArgs {
  ids?: InputMaybe<Array<Scalars["ID"]>>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerygetRfiArgs {
  input?: InputMaybe<GetRfiInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerygetStatementsWithDownloadUrlsArgs {
  input?: InputMaybe<GenerateCustomStatementDownloadUrlInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerygetUserCategoriesPaginatedArgs {
  integrationId?: InputMaybe<Scalars["ID"]>;
  pageSize?: InputMaybe<Scalars["Int"]>;
  pageToken?: InputMaybe<Scalars["String"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerygetUserCategoryForIntegrationMerchantCategoryArgs {
  integrationId?: InputMaybe<Scalars["ID"]>;
  merchantCategoryId?: InputMaybe<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerygetWorkflowStatusArgs {
  workflowId?: InputMaybe<Scalars["String"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryglobalSearchArgs {
  intentGroup?: InputMaybe<GlobalSearchIntentGroup>;
  intentTypes?: InputMaybe<Array<IntentType>>;
  limitPerIntentType?: InputMaybe<Scalars["Int"]>;
  searchQuery: Scalars["String"];
  searchSessionId?: InputMaybe<Scalars["String"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerygroupEventArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerygroupEventsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<GroupEventsFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  orderBy?: InputMaybe<Array<GroupEventsOrderInput>>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerygroupExpensesByBillingConfigurationArgs {
  expenseIds?: InputMaybe<Array<Scalars["ID"]>>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerygroupMembersArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<GroupMemberFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  groupIdentifier: GroupIdentifier;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerygroupedExpensesArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<ExpenseEntityFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  groupBy: ExpenseGroupByInput;
  last?: InputMaybe<Scalars["Int"]>;
  sorts?: InputMaybe<Array<ExpenseEntitySortInput>>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerygroupedTravelBookingsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<TravelBookingFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  groupBy: TravelBookingGroupByInput;
  last?: InputMaybe<Scalars["Int"]>;
  orderBy?: InputMaybe<Array<TravelBookingOrder>>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerygroupsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<GroupFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<GroupSortOrderInput>>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryhistoricalExchangeRateArgs {
  exchangeRateTime?: InputMaybe<Scalars["Time"]>;
  sourceCurrency: Scalars["String"];
  targetCurrency: Scalars["String"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryhotelAutocompleteArgs {
  filter?: InputMaybe<HotelAutocompleteFilterInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryhrConnectionArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryhrConnectionsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<HrConnectionFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryhrisConnectionsArgs {
  hrisAggregatorVendor?: InputMaybe<Array<InputMaybe<HrisAggregatorVendor>>>;
  hrisSystem?: InputMaybe<Array<InputMaybe<HrisSystem>>>;
  statuses?: InputMaybe<Array<InputMaybe<HrisStatus>>>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryhrisJobRunsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter: HrisJobRunsFilterInput;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryidentitySuspiciousActivitiesArgs {
  page: PaginationInput;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryinboxTasksArgs {
  filter?: InputMaybe<InboxTaskClientFilter>;
  filterTypes?: InputMaybe<InboxTaskFilterType>;
  page?: InputMaybe<PaginationInput>;
  sortBy?: InputMaybe<InboxTaskSortFilter>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryinboxTasksV2Args {
  filter?: InputMaybe<InboxTaskClientFilter>;
  filterTypes?: InputMaybe<InboxTaskFilterType>;
  page?: InputMaybe<PaginationInput>;
  sortBy?: InputMaybe<InboxTaskSortFilter>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryintegrationArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryintegrationEntitiesArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  entityType?: InputMaybe<Scalars["String"]>;
  fieldId?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  filterDeleted?: InputMaybe<Scalars["Boolean"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  query?: InputMaybe<Scalars["String"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryintegrationEntityArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryintegrationRuleArgs {
  id: Scalars["ID"];
  ruleBodyEnriched?: InputMaybe<Scalars["Boolean"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryintegrationsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  status?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryinternalEntitySyncErrorsArgs {
  after?: InputMaybe<Scalars["String"]>;
  entityType: Scalars["String"];
  first?: InputMaybe<Scalars["Int"]>;
  integrationId: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryinternationalBankInformationArgs {
  iban?: InputMaybe<Scalars["String"]>;
  swiftCode?: InputMaybe<Scalars["String"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryinvitableUserCountArgs {
  condition?: InputMaybe<UserConditionInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryinvitableUserSearchArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  condition?: InputMaybe<UserConditionInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryinviteArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryinvitesArgs {
  filter?: InputMaybe<InvitesFilterInput>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryinvoiceDetailsArgs {
  id?: InputMaybe<Scalars["String"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryinvoiceV1Args {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryinvoicesArgs {
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryinvoicesV1Args {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  orderBy?: InputMaybe<InvoiceV1Order>;
  where?: InputMaybe<InvoicesV1WhereInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryinvoicingInvoiceArgs {
  invoiceId: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryisAccounting1BStackEnabledArgs {
  vendorToEnable?: InputMaybe<AccountingIntegrationVendor>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryisExternalBookkeeperArgs {
  userId: Scalars["String"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryisFspArgs {
  accountId: Scalars["String"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryisHighRiskIDVArgs {
  input: HighRiskIDVInput;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryisIntegrationReadyToSyncArgs {
  endDate?: InputMaybe<Scalars["Time"]>;
  id: Scalars["ID"];
  isPrimitive?: InputMaybe<Scalars["Boolean"]>;
  sourceIds?: InputMaybe<Array<Scalars["ID"]>>;
  startDate?: InputMaybe<Scalars["Time"]>;
  statementEntryTypes?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryisPaymentAccountsMappingEnabledArgs {
  vendorToEnable?: InputMaybe<AccountingIntegrationVendor>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryknowledgeBaseVendorsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<KnowledgeBaseVendorFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerylatestStatementRequestArgs {
  type: FinancialStatementRequestType;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryleadArgs {
  id?: InputMaybe<Scalars["ID"]>;
  leadToken?: InputMaybe<Scalars["String"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerylegalEntitiesArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<LegalEntitiesFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerylegalEntityArgs {
  filter?: InputMaybe<LegalEntityFilterInput>;
  identifier: LegalEntityIdentifier;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerylimitGroupArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerylimitGroupOrSpendLimitsArgs {
  after?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<LimitGroupOrSpendLimitFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  order?: InputMaybe<LimitGroupOrSpendLimitOrderInput>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerylimitGroupsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<LimitGroupFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  order?: InputMaybe<LimitGroupOrderInput>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerylinkExistingUberOrganizationDataArgs {
  input: LinkExistingUberOrganizationDataInput;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerylistAccountingRecordSourceExportEntriesArgs {
  after?: InputMaybe<Scalars["String"]>;
  filter: AccountingRecordSourceExportEntriesFilterInput;
  first?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerylistAlertsArgs {
  input?: InputMaybe<ListAlertsInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerylistAutoInviteSettingsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerylistCredentialsArgs {
  input: ListCredentialsInput;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerylistDepartmentsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<DepartmentsFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerylistExportJobsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<ExportJobsFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  pagination?: InputMaybe<PaginationInput>;
  sorts?: InputMaybe<Array<ExportJobsSortInput>>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerylistGroupsByDependencyArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<DependencyFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<GroupSortOrderInput>>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerylistLocationsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<LocationsFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerylistPartnerCodesArgs {
  input: ListPartnerCodesInput;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerylistRailRequirementsArgs {
  bankAccountClass: BankAccountCls;
  rail?: InputMaybe<BankingGatewayRail>;
  sourceCountry: Scalars["String"];
  sourceCurrency: Scalars["String"];
  targetAmount?: InputMaybe<Scalars["Int"]>;
  targetCountry: Scalars["String"];
  targetCurrency: Scalars["String"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerylistReferralRecordsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  order?: InputMaybe<ListReferralRecordsOrderInput>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerylistRfisForAccountByStatusArgs {
  page?: InputMaybe<PaginationInput>;
  status: RfiStatus;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerylistSandboxAccountActionsArgs {
  filter?: InputMaybe<ListSandboxAccountActionsFilterInput>;
  order?: InputMaybe<ListSandboxAccountActionsOrderInput>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryllmOAuthIntegrationsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerylocationArgs {
  identifier: LocationIdentifier;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryloyaltyProgramsV2Args {
  pagination?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerymappingClassArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerymappingClassesArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  sort?: InputMaybe<MappingClassSortInput>;
  where?: InputMaybe<MappingClassFilterInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerymarketoLeadFormArgs {
  marketoFormId: Scalars["SafeString"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerymerchantArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerymerchantCategoriesArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerymerchantCategoryArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerymerchantCategoryEntityArgs {
  id?: InputMaybe<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerymerchantEntityArgs {
  id?: InputMaybe<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerymigratedUsersArgs {
  filter?: InputMaybe<MigratedUsersFilterInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerymigrationTargetUserArgs {
  id?: InputMaybe<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerymigrationTargetUsersArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  departmentId?: InputMaybe<Scalars["ID"]>;
  filter?: InputMaybe<UserFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  locationId?: InputMaybe<Scalars["ID"]>;
  managerId?: InputMaybe<Scalars["ID"]>;
  orderBy?: InputMaybe<Array<UserSortOrder>>;
  page?: InputMaybe<PaginationInput>;
  role?: InputMaybe<UserRoleTypeInput>;
  searchText?: InputMaybe<Scalars["String"]>;
  status?: InputMaybe<Scalars["String"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerymileageRateArgs {
  countryAlpha2: Scalars["String"];
  purchasedAt?: InputMaybe<Scalars["Date"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerymileageSettingArgs {
  countryAlpha2?: InputMaybe<Scalars["String"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerymileageSettingsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerymilesTransfersV2Args {
  orderBy: MilesTransfersSortOrderInput;
  pagination?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerymostRecentlyUsedCurrencyArgs {
  input: PaymentInstrumentLogicalIdInput;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerynodeArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerynodesArgs {
  ids: Array<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryobjectMappingsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<ObjectMappingsFilters>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryonboardingApplicationArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryonboardingApplicationEntityArgs {
  id?: InputMaybe<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryonboardingApplicationsArgs {
  after?: InputMaybe<Scalars["String"]>;
  applicantCustomerUserId?: InputMaybe<Scalars["ID"]>;
  applicationInput?: InputMaybe<OnboardingApplicationInput>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  type?: InputMaybe<OnboardingBlueprintType>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryopinionatedSectionTemplateArgs {
  section?: InputMaybe<RelatedFeature>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryorganizationMutationEventsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<OrganizationMutationEventsFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerypersonalAccountsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  personalSourceId: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerypersonalCurrentBalancesArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  personalAccountIds: Array<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerypersonalSourcesArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryplacementsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  supportedPlacements: Array<IncentivePlacementType>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerypoliciesArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<PolicyFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  order?: InputMaybe<PolicyOrderInput>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerypolicyArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerypolicyPreviewArgs {
  input: PolicyPreviewInput;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerypreviewExpenseLensesArgs {
  integrationId: Scalars["ID"];
  omitRuleId?: InputMaybe<Scalars["ID"]>;
  page?: InputMaybe<PaginationInput>;
  ruleBody: Scalars["String"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerypreviewGroupMembersArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  memberCondition?: InputMaybe<MemberConditionInput>;
  members?: InputMaybe<Array<GroupMemberInput>>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerypreviewIntegrationRuleArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  integrationId: Scalars["ID"];
  last?: InputMaybe<Scalars["Int"]>;
  ruleBody: Scalars["Json"];
  ruleId?: InputMaybe<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerypreviewLimitGroupMembersArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<LimitGroupMemberFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  input: PreviewLimitGroupMembersInput;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerypreviewLimitGroupMembershipArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  input: PreviewLimitGroupMembershipInput;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerypreviewVendorFileMatchesArgs {
  filter: PreviewVendorFileMatchesFilterInput;
  page: PaginationInput;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryprimitiveFuzzySearchArgs {
  filter?: InputMaybe<PrimitiveFuzzySearchFilterInput>;
  page?: InputMaybe<PaginationInput>;
  searchText?: InputMaybe<Scalars["String"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerypurchaseOrderArgs {
  id?: InputMaybe<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerypurchaseOrdersArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<PurchaseOrderFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  order?: InputMaybe<PurchaseOrderSortInput>;
  page?: InputMaybe<PaginationInput>;
  suggestionsInput?: InputMaybe<PurchaseOrderSuggestionsInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerypurchasingCardsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<PurchasingCardFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  order?: InputMaybe<PurchasingCardOrderInput>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryqualifyingLimitGroupsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  userAttributes?: InputMaybe<LimitGroupUserAttributesInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryrailAccountDetailsArgs {
  filter?: InputMaybe<RailAccountDetailsFilter>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryrailAccountDetailsBatchValidateArgs {
  input?: InputMaybe<Array<RailAccountDetailsBatchValidateInput>>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryrailAutocompleteArgs {
  filter?: InputMaybe<RailAutocompleteFilterInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryrailRequirementsArgs {
  filter: RailRequirementsFilter;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryrailsArgs {
  filter?: InputMaybe<RailsFilter>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryreceiptArgs {
  id?: InputMaybe<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryreceiptIntegrationArgs {
  input: ReceiptIntegrationInput;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryreceiptIntegrationUserConnectionStatusArgs {
  input: ReceiptIntegrationUserConnectionStatusOneOfInput;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryreceiptWorkflowArgs {
  workflowId: Scalars["String"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryreceiptsArgs {
  filter: ReceiptFilterInput;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryreferralRecordsPaginatedArgs {
  pageSize?: InputMaybe<Scalars["Int"]>;
  pageToken?: InputMaybe<Scalars["String"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryreferralsSummaryArgs {
  isAdmin?: InputMaybe<Scalars["Boolean"]>;
  isExperimental?: InputMaybe<Scalars["Boolean"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryreimbursementHealthArgs {
  customerUserId?: InputMaybe<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryreimbursementItemEntityArgs {
  id?: InputMaybe<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryremainingBalanceArgs {
  journalAccountId: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryreportEntriesArgs {
  resourceIds?: InputMaybe<Array<Scalars["ID"]>>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryreportTemplateArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryreportTemplatesArgs {
  after?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<ReportTemplateFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryreportingDashboardArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryreportingDashboardsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filters?: InputMaybe<ReportingDashboardFilters>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryreportsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<ReportsFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  identifier: EmployeeIdentifier;
  last?: InputMaybe<Scalars["Int"]>;
  maxDepth?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryrequestActionArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryrequestDeadlineSettingsArgs {
  type?: InputMaybe<RequestDeadlineSettingsType>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryrevokeUberOrganizationDataArgs {
  input: RevokeUberOrganizationDataInput;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryrewardsGiftCardRedemptionsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  input: RewardsGiftCardRedemptionsInput;
  last?: InputMaybe<Scalars["Int"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryrewardsPointHistoryEntriesV2Args {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  input: RewardsPointHistoryEntriesInputV2;
  last?: InputMaybe<Scalars["Int"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryrewardsRedemptionArgs {
  input: RewardsRedemptionInput;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryrolesArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
  where?: InputMaybe<RoleWhereInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryrootPolicyArgs {
  requestType: RequestType;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerysavedViewsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  table?: InputMaybe<SavedViewTableIdentifier>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryscimConnectionsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerysearchArgs {
  aggregates?: InputMaybe<Scalars["Json"]>;
  cursor?: InputMaybe<Scalars["String"]>;
  filters: Scalars["Json"];
  orderBy?: InputMaybe<Array<InputMaybe<OrderByInput>>>;
  pageSize?: InputMaybe<Scalars["Int"]>;
  scopeToUser?: InputMaybe<Scalars["Boolean"]>;
  type: Scalars["String"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerysearchEntitiesArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  includedEntities: Array<EntityType>;
  instantiationId?: InputMaybe<Scalars["String"]>;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
  returnEmptyState?: InputMaybe<Scalars["Boolean"]>;
  searchQuery: Scalars["String"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerysearchIndustriesArgs {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  keywords: Scalars["String"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerysearchMerchantsArgs {
  searchMerchantsInput: SearchMerchantsInput;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerysearchUsersArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  canAccessCorporateCards?: InputMaybe<Scalars["Boolean"]>;
  departmentId?: InputMaybe<Scalars["ID"]>;
  displayRole?: InputMaybe<UserRoleTypeInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  locationId?: InputMaybe<Scalars["ID"]>;
  managerId?: InputMaybe<Scalars["ID"]>;
  preapprovedCards?: InputMaybe<Scalars["Boolean"]>;
  searchText?: InputMaybe<Scalars["String"]>;
  status?: InputMaybe<Scalars["String"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryseenFlagEntityArgs {
  id?: InputMaybe<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryshouldSeeLegalAgreementsArgs {
  activationToken: Scalars["String"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerysimulateExpenseWorkflowRuleArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  existingRuleId?: InputMaybe<Scalars["ID"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  maxExpensesSimulated?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
  workflowRule: CreateWorkflowRuleInput;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryspendBudgetArgs {
  id?: InputMaybe<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryspendBudgetsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<SpendBudgetFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  order?: InputMaybe<SpendBudgetOrderInput>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryspendLimitArgs {
  id?: InputMaybe<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryspendLimitsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<SpendLimitFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  order?: InputMaybe<SpendLimitOrderInput>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryspendLimitsUserCanRequestIncreaseArgs {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  name?: InputMaybe<Scalars["String"]>;
  onlyProvisionedCardsSpend?: InputMaybe<Scalars["Boolean"]>;
  page?: InputMaybe<PaginationInput>;
  statuses?: InputMaybe<Array<SpendLimitStatus>>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryssuPrefillDataArgs {
  referralIdentifier: Scalars["String"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerystatementEntriesArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  onlyUnexported?: InputMaybe<Scalars["Boolean"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerystatementEntryArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerystatementEntryEntityArgs {
  id?: InputMaybe<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerystatementsArgs {
  after?: InputMaybe<Scalars["String"]>;
  filters?: InputMaybe<StatementsFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerysuggestArgs {
  scopeToUser?: InputMaybe<Scalars["Boolean"]>;
  text: Scalars["String"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerysurfaceTaskCountsArgs {
  surface: Surface;
  surfaceGroups?: InputMaybe<Array<SurfaceGroup>>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerysurfaceTasksArgs {
  groups?: InputMaybe<Array<Scalars["String"]>>;
  page?: InputMaybe<PaginationInput>;
  sortBy?: InputMaybe<SurfaceTaskSortFilter>;
  surface: Surface;
  surfaceGroups?: InputMaybe<Array<SurfaceGroup>>;
  taskStates?: InputMaybe<Array<SurfaceTaskState>>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerytaggedEmployeePermissionArgs {
  input: TaggedEmployeePermissionInput;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerytaskArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerytaskMaxSizeArgs {
  input: TaskMaxSizeInput;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerytasksArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<TaskFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerytitlesArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<TitlesFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerytrackingExpensePoliciesArgs {
  filters?: InputMaybe<TrackingExpensePoliciesFilterInput>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerytransactedMerchantsArgs {
  limit?: InputMaybe<Scalars["Int"]>;
  query?: InputMaybe<Scalars["String"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerytravelBookingArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerytravelBookingsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<TravelBookingFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  order?: InputMaybe<TravelBookingOrder>;
  orderBy?: InputMaybe<Array<TravelBookingOrder>>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerytravelCostEstimatesArgs {
  filter?: InputMaybe<TravelCostEstimateFilterInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerytravelPartnerUserAssociationArgs {
  input?: InputMaybe<TravelPartnerUserAssociationQueryInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerytravelPermissionStatusArgs {
  permission?: InputMaybe<TravelPermission>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerytravelTripArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerytravelTripsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<TravelTripFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  order?: InputMaybe<TravelTripOrderInput>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerytripIdFromPartnerIdArgs {
  partnerId: Scalars["String"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QuerytripsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<ExpenseGroupingFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  order?: InputMaybe<ExpenseGroupingOrderInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryunauthenticatedUserPasswordScreenArgs {
  activationToken?: InputMaybe<Scalars["String"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryunexportedExpenseCountArgs {
  endDate?: InputMaybe<Scalars["Time"]>;
  integrationId?: InputMaybe<Scalars["ID"]>;
  startDate?: InputMaybe<Scalars["Time"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryunexportedExpenseFilterFacetsArgs {
  endDate?: InputMaybe<Scalars["Time"]>;
  integrationId?: InputMaybe<Scalars["ID"]>;
  startDate?: InputMaybe<Scalars["Time"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryunexportedExpensesArgs {
  enablePrecompute?: InputMaybe<Scalars["Boolean"]>;
  endDate?: InputMaybe<Scalars["Time"]>;
  filter?: InputMaybe<ExpenseLensFilterInput>;
  integrationId: Scalars["ID"];
  page?: InputMaybe<PaginationInput>;
  personalExpenseFilter?: InputMaybe<Scalars["Boolean"]>;
  startDate?: InputMaybe<Scalars["Time"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryunexportedStatementEntriesArgs {
  activeFacetType?: InputMaybe<IntegrationRulesFilterFacetType>;
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  endDate?: InputMaybe<Scalars["Time"]>;
  first?: InputMaybe<Scalars["Int"]>;
  integrationId?: InputMaybe<Scalars["ID"]>;
  last?: InputMaybe<Scalars["Int"]>;
  ruleIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
  startDate?: InputMaybe<Scalars["Time"]>;
  statementEntryTypes?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryunexportedStatementEntryCountArgs {
  endDate?: InputMaybe<Scalars["Time"]>;
  integrationId?: InputMaybe<Scalars["ID"]>;
  startDate?: InputMaybe<Scalars["Time"]>;
  statementEntryTypes?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryunexportedStatementEntryFilterFacetsArgs {
  endDate?: InputMaybe<Scalars["Time"]>;
  integrationId?: InputMaybe<Scalars["ID"]>;
  startDate?: InputMaybe<Scalars["Time"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryusageMeasurementsArgs {
  measuredAt: Scalars["Time"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryuserArgs {
  id?: InputMaybe<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryuserActiveOauthApplicationsArgs {
  page: PaginationInput;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryuserActiveSessionsArgs {
  page: PaginationInput;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryuserActivityHistoryArgs {
  page: PaginationInput;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryuserCategoriesArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryuserCategoryArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryuserGroupOptionsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter: UserGroupOptionsFilterInput;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryuserLimitArgs {
  customerUserId?: InputMaybe<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryuserLimitsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<UserLimitFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryuserMostRecentSearchesArgs {
  instantiationId?: InputMaybe<Scalars["String"]>;
  limit: Scalars["Int"];
  type: RecentSearchType;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryuserReviewTasksArgs {
  input: UserReviewTasksInput;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryuserTrustedDevicesArgs {
  page: PaginationInput;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryuserWithoutDelegatorArgs {
  id?: InputMaybe<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryusersArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  departmentId?: InputMaybe<Scalars["ID"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  locationId?: InputMaybe<Scalars["ID"]>;
  managerId?: InputMaybe<Scalars["ID"]>;
  role?: InputMaybe<UserRoleTypeInput>;
  searchText?: InputMaybe<Scalars["String"]>;
  status?: InputMaybe<Scalars["String"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryvalidateActivationArgs {
  token: Scalars["String"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryvalidatedVendorContactInputsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  vendorContactInputs: Array<VendorContactInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryvalueMetricsArgs {
  dateRange: ValueMetricsDateRangeType;
  metricCategory?: InputMaybe<MetricCategoryType>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryvalueMetricsExplanationsArgs {
  dateRange: ValueMetricsDateRangeType;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryvendorArgs {
  id?: InputMaybe<Scalars["ID"]>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryvendorDocumentArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryvendorFileMatchArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryvendorFileMatchesArgs {
  filter?: InputMaybe<VendorFileMatchFilterInput>;
  page: PaginationInput;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryvendorsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<VendorFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  order?: InputMaybe<VendorOrderInput>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryverificationArgs {
  input: VerificationInput;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryverificationAnalysesArgs {
  filter?: InputMaybe<VerificationAnalysesFilterInput>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryverificationAnalysisArgs {
  id: Scalars["ID"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryverificationNotificationsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
  status: VerificationNotificationStatus;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryverifyAddressArgs {
  address1: Scalars["String"];
  address2: Scalars["String"];
  city: Scalars["String"];
  country?: InputMaybe<Scalars["String"]>;
  state: Scalars["String"];
  zip: Scalars["String"];
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryverifyAddressV2Args {
  input: VerifyAddressInput;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryworkflowActionsArgs {
  entityType: WorkflowEntity;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryworkflowAttributeGroupsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  where?: InputMaybe<WorkflowAttributeGroupWhereFilterInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryworkflowAttributesArgs {
  entityType: WorkflowEntity;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryworkflowAttributesV2Args {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  where?: InputMaybe<WorkflowAttributeWhereFilterInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryworkflowFunctionsArgs {
  entityType: WorkflowEntity;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryworkflowRulesArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<ListWorkflowRulesFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
}

/**  Base Query type which allows other schema files to extend it */
export interface QueryworkflowRulesFacetConnectionArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<ListWorkflowRulesFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
  tagKey: Scalars["String"];
}

/** ASSISTANT MESSAGES TYPES */
export interface QueryAssistantMessagesResponse {
  chatSessionId: Scalars["ID"];
  connection: AssistantMessagesConnection;
}

/** Specifies an operator for queries using a list */
export enum QueryListOperator {
  IN = "IN",
  NOT_IN = "NOT_IN",
}

/** Response to quick actions list */
export interface QueryQuickActionsResponse {
  actions: Array<Maybe<QuickAction>>;
}

export interface QueryReleaseNotesResponse {
  releaseNotes?: Maybe<Array<ReleaseNote>>;
  title: Scalars["String"];
}

/** Specifies a sort order for a given field */
export enum QuerySortOrder {
  SORT_ASC = "SORT_ASC",
  SORT_DESC = "SORT_DESC",
}

export interface QueryValueMetricsDateRangesResponse {
  dateRangeWithStartAndEndDates?: Maybe<Array<DateRangeWithStartAndEndDates>>;
}

/** Response to metric explanations */
export interface QueryValueMetricsExplanationsResponse {
  categoryExplanations?: Maybe<Array<MetricsCategoryExplanation>>;
}

export interface QueryValueMetricsResponse {
  /** Time when metrics were updated. */
  lastUpdatedTime?: Maybe<Scalars["Time"]>;
  metrics?: Maybe<Array<ValueMetric>>;
}

export enum QuestionCreditCardSpendConsolidated {
  FIVE_HUNDRED_K_TO_ONE_MM = "FIVE_HUNDRED_K_TO_ONE_MM",
  MORE_THAN_ONE_MM = "MORE_THAN_ONE_MM",
  SEVENTY_FIVE_K_TO_FIVE_HUNDRED_K = "SEVENTY_FIVE_K_TO_FIVE_HUNDRED_K",
  UNDER_ONE_HUNDRED_K = "UNDER_ONE_HUNDRED_K",
  UNDER_SEVENTY_FIVE_K = "UNDER_SEVENTY_FIVE_K",
}

export enum QuestionEmployeeCount {
  FIFTY_ONE_TO_ONE_HUNDRED = "FIFTY_ONE_TO_ONE_HUNDRED",
  FIVE_HUNDRED_ONE_TO_TWO_THOUSAND_FIVE_HUNDRED = "FIVE_HUNDRED_ONE_TO_TWO_THOUSAND_FIVE_HUNDRED",
  FIVE_TO_TWENTY = "FIVE_TO_TWENTY",
  MORE_THAN_TWO_THOUSAND_FIVE_HUNDRED = "MORE_THAN_TWO_THOUSAND_FIVE_HUNDRED",
  ONE_HUNDRED_ONE_TO_FIVE_HUNDRED = "ONE_HUNDRED_ONE_TO_FIVE_HUNDRED",
  ONE_TO_FOUR = "ONE_TO_FOUR",
  TWENTY_ONE_TO_FIFTY = "TWENTY_ONE_TO_FIFTY",
}

export enum QuestionFundingSource {
  CROWDSOURCE = "CROWDSOURCE",
  FAMILY = "FAMILY",
  ICO = "ICO",
  PROFESSIONAL_INVESTMENT = "PROFESSIONAL_INVESTMENT",
  SELF_FUNDED = "SELF_FUNDED",
}

export enum QuestionFundingSourceV2 {
  ANGEL_INVESTMENT = "ANGEL_INVESTMENT",
  BUSINESS_REVENUE = "BUSINESS_REVENUE",
  CROWDSOURCED = "CROWDSOURCED",
  FAMILY = "FAMILY",
  GRANTS = "GRANTS",
  INITIAL_COIN_OFFERING = "INITIAL_COIN_OFFERING",
  LOAN_FUNDING = "LOAN_FUNDING",
  PARENT_COMPANY = "PARENT_COMPANY",
  PRIVATE_EQUITY = "PRIVATE_EQUITY",
  PROFESSIONAL_INVESTOR = "PROFESSIONAL_INVESTOR",
  SELF_FUNDED = "SELF_FUNDED",
  VENTURE_ACCELERATOR_GROWTH = "VENTURE_ACCELERATOR_GROWTH",
}

export enum QuestionIntent {
  BUILD_BUSINESS_CREDIT = "BUILD_BUSINESS_CREDIT",
  GET_CREDIT_CARD = "GET_CREDIT_CARD",
  MANAGE_TEAM_EXPENSES = "MANAGE_TEAM_EXPENSES",
  OPEN_BUSINESS_ACCOUNT = "OPEN_BUSINESS_ACCOUNT",
}

export enum QuestionSalesVolumeLeadForm {
  EQUAL_ABOVE_TWO_HUNDRED_FIFTY_K = "EQUAL_ABOVE_TWO_HUNDRED_FIFTY_K",
  UNDER_TWO_HUNDRED_FIFTY_K = "UNDER_TWO_HUNDRED_FIFTY_K",
}

export interface QuickAction {
  iconName: Scalars["String"];
  label: Scalars["String"];
  redirectUrl: Scalars["String"];
}

export interface QuickbooksAuthPayloadInput {
  /** Brex page where quickbooks website will redirect back to when linking is complete. */
  redirectUrl?: InputMaybe<Scalars["String"]>;
}

export interface QuickbooksCategories {
  accountsPayableUserCategory?: Maybe<UserCategory>;
  /** awx wallet user category */
  awxWalletUserCategory?: Maybe<UserCategory>;
  collectionTargetUserCategory?: Maybe<UserCategory>;
  /** reimbursement accrual basis accounting user category */
  reimbursementClearingUserCategory?: Maybe<UserCategory>;
  /** reimbursements user category */
  reimbursementsUserCategory?: Maybe<UserCategory>;
  rewardsIncomeUserCategory?: Maybe<UserCategory>;
  vendorName?: Maybe<Scalars["String"]>;
}

export interface QuickbooksClass {
  name?: Maybe<Scalars["String"]>;
}

/** Customer imported from Quickbooks */
export interface QuickbooksCustomer {
  /** Customer Type Enum. Either Customer or Project */
  customerType?: Maybe<CustomerType>;
  /** Customer name from QuickBooks */
  name?: Maybe<Scalars["String"]>;
}

export interface QuickbooksLocation {
  name?: Maybe<Scalars["String"]>;
}

export interface QuickbooksPayload {
  oauth2AccessToken?: Maybe<Scalars["String"]>;
  oauth2RefreshToken?: Maybe<Scalars["String"]>;
  oauth2RefreshTokenExpirationDate?: Maybe<Scalars["LocalDateTime"]>;
  realmId?: Maybe<Scalars["String"]>;
}

/** Vendor imported from Quickbooks */
export interface QuickbooksVendor {
  /** Vendor from QuickBooks */
  name?: Maybe<Scalars["String"]>;
}

export interface Rail {
  capabilities: Array<RailCapability>;
  displayName: Scalars["String"];
  id: Scalars["ID"];
  railMandate?: Maybe<RailMandate>;
  requiredVerifications: Array<RequiredVerification>;
  sourceCountries: Array<Scalars["String"]>;
  sourceCurrencies: Array<Scalars["String"]>;
  targetCountries: Array<Scalars["String"]>;
  targetCurrencies: Array<Scalars["String"]>;
  type: RailType;
}

export interface RailrailMandateArgs {
  ownerType: RailAccountDetailsOwnerType;
}

export interface RailrequiredVerificationsArgs {
  ownerType: RailAccountDetailsOwnerType;
}

/** Rail Account Details, for federation */
export interface RailAccountDetails extends Node {
  accountHolderAddress?: Maybe<Address>;
  bankAccountClass?: Maybe<BankAccountClassType>;
  bankName?: Maybe<Scalars["String"]>;
  beneficiaryBankAddress?: Maybe<Address>;
  beneficiaryNameInfo?: Maybe<Scalars["Json"]>;
  beneficiaryType?: Maybe<BeneficiaryType>;
  counterpartyId: Scalars["ID"];
  customerAccountId: Scalars["ID"];
  defaultCurrency?: Maybe<Currency>;
  deletedAt?: Maybe<Scalars["Time"]>;
  displayName: Scalars["String"];
  drawdownAuthorizations?: Maybe<Array<WireDrawdownAuthorization>>;
  /** Rails account id, required for Local Auto Pay payments. */
  id: Scalars["ID"];
  insertedAt: Scalars["Time"];
  ownerId: Scalars["ID"];
  ownerType: RailAccountDetailsOwnerType;
  /** Nullable Financials PersonalAccount associated to this rail account details */
  personalAccount?: Maybe<FinancialsAccountV2>;
  properties: Scalars["Json"];
  rail: Rail;
  status: RailAccountDetailsStatus;
  targetCountry?: Maybe<Scalars["String"]>;
  targetCurrency?: Maybe<Currency>;
  trustedBeneficiaries?: Maybe<Array<Maybe<CounterpartyTrustedBeneficiary>>>;
  uniqueProperties: Array<RailAccountDetailsProperty>;
  updatedAt: Scalars["Time"];
  /** Runs validations if requested, which may impact performance / is not recommended for normal data presentation */
  validity?: Maybe<RailAccountDetailsValidity>;
  verifications?: Maybe<Array<RailAccountDetailsVerification>>;
}

/** Rail Account Details, for federation */
export interface RailAccountDetailsverificationsArgs {
  filter?: InputMaybe<RailAccountDetailsVerificationsFilter>;
}

export interface RailAccountDetailsBatchValidateInput {
  accountHolderAddress?: InputMaybe<AddressInput>;
  bankAccountClass?: InputMaybe<BankAccountClassType>;
  beneficiaryNameInfo?: InputMaybe<Scalars["Json"]>;
  beneficiaryType?: InputMaybe<BeneficiaryType>;
  identifier?: InputMaybe<Scalars["String"]>;
  ownerType: RailAccountDetailsOwnerType;
  properties: Scalars["Json"];
  railType: RailType;
}

export interface RailAccountDetailsBatchValidateResult {
  /** For batch validations, can be used to tie the results together. */
  identifier?: Maybe<Scalars["String"]>;
  validity: RailAccountDetailsValidity;
}

export interface RailAccountDetailsConnection extends Connection {
  edges: Array<RailAccountDetailsEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface RailAccountDetailsEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<RailAccountDetails>;
}

export interface RailAccountDetailsFilter {
  /**  Only a single value allowed for customerAccountIds */
  customerAccountIds?: InputMaybe<Array<Scalars["String"]>>;
  ids?: InputMaybe<Array<Scalars["ID"]>>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]>;
  /**  Only a single value allowed for ownerIds */
  ownerIds?: InputMaybe<Array<Scalars["String"]>>;
  /**  Only a single value allowed for ownerTypes */
  ownerTypes?: InputMaybe<Array<RailAccountDetailsOwnerType>>;
  /**  Only a single value allowed for railIds */
  railIds?: InputMaybe<Array<Scalars["ID"]>>;
  /**  Only a single value allowed for statuses */
  statuses?: InputMaybe<Array<RailAccountDetailsStatus>>;
}

export enum RailAccountDetailsOwnerType {
  CONTACT = "CONTACT",
  ENTITY = "ENTITY",
  USER = "USER",
}

export interface RailAccountDetailsProperty {
  displayName: Scalars["String"];
  value: Scalars["String"];
}

export interface RailAccountDetailsRequiredVerificationDataInput {
  metadata: RailAccountDetailsVerificationMetadataInput;
  type: RailAccountDetailsVerificationType;
}

/** Input for specifying a rail account details source */
export interface RailAccountDetailsSourceInput {
  railAccountDetailsId: Scalars["String"];
}

export enum RailAccountDetailsStatus {
  ACCOUNT_CLOSED = "ACCOUNT_CLOSED",
  ACTIVE = "ACTIVE",
  AUTOMATICALLY_INVALIDATED = "AUTOMATICALLY_INVALIDATED",
  DELETED = "DELETED",
  FAILED_VERIFICATIONS = "FAILED_VERIFICATIONS",
}

export interface RailAccountDetailsValidationError {
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export enum RailAccountDetailsValidationStatus {
  INVALID = "INVALID",
  VALID = "VALID",
}

export interface RailAccountDetailsValidity {
  errors?: Maybe<Array<RailAccountDetailsValidationError>>;
  status: RailAccountDetailsValidationStatus;
}

export interface RailAccountDetailsVerification {
  id: Scalars["ID"];
  insertedAt: Scalars["Time"];
  invalidatedAt?: Maybe<Scalars["Time"]>;
  metadata?: Maybe<RailAccountDetailsVerificationMetadata>;
  railAccountDetailsId: Scalars["ID"];
  status: RailAccountDetailsVerificationStatus;
  type: RailAccountDetailsVerificationType;
  updatedAt: Scalars["Time"];
}

export type RailAccountDetailsVerificationMetadata =
  | EgiroVerificationMetadata
  | MandateMetadata
  | MicroDepositsVerificationMetadata
  | PoaoVerificationMetadata;

/**
 * Should only contain one metadata type
 * (@oneOf is not supported for inputs)
 */
export interface RailAccountDetailsVerificationMetadataInput {
  mandateMetadata?: InputMaybe<MandateMetadataInput>;
  poaoMetadata?: InputMaybe<PoaoVerificationMetadataInput>;
}

export enum RailAccountDetailsVerificationStatus {
  APPROVED = "APPROVED",
  CUSTOMER_INPUT_REQUIRED = "CUSTOMER_INPUT_REQUIRED",
  FAILED = "FAILED",
  PENDING = "PENDING",
  REQUESTED = "REQUESTED",
  SUBMITTED = "SUBMITTED",
}

export enum RailAccountDetailsVerificationType {
  EGIRO = "EGIRO",
  MANDATE = "MANDATE",
  MICRO_DEPOSITS = "MICRO_DEPOSITS",
  PENNY_PULL = "PENNY_PULL",
  POAO = "POAO",
}

export interface RailAccountDetailsVerificationsFilter {
  types?: InputMaybe<Array<RailAccountDetailsVerificationType>>;
}

/** Any string intended for looking up rail stations. */
export interface RailAutocompleteFilterInput {
  queryString: Scalars["String"];
}

export interface RailAutocompleteResult {
  /** The code for the city hosting this station, if it exists. */
  cityCode?: Maybe<Scalars["String"]>;
  /** High-level location info for the station. */
  location?: Maybe<TravelLocation>;
  /** The code (ID) of the rail station. */
  railStationCode: Scalars["String"];
  /** The name of the rail station. */
  railStationName: Scalars["String"];
  /** The station type (e.g., METRO, INDIVIDUAL, etc.). */
  railStationType?: Maybe<TravelRailStationType>;
  /** The data source or origin for this station info (e.g., "SPOTNANA"). */
  source?: Maybe<Scalars["String"]>;
  /** A specialized reference ID for the station. */
  stationReferenceId?: Maybe<Scalars["String"]>;
  /** Timezone of the station */
  timezone?: Maybe<Scalars["String"]>;
}

/** Results from a rail station autocomplete query. */
export interface RailAutocompleteResults {
  results?: Maybe<Array<RailAutocompleteResult>>;
}

export enum RailCapability {
  PULL = "PULL",
  PUSH = "PUSH",
}

export interface RailMandate {
  content: Scalars["String"];
  id: Scalars["ID"];
  vendorVersion: Scalars["String"];
}

/** false */
export interface RailRequirement extends Node {
  /** The required list of fields to fulfil this requirement */
  fields: Array<RailRequirementField>;
  /** The ID of an object */
  id: Scalars["ID"];
  /** The display name for this requirement, for UI consumption */
  name: Scalars["String"];
  /** The Brex definition for a supported rail */
  rail: BankingGatewayRail;
}

/** Field is for representing one single field with all necessary info, for UI consumption */
export interface RailRequirementField {
  /** Optional, the format to apply to a text field, like sort code **-**-** */
  displayFormat?: Maybe<Scalars["String"]>;
  /** How should UI should display this field. */
  displayType: FieldDisplayType;
  /** Optional, any additional text that should be provided to assist users entering a value for the field */
  helperText?: Maybe<Scalars["String"]>;
  /** Required, whether a field is optional or not to fill out. */
  isOptional: Scalars["Boolean"];
  /** The name in the Brex Requirement Form, for back end consumption */
  key: Scalars["String"];
  /** Optional, the maximum length of this field, applicable to text fields only. */
  maxLength?: Maybe<Scalars["Int"]>;
  /** Optional, the minimum length of this field, applicable to text fields only. */
  minLength?: Maybe<Scalars["Int"]>;
  /** The display name in the Brex Requirement Form, for UI consumption */
  name: Scalars["String"];
  /** Optional, the example for end users to follow, like sort code 40-30-20 */
  placeholder?: Maybe<Scalars["String"]>;
  /** Whether UI needs to pull from BE again after the value is updated. */
  refreshRequirementsOnChange: Scalars["Boolean"];
  /** whether the input needs to be entered twice */
  requireDualEntry: Scalars["Boolean"];
  /** Optional, the regular expression for UI to validate end user inputs */
  validationRegexp?: Maybe<Scalars["String"]>;
  /** value input/chosen by end users */
  value?: Maybe<Scalars["String"]>;
  /** Optional, a list of candidate values for bounded fields. */
  valuesAllowed?: Maybe<Array<Maybe<RailRequirementFieldValue>>>;
}

/** Field Value is for when a field has multiple fixed values to pick from */
export interface RailRequirementFieldValue {
  /** Optional, any additional text that should be provided to assist users selecting the value */
  helperText?: Maybe<Scalars["String"]>;
  /** The brief description for what the associated value stands for, for end user consumption */
  name: Scalars["String"];
  /** The actual value represents one of the options for a field, for back end consumption */
  value: Scalars["String"];
}

export interface RailRequirements {
  rail: Rail;
  requiredFields: Array<RailRequirementsField>;
}

export interface RailRequirementsField {
  displayFormat?: Maybe<Scalars["String"]>;
  displayType: RailRequirementsFieldDisplayType;
  helperText?: Maybe<Scalars["String"]>;
  isOptional: Scalars["Boolean"];
  key: Scalars["String"];
  maxLength?: Maybe<Scalars["Int"]>;
  minLength?: Maybe<Scalars["Int"]>;
  name: Scalars["String"];
  placeholder?: Maybe<Scalars["String"]>;
  refreshRequirementsOnChange: Scalars["Boolean"];
  requireDualEntry: Scalars["Boolean"];
  validationRegexp?: Maybe<Scalars["String"]>;
  value?: Maybe<Scalars["String"]>;
  valuesAllowed?: Maybe<Array<RailRequirementsFieldValue>>;
}

export enum RailRequirementsFieldDisplayType {
  ADDRESS = "ADDRESS",
  DATE = "DATE",
  RADIO = "RADIO",
  SELECT = "SELECT",
  TEXT = "TEXT",
}

export interface RailRequirementsFieldValue {
  helperText?: Maybe<Scalars["String"]>;
  name: Scalars["String"];
  value: Scalars["String"];
}

export interface RailRequirementsFilter {
  bankAccountClass?: InputMaybe<BankAccountClassType>;
  capabilities: Array<RailCapability>;
  ownerType: RailAccountDetailsOwnerType;
  sourceCountries: Array<Scalars["String"]>;
  sourceCurrencies: Array<Scalars["String"]>;
  targetCountries: Array<Scalars["String"]>;
  targetCurrencies: Array<Scalars["String"]>;
}

export enum RailType {
  AU_BECS = "AU_BECS",
  CA_EFT = "CA_EFT",
  EU_SEPA = "EU_SEPA",
  GLOBAL_BANK_TRANSFER = "GLOBAL_BANK_TRANSFER",
  HK_FPS = "HK_FPS",
  INTL_SWIFT_WIRE = "INTL_SWIFT_WIRE",
  SG_EGIRO = "SG_EGIRO",
  UK_BACS = "UK_BACS",
  US_ACH = "US_ACH",
  US_CHEQUE = "US_CHEQUE",
  US_WIRE = "US_WIRE",
}

export interface RailsFilter {
  ids?: InputMaybe<Array<Scalars["ID"]>>;
}

/** Valid ACH information extracted by the OCR provider. */
export interface RawOcrExtractedAch {
  /** The bank account class. */
  accountClass?: Maybe<BankAccountClass>;
  /** The bank account number extracted by the OCR provider. */
  accountNumber?: Maybe<RawOcrExtractedString>;
  /** The bank account type. */
  accountType?: Maybe<BankAccountType>;
  /** Beneficiary name. */
  beneficiaryName?: Maybe<Scalars["String"]>;
  /** Date of payment, calculated based on the due date and ACH processing time (3 days) */
  paymentSendAt?: Maybe<Scalars["Time"]>;
  /** Identifies the priority of payment for this bank account in a list of bank accounts. The higher the number, the highest the priority. */
  priority: Scalars["Int"];
  /** The bank routing number extracted by the OCR provider. */
  routingNumber?: Maybe<RawOcrExtractedString>;
}

/** Address extracted by the OCR provider. */
export interface RawOcrExtractedAddress {
  /** The address line extracted by the OCR provider. For instance: 410 S Arthur Ave. */
  addressLine?: Maybe<RawOcrExtractedString>;
  /** The city extracted by the OCR provider. For instance: Louisville. */
  city?: Maybe<RawOcrExtractedString>;
  /** The country code returned by the OCR provider. For instance: US. */
  countryCode?: Maybe<RawOcrExtractedString>;
  /** The state extracted by the OCR provider. For instance: Co. */
  state?: Maybe<RawOcrExtractedString>;
  /** The zip code extracted by the OCR provider. For instance: 80027. */
  zipCode?: Maybe<RawOcrExtractedString>;
}

/** Valid Bank account information extracted by the OCR provider. */
export type RawOcrExtractedBankInfo =
  | RawOcrExtractedAch
  | RawOcrExtractedCheque
  | RawOcrExtractedDomesticWire
  | RawOcrExtractedInternationalWire;

/** Valid Cheque information extracted by the OCR provider. */
export interface RawOcrExtractedCheque {
  /** The address extracted by the OCR provider. */
  address?: Maybe<RawOcrExtractedAddress>;
  /** Date of payment, calculated based on the due date and Cheque processing time (14 days) */
  paymentSendAt?: Maybe<Scalars["Time"]>;
  /** Identifies the priority of payment for this bank account in a list of bank accounts. The higher the number, the highest the priority. */
  priority: Scalars["Int"];
  /** The Recipient name. */
  recipientName?: Maybe<Scalars["String"]>;
  /** The vendor name extracted by the OCR provider. */
  vendorName?: Maybe<Scalars["String"]>;
}

/** Valid Domestic Wire information extracted by the OCR provider. */
export interface RawOcrExtractedDomesticWire {
  /** The bank account number extracted by the OCR provider. */
  accountNumber?: Maybe<RawOcrExtractedString>;
  /** The address extracted by the OCR provider. */
  address?: Maybe<RawOcrExtractedAddress>;
  /** Beneficiary name. */
  beneficiaryName?: Maybe<Scalars["String"]>;
  /** Date of payment, calculated based on the due date and Domestic wire processing time (2 days) */
  paymentSendAt?: Maybe<Scalars["Time"]>;
  /** Identifies the priority of payment for this bank account in a list of bank accounts. The higher the number, the highest the priority. */
  priority: Scalars["Int"];
  /** The bank routing number extracted by the OCR provider. */
  routingNumber?: Maybe<RawOcrExtractedString>;
}

/** Financial field extracted by the OCR provider */
export interface RawOcrExtractedFinancial {
  /** Field metadata. */
  metadata?: Maybe<InvoiceOcrFieldMetadata>;
  /** Financial field value. */
  value: FinancialAsset;
}

/** Valid International Wire information extracted by the OCR provider. */
export interface RawOcrExtractedInternationalWire {
  /** The address extracted by the OCR provider. */
  address?: Maybe<RawOcrExtractedAddress>;
  /** The IBAN extracted by the OCR provider. */
  iban?: Maybe<RawOcrExtractedString>;
  /** Date of payment, calculated based on the due date and International Wire processing time (6 days) */
  paymentSendAt?: Maybe<Scalars["Time"]>;
  /** Identifies the priority of payment for this bank account in a list of bank accounts. The higher the number, the highest the priority. */
  priority: Scalars["Int"];
  /** The swift code extracted by the OCR provider. */
  swiftCode?: Maybe<RawOcrExtractedString>;
}

/** String field extracted by the OCR provider */
export interface RawOcrExtractedString {
  /** Field metadata. */
  metadata?: Maybe<InvoiceOcrFieldMetadata>;
  /** String field value. */
  value: Scalars["String"];
}

/** Date field extracted by the OCR provider */
export interface RawOcrExtractedTime {
  /** Field metadata. */
  metadata?: Maybe<InvoiceOcrFieldMetadata>;
  /** Date field value. */
  value: Scalars["Time"];
}

/** Vendor information, extracted from invoice */
export interface RawOcrExtractedVendor {
  /** The vendor address extracted by the OCR provider. */
  address?: Maybe<RawOcrExtractedAddress>;
  /** The all matching vendor bank account information extracted by the OCR provider. */
  bankAccountInfo?: Maybe<Array<RawOcrExtractedBankInfo>>;
  /** The vendor email extracted by the OCR provider. */
  email?: Maybe<RawOcrExtractedString>;
  /** The vendor name extracted by the OCR provider. */
  name?: Maybe<RawOcrExtractedString>;
}

/** A receipt in the receipts-v2 table. */
export interface Receipt extends Node {
  /** Filestore asset associated with the reecipt. */
  asset?: Maybe<Asset>;
  /** How the receipt was sent (e.g. web, mobile, SMS). */
  channel: ReceiptChannel;
  /** The structured, extracted content of a receipt. */
  content?: Maybe<ReceiptContent>;
  /** Document type, allows differentiating between receipt and invoices */
  documentType: DocumentType;
  /** The ID of an object */
  id: Scalars["ID"];
  /** State of the receipt in matching flow, if applicable. */
  matchStatus: ReceiptMatchStatus;
  /** Source of the receipt. Deprecated. */
  origin?: Maybe<Scalars["String"]>;
  /** Provider of which the receipt is sourced. */
  provider: ReceiptProvider;
}

export interface ReceiptAffidavitAddendum extends ExpenseAddendum {
  /** The channel of the affidavit request */
  channel?: Maybe<ReceiptChannelType>;
  /** The unique ID of the expense addendum. */
  id: Scalars["ID"];
}

export interface ReceiptAffidavitAddendumInput {
  /** The channel of the affidavit request */
  channel?: InputMaybe<ReceiptChannelType>;
}

export interface ReceiptAffidavitInput {
  /** The channel affidavit is provided */
  affidavitChannel: AffidavitChannel;
}

export interface ReceiptAutogenDisabledRationale {
  /** Customer account ID of the user who submitted the form */
  customerAccountId: Scalars["ID"];
  /** Customer user ID of the user who submitted the form */
  customerUserId: Scalars["ID"];
  /** When the form was submitted */
  insertedAt?: Maybe<Scalars["LocalDateTime"]>;
  /** Comment about disabling receipt autogen */
  receiptAutogenDisabledComment?: Maybe<Scalars["String"]>;
  /** Reason for disabling receipt autogen */
  receiptAutogenDisabledReasons: Array<ReceiptAutogenDisabledReasonType>;
}

export enum ReceiptAutogenDisabledReasonType {
  /** Other reason */
  OTHER = "OTHER",
  /** I prefer employees to submit receipts manually */
  PREFER_MANUAL_RECEIPTS = "PREFER_MANUAL_RECEIPTS",
  /** Auto Generated receipts aren't detailed enough */
  RECEIPTS_NOT_DETAILED_ENOUGH = "RECEIPTS_NOT_DETAILED_ENOUGH",
  /** Brex takes too long to auto generate receipts */
  TOO_LONG_TO_AUTOGEN = "TOO_LONG_TO_AUTOGEN",
}

export interface ReceiptAutogenSetting {
  /** Customer account ID for which these settings are applied */
  customerAccountId: Scalars["ID"];
  /** Customer user ID of the user who last mutated the settings */
  customerUserId?: Maybe<Scalars["ID"]>;
  /** Whether receipt auto generation is disabled for all users under this customer account */
  isReceiptAutogenDisabled: Scalars["Boolean"];
}

export interface ReceiptAutogenSettingTest {
  customerAccountId: Scalars["ID"];
  customerUserId?: Maybe<Scalars["ID"]>;
  isReceiptAutogenDisabled: Scalars["Boolean"];
}

export interface ReceiptAutogenStatistics {
  /**
   * # of receipts which were auto generated / total # of receipts since the beginning of time
   * Rounded up to the nearest integer (e.g. 32)
   */
  receiptAutogenPercentage: Scalars["Int"];
}

export enum ReceiptChannel {
  /** Receipt was sent via /match_expense api endpoint. */
  API_MATCH = "API_MATCH",
  /** Uploaded through external API /upload_receipt endpoint. */
  API_UPLOAD = "API_UPLOAD",
  /** Receipt was auto generated. */
  AUTO_GENERATED = "AUTO_GENERATED",
  /** Invoice was sent to some bill pay email (bills@brex.com, unique-email@bills.brex.com). */
  EMAIL_BILLS = "EMAIL_BILLS",
  /** Receipt was sent to receipts@brex.com. */
  EMAIL_RECEIPTS = "EMAIL_RECEIPTS",
  /** Receipt was sent to receipts+forwarding@brex.com */
  EMAIL_RECEIPTS_FORWARDING = "EMAIL_RECEIPTS_FORWARDING",
  /** Receipt was sent to reimbursements@brex.com. */
  EMAIL_REIMBURSEMENTS = "EMAIL_REIMBURSEMENTS",
  /** Receipt was posted to receipts-internal.brexapis.com/gmail/receipts from the Google Workspace App. */
  GOOGLE_WORKSPACE_APP = "GOOGLE_WORKSPACE_APP",
  /** Invalid. */
  INVALID = "INVALID",
  /** Receipt was uploaded on the mobile app -- not a matching flow. */
  MOBILE = "MOBILE",
  /** Receipt was uploaded through easy upload flow on mobile. */
  MOBILE_MATCHING = "MOBILE_MATCHING",
  /** Receipt was uploaded via reimbursement OCR flow on mobile. */
  MOBILE_REIMBURSEMENTS = "MOBILE_REIMBURSEMENTS",
  /** Receipt was sent through the Slack app. */
  SLACK = "SLACK",
  /** Receipt was sent via SMS (includes Whatsapp). */
  SMS = "SMS",
  /** Channel is unknown. */
  UNKNOWN_CHANNEL = "UNKNOWN_CHANNEL",
  /** Receipt was uploaded on the web dashboard to a specific expense -- not a matching flow. */
  WEB = "WEB",
  /** Invoice was uploaded via bill pay details pane. */
  WEB_BILLS_DETAILS_PANE = "WEB_BILLS_DETAILS_PANE",
  /** Invoice was uploaded via bill pay form flow on dashboard. */
  WEB_BILLS_FORM = "WEB_BILLS_FORM",
  /** Invoice was uploaded via bill pay list page on dashboard. */
  WEB_BILLS_LIST_PAGE = "WEB_BILLS_LIST_PAGE",
  /** Receipt was uploaded through easy upload flow on web. */
  WEB_MATCHING = "WEB_MATCHING",
  /** Receipt was uploaded via reimbursement OCR flow on web. */
  WEB_REIMBURSEMENTS = "WEB_REIMBURSEMENTS",
}

export enum ReceiptChannelType {
  MOBILE = "MOBILE",
  WEB = "WEB",
}

export interface ReceiptConnection extends Connection {
  edges: Array<ReceiptEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

/** The structured, extracted content of a receipt */
export interface ReceiptContent {
  /** Fields applicable to any type of receipt */
  generalReceiptFields: GeneralReceiptFields;
  /** Status of the extraction process of the receipt content */
  status?: Maybe<ReceiptContentStatus>;
}

export enum ReceiptContentStatus {
  /** Content extraction was cancelled */
  CANCELED = "CANCELED",
  /** Content extraction is finished and have full response */
  DONE = "DONE",
  /** Content extraction has failed */
  FAILED = "FAILED",
  /** Content extraction has failed but can be retried */
  FAILED_TRANSIENT = "FAILED_TRANSIENT",
  /** Content extraction is planned */
  PLANNED = "PLANNED",
  /** Content extraction is ready. Might have partial response */
  READY = "READY",
  /** Content extraction was sent to provider */
  SENT = "SENT",
}

/** A field that represents a discount item */
export interface ReceiptDiscountItem {
  /** Nominal amount of the discount */
  amount?: Maybe<ReceiptRawOcrExtractedFinancial>;
  /** Name of the discount */
  name?: Maybe<ReceiptRawOcrExtractedString>;
  /** Percentage rate of the discount */
  rate?: Maybe<ReceiptRawOcrExtractedString>;
}

export interface ReceiptEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<Receipt>;
}

export interface ReceiptExpenseWorkflowAssociations {
  /** List of Associated Expense IDs */
  expenses: Array<Expense>;
  /** List of Associated Receipt IDs */
  receipts: Array<Receipt>;
}

/** Defines how the calculate the points (X1, Y1), (X1, Y2), (X2, Y1), (X2, Y2) */
export enum ReceiptFieldCoordinateType {
  /**
   * The coordinates are decimal values representing the positioning relative to the image dimensions, between 0 and 1.
   * Calculate the four points as follows: (X1, Y1), (X1, Y2), (X2, Y1), (X2, Y2)
   * X1 = image width * Xmin
   * X2 = image width * Xmax
   * Y1 = image height * Ymin
   * Y2 = image height * Ymax
   */
  RELATIVE = "RELATIVE",
}

/** A rectangular region that encloses an object within a recipt file (PDF, image, etc) */
export interface ReceiptFieldCoordinates {
  /** Defines how the calculate the points (X1, Y1), (X1, Y2), (X2, Y1), (X2, Y2) */
  coordinateType?: Maybe<ReceiptFieldCoordinateType>;
  /** The right X coordinate. */
  maxX?: Maybe<Scalars["Float"]>;
  /** The lower Y coordinate. */
  maxY?: Maybe<Scalars["Float"]>;
  /** The left X coordinate. */
  minX?: Maybe<Scalars["Float"]>;
  /** The upper Y coordinate. */
  minY?: Maybe<Scalars["Float"]>;
  /** The page number from where the field was extracted. */
  page?: Maybe<Scalars["Int"]>;
}

export interface ReceiptFilterInput {
  receiptIds: Array<Scalars["ID"]>;
}

export type ReceiptIntegration = UberReceiptIntegration;

export interface ReceiptIntegrationInput {
  type: ReceiptsCollectionIntegrationType;
}

export enum ReceiptIntegrationType {
  UBER = "UBER",
}

export type ReceiptIntegrationUserConnectionStatus = UberUserConnectionStatus;

export interface ReceiptIntegrationUserConnectionStatusOneOfInput {
  uber?: InputMaybe<UberUserConnectionStatusInput>;
}

/** A field that represents a line item */
export interface ReceiptLineItem {
  /** Name of the item */
  name?: Maybe<ReceiptRawOcrExtractedString>;
  /** Quantity of the item */
  quantity?: Maybe<ReceiptRawOcrExtractedFloat>;
  /** Total amount of the line item */
  total?: Maybe<ReceiptRawOcrExtractedFinancial>;
  /** Price of the item */
  unitPrice?: Maybe<ReceiptRawOcrExtractedFinancial>;
}

export enum ReceiptMatchStatus {
  FAILED = "FAILED",
  MATCHED = "MATCHED",
  NOT_TRACKED = "NOT_TRACKED",
  PENDING = "PENDING",
}

export interface ReceiptMetadata {
  integrationType?: Maybe<ReceiptIntegrationType>;
}

export interface ReceiptOcrFieldMetadata {
  /** A measure of how confident the OCR provider is in the accuracy of the recognized text. */
  confidenceScore?: Maybe<Scalars["Float"]>;
  /** The field coordinates where it was extracted from the receipt. */
  coordinates?: Maybe<ReceiptFieldCoordinates>;
}

export enum ReceiptProvider {
  BANYAN = "BANYAN",
  BASIC = "BASIC",
  CARD_NETWORK = "CARD_NETWORK",
  CARD_NETWORK_BASIC = "CARD_NETWORK_BASIC",
  DOORDASH = "DOORDASH",
  ETHOCA = "ETHOCA",
  INVALID = "INVALID",
  LYFT = "LYFT",
  RECEIPT_ASSISTANT = "RECEIPT_ASSISTANT",
  SPOTNANA = "SPOTNANA",
  SPOTNANA_INTEGRATION = "SPOTNANA_INTEGRATION",
  SUBSTANTIATION_BASIC = "SUBSTANTIATION_BASIC",
  TRIPS = "TRIPS",
  UBER = "UBER",
  UNKNOWN_PROVIDER = "UNKNOWN_PROVIDER",
  USER = "USER",
  USER_AFFIDAVIT = "USER_AFFIDAVIT",
}

/** Details for a mobile push notification prompting user to add a receipt to an expense */
export interface ReceiptPushNotificationDetailsInput {
  /** Expense ID */
  expenseId: Scalars["ID"];
  /** Optional merchant name */
  merchantName?: InputMaybe<Scalars["String"]>;
  /** Optional amount */
  originalAmount?: InputMaybe<FinancialAssetInput>;
}

/** Financial field extracted by the OCR provider */
export interface ReceiptRawOcrExtractedFinancial {
  /** Field metadata. */
  metadata?: Maybe<ReceiptOcrFieldMetadata>;
  /** Financial field value. */
  value?: Maybe<FinancialAsset>;
}

/** String field extracted by the OCR provider */
export interface ReceiptRawOcrExtractedFloat {
  /** Field metadata. */
  metadata?: Maybe<ReceiptOcrFieldMetadata>;
  /** Float field value. */
  value?: Maybe<Scalars["Float"]>;
}

/** String field extracted by the OCR provider */
export interface ReceiptRawOcrExtractedString {
  /** Field metadata. */
  metadata?: Maybe<ReceiptOcrFieldMetadata>;
  /** String field value. */
  value?: Maybe<Scalars["String"]>;
}

export interface ReceiptReviewByItemCategoryRule {
  lineItemCategories: Array<LineItemCategory>;
}

export interface ReceiptReviewByItemCategoryRuleInput {
  lineItemCategories: Array<LineItemCategory>;
}

/**
 * #############################
 *  Receipt review configuration
 * #############################
 */
export interface ReceiptReviewRules {
  receiptReviewByItemCategory: ReceiptReviewByItemCategoryRule;
}

/**
 * #############################
 *  Receipt review configuration
 * #############################
 */
export interface ReceiptReviewRulesInput {
  receiptReviewByItemCategory: ReceiptReviewByItemCategoryRuleInput;
}

export enum ReceiptStatus {
  RECEIPT_ABSENT = "RECEIPT_ABSENT",
  RECEIPT_PRESENT = "RECEIPT_PRESENT",
}

/** A field that represents a tax item */
export interface ReceiptTaxItem {
  /** Nominal amount of the tax */
  amount?: Maybe<ReceiptRawOcrExtractedFinancial>;
  /** Name of the tax */
  name?: Maybe<ReceiptRawOcrExtractedString>;
  /** Percentage rate of the tax */
  rate?: Maybe<ReceiptRawOcrExtractedString>;
}

export interface ReceiptValidationResult {
  matchesAmount?: Maybe<Scalars["Boolean"]>;
  matchesDate?: Maybe<Scalars["Boolean"]>;
  matchesMerchant?: Maybe<Scalars["Boolean"]>;
  result: ResultType;
}

/** Setting of receipt validation */
export interface ReceiptValidationSetting {
  value?: Maybe<ReceiptValidationSettingValue>;
}

/** Enum to represent whether receipt validation is enabled or disabled */
export enum ReceiptValidationSettingValue {
  DISABLED = "DISABLED",
  ENABLED = "ENABLED",
}

export interface ReceiptWorkflow {
  /** Workflow Associations type */
  associations?: Maybe<ReceiptExpenseWorkflowAssociations>;
  /** Workflow ID (to query in temporal) */
  id: Scalars["ID"];
  /** The names of pending workflow activities. */
  pendingActivities: Array<Scalars["String"]>;
  /** The names of pending child Workflow activities. */
  pendingChildWorkflowIds: Array<Scalars["String"]>;
  /** Workflow status */
  status: TemporalWorkflowStatus;
}

export enum ReceiptsCollectionIntegrationType {
  UBER = "UBER",
}

export interface ReceivablesOffersAdvanceDetails {
  resourceId?: Maybe<Scalars["String"]>;
}

export interface ReceivablesOffersRepaymentDetails {
  resourceId?: Maybe<Scalars["String"]>;
}

export interface RecentLocalSearch {
  groupId: Scalars["String"];
  id: Scalars["String"];
  label: Scalars["String"];
  value: Scalars["String"];
}

export interface RecentLocalSearchInput {
  groupId: Scalars["String"];
  id: Scalars["String"];
  label: Scalars["String"];
  value: Scalars["String"];
}

export interface RecentSearchError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface RecentSearchItem {
  lastTimeSearched: Scalars["Time"];
}

export interface RecentSearchList {
  instantiationId?: Maybe<Scalars["String"]>;
  searchItems: Array<RecentSearchItem>;
  type: RecentSearchType;
}

export type RecentSearchResult = RecentSearchError | RecentSearchList;

/** Types of recent search */
export enum RecentSearchType {
  /** Recent search made in the Global Search */
  GLOBAL_SEARCH = "GLOBAL_SEARCH",
  /** Recent search made in a local reference (anywhere in the product) */
  LOCAL_SEARCH = "LOCAL_SEARCH",
}

export enum RecipientType {
  BUSINESS = "BUSINESS",
  INDIVIDUAL = "INDIVIDUAL",
}

export enum RecognizedCounterpartyName {
  ACORNS = "ACORNS",
  ADP = "ADP",
  AFFINIPAY = "AFFINIPAY",
  AFFIRM = "AFFIRM",
  AFTERPAY = "AFTERPAY",
  AMAZON = "AMAZON",
  AMPLA = "AMPLA",
  ANTHEM = "ANTHEM",
  APINTEGO = "APINTEGO",
  BETTERMENT = "BETTERMENT",
  BILL_COM = "BILL_COM",
  BLUEVINE = "BLUEVINE",
  BRAINTREE = "BRAINTREE",
  BRIGIT_COM = "BRIGIT_COM",
  CARTA = "CARTA",
  CLEARCO = "CLEARCO",
  COINBASE = "COINBASE",
  CURRENCY_CLOUD = "CURRENCY_CLOUD",
  DEEL = "DEEL",
  DELUXE = "DELUXE",
  DIVVY = "DIVVY",
  DOORDASH = "DOORDASH",
  EBAY = "EBAY",
  ETSY = "ETSY",
  EXPENSIFY = "EXPENSIFY",
  GRUBHUB = "GRUBHUB",
  GUIDELINE = "GUIDELINE",
  GUSTO = "GUSTO",
  HUMAN_INTEREST = "HUMAN_INTEREST",
  INSTAMED = "INSTAMED",
  INTUIT = "INTUIT",
  INVALID = "INVALID",
  JUSTWORKS = "JUSTWORKS",
  MAINSTREET = "MAINSTREET",
  MELIO = "MELIO",
  ONPAY = "ONPAY",
  PAYCHEX = "PAYCHEX",
  PAYONEER = "PAYONEER",
  PAYPAL = "PAYPAL",
  PILOT = "PILOT",
  PNC = "PNC",
  PRIME_TRUST = "PRIME_TRUST",
  QUICKBOOKS = "QUICKBOOKS",
  QUILL = "QUILL",
  RIPPLING = "RIPPLING",
  SELF_LENDER = "SELF_LENDER",
  SEZZLE = "SEZZLE",
  SHOPIFY = "SHOPIFY",
  SQUARE = "SQUARE",
  STRIPE = "STRIPE",
  SYNAPSE = "SYNAPSE",
  THE_HARTFORD = "THE_HARTFORD",
  TRINET = "TRINET",
  UBER = "UBER",
  UNITED_HEALTHCARE = "UNITED_HEALTHCARE",
  VENMO = "VENMO",
  VERIZON = "VERIZON",
  WAVE = "WAVE",
  WEX = "WEX",
  WISE = "WISE",
  WOO_COMMERCE = "WOO_COMMERCE",
  ZENEFITS = "ZENEFITS",
}

export interface ReconnectErpFeedInput {
  clientMutationId: Scalars["String"];
  erpFeedId: Scalars["ID"];
}

export interface ReconnectErpFeedPayload {
  clientMutationId: Scalars["String"];
  erpFeed?: Maybe<ErpFeed>;
  errorMessage?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
}

export interface RecurringMetadata {
  autoApproveUserIds?: Maybe<Array<Scalars["String"]>>;
  previousBillId: Scalars["String"];
  recurrenceId: Scalars["String"];
}

/**  Defined in the DepositsPayment component in APIv1 */
export interface RecurringRules {
  ends: Scalars["String"];
  howOften: Scalars["String"];
}

/**  Defined in the DepositsPayment component in APIv1 */
export type RecurringSchedule =
  | DepositsMonthlySchedule
  | DepositsWeeklySchedule;

export enum RecurringScheduleBusinessDays {
  FRIDAY = "FRIDAY",
  MONDAY = "MONDAY",
  THURSDAY = "THURSDAY",
  TUESDAY = "TUESDAY",
  WEDNESDAY = "WEDNESDAY",
}

export interface RecurringScheduleDetails {
  /** ID of the recurring schedule. */
  id: Scalars["ID"];
  /** Recurring schedule rule. */
  schedule: RecurringScheduleSpec;
}

export interface RecurringScheduleInput {
  endsAt?: InputMaybe<Scalars["Time"]>;
  monthlySchedule?: InputMaybe<MonthlyScheduleInput>;
  totalNumberOfPayments?: InputMaybe<Scalars["Int"]>;
  weeklySchedule?: InputMaybe<WeeklyScheduleInput>;
}

export interface RecurringScheduleRuleOneOfInput {
  daily?: InputMaybe<DailyScheduleRuleInput>;
  dayOfMonth?: InputMaybe<DayOfMonthScheduleRuleInput>;
  weekAndDayOfMonth?: InputMaybe<WeekAndDayMonthlyScheduleRuleInput>;
  weekly?: InputMaybe<WeeklyScheduleRuleInput>;
}

/** Interface for recurring schedule rules with common fields. */
export interface RecurringScheduleSpec {
  /**
   * The date when the recurring will end.
   * null means infinite (until user cancels)
   */
  endAt?: Maybe<Scalars["Time"]>;
  /**
   * The number of instances of the recurring schedule that will be triggered.
   * null means infinite (until user cancels)
   */
  numInstances?: Maybe<Scalars["Int"]>;
}

export interface RedeemCashBalanceInput {
  /** amount of points to redeem in centipoints */
  centipointsAmount: Scalars["Int"];
  clientMutationId: Scalars["String"];
  /** expected balance in usd cents */
  expectedBalanceAmountCents: Scalars["Int"];
  /** Id for the cash balance redemption offer */
  redemptionOfferId: Scalars["String"];
  /** ID of the target deposits account for redeem */
  targetDepositsAccountId: Scalars["String"];
}

export interface RedeemCashBalanceResult {
  redemptionInstanceId: Scalars["String"];
}

export interface RedeemDonationInputV2 {
  /** amount of points to redeem in centipoints */
  centipointsAmount: Scalars["Int"];
  clientMutationId: Scalars["String"];
  /** expected donation in usd cents */
  expectedDonationAmountUsdCents: Scalars["Int"];
  /** id of nonprofit from the getchange.io API */
  nonprofitId: Scalars["String"];
  /** Id for the donation redemption offer */
  redemptionOfferId: Scalars["String"];
}

export interface RedeemDonationResult {
  redemptionInstanceId: Scalars["String"];
}

export interface RedeemForBalanceInput {
  clientMutationId: Scalars["String"];
  expectedBalanceAmountCents: Scalars["Int"];
  idempotencyKey: Scalars["String"];
  pointsToRedeem: Scalars["Int"];
  redemptionOfferId: Scalars["ID"];
  targetDepositsAccountId: Scalars["ID"];
}

export interface RedeemForBalancePayload {
  account: Account;
  balanceBreakdown?: Maybe<BalanceBreakdown>;
  clientMutationId: Scalars["String"];
  redeemedBalanceAmountCents: Scalars["Int"];
}

export interface RedeemGiftCardInput {
  /** amount of points to redeem in centipoints */
  centipointsAmount: Scalars["Int"];
  clientMutationId: Scalars["String"];
  /** expected donation in usd cents */
  giftCardAmountUsdCents: Scalars["Int"];
  message?: InputMaybe<Scalars["String"]>;
  recipientEmailV2: Scalars["Email"];
  recipientFirstName: Scalars["String"];
  recipientLastName: Scalars["String"];
  redemptionOfferId: Scalars["String"];
  /** id of gift card from tangocard API */
  utid: Scalars["String"];
}

export interface RedeemGiftCardResult {
  redemptionInstanceId: Scalars["String"];
}

export interface RedeemStatementCreditInputV2 {
  /** amount of points to redeem in centipoints */
  centipointsAmount: Scalars["Int"];
  clientMutationId: Scalars["String"];
  /** expected credit in usd cents */
  expectedCreditAmountUsdCents: Scalars["Int"];
  /** Id for the statement credit redemption offer */
  redemptionOfferId: Scalars["ID"];
}

export interface RedeemStatementCreditResult {
  redemptionInstanceId: Scalars["String"];
}

export interface ReferUserInput {
  clientMutationId: Scalars["String"];
  targetEmail: Scalars["String"];
}

export interface ReferUserPayload {
  clientMutationId: Scalars["String"];
  referral: ReferralRecord;
}

export interface ReferralCodesInput {
  /** ads referral code */
  ads?: InputMaybe<Scalars["String"]>;
  /** finalAttribution referral code */
  finalAttribution?: InputMaybe<Scalars["String"]>;
  /** firstParty referral code */
  firstParty?: InputMaybe<Scalars["String"]>;
  /** generalPartner referral code */
  generalPartner?: InputMaybe<Scalars["String"]>;
  /** onboarding api partner referral code */
  onboardingApiPartner?: InputMaybe<Scalars["String"]>;
  /** selfAttested referral code */
  selfAttested?: InputMaybe<Scalars["String"]>;
}

/** Referral config values */
export interface ReferralConfig extends Node {
  /** End date time */
  endDate?: Maybe<Scalars["Time"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  /** Minimum spend required in cents */
  minimumSpendRequiredInCents?: Maybe<Scalars["Int"]>;
  /** Source reward amount in cents */
  sourceRewardAmountInCents?: Maybe<Scalars["Int"]>;
  /** Source reward type */
  sourceRewardType?: Maybe<RewardType>;
  /** Start date time */
  startDate?: Maybe<Scalars["Time"]>;
  /** Target reward amount in cents */
  targetRewardAmountInCents?: Maybe<Scalars["Int"]>;
  /** Target reward type */
  targetRewardType?: Maybe<RewardType>;
}

/** Referrals information object */
export interface ReferralInformation extends Node {
  /** The ID of an object */
  id: Scalars["ID"];
  /** Mobile referral information values */
  mobile?: Maybe<MobileReferralInformation>;
  /** Referral config values */
  referralConfig?: Maybe<ReferralConfig>;
  /** Referral terms and conditions */
  termsAndConditions?: Maybe<Scalars["String"]>;
}

/** Customer referral object */
export interface ReferralRecord extends Node {
  /** The ID of an object */
  id: Scalars["ID"];
  /** referral creation time */
  insertedAt: Scalars["Time"];
  /** id of the referral record */
  referralRecordId?: Maybe<Scalars["String"]>;
  /** referral status */
  referralStatus: ReferralRecordStatus;
  /** the email of the referred user */
  targetEmail: Scalars["String"];
}

export interface ReferralRecordEntry {
  /** id of the referral record */
  id: Scalars["ID"];
  /** time this referral was created */
  insertedAt: Scalars["Time"];
  /** status of this referral */
  referralStatus: ReferralStatus;
  /** email of the person being referred */
  targetEmail: Scalars["String"];
}

export enum ReferralRecordStatus {
  APPLICATION_APPROVED = "APPLICATION_APPROVED",
  COMPLETED = "COMPLETED",
  EXPIRED = "EXPIRED",
  INVALID = "INVALID",
  INVITE_SENT = "INVITE_SENT",
  PENDING_INVITE = "PENDING_INVITE",
  SIGNED_UP = "SIGNED_UP",
}

/** Paginated referral records */
export interface ReferralRecordsPaginated extends Node {
  /** The ID of an object */
  id: Scalars["ID"];
  /** next page token */
  nextPageToken?: Maybe<Scalars["String"]>;
  /** list of referral records */
  referralRecords?: Maybe<Array<Maybe<ReferralRecord>>>;
}

export enum ReferralStatus {
  APPLICATION_APPROVED = "APPLICATION_APPROVED",
  COMPLETED = "COMPLETED",
  EXPIRED = "EXPIRED",
  INVALID = "INVALID",
  INVITE_SENT = "INVITE_SENT",
  PENDING_INVITE = "PENDING_INVITE",
  SIGNED_UP = "SIGNED_UP",
}

/** Referrals summary object */
export interface ReferralsSummary extends Node {
  /** The ID of an object */
  id: Scalars["ID"];
  /** Mobile summary values */
  mobile?: Maybe<MobileReferralsSummary>;
}

/** Update fx rates with newest rates for account policy currencies */
export interface RefreshAccountPolicyCurrenciesFxRatesResult
  extends MutationResult {
  accountPolicyCurrencies?: Maybe<Array<AccountPolicyCurrency>>;
  errors?: Maybe<Array<AccountPolicyCurrenciesErrors>>;
}

export interface RefreshAccountingIntegrationInput {
  /** Required, the client mutation id. */
  clientMutationId: Scalars["String"];
  /** Optional, the accounting field ids to refresh. If not provided, all fields will be refreshed. */
  fieldIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Required, the accounting integration id. */
  id: Scalars["ID"];
}

export interface RefreshAccountingIntegrationResult extends MutationResult {
  errors?: Maybe<Array<AccountingIntegrationMutationError>>;
  result?: Maybe<AccountingIntegration>;
}

export interface RefreshCredentialInput {
  clientMutationId: Scalars["String"];
  credentialId?: InputMaybe<Scalars["String"]>;
  credentialStatus?: InputMaybe<CredentialStatus>;
  integrationId?: InputMaybe<Scalars["String"]>;
}

export interface RefreshCredentialResult extends MutationResult {
  errors?: Maybe<Array<CredentialMutationError>>;
  result?: Maybe<VendorCredential>;
}

export interface RefreshEntityFromAccountingIntegrationInput {
  /** Required, the client mutation id. */
  clientMutationId: Scalars["String"];
  /** Required, the type of entity to refresh. */
  entity: RefreshableEntity;
}

export interface RefreshEntityFromAccountingIntegrationResult
  extends MutationResult {
  errors?: Maybe<Array<AccountingIntegrationMutationError>>;
  result?: Maybe<RefreshEntityResult>;
}

export interface RefreshEntityResult {
  /** Required, ID of the created export job. */
  exportJobId: Scalars["ID"];
}

export interface RefreshFinancialSourceInput {
  clientMutationId: Scalars["String"];
  financialSourceId: Scalars["ID"];
}

export interface RefreshFinancialSourcePayload {
  clientMutationId: Scalars["String"];
  result?: Maybe<FinancialsSourceResult>;
}

export interface RefreshIntegrationCredentialsInput {
  clientMutationId: Scalars["String"];
  /** Filter by integration id */
  integrationId?: InputMaybe<Scalars["ID"]>;
  /** Filter by integration status */
  status?: InputMaybe<Scalars["String"]>;
}

export interface RefreshIntegrationCredentialsPayload {
  clientMutationId: Scalars["String"];
  integrations?: Maybe<Array<Maybe<Integration>>>;
}

export interface RefreshIntegrationInput {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
}

export interface RefreshIntegrationPayload {
  clientMutationId: Scalars["String"];
  integration?: Maybe<Integration>;
}

export interface RefreshPersonalSourceInput {
  clientMutationId: Scalars["String"];
  /** Customer User ID associated with personal source */
  customerUserId: Scalars["String"];
  personalSourceId: Scalars["ID"];
  /** Whether source not in [:active, :connecting] status should be reset to :connecting before refreshing */
  shouldForceRefresh?: InputMaybe<Scalars["Boolean"]>;
  /** Whether account details should be pulled synchronously with this request */
  shouldPullDetails?: InputMaybe<Scalars["Boolean"]>;
}

export interface RefreshPersonalSourcePayload {
  clientMutationId: Scalars["String"];
  result: FinancialSource;
}

/** Input for refreshing trip information from Spotnana by trip ID or partner trip ID. */
export interface RefreshTripInformationInput {
  partnerTripId?: InputMaybe<Scalars["String"]>;
  tripId?: InputMaybe<Scalars["String"]>;
}

/** Result of refreshing trip information from an external partner like Spotnana. */
export interface RefreshTripInformationResult {
  bookingId?: Maybe<Scalars["String"]>;
  status: RefreshTripInformationStatus;
  tripId?: Maybe<Scalars["String"]>;
}

/** ---[ Enums ]------------ */
export enum RefreshTripInformationStatus {
  ERROR = "ERROR",
  SUCCESS = "SUCCESS",
}

/** Input for refreshing trip information and ensuring a PNR is present. */
export interface RefreshTripInformationWithPnrInput {
  partnerPnrId: Scalars["String"];
  partnerTripId?: InputMaybe<Scalars["String"]>;
  tripId?: InputMaybe<Scalars["String"]>;
}

export interface RefreshVerificationStatusInput {
  clientMutationId: Scalars["String"];
  financialSourceId: Scalars["ID"];
}

export interface RefreshVerificationStatusPayload {
  clientMutationId: Scalars["String"];
  verificationStatus?: Maybe<VerificationStatusType>;
}

export enum RefreshableEntity {
  PURCHASE_ORDER = "PURCHASE_ORDER",
}

export interface RefundTransactionPayloadV2 {
  redemptionRate: Scalars["Float"];
}

export interface RegisterGroupInput {
  id: Scalars["ID"];
  resources: Array<ResourceInput>;
}

export interface RegisterGroupResult extends MutationResult {
  errors?: Maybe<Array<GroupsMutationError>>;
}

/** Registration status with customer's primary regulator. */
export enum RegistrationStatus {
  APPLIED_AND_REJECTED = "APPLIED_AND_REJECTED",
  APPLIED_AND_WAITING_ON_A_DECISION = "APPLIED_AND_WAITING_ON_A_DECISION",
  CURRENTLY_REGISTERED = "CURRENTLY_REGISTERED",
  DO_NOT_PLAN_TO_REGISTER = "DO_NOT_PLAN_TO_REGISTER",
  PLAN_TO_REGISTER = "PLAN_TO_REGISTER",
}

export interface RegulatoryAuthorityInput {
  authorityType: RegulatoryAuthorityType;
  name?: InputMaybe<Scalars["String"]>;
  registrationNumber: Scalars["String"];
}

export enum RegulatoryAuthorityType {
  FINCEN = "FINCEN",
  FINRA = "FINRA",
  OTHER = "OTHER",
  SEC = "SEC",
}

export interface ReimbursementAttendeesAddendumInput {
  /** External attendees */
  externalAttendees: Array<ReimbursementExternalAttendeeInput>;
  /** Internal attendees */
  internalAttendees: Array<ReimbursementInternalAttendeeInput>;
}

export interface ReimbursementBooleanValueInput {
  value?: InputMaybe<Scalars["Boolean"]>;
}

/** General client error */
export interface ReimbursementDenyClientError
  extends ReimbursementDenyErrors,
    StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

/** Error from expense rejection */
export interface ReimbursementDenyError extends MutationError {
  errors?: Maybe<Array<ReimbursementDenyErrors>>;
}

/** Base interface for expense reject errors */
export interface ReimbursementDenyErrors {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface ReimbursementDenyInput {
  /** Optional client mutation ID */
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** ID of an APPROVED reimbursement expense to reject */
  expenseId: Scalars["ID"];
}

/** Precondition errors */
export interface ReimbursementDenyPreconditionError
  extends ReimbursementDenyErrors,
    StandardClientError {
  code: ErrorCode;
  errorCode?: Maybe<ReimbursementDenyPreconditionErrorCode>;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export enum ReimbursementDenyPreconditionErrorCode {
  EXPENSE_NOT_FOUND = "EXPENSE_NOT_FOUND",
  INVALID_STATUS = "INVALID_STATUS",
  UNSUPPORTED_TYPE = "UNSUPPORTED_TYPE",
}

/** Result of the expense reject operation */
export type ReimbursementDenyResult = Expense | ReimbursementDenyError;

export interface ReimbursementDistance {
  /** The travel distance. */
  quantity: Scalars["Decimal"];
  /** The unit of distance measure (ie miles). */
  unit: ReimbursementDistanceUnit;
}

export interface ReimbursementDistanceInput {
  /** The travel distance. */
  quantity: Scalars["Decimal"];
  /** The unit of distance measure (ie miles). */
  unit: ReimbursementDistanceUnit;
}

export enum ReimbursementDistanceUnit {
  KILOMETERS = "KILOMETERS",
  MILES = "MILES",
}

export interface ReimbursementDraftInboxTaskEntityDetails
  extends InboxTaskEntityDetails {
  /** Base64 encoded expense ID. */
  encodedEntityId: Scalars["String"];
  /** Base64 encoded reimbursement ID. */
  encodedReimbursementId: Scalars["String"];
  /** The expense ID. */
  entityId: Scalars["String"];
  /** True if the reimbursement is for mileage, false otherwise. */
  isMileageReimbursement: Scalars["Boolean"];
  /** The reimbursement ID. Required to submit the draft along with the draft expense ID. */
  reimbursementId: Scalars["String"];
}

export interface ReimbursementExtendedFieldInput {
  /** Whether the extended field is deleted */
  isDeleted?: InputMaybe<Scalars["Boolean"]>;
  /** The key for extended field */
  key: Scalars["String"];
  /** The values of extended fields */
  values?: InputMaybe<Array<ReimbursementFieldValueInputUnion>>;
}

export interface ReimbursementExternalAttendeeInput {
  /** The company name of attendee */
  companyName?: InputMaybe<Scalars["String"]>;
  /** The ID */
  id?: InputMaybe<Scalars["String"]>;
  /** Whether attendee is government official */
  isGovernmentOfficial?: InputMaybe<Scalars["Boolean"]>;
  /** The name of attendee */
  name: Scalars["String"];
  /** The title of attendee */
  title?: InputMaybe<Scalars["String"]>;
}

export interface ReimbursementFeatureAvailability {
  /** list of reasons if reimbursements feature is available but disabled */
  disabledReasons: Array<ReimbursementsDisabledReason>;
  status: ReimbursementFeatureAvailabilityStatus;
}

export enum ReimbursementFeatureAvailabilityStatus {
  /** reimbursement feature is available and can be used */
  AVAILABLE = "AVAILABLE",
  /**
   * reimbursement feature is available but disabled. this can happen due to a variety of reasons. for e.g.
   * the funding source is not set up
   */
  AVAILABLE_BUT_DISABLED = "AVAILABLE_BUT_DISABLED",
  /** reimbursement feature is not available. for e.g. the customer is not entitled to use reimbursements feature */
  NOT_AVAILABLE = "NOT_AVAILABLE",
}

export enum ReimbursementFeatureAvailabilityV2 {
  ACCOUNT_PENDING_ACTIVATION = "ACCOUNT_PENDING_ACTIVATION",
  AVAILABLE = "AVAILABLE",
  BILLING_CONFIGURATION_MISSING = "BILLING_CONFIGURATION_MISSING",
  FUNDING_SOURCE_NOT_SETUP = "FUNDING_SOURCE_NOT_SETUP",
  NOT_AVAILABLE = "NOT_AVAILABLE",
}

export interface ReimbursementFieldValueInputUnion {
  reimbursementBooleanValueInput?: InputMaybe<ReimbursementBooleanValueInput>;
  reimbursementIdentifierToStringValueInput?: InputMaybe<ReimbursementIdentifierToStringValueInput>;
  reimbursementNumberValueInput?: InputMaybe<ReimbursementNumberValueInput>;
  reimbursementStringValueInput?: InputMaybe<ReimbursementStringValueInput>;
}

export interface ReimbursementHealth {
  healthStatus: HealthStatus;
  healthStatusDetail?: Maybe<HealthStatusDetail>;
  healthStatusDetails: Array<HealthStatusDetail>;
}

export interface ReimbursementIdentifier {
  expenseId?: InputMaybe<Scalars["String"]>;
  reimbursementItemId?: InputMaybe<Scalars["String"]>;
}

export interface ReimbursementIdentifierToStringValueInput {
  displayName?: InputMaybe<Scalars["String"]>;
  identifier?: InputMaybe<Scalars["String"]>;
}

export interface ReimbursementInternalAttendeeInput {
  /** Customer user id */
  customerUserId: Scalars["ID"];
}

export interface ReimbursementItem extends Node {
  approvalRequestId?: Maybe<Scalars["ID"]>;
  approvalsRequest?: Maybe<ApprovalsRequest>;
  customerAccountId: Scalars["ID"];
  customerUserId: Scalars["ID"];
  expenseId?: Maybe<Scalars["ID"]>;
  fundingSource?: Maybe<FundingSource>;
  /** The ID of an object */
  id: Scalars["ID"];
  insertedAt: Scalars["Time"];
  modifiedBy?: Maybe<Scalars["String"]>;
  paymentFailureReason?: Maybe<ReimbursementPaymentFailureReason>;
  paymentInstrument?: Maybe<PaymentInstrument>;
  paymentInstrumentVersion?: Maybe<Scalars["Int"]>;
  postedDate?: Maybe<Scalars["Time"]>;
  reimbursementMetadata?: Maybe<ReimbursementMetadata>;
  requestingUser?: Maybe<User>;
  state?: Maybe<ReimbursementItemState>;
  updatedAt: Scalars["Time"];
}

export enum ReimbursementItemState {
  APPROVED = "APPROVED",
  CANCELED = "CANCELED",
  COMPLETED = "COMPLETED",
  CREATED = "CREATED",
  FAILED = "FAILED",
  INVALID = "INVALID",
  PAYMENT_PROCESSING = "PAYMENT_PROCESSING",
  PAYMENT_WITHDRAWING = "PAYMENT_WITHDRAWING",
  REJECTED = "REJECTED",
  REVOKED = "REVOKED",
  SUBMITTED = "SUBMITTED",
}

export interface ReimbursementMetadata {
  amount?: Maybe<Scalars["Int"]>;
  auxiliaryMetadata?: Maybe<AuxiliaryMetadata>;
  department?: Maybe<Department>;
  departmentId?: Maybe<Scalars["ID"]>;
  departmentName?: Maybe<Scalars["String"]>;
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars["ID"]>;
  locationName?: Maybe<Scalars["String"]>;
  memo?: Maybe<Scalars["String"]>;
  merchant?: Maybe<Merchant>;
  merchantCategory?: Maybe<MerchantCategory>;
  merchantCategoryId?: Maybe<Scalars["ID"]>;
  merchantId?: Maybe<Scalars["ID"]>;
  merchantName?: Maybe<Scalars["String"]>;
  netsuiteClass?: Maybe<ExternalIntegrationEntity>;
  netsuiteClassExternalEntityId?: Maybe<Scalars["ID"]>;
  purchaseDate?: Maybe<Scalars["Time"]>;
  receiptAssetFileId?: Maybe<Scalars["ID"]>;
  userCategory?: Maybe<UserCategory>;
  userCategoryId?: Maybe<Scalars["ID"]>;
}

export interface ReimbursementMetadataInput {
  /** The IDs of assets to add */
  addAssetIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** The addendum for attendees */
  addedAttendeesAddendum?: InputMaybe<ReimbursementAttendeesAddendumInput>;
  /** The amount */
  amount?: InputMaybe<Scalars["Int"]>;
  /** The ID of budget */
  budgetId?: InputMaybe<Scalars["ID"]>;
  /** The ID of department */
  departmentId?: InputMaybe<Scalars["ID"]>;
  /** The name of department */
  departmentName?: InputMaybe<Scalars["String"]>;
  /** The ID of location */
  locationId?: InputMaybe<Scalars["ID"]>;
  /** The name of location */
  locationName?: InputMaybe<Scalars["String"]>;
  /** The memo */
  memo?: InputMaybe<Scalars["String"]>;
  /** The ID of merchant category */
  merchantCategoryId?: InputMaybe<Scalars["ID"]>;
  /** The ID of merchant */
  merchantId?: InputMaybe<Scalars["ID"]>;
  /** The name of merchant */
  merchantName?: InputMaybe<Scalars["String"]>;
  /** The metadata of mileage */
  mileageAuxiliaryMetadata?: InputMaybe<MileageAuxiliaryMetadataInput>;
  /** The ID of netsuite class external entity */
  netsuiteClassExternalEntityId?: InputMaybe<Scalars["ID"]>;
  /** The original amount */
  originalAmount?: InputMaybe<FinancialAssetInput>;
  /** The date of purchase */
  purchaseDate?: InputMaybe<Scalars["Time"]>;
  /** The purchase amount */
  purchasedAmount?: InputMaybe<FinancialAssetInput>;
  /** The receipt affidavit */
  receiptAffidavit?: InputMaybe<ReceiptAffidavitInput>;
  /** The ID of receipt asset file */
  receiptAssetFileId?: InputMaybe<Scalars["ID"]>;
  /** The input for reimbursement extended field */
  reimbursementExtendedFieldInput?: InputMaybe<
    Array<InputMaybe<ReimbursementExtendedFieldInput>>
  >;
  /** The IDs of assets to remove */
  removeAssetIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** The ID of user category */
  userCategoryId?: InputMaybe<Scalars["ID"]>;
}

export interface ReimbursementNumberValueInput {
  value?: InputMaybe<Scalars["Decimal"]>;
}

export enum ReimbursementPaymentFailureReason {
  CANCELLED = "CANCELLED",
  COMPANY_ACCOUNT_CLOSED = "COMPANY_ACCOUNT_CLOSED",
  COMPANY_ACCOUNT_FUNDING_SOURCE_NOT_VERIFIED = "COMPANY_ACCOUNT_FUNDING_SOURCE_NOT_VERIFIED",
  COMPANY_ACCOUNT_INSUFFICIENT_FUNDS = "COMPANY_ACCOUNT_INSUFFICIENT_FUNDS",
  COMPANY_ACCOUNT_NOT_FOUND = "COMPANY_ACCOUNT_NOT_FOUND",
  COMPANY_ACCOUNT_OTHER = "COMPANY_ACCOUNT_OTHER",
  COMPANY_ACCOUNT_UNAUTHORIZED = "COMPANY_ACCOUNT_UNAUTHORIZED",
  EMPLOYEE_ACCOUNT_CLOSED = "EMPLOYEE_ACCOUNT_CLOSED",
  EMPLOYEE_ACCOUNT_INSUFFICIENT_FUNDS = "EMPLOYEE_ACCOUNT_INSUFFICIENT_FUNDS",
  EMPLOYEE_ACCOUNT_KYC_NOT_SETUP = "EMPLOYEE_ACCOUNT_KYC_NOT_SETUP",
  EMPLOYEE_ACCOUNT_KYC_NOT_VERIFIED = "EMPLOYEE_ACCOUNT_KYC_NOT_VERIFIED",
  EMPLOYEE_ACCOUNT_NOT_FOUND = "EMPLOYEE_ACCOUNT_NOT_FOUND",
  EMPLOYEE_ACCOUNT_OTHER = "EMPLOYEE_ACCOUNT_OTHER",
  EMPLOYEE_ACCOUNT_PAYMENT_INSTRUMENT_NOT_VERIFIED = "EMPLOYEE_ACCOUNT_PAYMENT_INSTRUMENT_NOT_VERIFIED",
  EMPLOYEE_ACCOUNT_UNAUTHORIZED = "EMPLOYEE_ACCOUNT_UNAUTHORIZED",
  FRAUD_CHECK = "FRAUD_CHECK",
  INVALID = "INVALID",
  NO_VALID_QUOTES_AVAILABLE = "NO_VALID_QUOTES_AVAILABLE",
  UNMATCHED_BILLING_AND_TRANSMISSION_CURRENCY = "UNMATCHED_BILLING_AND_TRANSMISSION_CURRENCY",
  UNSET = "UNSET",
  UNSUPPORTED_CURRENCY = "UNSUPPORTED_CURRENCY",
}

/**
 * Determines if a reimbursement expense should incur on money movement or
 * just tracking (paid outside of Brex)
 */
export enum ReimbursementPaymentMethod {
  MONEY_MOVEMENT = "MONEY_MOVEMENT",
  TRACKING = "TRACKING",
}

export interface ReimbursementPaymentSource {
  fundingSource?: Maybe<FundingSource>;
  updatedBy?: Maybe<Scalars["String"]>;
}

export interface ReimbursementPlace {
  /**
   * The external place id.
   * https://developers.google.com/maps/documentation/places/web-service/details#Place-place_id
   */
  externalPlaceId?: Maybe<Scalars["String"]>;
  /** The human readable address of the place */
  formattedAddress?: Maybe<Scalars["String"]>;
  /** The latitude of the place. */
  latitude: Scalars["Decimal"];
  /** The longitude of the place. */
  longitude: Scalars["Decimal"];
  /** The name of the place. */
  name?: Maybe<Scalars["String"]>;
}

export interface ReimbursementPlaceInput {
  /**
   * The external place id.
   * https://developers.google.com/maps/documentation/places/web-service/details#Place-place_id
   */
  externalPlaceId?: InputMaybe<Scalars["String"]>;
  /** The human readable address of the place */
  formattedAddress?: InputMaybe<Scalars["String"]>;
  /** The latitude of the place. */
  latitude: Scalars["Decimal"];
  /** The longitude of the place. */
  longitude: Scalars["Decimal"];
  /** The name of the place. */
  name?: InputMaybe<Scalars["String"]>;
}

/** Fields for reimbursement product billing groups */
export interface ReimbursementProductDetails {
  /**  The reimbursement balance converted to usd */
  convertedTotalBalance: FinancialAsset;
  /** This is ID for the journal account (from Billing) that will be used to fund reimbursements. This field might be null if the billing group is still in a PENDING billable state. */
  reimbursementsFundingJournalAccountId?: Maybe<Scalars["String"]>;
}

export interface ReimbursementRoute {
  /** Each stop on the route. */
  places: Array<ReimbursementPlace>;
}

export interface ReimbursementRouteInput {
  /** Each stop on the route. */
  places: Array<ReimbursementPlaceInput>;
}

/** Requirements context to set up Reimbursements */
export interface ReimbursementSetupContext {
  /** ISO-2 country code of payment instrument */
  countryCode: Scalars["String"];
  /** ID of the Customer User to get Verification requirements for */
  customerUserId: Scalars["ID"];
}

export interface ReimbursementStringValueInput {
  value?: InputMaybe<Scalars["String"]>;
}

/** The medatata object for a reimbursement tracking policy */
export interface ReimbursementTrackingMetadata {
  /** The country to which the policy applies */
  country: Country;
}

export interface ReimbursementTrackingMetadataInput {
  countryAlpha2?: InputMaybe<Scalars["String"]>;
}

export interface ReimbursementsApprovalSummaryMetadata {
  /** Legal entity name */
  legalEntityName: Scalars["String"];
  /** Sum of payments in the statement */
  totalPayments?: Maybe<FinancialAsset>;
  /** Sum of transactions in the statement */
  totalTransactions?: Maybe<FinancialAsset>;
}

export enum ReimbursementsDisabledReason {
  ACCOUNT_PENDING_ACTIVATION = "ACCOUNT_PENDING_ACTIVATION",
  BILLING_CONFIGURATION_MISSING = "BILLING_CONFIGURATION_MISSING",
  FUNDING_SOURCE_NOT_SETUP = "FUNDING_SOURCE_NOT_SETUP",
}

export interface ReimbursementsPayoutSummaryMetadata {
  /** Legal entity name */
  legalEntityName: Scalars["String"];
  /** Sum of payments in the statement */
  totalPayments?: Maybe<FinancialAsset>;
  /** Sum of payouts in the statement */
  totalPayouts?: Maybe<FinancialAsset>;
}

/** Input type to reject a budget limit increase request */
export interface RejectBudgetLimitIncreaseRequestInput {
  id: Scalars["ID"];
}

export interface RejectBudgetLimitIncreaseRequestV2Result
  extends MutationResult {
  /** The ID of the budget limit increase request. */
  budgetLimitIncreaseRequestEntityId?: Maybe<Scalars["ID"]>;
  /** A list of user errors for mutation responses. Clients should always request this field when performing mutations */
  errors?: Maybe<Array<ClientError>>;
}

export enum RelatedFeature {
  BENEFITS = "BENEFITS",
  BILL_PAY = "BILL_PAY",
  DISCRETIONARY_SPEND = "DISCRETIONARY_SPEND",
  EXPENSE_CATEGORY = "EXPENSE_CATEGORY",
  PRESET = "PRESET",
  TRAVEL = "TRAVEL",
  TRAVEL_AIR = "TRAVEL_AIR",
  TRAVEL_CAR_RENTAL = "TRAVEL_CAR_RENTAL",
  TRAVEL_EXPENSE = "TRAVEL_EXPENSE",
  TRAVEL_LODGING = "TRAVEL_LODGING",
  TRAVEL_RAIL = "TRAVEL_RAIL",
  VAT = "VAT",
}

export interface ReleaseNote {
  /** Full detail of the release. */
  description: Scalars["String"];
  /** Icon url for the release note card. */
  iconUrl?: Maybe<Scalars["String"]>;
  /** Image url when side panel is opened. */
  imageUrl?: Maybe<Scalars["String"]>;
  /** redirect url of the release. */
  redirectUrl?: Maybe<Scalars["String"]>;
  /** Summary of the release. */
  summary: Scalars["String"];
  /** Title of the release. */
  title: Scalars["String"];
}

export interface RemoveAttendeesInput {
  attendeeIds?: InputMaybe<Array<Scalars["ID"]>>;
  clientMutationId: Scalars["String"];
  groupEventId: Scalars["ID"];
}

export interface RemoveAttendeesResult {
  attendees?: Maybe<Array<EventAttendee>>;
  error?: Maybe<Scalars["String"]>;
}

export interface RemoveAutoApproveUserIdInput {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
}

export interface RemoveCommentEntityAuthorizationInput {
  /** ID of the CommentEntityAuthorization to delete */
  id: Scalars["ID"];
}

export interface RemoveCommentEntityAuthorizationResult {
  /** The updated CommentEntityAuthorization, if successful */
  commentEntityAuthorization?: Maybe<CommentEntityAuthorization>;
  /** Errors that occurred while removing, if any. */
  errors?: Maybe<Array<CommentMutationError>>;
  /** ID of the CommentEntityAuthorization in which this result relates to */
  id: Scalars["ID"];
  /**
   * Boolean indicating success of the operation.
   * @deprecated This field is deprecated, rely on errors field instead
   */
  success: Scalars["Boolean"];
}

export interface RemoveDepartmentInput {
  /** clientMutationId */
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** The ID of the department to delete. */
  id: Scalars["ID"];
}

export interface RemoveDepartmentResult {
  /** ID of the department that was deleted. */
  id: Scalars["ID"];
}

export interface RemoveFieldRequiredForExportError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface RemoveFieldRequiredForExportInput {
  extendedFieldId: Scalars["ID"];
}

export type RemoveFieldRequiredForExportResult =
  | ExtendedField
  | RemoveFieldRequiredForExportError;

export interface RemoveFinancialSourceInput {
  clientMutationId: Scalars["String"];
  financialSourceId: Scalars["ID"];
}

export interface RemoveFinancialSourcePayload {
  clientMutationId: Scalars["String"];
  financialSources?: Maybe<FinancialSourceConnection>;
}

export interface RemoveFinancialSourcePayloadfinancialSourcesArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

export interface RemoveFspBookkeeperInput {
  bookkeeperAccountId: Scalars["String"];
  clientMutationId: Scalars["String"];
}

export interface RemoveFspBookkeeperPayload {
  clientMutationId: Scalars["String"];
  policyUrn?: Maybe<Scalars["String"]>;
}

export interface RemoveFspBookkeeperUserInput {
  bookkeeperUserId: Scalars["String"];
  clientMutationId: Scalars["String"];
}

export interface RemoveFspBookkeeperUserPayload {
  clientMutationId: Scalars["String"];
  groupUrn?: Maybe<Scalars["String"]>;
}

export interface RemoveGroupEventBudgetInput {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
}

export interface RemoveGroupEventBudgetResult {
  error?: Maybe<Scalars["String"]>;
  groupEvent?: Maybe<GroupEvent>;
}

export interface RemoveLimitEscalationInput {
  clientMutationId: Scalars["String"];
  escalationId: Scalars["String"];
}

export interface RemoveLimitEscalationResponse {
  success: Scalars["Boolean"];
}

export interface RemoveLimitEscalationResult extends MutationResult {
  errors?: Maybe<Array<LimitsExperienceMutationError>>;
  result?: Maybe<RemoveLimitEscalationResponse>;
}

export interface RemoveLocationError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface RemoveLocationInput {
  /** clientMutationId */
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** The ID of the location to delete. */
  id: Scalars["ID"];
}

export interface RemoveLocationResult extends MutationResult {
  errors?: Maybe<Array<RemoveLocationError>>;
}

export interface RemovePersonalSourceInput {
  clientMutationId: Scalars["String"];
  personalSourceId: Scalars["ID"];
}

export interface RemovePersonalSourcePayload {
  clientMutationId: Scalars["String"];
}

export enum RentalCarClass {
  COMPACT = "COMPACT",
  COMPACT_SUV = "COMPACT_SUV",
  CONVERTIBLE = "CONVERTIBLE",
  ECONOMY = "ECONOMY",
  ELECTRIC = "ELECTRIC",
  FULL_SIZE = "FULL_SIZE",
  HYBRID = "HYBRID",
  INTERMEDIATE = "INTERMEDIATE",
  INTERMEDIATE_SUV = "INTERMEDIATE_SUV",
  LUXURY = "LUXURY",
  LUXURY_SUV = "LUXURY_SUV",
  MINI = "MINI",
  MINI_VAN = "MINI_VAN",
  OTHER = "OTHER",
  PASSENGER_VAN = "PASSENGER_VAN",
  PICKUP_TRUCK = "PICKUP_TRUCK",
  PREMIUM = "PREMIUM",
  PREMIUM_SUV = "PREMIUM_SUV",
  RECREATIONAL_VEHICLE = "RECREATIONAL_VEHICLE",
  SPECIAL = "SPECIAL",
  SPORTS = "SPORTS",
  STANDARD = "STANDARD",
  SUV = "SUV",
}

export interface ReopenSpendLimitInput {
  clientMutationId: Scalars["String"];
  endDate?: InputMaybe<Scalars["Date"]>;
  id: Scalars["ID"];
  resetRolloverAmount?: InputMaybe<Scalars["Boolean"]>;
}

export interface ReopenSpendLimitResult extends MutationResult {
  errors?: Maybe<Array<StandardClientError>>;
}

export interface ReplaceCardInput {
  /** The card to replace */
  cardId: Scalars["ID"];
  /** The client mutation id */
  clientMutationId: Scalars["String"];
  /** Display name of the card. Only applicable when not keeping the same number. */
  displayName?: InputMaybe<Scalars["String"]>;
  /** The name of the card holder. Only applicable when not keeping the same number. */
  holderName?: InputMaybe<Scalars["String"]>;
  /** The new instrument type of the card */
  instrumentType: InstrumentType;
  /** Whether we should replace the card altogether or just reissue the current one keeping the same number. */
  keepSameNumber?: InputMaybe<Scalars["Boolean"]>;
  /** The card's PIN. Optional field to set PIN during card replacement. */
  pin?: InputMaybe<Scalars["String"]>;
  /** The description for replacing the card */
  replacementDescription?: InputMaybe<Scalars["String"]>;
  /** The reason for replacing the card */
  replacementReason: CardReplacementReason;
  /** Shipping address for delivery of the card. Only applicable to physical cards. */
  shippingAddress?: InputMaybe<ShippingAddressInput>;
  /** Shipping method for delivery of the card. Only applicable to physical cards. */
  shippingMethod?: InputMaybe<ShippingMethod>;
  /** Phone number printed on the shipping label */
  shippingPhoneNumber?: InputMaybe<Scalars["String"]>;
  /** Whether the card being replaced should be terminated. Only applicable to physical cards and when we're not keeping the same number. */
  terminateCard?: InputMaybe<Scalars["Boolean"]>;
}

export interface ReplaceCardPayload {
  /** The client mutation id */
  clientMutationId: Scalars["String"];
  /** This is either the replacement card or the new issuance of the reissued card (if user decided to keep the same number). */
  newCard: Card;
  /** The card that was replaced. Applicable only when replacing the card altogether (not keeping the same number). */
  oldCard?: Maybe<Card>;
}

export interface ReplaceCardWithPhysicalInput {
  /** The card to replace */
  cardId: Scalars["ID"];
  /** The client mutation id */
  clientMutationId: Scalars["String"];
  /** The name of the card holder */
  holderName?: InputMaybe<Scalars["String"]>;
  /** The description for replacing the card */
  replacementDescription?: InputMaybe<Scalars["String"]>;
  /** The reason for replacing the card */
  replacementReason: CardReplacementReason;
  /** Shipping address for delivery of the card */
  shippingAddress: ShippingAddressInput;
  /** Shipping method for delivery of the card */
  shippingMethod?: InputMaybe<ShippingMethod>;
  /** Phone number printed on the shipping label */
  shippingPhoneNumber?: InputMaybe<Scalars["String"]>;
  /** Whether the card being replaced should be terminated */
  terminateCard?: InputMaybe<Scalars["Boolean"]>;
}

export interface ReplaceCardWithPhysicalPayload {
  /** The client mutation id */
  clientMutationId: Scalars["String"];
  /** The card that was replaced */
  replacedCard?: Maybe<Card>;
  /** The newly created card */
  replacementCard?: Maybe<Card>;
}

export interface ReplaceCardWithVirtualInput {
  /** The card to replace */
  cardId: Scalars["ID"];
  /** The client mutation id */
  clientMutationId: Scalars["String"];
  /** Display name of the card */
  displayName?: InputMaybe<Scalars["String"]>;
  /** The name of the card holder */
  holderName?: InputMaybe<Scalars["String"]>;
  /** The description for replacing the card */
  replacementDescription?: InputMaybe<Scalars["String"]>;
  /** The reason for replacing the card */
  replacementReason: CardReplacementReason;
  /** Whether the card being replaced should be terminated */
  terminateCard?: InputMaybe<Scalars["Boolean"]>;
}

export interface ReplaceCardWithVirtualPayload {
  /** The client mutation id */
  clientMutationId: Scalars["String"];
  /** The card that was replaced */
  replacedCard?: Maybe<Card>;
  /** The newly created card */
  replacementCard?: Maybe<Card>;
}

export interface ReplaceFundingSourceInput {
  bankAccountSource: BankAccountSourceInput;
  clientMutationId: Scalars["String"];
  fundingSourceId: Scalars["String"];
  idempotencyKey: Scalars["String"];
  notes: Scalars["String"];
  priority?: InputMaybe<FundingSourcePriority>;
  reason: FundingSourceStatusChangeReason;
  type: Scalars["String"];
}

export interface ReplaceFundingSourcePayload {
  clientMutationId: Scalars["String"];
  fundingSource: FundingSource;
}

export interface ReplacedByRecord {
  /** The card that replaced another */
  card: Card;
  /** Time the record was inserted */
  insertedAt: Scalars["Time"];
  /** Reason that the original card was replaced */
  reason: CardReplacementReason;
}

/** Replaces card record */
export interface ReplacesRecord {
  /** The replaces card (old card) */
  card: Card;
  /** The Replaces Record creation date */
  insertedAt: Scalars["Time"];
  /** Card replacement reason */
  reason: CardReplacementReason;
}

/** Replaces card record connection */
export interface ReplacesRecordConnection {
  /** Edges */
  edges: Array<Maybe<ReplacesRecordEdge>>;
  /** Page info */
  pageInfo: PageInfo;
  /** Total count */
  totalCount: Scalars["Int"];
}

/** Replaces card record edge */
export interface ReplacesRecordEdge {
  /** Cursor */
  cursor?: Maybe<Scalars["String"]>;
  /** The replaces card record node */
  node: ReplacesRecord;
}

export interface Report {
  file?: Maybe<Asset>;
  format?: Maybe<ReportFormat>;
  type?: Maybe<ReportType>;
}

/** Column Options */
export interface ReportColumnOption {
  /** Internal name for the data field */
  field: Scalars["String"];
  /** Human readable name for the field */
  fieldDisplayName: Scalars["String"];
}

export interface ReportColumnOptionConnection extends Connection {
  /** The column options in the current page of results. */
  edges: Array<ReportColumnOptionEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of templates matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface ReportColumnOptionEdge {
  /** The opaque cursor of the current edge */
  cursor?: Maybe<Scalars["String"]>;
  /** The column option at this edge */
  node?: Maybe<ReportColumnOption>;
}

export interface ReportCustomIntegrationField {
  integrationFieldId?: Maybe<Scalars["String"]>;
  integrationFieldValue?: Maybe<Scalars["String"]>;
}

export interface ReportEntry {
  resourceId: Scalars["ID"];
  values: Array<ReportEntryValue>;
}

export interface ReportEntryData {
  activityType?: Maybe<Scalars["String"]>;
  amount?: Maybe<Scalars["String"]>;
  brexCategory?: Maybe<Scalars["String"]>;
  budgetName?: Maybe<Scalars["String"]>;
  cardType?: Maybe<Scalars["String"]>;
  currency?: Maybe<Scalars["String"]>;
  customIntegrationFields?: Maybe<Array<Maybe<ReportCustomIntegrationField>>>;
  departmentName?: Maybe<Scalars["String"]>;
  expenseStatus?: Maybe<Scalars["String"]>;
  hierarchyCostCenterName?: Maybe<Scalars["String"]>;
  hierarchyDepartmentName?: Maybe<Scalars["String"]>;
  hierarchyLegalEntityName?: Maybe<Scalars["String"]>;
  hierarchyLocationName?: Maybe<Scalars["String"]>;
  integrationBillableStatus?: Maybe<Scalars["String"]>;
  integrationCategory?: Maybe<Scalars["String"]>;
  integrationCategoryFullyQualifiedName?: Maybe<Scalars["String"]>;
  integrationClass?: Maybe<Scalars["String"]>;
  integrationCustomer?: Maybe<Scalars["String"]>;
  integrationDepartment?: Maybe<Scalars["String"]>;
  integrationEmployee?: Maybe<Scalars["String"]>;
  integrationLocation?: Maybe<Scalars["String"]>;
  integrationProject?: Maybe<Scalars["String"]>;
  integrationSubsidiary?: Maybe<Scalars["String"]>;
  integrationVendor?: Maybe<Scalars["String"]>;
  last4?: Maybe<Scalars["String"]>;
  locationName?: Maybe<Scalars["String"]>;
  memo?: Maybe<Scalars["String"]>;
  merchantName?: Maybe<Scalars["String"]>;
  originalAmount?: Maybe<Scalars["String"]>;
  originalCurrency?: Maybe<Scalars["String"]>;
  outstandingBalance?: Maybe<Scalars["String"]>;
  paymentDate?: Maybe<Scalars["String"]>;
  policyName?: Maybe<Scalars["String"]>;
  postedDate?: Maybe<Scalars["String"]>;
  purchasedAt?: Maybe<Scalars["String"]>;
  statementDescriptor?: Maybe<Scalars["String"]>;
  statementEntryId?: Maybe<Scalars["String"]>;
  swipeTime?: Maybe<Scalars["String"]>;
  transactionSource?: Maybe<Scalars["String"]>;
  userName?: Maybe<Scalars["String"]>;
}

/** Report Entry Data - Data for Report Entries - used to populate the preview table */
export interface ReportEntryDataConnection extends Connection {
  /** The report entries in the current page of results. */
  edges: Array<ReportEntryDataEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of report entries matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface ReportEntryDataEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The report entry at this edge. */
  node?: Maybe<ReportEntryData>;
}

export interface ReportEntryValue {
  columnOptionId: Scalars["String"];
  displayName: Scalars["String"];
  value?: Maybe<Scalars["String"]>;
}

/** Error result for the mutation */
export interface ReportExportResultsError extends StandardClientError {
  /** Error code from the standardized error code enum */
  code: ErrorCode;
  /** Additional error details specific to export results */
  errorDetails?: Maybe<ExportResultsErrorDetails>;
  /** Developer-facing error message for debugging */
  message?: Maybe<Scalars["String"]>;
  /** Input path that caused the error */
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface ReportExportResultsInput {
  /** List of export results to report. Must contain at least one result. */
  results: Array<ExportResultInput>;
}

/** Result union for the reportExportResults mutation */
export type ReportExportResultsResult =
  | ReportExportResultsError
  | ReportExportResultsSuccess;

/** Successful result containing updated export entries */
export interface ReportExportResultsSuccess {
  /** List of export result entries that were successfully updated */
  exportEntries: Array<ExportResultEntry>;
}

export enum ReportFormat {
  CSV = "CSV",
  HTML = "HTML",
  PDF = "PDF",
  TXT = "TXT",
  XLSX = "XLSX",
}

/** The type of report file type. */
export enum ReportFormatType {
  CSV = "CSV",
  HTML = "HTML",
  PDF = "PDF",
  TXT = "TXT",
  XLSX = "XLSX",
}

/** The report mode which controls how data is displayed for the report file. */
export enum ReportMode {
  BILLPAY = "BILLPAY",
  DEFAULT = "DEFAULT",
}

/** The options to include for the report file. */
export enum ReportOption {
  INCLUDE_LINE_ITEMS = "INCLUDE_LINE_ITEMS",
  INCLUDE_RECEIPTS = "INCLUDE_RECEIPTS",
}

/** Who has access to see the report? */
export enum ReportScope {
  ACCOUNT = "ACCOUNT",
  GLOBAL = "GLOBAL",
  USER = "USER",
}

/** Set who has access to see the report. */
export enum ReportScopeInput {
  ACCOUNT = "ACCOUNT",
  /**  Using a separate enum for the input prevents users from writing to the GLOBAL scope at the schema level. */
  USER = "USER",
}

/** Template - contains all information about a template */
export interface ReportTemplate extends Node {
  /** Description for the template */
  description?: Maybe<Scalars["String"]>;
  /** Entries forming the template */
  entries?: Maybe<Array<ReportTemplateEntry>>;
  /** Template Primary Key */
  id: Scalars["ID"];
  /** Time the template was last used */
  lastUsed?: Maybe<Scalars["Time"]>;
  /** Name for the template */
  name?: Maybe<Scalars["String"]>;
  /** Customer ID of the account owning the template */
  owner?: Maybe<Scalars["String"]>;
  /** User marked status of the template */
  status?: Maybe<ReportTemplateCustomerStatus>;
  /**
   * Template Data
   * @deprecated No longer supported
   */
  templateData: ReportTemplateData;
  /**
   * Template Info
   * @deprecated No longer supported
   */
  templateInfo: ReportTemplateInfo;
  /** Time the template was update at */
  updatedAt?: Maybe<Scalars["Time"]>;
}

export interface ReportTemplateConnection extends Connection {
  /** The templates in the current page of results. */
  edges: Array<ReportTemplateEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of templates matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface ReportTemplateCreateInput {
  clientMutationId: Scalars["String"];
  /** Description for the new template */
  description?: InputMaybe<Scalars["String"]>;
  /** Template entries for the template to use */
  entries: Array<ReportTemplateEntryInput>;
  /** Name for the new template */
  name: Scalars["String"];
}

export interface ReportTemplateCreateResult extends MutationResult {
  errors?: Maybe<Array<ReportTemplateMutationError>>;
  result?: Maybe<ReportTemplate>;
}

/** Enum type representing how the customer account has marked the template */
export enum ReportTemplateCustomerStatus {
  /** Default state for a template */
  DEFAULT = "DEFAULT",
  /** Customer has favorited the template */
  FAVORITE = "FAVORITE",
}

/** Template Data - Entries forming the template, specifying how the Report will be generated */
export interface ReportTemplateData {
  /** Entries forming the template */
  templateEntries?: Maybe<Array<ReportTemplateEntry>>;
}

export interface ReportTemplateDeleteInput {
  /** Template id for the template to delete */
  id: Scalars["ID"];
}

export interface ReportTemplateDeleteResult extends MutationResult {
  errors?: Maybe<Array<ReportTemplateMutationError>>;
}

export interface ReportTemplateDuplicateInput {
  /** Id of a template to clone from */
  baseId: Scalars["ID"];
  clientMutationId: Scalars["String"];
  /** Name for the new template */
  name: Scalars["String"];
}

export interface ReportTemplateDuplicateResult extends MutationResult {
  errors?: Maybe<Array<ReportTemplateMutationError>>;
  result?: Maybe<ReportTemplate>;
}

export interface ReportTemplateEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The template at this edge. */
  node?: Maybe<ReportTemplate>;
}

/** Entry Types - used to specify columns and transformations on template entries */
export interface ReportTemplateEntry {
  /** If not null, entry is a brex data entry type - representing a column populated with the Brex data specified */
  brexDataReportTemplateEntry?: Maybe<BrexDataReportTemplateEntry>;
  /** Status for the entry */
  entryStatus: ReportTemplateEntryStatusType;
  /** Name for the column the entry represents */
  reportColumnName: Scalars["String"];
  /** If not null, entry is a static entry type - representing a column populated with the static data specified */
  staticReportTemplateEntry?: Maybe<StaticReportTemplateEntry>;
}

/**  Input Types - used to specify columns and transformations on template entries */
export interface ReportTemplateEntryInput {
  /** If not null, entry is a brex data entry type - representing a column populated with the Brex data specified */
  brexDataReportTemplateEntry?: InputMaybe<BrexDataReportTemplateEntryInput>;
  /** Status for the entry */
  entryStatus: ReportTemplateEntryStatusType;
  /** Name for the column the entry represents */
  reportColumnName: Scalars["String"];
  /** If not null, entry is a static entry type - representing a column populated with the static data specified */
  staticReportTemplateEntry?: InputMaybe<StaticReportTemplateEntryInput>;
}

/** Enum type representing the possible options for a template entry */
export enum ReportTemplateEntryStatusType {
  /** Don't include the entry in the final Report */
  DISABLED = "DISABLED",
  /** Include the entry in the final Report */
  ENABLED = "ENABLED",
  /** Template must include the entry in the Report */
  REQUIRED = "REQUIRED",
}

export interface ReportTemplateFilterInput {
  /** Template name we are searching for */
  name?: InputMaybe<Scalars["String"]>;
}

/** Template Info - Misc data about the template */
export interface ReportTemplateInfo {
  /** User marked status of the template */
  customerStatus: ReportTemplateCustomerStatus;
  /** Time the template was last used */
  lastUsed: Scalars["Time"];
  /** Description for the template */
  templateDescription: Scalars["String"];
  /** Name for the template */
  templateName: Scalars["String"];
  /** Customer ID of the account owning the template */
  templateOwner: Scalars["String"];
}

export interface ReportTemplateMutationError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface ReportTemplateUpdateInput {
  clientMutationId: Scalars["String"];
  /** New template description for template */
  description?: InputMaybe<Scalars["String"]>;
  /** Id of template to update */
  id: Scalars["ID"];
  /** New template name for template */
  name?: InputMaybe<Scalars["String"]>;
  /** New entries for template */
  newEntries?: InputMaybe<Array<ReportTemplateEntryInput>>;
  /** New customer status for template */
  status?: InputMaybe<ReportTemplateCustomerStatus>;
}

export interface ReportTemplateUpdateResult extends MutationResult {
  errors?: Maybe<Array<ReportTemplateMutationError>>;
  result?: Maybe<ReportTemplate>;
}

export enum ReportType {
  D_T = "D_T",
  R_R = "R_R",
  SEARCH = "SEARCH",
  W_D = "W_D",
}

/** Concrete implementation of StandardClientError for the Reporting schema */
export interface ReportingClientError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface ReportingDashboard {
  /** Storage for the report's global filters */
  globalFilterJson?: Maybe<Scalars["Json"]>;
  id: Scalars["ID"];
  /** The name of the dashboard, either set by the user or by Brex */
  name: Scalars["String"];
  /**
   * The owner (generally, the creator) of this dashboard.
   * Can be null e.g. for GLOBAL reports
   */
  owner?: Maybe<User>;
  /** Who has access to this report? */
  scope: ReportScope;
  /**
   * For stock reports (i.e. made by Brex), this allows FE to customize based on the report type e.g.
   * - education banners
   * - icons
   */
  stockReportType?: Maybe<StockReportType>;
  /** All of the widgets in the report (not paginated) */
  widgets: ReportingDashboardWidgetConnection;
}

export interface ReportingDashboardwidgetsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
}

export interface ReportingDashboardConnection extends Connection {
  edges: Array<ReportingDashboardEdge>;
  pageInfo: PageInfo;
  /** The total number of dashboards matching the query filters */
  totalCount: Scalars["Int"];
}

export interface ReportingDashboardEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<ReportingDashboard>;
}

/** Filters to narrow down listing of dashboards */
export interface ReportingDashboardFilters {
  /** Which report scopes to query for */
  scopes?: InputMaybe<Array<ReportScope>>;
}

export interface ReportingDashboardSchedule {
  /** The cadence of the scheduled report */
  cadence: ScheduleCadence;
  /** The ID of the report schedule */
  id: Scalars["ID"];
  /** The message to be included in the email body */
  message: Scalars["String"];
  /** The list of employees who will receive the scheduled report */
  recipientEmployees: ReportingDashboardScheduleEmployeeConnection;
  /** The report that this schedule is configured for */
  reportingDashboard: ReportingDashboard;
}

export interface ReportingDashboardScheduleEmployeeConnection
  extends Connection {
  /** The items in the current page of results. */
  edges: Array<Maybe<ReportingDashboardScheduleEmployeeEdge>>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of items, across all pages, matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

/** A ReportingDashboardScheduleEmployee edge for the ReportingDashboardScheduleEmployee connection. */
export interface ReportingDashboardScheduleEmployeeEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The item at this edge. */
  node: Employee;
}

export interface ReportingDashboardScheduleInput {
  /** The cadence of the scheduled report */
  cadence: ScheduleCadence;
  /** The message to be included in the email body */
  message: Scalars["String"];
  /** The list of employees who should receive the scheduled report */
  recipientEmployeeIds: Array<Scalars["ID"]>;
}

export interface ReportingDashboardWidgetConnection extends Connection {
  edges: Array<ReportingDashboardWidgetEdge>;
  pageInfo: PageInfo;
  /**  The total number of widgets in this dashboard  */
  totalCount: Scalars["Int"];
}

export interface ReportingDashboardWidgetEdge {
  cursor?: Maybe<Scalars["String"]>;
  /** The widget's layout within this specific report */
  layout?: Maybe<ReportingLayout>;
  /** The widget occupying this edge's layout position */
  node?: Maybe<ReportingWidget>;
}

export interface ReportingDashboardWidgetInput {
  /** Specification of how the query data is formatted */
  displayJson?: InputMaybe<Scalars["Json"]>;
  /** The ID of the Widget to update, or null if the Widget is being added */
  id?: InputMaybe<Scalars["ID"]>;
  /** Set the widget's position in the dashboard */
  layout?: InputMaybe<ReportingLayoutInput>;
  /** Specification of the Widget's query (how we get the data) */
  queryJson?: InputMaybe<Scalars["Json"]>;
}

/** A widget's position and size in a dashboard */
export interface ReportingLayout {
  /** The vertical space (rows) occupied by the widget (h >= 0) */
  h: Scalars["Int"];
  /** The horizontal space (columns) occupied by the widget (0 <= w < 12) */
  w: Scalars["Int"];
  /** The horizontal position (column) of the widget in the layout (0 <= x < 12) */
  x: Scalars["Int"];
  /** The vertical position (row) of the widget in the report layout (y >= 0) */
  y: Scalars["Int"];
}

/** Set the widget's position and size in the dashboard */
export interface ReportingLayoutInput {
  /** Set the vertical space (rows) occupied by the widget (h >= 0) */
  h: Scalars["Int"];
  /** Set the horizontal space (columns) occupied by the widget (0 <= w < 12) */
  w: Scalars["Int"];
  /** Set the horizontal position (column) of the widget in the layout (0 <= x < 12) */
  x: Scalars["Int"];
  /** Set the vertical position (row) of the widget in the report layout (y >= 0) */
  y: Scalars["Int"];
}

/** A widget combines a query with metadata describing how to display it */
export interface ReportingWidget {
  /** Specification of how the query data is formatted */
  displayJson: Scalars["Json"];
  id: Scalars["ID"];
  /** Specification of the Widget's query (how we get the data) */
  queryJson: Scalars["Json"];
}

export interface ReportsFilterInput {
  userStatuses?: InputMaybe<Array<UserStatus>>;
}

export interface ReportsInformation {
  /** The number of direct reports for the user. */
  directReportsCount: Scalars["Int"];
  /** The total number of reports for the user (recursively resolved through all levels). */
  nestedReportsCount: Scalars["Int"];
}

/** Dedicated Representative to a Customer Account */
export interface Representative {
  /** Expected available hours */
  availability?: Maybe<Scalars["String"]>;
  /** Call support channel information */
  call?: Maybe<Call>;
  /** Email support channel information */
  email?: Maybe<EmailChannel>;
  /** Representative's first name */
  firstName?: Maybe<Scalars["String"]>;
  /** Whether the account based on the representative has VIP chat access */
  hasVipChatAccess?: Maybe<Scalars["Boolean"]>;
  /** Representative's last name */
  lastName?: Maybe<Scalars["String"]>;
  /** Book a meeting scheduling link */
  schedulingLink?: Maybe<Scalars["String"]>;
  /** Type of representative */
  type?: Maybe<RepresentativeType>;
}

export enum RepresentativeType {
  /** Customer success manager */
  CUSTOMER_SUCCESS_MANAGER = "CUSTOMER_SUCCESS_MANAGER",
  /** Dedicated support specialist */
  DEDICATED_SUPPORT_SPECIALIST = "DEDICATED_SUPPORT_SPECIALIST",
  /** A team of dedicated support specialists  */
  DEDICATED_SUPPORT_TEAM = "DEDICATED_SUPPORT_TEAM",
  /** Unset value for this enumeration */
  INVALID = "INVALID",
  /** Relationship manager */
  RELATIONSHIP_MANAGER = "RELATIONSHIP_MANAGER",
}

/** A request to accomplish some task (e.g. approve an expense, approve a budget, etc...) */
export interface Request {
  /**
   * Fetch actions on the Request.
   * Can be filtered e.g. to select only pending actions
   */
  actions?: Maybe<RequestActionConnection>;
  /** User that canceled the request */
  canceledBy?: Maybe<Employee>;
  /** The compliance status for the request */
  complianceStatus?: Maybe<ComplianceStatus>;
  /** When the request was created. */
  createdAt: Scalars["Time"];
  /** The employee who initiated the request. */
  createdBy?: Maybe<Employee>;
  /** The compliance status for the request that is derived from the submitter and reviewer compliance statuses. */
  derivedComplianceStatus?: Maybe<DerivedComplianceStatus>;
  /** The unique ID of the request */
  id: Scalars["ID"];
  /** The timestamp when a controller overridden the request */
  overriddenAt?: Maybe<Scalars["Time"]>;
  /** The employee who overridden the request. */
  overriddenBy?: Maybe<Employee>;
  /** User id being co-piloted when this request was overridden. */
  overriddenOnBehalfOf?: Maybe<Employee>;
  /** The employee who owns the request. */
  owner?: Maybe<Employee>;
  /**
   * The user who initiated the request
   * @deprecated Incorrect permission scoping, use requestedByEmployee instead
   */
  requestedBy?: Maybe<User>;
  /**
   * The employee who initiated the request
   * @deprecated Not clear whether this is owner or creator of request after copilot context was introduced, use owner instead
   */
  requestedByEmployee?: Maybe<Employee>;
  /** The reviewer compliance status for the request. */
  reviewerComplianceStatus?: Maybe<ComplianceStatus>;
  /** The timestamp when reviewer compliance deadline will be reached */
  reviewerDeadlineAt?: Maybe<Scalars["Time"]>;
  /** The stage of approval of the request, e.g. created, approved, denied */
  status?: Maybe<RequestStatus>;
  /** The timestamp when the submitter compliance deadline will be reached */
  submitterDeadlineAt?: Maybe<Scalars["Time"]>;
  /**
   * The type of thing being requested.
   *
   * This is a 1:1 mapping to __typename, but it exists for convenience and consistency.
   */
  type?: Maybe<RequestType>;
}

/** A request to accomplish some task (e.g. approve an expense, approve a budget, etc...) */
export interface RequestactionsArgs {
  filter?: InputMaybe<RequestActionFilterInput>;
  order?: InputMaybe<RequestActionOrderInput>;
  page?: InputMaybe<PaginationInput>;
}

/** An action which needs (or needed) to be taken on a Request */
export interface RequestAction {
  /** The user who resolved the request action and the owner of the request action. */
  ackedBy?: Maybe<RequestActionAckedBy>;
  /** The execution order of the request action */
  executionOrder?: Maybe<Scalars["Int"]>;
  /** The unique ID of the RequestAction */
  id: Scalars["ID"];
  /**
   * A list of the users who have been requested to take this action,
   * alongside information about why they are the owners.
   * For Receipt/Memo requests, this will generally be the requester
   */
  owners: Array<RequestActionOwner>;
  /** Policy action metadata of the request action */
  policyAction?: Maybe<RequestPolicyAction>;
  policyReason?: Maybe<PolicyReason>;
  /**
   * A list of ids referencing the reasons (may be more than one)
   * that the policy requires this action to be taken
   */
  policyReasonIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  policyReasonV2?: Maybe<PolicyReasonV2>;
  /** How the user doing the query relates to the request action, e.g. owner, none */
  relation: RequestActionUserRelation;
  /** The Request which this action must be performed for */
  request?: Maybe<Request>;
  /**
   * The comment left by the person who resolved the action.
   *
   * - If this was an Approval action, this would be the approver
   * - If this was a Justification action, this would be the justifier
   */
  resolutionComment?: Maybe<Scalars["String"]>;
  /** The time that the action was resolved at. */
  resolvedAt?: Maybe<Scalars["Time"]>;
  /** The user who resolved the request action (and the reason they were able to resolve it) */
  resolvedBy?: Maybe<RequestActionOwner>;
  /** The current status of the request action e.g. whether it has been performed */
  status?: Maybe<RequestActionStatus>;
  /** The type of action to be performed */
  type?: Maybe<RequestActionType>;
  /** The time that the request action was updated at */
  updatedAt?: Maybe<Scalars["Time"]>;
}

/** Contains the owner of a request action and the user who resolved it. */
export interface RequestActionAckedBy {
  /** The user who resolved the request action */
  employee?: Maybe<Employee>;
  /** The owner of the request action */
  owner?: Maybe<RequestActionOwner>;
}

export interface RequestActionAuthRoleOwner extends RequestActionOwner {
  /** The role required to approve this action. */
  authRole?: Maybe<AuthRole>;
  /** An employee who has (or had, if the Request is resolved) the role required to approve this action, and is therefore requested to take action. */
  employee?: Maybe<Employee>;
  /** Deprecated. Use Employee instead */
  user?: Maybe<User>;
}

export interface RequestActionBudgetOwner extends RequestActionOwner {
  /** An employee who is (or was, if the Request is resolved) an owner of the budget associated with this request, and is therefore requested to take action. */
  employee?: Maybe<Employee>;
  /**
   * A user who is (or was, if the Request is resolved) an owner of the budget associated with this request, and is therefore requested to take action.
   * @deprecated Incorrect permission scoping, use employee instead
   */
  user?: Maybe<User>;
}

export interface RequestActionCapabilityOwner extends RequestActionOwner {
  /** The capability key required to approve this action. */
  capabilityKey?: Maybe<AuthCapabilityKey>;
  /** An employee who has (or had, if the Request is resolved) the role required to approve this action, and is therefore requested to take action. */
  employee?: Maybe<Employee>;
  /** Deprecated. Use Employee instead */
  user?: Maybe<User>;
}

/** A request action connection for the request action pagination. */
export interface RequestActionConnection extends Connection {
  /** The request actions in the current page of results. */
  edges: Array<RequestActionEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /**
   * The total count of request actions matching the filter criteria specified for this connection.
   * @deprecated Calculating totalCount is expensive and often leads to timeouts.
   */
  totalCount?: Maybe<Scalars["Int"]>;
}

/** A RequestAction edge for the RequestAction pagination. */
export interface RequestActionEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The request action at this edge. */
  node?: Maybe<RequestAction>;
}

export interface RequestActionExpenseRoleOwner extends RequestActionOwner {
  /** An employee who has (or had, if the Request is resolved) the role required to approve this action, and is therefore requested to take action. */
  employee?: Maybe<Employee>;
  /**
   * A user who has (or had, if the Request is resolved) the role required to approve this action, and is therefore requested to take action.
   * @deprecated Incorrect permission scoping, use employee instead
   */
  user?: Maybe<User>;
}

/** Filters available to control which request actions get returned. */
export interface RequestActionFilterInput {
  /** Match IN specific action types. Match ALL when no filter is provided. */
  actionType?: InputMaybe<Array<RequestActionType>>;
  /** Match IN specific statues, match ALL when no filter is provided */
  status?: InputMaybe<Array<RequestActionStatus>>;
}

export interface RequestActionInput {
  /**
   * Default is false. This argument is only used in the V2 update endpoints.
   * If false, actions temporarily transition to a TENTATIVE status for a short period of time where the status transition can be undone before transitioning to the terminal status.
   * Only used when setting action status to COMPLETED or REJECTED. Other statuses will transition to the terminal state immediately.
   */
  skipTentativeStatus?: InputMaybe<Scalars["Boolean"]>;
  /**
   * The status of the request action.
   * Note: Only REVIEW request actions can be COMPLETED or REJECTED.
   * Note: Any request action can be DISMISSED.
   */
  status?: InputMaybe<RequestActionStatusInput>;
}

export interface RequestActionManagerDifference extends RequestActionOwner {
  /**
   * A employee who is (or was, if the Request is resolved) 'levelDifference' levels up the manager hierarchy from the
   * requester, and is therefore requested to take action.
   */
  employee?: Maybe<Employee>;
  /**
   * The action/review was requested from the manager N-levels up the manager chain.
   *
   * For example, N=1 = the requester's manager. N=2 = the requester's manager's manager.
   */
  levelDifference: Scalars["Int"];
  /**
   * A user who is (or was, if the Request is resolved) 'levelDifference' levels up the manager hierarchy from the
   * requester, and is therefore requested to take action.
   * @deprecated Incorrect permission scoping, use employee instead
   */
  user?: Maybe<User>;
}

/** Determines the order that the requests will be returned. */
export interface RequestActionOrderInput {
  field: SortableRequestActionField;
  order: OrderByDirection;
}

export interface RequestActionOwner {
  /** A employee who is requested to perform this action */
  employee?: Maybe<Employee>;
  /**
   * A user who is requested to perform this action
   * @deprecated Incorrect permission scoping, use employee instead
   */
  user?: Maybe<User>;
}

export interface RequestActionSpecificOwner extends RequestActionOwner {
  /**
   * The policy specified that this exact employee is requested to take action.
   * Often this will be the requester, e.g. for requests to upload Memos/Receipts
   */
  employee?: Maybe<Employee>;
  /**
   * The policy specified that this exact user is requested to take action.
   * Often this will be the requester, e.g. for requests to upload Memos/Receipts
   * @deprecated Incorrect permission scoping, use employee instead
   */
  user?: Maybe<User>;
}

/** The current status of the request action. */
export enum RequestActionStatus {
  /** An action which is not ready to be taken because its dependencies are unresolved */
  BLOCKED = "BLOCKED",
  /** The action's request was canceled */
  CANCELED = "CANCELED",
  /** The desired action was taken by the owner */
  COMPLETED = "COMPLETED",
  /** The action was marked as not needed */
  DISMISSED = "DISMISSED",
  /** An action which is ready to be taken (no dependencies, or all dependencies are resolved) */
  PENDING = "PENDING",
  /**
   * The owner explicitly refuses to take an action, e.g. approving an expense.
   * Not all Request Actions can be REJECTED.
   */
  REJECTED = "REJECTED",
  /** The desired action was tentatively taken by the owner */
  TENTATIVELY_COMPLETED = "TENTATIVELY_COMPLETED",
  /**
   * The owner explicitly and tentatively refuses to take an action, e.g. approving an expense.
   * Not all Request Actions can be TENTATIVELY_REJECTED.
   */
  TENTATIVELY_REJECTED = "TENTATIVELY_REJECTED",
}

export enum RequestActionStatusInput {
  /** Approve a request action, approving the request if this was the last action */
  COMPLETED = "COMPLETED",
  /** The action was marked as not needed */
  DISMISSED = "DISMISSED",
  /** Reject a request action, therefore rejecting the whole request */
  REJECTED = "REJECTED",
}

export interface RequestActionTitleOwner extends RequestActionOwner {
  /** A employee who holds (or held, if the Request is resolved) the the title specified by the policy to take action. */
  employee?: Maybe<Employee>;
  /**
   * A user who holds (or held, if the Request is resolved) the the title specified by the policy to take action.
   * @deprecated Incorrect permission scoping, use employee instead
   */
  user?: Maybe<User>;
}

/** The type of the request action. */
export enum RequestActionType {
  /** A listing of attendees is requested. */
  ATTENDEES = "ATTENDEES",
  /** An auto-memo will be generated. */
  AUTO_MEMO = "AUTO_MEMO",
  /** A response is required in a Comment Thread in which the user was tagged. */
  COMMENT_RESPONSE = "COMMENT_RESPONSE",
  /** An extended field is required. */
  EXTENDED_FIELD = "EXTENDED_FIELD",
  /**
   * An approval (for a Booking) is required within some time limit. Past the deadline, it will be
   * **automatically canceled**.
   */
  HARD_APPROVAL = "HARD_APPROVAL",
  /** An invoice is required. */
  INVOICE = "INVOICE",
  /** A memo is requested. */
  MEMO = "MEMO",
  /** A receipt is requested. */
  RECEIPT = "RECEIPT",
  /** Receipts must be line item categorized if the Policy has line item categorization rules. */
  RECEIPT_CATEGORIZATION = "RECEIPT_CATEGORIZATION",
  /** Receipts must go through a validation process. */
  RECEIPT_VALIDATION = "RECEIPT_VALIDATION",
  /** A manager (or other) review is requested. */
  REVIEW = "REVIEW",
  /** A request to review the auto-assigned spend limit of an expense */
  REVIEW_AUTO_ASSIGNED_SPEND_LIMIT = "REVIEW_AUTO_ASSIGNED_SPEND_LIMIT",
  /**
   * An approval (for a Booking) is required within some time limit. Past the deadline, it will be
   * **automatically approved**.
   */
  SOFT_APPROVAL = "SOFT_APPROVAL",
}

export enum RequestActionUserRelation {
  /**
   * No specific relation to the request action
   * Keep in mind that this should not be used for authorization
   * checks given that admins could see request actions that don't
   * belong to them
   */
  NONE = "NONE",
  /** Is the owner of the request action */
  OWNER = "OWNER",
}

export interface RequestActionUserRoleOwner extends RequestActionOwner {
  /** An employee who has (or had, if the Request is resolved) the role required to approve this action, and is therefore requested to take action. */
  employee?: Maybe<Employee>;
  /**
   * A user who has (or had, if the Request is resolved) the role required to approve this action, and is therefore requested to take action.
   * @deprecated Incorrect permission scoping, use employee instead
   */
  user?: Maybe<User>;
  userRole?: Maybe<RequiredUserRole>;
}

export interface RequestBoolValueInput {
  value?: InputMaybe<Scalars["Boolean"]>;
}

/** A request connection for the request pagination. */
export interface RequestConnection extends Connection {
  /** The requests in the current page of results. */
  edges: Array<RequestEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of requests matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface RequestDeadlineSettings {
  /** Whether cc'ing managers is enabled or disabled. */
  ccManagersEnabled?: Maybe<Scalars["Boolean"]>;
  /** Whether this setting is enabled or disabled. */
  enabled?: Maybe<Scalars["Boolean"]>;
  /** The number of grace period days to use. */
  gracePeriodDays?: Maybe<Scalars["Int"]>;
  /** ID of this setting. */
  id: Scalars["ID"];
  /** Whether reminders are enabled or disabled. */
  remindersEnabled?: Maybe<Scalars["Boolean"]>;
}

export enum RequestDeadlineSettingsType {
  /** Reviewer compliance setting type, this type of deadline applies to required review of a request such manager/admin review */
  REVIEWER_COMPLIANCE = "REVIEWER_COMPLIANCE",
  /** Submitter compliance setting type, this type of deadline applies to missing info from expense owner such as missing receipt and memo */
  SUBMITTER_COMPLIANCE = "SUBMITTER_COMPLIANCE",
}

/** A Request edge for Request pagination. */
export interface RequestEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The request at this edge. */
  node?: Maybe<Request>;
}

export interface RequestFSPConnectionInput {
  fspCustomerAccountId: Scalars["String"];
}

export interface RequestFSPConnectionResult {
  message?: Maybe<Scalars["String"]>;
}

export interface RequestFieldValueOneOfInput {
  boolValueInput?: InputMaybe<RequestBoolValueInput>;
  identifierToStringValueInput?: InputMaybe<RequestIdentifierToStringValueInput>;
  numberValueInput?: InputMaybe<RequestNumberValueInput>;
  stringValueInput?: InputMaybe<RequestStringValueInput>;
}

/** Filters available to control which requests get returned in a connection. */
export interface RequestFilterInput {
  /** Select requests by one or more types */
  requestTypes?: InputMaybe<Array<RequestType>>;
  /** Match IN specific statuses, match ALL when no filter it provided */
  status?: InputMaybe<Array<RequestStatus>>;
}

export interface RequestGroupEventBudgetInput {
  budgetTemplateId?: InputMaybe<Scalars["ID"]>;
  clientMutationId: Scalars["String"];
  description?: InputMaybe<Scalars["String"]>;
  id: Scalars["ID"];
  limit: FinancialAssetInput;
  ownerUserIds?: InputMaybe<Array<Scalars["ID"]>>;
}

export interface RequestGroupEventBudgetResult {
  error?: Maybe<Scalars["String"]>;
  groupEvent?: Maybe<GroupEvent>;
}

export interface RequestIdentifierToStringValueInput {
  displayName?: InputMaybe<Scalars["String"]>;
  identifier?: InputMaybe<Scalars["String"]>;
}

export interface RequestInput {
  /** The status of the request. */
  status?: InputMaybe<RequestStatus>;
}

export interface RequestMutationError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface RequestNumberValueInput {
  value?: InputMaybe<Scalars["Decimal"]>;
}

/**
 * Object holding metadata. Aligns with Requests definition of PolicyAction.
 *
 * We are only concerned with action metadata for our use case, not reasons
 */
export interface RequestPolicyAction {
  actionMetadata?: Maybe<PolicyActionMetadataOneOf>;
}

export interface RequestRepaymentInformation {
  /** Optional explanation for requesting repayment */
  reason?: Maybe<Scalars["String"]>;
}

/** The status of a Request. */
export enum RequestStatus {
  /**
   * When all request actions associated with this request are approved/dismissed,
   * or an admin directly overrode the request with an approval
   */
  APPROVED = "APPROVED",
  /**
   * When a request was canceled by the requester
   *
   * TODO: do we need to differentiate between 'user'-canceled vs 'system'-canceled? (e.g. VOID)
   */
  CANCELED = "CANCELED",
  /** Requests are created as pending */
  PENDING = "PENDING",
  /** When one of the actions was rejected */
  REJECTED = "REJECTED",
}

export enum RequestStatusInput {
  /** Force a request to be approved, even if its actions have not been completed */
  APPROVED = "APPROVED",
  /** Cancel a request which is no longer needed */
  CANCELED = "CANCELED",
  /** Completely reject a request, even if it didn't ask for your approval */
  REJECTED = "REJECTED",
}

export interface RequestStringValueInput {
  value?: InputMaybe<Scalars["String"]>;
}

/** A computed field summarizing the request and actions associated with the Request */
export interface RequestSummary {
  /**
   * Indicates whether the current user has approved any review actions assigned to them. If the user has no
   * review actions, this is false.
   */
  approvedByCurrentUser: Scalars["Boolean"];
  /** The current pending review action, as determined by execution order. Null if there are no pending review actions. */
  currentPendingReviewAction?: Maybe<RequestAction>;
  /** If the current user is in the approval chain, the review action belonging to the user. Otherwise, it will be null. */
  currentUserReviewAction?: Maybe<RequestAction>;
  /** Unique identifier for the request summary, composed of requestId and userId to ensure uniqueness per user context */
  id: Scalars["ID"];
  /** The last review request action, as determined by execution order. Null if there are no review actions. */
  lastReviewRequestAction?: Maybe<RequestAction>;
  /**
   * Returns the next singular reviewer in the review chain. The current user is prioritized first, if the current user is on the review chain.
   * If the current is not on the review chain, this will be a stable random user on the review chain - it will be the same for the same
   * request but differ for different requests.
   *
   * In the case of exactly 2 reviewers, this will contain all the reviewers in the list.
   *
   * This is empty if there is no reviewer.
   */
  nextReviewApprovers?: Maybe<Array<Employee>>;
  /**
   * The number of next possible approvers for the current pending review. Includes the current user, if applicable.
   *
   * This is null if there is no reviewer.
   */
  numberOfNextApprovers?: Maybe<Scalars["Int"]>;
  /** All the pending and blocked request actions associated with this request. */
  pendingRequestActionTypes?: Maybe<Array<RequestActionType>>;
  /**
   * Indicates whether there are any pending or blocked review actions from the current user. If the user
   * has no review actions, this is false.
   */
  pendingReviewByCurrentUser: Scalars["Boolean"];
  /**
   * Indicates whether there are any pending (and not blocked) review actions from the expense owner. If the expense owner
   * does not have a pending review action, this is false.
   * We leverage request owner to resolve this field, which is equivalent to expense owner.
   */
  pendingReviewByExpenseOwner?: Maybe<Scalars["Boolean"]>;
  /**
   * The time when the first pending review action was assigned to the current user.
   * Null if there are no pending review actions assigned to the current user.
   */
  timeReviewAssignedToMe?: Maybe<Scalars["Time"]>;
  /** The total number of review actions associated with the request. */
  totalNumberOfReviewActions?: Maybe<Scalars["Int"]>;
}

/** The type of the Request. */
export enum RequestType {
  /** This is a banking transaction request. */
  BANKING_TRANSACTION = "BANKING_TRANSACTION",
  /** This is a budget request. */
  BUDGET = "BUDGET",
  /** This is a budget limit increase request. */
  BUDGET_LIMIT_INCREASE = "BUDGET_LIMIT_INCREASE",
  /** This is a comment request. */
  COMMENT = "COMMENT",
  /** This is an expense request. */
  EXPENSE = "EXPENSE",
  /** This is a spend limit approval request. */
  SPEND_LIMIT_APPROVAL_REQUEST = "SPEND_LIMIT_APPROVAL_REQUEST",
}

/** The types of relationships for filtering who requested a request. */
export enum RequestedByFilterInput {
  /** Created by anyone in the user's company */
  COMPANY = "COMPANY",
  /** Created by the logged in user */
  ME = "ME",
  /** Created by anyone in the user's team */
  TEAM = "TEAM",
}

/** An action that means a list of attendees must be added to the expense. */
export interface RequireAttendeesPolicyAction {
  /** Whether or not the user should be required to input a company name for external attendees. */
  requireCompanyName: Scalars["Boolean"];
  /** Whether or not the user should be required to specify whether or not external attendees are government officials */
  requireIsGovernmentOfficial: Scalars["Boolean"];
  /** Whether or not the user should be required to input a job title for external attendees. */
  requireTitle: Scalars["Boolean"];
}

/** An action that means a given extended field must be added to the expense. */
export interface RequireExtendedFieldPolicyAction {
  /** The extended field that is being required */
  extendedField?: Maybe<ExtendedField>;
}

export interface RequiredItem {
  createdAt: Scalars["String"];
  customRejectionMessage?: Maybe<Scalars["String"]>;
  documentType: FinancialDocumentType;
  id: Scalars["ID"];
  itemMetadata?: Maybe<RequiredItemMetadata>;
  period: FinancialPeriod;
  rejectionReason?: Maybe<FinancialStatementRejectionReason>;
  requiredItemMappingId?: Maybe<Scalars["ID"]>;
  status: RequiredItemStatus;
  updatedAt: Scalars["String"];
  year: Scalars["Int"];
}

export type RequiredItemMetadata = BankStatementRequiredItemMetadata;

export enum RequiredItemStatus {
  ACCEPTED = "ACCEPTED",
  CANCELED = "CANCELED",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  INCLUDED = "INCLUDED",
  NOT_SUBMITTED = "NOT_SUBMITTED",
  PENDING = "PENDING",
  PROCESSED = "PROCESSED",
  REJECTED = "REJECTED",
  SKIPPED = "SKIPPED",
  UNSET = "UNSET",
}

/** Segment of an account specification for Oracle Fusion (output) */
export interface RequiredSegment {
  /** ID of the external entity (value) */
  externalEntity?: Maybe<ExternalIntegrationEntity>;
  /** ID of the external field (key) */
  externalField?: Maybe<ExternalIntegrationField>;
}

/** Segment of an account specification for Oracle Fusion (input) */
export interface RequiredSegmentInput {
  /** ID of the external entity (value) */
  externalEntityId?: InputMaybe<Scalars["ID"]>;
  /** ID of the external field (key) */
  externalFieldId?: InputMaybe<Scalars["ID"]>;
}

export enum RequiredUserRole {
  ACCOUNT_ADMIN = "ACCOUNT_ADMIN",
  BILL_APPROVAL_ACCESS = "BILL_APPROVAL_ACCESS",
  BOOKKEEPER = "BOOKKEEPER",
  BREX_OPS = "BREX_OPS",
  CARD_ADMIN = "CARD_ADMIN",
  INVALID = "INVALID",
  USER_MANAGEMENT_ADMIN = "USER_MANAGEMENT_ADMIN",
}

export interface RequiredVerification {
  requireForCustomerInput: Scalars["Boolean"];
  verificationType: RailAccountDetailsVerificationType;
}

export interface Requirement {
  /** Name of verification requirement. */
  name?: Maybe<Scalars["String"]>;
}

export interface RequirementIdentifier {
  /** Name of verification requirement. */
  name?: InputMaybe<Scalars["String"]>;
}

/** The information to satisfy the associated verification that needs to be collected. */
export interface RequirementInformation {
  /** Individual fields for each required information */
  fields: Array<RequirementInformationField>;
  /** Name of this requirement */
  name: Scalars["String"];
}

/** The set of types of information that may need to be collected. */
export type RequirementInformationField =
  | AddressInformation
  | DateInformation
  | ImageInformation
  | PersonaInformation
  | SelectInformation
  | TextInformation;

export enum RequirementInformationFieldDisplayType {
  /** Structured address display type */
  ADDRESS = "ADDRESS",
  /** Date / calendar display type */
  DATE = "DATE",
  /** Generic image upload display type */
  IMAGE = "IMAGE",
  /** Persona display type */
  PERSONA = "PERSONA",
  /** Single select display type */
  SELECT = "SELECT",
  /** Text display type */
  TEXT = "TEXT",
}

export interface RequirementInformationFieldValue {
  /** The brief description for what the associated value stands for */
  name: Scalars["String"];
  /** The actual value represents one of the options for a field */
  value: Scalars["String"];
}

export enum RequirementType {
  /** Field is required by the ERP system for export */
  ERP = "ERP",
  /** Field is required by the user for export */
  USER = "USER",
}

export enum Requirements {
  BUSINESS_JUSTIFICATION = "BUSINESS_JUSTIFICATION",
  ITEM_DESCRIPTION = "ITEM_DESCRIPTION",
}

export interface RescindDrawdownAuthorizationInput {
  clientMutationId: Scalars["String"];
  /** id of drawdown authorization */
  drawdownAuthorizationId: Scalars["ID"];
}

export interface RescindDrawdownAuthorizationPayload {
  clientMutationId: Scalars["String"];
}

export interface ResendEmployeeUberBusinessInviteResponse {
  success: Scalars["Boolean"];
}

export interface ResendGiftCardInput {
  email: Scalars["String"];
  referenceOrderId: Scalars["String"];
}

export interface ResendGiftCardResult {
  email: Scalars["String"];
}

export interface ResendWelcomeEmailInput {
  clientMutationId: Scalars["String"];
  /** Url for the button in the email */
  redirectUrl: Scalars["String"];
  /** Unique token for the email (won't send duplicates) */
  uniqueToken: Scalars["String"];
}

export interface ResendWelcomeEmailPayload {
  clientMutationId: Scalars["String"];
}

export interface ResetBackupCodesInput {
  clientMutationId: Scalars["String"];
}

export interface ResetBackupCodesPayload {
  clientMutationId: Scalars["String"];
  codes: Array<Maybe<Scalars["String"]>>;
}

export interface ResetUserInput {
  clientMutationId: Scalars["String"];
  token: Scalars["String"];
  user: ResetUserUserInput;
}

export interface ResetUserPayload {
  clientMutationId: Scalars["String"];
  user?: Maybe<User>;
}

export interface ResetUserUserInput {
  password: Scalars["String"];
}

export interface ResolveCommentRequestInput {
  /**
   * ID of the CommentThread to resolve associated Requests for. If given, all Requests assigned to the user in the
   * CommentThread will be resolved.
   */
  commentThreadId?: InputMaybe<Scalars["ID"]>;
  /** ID of the Request being resolved. If given, only the Request with the given ID will be resolved. */
  requestId?: InputMaybe<Scalars["ID"]>;
}

export interface ResolveCommentRequestResult {
  /** The updated RequestActions */
  requestActions?: Maybe<Array<RequestAction>>;
  /** Boolean indicating success of the operation. */
  success: Scalars["Boolean"];
}

export interface ResolveLimitEscalationWithFinancialSourceInput {
  clientMutationId: Scalars["String"];
  escalationId: Scalars["String"];
  financialSourceId: Scalars["String"];
}

export interface ResolveLimitEscalationWithFinancialSourceResponse {
  success: Scalars["Boolean"];
}

export interface ResolveLimitEscalationWithFinancialSourceResult
  extends MutationResult {
  errors?: Maybe<Array<LimitsExperienceMutationError>>;
  result?: Maybe<ResolveLimitEscalationWithFinancialSourceResponse>;
}

export interface Resource {
  resourceId: Scalars["ID"];
  type: ResourceType;
}

/** ResourceOperations */
export enum ResourceAction {
  CREATE = "CREATE",
  DELETE = "DELETE",
  LIST = "LIST",
  MANAGE = "MANAGE",
  READ = "READ",
  UPDATE = "UPDATE",
}

export interface ResourceInput {
  resourceId: Scalars["ID"];
  type: ResourceType;
}

export interface ResourceOperation {
  action: ResourceAction;
}

export enum ResourceType {
  BUDGET_PROGRAM = "BUDGET_PROGRAM",
  ROLE_MEMBER = "ROLE_MEMBER",
}

export interface Restrictions {
  /** Indicates if the country is enabled for card collections in local currency */
  isEnabledForLocalCardCollections: Scalars["Boolean"];
  /** Indicates if the country is enabled for reimbursements collections in local currency */
  isEnabledForLocalReimbursementsCollections: Scalars["Boolean"];
  /** Indicates if the country is enabled for reimbursements purposes */
  isEnabledForReimbursements: Scalars["Boolean"];
  /** Indicates if the country is sanctioned for card shipping purposes */
  isSanctionedForCardShipping: Scalars["Boolean"];
}

/** The type of results for receipt validation. */
export enum ResultType {
  INVALID = "INVALID",
  SKIPPED = "SKIPPED",
  VERIFIED = "VERIFIED",
}

export interface ResyncBillsInput {
  billIds: Array<InputMaybe<Scalars["ID"]>>;
  clientMutationId: Scalars["String"];
  integrationId: Scalars["ID"];
  /** Will fetch a new sync token from QBO before attempting bills data sync. This overwrites any data on the QBO side with Brex data */
  overwrite?: InputMaybe<Scalars["Boolean"]>;
}

export interface ResyncBillsPayload {
  clientMutationId: Scalars["String"];
}

export interface ResyncReimbursementItemsInput {
  clientMutationId: Scalars["String"];
  idempotencyKey: Scalars["String"];
  integrationId: Scalars["ID"];
  reimbursementItemIds: Array<InputMaybe<Scalars["ID"]>>;
}

export interface ResyncReimbursementItemsPayload {
  clientMutationId: Scalars["String"];
}

export interface RetryClawbackPaymentInput {
  /** The clawback expense ID to retry payment. */
  clawbackExpensesExpenseId: Scalars["ID"];
  /** clientMutationId */
  clientMutationId: Scalars["String"];
}

export interface RetryClawbackPaymentResult {
  /** The clawback that submitted payment retry. */
  clawback: Clawback;
}

export interface RetryFailedBillBatchInput {
  /** The ID of the bill batch to retry */
  billBatchId: Scalars["ID"];
  /** Client mutation ID for tracking */
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** Optional new payment date */
  paymentDate?: InputMaybe<Scalars["Time"]>;
  /** Optional new payment source account */
  sourceAccount?: InputMaybe<SourceAccountInput>;
}

export interface RetryFailedBillBatchResult {
  /** List of errors if retry failed */
  errors?: Maybe<Array<BillBatchMutationError>>;
  /** Result of the retry operation, either the updated bill batch or an error */
  result?: Maybe<BillBatch>;
}

/** Input for creating a penny pull retry */
export interface RetryPennyPullInput {
  /** The ID of the funding source to retry the penny pull for */
  fundingSourceId: Scalars["ID"];
  /** The ID of the legal entity for which the funding source is the primary funding source */
  legalEntityId: Scalars["ID"];
}

export interface RetryReimbursementPaymentInput {
  /** clientMutationId */
  clientMutationId: Scalars["String"];
  /** The reimbursement expense ID to retry payment. */
  expenseId: Scalars["ID"];
}

export interface RetryReimbursementPaymentResult {
  /** The expense that was retried. */
  expense: Expense;
}

export interface RetryVerificationError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface RetryVerificationInput {
  idempotencyKey: Scalars["String"];
  metadata: RailAccountDetailsVerificationMetadataInput;
  railAccountDetailsId: Scalars["ID"];
  type: RailAccountDetailsVerificationType;
}

export interface RetryVerificationResult extends MutationResult {
  errors?: Maybe<Array<RetryVerificationError>>;
  result?: Maybe<RailAccountDetailsVerification>;
}

export interface ReturnDetails {
  amountDrift?: Maybe<FinancialAsset>;
  returnReason?: Maybe<Scalars["String"]>;
}

export enum ReturnMode {
  RETURN_MODE_IN_PERSON = "RETURN_MODE_IN_PERSON",
  RETURN_MODE_OTHER = "RETURN_MODE_OTHER",
  RETURN_MODE_SHIPPING = "RETURN_MODE_SHIPPING",
}

export enum ReturnReason {
  ACCOUNT_NOT_FOUND = "ACCOUNT_NOT_FOUND",
  AUTOMATICALLY_RETURNED_LENDING_CLUB = "AUTOMATICALLY_RETURNED_LENDING_CLUB",
  CORPORATE_CUSTOMER_ADVISES_NOT_AUTHORIZED = "CORPORATE_CUSTOMER_ADVISES_NOT_AUTHORIZED",
  CREDIT_ENTRY_REFUSED_BY_RECEIVER = "CREDIT_ENTRY_REFUSED_BY_RECEIVER",
  INCORRECTLY_CODED_OUTBOUND_INTERNATIONAL_PAYMENT = "INCORRECTLY_CODED_OUTBOUND_INTERNATIONAL_PAYMENT",
  INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
  UNKNOWN = "UNKNOWN",
}

export interface ReturnedProductInput {
  attemptedResolutionDate: Scalars["Date"];
  contact?: InputMaybe<Scalars["String"]>;
  contactMode?: InputMaybe<ContactMode>;
  description: Scalars["String"];
  returnDate: Scalars["Date"];
  returnMode: ReturnMode;
  returnProof: Scalars["String"];
}

export interface RevertCancelledBillInput {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
}

export interface RevertCancelledBillPayload {
  bill?: Maybe<Bill>;
  clientMutationId: Scalars["String"];
}

export interface RevertCancelledBillV2Input {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
}

export interface RevertExportEntriesError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface RevertExportEntriesInput {
  /** The ids of the export jobs to revert. */
  exportJobIds: Array<Scalars["ID"]>;
}

export interface RevertExportEntriesResult extends MutationResult {
  /** No errors if the revert was successful. */
  errors?: Maybe<Array<RevertExportEntriesError>>;
}

export interface RevertMarkedPaidBillInput {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
}

export interface RevertPaidBillInput {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
}

export interface RevertPaidBillPayload {
  bill: Bill;
  clientMutationId: Scalars["String"];
}

export interface ReviewPolicyInput {
  policyId: Scalars["ID"];
  policyReviewStatus: PolicyReviewStatus;
}

/**
 * RevokeActiveOauthApplication
 * Revokes all grants for a specific Client ID
 */
export interface RevokeActiveOauthApplicationInput {
  clientId?: InputMaybe<Scalars["String"]>;
}

export interface RevokeActiveOauthApplicationResult {
  status?: Maybe<RevokeActiveOauthApplicationStatus>;
}

export enum RevokeActiveOauthApplicationStatus {
  ERROR = "ERROR",
  SUCCESS = "SUCCESS",
}

export interface RevokeDeveloperApiTokenInput {
  clientMutationId: Scalars["String"];
  id: Scalars["String"];
}

export interface RevokeDeveloperApiTokenPayload {
  clientMutationId: Scalars["String"];
  success?: Maybe<Scalars["Boolean"]>;
}

export interface RevokeFSPUsersClientAccessInput {
  clientCustomerAccountId: Scalars["String"];
  fspCustomerAccountId: Scalars["String"];
  fspCustomerUserIds: Array<Scalars["String"]>;
}

export interface RevokeFSPUsersClientAccessResult {
  revokedFspCustomerUserIds?: Maybe<Array<Scalars["String"]>>;
}

export interface RevokeFSPUsersRolesInput {
  clientCustomerAccountId: Scalars["ID"];
  fspCustomerUsers: Array<FSPUser>;
}

export interface RevokeFSPUsersRolesResult {
  fspCustomerUserIds?: Maybe<Array<Scalars["ID"]>>;
}

export interface RevokeLLMOAuthIntegrationError extends StandardClientError {
  code: ErrorCode;
  llmOAuthIntegrationId: Scalars["ID"];
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface RevokeLLMOAuthIntegrationInput {
  llmOAuthIntegrationId: Scalars["ID"];
}

export interface RevokeLLMOAuthIntegrationResult {
  error?: Maybe<RevokeLLMOAuthIntegrationError>;
  result?: Maybe<LLMOAuthIntegration>;
}

export enum RevokeOption {
  INTEGRATIONS = "INTEGRATIONS",
  NOT_REVOCABLE = "NOT_REVOCABLE",
  SPC = "SPC",
}

export interface RevokeRequestActionStatusInput {
  /** clientMutationId */
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** The ID of the request action whose tentative completion or rejection should be revoked. */
  id: Scalars["ID"];
}

export interface RevokeRequestActionStatusResult {
  /** The RequestAction which had its tentative completion or rejection revoked */
  requestAction: RequestAction;
}

/** RevokeSession */
export interface RevokeSessionInput {
  sessionHash?: InputMaybe<Scalars["String"]>;
}

export interface RevokeSessionResult {
  status?: Maybe<RevokeSessionStatus>;
}

export enum RevokeSessionStatus {
  ERROR = "ERROR",
  SUCCESS = "SUCCESS",
}

export interface RevokeUberOrganizationData {
  /** External Uber URL used to revoke an Uber for Business organization. */
  url: Scalars["String"];
}

export interface RevokeUberOrganizationDataInput {
  /**
   * Brex landing page which the Uber website will redirect back to when revocation is complete.
   * The BE will append an org_uuid param to this URL
   */
  redirectUrl: Scalars["String"];
}

export interface RewardCashbackCredit {
  rewardsCashbackId?: Maybe<Scalars["String"]>;
}

export interface RewardRedemptionTransaction {
  pointsCost: Scalars["Int"];
  /** @deprecated Use BillingTransaction.user instead. */
  redeemer: User;
}

export enum RewardType {
  GIFT_CARD = "GIFT_CARD",
  INVALID = "INVALID",
}

export interface RewardsAccrualEntryV2 {
  /** amount of points accrued in centipoints */
  amount: Scalars["Int"];
  id: Scalars["ID"];
  rewardsTrigger?: Maybe<RewardsTriggerV2>;
}

export interface RewardsBalance {
  amount?: Maybe<Scalars["Long"]>;
  walletType?: Maybe<RewardsWalletType>;
}

export interface RewardsCampaignV2 {
  description: Scalars["String"];
  id: Scalars["ID"];
  name: Scalars["String"];
  rewardsTriggersV2: Array<RewardsTriggerV2>;
}

export interface RewardsCampaignV2Connection {
  edges?: Maybe<Array<Maybe<RewardsCampaignV2Edge>>>;
  pageInfo: PageInfo;
}

export interface RewardsCampaignV2Edge {
  cursor: Scalars["String"];
  node?: Maybe<RewardsCampaignV2>;
}

export interface RewardsGiftCardBrand {
  brandKey: Scalars["String"];
  brandName: Scalars["String"];
  description: Scalars["String"];
  disclaimer: Scalars["String"];
  imageUrls: Array<Scalars["String"]>;
  items: Array<RewardsGiftCardItem>;
  shortDescription: Scalars["String"];
  status: Scalars["String"];
  terms: Scalars["String"];
}

export interface RewardsGiftCardCatalog {
  brands?: Maybe<Array<RewardsGiftCardBrand>>;
}

export interface RewardsGiftCardItem {
  countries?: Maybe<Array<Maybe<Scalars["String"]>>>;
  currencyCode: Scalars["String"];
  isWholeAmountValueRequired: Scalars["Boolean"];
  maxValue: Scalars["Float"];
  minValue: Scalars["Float"];
  redemptionInstructions: Scalars["String"];
  rewardName: Scalars["String"];
  rewardType: Scalars["String"];
  status: Scalars["String"];
  utid: Scalars["String"];
  valueType: Scalars["String"];
}

export enum RewardsGiftCardOrderStatus {
  CANCELLED = "CANCELLED",
  COMPLETE = "COMPLETE",
  FAILED = "FAILED",
  PENDING = "PENDING",
}

export interface RewardsGiftCardRedemption {
  centipointsRedeemed: Scalars["Long"];
  customerAccountId: Scalars["String"];
  customerUserId: Scalars["String"];
  giftCardAmountUsdCents: Scalars["Long"];
  id: Scalars["ID"];
  insertedAt: Scalars["Time"];
  recipientEmail?: Maybe<Scalars["String"]>;
  recipientFirstName: Scalars["String"];
  recipientLastName: Scalars["String"];
  recipientMessage?: Maybe<Scalars["String"]>;
  /** order id from tango */
  referenceOrderId: Scalars["String"];
  rewardName?: Maybe<Scalars["String"]>;
  senderEmail?: Maybe<Scalars["String"]>;
  senderFirstName?: Maybe<Scalars["String"]>;
  senderLastName?: Maybe<Scalars["String"]>;
  status: RewardsGiftCardOrderStatus;
  /** reward id from tango */
  utid: Scalars["String"];
}

export interface RewardsGiftCardRedemptionsConnection extends Connection {
  /** A list of edges, each representing a RewardsGiftCardRedemption */
  edges?: Maybe<Array<Maybe<RewardsGiftCardRedemptionsEdge>>>;
  /** Information about pagination in a connection */
  pageInfo: PageInfo;
  /** The total count of gift card redemptions for the customer. */
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface RewardsGiftCardRedemptionsEdge {
  cursor: Scalars["String"];
  node?: Maybe<RewardsGiftCardRedemption>;
}

export interface RewardsGiftCardRedemptionsInput {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
}

export enum RewardsHistoryEntryDescriptionTypeV2 {
  ASCENDA = "ASCENDA",
  BRANDED_SWAG = "BRANDED_SWAG",
  CASH = "CASH",
  CRYPTO = "CRYPTO",
  GIFT_CARD = "GIFT_CARD",
  INCENTIVE_BONUS = "INCENTIVE_BONUS",
  INKLE = "INKLE",
  INSTANT_PAYOUTS_FEE = "INSTANT_PAYOUTS_FEE",
  OPERATIONAL = "OPERATIONAL",
  OTHER = "OTHER",
  PAYROLL_LINK_BONUS = "PAYROLL_LINK_BONUS",
  PRIVATE_DINING_EVENTS = "PRIVATE_DINING_EVENTS",
  SPEND_ACCRUAL = "SPEND_ACCRUAL",
  SPEND_BONUS = "SPEND_BONUS",
  STATEMENT_CREDIT = "STATEMENT_CREDIT",
  TRAVEL = "TRAVEL",
}

export enum RewardsHistoryEntryOrderFieldV2 {
  AMOUNT = "AMOUNT",
  INSERTED_AT = "INSERTED_AT",
}

export enum RewardsHistoryEntryOrderTypeV2 {
  ASC = "ASC",
  DESC = "DESC",
}

export enum RewardsHistoryEntryStateV2 {
  CLEARED = "CLEARED",
  HOLD = "HOLD",
}

export enum RewardsHistoryEntryTypeV2 {
  /** Points accrual */
  ACCRUAL = "ACCRUAL",
  /** Points redemption */
  REDEMPTION = "REDEMPTION",
}

export interface RewardsMilestone {
  iconName: Scalars["String"];
  milestoneTooltip: RewardsTooltip;
  pointsToUnlock: Scalars["Int"];
}

export interface RewardsPointHistoryEntriesInputV2 {
  after?: InputMaybe<Scalars["String"]>;
  descriptionTypes?: InputMaybe<Array<RewardsHistoryEntryDescriptionTypeV2>>;
  endAt?: InputMaybe<Scalars["Time"]>;
  first?: InputMaybe<Scalars["Int"]>;
  ids?: InputMaybe<Array<Scalars["ID"]>>;
  orderField?: InputMaybe<RewardsHistoryEntryOrderFieldV2>;
  orderType?: InputMaybe<RewardsHistoryEntryOrderTypeV2>;
  startAt?: InputMaybe<Scalars["Time"]>;
  type?: InputMaybe<RewardsHistoryEntryTypeV2>;
}

export interface RewardsPointsHistoryEntryV2 {
  additionalData?: Maybe<AdditionalDataV2>;
  amountCentipoints: Scalars["Long"];
  cardFinancialAssetMovement?: Maybe<CardFinancialAssetMovement>;
  descriptionType: RewardsHistoryEntryDescriptionTypeV2;
  id: Scalars["String"];
  insertedAt: Scalars["Time"];
  state: RewardsHistoryEntryStateV2;
  type: RewardsHistoryEntryTypeV2;
  user?: Maybe<User>;
}

/** A connection object for the RewardsPointsHistoryEntryV2 type */
export interface RewardsPointsHistoryEntryV2Connection extends Connection {
  /** A list of edges, each representing a RewardsPointsHistoryEntry */
  edges?: Maybe<Array<Maybe<RewardsPointsHistoryEntryV2Edge>>>;
  /** Information about pagination in a connection */
  pageInfo: PageInfo;
  /** The total count of points history entries matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
  /** The wallet type for this connection (POINTS or CASHBACK) */
  walletType?: Maybe<RewardsWalletType>;
}

/** A connection object for the RewardsPointsHistoryEntryV2 type */
export interface RewardsPointsHistoryEntryV2Edge {
  /** A cursor for use in pagination */
  cursor: Scalars["String"];
  /** The node representing a RewardsPointsHistoryEntry */
  node?: Maybe<RewardsPointsHistoryEntryV2>;
}

export interface RewardsRedeemValueAddedServiceCoachingInputV2 {
  contactBio?: InputMaybe<Scalars["String"]>;
  contactEmail: Scalars["String"];
  contactName: Scalars["String"];
  contactRole: Scalars["String"];
  didAcceptTerms: Scalars["Boolean"];
  focusAreaPreference?: InputMaybe<Scalars["String"]>;
  idempotencyKey: Scalars["String"];
  locationName: Scalars["String"];
  orgSize: Scalars["String"];
  preferredFrequency: Scalars["String"];
  redemptionOfferId: Scalars["ID"];
}

export interface RewardsRedeemValueAddedServiceDoohInputV2 {
  didAcceptTerms: Scalars["Boolean"];
  duration: Scalars["Int"];
  email: Scalars["String"];
  idempotencyKey: Scalars["String"];
  redemptionOfferId: Scalars["ID"];
  startDate: Scalars["String"];
}

export interface RewardsRedeemValueAddedServiceDoohInputV3 {
  /** Additional details for custom offer type */
  customOfferDetails?: InputMaybe<Scalars["String"]>;
  /** Whether user accepted terms and conditions */
  didAcceptTerms: Scalars["Boolean"];
  /** Contact email */
  email: Scalars["String"];
  /** Idempotency key for the request */
  idempotencyKey: Scalars["String"];
  /** Marketing point of contact email */
  marketingPOC?: InputMaybe<Scalars["String"]>;
  /** ID of the redemption offer */
  redemptionOfferId: Scalars["ID"];
  /** Selected offer from the available offers */
  selectedOffers: Array<InputMaybe<Scalars["String"]>>;
}

export interface RewardsRedeemValueAddedServiceMentalHealthInputV2 {
  companyName: Scalars["String"];
  contactEmail: Scalars["String"];
  country: Scalars["String"];
  didAcceptTerms: Scalars["Boolean"];
  dob: Scalars["String"];
  firstName: Scalars["String"];
  idempotencyKey: Scalars["String"];
  lastName: Scalars["String"];
  numEmployees?: InputMaybe<Scalars["String"]>;
  postalCode: Scalars["String"];
  redemptionOfferId: Scalars["ID"];
}

export interface RewardsRedeemValueAddedServiceOffsiteInputV2 {
  companyName: Scalars["String"];
  contactEmail: Scalars["String"];
  contactName: Scalars["String"];
  didAcceptTerms: Scalars["Boolean"];
  idempotencyKey: Scalars["String"];
  numberOfAttendees: Scalars["String"];
  preferredTime: Scalars["String"];
  redemptionOfferId: Scalars["ID"];
}

export interface RewardsRedeemValueAddedServiceResult {
  redemptionInstanceId: Scalars["String"];
}

/** A representation of a rewards redemption */
export interface RewardsRedemption {
  centipointsRedeemed: Scalars["Long"];
  customerAccountId: Scalars["String"];
  customerUserId: Scalars["String"];
  id: Scalars["ID"];
  insertedAt: Scalars["Time"];
  payload: RewardsRedemptionPayload;
  status: Scalars["String"];
  type: Scalars["String"];
}

export interface RewardsRedemptionDetails {
  initiatedByCustomerUser?: Maybe<User>;
  pointsRedeemed: Scalars["Int"];
}

/** Gift card specific redemption payload */
export interface RewardsRedemptionGiftCardPayload {
  giftCardAmountUsdCents: Scalars["Long"];
  recipientEmail: Scalars["String"];
  recipientFirstName: Scalars["String"];
  recipientLastName: Scalars["String"];
  recipientMessage?: Maybe<Scalars["String"]>;
  referenceOrderId?: Maybe<Scalars["String"]>;
  rewardName?: Maybe<Scalars["String"]>;
  senderEmail?: Maybe<Scalars["String"]>;
  senderFirstName?: Maybe<Scalars["String"]>;
  senderLastName?: Maybe<Scalars["String"]>;
  status?: Maybe<RewardsGiftCardOrderStatus>;
  utid: Scalars["String"];
}

export interface RewardsRedemptionInput {
  id: Scalars["ID"];
  status?: InputMaybe<Scalars["String"]>;
  type?: InputMaybe<Scalars["String"]>;
}

export interface RewardsRedemptionOffer extends Node {
  /** The ID of an object */
  id: Scalars["ID"];
}

export type RewardsRedemptionOfferPayloadV2 =
  | AscendaTransferPayloadV2
  | CashBalancePayloadV2
  | DonationPayloadV2
  | GiftCardPayloadV2
  | InstantPayoutsFeePayloadV2
  | IssuerTransactionPayloadV2
  | RefundTransactionPayloadV2
  | StatementCreditPayloadV2
  | ValueAddedServicePayloadV2;

export enum RewardsRedemptionOfferTypeV2 {
  ASCENDA_TRANSFER = "ASCENDA_TRANSFER",
  CASH_BALANCE = "CASH_BALANCE",
  DONATION = "DONATION",
  GIFT_CARD = "GIFT_CARD",
  INSTANT_PAYOUTS_FEE = "INSTANT_PAYOUTS_FEE",
  ISSUER_TRANSACTION = "ISSUER_TRANSACTION",
  REFUND_TRANSACTION = "REFUND_TRANSACTION",
  STATEMENT_CREDIT = "STATEMENT_CREDIT",
  VALUE_ADDED_SERVICE = "VALUE_ADDED_SERVICE",
}

export interface RewardsRedemptionOfferV2 {
  id: Scalars["ID"];
  name: Scalars["String"];
  payload: RewardsRedemptionOfferPayloadV2;
  type: RewardsRedemptionOfferTypeV2;
}

/** Union for different types of redemption payloads */
export type RewardsRedemptionPayload = RewardsRedemptionGiftCardPayload;

export interface RewardsRedemptionProgramV2 {
  description: Scalars["String"];
  id: Scalars["ID"];
  name: Scalars["String"];
  rewardsRedemptionOffersV2?: Maybe<Array<Maybe<RewardsRedemptionOfferV2>>>;
}

/** An edge object for the RewardsRedemptionProgramV2 type */
export interface RewardsRedemptionProgramV2Edge {
  /** A cursor for use in pagination */
  cursor: Scalars["String"];
  /** The node representing a RewardsRedemptionProgram */
  node?: Maybe<RewardsRedemptionProgramV2>;
}

/** A connection object for the RewardsRedemptionProgramV2 type */
export interface RewardsRedemptionProgramsV2Connection {
  /** A list of edges, each representing a RewardsRedemptionProgramsV2 */
  edges?: Maybe<Array<Maybe<RewardsRedemptionProgramV2Edge>>>;
  /** Information about pagination in a connection */
  pageInfo: PageInfo;
}

/** The source of funds was a rewards redemption */
export interface RewardsRedemptionSource {
  /** The maximum amount of rewards redeemed */
  maximumAmount?: Maybe<FinancialAsset>;
  /** The id of the rewards redemption */
  rewardsRedemptionInstanceId: Scalars["String"];
}

export interface RewardsRefund extends Node {
  /** The ID of an object */
  id: Scalars["ID"];
  pointsCost: Scalars["Int"];
}

export enum RewardsStatusV2 {
  CANNOT_REDEEM_DELINQUENT = "CANNOT_REDEEM_DELINQUENT",
  CAN_REDEEM = "CAN_REDEEM",
}

export interface RewardsTooltip {
  descriptions?: Maybe<Array<Scalars["String"]>>;
  thumbnailUrl: Scalars["String"];
  title: Scalars["String"];
  tooltipCta: AdminHomeWidgetCTA;
}

export type RewardsTriggerPayloadV2 =
  | RewardsTriggerPurchaseV2
  | RewardsTriggerTravelPartnerAccrual;

export interface RewardsTriggerPurchaseV2 {
  accrualRate: Scalars["Float"];
  excludedPresentMerchantCategoryIds?: Maybe<Array<Maybe<Scalars["String"]>>>;
  excludedPresentMerchantIds?: Maybe<Array<Maybe<Scalars["String"]>>>;
  includedPresentMerchantCategoryIds?: Maybe<Array<Maybe<Scalars["String"]>>>;
  includedPresentMerchantIds?: Maybe<Array<Maybe<Scalars["String"]>>>;
}

export interface RewardsTriggerTravelPartnerAccrual {
  accrualRate: Scalars["Float"];
  includedPresentMerchantCategoryIds?: Maybe<Array<Maybe<Scalars["String"]>>>;
}

export enum RewardsTriggerTypeV2 {
  PURCHASE = "PURCHASE",
  TRAVEL_PARTNER_ACCRUAL = "TRAVEL_PARTNER_ACCRUAL",
}

export interface RewardsTriggerV2 {
  description: Scalars["String"];
  id: Scalars["ID"];
  name: Scalars["String"];
  payload: RewardsTriggerPayloadV2;
  type: RewardsTriggerTypeV2;
}

export enum RewardsWalletType {
  CASH = "CASH",
  INVALID = "INVALID",
  POINTS = "POINTS",
}

/**
 * Request for information. Is a collection of Rfi Items + broader context for the Request,
 * used to keep track of the exchange of information between requester and responder
 */
export interface Rfi {
  /** Salesforce ID of the related Case */
  arfiCaseId?: Maybe<Scalars["String"]>;
  /** Salesforce Number of the related case */
  arfiCaseNumber?: Maybe<Scalars["String"]>;
  /** Internal ID for the customer's account on another service, e.g. undacc_ for underwriting */
  brexObjectId?: Maybe<Scalars["String"]>;
  /** Unique idenfitifier of this RFI */
  id: Scalars["ID"];
  /** List of requested items */
  items: Array<RfiItem>;
  /** Salesforce ID of the related parent Case */
  parentCaseId?: Maybe<Scalars["String"]>;
  /** Message for the recipient providing context for this RFI */
  requestMessage?: Maybe<Scalars["String"]>;
  /** Markdown message for the recipient providing context for this RFI */
  requestMessageMd?: Maybe<Scalars["String"]>;
  /**
   * Internal Id for the requestor who initiated the RFI
   * Either an internal user (e.g. Ops) or a service
   */
  requestor?: Maybe<Scalars["String"]>;
  /** Current status of this RFI */
  status?: Maybe<RfiStatus>;
  /** Subject Line with information from the workflow */
  subjectLine?: Maybe<Scalars["String"]>;
  /** Workflow that created this RFI */
  workflow?: Maybe<RfiWorkflow>;
}

/** Rfi connection */
export interface RfiConnection extends Connection {
  /** The items in the current page of results. */
  edges: Array<RfiEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of items, across all pages, matching the filter criteria specified for this connection. */
  totalCount: Scalars["Int"];
}

/** RfiConnection edge */
export interface RfiEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The RFI at this edge. */
  node: Rfi;
}

/**
 * Atomic element of a Request for information,
 * defines a type of document / information that is needed
 */
export interface RfiItem {
  /** Key-Value Struct of extra metadata describing the item */
  details?: Maybe<Scalars["String"]>;
  /** Unique identifier of this RFI Item */
  id: Scalars["ID"];
  /** Additional metadata to render the RFI information */
  metadata?: Maybe<Scalars["Json"]>;
  /** Specifies what document / information is being requested */
  name: Scalars["String"];
  /** The response related to this RFI Item */
  response?: Maybe<RfiResponse>;
  /**
   * Response Item providing information for this specific RFI Item
   * @deprecated Consider accessing this information from the response.responseItems field
   */
  responseItem?: Maybe<RfiResponseItem>;
  /**
   * Response Items providing information for this specific RFI Item
   * @deprecated Consider accessing this information from the response.responseItems field
   */
  responseItems?: Maybe<Array<RfiResponseItem>>;
  /** Type of the item. */
  type?: Maybe<RfiItemType>;
}

export interface RfiItemResponseInput {
  customerMessage?: InputMaybe<Scalars["String"]>;
  isOptedOut: Scalars["Boolean"];
  responseItems?: InputMaybe<Array<RfiResponseItemInput>>;
  rfiItemId: Scalars["ID"];
}

/**
 * Possible types of request item
 * This should allow ARFI aplications to use contextual behaviour based on the type of information we request to the customer
 */
export enum RfiItemType {
  DOCUMENT = "DOCUMENT",
  PROOF_OF_FUNDS = "PROOF_OF_FUNDS",
  PROOF_OF_PROFESSIONAL_INVESTMENT = "PROOF_OF_PROFESSIONAL_INVESTMENT",
}

/**
 * The counterpart to a Rfi, providing the Information requested by a specific
 * RfiItem (a document, or a text response). Whether or not the response is
 * valid is something determined by the reviewer (usually the requestor).
 */
export interface RfiResponse {
  /** Whether the customer opted-out of responding this item */
  isOptedOut?: Maybe<Scalars["Boolean"]>;
  /** Freeform text message of this RFI Response */
  message?: Maybe<Scalars["String"]>;
  /** List of RFI Response Itens associated with this RFI Response */
  responseItems?: Maybe<Array<Maybe<RfiResponseItem>>>;
}

/** The counterpart to a RfiItem */
export interface RfiResponseItem {
  /** Token for filestore, referencing the uploaded file */
  documentToken?: Maybe<Scalars["String"]>;
  /** Current status of this RFI Response Item */
  status: RfiResponseStatus;
  /** Details on the current status, e.g. reasons for rejecting a response, filled by ops */
  statusMessage?: Maybe<Scalars["String"]>;
}

export interface RfiResponseItemInput {
  documentToken?: InputMaybe<Scalars["String"]>;
}

/** Describes the current Status of a RFI Response */
export enum RfiResponseStatus {
  /** Message was reviewed and approved by requestor, i.e. it provides the information requested */
  RFI_RESPONSE_STATUS_APPROVED = "RFI_RESPONSE_STATUS_APPROVED",
  /** Message was reviewed and denied by requestor, i.e. it does not provides the information requested, etc. */
  RFI_RESPONSE_STATUS_DENIED = "RFI_RESPONSE_STATUS_DENIED",
  /** Message received, pending review from the requestor (i.e. Ops). */
  RFI_RESPONSE_STATUS_PENDING = "RFI_RESPONSE_STATUS_PENDING",
}

/** Describes the current Status of a RFI */
export enum RfiStatus {
  /** Rfi was automatically closed due to some event, but without action from Ops */
  RFI_STATUS_AUTOMATICALLY_CLOSED = "RFI_STATUS_AUTOMATICALLY_CLOSED",
  /** The Rfi was cancelled by the requestor. */
  RFI_STATUS_CANCELLED = "RFI_STATUS_CANCELLED",
  /** The customer didn't respond the Rfi after all attemps to contact */
  RFI_STATUS_CUSTOMER_UNRESPONSIVE = "RFI_STATUS_CUSTOMER_UNRESPONSIVE",
  /** Unset value for this enumeration */
  RFI_STATUS_INVALID = "RFI_STATUS_INVALID",
  /** RFI entry was recently created and it is still doesn't have a Salesforce case linked to it */
  RFI_STATUS_NEW = "RFI_STATUS_NEW",
  /** A SFDC case was linked to the Rfi and it is now pending a response from the customer. */
  RFI_STATUS_PENDING_CUSTOMER = "RFI_STATUS_PENDING_CUSTOMER",
  /** The RFI is waiting for SendGrid to successfully send the notification */
  RFI_STATUS_PENDING_NOTIFICATION = "RFI_STATUS_PENDING_NOTIFICATION",
  /** The response is pending human review */
  RFI_STATUS_PENDING_REVIEW = "RFI_STATUS_PENDING_REVIEW",
  /** The reponse in its entirety is considered valid, i.e. all requested information items were */
  RFI_STATUS_RESPONSE_ACCEPTED = "RFI_STATUS_RESPONSE_ACCEPTED",
  /** Some of the items in the response are considered valid, while others are invalid, for some reason. */
  RFI_STATUS_RESPONSE_PARTIALLY_ACCEPTED = "RFI_STATUS_RESPONSE_PARTIALLY_ACCEPTED",
  /** The customer submitted a response, but SFDC still hasn't been updated to reflect this. */
  RFI_STATUS_RESPONSE_RECEIVED = "RFI_STATUS_RESPONSE_RECEIVED",
  /** The response provided is invalid, it either doesn't provide the requested information, etc. */
  RFI_STATUS_RESPONSE_REJECTED = "RFI_STATUS_RESPONSE_REJECTED",
}

export interface RfiSubmitForReviewInput {
  clientMutationId: Scalars["String"];
  rfiId: Scalars["ID"];
}

export interface RfiSubmitForReviewResponse {
  rfiId: Scalars["ID"];
}

export enum RfiWorkflow {
  /** Held Wire */
  WORKFLOW_ACCOUNT_PROTECTION = "WORKFLOW_ACCOUNT_PROTECTION",
  /** Cash alerts */
  WORKFLOW_CASH_ALERTS = "WORKFLOW_CASH_ALERTS",
  /** Default to Training. */
  WORKFLOW_DEFAULT = "WORKFLOW_DEFAULT",
  /** Default to Training. */
  WORKFLOW_DEFAULT_NOTIFICATION = "WORKFLOW_DEFAULT_NOTIFICATION",
  /** Default to Training, no response handling. */
  WORKFLOW_DEFAULT_NO_RESPONSE = "WORKFLOW_DEFAULT_NO_RESPONSE",
  /** Disputes. */
  WORKFLOW_DISPUTES = "WORKFLOW_DISPUTES",
  /** Emissary Onboarding */
  WORKFLOW_EMISSARY = "WORKFLOW_EMISSARY",
  /** Held Wire */
  WORKFLOW_HELD_WIRE = "WORKFLOW_HELD_WIRE",
  WORKFLOW_INVALID = "WORKFLOW_INVALID",
  /** KYC_PERIODIC_REVIEW */
  WORKFLOW_RISK_PERIODIC = "WORKFLOW_RISK_PERIODIC",
  /** Servicing */
  WORKFLOW_SERVICING = "WORKFLOW_SERVICING",
  /** UW_FINANCIALS */
  WORKFLOW_UW_FINANCIALS = "WORKFLOW_UW_FINANCIALS",
  /** Underwriting - General use */
  WORKFLOW_UW_GENERAL = "WORKFLOW_UW_GENERAL",
  /** Underwriting - Limit Increase request. */
  WORKFLOW_UW_LIMIT_INCREASE_REQUEST = "WORKFLOW_UW_LIMIT_INCREASE_REQUEST",
  /** Underwriting - Mid-Market, Bulk */
  WORKFLOW_UW_MM = "WORKFLOW_UW_MM",
  /** Underwriting - Non PI Statement Collection Pilot */
  WORKFLOW_UW_NONPI_STATEMENT_COLLECTION = "WORKFLOW_UW_NONPI_STATEMENT_COLLECTION",
  /** Underwriting - Statement Collection In-App, Bulk */
  WORKFLOW_UW_STATEMENT_COLLECTION_IN_APP = "WORKFLOW_UW_STATEMENT_COLLECTION_IN_APP",
  /** Underwriting - Tech, Bulk */
  WORKFLOW_UW_TECH = "WORKFLOW_UW_TECH",
  /** Underwriting - Venture-Backed, Bulk */
  WORKFLOW_UW_VB = "WORKFLOW_UW_VB",
}

export type RightHandSide =
  | RightHandSideMultipleValues
  | RightHandSideSingleValue;

export interface RightHandSideMultipleValues {
  values: Array<RightHandSideSingleValueUnion>;
}

/** Policy Engine currently only supports lists of strings & identifiers */
export interface RightHandSideMultipleValuesOneOfInput {
  identifierValues?: InputMaybe<Array<Scalars["ID"]>>;
  stringValues?: InputMaybe<Array<Scalars["String"]>>;
}

/**
 * Acts as an input union/oneOf depending on which field is not NULL
 * One field is required to be set
 */
export interface RightHandSideOneOfInput {
  multipleValues?: InputMaybe<RightHandSideMultipleValuesOneOfInput>;
  singleValue?: InputMaybe<RightHandSideSingleValueOneOfInput>;
}

export interface RightHandSideSingleValue {
  value: RightHandSideSingleValueUnion;
}

/**
 * Acts as an input union/oneOf depending on which field is not NULL
 * One field is required to be set
 */
export interface RightHandSideSingleValueOneOfInput {
  booleanValue?: InputMaybe<Scalars["Boolean"]>;
  dateValue?: InputMaybe<Scalars["Date"]>;
  decimalValue?: InputMaybe<Scalars["Decimal"]>;
  enumValue?: InputMaybe<EnumValueOneOfInput>;
  financialAssetValue?: InputMaybe<FinancialAssetInput>;
  identifierValue?: InputMaybe<Scalars["ID"]>;
  stringValue?: InputMaybe<Scalars["String"]>;
  timestampValue?: InputMaybe<Scalars["Time"]>;
}

export type RightHandSideSingleValueUnion =
  | BoolValue
  | DateValue
  | DecimalValue
  | EnumValueOneOf
  | FinancialAssetValue
  | IdentifierToStringValue
  | StringValue
  | TimestampValue;

export enum RiskTier {
  /** High risk: limited feature access, potentially offboard */
  HIGH = "HIGH",
  /** Low risk: full feature access */
  LOW = "LOW",
  /** Med risk: limited feature access */
  MEDIUM = "MEDIUM",
  /** Risk evaluation has not yet been performed on this account */
  PENDING = "PENDING",
}

export interface Role extends Node {
  description?: Maybe<Scalars["String"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  name: Scalars["String"];
  rules?: Maybe<Array<Maybe<RoleRule>>>;
}

export interface RoleIdFilterInput {
  ids: Array<Scalars["ID"]>;
  operator: QueryListOperator;
}

export interface RoleRule {
  actions?: Maybe<Array<Maybe<Scalars["String"]>>>;
  predicates?: Maybe<Array<Maybe<RoleRulePredicate>>>;
  resources?: Maybe<Array<Maybe<Scalars["String"]>>>;
}

export interface RoleRulePredicate {
  customerAccountId?: Maybe<Scalars["String"]>;
  customerUserId?: Maybe<Scalars["String"]>;
}

export interface RoleWhereInput {
  /** The role names to filter by. Only 'in' is supported, case-sensitive. */
  name?: InputMaybe<StringFilterInput>;
}

export enum RoomBlockUploadError {
  /** neither the customerUserId or userEmail was provided */
  MISSING_USER_IDENTIFIER = "MISSING_USER_IDENTIFIER",
  /** there is no trip mapping for the attendee. Possibly means the user has not been invited yet */
  NO_TRIP_MAPPING = "NO_TRIP_MAPPING",
  /** user is not an attendee of the group event */
  USER_NOT_ATTENDEE = "USER_NOT_ATTENDEE",
}

export enum RoomBlockUploadStrategy {
  /**
   * Clears existing room blocks and replaces them with the new ones.
   * If a user is NOT in the new block, their booking will be removed.
   */
  REPLACE = "REPLACE",
  /**
   * Adds new room blocks to existing room blocks, overriding when specified.
   * If a user is NOT in the new block, leave their existing booking.
   */
  UPSERT = "UPSERT",
}

export interface Route {
  /** Each stop on the route. */
  places: Array<Place>;
}

export interface RouteInput {
  /** Each stop on the route. */
  places: Array<PlaceInput>;
}

/** Accounting Journal Entry states, used to apply rules under certain conditions */
export enum RuleApplicationConditionAccountingJournalEntryState {
  /** The AJE has status "EXPORTED" */
  EXPORTED = "EXPORTED",
  /** The AJE has status "IN_REVIEW" */
  IN_REVIEW = "IN_REVIEW",
  /** The AJE has not been created */
  NOT_CREATED = "NOT_CREATED",
  /** The AJE has status "READY_FOR_EXPORT" */
  READY_FOR_EXPORT = "READY_FOR_EXPORT",
}

/**
 * Acts as an input union/oneOf depending on which field is not NULL
 * One field is required to be set
 */
export interface RuleApplicationConditionOneOfInput {
  accountingJournalEntryCondition?: InputMaybe<AccountingJournalEntryCondition>;
}

/** A rule evaluation is a evaluation result for an integration field. */
export interface RuleEvaluation extends Node {
  billableStatus?: Maybe<Scalars["Boolean"]>;
  erpSubsidiaryId?: Maybe<Scalars["String"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  integrationField?: Maybe<IntegrationField>;
  integrationRule?: Maybe<IntegrationRule>;
  ruleId?: Maybe<Scalars["String"]>;
  userCategoryId?: Maybe<Scalars["String"]>;
}

/** A rule evaluation is a evaluation result for an integration field. */
export interface RuleEvaluationintegrationRuleArgs {
  integrationId?: InputMaybe<Scalars["ID"]>;
  ruleBodyEnriched?: InputMaybe<Scalars["Boolean"]>;
}

/** Represents the VXW / Workflow Rule evaluation status of the Source Object */
export enum RuleEvaluationStatus {
  /** The Source Object has been evaluated by the VXW / Workflow Rule Engine and all actions applied */
  COMPLETED = "COMPLETED",
  /** The Source Object has not had the most recent rules applied to it yet. There may be pending actions */
  IN_PROGRESS = "IN_PROGRESS",
}

export interface SAMLConfigInput {
  destinationUrl?: InputMaybe<Scalars["String"]>;
  idpSsoUrl: Scalars["String"];
  issuerUri: Scalars["String"];
  signingCertificate: Scalars["String"];
  ssoProviderName?: InputMaybe<SsoProviderName>;
}

export interface SAMLUpdateValuesInput {
  destinationUrl?: InputMaybe<Scalars["String"]>;
  idpSsoUrl?: InputMaybe<Scalars["String"]>;
  issuerUri?: InputMaybe<Scalars["String"]>;
  signingCertificate?: InputMaybe<Scalars["String"]>;
  ssoProviderName?: InputMaybe<SsoProviderName>;
}

export interface SSOSettings {
  /** General IDP details for this SSO configuration. */
  customerIdpDetails?: Maybe<CustomerIdpDetails>;
  /** List of users excluded from SSO. */
  excludedUsers?: Maybe<Array<User>>;
  /** Whether this account is using SAML2 or OIDC */
  idpType: IdpType;
  /** Whether JIT provisioning is enabled for this account. */
  jitEnabled: Scalars["Boolean"];
  /** Whether the settings need to be migrated from Okta */
  needsMigration?: Maybe<Scalars["Boolean"]>;
  /** Brex-configured IDP details for the customer. */
  serviceProviderDetails: ServiceProviderDetails;
  /** Service that provides the integration (e.g.: Okta, Google, etc.) */
  ssoProviderName: SsoProviderName;
  /** The current status of the SSO for this account. */
  ssoStatus: CustomerSsoSettingsSsoStatus;
  /** The current status of the last mutation (mutations are processed async). */
  syncStatus: CustomerSsoSettingsSyncStatus;
  /** Contains the current state of SSO routing for this account. */
  userRules?: Maybe<SsoUserRules>;
}

/** Structured data for SSO user rule changes */
export interface SSOUserRuleChangeContent extends StructuredData {
  /** Type of the new rule (e.g., 'UserIdExactMatch', 'UserCustomerAccountIdMatch', 'DefaultDenyRule') */
  newRuleType?: Maybe<Scalars["String"]>;
  /** List of user IDs in the new rule */
  newUserIdList?: Maybe<Array<Maybe<Scalars["String"]>>>;
  /** Type of the old rule (e.g., 'UserIdExactMatch', 'UserCustomerAccountIdMatch', 'DefaultDenyRule') */
  oldRuleType?: Maybe<Scalars["String"]>;
  /** List of user IDs in the old rule */
  oldUserIdList?: Maybe<Array<Maybe<Scalars["String"]>>>;
  /** Type discriminator value - 'SSOUserRuleChangeContent' */
  type?: Maybe<Scalars["String"]>;
}

export interface SaasBillingPaymentInvoice extends BaseBillingInvoice {
  /** ACH routing number */
  achRoutingNumber?: Maybe<Scalars["String"]>;
  /** Bank account number */
  bankAccountNumber?: Maybe<Scalars["String"]>;
  /** Invoice close time */
  closesAt?: Maybe<Scalars["Time"]>;
  /** Credit memo amount */
  creditMemoAmount?: Maybe<FinancialAsset>;
  /** Invoice due time */
  dueAt: Scalars["Time"];
  /** Invoice Id */
  id: Scalars["ID"];
  /** Netsuite Invoice Id */
  invoiceId: Scalars["String"];
  /** invoice number */
  invoiceNumber: Scalars["String"];
  /** Invoice issued date */
  issuedDate?: Maybe<Scalars["Date"]>;
  /** Invoice line items V2 */
  lineItemsV2?: Maybe<Array<SaasBillingPaymentInvoiceLineItemPair>>;
  /** Invoice payment date */
  paymentDate?: Maybe<Scalars["Date"]>;
  /** Invoice pdf url */
  pdfUrl?: Maybe<Scalars["String"]>;
  /** Enum on whether we auto pull */
  pullPaymentEligibility?: Maybe<SaasBillingPaymentInvoicePullPaymentEligibility>;
  /** Invoice start time */
  startsAt?: Maybe<Scalars["Time"]>;
  /** Payment Status */
  status?: Maybe<SaasBillingPaymentInvoicePaymentStatus>;
  /** Wire transfer swift code */
  swiftCode?: Maybe<Scalars["String"]>;
  /** Tax amount */
  taxAmount?: Maybe<FinancialAsset>;
  /** total debits in the invoice */
  totalDebits: FinancialAsset;
  /** Address for wire transfer */
  wireAddress?: Maybe<Scalars["String"]>;
  /** Wire transfer routing number */
  wireRoutingNumber?: Maybe<Scalars["String"]>;
}

export interface SaasBillingPaymentInvoiceLineItemData {
  /** End date */
  endDate?: Maybe<Scalars["Date"]>;
  /** Quantity */
  quantity?: Maybe<Scalars["Int"]>;
  /** Start date */
  startDate?: Maybe<Scalars["Date"]>;
  /** Unit price */
  unitPrice?: Maybe<FinancialAsset>;
}

export interface SaasBillingPaymentInvoiceLineItemPair {
  /** Line item data */
  items?: Maybe<Array<SaasBillingPaymentInvoiceLineItemData>>;
  /** Line item name */
  key?: Maybe<Scalars["String"]>;
}

export enum SaasBillingPaymentInvoicePaymentStatus {
  CANCELLED = "CANCELLED",
  PAID = "PAID",
  PAYMENT_DUE = "PAYMENT_DUE",
  PAYMENT_IN_PROGRESS = "PAYMENT_IN_PROGRESS",
  REJECTED = "REJECTED",
}

export enum SaasBillingPaymentInvoicePullPaymentEligibility {
  AUTO_PULL_PAYMENT = "AUTO_PULL_PAYMENT",
  MANUAL_PULL_PAYMENT = "MANUAL_PULL_PAYMENT",
  PULL_PAYMENT_BLOCKED = "PULL_PAYMENT_BLOCKED",
}

export interface SageIntacctAuthPayloadInput {
  companyId: Scalars["String"];
  password: Scalars["String"];
  username: Scalars["String"];
}

/** Sage Intacct GL account settings */
export interface SageIntacctCategories {
  /** Default accounts payable GL account */
  accountsPayableUserCategory?: Maybe<UserCategory>;
  /** Default collections GL account */
  collectionTargetUserCategory?: Maybe<UserCategory>;
  /** personal expense user category */
  personalExpenseUserCategory?: Maybe<UserCategory>;
  /** reimbursement accrual basis accounting user category */
  reimbursementClearingUserCategory?: Maybe<UserCategory>;
  /** reimbursements user category */
  reimbursementsUserCategory?: Maybe<UserCategory>;
  /** Default rewards GL account */
  rewardsIncomeUserCategory?: Maybe<UserCategory>;
}

export interface SageIntacctIntegrationExtendedFieldExtension {
  id: Scalars["ID"];
  /**
   * The 'object' field in the Sage Intacct API.
   * See: https://developer.intacct.com/web-services/your-first-api-calls/#get-information-about-objects
   */
  object?: Maybe<Scalars["String"]>;
}

export interface SageIntacctPayload {
  companyId?: Maybe<Scalars["String"]>;
  password?: Maybe<Scalars["String"]>;
  username?: Maybe<Scalars["String"]>;
}

/** Additional data for creating the Sage Intacct integration */
export interface SageintacctInput {
  /** ID of the card for CC exports */
  exportsCardId?: InputMaybe<Scalars["String"]>;
}

export enum SalesSegment {
  EARLY_STAGE_ECOMM = "EARLY_STAGE_ECOMM",
  EARLY_STAGE_TIER_ONE = "EARLY_STAGE_TIER_ONE",
  EARLY_STAGE_TIER_TWO = "EARLY_STAGE_TIER_TWO",
  ECOMM_MID_MARKET = "ECOMM_MID_MARKET",
  ENTERPRISE = "ENTERPRISE",
  GROWTH_TIER_ONE = "GROWTH_TIER_ONE",
  GROWTH_TIER_TWO = "GROWTH_TIER_TWO",
  INVALID = "INVALID",
  LOWER_MID_MARKET = "LOWER_MID_MARKET",
  MID_MARKET = "MID_MARKET",
  PI_MID_MARKET = "PI_MID_MARKET",
  SMALL_BUSINESS = "SMALL_BUSINESS",
  VENTURE_BACKED = "VENTURE_BACKED",
}

export enum SalesVolumeV1 {
  FIFTY_K_TO_ONE_HUNDRED_K = "FIFTY_K_TO_ONE_HUNDRED_K",
  FIVE_HUNDRED_K_TO_ONE_MM = "FIVE_HUNDRED_K_TO_ONE_MM",
  FOUR_HUNDRED_K_TO_ONE_MM = "FOUR_HUNDRED_K_TO_ONE_MM",
  INVALID = "INVALID",
  MORE_THAN_FIVE_MM = "MORE_THAN_FIVE_MM",
  MORE_THAN_TWELVE_MM = "MORE_THAN_TWELVE_MM",
  ONE_HUNDRED_K_TO_TWO_HUNDRED_FIFTY_K = "ONE_HUNDRED_K_TO_TWO_HUNDRED_FIFTY_K",
  ONE_MM_TO_FIVE_MM = "ONE_MM_TO_FIVE_MM",
  ONE_MM_TO_TWELVE_MM = "ONE_MM_TO_TWELVE_MM",
  TWO_HUNDRED_FIFTY_K_TO_FIVE_HUNDRED_K = "TWO_HUNDRED_FIFTY_K_TO_FIVE_HUNDRED_K",
  /**  Legacy values */
  UNDER_FIFTY_K = "UNDER_FIFTY_K",
  UNDER_FOUR_HUNDRED_K = "UNDER_FOUR_HUNDRED_K",
}

export enum SalesVolumeV2 {
  FIFTY_K_TO_ONE_HUNDRED_K = "FIFTY_K_TO_ONE_HUNDRED_K",
  FIVE_HUNDRED_K_TO_ONE_MM = "FIVE_HUNDRED_K_TO_ONE_MM",
  FOUR_HUNDRED_K_TO_ONE_MM = "FOUR_HUNDRED_K_TO_ONE_MM",
  MORE_THAN_FIVE_MM = "MORE_THAN_FIVE_MM",
  MORE_THAN_TWELVE_MM = "MORE_THAN_TWELVE_MM",
  ONE_HUNDRED_K_TO_TWO_HUNDRED_FIFTY_K = "ONE_HUNDRED_K_TO_TWO_HUNDRED_FIFTY_K",
  ONE_MM_TO_FIVE_MM = "ONE_MM_TO_FIVE_MM",
  ONE_MM_TO_TWELVE_MM = "ONE_MM_TO_TWELVE_MM",
  TWO_HUNDRED_FIFTY_K_TO_FIVE_HUNDRED_K = "TWO_HUNDRED_FIFTY_K_TO_FIVE_HUNDRED_K",
  UNDER_FIFTY_K = "UNDER_FIFTY_K",
  UNDER_FOUR_HUNDRED_K = "UNDER_FOUR_HUNDRED_K",
}

export enum SalesVolumeV3 {
  FOUR_HUNDRED_K_TO_ONE_MM = "FOUR_HUNDRED_K_TO_ONE_MM",
  MORE_THAN_TWELVE_MM = "MORE_THAN_TWELVE_MM",
  ONE_MM_TO_TWELVE_MM = "ONE_MM_TO_TWELVE_MM",
  UNDER_FOUR_HUNDRED_K = "UNDER_FOUR_HUNDRED_K",
}

export interface SameDayMicrodepositsTaskEntityDetails
  extends InboxTaskEntityDetails {
  /** Base64 encoded budget request template ID. */
  encodedEntityId: Scalars["String"];
  /** The default entity ID. All tasks must have an entity ID. */
  entityId: Scalars["String"];
  /** Indicates whether the micro-deposit is related to a personal account. */
  isPersonal: Scalars["Boolean"];
}

export interface SamlIdpDetails {
  destinationUrl?: Maybe<Scalars["String"]>;
  idpSsoUrl?: Maybe<Scalars["String"]>;
  issuerUri?: Maybe<Scalars["String"]>;
  signingCertificate?: Maybe<Scalars["String"]>;
  signingCertificateDetails?: Maybe<SamlSigningCertificateDetails>;
}

export interface SamlServiceProvider {
  assertionCustomerServiceUrl: Scalars["String"];
  audienceUri: Scalars["String"];
}

export interface SamlSigningCertificateDetails {
  expiresAt: Scalars["Time"];
  expires_at: Scalars["Time"];
  issuerDetails?: Maybe<Scalars["String"]>;
}

export interface SandboxAccountAction {
  /** The actor which triggered the action */
  actor: SandboxAccountActionActor;
  /** The sandbox account action ID */
  id: Scalars["ID"];
  /** The time when the action was created */
  insertedAt: Scalars["Time"];
  /** The current status of the action */
  status: SandboxAccountActionStatus;
  /** The type of the action */
  type: SandboxAccountActionType;
}

export interface SandboxAccountActionActor {
  /** The actor display name */
  displayName: Scalars["String"];
  /** The actor ID */
  id: Scalars["ID"];
  /** The source of the actor action */
  source: SandboxAccountActionSource;
}

export enum SandboxAccountActionSource {
  BREX = "BREX",
  CUSTOMER = "CUSTOMER",
}

export enum SandboxAccountActionStatus {
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  IN_PROGRESS = "IN_PROGRESS",
  REQUESTED = "REQUESTED",
}

export enum SandboxAccountActionType {
  GENERAL_DATA_IMPORT = "GENERAL_DATA_IMPORT",
  IMPORT_ACCOUNTING_DATA = "IMPORT_ACCOUNTING_DATA",
  PROVISION_ACCOUNT = "PROVISION_ACCOUNT",
}

export interface SaveGlobalSearchToRecentInput {
  /** The searched item */
  searchItem: SearchItemInput;
}

export interface SaveLocalSearchToRecentInput {
  /** The instantiationId to which the recent search belong */
  instantiationId: Scalars["String"];
  /** The searched item */
  searchItem: RecentLocalSearchInput;
}

export interface SaveOnboardingInformationRequestInput {
  clientMutationId: Scalars["String"];
  data?: InputMaybe<Scalars["Json"]>;
  id: Scalars["ID"];
}

export interface SaveOnboardingInformationRequestPayload {
  clientMutationId: Scalars["String"];
  informationRequest: OnboardingInformationRequest;
}

export interface SaveResponseToRfiItemInput {
  clientMutationId: Scalars["String"];
  items?: InputMaybe<Array<RfiItemResponseInput>>;
  responderCustomerUserId: Scalars["String"];
  rfiId: Scalars["ID"];
}

export interface SaveResponseToRfiItemResponse {
  rfi: Rfi;
  success: Scalars["Boolean"];
}

/** Either a Local Search item, or a Global Search item, not both. */
export interface SaveSearchToRecentInput {
  globalSearchItem?: InputMaybe<SaveGlobalSearchToRecentInput>;
  localSearchItem?: InputMaybe<SaveLocalSearchToRecentInput>;
}

export interface SaveVerificationRequestInput {
  payload: Scalars["Json"];
  requestId: Scalars["ID"];
}

export interface SaveVerificationRequestResult {
  success: Scalars["Boolean"];
}

export interface SavedView {
  dataGridSettings?: Maybe<Scalars["Json"]>;
  id?: Maybe<Scalars["ID"]>;
  label?: Maybe<Scalars["String"]>;
  tableIdentifier?: Maybe<SavedViewTableIdentifier>;
}

export interface SavedViewConnection extends Connection {
  edges?: Maybe<Array<SavedViewEdge>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface SavedViewDeleteResult extends MutationResult {
  /**
   * The ID of the deleted saved view.
   * Will be null if the delete operation was not successful, in which case the `errors` field will contain the reason for the failure.
   */
  deletedSavedViewId?: Maybe<Scalars["ID"]>;
  /** No error if the saved view was deleted successfully */
  errors?: Maybe<Array<ReportingClientError>>;
}

export interface SavedViewEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The saved view at this edge. */
  node?: Maybe<SavedView>;
}

export interface SavedViewInput {
  dataGridSettings: Scalars["Json"];
  label: Scalars["String"];
  tableIdentifier: SavedViewTableIdentifier;
}

export enum SavedViewTableIdentifier {
  ACCOUNTING_JOURNAL = "ACCOUNTING_JOURNAL",
  ALL_CARDS = "ALL_CARDS",
  BOOKINGS = "BOOKINGS",
  EMPLOYEE_CARDS = "EMPLOYEE_CARDS",
  EXPENSES = "EXPENSES",
  EXPORT_HISTORY = "EXPORT_HISTORY",
  GROUP_EVENTS = "GROUP_EVENTS",
  PURCHASING_CARDS = "PURCHASING_CARDS",
  TRIPS_ADMIN = "TRIPS_ADMIN",
}

export interface SavedViewUpdateResult extends MutationResult {
  /** No error if the saved view was updated successfully */
  errors?: Maybe<Array<ReportingClientError>>;
  result?: Maybe<SavedView>;
}

/** The cadence of a scheduled report, i.e. how often it's sent */
export enum ScheduleCadence {
  ANNUALLY = "ANNUALLY",
  MONTHLY = "MONTHLY",
  QUARTERLY = "QUARTERLY",
  WEEKLY = "WEEKLY",
}

/** Input for scheduling a new collection promise */
export interface ScheduleCollectionPromiseInput {
  /** The amount to be collected */
  amount: FinancialAssetInput;
  /** Idempotency key to prevent duplicate promises */
  clientMutationId: Scalars["String"];
  /** Early authorization balance decrease commitment ID */
  earlyAuthBalanceDecreaseCommitmentId?: InputMaybe<Scalars["String"]>;
  /** The ID of the originator entity */
  originatorId: Scalars["String"];
  /** The type of the originator entity */
  originatorType: CollectionPromiseOriginatorType;
  /** The ID of the owner entity */
  ownerId: Scalars["String"];
  /** The owner type of the promise */
  ownerType: CollectionPromiseOwnerType;
  /** The payment source to collect from */
  paymentSource: PaymentSourceInput;
  /** When the promise should be scheduled for */
  scheduleForDatetime?: InputMaybe<Scalars["Time"]>;
}

/** Response payload for the scheduleCollectionPromise mutation */
export interface ScheduleCollectionPromisePayload {
  /** The created collection promise */
  collectionPromise?: Maybe<CollectionPromise>;
}

export interface SchedulePaymentInput {
  amount?: InputMaybe<Scalars["Int"]>;
  amountAsset?: InputMaybe<FinancialAssetInput>;
  clientMutationId: Scalars["String"];
  fundingSourceId?: InputMaybe<Scalars["ID"]>;
  idempotencyKey: Scalars["String"];
  journalAccountId?: InputMaybe<Scalars["ID"]>;
  paymentEarlyAuthBalanceDecreaseCommitmentId?: InputMaybe<Scalars["ID"]>;
  railAccountDetailsId?: InputMaybe<Scalars["ID"]>;
}

export interface SchedulePaymentPayload {
  billingPayment?: Maybe<BillingPayment>;
  clientMutationId: Scalars["String"];
}

export interface ScheduledPrepayment extends Node {
  amountUsdCents: Scalars["Int"];
  /** The ID of an object */
  id: Scalars["ID"];
  paymentIntentId: Scalars["String"];
  percentageThreshold: Scalars["Int"];
  scheduledToDatetime: Scalars["Time"];
}

export interface ScimConnection {
  allowedDomains?: Maybe<Array<Scalars["String"]>>;
  id: Scalars["ID"];
}

export interface ScimConnectionConnection extends Connection {
  edges: Array<ScimConnectionEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface ScimConnectionEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<ScimConnection>;
}

export enum Scope {
  ACCOUNTING_INTEGRATION_READ = "ACCOUNTING_INTEGRATION_READ",
  ACCOUNTING_INTEGRATION_WRITE = "ACCOUNTING_INTEGRATION_WRITE",
  ACCOUNTING_RECORD_READ = "ACCOUNTING_RECORD_READ",
  ACCOUNTING_RECORD_WRITE = "ACCOUNTING_RECORD_WRITE",
  ACCOUNTS_CARD_READONLY = "ACCOUNTS_CARD_READONLY",
  ACCOUNTS_CASH_READONLY = "ACCOUNTS_CASH_READONLY",
  AUTOMATION_CUSTOM_RULES_READ = "AUTOMATION_CUSTOM_RULES_READ",
  AUTOMATION_CUSTOM_RULES_WRITE = "AUTOMATION_CUSTOM_RULES_WRITE",
  AUTOMATION_MAPPING_RULES_READ = "AUTOMATION_MAPPING_RULES_READ",
  AUTOMATION_MAPPING_RULES_WRITE = "AUTOMATION_MAPPING_RULES_WRITE",
  AUTOMATION_WORKFLOW_RULES_READ = "AUTOMATION_WORKFLOW_RULES_READ",
  AUTOMATION_WORKFLOW_RULES_WRITE = "AUTOMATION_WORKFLOW_RULES_WRITE",
  BUDGETS = "BUDGETS",
  BUDGETS_READONLY = "BUDGETS_READONLY",
  CARDS = "CARDS",
  CARDS_READONLY = "CARDS_READONLY",
  CARD_NUMBERS_READONLY = "CARD_NUMBERS_READONLY",
  CASH_ACCOUNTS_READONLY = "CASH_ACCOUNTS_READONLY",
  COMPANIES_READONLY = "COMPANIES_READONLY",
  DEPARTMENTS = "DEPARTMENTS",
  DEPARTMENTS_READONLY = "DEPARTMENTS_READONLY",
  EMBEDDED_ACCOUNTS_MANAGE = "EMBEDDED_ACCOUNTS_MANAGE",
  EMBEDDED_ACCOUNTS_READ = "EMBEDDED_ACCOUNTS_READ",
  EMBEDDED_ACCOUNTS_UNDERWRITING_PREFILL = "EMBEDDED_ACCOUNTS_UNDERWRITING_PREFILL",
  EMBEDDED_ASSETS_READ = "EMBEDDED_ASSETS_READ",
  EMBEDDED_ASSETS_UPLOAD = "EMBEDDED_ASSETS_UPLOAD",
  EMBEDDED_BILLING_GROUPS_MANAGE = "EMBEDDED_BILLING_GROUPS_MANAGE",
  EMBEDDED_BILLING_GROUPS_READ = "EMBEDDED_BILLING_GROUPS_READ",
  EMBEDDED_BILLING_STATEMENTS_READ = "EMBEDDED_BILLING_STATEMENTS_READ",
  EMBEDDED_BUDGETS_READ = "EMBEDDED_BUDGETS_READ",
  EMBEDDED_CARDS_MANAGE = "EMBEDDED_CARDS_MANAGE",
  EMBEDDED_CARDS_READ = "EMBEDDED_CARDS_READ",
  EMBEDDED_CARDS_READ_PAN = "EMBEDDED_CARDS_READ_PAN",
  EMBEDDED_CARD_AUTHORIZATIONS = "EMBEDDED_CARD_AUTHORIZATIONS",
  EMBEDDED_CARD_TRANSACTIONS_READ = "EMBEDDED_CARD_TRANSACTIONS_READ",
  EMBEDDED_CARD_TRANSACTIONS_SIMULATE = "EMBEDDED_CARD_TRANSACTIONS_SIMULATE",
  EMBEDDED_COST_CENTERS_READ = "EMBEDDED_COST_CENTERS_READ",
  EMBEDDED_DEPARTMENTS_READ = "EMBEDDED_DEPARTMENTS_READ",
  EMBEDDED_DISPUTES_MANAGE = "EMBEDDED_DISPUTES_MANAGE",
  EMBEDDED_DISPUTES_READ = "EMBEDDED_DISPUTES_READ",
  EMBEDDED_FIELDS_MANAGE = "EMBEDDED_FIELDS_MANAGE",
  EMBEDDED_FIELDS_READ = "EMBEDDED_FIELDS_READ",
  EMBEDDED_FRAUD_REVIEWS_MANAGE = "EMBEDDED_FRAUD_REVIEWS_MANAGE",
  EMBEDDED_IDENTITY_PROVIDERS_MANAGE = "EMBEDDED_IDENTITY_PROVIDERS_MANAGE",
  EMBEDDED_IDENTITY_PROVIDERS_READ = "EMBEDDED_IDENTITY_PROVIDERS_READ",
  EMBEDDED_LEGAL_ENTITIES_MANAGE = "EMBEDDED_LEGAL_ENTITIES_MANAGE",
  EMBEDDED_LEGAL_ENTITIES_READ = "EMBEDDED_LEGAL_ENTITIES_READ",
  EMBEDDED_LOCATIONS_READ = "EMBEDDED_LOCATIONS_READ",
  EMBEDDED_PARTNERSHIP_CONNECTIONS_CREATE = "EMBEDDED_PARTNERSHIP_CONNECTIONS_CREATE",
  EMBEDDED_PARTNERSHIP_CONNECTIONS_READ = "EMBEDDED_PARTNERSHIP_CONNECTIONS_READ",
  EMBEDDED_PARTNERSHIP_CONNECTIONS_UPDATE = "EMBEDDED_PARTNERSHIP_CONNECTIONS_UPDATE",
  EMBEDDED_POLICIES_READ = "EMBEDDED_POLICIES_READ",
  EMBEDDED_USERS_MANAGE = "EMBEDDED_USERS_MANAGE",
  EMBEDDED_USERS_READ = "EMBEDDED_USERS_READ",
  EXPENSES_BILL = "EXPENSES_BILL",
  EXPENSES_CARD = "EXPENSES_CARD",
  EXPENSES_CARD_READONLY = "EXPENSES_CARD_READONLY",
  EXTENDED_FIELDS = "EXTENDED_FIELDS",
  EXTENDED_FIELDS_READONLY = "EXTENDED_FIELDS_READONLY",
  FIELDS_READ = "FIELDS_READ",
  FIELDS_WRITE = "FIELDS_WRITE",
  FIELD_OPTIONS_READ = "FIELD_OPTIONS_READ",
  FIELD_OPTIONS_WRITE = "FIELD_OPTIONS_WRITE",
  FIELD_VALUES_READ = "FIELD_VALUES_READ",
  FIELD_VALUES_WRITE = "FIELD_VALUES_WRITE",
  INCOMING_TRANSFERS = "INCOMING_TRANSFERS",
  INVALID = "INVALID",
  LEGACY_ACCOUNTING_CARD = "LEGACY_ACCOUNTING_CARD",
  LEGACY_ACCOUNTING_CASH = "LEGACY_ACCOUNTING_CASH",
  LEGAL_ENTITIES = "LEGAL_ENTITIES",
  LEGAL_ENTITIES_READONLY = "LEGAL_ENTITIES_READONLY",
  LINKED_ACCOUNTS_READONLY = "LINKED_ACCOUNTS_READONLY",
  LOCATIONS = "LOCATIONS",
  LOCATIONS_READONLY = "LOCATIONS_READONLY",
  REFERRALS = "REFERRALS",
  REWARDS = "REWARDS",
  STATEMENTS_CARD_READONLY = "STATEMENTS_CARD_READONLY",
  STATEMENTS_CASH_READONLY = "STATEMENTS_CASH_READONLY",
  TITLES = "TITLES",
  TITLES_READONLY = "TITLES_READONLY",
  TRANSACTIONS_CARD_READONLY = "TRANSACTIONS_CARD_READONLY",
  TRANSACTIONS_CASH_READONLY = "TRANSACTIONS_CASH_READONLY",
  TRANSFERS = "TRANSFERS",
  TRANSFERS_READONLY = "TRANSFERS_READONLY",
  TRAVEL = "TRAVEL",
  TRAVEL_TRIPS = "TRAVEL_TRIPS",
  TRAVEL_TRIPS_READONLY = "TRAVEL_TRIPS_READONLY",
  USERS = "USERS",
  USERS_READONLY = "USERS_READONLY",
  VENDORS = "VENDORS",
  VENDORS_READONLY = "VENDORS_READONLY",
}

/** Scope object */
export interface ScopeWrapper {
  /** API this scope is used for */
  api: Api;
  /** Description of the scope */
  description?: Maybe<Scalars["String"]>;
  /** Name shown in dashboard */
  displayName: Scalars["String"];
  /** Scope enum */
  enum: Scope;
  /** Scope string value, used when creating tokens */
  value: Scalars["String"];
}

/**
 * A search item in global search can represent a route, primitive, smart commands and etc. This aims to create a more
 * flat structure for the FE to integrate with.
 */
export interface SearchItem {
  /** The description of this search item. Will be used as a subtitle in the search result. */
  description?: Maybe<Scalars["String"]>;
  /** Link to the external URL if any. */
  externalUrl?: Maybe<Scalars["String"]>;
  /**
   * The local Metal icon, e.g.,. a "checkmark," or the URL of the remote icon that the client must load. The remote icon
   * takes precedence over the local icon if both are present.
   */
  icon?: Maybe<SearchItemIcon>;
  /**
   * The intent represents the goal or purpose that a user has when they enter a query into global search. It is an
   * unique key that reference to a URL, primitive type, smart command or etc.
   */
  intent: Scalars["String"];
  /**
   * The intent group this search item belongs to.
   * @deprecated Use `intentGroupType` instead
   */
  intentGroup: Scalars["String"];
  /** The intent group this search item belongs to. */
  intentGroupType: GlobalSearchIntentGroup;
  /** The search metadata. */
  metadata?: Maybe<SearchMetadata>;
  /** The name of this search item. */
  name: Scalars["String"];
  /** A list of parameters. */
  parameters?: Maybe<Array<Parameter>>;
  /** The template type */
  templateType?: Maybe<TemplateType>;
}

/** Defines which icon is displayed next to the search item. */
export interface SearchItemIcon {
  /** A local Metal icon string constant. */
  localMetalIcon?: Maybe<Scalars["String"]>;
  /** A remote icon that the client is responsible for loading via the URL. */
  remoteIcon?: Maybe<Asset>;
}

export interface SearchItemIconInput {
  /** Id of the icon Asset. */
  assetId?: InputMaybe<Scalars["String"]>;
  /** A local Metal icon string constant. */
  localMetalIcon?: InputMaybe<Scalars["String"]>;
  remoteIconUrl?: InputMaybe<Scalars["String"]>;
}

export interface SearchItemInput {
  /** The description of this search item. Will be used as a subtitle in the search result. */
  description?: InputMaybe<Scalars["String"]>;
  /** Link to the external URL if any. */
  externalUrl?: InputMaybe<Scalars["String"]>;
  /**
   * The local Metal icon, e.g.,. a "checkmark," or the URL of the remote icon that the client must load. The remote icon
   * takes precedence over the local icon if both are present.
   */
  icon?: InputMaybe<SearchItemIconInput>;
  /**
   * The intent represents the goal or purpose that a user has when they enter a query into global search. It is an
   * unique key that reference to a URL, primitive type, smart command or etc.
   */
  intent: Scalars["String"];
  /** The intent group this search item belongs to. */
  intentGroupType: GlobalSearchIntentGroup;
  /** The name of this search item. */
  name: Scalars["String"];
  /** A list of parameters. */
  parameters?: InputMaybe<Array<ParameterInput>>;
}

/** Input type for searching merchants */
export interface SearchMerchantsInput {
  /** Name of the merchant */
  name: Scalars["String"];
  /** Page size of the search */
  pageSize?: InputMaybe<Scalars["Int"]>;
  /** By setting scopedToAccount, it only shows the merchants that the customers transacted with */
  scopeToAccount?: InputMaybe<Scalars["Boolean"]>;
}

export type SearchMetadata = Budget | Card | LimitGroup | User | VendorDetails;

export interface SearchResult {
  aggregates?: Maybe<Array<Maybe<AggregationResult>>>;
  cursor?: Maybe<Scalars["String"]>;
  hits: Array<Maybe<Searchable>>;
  totalHits: Scalars["Int"];
}

export interface SearchResults {
  results: Array<SearchItem>;
  searchSessionId: Scalars["String"];
}

export type Searchable =
  | CollectionIntention
  | Department
  | Merchant
  | MerchantCategory
  | User
  | UserCategory;

export interface SectionEnablement {
  isEnabled: Scalars["Boolean"];
  section: AdminHomeSectionType;
}

export interface SectionEnablementInput {
  isEnabled: Scalars["Boolean"];
  section: AdminHomeSectionType;
}

export interface SeenFlag extends Node {
  /** The ID of an object */
  id: Scalars["ID"];
  /** Should keys be ignored */
  isDeprecated?: Maybe<Scalars["Boolean"]>;
  /** Named with the convention [Team]_[Location]_[Action] */
  key: SeenFlagKey;
  /** Last seen */
  lastSeenAt?: Maybe<Scalars["Time"]>;
  /** Only boolean values supported */
  value?: Maybe<Scalars["Boolean"]>;
}

/**
 * ! DO NOT DELETE OR RENAME SEEN FLAGS
 * You will probably bring down staging, cause a release validation
 * incident, and break older versions of the mobile app
 * Don't believe me? Look through the git history of this file
 * ! DO NOT DELETE OR RENAME SEEN FLAGS
 * Sorted list of flag keys with a naming convention of:
 *   [Team]_[Location]_[Action]
 */
export enum SeenFlagKey {
  ACCOUNTING_CLASSIC_TO_EMPOWER_MODAL_SEEN = "ACCOUNTING_CLASSIC_TO_EMPOWER_MODAL_SEEN",
  ACCOUNTING_CSV_EXPORT_ACCOUNTING_EDUCATION_BANNER_SEEN = "ACCOUNTING_CSV_EXPORT_ACCOUNTING_EDUCATION_BANNER_SEEN",
  ACCOUNTING_EXPENSE_CATEGORY_MOVED_BANNER_DISMISSED = "ACCOUNTING_EXPENSE_CATEGORY_MOVED_BANNER_DISMISSED",
  ACCOUNTING_EXPORT_HISTORY_NEW_LAUNCH_BANNER_SEEN = "ACCOUNTING_EXPORT_HISTORY_NEW_LAUNCH_BANNER_SEEN",
  ACCOUNTING_EXPORT_HISTORY_TRANSACTIONS_TAB_EDUCATION_SEEN = "ACCOUNTING_EXPORT_HISTORY_TRANSACTIONS_TAB_EDUCATION_SEEN",
  ACCOUNTING_EXPORT_SETTINGS_CHANGE_EXPORT_TYPE_ALERT_DISMISSED = "ACCOUNTING_EXPORT_SETTINGS_CHANGE_EXPORT_TYPE_ALERT_DISMISSED",
  ACCOUNTING_FIELDS_LIBRARY_ERP_DEPENDENCIES_BANNER_DISMISSED = "ACCOUNTING_FIELDS_LIBRARY_ERP_DEPENDENCIES_BANNER_DISMISSED",
  ACCOUNTING_JOURNAL_BULK_UPDATE_EDUCATION_SEEN = "ACCOUNTING_JOURNAL_BULK_UPDATE_EDUCATION_SEEN",
  ACCOUNTING_JOURNAL_DATAGRID_ACCRUALS_ONBOARDING_EDUCATION_BANNER_SEEN = "ACCOUNTING_JOURNAL_DATAGRID_ACCRUALS_ONBOARDING_EDUCATION_BANNER_SEEN",
  ACCOUNTING_JOURNAL_DATAGRID_FIRST_TIME_ACCRUAL_ACTION_DISMISSED = "ACCOUNTING_JOURNAL_DATAGRID_FIRST_TIME_ACCRUAL_ACTION_DISMISSED",
  ACCOUNTING_JOURNAL_DATAGRID_NON_COMPLIANT_TRANSACTIONS_MODAL_DISMISSED = "ACCOUNTING_JOURNAL_DATAGRID_NON_COMPLIANT_TRANSACTIONS_MODAL_DISMISSED",
  ACCOUNTING_JOURNAL_EXPENSE_CATEGORY_INLINE_EDIT_ALERT_DISMISSED = "ACCOUNTING_JOURNAL_EXPENSE_CATEGORY_INLINE_EDIT_ALERT_DISMISSED",
  ACCOUNTING_JOURNAL_REAL_SELECT_ALL_EDUCATION_SEEN = "ACCOUNTING_JOURNAL_REAL_SELECT_ALL_EDUCATION_SEEN",
  ACCOUNTING_JOURNAL_REPORTS_EDUCATION_SEEN = "ACCOUNTING_JOURNAL_REPORTS_EDUCATION_SEEN",
  ACCOUNTING_SETTINGS_NAVBAR_AMORTIZE_SETUP_SEEN = "ACCOUNTING_SETTINGS_NAVBAR_AMORTIZE_SETUP_SEEN",
  ACCOUNTING_SETTINGS_NAVBAR_REQUIRED_FIELDS_SEEN = "ACCOUNTING_SETTINGS_NAVBAR_REQUIRED_FIELDS_SEEN",
  ACCOUNTING_SHELF_AMORTIZE_SETUP_SEEN = "ACCOUNTING_SHELF_AMORTIZE_SETUP_SEEN",
  ACCOUNTING_SHELF_ITEM_FIELDS_LIBRARY_CLICKED = "ACCOUNTING_SHELF_ITEM_FIELDS_LIBRARY_CLICKED",
  ACCOUNTING_SHELF_ITEM_INTEGRATION_SETTINGS_CLICKED = "ACCOUNTING_SHELF_ITEM_INTEGRATION_SETTINGS_CLICKED",
  ACCOUNTING_SHELF_ITEM_MANAGE_AUTOMATIONS_CLICKED = "ACCOUNTING_SHELF_ITEM_MANAGE_AUTOMATIONS_CLICKED",
  ACCOUNTING_SHELF_ITEM_MANAGE_UPDATED_AUTOMATIONS_CLICKED = "ACCOUNTING_SHELF_ITEM_MANAGE_UPDATED_AUTOMATIONS_CLICKED",
  ACCOUNTING_STREAMLINED_SUGGESTIONS_BUTTON_SEEN = "ACCOUNTING_STREAMLINED_SUGGESTIONS_BUTTON_SEEN",
  ACCOUNT_REIMBURSEMENTS_SETUP_CARD_DISMISSED = "ACCOUNT_REIMBURSEMENTS_SETUP_CARD_DISMISSED",
  ACCOUNT_SB_OFFBOARDING_BANNER_FINAL_SEEN = "ACCOUNT_SB_OFFBOARDING_BANNER_FINAL_SEEN",
  ACCOUNT_SB_OFFBOARDING_BANNER_SEEN = "ACCOUNT_SB_OFFBOARDING_BANNER_SEEN",
  ACCOUNT_TIME_ZONE_BANNER_SEEN = "ACCOUNT_TIME_ZONE_BANNER_SEEN",
  AI_ASSISTED_REVIEW_EDUCATION_SEEN = "AI_ASSISTED_REVIEW_EDUCATION_SEEN",
  AI_EXPERIENCES_BREX_ASSISTANT_M1_WAITLIST_JOINED = "AI_EXPERIENCES_BREX_ASSISTANT_M1_WAITLIST_JOINED",
  AI_EXPERIENCES_BREX_ASSISTANT_UPSELL_ADMIN_MODAL_SEEN = "AI_EXPERIENCES_BREX_ASSISTANT_UPSELL_ADMIN_MODAL_SEEN",
  AI_EXPERIENCES_BREX_ASSISTANT_UPSELL_USER_PANE_SEEN = "AI_EXPERIENCES_BREX_ASSISTANT_UPSELL_USER_PANE_SEEN",
  APPLE_NL_CARD_ALERT_SEEN = "APPLE_NL_CARD_ALERT_SEEN",
  APP_DARK_MODE_IS_ENABLED_TRACKED = "APP_DARK_MODE_IS_ENABLED_TRACKED",
  APP_SANCTIONS_POSSIBLY_IMPACTED_BANNER_DISMISSED = "APP_SANCTIONS_POSSIBLY_IMPACTED_BANNER_DISMISSED",
  AUTOMATION_WORKFLOWS_TAB_CLICKED = "AUTOMATION_WORKFLOWS_TAB_CLICKED",
  AUTO_INVITE_CREATE_HOTSPOT_SEEN = "AUTO_INVITE_CREATE_HOTSPOT_SEEN",
  AUTO_INVITE_MANAGE_HOTSPOT_SEEN = "AUTO_INVITE_MANAGE_HOTSPOT_SEEN",
  AUTO_LIMIT_ASSIGNMENT_FTUX_SEEN = "AUTO_LIMIT_ASSIGNMENT_FTUX_SEEN",
  BANKING_ADD_ACCOUNT_PRIMER_SEEN = "BANKING_ADD_ACCOUNT_PRIMER_SEEN",
  BANKING_INVOICING_NEW_BADGE_SEEN = "BANKING_INVOICING_NEW_BADGE_SEEN",
  BANKING_MOBILE_ADD_ACCOUNT_PRIMER_SEEN = "BANKING_MOBILE_ADD_ACCOUNT_PRIMER_SEEN",
  BANKING_UPSELL_BANNER_DISMISSED = "BANKING_UPSELL_BANNER_DISMISSED",
  BBA_ADD_ACCOUNT_PRIMER_SEEN = "BBA_ADD_ACCOUNT_PRIMER_SEEN",
  BILLS_ACCOUNT_LATE_FEE_BANNER_DISMISSED = "BILLS_ACCOUNT_LATE_FEE_BANNER_DISMISSED",
  BILLS_AMORTIZE_SETTINGS_SEEN = "BILLS_AMORTIZE_SETTINGS_SEEN",
  BILLS_BATCHED_BILL_PAY_25Q2_SEEN = "BILLS_BATCHED_BILL_PAY_25Q2_SEEN",
  BILLS_CUSTOM_ERP_SYNC_SETTINGS_SEEN = "BILLS_CUSTOM_ERP_SYNC_SETTINGS_SEEN",
  BILLS_CUSTOM_PAYMENT_SYNC_SETTINGS_SEEN = "BILLS_CUSTOM_PAYMENT_SYNC_SETTINGS_SEEN",
  BILLS_DRAG_AND_DROP_TOOLTIP_DISMISSED = "BILLS_DRAG_AND_DROP_TOOLTIP_DISMISSED",
  BILLS_EXTERNAL_BANK_ACCOUNTS_FEATURE_BANNER_DISMISSED = "BILLS_EXTERNAL_BANK_ACCOUNTS_FEATURE_BANNER_DISMISSED",
  BILLS_FIELDS_FOR_COMMERCIAL_SETTINGS_SEEN = "BILLS_FIELDS_FOR_COMMERCIAL_SETTINGS_SEEN",
  BILLS_GLOBAL_ONBOARDING_MODAL_SEEN = "BILLS_GLOBAL_ONBOARDING_MODAL_SEEN",
  BILLS_INTEGRATIONS_BILL_SYNC_SET_UP_BANNER_DISMISSED = "BILLS_INTEGRATIONS_BILL_SYNC_SET_UP_BANNER_DISMISSED",
  BILLS_INTEGRATIONS_QBO_ACCOUNT_SET_UP_BANNER_DISMISSED = "BILLS_INTEGRATIONS_QBO_ACCOUNT_SET_UP_BANNER_DISMISSED",
  BILLS_NETSUITE_FEATURE_BANNER_DISMISSED = "BILLS_NETSUITE_FEATURE_BANNER_DISMISSED",
  BILLS_ONBOARDING_FIRST_BILL_CREATED = "BILLS_ONBOARDING_FIRST_BILL_CREATED",
  BILLS_ONBOARDING_TOOLTIP_DISMISSED = "BILLS_ONBOARDING_TOOLTIP_DISMISSED",
  BILLS_POLICY_APPROVER_TOOLTIP_DISMISSED = "BILLS_POLICY_APPROVER_TOOLTIP_DISMISSED",
  /**  ! DO NOT DELETE OR RENAME SEEN FLAGS */
  BILLS_STATEMENTS_HOTSPOT_DISMISSED = "BILLS_STATEMENTS_HOTSPOT_DISMISSED",
  BILLS_TAB_INTERACTED = "BILLS_TAB_INTERACTED",
  BILLS_USER_ACCESS_TOOLTIP_DISMISSED = "BILLS_USER_ACCESS_TOOLTIP_DISMISSED",
  BILL_PAY_BUDGETS_NEW_TAG_DISMISSED = "BILL_PAY_BUDGETS_NEW_TAG_DISMISSED",
  BILL_PAY_FORM_ERP_SYNC_BANNER_DISMISSED = "BILL_PAY_FORM_ERP_SYNC_BANNER_DISMISSED",
  BILL_PAY_POST_BILL_CREATION_TOOLTIP_TOUR_COMPLETED = "BILL_PAY_POST_BILL_CREATION_TOOLTIP_TOUR_COMPLETED",
  BUDGETS_BUDGET_TEMPLATE_TOOLTIP_DISMISSED = "BUDGETS_BUDGET_TEMPLATE_TOOLTIP_DISMISSED",
  BUDGETS_ESSENTIALS_EMPTY_STATE_BANNER_DISMISSED = "BUDGETS_ESSENTIALS_EMPTY_STATE_BANNER_DISMISSED",
  BUDGETS_EXPLORER_EDUCATION_SEEN = "BUDGETS_EXPLORER_EDUCATION_SEEN",
  BUDGETS_GLOBAL_EXPENSE_POLICY_CREATOR_BANNER_DISMISSED = "BUDGETS_GLOBAL_EXPENSE_POLICY_CREATOR_BANNER_DISMISSED",
  BUDGETS_STRUCTURE_TIP_SEEN = "BUDGETS_STRUCTURE_TIP_SEEN",
  BUDGETS_TABLE_TOUR_COMPLETED = "BUDGETS_TABLE_TOUR_COMPLETED",
  BUDGETS_V1_FTUX_BUDGETS_AND_SPEND_LIMITS_TUTORIAL_COMPLETED = "BUDGETS_V1_FTUX_BUDGETS_AND_SPEND_LIMITS_TUTORIAL_COMPLETED",
  BUDGETS_V1_FTUX_COMPLETED = "BUDGETS_V1_FTUX_COMPLETED",
  BUDGETS_V1_FTUX_EDUCATION_DISMISSED = "BUDGETS_V1_FTUX_EDUCATION_DISMISSED",
  BUDGETS_V1_FTUX_EDUCATION_HOTSPOT_DISMISSED = "BUDGETS_V1_FTUX_EDUCATION_HOTSPOT_DISMISSED",
  BUDGETS_V1_FTUX_MIGRATED_TO_CARD_LIMITS_TUTORIAL_COMPLETED = "BUDGETS_V1_FTUX_MIGRATED_TO_CARD_LIMITS_TUTORIAL_COMPLETED",
  BUDGETS_V1_FTUX_PROCUREMENT_TUTORIAL_COMPLETED = "BUDGETS_V1_FTUX_PROCUREMENT_TUTORIAL_COMPLETED",
  BUDGETS_V1_FTUX_SPEND_LIMITS_TUTORIAL_COMPLETED = "BUDGETS_V1_FTUX_SPEND_LIMITS_TUTORIAL_COMPLETED",
  BUDGETS_V1_FTUX_TRAVEL_TUTORIAL_COMPLETED = "BUDGETS_V1_FTUX_TRAVEL_TUTORIAL_COMPLETED",
  BUDGET_CONFIG_DROPDOWN_SEEN = "BUDGET_CONFIG_DROPDOWN_SEEN",
  BUDGET_CREATION_PRIMER_SEEN = "BUDGET_CREATION_PRIMER_SEEN",
  BUDGET_DETAILS_V2_TOUR_COMPLETED = "BUDGET_DETAILS_V2_TOUR_COMPLETED",
  BUDGET_DISTRIBUTION_TIP_SEEN = "BUDGET_DISTRIBUTION_TIP_SEEN",
  BUDGET_LEVEL_NOTIFICATIONS_TOOLTIP_SEEN = "BUDGET_LEVEL_NOTIFICATIONS_TOOLTIP_SEEN",
  BUDGET_ROLLOVER_TOOLTIP_SEEN = "BUDGET_ROLLOVER_TOOLTIP_SEEN",
  BUDGET_SUGGESTION_UPSELL_DISMISSED = "BUDGET_SUGGESTION_UPSELL_DISMISSED",
  BUDGET_SUGGESTION_UPSELL_SEEN = "BUDGET_SUGGESTION_UPSELL_SEEN",
  BUDGET_TEMPLATES_HELP_PANEL_SEEN = "BUDGET_TEMPLATES_HELP_PANEL_SEEN",
  BUDGET_TEMPLATES_TOOLTIP_TOUR_COMPLETED = "BUDGET_TEMPLATES_TOOLTIP_TOUR_COMPLETED",
  BUDGET_TEMPLATES_VIDEO_SEEN = "BUDGET_TEMPLATES_VIDEO_SEEN",
  BULK_BUDGET_MANAGEMENT_M2_TOOLTIP_SEEN = "BULK_BUDGET_MANAGEMENT_M2_TOOLTIP_SEEN",
  BULK_BUDGET_MANAGEMENT_TOOLTIP_TOUR_SEEN = "BULK_BUDGET_MANAGEMENT_TOOLTIP_TOUR_SEEN",
  CAPITAL_INSTANT_PAYOUTS_TAB_INTERACTED = "CAPITAL_INSTANT_PAYOUTS_TAB_INTERACTED",
  CAPITAL_INSTANT_REVENUE_ANNOUNCEMENT_SEEN = "CAPITAL_INSTANT_REVENUE_ANNOUNCEMENT_SEEN",
  CAPITAL_INSTANT_REVENUE_SUMMARY_STATS_HOW_IT_WORKS_DISMISSED = "CAPITAL_INSTANT_REVENUE_SUMMARY_STATS_HOW_IT_WORKS_DISMISSED",
  CARD_BANK_CONNECTIONS_SETTING_TAB_SEEN = "CARD_BANK_CONNECTIONS_SETTING_TAB_SEEN",
  /**  ! DO NOT DELETE OR RENAME SEEN FLAGS */
  CARD_EXPIRING_PHYSICAL_CARD_MODAL_DISMISSED = "CARD_EXPIRING_PHYSICAL_CARD_MODAL_DISMISSED",
  CARD_PREAPPROVED_CARD_REQUEST_APPROVE_MODAL_SEEN = "CARD_PREAPPROVED_CARD_REQUEST_APPROVE_MODAL_SEEN",
  CARD_PREAPPROVED_CARD_REQUEST_DENY_MODAL_SEEN = "CARD_PREAPPROVED_CARD_REQUEST_DENY_MODAL_SEEN",
  CASH_ACCOUNT_CLOSED_BANNER_DISMISSED = "CASH_ACCOUNT_CLOSED_BANNER_DISMISSED",
  CASH_ADP_PAYROLL_SETUP_SEEN = "CASH_ADP_PAYROLL_SETUP_SEEN",
  CASH_BBA_AUTOMATIC_TRANSFERS_POPUP_SEEN = "CASH_BBA_AUTOMATIC_TRANSFERS_POPUP_SEEN",
  CASH_BBA_AUTOMATIC_TRANSFERS_SETUP_DISMISSED = "CASH_BBA_AUTOMATIC_TRANSFERS_SETUP_DISMISSED",
  CASH_BBA_DEFAULT_AUTOPAY_ACCOUNT_CREDIT_BANNER_DISMISSED = "CASH_BBA_DEFAULT_AUTOPAY_ACCOUNT_CREDIT_BANNER_DISMISSED",
  CASH_BBA_DEFAULT_AUTOPAY_ACCOUNT_REIMBURSEMENTS_BANNER_DISMISSED = "CASH_BBA_DEFAULT_AUTOPAY_ACCOUNT_REIMBURSEMENTS_BANNER_DISMISSED",
  CASH_BBA_MANAGE_ALLOCATION_BANNER_DISMISSED = "CASH_BBA_MANAGE_ALLOCATION_BANNER_DISMISSED",
  CASH_BBA_NOTICE_BANNER_DISMISSED = "CASH_BBA_NOTICE_BANNER_DISMISSED",
  CASH_BBA_PAYROLL_BANNER_DISMISSED = "CASH_BBA_PAYROLL_BANNER_DISMISSED",
  CASH_DEPOSIT_SAFETY_MODAL_SEEN = "CASH_DEPOSIT_SAFETY_MODAL_SEEN",
  CASH_FBO_MODAL_INTERACTED = "CASH_FBO_MODAL_INTERACTED",
  CASH_FDIC_AND_WIRE_TRANSFER_BANNER_5P5M_SEEN = "CASH_FDIC_AND_WIRE_TRANSFER_BANNER_5P5M_SEEN",
  CASH_FDIC_AND_WIRE_TRANSFER_BANNER_SEEN = "CASH_FDIC_AND_WIRE_TRANSFER_BANNER_SEEN",
  CASH_FDIC_MMF_ALLOCATION_MODAL_INTERACTED = "CASH_FDIC_MMF_ALLOCATION_MODAL_INTERACTED",
  CASH_FTUE_TOUR_COMPLETED = "CASH_FTUE_TOUR_COMPLETED",
  CASH_GUSTO_PAYROLL_SETUP_SEEN = "CASH_GUSTO_PAYROLL_SETUP_SEEN",
  CASH_INSIGHTS_CSAT_TAKEN = "CASH_INSIGHTS_CSAT_TAKEN",
  CASH_INSIGHTS_SCENARIO_PLANNING_EVENTS_CLICKED = "CASH_INSIGHTS_SCENARIO_PLANNING_EVENTS_CLICKED",
  CASH_INSIGHTS_SEEN = "CASH_INSIGHTS_SEEN",
  CASH_INSIGHTS_TOOLTIP_DISMISSED = "CASH_INSIGHTS_TOOLTIP_DISMISSED",
  CASH_INTEGRATIONS_ANNOUNCEMENT_INTERACTED = "CASH_INTEGRATIONS_ANNOUNCEMENT_INTERACTED",
  /**  ! DO NOT DELETE OR RENAME SEEN FLAGS */
  CASH_INTL_WIRE_ASK_UPDATE_JPM_COUNTRY_CONFIG_INTERACTED = "CASH_INTL_WIRE_ASK_UPDATE_JPM_COUNTRY_CONFIG_INTERACTED",
  CASH_INTL_WIRE_BANK_INFO_CHANGED_TO_JPM_INTERACTED = "CASH_INTL_WIRE_BANK_INFO_CHANGED_TO_JPM_INTERACTED",
  CASH_MULTIPLE_ACCOUNTS_INTRO_SEEN = "CASH_MULTIPLE_ACCOUNTS_INTRO_SEEN",
  CASH_MULTIPLE_ACCOUNTS_TOOLTIP_SEEN = "CASH_MULTIPLE_ACCOUNTS_TOOLTIP_SEEN",
  CASH_PAYABLES_TAB_INTERACTED = "CASH_PAYABLES_TAB_INTERACTED",
  CASH_PAYCHEX_PAYROLL_SETUP_SEEN = "CASH_PAYCHEX_PAYROLL_SETUP_SEEN",
  CASH_PAYMENT_APPROVALS_TAKEOVER_DISMISSED = "CASH_PAYMENT_APPROVALS_TAKEOVER_DISMISSED",
  CASH_PAYMENT_APPROVALS_THRESHOLDS_SETUP_TOAST_SEEN = "CASH_PAYMENT_APPROVALS_THRESHOLDS_SETUP_TOAST_SEEN",
  CASH_QUICKBOOKS_PAYROLL_SETUP_SEEN = "CASH_QUICKBOOKS_PAYROLL_SETUP_SEEN",
  CASH_REVERSE_WIRE_PAYROLL_BANNER_DISMISSED = "CASH_REVERSE_WIRE_PAYROLL_BANNER_DISMISSED",
  CASH_RIPPLING_PAYROLL_SETUP_SEEN = "CASH_RIPPLING_PAYROLL_SETUP_SEEN",
  CASH_SAFETY_LIST_WARNING_BANNER_DISMISSED = "CASH_SAFETY_LIST_WARNING_BANNER_DISMISSED",
  CASH_SAFETY_LIST_WARNING_SEEN = "CASH_SAFETY_LIST_WARNING_SEEN",
  CASH_TRANSACTIONS_TOUR_PROMPT_INTERACTED = "CASH_TRANSACTIONS_TOUR_PROMPT_INTERACTED",
  CASH_TRINET_PAYROLL_SETUP_SEEN = "CASH_TRINET_PAYROLL_SETUP_SEEN",
  CASH_VENDORS_ANNOUNCEMENT_INTERACTED = "CASH_VENDORS_ANNOUNCEMENT_INTERACTED",
  CASH_VENDORS_BULK_UPLOAD_TOOLTIP_INTERACTED = "CASH_VENDORS_BULK_UPLOAD_TOOLTIP_INTERACTED",
  CASH_VENDORS_TAB_INTERACTED = "CASH_VENDORS_TAB_INTERACTED",
  CASH_WELCOME_MODAL_SEEN = "CASH_WELCOME_MODAL_SEEN",
  CASH_WIRE_TRANSFER_BANNER_SEEN = "CASH_WIRE_TRANSFER_BANNER_SEEN",
  COLUMN_MIGRATION_BANNER_DISMISSED = "COLUMN_MIGRATION_BANNER_DISMISSED",
  COLUMN_MIGRATION_CUSTOMER_SURVEY = "COLUMN_MIGRATION_CUSTOMER_SURVEY",
  COLUMN_MIGRATION_REMINDER_MODAL_SEEN = "COLUMN_MIGRATION_REMINDER_MODAL_SEEN",
  COLUMN_MIGRATION_WALKTHROUGH_FINISHED = "COLUMN_MIGRATION_WALKTHROUGH_FINISHED",
  /**  ! DO NOT DELETE OR RENAME SEEN FLAGS */
  COLUMN_MIGRATION_WALKTHROUGH_STARTED = "COLUMN_MIGRATION_WALKTHROUGH_STARTED",
  COMMS_EXPENSES_BANNER_DISMISSED = "COMMS_EXPENSES_BANNER_DISMISSED",
  COMMS_WHATSAPP_BANNER_DISMISSED = "COMMS_WHATSAPP_BANNER_DISMISSED",
  DELEGATOR_NOTIFICATIONS_BANNER_DISMISSED = "DELEGATOR_NOTIFICATIONS_BANNER_DISMISSED",
  EDUCATION_TOURS_TOOLTIP_SEEN = "EDUCATION_TOURS_TOOLTIP_SEEN",
  EMPLOYEE_GROWTH_VIRTUAL_CARD_CALLOUT_SEEN = "EMPLOYEE_GROWTH_VIRTUAL_CARD_CALLOUT_SEEN",
  EMPLOYEE_PRODUCTIVITY_AUTO_MATCHING_MODAL_SEEN = "EMPLOYEE_PRODUCTIVITY_AUTO_MATCHING_MODAL_SEEN",
  EMPOWER_ACCOUNT_SETUP_TOOLTIP_SEEN = "EMPOWER_ACCOUNT_SETUP_TOOLTIP_SEEN",
  EMPOWER_IMPLEMENTATION_COMPLETE_SEEN = "EMPOWER_IMPLEMENTATION_COMPLETE_SEEN",
  EMPOWER_LIGHT_ONBOARDING_ACCOUNTING_NEW_TAG_INTERACTED = "EMPOWER_LIGHT_ONBOARDING_ACCOUNTING_NEW_TAG_INTERACTED",
  EMPOWER_LIGHT_ONBOARDING_BUDGETS_NEW_TAG_INTERACTED = "EMPOWER_LIGHT_ONBOARDING_BUDGETS_NEW_TAG_INTERACTED",
  EMPOWER_LIGHT_ONBOARDING_BUDGETS_TOOLTIP_TOUR_COMPLETED = "EMPOWER_LIGHT_ONBOARDING_BUDGETS_TOOLTIP_TOUR_COMPLETED",
  EMPOWER_LIGHT_ONBOARDING_INBOX_NEW_TAG_INTERACTED = "EMPOWER_LIGHT_ONBOARDING_INBOX_NEW_TAG_INTERACTED",
  EMPOWER_LIGHT_ONBOARDING_MODAL_TOUR_COMPLETED = "EMPOWER_LIGHT_ONBOARDING_MODAL_TOUR_COMPLETED",
  EMPOWER_LIGHT_ONBOARDING_PRE_BUDGETS_MIGRATION_MODAL_TOUR_COMPLETED = "EMPOWER_LIGHT_ONBOARDING_PRE_BUDGETS_MIGRATION_MODAL_TOUR_COMPLETED",
  EMPOWER_LIGHT_ONBOARDING_PRE_BUDGETS_MIGRATION_MODAL_TOUR_INTERACTED = "EMPOWER_LIGHT_ONBOARDING_PRE_BUDGETS_MIGRATION_MODAL_TOUR_INTERACTED",
  EMPOWER_LIGHT_ONBOARDING_TOOLTIP_TOUR_COMPLETED = "EMPOWER_LIGHT_ONBOARDING_TOOLTIP_TOUR_COMPLETED",
  EMPOWER_LIGHT_ONBOARDING_WALLET_LIMIT_TOOLTIP_SEEN = "EMPOWER_LIGHT_ONBOARDING_WALLET_LIMIT_TOOLTIP_SEEN",
  EMPOWER_LIGHT_ONBOARDING_WALLET_LIMIT_UPDATED_TOOLTIP_SEEN = "EMPOWER_LIGHT_ONBOARDING_WALLET_LIMIT_UPDATED_TOOLTIP_SEEN",
  EMPOWER_LIGHT_ONBOARDING_WALLET_TOOLTIP_TOUR_COMPLETED = "EMPOWER_LIGHT_ONBOARDING_WALLET_TOOLTIP_TOUR_COMPLETED",
  /**  ! DO NOT DELETE OR RENAME SEEN FLAGS */
  ENGAGEMENT_COMPANY_POLICY_AGREEMENT_ACCEPTED = "ENGAGEMENT_COMPANY_POLICY_AGREEMENT_ACCEPTED",
  ENGAGEMENT_HOME_CREATE_EXPENSE_POLICY_TASK_DISMISSED = "ENGAGEMENT_HOME_CREATE_EXPENSE_POLICY_TASK_DISMISSED",
  ENGAGEMENT_HOME_ENABLE_SPEND_REQUESTS_TASK_DISMISSED = "ENGAGEMENT_HOME_ENABLE_SPEND_REQUESTS_TASK_DISMISSED",
  ENGAGEMENT_HOME_SETUP_QUICKBOOKS_TASK_DISMISSED = "ENGAGEMENT_HOME_SETUP_QUICKBOOKS_TASK_DISMISSED",
  ENGAGEMENT_Q4_21_PLATFORM_AGREEMENT_UPDATED_MODAL_INTERACTED = "ENGAGEMENT_Q4_21_PLATFORM_AGREEMENT_UPDATED_MODAL_INTERACTED",
  ENGAGEMENT_Q4_21_PLATFORM_AGREEMENT_UPDATED_MODAL_SEEN = "ENGAGEMENT_Q4_21_PLATFORM_AGREEMENT_UPDATED_MODAL_SEEN",
  ENGAGEMENT_Q4_22_PLATFORM_AGREEMENT_UPDATED_MODAL_INTERACTED = "ENGAGEMENT_Q4_22_PLATFORM_AGREEMENT_UPDATED_MODAL_INTERACTED",
  ENGAGEMENT_Q4_22_PLATFORM_AGREEMENT_UPDATED_MODAL_SEEN = "ENGAGEMENT_Q4_22_PLATFORM_AGREEMENT_UPDATED_MODAL_SEEN",
  ENGAGEMENT_ROLE_NAME_BANNER_SEEN = "ENGAGEMENT_ROLE_NAME_BANNER_SEEN",
  ENGAGEMENT_USER_ROLE_NAME_BANNER_SEEN = "ENGAGEMENT_USER_ROLE_NAME_BANNER_SEEN",
  ESSENTIALS_MIGRATION_NOTICE_STATUS_COMPLETED_DISMISSED = "ESSENTIALS_MIGRATION_NOTICE_STATUS_COMPLETED_DISMISSED",
  EXPENSES_TOOLKIT_TAB_INTERACTED = "EXPENSES_TOOLKIT_TAB_INTERACTED",
  EXPENSE_FILTERS_EDUCATION_SEEN = "EXPENSE_FILTERS_EDUCATION_SEEN",
  EXPENSE_GROUPING_EDUCATION_SEEN = "EXPENSE_GROUPING_EDUCATION_SEEN",
  FINANCIAL_CONNECTIVITY_BANK_DISCONNECTION_MODAL_DISMISSED = "FINANCIAL_CONNECTIVITY_BANK_DISCONNECTION_MODAL_DISMISSED",
  FINANCIAL_CONNECTIVITY_STALE_FINANCIALS_LIMIT_WARNING_MODAL_DISMISSED = "FINANCIAL_CONNECTIVITY_STALE_FINANCIALS_LIMIT_WARNING_MODAL_DISMISSED",
  GLOBAL_ACCOUNTS_BILLING_ACCOUNTING_MISMATCH_BANNER_DISMISSED = "GLOBAL_ACCOUNTS_BILLING_ACCOUNTING_MISMATCH_BANNER_DISMISSED",
  GLOBAL_ACCOUNTS_ENTITY_MANAGEMENT_BILLING_BANNER_DISMISSED = "GLOBAL_ACCOUNTS_ENTITY_MANAGEMENT_BILLING_BANNER_DISMISSED",
  GLOBAL_ACCOUNTS_REIMBURSEMENT_ACCOUNTING_BANNER_DISMISSED = "GLOBAL_ACCOUNTS_REIMBURSEMENT_ACCOUNTING_BANNER_DISMISSED",
  GLOBAL_ACCOUNTS_REIMBURSEMENT_REQUEST_SOUTH_AFRICA_INFO_BANNER_DISMISSED = "GLOBAL_ACCOUNTS_REIMBURSEMENT_REQUEST_SOUTH_AFRICA_INFO_BANNER_DISMISSED",
  GLOBAL_SEARCH_SCOPED_SEARCH_FILTERS_SEEN = "GLOBAL_SEARCH_SCOPED_SEARCH_FILTERS_SEEN",
  HIGH_RISK_EXPENSE_EDUCATION_SEEN = "HIGH_RISK_EXPENSE_EDUCATION_SEEN",
  INBOX_NAVIGATION_EDUCATION_SEEN = "INBOX_NAVIGATION_EDUCATION_SEEN",
  LIMITS_EXPERIENCE_CREDIT_LIMIT_REQUEST_RESULT_DISMISSED = "LIMITS_EXPERIENCE_CREDIT_LIMIT_REQUEST_RESULT_DISMISSED",
  LIMITS_EXPERIENCE_EXTERNAL_ACCOUNTS_NICKNAME_TOOLTIP_SEEN = "LIMITS_EXPERIENCE_EXTERNAL_ACCOUNTS_NICKNAME_TOOLTIP_SEEN",
  LIMITS_EXPERIENCE_EXTERNAL_ACCOUNTS_NICKNAME_TOOLTIP_STEP_1_SEEN = "LIMITS_EXPERIENCE_EXTERNAL_ACCOUNTS_NICKNAME_TOOLTIP_STEP_1_SEEN",
  LIMITS_EXPERIENCE_EXTERNAL_ACCOUNTS_NICKNAME_TOOLTIP_STEP_2_SEEN = "LIMITS_EXPERIENCE_EXTERNAL_ACCOUNTS_NICKNAME_TOOLTIP_STEP_2_SEEN",
  LIMITS_EXPERIENCE_FRB_BALANCE_DROP_MODAL_SEEN = "LIMITS_EXPERIENCE_FRB_BALANCE_DROP_MODAL_SEEN",
  /**  ! DO NOT DELETE OR RENAME SEEN FLAGS */
  LIMITS_EXPERIENCE_FRB_PREVENT_LIMIT_DROP_BANNER_SEEN = "LIMITS_EXPERIENCE_FRB_PREVENT_LIMIT_DROP_BANNER_SEEN",
  LIMITS_EXPERIENCE_LIMIT_DROP_PENDING_MODAL_SEEN = "LIMITS_EXPERIENCE_LIMIT_DROP_PENDING_MODAL_SEEN",
  LIMITS_EXPERIENCE_SILVERGATE_INSTABILITY_BANNER_SEEN = "LIMITS_EXPERIENCE_SILVERGATE_INSTABILITY_BANNER_SEEN",
  LIMITS_EXPERIENCE_SVB_BALANCE_DROP_MODAL_SEEN = "LIMITS_EXPERIENCE_SVB_BALANCE_DROP_MODAL_SEEN",
  LIMITS_EXPERIENCE_SVB_INSTABILITY_BANNER_SEEN = "LIMITS_EXPERIENCE_SVB_INSTABILITY_BANNER_SEEN",
  LIMITS_EXPERIENCE_SVB_LIMITS_SPEND_VELOCITY_BANNER_SEEN = "LIMITS_EXPERIENCE_SVB_LIMITS_SPEND_VELOCITY_BANNER_SEEN",
  LIMITS_EXPERIENCE_SVB_PREVENT_LIMIT_DROP_BANNER_SEEN = "LIMITS_EXPERIENCE_SVB_PREVENT_LIMIT_DROP_BANNER_SEEN",
  LOCALIZATION_NEW_LANGUAGE_AVAILABLE_MODAL_SEEN = "LOCALIZATION_NEW_LANGUAGE_AVAILABLE_MODAL_SEEN",
  LOCAL_AUTOPAY_ENBALE_BANNER_SEEN = "LOCAL_AUTOPAY_ENBALE_BANNER_SEEN",
  MOBILE_APP_RATING_AFTER_FIRST_RECEIPT_UPLOAD_SEEN = "MOBILE_APP_RATING_AFTER_FIRST_RECEIPT_UPLOAD_SEEN",
  MOBILE_DOWNLOAD_UPSELL_MODAL_SEEN = "MOBILE_DOWNLOAD_UPSELL_MODAL_SEEN",
  MOBILE_SHAKE_TO_REPORT_ANNOUNCEMENT_SEEN = "MOBILE_SHAKE_TO_REPORT_ANNOUNCEMENT_SEEN",
  ONBOARDING_MEDIUM_RISK_TIER_NUDGE_MODAL_SEEN = "ONBOARDING_MEDIUM_RISK_TIER_NUDGE_MODAL_SEEN",
  ONBOARDING_MEDIUM_RISK_TIER_OUTCOME_MODAL_SEEN = "ONBOARDING_MEDIUM_RISK_TIER_OUTCOME_MODAL_SEEN",
  ONBOARDING_YOUR_WALLET_TUTORIAL_DISMISSED = "ONBOARDING_YOUR_WALLET_TUTORIAL_DISMISSED",
  POLICY_DRAG_AND_DROP_INFO_SEEN = "POLICY_DRAG_AND_DROP_INFO_SEEN",
  PRIMITIVES_ONBOARDING_COMPLETED = "PRIMITIVES_ONBOARDING_COMPLETED",
  PRIMITIVES_ONBOARDING_INTERACTED = "PRIMITIVES_ONBOARDING_INTERACTED",
  PRIMITIVES_POLICIES_INTERACTED = "PRIMITIVES_POLICIES_INTERACTED",
  PRODUCTIVITY_DASHBOARD_SEARCH_SEEN = "PRODUCTIVITY_DASHBOARD_SEARCH_SEEN",
  PRODUCT_CONFIG_BILL_PAY_ANNOUNCEMENT_SEEN = "PRODUCT_CONFIG_BILL_PAY_ANNOUNCEMENT_SEEN",
  PRODUCT_CONFIG_TRAVEL_ANNOUNCEMENT_SEEN = "PRODUCT_CONFIG_TRAVEL_ANNOUNCEMENT_SEEN",
  PRODUCT_CONFIG_TRAVEL_SETUP_COMPLETE_SEEN = "PRODUCT_CONFIG_TRAVEL_SETUP_COMPLETE_SEEN",
  /**  ! DO NOT DELETE OR RENAME SEEN FLAGS */
  PRODUCT_LOG_UPDATE_SEEN = "PRODUCT_LOG_UPDATE_SEEN",
  PRODUCT_TERMS_AND_CONDITIONS_BANNER_DISMISSED = "PRODUCT_TERMS_AND_CONDITIONS_BANNER_DISMISSED",
  RECEIPTS_AUTO_MATCHING_MODAL_SEEN = "RECEIPTS_AUTO_MATCHING_MODAL_SEEN",
  REIMBURSEMENTS_CONFIGURE_BILLING_FLOW_EDUCATION_SCREEN_DISMISSED = "REIMBURSEMENTS_CONFIGURE_BILLING_FLOW_EDUCATION_SCREEN_DISMISSED",
  REIMBURSEMENTS_OCR_EDUCATIONAL_MESSAGE_SEEN = "REIMBURSEMENTS_OCR_EDUCATIONAL_MESSAGE_SEEN",
  REPORTS_COMPLIANCE_EDUCATION_BANNER_SEEN = "REPORTS_COMPLIANCE_EDUCATION_BANNER_SEEN",
  REPORTS_NAVIGATION_BADGE_SEEN = "REPORTS_NAVIGATION_BADGE_SEEN",
  REPORTS_SAVE_REMINDER_DISMISSED = "REPORTS_SAVE_REMINDER_DISMISSED",
  REQUEST_REIMBURSEMENT_FLOW_EDUCATION_SCREEN_DISMISSED = "REQUEST_REIMBURSEMENT_FLOW_EDUCATION_SCREEN_DISMISSED",
  REVISIT_EDUCATION_BILL_PAY_TOUR_NEW_TAG_DISMISSED = "REVISIT_EDUCATION_BILL_PAY_TOUR_NEW_TAG_DISMISSED",
  REVISIT_EDUCATION_ENABLED = "REVISIT_EDUCATION_ENABLED",
  REWARDS_DASHPASS_BANNER_DISMISSED = "REWARDS_DASHPASS_BANNER_DISMISSED",
  REWARDS_DASHPASS_BANNER_SEEN = "REWARDS_DASHPASS_BANNER_SEEN",
  REWARDS_OVERVIEW_TAB_INTERACTED = "REWARDS_OVERVIEW_TAB_INTERACTED",
  REWARDS_REFERRALS_WELCOME_MODAL_SEEN = "REWARDS_REFERRALS_WELCOME_MODAL_SEEN",
  RISK_PERIODIC_REVIEW_BLOCKING_EXPERIENCE_SEEN = "RISK_PERIODIC_REVIEW_BLOCKING_EXPERIENCE_SEEN",
  SET_UP_MULTI_ENTITY_BILL_PAY_BANNER_DISMISSED = "SET_UP_MULTI_ENTITY_BILL_PAY_BANNER_DISMISSED",
  SINGAPORE_SMS_BANNER_DISMISSED = "SINGAPORE_SMS_BANNER_DISMISSED",
  SPEND_ADD_TO_SLACK_CLOSED = "SPEND_ADD_TO_SLACK_CLOSED",
  SPEND_ALERTS_ONBOARDING_SEEN = "SPEND_ALERTS_ONBOARDING_SEEN",
  SPEND_AUTOMATION_EXPENSE_MEMO_SUGGESTIONS_UPSELL_DISMISSED = "SPEND_AUTOMATION_EXPENSE_MEMO_SUGGESTIONS_UPSELL_DISMISSED",
  SPEND_COMPLIANCE_FIRST_SPEND_EDUCATION_TOUR_SEEN = "SPEND_COMPLIANCE_FIRST_SPEND_EDUCATION_TOUR_SEEN",
  SPEND_COMPLIANCE_FIRST_TIME_COMPLIANCE_MODAL_SEEN = "SPEND_COMPLIANCE_FIRST_TIME_COMPLIANCE_MODAL_SEEN",
  SPEND_COMPLIANCE_SHOW_DD_MODAL_UPSELL_TO_TOOLTIP_USERS = "SPEND_COMPLIANCE_SHOW_DD_MODAL_UPSELL_TO_TOOLTIP_USERS",
  SPEND_COMPLIANCE_SHOW_RD_MODAL_UPSELL_TO_TOOLTIP_USERS = "SPEND_COMPLIANCE_SHOW_RD_MODAL_UPSELL_TO_TOOLTIP_USERS",
  /**  ! DO NOT DELETE OR RENAME SEEN FLAGS */
  SPEND_DISMISS_CONFIRMATION_MODAL_HIDE = "SPEND_DISMISS_CONFIRMATION_MODAL_HIDE",
  SPEND_ENGAGEMENT_DOCUMENTATION_DEADLINES_UPSELL_SEEN = "SPEND_ENGAGEMENT_DOCUMENTATION_DEADLINES_UPSELL_SEEN",
  SPEND_ENGAGEMENT_REVIEWER_DEADLINES_UPSELL_SEEN = "SPEND_ENGAGEMENT_REVIEWER_DEADLINES_UPSELL_SEEN",
  SPEND_EXPENSE_DETAILS_PANE_V2_TOUR_SEEN = "SPEND_EXPENSE_DETAILS_PANE_V2_TOUR_SEEN",
  SPEND_INSIGHTS_INTRO_DISMISSED = "SPEND_INSIGHTS_INTRO_DISMISSED",
  SPEND_MIGRATION_ADD_VENDORS_TAKEOVER_EDUCATION_DISMISSED = "SPEND_MIGRATION_ADD_VENDORS_TAKEOVER_EDUCATION_DISMISSED",
  SPEND_MIGRATION_REVIEW_ERP_VENDORS_BANNER_DISMISSED = "SPEND_MIGRATION_REVIEW_ERP_VENDORS_BANNER_DISMISSED",
  SPEND_MULTIPLAYER_INTRO_MODAL_COMPLETED = "SPEND_MULTIPLAYER_INTRO_MODAL_COMPLETED",
  SPEND_PREMIUM_SETTINGS_SEEN = "SPEND_PREMIUM_SETTINGS_SEEN",
  SPEND_REPORTS_INTEGRATION_UPSELL_DISMISSED = "SPEND_REPORTS_INTEGRATION_UPSELL_DISMISSED",
  SPEND_REQUESTS_SETUP_BANNER_CARD_REQUESTS_SEEN = "SPEND_REQUESTS_SETUP_BANNER_CARD_REQUESTS_SEEN",
  SPEND_REQUESTS_SETUP_BANNER_REIMBURSEMENTS_SEEN = "SPEND_REQUESTS_SETUP_BANNER_REIMBURSEMENTS_SEEN",
  SPEND_REQUESTS_TAB_INTERACTED = "SPEND_REQUESTS_TAB_INTERACTED",
  SPEND_SETUP_MODAL_SEEN = "SPEND_SETUP_MODAL_SEEN",
  SUPPORT_HUB_CREATE_ISSUE_SEEN = "SUPPORT_HUB_CREATE_ISSUE_SEEN",
  SVB_CARD_UPSELL_MODAL = "SVB_CARD_UPSELL_MODAL",
  SVB_MODAL = "SVB_MODAL",
  TEAM_INVITE_PRIMER_SEEN = "TEAM_INVITE_PRIMER_SEEN",
  TEAM_SHELF_ITEM_FIELDS_LIBRARY_CLICKED = "TEAM_SHELF_ITEM_FIELDS_LIBRARY_CLICKED",
  TEAM_SUPER_ADMIN_INFO_BANNER_SEEN = "TEAM_SUPER_ADMIN_INFO_BANNER_SEEN",
  TEAM_UMA_ENTITY_SETUP_SEEN = "TEAM_UMA_ENTITY_SETUP_SEEN",
  TRAVEL_ESSENTIALS_REWARDS_FREE_TRIPS_SEEN = "TRAVEL_ESSENTIALS_REWARDS_FREE_TRIPS_SEEN",
  TRAVEL_NEW_BADGE_SEEN = "TRAVEL_NEW_BADGE_SEEN",
  TRAVEL_USER_CONSENTED = "TRAVEL_USER_CONSENTED",
  UMA_TOOLTIP_TOUR_COMPLETED = "UMA_TOOLTIP_TOUR_COMPLETED",
  USER_INVITE_PRIMER_SEEN = "USER_INVITE_PRIMER_SEEN",
  WALLET_BUDGET_TOOLTIP_SEEN = "WALLET_BUDGET_TOOLTIP_SEEN",
  WALLET_CARD_TOOLTIP_SEEN = "WALLET_CARD_TOOLTIP_SEEN",
  WALLET_DISCO_EDUCATION_SEEN = "WALLET_DISCO_EDUCATION_SEEN",
  WALLET_V2_BUDGET_TOOLTIP_SEEN = "WALLET_V2_BUDGET_TOOLTIP_SEEN",
  WALLET_V2_INBOX_TOOLTIP_SEEN = "WALLET_V2_INBOX_TOOLTIP_SEEN",
  YOUR_WALLET_MULTIPLE_CARDS_TOOLTIP_SEEN = "YOUR_WALLET_MULTIPLE_CARDS_TOOLTIP_SEEN",
}

export interface SegmentDataV4 {
  segmentV4?: Maybe<SegmentV4>;
  subsegmentV4?: Maybe<SubsegmentV4>;
}

export interface SegmentQueryResult {
  v4?: Maybe<SegmentDataV4>;
}

export enum SegmentV4 {
  EARLY_STAGE = "EARLY_STAGE",
  ENTERPRISE = "ENTERPRISE",
  GROWTH = "GROWTH",
  MID_MARKET = "MID_MARKET",
}

/** V3 of the segmentation responses */
export interface SegmentationDataV3 {
  /** Company type V3 */
  companyType?: InputMaybe<CompanyTypeV3>;
  /** Employee count V3 */
  employeeCount?: InputMaybe<EmployeeCountV3>;
  /** Funding sources V3 */
  fundingSources: Array<FundingSourceV3>;
  /** Sales volume V3 */
  salesVolume?: InputMaybe<SalesVolumeV3>;
}

/** V3 of the segmentation responses */
export interface SegmentationDataV3Output {
  /** Company type V3 */
  companyType?: Maybe<CompanyTypeV3>;
  /** Employee count V3 */
  employeeCount?: Maybe<EmployeeCountV3>;
  /** Funding sources V3 */
  fundingSources?: Maybe<Array<Maybe<FundingSourceV3>>>;
  /** Sales volume V3 */
  salesVolume?: Maybe<SalesVolumeV3>;
}

export interface SegmentationInfoInput {
  /** v3 of segmentation data */
  v3?: InputMaybe<SegmentationDataV3>;
}

/** Contains the parameters to collect information of Select type. */
export interface SelectInformation {
  /** Type of the information requirement */
  displayType: RequirementInformationFieldDisplayType;
  /** Identifier of the information requirement */
  key: Scalars["String"];
  /** Name of the information requirement to be displayed */
  name: Scalars["String"];
  /** List of valid values for this information requirement */
  valuesAllowed: Array<RequirementInformationFieldValue>;
}

export enum SelectionState {
  /** Value for customers who saw this option and explicitly de-selected it */
  NOT_SELECTED = "NOT_SELECTED",
  /** Value for customers who selected this option */
  SELECTED = "SELECTED",
}

export interface SelfAttestAccountTypePair {
  financialAccountId: Scalars["ID"];
  selfAttestAccountType?: InputMaybe<SelfAttestationAccountType>;
}

/**
 * NOTE All types, queries and mutations related to ExampleUser are generated to provide a working
 * example for getting a new DGS up and running, but should be removed before deploying this service
 * to prevent them being registered in the schema registry.
 */
export enum SelfAttestationAccountType {
  BUSINESS = "BUSINESS",
  CONSUMER = "CONSUMER",
  INELIGIBLE = "INELIGIBLE",
  INVALID = "INVALID",
  NOT_SELECTED = "NOT_SELECTED",
}

export interface SelfInitiateBankStatementRequestInput {
  /** clientMutationId client-supplied idempotency key for a given mutation request. */
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** The number of hours that we will use for the due date */
  dueDateInHours: Scalars["Int"];
  /** Optionally a financial account id */
  financialAccountId?: InputMaybe<Scalars["ID"]>;
  /** The number of periods for which the request will cover (considering monthly) */
  numberOfPeriods?: InputMaybe<Scalars["Int"]>;
}

export enum SelfServeEmailChangeStatus {
  DISABLED = "DISABLED",
  ENABLED = "ENABLED",
}

export interface SemiMonthlyClosingStrategy {
  firstDay?: Maybe<Scalars["Int"]>;
  secondDay?: Maybe<Scalars["Int"]>;
}

export interface SemiMonthlyDetails {
  /** First day of a semi monthly plan (1st is default) */
  firstDay?: Maybe<Scalars["Int"]>;
  /** Second day of a semi monthly plan (15th is default) */
  secondDay?: Maybe<Scalars["Int"]>;
}

export interface SemiWeeklyClosingStrategy {
  firstDay?: Maybe<Scalars["Int"]>;
  secondDay?: Maybe<Scalars["Int"]>;
}

export interface SemiWeeklyDetails {
  /**
   * First day of a semi weekly plan (1 is Sunday)
   * https://hexdocs.pm/elixir/1.12/Date.html#day_of_week/2
   */
  firstDay?: Maybe<Scalars["Int"]>;
  /**
   * Second day of a semi weekly plan (7 is Saturday)
   * https://hexdocs.pm/elixir/1.12/Date.html#day_of_week/2
   */
  secondDay?: Maybe<Scalars["Int"]>;
}

export interface SendBeneficiaryOptCodeError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface SendBeneficiaryOtpCodeInput {
  /** The beneficiaries IDs that the OTP code is being generated for */
  trustedBeneficiariesIds: Array<Scalars["ID"]>;
}

export interface SendBeneficiaryOtpCodeResult extends MutationResult {
  errors?: Maybe<Array<SendBeneficiaryOptCodeError>>;
  result?: Maybe<Array<TrustedBeneficiary>>;
}

export interface SendBillPaymentInput {
  clientMutationId: Scalars["String"];
  contactVersion?: InputMaybe<Scalars["Int"]>;
  id: Scalars["ID"];
  idempotencyKey: Scalars["String"];
  paymentInstrumentVersion?: InputMaybe<Scalars["Int"]>;
}

export interface SendBillPaymentPayload {
  bill?: Maybe<Bill>;
  clientMutationId: Scalars["String"];
}

export interface SendBillPaymentV2Input {
  clientMutationId: Scalars["String"];
  contactVersion: Scalars["Int"];
  id: Scalars["ID"];
  paymentInstrumentVersion: Scalars["Int"];
}

export interface SendBookingRemindersInput {
  attendeeIds?: InputMaybe<Array<Scalars["ID"]>>;
  clientMutationId: Scalars["String"];
  groupEventId: Scalars["ID"];
}

export interface SendBookingRemindersResult {
  error?: Maybe<Scalars["String"]>;
}

export interface SendCardToVendorInput {
  clientMutationId: Scalars["String"];
  expenseId: Scalars["ID"];
  vendorId: Scalars["ID"];
}

export interface SendCardToVendorResult extends MutationResult {
  errors?: Maybe<Array<VendorMutationError>>;
  result?: Maybe<VendorDetails>;
}

export interface SendCommsMetadata {
  percentageThreshold: Scalars["Int"];
  sendCommsType: LimitUtilizationTriggerConfigurationSendCommsType;
}

export interface SendInvitesInput {
  attendeeIds?: InputMaybe<Array<Scalars["ID"]>>;
  clientMutationId: Scalars["String"];
  groupEventId: Scalars["ID"];
  inviteMessage?: InputMaybe<Scalars["String"]>;
}

export interface SendInvitesResult {
  error?: Maybe<Scalars["String"]>;
}

export interface SendInvoiceInput {
  clientMutationId: Scalars["String"];
  idempotencyKey: Scalars["String"];
  invoiceId: Scalars["ID"];
}

export interface SendInvoicePayload {
  clientMutationId: Scalars["String"];
  invoice?: Maybe<InvoicingInvoice>;
}

export interface SendInvoiceReminderV1Input {
  /** Idempotency key. */
  idempotencyKey: Scalars["String"];
  /** Base invoice id. */
  invoiceId: Scalars["ID"];
}

export interface SendInvoiceReminderV1Result extends MutationResult {
  errors?: Maybe<Array<InvoicingV1ClientError>>;
  success: Scalars["Boolean"];
}

export interface SendInvoiceV1Input {
  /** List of emails to send the invoice as cc. */
  ccRecipients?: InputMaybe<Array<Scalars["String"]>>;
  /** A unique idempotency key. */
  idempotencyKey: Scalars["String"];
  /** ID of the invoice to be sent. */
  invoiceId: Scalars["ID"];
}

/** SendMessageToRepresentative input */
export interface SendMessageToRepresentativeInput {
  /** Associated Brex object (e.g. dispute) */
  brexObjectId?: InputMaybe<Scalars["String"]>;
  /** Unique identifier of this mutation */
  clientMutationId: Scalars["String"];
  /** Associated documents' tokens */
  documentTokens?: InputMaybe<Array<Scalars["String"]>>;
  /** Salesforce Case Sub Category. Defaults to empty string */
  issueSubType?: InputMaybe<Scalars["String"]>;
  /** Type of issue. Defaults to General Support */
  issueType?: InputMaybe<IssueType>;
  /** Message body */
  messageBody?: InputMaybe<Scalars["String"]>;
}

/** SendMessageToRepresentative output */
export interface SendMessageToRepresentativePayload {
  /** Unique identifier of this mutation */
  clientMutationId: Scalars["String"];
  /** Whether the message was successfully sent or not */
  success: Scalars["Boolean"];
}

export interface SendMfaResetError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface SendMfaResetTokenInput {
  userId: Scalars["String"];
}

export interface SendMfaResetTokenResult extends MutationResult {
  errors?: Maybe<Array<SendMfaResetError>>;
}

export interface SendMobileChequeDepositNotificationInput {
  clientMutationId: Scalars["String"];
  phoneNumber: Scalars["String"];
}

export interface SendMobileChequeDepositNotificationPayload {
  clientMutationId: Scalars["String"];
}

export interface SendRsvpRemindersInput {
  attendeeIds?: InputMaybe<Array<Scalars["ID"]>>;
  clientMutationId: Scalars["String"];
  groupEventId: Scalars["ID"];
}

export interface SendRsvpRemindersResult {
  error?: Maybe<Scalars["String"]>;
}

export interface SendUserInviteEmailsInput {
  /** IDs of the Users to send invite email to. */
  userIds: Array<Scalars["ID"]>;
}

export interface SendUserInviteEmailsResult {
  /** If there was an error sending the email, it will be returned here. */
  errors: Array<UserError>;
  /** The IDs of the Users that were successfully sent an invite email. */
  usersSuccessfullySentEmail: Array<Scalars["ID"]>;
}

/** An internal system actor (eg, SCIM, HRIS, etc) */
export interface ServiceActor extends Displayable {
  displayName: Scalars["String"];
}

export type ServiceProviderDetails = OidcServiceDetails | SamlServiceProvider;

export interface ServicingPolicy extends Node {
  closingStrategy?: Maybe<ClosingStrategy>;
  collectedNumDaysAfterClose?: Maybe<Scalars["Int"]>;
  delinquentNumDaysAfterClose?: Maybe<Scalars["Int"]>;
  /** The ID of an object */
  id: Scalars["ID"];
}

/** Result for the getServicingState query, with the servicing state result */
export interface ServicingState {
  /** Timestamp when this information was queried */
  asOf: Scalars["Time"];
  /** Customer Account Id for the account */
  customerAccountId: Scalars["String"];
  /** Journal Account Id for the account */
  journalAccountId: Scalars["String"];
  /** Servicing State Status for the account */
  status: ServicingStateStatus;
}

/** Enumerates all possible Servicing State Status */
export enum ServicingStateStatus {
  /** Status: Charged Off */
  CHARGED_OFF = "CHARGED_OFF",
  /** Status: Current */
  CURRENT = "CURRENT",
  /** Status: Delinquent */
  DELINQUENT = "DELINQUENT",
  /** Invalid Status */
  INVALID = "INVALID",
}

export enum SessionStatus {
  /**  session information not found in token */
  NOT_FOUND = "NOT_FOUND",
  /**  session information found in token */
  SIGNED_IN = "SIGNED_IN",
  /**  session information not found and user just signed up recently */
  SIGNED_UP = "SIGNED_UP",
}

export interface SetAccountLocaleInput {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  languageTag?: InputMaybe<Scalars["String"]>;
}

export interface SetAccountRestrictAchDebitsInput {
  clientMutationId: Scalars["String"];
  depositsAccountId: Scalars["ID"];
  restrictAchDebits: Scalars["Boolean"];
}

export interface SetAccountRestrictAchDebitsPayload {
  clientMutationId: Scalars["String"];
  restrictAchDebits: Scalars["Boolean"];
}

export interface SetAccountSettingsResult extends MutationResult {
  account?: Maybe<Account>;
  clientMutationId?: Maybe<Scalars["String"]>;
  errors?: Maybe<Array<SetEntitySettingsError>>;
  success: Scalars["Boolean"];
}

export interface SetAccountingJournalEntriesReviewStatusResult {
  entries?: Maybe<Array<Maybe<AccountingJournalEntry>>>;
  failedEntryIds?: Maybe<Array<Scalars["ID"]>>;
}

export interface SetAccountingJournalEntryReviewStatusResult {
  entry: AccountingJournalEntry;
}

/** VX Workflow Action to set a Field */
export interface SetAction {
  /** The field to set. */
  leftHandSide: LeftHandSide;
  /** The field value that will be set */
  rightHandSide: RightHandSide;
}

/** VX Workflow Action to set a Field */
export interface SetActionInput {
  /** The field to set. */
  leftHandSide: LeftHandSideOneOfInput;
  /** The field value that will be set */
  rightHandSide: RightHandSideOneOfInput;
}

export interface SetApprovalsUnsafeFlagInput {
  clientMutationId: Scalars["String"];
  flagName: Scalars["String"];
  keyType: ApprovalsUnsafeFlagKeyType;
  value: Scalars["String"];
}

export interface SetApprovalsUnsafeFlagPayload {
  clientMutationId: Scalars["String"];
  value?: Maybe<Scalars["String"]>;
}

export interface SetAutomationWorkflowSpecStatusInput {
  id: Scalars["ID"];
  status: AutomationWorkflowSpecStatus;
}

export interface SetAutomationWorkflowSpecStatusesResult {
  specs?: Maybe<Array<AutomationWorkflowSpec>>;
}

/** Input for setCardLimitSource */
export interface SetCardLimitSourceInput {
  cardId: Scalars["ID"];
  limitId: Scalars["String"];
  limitSourceType: CardLimitSource;
}

export interface SetCardLimitSourceMutationResult extends MutationResult {
  errors?: Maybe<Array<CardClientError>>;
  result?: Maybe<Card>;
}

export interface SetCorporateCardAccessInput {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** A user's employee id */
  id: Scalars["ID"];
  isCorporateCardEnabled: Scalars["Boolean"];
}

export interface SetCorporateCardAccessResult {
  id: Scalars["ID"];
}

export interface SetDepositsTransactionPaymentMemoInput {
  clientMutationId: Scalars["String"];
  memo?: InputMaybe<Scalars["String"]>;
  transactionId: Scalars["ID"];
}

export interface SetDepositsTransactionPaymentMemoPayload {
  clientMutationId: Scalars["String"];
  transaction: DepositsTransaction;
}

export interface SetEntityAutopayFundingSourceInput {
  /** Chosen funding source for autopay for product/entity */
  fundingSourceId: Scalars["String"];
  /**
   * Legal Entity Id
   * Not passing this value will set the default entity for the customer.
   * This is desired for Transaction Fees and SAAS Billing which are not billed by entity
   */
  legalEntityId?: InputMaybe<Scalars["String"]>;
  /** Enum representing the product type associated with an autopay funding source */
  productType: FundingSourceProductType;
}

export interface SetEntitySettingsError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface SetEntriesReviewStatusInput {
  /** Specifies the type of accounting method to be used (Accrual or Actual). */
  accountingMethodType?: InputMaybe<AccountingMethodType>;
  /**
   * [oneOf] Filter to find accounting records to set the review status for.
   * Exactly one of [filter, entityFilter, entryIds, accountingRecordFilter] must be specified.
   * An exception will be thrown if none or multiple are passed.
   */
  accountingRecordFilter?: InputMaybe<AccountingRecordFilterInput>;
  /**
   * [oneOf] Entity Filter to find entries to set the review status for.
   *         NOTE: new uses cases should use accountingRecordFilter over filter
   * Exactly one of [filter, entityFilter, entryIds, accountingRecordFilter] must be specified.
   * An exception will be thrown if none or multiple are passed.
   */
  entityFilter?: InputMaybe<EntityFilterInput>;
  /**
   * [oneOf] Entry IDs to set the review status for.
   * Exactly one of [filter, entityFilter, entryIds, accountingRecordFilter] must be specified.
   * An exception will be thrown if none or multiple are passed.
   */
  entryIds?: InputMaybe<Array<Scalars["ID"]>>;
  /**
   * [oneOf] Filter to find entries to set the review status for.
   *         NOTE: new uses cases should use accountingRecordFilter over filter
   * Exactly one of [filter, entityFilter, entryIds, accountingRecordFilter] must be specified.
   * An exception will be thrown if none or multiple are passed.
   */
  filter?: InputMaybe<AccountingJournalEntryFilterInput>;
  /** The currently active integration. Should be set whenever filter is set. */
  integrationId?: InputMaybe<Scalars["ID"]>;
  reviewStatus: AccountingJournalEntryReviewStatus;
}

export interface SetEntryReviewStatusInput {
  entryId: Scalars["ID"];
  reviewStatus: AccountingJournalEntryReviewStatus;
}

export interface SetFinancialAccountNicknameInput {
  financialAccountId: Scalars["ID"];
  nickname?: InputMaybe<Scalars["String"]>;
}

export interface SetFinancialAccountNicknameResult {
  id?: Maybe<Scalars["String"]>;
}

export interface SetFundingSourceAsPrimaryForEntityInput {
  clientMutationId: Scalars["String"];
  fundingSourceId: Scalars["ID"];
  legalEntityId: Scalars["ID"];
  productType?: InputMaybe<FundingSourceEntityPriorityProductType>;
}

export interface SetFundingSourceAsPrimaryForEntityPayload {
  clientMutationId: Scalars["String"];
  fundingSource: FundingSource;
}

export interface SetFundsAllocationInput {
  customerAccountId: Scalars["ID"];
  fundsAllocations: Array<InputMaybe<FundsAllocation>>;
  idempotencyKey: Scalars["String"];
}

export interface SetInitialAutopayFundingSourceInput {
  clientMutationId: Scalars["String"];
  fundingSourceId: Scalars["ID"];
}

export interface SetInitialAutopayFundingSourcePayload {
  clientMutationId: Scalars["String"];
  fundingSource: FundingSource;
}

export interface SetIntegrationFieldInactiveInput {
  clientMutationId: Scalars["String"];
  /** integration field id */
  id: Scalars["ID"];
  /** is inactive status */
  isInactive: Scalars["Boolean"];
}

export interface SetIntegrationFieldInactivePayload {
  clientMutationId: Scalars["String"];
}

export interface SetLegalEntityLocaleInput {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  languageTag?: InputMaybe<Scalars["String"]>;
  /**
   * If null, changes the user's legal entity locale. Only account admins are
   * allowed to change the legal entity's locale.
   */
  legalEntityId?: InputMaybe<Scalars["ID"]>;
}

export interface SetLimitActionInput {
  newLimit: FinancialAssetInput;
}

export interface SetManagerInput {
  clientMutationId: Scalars["String"];
  managerId?: InputMaybe<Scalars["ID"]>;
  reportIds: Array<InputMaybe<Scalars["ID"]>>;
}

export interface SetManagerPayload {
  clientMutationId: Scalars["String"];
  users?: Maybe<Array<Maybe<User>>>;
}

export interface SetMileageSettingsResult {
  status: SetMileageSettingsStatus;
}

export enum SetMileageSettingsStatus {
  ERROR = "ERROR",
  SUCCESS = "SUCCESS",
}

export interface SetPrimaryFundingSourceInput {
  clientMutationId: Scalars["String"];
  fundingSourceId: Scalars["ID"];
}

export interface SetPrimaryFundingSourcePayload {
  clientMutationId: Scalars["String"];
  fundingSource: FundingSource;
}

export interface SetSelfServeEmailUpdateAccessInput {
  /** The new status to set. */
  status: SelfServeEmailChangeStatus;
}

export interface SetSelfServeEmailUpdateAccessResult extends MutationResult {
  errors?: Maybe<Array<ChangeEmailOperationError>>;
  result?: Maybe<SelfServeEmailChangeStatus>;
}

export interface SetSsoUserRulesError extends SsoClientError {
  code?: Maybe<SsoClientErrorCode>;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export type SetSsoUserRulesResult = SetSsoUserRulesError | SsoUserRule;

export interface SetUserListRuleInput {
  userIds: Array<Scalars["String"]>;
}

export interface SetUserLocaleInput {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  languageTag?: InputMaybe<Scalars["String"]>;
  /**
   * If null, changes the user's locale. Only account admins are allowed
   * to change other users' locales.
   */
  userId?: InputMaybe<Scalars["ID"]>;
}

export interface SetUserPrimaryCardInput {
  /** The ID of the card to set as primary */
  cardId: Scalars["ID"];
  /** The client mutation id */
  clientMutationId?: InputMaybe<Scalars["String"]>;
}

export interface SetUserPrimaryCardPayload {
  card: Card;
}

export interface SetUserSettingsResult extends MutationResult {
  clientMutationId?: Maybe<Scalars["String"]>;
  errors?: Maybe<Array<SetEntitySettingsError>>;
  success: Scalars["Boolean"];
  user?: Maybe<User>;
}

export type SetupInstructions = ExpensifySetupInstructions;

export interface SetupMfaInput {
  clientMutationId: Scalars["String"];
  mfaDeviceType: MfaPrimaryMethod;
  phoneNumber: Scalars["String"];
}

export interface SetupMfaPayload {
  clientMutationId: Scalars["String"];
  deviceId: Scalars["String"];
  deviceSecret?: Maybe<Scalars["String"]>;
}

/**
 * Singapore's banking code.
 * Format is 4-digits identifying a bank.
 */
export interface SgLocal {
  accountNumber?: Maybe<Scalars["String"]>;
  bankCode?: Maybe<Scalars["String"]>;
}

/**
 * Singapore's banking code.
 * Format is 4-digits identifying a bank.
 */
export interface SgLocalInput {
  accountNumber?: InputMaybe<Scalars["String"]>;
  bankCode?: InputMaybe<Scalars["String"]>;
}

export interface SharedBankAccount {
  accountNumberLast2: Scalars["String"];
  bankName: Scalars["String"];
  routingNumber: Scalars["String"];
}

/** All qualified users will be added to a shared budget. */
export interface SharedBudgetDistributionSettings {
  /** User Filters. */
  userFilters: BudgetDistributionUserFilters;
  /** The user group to be associated with this distribution. If null, will convert from the user filters. */
  userGroup?: InputMaybe<UserGroupInput>;
}

export interface SharedCardDetails {
  /** The group associated with the card */
  group?: Maybe<Group>;
  /** The ID representing the sharing details of the card */
  id: Scalars["ID"];
  /** Whether the current user is an authorized user on the shared card */
  isAuthorizedUser?: Maybe<Scalars["Boolean"]>;
  /** Card alias for the current user */
  userAlias?: Maybe<CardAlias>;
}

export interface ShippingAddress {
  address: Address;
  firstName: Scalars["String"];
  lastName: Scalars["String"];
}

export interface ShippingAddressInput {
  address: AddressInput;
  firstName: Scalars["String"];
  lastName: Scalars["String"];
}

export interface ShippingCourierServiceAddendum extends ExpenseAddendum {
  /** The unique ID of the expense addendum. */
  id: Scalars["ID"];
  /** Service descriptor codes for the shipping service. */
  serviceDescriptorCodes?: Maybe<Scalars["String"]>;
  /** The tracking number for the shipping service. */
  trackingNumber?: Maybe<Scalars["String"]>;
}

/** Shipping Event */
export interface ShippingEvent {
  /**
   * Shipping event update time.
   * Note: this is local date time, we are using the ISOz format in here due to the platform limitation.
   */
  date: Scalars["Time"];
  /** Package location for the shipping event */
  location?: Maybe<ShippingEventAddress>;
  /** Shipping event message */
  message: Scalars["String"];
  /** Status for Shipping Event */
  status: ShippingStatus;
}

/** Another form of Address object, only used in the card shipping dgs service. */
export interface ShippingEventAddress {
  /** Address 1 info */
  address1?: Maybe<Scalars["String"]>;
  /** Address 2 info */
  address2?: Maybe<Scalars["String"]>;
  /** City name */
  city: Scalars["String"];
  /** Country name */
  country: Scalars["String"];
  /** State name */
  state: Scalars["String"];
  /** Zip or Portal code */
  zip?: Maybe<Scalars["String"]>;
}

export enum ShippingMethod {
  EXPEDITED = "EXPEDITED",
  OVERNIGHT = "OVERNIGHT",
  REGULAR = "REGULAR",
}

/** Enum for Shipping Status */
export enum ShippingStatus {
  ATTEMPT_FAILED = "ATTEMPT_FAILED",
  AVAILABLE_FOR_PICKUP = "AVAILABLE_FOR_PICKUP",
  CANCELED = "CANCELED",
  DELAYED = "DELAYED",
  DELIVERED = "DELIVERED",
  EXPIRED = "EXPIRED",
  FAILED = "FAILED",
  INFORMATION_RECEIVED = "INFORMATION_RECEIVED",
  IN_TRANSIT = "IN_TRANSIT",
  ISSUE_WITH_DELIVERY = "ISSUE_WITH_DELIVERY",
  NO_TRACKING_NUMBER_EDD_REACHED = "NO_TRACKING_NUMBER_EDD_REACHED",
  ORDERED = "ORDERED",
  OUT_FOR_DELIVERY = "OUT_FOR_DELIVERY",
  PENDING = "PENDING",
  PICKUP_MISSED = "PICKUP_MISSED",
  SHIPPED = "SHIPPED",
}

export interface ShopifyAuthPayloadInput {
  id: Scalars["ID"];
  redirectUrl: Scalars["String"];
  shopName: Scalars["String"];
}

export interface ShopifyPayload {
  accessToken?: Maybe<Scalars["String"]>;
  connectNonce?: Maybe<Scalars["String"]>;
  shopName?: Maybe<Scalars["String"]>;
}

export interface ShouldDisplayFinancialStatementExperienceResponse {
  shouldDisplay: Scalars["Boolean"];
}

/** Determines which legal agreements to display on 'set password' page for invited user */
export interface ShouldSeeLegalAgreementsResponse {
  /** Company name */
  dbaName?: Maybe<Scalars["String"]>;
  /** Whether to show platform agreement */
  showPlatformAgreement?: Maybe<Scalars["Boolean"]>;
}

export interface ShouldWithdrawPointsResponse {
  allowed: Scalars["Boolean"];
}

/** Signup Payload */
export interface Signup {
  /** Attribution token for the signup */
  attributionToken?: Maybe<Scalars["String"]>;
  /** Industry for the signup. */
  companyIndustry?: Maybe<Scalars["String"]>;
  /** Company name for the signup. */
  companyName?: Maybe<Scalars["String"]>;
  /** Customer Account ID */
  customerAccountId?: Maybe<Scalars["ID"]>;
  /** Customer User ID */
  customerUserId?: Maybe<Scalars["ID"]>;
  /** List of funding sources for the signup. */
  fundingSources: Array<FundingSourceV2>;
  /** Signup primary key */
  id: Scalars["ID"];
  /** Whether or not this customer was referred by a banking partner. */
  isBankPartnerReferral: Scalars["Boolean"];
  /** Flag indicating whether companyType needs to be populated. */
  needsCompanyTypeSubmission: Scalars["Boolean"];
  /** Flag indicating whether company url needs to be populated. */
  needsCompanyUrlSubmission: Scalars["Boolean"];
  /** Flag indicating whether employee count needs to be populated. */
  needsEmployeeCountSubmission: Scalars["Boolean"];
  /** Flag indicating whether segmentation questions need to be populated. */
  needsSegmentationSubmission: Scalars["Boolean"];
  /** RefCodes associated with the signup. */
  refCodes: Array<Scalars["String"]>;
  /** SalesVolume for the signup. */
  salesVolume?: Maybe<SalesVolumeV1>;
}

export enum SignupCohort {
  SB_WAITLIST_BYPASS_PILOT = "SB_WAITLIST_BYPASS_PILOT",
}

export interface SignupCompanyInput {
  /** industry of the company */
  industry?: InputMaybe<Scalars["String"]>;
  /** name of the company */
  name: Scalars["String"];
  /** information used to segment the company */
  segmentationInfo?: InputMaybe<SegmentationInfoInput>;
  /** website of the company */
  website?: InputMaybe<Scalars["String"]>;
}

export interface SignupInitialUserError extends StandardClientError {
  /** error code of error */
  code: ErrorCode;
  /** error message */
  message?: Maybe<Scalars["String"]>;
  /** optional path to field that caused error */
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface SignupInitialUserInput {
  /** Idempotency key for this request */
  clientMutationId: Scalars["String"];
  /** Signup information of the company */
  company: SignupCompanyInput;
  /** Signup metadata of the company */
  metadata: SignupMetadataInput;
  /** Signup information of the user */
  user: SignupUserInput;
}

export interface SignupInitialUserResponse {
  /** customerAccountId of signup */
  customerAccountId: Scalars["String"];
  /** customerUserId of signup */
  customerUserId: Scalars["String"];
  /** generated token from identity */
  token: Scalars["String"];
}

export interface SignupInitialUserResult extends MutationResult {
  /** list of errors if exists */
  errors?: Maybe<Array<SignupInitialUserError>>;
  /** result of SignupInitialUser */
  result?: Maybe<SignupInitialUserResponse>;
}

export interface SignupMetadataInput {
  /** attribution metadata */
  attribution?: InputMaybe<AttributionMetadataInput>;
  /** blackbox information. Likely deprecated */
  blackbox?: InputMaybe<Scalars["String"]>;
  /** identifier generated from associated Lead */
  leadToken?: InputMaybe<Scalars["String"]>;
  /** List of legal agreements */
  legalAgreements: Array<InputMaybe<LegalAgreementInput>>;
  /** marketing metadata */
  marketing?: InputMaybe<MarketingMetadataInput>;
  /** redirectUrl */
  redirectUrl: Scalars["String"];
  /** referral codes associated with the signup */
  referralCodes?: InputMaybe<ReferralCodesInput>;
  /** Any experiment cohorts this customer was included in at time of signup */
  signupCohorts?: InputMaybe<Array<SignupCohort>>;
}

export interface SignupUserInput {
  /** email of the user */
  email: Scalars["String"];
  /** First name of the user */
  firstName: Scalars["String"];
  /** Last name of the user */
  lastName: Scalars["String"];
  /** password of the user */
  password: Scalars["String"];
}

export interface SimulateAttendeesAddendumInput {
  /** Attendees who are not on the Brex system */
  externalAttendees: Array<SimulateExternalAttendeeInput>;
  /** Attendees who are on the Brex system on the same account as the expense. */
  internalAttendees: Array<SimulateInternalAttendeeInput>;
}

export interface SimulateExpenseRequestExtendedFieldValueInput {
  isDeleted?: InputMaybe<Scalars["Boolean"]>;
  key: Scalars["String"];
  values?: InputMaybe<Array<RequestFieldValueOneOfInput>>;
}

export interface SimulateExpenseRequestInput {
  /** The attendees addendum to add to this expense. */
  addedAttendeesAddendum?: InputMaybe<SimulateAttendeesAddendumInput>;
  /** Amount of the expense; may be negative */
  amount?: InputMaybe<FinancialAssetInput>;
  /** The budget to which this expense accrues (optional if no spend limit is selected) */
  budgetId?: InputMaybe<Scalars["ID"]>;
  /** Id associated with this graphql mutation request */
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** The Customer Department to which the expense is attributed, auto-denormalized from User */
  departmentId?: InputMaybe<Scalars["ID"]>;
  /** The expense type (reimbursement or card) */
  expenseType: ExpenseType;
  /** The extended field values */
  extendedFieldValues?: InputMaybe<
    Array<InputMaybe<SimulateExpenseRequestExtendedFieldValueInput>>
  >;
  /** The Customer Location to which the expense is attributed, auto-denormalized from User */
  locationId?: InputMaybe<Scalars["ID"]>;
  /** The memo line */
  memo?: InputMaybe<Scalars["String"]>;
  /** The category to which this expense belongs to, auto-denormalized from Merchant */
  merchantCategoryId?: InputMaybe<Scalars["ID"]>;
  /** The merchant counter-party */
  merchantId?: InputMaybe<Scalars["ID"]>;
  /** The merchant name */
  merchantName?: InputMaybe<Scalars["String"]>;
  /** The time of purchase */
  purchasedAt?: InputMaybe<Scalars["Time"]>;
  /** The number of receipts that would be submitted with the expense */
  receiptCount?: InputMaybe<Scalars["Int"]>;
}

export interface SimulateExternalAttendeeInput {
  /** The company at which this attendee works */
  companyName?: InputMaybe<Scalars["String"]>;
  /** Whether or not this attendee is flagged as a government official by the user */
  isGovernmentOfficial?: InputMaybe<Scalars["Boolean"]>;
  /** The name of this attendee */
  name: Scalars["String"];
  /** The job title of this attendee */
  title?: InputMaybe<Scalars["String"]>;
}

export interface SimulateInternalAttendeeInput {
  /** Customer user ID of the attendee */
  customerUserId: Scalars["ID"];
}

export interface SimulateRequestResults {
  /** Result includes a list of RequestActions with the PolicyReasons nested within each RequestAction. */
  results?: Maybe<Array<Maybe<RequestAction>>>;
}

export interface SkipVendorFileMatchAutoMigrationInput {
  /** The vendor file match IDs to skip auto migration for */
  vendorFileMatchIds: Array<Scalars["ID"]>;
}

export interface SkipVendorFileMatchAutoMigrationMutationError
  extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface SkipVendorFileMatchAutoMigrationResult extends MutationResult {
  errors?: Maybe<Array<SkipVendorFileMatchAutoMigrationMutationError>>;
}

export interface SoftExpirationSummary {
  isSoftExpired?: Maybe<Scalars["Boolean"]>;
  softExpiresAt?: Maybe<Scalars["Time"]>;
}

export enum SortOrder {
  SORT_ASC = "SORT_ASC",
  SORT_DESC = "SORT_DESC",
}

export enum SortableBillField {
  AMOUNT = "AMOUNT",
  CREATED_AT = "CREATED_AT",
  DUE_AT = "DUE_AT",
  EXTERNAL_INVOICE_NUMBER = "EXTERNAL_INVOICE_NUMBER",
  PAYMENT_SEND_AT = "PAYMENT_SEND_AT",
}

export enum SortableBillingTransactionField {
  AMOUNT = "AMOUNT",
  POSTED_AT = "POSTED_AT",
}

/** Available fields to order budget employees by */
export enum SortableBudgetEmployeeField {
  ADDED_VERSION = "ADDED_VERSION",
  AMOUNT_SPENT = "AMOUNT_SPENT",
  NAME = "NAME",
}

/** Available fields to order the Budget connection by. */
export enum SortableBudgetField {
  AMOUNT_SPENT = "AMOUNT_SPENT",
  CREATED_AT = "CREATED_AT",
  END_DATE = "END_DATE",
  LIMIT = "LIMIT",
  NAME = "NAME",
  START_DATE = "START_DATE",
  STATUS = "STATUS",
}

/** Available fields to order the BudgetTreeNode connection by. */
export enum SortableBudgetTreeNodeField {
  CREATED_AT = "CREATED_AT",
  END_DATE = "END_DATE",
  NAME = "NAME",
  START_DATE = "START_DATE",
  STATUS = "STATUS",
}

/** Available fields to order spend limit personnel by */
export enum SortableBudgetTreeNodePersonnelField {
  ADDED_ON = "ADDED_ON",
  AMOUNT_SPENT = "AMOUNT_SPENT",
  NAME = "NAME",
}

/** Available fields to sort Cards by */
export enum SortableCardField {
  DISPLAY_NAME = "DISPLAY_NAME",
  HOLDER_NAME = "HOLDER_NAME",
  INSTRUMENT_TYPE = "INSTRUMENT_TYPE",
  ISSUED_AT = "ISSUED_AT",
  LAST_FOUR = "LAST_FOUR",
  USER_FULL_NAME = "USER_FULL_NAME",
}

/** Available fields to order the Category connection by. */
export enum SortableCategoryField {
  CATEGORY_NAME = "CATEGORY_NAME",
}

/** Available fields to order the Comment connection by. */
export enum SortableCommentField {
  CREATED_AT = "CREATED_AT",
}

export enum SortableEventAttendeesField {
  ADDED_AT = "ADDED_AT",
  ATTENDANCE_STATUS = "ATTENDANCE_STATUS",
  EMAIL = "EMAIL",
  NAME = "NAME",
  REQUIREMENTS = "REQUIREMENTS",
}

/** Available fields to order the Expense connection by. */
export enum SortableExpenseField {
  ACCRUED_AT = "ACCRUED_AT",
  AMOUNT = "AMOUNT",
  PURCHASED_AT = "PURCHASED_AT",
}

/** Available field to order expense's financial asset movements by */
export enum SortableExpenseFinancialAssetMovementField {
  INITIATED_AT = "INITIATED_AT",
}

export enum SortableGroupEventField {
  END_DATE = "END_DATE",
  INSERTED_AT = "INSERTED_AT",
  NAME = "NAME",
  START_DATE = "START_DATE",
  STATUS = "STATUS",
}

/** Available fields to order the invoicing customer connection by. */
export enum SortableInvoicingCustomerField {
  INVOICING_CUSTOMER_NAME = "INVOICING_CUSTOMER_NAME",
}

/** Available fields to order the limit group connection by. */
export enum SortableLimitGroupField {
  CREATED_AT = "CREATED_AT",
  END_DATE = "END_DATE",
  NAME = "NAME",
  START_DATE = "START_DATE",
  STATUS = "STATUS",
}

/** Available fields to order the LimitGroupOrSpendLimit connection by. */
export enum SortableLimitGroupOrSpendLimitField {
  CREATED_AT = "CREATED_AT",
  END_DATE = "END_DATE",
  NAME = "NAME",
  START_DATE = "START_DATE",
  STATUS = "STATUS",
}

/** Available fields to order policies by. */
export enum SortablePolicyField {
  INSERTED_AT = "INSERTED_AT",
  UPDATED_AT = "UPDATED_AT",
}

/** Enum defining the fields that can be used for sorting purchase orders. */
export enum SortablePurchaseOrderField {
  /** Sort by the purchase order date (date of issue) */
  PO_DATE = "PO_DATE",
  /**
   * Sort by the purchase order status. Note: OPEN and DRAFT have the same weight,
   * as do CLOSED and ARCHIVED statuses.
   */
  STATUS = "STATUS",
}

/** Available fields to order the Purchasing Card connection by. */
export enum SortablePurchasingCardField {
  CARDHOLDER = "CARDHOLDER",
  CARD_STATUS = "CARD_STATUS",
  LIMIT = "LIMIT",
  PERIOD_RECURRENCE_TYPE = "PERIOD_RECURRENCE_TYPE",
}

/** Available fields to order the Expense connection by. */
export enum SortableRequestActionField {
  EXECUTION_ORDER = "EXECUTION_ORDER",
}

/** Available fields to order the Spend Budget connection by. */
export enum SortableSpendBudgetField {
  AMOUNT = "AMOUNT",
  AMOUNT_SPENT = "AMOUNT_SPENT",
  CREATED_AT = "CREATED_AT",
  END_DATE = "END_DATE",
  NAME = "NAME",
  START_DATE = "START_DATE",
  STATUS = "STATUS",
}

/** Available fields to order spend budget owners by */
export enum SortableSpendBudgetPersonnelField {
  ADDED_ON = "ADDED_ON",
  AMOUNT_SPENT = "AMOUNT_SPENT",
  NAME = "NAME",
}

/** Available fields to order the Spend Limit connection by. */
export enum SortableSpendLimitField {
  /**  This sorts by limit with increases */
  AMOUNT_SPENT = "AMOUNT_SPENT",
  CREATED_AT = "CREATED_AT",
  END_DATE = "END_DATE",
  LIMIT = "LIMIT",
  NAME = "NAME",
  START_DATE = "START_DATE",
  STATUS = "STATUS",
}

/** Available fields to order spend limit personnel by */
export enum SortableSpendLimitPersonnelField {
  ADDED_ON = "ADDED_ON",
  AMOUNT_SPENT = "AMOUNT_SPENT",
  NAME = "NAME",
}

/** Defines how a trip can be sorted. */
export enum SortableTravelTripField {
  BILLABLE_AT = "BILLABLE_AT",
  INSERTED_AT = "INSERTED_AT",
  START_DATE = "START_DATE",
}

/** Available fields to order the Vendor connection by. */
export enum SortableVendorField {
  VENDOR_NAME = "VENDOR_NAME",
}

export type SourceAccount =
  | DepositsAccount
  | FundingSource
  | RailAccountDetails;

export interface SourceAccountInput {
  depositsAccountId?: InputMaybe<Scalars["ID"]>;
  fundingSourceId?: InputMaybe<Scalars["ID"]>;
  railsAccountId?: InputMaybe<Scalars["ID"]>;
}

/** The type of resource that the extended field is attached to */
export enum SourceObjectType {
  ACCOUNTING_RECORD = "ACCOUNTING_RECORD",
  ACCOUNTING_RECORD_LINE_ITEM = "ACCOUNTING_RECORD_LINE_ITEM",
  BUDGET_REQUEST = "BUDGET_REQUEST",
  EXPENSE = "EXPENSE",
  ITEM = "ITEM",
  USER = "USER",
}

export enum SourceOfFundsDocumentType {
  BANK_STATEMENT = "BANK_STATEMENT",
  CONVERTIBLE_NOTE = "CONVERTIBLE_NOTE",
  NO_DOCUMENT = "NO_DOCUMENT",
  SAFE = "SAFE",
  TERM_SHEET = "TERM_SHEET",
}

export interface SourceOfFundsPayloadInput {
  documentType: SourceOfFundsDocumentType;
  documentUploads?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  founderLinkedin?: InputMaybe<Scalars["String"]>;
  founderLinkedins?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  founderTwitters?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  fundingAnnouncement?: InputMaybe<Scalars["String"]>;
  fundingAnnouncements?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  fundingRound?: InputMaybe<FundingRound>;
  fundraisingPlan?: InputMaybe<Scalars["String"]>;
  hasRaisedFunds?: InputMaybe<HasRaisedFunds>;
  howFunded?: InputMaybe<Scalars["String"]>;
  leadInvestors?: InputMaybe<Scalars["String"]>;
  pitchDeck?: InputMaybe<Scalars["String"]>;
  roundSize?: InputMaybe<Scalars["String"]>;
}

export interface SourceOfFundsRequestConfig {
  /** Whether PI funding sources (Angel investment, VC/accelerator/GE, or PE/LPs) have been collected in SSU previously. */
  hasPIFundingSource: Scalars["Boolean"];
  /** Whether PI is 3rd party verified per PI Policy. */
  isThirdPartyVerified: Scalars["Boolean"];
  /** Whether the company has more than 50 employees. */
  moreThan50Employees: Scalars["Boolean"];
  /** Deprecated. Use isThirdPartyVerified instead. */
  shouldCollectDocument: Scalars["Boolean"];
}

/** A spend budget organizes and tracks spend */
export interface SpendBudget extends Node {
  /**
   * The Customer Account
   * Nullable to support partial failure
   */
  account?: Maybe<Account>;
  /**
   * The allocation metrics of the spend budget.
   * This calculation may be slow, so if only the currentAllocatedAmount is needed, use that field instead.
   */
  allocation?: Maybe<AllocationMetrics>;
  /** A list of operations that the user can perform on the spend budget */
  allowedOperations: Array<SpendBudgetOperationPermission>;
  /** [Optional] Target amount of the spend budget */
  amount?: Maybe<FinancialAsset>;
  /** Ordered list of ancestors */
  ancestryPath: Array<SpendBudget>;
  /** [Optional] Authorization behavior of the spend budget (must be null). */
  authorizationSettings?: Maybe<SpendBudgetAuthorizationSettings>;
  /** Time when the spend budget was created */
  createdAt: Scalars["Time"];
  /** The current allocation amount of a budget period. */
  currentAllocatedAmount?: Maybe<FinancialAsset>;
  /** Spend budget period balance */
  currentPeriodBalance: SpendBudgetPeriodBalance;
  /** Description of what the spend budget is used for */
  description?: Maybe<Scalars["String"]>;
  /** The optional end date of the spend budget, inclusive. */
  endDate?: Maybe<Scalars["Date"]>;
  /** The optional inclusive end time with timezone offset in absolute UTC time. Ex: 01/31/2022 7:59AM UTC */
  endTimeUtc?: Maybe<Scalars["Time"]>;
  /** Logical ID */
  id: Scalars["ID"];
  /** Last status update details */
  lastStatusUpdateDetails?: Maybe<StatusUpdateDetails>;
  /** [Optional] The legal entity override for the spend budget */
  legalEntity?: Maybe<LegalEntity>;
  /** Name of the spend budget */
  name: Scalars["String"];
  /** The employees who are considered owners of this budget (nullable for partial failure) */
  owners?: Maybe<UserConnection>;
  /** The parent of this spend budget, if any */
  parent?: Maybe<SpendBudget>;
  /** The recurring period type of the spend budget. */
  periodType: SpendBudgetPeriodRecurrenceType;
  /** The child spend budgets for this spend budget */
  spendBudgets: SpendBudgetConnection;
  /** The nested spend limits for this spend budget */
  spendLimits: SpendLimitConnection;
  /** The optional start date of the spend budget, inclusive. */
  startDate?: Maybe<Scalars["Date"]>;
  /** The optional inclusive start time with timezone offset in absolute UTC time. Ex: 01/01/2022 8:00AM UTC */
  startTimeUtc?: Maybe<Scalars["Time"]>;
  /** Status of the spend budget */
  status: SpendBudgetStatus;
  /** The timezone of this spend budget */
  timezone: Scalars["String"];
}

/** A spend budget organizes and tracks spend */
export interface SpendBudgetallowedOperationsArgs {
  operations: Array<SpendBudgetOperation>;
}

/** A spend budget organizes and tracks spend */
export interface SpendBudgetownersArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<SpendBudgetPersonnelFilter>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  order?: InputMaybe<SpendBudgetPersonnelOrder>;
  page?: InputMaybe<PaginationInput>;
}

/** A spend budget organizes and tracks spend */
export interface SpendBudgetspendBudgetsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<SpendBudgetFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  order?: InputMaybe<SpendBudgetOrderInput>;
  page?: InputMaybe<PaginationInput>;
}

/** A spend budget organizes and tracks spend */
export interface SpendBudgetspendLimitsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<SpendLimitFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  order?: InputMaybe<SpendLimitOrderInput>;
  page?: InputMaybe<PaginationInput>;
}

/** Spend Budget Authorization Settings */
export interface SpendBudgetAuthorizationSettings {
  /** Authorization behavior against the spend budget's amount. */
  authorizationType: SpendBudgetAuthorizationType;
  /** The percentage of flexible buffer on the limit as a 0-100 INT */
  flexibleBufferPercentage: Scalars["Int"];
}

/**
 * Spend Budget Authorization behavior with its target amount
 * (Replaces enforceLimit boolean)
 */
export enum SpendBudgetAuthorizationType {
  /** Authorizations will be declined if it exceeds the amount */
  HARD = "HARD",
  /** Authorizations will still be authorized even if it exceeds the amount */
  SOFT = "SOFT",
}

/** An SpendBudget connection for SpendBudget pagination. */
export interface SpendBudgetConnection extends Connection {
  /** The spend budgets in the current page of results. */
  edges: Array<SpendBudgetEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of spend budgets matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

/** Display representation of a spend budget that implements the basic limit functionality */
export interface SpendBudgetDisplayLimit extends DisplayLimit {
  /** Amount spent against this limit */
  amountSpent?: Maybe<FinancialAsset>;
  /** Ordered list of ancestors */
  ancestryPath: Array<SpendBudgetDisplayLimit>;
  /** Logical ID - The spendBudgetId for this spend budget */
  id: Scalars["ID"];
  /** Name of the limit */
  name: Scalars["String"];
  /** The type of limit this represents */
  type: DisplayLimitType;
}

/** A Spend Budget edge for the Spend Budget connection. */
export interface SpendBudgetEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The spend budget at this edge. */
  node?: Maybe<SpendBudget>;
}

export interface SpendBudgetFilterInput {
  /** Search spend budgets by their budget ids */
  budgetIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Search spend budgets by whether they enforce a limit */
  enforceLimit?: InputMaybe<Scalars["Boolean"]>;
  /** Exclude spend budgets with zero amount */
  excludeZeroAmount?: InputMaybe<Scalars["Boolean"]>;
  /** Include all descendants of the parent budget */
  includeAllDescendants?: InputMaybe<Scalars["Boolean"]>;
  /** Search spend budgets by whether they are a parent budget */
  isParent?: InputMaybe<Scalars["Boolean"]>;
  /** Search spend budgets by their legal entity mappings */
  legalEntityMappings?: InputMaybe<Array<LegalEntityMapping>>;
  /** Search spend budgets by name */
  name?: InputMaybe<Scalars["String"]>;
  /** Search spend budgets by the owners */
  ownerCustomerUserIds?: InputMaybe<Array<Scalars["String"]>>;
  /** Search spend budgets by their parent budget */
  parentBudgetIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Skip the root budget */
  skipRootBudget?: InputMaybe<Scalars["Boolean"]>;
  /** Search spend budgets by the status last updated by an ancestor budget */
  statusLastUpdatedByAncestorBudgetId?: InputMaybe<Scalars["ID"]>;
  /** Search spend budgets by their statuses */
  statuses?: InputMaybe<Array<SpendBudgetStatus>>;
}

export interface SpendBudgetMutationError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

/** Possible operations a user could perform on a spend budget */
export enum SpendBudgetOperation {
  /** Update the spend budget's status to archived */
  ARCHIVE = "ARCHIVE",
  /** Update the spend budget's status to deleted */
  DELETE = "DELETE",
  /** Update any of the spend budget's fields */
  EDIT_FULL = "EDIT_FULL",
  /** Update the spend budget's owners */
  EDIT_OWNERS = "EDIT_OWNERS",
  /** Reassign the spend budget to a new parent */
  MOVE = "MOVE",
  /** Update the spend budget's status from archived or expired to active */
  REOPEN = "REOPEN",
}

export interface SpendBudgetOperationPermission {
  allowed: Scalars["Boolean"];
  disabledReason?: Maybe<Array<Scalars["String"]>>;
  operation: SpendBudgetOperation;
}

export interface SpendBudgetOrderInput {
  direction: OrderByDirection;
  field: SortableSpendBudgetField;
}

/** Spend budget period balance */
export interface SpendBudgetPeriodBalance {
  /** Amount spend in the current period */
  amountSpent?: Maybe<FinancialAsset>;
  /** End date of the current period */
  endDate?: Maybe<Scalars["Date"]>;
  /** Start date of the current period */
  startDate?: Maybe<Scalars["Date"]>;
}

/** Available period types for a spend budget */
export enum SpendBudgetPeriodRecurrenceType {
  ONE_TIME = "ONE_TIME",
  PER_MONTH = "PER_MONTH",
  PER_QUARTER = "PER_QUARTER",
  /** PER_WEEK is being grandfathered in, no new budgets can be created/updated with this recurrence type */
  PER_WEEK = "PER_WEEK",
  PER_YEAR = "PER_YEAR",
}

export interface SpendBudgetPersonnelFilter {
  /** filter for users by name */
  name: Scalars["String"];
}

export interface SpendBudgetPersonnelOrder {
  /** Direction */
  direction: OrderByDirection;
  /** Which field is being sorted on */
  field: SortableSpendBudgetPersonnelField;
}

/** Spend Budget statuses */
export enum SpendBudgetStatus {
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
  DELETED = "DELETED",
  EXPIRED = "EXPIRED",
}

/** A spend limit controls spend */
export interface SpendLimit extends LimitSource, Node {
  /**
   * The Customer Account
   * Nullable to support partial failure
   */
  account?: Maybe<Account>;
  /** The action logs associated with this spendLimit */
  actionLogs: BudgetActionLogConnection;
  /** A list of operations that the user can perform on the spend limit */
  allowedOperations: Array<SpendLimitOperationPermission>;
  /** Ordered list of ancestors */
  ancestryPath: Array<SpendBudget>;
  /** The exact settings that govern authorizations.  */
  authSettings?: Maybe<AuthorizationSettings>;
  /**
   * Authorization settings of the spend limit
   * null if user does not have permission to view these settings (based off authorizationVisibility)
   * @deprecated use AuthorizationSettings
   */
  authorizationSettings?: Maybe<SpendLimitAuthorizationSettings>;
  /**
   * Privacy setting whether its members are allowed to view the limit & authorization settings
   * (previously known as limit visibility)
   * @deprecated use AuthorizationSettings
   */
  authorizationVisibility: SpendLimitAuthorizationVisibility;
  /** Setting for auto-transferring budget cards when their owners are either disabled or removed as members from the budget. */
  autoTransferCardsSetting: AutoTransferCardsSetting;
  /** List of cards related to the spend limit */
  cards: BudgetCardConnection;
  /** Returns a summary of the cards in the spend limit (generally a count cards by a specified field) */
  cardsSummary?: Maybe<CardsSummary>;
  /** Time when the spend limit was created */
  createdAt: Scalars["Time"];
  /**
   * Spend limit period balance
   * @deprecated use spent
   */
  currentPeriodBalance?: Maybe<SpendLimitPeriodBalance>;
  customRules?: Maybe<WorkflowRuleConnection>;
  /** Description of what the spend limit is used for */
  description?: Maybe<Scalars["String"]>;
  /**
   * The optional end date of the spend limit, inclusive.
   * @deprecated use AuthorizationSettings
   */
  endDate?: Maybe<Scalars["Date"]>;
  /**
   * The optional inclusive end time with timezone offset in absolute UTC time. Ex: 01/31/2022 7:59AM UTC
   * @deprecated use AuthorizationSettings
   */
  endTimeUtc?: Maybe<Scalars["Time"]>;
  /** Determines if budget members are allowed to view other members expenses. */
  expenseVisibility: SpendLimitExpenseVisibility;
  /** The ID of an object */
  id: Scalars["ID"];
  /**
   * Whether the legal entity is explicitly mapped to the spend limit
   *
   * If true, the legal entity is explicitly mapped to the spend limit
   * Otherwise, the legal entity is derived from the spend limit's ancestry
   */
  isLegalEntityExplicitlySet: Scalars["Boolean"];
  /** Whether the current user is a member of the spend limit */
  isMember: Scalars["Boolean"];
  /** Whether the current user is an owner of the spend limit */
  isOwner: Scalars["Boolean"];
  /** Last status update details */
  lastStatusUpdateDetails?: Maybe<StatusUpdateDetails>;
  /** The template of this Spend Limit */
  legacyBudgetTemplate?: Maybe<BudgetTemplate>;
  /** The template derived metadata used to create this budget */
  legacyTemplateMetadata?: Maybe<BudgetTemplateDerivedMetadata>;
  /** Override that associates all transactions to this legal entity instead of the default */
  legalEntity?: Maybe<LegalEntity>;
  /**
   * The policy used for approving limit changes, if empty this defaults to requiring approval from:
   * 1. The user's direct manager
   * 2. Any admin
   */
  limitApprovalPolicy?: Maybe<Policy>;
  /** The exact settings that govern whether users can request for limit changes */
  limitChangeSettings?: Maybe<LimitChangeSettings>;
  /** The limit group associated with this spend limit, if any */
  limitGroup?: Maybe<LimitGroup>;
  /**
   * Budget limit increase requests
   * Takes in an active filter (to fetch limit increase requests currently applied to the budget).
   */
  limitIncreaseRequests: Array<Maybe<BudgetLimitIncreaseRequestEntity>>;
  /**
   * Whether the limit increase feature is enabled for this entity
   * @deprecated use LimitChangeRequestSettings
   */
  limitIncreaseSetting: LimitIncreaseSetting;
  /** Whether the current user can view the limit or not. */
  limitVisibleForUser: Scalars["Boolean"];
  /** The mapping rule that is associated with this spend limit */
  mappingRuleId?: Maybe<Scalars["ID"]>;
  /** The employees who are considered members of this budget (nullable for partial failure) */
  members?: Maybe<UserConnection>;
  /** The members of this spend limit with extra details (nullable for partial failure) */
  membersV2?: Maybe<SpendLimitMemberConnection>;
  /**
   * Merchant category controls, including those along ancestry path.
   * @deprecated use AuthorizationSettings
   */
  merchantCategoryControls?: Maybe<SpendLimitMerchantCategoryControls>;
  /** Name of the spend limit */
  name: Scalars["String"];
  /** The employees who are considered owners of this budget (nullable for partial failure) */
  owners?: Maybe<UserConnection>;
  /** The parent of this spend limit, if any */
  parentBudget?: Maybe<SpendBudget>;
  /** The parent spend limit of this spend limit, if it is an LPE child */
  parentSpendLimit?: Maybe<SpendLimit>;
  /**
   * The recurring period type of the spend limit.
   * @deprecated use AuthorizationSettings
   */
  periodType: SpendLimitPeriodType;
  /**
   * The policy governing this spend limit
   * (nullable to support partial error cross resolving)
   */
  policy?: Maybe<Policy>;
  /** Per diems of this spend limit as defined by the policy */
  policyPerDiems?: Maybe<Array<SpendLimitPerDiem>>;
  /** If this spend limit was provisioned by a limit group, this field represents the original user associated with the spend limit */
  provisionedForUser?: Maybe<User>;
  /**
   * The remainingLimit of a spend limit in the current period, this is the difference between the spendable limit and the amount spent on the current period's balance.
   * Null if user does not have permission to view this field
   * @deprecated use AuthorizationSettings
   */
  remainingLimit?: Maybe<FinancialAsset>;
  /** Allocation impact of this spend limit */
  spendLimitAllocations: Array<Maybe<SpendLimitAllocation>>;
  /** Allowed spend sources on a Spend Limit. */
  spendSourceSetting: SpendSourceSetting;
  /**
   * The spendableLimit of the spend limit in the current period, includes limit increases and rollover
   * Null if user does not have permission to view this field
   * @deprecated use AuthorizationSettings
   */
  spendableLimit?: Maybe<FinancialAsset>;
  /** Amount spent in the period defined by the reset frequency */
  spent?: Maybe<FinancialAsset>;
  /**
   * The optional start date of the spend limit, inclusive.
   * @deprecated use AuthorizationSettings
   */
  startDate?: Maybe<Scalars["Date"]>;
  /**
   * The optional inclusive start time with timezone offset in absolute UTC time. Ex: 01/01/2022 8:00AM UTC
   * @deprecated use AuthorizationSettings
   */
  startTimeUtc?: Maybe<Scalars["Time"]>;
  /** Status of the spend limit */
  status: SpendLimitStatus;
  /** The timezone of this spend limit */
  timezone: Scalars["String"];
  /**
   * The transaction limit mapped to the spend limit.
   * Null if no transaction limit is set.
   * @deprecated use AuthorizationSettings
   */
  transactionLimit?: Maybe<FinancialAsset>;
  /** The amount spent by the current user */
  userAmountSpent?: Maybe<FinancialAsset>;
  /** The user group associated with this spend limit */
  userGroup?: Maybe<Group>;
  /** Amount spent by the requesting user in the period defined by the reset frequency */
  userSpent?: Maybe<FinancialAsset>;
}

/** A spend limit controls spend */
export interface SpendLimitactionLogsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
}

/** A spend limit controls spend */
export interface SpendLimitallowedOperationsArgs {
  operations: Array<SpendLimitOperation>;
}

/** A spend limit controls spend */
export interface SpendLimitcardsArgs {
  filter: CardFilterInput;
  page?: InputMaybe<PaginationInput>;
}

/** A spend limit controls spend */
export interface SpendLimitcardsSummaryArgs {
  input: BudgetsCardsSummaryInput;
}

/** A spend limit controls spend */
export interface SpendLimitcustomRulesArgs {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
}

/** A spend limit controls spend */
export interface SpendLimitlimitIncreaseRequestsArgs {
  active?: InputMaybe<Scalars["Boolean"]>;
}

/** A spend limit controls spend */
export interface SpendLimitmembersArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<SpendLimitPersonnelFilter>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  order?: InputMaybe<SpendLimitPersonnelOrder>;
  page?: InputMaybe<PaginationInput>;
}

/** A spend limit controls spend */
export interface SpendLimitmembersV2Args {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  orderBy?: InputMaybe<SpendLimitPersonnelOrder>;
  where?: InputMaybe<SpendLimitPersonnelFilter>;
}

/** A spend limit controls spend */
export interface SpendLimitownersArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<SpendLimitPersonnelFilter>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  order?: InputMaybe<SpendLimitPersonnelOrder>;
  page?: InputMaybe<PaginationInput>;
}

/** A spend limit controls spend */
export interface SpendLimitspendLimitAllocationsArgs {
  referenceBudgetId?: InputMaybe<Scalars["ID"]>;
}

/** Spend Limit Allocation Fields */
export interface SpendLimitAllocation {
  /** The allocation end date */
  endDate: Scalars["Date"];
  /** The allocation contribution from the spend limit's limit */
  limitAmount: FinancialAsset;
  /**
   * The deduction from allocation amount related to spend done outside of the budget period,
   * but inside the spend limit's current period. This only happens when the spend limit has
   * a larger recurrence than the budget
   */
  negativeAdjustmentAmount: FinancialAsset;
  /** The allocation contribution from permanent limit increases in effect during the period */
  permanentIncreasesAmount: FinancialAsset;
  /** The allocation contribution from rollover balances, if available */
  rolloverAmount: FinancialAsset;
  /** The allocation start date */
  startDate: Scalars["Date"];
  /** The allocation contribution from temporary limit increases in effect during the period */
  temporaryIncreasesAmount: FinancialAsset;
}

/**
 * Allowed spend sources on a Spend Limit
 * (Replaces onlyProvisionedCardSpend boolean)
 */
export enum SpendLimitAllowedSpendSource {
  /** All types of spend (bill pay, reimbursement, user card) are allowed on this spend limit */
  ALL = "ALL",
  /** Only budget cards can spend out of this spend limit */
  BUDGET_CARD = "BUDGET_CARD",
}

export type SpendLimitAssignmentFailureError =
  | SpendLimitAssignmentInsufficientAncestorLimitError
  | SpendLimitAssignmentInsufficientLimitError
  | SpendLimitAssignmentSpendLimitExpiredError
  | SpendLimitAssignmentSpendLimitNotStartedError
  | SpendLimitAssignmentSpendLimitTerminatedError
  | SpendLimitAssignmentTransactionLimitError;

/** if the relevant period the expense is incurred in does not have enough balance */
export interface SpendLimitAssignmentInsufficientAncestorLimitError {
  /** The ancestor of the spend limit (parent budget, or further up the hierarchy), this can be null if the user does not have access to that budget. */
  ancestorId?: Maybe<Scalars["ID"]>;
  /** Whether the user has the capabilities to assign the expense and override the insufficient ancestor limit error, this is true for the case of admins, and false otherwise. */
  canOverride: Scalars["Boolean"];
  limitAmount?: Maybe<FinancialAsset>;
  overLimitAmount?: Maybe<FinancialAsset>;
  spendLimitId: Scalars["ID"];
}

export interface SpendLimitAssignmentInsufficientLimitError {
  /** Whether the user has the capabilities to assign the expense and override the insufficient limit error, this is true for the case of admins, and false otherwise. */
  canOverride: Scalars["Boolean"];
  /** The amount on the expense */
  expenseAmount: FinancialAsset;
  /** Whether the expense occurred within the current period of the spend limit, if so, it's possible to request a limit increase, if not, the window has passed. */
  isExpenseWithinCurrentPeriod: Scalars["Boolean"];
  limitAmount?: Maybe<FinancialAsset>;
  overLimitAmount?: Maybe<FinancialAsset>;
  /** Whether the user who incurred the expense, has a pending limit increase request on this specific spend limit, if so, the id will be populated, if not, it will be null. */
  pendingLimitIncreaseRequestId?: Maybe<Scalars["ID"]>;
  spendLimitId: Scalars["ID"];
}

/** if the expense cannot be assigned to the spend limit because the spend limit has expired */
export interface SpendLimitAssignmentSpendLimitExpiredError {
  /** Whether the user has the capabilities to assign the expense and override the spend limit expired error. This is always false, as even admins cannot override this. */
  canOverride: Scalars["Boolean"];
  expenseDate: Scalars["Date"];
  expirationDate: Scalars["Date"];
  spendLimitId: Scalars["ID"];
}

/** if the expense cannot be assigned to the spend limit because it has not started yet */
export interface SpendLimitAssignmentSpendLimitNotStartedError {
  /** Whether the user has the capabilities to assign the expense and override the spend limit start date error. This is always false, as even admins cannot override this. */
  canOverride: Scalars["Boolean"];
  expenseDate: Scalars["Date"];
  spendLimitId: Scalars["ID"];
  startDate: Scalars["Date"];
}

/** if the expense cannot be assigned to the spend limit because it has been terminated */
export interface SpendLimitAssignmentSpendLimitTerminatedError {
  /** Whether the user has the capabilities to assign the expense and override the spend limit terminated error. This is always false, as even admins cannot override this. */
  canOverride: Scalars["Boolean"];
  spendLimitId: Scalars["ID"];
}

/** if the expense cannot be assigned to the spend limit due to the spend limit's transaction limit */
export interface SpendLimitAssignmentTransactionLimitError {
  /** Whether the user has the capabilities to assign the expense and override the transaction limit error. This is always false, as even admins cannot override this. */
  canOverride: Scalars["Boolean"];
  /** The amount on the expense */
  expenseAmount: FinancialAsset;
  spendLimitId: Scalars["ID"];
  transactionLimit: FinancialAsset;
}

/** Spend Limit Authorization Settings */
export interface SpendLimitAuthorizationSettings {
  /** Authorization behavior against the spend limit's limit. */
  authorizationType: SpendLimitAuthorizationType;
  /** Base limit of the spend limit */
  baseLimit: FinancialAsset;
  /** The percentage of flexible buffer on the limit as a 0-100 INT */
  flexibleBufferPercentage: Scalars["Int"];
  /** Base limit including permanent + temporary limit increases */
  limitWithIncreases: FinancialAsset;
  /** The rollover refresh rate for this spend limit (the recurrence by which all rolled over unused funds within the cycle should no longer roll over to the next period). */
  rolloverRefreshRate?: Maybe<SpendLimitRolloverRefreshRate>;
}

/** Input for Spend Limit Authorization Settings */
export interface SpendLimitAuthorizationSettingsInput {
  /** Authorization behavior against the spend limit's limit. */
  authorizationType: SpendLimitAuthorizationType;
  /** Base limit of the spend limit */
  baseLimit: FinancialAssetInput;
  /** The percentage of flexible buffer on the limit as a 0-100 INT */
  flexibleBufferPercentage?: InputMaybe<Scalars["Int"]>;
  /** The rollover refresh rate for this spend limit (the recurrence by which all rolled over unused funds within the cycle should no longer roll over to the next period). */
  rolloverRefreshRate?: InputMaybe<SpendLimitRolloverRefreshRate>;
}

/**
 * Spend Limit Authorization behavior with its limit
 * (Replaces enforceLimit boolean)
 */
export enum SpendLimitAuthorizationType {
  /** Authorizations will be declined if it exceeds the limit */
  HARD = "HARD",
  /** Authorizations will still be authorized even if it exceeds the limit */
  SOFT = "SOFT",
}

export enum SpendLimitAuthorizationVisibility {
  PRIVATE = "PRIVATE",
  PUBLIC = "PUBLIC",
}

/** A blueprint used to create new spend limits */
export interface SpendLimitBlueprint {
  associatedSpendLimitsCount: Scalars["Int"];
  fields: SpendLimitBlueprintFields;
  id: Scalars["ID"];
}

/** Fields composing a spend limit blueprint */
export interface SpendLimitBlueprintFields {
  /** Authorization behavior against the spend limit's limit. */
  authorizationType: SpendLimitAuthorizationType;
  /**
   * Privacy setting whether its members are allowed to view the limit & authorization settings
   * (previously known as limit visibility)
   */
  authorizationVisibility: SpendLimitAuthorizationVisibility;
  /** Setting for how auto limit card creation works for members. */
  autoCreateLimitCardsSetting: AutoCreateLimitCardsSetting;
  /** Setting for auto-transferring spend limit cards when their owners are either disabled or removed as members from the budget. */
  autoTransferCardsSetting?: Maybe<AutoTransferCardsSetting>;
  /** Description of what the spend limit is used for */
  description?: Maybe<Scalars["String"]>;
  /** The end date of the spend limit, inclusive. */
  endDate?: Maybe<Scalars["Date"]>;
  /** The expense policy that manages expenses for this spend limit */
  expensePolicy?: Maybe<Policy>;
  /** Determines if spend limit members are allowed to view other members expenses. */
  expenseVisibility: SpendLimitExpenseVisibility;
  /** The percentage of flexible buffer on the limit as a 0-100 INT */
  flexibleBufferPercentage?: Maybe<Scalars["Int"]>;
  /**
   * The legal entity override for the spend limits provisioned by the blueprint.
   * Null if no legal entity is set.
   */
  legalEntity?: Maybe<LegalEntity>;
  /** Limit on the spend limit */
  limit: FinancialAsset;
  /** The policy that manages approval chain for limit increase requests for this spend limit. */
  limitApprovalPolicyId?: Maybe<Scalars["ID"]>;
  /** Whether limit increase request feature is enabled on a spend limit */
  limitIncreaseSetting: LimitIncreaseSetting;
  /** Merchant category controls. */
  merchantCategoryControls?: Maybe<SpendLimitMerchantCategoryControls>;
  /** The name of the spend limit */
  name: Scalars["String"];
  /** The employees who are considered owners of this spend limit (nullable for partial failure) */
  owners?: Maybe<UserConnection>;
  /** Parent budget */
  parentBudget: SpendBudget;
  /** The recurring period type of the spend limit. */
  periodType: SpendLimitPeriodType;
  /** True if the user's name should be prepended to the spend limit name */
  prependUserNameToSpendLimitName: Scalars["Boolean"];
  /**
   * Specifies the date offset to be applied when setting the end date of the provisioned spend limit. Cannot be set if end
   * date is set
   *
   * The offset is calculated based on the time of provisioning. For instance, if the offset is set to 7 DAY and the
   * spend limit is provisioned on 2024-01-01, the end date of the provisioned spend limit will be 2024-01-08.
   */
  provisionedDateOffset?: Maybe<DateOffset>;
  /** The rollover refresh rate for this spend limit (the recurrence by which all rolled over unused funds within the cycle should no longer roll over to the next period). */
  rolloverRefreshRate: SpendLimitRolloverRefreshRate;
  /** Allowed spend sources on a Spend Limit. */
  spendSourceSetting?: Maybe<SpendSourceSetting>;
  /** The start date of the spend limit, inclusive. */
  startDate?: Maybe<Scalars["Date"]>;
  /** True if the spend limits created by this blueprint should start in the next spend limit period */
  startSpendLimitNextAvailableSpendLimitPeriod: Scalars["Boolean"];
  /**
   * The transaction limit mapped to the spend limits provisioned by the blueprint
   * Null if no transaction limit is set.
   */
  transactionLimit?: Maybe<FinancialAsset>;
}

/** Fields composing a spend limit blueprint */
export interface SpendLimitBlueprintFieldsownersArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<SpendLimitPersonnelFilter>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  order?: InputMaybe<SpendLimitPersonnelOrder>;
  page?: InputMaybe<PaginationInput>;
}

export interface SpendLimitCitation extends Citation {
  /** Positions of the spend limit citation in the text. */
  citationPositions: Array<CitationPosition>;
  /** index of the spend limit citation e.g. [1], [2] */
  index: Scalars["Int"];
  /** Name describing the spend limit citation. */
  name: Scalars["String"];
  /**
   * Enum from each section of the spend limit citation e.g. Mcc Rules, limit balance,
   * meals per diem ...
   */
  spendLimitSection: SpendLimitSection;
}

/** A Spend Limit connection for pagination. */
export interface SpendLimitConnection extends Connection {
  /** The spend limits in the current page of results. */
  edges: Array<SpendLimitEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of spend limits matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

/** Display representation of a spend limit that implements the basic limit functionality */
export interface SpendLimitDisplayLimit extends DisplayLimit {
  /** Amount spent against this limit */
  amountSpent?: Maybe<FinancialAsset>;
  /** Ordered list of ancestors */
  ancestryPath: Array<SpendBudgetDisplayLimit>;
  /** Logical ID - The spendLimitId for this spend limit */
  id: Scalars["ID"];
  /** Name of the limit */
  name: Scalars["String"];
  /** The type of limit this represents */
  type: DisplayLimitType;
}

/** A Spend Limit edge for the Budget connection. */
export interface SpendLimitEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The spend limit at this edge. */
  node?: Maybe<SpendLimit>;
}

export enum SpendLimitExpenseVisibility {
  PRIVATE = "PRIVATE",
  SHARED = "SHARED",
}

export interface SpendLimitFilterInput {
  /**
   * List all descendant spend limits belonging to an ancestor spend budget, excluding the ancestor spend budget itself
   * Will throw error if both parentBudgetId and ancestorBudgetId are specified
   */
  ancestorBudgetId?: InputMaybe<Scalars["ID"]>;
  /** Whether or not the SpendLimit is authable (Ex. Expense reports have authable=false) */
  authable?: InputMaybe<Scalars["Boolean"]>;
  /** Filter spend limits by budgetIds */
  budgetIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Filter to include the listed template ids */
  budgetTemplateIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Match IN specific associated cards */
  cardIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Filter to include/exclude limit-per-employee distribution children */
  distributionChildrenFilter?: InputMaybe<DistributionChildrenFilter>;
  /** Filter by budget policy eligible workflows, match ALL when no filter or and empty array is provided */
  eligibleWorkflows?: InputMaybe<Array<PolicyWorkflowType>>;
  /** List spend limits that have no expiration date (null end date) or spend limits that have end dates after this field */
  endDateNullOrAfter?: InputMaybe<Scalars["Date"]>;
  /** Determines if spend limit members are allowed to view other members' expenses. */
  expenseVisibilityShared?: InputMaybe<Scalars["Boolean"]>;
  /** Filter to include or exclude purchasing card limits */
  filterPurchasingCardLimits?: InputMaybe<PurchasingCardLimitsFilterType>;
  /** Match IN template types. If empty returns all items. */
  includeTemplateTypes?: InputMaybe<Array<BudgetTemplateType>>;
  /** Filter by automated distribution on spend limits, or ignores the filter if not specified */
  isAutomationEnabled?: InputMaybe<Scalars["Boolean"]>;
  /** Amount of the financial asset limit of each spend limit being filtered. Could be ALL (all spend limit limits), NONZERO (nonzero spend limit limits), etc. */
  limitAmountType?: InputMaybe<LimitAmountType>;
  /** Match IN specific members */
  memberCustomerUserIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Search spend limits by name */
  name?: InputMaybe<Scalars["String"]>;
  /** Whether or not the spend limit has a virtual card */
  onlyProvisionedCardSpend?: InputMaybe<Scalars["Boolean"]>;
  /** Match IN specific owners */
  ownerCustomerUserIds?: InputMaybe<Array<Scalars["ID"]>>;
  /**
   * List direct child spend limits belonging to a parent spend budget, excluding the parent spend budget itself
   * Will throw error if both parentBudgetId and ancestorBudgetId are specified
   */
  parentBudgetId?: InputMaybe<Scalars["ID"]>;
  /** Filter spend limits by the policy they are using. */
  policyIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Search spend limits by name or associated cards' last four */
  search?: InputMaybe<Scalars["String"]>;
  /** List all spend limits closed or deleted by a parent spend budget */
  statusLastUpdatedByAncestorBudgetId?: InputMaybe<Scalars["ID"]>;
  /** Spend Limit Status IN statuses */
  statuses?: InputMaybe<Array<SpendLimitStatus>>;
}

/** A member of a spend limit */
export interface SpendLimitMember extends Node {
  /** The amount spent by this member in the current period of the spend limit */
  amountSpentCurrentPeriod?: Maybe<FinancialAsset>;
  /** The user who is a member of the spend limit group with respective group assignment type */
  groupMember?: Maybe<GroupMember>;
  /** Global logical ID composite by (spend limit id + user id) */
  id: Scalars["ID"];
}

/** A SpendLimitMember connection for pagination. */
export interface SpendLimitMemberConnection extends Connection {
  edges: Array<Maybe<SpendLimitMemberEdge>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

/** A SpendLimitMember edge for the SpendLimitMember connection. */
export interface SpendLimitMemberEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<SpendLimitMember>;
}

/** Input for modifying spend limit members */
export interface SpendLimitMemberModificationInput {
  /** The action to perform (add or remove) */
  action: ModificationAction;
  /** The user ID */
  userId: Scalars["ID"];
}

/** Merchant category controls from root budget, ancestor budgets and current budget. */
export interface SpendLimitMerchantCategoryControls {
  currentBudgetConfigs?: Maybe<Array<Maybe<MerchantCategoryConfig>>>;
  globalBudgetConfigs?: Maybe<Array<Maybe<MerchantCategoryConfig>>>;
}

/** Input for modifying spend limit membership by adding or removing specific owners and members */
export interface SpendLimitModifyMembershipInput {
  /** The idempotency key */
  clientMutationId: Scalars["String"];
  /** Member modifications (add or remove) */
  memberModifications?: InputMaybe<Array<SpendLimitMemberModificationInput>>;
  /** Owner modifications (add or remove) */
  ownerModifications?: InputMaybe<Array<SpendLimitOwnerModificationInput>>;
  /** The spend limit id */
  spendLimitId: Scalars["ID"];
}

export interface SpendLimitModifyMembershipResult extends MutationResult {
  errors?: Maybe<Array<StandardClientError>>;
  spendLimit?: Maybe<SpendLimit>;
}

/** Possible operations a user could perform on a spend limit */
export enum SpendLimitOperation {
  /** Update the spend limit's status to archived */
  ARCHIVE = "ARCHIVE",
  /** Convert the spend limit to a purchasing card */
  CONVERT_TO_PURCHASING_CARD = "CONVERT_TO_PURCHASING_CARD",
  /** Update the spend limit's status to deleted */
  DELETE = "DELETE",
  /** Update any of the spend limit's fields */
  EDIT_FULL = "EDIT_FULL",
  /** Update the spend limit's owners and members */
  EDIT_USERS = "EDIT_USERS",
  /** Reassign the spend limit to a new parent */
  MOVE = "MOVE",
  /** Update the spend limit's status from archived or expired to active */
  REOPEN = "REOPEN",
  /** Create a limit increase request */
  REQUEST_LIMIT_INCREASE = "REQUEST_LIMIT_INCREASE",
  /** View other member's expenses for the spend limit */
  VIEW_EXPENSES = "VIEW_EXPENSES",
  /** View the spend limit's limit. Disabled for members if the limit is masked */
  VIEW_LIMIT = "VIEW_LIMIT",
  /** View the spend limit's owners and members */
  VIEW_USERS = "VIEW_USERS",
}

export interface SpendLimitOperationPermission {
  allowed: Scalars["Boolean"];
  disabledReason?: Maybe<Array<Scalars["String"]>>;
  operation: SpendLimitOperation;
}

export interface SpendLimitOrderInput {
  direction: OrderByDirection;
  field: SortableSpendLimitField;
}

/** Input for modifying spend limit owners */
export interface SpendLimitOwnerModificationInput {
  /** The action to perform (add or remove) */
  action: ModificationAction;
  /** The user ID */
  userId: Scalars["ID"];
}

/** Spend Limit Per Diem Information */
export interface SpendLimitPerDiem {
  availableSpend: FinancialAsset;
  dailyLimit: FinancialAsset;
  perDiemCategory: PerDiemCategory;
}

/** Spend limit period balance */
export interface SpendLimitPeriodBalance {
  /** Amount spend in the current period */
  amountSpent?: Maybe<FinancialAsset>;
  /**
   * Total available amount to spend for the current period,
   * null if the there is no limit set on the spend limit, or if the user does not have permission to view this field.
   */
  availableAmount?: Maybe<FinancialAsset>;
  /** End date of the current period */
  endDate?: Maybe<Scalars["Date"]>;
  /** End time of the current period (adjusted for timezone) */
  endTime?: Maybe<Scalars["Time"]>;
  /**
   * Whether spending has exceeded the limit for this current period,
   * null if the there is no limit set on the spend limit, or if the user does not have permission to view this field.
   */
  isOverLimit?: Maybe<Scalars["Boolean"]>;
  /**
   * The amount spent which exceeds the spendable limit for this period,
   * null if the there is no limit set on the spend limit, or if the user does not have permission to view this field.
   */
  overLimitAmount?: Maybe<FinancialAsset>;
  /** Rollover amount for the current period */
  rolloverAmount?: Maybe<FinancialAsset>;
  /** Start date of the current period */
  startDate?: Maybe<Scalars["Date"]>;
  /** Start time of the current period (adjusted for timezone) */
  startTime?: Maybe<Scalars["Time"]>;
}

/** Available period types for a spend limit */
export enum SpendLimitPeriodRecurrenceType {
  ONE_TIME = "ONE_TIME",
  PER_MONTH = "PER_MONTH",
  PER_QUARTER = "PER_QUARTER",
  PER_WEEK = "PER_WEEK",
  PER_YEAR = "PER_YEAR",
}

export enum SpendLimitPeriodType {
  /** Invalid */
  INVALID = "INVALID",
  /** Only once */
  ONE_TIME = "ONE_TIME",
  /** Every month */
  PER_MONTH = "PER_MONTH",
  /** Every quarter */
  PER_QUARTER = "PER_QUARTER",
  /** Every week */
  PER_WEEK = "PER_WEEK",
  /** Every year */
  PER_YEAR = "PER_YEAR",
}

export interface SpendLimitPersonnelFilter {
  /** filter for users by name */
  name: Scalars["String"];
}

export interface SpendLimitPersonnelOrder {
  /** Direction */
  direction: OrderByDirection;
  /** Which field is being sorted on */
  field: SortableSpendLimitPersonnelField;
}

/** Rollover options for a spend limit */
export enum SpendLimitRolloverRefreshRate {
  /** Rollover amount never refreshes. */
  NEVER = "NEVER",
  /** Rollover is disabled. */
  OFF = "OFF",
  /** Rollover amount within a month is not carried into the next month. */
  PER_MONTH = "PER_MONTH",
  /** Rollover amount within a quarter is not carried into the next quarter. */
  PER_QUARTER = "PER_QUARTER",
  /** Rollover amount within a year is not carried into the next year. */
  PER_YEAR = "PER_YEAR",
}

export enum SpendLimitSection {
  /** Limit usage */
  SPEND_LIMIT_SECTION_LIMIT_BALANCE = "SPEND_LIMIT_SECTION_LIMIT_BALANCE",
  /** Mcc rules */
  SPEND_LIMIT_SECTION_MCC_RULES = "SPEND_LIMIT_SECTION_MCC_RULES",
  /** Meals per diem */
  SPEND_LIMIT_SECTION_MEALS_PER_DIEM = "SPEND_LIMIT_SECTION_MEALS_PER_DIEM",
}

/** Settings pertaining only to a spend limit type */
export interface SpendLimitSettings {
  /** Setting for how auto limit card creation works for members. */
  autoCreateLimitCardsSetting?: Maybe<AutoCreateLimitCardsSetting>;
  /** Setting for auto-transferring budget cards when their owners are either disabled or removed as members from the budget. */
  autoTransferCardsSetting?: Maybe<AutoTransferCardsSetting>;
  /** Determines if budget members are allowed to view other members expenses. */
  expenseVisibility: SpendLimitExpenseVisibility;
  /**
   * Whether the transaction limit is explicitly mapped to the budget
   *
   * If true, the transaction limit is explicitly mapped to the budget
   * Otherwise, the transaction limit is derived from the budget's ancestry
   */
  isTransactionLimitExplicitlySet: Scalars["Boolean"];
  /** The policy that manages spend limit approval chain for limit increase requests for this spend limit */
  limitApprovalPolicy?: Maybe<Policy>;
  /** Are budget limit increase requests allowed on this budget. */
  limitIncreaseRequestEnabled: Scalars["Boolean"];
  /** The policy that manages limit increase requests for this budget */
  limitIncreaseRequestPolicy?: Maybe<Policy>;
  /** Determines if budget members are allowed to view the budget limit */
  limitVisibility: BudgetLimitVisibilityType;
  /** Determines if the requesting user is allowed to view the budget limit */
  limitVisibleForUser: Scalars["Boolean"];
  /** True if only provisioned cards can spend from this budget */
  onlyProvisionedCardSpend: Scalars["Boolean"];
  /** The policy that manages expenses for this budget */
  policy: Policy;
  /** The rollover refresh rate for this budget (the recurrence by which all rolled over unused funds within the cycle should no longer roll over to the next period). */
  rolloverRefreshRate: BudgetRolloverRefreshRate;
  /** The template derived metadata used to create this budget */
  templateDerivedMetadata?: Maybe<BudgetTemplateDerivedMetadata>;
  /**
   * The transaction limit mapped to the budget.
   * Null if no transaction limit is set.
   */
  transactionLimit?: Maybe<FinancialAsset>;
}

/** Spend Limit statuses */
export enum SpendLimitStatus {
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
  DELETED = "DELETED",
  EXPIRED = "EXPIRED",
}

/** Input to filter by spend limit statuses */
export interface SpendLimitStatusFilter {
  /** Filter for (not) null statuses */
  isNull?: InputMaybe<Scalars["Boolean"]>;
  /** Match IN specific spend limit statuses (null and empty list filters are ignored) */
  values?: InputMaybe<Array<SpendLimitStatus>>;
}

/** Errors that occur when validating inputs alongside spend limit state to determine if a mutation can be performed successfully by the client */
export interface SpendLimitValidationError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
  validationErrorCode: SpendLimitValidationErrorCode;
}

/** Validation error codes that can occur when validating spend limits during mutations */
export enum SpendLimitValidationErrorCode {
  /** When the spend limit ends after the limit group, in this case the end date must be the same or before the limit group end date */
  END_DATE_AFTER_LIMIT_GROUP_END_DATE = "END_DATE_AFTER_LIMIT_GROUP_END_DATE",
  /** When the limit group has an end date but the spend limit doesn't, in this case the end date has to be specified and must be the same or before the limit group end date */
  END_DATE_CANNOT_BE_NULL_IF_LIMIT_GROUP_HAS_END_DATE = "END_DATE_CANNOT_BE_NULL_IF_LIMIT_GROUP_HAS_END_DATE",
  /** When the limit group is in a status that doesn't allow updates */
  LIMIT_GROUP_STATUS_INVALID = "LIMIT_GROUP_STATUS_INVALID",
  /** When the original associated user is no longer in the members list of the spend limit */
  ORIGINAL_ASSOCIATED_USER_NOT_IN_MEMBERS_LIST = "ORIGINAL_ASSOCIATED_USER_NOT_IN_MEMBERS_LIST",
  /** When the user tries shrinking a budget/spend limit's startTime that already started and has expenses */
  SHRINK_START_TIME_WITH_EXPENSES = "SHRINK_START_TIME_WITH_EXPENSES",
  /** When the spend limit is in a status that doesn't allow updates */
  SPEND_LIMIT_STATUS_INVALID = "SPEND_LIMIT_STATUS_INVALID",
  /** When the spend limit starts before the limit group */
  START_DATE_BEFORE_LIMIT_GROUP_START_DATE = "START_DATE_BEFORE_LIMIT_GROUP_START_DATE",
  /** When the spend limit has no start date but the limit group does, in this case the start date has to be specified and must be the same or after the limit group start date */
  START_DATE_CANNOT_BE_NULL_IF_LIMIT_GROUP_HAS_START_DATE = "START_DATE_CANNOT_BE_NULL_IF_LIMIT_GROUP_HAS_START_DATE",
}

/**
 * Top-level spend migration data for efficient client-side page loading.
 * Provides aggregated information about the account's spend migration state.
 */
export interface SpendMigration {
  /**
   * Indicates whether the account has any active spend limit cards.
   * Used by the client to determine whether to support p-card creation by default
   */
  hasActiveSpendLimitCards?: Maybe<Scalars["Boolean"]>;
}

export interface SpendMigrationImport {
  /** The account that the import is associated with */
  account: Account;
  /** The type of the upload */
  documentType: SpendMigrationImportDocumentType;
  /** The ID of the import */
  id: Scalars["ID"];
  /** The user that initiated the import */
  initiatedBy?: Maybe<User>;
  /** Whether the import has been resolved */
  isResolved: Scalars["Boolean"];
  /** The processing status of the import */
  processingStatus: SpendMigrationImportProcessingStatus;
  /** Returns the vendorFileMatches to be created from a spend migration import. */
  vendorFileMatches: VendorFileMatchConnection;
}

export interface SpendMigrationImportvendorFileMatchesArgs {
  page: PaginationInput;
}

export interface SpendMigrationImportConnection extends Connection {
  /** The uploads in the current page of results. */
  edges: Array<SpendMigrationImportEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of vendors file uploads matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

export enum SpendMigrationImportDocumentType {
  /** This upload comes from an ERP export */
  ACCOUNTING_INTEGRATION = "ACCOUNTING_INTEGRATION",
  /** Customer has uploaded a custom csv where they manually calculated vendors and vendor rollups */
  CUSTOM = "CUSTOM",
  /** This upload comes from importing ERP transactions */
  ERP_IMPORT = "ERP_IMPORT",
  /** Customer uploaded a PDF credit card statement */
  PDF_STATEMENT = "PDF_STATEMENT",
}

export interface SpendMigrationImportEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The vendor file upload at this edge. */
  node: SpendMigrationImport;
}

export enum SpendMigrationImportProcessingStatus {
  /** Processing the import has finished and the results are ready. */
  COMPLETED = "COMPLETED",
  /** An error occurred during processing the import and must be retried. */
  FAILED = "FAILED",
  /** The import is currently being processed. */
  PROCESSING = "PROCESSING",
}

export interface SpendMigrationImportVendorInclusionInput {
  /** The mode to create vendor file matches from the import. */
  mode: SpendMigrationImportVendorInclusionMode;
  /** Vendor ids from the import to either only create vendor file matches for (mode: INCLUDE) or exclude from creation (mode: EXCLUDE). */
  vendorIds: Array<Scalars["ID"]>;
}

export enum SpendMigrationImportVendorInclusionMode {
  /** Exclude the specified vendor ids from creation (ids must be present in the import) */
  EXCLUDE = "EXCLUDE",
  /** Only create vendor file matches for the specified vendor ids (ids must be present in the import) */
  INCLUDE = "INCLUDE",
}

export enum SpendMigrationSpendStatus {
  /** Spend on the vendor already exists on the account before upload. */
  PREEXISTING_SPEND_DETECTED = "PREEXISTING_SPEND_DETECTED",
  /** A user has migrated the vendor outside of the spend migration flow. */
  SPEND_DETECTED_EXTERNALLY = "SPEND_DETECTED_EXTERNALLY",
  /** The user has migrated the spend via the card created in the spend migration flow but didn't click "done" */
  SPEND_DETECTED_ON_CARD = "SPEND_DETECTED_ON_CARD",
}

/** Allowed spend source types on the allow list */
export enum SpendSource {
  BILL_PAY = "BILL_PAY",
  BUDGET_CARD = "BUDGET_CARD",
  REIMBURSEMENT = "REIMBURSEMENT",
  USER_CARD = "USER_CARD",
}

/** Allowed spend source authorization type on a Spend Limit */
export enum SpendSourceAuthorizationType {
  ALL = "ALL",
  ALLOW_LIST = "ALLOW_LIST",
}

/** Allowed spend sources on a Spend Limit. */
export interface SpendSourceSetting {
  /** The authorization type for the spend limit's spend sources, either all sources or an allow list of sources. */
  authorizationType: SpendSourceAuthorizationType;
  /** The spend sources that are allowed for the spend limit. Null if all sources are allowed. */
  spendSources?: Maybe<Array<SpendSource>>;
}

/** Allowed spend sources on a Spend Limit. */
export interface SpendSourceSettingInput {
  authorizationType: SpendSourceAuthorizationType;
  spendSources?: InputMaybe<Array<InputMaybe<SpendSource>>>;
}

/**
 * A payload returned when generating or refreshing a Spotnana session for trip creation
 * or partner integrations. Referenced by both the Trip and Partner Integration domains.
 */
export interface SpotnanaPayload {
  /** Encoded Payload for Spotnana IFrame */
  encodedPayload: Scalars["String"];
  /** Company Id */
  spotnanaCompanyId?: Maybe<Scalars["String"]>;
  /** User Id */
  spotnanaUserId?: Maybe<Scalars["String"]>;
}

export interface SpreadsheetError {
  location: SpreadsheetLocation;
  message: Scalars["String"];
}

/** Common utilities */
export interface SpreadsheetLocation {
  /**  Deprecated */
  cell?: Maybe<Scalars["String"]>;
  column?: Maybe<Scalars["String"]>;
  /**  Deprecated */
  row?: Maybe<Scalars["String"]>;
  rowNumber: Scalars["Int"];
}

export interface SsoClientError {
  code?: Maybe<SsoClientErrorCode>;
  message?: Maybe<Scalars["String"]>;
  /**  for debugging purposes, do not use to set client copy */
  path?: Maybe<Array<Scalars["String"]>>;
}

/**  Duplicated from ErroCode because ErrorCode is not present in admin-dgs */
export enum SsoClientErrorCode {
  ALREADY_EXISTS = "ALREADY_EXISTS",
  FAILED_PRECONDITION = "FAILED_PRECONDITION",
  INVALID_ARGUMENT = "INVALID_ARGUMENT",
  NOT_FOUND = "NOT_FOUND",
  OUT_OF_RANGE = "OUT_OF_RANGE",
  PERMISSION_DENIED = "PERMISSION_DENIED",
  UNMAPPED = "UNMAPPED",
}

export interface SsoMetaResult {
  enabled?: Maybe<Scalars["Boolean"]>;
}

export enum SsoProviderName {
  GOOGLE = "GOOGLE",
  MICROSOFT = "MICROSOFT",
  OKTA = "OKTA",
  OTHER_OIDC = "OTHER_OIDC",
  OTHER_SAML2 = "OTHER_SAML2",
}

export interface SsoUserRule {
  activeRule: SsoUserRules;
}

export type SsoUserRules =
  | DefaultDenyRule
  | DomainMatchRule
  | EmailMatchRule
  | FullAccountRule
  | UserListRule;

/** Fields for customizing SSU forms */
export interface SsuFormCustomization {
  /** Call to action */
  cta?: Maybe<Scalars["String"]>;
  /** Indicates whether we know if this application has been incorporated */
  isIncorporated?: Maybe<Scalars["Boolean"]>;
  /** Sub-heading */
  subheader?: Maybe<Scalars["String"]>;
  /** Title */
  title?: Maybe<Scalars["String"]>;
}

export interface SsuPrefillData {
  attributionToken?: Maybe<Scalars["String"]>;
  companyName?: Maybe<Scalars["String"]>;
  companyType?: Maybe<Scalars["String"]>;
  companyUrl?: Maybe<Scalars["String"]>;
  /** Form customization field */
  customization?: Maybe<SsuFormCustomization>;
  disclaimer?: Maybe<Scalars["String"]>;
  employeeCount?: Maybe<Scalars["String"]>;
  firstName?: Maybe<Scalars["String"]>;
  lastName?: Maybe<Scalars["String"]>;
  partnerLogoUrl?: Maybe<Scalars["String"]>;
  partnerName?: Maybe<Scalars["String"]>;
  workEmail?: Maybe<Scalars["String"]>;
}

export interface StackAdminHomeWidget {
  stackWidgets?: Maybe<Array<AdminHomeWidget>>;
}

/** A financial account that is flagged for triggering notifications for */
export interface StaleAccount {
  /** Contribution percentage of each financial account - directly from UW analysis flag */
  contributionPercentage: Scalars["Float"];
  financialAccount: FinancialAccount;
  financialAccountId: Scalars["String"];
  /** Stale days of each financial account - directly from UW analysis flag */
  staleDays: Scalars["Int"];
}

/** A stale financial source with some fields related to staleness */
export interface StaleSource {
  financialSource?: Maybe<FinancialSource>;
  financialSourceId: Scalars["String"];
  /** For Ocrolus sources, the datetime for the statement that's missing. Null for other vendors */
  missingStatementDatetime?: Maybe<Scalars["Time"]>;
  /** Stale account that's on financial account level but with stale info */
  staleAccounts: Array<StaleAccount>;
  /**
   * Stale days to display to the customer.
   * Accounts that belong to the same source should have the same stale days.
   * In case they're different - use the maximum of all stale days
   */
  staleDays: Scalars["Int"];
}

/**
 * The interface for standard client errors. All mutation errors should implement
 * this interface.
 */
export interface StandardClientError {
  /**
   * Error code representing an enum of known user error values used to map
   * to UI. Should be a fairly coarse characterization of an error that
   * should be sufficient for client side branching logic. Expect this to
   * remain relatively static. Domains can implement this error and use
   * errorType for further domain-specific branching logic
   */
  code: ErrorCode;
  /** An optional internal message used for debugging purposes */
  message?: Maybe<Scalars["String"]>;
  /** The path to the input field(s) that caused the error. */
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface StartAccountingIntegrationExportInput {
  /**
   * [oneOf] Filter to find accounting records to export.
   * Exactly one of [filter, entityFilter, sourceOriginatorIds, accountingRecordFilter] must be specified.
   * An exception will be thrown if none or multiple are passed.
   */
  accountingRecordFilter?: InputMaybe<AccountingRecordFilterInput>;
  /** The accrual date of the accounting event if marked for accrual. */
  accrualReversalDate?: InputMaybe<Scalars["Time"]>;
  /**
   * [oneOf] Entity Filter to use when querying against UGQL (queries service) for the entries to export
   * Exactly one of [filter, entityFilter, sourceOriginatorIds, accountingRecordFilter] must be specified.
   * An exception will be thrown if none or multiple are passed.
   */
  entityFilter?: InputMaybe<EntityFilterInput>;
  /** Required, the export method (CSV or Direct). */
  exportMethod: ExportMethod;
  /**
   * [oneOf]  The accounting journal search filter for entries to export. Either filter or sourceOriginatorIds is required.
   * Exactly one of [filter, entityFilter, sourceOriginatorIds, accountingRecordFilter] must be specified.
   * An exception will be thrown if none or multiple are passed.
   */
  filter?: InputMaybe<AccountingJournalEntryFilterInput>;
  /** Required, the accounting integration id. */
  integrationId: Scalars["ID"];
  /** Required, export notification type. */
  notificationType: ExportNotificationMethod;
  /**
   * [oneOf] List of source originator ids.
   * Exactly one of [filter, entityFilter, sourceOriginatorIds, accountingRecordFilter] must be specified.
   * An exception will be thrown if none or multiple are passed.
   */
  sourceOriginatorIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Optional, template id (required when method is CSV). */
  templateId?: InputMaybe<Scalars["ID"]>;
}

export interface StartAccountingIntegrationExportResult extends MutationResult {
  errors?: Maybe<Array<AccountingIntegrationMutationError>>;
  result?: Maybe<AccountingIntegration>;
}

export interface StartDepositsOffboardingInput {
  clientMutationId: Scalars["String"];
  closureReason: DepositsAccountClosureReason;
  depositsAccountId: Scalars["ID"];
}

export interface StartDepositsOffboardingPayload {
  clientMutationId: Scalars["String"];
  depositsAccount: DepositsAccount;
}

export interface StartIntegrationExportInput {
  clientMutationId: Scalars["String"];
  /** CSV template ID - returns a customizable CSV if export type is CSV and csv_template_id is not null, and is valid */
  csvTemplateId?: InputMaybe<Scalars["ID"]>;
  /** Time in user's timezone that report is generated */
  displayTime: Scalars["Time"];
  /** Export STEs before this date */
  endDateRange?: InputMaybe<Scalars["Time"]>;
  /** Type of export - 'csv', 'direct', or 'iif (go/qbd-iif-overview-external)' */
  exportType: ExportType;
  isPrimitive?: InputMaybe<Scalars["Boolean"]>;
  /** Notification preference when sync completes */
  notificationType?: InputMaybe<ExportNotificationType>;
  /** Export STEs/Expenses by Ids (only 1 of 2) */
  sourceIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Export STEs after this date */
  startDateRange?: InputMaybe<Scalars["Time"]>;
  statementEntryTypes?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
}

export interface StartIntegrationExportPayload {
  clientMutationId: Scalars["String"];
  /** Export_attempt_id to use for tracking export status and getting results */
  exportAttemptId?: Maybe<Scalars["ID"]>;
}

export interface StartResetUserInput {
  clientMutationId: Scalars["String"];
  user: StartResetUserUserInput;
}

export interface StartResetUserInputV2 {
  clientMutationId: Scalars["String"];
  user: StartResetUserUserInputV2;
}

export interface StartResetUserPayload {
  clientMutationId: Scalars["String"];
}

export interface StartResetUserUserInput {
  email: Scalars["String"];
}

export interface StartResetUserUserInputV2 {
  customerUserId?: InputMaybe<Scalars["String"]>;
  email?: InputMaybe<Scalars["String"]>;
}

export interface StartSpendMigrationImportInput {
  /** The filestore IDs of the statements to be processed for spend migration. Only one file is supported at the moment. */
  assetIds: Array<Scalars["ID"]>;
}

export interface StartSpendMigrationImportMutationError
  extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface StartSpendMigrationImportResult extends MutationResult {
  errors?: Maybe<Array<StartSpendMigrationImportMutationError>>;
  result?: Maybe<SpendMigrationImport>;
}

export interface StartUpdateUserEmailInput {
  /** The new email address to update to. */
  email: Scalars["String"];
  /** Optional user id to update. If not set, the update process will be started for the logged-in user. */
  userId?: InputMaybe<Scalars["String"]>;
}

export interface StartUpdateUserEmailResult extends MutationResult {
  errors?: Maybe<Array<ChangeEmailOperationError>>;
  result?: Maybe<PendingEmailChange>;
}

export interface StartVerificationAnalysisInput {
  /** Optional analysis context type. */
  analysisContextType?: InputMaybe<AnalysisContextType>;
  /** Client mutation ID. */
  clientMutationId: Scalars["String"];
  /** Requirement. */
  requirement: RequirementIdentifier;
  /** Subject ID. */
  subjectId: Scalars["String"];
}

/** An Statement stub entity that will be resolved by another DGS. */
export interface Statement {
  /** Balance at the beginning of the statement */
  beginningBalance: FinancialAsset;
  /** The billing currency for this statement */
  billingFinancialInstrument?: Maybe<FinancialInstrument>;
  /** Balance at the end of the statement */
  endingBalance: FinancialAsset;
  /** Unique identififer of the statement */
  id: Scalars["ID"];
  /** Statement insertion to the DB time */
  insertedAt: Scalars["Time"];
  /** The journal account for this statement */
  journalAccount: StatementJournalAccount;
  /** Statement end date time */
  periodEndTime: Scalars["Time"];
  /** Statement start date time */
  periodStartTime: Scalars["Time"];
  /** Metadata specific to the statement template requested */
  summaryMetadata: StatementSummaryMetadata;
}

export interface StatementCreditPayloadV2 {
  /** How many cents a point is worth in bulk statement redemption */
  usdCentsPerPoint: Scalars["Float"];
}

export interface StatementEntry extends Node {
  billableAmount?: Maybe<FinancialAsset>;
  /** The ID of an object */
  id: Scalars["ID"];
  lens?: Maybe<StatementEntryLens>;
}

export interface StatementEntryConnection {
  edges?: Maybe<Array<Maybe<StatementEntryEdge>>>;
  pageInfo: PageInfo;
}

export interface StatementEntryEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<StatementEntry>;
}

export interface StatementEntryLens extends Node {
  billableStatus?: Maybe<BillableStatus>;
  disabledRules?: Maybe<Array<Maybe<IntegrationRule>>>;
  displayFieldEntities?: Maybe<Array<Maybe<ExternalIntegrationEntity>>>;
  displayFields?: Maybe<Scalars["Json"]>;
  externalClass?: Maybe<ExternalIntegrationEntity>;
  externalDepartment?: Maybe<ExternalIntegrationEntity>;
  externalLocation?: Maybe<ExternalIntegrationEntity>;
  /** The ID of an object */
  id: Scalars["ID"];
  /**
   * Returns the computed integration field entities from integration rule engine for a ste.
   * We return a list of PEIEs as the PEIF data exists on the object itself to match in the frontend.
   */
  integrationFieldEntities?: Maybe<Array<Maybe<ExternalIntegrationEntity>>>;
  ruleEvaluations?: Maybe<Array<Maybe<IntegrationRuleEvaluation>>>;
  ste?: Maybe<StatementEntry>;
  userCategory?: Maybe<UserCategory>;
}

export interface StatementEntryLensConnection {
  edges?: Maybe<Array<Maybe<StatementEntryLensEdge>>>;
  pageInfo: PageInfo;
}

export interface StatementEntryLensEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<StatementEntryLens>;
}

export interface StatementJournalAccount {
  /** Journal account id */
  id: Scalars["ID"];
}

export type StatementSummaryMetadata =
  | CardSummaryMetadata
  | ReimbursementsApprovalSummaryMetadata
  | ReimbursementsPayoutSummaryMetadata;

export interface StatementUpload {
  fileUploadedBy: Scalars["ID"];
  uploadFileId: Scalars["ID"];
}

export interface StatementWithDownloadUrl {
  /** Respective download url */
  downloadUrl: Scalars["String"];
  /** Statement name in format MMM dd, yyyy - MMM dd, yyyy */
  name: Scalars["String"];
  /** Statement */
  statement?: Maybe<Statement>;
}

export interface StatementWithDownloadUrlEdge {
  node?: Maybe<StatementWithDownloadUrl>;
}

export interface StatementsConnection extends Connection {
  edges?: Maybe<Array<StatementsEdge>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface StatementsEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<Statement>;
}

export interface StatementsFilterInput {
  /** Flag to indicate whether custom period statements must be included in the response */
  includeCustomPeriodStatements?: InputMaybe<Scalars["Boolean"]>;
  /** The journal accounts ids to be queried */
  journalAccountsIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
  /** The owner types of journal accounts */
  ownerTypes?: InputMaybe<Array<InputMaybe<JournalAccountOwnerType>>>;
  /** Statement end date time */
  periodEndTime?: InputMaybe<Scalars["Time"]>;
  /** Statement start date time */
  periodStartTime?: InputMaybe<Scalars["Time"]>;
}

export interface StaticReportTemplateEntry {
  /** Static value to populate the column with */
  columnValue: Scalars["String"];
}

export interface StaticReportTemplateEntryInput {
  /** Static value to populate the column with */
  columnValue: Scalars["String"];
}

export interface StatsBreakdown {
  outstanding: FinancialAsset;
  overdue: FinancialAsset;
  paid: FinancialAsset;
  paidLast30d: FinancialAsset;
}

export enum Status {
  FAILED = "FAILED",
  PROCESSED = "PROCESSED",
  PROCESSING = "PROCESSING",
}

export interface StatusFilterInput {
  enrollment?: InputMaybe<Array<PolicyEnrollmentStatus>>;
  reviewStatus?: InputMaybe<Array<PolicyReviewStatus>>;
}

export enum StatusReason {
  ACCOUNT_CLOSED = "ACCOUNT_CLOSED",
  ACCOUNT_NOT_FOUND = "ACCOUNT_NOT_FOUND",
  ACH_DEBIT_CAPABILITY_REVOKED = "ACH_DEBIT_CAPABILITY_REVOKED",
  ADMIN_DENIED_APPROVAL = "ADMIN_DENIED_APPROVAL",
  BLOCKED_BY_POSITIVE_PAY = "BLOCKED_BY_POSITIVE_PAY",
  CUSTOMER_EDITED = "CUSTOMER_EDITED",
  EXCEEDS_AUTHORIZED_VENDOR_DRAWDOWN_AMOUNT = "EXCEEDS_AUTHORIZED_VENDOR_DRAWDOWN_AMOUNT",
  FAILED_VERIFICATION = "FAILED_VERIFICATION",
  INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
  MISSED_SEND_ON = "MISSED_SEND_ON",
  SACA_BALANCE_COMMITMENT_VIOLATION = "SACA_BALANCE_COMMITMENT_VIOLATION",
  SYSTEM_CANCELLED = "SYSTEM_CANCELLED",
  UNAUTHORIZED_VENDOR_DRAWDOWN_REQUEST = "UNAUTHORIZED_VENDOR_DRAWDOWN_REQUEST",
  USER_CANCELLED = "USER_CANCELLED",
}

/** Detail about an status update. */
export interface StatusUpdateDetails {
  /** Time at which the status update occurred. */
  updatedAt?: Maybe<Scalars["Time"]>;
}

/** Status view of a card */
export enum StatusView {
  ACTIVE = "ACTIVE",
  EXPIRED = "EXPIRED",
  LOCKED = "LOCKED",
  TERMINATED = "TERMINATED",
  WAITING_ACTIVATION = "WAITING_ACTIVATION",
}

export interface StepUpMfaConditionOutcomes {
  mfaStatus?: Maybe<MfaStatus>;
  sessionStatus?: Maybe<SessionStatus>;
}

/** This enum enables frontend customizations for specific stock reports */
export enum StockReportType {
  BILL_PAY = "BILL_PAY",
  COMPLIANCE = "COMPLIANCE",
  SPEND = "SPEND",
  TRAVEL = "TRAVEL",
}

export interface StringFieldInstance extends ExtendedFieldInstance, Node {
  dependencyOfAll?: Maybe<Array<ExtendedFieldInstance>>;
  dependsOnAll?: Maybe<Array<ExtendedFieldInstance>>;
  editStatus?: Maybe<FieldEditStatus>;
  extension?: Maybe<ExtendedFieldInstanceExtension>;
  field: ExtendedField;
  /** The ID of an object */
  id: Scalars["ID"];
  /** The instance of the value associated with this field instance. Null means unset */
  stringValue?: Maybe<Scalars["String"]>;
  updatedBy?: Maybe<ValueOriginator>;
  workflowValues?: Maybe<Array<WorkflowStringValue>>;
}

export interface StringFieldInstancedependencyOfAllArgs {
  filter?: InputMaybe<ExtendedFieldDependencyFilter>;
}

export interface StringFieldInstancedependsOnAllArgs {
  filter?: InputMaybe<ExtendedFieldDependencyFilter>;
}

export interface StringFieldInstanceInput {
  /** The client mutation id */
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fieldInstanceId: Scalars["ID"];
  /** Explicitly set this to null to clear the value */
  value?: InputMaybe<Scalars["String"]>;
}

export interface StringFilterInput {
  contains?: InputMaybe<Scalars["String"]>;
  endsWith?: InputMaybe<Scalars["String"]>;
  in?: InputMaybe<Array<Scalars["String"]>>;
  not?: InputMaybe<StringFilterInput>;
  notIn?: InputMaybe<Array<Scalars["String"]>>;
  startsWith?: InputMaybe<Scalars["String"]>;
}

export interface StringInconsistency {
  externalValue?: Maybe<Scalars["String"]>;
  scdValue?: Maybe<Scalars["String"]>;
}

export interface StringValue {
  value?: Maybe<Scalars["String"]>;
}

/**  Fields */
export interface StringValueInput {
  value?: InputMaybe<Scalars["String"]>;
}

/** Base interface for all structured data types in audit logs */
export interface StructuredData {
  /** The type discriminator for the structured data */
  type?: Maybe<Scalars["String"]>;
}

export interface StructuredValueInput {
  keyValuePairs: Array<KeyValuePairInput>;
}

export enum SubmissionFrequency {
  QUARTERLY = "QUARTERLY",
  YEARLY = "YEARLY",
  quarterly = "quarterly",
  yearly = "yearly",
}

/** Submission mode for a request. */
export enum SubmissionMode {
  /**  Validates payload only. Resulting request is ready for submission in subsequent batch call. */
  DEFERRED = "DEFERRED",
  /**  Validates and submits payload to resume evaluation. Resulting request is terminal. */
  IMMEDIATE = "IMMEDIATE",
}

export interface SubmitAirwallexCardsConsentInput {
  /** Whether the entity has given consent or not. */
  hasGiven: Scalars["Boolean"];
  /** The id of the entity to submit consent for. */
  legalEntityId: Scalars["ID"];
}

export interface SubmitAirwallexCardsConsentPayload {
  /** The legal entity id for which consent was submitted. */
  legalEntityId: Scalars["ID"];
}

export interface SubmitApplicationInfoInput {
  /** The application Id */
  applicationId: Scalars["String"];
  /** The client mutation id */
  clientMutationId: Scalars["String"];
}

export interface SubmitBillInput {
  /** Auto approve bill if submitter is on approval chain */
  autoApprove?: InputMaybe<Scalars["Boolean"]>;
  /** The Brex Invoice ID (if the invoice of the Bill is created by Brex) */
  brexInvoiceId?: InputMaybe<Scalars["String"]>;
  /** Unique identifier for the request. */
  clientMutationId: Scalars["String"];
  /** The bill ID to submit */
  id: Scalars["ID"];
}

export interface SubmitDocumentsError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface SubmitDocumentsInput {
  customerAccountId: Scalars["ID"];
  filestoreIdToType?: InputMaybe<Array<InputMaybe<FilestoreIdToType>>>;
}

export interface SubmitDocumentsResult extends MutationResult {
  errors?: Maybe<Array<SubmitDocumentsError>>;
}

export interface SubmitExpenseInput {
  /** clientMutationId */
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /**
   * expense ID to submit
   *
   * expenseId is optional
   * At least one of [expenseId, expenseMetadata] must be set.
   */
  expenseId?: InputMaybe<Scalars["ID"]>;
  /**
   * The input for the expense object.
   *
   * ExpenseInput must be set.
   * It is okay to set both arguments.
   */
  expenseMetadata: ExpenseInput;
  /** (OPTIONAL) Idempotency key */
  idempotencyKey?: InputMaybe<Scalars["String"]>;
  /**
   * The input for the integration fields.
   *
   * IntegrationInput is optional.
   * It is okay to set both arguments.
   */
  integration?: InputMaybe<IntegrationInput>;
}

export interface SubmitExpenseResult {
  /** List of errors when submitting the expense */
  errors?: Maybe<Array<ExpenseMutationError>>;
  /** The expense that was submitted. */
  expense?: Maybe<Expense>;
}

export interface SubmitFinancialStatementsInput {
  /** clientMutationId client-supplied idempotency key for a given mutation request. */
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** Financial statement request ID that will be submitted */
  encodedFinancialStatementRequestId: Scalars["ID"];
  /** Text explanation from the customer to associate with the submission */
  supportingDetails?: InputMaybe<Scalars["String"]>;
}

export interface SubmitFinancialStatementsResponse {
  financialStatementRequest: FinancialStatementRequest;
  success: Scalars["Boolean"];
}

export interface SubmitFinancialStatementsResult extends MutationResult {
  errors?: Maybe<Array<LimitsExperienceMutationError>>;
  /** API response */
  result?: Maybe<FinancialStatementRequest>;
}

/** SubmitLimitRequestInput */
export interface SubmitLimitIncreaseRequestInput {
  /** clientMutationId client-supplied idempotency key for a given mutation request. */
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** The expected monthly credit usage */
  expectedMonthlyCreditUsage?: InputMaybe<FinancialAssetInput>;
  /** otherReason if not pre-defined */
  otherReason?: InputMaybe<Scalars["String"]>;
  /** The reason why the limit increase is being submitted */
  reason: LimitIncreaseRequestReason;
}

export interface SubmitNotApplicableOnboardingInformationRequestInput {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
}

export interface SubmitNotApplicableOnboardingInformationRequestPayload {
  clientMutationId: Scalars["String"];
  informationRequest: OnboardingInformationRequest;
}

export interface SubmitOnboardingApplicationInput {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
}

export interface SubmitOnboardingApplicationPayload {
  clientMutationId: Scalars["String"];
  onboardingApplication: OnboardingApplication;
}

export interface SubmitOnboardingInformationRequestInput {
  clientMutationId: Scalars["String"];
  data?: InputMaybe<Scalars["Json"]>;
  id: Scalars["ID"];
}

export interface SubmitOnboardingInformationRequestPayload {
  clientMutationId: Scalars["String"];
  informationRequest: OnboardingInformationRequest;
}

export interface SubmitReceiptAutogenDisabledRationaleInput {
  /** Comment about disabling receipt autogen */
  receiptAutogenDisabledComment?: InputMaybe<Scalars["String"]>;
  /** Reasons for disabling receipt autogen */
  receiptAutogenDisabledReasons: Array<ReceiptAutogenDisabledReasonType>;
}

/**
 * END EXPENSE REQUEST RELATED OBJECTS
 * BEGIN REIMBURSEMENT REQUEST RELATED OBJECTS
 */
export interface SubmitReimbursementInput {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** (OPTIONAL) Idempotency key to use for this mutation. */
  idempotencyKey?: InputMaybe<Scalars["String"]>;
  /**
   * (OPTIONAL) Reimbursement ID to submit
   * At least one of [reimbursementItemId, updatedReimbursementMetadata] must be set.
   */
  reimbursementItemId?: InputMaybe<Scalars["ID"]>;
  /**
   * (OPTIONAL) Updated reimbursement metadata
   * At least one of [reimbursementItemId, updatedReimbursementMetadata] must be set.
   */
  updatedReimbursementMetadata?: InputMaybe<ReimbursementMetadataInput>;
}

/** Inputs for submitting a UserReviewTask. */
export interface SubmitUserReviewTasksInput {
  userReviewTasksOutcomeList: Array<UserReviewTaskOutcome>;
}

/** The result of a UserReviewTask submission. */
export interface SubmitUserReviewTasksResult {
  /** The UserReviewTask that was updated. */
  userReviewTaskOutcomeResult: Array<UserReviewTaskOutcomeResult>;
}

export interface SubmitVerificationRequestError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface SubmitVerificationRequestInput {
  /** Submission payload. */
  payload: VerificationSubmissionPayload;
  /** Request ID. */
  requestId: Scalars["ID"];
  /** Submission mode. Default to `DEFERRED`. */
  submissionMode?: InputMaybe<SubmissionMode>;
}

export interface SubmitVerificationRequestResult extends MutationResult {
  errors?: Maybe<Array<SubmitVerificationRequestError>>;
  result: VerificationRequest;
}

export interface Subregion {
  /** ISO 3166-1 alpha-2 representation of a province/state (ex. 'AL' for Alabama) */
  alpha2: Scalars["String"];
  /** Name of the province/state */
  name: Scalars["String"];
}

export interface SubscribeToGroupInput {
  /** Channel type being subscribed */
  channelType: Scalars["String"];
  clientMutationId: Scalars["String"];
  /** ID of the notification group to subscribe to */
  notificationGroupId: Scalars["ID"];
}

export interface SubscribeToGroupPayload {
  clientMutationId: Scalars["String"];
  subscription?: Maybe<SubscriptionV2>;
}

/** Represents a user's subscription to a notification group */
export interface SubscriptionV2 extends Node {
  /** subscription information for all channel types supported by this notification */
  channelTypes?: Maybe<Array<Maybe<ChannelTypeInfo>>>;
  /** The ID of an object */
  id: Scalars["ID"];
  /** notification category that this subscription references */
  notificationCategory: NotificationCategory;
  /** notification group that this subscription references */
  notificationGroup: NotificationGroup;
}

export interface SubscriptionV2Connection {
  edges?: Maybe<Array<Maybe<SubscriptionV2Edge>>>;
  pageInfo: PageInfo;
}

export interface SubscriptionV2Edge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<SubscriptionV2>;
}

export enum SubsegmentV4 {
  EARLY_STAGE_TIER_ONE = "EARLY_STAGE_TIER_ONE",
  EARLY_STAGE_TIER_THREE = "EARLY_STAGE_TIER_THREE",
  EARLY_STAGE_TIER_TWO = "EARLY_STAGE_TIER_TWO",
  ENTERPRISE = "ENTERPRISE",
  GROWTH_TIER_ONE = "GROWTH_TIER_ONE",
  GROWTH_TIER_TWO = "GROWTH_TIER_TWO",
  MID_MARKET = "MID_MARKET",
}

export enum SubsidiaryConnectionStatus {
  ACTIVE = "ACTIVE",
  DISABLED = "DISABLED",
}

export interface SubsidiaryInput {
  name: Scalars["String"];
  /** Convenience field so we can set status on creation */
  status?: InputMaybe<SubsidiaryStatus>;
  vendorInternalId: Scalars["String"];
}

/** Definition of a subsidiary payload. */
export interface SubsidiaryPayload {
  /** Accounts payable required segments */
  accountsPayableAdditionalRequiredSegments?: Maybe<
    Array<Maybe<RequiredSegment>>
  >;
  /** The GL account for accounts payable. */
  accountsPayableUserCategory?: Maybe<UserCategory>;
  /** The GL account id for accounts payable. */
  accountsPayableUserCategoryId?: Maybe<Scalars["ID"]>;
  /** AWX wallet account required segments */
  awxWalletAdditionalRequiredSegments?: Maybe<Array<Maybe<RequiredSegment>>>;
  /** The exchange account for locally funded reimbursements. */
  awxWalletUserCategory?: Maybe<UserCategory>;
  /** The exchange account for locally funded reimbursements */
  awxWalletUserCategoryId?: Maybe<Scalars["ID"]>;
  /** Cash/bank account required segments */
  collectionsAdditionalRequiredSegments?: Maybe<Array<Maybe<RequiredSegment>>>;
  /** The GL account for collections. */
  collectionsUserCategory?: Maybe<UserCategory>;
  /** The GL account id for collections. */
  collectionsUserCategoryId?: Maybe<Scalars["ID"]>;
  /** The external entity for customer. */
  customer?: Maybe<ExternalIntegrationEntity>;
  /** The external entity id for customer. */
  customerId?: Maybe<Scalars["ID"]>;
  /** The GL account id for intercompany payable. */
  intercompanyPayableId?: Maybe<Scalars["ID"]>;
  /** The GL account for intercompany payable. */
  intercompanyPayableUserCategory?: Maybe<UserCategory>;
  /** The GL account id for intercompany receivable. */
  intercompanyReceivableId?: Maybe<Scalars["ID"]>;
  /** The GL account for intercompany receivable. */
  intercompanyReceivableUserCategory?: Maybe<UserCategory>;
  /** Ledger Type only used for Oracle Fusion in child subsidiaries */
  ledgerType?: Maybe<Scalars["String"]>;
  /** Personal expense account required segments */
  personalExpenseAdditionalRequiredSegments?: Maybe<
    Array<Maybe<RequiredSegment>>
  >;
  /** Reimbursements clearing required segments */
  reimbursementClearingAdditionalRequiredSegments?: Maybe<
    Array<Maybe<RequiredSegment>>
  >;
  /** The GL account for reimbursement clearing. */
  reimbursementClearingUserCategory?: Maybe<UserCategory>;
  /** The GL account id for reimbursement clearing. */
  reimbursementClearingUserCategoryId?: Maybe<Scalars["ID"]>;
  /** Reimbursements account required segments */
  reimbursementsAdditionalRequiredSegments?: Maybe<
    Array<Maybe<RequiredSegment>>
  >;
  /** The GL account for reimbursements. */
  reimbursementsUserCategory?: Maybe<UserCategory>;
  /** The GL account id for reimbursements. */
  reimbursementsUserCategoryId?: Maybe<Scalars["ID"]>;
  /** The GL account for person expenses. */
  repaymentsUserCategory?: Maybe<UserCategory>;
  /** The GL account id for person expenses. */
  repaymentsUserCategoryId?: Maybe<Scalars["ID"]>;
  /** Rewards account required segments */
  rewardsAdditionalRequiredSegments?: Maybe<Array<Maybe<RequiredSegment>>>;
  /** The GL account for rewards redemption. */
  rewardsUserCategory?: Maybe<UserCategory>;
  /** The GL account id for rewards redemption. */
  rewardsUserCategoryId?: Maybe<Scalars["ID"]>;
  /** SageIntacct settings */
  sageIntacct?: Maybe<SubsidiaryPayloadSageIntacct>;
  /** Netsuite Subsidiary Payload Metadata: tax purchase accounts */
  taxPurchaseAccounts?: Maybe<Array<Maybe<TaxPurchaseAccount>>>;
  /** The external entity for vendor. */
  vendor?: Maybe<ExternalIntegrationEntity>;
  /** The external entity id for vendor. */
  vendorId?: Maybe<Scalars["ID"]>;
}

export interface SubsidiaryPayloadInput {
  /** Oracle Fusion only: AP required segments */
  accountsPayableAdditionalRequiredSegments?: InputMaybe<
    Array<InputMaybe<RequiredSegmentInput>>
  >;
  /** The GL account id for accounts payable. */
  accountsPayableUserCategoryId?: InputMaybe<Scalars["ID"]>;
  /** Oracle Fusion only: AWX wallet required segments */
  awxWalletAdditionalRequiredSegments?: InputMaybe<
    Array<InputMaybe<RequiredSegmentInput>>
  >;
  /** The GL account id for AWX wallet. */
  awxWalletUserCategoryId?: InputMaybe<Scalars["ID"]>;
  /** Oracle Fusion only: cash/bank required segments */
  collectionsAdditionalRequiredSegments?: InputMaybe<
    Array<InputMaybe<RequiredSegmentInput>>
  >;
  /** The GL account id for collections. */
  collectionsUserCategoryId?: InputMaybe<Scalars["ID"]>;
  /** The external entity id for customer. */
  customerId?: InputMaybe<Scalars["ID"]>;
  /** The GL account id for intercompany payable. */
  intercompanyPayableId?: InputMaybe<Scalars["ID"]>;
  /** The GL account id for intercompany receivable. */
  intercompanyReceivableId?: InputMaybe<Scalars["ID"]>;
  /** Ledger Type */
  ledgerType?: InputMaybe<Scalars["String"]>;
  /** Oracle Fusion only: personal expense required segments */
  personalExpenseAdditionalRequiredSegments?: InputMaybe<
    Array<InputMaybe<RequiredSegmentInput>>
  >;
  /** Oracle Fusion only: reimbursement clearing required segments */
  reimbursementClearingAdditionalRequiredSegments?: InputMaybe<
    Array<InputMaybe<RequiredSegmentInput>>
  >;
  /** The GL account id for reimbursement clearing. */
  reimbursementClearingUserCategoryId?: InputMaybe<Scalars["ID"]>;
  /** Oracle Fusion only: reimbursements required segments */
  reimbursementsAdditionalRequiredSegments?: InputMaybe<
    Array<InputMaybe<RequiredSegmentInput>>
  >;
  /** The GL account id for reimbursements. */
  reimbursementsUserCategoryId?: InputMaybe<Scalars["ID"]>;
  /** The GL account id for person expenses. */
  repaymentsUserCategoryId?: InputMaybe<Scalars["ID"]>;
  /** Oracle Fusion only: rewards required segments */
  rewardsAdditionalRequiredSegments?: InputMaybe<
    Array<InputMaybe<RequiredSegmentInput>>
  >;
  /** The GL account id for rewards redemption. */
  rewardsUserCategoryId?: InputMaybe<Scalars["ID"]>;
  sageIntacct?: InputMaybe<SubsidiaryPayloadSageIntacctInput>;
  /** Netsuite Subsidiary Payload Metadata: tax purchase accounts */
  taxPurchaseAccounts?: InputMaybe<Array<InputMaybe<TaxPurchaseAccountInput>>>;
  /** The external entity id for vendor. */
  vendorId?: InputMaybe<Scalars["ID"]>;
}

/** Payload for subsidiaries in Sage Intacct */
export interface SubsidiaryPayloadSageIntacct {
  /** ID of the credit card account to use for exports of card expenses */
  exportCardId?: Maybe<Scalars["String"]>;
}

/** Payload for subsidiaries in Sage Intacct (input) */
export interface SubsidiaryPayloadSageIntacctInput {
  /** ID of the credit card account to use for exports of card expenses (input) */
  exportCardId?: InputMaybe<Scalars["String"]>;
}

export enum SubsidiarySettingErrorType {
  INVALID_ACCOUNTS_PAYABLE_GL = "INVALID_ACCOUNTS_PAYABLE_GL",
  MISSING_ACCOUNTS_PAYABLE_GL = "MISSING_ACCOUNTS_PAYABLE_GL",
  MISSING_ACCRUED_LIABILITY_GL = "MISSING_ACCRUED_LIABILITY_GL",
  MISSING_AWX_WALLET_GL = "MISSING_AWX_WALLET_GL",
  MISSING_BREX_REIMBURSEMENT_CLEARING_GL = "MISSING_BREX_REIMBURSEMENT_CLEARING_GL",
  MISSING_CARD_BANK_ACCOUNT_GL = "MISSING_CARD_BANK_ACCOUNT_GL",
  MISSING_MANUAL_PAYMENTS_BANK_ACCOUNT_GL = "MISSING_MANUAL_PAYMENTS_BANK_ACCOUNT_GL",
  MISSING_PERSONAL_EXPENSE_RECEIVABLE_GL = "MISSING_PERSONAL_EXPENSE_RECEIVABLE_GL",
  MISSING_REIMBURSEMENT_ACCRUED_LIABILITY_GL = "MISSING_REIMBURSEMENT_ACCRUED_LIABILITY_GL",
  MISSING_REIMBURSEMENT_BANK_ACCOUNT_GL = "MISSING_REIMBURSEMENT_BANK_ACCOUNT_GL",
  MISSING_REIMBURSEMENT_LIABILITY_GL = "MISSING_REIMBURSEMENT_LIABILITY_GL",
  MISSING_REWARDS_GL = "MISSING_REWARDS_GL",
}

export interface SubsidiarySettingsCreateDefaultIntegrationFieldMappingInput {
  extendedFieldOptionIds: Array<Scalars["ID"]>;
  subsidiaryOptionId: Scalars["ID"];
}

export interface SubsidiarySettingsDeleteDefaultIntegrationFieldMappingInput {
  defaultFieldIds: Array<Scalars["ID"]>;
  subsidiaryOptionId: Scalars["ID"];
}

export interface SubsidiarySettingsDeleteEntityMappingInput {
  legalEntityIds: Array<Scalars["ID"]>;
  subsidiaryOptionId: Scalars["ID"];
}

export interface SubsidiarySettingsUpdateDefaultIntegrationFieldMappingInput {
  defaultIntegrationFieldMappings?: InputMaybe<
    Array<DefaultAccountingIntegrationFieldMappingInput>
  >;
  subsidiaryOptionId: Scalars["ID"];
}

export interface SubsidiarySettingsUpdateEntityMappingInput {
  legalEntityIds?: InputMaybe<Array<Scalars["ID"]>>;
  subsidiaryOptionId: Scalars["ID"];
}

export enum SubsidiaryStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

export interface Suggestion {
  field: Scalars["String"];
  options: Array<Maybe<SuggestionType>>;
}

export enum SuggestionConfidenceLevel {
  HIGH = "HIGH",
  LOW = "LOW",
  MEDIUM = "MEDIUM",
}

/** Enum type for suggestion status. */
export enum SuggestionEnablementStatusType {
  ENABLED = "ENABLED",
  NOT_ENABLED = "NOT_ENABLED",
}

export type SuggestionType =
  | Department
  | Location
  | Merchant
  | MerchantCategory
  | User
  | UserCategory;

export interface SuggestionsBoolValue {
  value?: Maybe<Scalars["Boolean"]>;
}

/**
 * Address of a Core Field (e.g. expense memo).
 *
 * Uses the Queries Service fieldKey format (e.g. expense.memo)
 * https://github.com/brexhq/credit_card/blob/main/protos/business_intelligence/v1/resources/query.proto#L9-L17
 *
 * See the ColumnNameMap for list of available fields
 * https://github.com/brexhq/credit_card/blob/main/spend/businessintelligence/src/main/kotlin/brex/businessintelligence/data/ColumnNameMap.kt
 */
export interface SuggestionsCoreFieldAddress {
  address: Scalars["String"];
}

/**
 * Input for addressing a Core Field (e.g. expense memo).
 *
 * Use the Queries Service fieldKey format (e.g. expense.memo)
 * https://github.com/brexhq/credit_card/blob/main/protos/business_intelligence/v1/resources/query.proto#L9-L17
 *
 * See the ColumnNameMap for list of available fields
 * https://github.com/brexhq/credit_card/blob/main/spend/businessintelligence/src/main/kotlin/brex/businessintelligence/data/ColumnNameMap.kt
 */
export interface SuggestionsCoreFieldAddressInput {
  address: Scalars["String"];
}

export interface SuggestionsDecimalValue {
  value?: Maybe<Scalars["Decimal"]>;
}

/** VX Workflow Action to delete a Field */
export interface SuggestionsDeleteAction {
  /** The field to delete. */
  leftHandSide: SuggestionsLeftHandSide;
}

/** VX Workflow Action to delete a Field */
export interface SuggestionsDeleteActionInput {
  /** The field to delete. */
  leftHandSide: SuggestionsLeftHandSideOneOfInput;
}

/**
 * Only one of these will be set.
 * You can't have a union of enums in GraphQL
 *
 * Enums are duplicated here to avoid sharing types across DGS which is brittle and tricky to work with.
 */
export interface SuggestionsEnumValueOneOf {
  billableStatus?: Maybe<SuggestionsWorkflowRuleBillableStatus>;
  expenseStatus?: Maybe<SuggestionsWorkflowRuleExpenseStatus>;
}

/**
 * Acts as an input union/oneOf depending on which field is not NULL
 * One field is required to be set
 *
 * Enums are duplicated here to avoid sharing types across DGS which is brittle and tricky to work with.
 */
export interface SuggestionsEnumValueOneOfInput {
  billableStatus?: InputMaybe<SuggestionsWorkflowRuleBillableStatus>;
  expenseStatus?: InputMaybe<SuggestionsWorkflowRuleExpenseStatus>;
}

/** Address of an Extended Field (e.g. extended_field_foo123) */
export interface SuggestionsExtendedFieldAddress {
  id: Scalars["ID"];
}

/** Input for addressing Extended Fields (e.g. extended_field_foo123) */
export interface SuggestionsExtendedFieldAddressInput {
  id: Scalars["ID"];
}

export interface SuggestionsExtendedFieldSingleValue {
  value?: Maybe<SuggestionsExtendedFieldSingleValueUnion>;
}

export type SuggestionsExtendedFieldSingleValueUnion =
  | SuggestionsBoolValue
  | SuggestionsDecimalValue
  | SuggestionsIdentifierToStringValue
  | SuggestionsStringValue
  | SuggestionsTimestampValue;

export type SuggestionsFilterMetadata = SuggestionsNestedBudgetMetadata;

/**
 * Acts as an input union/oneOf depending on which field is not NULL
 * One field is required to be set
 */
export interface SuggestionsFilterMetadataOneOfInput {
  nestedBudgetMetadata?: InputMaybe<SuggestionsNestedBudgetMetadataInput>;
}

/** The operator for the filter */
export enum SuggestionsFilterOperator {
  EQUALS = "EQUALS",
  GREATER_THAN = "GREATER_THAN",
  GREATER_THAN_EQUAL = "GREATER_THAN_EQUAL",
  /** The leftHandSide string contains the rightHandSide string (case insensitive) */
  ILIKE = "ILIKE",
  /** The leftHandSide value is IN the list of rightHandSide values */
  IN = "IN",
  /**
   * Unary operator.
   *
   * Check that the value of leftHandSide field is "empty". Additional checks based on the type of the leftHandSide:
   * String -> value should be an empty string if not null
   * List (MultipleValues) -> value should be an empty list of not null
   * Everything else -> value should be null
   *
   * The rightHandSide value should be left empty and will be ignored if set.
   */
  IS_EMPTY = "IS_EMPTY",
  /** The inverse of the IS_EMPTY operator */
  IS_NOT_EMPTY = "IS_NOT_EMPTY",
  /** The inverse of the IS_NULL operator */
  IS_NOT_NULL = "IS_NOT_NULL",
  /**
   * Unary operator.
   *
   * Check if the leftHandSide value is null.
   * The rightHandSide value should be left empty and will be ignored if set.
   */
  IS_NULL = "IS_NULL",
  LESS_THAN = "LESS_THAN",
  LESS_THAN_EQUAL = "LESS_THAN_EQUAL",
  NOT_EQUALS = "NOT_EQUALS",
  /** The leftHandSide string does not contain the rightHandSide string (case insensitive) */
  NOT_ILIKE = "NOT_ILIKE",
  /** The leftHandSide value is NOT IN the list of rightHandSide values */
  NOT_IN = "NOT_IN",
}

export interface SuggestionsFinancialAssetValue {
  value?: Maybe<FinancialAsset>;
}

export interface SuggestionsIdentifierToStringValue {
  displayName?: Maybe<Scalars["String"]>;
  identifier?: Maybe<Scalars["String"]>;
  option?: Maybe<ExtendedFieldOption>;
}

/**
 * The left hand side operand of the filter or action.
 *
 * Can be used to address either a Primitive Core Field or an Extended Field.
 */
export type SuggestionsLeftHandSide =
  | SuggestionsCoreFieldAddress
  | SuggestionsExtendedFieldAddress;

/**
 * The left hand side operand of the filter or action.
 *
 * Can be used to address either a Primitive Core Field or an Extended Field.
 */
export interface SuggestionsLeftHandSideOneOfInput {
  coreFieldAddress?: InputMaybe<SuggestionsCoreFieldAddressInput>;
  extendedFieldAddress?: InputMaybe<SuggestionsExtendedFieldAddressInput>;
}

/**
 * Metadata used to create a "Nested Budget" Filter
 *
 * Nested Budget Filters apply to the specified budgetIds AND all of their descendants
 */
export interface SuggestionsNestedBudgetMetadata {
  /**
   * Budget IDs who's descendants will also match the Filter
   * The budget IDs in this list MUST also be in the rightHandSide of the Filter
   */
  applyNestedBudgetIds: Array<Scalars["ID"]>;
  /**
   * Budget IDs explicitly excluded from matching the Filter
   * e.g. budget hierarchy A->B->C->D (applyNested: [B], exclude: [C]) will match B and D
   */
  excludeBudgetIds: Array<Scalars["ID"]>;
}

/**
 * Metadata used to create a "Nested Budget" Filter
 *
 * Nested Budget Filters apply to the specified budgetIds AND all of their descendants
 */
export interface SuggestionsNestedBudgetMetadataInput {
  /**
   * Budget IDs who's descendants will also match the Filter
   * The budget IDs in this list MUST also be in the rightHandSide of the Filter
   */
  applyNestedBudgetIds: Array<Scalars["ID"]>;
  /**
   * Budget IDs to explicitly exclude from matching the Filter
   * e.g. budget hierarchy A->B->C->D (applyNested: [B], exclude: [C]) will match B and D
   */
  excludeBudgetIds: Array<Scalars["ID"]>;
}

export type SuggestionsRightHandSide =
  | SuggestionsRightHandSideMultipleValues
  | SuggestionsRightHandSideSingleValue;

export interface SuggestionsRightHandSideMultipleValues {
  values: Array<SuggestionsRightHandSideSingleValueUnion>;
}

/** Policy Engine currently only supports lists of strings & identifiers */
export interface SuggestionsRightHandSideMultipleValuesOneOfInput {
  identifierValues?: InputMaybe<Array<Scalars["ID"]>>;
  stringValues?: InputMaybe<Array<Scalars["String"]>>;
}

/**
 * Acts as an input union/oneOf depending on which field is not NULL
 * One field is required to be set
 */
export interface SuggestionsRightHandSideOneOfInput {
  multipleValues?: InputMaybe<SuggestionsRightHandSideMultipleValuesOneOfInput>;
  singleValue?: InputMaybe<SuggestionsRightHandSideSingleValueOneOfInput>;
}

export interface SuggestionsRightHandSideSingleValue {
  value: SuggestionsRightHandSideSingleValueUnion;
}

/**
 * Acts as an input union/oneOf depending on which field is not NULL
 * One field is required to be set
 */
export interface SuggestionsRightHandSideSingleValueOneOfInput {
  booleanValue?: InputMaybe<Scalars["Boolean"]>;
  decimalValue?: InputMaybe<Scalars["Decimal"]>;
  enumValue?: InputMaybe<SuggestionsEnumValueOneOfInput>;
  financialAssetValue?: InputMaybe<FinancialAssetInput>;
  identifierValue?: InputMaybe<Scalars["ID"]>;
  stringValue?: InputMaybe<Scalars["String"]>;
  timestampValue?: InputMaybe<Scalars["Time"]>;
}

export type SuggestionsRightHandSideSingleValueUnion =
  | SuggestionsBoolValue
  | SuggestionsDecimalValue
  | SuggestionsEnumValueOneOf
  | SuggestionsFinancialAssetValue
  | SuggestionsIdentifierToStringValue
  | SuggestionsStringValue
  | SuggestionsTimestampValue;

/** VX Workflow Action to set a Field */
export interface SuggestionsSetAction {
  /** The field to set. */
  leftHandSide: SuggestionsLeftHandSide;
  /** The field value that will be set */
  rightHandSide: SuggestionsRightHandSide;
}

/** VX Workflow Action to set a Field */
export interface SuggestionsSetActionInput {
  /** The field to set. */
  leftHandSide: SuggestionsLeftHandSideOneOfInput;
  /** The field value that will be set */
  rightHandSide: SuggestionsRightHandSideOneOfInput;
}

/** The type of resource that the extended field is attached to */
export enum SuggestionsSourceObjectType {
  ACCOUNTING_RECORD = "ACCOUNTING_RECORD",
  ACCOUNTING_RECORD_LINE_ITEM = "ACCOUNTING_RECORD_LINE_ITEM",
  EXPENSE = "EXPENSE",
}

export interface SuggestionsStringValue {
  value?: Maybe<Scalars["String"]>;
}

export interface SuggestionsTimestampValue {
  value?: Maybe<Scalars["Time"]>;
}

/** The specific Workflow this Rule is associated with */
export enum SuggestionsWorkflow {
  /**
   * The workflow for Accounting Rules
   * Allows automatic categorization of Expenses and Accounting Records
   * Powers the Accounting Mappings page as well as Accounting Custom Rules page
   *
   * Required tag: `accounting_integration_id`
   */
  ACCOUNTING = "ACCOUNTING",
  /**
   * The workflow for Budget Override Rules
   * Overrides change the default categories for expenses in this budget and its nested budgets.
   * Powers the Budget Overrides tab in the advanced settings page for Budgets
   *
   * Required tag: `budget_id`
   */
  BUDGET_OVERRIDE = "BUDGET_OVERRIDE",
}

/** Union of the available VX Workflow Actions */
export type SuggestionsWorkflowRuleAction =
  | SuggestionsDeleteAction
  | SuggestionsSetAction;

/**
 * Acts as an input union/oneOf depending on which field is not NULL
 * One field is required to be set
 */
export interface SuggestionsWorkflowRuleActionOneOfInput {
  deleteAction?: InputMaybe<SuggestionsDeleteActionInput>;
  setAction?: InputMaybe<SuggestionsSetActionInput>;
}

export enum SuggestionsWorkflowRuleBillableStatus {
  BILLABLE_TYPE_BILLABLE = "BILLABLE_TYPE_BILLABLE",
  BILLABLE_TYPE_NON_BILLABLE = "BILLABLE_TYPE_NON_BILLABLE",
  BILLABLE_TYPE_NOT_SET = "BILLABLE_TYPE_NOT_SET",
}

/**
 * We currently only need the APPROVED status for expenses to support the "is approved" filter.
 * More can be added when/if needed.
 */
export enum SuggestionsWorkflowRuleExpenseStatus {
  /** An approved expense is public, with a request evaluated to have met the policy requirements */
  APPROVED = "APPROVED",
}

/** VX Workflow Rule Filter */
export interface SuggestionsWorkflowRuleFilter {
  /**
   * Additional metadata for how to create the filter
   * See the particular metadata type for more information on the impacts it will have to the filter
   */
  filterMetadata?: Maybe<SuggestionsFilterMetadata>;
  /** The Field to filter on. Left hand side operand */
  leftHandSide: SuggestionsLeftHandSide;
  /**
   * The operator to be used for this filter.
   * Operands use infix notation like '<leftHandSide> <operator> <rightHandSide>'
   * (e.g. 'amount > 100' where lhs = amount, operator = >, rhs = 100)
   */
  operator: SuggestionsFilterOperator;
  /**
   * The value that needs to match the filter based on the operator. Right hand side operand
   *
   * Will be null when accompanied by a unary operator (e.g. 'IS_NULL')
   */
  rightHandSide?: Maybe<SuggestionsRightHandSide>;
}

export interface SuggestionsWorkflowRuleFilterInput {
  /**
   * Additional metadata for how to create the filter
   * See the particular metadata type for more information on the impacts it will have to the filter
   */
  filterMetadata?: InputMaybe<SuggestionsFilterMetadataOneOfInput>;
  /** The Field to filter on. Left hand side operand */
  leftHandSide: SuggestionsLeftHandSideOneOfInput;
  /**
   * The operator to be used for this filter.
   * Operands use infix notation like '<leftHandSide> <operator> <rightHandSide>'
   * (e.g. 'amount > 100' where lhs = amount, operator = >, rhs = 100)
   */
  operator: SuggestionsFilterOperator;
  /**
   * The value that needs to match the filter based on the operator. Right hand side operand
   *
   * Should be left null when using a unary operator (e.g. 'IS_NULL').
   * It will be ignored if set alongside a unary operator.
   */
  rightHandSide?: InputMaybe<SuggestionsRightHandSideOneOfInput>;
}

export interface SuggestionsWorkflowRulePriority {
  /** The priority of the rule */
  priority: Scalars["Int"];
}

/**
 * VX Workflows
 * ------------
 * Based on extensibility/src/main/resources/extensible_platform_dgs.graphqls
 */
export interface SuggestionsWorkflowRulePriorityInput {
  priority: Scalars["Int"];
}

/** The status of the Workflow Rule */
export enum SuggestionsWorkflowRuleStatus {
  /**  The rule is soft deleted by a user or service and cannot be evaluated  */
  DELETED = "DELETED",
  /**  The rule will be enabled and can be evaluated  */
  ENABLED = "ENABLED",
}

/**
 * Tag belonging to a VX Workflow Rule.
 * Can be used to store client specific metadata about the rule.
 */
export interface SuggestionsWorkflowRuleTag {
  key: Scalars["String"];
  value: Scalars["String"];
}

/** Input fields for filtering by VX Workflow Rule tags */
export interface SuggestionsWorkflowRuleTagFilterInput {
  key: Scalars["String"];
  value: Scalars["String"];
}

export interface SumAggregationResult {
  name: Scalars["String"];
  value: Scalars["Float"];
}

/** Summary of different card aggregations. */
export interface Summary {
  numValidMetal?: Maybe<Scalars["Int"]>;
  numValidPhysical?: Maybe<Scalars["Int"]>;
  numValidVirtual?: Maybe<Scalars["Int"]>;
  numWaitingActivation?: Maybe<Scalars["Int"]>;
}

export enum SunlightMigrationStatus {
  /** Use of Sunlight is not available for this VendorFileMatch. Set via frontend on sync failure from Sunlight SDK */
  BLOCKED = "BLOCKED",
  /** Card on file was successfully migrated. Set via Sunlight backend callback. */
  COMPLETED = "COMPLETED",
  /** Card on file could not be migrated due to an error. Set via Sunlight backend callback. */
  FAILED = "FAILED",
  /**
   * Reflects that Sunlight has been successfully configured to migrate the card on file, though the migration has not yet
   * been started by the user.
   */
  INITIALIZED = "INITIALIZED",
  /** Async migration is in progress. This value reflects a backend callback from Sunlight, rather than a direct user action. */
  IN_PROGRESS = "IN_PROGRESS",
}

/**
 * Fields to initialize the Sunlight API
 * https://docs.sunlightapi.com/docs/sdk-initialization#initialization
 */
export interface SunlightSDKConfig {
  sunlightAccessToken: Scalars["String"];
  sunlightCardId?: Maybe<Scalars["String"]>;
  sunlightCustomizationId?: Maybe<Scalars["String"]>;
  sunlightUserId: Scalars["String"];
}

export enum SuperAdminUpgradeStatus {
  PENDING = "PENDING",
}

/** Encapsulates all Support Channels information such as availability and SLA */
export interface SupportChannels {
  /** Call support channel information */
  call?: Maybe<Call>;
  /** Chat support channel information */
  chat?: Maybe<Chat>;
  /** Email support channel information */
  email?: Maybe<EmailChannel>;
}

/** The type of the surface */
export enum Surface {
  AMS = "AMS",
  INBOX_DASHBOARD = "INBOX_DASHBOARD",
  INBOX_MOBILE = "INBOX_MOBILE",
  SLACK = "SLACK",
}

/** Group of tasks types. */
export enum SurfaceGroup {
  ACCOUNT = "ACCOUNT",
  ALL = "ALL",
  ALL_PERSONAL = "ALL_PERSONAL",
  ALL_WALLET = "ALL_WALLET",
  /** @deprecated Please use either APPROVALS_SPEND_LIMIT_REQUESTS or APPROVALS_SPEND_LIMIT_INCREASE_REQUESTS instead. */
  APPROVALS = "APPROVALS",
  APPROVALS_SPEND_LIMIT_INCREASE_REQUESTS = "APPROVALS_SPEND_LIMIT_INCREASE_REQUESTS",
  APPROVALS_SPEND_LIMIT_REQUESTS = "APPROVALS_SPEND_LIMIT_REQUESTS",
  BANKING = "BANKING",
  /**  Tasks Page Groups - legacy TaskInboxCount - Dashboard specific groups */
  BILL_EXPENSE_APPROVALS = "BILL_EXPENSE_APPROVALS",
  BUDGET_ANY_REQUEST_APPROVALS = "BUDGET_ANY_REQUEST_APPROVALS",
  BUDGET_REQUESTS = "BUDGET_REQUESTS",
  CARD_EXPENSE_APPROVALS = "CARD_EXPENSE_APPROVALS",
  CLOSE_YOUR_BOOKS = "CLOSE_YOUR_BOOKS",
  COMMENTS = "COMMENTS",
  COMPANY_REPAYMENTS = "COMPANY_REPAYMENTS",
  CRITICAL = "CRITICAL",
  DRAFTS = "DRAFTS",
  EMPOWER_YOUR_TEAM = "EMPOWER_YOUR_TEAM",
  EXPENSE_REQUESTS = "EXPENSE_REQUESTS",
  GET_YOUR_PRODUCTS = "GET_YOUR_PRODUCTS",
  MISSING_ATTENDEES = "MISSING_ATTENDEES",
  MISSING_DOCUMENTATION = "MISSING_DOCUMENTATION",
  PAY_YOUR_VENDORS = "PAY_YOUR_VENDORS",
  PENDING_TRANSACTION_APPROVALS = "PENDING_TRANSACTION_APPROVALS",
  PERSONAL_ACCOUNT = "PERSONAL_ACCOUNT",
  PERSONAL_EXPENSES = "PERSONAL_EXPENSES",
  REIMBURSEMENT_EXPENSE_APPROVALS = "REIMBURSEMENT_EXPENSE_APPROVALS",
  REQUESTS = "REQUESTS",
  SETUP_EMBEDDED_ACCOUNT = "SETUP_EMBEDDED_ACCOUNT",
  SPEND_INSIGHTS = "SPEND_INSIGHTS",
  START_SPENDING = "START_SPENDING",
  TASKS_COMPANY = "TASKS_COMPANY",
  TASKS_PERSONAL = "TASKS_PERSONAL",
  TEAM_APPROVALS = "TEAM_APPROVALS",
  TRAVEL = "TRAVEL",
  TRIPS = "TRIPS",
  USER_PENDING_REQUESTS = "USER_PENDING_REQUESTS",
}

export interface SurfaceGroupCount {
  /** Provided as a string label, as anything above 99 is labeled as 99+ */
  count: Scalars["String"];
  /** SurfaceGroup in which this count refers to. */
  surfaceGroup: SurfaceGroup;
}

export interface SurfaceGroupTask {
  /** The group */
  group: SurfaceGroup;
  /**
   * The group name
   * @deprecated Use group instead
   */
  groupName: Scalars["String"];
  tasks: Array<SurfaceTask>;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface SurfaceGroupTaskEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The SurfaceTask at this edge. */
  node?: Maybe<SurfaceGroupTask>;
}

/** Displayed in the user's surface, a task represents an action that a user needs to take. */
export interface SurfaceTask extends Node {
  /** The task's criticality */
  criticality: SurfaceTaskCriticality;
  /** The raw task creation date. Useful for clientside sorting, filtering, and apply date section headers. */
  date: Scalars["Time"];
  /** The order set by its position in the policy */
  executionOrder?: Maybe<Scalars["Int"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  /** A list of request actions associated with the task */
  requestActions?: Maybe<Array<RequestAction>>;
  /** Base64 encoded ID of the Request associated with the Task. Null for Draft Reimbursements only */
  requestId?: Maybe<Scalars["String"]>;
  surfaceTaskMaterializedView?: Maybe<SurfaceTaskMaterializedView>;
  /** State of this task, currently RESOLVED or UNRESOLVED */
  taskState: SurfaceTaskState;
  /**
   * The task type. Used as the source of truth for building tables on dashboard, and informing mobile task completion
   * actions.
   * @deprecated Use type instead
   */
  taskType: Scalars["String"];
  type: InboxTaskType;
}

/** Defines the label and style (for severity) of the badge displayed with the task in the inbox. */
export interface SurfaceTaskBadge {
  /** The text contained in the badge. */
  label: Scalars["String"];
  /** The style of the badge. This is used for different levels of priority/severity of tasks. */
  style: SurfaceTaskBadgeStyle;
}

/** Style and color of the badge (for criticality, due date) displayed with the task. */
export enum SurfaceTaskBadgeStyle {
  DANGER = "DANGER",
  DEFAULT = "DEFAULT",
  WARNING = "WARNING",
}

export interface SurfaceTaskConnection extends Connection {
  /** The items in the current page of results. */
  edges: Array<SurfaceGroupTaskEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** total count of tasks */
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface SurfaceTaskCounts {
  /** Counts broken down by SurfaceGroups provided in the input */
  countsBySurfaceGroup?: Maybe<Array<SurfaceGroupCount>>;
  /** Provided as a string label, as anything above 99 is labeled as 99+ */
  totalCount: Scalars["String"];
}

/** Task criticality. */
export enum SurfaceTaskCriticality {
  CRITICAL = "CRITICAL",
  OPTIONAL = "OPTIONAL",
  REQUIRED = "REQUIRED",
}

export interface SurfaceTaskCta {
  /** The CTA label, e.g., "RSVP". The client will look to the task type and entity to inform what action to take. */
  label: Scalars["String"];
  /** The CTA style/colour. */
  style?: Maybe<SurfaceTaskCtaStyle>;
}

/** Style and color of the task's CTA (e.g. for criticality) displayed with the task. */
export enum SurfaceTaskCtaStyle {
  DANGER = "DANGER",
  DEFAULT = "DEFAULT",
  GHOST = "GHOST",
}

export interface SurfaceTaskCtas {
  /** Dismiss cta for a task. Only returned for tasks that are dismissible. */
  dismiss?: Maybe<SurfaceTaskCta>;
  /** Primary cta for a task. Should always be returned. */
  primary: SurfaceTaskCta;
  /** Resolve cta for a task. Only returned for tasks that are resolvable by the user. */
  resolve?: Maybe<SurfaceTaskCta>;
}

/** Defines which icon is displayed next to the task in the inbox. */
export interface SurfaceTaskIcon {
  /** The icon's accessibility text that is announced for vision impaired users. *\/ */
  accessibilityText: Scalars["String"];
  /** A local Metal icon string constant. */
  localMetalIcon?: Maybe<Scalars["String"]>;
  /** A remote icon that the client is responsible for loading via the URL. *\/ */
  remoteIcon?: Maybe<SurfaceTaskRemoteIcon>;
}

export interface SurfaceTaskMaterializedView {
  /** The optional task badge */
  badge?: Maybe<SurfaceTaskBadge>;
  ctas: SurfaceTaskCtas;
  /**
   * The local Metal icon, e.g.,. a "checkmark," or the URL of the remote icon that the client must load. The remote icon
   * takes precedence over the local icon if both are present.
   */
  icon: SurfaceTaskIcon;
  /** The task subtitle, e.g., "Starbucks ��� $9.99". */
  subtitle: Scalars["String"];
  /**
   * Task entity details. At minimum this includes the entity ID, e.g. "expense_123," but can be extended to include more
   * fields like the expense entity.
   */
  taskEntityDetails: InboxTaskEntityDetails;
  /** The task title, e.g., "Missing memo". */
  title: Scalars["String"];
}

/** URL(s) for the remote icon that will be displayed next to the task in the inbox. */
export interface SurfaceTaskRemoteIcon {
  /**
   * The optional URL of the remote icon that the clients with dark themes should use. Depending on the color palette,
   * some icons will have enough contrast in both light and dark themes. This is thus optional.
   */
  darkUrl?: Maybe<Scalars["String"]>;
  /** The URL of the remote icon that the clients with light themes should use. */
  lightUrl: Scalars["String"];
}

/** Sort order filter for surface clients */
export enum SurfaceTaskSortFilter {
  CRITICALITY = "CRITICALITY",
  EXECUTION_ORDER = "EXECUTION_ORDER",
  INSERTED_AT = "INSERTED_AT",
}

export enum SurfaceTaskState {
  BLOCKED = "BLOCKED",
  CANCELED = "CANCELED",
  HIDDEN = "HIDDEN",
  RESOLVED = "RESOLVED",
  UNRESOLVED = "UNRESOLVED",
}

export interface SuspendCardV2Input {
  /** The client mutation id */
  clientMutationId: Scalars["String"];
  /** The ID of the card to suspend */
  id: Scalars["ID"];
  /** Description for why the card was suspended */
  suspendDescription?: InputMaybe<Scalars["String"]>;
  /** The reason for suspending the card */
  suspendReason?: InputMaybe<CardSuspendReason>;
}

export interface SuspendCardV2Payload {
  /** The card that was suspended */
  card: Card;
  /** The client mutation id */
  clientMutationId: Scalars["String"];
}

export interface SuspendUsersInput {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  userIds: Array<Scalars["ID"]>;
}

export interface SuspendUsersResult {
  errors: Array<UserError>;
}

export interface SyncIntegrationInput {
  clientMutationId: Scalars["String"];
  endDateRange?: InputMaybe<Scalars["Time"]>;
  id: Scalars["ID"];
  isPrimitive?: InputMaybe<Scalars["Boolean"]>;
  /** Notification preference when sync completes */
  notificationType?: InputMaybe<ExportNotificationType>;
  /** STE/Expense Ids (only 1 of 2) that is to be synced */
  sourceIds?: InputMaybe<Array<Scalars["ID"]>>;
  startDateRange?: InputMaybe<Scalars["Time"]>;
  statementEntryTypes?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
}

export interface SyncIntegrationPayload {
  clientMutationId: Scalars["String"];
  integration?: Maybe<Integration>;
}

export interface SyncObjectsError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface SyncObjectsInput {
  /**
   * Optional - list of IDs to sync. If not provided, all objects of the specified type will be synced.
   * Example use case: syncing all Vendors
   */
  brexObjectIds?: InputMaybe<Array<Scalars["ID"]>>;
  /**  Required - object type to sync */
  objectType: ObjectMappingObjectType;
}

export type SyncObjectsResult = SyncObjectsError | SyncObjectsSuccess;

export interface SyncObjectsSuccess {
  objectMappings: Array<ObjectMapping>;
}

export enum SyncReadyStatus {
  HAS_CONFLICT = "HAS_CONFLICT",
  INVALID_FIELDS = "INVALID_FIELDS",
  INVALID_INTERCOMPANY_ACCOUNT = "INVALID_INTERCOMPANY_ACCOUNT",
  INVALID_REIMBURSEMENT_ACCOUNT = "INVALID_REIMBURSEMENT_ACCOUNT",
  PAYLOAD_INVALID = "PAYLOAD_INVALID",
  READY_TO_SYNC = "READY_TO_SYNC",
}

export enum SyncStatus {
  ERROR = "ERROR",
  PENDING = "PENDING",
}

/** A Tagged Employee */
export interface TaggedEmployee {
  /** The level of access the tagged employee has in the given context. */
  entityAccessLevel?: Maybe<CommentExternalEntityAccessLevel>;
  /**
   * Whether the user already has normal permission to access the entity.
   * @deprecated This field is deprecated, use entityAccessLevel instead
   */
  hasPermission: Scalars["Boolean"];
  /** The tagged employee entity */
  taggedEmployee: Employee;
}

export interface TaggedEmployeePermissionInput {
  /**
   * Customer User ID.
   * the id for the user we want to check permission for.
   */
  customerUserId?: InputMaybe<Scalars["String"]>;
  /**
   * External Entity ID.
   * For comment threads with externalEntityType=EXPENSE, this will be the Expense ID.
   */
  externalEntityId?: InputMaybe<Scalars["String"]>;
  /** Type of entity to associate the new comment with. */
  externalEntityType?: InputMaybe<CommentExternalEntityType>;
}

export interface Target {
  /**
   * Generic name generated based on the type
   * User = email
   * Support = "Brex Support"
   */
  name: Scalars["String"];
  targetId?: Maybe<Scalars["String"]>;
  type: TargetType;
}

export enum TargetType {
  ACCOUNTING_INTEGRATION_SETTINGS = "ACCOUNTING_INTEGRATION_SETTINGS",
  ACCOUNTING_RECORD = "ACCOUNTING_RECORD",
  ACCOUNTING_SETTINGS_SUBSIDIARY = "ACCOUNTING_SETTINGS_SUBSIDIARY",
  AUDIT_TRAIL = "AUDIT_TRAIL",
  AUTO_INVITE_SETTINGS = "AUTO_INVITE_SETTINGS",
  BILLING_PAYMENT_INTENT = "BILLING_PAYMENT_INTENT",
  BOOKING = "BOOKING",
  BUDGET = "BUDGET",
  CARD = "CARD",
  CARD_ALIAS = "CARD_ALIAS",
  CUSTOMER_ACCOUNT = "CUSTOMER_ACCOUNT",
  CUSTOMER_USER = "CUSTOMER_USER",
  CUSTOM_RULE = "CUSTOM_RULE",
  EMBEDDED_USER = "EMBEDDED_USER",
  EXPENSE = "EXPENSE",
  FINANCIAL_ASSET_MOVEMENT = "FINANCIAL_ASSET_MOVEMENT",
  LIMIT_GROUP = "LIMIT_GROUP",
  PARTNER_ACCOUNT_INTEGRATION = "PARTNER_ACCOUNT_INTEGRATION",
  ROLE = "ROLE",
  SESSION = "SESSION",
  TRIP = "TRIP",
  UNKNOWN = "UNKNOWN",
  /**  DEPRECATED - Remove after the frontend migrates to account-specific filters. */
  USER = "USER",
  VENDOR = "VENDOR",
}

export interface TargetTypeNode {
  displayName: Scalars["String"];
  value: TargetType;
}

export interface TargetTypesEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<TargetTypeNode>;
}

/** Async task that should be executed in the background. */
export interface Task {
  creatorEmail?: Maybe<Scalars["String"]>;
  creatorFirstName?: Maybe<Scalars["String"]>;
  creatorId: Scalars["ID"];
  creatorLastName?: Maybe<Scalars["String"]>;
  displayName: Scalars["String"];
  id: Scalars["ID"];
  insertedAt?: Maybe<Scalars["Time"]>;
  isSeen: Scalars["Boolean"];
  request?: Maybe<TaskRequest>;
  response?: Maybe<TaskResponse>;
  status: TaskStatus;
  type: TaskType;
  updatedAt?: Maybe<Scalars["Time"]>;
}

/** Task connection for pagination */
export interface TaskConnection extends Connection {
  edges: Array<TaskEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

/** Task edge for the Task connection. */
export interface TaskEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<Task>;
}

/** Filters for the list task query. Records returned will match ALL filters. */
export interface TaskFilterInput {
  creatorIds?: InputMaybe<Array<Scalars["ID"]>>;
  isSeen?: InputMaybe<Scalars["Boolean"]>;
  statuses?: InputMaybe<Array<TaskStatus>>;
  types?: InputMaybe<Array<TaskType>>;
}

export interface TaskInput {
  displayName?: InputMaybe<Scalars["String"]>;
  idempotencyKey?: InputMaybe<Scalars["String"]>;
  request?: InputMaybe<TaskRequestInput>;
  type: TaskType;
}

/**
 * Filters available to control which expenses get exported. Only contains the time interval filters that get rendered by
 * the frontend.
 */
export interface TaskManagerExpenseFilter {
  /** Range query filter for paymentPostedAt */
  paymentPostedBetween?: Maybe<TaskManagerTimeInterval>;
  /** Range query filter for purchaseAt */
  purchasedBetween?: Maybe<TaskManagerTimeInterval>;
}

/** The type of report file type. */
export enum TaskManagerReportFormatType {
  CSV = "CSV",
  HTML = "HTML",
  PDF = "PDF",
  TXT = "TXT",
  XLSX = "XLSX",
}

/** The options to include for the report file. */
export enum TaskManagerReportOption {
  INCLUDE_LINE_ITEMS = "INCLUDE_LINE_ITEMS",
  INCLUDE_RECEIPTS = "INCLUDE_RECEIPTS",
}

export interface TaskManagerTimeInterval {
  /** Exclusive end at. */
  endAt?: Maybe<Scalars["Time"]>;
  /** Inclusive start at. */
  startAt?: Maybe<Scalars["Time"]>;
}

export interface TaskMaxSizeInput {
  taskType: TaskType;
}

export interface TaskMutationError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export type TaskRequest =
  | AuditSpreadsheetExportRequest
  | BulkBudgetActionRequest
  | ExpensesExportRequest
  | UserSpreadsheetImportRequest;

/** Payload corresponding to the TaskType */
export interface TaskRequestInput {
  auditSpreadsheetExport?: InputMaybe<AuditSpreadsheetExportInput>;
  userSpreadsheetExport?: InputMaybe<UserSpreadsheetExportInput>;
  userSpreadsheetImport?: InputMaybe<UserSpreadsheetImportInput>;
}

/** Response */
export type TaskResponse =
  | AuditSpreadsheetExportResponse
  | BulkOperationResponse
  | ErrorResponse
  | ExpensesExportResponse
  | UserSpreadsheetExportResponse
  | UserSpreadsheetImportResponse;

/** Status of a task */
export enum TaskStatus {
  ERROR = "ERROR",
  PENDING = "PENDING",
  SUCCESS = "SUCCESS",
}

/**
 * Since GraphQL doesn't allow polymorphic input types, we use this enum in conjunction with
 * other messages to define differentiated unions.
 */
export enum TaskType {
  AUDIT_LOGS_EXPORT = "AUDIT_LOGS_EXPORT",
  BULK_BUDGET_ACTION = "BULK_BUDGET_ACTION",
  BULK_UPDATE_EXPENSES = "BULK_UPDATE_EXPENSES",
  EXPENSES_EXPORT = "EXPENSES_EXPORT",
  USER_SPREADSHEET_EXPORT = "USER_SPREADSHEET_EXPORT",
  USER_SPREADSHEET_IMPORT = "USER_SPREADSHEET_IMPORT",
}

export interface TaskUpdateInput {
  isSeen?: InputMaybe<Scalars["Boolean"]>;
}

/** A specific Tax code, can be available on more than one entity */
export interface TaxCode {
  /** The extended field option that represents this tax code */
  extendedFieldOption?: Maybe<ExtendedFieldOption>;
  /** Status of this Tax Code for the specific Subsidiary */
  status?: Maybe<TaxCodeStatus>;
}

export enum TaxCodeStatus {
  DISABLED = "DISABLED",
  ENABLED = "ENABLED",
}

/** Input for updating a single tax code's status */
export interface TaxCodeUpdateInput {
  /** New status for this tax code */
  status: TaxCodeStatus;
  /** ID of the ExtendedFieldOption that represents the tax code */
  taxCodeOptionId: Scalars["ID"];
}

/** Tax codes connection for pagination */
export interface TaxCodesConnection extends Connection {
  edges: Array<TaxCodesEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

/** Edge for tax codes pagination */
export interface TaxCodesEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<TaxCode>;
}

/** Used in GraphQL field taxCodes(...) for filtering the list of tax codes. */
export interface TaxCodesFilterInput {
  /** If null, no filtering. */
  status?: InputMaybe<TaxCodeStatus>;
}

/** Represents the tax information related to the expense */
export interface TaxDetails {
  /** The amount of tax related to an expense as string */
  taxAmount?: Maybe<Scalars["String"]>;
  /** The tax code for the expense */
  taxCode?: Maybe<Scalars["String"]>;
}

export enum TaxFormTinValidationStatus {
  INVALID = "INVALID",
  REQUESTED = "REQUESTED",
  VALID = "VALID",
}

/** Netsuite tax purchase account (output) */
export interface TaxPurchaseAccount {
  /** VX field (key) */
  extendedFieldKey?: Maybe<Scalars["String"]>;
  /** GL Account (value) */
  userCategory?: Maybe<UserCategory>;
}

/** Netsuite tax purchase account (input) */
export interface TaxPurchaseAccountInput {
  /** VX field (key) */
  extendedFieldKey?: InputMaybe<Scalars["String"]>;
  /** ID of the GL Account (value) */
  userCategoryId?: InputMaybe<Scalars["ID"]>;
}

export enum TaxStatementType {
  TAX_STATEMENT_TYPE_1099_DIV = "TAX_STATEMENT_TYPE_1099_DIV",
}

export enum TeamUserColumn {
  ACCESS = "ACCESS",
  BILL_PAY_ACCESS = "BILL_PAY_ACCESS",
  CARD_ACCESS = "CARD_ACCESS",
  COPILOT = "COPILOT",
  COPILOT_COUNT = "COPILOT_COUNT",
  COST_CENTER = "COST_CENTER",
  DEPARTMENT = "DEPARTMENT",
  EMAIL = "EMAIL",
  EMPLOYMENT_TYPE = "EMPLOYMENT_TYPE",
  FIRST_NAME = "FIRST_NAME",
  INVITED_AT = "INVITED_AT",
  INVITED_BY = "INVITED_BY",
  LAST_NAME = "LAST_NAME",
  LEGAL_ENTITY = "LEGAL_ENTITY",
  LOCATION = "LOCATION",
  MANAGER = "MANAGER",
  MONTHLY_SPEND = "MONTHLY_SPEND",
  REIMBURSEMENT_ACCESS = "REIMBURSEMENT_ACCESS",
  ROLE = "ROLE",
  SIGN_IN = "SIGN_IN",
  STATUS = "STATUS",
  SYNCED = "SYNCED",
  TITLE = "TITLE",
  TRAVEL_ACCESS = "TRAVEL_ACCESS",
}

export interface TellerPayload {
  enrollmentId: Scalars["String"];
  tellerEnrollmentId?: Maybe<Scalars["String"]>;
  tellerInstitutionId: Scalars["String"];
}

export type TemplateApprovalChains =
  | TemplateApprovalChainsCostCenter
  | TemplateApprovalChainsDepartment
  | TemplateApprovalChainsStatic;

export interface TemplateApprovalChainsCostCenter {
  defaultApprovalChain: Array<PolicyApprovalStep>;
  elements: Array<TemplateApprovalChainsCostCenterElement>;
}

export interface TemplateApprovalChainsCostCenterElement {
  amountBasedApprovalChains: Array<AmountBasedApprovalChain>;
  approvalChain?: Maybe<Array<PolicyApprovalStep>>;
  autoApprovalRules?: Maybe<BudgetAutoApprovalSettings>;
  costCenters: Array<CostCenter>;
}

export interface TemplateApprovalChainsCostCenterElementInput {
  amountBasedApprovalChains?: InputMaybe<Array<AmountBasedApprovalChainInput>>;
  approvalChain?: InputMaybe<Array<PolicyApprovalStepInput>>;
  autoApprovalRules?: InputMaybe<BudgetAutoApprovalSettingsInput>;
  costCenterIds: Array<Scalars["ID"]>;
}

export interface TemplateApprovalChainsCostCenterInput {
  defaultApprovalChain: Array<PolicyApprovalStepInput>;
  elements: Array<TemplateApprovalChainsCostCenterElementInput>;
}

export interface TemplateApprovalChainsDepartment {
  defaultApprovalChain: Array<PolicyApprovalStep>;
  elements: Array<TemplateApprovalChainsDepartmentElement>;
}

export interface TemplateApprovalChainsDepartmentElement {
  amountBasedApprovalChains: Array<AmountBasedApprovalChain>;
  approvalChain?: Maybe<Array<PolicyApprovalStep>>;
  autoApprovalRules?: Maybe<BudgetAutoApprovalSettings>;
  departments: Array<Department>;
}

export interface TemplateApprovalChainsDepartmentElementInput {
  amountBasedApprovalChains?: InputMaybe<Array<AmountBasedApprovalChainInput>>;
  approvalChain?: InputMaybe<Array<PolicyApprovalStepInput>>;
  autoApprovalRules?: InputMaybe<BudgetAutoApprovalSettingsInput>;
  departmentIds: Array<Scalars["ID"]>;
}

export interface TemplateApprovalChainsDepartmentInput {
  defaultApprovalChain: Array<PolicyApprovalStepInput>;
  elements: Array<TemplateApprovalChainsDepartmentElementInput>;
}

export interface TemplateApprovalChainsStatic {
  amountBasedApprovalChains: Array<AmountBasedApprovalChain>;
  approvalChain: Array<PolicyApprovalStep>;
  autoApprovalRules?: Maybe<BudgetAutoApprovalSettings>;
}

export interface TemplateApprovalChainsStaticInput {
  amountBasedApprovalChains?: InputMaybe<Array<AmountBasedApprovalChainInput>>;
  approvalChain: Array<PolicyApprovalStepInput>;
  autoApprovalRules?: InputMaybe<BudgetAutoApprovalSettingsInput>;
}

export interface TemplateBudgetApprovalChainsInput {
  byCostCenter?: InputMaybe<TemplateApprovalChainsCostCenterInput>;
  byDepartment?: InputMaybe<TemplateApprovalChainsDepartmentInput>;
  static?: InputMaybe<TemplateApprovalChainsStaticInput>;
}

export type TemplateBudgetNestingRules =
  | TemplateBudgetNestingRulesCostCenter
  | TemplateBudgetNestingRulesDepartment
  | TemplateBudgetNestingRulesStatic;

export interface TemplateBudgetNestingRulesCostCenter {
  defaultParentBudget?: Maybe<Budget>;
  elements: Array<TemplateBudgetNestingRulesCostCenterElement>;
}

export interface TemplateBudgetNestingRulesCostCenterElement {
  costCenters: Array<CostCenter>;
  parentBudget?: Maybe<Budget>;
}

export interface TemplateBudgetNestingRulesCostCenterElementInput {
  costCenterIds: Array<Scalars["ID"]>;
  parentBudgetId?: InputMaybe<Scalars["ID"]>;
}

export interface TemplateBudgetNestingRulesCostCenterInput {
  defaultParentBudgetId?: InputMaybe<Scalars["ID"]>;
  elements: Array<TemplateBudgetNestingRulesCostCenterElementInput>;
}

export interface TemplateBudgetNestingRulesDepartment {
  defaultParentBudget?: Maybe<Budget>;
  elements: Array<TemplateBudgetNestingRulesDepartmentElement>;
}

export interface TemplateBudgetNestingRulesDepartmentElement {
  departments: Array<Department>;
  parentBudget?: Maybe<Budget>;
}

export interface TemplateBudgetNestingRulesDepartmentElementInput {
  departmentIds: Array<Scalars["ID"]>;
  parentBudgetId?: InputMaybe<Scalars["ID"]>;
}

export interface TemplateBudgetNestingRulesDepartmentInput {
  defaultParentBudgetId?: InputMaybe<Scalars["ID"]>;
  elements: Array<TemplateBudgetNestingRulesDepartmentElementInput>;
}

export interface TemplateBudgetNestingRulesInput {
  byCostCenter?: InputMaybe<TemplateBudgetNestingRulesCostCenterInput>;
  byDepartment?: InputMaybe<TemplateBudgetNestingRulesDepartmentInput>;
  static?: InputMaybe<TemplateBudgetNestingRulesStaticInput>;
}

export interface TemplateBudgetNestingRulesStatic {
  parentBudget?: Maybe<Budget>;
}

export interface TemplateBudgetNestingRulesStaticInput {
  parentBudgetId?: InputMaybe<Scalars["ID"]>;
}

export type TemplateBudgetStructure =
  | TemplateCostCenterBudgetStructure
  | TemplateDepartmentBudgetStructure
  | TemplateStaticBudgetStructure;

export interface TemplateBudgetStructureOneOfInput {
  byCostCenter?: InputMaybe<TemplateCostCenterBudgetStructureInput>;
  byDepartment?: InputMaybe<TemplateDepartmentBudgetStructureInput>;
  static?: InputMaybe<TemplateStaticBudgetStructureInput>;
}

export interface TemplateCostCenterBudgetStructure {
  defaultApprovalChain: Array<PolicyApprovalStep>;
  defaultParentBudget?: Maybe<Budget>;
  elements: Array<TemplateCostCenterBudgetStructureElement>;
}

export interface TemplateCostCenterBudgetStructureElement {
  amountBasedApprovalChains: Array<AmountBasedApprovalChain>;
  approvalChain?: Maybe<Array<PolicyApprovalStep>>;
  autoApprovalRules?: Maybe<BudgetAutoApprovalSettings>;
  costCenters: Array<CostCenter>;
  parentBudget?: Maybe<Budget>;
}

export interface TemplateCostCenterBudgetStructureElementInput {
  amountBasedApprovalChains?: InputMaybe<Array<AmountBasedApprovalChainInput>>;
  approvalChain?: InputMaybe<Array<PolicyApprovalStepInput>>;
  autoApprovalRules?: InputMaybe<BudgetAutoApprovalSettingsInput>;
  costCenterIds: Array<Scalars["ID"]>;
  parentBudgetId?: InputMaybe<Scalars["ID"]>;
}

export interface TemplateCostCenterBudgetStructureInput {
  defaultApprovalChain?: InputMaybe<Array<PolicyApprovalStepInput>>;
  defaultParentBudgetId?: InputMaybe<Scalars["ID"]>;
  elements: Array<TemplateCostCenterBudgetStructureElementInput>;
}

export interface TemplateDepartmentBudgetStructure {
  defaultApprovalChain: Array<PolicyApprovalStep>;
  defaultParentBudget?: Maybe<Budget>;
  elements: Array<TemplateDepartmentBudgetStructureElement>;
}

export interface TemplateDepartmentBudgetStructureElement {
  amountBasedApprovalChains: Array<AmountBasedApprovalChain>;
  approvalChain?: Maybe<Array<PolicyApprovalStep>>;
  autoApprovalRules?: Maybe<BudgetAutoApprovalSettings>;
  departments: Array<Department>;
  parentBudget?: Maybe<Budget>;
}

export interface TemplateDepartmentBudgetStructureElementInput {
  amountBasedApprovalChains?: InputMaybe<Array<AmountBasedApprovalChainInput>>;
  approvalChain?: InputMaybe<Array<PolicyApprovalStepInput>>;
  autoApprovalRules?: InputMaybe<BudgetAutoApprovalSettingsInput>;
  departmentIds: Array<Scalars["ID"]>;
  parentBudgetId?: InputMaybe<Scalars["ID"]>;
}

export interface TemplateDepartmentBudgetStructureInput {
  defaultApprovalChain?: InputMaybe<Array<PolicyApprovalStepInput>>;
  defaultParentBudgetId?: InputMaybe<Scalars["ID"]>;
  elements: Array<TemplateDepartmentBudgetStructureElementInput>;
}

export interface TemplateGenerationOperation {
  /** Purposefully Nullable to allow us to extend this in the future to a long running operation if needed. */
  template?: Maybe<Asset>;
}

export interface TemplateStaticBudgetStructure {
  amountBasedApprovalChains: Array<AmountBasedApprovalChain>;
  approvalChain: Array<PolicyApprovalStep>;
  autoApprovalRules?: Maybe<BudgetAutoApprovalSettings>;
  parentBudget?: Maybe<Budget>;
}

export interface TemplateStaticBudgetStructureInput {
  amountBasedApprovalChains?: InputMaybe<Array<AmountBasedApprovalChainInput>>;
  approvalChain?: InputMaybe<Array<PolicyApprovalStepInput>>;
  autoApprovalRules?: InputMaybe<BudgetAutoApprovalSettingsInput>;
  parentBudgetId?: InputMaybe<Scalars["ID"]>;
}

export enum TemplateType {
  /** Row item */
  ROW_ITEM = "ROW_ITEM",
  /** Smart card */
  SMART_CARD = "SMART_CARD",
}

export interface TemplatedVariable {
  key: Scalars["String"];
  value: ComplexValueInput;
}

export enum TemporalWorkflowStatus {
  CANCELED = "CANCELED",
  COMPLETED = "COMPLETED",
  CONTINUED_AS_NEW = "CONTINUED_AS_NEW",
  FAILED = "FAILED",
  RUNNING = "RUNNING",
  TERMINATED = "TERMINATED",
  TIMED_OUT = "TIMED_OUT",
  UNSPECIFIED = "UNSPECIFIED",
}

export interface TerminateBudgetInput {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
}

export interface TerminateCardInput {
  /** The client mutation id */
  clientMutationId: Scalars["String"];
  /** The ID of the card to terminate */
  id: Scalars["ID"];
  /** The description for terminating the card */
  terminationDescription?: InputMaybe<Scalars["String"]>;
  /** The reason for terminating the card */
  terminationReason?: InputMaybe<TerminationReason>;
}

export interface TerminateCardPayload {
  /** The card that was terminated */
  card: Card;
  /** The client mutation id */
  clientMutationId: Scalars["String"];
}

export enum TerminationReason {
  CARD_DAMAGED = "CARD_DAMAGED",
  CARD_LOST = "CARD_LOST",
  CARD_NOT_RECEIVED = "CARD_NOT_RECEIVED",
  DO_NOT_NEED_PHYSICAL_CARD = "DO_NOT_NEED_PHYSICAL_CARD",
  DO_NOT_NEED_VIRTUAL_CARD = "DO_NOT_NEED_VIRTUAL_CARD",
  FRAUD = "FRAUD",
  OTHER = "OTHER",
}

export interface TermsAgreementInput {
  /** Terms agreement name */
  agreementType: TermsAgreementType;
  /** Terms agreement version */
  version: Scalars["String"];
}

export enum TermsAgreementType {
  ANTI_MONEY_LAUNDERING_CERTIFICATION = "ANTI_MONEY_LAUNDERING_CERTIFICATION",
  BUSINESS_ACCOUNT_AGREEMENT = "BUSINESS_ACCOUNT_AGREEMENT",
  CARD_PROGRAM_TERMS = "CARD_PROGRAM_TERMS",
  COLUMN_DDA_AGREEMENT = "COLUMN_DDA_AGREEMENT",
  COLUMN_ICS_AGREEMENT = "COLUMN_ICS_AGREEMENT",
  COUPA_CARD_TERMS = "COUPA_CARD_TERMS",
  FUND_PROSPECTUS = "FUND_PROSPECTUS",
  NAVAN_TERMS = "NAVAN_TERMS",
  OWNERSHIP_CERTIFICATION = "OWNERSHIP_CERTIFICATION",
  PAYMENTS_AGREEMENT = "PAYMENTS_AGREEMENT",
  PLATFORM_AGREEMENT = "PLATFORM_AGREEMENT",
  PROHIBITED_RESTRICTED_ACTIVITIES_AGREEMENT = "PROHIBITED_RESTRICTED_ACTIVITIES_AGREEMENT",
  TAX_CERTIFICATION = "TAX_CERTIFICATION",
  TRAVEL_TERMS = "TRAVEL_TERMS",
  TREASURY_AGREEMENT = "TREASURY_AGREEMENT",
}

export interface TermsRequestConfig {
  termsType: TermsType;
}

export interface TermsSubmissionPayloadInput {
  /**
   * Is your company a registered brokerage firm or securities exchange, or an investment advisor, investment company,
   * or investment fund of any kind?
   */
  companyHasInvestmentBackground: Scalars["Boolean"];
  /**
   * Is your company or any of its beneficial owners or controlling officers a 10% or more shareholder of a public
   * company?
   */
  companyPartiallyOwnsPublicCompany: Scalars["Boolean"];
  /**
   * Will you be using your Brex Cash account to hold or process funds on behalf of anyone else (for example, on
   * behalf of your customers or employees)?
   */
  companyWillProxyMoneyMovement: Scalars["Boolean"];
  /** Version of the terms. */
  version: Scalars["String"];
}

/** Types of terms to be accepted by user. */
export enum TermsType {
  CARD = "CARD",
  CASH = "CASH",
}

/** Contains the parameters to collect information of Text type. */
export interface TextInformation {
  /** The format to apply to the text field, e.g. ***.***.***-** */
  displayFormat: Scalars["String"];
  /** Type of the information requirement */
  displayType: RequirementInformationFieldDisplayType;
  /** Additional comments to be displayed, in the tooltip for example */
  helperText: Scalars["String"];
  /** Identifier of the information requirement */
  key: Scalars["String"];
  /** Maximum length of the information requirement */
  maxLength: Scalars["Int"];
  /** Minimum length of the information requirement */
  minLength: Scalars["Int"];
  /** Name of the information requirement to be displayed */
  name: Scalars["String"];
  /** Whether the input needs to be entered twice */
  requireDualEntry: Scalars["Boolean"];
  /** The regular expression to validate this information requirement */
  validationRegexp: Scalars["Int"];
}

export enum TicketChangeRules {
  ALLOWED_WITHOUT_FEE = "ALLOWED_WITHOUT_FEE",
  ALLOWED_WITH_FEE = "ALLOWED_WITH_FEE",
  NOT_ALLOWED = "NOT_ALLOWED",
}

export interface TimeIntervalInput {
  /** Exclusive end at. */
  endAt?: InputMaybe<Scalars["Time"]>;
  /** Inclusive start at. */
  startAt?: InputMaybe<Scalars["Time"]>;
}

export interface TimestampFieldInstance extends ExtendedFieldInstance, Node {
  dependencyOfAll?: Maybe<Array<ExtendedFieldInstance>>;
  dependsOnAll?: Maybe<Array<ExtendedFieldInstance>>;
  editStatus?: Maybe<FieldEditStatus>;
  extension?: Maybe<ExtendedFieldInstanceExtension>;
  field: ExtendedField;
  /** The ID of an object */
  id: Scalars["ID"];
  /** The instance of the value associated with this field instance. Null means unset */
  timeValue?: Maybe<Scalars["Time"]>;
  updatedBy?: Maybe<ValueOriginator>;
  workflowValues?: Maybe<Array<WorkflowTimestampValue>>;
}

export interface TimestampFieldInstancedependencyOfAllArgs {
  filter?: InputMaybe<ExtendedFieldDependencyFilter>;
}

export interface TimestampFieldInstancedependsOnAllArgs {
  filter?: InputMaybe<ExtendedFieldDependencyFilter>;
}

export interface TimestampFieldInstanceInput {
  /** The client mutation id */
  clientMutationId?: InputMaybe<Scalars["String"]>;
  fieldInstanceId: Scalars["ID"];
  /** Explicitly set this to null to clear the value */
  value?: InputMaybe<Scalars["Time"]>;
}

export interface TimestampValue {
  value?: Maybe<Scalars["Time"]>;
}

export interface TimestampValueQuery {
  comparison: ComparisonOperator;
  val: Scalars["Time"];
}

/** Corresponds to a single IANA timezone. */
export interface Timezone {
  /** The name of the timezone. E.g., "America/New_York", "EST", etc. */
  name: Scalars["String"];
}

export interface TimezoneInput {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  timezoneName: Scalars["String"];
}

/** An employee's title defined within a company's organization hierarchy. */
export interface Title extends Node {
  /** The name of the title defined by the customer */
  displayTitle: Scalars["String"];
  /** The unique ID of the title. */
  id: Scalars["ID"];
  /** Number of employees associated with the title */
  memberCount?: Maybe<Scalars["Int"]>;
  /**
   * Where in the organizational hierarchy this title sits. Lower rank is higher up, for example the CEO might be rank 0.
   * Null if not set.
   */
  rank?: Maybe<Scalars["Int"]>;
}

/** Title connection for pagination */
export interface TitleConnection extends Connection {
  edges: Array<TitleEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

/** Title edge for the Title connection. */
export interface TitleEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<Title>;
}

export interface TitleInput {
  /** Name of the title. */
  name?: InputMaybe<Scalars["String"]>;
}

/** Filters for list titles query. */
export interface TitlesFilterInput {
  /** Filter by title ID. */
  id?: InputMaybe<Scalars["ID"]>;
  query?: InputMaybe<Scalars["String"]>;
}

export enum TmcDataStatus {
  COMPLETE = "COMPLETE",
  PENDING = "PENDING",
  UNAVAILABLE = "UNAVAILABLE",
}

/** data specific to travel management companies' expenses */
export interface TmcMetadata {
  dataStatus: TmcDataStatus;
  isMatched: Scalars["Boolean"];
  tmcMatchingDeadline?: Maybe<Scalars["Time"]>;
}

export interface ToggleMutationInput {
  toggle: ProductConfigToggle;
}

export interface ToggleMutationResponse {
  error?: Maybe<Scalars["String"]>;
  success: Scalars["Boolean"];
}

export interface ToggleMutationResponseV2 {
  enablement?: Maybe<ProductConfigToggleEnablementV2>;
  error?: Maybe<Scalars["String"]>;
  success?: Maybe<Scalars["Boolean"]>;
}

export interface ToggleRuleForStatementEntryInput {
  clientMutationId: Scalars["String"];
  integrationRuleId: Scalars["ID"];
  statementEntryId: Scalars["ID"];
}

export interface ToggleRuleForStatementEntryPayload {
  clientMutationId: Scalars["String"];
  statementEntry?: Maybe<StatementEntry>;
}

export interface ToggleRuleInput {
  clientMutationId: Scalars["String"];
  /** Integration rule id for the toggled rule */
  integrationRuleId: Scalars["ID"];
  /** Source object id for the toggled rule */
  sourceObjectId: Scalars["ID"];
}

export interface ToggleRulePayload {
  clientMutationId: Scalars["String"];
}

export interface ToggleSelfServeEmailUpdateAccessResult extends MutationResult {
  errors?: Maybe<Array<ChangeEmailOperationError>>;
  result?: Maybe<SelfServeEmailChangeStatus>;
}

/** SocialLogins */
export interface ToggleSocialLoginsInput {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  enabled?: InputMaybe<Scalars["Boolean"]>;
}

export interface ToggleSocialLoginsResult {
  accountId?: Maybe<Scalars["String"]>;
  enabled?: Maybe<Scalars["Boolean"]>;
  ruleId?: Maybe<Scalars["String"]>;
}

export interface TotalInterestEarnedSummary {
  totalInterestEarned: Scalars["Float"];
}

/** A export for tracked expenses */
export interface TrackedExpenseExport {
  /** Asset used to download the expense export file */
  asset: Asset;
  /** When the earliest expense in the export range was approved */
  earliestExpenseApprovalTime: Scalars["Time"];
  /** How many expenses were exported */
  expenseCount: Scalars["Int"];
  /** When the expenses were exported */
  exportedAt: Scalars["Time"];
  /** The user who exported the expenses */
  exportedBy: User;
  /** Primary key for the export entry */
  id: Scalars["ID"];
  /** When the latest expense in the export range was approved */
  latestExpenseApprovalTime: Scalars["Time"];
}

/** TrackedExpenseExport connection for pagination */
export interface TrackedExpenseExportConnection extends Connection {
  edges?: Maybe<Array<TrackedExpenseExportEdge>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

/** TrackedExpenseExport edge */
export interface TrackedExpenseExportEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<TrackedExpenseExport>;
}

export interface TrackingExpensePoliciesFilterInput {
  customerUserId?: InputMaybe<Scalars["String"]>;
  expenseTypes?: InputMaybe<Array<ExpenseType>>;
}

/** A user's tracking expense policy */
export interface TrackingExpensePolicy {
  /**
   * Which expense type that policy is for.
   * Currently only REIMBURSEMENTS are supported
   */
  expenseType: ExpenseType;
  /** Primary key */
  id: Scalars["ID"];
  /** Metadata for the policy */
  metadata?: Maybe<TrackingExpensePolicyMetadata>;
}

/** Paginated connection for TrackingExpensePolicy */
export interface TrackingExpensePolicyConnection extends Connection {
  edges?: Maybe<Array<TrackingExpensePolicyEdge>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

/** Paginated edge for TrackingExpensePolicy */
export interface TrackingExpensePolicyEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<TrackingExpensePolicy>;
}

export interface TrackingExpensePolicyError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export type TrackingExpensePolicyMetadata = ReimbursementTrackingMetadata;

export interface TrackingExpensePolicyMetadataOneOf {
  /** Metadata for the reimbursement policy */
  reimbursementTrackingMetadata?: InputMaybe<ReimbursementTrackingMetadataInput>;
}

export interface TrackingExpensePolicyResult extends MutationResult {
  errors?: Maybe<Array<TrackingExpensePolicyError>>;
  result?: Maybe<TrackingExpensePolicy>;
}

export interface TrackingExtension extends ExpenseExtensionType {
  id: Scalars["ID"];
  trackingStatus: TrackingStatus;
}

/** Determines if a tracked expense (paid outside of Brex) was already exported or not */
export enum TrackingStatus {
  /** Expense is tracked and was already exported */
  EXPORTED = "EXPORTED",
  /** Expense is tracked and was not yet exported */
  NOT_EXPORTED = "NOT_EXPORTED",
}

export interface TrainDataAddendum extends ExpenseAddendum {
  /** The city of destination */
  destinationCity?: Maybe<Scalars["String"]>;
  /** Station in which this trip ended. */
  destinationStation?: Maybe<Scalars["String"]>;
  /** The unique ID of the expense addendum. */
  id: Scalars["ID"];
  /** The city of origin */
  originCity?: Maybe<Scalars["String"]>;
  /** Train server procedure or order in which service was booked. */
  procedureId?: Maybe<Scalars["String"]>;
  /** Indicates the sequence that this train segment falls within the trip. */
  sequenceNumber?: Maybe<Scalars["String"]>;
  /** The service class code */
  serviceClassCode?: Maybe<Scalars["String"]>;
  /** Station in which this trip started. */
  startStation?: Maybe<Scalars["String"]>;
  /** The travel date */
  travelDate?: Maybe<Scalars["Date"]>;
}

/** Additional tracking step data specific to ACH transfers. */
export interface TransactionAchAddenda extends TransactionTrackingAddenda {
  /** The ACH trace number for the transaction, if available. */
  traceNumber?: Maybe<Scalars["String"]>;
  /** The rail type for this addenda. Always ACH for this type. */
  type: TransactionTrackingRail;
}

export enum TransactionAmountRange {
  RANGE_0_TO_100K = "RANGE_0_TO_100K",
  RANGE_1M_PLUS = "RANGE_1M_PLUS",
  RANGE_100K_TO_500K = "RANGE_100K_TO_500K",
  RANGE_500K_TO_1M = "RANGE_500K_TO_1M",
}

export enum TransactionExportType {
  /** Export transactions as credit card charges */
  CREDIT_CARD = "CREDIT_CARD",
  /** Export transactions as journal entries */
  JOURNAL_ENTRY = "JOURNAL_ENTRY",
  /** Export transactions as VendorBills */
  VENDOR_BILL = "VENDOR_BILL",
}

export interface TransactionFeesProductDetails {
  _placeholder?: Maybe<Scalars["String"]>;
}

export type TransactionMetadata =
  | CardOperationTransaction
  | FeeTransaction
  | PaymentTransaction
  | RewardCashbackCredit
  | RewardRedemptionTransaction
  | TransferredPurchase;

export interface TransactionPresenceNotificationFilter {
  isPhysical?: Maybe<Scalars["Boolean"]>;
}

export interface TransactionThreshold {
  approvalSteps: Array<ApprovalChainStep>;
  thresholdAmount: FinancialAsset;
}

export interface TransactionThresholdInput {
  approvalSteps: Array<ApprovalChainStepInput>;
  thresholdAmount: FinancialAssetInput;
}

/**
 * Interface representing additional data specific to the rail type for a tracking step.
 * Concrete implementations will contain rail-specific details (e.g., ACH trace number).
 */
export interface TransactionTrackingAddenda {
  /** The rail type for this addenda. Determines the concrete type of the addenda. */
  type: TransactionTrackingRail;
}

/** Data class to represent a transfer attachment. */
export interface TransactionTrackingAttachment {
  /** The download URL for the attachment. */
  attachmentDownloadUrl?: Maybe<Scalars["String"]>;
  /** The type of attachment. */
  attachmentType: TransactionTrackingAttachmentType;
  /** Timestamp of when this attachment will expire and become unavailable. */
  expiresAt?: Maybe<Scalars["Time"]>;
  /** The status of the attachment. */
  status: TransactionTrackingAttachmentStatus;
  /** The transfer type of which the attachment relates to. */
  transferType?: Maybe<TransactionTrackingTransferType>;
}

/** Enum to represent the status of the downloadable attachment. */
export enum TransactionTrackingAttachmentStatus {
  /** Attachment status is available, meaning it can be download by the user. */
  AVAILABLE = "AVAILABLE",
  /**
   * Attachment status is expired, meaning that the attachment is no longer available for download
   * and the customer should reach out to support to get a new one.
   */
  EXPIRED = "EXPIRED",
  /** Attachment status is not available, meaning that an attachment doesn't exist for the transfer. */
  NOT_AVAILABLE = "NOT_AVAILABLE",
  /** Attachment status is not ready, meaning that the attachment is not ready for download yet. */
  NOT_READY = "NOT_READY",
}

/** Enum to represent the type of the downloadable attachment. */
export enum TransactionTrackingAttachmentType {
  /** Attachment type indicating a domestic wire message. */
  DOMESTIC_WIRE = "DOMESTIC_WIRE",
  /** Attachment type indicating a SWIFT MT103 message. */
  SWIFT_MT103 = "SWIFT_MT103",
  /** Attachment type indicating a SWIFT PACS message. */
  SWIFT_PACS = "SWIFT_PACS",
}

/** Enum to represent the reason for a tracking event failure. */
export enum TransactionTrackingFailureReason {
  /** Failure reason indicating a blocked account. */
  ACCOUNT_BLOCKED = "ACCOUNT_BLOCKED",
  /** Failure reason indicating a closed account. */
  ACCOUNT_CLOSED = "ACCOUNT_CLOSED",
  /** Failure reason indicating a country not supported. */
  COUNTRY_NOT_SUPPORTED = "COUNTRY_NOT_SUPPORTED",
  /** Failure reason indicating a generic failure. */
  GENERIC = "GENERIC",
  /** Failure reason indicating missing or invalid information. */
  INFORMATION_MISSING_OR_INVALID = "INFORMATION_MISSING_OR_INVALID",
  /** Failure reason indicating an invalid account number. */
  INVALID_ACCOUNT_NUMBER = "INVALID_ACCOUNT_NUMBER",
  /** Failure reason indicating an invalid BIC. */
  INVALID_BIC = "INVALID_BIC",
  /** Failure reason indicating an invalid payment currency. */
  INVALID_PAYMENT_CURRENCY = "INVALID_PAYMENT_CURRENCY",
  /** Failure reason indicating a missing correspondent bank. */
  MISSING_CORRESPONDENT_BANK = "MISSING_CORRESPONDENT_BANK",
  /** Failure reason indicating a missing purpose code. */
  MISSING_PURPOSE_CODE = "MISSING_PURPOSE_CODE",
  /** Failure reason indicating an account mismatch. */
  NAME_ACCOUNT_MISMATCH = "NAME_ACCOUNT_MISMATCH",
  /** Failure reason indicating a reason returned by the request. */
  RETURNED_BY_REQUEST = "RETURNED_BY_REQUEST",
  /** Failure reason indicating a transfer above the maximum amount. */
  TRANSFER_ABOVE_MAX_AMOUNT = "TRANSFER_ABOVE_MAX_AMOUNT",
  /** Failure reason indicating a transfer under the minimum amount. */
  TRANSFER_UNDER_MIN_AMOUNT = "TRANSFER_UNDER_MIN_AMOUNT",
}

/** Data class to represent a transfer fee. This will be associated to a particular tracking step. */
export interface TransactionTrackingFee {
  /** Monetary amount the was charged as a fee. */
  amount: FinancialAsset;
  /** Monetary amount the was charged as a fee. */
  feeType: TransactionTrackingFeeType;
}

/** Enum to represent the type of fee that was charged on a transfer. */
export enum TransactionTrackingFeeType {
  /** Fee type indicating a regular processing fee. */
  PROCESSING = "PROCESSING",
  /** Fee type indicating a return fee. */
  RETURN = "RETURN",
}

/** Representation of a payment tracking object. */
export interface TransactionTrackingObject {
  /** The attachments of the tracking object. */
  attachments: Array<TransactionTrackingAttachment>;
  /** The steps of the tracking object. */
  steps: Array<TransactionTrackingStep>;
}

/** Enum to represent the rail used for the transfer. */
export enum TransactionTrackingRail {
  /** Fintech-powered international transfer, like the ones offered by Wise, Airwallex and others. */
  GLOBAL_BANK_TRANSFER = "GLOBAL_BANK_TRANSFER",
  /** Internal book transfer within Brex. */
  INTERNAL_TRANSFER = "INTERNAL_TRANSFER",
  /** Manual execution by Ops. */
  MANUAL = "MANUAL",
  /** SWIFT international Wire. */
  SWIFT_WIRE = "SWIFT_WIRE",
  /** Trading transfer, used for MMF trading. */
  TRADING = "TRADING",
  /** As an input, signals banking_gateway that it should decide on the best approach/s. */
  UNSPECIFIED = "UNSPECIFIED",
  /** US ACH. */
  US_ACH = "US_ACH",
  /** US Cheque for withdrawal, externally originated incoming debit. */
  US_CHEQUE = "US_CHEQUE",
  /** US Cheque for deposit, Brex originated outgoing debit. */
  US_CHEQUE_DEPOSIT = "US_CHEQUE_DEPOSIT",
  /** US Wire. */
  US_WIRE = "US_WIRE",
}

/** A payment tracking step encapsulating all the necessary information about a transfer event. */
export interface TransactionTrackingStep {
  /**
   * The addenda information for the tracking step that is specific to the rail type.
   * e.g., For ACH rail type, it will contain the transfer's trace number.
   */
  addenda?: Maybe<TransactionTrackingAddenda>;
  /**
   * The effective date and time of the tracking step.
   * If update status is AWAITING then this will indicate the ETA.
   */
  effectiveAt: Scalars["Time"];
  /** The effective bank of the tracking step. */
  effectiveBank?: Maybe<Scalars["String"]>;
  /** The identifier of the effective bank of the tracking step, such as BIC or routing number. */
  effectiveBankIdentifier?: Maybe<Scalars["String"]>;
  /**
   * The reason for the tracking event failure.
   * Only available if the update_status is FAILURE.
   */
  failureReason?: Maybe<TransactionTrackingFailureReason>;
  /** The fees associated with the tracking step. */
  fees: Array<TransactionTrackingFee>;
  /**
   * The raw message from the partner for the tracking step.
   * Possibly available with GENERIC failure reason.
   */
  partnerRawMessage?: Maybe<Scalars["String"]>;
  /** The rail used for the transfer. */
  rail: TransactionTrackingRail;
  /** The settled amount of the tracking step. */
  settledAmount?: Maybe<FinancialAsset>;
  /** The type of the transfer of the tracking event. */
  transferType?: Maybe<TransactionTrackingTransferType>;
  /** The status of the tracking update. */
  updateStatus: TransactionTrackingUpdateStatus;
  /** The type of update for the tracking event. */
  updateType: TransactionTrackingUpdateType;
}

/** Enum to represent the type of the transfer being tracked. */
export enum TransactionTrackingTransferType {
  /** Transfer type indicating a collection, normally used for pay-ins. */
  COLLECTION = "COLLECTION",
  /** Transfer type indicating a payment, normally used for pay-outs. */
  PAYMENT = "PAYMENT",
}

/** Enum to represent the status of a tracking event. */
export enum TransactionTrackingUpdateStatus {
  /** Tracking update indicating a step that is awaiting completion. */
  AWAITING = "AWAITING",
  /** Tracking update indicating a completed step. */
  COMPLETED = "COMPLETED",
  /** Tracking update indicating a failed step. */
  FAILED = "FAILED",
  /** Tracking update indicating a step that is processing. */
  PROCESSING = "PROCESSING",
}

/** Enum to represent the type of update for a tracking event. */
export enum TransactionTrackingUpdateType {
  /** Tracking update indicating a cancellation. */
  CANCELLATION = "CANCELLATION",
  /** Tracking update indicating a cancellation request. */
  CANCELLATION_REQUEST = "CANCELLATION_REQUEST",
  /** Tracking update indicating the delivery at destination. */
  DELIVERY_AT_DESTINATION = "DELIVERY_AT_DESTINATION",
  /** Tracking update indicating the process at Brex. */
  PROCESS_AT_BREX = "PROCESS_AT_BREX",
  /** Tracking update indicating the process at intermediary. */
  PROCESS_AT_INTERMEDIARY = "PROCESS_AT_INTERMEDIARY",
  /** Tracking update indicating the initiation at partner. */
  PROCESS_AT_PARTNER = "PROCESS_AT_PARTNER",
  /** Tracking update indicating the step which funds the transfer. */
  PROCESS_FUNDING = "PROCESS_FUNDING",
  /** Tracking update indicating a return. */
  RETURN = "RETURN",
  /** Indication that tracking updates are unavailable. */
  UNAVAILABLE = "UNAVAILABLE",
}

/** Type of deposits transaction. */
export enum TransactionType {
  ACH = "ACH",
  CHEQUE = "CHEQUE",
  WIRE = "WIRE",
}

export interface TransferCardInput {
  /** The ID of the budget to transfer the card to */
  budgetId?: InputMaybe<Scalars["ID"]>;
  /** The client mutation id */
  clientMutationId: Scalars["String"];
  /** The ID of the card to transfer */
  id: Scalars["ID"];
  /** The reason for transferring the card */
  reason: CardOwnershipTransferReason;
  /** The ID of the user to transfer the card to */
  userId: Scalars["ID"];
}

export interface TransferCardPayload {
  /** The card that was transferred */
  card: Card;
  /** The client mutation id */
  clientMutationId: Scalars["String"];
}

export type TransferDetails =
  | AchTransferDetails
  | ChequeTransferDetails
  | DomesticWireTransferDetails
  | InternationalWireTransferDetails;

/** Input for transferring the Purchasing Card to a different user */
export interface TransferPurchasingCardInput {
  /** The card ID associated with the Purchasing Card */
  cardId: Scalars["ID"];
  /** The idempotency key */
  clientMutationId: Scalars["String"];
  /** New end date of the Purchasing Card. If expired, and this is not set, end date will be removed. */
  endDate?: InputMaybe<Scalars["Date"]>;
  /** The user group to be associated with the Purchasing Card. */
  userGroup: UserGroupInput;
}

export interface TransferPurchasingCardResult extends MutationResult {
  cards?: Maybe<Array<Card>>;
  errors?: Maybe<Array<PurchasingCardMutationError>>;
  spendLimit?: Maybe<SpendLimit>;
}

export interface TransferredPurchase {
  expenses: Array<Expense>;
  transferredFromLegalEntityId?: Maybe<Scalars["String"]>;
  transferredToLegalEntityId?: Maybe<Scalars["String"]>;
}

export interface TransitionAccountingJournalEntriesError
  extends StandardClientError {
  accountingJournalEntryId: Scalars["ID"];
  code: ErrorCode;
  errorType: TransitionAccountingJournalEntriesErrorType;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

/**  ---[ Enums ]--------------------------- */
export enum TransitionAccountingJournalEntriesErrorType {
  /** The accounting record has a conflicting rules. The user needs to resolve the conflict before moving AJE from (Prepare -> Review tab) */
  CONFLICTING_RULES = "CONFLICTING_RULES",
  /**
   * The accounting record gl field is no longer valid due to either being disabled or deleted by the user.
   * This can be resolved by either doing an integration refresh or enabling the disabled gl account
   */
  INACTIVE_GL_FIELD = "INACTIVE_GL_FIELD",
  /**
   * Accounting records are not eligible to be accrued, and must be marked as READY_FOR_EXPORT as
   * an actual
   */
  INVALID_ACCRUAL_ACCOUNTING_RECORD_TYPE = "INVALID_ACCRUAL_ACCOUNTING_RECORD_TYPE",
  /** The Accounting Journal Entry is not being transitioned to a valid state */
  INVALID_REVIEW_STATUS_TRANSITION = "INVALID_REVIEW_STATUS_TRANSITION",
  /**
   * The accounting record is missing a credit GL account. It's a required field when transitioning AJE from (Prepare -> Review tab)
   * Usually due to missing rules in the subsidiary settings
   */
  MISSING_CREDIT_GL = "MISSING_CREDIT_GL",
  /**
   * The accounting record is missing a debit GL account. It's a required field when transitioning AJE from (Prepare -> Review tab)
   * Usually due to missing custom rules
   */
  MISSING_DEBIT_GL = "MISSING_DEBIT_GL",
  /** The accounting record is missing required fields. The user needs to fill out these fields before transitioning AJE review status. */
  MISSING_REQUIRED_FIELDS = "MISSING_REQUIRED_FIELDS",
  /** Catch all of other errors that are either non-actionable by user or not yet defined */
  OTHER = "OTHER",
}

export interface TransitionAccountingJournalEntriesResult
  extends MutationResult {
  /** The list of errors for accounting journal entries which failed to be updated. */
  errors?: Maybe<Array<TransitionAccountingJournalEntriesError>>;
  /** The list of all accounting journal entries successfully updated */
  result?: Maybe<Array<AccountingJournalEntry>>;
}

/**  --- Air Bookings --- */
export interface TravelAirBooking {
  fareStatistics?: Maybe<TravelBookingFareStatistics>;
  ktn?: Maybe<TravelIdentification>;
  legs: Array<TravelAirLeg>;
  metrics?: Maybe<TravelAirBookingMetrics>;
  redressNumber?: Maybe<TravelIdentification>;
  tickets?: Maybe<Array<TravelAirTicket>>;
  totalFare: TravelRate;
}

export interface TravelAirBookingMetrics {
  /** Cumulative CO2 emission in kg */
  co2EmissionKg?: Maybe<Scalars["Float"]>;
  /** Cumulative flight distance in km */
  distanceKm?: Maybe<Scalars["Float"]>;
  /** Cumulative flight distance in miles */
  distanceMiles?: Maybe<Scalars["Float"]>;
  /** Cumulative flight duration in hours */
  durationInHours?: Maybe<Scalars["Float"]>;
  /** Cumulative flight duration in seconds */
  durationInSeconds?: Maybe<Scalars["Int"]>;
  /** Number of legs in the booking */
  legCount?: Maybe<Scalars["Int"]>;
}

export interface TravelAirFareRules {
  /** Cancellation policy for the leg. */
  cancellationPolicy?: Maybe<Scalars["String"]>;
  /** Rules about carry-on bags. */
  carryOnBagRules: Array<Scalars["String"]>;
  /** Rules about checked bags. */
  checkedBagRules: Array<Scalars["String"]>;
  /** Exchange policy for the leg. */
  exchangePolicy?: Maybe<Scalars["String"]>;
}

export interface TravelAirFlight {
  airLoyalty?: Maybe<AirLoyalty>;
  /** Gate information for arrival */
  arrivalGate?: Maybe<TravelAirportGate>;
  /** Arrival location */
  arrivalLocation: TravelLocation;
  /** CO2 emission in kg */
  co2EmissionKg?: Maybe<Scalars["Float"]>;
  /** Confirmation code provided by the airline */
  confirmationCode?: Maybe<Scalars["String"]>;
  /** Gate information for departure */
  departureGate?: Maybe<TravelAirportGate>;
  /** Departure location */
  departureLocation: TravelLocation;
  /** Destination 3 letter IATA airport code. */
  destinationAirportCode: Scalars["String"];
  /** Distance in km */
  distanceKm?: Maybe<Scalars["Float"]>;
  /** Distance in miles */
  distanceMiles?: Maybe<Scalars["Float"]>;
  /** Duration of the flight, in hours */
  durationInHours: Scalars["Float"];
  /** Duration of the flight, in seconds */
  durationInSeconds: Scalars["Int"];
  /** Arrival timestamp */
  epochArrivalTime: Scalars["Time"];
  /** Departure timestamp */
  epochDepartureTime: Scalars["Time"];
  /** Airline-specific fare code ie. https://cwsi.net/united.htm */
  fareCode?: Maybe<Scalars["String"]>;
  /** Flight class. e.g. First, Business, Economy. */
  flightClass?: Maybe<FlightClass>;
  /** If the flight has restrictions */
  flightRestrictions?: Maybe<Array<FlightRestrictions>>;
  /** Local arrival time as iso8601 */
  localArrivalTime: Scalars["LocalDateTime"];
  /** Local departure time as iso8601 */
  localDepartureTime: Scalars["LocalDateTime"];
  marketingFlight: FlightNumber;
  operatingFlight: FlightNumber;
  /** Origin 3 letter IATA airport code. */
  originAirportCode: Scalars["String"];
  /** If the flight has some attributes changed, this is where you can find the original values of those attributes */
  originalFlightInformation?: Maybe<TravelOriginalFlightInformation>;
  seatNumber?: Maybe<Scalars["String"]>;
  /**
   * Seat status eg. 'PENDING', 'CONFIRMED'
   * @deprecated Use `seatStatusV2` instead
   */
  seatStatus?: Maybe<Scalars["String"]>;
  /** Seat status eg. 'PENDING', 'CONFIRMED' */
  seatStatusV2?: Maybe<AirSeatStatus>;
  /** ticket number */
  ticketNumber?: Maybe<Scalars["String"]>;
}

/** One leg of an air booking (e.g., SEA -> MIA, possibly with layovers). */
export interface TravelAirLeg {
  /** Cabin display name as shown by the airline, e.g. 'Main Cabin Flexible'. */
  cabinDisplayName?: Maybe<Scalars["String"]>;
  /** Information about the fare rules for this leg. */
  fareRules?: Maybe<TravelAirFareRules>;
  /** Every flight in a leg. */
  flights?: Maybe<Array<TravelAirFlight>>;
  /** Restrictions for the leg (e.g. seat changes not allowed). */
  legRestrictions?: Maybe<Array<LegRestrictions>>;
  /**
   * Status of the leg, matches the booking's overall status.
   * @deprecated Use legStatusV2 instead
   */
  legStatus?: Maybe<BookingStatus>;
  /** Status of the leg (including new pending statuses). */
  legStatusV2?: Maybe<BookingStatusV2>;
}

export interface TravelAirTicket {
  changeRules?: Maybe<TicketChangeRules>;
  fare?: Maybe<TravelRate>;
  issuedTime?: Maybe<Scalars["Time"]>;
  merchantsMerchantId?: Maybe<Scalars["String"]>;
  /** Rules for refunding the ticket. */
  refundRules?: Maybe<TicketChangeRules>;
  ticketNumber?: Maybe<Scalars["String"]>;
}

export interface TravelAirportGate {
  gateNumber?: Maybe<Scalars["String"]>;
  terminal?: Maybe<Scalars["String"]>;
}

/** A booking within a trip, such as a flight, hotel stay, car rental, or other travel segment. */
export interface TravelBooking {
  /** Name of the booking. For example, SFO to JFK round trip */
  bookingNameInfo?: Maybe<TravelBookingNameInfo>;
  /** The current active request associated with this booking (if out-of-policy). */
  bookingRequest?: Maybe<BookingRequest>;
  /** The source of the booking, e.g., BREX_TRAVEL or EXTERNAL. */
  bookingSource?: Maybe<BookingSource>;
  /** Metadata related to the booking */
  bookingSourceInfo?: Maybe<TravelBookingSourceInfo>;
  /** Type of this booking (AIR, CAR_RENTAL, etc.). */
  bookingType: TravelBookingType;
  /** Whether or not the user can request a reimbursement for this booking. */
  canRequestReimbursement: Scalars["Boolean"];
  /** Data describing the booking, e.g., flight segments or hotel reservation details. */
  data: TravelBookingData;
  /**
   * The scheduled end time of the booking in both local time and UTC, including timezone information.
   * For flights this is the last arrival, for hotels the check-out time, for car rentals the drop-off time, etc.
   */
  endAt: TravelTimeWithTimezone;
  /** Expense info of the booking */
  expenses?: Maybe<Array<Expense>>;
  /** Auto generated ID */
  id: Scalars["ID"];
  /** Auto assigned timestamp when a booking is created. */
  insertedAt: Scalars["Time"];
  /** The name of the traveler associated with the booking. */
  name?: Maybe<TravelerName>;
  /** Whether the customer used Brex Rewards points to pay. */
  paidWithBrexRewards?: Maybe<Scalars["Boolean"]>;
  /** Whether the customer has paid with a personal card instead of a Brex card. */
  paidWithPersonalCard?: Maybe<Scalars["Boolean"]>;
  /** Payment info of the booking */
  paymentInfo?: Maybe<Array<TravelBookingPaymentInfo>>;
  /** Policy results before and after user booked. */
  policyResults?: Maybe<TravelPolicyResults>;
  /**
   * Returns a list of descriptions for each policy violated by this booking, if any.
   * Temporary solution for Slack notifications, do not rely on it for other features.
   */
  policyViolationDescriptions: Array<Scalars["String"]>;
  /** Returns a list of TravelBookingPolicyViolation for each policy violation that exists. It contains the description of the policy violation and a boolean indicating if it is violated. */
  policyViolations: Array<TravelBookingPolicyViolation>;
  /** Any reimbursement requests for the booking. Usually length 0 or 1. */
  reimbursementExpenseRequests: Array<Expense>;
  /** Spotnana PNR ID of the booking. */
  spotnanaPnrId?: Maybe<Scalars["String"]>;
  /**
   * The scheduled start time of the booking in both local time and UTC, including timezone information.
   * For flights this is the first departure, for hotels the check-in time, for car rentals the pick-up time, etc.
   */
  startAt: TravelTimeWithTimezone;
  /**
   * The old status field for the booking. Use statusV2 instead.
   * @deprecated Use statusV2 instead
   */
  status: BookingStatus;
  /** The status of the booking, including new pending or partial states. */
  statusV2: BookingStatusV2;
  /** How many Brex Rewards Points were spent. */
  totalBrexRewardsPointsSpent?: Maybe<Scalars["Int"]>;
  /** Total fare for the booking, including any surcharges and taxes. Can be null if the fare is not available. */
  totalFare?: Maybe<TravelRate>;
  /** The trip that this booking belongs to. */
  trip?: Maybe<TravelTrip>;
  /** Id of the associated trip. */
  tripId: Scalars["String"];
  /** Auto assigned timestamp when a booking is updated. */
  updatedAt: Scalars["Time"];
  /** Version of the booking */
  version: Scalars["Int"];
}

export enum TravelBookingAggregateFunction {
  COUNT = "COUNT",
  SUM = "SUM",
}

export interface TravelBookingAggregateInput {
  /**
   * Required field key to aggregate on.
   * (e.g. TRIP_ID)
   */
  fieldKey: TravelBookingFieldKeyInput;
  /** Required aggregate function. */
  function?: TravelBookingAggregateFunction;
}

/** Status of a booking's approval. */
export enum TravelBookingApprovalStatus {
  /** A booking is considered approved if its request is approved. */
  APPROVED = "APPROVED",
  /** A booking is considered pending if its request is pending. */
  PENDING = "PENDING",
  /** A booking is considered rejected if its request is rejected. */
  REJECTED = "REJECTED",
}

/** A type of approval for a Booking that determines behavior after a deadline. */
export enum TravelBookingApprovalType {
  /** Automatically cancel the booking after the deadline. */
  HARD_APPROVAL = "HARD_APPROVAL",
  /** Automatically approve the booking after the deadline. */
  SOFT_APPROVAL = "SOFT_APPROVAL",
}

/** A paginated collection of TravelBooking objects. */
export interface TravelBookingConnection extends Connection {
  /** The bookings in the current page of results. */
  edges: Array<TravelBookingEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of bookings matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

/**
 * Union for the different categories of bookings:
 * - Air, Car rental, Lodging, Rail, Limo, Misc
 */
export type TravelBookingData =
  | TravelAirBooking
  | TravelCarRentalBooking
  | TravelLimoBooking
  | TravelLodgingBooking
  | TravelMiscBooking
  | TravelRailBooking;

/** Region type of a booking. Currently only available for AIR bookings */
export enum TravelBookingDestinationType {
  DOMESTIC = "DOMESTIC",
  INTERNATIONAL = "INTERNATIONAL",
}

/** Represents one TravelBooking in a paginated list. */
export interface TravelBookingEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The booking at this edge. */
  node?: Maybe<TravelBooking>;
}

export interface TravelBookingFareStatistics {
  /** Lowest logical fare for the booking */
  lowestLogicalFare?: Maybe<TravelRate>;
  /** Median fare for the booking */
  medianFare?: Maybe<TravelRate>;
}

/** Specifies the field to group travel bookings by */
export enum TravelBookingFieldKeyInput {
  ALL = "ALL",
  TRIP_ID = "TRIP_ID",
}

/** Arguments to filter bookings in travelBookings. */
export interface TravelBookingFilterInput {
  /** Matches IN booking approval statuses */
  approvalStatuses?: InputMaybe<Array<TravelBookingApprovalStatus>>;
  /** Matches in whose bookings to show */
  bookedBy?: InputMaybe<BookedBy>;
  /** Matches IN cost centers */
  bookerCostCenterIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Matches IN departments */
  bookerDepartmentIds?: InputMaybe<Array<Scalars["ID"]>>;
  /**
   * Filter by a list of booker employees. The 'booker' is the user who booked the trip,
   * which may or may not be the traveler.
   */
  bookerIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Matches IN legal entities */
  bookerLegalEntityIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Matches IN booking destination types */
  bookingDestinationTypes?: InputMaybe<Array<TravelBookingDestinationType>>;
  /** Matches IN booking out of policy status */
  bookingOutOfPolicyStatuses?: InputMaybe<
    Array<TravelBookingOutOfPolicyStatus>
  >;
  /** Filter based on booking status */
  bookingStatuses?: InputMaybe<Array<BookingStatusV2>>;
  /** Filter based on booking types */
  bookingTypes?: InputMaybe<Array<TravelBookingType>>;
  /** Filter for bookings with an end date later than this value. */
  endDateOnOrAfter?: InputMaybe<Scalars["Date"]>;
  /** Filter for bookings with an end date earlier than this value. */
  endDateOnOrBefore?: InputMaybe<Scalars["Date"]>;
  /**
   * Performs a case-insensitive fuzzy search on supported fields.
   * Searches across the following booking properties: pnrId.
   */
  search?: InputMaybe<Scalars["String"]>;
  /** Filter for bookings with a start date later than this value. */
  startDateOnOrAfter?: InputMaybe<Scalars["Date"]>;
  /** Filter for bookings with a start date earlier than this value. */
  startDateOnOrBefore?: InputMaybe<Scalars["Date"]>;
  /** Filter by the travelers identifiers (customerUserId, guestEmail or guestTravelerIds) */
  travelerIdentifiers?: InputMaybe<Array<TravelerIdentifiers>>;
  /** Filter by traveler type, e.g. EMPLOYEE, GUEST */
  travelerTypes?: InputMaybe<Array<TravelerType>>;
}

/**
 * Represents a group of travel bookings that share common attribute values
 * Groups are formed based on the groupByKeys specified in the query
 */
export interface TravelBookingGroup {
  /** The bookings in this group. */
  bookings: Array<TravelBooking>;
  /**
   * Contains the data that was grouped upon.
   * (e.g. if grouping by trip id, this will contain the trip id for the bookings in this group.)
   */
  groupFields: Array<TravelBookingGroupField>;
  /**
   * The unique ID of the booking group - varies based on the grouping field
   * For example, if grouped by booking type, this might be "booking_groupedby_type_AIR"
   */
  id: Scalars["String"];
}

/** Input for grouping travel bookings by specific attributes */
export interface TravelBookingGroupByInput {
  /** Optional. Aggregate on all items within the group regardless of the group items limit. */
  aggregates?: InputMaybe<Array<TravelBookingAggregateInput>>;
  /**
   * Required field keys used for grouping travel bookings
   * Examples: TRIP_ID, BOOKING_TYPE, TRAVELER_ID, BOOKING_STATUS
   */
  groupByKeys: Array<TravelBookingFieldKeyInput>;
  /** Optional. Max number of items returned in each group */
  groupItemsLimit?: InputMaybe<Scalars["Int"]>;
  /**
   * Optional. Sort for the groups.
   * Default sort is groupByKeys and ASC
   */
  groupSorts?: InputMaybe<Array<TravelBookingOrder>>;
}

/**
 * A paginated connection of travel booking groups
 * Each group contains bookings that share the same values for the specified grouping attributes
 */
export interface TravelBookingGroupConnection extends Connection {
  /** The bookings in the current page of results. */
  edges: Array<TravelBookingGroupEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of bookings matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

/**
 * Represents an edge in the TravelBookingGroupConnection
 * Contains a cursor for pagination and the group node
 */
export interface TravelBookingGroupEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The bookings in this group. */
  node: TravelBookingGroup;
}

export interface TravelBookingGroupField {
  /**
   * The field key that was grouped upon.
   * (e.g. if grouping by trip id, this will be TRIP_ID)
   */
  key: TravelBookingFieldKeyInput;
  /**
   * Optional name, populated when used while returning groupFields
   * (e.g for key = TRIP_ID, name can be "Trip 123")
   */
  name?: Maybe<Scalars["String"]>;
  /**
   * The value of the field that was grouped upon.
   * (e.g. if grouping by trip id, this will be the trip id for the bookings in this group.)
   */
  value?: Maybe<EntityQueryValue>;
}

export interface TravelBookingNameInfo {
  /** The subtitle of the booking, e.g. "San Francisco to New York City (round-trip)" */
  subtitle?: Maybe<Scalars["String"]>;
  /** The title of the booking, e.g. "SFO to JFK" */
  title?: Maybe<Scalars["String"]>;
}

/** Specifies how to sort a list of bookings. */
export interface TravelBookingOrder {
  direction: OrderByDirection;
  field: TravelBookingOrderField;
}

/** Defines which field is used for sorting travel bookings. */
export enum TravelBookingOrderField {
  INSERTED_AT = "INSERTED_AT",
  START_DATE = "START_DATE",
  UPDATED_AT = "UPDATED_AT",
}

/** Status of a booking's policy compliance. */
export enum TravelBookingOutOfPolicyStatus {
  IN_POLICY = "IN_POLICY",
  OUT_OF_POLICY = "OUT_OF_POLICY",
}

/** Represents travel booking payment information */
export interface TravelBookingPaymentInfo {
  fop: TravelFormOfPayment;
}

export interface TravelBookingPolicyViolation {
  description: Scalars["String"];
  isViolated: Scalars["Boolean"];
}

export interface TravelBookingSourceInfo {
  /** The tool used to make the booking. e.g. OBT, SHELL, API, etc. */
  bookingTool?: Maybe<Scalars["String"]>;
  /** Persona that made the booking such as TRAVELER, AGENT, etc. */
  pnrBookedBy?: Maybe<Scalars["String"]>;
  /** Concatenation of pnrBookedBy and the tool used to book. e.g. TRAVELER_OBT */
  pnrBookedByTool?: Maybe<Scalars["String"]>;
  /** Booking source system. e.g. SABRE, FARELOGIX_NDC, TRAVEL_FUSION, Southwest, etc. */
  sourceSystem?: Maybe<Scalars["String"]>;
}

/** The category of booking (Air, Car, Lodging, etc.). */
export enum TravelBookingType {
  AIR = "AIR",
  CAR_RENTAL = "CAR_RENTAL",
  LIMO = "LIMO",
  LODGING = "LODGING",
  MISC = "MISC",
  RAIL = "RAIL",
}

/** A dedicated budget record for travel purposes. */
export interface TravelBudget {
  /** [DEPRECATED: use trip.budgetOrError] */
  budget: Budget;
  /** [DEPRECATED: use trip.budgetOrError] */
  budgetOrNull?: Maybe<Budget>;
  /** If budgetOrNull is null, this will say why. */
  error?: Maybe<TravelBudgetError>;
  /** ID */
  id: Scalars["ID"];
}

export interface TravelBudgetConnection extends Connection {
  /** The TravelBudgets in the current page of results. */
  edges: Array<TravelBudgetEdge>;
  /** Page information for additional navigation. */
  pageInfo: PageInfo;
  /** The total count of TravelBudgets matching the filter criteria specified. */
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface TravelBudgetEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The TravelBudget in this edge. */
  node?: Maybe<TravelBudget>;
}

/** Error states for TravelBudget. */
export enum TravelBudgetError {
  NOT_FOUND = "NOT_FOUND",
  PERMISSION_DENIED = "PERMISSION_DENIED",
}

/**  --- Shared among booking subtypes --- */
export interface TravelCancellationInfo {
  /** Deadline for when the booking can be cancelled. */
  deadline?: Maybe<Scalars["Time"]>;
  /** If it is non-refundable, partially refundable, or fully refundable. */
  refundRules: TicketChangeRules;
  /** How much of the total rate is refundable (only for partially refundable bookings). */
  refundableAmount?: Maybe<FinancialAsset>;
}

/**  --- Car Rental Bookings --- */
export interface TravelCarInfo {
  displayName?: Maybe<Scalars["String"]>;
  images?: Maybe<Array<TravelImage>>;
  largeBagCount?: Maybe<Scalars["Int"]>;
  rentalCarClass: RentalCarClass;
  seatCount?: Maybe<Scalars["Int"]>;
  smallBagCount?: Maybe<Scalars["Int"]>;
}

export interface TravelCarRentalBooking {
  /** Information about the car */
  carInfo: TravelCarInfo;
  merchantDisplayName?: Maybe<Scalars["String"]>;
  /** Rental car company vendor code, e.g. ZE for Hertz */
  merchantVendorCode?: Maybe<Scalars["String"]>;
  merchantsMerchantId?: Maybe<Scalars["String"]>;
  /** Information about the reservation */
  reservation: TravelCarReservation;
}

export interface TravelCarReservation {
  cancellationInfo?: Maybe<TravelCancellationInfo>;
  /** Confirmation code provided by the rental agency */
  confirmationCode?: Maybe<Scalars["String"]>;
  dailyRate?: Maybe<TravelRate>;
  dropOffLocation: TravelLocation;
  dropOffOperatingSchedule?: Maybe<TravelOperatingSchedule>;
  /** Unix Epoch drop-off timestamp */
  epochDropOffTime: Scalars["Time"];
  /** Unix Epoch pick-up timestamp */
  epochPickUpTime: Scalars["Time"];
  /** Local drop-off time */
  localDropOffTime: Scalars["LocalDateTime"];
  /** Local pick-up time */
  localPickUpTime: Scalars["LocalDateTime"];
  pickUpLocation: TravelLocation;
  pickUpOperatingSchedule?: Maybe<TravelOperatingSchedule>;
  totalRate?: Maybe<TravelRate>;
}

/** Represents card payment information */
export interface TravelCardPaymentInfo {
  cardLastFour?: Maybe<Scalars["String"]>;
}

/**
 * A filter indicating what type of travel to get a cost estimate for.
 * 2023-02-24: Cost estimates based on actual inventory are only available for flights,
 * so other travel categories will receive a single default estimate regardless of trip details.
 */
export interface TravelCostEstimateFilterInput {
  flightCostEstimateFilterInput?: InputMaybe<TravelFlightCostEstimateFilterInput>;
}

/** Contains cost estimates for different parts of a trip, aggregated by instrument code if needed. */
export interface TravelCostEstimates {
  /** A cost estimate for each flight leg */
  flightCostEstimates?: Maybe<TravelFlightCostEstimates>;
  /** An estimate of the total cost of lodging for the trip */
  lodgingCostEstimates?: Maybe<TravelLodgingCostEstimates>;
  /** An estimate of the total meal allowance for the trip */
  mealCostEstimates?: Maybe<TravelMealCostEstimates>;
  /** An estimate of the total rideshare allowance for the trip */
  rideshareCostEstimates?: Maybe<TravelRideshareCostEstimates>;
  /** The sum of all cost estimates, grouped by instrument code */
  totalCostEstimates?: Maybe<Array<FinancialAsset>>;
}

export interface TravelCredit {
  /** Credit that has been applied so the user doesn't pay out of pocket. */
  creditApplied: FinancialAsset;
  /** Any penalty that is applied to the credit. */
  penalty?: Maybe<FinancialAsset>;
  /** Any leftover amount on the credit. */
  residualCredit?: Maybe<FinancialAsset>;
}

export interface TravelExtension extends ExpenseExtensionType {
  id: Scalars["ID"];
  tripsBookingId?: Maybe<Scalars["String"]>;
  tripsTripId?: Maybe<Scalars["String"]>;
}

/** Cabin classes for flight cost estimates. */
export enum TravelFlightCabinClass {
  BASIC = "BASIC",
  BUSINESS = "BUSINESS",
  ECONOMY = "ECONOMY",
  FIRST = "FIRST",
  PREMIUM_ECONOMY = "PREMIUM_ECONOMY",
}

export interface TravelFlightCostEstimate {
  /** If provided, annotates the cost estimate with the flight cabin class the estimate is for */
  flightCabinClass?: Maybe<TravelFlightCabinClass>;
  flightCostEstimate: FinancialAsset;
}

/** Flight cost characteristics which determine cost. */
export interface TravelFlightCostEstimateFilterInput {
  /** The flight cabin classes to get cost estimates for. */
  flightCabinClasses: Array<InputMaybe<TravelFlightCabinClass>>;
  /** The flight legs to get cost estimates for. */
  flightLegs?: InputMaybe<Array<TravelFlightLegInput>>;
}

export interface TravelFlightCostEstimates {
  /** A breakdown of flight cost estimates */
  costEstimateBreakdown?: Maybe<Array<TravelFlightCostEstimate>>;
  /** The sum of all flight cost estimates, grouped by instrument code */
  totalCostEstimates?: Maybe<Array<FinancialAsset>>;
}

export interface TravelFlightLegInput {
  /** The date of the flight. */
  date: Scalars["Date"];
  /** The flight's ending location. */
  destination: TravelFlightTerminusInput;
  /** The flight's starting location. */
  origin: TravelFlightTerminusInput;
}

export interface TravelFlightTerminusInput {
  /** The IATA airport code. */
  airportCode: Scalars["String"];
}

/** Represents the form of payment details */
export interface TravelFormOfPayment {
  info?: Maybe<TravelPaymentMethodInfo>;
  type?: Maybe<TravelPaymentType>;
}

/** Identification documents like KTN or redress number. */
export interface TravelIdentification {
  documentNumber: Scalars["String"];
  issuingCountry: Scalars["String"];
}

export interface TravelImage {
  caption?: Maybe<Scalars["String"]>;
  url?: Maybe<Scalars["String"]>;
}

/**  --- Limo Bookings --- */
export interface TravelLimoBooking {
  cancellationPolicy?: Maybe<Scalars["String"]>;
  carType?: Maybe<Scalars["String"]>;
  driverName?: Maybe<Scalars["String"]>;
  driverPhone?: Maybe<Scalars["String"]>;
  limoLegs: Array<TravelLimoLeg>;
  paymentType?: Maybe<Scalars["String"]>;
  totalRate: TravelRate;
  vendorConfirmationNumber?: Maybe<Scalars["String"]>;
  vendorEmail?: Maybe<Scalars["String"]>;
  vendorName?: Maybe<Scalars["String"]>;
}

export interface TravelLimoLeg {
  dropOff: TravelLimoTransfer;
  pickUp: TravelLimoTransfer;
}

export interface TravelLimoTransfer {
  epochTime?: Maybe<Scalars["Time"]>;
  localTime?: Maybe<Scalars["LocalDateTime"]>;
  location: TravelLocation;
  notes?: Maybe<Scalars["String"]>;
}

/**
 * Represents a high-level address or geographic coordinates.
 * Used by both Booking (e.g. lodging, car rental) and Search (e.g. hotelAutocomplete).
 */
export interface TravelLocation {
  addressLine1?: Maybe<Scalars["String"]>;
  addressLine2?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  coordinates?: Maybe<LatLong>;
  country?: Maybe<Scalars["String"]>;
  countryCode?: Maybe<Scalars["String"]>;
  /**
   * Optional Google Place ID. Will only be present if the data source used to fetch
   * the location provides this piece of information.
   */
  googlePlaceId?: Maybe<Scalars["ID"]>;
  locationCode?: Maybe<Scalars["String"]>;
  postalCode?: Maybe<Scalars["String"]>;
  state?: Maybe<Scalars["String"]>;
  stateCode?: Maybe<Scalars["String"]>;
  timezone?: Maybe<Scalars["String"]>;
}

/**  --- Lodging Bookings --- */
export interface TravelLodgingBooking {
  lodgingInfo: TravelLodgingInfo;
  lodgingReservation: TravelLodgingReservation;
}

export interface TravelLodgingCostEstimate {
  lodgingCostEstimate: FinancialAsset;
}

export interface TravelLodgingCostEstimates {
  /** A breakdown of lodging cost estimates */
  costEstimateBreakdown?: Maybe<Array<TravelLodgingCostEstimate>>;
  /** The sum of all the lodging cost estimates, grouped by instrument code */
  totalCostEstimates?: Maybe<Array<FinancialAsset>>;
}

export interface TravelLodgingInfo {
  /** Hotel amenity codes */
  amenities?: Maybe<Array<Scalars["String"]>>;
  displayName?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  fax?: Maybe<Scalars["String"]>;
  /** Images of the property for the trip details page */
  images?: Maybe<Array<TravelImage>>;
  /**
   * Physical location of the lodging
   * (TravelLocation is in base, because its shared by multiple domains.)
   */
  location?: Maybe<TravelLocation>;
  merchantsMerchantId?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
  /** Star rating of the lodging */
  starRating?: Maybe<Scalars["Float"]>;
}

export interface TravelLodgingMeal {
  /** Meal type (e.g. breakfast, lunch, dinner) */
  types?: Maybe<Array<TravelLodgingMealType>>;
}

export enum TravelLodgingMealType {
  BREAKFAST = "BREAKFAST",
  DINNER = "DINNER",
  LUNCH = "LUNCH",
}

export interface TravelLodgingReservation {
  averageNightlyRate: TravelRate;
  cancellationInfo?: Maybe<TravelCancellationInfo>;
  /** Confirmation code from lodging provider */
  confirmationCode?: Maybe<Scalars["String"]>;
  /** Unix Epoch check-in timestamp */
  epochCheckInTime: Scalars["Time"];
  /** Unix Epoch check-out timestamp */
  epochCheckOutTime: Scalars["Time"];
  /** Local check-in time */
  localCheckInTime: Scalars["LocalDateTime"];
  /** Local check-out time */
  localCheckOutTime: Scalars["LocalDateTime"];
  nightsBooked?: Maybe<Scalars["Int"]>;
  room: TravelRoom;
  totalRate: TravelRate;
}

/**  --- Rail Bookings --- */
export interface TravelLoyaltyRailCard {
  /** Name of the loyalty or rail card */
  name: Scalars["String"];
  /** Number of the loyalty or rail card */
  programNumber?: Maybe<Scalars["String"]>;
}

export interface TravelMealCostEstimate {
  mealCostEstimate: FinancialAsset;
}

export interface TravelMealCostEstimates {
  /** A breakdown of meal cost estimates */
  costEstimateBreakdown?: Maybe<Array<TravelMealCostEstimate>>;
  /** The sum of all the meal cost estimates, grouped by instrument code */
  totalCostEstimates?: Maybe<Array<FinancialAsset>>;
}

/**  --- Misc Bookings --- */
export interface TravelMiscBooking {
  /** Description of the miscellaneous booking */
  description: Scalars["String"];
  localEndTime?: Maybe<Scalars["LocalDateTime"]>;
  localStartTime?: Maybe<Scalars["LocalDateTime"]>;
  totalRate?: Maybe<TravelRate>;
  /** Confirmation number for the booking */
  vendorConfirmationNumber?: Maybe<Scalars["String"]>;
}

export interface TravelOperatingSchedule {
  /** Intervals for when the business is open on the relevant day. */
  scheduleIntervals: Array<TravelScheduleInterval>;
}

export interface TravelOriginalFlightInformation {
  arrivalGate?: Maybe<TravelAirportGate>;
  departureGate?: Maybe<TravelAirportGate>;
  localArrivalTime?: Maybe<Scalars["LocalDateTime"]>;
  localDepartureTime?: Maybe<Scalars["LocalDateTime"]>;
}

/** Association between a Brex user and a travel partner user (e.g., Spotnana). */
export interface TravelPartnerUserAssociation {
  customerUserId: Scalars["ID"];
  partnerCompanyId: Scalars["ID"];
  partnerUserId: Scalars["ID"];
}

/** Specifies how to query an association between a customer user ID and a partner user ID. */
export interface TravelPartnerUserAssociationQueryInput {
  /** If queryBy is set to CUSTOMER_USER_ID, this field MUST be provided. */
  customerUserId?: InputMaybe<Scalars["ID"]>;
  /** If queryBy is set to PARTNER_USER_ID, this field MUST be provided. */
  partnerUserId?: InputMaybe<TravelPartnerUserIdInput>;
  /** The kind of query that is being performed. */
  queryBy: TravelPartnerUserAssociationQueryType;
}

export enum TravelPartnerUserAssociationQueryType {
  CUSTOMER_USER_ID = "CUSTOMER_USER_ID",
  PARTNER_USER_ID = "PARTNER_USER_ID",
}

/**
 * Holds the partner user ID.
 * We could eventually extend this to specify which partner if needed.
 */
export interface TravelPartnerUserIdInput {
  /** The partner user ID. */
  userId: Scalars["ID"];
}

/** ---[ Local Shared Unions ]------------ */
export type TravelPaymentMethodInfo = TravelCardPaymentInfo;

/** ---[ Local Shared Enums ]------------ */
export enum TravelPaymentType {
  CARD = "CARD",
  REWARDS = "REWARDS",
}

/** Type of permission being queried. */
export enum TravelPermission {
  ALLOW_PERSONAL_CARD = "ALLOW_PERSONAL_CARD",
  DUTY_OF_CARE = "DUTY_OF_CARE",
  GROUP_EVENTS = "GROUP_EVENTS",
  REPORTING = "REPORTING",
  TRIPS_FULL_ACCESS = "TRIPS_FULL_ACCESS",
}

/** Indicates whether a user permission is granted or denied. */
export enum TravelPermissionStatus {
  DENIED = "DENIED",
  GRANTED = "GRANTED",
}

export interface TravelPolicyResult {
  outOfPolicy: Scalars["Boolean"];
}

/** Policy results for a booking, indicating if it's out-of-policy. */
export interface TravelPolicyResults {
  postBooking?: Maybe<TravelPolicyResult>;
  preBooking?: Maybe<TravelPolicyResult>;
}

export enum TravelProvider {
  BREX_TRAVEL = "BREX_TRAVEL",
  NON_BREX_TRAVEL = "NON_BREX_TRAVEL",
}

export interface TravelRailBooking {
  /** Agency reference number for the rail booking */
  agencyReferenceNumber?: Maybe<Scalars["String"]>;
  /** Collection reference number, if ticketType is collection */
  collectionReferenceNumber?: Maybe<Scalars["String"]>;
  /**
   * List of journeys that comprise the booking,
   * we split the journeys in the UI similar to air.
   */
  journeys: Array<TravelRailJourney>;
  /** Type of ticket for the booking (e-ticket or collection). */
  ticketType?: Maybe<TravelRailTicketType>;
  /** Total rate for the booking */
  totalRate: TravelRate;
  /** Potential travelcard (London only, rare in practice) */
  travelcard?: Maybe<TravelRailTravelcard>;
}

export enum TravelRailClass {
  BUSINESS = "BUSINESS",
  BUSINESS_PREMIUM = "BUSINESS_PREMIUM",
  COACH = "COACH",
  EXECUTIVE = "EXECUTIVE",
  FIRST = "FIRST",
  ROOM = "ROOM",
  SLEEPER = "SLEEPER",
  STANDARD = "STANDARD",
  STANDARD_PREMIUM = "STANDARD_PREMIUM",
  UNSET = "UNSET",
}

export interface TravelRailFareDetails {
  detailDescription: Scalars["String"];
  detailName: Scalars["String"];
}

export interface TravelRailFareType {
  /** Short description of the fare type */
  description: Scalars["String"];
  /** More in-depth information of the fare details */
  details?: Maybe<Array<TravelRailFareDetails>>;
}

export interface TravelRailJourney {
  legs: Array<TravelRailLeg>;
}

export interface TravelRailLeg {
  co2EmissionKg?: Maybe<Scalars["Float"]>;
  destination: TravelRailStation;
  durationInSeconds?: Maybe<Scalars["Int"]>;
  epochArrivalTime?: Maybe<Scalars["Time"]>;
  epochDepartureTime?: Maybe<Scalars["Time"]>;
  fareDetails?: Maybe<TravelRailFareType>;
  localArrivalTime?: Maybe<Scalars["LocalDateTime"]>;
  localDepartureTime?: Maybe<Scalars["LocalDateTime"]>;
  loyaltyOrRailCard?: Maybe<TravelLoyaltyRailCard>;
  origin: TravelRailStation;
  railClass: TravelRailClass;
  seat?: Maybe<TravelRailSeat>;
  vehicle?: Maybe<TravelRailVehicle>;
}

export interface TravelRailSeat {
  coachNumber?: Maybe<Scalars["String"]>;
  seatNumber?: Maybe<Scalars["String"]>;
}

export interface TravelRailStation {
  location: TravelLocation;
  name?: Maybe<Scalars["String"]>;
  stationType?: Maybe<TravelRailStationType>;
}

export enum TravelRailStationType {
  BUS_STOP = "BUS_STOP",
  FERRY_TERMINAL = "FERRY_TERMINAL",
  INDIVIDUAL = "INDIVIDUAL",
  METRO = "METRO",
  STATION_GROUP = "STATION_GROUP",
}

export enum TravelRailTicketType {
  COLLECTION = "COLLECTION",
  E_TICKET = "E_TICKET",
}

export interface TravelRailTravelcard {
  /** Description of the travelcard */
  description?: Maybe<Scalars["String"]>;
  /** Name of the travelcard */
  name?: Maybe<Scalars["String"]>;
}

export interface TravelRailVehicle {
  carrierName?: Maybe<Scalars["String"]>;
  timetableId?: Maybe<Scalars["String"]>;
  vehicleType?: Maybe<TravelRailVehicleType>;
}

export enum TravelRailVehicleType {
  BUS = "BUS",
  FERRY = "FERRY",
  METRO = "METRO",
  TAXI = "TAXI",
  TRAIN = "TRAIN",
  TRAM = "TRAM",
  TUBE = "TUBE",
  UNSET = "UNSET",
  WALK = "WALK",
}

export interface TravelRate {
  /** Base price in the original currency of the booking. */
  base: FinancialAsset;
  /** Approximate base in the billing currency. */
  billingBase?: Maybe<FinancialAsset>;
  /** Approximate surcharges in the billing currency. */
  billingSurcharges?: Maybe<FinancialAsset>;
  /** Approximate tax in the billing currency. */
  billingTax?: Maybe<FinancialAsset>;
  /** Approximate total in the billing currency. */
  billingTotal?: Maybe<FinancialAsset>;
  /** Any surcharges are grouped into 1 money object. */
  surcharges?: Maybe<FinancialAsset>;
  /** Tax in the original currency of the booking. */
  tax: FinancialAsset;
  /** Total rate in the original currency of the booking. */
  total: FinancialAsset;
  /** Total charged amount after any credit is applied. */
  totalChargedAmount: FinancialAsset;
  /** Any travel credit that is applied to the booking or ticket. */
  travelCredit?: Maybe<TravelCredit>;
}

/** TRAVEL OPERATIONS */
export enum TravelResourceAttribute {
  DUTY_OF_CARE = "DUTY_OF_CARE",
  GROUP_EVENTS = "GROUP_EVENTS",
  GROUP_EVENTS_ATTEND = "GROUP_EVENTS_ATTEND",
  GROUP_EVENTS_MANAGE = "GROUP_EVENTS_MANAGE",
  PERSONAL_CARD_BOOKINGS = "PERSONAL_CARD_BOOKINGS",
  REPORTING = "REPORTING",
  TRIPS = "TRIPS",
  TRIPS_MANAGE = "TRIPS_MANAGE",
  VIP_BOOKINGS = "VIP_BOOKINGS",
}

export interface TravelResourceOperation extends ResourceOperation {
  action: ResourceAction;
  attribute?: Maybe<TravelResourceAttribute>;
}

export interface TravelRideshareCostEstimate {
  rideshareCostEstimate: FinancialAsset;
}

export interface TravelRideshareCostEstimates {
  /** A breakdown of rideshare cost estimates */
  costEstimateBreakdown?: Maybe<Array<TravelRideshareCostEstimate>>;
  /** The sum of all the rideshare cost estimates, grouped by instrument code */
  totalCostEstimates?: Maybe<Array<FinancialAsset>>;
}

export interface TravelRoom {
  /** Room amenity codes */
  amenities?: Maybe<Array<Scalars["String"]>>;
  bedCount?: Maybe<Scalars["Int"]>;
  bedType?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  displayName?: Maybe<Scalars["String"]>;
  /** Room images */
  images?: Maybe<Array<TravelImage>>;
  meal?: Maybe<TravelLodgingMeal>;
}

export interface TravelScheduleInterval {
  /** End time of the interval */
  intervalEndTime: Scalars["LocalDateTime"];
  /** Start time of the interval */
  intervalStartTime: Scalars["LocalDateTime"];
}

export enum TravelSpotnanaPayloadType {
  /** The trip will be used only for Rewards bookings. */
  REWARDS = "REWARDS",
  /** The trip will be used with a Spend Limit. */
  SPEND_LIMIT = "SPEND_LIMIT",
  /** The trip will be used with a User Limit */
  USER_LIMIT = "USER_LIMIT",
}

export interface TravelTimeWithTimezone {
  /**
   * The local time in the given timezone in the ISO 8601 format. It will not contain an offset.
   * Example: "2025-06-25 14:59:32"
   * https://en.wikipedia.org/wiki/ISO_8601
   */
  localTime: Scalars["Time"];
  /**
   * The UTC time in ISO 8601 format. It will always include the 'Z' to signal the offset of 0.
   * Example: "2025-06-25 14:59:32Z"
   * https://en.wikipedia.org/wiki/ISO_8601
   */
  timestamp: Scalars["Time"];
  /**
   * The IANA timezone of this time.
   * https://www.iana.org/time-zones
   */
  timezone: Scalars["String"];
}

/** Extend the TravelTrip from travel-dgs. */
export interface TravelTrip extends ExpenseGrouping, Node {
  billableAt?: Maybe<Scalars["Time"]>;
  /** User who booked the trip. */
  booker: User;
  /** Status of the booker at the time of booking (REGULAR or VIP). */
  bookerStatusAtBookingTime?: Maybe<BookerStatus>;
  /** Reasons why a trip cannot be booked. Empty if the trip can be booked. */
  bookingBlockers: Array<TripBookingBlockers>;
  /**
   * Bookings associated with the trip. Sorted in chronological order.
   * (These bookings will be defined in the Booking domain, but referenced here.)
   */
  bookings?: Maybe<Array<TravelBooking>>;
  /** [DEPRECATED: use budgetOrError] */
  budget?: Maybe<TravelBudget>;
  /** Budget ID so we can fetch it from the Budget subgraph if needed. */
  budgetId?: Maybe<Scalars["ID"]>;
  /** Budget if user has permission to see it. */
  budgetOrError?: Maybe<BudgetOrError>;
  /** Associated budget request for the trip. */
  budgetRequestEntity?: Maybe<BudgetRequestEntity>;
  /**
   * The number of calendar days a trip touches, even if the time difference is less than 24 hours.
   * For example, the duration of a trip from 2023-02-24 22:00 to 2023-02-25 12:00  is 2 days.
   */
  duration?: Maybe<Scalars["Int"]>;
  endDate?: Maybe<Scalars["Date"]>;
  /** The group event associated with this trip (if any) */
  groupEvent?: Maybe<GroupEvent>;
  /** The ID of an object */
  id: Scalars["ID"];
  insertedAt?: Maybe<Scalars["Time"]>;
  name: Scalars["String"];
  /**
   * If there is no group event associated with this trip
   * But it seems like it was likely meant to be one of these group events
   * Note that this is slow and should not be called on list endpoints
   */
  possibleGroupEvents: Array<GroupEvent>;
  /** The type of trip. Governs how this trip will behave when generating a Spotnana payload. */
  spotnanaPayloadType?: Maybe<TravelSpotnanaPayloadType>;
  /** Corresponding trip ID in Spotnana. */
  spotnanaTripId?: Maybe<Scalars["String"]>;
  startDate?: Maybe<Scalars["Date"]>;
  /**
   * The old status field for a trip. Use statusV2 instead.
   * @deprecated Use statusV2 instead
   */
  status: TripStatus;
  /** New status field for a trip, with a broader set of states. */
  statusV2: TripStatusV2;
  /** Traveler or guest union. */
  traveler?: Maybe<Traveler>;
  /** The type of traveler associated with the booking. */
  travelerType?: Maybe<TravelerType>;
}

export interface TravelTripConnection extends Connection {
  /** The trips in the current page of results. */
  edges: Array<TravelTripEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of trips matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface TravelTripEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The trip at this edge. */
  node?: Maybe<TravelTrip>;
}

/** The interface for standard trip pagination input. */
export interface TravelTripFilterInput {
  /** Filter for trips with a billable time later than this value. */
  billableAtOnOrAfter?: InputMaybe<Scalars["Time"]>;
  /** Filter for trips with a billable time earlier than this value. */
  billableAtOnOrBefore?: InputMaybe<Scalars["Time"]>;
  /**
   * Filter for trips by booking employee.
   * Only used when: bookerCustomerUserScope = SELECTED_USERS
   */
  bookerCustomerUserIds?: InputMaybe<Array<Scalars["String"]>>;
  /**
   * behavior of bookerCustomerUserIds filter. Defaults to 'SELF'
   * bookerCustomerUserIds is required when set to 'SELECTED_USERS'
   */
  bookerCustomerUserScope?: InputMaybe<TripUserScope>;
  /** Filter based on booker status at booking time (REGULAR or VIP) */
  bookerStatusAtBookingTime?: InputMaybe<BookerStatus>;
  /** budget IDs */
  budgetIds?: InputMaybe<Array<Scalars["String"]>>;
  /** Filter for trips with an end date later than this value. */
  endDateAfter?: InputMaybe<Scalars["Time"]>;
  /** Filter for trips with an end date earlier than this value. */
  endDateBefore?: InputMaybe<Scalars["Time"]>;
  /** Filter for trips with an end date earlier than this value. */
  endDateOnOrAfter?: InputMaybe<Scalars["Date"]>;
  /** Filter for trips with an end date earlier than this value. */
  endDateOnOrBefore?: InputMaybe<Scalars["Date"]>;
  /** Filter for trips with a fuzzy case-insensitive search (trip name, ID, traveler name, etc.) */
  search?: InputMaybe<Scalars["String"]>;
  /** Filter based on the spotnanaPayloadType field. */
  spotnanaPayloadTypes?: InputMaybe<
    Array<InputMaybe<TravelSpotnanaPayloadType>>
  >;
  /** Filter by Spotnana Trip IDs. */
  spotnanaTripIds?: InputMaybe<Array<Scalars["String"]>>;
  /** Filter for trips with a start date later than this value. */
  startDateAfter?: InputMaybe<Scalars["Time"]>;
  /** Filter for trips with a start date earlier than this value. */
  startDateBefore?: InputMaybe<Scalars["Time"]>;
  /** Filter for trips with a start date later than this value. */
  startDateOnOrAfter?: InputMaybe<Scalars["Date"]>;
  /** Filter for trips with a start date earlier than this value. */
  startDateOnOrBefore?: InputMaybe<Scalars["Date"]>;
  /** Filter for trips by traveler identifier (guest or employee). */
  travelerIdentifiers?: InputMaybe<TravelerIdentifiers>;
  /** Filter based on traveler type (EMPLOYEE or GUEST). */
  travelerTypes?: InputMaybe<Array<InputMaybe<TravelerType>>>;
  /** Filter based on approval status of trip's bookings. */
  tripApprovalStatusFilter?: InputMaybe<TripApprovalStatusFilter>;
  /** trip IDs */
  tripIds?: InputMaybe<Array<Scalars["String"]>>;
  /** Filter for trips by trip name (fuzzy, case insensitive). */
  tripName?: InputMaybe<Scalars["String"]>;
  /**
   * Filter based on the policy status of bookings on the trip.
   * Will exclude any trips without bookings.
   */
  tripPolicyFilter?: InputMaybe<TripPolicyFilter>;
  /** Filter for trips with specific TripStatus(es). */
  tripStatuses?: InputMaybe<Array<TripStatus>>;
  /** Filter for trips with specific TripStatusV2(es). */
  tripStatusesV2?: InputMaybe<Array<TripStatusV2>>;
}

export interface TravelTripOrderInput {
  direction: OrderByDirection;
  field: SortableTravelTripField;
}

export type Traveler = GuestTraveler | User;

/** Filter for enumerating users (employees or guests) who can own or travel on the trip. */
export interface TravelerIdentifiers {
  /** User IDs */
  customerUserIds?: InputMaybe<Array<Scalars["String"]>>;
  /** Raw guest emails */
  guestEmails?: InputMaybe<Array<Scalars["String"]>>;
  /** Guest IDs from the GuestTraveler object (encoded emails). */
  guestTravelerIds?: InputMaybe<Array<Scalars["String"]>>;
}

/**
 * Represents the traveler's full name.
 * Used in Trip domain for GuestTraveler and in Booking domain for TravelBooking.
 */
export interface TravelerName {
  familyName: Scalars["String"];
  givenName: Scalars["String"];
  middleName?: Maybe<Scalars["String"]>;
  suffix?: Maybe<Scalars["String"]>;
}

/** Indicates the type of traveler for a trip. */
export enum TravelerType {
  EMPLOYEE = "EMPLOYEE",
  GUEST = "GUEST",
}

export interface TreasuryAccount extends BankingAccount, Node {
  balance?: Maybe<BankingAccountBalance>;
  cashflow?: Maybe<BankingAccountCashflow>;
  displayName?: Maybe<Scalars["String"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
  priority?: Maybe<BankingAccountPriority>;
  status?: Maybe<BankingAccountStatus>;
  yield?: Maybe<TreasuryYield>;
}

export interface TreasuryAccountcashflowArgs {
  endTime: Scalars["Time"];
  startTime: Scalars["Time"];
}

export interface TreasuryYield {
  rate?: Maybe<TreasuryYieldRate>;
}

export interface TreasuryYieldRate {
  additionalApy?: Maybe<YieldRate>;
  baseApy?: Maybe<YieldRate>;
  totalApy?: Maybe<YieldRate>;
}

export interface TriggerErpFeedSyncInput {
  clientMutationId: Scalars["String"];
  erpFeedId: Scalars["ID"];
}

export interface TriggerErpFeedSyncPayload {
  clientMutationId: Scalars["String"];
  exportAttemptId?: Maybe<Scalars["String"]>;
}

export interface TriggerLimitUtilizationSurveyInput {
  /** clientMutationId client-supplied idempotency key for a given mutation request. */
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** Opt-out timestamp */
  requestedAt: Scalars["Time"];
  /** Type of survey */
  survey: LimitUtilizationSurvey;
}

export interface TriggerLimitUtilizationSurveyResponse {
  success: Scalars["Boolean"];
}

/** Possible states indicating an approval status for trip bookings. */
export enum TripApprovalStatusFilter {
  /** A trip is considered approved if all of its bookings requests are approved. */
  APPROVED = "APPROVED",
  /** A trip is considered pending if any of its bookings requests are pending. */
  PENDING = "PENDING",
  /**
   * A trip is considered rejected if any of its bookings requests are rejected
   * and none are pending.
   */
  REJECTED = "REJECTED",
}

/** Reasons why a trip cannot be booked. */
export enum TripBookingBlockers {
  BUDGET_POLICY_INVALID = "BUDGET_POLICY_INVALID",
  BUDGET_STATUS_INVALID = "BUDGET_STATUS_INVALID",
  BUDGET_USER_IS_NOT_MEMBER = "BUDGET_USER_IS_NOT_MEMBER",
  NO_BUDGET_ASSOCIATION = "NO_BUDGET_ASSOCIATION",
  TRIP_COMPLETE = "TRIP_COMPLETE",
  TRIP_STATUS_INVALID = "TRIP_STATUS_INVALID",
  TRIP_USER_IS_NOT_TRAVELER = "TRIP_USER_IS_NOT_TRAVELER",
  USER_CANNOT_REDEEM_TRAVEL = "USER_CANNOT_REDEEM_TRAVEL",
}

export interface TripLegDataAddendum extends ExpenseAddendum {
  /** The flight's carrier code */
  carrierCode?: Maybe<Scalars["String"]>;
  /** The departure time, comes as string (eg: 1530P for 3:30 PM) */
  departureTime?: Maybe<Scalars["String"]>;
  /** The destination airport code */
  destinationAirportCode?: Maybe<Scalars["String"]>;
  /** The flight number */
  flightNumber?: Maybe<Scalars["String"]>;
  /** The unique ID of the expense addendum. */
  id: Scalars["ID"];
  /** The origin airport code */
  originAirportCode?: Maybe<Scalars["String"]>;
  /** The flight's service class code */
  serviceClassCode?: Maybe<Scalars["String"]>;
  /** The date the travel takes place */
  travelDate?: Maybe<Scalars["Date"]>;
}

/** Where the trip name was derived from. */
export enum TripNameSource {
  /** Name was auto-generated as a placeholder for the trip draft */
  DRAFT = "DRAFT",
  /** Name was created by a user */
  USER = "USER",
}

/** Policies about time-based or user-based booking filters for trips. */
export enum TripPolicyFilter {
  ALL_OUT_OF_POLICY = "ALL_OUT_OF_POLICY",
  ANY_OUT_OF_POLICY = "ANY_OUT_OF_POLICY",
  IN_POLICY = "IN_POLICY",
}

/** Possible statuses for a trip. */
export enum TripStatus {
  CANCELED = "CANCELED",
  COMPLETED = "COMPLETED",
  DELETED = "DELETED",
  DRAFT = "DRAFT",
  INVITED = "INVITED",
  IN_PROGRESS = "IN_PROGRESS",
  PENDING = "PENDING",
  REFUNDED = "REFUNDED",
  UPCOMING = "UPCOMING",
  VOIDED = "VOIDED",
}

/** Expanded statuses for a trip, including new states. */
export enum TripStatusV2 {
  AIRLINE_CONTROL = "AIRLINE_CONTROL",
  APPROVAL_DENIED = "APPROVAL_DENIED",
  APPROVAL_REQUESTED = "APPROVAL_REQUESTED",
  CANCELED = "CANCELED",
  CANCELLATION_IN_PROGRESS = "CANCELLATION_IN_PROGRESS",
  COMPLETED = "COMPLETED",
  DELETED = "DELETED",
  DRAFT = "DRAFT",
  HOLD = "HOLD",
  INVITED = "INVITED",
  IN_PROGRESS = "IN_PROGRESS",
  PAYMENT_DECLINED = "PAYMENT_DECLINED",
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  REFUNDED = "REFUNDED",
  SCHEDULE_CHANGE = "SCHEDULE_CHANGE",
  UNCONFIRMED = "UNCONFIRMED",
  UPCOMING = "UPCOMING",
  VOIDED = "VOIDED",
}

export interface TripSuggestionInformation {
  /** Enum describing what method was used to generate the trip suggestion (ex LLM, Static Rules, etc). */
  suggestionSource?: Maybe<TripSuggestionSource>;
  /** The trip being suggested. */
  trip?: Maybe<ExpenseGrouping>;
}

export enum TripSuggestionSource {
  /** Generated via a static rule mapping. */
  STATIC_RULES = "STATIC_RULES",
}

/** Scopes for which user(s) can be the booker of a trip. */
export enum TripUserScope {
  ALL_USERS = "ALL_USERS",
  SELECTED_USERS = "SELECTED_USERS",
  SELF = "SELF",
}

export interface TrustedBeneficiariesFilterInput {
  approvalStatuses?: InputMaybe<Array<ApprovalStatus>>;
  beneficiaryType?: InputMaybe<Array<TrustedBeneficiaryBeneficiaryType>>;
}

export interface TrustedBeneficiary {
  /** Whether a trusted beneficiary is APPROVED or PENDING_APPROVAL */
  approvalStatus: ApprovalStatus;
  /** The beneficiary type. What does the counterparty map to in product? */
  beneficiary?: Maybe<BeneficiaryDetails>;
  /** The banking counterparty of the trusted beneficiary */
  counterparty: TrustedBeneficiaryCounterparty;
  id: Scalars["ID"];
  /** Whether a trusted beneficiary is NEW or UPDATED */
  modificationStatus: ModificationStatus;
}

export enum TrustedBeneficiaryBeneficiaryType {
  USER = "USER",
  VENDOR = "VENDOR",
}

export interface TrustedBeneficiaryCounterparty {
  /** The name of the counterpart's account holder */
  accountHolderName?: Maybe<Scalars["String"]>;
  /** The last four digits of the counterpart's account number */
  accountNumberLastFour?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
}

/** GetTrustedDevices */
export interface TrustedDevicesConnection extends Connection {
  edges?: Maybe<Array<Maybe<TrustedDevicesEdge>>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface TrustedDevicesEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<Device>;
}

export interface TurnOffSeenFlagInput {
  clientMutationId: Scalars["String"];
  /** Target flag by key */
  key: SeenFlagKey;
}

export interface TurnOffSeenFlagPayload {
  clientMutationId: Scalars["String"];
  /** Updated flag */
  seenFlag?: Maybe<SeenFlag>;
}

export interface TurnOnSeenFlagInput {
  clientMutationId: Scalars["String"];
  /** Target flag by key */
  key: SeenFlagKey;
}

export interface TurnOnSeenFlagPayload {
  clientMutationId: Scalars["String"];
  /** Updated flag */
  seenFlag?: Maybe<SeenFlag>;
}

export enum TxPaymentRail {
  ACH = "ACH",
  CHEQUE = "CHEQUE",
  WIRE = "WIRE",
}

export enum TxType {
  RETURN = "RETURN",
  STANDARD = "STANDARD",
}

export enum Type {
  CHECKING = "CHECKING",
  SAVINGS = "SAVINGS",
}

export interface UberReceiptIntegration {
  /** Whether users should be removed the linked U4B when they are deactivated on Brex. */
  autoOffboardEmployees: OffboardUberEmployeesSetting;
  /** Setting for when new users should be onboarded onto linked U4B. */
  createUberAccountsEmployees: CreateUberAccountsEmployees;
}

export enum UberUserConnectionState {
  /** User is connected to Uber for Business account. */
  CONNECTED = "CONNECTED",
  /** Error/unexpected response from Uber when checking user status. */
  ERROR = "ERROR",
  /** User has been invited to join Uber for Business account. */
  INVITED = "INVITED",
  /** Integration is not enabled for this customer account. */
  NOT_ENABLED = "NOT_ENABLED",
  /** User has not been invited to join Uber for Business account. */
  NOT_INVITED = "NOT_INVITED",
}

export interface UberUserConnectionStatus {
  /**
   * If user is in INVITED state, linkUrl is provided which the user can go to
   * to finish linking account to Uber.
   */
  linkUrl?: Maybe<Scalars["String"]>;
  state: UberUserConnectionState;
}

export interface UberUserConnectionStatusInput {
  /**
   * A dummy field because objects need to have at least one field.
   * https://spec.graphql.org/October2021/#sec-Objects
   */
  _?: InputMaybe<Scalars["Boolean"]>;
}

/** UK banking code that resolves to a branch. */
export interface UkLocal {
  accountNumber?: Maybe<Scalars["String"]>;
  sortCode?: Maybe<Scalars["String"]>;
}

/** UK banking code that resolves to a branch. */
export interface UkLocalInput {
  accountNumber?: InputMaybe<Scalars["String"]>;
  sortCode?: InputMaybe<Scalars["String"]>;
}

/** Input for unarchiving the limit group */
export interface UnarchiveLimitGroupInput {
  clientMutationId: Scalars["String"];
  endDate?: InputMaybe<Scalars["Date"]>;
  id: Scalars["ID"];
}

export interface UnarchiveLimitGroupResult extends MutationResult {
  errors?: Maybe<Array<LimitGroupMutationError>>;
}

/** Input for the spend budget unarchivation */
export interface UnarchiveSpendBudgetInput {
  clientMutationId: Scalars["String"];
  endDate?: InputMaybe<Scalars["Date"]>;
  id: Scalars["ID"];
  includeDescendants: Scalars["Boolean"];
}

export interface UnarchiveSpendBudgetResult extends MutationResult {
  errors?: Maybe<Array<SpendBudgetMutationError>>;
}

/** Input for the spend limit unarchivation */
export interface UnarchiveSpendLimitInput {
  clientMutationId: Scalars["String"];
  endDate?: InputMaybe<Scalars["Date"]>;
  id: Scalars["ID"];
  includeDescendants: Scalars["Boolean"];
  resetRolloverAmount?: InputMaybe<Scalars["Boolean"]>;
}

export interface UnarchiveSpendLimitResult extends MutationResult {
  errors?: Maybe<Array<StandardClientError>>;
}

/** The unary filter condition. This is a @oneOf input. */
export interface UnaryCondition {
  costCenterId?: InputMaybe<IDValueQuery>;
  departmentId?: InputMaybe<IDValueQuery>;
  extendedFieldKeyValue?: InputMaybe<ExtendedFieldKeyValueQuery>;
  groupId?: InputMaybe<IDValueQuery>;
  invitedAt?: InputMaybe<TimestampValueQuery>;
  legalEntityId?: InputMaybe<IDValueQuery>;
  locationId?: InputMaybe<IDValueQuery>;
  managerId?: InputMaybe<IDValueQuery>;
  roleId?: InputMaybe<IDValueQuery>;
  titleId?: InputMaybe<IDValueQuery>;
}

/** The unary condition for user filtering */
export interface UnaryConditionInput {
  attributeType: UserConditionAttributeType;
  attributeValue: Scalars["String"];
  comparisonOperator: UserConditionComparisonOperator;
}

/** Input type for unassigning budgets from cards. */
export interface UnassignBudgetFromCardInput {
  clientMutationId: Scalars["String"];
  networkCardId: Scalars["ID"];
}

/** Response type for unassigning budgets from cards. */
export interface UnassignBudgetFromCardResult extends MutationResult {
  clientMutationId: Scalars["String"];
  errors?: Maybe<Array<ClientError>>;
}

export interface UnauthenticatedUserPasswordScreenResponse {
  dbaName: Scalars["String"];
  email: Scalars["String"];
  firstName: Scalars["String"];
  partnerId: Scalars["String"];
  partnerName: Scalars["String"];
  shouldShowEmbeddedExperience: Scalars["Boolean"];
}

export interface UnderwritingAccount extends Node {
  appliedAnalysis?: Maybe<UnderwritingAnalysis>;
  /** The ID of an object */
  id: Scalars["ID"];
  isSuspended: Scalars["Boolean"];
  status: UnderwritingAccountStatus;
  statusV2: UnderwritingAccountStatusV2;
}

export enum UnderwritingAccountStatus {
  APPROVED = "APPROVED",
  PENDING = "PENDING",
  PROVISIONALLY_APPROVED = "PROVISIONALLY_APPROVED",
  REJECTED = "REJECTED",
}

export enum UnderwritingAccountStatusV2 {
  APPROVED = "APPROVED",
  LOW_FIDELITY_APPROVED = "LOW_FIDELITY_APPROVED",
  MISSING_DATA_APPROVED = "MISSING_DATA_APPROVED",
  PENDING = "PENDING",
  REJECTED = "REJECTED",
}

export enum UnderwritingAgreement {
  CASH_COVENANT = "CASH_COVENANT",
  COLLATERAL = "COLLATERAL",
  CRITICAL_VENDOR_AGREEMENT = "CRITICAL_VENDOR_AGREEMENT",
  LETTER_OF_CREDIT = "LETTER_OF_CREDIT",
  PARENT_GUARANTEE = "PARENT_GUARANTEE",
  PERSONAL_GUARANTEE = "PERSONAL_GUARANTEE",
}

export interface UnderwritingAnalysis extends Node {
  flags?: Maybe<UnderwritingAnalysisFlagConnection>;
  /** The ID of an object */
  id: Scalars["ID"];
}

export interface UnderwritingAnalysisflagsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

export interface UnderwritingAnalysisFlag extends Node {
  /** The ID of an object */
  id: Scalars["ID"];
  name: UnderwritingAnalysisFlagName;
}

export interface UnderwritingAnalysisFlagConnection extends Connection {
  edges?: Maybe<Array<Maybe<UnderwritingAnalysisFlagEdge>>>;
  pageInfo: PageInfo;
  /** Not implemented */
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface UnderwritingAnalysisFlagEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<UnderwritingAnalysisFlag>;
}

export enum UnderwritingAnalysisFlagName {
  LOW_FIDELITY = "LOW_FIDELITY",
}

export interface UnderwritingAssets {
  fileName?: Maybe<Scalars["String"]>;
}

export interface UnderwritingBankConnectionInput {
  applicationMethod: ApplicationMethod;
  bankStatementAssetIds?: InputMaybe<Array<Scalars["String"]>>;
  expectedDepositDays?: InputMaybe<Scalars["String"]>;
  insufficientFundReason?: InputMaybe<Scalars["String"]>;
  underwritingPolicy?: InputMaybe<UnderwritingPolicyInput>;
}

export interface UnderwritingDetailsPayloadInput {
  supportingDetails?: InputMaybe<Scalars["String"]>;
  underwritingBankConnection?: InputMaybe<UnderwritingBankConnectionInput>;
  underwritingQuarterlyBalanceSheets?: InputMaybe<Array<Scalars["String"]>>;
  underwritingQuarterlyIncomeStatements?: InputMaybe<Array<Scalars["String"]>>;
  underwritingQuarterlyStatementsOfCashFlow?: InputMaybe<
    Array<Scalars["String"]>
  >;
  underwritingSalesVolume?: InputMaybe<Scalars["String"]>;
}

export interface UnderwritingDetailsRequestConfig {
  /** Whether the customer can skip uploading financial statements */
  canSkipStatements: Scalars["Boolean"];
}

export enum UnderwritingEligibility {
  ELIGIBLE = "ELIGIBLE",
  NOT_ELIGIBLE = "NOT_ELIGIBLE",
  PENDING = "PENDING",
}

/**  Deprecated in favor of CollectionFrequency */
export enum UnderwritingFrequency {
  ANNUAL = "ANNUAL",
  DAILY = "DAILY",
  MONTHLY = "MONTHLY",
  QUARTERLY = "QUARTERLY",
  SEMI_ANNUAL = "SEMI_ANNUAL",
}

/** A factor that impacts a credit limit */
export interface UnderwritingLimitFactor extends Node {
  /** The ID of an object */
  id: Scalars["ID"];
  /** When the value was last updated */
  lastUpdated?: Maybe<Scalars["Time"]>;
  /** The type of factor */
  limitFactor: UnderwritingLimitFactorType;
  /** The score or value of the factor */
  score: Scalars["Int"];
}

export enum UnderwritingLimitFactorType {
  DTI = "DTI",
  FICO = "FICO",
}

export enum UnderwritingModelName {
  BANK_BASED_CREDIT_RATING = "BANK_BASED_CREDIT_RATING",
  CASH_BASED = "CASH_BASED",
  EMPOWER_T_AND_E = "EMPOWER_T_AND_E",
  FINANCIALS_BASED_CREDIT_RATING = "FINANCIALS_BASED_CREDIT_RATING",
  INDIVIDUAL_CREDIT_BASED = "INDIVIDUAL_CREDIT_BASED",
  INVALID = "INVALID",
  MANUAL = "MANUAL",
  NONE = "NONE",
  ONBOARDING = "ONBOARDING",
  REGULAR_FINANCIALS_BASED_MID_MARKET = "REGULAR_FINANCIALS_BASED_MID_MARKET",
  REVENUE_BASED = "REVENUE_BASED",
  TECH_MM = "TECH_MM",
}

export interface UnderwritingParameters {
  useConnectedBank: Scalars["Boolean"];
  useStatements: Scalars["Boolean"];
}

/** Underwriting policy details for an account */
export interface UnderwritingPolicy {
  /** Whether totalUWBalance is sufficient per UW policy */
  balanceSufficiencyLevel: BalanceSufficiencyLevel;
  /** The minimum balance required per UW policy */
  policyMinRequirement: Scalars["Float"];
  /** Total bank account balances available for underwriting */
  totalUWBalance: Scalars["Float"];
}

/** Input version of UnderwritingPolicy, so we can submit and persist the value the customer saw */
export interface UnderwritingPolicyInput {
  /** Whether totalUWBalance is sufficient per UW policy */
  balanceSufficiencyLevel: BalanceSufficiencyLevel;
  /** The minimum balance required per UW policy */
  policyMinRequirement: Scalars["Float"];
  /** Total bank account balances available for underwriting */
  totalUWBalance: Scalars["Float"];
}

export interface UnexpireBudgetInput {
  budgetId: Scalars["ID"];
  clientMutationId: Scalars["String"];
  endDate?: InputMaybe<Scalars["Date"]>;
  includeDescendants?: InputMaybe<Scalars["Boolean"]>;
  resetRolloverAmount?: InputMaybe<Scalars["Boolean"]>;
}

export interface UnexpireBudgetResult {
  /** The budget that was unexpired. */
  budget: Budget;
}

/** Unexported expense count. */
export interface UnexportedExpenseCount {
  /** The result in integer. */
  count?: Maybe<Scalars["Int"]>;
}

export interface UnexportedStatementEntryCount {
  count?: Maybe<Scalars["Int"]>;
}

/** Unknown structured data for content types not explicitly modeled */
export interface UnknownStructuredData extends StructuredData {
  /** JSON representation of the structured data */
  json?: Maybe<Scalars["String"]>;
  /** Name of the unknown structured data type */
  type?: Maybe<Scalars["String"]>;
}

/** Input for unlocking the Purchasing Card */
export interface UnlockPurchasingCardInput {
  /** The card ID associated with the Purchasing Card */
  cardId: Scalars["ID"];
  /** The idempotency key */
  clientMutationId: Scalars["String"];
  /** End date of the Purchasing Card */
  endDate?: InputMaybe<Scalars["Date"]>;
  /** Start date of the Purchasing Card */
  startDate?: InputMaybe<Scalars["Date"]>;
}

export interface UnlockPurchasingCardResult extends MutationResult {
  cards?: Maybe<Array<Card>>;
  errors?: Maybe<Array<PurchasingCardMutationError>>;
  spendLimit?: Maybe<SpendLimit>;
}

export interface UnmappedError
  extends StandardClientError,
    UpsertExpensePolicySpecErrors {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface UnregisterGroupInput {
  id: Scalars["ID"];
  resources: Array<ResourceInput>;
}

export interface UnregisterGroupResult extends MutationResult {
  errors?: Maybe<Array<GroupsMutationError>>;
}

export interface UnsubscribeFromGroupInput {
  /** Channel type being unsubscribed */
  channelType: Scalars["String"];
  clientMutationId: Scalars["String"];
  /** ID of the notification group to unsubscribe from */
  notificationGroupId: Scalars["ID"];
}

export interface UnsubscribeFromGroupPayload {
  clientMutationId: Scalars["String"];
  subscription?: Maybe<SubscriptionV2>;
}

export interface UnsuspendCardInput {
  /** The client mutation id */
  clientMutationId: Scalars["String"];
  /** The ID of the card to unsuspend */
  id: Scalars["ID"];
}

export interface UnsuspendCardPayload {
  /** The card that was unsuspended */
  card: Card;
  /** The client mutation id */
  clientMutationId: Scalars["String"];
}

export interface UnterminateBudgetInput {
  budgetId: Scalars["ID"];
  clientMutationId: Scalars["String"];
  endDate?: InputMaybe<Scalars["Date"]>;
  includeDescendants: Scalars["Boolean"];
  resetRolloverAmount?: InputMaybe<Scalars["Boolean"]>;
}

export interface UnterminateBudgetResult {
  /** The budget that was unterminated. */
  budget: Budget;
}

export interface UpcomingDueAmount {
  amountDue: FinancialAsset;
  amountDueUsdCents: Scalars["Int"];
  billingPeriod: Period;
  dueAt: Scalars["Time"];
}

/** Information about an upcoming payment for a vendor */
export interface UpcomingPayments {
  /** The time at which this payment is scheduled to go out */
  paymentDate?: Maybe<Scalars["Time"]>;
}

export interface UpdateAccountAddressInput {
  address: AddressInput;
  clientMutationId: Scalars["String"];
  updateExistingCardAddresses?: InputMaybe<Scalars["Boolean"]>;
}

export interface UpdateAccountAddressPayload {
  account: Account;
  clientMutationId: Scalars["String"];
}

/** One of credentialId, exportSettings or subsidiarySettings must be provided. */
export interface UpdateAccountingIntegrationInput {
  /** Optional, settings related to Enabling Accruals for an integration */
  accrualSettings?: InputMaybe<AccrualSettingsInput>;
  /** Optional, settings related to auto ERP importing */
  autoImportSettings?: InputMaybe<AutoImportSettingsOneOfInput>;
  /** Optional, bill pay export settings. */
  billSettings?: InputMaybe<BillSettingsInput>;
  /** Optional, update bills enabled. */
  billsEnabled?: InputMaybe<Scalars["Boolean"]>;
  /** Required, the client mutation id. */
  clientMutationId: Scalars["String"];
  /** Optional, update the vendor credential. */
  credentialId?: InputMaybe<Scalars["String"]>;
  /** Optional, the integration settings extensions for ERP */
  extensionSettings?: InputMaybe<AccountingIntegrationSettingsExtensionOneOfInput>;
  /** Optional, Grouping strategy for exporting transactions */
  groupSettings?: InputMaybe<GroupSettingsInput>;
  /** Required, ID of the integration to update. */
  id: Scalars["ID"];
  /** Optional, update whether invoice is auto exported. */
  invoiceExportEnabled?: InputMaybe<Scalars["Boolean"]>;
  /** Optional, addition fields on the memo */
  memoSettings?: InputMaybe<MemoSettingsInput>;
  /** Optional, purchase orders flow is enabled. */
  purchaseOrdersEnabled?: InputMaybe<Scalars["Boolean"]>;
  /** Optional, the type for exporting reimbursement card transactions. E.g. JE or VB */
  reimbursementExportType?: InputMaybe<TransactionExportType>;
  /** Optional, update subsidiary settings. */
  subsidiarySettingsInput?: InputMaybe<AccountingIntegrationSubsidiarySettingsInput>;
  /** Optional, the type for exporting credit card transactions. E.g. JE or CC */
  transactionExportType?: InputMaybe<TransactionExportType>;
  /** Optional, update whether vendor is auto exported upon creation. */
  vendorExportEnabled?: InputMaybe<Scalars["Boolean"]>;
  /** Optional, vendor-specific settings for export behavior. */
  vendorSettings?: InputMaybe<VendorSettingsInput>;
}

export interface UpdateAccountingIntegrationResult extends MutationResult {
  errors?: Maybe<Array<AccountingIntegrationMutationError>>;
  result?: Maybe<AccountingIntegration>;
}

/** Update the subsidiary settings for an integration */
export interface UpdateAccountingIntegrationSubsidiarySettingsInput {
  clientMutationId: Scalars["String"];
  /** Required, the accounting integration id. */
  integrationId: Scalars["ID"];
  /** Required, subsidiary settings to update. */
  subsidiarySettingsInput: AccountingIntegrationSubsidiarySettingsInput;
}

export interface UpdateAccountingIntegrationSubsidiarySettingsResult {
  errors?: Maybe<Array<AccountingIntegrationMutationError>>;
  result?: Maybe<AccountingIntegrationSubsidiarySettings>;
}

export interface UpdateAccountingRecordError extends StandardClientError {
  code: ErrorCode;
  /** The unique ID of the accounting record that the error occured with */
  id: Scalars["String"];
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface UpdateAccountingRecordInput {
  /** The booked accounting time for this accounting event. This is the time the accounting event was accrued in the ledger. */
  accruedAt?: InputMaybe<Scalars["Time"]>;
  /** Idempotency key for the update */
  clientMutationId: Scalars["String"];
  /** The unique ID of the accounting record. */
  id: Scalars["ID"];
}

export interface UpdateAdminHomeSettingInput {
  /** The display setting for Admin Home. */
  displaySetting: AdminHomeDisplaySettingInput;
}

export interface UpdateAdminHomeSettingResult extends MutationResult {
  /** User Admin Home Setting if updated correctly */
  adminHomeSetting?: Maybe<AdminHomeSetting>;
  /** No errors if the setting are updated successfully */
  errors?: Maybe<Array<UpdateAdminHomeSettingResultError>>;
}

export interface UpdateAdminHomeSettingResultError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface UpdateAlertReadStatusInput {
  clickedLink?: InputMaybe<Scalars["String"]>;
  clientMutationId: Scalars["String"];
  newStatus: Scalars["Boolean"];
  notificationId: Scalars["String"];
}

export interface UpdateAlertReadStatusResult {
  clientMutationId: Scalars["String"];
}

export interface UpdateAssignedRoleForFSPUserInput {
  clientCustomerAccountId: Scalars["ID"];
  fspUserId: Scalars["ID"];
  roleToAssign: FSPUserRole;
}

export interface UpdateAssignedRoleForFSPUserResult {
  assignedRole: FSPUserRole;
}

export interface UpdateAttributeMappingsError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface UpdateAttributeMappingsInput {
  accountId?: InputMaybe<Scalars["ID"]>;
  mappings: Array<AttributeMapping>;
}

export interface UpdateAttributeMappingsResult extends MutationResult {
  errors?: Maybe<Array<CreateAttributeMappingsError>>;
  result?: Maybe<Array<MappedAttribute>>;
}

export interface UpdateAuditGroupStatusInput {
  /** clientMutationId */
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** The ID of the audit group to update. */
  id: Scalars["ID"];
  /** The desired audit group status. */
  status: AuditGroupStatus;
}

export interface UpdateAuditGroupStatusResult {
  /** The audit group that was updated. */
  auditGroup: AuditGroup;
  /** List of errors when creating the expense */
  errors?: Maybe<Array<AuditGroupMutationError>>;
}

export interface UpdateAutoInviteSettingInput {
  active?: InputMaybe<Scalars["Boolean"]>;
  assignments?: InputMaybe<AutoInviteAssignmentInput>;
  condition?: InputMaybe<UserConditionInput>;
  id: Scalars["ID"];
  name?: InputMaybe<Scalars["String"]>;
}

export interface UpdateAutomaticTransferSettingsInput {
  /** Represents either the fixed amount or threshold amount based on the type of autotransfer settings */
  amountUsdCents?: InputMaybe<Scalars["Int"]>;
  /** Type of automatic transfer configured by this setting */
  automaticTransferType?: InputMaybe<AutomaticTransferType>;
  clientMutationId: Scalars["String"];
  /** ID target deposits account for autotransfer */
  depositsAccountId: Scalars["ID"];
  /** ID of automatic transfer settings to disable */
  id?: InputMaybe<Scalars["ID"]>;
  /** Deprecated, use amount_usd_cents */
  minimumBalanceThresholdUsdCents?: InputMaybe<Scalars["Int"]>;
  /** Schedule of when the transfer will be executed */
  schedule: InputAutomaticTransferScheduleTypeUnion;
  /** Source account for the autotransfer funds */
  sourceAccount: InputAutomaticTransferSourceAccountUnion;
}

export interface UpdateAutomaticTransferSettingsPayload {
  automaticTransferSettings: AutomaticTransferSettings;
  clientMutationId: Scalars["String"];
}

export interface UpdateAutomationWorkflowSpecInput {
  cadence?: InputMaybe<AutomationWorkflowCadenceOneOfInput>;
  id: Scalars["ID"];
  name?: InputMaybe<Scalars["String"]>;
  steps?: InputMaybe<Array<AutomationWorkflowStepInput>>;
}

export interface UpdateAutomationWorkflowSpecsResult {
  specs?: Maybe<Array<AutomationWorkflowSpec>>;
}

export interface UpdateBillFields {
  amount?: InputMaybe<Scalars["Int"]>;
  attachmentAssetId?: InputMaybe<Scalars["ID"]>;
  autoSendOneTimeCardDetails?: InputMaybe<Scalars["Boolean"]>;
  budgetId?: InputMaybe<Scalars["ID"]>;
  /** [Deprecated!] Use transferDescription instead */
  chequeMemo?: InputMaybe<Scalars["String"]>;
  contactId?: InputMaybe<Scalars["ID"]>;
  /** Aka memo */
  description?: InputMaybe<Scalars["String"]>;
  dueAt?: InputMaybe<Scalars["Time"]>;
  entityId?: InputMaybe<Scalars["ID"]>;
  erpApAccountId?: InputMaybe<Scalars["ID"]>;
  erpApAccountVxOptionId?: InputMaybe<Scalars["ID"]>;
  erpClassId?: InputMaybe<Scalars["ID"]>;
  erpClassVxOptionId?: InputMaybe<Scalars["ID"]>;
  erpDepartmentId?: InputMaybe<Scalars["ID"]>;
  erpDepartmentVxOptionId?: InputMaybe<Scalars["ID"]>;
  erpLocationId?: InputMaybe<Scalars["ID"]>;
  erpLocationVxOptionId?: InputMaybe<Scalars["ID"]>;
  erpPaymentAccountId?: InputMaybe<Scalars["ID"]>;
  erpPaymentAccountVxOptionId?: InputMaybe<Scalars["ID"]>;
  externalInvoiceNumber?: InputMaybe<Scalars["String"]>;
  isDuplicate?: InputMaybe<Scalars["Boolean"]>;
  notifyRecipient?: InputMaybe<Scalars["Boolean"]>;
  oneTimeCardOwnerUserId?: InputMaybe<Scalars["ID"]>;
  /** Used as message to card owner for `ONE_TIME_VIRTUAL_CARD`. */
  oneTimeCardRecipientMessage?: InputMaybe<Scalars["String"]>;
  paymentInstrumentId?: InputMaybe<Scalars["ID"]>;
  paymentMethod?: InputMaybe<BillPaymentMethod>;
  /**
   * When the payment will be initiated for EBA/BBA payments.
   * When the card will be issued for virtual card payments.
   */
  paymentSendAt?: InputMaybe<Scalars["Time"]>;
  purchaseOrderId?: InputMaybe<Scalars["ID"]>;
  recurringSchedule?: InputMaybe<RecurringScheduleInput>;
  servicePerformedAt?: InputMaybe<Scalars["Time"]>;
  sourceAccount?: InputMaybe<SourceAccountInput>;
  /**
   * A description of the transfer used as `Payment Instructions` for `WIRE` and the `Entry Description` for `ACH`.
   * Max 90 characters for `ACH` and `WIRE` and max 40 characters for `CHEQUES`.
   */
  transferDescription?: InputMaybe<Scalars["String"]>;
  userErpCategoryId?: InputMaybe<Scalars["ID"]>;
  userErpCategoryVxOptionId?: InputMaybe<Scalars["ID"]>;
}

export interface UpdateBillInput {
  attachmentAssetId?: InputMaybe<Scalars["ID"]>;
  chequeMemo?: InputMaybe<Scalars["String"]>;
  clientMutationId: Scalars["String"];
  contactId?: InputMaybe<Scalars["ID"]>;
  counterpartyId?: InputMaybe<Scalars["String"]>;
  /** DEPRECATED. Use sourceAccount field instead */
  depositsAccountId?: InputMaybe<Scalars["ID"]>;
  description?: InputMaybe<Scalars["String"]>;
  dueAmountCents?: InputMaybe<Scalars["Int"]>;
  dueAt?: InputMaybe<Scalars["Time"]>;
  endsAt?: InputMaybe<Scalars["Time"]>;
  erpApAccountId?: InputMaybe<Scalars["ID"]>;
  erpClassId?: InputMaybe<Scalars["ID"]>;
  erpDepartmentId?: InputMaybe<Scalars["ID"]>;
  erpLocationId?: InputMaybe<Scalars["ID"]>;
  erpPaymentAccountId?: InputMaybe<Scalars["ID"]>;
  externalInvoiceNumber?: InputMaybe<Scalars["String"]>;
  id: Scalars["ID"];
  isDuplicate?: InputMaybe<Scalars["Boolean"]>;
  merchantCategoryId?: InputMaybe<Scalars["ID"]>;
  monthlySchedule?: InputMaybe<MonthlySchedule>;
  notifyRecipient?: InputMaybe<Scalars["Boolean"]>;
  paymentInstrumentId?: InputMaybe<Scalars["ID"]>;
  paymentSendAt?: InputMaybe<Scalars["Time"]>;
  servicePerformedAt?: InputMaybe<Scalars["Time"]>;
  sourceAccount?: InputMaybe<InputSourceAccountUnion>;
  totalNumberOfPayments?: InputMaybe<Scalars["Int"]>;
  transferDescription?: InputMaybe<Scalars["String"]>;
  userErpCategoryId?: InputMaybe<Scalars["ID"]>;
  weeklySchedule?: InputMaybe<WeeklySchedule>;
}

export interface UpdateBillPayload {
  bill?: Maybe<Bill>;
  clientMutationId: Scalars["String"];
}

export interface UpdateBillV2Input {
  clientMutationId: Scalars["String"];
  fields: UpdateBillFields;
  id: Scalars["ID"];
}

export interface UpdateBudgetFields {
  /** Setting for auto-transferring budget cards when their owners are either disabled or removed as members from the budget. */
  autoTransferCardsSetting?: InputMaybe<AutoTransferCardsSetting>;
  /** Budget template ID if changing */
  budgetTemplateId?: InputMaybe<Scalars["ID"]>;
  /** Description of what the budget is used for */
  description?: InputMaybe<Scalars["String"]>;
  /** The end date of the budget, inclusive. */
  endDate?: InputMaybe<Scalars["Date"]>;
  /** True if the budget limit is hard enforced */
  enforceLimit?: InputMaybe<Scalars["Boolean"]>;
  /** The percentage of the buffer on the budget limit */
  enforceLimitBufferPercentage?: InputMaybe<Scalars["Int"]>;
  /** Determines if budget members are allowed to view other members expenses. */
  expenseVisibilityShared?: InputMaybe<Scalars["Boolean"]>;
  /** The legal entity mapping for this budget */
  legalEntityMapping?: InputMaybe<LegalEntityMapping>;
  /** Limit on the budget */
  limit?: InputMaybe<FinancialAssetInput>;
  /** True if limit increase request feature is enabled */
  limitIncreaseRequestEnabled?: InputMaybe<Scalars["Boolean"]>;
  /** The policy that manages limit increase requests for this budget */
  limitIncreaseRequestPolicyId?: InputMaybe<Scalars["ID"]>;
  /** Determines if budget members are allowed to view the budget limit */
  limitVisibility?: InputMaybe<BudgetLimitVisibilityType>;
  /** The employees who are considered members of this budget */
  members?: InputMaybe<Array<Scalars["ID"]>>;
  /** Merchant category controls */
  merchantCategoryControls?: InputMaybe<Array<MerchantCategoryConfigInput>>;
  /** Name of the budget */
  name?: InputMaybe<Scalars["String"]>;
  /** True if only provisioned cards can spend from this budget */
  onlyProvisionedCardSpend?: InputMaybe<Scalars["Boolean"]>;
  /** The employees who are considered owners of this budget */
  owners?: InputMaybe<Array<Scalars["ID"]>>;
  /** The recurring period type of the budget. */
  periodType?: InputMaybe<BudgetPeriodType>;
  /** The policy that manages expenses for this budget */
  policyId?: InputMaybe<Scalars["ID"]>;
  /** The rollover refresh rate for this budget (the recurrence by which all rolled over unused funds within the cycle should no longer roll over to the next period). */
  rolloverRefreshRate?: InputMaybe<BudgetRolloverRefreshRate>;
  /** The start date of the budget, inclusive. */
  startDate?: InputMaybe<Scalars["Date"]>;
  /** Budget Status */
  status?: InputMaybe<BudgetStatus>;
  /**
   * The transaction limit for this budget
   *
   * Defaults to the transaction limit of the parent budget if not specified
   */
  transactionLimit?: InputMaybe<FinancialAssetInput>;
}

/** Fields needed to update a budget-template derived budget */
export interface UpdateBudgetFromTemplateFields {
  /** Setting for auto-transferring budget cards when their owners are either disabled or removed as members from the budget. */
  autoTransferCardsSetting?: InputMaybe<AutoTransferCardsSetting>;
  /** The budget template ID we want this to be updated to */
  budgetTemplateId?: InputMaybe<Scalars["ID"]>;
  /** Description of what the budget is used for */
  description?: InputMaybe<Scalars["String"]>;
  /** The end date of the budget, inclusive. */
  endDate?: InputMaybe<Scalars["Date"]>;
  /** True if the budget limit is hard enforced */
  enforceLimit?: InputMaybe<Scalars["Boolean"]>;
  /** The percentage of the buffer on the budget limit */
  enforceLimitBufferPercentage?: InputMaybe<Scalars["Int"]>;
  /** Determines if budget members are allowed to view other members expenses. */
  expenseVisibilityShared?: InputMaybe<Scalars["Boolean"]>;
  /**
   * The legal entity mapping for this budget
   *
   * Defaults to the legal entity mapping of the parent budget if not specified
   */
  legalEntityMapping?: InputMaybe<LegalEntityMapping>;
  /** Limit on the budget */
  limit?: InputMaybe<FinancialAssetInput>;
  /** True if limit increase request feature is enabled */
  limitIncreaseRequestEnabled?: InputMaybe<Scalars["Boolean"]>;
  /** The policy that manages limit increase requests for this budget */
  limitIncreaseRequestPolicyId?: InputMaybe<Scalars["ID"]>;
  /** Determines if budget members are allowed to view the budget limit */
  limitVisibility?: InputMaybe<BudgetLimitVisibilityType>;
  /** The employees who are considered members of this budget */
  members?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
  /** Merchant category controls */
  merchantCategoryControls?: InputMaybe<
    Array<InputMaybe<MerchantCategoryConfigInput>>
  >;
  /** The metadata of the template that Budget was derived from */
  metadata: BudgetTemplateDerivedMetadataOneOfInput;
  /** Name of the budget */
  name?: InputMaybe<Scalars["String"]>;
  /** True if only provisioned cards can spend from this budget */
  onlyProvisionedCardSpend?: InputMaybe<Scalars["Boolean"]>;
  /** The employees who are considered owners of this budget */
  owners?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
  /** The recurring period type of the budget. */
  periodType?: InputMaybe<BudgetPeriodType>;
  /** The rollover refresh rate for this budget (the recurrence by which all rolled over unused funds within the cycle should no longer roll over to the next period). */
  rolloverRefreshRate?: InputMaybe<BudgetRolloverRefreshRate>;
  /** The start date of the budget, inclusive. */
  startDate?: InputMaybe<Scalars["Date"]>;
  /** Budget Status */
  status?: InputMaybe<BudgetStatus>;
  /**
   * The transaction limit for this budget
   *
   * Defaults to the transaction limit of the parent budget if not specified
   */
  transactionLimit?: InputMaybe<FinancialAssetInput>;
}

export interface UpdateBudgetFromTemplateInput {
  clientMutationId: Scalars["String"];
  fields: UpdateBudgetFromTemplateFields;
  id: Scalars["ID"];
}

export interface UpdateBudgetInput {
  clientMutationId: Scalars["String"];
  fields: UpdateBudgetFields;
  id: Scalars["ID"];
}

/** Input to to update budget limits. Used in BatchUpdateBulkBudgetLimitAsyncInput */
export interface UpdateBudgetLimitAsyncFields {
  /** Id of budget to update */
  budgetId: Scalars["ID"];
  /** Idempotency key for budget limit updates */
  clientMutationId: Scalars["String"];
  /** True if the budget's limit is strictly enforced */
  enforceLimit?: InputMaybe<Scalars["Boolean"]>;
  /** The percentage of the buffer on the budget limit */
  enforceLimitBufferPercentage?: InputMaybe<Scalars["Int"]>;
  /** limit of budget */
  limit: FinancialAssetInput;
}

/** Fields needed to update a request for a budget. */
export interface UpdateBudgetLimitIncreaseRequestFields {
  endDate?: InputMaybe<Scalars["Date"]>;
  endingStrategy?: InputMaybe<BudgetIncreaseLimitRequestEndingStrategy>;
  increaseAmount?: InputMaybe<FinancialAssetInput>;
  reason?: InputMaybe<Scalars["String"]>;
}

/** Input to update a limit increase request for a budget. */
export interface UpdateBudgetLimitIncreaseRequestInput {
  fields: UpdateBudgetLimitIncreaseRequestFields;
  id: Scalars["ID"];
}

/** Fields needed to update a request for a budget. */
export interface UpdateBudgetRequestFields {
  autoTransferCardsSetting?: InputMaybe<AutoTransferCardsSetting>;
  description?: InputMaybe<Scalars["String"]>;
  endDate?: InputMaybe<Scalars["Date"]>;
  enforceLimit?: InputMaybe<Scalars["Boolean"]>;
  enforceLimitBufferPercentage?: InputMaybe<Scalars["Int"]>;
  expenseVisibilityShared?: InputMaybe<Scalars["Boolean"]>;
  limit?: InputMaybe<FinancialAssetInput>;
  limitIncreaseRequestEnabled?: InputMaybe<Scalars["Boolean"]>;
  limitIncreaseRequestPolicyId?: InputMaybe<Scalars["ID"]>;
  limitVisibility?: InputMaybe<BudgetLimitVisibilityType>;
  members?: InputMaybe<Array<Scalars["ID"]>>;
  merchantCategoryControls?: InputMaybe<Array<MerchantCategoryConfigInput>>;
  name?: InputMaybe<Scalars["String"]>;
  onlyProvisionedCardSpend?: InputMaybe<Scalars["Boolean"]>;
  owners?: InputMaybe<Array<Scalars["ID"]>>;
  parentBudgetId?: InputMaybe<Scalars["ID"]>;
  periodType?: InputMaybe<BudgetPeriodType>;
  policyId?: InputMaybe<Scalars["ID"]>;
  spendMethod?: InputMaybe<BudgetRequestEntitySpendMethod>;
  spendMethodMetadata?: InputMaybe<BudgetRequestEntitySpendMethodMetadataOneOfInput>;
  startDate?: InputMaybe<Scalars["Date"]>;
}

/** Fields needed to update a request for a budget-template derived budget */
export interface UpdateBudgetRequestFromTemplateFields {
  merchantCategoryControls?: InputMaybe<Array<MerchantCategoryConfigInput>>;
  metadata: BudgetTemplateDerivedMetadataOneOfInput;
}

/** Input to update a request for a budget-template derived budget */
export interface UpdateBudgetRequestFromTemplateInput {
  clientMutationId: Scalars["String"];
  fields: UpdateBudgetRequestFromTemplateFields;
  id: Scalars["ID"];
}

/** Input to update a request for a budget. */
export interface UpdateBudgetRequestInput {
  clientMutationId: Scalars["String"];
  fields: UpdateBudgetRequestFields;
  id: Scalars["ID"];
}

export interface UpdateBudgetRequestResult {
  /** The budget that was updated. */
  budgetRequestEntity: BudgetRequestEntity;
}

export interface UpdateBudgetResult {
  /** The budget that was updated. */
  budget: Budget;
  /** The request that was potentially modified when this budget was updated. */
  request?: Maybe<BudgetRequest>;
}

export interface UpdateBudgetTemplateInput {
  /** Approval chains for the Spend Limit requests created from this Template */
  approvalChains?: InputMaybe<TemplateBudgetApprovalChainsInput>;
  /** The rules that define who can see this template */
  availability?: InputMaybe<BudgetTemplateAvailabilityInput>;
  /** The auto approval settings for this template */
  budgetAutoApprovalSettings?: InputMaybe<BudgetAutoApprovalSettingsInput>;
  /** Budget nesting rules for the Spend Limit requests created from this Template */
  budgetNestingRules?: InputMaybe<TemplateBudgetNestingRulesInput>;
  /** Rules for how parent budgets are assigned, who reviews budget requests, etc. */
  budgetStructure?: InputMaybe<TemplateBudgetStructureOneOfInput>;
  /** Whether or not budgets derived from this template can inherit */
  canInherit?: InputMaybe<Scalars["Boolean"]>;
  /** A description about what this template represents */
  description?: InputMaybe<Scalars["String"]>;
  /** Default end date (if any) for budgets derived from this template */
  endDate?: InputMaybe<Scalars["Date"]>;
  /** Whether or not we want to budgets derived from this template to enforce limits */
  enforceLimit?: InputMaybe<Scalars["Boolean"]>;
  /** Default limit buffer applied to budgets derived from this template */
  enforceLimitBufferPercentage?: InputMaybe<Scalars["Int"]>;
  /**
   * The list of approval chains that should be used in the template's expense policy. The conditions are evaluated in
   * the order they are given and the first one that matches the expense will be used if a review is requested.
   *
   * This is a legacy API; prefer expensePolicyDefinition.
   */
  expenseApprovalChains?: InputMaybe<Array<PolicyApprovalChainInput>>;
  /**
   * The currency that amounts in `expensePolicyDefinition` are denominated in. Required if `expensePolicyDefinition`
   * is provided.
   */
  expensePolicyCurrency?: InputMaybe<Scalars["String"]>;
  /** The expense policy associated with this template */
  expensePolicyDefinition?: InputMaybe<ExpensePolicyInput>;
  /** The expense policy ID associated with this budget template */
  expensePolicyId?: InputMaybe<Scalars["ID"]>;
  /**
   * The rules in the expense policy.
   *
   * This is a legacy API; prefer expensePolicyDefinition.
   */
  expenseRules?: InputMaybe<Array<PolicyRuleSetInput>>;
  /** Whether or not budgets created from this template will share visibility */
  expenseVisibilityShared?: InputMaybe<Scalars["Boolean"]>;
  /** Unique identifier for this budget template */
  id: Scalars["ID"];
  /** The limit associated with this budget template */
  limit?: InputMaybe<FinancialAssetInput>;
  /** The approval chain limit policy ID */
  limitApprovalPolicyId?: InputMaybe<Scalars["ID"]>;
  /** Whether or not budgets derived from this template may have limit increase requests applied */
  limitIncreaseRequestEnabled?: InputMaybe<Scalars["Boolean"]>;
  /** The associated limit increase request policy ID */
  limitIncreaseRequestPolicyId?: InputMaybe<Scalars["ID"]>;
  /** Determines if budget members are allowed to view the budget limit */
  limitVisibility?: InputMaybe<BudgetLimitVisibilityTypeInput>;
  /** A list of employees who may be members of budgets created from this template */
  members?: InputMaybe<Array<Scalars["ID"]>>;
  /** The name of the budget template */
  name?: InputMaybe<Scalars["String"]>;
  /** Whether or not only provisioned cards can spend from budgets derived from this template */
  onlyProvisionedCardSpend?: InputMaybe<Scalars["Boolean"]>;
  /** A list of employees who are to own budgets derived from these templates */
  owners?: InputMaybe<Array<Scalars["ID"]>>;
  /** Default period type for budgets derived from this template */
  periodType?: InputMaybe<BudgetPeriodTypeInput>;
  /** Default start date (if any) for budgets derived from this template */
  startDate?: InputMaybe<Scalars["Date"]>;
  /** Status of budget template. Whether it is active or inactive */
  status?: InputMaybe<BudgetTemplateStatusInput>;
}

/** Input to update the ordering of budget templates */
export interface UpdateBudgetTemplatesOrderInput {
  /** Idempotency key for templates order updates */
  clientMutationId: Scalars["String"];
  /** A list of ids representing the new order for the budget templates */
  templateIds: Array<Scalars["ID"]>;
}

export interface UpdateBudgetTemplatesOrderResult extends MutationResult {
  /** The any errors that may have occurred. If it is empty, the mutation was successful. */
  errors?: Maybe<Array<ClientError>>;
}

export interface UpdateBudgetUserNotificationPreferenceInput {
  budgetId: Scalars["ID"];
  notificationTypePreferences: Array<BudgetUserNotificationTypePreferenceInput>;
}

export interface UpdateBudgetUserNotificationPreferenceResult {
  /** The budget user notification type preferences that were updated. */
  budgetUserNotificationPreferences: Array<BudgetUserNotificationTypePreference>;
}

/** Server error when attempting to publish budget for update */
export interface UpdateBudgetsLimitAsyncPublishError {
  /** Budget id that failed to publish */
  id: Scalars["ID"];
}

export interface UpdateCardDisplayNameInput {
  /** The client mutation id */
  clientMutationId: Scalars["String"];
  /** The display name to set for the card */
  displayName: Scalars["String"];
  /** The ID of the card to update */
  id: Scalars["ID"];
}

export interface UpdateCardDisplayNamePayload {
  /** The card with updated display name */
  card: Card;
  /** The client mutation id */
  clientMutationId: Scalars["String"];
}

export interface UpdateCardPinInput {
  /** The client mutation id */
  clientMutationId: Scalars["String"];
  /** The ID of the card to update pin */
  id: Scalars["ID"];
  /** The pin to set for the card */
  pin: Scalars["String"];
}

export interface UpdateCardPinPayload {
  /** The card with updated pin */
  card: Card;
  /** The client mutation id */
  clientMutationId: Scalars["String"];
}

export interface UpdateCardShippingOrderDismissInput {
  cardId: Scalars["ID"];
  clientMutationId?: InputMaybe<Scalars["String"]>;
}

export interface UpdateCardSpendLimitAssignmentSettingsInput {
  /** Whether accidental decline protection should be enabled on the card. */
  accidentalDeclineProtectionEnabled: Scalars["Boolean"];
  /** The id of the card to update */
  cardId: Scalars["ID"];
}

export interface UpdateCardSpendLimitAssignmentSettingsResult
  extends MutationResult {
  card?: Maybe<Card>;
  errors?: Maybe<Array<ClientError>>;
}

export interface UpdateCashTransactionInput {
  amountUsdCents?: InputMaybe<Scalars["Int"]>;
  clientMutationId: Scalars["String"];
  /** A customer editable memo for the transaction which is not meant to be processed in any way outside of a note for the customer to view */
  customerMemo?: InputMaybe<Scalars["String"]>;
  /**
   * Optional description for transfer that will be used for the "Payment Instructions" for
   * Wires and the "Entry Description" field for Ach transactions
   */
  externalMemo?: InputMaybe<Scalars["String"]>;
  /** If present, specifies this as an international FX transaction. */
  fxQuoteId?: InputMaybe<Scalars["ID"]>;
  id: Scalars["ID"];
  idempotencyKey: Scalars["String"];
  /** If true, the customer opted into Principal Protection for this transaction. */
  isPproEnabled?: InputMaybe<Scalars["Boolean"]>;
  /**
   * Notify the contact if and when the transaction moves to the processing state
   * False by default, ignored unless a credit to a contact with a valid email
   */
  notifyContactProcessing?: InputMaybe<Scalars["Boolean"]>;
  recurringSchedule?: InputMaybe<InputCashRecurringSchedule>;
  /** If not set, initiate the transaction as soon as possible (e.g. business day) */
  scheduledSendAt?: InputMaybe<Scalars["Time"]>;
  updateType?: InputMaybe<InputCashTransactionUpdateArgumentUnion>;
}

export interface UpdateCashTransactionPayload {
  clientMutationId: Scalars["String"];
  transaction: CashTransaction;
}

export interface UpdateChannelPreferencesInput {
  channelId: Scalars["ID"];
  clientMutationId: Scalars["String"];
  medium: Medium;
}

export interface UpdateChannelPreferencesPayload {
  channelPreferences?: Maybe<ChannelPreferences>;
  clientMutationId: Scalars["String"];
}

export interface UpdateCompanyAssistantSettingError
  extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface UpdateCompanyAssistantSettingInput {
  /** The mode of the assistant at company level. */
  mode: AssistantMode;
}

export interface UpdateCompanyAssistantSettingResult extends MutationResult {
  /** No errors if the setting are updated successfully */
  errors?: Maybe<Array<UpdateCompanyAssistantSettingError>>;
  /** Company Assistant Setting if updated correctly */
  setting?: Maybe<CompanyAssistantSetting>;
}

export interface UpdateCompanyPreferenceInput {
  /** The preferences of the assistant memo generator at company level. */
  preferences?: InputMaybe<CompanyAssistantPreferencesInput>;
}

export interface UpdateCompanyPreferenceResult extends MutationResult {
  /** No errors if the setting are updated successfully */
  errors?: Maybe<Array<UpdateCompanyAssistantSettingError>>;
  /** Company Assistant Setting Preference if updated correctly */
  setting?: Maybe<CompanyAssistantPreferences>;
}

export interface UpdateConnectionStatusInput {
  clientCustomerAccountId: Scalars["String"];
  fspCustomerAccountId: Scalars["String"];
  status: FspConnectionStatus;
}

export interface UpdateConnectionStatusResult {
  status: FspConnectionStatus;
}

export interface UpdateContactDefaultErpCategoryInput {
  /** The 1Brex integration id. Either this or integration_id must be set. */
  accountingIntegrationId?: InputMaybe<Scalars["ID"]>;
  clientMutationId: Scalars["String"];
  /** The contact id */
  contactId: Scalars["ID"];
  /** The pre-accounting-1B erp A/P account id. Set to null to set the contact to have no default A/P account on the given integration. */
  erpApAccountId?: InputMaybe<Scalars["ID"]>;
  /**
   * The erp A/P account vx option id. Set to null to set the contact to have no default A/P account on the given integration.
   * Should only be set if the user is enabled for accounting 1B.
   */
  erpApAccountVxOptionId?: InputMaybe<Scalars["ID"]>;
  /** The pre-accounting-1B erp payment account id. Set to null to set the contact to have no default payment account on the given integration. */
  erpPaymentAccountId?: InputMaybe<Scalars["ID"]>;
  /**
   * The erp payment account vx option id. Set to null to set the contact to have no default payment account on the given integration.
   * Should only be set if the user is enabled for accounting 1B.
   */
  erpPaymentAccountVxOptionId?: InputMaybe<Scalars["ID"]>;
  /** The pre-accounting-1B integration id. Either this or accounting_integration_id must be set. */
  integrationId?: InputMaybe<Scalars["ID"]>;
  /** The pre-accounting-1B user category id. Set to null to set the contact to have no default category on the given integration. */
  userErpCategoryId?: InputMaybe<Scalars["ID"]>;
  /**
   * The user category vx option id. Set to null to set the contact to have no default category on the given integration.
   * Should only be set if the user is enabled for accounting 1B.
   */
  userErpCategoryVxOptionId?: InputMaybe<Scalars["ID"]>;
}

export interface UpdateContactDefaultErpCategoryPayload {
  clientMutationId: Scalars["String"];
}

export interface UpdateContactInput {
  billPayDefaultBudgetId?: InputMaybe<Scalars["ID"]>;
  clientMutationId: Scalars["String"];
  email?: InputMaybe<Scalars["String"]>;
  id: Scalars["ID"];
  name?: InputMaybe<Scalars["String"]>;
  phoneNumber?: InputMaybe<Scalars["String"]>;
}

export interface UpdateContactPayload {
  clientMutationId: Scalars["String"];
  contact: PaymentContact;
}

export interface UpdateCopilotInput {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** Copilot update values */
  copilot: CopilotUpdateInput;
  /** ID of the Copilot to update */
  id: Scalars["ID"];
}

export interface UpdateCostCenterInput {
  /** clientMutationId */
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** All fields are optional. Only those provided will be updated. */
  costCenter: CostCenterInput;
  /** The ID of the cost center to update. */
  id: Scalars["ID"];
}

export interface UpdateCostCenterResult {
  /** Cost center that was updated. */
  costCenter: CostCenter;
}

export interface UpdateCustomRoleInput {
  /**
   * Optional, the capabilities comprising the role's access definition. Values set here will REPLACE the role's
   * existing configured capabilities.
   */
  capabilityKeys?: InputMaybe<Array<InputMaybe<AuthCapabilityKey>>>;
  /** Optional, the new description of the role. */
  description?: InputMaybe<Scalars["String"]>;
  /** Optional, the new name to display for the role. */
  displayName?: InputMaybe<Scalars["String"]>;
  /** Required, which role to update. */
  id: Scalars["ID"];
}

export interface UpdateCustomRoleResult extends MutationResult {
  errors?: Maybe<Array<AuthRoleError>>;
  result?: Maybe<AuthRole>;
}

export interface UpdateDDAMigrationStateInput {
  customerAccountId: Scalars["ID"];
  state: MigrationState;
}

/** Updates a default integration field, updating the default field's extended field option to the value given */
export interface UpdateDefaultIntegrationFieldMappingInput {
  clientMutationId: Scalars["String"];
  defaultFieldId: Scalars["ID"];
  extendedFieldOptionId: Scalars["ID"];
}

export interface UpdateDefaultIntegrationFieldMappingResult
  extends MutationResult {
  errors?: Maybe<Array<AccountingIntegrationMutationError>>;
  result?: Maybe<DefaultIntegrationFieldMapping>;
}

export interface UpdateDepartmentInput {
  clientMutationId: Scalars["String"];
  /** The new description of the department */
  description?: InputMaybe<Scalars["String"]>;
  /** Required identifier for the department to update */
  id: Scalars["ID"];
  /** The new name of the department */
  name?: InputMaybe<Scalars["String"]>;
}

export interface UpdateDepositsAccountInput {
  clientMutationId: Scalars["String"];
  depositsAccountId: Scalars["ID"];
  nickname: Scalars["String"];
}

export interface UpdateDepositsAccountPayload {
  clientMutationId: Scalars["String"];
  depositsAccount: DepositsAccount;
}

export interface UpdateEmployeeInput {
  /** clientMutationId */
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** The input for the request object. All fields are optional. Only those provided will be updated. */
  employee: EmployeeUpdateInput;
  /** The ID of the employee to update. */
  id: Scalars["ID"];
}

export interface UpdateEmployeeResult {
  /** The employee that was updated. */
  employee: Employee;
}

/** Update policy currencies enablement */
export interface UpdateEnabledAccountPolicyCurrenciesInput {
  /** list of selected currencies */
  currencies: Array<AccountPolicyCurrencyWithEnabled>;
}

/** Update a list of currencies that are enabled for account policies */
export interface UpdateEnabledAccountPolicyCurrenciesResult
  extends MutationResult {
  accountPolicyCurrencies?: Maybe<Array<AccountPolicyCurrency>>;
  errors?: Maybe<Array<AccountPolicyCurrenciesErrors>>;
}

export interface UpdateEngagementSettingInput {
  /** Desired enablement of AI commenting */
  aiCommentingEnabled?: InputMaybe<Scalars["Boolean"]>;
  /** Desired ComplianceRatingProductStatus to update the setting with. */
  complianceRatingProductStatus?: InputMaybe<ComplianceRatingProductStatus>;
}

export interface UpdateEngagementSettingResult {
  /** Updated EngagementSetting. */
  engagementSetting: EngagementSetting;
}

/** Mapping between a entity and another value on an integration */
export interface UpdateEntityMappingInput {
  /** ID of the integration. */
  integrationId: Scalars["ID"];
  /** ID of the value we are mapping from */
  mappingInputId: Scalars["ID"];
  /** ID of the extended field the value we are mapping to */
  mappingOutputFieldId?: InputMaybe<Scalars["ID"]>;
  /** ID of the value we are mapping to */
  mappingOutputId: Scalars["ID"];
  /** Type of mapping we are performing */
  mappingType: EntityMappingType;
  /**
   * @Deprecated. oldMappingInputId is not needed and will have no effect on the mutation
   * Old ID of the value we are mapping from
   */
  oldMappingInputId?: InputMaybe<Scalars["ID"]>;
  /** Old ID of the extended field the value we are mapping to */
  oldMappingOutputId?: InputMaybe<Scalars["ID"]>;
}

export interface UpdateEntityMappingResult extends MutationResult {
  errors?: Maybe<Array<AccountingIntegrationMutationError>>;
  result?: Maybe<EntityMapping>;
}

export interface UpdateExpenseInput {
  /** clientMutationId */
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /**
   * The input for the expense object.
   *
   * Either ExpenseInput or IntegrationInput must be set.
   * It is okay to set both arguments.
   */
  expense?: InputMaybe<ExpenseInput>;
  /** The ID of the expense to update. */
  id: Scalars["ID"];
  /**
   * The input for the integration fields.
   *
   * Either ExpenseInput or IntegrationInput must be set.
   * It is okay to set both arguments.
   */
  integration?: InputMaybe<IntegrationInput>;
}

export interface UpdateExpenseReportInput {
  /** The idempotency key */
  clientMutationId: Scalars["String"];
  /** The expense report update fields */
  fields: UpdateExpenseReportInputFields;
  /** The expense report id */
  id: Scalars["ID"];
}

export interface UpdateExpenseReportInputFields {
  /** Description of what the expense report is used for */
  description?: InputMaybe<Scalars["String"]>;
  /** End date of the expense report */
  endDate?: InputMaybe<Scalars["Date"]>;
  /** The ID of the expense policy for this expense report */
  expensePolicyId?: InputMaybe<Scalars["ID"]>;
  /** Legal entity mapping of the expense report */
  legalEntityMapping?: InputMaybe<LegalEntityMapping>;
  /** Name of the expense report */
  name?: InputMaybe<Scalars["String"]>;
  /** Start date of the expense report */
  startDate?: InputMaybe<Scalars["Date"]>;
}

export interface UpdateExpenseReportResult extends MutationResult {
  errors?: Maybe<Array<ExpenseReportMutationError>>;
  expenseReport?: Maybe<ExpenseReport>;
}

export interface UpdateExpenseResult {
  /** List of errors when creating the expense */
  errors?: Maybe<Array<ExpenseMutationError>>;
  /** The expense that was updated. */
  expense: Expense;
}

export interface UpdateExpenseReviewResult {
  /** A list of user errors for mutation responses. Clients should always request this field when performing mutations */
  errors?: Maybe<Array<ExpenseMutationError>>;
  /** The expense that was updated. */
  expense?: Maybe<Expense>;
}

export interface UpdateExpensesAuditStatusError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface UpdateExpensesAuditStatusInput {
  /** clientMutationId */
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** The target expense to update. */
  expenseId: Scalars["ID"];
  /** The desired audit status. */
  status: AuditStatus;
}

export interface UpdateExpensesInput {
  /** clientMutationId */
  clientMutationId: Scalars["String"];
  /** A list of expense inputs. */
  updateExpenseInputs: Array<UpdateExpenseInput>;
}

export interface UpdateExpensesResult {
  /** The expenses that were updated. */
  expenses: Array<Expense>;
}

export interface UpdateExportJobNotificationInput {
  /** Job notification id */
  exportJobNotificationId: Scalars["ID"];
  /** The state of job notification */
  state: ExportJobNotificationState;
}

/**
 * Specify the fields to update for the ExportRecord.
 * If a field is non-null it will be used for update
 */
export interface UpdateExportRecordInput {
  /** Indicates if the user has acknowledged/dismissed an export banner from Accounting Journal */
  hasStatusAcknowledgedByUser?: InputMaybe<Scalars["Boolean"]>;
  /** The id of the export attempt the export record is referencing */
  id: Scalars["ID"];
}

export interface UpdateExportRecordResult {
  exportRecord: ExportRecord;
}

/** Update extended field mutation errors */
export interface UpdateExtendedFieldError extends MutationResult {
  errors?: Maybe<Array<ExtendedFieldMutationError>>;
}

/** Top-level input fields for updating an extended field */
export interface UpdateExtendedFieldInput {
  clientMutationId: Scalars["String"];
  field: ExtendedFieldUpdateInput;
  id: Scalars["ID"];
}

export interface UpdateExtendedFieldOptionInput {
  /** The option id to be updated. */
  optionId: Scalars["ID"];
  optionInput: ExtendedFieldOptionInput;
}

/** Response of extended field update */
export interface UpdateExtendedFieldResult {
  extendedField: ExtendedField;
}

/** Response of extended field update or error */
export type UpdateExtendedFieldResultOrError =
  | UpdateExtendedFieldError
  | UpdateExtendedFieldResult;

/** Top-level input fields for creating an extended field visibility rule */
export interface UpdateExtendedFieldVisibilityRuleInput {
  id: Scalars["ID"];
  visibilityRule: ExtendedFieldVisibilityRuleUpdateInput;
}

/** Response of extended field visibility rule update */
export interface UpdateExtendedFieldVisibilityRuleResult
  extends MutationResult {
  errors?: Maybe<Array<ExtendedFieldVisibilityRuleMutationError>>;
  extendedFieldVisibilityRule: ExtendedFieldVisibilityRule;
}

/** Top-level input fields for updating multiple extended fields */
export interface UpdateExtendedFieldsInput {
  clientMutationId: Scalars["String"];
  fields: Array<ExtendedFieldUpdateInput>;
}

/** Either provide start / end date or start / end time. If both are provided, start / end time will be used. */
export interface UpdateGroupEventFields {
  accommodation?: InputMaybe<LocationMetadataInput>;
  agendaLink?: InputMaybe<Scalars["String"]>;
  budgetId?: InputMaybe<Scalars["ID"]>;
  carRequirement?: InputMaybe<BookingRequirement>;
  commsChannelLink?: InputMaybe<Scalars["String"]>;
  commsChannelTitle?: InputMaybe<Scalars["String"]>;
  coverPhotoAssetId?: InputMaybe<Scalars["String"]>;
  description?: InputMaybe<Scalars["String"]>;
  destination?: InputMaybe<LocationMetadataInput>;
  endDate?: InputMaybe<Scalars["Date"]>;
  endTime?: InputMaybe<Scalars["LocalDateTime"]>;
  flightRequirement?: InputMaybe<BookingRequirement>;
  hotelRequirement?: InputMaybe<BookingRequirement>;
  limitGroupOrSpendLimitId?: InputMaybe<Scalars["ID"]>;
  name?: InputMaybe<Scalars["String"]>;
  pointOfContact?: InputMaybe<Scalars["String"]>;
  preferredAirportCode?: InputMaybe<Scalars["String"]>;
  railRequirement?: InputMaybe<BookingRequirement>;
  startDate?: InputMaybe<Scalars["Date"]>;
  startTime?: InputMaybe<Scalars["LocalDateTime"]>;
  timezone?: InputMaybe<Scalars["String"]>;
}

export interface UpdateGroupEventInput {
  clientMutationId: Scalars["String"];
  fields: UpdateGroupEventFields;
  id: Scalars["ID"];
}

export interface UpdateGroupEventResult {
  error?: Maybe<Scalars["String"]>;
  groupEvent?: Maybe<GroupEvent>;
}

export interface UpdateGroupEventTripInput {
  /**
   * Customer User ID of the user to change the trip for
   * Defaults to the current user
   */
  customerUserId?: InputMaybe<Scalars["String"]>;
  /** Group Event to change the trip for */
  groupEventId: Scalars["String"];
  /** New trip ID */
  newTripId: Scalars["String"];
}

export interface UpdateGroupInput {
  displayName?: InputMaybe<Scalars["String"]>;
  groupIdentifier: GroupIdentifier;
  memberCondition?: InputMaybe<MemberConditionInput>;
  members?: InputMaybe<Array<GroupMemberInput>>;
  status?: InputMaybe<GroupStatus>;
  syncType?: InputMaybe<GroupSyncType>;
}

export interface UpdateGroupResult extends MutationResult {
  errors?: Maybe<Array<GroupsMutationError>>;
  result?: Maybe<Group>;
}

/**
 * How to update an existing HRIS connection. Currently, the only supported update is changing a connection's status
 * from UNLINKED to ENABLED.
 */
export interface UpdateHrConnectionInput {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** The new status for the connection. Must pass ENABLED when current status is UNLINKED. */
  hrisStatus?: InputMaybe<HrConnectionStatus>;
  /** The connection that is being updated. */
  id: Scalars["ID"];
}

export interface UpdateIdpConfigError extends SsoClientError {
  code?: Maybe<SsoClientErrorCode>;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export type UpdateIdpConfigResult = CustomerSsoSettings | UpdateIdpConfigError;

export interface UpdateInsightSettingInput {
  /** The ID of the insight setting to update */
  id: Scalars["ID"];
  /** Fields to update on the insight setting */
  setting: InsightSettingInput;
}

export interface UpdateInsightSettingsInput {
  /** List of updates in the batch */
  updates: Array<UpdateInsightSettingInput>;
}

export interface UpdateInsightSettingsResult extends MutationResult {
  errors?: Maybe<Array<InsightSettingsClientError>>;
  /** The updated insight settings */
  result?: Maybe<Array<InsightSetting>>;
}

export interface UpdateInstitutionLoginInput {
  clientMutationId: Scalars["String"];
  financialSourceId: Scalars["ID"];
}

export interface UpdateInstitutionLoginPayload {
  clientMutationId: Scalars["String"];
  result?: Maybe<FinancialsSourceResult>;
}

export interface UpdateIntegrationCredentialInput {
  clientMutationId: Scalars["String"];
  /** ID of new credential */
  credentialId: Scalars["ID"];
  /** ID of integration whose credential is getting changed */
  integrationId: Scalars["ID"];
}

export interface UpdateIntegrationCredentialPayload {
  clientMutationId: Scalars["String"];
  integration?: Maybe<Integration>;
}

export interface UpdateIntegrationRuleInput {
  body?: InputMaybe<Scalars["Json"]>;
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
  name?: InputMaybe<Scalars["String"]>;
  priority?: InputMaybe<Scalars["Int"]>;
  ruleBodyEnriched?: InputMaybe<Scalars["Boolean"]>;
}

export interface UpdateIntegrationRulePayload {
  clientMutationId: Scalars["String"];
  integrationRule?: Maybe<IntegrationRule>;
}

export interface UpdateIntegrationSettingsInput {
  /** Oracle Fusion only: AP required segments */
  accountsPayableAdditionalRequiredSegments?: InputMaybe<
    Array<InputMaybe<RequiredSegmentInput>>
  >;
  accountsPayableCategoryId?: InputMaybe<Scalars["ID"]>;
  /** Oracle Fusion only: awx wallet required segments */
  awxWalletAdditionalRequiredSegments?: InputMaybe<
    Array<InputMaybe<RequiredSegmentInput>>
  >;
  /** The exchange account for locally funded reimbursements */
  awxWalletUserCategoryId?: InputMaybe<Scalars["ID"]>;
  clientMutationId: Scalars["String"];
  collectionTargetCategoryId?: InputMaybe<Scalars["ID"]>;
  /** Oracle Fusion only: cash/bank required segments */
  collectionsAdditionalRequiredSegments?: InputMaybe<
    Array<InputMaybe<RequiredSegmentInput>>
  >;
  /** The netsuite vendor id for credit card transactions. */
  creditCardTransactionsVendorId?: InputMaybe<Scalars["ID"]>;
  /** The peie ids for default integration entities. */
  defaultIntegrationEntityIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
  id: Scalars["ID"];
  /** Workday-specific ledger type */
  ledgerType?: InputMaybe<Scalars["String"]>;
  /** Oracle Fusion only: personal expense required segments */
  personalExpenseAdditionalRequiredSegments?: InputMaybe<
    Array<InputMaybe<RequiredSegmentInput>>
  >;
  /** The GL account id for syncing personal expenses */
  personalExpenseUserCategoryId?: InputMaybe<Scalars["ID"]>;
  /** Oracle Fusion only: reimbursement clearing required segments */
  reimbursementClearingAdditionalRequiredSegments?: InputMaybe<
    Array<InputMaybe<RequiredSegmentInput>>
  >;
  /** The GL account id for accrual basis accounting for reimbursement */
  reimbursementClearingUserCategoryId?: InputMaybe<Scalars["ID"]>;
  /** Oracle Fusion only: reimbursements required segments */
  reimbursementsAdditionalRequiredSegments?: InputMaybe<
    Array<InputMaybe<RequiredSegmentInput>>
  >;
  /** The GL account id for syncing reimbursements data */
  reimbursementsUserCategoryId?: InputMaybe<Scalars["ID"]>;
  /** Oracle Fusion only: rewards required segments */
  rewardsAdditionalRequiredSegments?: InputMaybe<
    Array<InputMaybe<RequiredSegmentInput>>
  >;
  rewardsIncomeUserCategoryId?: InputMaybe<Scalars["ID"]>;
}

export interface UpdateIntegrationSettingsPayload {
  clientMutationId: Scalars["String"];
  integration?: Maybe<Integration>;
}

export interface UpdateIntegrationSyncSettingsInput {
  batchCadence?: InputMaybe<BatchCadence>;
  batchEntity?: InputMaybe<BatchEntity>;
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
  syncFrom?: InputMaybe<Scalars["Time"]>;
  transactionExportType?: InputMaybe<TransactionExportType>;
  version?: InputMaybe<Scalars["Int"]>;
}

export interface UpdateIntegrationSyncSettingsPayload {
  clientMutationId: Scalars["String"];
  integration?: Maybe<Integration>;
}

export interface UpdateInviteResponseInput {
  accessibilityRequirements?: InputMaybe<Scalars["String"]>;
  attending: Scalars["Boolean"];
  clientMutationId: Scalars["String"];
  declineReason?: InputMaybe<Scalars["String"]>;
  dietaryRestrictions?: InputMaybe<Scalars["String"]>;
  id: Scalars["ID"];
  needsCar: Scalars["Boolean"];
  needsFlight: Scalars["Boolean"];
  needsHotel: Scalars["Boolean"];
  needsRail?: InputMaybe<Scalars["Boolean"]>;
}

export interface UpdateInviteResponseResult {
  error?: Maybe<Scalars["String"]>;
  invite?: Maybe<Invite>;
}

export interface UpdateItineraryActivityFields {
  description?: InputMaybe<Scalars["String"]>;
  endDateTime: Scalars["LocalDateTime"];
  location: LocationMetadataInput;
  startDateTime: Scalars["LocalDateTime"];
  timezone: Scalars["String"];
  title: Scalars["String"];
  type: ItineraryActivityType;
  version: Scalars["Int"];
}

export interface UpdateItineraryActivityInput {
  clientMutationId: Scalars["String"];
  fields: UpdateItineraryActivityFields;
  id: Scalars["ID"];
}

export interface UpdateItineraryActivityResult {
  error?: Maybe<Scalars["String"]>;
  itineraryActivity?: Maybe<ItineraryActivity>;
}

export interface UpdateJitEnabledError extends SsoClientError {
  code?: Maybe<SsoClientErrorCode>;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export type UpdateJitEnabledResult =
  | UpdateJitEnabledError
  | UpdateJitEnabledStatus;

export interface UpdateJitEnabledStatus {
  customerAccountId: Scalars["String"];
  enabled: Scalars["Boolean"];
  id: Scalars["ID"];
}

export interface UpdateKYCIndividualInput {
  birthDate?: InputMaybe<Scalars["Date"]>;
  firstName?: InputMaybe<Scalars["String"]>;
  lastName?: InputMaybe<Scalars["String"]>;
  ssnLast4?: InputMaybe<Scalars["String"]>;
}

export interface UpdateKYCIndividualResult {
  success: Scalars["Boolean"];
}

export interface UpdateLeadInput {
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
  idempotencyKey: Scalars["String"];
  leadDetails?: InputMaybe<LeadDetailsInput>;
  leadFormStatus?: InputMaybe<LeadFormStatus>;
  leadFormType: LeadFormType;
  marketoProgramName?: InputMaybe<Scalars["String"]>;
}

export interface UpdateLeadPayload {
  clientMutationId: Scalars["String"];
  lead?: Maybe<LeadObject>;
}

export interface UpdateLegalEntityInput {
  /** clientMutationId */
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** The ID of the legal entity to update. */
  id: Scalars["ID"];
  /** All fields are optional. Only those provided will be updated. */
  legalEntity: LegalEntityInput;
}

export interface UpdateLegalEntityResult {
  /** Legal entity that was updated. */
  legalEntity: LegalEntity;
}

/** Input for limit group overrides for financial asset type fields */
export interface UpdateLimitGroupFinancialAssetFieldOverride {
  memberCondition: UpdateLimitGroupOverrideMemberConditionInput;
  value: FinancialAssetInput;
}

/** Input for limit group update */
export interface UpdateLimitGroupInput {
  /** The idempotency key */
  clientMutationId: Scalars["String"];
  /** The spend limit group creation fields */
  fields: UpdateLimitGroupInputFields;
  /** The limit group ID */
  id: Scalars["ID"];
}

export interface UpdateLimitGroupInputFields {
  /** The default limit fields that are applied to all the limits of the limit group */
  defaultLimitFields?: InputMaybe<UpdateSpendLimitBlueprintFields>;
  /** The description of the limit group */
  description?: InputMaybe<Scalars["String"]>;
  /** The name of the limit group */
  name?: InputMaybe<Scalars["String"]>;
  /** Optional overrides on eligible spend limit fields for specific groups */
  spendLimitFieldOverrides?: InputMaybe<UpdateLimitGroupOverrides>;
  /** User group configuration to be applied to the group associated with this limit group */
  userGroup?: InputMaybe<UserGroupInput>;
}

export interface UpdateLimitGroupOverrideMemberConditionInput {
  memberCondition?: InputMaybe<MemberConditionInput>;
  /** The member ids additional to the member condition */
  memberIds?: InputMaybe<Array<Scalars["ID"]>>;
}

/** Input for limit group overrides on eligible fields */
export interface UpdateLimitGroupOverrides {
  /** Overrides on the limit field of a spend limit */
  limit?: InputMaybe<Array<UpdateLimitGroupFinancialAssetFieldOverride>>;
}

export interface UpdateLimitGroupResult {
  /** The limit group that was updated. */
  limitGroup: LimitGroup;
}

export interface UpdateLineItemInput {
  /** The ID of the line item to update. */
  id: Scalars["ID"];
  /** The input for the line item object. */
  lineItem: LineItemInput;
}

export interface UpdateLocationInput {
  clientMutationId: Scalars["String"];
  /** The new description of the location */
  description?: InputMaybe<Scalars["String"]>;
  /** Required identifier for the location to update */
  id: Scalars["ID"];
  /** The new name of the location */
  name?: InputMaybe<Scalars["String"]>;
}

export interface UpdateMappingClassInput {
  /**
   * The new left hand side of the mapping class action, if not null. Action left can only be changed for empty mapping
   * classes.
   */
  actionLeft?: InputMaybe<LeftHandSideOneOfInput>;
  /** The new automatch status, if not null. */
  automatchStatus?: InputMaybe<MappingClassAutomatchStatus>;
  /**
   * The new left hand side of the mapping class filter, if not null. Filter left can only be changed for empty mapping
   * classes.
   */
  filterLeft?: InputMaybe<LeftHandSideOneOfInput>;
  /** The mapping class to update. */
  mappingClassId: Scalars["ID"];
}

export interface UpdateMappingClassResult {
  mappingClass: MappingClass;
}

export interface UpdateMappingInput {
  /** The new right hand side for the mapping action, if not null. */
  actionRight?: InputMaybe<RightHandSideSingleValueOneOfInput>;
  /** The new right hand side for the mapping filter, if not null. */
  filterRight?: InputMaybe<RightHandSideSingleValueOneOfInput>;
  /** The mapping to update. */
  mappingId: Scalars["ID"];
}

export interface UpdateMappingResult {
  mapping: Mapping;
}

export interface UpdateMigratedUsersInput {
  migratedUsers: Array<MigratedUserInput>;
}

export interface UpdateMostRecentlyUsedCurrencyInput {
  currency: Scalars["String"];
  paymentInstrumentLogicalId: Scalars["String"];
}

/** Input to update a request for a budget-template derived budget */
export interface UpdateParentBudgetAndApproveBudgetRequestInput {
  budgetRequestEntityId: Scalars["ID"];
  clientMutationId: Scalars["String"];
  isAdminOverride: Scalars["Boolean"];
  parentBudgetId: Scalars["String"];
}

export interface UpdateParentBudgetAndApproveBudgetRequestResult
  extends MutationResult {
  /** The ID of the budget request. */
  budgetRequestEntityId?: Maybe<Scalars["ID"]>;
  /** A list of user errors for mutation responses. Clients should always request this field when performing mutations */
  errors?: Maybe<Array<ClientError>>;
}

export interface UpdatePartnershipIntegrationInput {
  id: Scalars["ID"];
  integrationTypes: Array<PartnerIntegrationType>;
  status: PartnerIntegrationStatus;
}

export interface UpdatePaymentInstrumentInput {
  achPaymentInstrument?: InputMaybe<AchPaymentInstrumentInput>;
  /** For Banking Counterparty payment instrument */
  bankingCounterpartyPaymentInstrument?: InputMaybe<BankingCounterpartyPaymentInstrumentInput>;
  /** Payment instrument's beneficiary business name, set when beneficiary type is business */
  beneficiaryBusinessName?: InputMaybe<Scalars["String"]>;
  /** Payment instrument's beneficiary first name, set when beneficiary type is individual */
  beneficiaryFirstName?: InputMaybe<Scalars["String"]>;
  /** Payment instrument's beneficiary last name, set when beneficiary type is individual */
  beneficiaryLastName?: InputMaybe<Scalars["String"]>;
  /** Payment instrument's beneficiary name */
  beneficiaryName?: InputMaybe<Scalars["String"]>;
  /** Payment instrument's beneficiary type */
  beneficiaryType?: InputMaybe<PaymentInstrumentBeneficiaryType>;
  chequePaymentInstrument?: InputMaybe<ChequePaymentInstrumentInput>;
  clientMutationId: Scalars["String"];
  counterpartyPaymentInstrument?: InputMaybe<CounterpartyPaymentInstrumentInput>;
  domesticWirePaymentInstrument?: InputMaybe<DomesticWirePaymentInstrumentInput>;
  id: Scalars["ID"];
  internationalWirePaymentInstrument?: InputMaybe<InternationalWirePaymentInstrumentInput>;
  internationalWirePaymentInstrumentForBankingCounterparty?: InputMaybe<BankingCounterpartyInput>;
}

export interface UpdatePaymentInstrumentPayload {
  clientMutationId: Scalars["String"];
  paymentInstrument: PaymentInstrument;
}

export interface UpdatePaymentSourceInput {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** Funding source id to set as reimbursement payment source */
  fundingSourceId: Scalars["ID"];
}

export interface UpdatePaymentSourcePayload {
  clientMutationId?: Maybe<Scalars["String"]>;
}

export interface UpdatePersonalPlaidLinkTokenInput {
  androidPackageName?: InputMaybe<Scalars["String"]>;
  clientMutationId: Scalars["String"];
  financialSourceId: Scalars["ID"];
  linkCustomizationName?: InputMaybe<Scalars["String"]>;
  redirectUri?: InputMaybe<Scalars["String"]>;
}

export interface UpdatePersonalPlaidLinkTokenPayload {
  clientMutationId: Scalars["String"];
  linkToken: Scalars["String"];
}

export interface UpdatePlaidLinkTokenInput {
  androidPackageName?: InputMaybe<Scalars["String"]>;
  clientMutationId: Scalars["String"];
  financialSourceId: Scalars["ID"];
  linkCustomizationName?: InputMaybe<Scalars["String"]>;
  redirectUri?: InputMaybe<Scalars["String"]>;
}

export interface UpdatePlaidLinkTokenPayload {
  clientMutationId: Scalars["String"];
  linkToken: Scalars["String"];
}

export interface UpdatePositivePayAccountSettingInput {
  achCompanyId?: InputMaybe<Scalars["String"]>;
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
  name?: InputMaybe<Scalars["String"]>;
  status?: InputMaybe<PositivePayAccountSettingStatus>;
}

export interface UpdatePositivePayAccountSettingPayload {
  clientMutationId: Scalars["String"];
  positivePayAccountSetting: PositivePayAccountSetting;
}

/**
 * Acts as an input union depending on which field is not NULL
 * One field is required to be set
 */
export interface UpdatePrimitiveInputOneOf {
  expense?: InputMaybe<UpdateExpenseInput>;
}

export interface UpdatePurchaseOrderInput {
  /** Client mutation ID for tracking */
  clientMutationId: Scalars["String"];
  /** The current version of the PO to update */
  currentVersion: Scalars["Int"];
  /** The fields to update on the purchase order */
  fields: PurchaseOrderFieldsInput;
  /** The ID of the purchase order to update */
  id: Scalars["ID"];
}

export interface UpdatePurchaseOrderResult extends MutationResult {
  errors?: Maybe<Array<PurchaseOrderMutationError>>;
  result?: Maybe<PurchaseOrder>;
}

/** Input for the Purchasing Card update */
export interface UpdatePurchasingCardInput {
  /** The idempotency key */
  clientMutationId: Scalars["String"];
  /** The Purchasing Card update fields */
  fields: UpdatePurchasingCardInputFields;
  /** The Purchasing Card id */
  id: Scalars["ID"];
}

export interface UpdatePurchasingCardInputFields {
  /** Purchasing Card Authorization Settings. */
  authorizationSettings?: InputMaybe<UpdateSpendLimitAuthorizationSettingsInput>;
  /**
   * Privacy setting whether its members are allowed to view the limit & authorization settings
   * (previously known as limit visibility)
   */
  authorizationVisibility?: InputMaybe<SpendLimitAuthorizationVisibility>;
  /** Setting for auto-transferring budget cards when their owners are either disabled or removed as members from the budget. */
  autoTransferCardsSetting?: InputMaybe<AutoTransferCardsSetting>;
  /** Description of what the Purchasing Card is used for */
  description?: InputMaybe<Scalars["String"]>;
  /** End date of the Purchasing Card */
  endDate?: InputMaybe<Scalars["Date"]>;
  /** The expense policy id for this Purchasing Card */
  expensePolicyId?: InputMaybe<Scalars["ID"]>;
  /** Determines if Purchasing Card members are allowed to view other members expenses. */
  expenseVisibility?: InputMaybe<SpendLimitExpenseVisibility>;
  /** Legal entity ID of a Purchasing Card */
  legalEntityId?: InputMaybe<Scalars["ID"]>;
  /** The limit increase request policy id for this Purchasing Card, it replaces limitIncreaseRequestPolicyId */
  limitApprovalPolicyId?: InputMaybe<Scalars["ID"]>;
  /** Whether the limit increase feature is enabled for this Purchasing Card */
  limitIncreaseSetting?: InputMaybe<LimitIncreaseSetting>;
  /** Merchant category controls */
  merchantCategoryControls?: InputMaybe<Array<MerchantCategoryConfigInput>>;
  /** Name of the Purchasing Card */
  name?: InputMaybe<Scalars["String"]>;
  /** Recurrence type of the Purchasing Card */
  periodRecurrenceType?: InputMaybe<SpendLimitPeriodRecurrenceType>;
  /** Start date of the Purchasing Card */
  startDate?: InputMaybe<Scalars["Date"]>;
  /** Status of the Purchasing Card */
  status?: InputMaybe<SpendLimitStatus>;
  /** The transaction limit mapped to the Purchasing Card. Null for no transaction limit. */
  transactionLimit?: InputMaybe<FinancialAssetInput>;
  /** The user group to be associated with the Purchasing Card. */
  userGroup?: InputMaybe<UserGroupInput>;
}

export interface UpdatePurchasingCardResult extends MutationResult {
  errors?: Maybe<Array<PurchasingCardMutationError>>;
  spendLimit?: Maybe<SpendLimit>;
}

export interface UpdateRailAccountDetailsError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface UpdateRailAccountDetailsInput {
  accountHolderAddress?: InputMaybe<AddressInput>;
  bankAccountClass?: InputMaybe<BankAccountClassType>;
  beneficiaryNameInfo?: InputMaybe<Scalars["Json"]>;
  beneficiaryType?: InputMaybe<BeneficiaryType>;
  defaultCurrency?: InputMaybe<CurrencyInput>;
  displayName?: InputMaybe<Scalars["String"]>;
  id: Scalars["ID"];
  idempotencyKey: Scalars["String"];
  /**
   * If true, only the properties specified in the properties field will be updated,
   * and other existing properties will be preserved. If false (default), the entire
   * properties object will be replaced.
   */
  patchProperties?: InputMaybe<Scalars["Boolean"]>;
  properties?: InputMaybe<Scalars["Json"]>;
}

export interface UpdateRailAccountDetailsResult extends MutationResult {
  errors?: Maybe<Array<UpdateRailAccountDetailsError>>;
  result?: Maybe<RailAccountDetails>;
}

export interface UpdateReceiptAutogenSettingInput {
  /** True if disabling receipt autogen; False if re-enabling */
  isReceiptAutogenDisabled: Scalars["Boolean"];
}

export interface UpdateReceiptIntegrationError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface UpdateReceiptIntegrationOneOfInput {
  /** Provider-specific data needed to update an integration. */
  uber?: InputMaybe<UpdateUberReceiptIntegrationInput>;
}

export interface UpdateReceiptIntegrationResponse extends MutationResult {
  errors?: Maybe<Array<UpdateReceiptIntegrationError>>;
  result?: Maybe<ReceiptIntegration>;
}

export interface UpdateReceiptValidationSettingInput {
  value: ReceiptValidationSettingValue;
}

export interface UpdateReportTemplateDataInput {
  /** Id of template to update */
  id: Scalars["ID"];
  /** Idempotency key for update request */
  idempotencyKey: Scalars["String"];
  /** New entries for template */
  newTemplateEntries?: InputMaybe<Array<ReportTemplateEntryInput>>;
}

export interface UpdateReportTemplateInfoInput {
  /** New customer status for template */
  customerStatus: ReportTemplateCustomerStatus;
  /** Id of template to update */
  id: Scalars["ID"];
  /** Idempotency key for update request */
  idempotencyKey: Scalars["String"];
  /** New template description for template */
  templateDescription?: InputMaybe<Scalars["String"]>;
  /** New template name for template */
  templateName: Scalars["String"];
}

export interface UpdateReportingDashboardInput {
  /** Idempotency key for the update mutation */
  clientMutationId: Scalars["String"];
  /** Set the report's global filters */
  globalFilterJson?: InputMaybe<Scalars["Json"]>;
  /** The ID of the report to update. */
  id: Scalars["ID"];
  /** An optional new name for the dashboard */
  name?: InputMaybe<Scalars["String"]>;
  /** Set the report's scope */
  scope?: InputMaybe<ReportScopeInput>;
  /**
   * The new set of widgets in the dashboard.
   *
   * If set to null, the widgets will remain unchanged.
   * If set to empty list, all the widgets will be deleted.
   * If set to a non-empty list, the widget with a null id will be created, and the widget with an id will be updated.
   */
  widgets?: InputMaybe<Array<ReportingDashboardWidgetInput>>;
}

export interface UpdateReportingDashboardResult extends MutationResult {
  errors?: Maybe<Array<ReportingClientError>>;
  /** The updated dashboard, with its latest state/widgets */
  result?: Maybe<ReportingDashboard>;
}

export interface UpdateRequestActionInput {
  /** clientMutationId */
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** The ID of the request action to update. */
  id: Scalars["ID"];
  /** The input for the request action object. */
  requestAction: RequestActionInput;
}

export interface UpdateRequestActionResult {
  /** The RequestAction which was updated */
  requestAction: RequestAction;
}

export interface UpdateRequestActionResultV2 extends MutationResult {
  /** A list of user errors for mutation responses. Clients should always request this field when performing mutations */
  errors?: Maybe<Array<RequestMutationError>>;
  /** The RequestAction which was updated */
  requestAction?: Maybe<RequestAction>;
}

export interface UpdateRequestActionResults {
  /** The RequestAction which were updated */
  results: Array<UpdateRequestActionResult>;
}

export interface UpdateRequestActionResultsV2 {
  /** The RequestAction which were updated */
  results: Array<UpdateRequestActionResultV2>;
}

export interface UpdateRequestActionsInput {
  /** clientMutationId */
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** A list of individual update request input */
  updateRequestActionInputs: Array<UpdateRequestActionInput>;
}

export interface UpdateRequestDeadlineSettingsInput {
  /** Optional - whether cc'ing managers is enabled or disabled. */
  ccManagersEnabled?: InputMaybe<Scalars["Boolean"]>;
  /** Optional - whether the settings are enabled or not. */
  enabled?: InputMaybe<Scalars["Boolean"]>;
  /** Optional - the number of grace period days to use. Default value is set if empty. */
  gracePeriodDays?: InputMaybe<Scalars["Int"]>;
  /** Optional - whether reminders are enabled or disabled. */
  remindersEnabled?: InputMaybe<Scalars["Boolean"]>;
  /** Optional - whether we should send notification to users about setting change. Default to false */
  shouldSendNotification?: InputMaybe<Scalars["Boolean"]>;
}

export interface UpdateRequestDeadlineSettingsResult {
  /** The RequestDeadlineSettings which were updated */
  requestDeadlineSettings: RequestDeadlineSettings;
}

export interface UpdateRequestInput {
  /** clientMutationId */
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** The ID of the request to update. */
  id: Scalars["ID"];
  /** The input for the request object. */
  request: RequestInput;
}

export interface UpdateRequestResult {
  /** The Request which was updated */
  request: Request;
}

export interface UpdateRequestResultV2 extends MutationResult {
  /** A list of user errors for mutation responses. Clients should always request this field when performing mutations */
  errors?: Maybe<Array<RequestMutationError>>;
  /** The Request which was updated */
  request?: Maybe<Request>;
}

export interface UpdateRequestResults {
  /** The Requests which were updated */
  results: Array<UpdateRequestResult>;
}

export interface UpdateRequestResultsV2 {
  /** The Requests which were updated */
  results: Array<UpdateRequestResultV2>;
}

export interface UpdateRequestsInput {
  /** clientMutationId */
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** A list of individual update request input */
  updateRequestInputs: Array<UpdateRequestInput>;
}

export interface UpdateRolesInput {
  /** clientMutationId */
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** The employees affected by the role change. */
  employeeIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** The role to update the employees' associated user with. */
  role: UserRole;
}

export interface UpdateRolesResult {
  errors: Array<EmployeeError>;
}

export interface UpdateSelfAttestationAccountTypeInput {
  accountsList?: InputMaybe<Array<InputMaybe<SelfAttestAccountTypePair>>>;
}

export interface UpdateSelfAttestationAccountTypeResult {
  id?: Maybe<Scalars["String"]>;
}

export interface UpdateSingleExtendedFieldOptionInput {
  /** The extended field id for the options to be deleted. */
  extendedFieldId: Scalars["ID"];
  /** The option id to be updated. */
  optionId: Scalars["ID"];
  /** The option to update. */
  optionInput: ExtendedFieldOptionInput;
}

/** Input for the spend budget update */
export interface UpdateSpendBudgetInput {
  /** The idempotency key */
  clientMutationId: Scalars["String"];
  /** The spend budget update fields */
  fields: UpdateSpendBudgetInputFields;
  /** The spend budget id */
  id: Scalars["ID"];
}

export interface UpdateSpendBudgetInputFields {
  /** Amount of the spend budget */
  amount?: InputMaybe<FinancialAssetInput>;
  /** Authorization behavior of the spend budget */
  authorizationType?: InputMaybe<SpendBudgetAuthorizationType>;
  /** Description of what the spend budget is used for */
  description?: InputMaybe<Scalars["String"]>;
  /** End date of the spend budget */
  endDate?: InputMaybe<Scalars["Date"]>;
  /** Percentage of the spend budget to enforce as a limit buffer */
  enforceLimitBufferPercentage?: InputMaybe<Scalars["Int"]>;
  /** Legal entity mapping of a spend budget */
  legalEntityMapping?: InputMaybe<LegalEntityMapping>;
  /** Name of the spend budget */
  name?: InputMaybe<Scalars["String"]>;
  /** Owners of a spend budget */
  owners?: InputMaybe<Array<Scalars["ID"]>>;
  /** Recurrence type of the spend budget */
  periodRecurrenceType?: InputMaybe<SpendBudgetPeriodRecurrenceType>;
  /** Start date of the spend budget */
  startDate?: InputMaybe<Scalars["Date"]>;
}

export interface UpdateSpendBudgetResult extends MutationResult {
  errors?: Maybe<Array<SpendBudgetMutationError>>;
  spendBudget?: Maybe<SpendBudget>;
}

/** Input for update Spend Limit Authorization Settings */
export interface UpdateSpendLimitAuthorizationSettingsInput {
  /** Authorization behavior against the spend limit's limit. */
  authorizationType?: InputMaybe<SpendLimitAuthorizationType>;
  /** Base limit of the spend limit */
  baseLimit?: InputMaybe<FinancialAssetInput>;
  /** The percentage of flexible buffer on the limit as a 0-100 INT */
  limitBufferPercentage?: InputMaybe<Scalars["Int"]>;
  /** The rollover refresh rate for this spend limit (the recurrence by which all rolled over unused funds within the cycle should no longer roll over to the next period). */
  rolloverRefreshRate?: InputMaybe<SpendLimitRolloverRefreshRate>;
}

export interface UpdateSpendLimitBlueprintFields {
  /** Authorization behavior against the spend limit's limit. */
  authorizationType?: InputMaybe<SpendLimitAuthorizationType>;
  /**
   * Privacy setting whether its members are allowed to view the limit & authorization settings
   * (previously known as limit visibility)
   */
  authorizationVisibility?: InputMaybe<SpendLimitAuthorizationVisibility>;
  /** Setting for how auto limit card creation works for members. */
  autoCreateLimitCardsSetting?: InputMaybe<AutoCreateLimitCardsSetting>;
  /** Setting for auto-transferring spend limit cards when their owners are either disabled or removed as members from the budget. */
  autoTransferCardsSetting?: InputMaybe<AutoTransferCardsSetting>;
  /** Description of what the spend limit is used for */
  description?: InputMaybe<Scalars["String"]>;
  /** The end date of the spend limit, inclusive. */
  endDate?: InputMaybe<Scalars["Date"]>;
  /** The ID of the expense policy that manages expenses for this spend limit */
  expensePolicyId?: InputMaybe<Scalars["ID"]>;
  /** Determines if spend limit members are allowed to view other members expenses. */
  expenseVisibility?: InputMaybe<SpendLimitExpenseVisibility>;
  /** The percentage of flexible buffer on the limit as a 0-100 INT */
  flexibleBufferPercentage?: InputMaybe<Scalars["Int"]>;
  /**
   * The legal entity ID for the to-be-created spend limits
   * Defaults to the legal entity mapping of the parent budget if not specified
   */
  legalEntityId?: InputMaybe<Scalars["ID"]>;
  /** Limit on the spend limit */
  limit?: InputMaybe<FinancialAssetInput>;
  /** The policy that manages approval chain for limit increase requests for this spend limit. */
  limitApprovalPolicyId?: InputMaybe<Scalars["ID"]>;
  /** Whether limit increase request feature is enabled on a spend limit */
  limitIncreaseSetting?: InputMaybe<LimitIncreaseSetting>;
  /** Merchant category controls, including those along ancestry path. */
  merchantCategoryControls?: InputMaybe<Array<MerchantCategoryConfigInput>>;
  /** The name of the spend limit */
  name?: InputMaybe<Scalars["String"]>;
  /** Ids of the employees who are considered owners of this spend limit */
  ownerIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Parent budget id */
  parentBudgetId?: InputMaybe<Scalars["ID"]>;
  /** Recurrence type of the spend limit */
  periodRecurrenceType?: InputMaybe<SpendLimitPeriodRecurrenceType>;
  /** True if the user's name should be prepended to the spend limit name */
  prependUserNameToSpendLimitName?: InputMaybe<Scalars["Boolean"]>;
  /**
   * Specifies the date offset to be applied when setting the end date of the provisioned spend limit. Cannot be set if end
   * date is set
   *
   * The offset is calculated based on the time of provisioning. For instance, if the offset is set to 7 DAY and the
   * spend limit is provisioned on 2024-01-01, the end date of the provisioned spend limit will be 2024-01-08.
   */
  provisionedDateOffset?: InputMaybe<DateOffsetInput>;
  /** The rollover refresh rate for this spend limit (the recurrence by which all rolled over unused funds within the cycle should no longer roll over to the next period). */
  rolloverRefreshRate?: InputMaybe<SpendLimitRolloverRefreshRate>;
  /** Allowed spend sources on a Spend Limit. */
  spendSourceSetting?: InputMaybe<SpendSourceSettingInput>;
  /** The start date of the spend limit, inclusive. */
  startDate?: InputMaybe<Scalars["Date"]>;
  /** True if the spend limits created by this blueprint should start in the next spend limit period */
  startSpendLimitNextAvailableSpendLimitPeriod?: InputMaybe<Scalars["Boolean"]>;
  /**
   * The transaction limit mapped to the spend limits provisioned by the blueprint
   * Null if no transaction limit is set.
   */
  transactionLimit?: InputMaybe<FinancialAssetInput>;
}

/** Input for the spend limit update */
export interface UpdateSpendLimitInput {
  /** The idempotency key */
  clientMutationId: Scalars["String"];
  /** The spend limit update fields */
  fields: UpdateSpendLimitInputFields;
  /** The spend limit id */
  id: Scalars["ID"];
}

export interface UpdateSpendLimitInputFields {
  /** Spend Limit Authorization Settings. */
  authorizationSettings?: InputMaybe<UpdateSpendLimitAuthorizationSettingsInput>;
  /**
   * Privacy setting whether its members are allowed to view the limit & authorization settings
   * (previously known as limit visibility)
   */
  authorizationVisibility?: InputMaybe<SpendLimitAuthorizationVisibility>;
  /** Setting for how auto limit card creation works for members. */
  autoCreateLimitCardsSetting?: InputMaybe<AutoCreateLimitCardsSetting>;
  /** Setting for auto-transferring budget cards when their owners are either disabled or removed as members from the budget. */
  autoTransferCardsSetting?: InputMaybe<AutoTransferCardsSetting>;
  /** Description of what the spend limit is used for */
  description?: InputMaybe<Scalars["String"]>;
  /** End date of the spend limit */
  endDate?: InputMaybe<Scalars["Date"]>;
  /** The expense policy id for this spend limit */
  expensePolicyId?: InputMaybe<Scalars["ID"]>;
  /** Determines if spend limit members are allowed to view other members expenses. */
  expenseVisibility?: InputMaybe<SpendLimitExpenseVisibility>;
  /** Legal entity ID of a spend limit */
  legalEntityId?: InputMaybe<Scalars["ID"]>;
  /** The limit increase request policy id for this spend limit, it replaces limitIncreaseRequestPolicyId */
  limitApprovalPolicyId?: InputMaybe<Scalars["ID"]>;
  /** Whether the limit increase feature is enabled for this spend limit */
  limitIncreaseSetting?: InputMaybe<LimitIncreaseSetting>;
  /** Merchant category controls */
  merchantCategoryControls?: InputMaybe<Array<MerchantCategoryConfigInput>>;
  /** Name of the spend limit */
  name?: InputMaybe<Scalars["String"]>;
  /** Owners of a spend limit */
  owners?: InputMaybe<Array<Scalars["ID"]>>;
  /** Recurrence type of the spend limit */
  periodRecurrenceType?: InputMaybe<SpendLimitPeriodRecurrenceType>;
  /** Allowed spend sources on a Spend Limit. */
  spendSourceSetting?: InputMaybe<SpendSourceSettingInput>;
  /** Start date of the spend limit */
  startDate?: InputMaybe<Scalars["Date"]>;
  /** Status of the spend limit */
  status?: InputMaybe<SpendLimitStatus>;
  /** The transaction limit mapped to the spend limit. Null for no transaction limit. */
  transactionLimit?: InputMaybe<FinancialAssetInput>;
  /**
   * The user group to be associated with the spend limit when is a distribution. This mutation supports
   * only shared spend limits, that is why we don't have anymore distributionSettings.sharedBudgetDistributionSettings
   * or distributionSettings.perMemberBudgetDistributionSettings as on the old createDistributedSpendLimit
   */
  userGroup?: InputMaybe<UserGroupInput>;
}

export interface UpdateSpendLimitResult extends MutationResult {
  errors?: Maybe<Array<StandardClientError>>;
  spendLimit?: Maybe<SpendLimit>;
}

export interface UpdateSsoEnabledError extends SsoClientError {
  code?: Maybe<SsoClientErrorCode>;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export type UpdateSsoEnabledResult =
  | UpdateSsoEnabledError
  | UpdateSsoEnabledStatus;

export interface UpdateSsoEnabledStatus {
  customerAccountId: Scalars["String"];
  enabled: Scalars["Boolean"];
  id: Scalars["ID"];
}

export interface UpdateSubsidiaryInput {
  clientMutationId: Scalars["String"];
  /** Updates the intercompany customer field */
  customerId?: InputMaybe<Scalars["ID"]>;
  /** ERP subsidiary ID */
  id: Scalars["ID"];
  /** Updates the intercompany payable GL account */
  intercompanyPayableAccountId?: InputMaybe<Scalars["ID"]>;
  /** Updates the intercompany receivable GL account */
  intercompanyReceivableAccountId?: InputMaybe<Scalars["ID"]>;
  /** Updates the payload of the subsidiary */
  payload?: InputMaybe<SubsidiaryPayloadInput>;
  /** Target status to update to */
  status?: InputMaybe<SubsidiaryStatus>;
  /** Updates the intercompany vendor field */
  vendorId?: InputMaybe<Scalars["ID"]>;
}

export interface UpdateSubsidiaryPayload {
  clientMutationId: Scalars["String"];
  /** Returns updated subsidiary */
  subsidiary?: Maybe<ErpSubsidiary>;
}

export interface UpdateTaskInput {
  /** ID of the Task to update */
  id: Scalars["ID"];
  /** Task update values */
  task: TaskUpdateInput;
}

export interface UpdateTaskStatesInput {
  /** The IDs of the Tasks to update. */
  ids: Array<Scalars["ID"]>;
  /** Can only be a terminal state. */
  taskState: InboxTaskState;
}

export interface UpdateTaskStatesResult extends MutationResult {
  /** A list of user errors from Task updates. */
  errors?: Maybe<Array<TaskMutationError>>;
  /** The updated Task(s). */
  results?: Maybe<Array<InboxTask>>;
}

export interface UpdateTaxCodeSettingsError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

/**
 * Input for updating individual tax code statuses on a subsidiary.
 *
 * Assumes the current active accounting integration; fails if no active integration exists.
 */
export interface UpdateTaxCodeSettingsInput {
  /** ID of the ExtendedFieldOption that identifies the subsidiary */
  subsidiaryOptionId: Scalars["ID"];
  /** List of tax code updates to apply */
  taxCodeUpdates: Array<TaxCodeUpdateInput>;
}

export type UpdateTaxCodeSettingsResult =
  | TaxCodesConnection
  | UpdateTaxCodeSettingsError;

export interface UpdateTitleInput {
  /** clientMutationId */
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** The ID of the title to update. */
  id: Scalars["ID"];
  /** All fields are optional. Only those provided will be updated. */
  title: TitleInput;
}

export interface UpdateTitleResult {
  /** Title that was updated. */
  title: Title;
}

/** Input for updating a travel support session ID for the current user. */
export interface UpdateTravelSupportSessionIdInput {
  travelSupportSessionId: Scalars["String"];
}

/** Input for updating a trip. */
export interface UpdateTripInput {
  description?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  tripId: Scalars["String"];
}

export interface UpdateUberReceiptIntegrationInput {
  /** Whether users should be removed the linked U4B when they are deactivated on Brex. If null, setting is not updated. */
  autoOffboardEmployees?: InputMaybe<OffboardUberEmployeesSetting>;
  /** Setting for when new users should be onboarded onto linked U4B. If null, setting is not updated. */
  createUberAccountsEmployees?: InputMaybe<CreateUberAccountsEmployees>;
}

export interface UpdateUserAssistantSettingError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface UpdateUserAssistantSettingInput {
  /** The mode of the assistant. User can only set the mode to ON or AUTO_PILOT. */
  mode: AssistantMode;
}

export interface UpdateUserAssistantSettingResult extends MutationResult {
  /** No errors if the setting are updated successfully */
  errors?: Maybe<Array<UpdateUserAssistantSettingError>>;
  /** User Assistant Setting if updated correctly */
  setting?: Maybe<UserAssistantSetting>;
}

export interface UpdateUserCategoriesInput {
  clientMutationId: Scalars["String"];
  userCategories: Array<InputMaybe<UserCategoryInput>>;
}

export interface UpdateUserCategoriesPayload {
  clientMutationId: Scalars["String"];
  userCategories?: Maybe<Array<UserCategory>>;
}

export interface UpdateUserCategoryInput {
  category: Scalars["String"];
  clientMutationId: Scalars["String"];
  id: Scalars["ID"];
  name: Scalars["String"];
}

export interface UpdateUserCategoryPayload {
  clientMutationId: Scalars["String"];
  userCategory?: Maybe<UserCategory>;
}

export interface UpdateUserEmailInput {
  /** The new email address to update to. */
  email: Scalars["String"];
  /** The user id to update. */
  userId: Scalars["String"];
}

export interface UpdateUserEmailResult {
  /** The updated email address. */
  email?: Maybe<Scalars["String"]>;
}

export interface UpdateUserGlanceVisitorIdError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface UpdateUserGlanceVisitorIdInput {
  glanceVisitorId: Scalars["String"];
}

export interface UpdateUserGlanceVisitorIdResult extends MutationResult {
  errors?: Maybe<Array<UpdateUserGlanceVisitorIdError>>;
}

export interface UpdateUserInput {
  clientMutationId: Scalars["String"];
  departmentId?: InputMaybe<Scalars["ID"]>;
  firstName?: InputMaybe<Scalars["String"]>;
  id: Scalars["ID"];
  lastName?: InputMaybe<Scalars["String"]>;
  locationId?: InputMaybe<Scalars["ID"]>;
}

/** How to update existing user management settings for a connection. Only the keys provided will change. */
export interface UpdateUserManagementSettingInput {
  /** How to manage the auto-offboarding of users, if at all. */
  autoOffboardSetting?: InputMaybe<AutoOffboardSettingInput>;
  /** How to manage the auto-onboarding of users, if at all. */
  autoOnboardSetting?: InputMaybe<AutoOnboardSettingInput>;
  clientMutationId?: InputMaybe<Scalars["String"]>;
  /** The connection these new settings configures. Required field, cannot not be updated. */
  connectionId: Scalars["ID"];
  /** Which kind of employees to manage. */
  employmentTypes?: InputMaybe<Array<HrisEmploymentType>>;
  /** The settings to update. Required field, cannot not be updated. */
  id: Scalars["ID"];
  /** Idempotency key */
  idempotencyKey: Scalars["String"];
}

export interface UpdateUserPayload {
  clientMutationId: Scalars["String"];
  user?: Maybe<User>;
}

export interface UpdateUserPermissionInput {
  /** setting to access corporate cards */
  canAccessCorporateCards?: InputMaybe<Scalars["Boolean"]>;
  clientMutationId: Scalars["String"];
  /** the customer_user_id */
  id: Scalars["ID"];
}

export interface UpdateUserPermissionPayload {
  clientMutationId: Scalars["String"];
  /** the updated user */
  user: User;
}

export interface UpdateVatSettingsError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

/**
 * Input for updating VAT settings on a subsidiary.
 *
 * Assumes the current active accounting integration; fails if no active integration exists.
 */
export interface UpdateVatSettingsInput {
  /** ID of the ExtendedFieldOption chosen for custom tax amounts on this subsidiary. */
  customTaxGlAccountId?: InputMaybe<Scalars["ID"]>;
  /**
   * Whether VAT is enabled on this subsidiary.
   * If null, the value is not updated.
   */
  status?: InputMaybe<VatEnabledStatus>;
  /** ID of the ExtendedFieldOption that identifies the subsidiary */
  subsidiaryOptionId: Scalars["ID"];
}

export type UpdateVatSettingsResult = UpdateVatSettingsError | VatSettings;

export interface UpdateVendorFromMagicLinkInput {
  /** The address of the vendor. TODO: Refactor this schema and combine with the contact inputs */
  address?: InputMaybe<AddressInput>;
  clientMutationId: Scalars["String"];
  /** Contact data for the vendor */
  contactInput?: InputMaybe<ContactInput>;
  customerAccountId?: InputMaybe<Scalars["ID"]>;
  /** Clear token and send notification that vendor has completed self-serve onboarding */
  isFinalUpdate?: InputMaybe<Scalars["Boolean"]>;
  /** Payment instrument data for the vendor */
  paymentInstrumentInput?: InputMaybe<PaymentInstrumentInput>;
  /** Tax form data for the vendor (W8 / W9) */
  taxFormData?: InputMaybe<VendorTaxFormInputUnion>;
  vendorId: Scalars["ID"];
}

export interface UpdateVendorFromMagicLinkResult extends MutationResult {
  errors?: Maybe<Array<VendorMutationError>>;
  result?: Maybe<VendorDetails>;
}

export interface UpdateVendorInput {
  address?: InputMaybe<AddressInput>;
  billPayVendorExtension?: InputMaybe<BillPayVendorExtensionInput>;
  clientMutationId: Scalars["String"];
  contactName?: InputMaybe<Scalars["String"]>;
  currentVersion: Scalars["Int"];
  documentsToAdd?: InputMaybe<Array<VendorDocumentInput>>;
  documentsToRemove?: InputMaybe<Array<Scalars["ID"]>>;
  email?: InputMaybe<Scalars["String"]>;
  extendedFieldValues?: InputMaybe<Array<ExtendedFieldValueInput>>;
  id: Scalars["ID"];
  name?: InputMaybe<Scalars["String"]>;
  paymentConfig?: InputMaybe<VendorPaymentConfigInput>;
  phone?: InputMaybe<Scalars["String"]>;
  status?: InputMaybe<VendorStatus>;
  website?: InputMaybe<Scalars["String"]>;
}

export interface UpdateVendorResult extends MutationResult {
  errors?: Maybe<Array<VendorMutationError>>;
  result?: Maybe<VendorDetails>;
}

/** UpdateVerificationNotification input */
export interface UpdateVerificationNotificationInput {
  /** Unique identifier of this mutation */
  clientMutationId: Scalars["String"];
  /** ID of the Verification Notification to update */
  id: Scalars["ID"];
  /** Desired status to update to */
  status: VerificationNotificationStatus;
}

/** UpdateVerificationNotification output */
export interface UpdateVerificationNotificationPayload {
  /** Unique identifier of this mutation */
  clientMutationId: Scalars["String"];
  /** The updated Verification Notification */
  verificationNotification?: Maybe<VerificationNotification>;
}

export interface UpdateWorkflowRuleInput {
  actions?: InputMaybe<Array<InputMaybe<WorkflowRuleActionOneOfInput>>>;
  clientMutationId: Scalars["String"];
  description?: InputMaybe<Scalars["String"]>;
  displayName?: InputMaybe<Scalars["String"]>;
  filters?: InputMaybe<Array<InputMaybe<WorkflowRuleFilterInput>>>;
  id: Scalars["ID"];
}

/** Response of update VX Workflow Rule */
export interface UpdateWorkflowRuleResult {
  rule?: Maybe<WorkflowRule>;
}

export interface UpgradeToSuperAdminInput {
  /** The ID of the user to upgrade. Only logged in user ID is supported. */
  userId: Scalars["ID"];
}

export interface UpgradeToSuperAdminOperationError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface UpgradeToSuperAdminResult extends MutationResult {
  errors?: Maybe<Array<UpgradeToSuperAdminOperationError>>;
  result?: Maybe<PendingUpgradeDetail>;
}

export interface UploadBulkMappingsTemplateInput {
  /** Mapping Class ID that the template will reflect */
  mappingClassId: Scalars["ID"];
}

/** Response of uploading a template for creating mappings */
export interface UploadBulkMappingsTemplateResult {
  template?: Maybe<Asset>;
}

export interface UploadCsvAndCreateMappingsInput {
  /** Asset ID of the CSV in file store to upload as mapping rules */
  assetId: Scalars["ID"];
  /** Mapping Class ID of the mappings being uploaded */
  mappingClassId: Scalars["ID"];
}

/** Response of uploading mapping rules from CSV */
export interface UploadCsvAndCreateMappingsResult {
  errorCsv?: Maybe<Asset>;
  errorMessage?: Maybe<Scalars["String"]>;
  mappingClass: MappingClass;
  numCreatedMappings: Scalars["Int"];
  numMappingErrors: Scalars["Int"];
}

export interface UploadHotelRoomBlockError {
  /** Error message */
  error: RoomBlockUploadError;
  /** Row ID */
  rowId: Scalars["String"];
}

export interface UploadHotelRoomBlockInput {
  /** ID of group event to upload hotel room block for */
  groupEventId: Scalars["ID"];
  /** Idempotency key */
  idempotencyKey: Scalars["String"];
  /** Room Blocks */
  roomBlocks: Array<HotelRoomBlockInput>;
  /** Strategy to use when uploading room block */
  strategy: RoomBlockUploadStrategy;
}

export interface UploadHotelRoomBlockResult {
  /** Row IDs of created rows */
  createdRowIds: Array<Scalars["String"]>;
  /** Rows with errors */
  errorRows: Array<UploadHotelRoomBlockError>;
  /** Group Event */
  groupEvent: GroupEvent;
  /** Removed row IDs */
  removedRowCount: Scalars["Int"];
  /**
   * Row IDs of skipped rows
   * Existing rows are skipped
   */
  skippedRowIds: Array<Scalars["String"]>;
  /** Updated row IDs */
  updatedRowIds: Array<Scalars["String"]>;
}

export interface UploadedFinancialDocumentsResponse {
  currentDocuments?: Maybe<Array<Maybe<FinancialDocument>>>;
  priorDocuments?: Maybe<Array<Maybe<FinancialDocument>>>;
  requiredItems: Array<RequiredItem>;
}

export interface UpsertExpensePolicySpecError extends MutationError {
  errors?: Maybe<Array<UpsertExpensePolicySpecErrors>>;
}

export enum UpsertExpensePolicySpecErrorCode {
  BILL_PAY_LAST_APPROVER_MISSING_PERMISSION = "BILL_PAY_LAST_APPROVER_MISSING_PERMISSION",
  INVALID_MCC_BLOCK_RULE = "INVALID_MCC_BLOCK_RULE",
  NO_DEFAULT_BILL_PAY_REVIEW_RULE = "NO_DEFAULT_BILL_PAY_REVIEW_RULE",
  NO_DEFAULT_SECTION = "NO_DEFAULT_SECTION",
}

export interface UpsertExpensePolicySpecErrors {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export type UpsertExpensePolicySpecResult =
  | ExpensePolicySpec
  | UpsertExpensePolicySpecError;

/** Top-level input fields for creating and updating extended fields */
export interface UpsertExpenseTypeExtendedFieldInput {
  expenseTypeFieldInputs: Array<ExpenseTypeExtendedFieldInput>;
}

/** Response of upserting Expense Type Extended Fields */
export interface UpsertExpenseTypeExtendedFieldsResult {
  extendedField: ExtendedField;
}

export interface UpsertLimitUtilizationTriggerInput {
  action: LimitUtilizationTriggerConfigurationAction;
  metadata?: InputMaybe<InputTriggerConfigurationMetadataUnion>;
  triggerId?: InputMaybe<Scalars["ID"]>;
}

export interface UpsertLimitUtilizationTriggerPayload {
  limitUtilizationTrigger: LimitUtilizationTrigger;
}

export interface UpsertUserLimitInput {
  /** The idempotency key */
  clientMutationId: Scalars["String"];
  /** The customer user id of the user limit */
  customerUserId: Scalars["ID"];
  /** The user limit upsert fields */
  fields: UpsertUserLimitInputFields;
  /** Whether to issue an employee card if one is missing for the user */
  issueEmployeeCardIfMissing?: InputMaybe<Scalars["Boolean"]>;
}

export interface UpsertUserLimitInputFields {
  /** Limit of the user limit */
  limit: FinancialAssetInput;
  /** Settings that control limit flexibility and how it should be enforced */
  limitEnforcementSettings?: InputMaybe<LimitEnforcementSettingsInput>;
}

export interface UpsertUserLimitResult extends MutationResult {
  errors?: Maybe<Array<UserLimitMutationError>>;
  userLimit?: Maybe<UserLimit>;
}

export interface UpsertValueRulesForDependencyCsvInput {
  /** Asset ID of the CSV in file store to upsert as value rules for dependencies */
  assetId: Scalars["ID"];
}

/** Response of upserting value rules for dependency from CSV. */
export interface UpsertValueRulesForDependencyCsvResult extends MutationResult {
  errors?: Maybe<Array<ValueRulesForDependencyMutationError>>;
}

/**
 * American Bank Association - American banking code.
 * * routing number - identifies the institution.
 * * account number - account identifier within the bank.
 * * account type - checking/savings.
 */
export interface UsAba {
  accountNumber?: Maybe<Scalars["String"]>;
  accountType?: Maybe<BankAccountType>;
  routingNumber?: Maybe<Scalars["String"]>;
}

/**
 * American Bank Association - American banking code.
 * * routing number - identifies the institution.
 * * account number - account identifier within the bank.
 * * account type - checking/savings.
 */
export interface UsAbaInput {
  accountNumber: Scalars["String"];
  accountType: BankAccountType;
  routingNumber: Scalars["String"];
}

export interface UsageResponse {
  /** Number of advanced global entities */
  advancedGlobalUsage?: Maybe<Scalars["Int"]>;
  /** Number of annual customer travel trips */
  annualTravelUsage?: Maybe<Scalars["Int"]>;
  /** Number of domestic (US) users */
  domesticUsage?: Maybe<Scalars["Int"]>;
  /** Number of global users */
  globalUsage?: Maybe<Scalars["Int"]>;
  /** Number of premium users */
  premiumUsage?: Maybe<Scalars["Int"]>;
  /** Number of customer travel trips */
  travelUsage?: Maybe<Scalars["Int"]>;
}

export interface UseDeviceTimezoneInput {
  clientMutationId?: InputMaybe<Scalars["String"]>;
  useDeviceTimezone: Scalars["Boolean"];
}

export enum UsedInUnderwriting {
  NOT_ELIGIBLE = "NOT_ELIGIBLE",
  PENDING = "PENDING",
  USED = "USED",
}

/** Extended Types */
export interface User extends Displayable, ExtensibleEntity, Node {
  account?: Maybe<Account>;
  address?: Maybe<Address>;
  adminHomeSetting?: Maybe<AdminHomeSetting>;
  /** Information regarding the requirements to issue Airwallex card products for this specific user. */
  airwallexCardsRequirements?: Maybe<AirwallexCardsUserRequirements>;
  amsSetting?: Maybe<AmsSetting>;
  /** List all installed apps available to the user */
  appInstallations?: Maybe<AppInstallationConnection>;
  /** The assistant settings for the user. */
  assistantSettings?: Maybe<UserAssistantSetting>;
  birthDate?: Maybe<Scalars["Time"]>;
  /**
   * Whether the user is provisioned to access
   * the Brex dashboard. Purely embedded users
   * (synced from partners like Navan) are not
   * able to log into Brex.
   * @deprecated use brexUserSignIn enum instead
   */
  brexSignIn?: Maybe<Scalars["Boolean"]>;
  /**
   * Whether the user is provisioned to access
   * the Brex dashboard. Purely embedded users
   * (synced from partners like Navan) are not
   */
  brexUserSignIn?: Maybe<BrexUserSignIn>;
  budgetAmountSpentCurrentMonth?: Maybe<FinancialAsset>;
  /**
   * Whether the user has permission to use corporate cards.
   * @deprecated DO NOT USE: use the card permission/operation's resourceType + action instead
   */
  canAccessCorporateCards?: Maybe<Scalars["Boolean"]>;
  /** Get list of user's cards */
  cards?: Maybe<CardConnection>;
  /** The user's communication channels */
  channels?: Maybe<ChannelConnection>;
  /** A value in the [0, 1] range which measures how well this user stays compliant with the policies they spend against. */
  complianceRating?: Maybe<ComplianceRating>;
  /**
   * All copilot relationships for which this user is the delegator.
   * All delegate users in this list can impersonate this user
   * through copilot access.
   */
  copilots?: Maybe<CopilotConnection>;
  /** The cost center the user is associated with. */
  costCenter?: Maybe<CostCenter>;
  /**
   * The phone number of the user's currently active SMS Channel.
   * If more than one active channel is found, the most recent one is returned.
   */
  currentPhoneNumber?: Maybe<Scalars["PhoneNumber"]>;
  /** The custom branding associated with this user at the user, legal entity, or account level */
  customBranding?: Maybe<CustomBranding>;
  /** Default shipping method for card shipping. */
  defaultShippingMethod?: Maybe<ShippingMethod>;
  /**
   * All copilot relationships for which this user is the delegate.
   * All delegator users in this list can be impersonated by this user
   * through copilot access.
   */
  delegators?: Maybe<CopilotConnection>;
  /** Department the user belongs to */
  department?: Maybe<Department>;
  depositsRole?: Maybe<DepositsRole>;
  /** Full name of the user. */
  displayName: Scalars["String"];
  displayRole?: Maybe<UserRoleTypeInput>;
  /** Email of the user. */
  email?: Maybe<Scalars["String"]>;
  /**
   * If partners have connected embedded users
   * to this Brex user, we include the embedded
   * users' attributes in this field.
   */
  embeddedUserDetails?: Maybe<Array<Maybe<EmbeddedUserDetail>>>;
  /** The user's employment status (ACTIVE, INACTIVE, or PENDING) from HRIS integrations */
  employmentStatus?: Maybe<EmploymentStatus>;
  /** Employment type of the user. */
  employmentType?: Maybe<EmploymentType>;
  /** User-friendly value for the user's employment type */
  employmentTypeDisplayValue?: Maybe<Scalars["String"]>;
  extendedFieldInstance?: Maybe<ExtendedFieldInstance>;
  extendedFieldInstances?: Maybe<ExtendedFieldInstanceConnection>;
  /** The extended field values on an user record */
  extendedFieldValues?: Maybe<ExtendedFieldValueConnection>;
  /** The external legal entity the user belongs to if it exists */
  externalLegalEntity?: Maybe<ExternalLegalEntity>;
  /** The first name of the user. */
  firstName?: Maybe<Scalars["String"]>;
  fraudAlerts?: Maybe<FraudAlertConnection>;
  fspUserFirstName?: Maybe<Scalars["String"]>;
  fspUserId?: Maybe<Scalars["String"]>;
  fspUserLastName?: Maybe<Scalars["String"]>;
  /**
   * The assigned FSP role of the user
   * @deprecated Use `fspUserRoles` instead
   */
  fspUserRole?: Maybe<FSPUserRole>;
  fspUserRoles?: Maybe<Array<FSPUserRole>>;
  /**
   * If this user has access to budget cards (not inclusive of user cards)
   * @deprecated DO NOT USE: use the card permission/operation's resourceType + action instead
   */
  hasBudgetCardAccess?: Maybe<Scalars["Boolean"]>;
  /** Whether the user has completed the onboarding flow */
  hasOnboarded?: Maybe<Scalars["Boolean"]>;
  helpshiftAuthToken?: Maybe<Scalars["String"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  /** The time the user was created at. */
  insertedAt?: Maybe<Scalars["Time"]>;
  /** The time the user as invited at. */
  invitedAt?: Maybe<Scalars["Time"]>;
  /** Who or what the user was invited by */
  invitedBy?: Maybe<MutatingActor>;
  /** Whether user is enrolled in the v2_notification_preferences experiment */
  isEnrolledInV2NotificationPreferences?: Maybe<Scalars["Boolean"]>;
  isInitialApplicant?: Maybe<Scalars["Boolean"]>;
  isInvitedDepositsAdmin?: Maybe<Scalars["Boolean"]>;
  isInvitedDepositsCashAndCardUser?: Maybe<Scalars["Boolean"]>;
  /** Whether the user is a manager (has any reports). */
  isManager?: Maybe<Scalars["Boolean"]>;
  isMfaEnabled?: Maybe<Scalars["Boolean"]>;
  /**  This is only used by the mobile app and will be removed in the future. */
  isOktaSso?: Maybe<Scalars["Boolean"]>;
  /** Is the user an Empower customer */
  isPrimitives?: Maybe<Scalars["Boolean"]>;
  /** The user's last mutator's Id */
  lastMutatedById?: Maybe<Scalars["ID"]>;
  /** The user's last mutator's type */
  lastMutatedByType?: Maybe<Scalars["String"]>;
  /** The last name of the user. */
  lastName?: Maybe<Scalars["String"]>;
  /** All active (non-terminal) onboarding applications belonging to the applicant. */
  latestOnboardingApplication?: Maybe<OnboardingApplication>;
  /** If this user has an in-progress email change, the details of that change. */
  latestPendingEmailChange?: Maybe<PendingEmailChange>;
  /** The legal entity the user is associated with. */
  legalEntity?: Maybe<LegalEntity>;
  /** The limit sources that can be used by this user */
  limitSources?: Maybe<LimitSourcesConnection>;
  locale?: Maybe<Locale>;
  /** Location the user belongs to */
  location?: Maybe<Location>;
  /** The user's manager. */
  manager?: Maybe<User>;
  memberedSpendLimits?: Maybe<SpendLimitConnection>;
  mfaPrimaryMethod?: Maybe<MfaPrimaryMethod>;
  /** Mileage setting of a user */
  mileageSetting?: Maybe<MileageSetting>;
  /** The latest onboarding application for this user */
  mostRecentOnboardingApplication?: Maybe<UserApplication>;
  /** Whether the user should be in the product onboarding flow */
  mustSeeProductOnboarding?: Maybe<Scalars["Boolean"]>;
  /**
   * Nested reports for this user
   * @deprecated Use `reportsInformation` for aggregate info, and `reports` for hydrated reports
   */
  nestedReports?: Maybe<UserConnection>;
  notificationSubscriptions?: Maybe<NotificationSubscriptionConnection>;
  /** When the user completed the onboarding flow */
  onboardedAt?: Maybe<Scalars["Time"]>;
  ownedSpendBudgets?: Maybe<SpendBudgetConnection>;
  /** The account-level access summary. */
  permissionsSummary?: Maybe<PermissionsSummary>;
  /** User's primary card */
  primaryCard?: Maybe<Card>;
  /** The products the user has access to. */
  productAccess?: Maybe<Array<UserProductAccess>>;
  /** The user's profile picture, if they have one. */
  profilePicture?: Maybe<Asset>;
  programMembershipsV2?: Maybe<ProgramMembershipV2Connection>;
  referralCode?: Maybe<Scalars["String"]>;
  /**
   * Whether reimbursement feature is available for a user.
   * NOTE: Only run this for unary calls on the current user, it is not performant to run this for > 1 user at a time.
   */
  reimbursementFeatureAvailability?: Maybe<ReimbursementFeatureAvailability>;
  /** ID of this user in the 3rd party HRIS system. */
  remoteId?: Maybe<Scalars["ID"]>;
  /** Information about the hierarchical structure associated with the user. */
  reportsInformation?: Maybe<ReportsInformation>;
  role?: Maybe<Scalars["String"]>;
  /** The account-level role assignments. */
  roleAssignments?: Maybe<Array<AuthRoleAssignment>>;
  seenFlags?: Maybe<Array<Maybe<SeenFlag>>>;
  /** User friendly value for the user's sign in status */
  signInDisplayValue?: Maybe<Scalars["String"]>;
  ssn?: Maybe<Scalars["String"]>;
  ssoStatus?: Maybe<UserSSOStatus>;
  status?: Maybe<Scalars["String"]>;
  /** User-friendly value for the user's status */
  statusDisplayValue?: Maybe<Scalars["String"]>;
  /** User's subscriptions to notification groups */
  subscriptionsV2?: Maybe<SubscriptionV2Connection>;
  /** Suggested shipping address used for card shipping */
  suggestedShippingAddress?: Maybe<Address>;
  timezone?: Maybe<Timezone>;
  /** The user's title. */
  title?: Maybe<Title>;
  travelSupportSessionId?: Maybe<Scalars["String"]>;
  useDeviceTimezone?: Maybe<Scalars["Boolean"]>;
  userLimit?: Maybe<UserLimit>;
  /** The UserRole of the user */
  userRole?: Maybe<UserRole>;
  /** The status of the User. */
  userStatus?: Maybe<UserStatus>;
  /**
   * Upstream sources that the user is synced from.
   * These can include HRIS integrations or
   * partner integrations for embedded finance.
   */
  userSyncSources?: Maybe<Array<Maybe<UserSyncSource>>>;
  /**
   * Indicates if the current user is allowed to impersonate this user
   * through copilot access.
   */
  viewerCanCopilot?: Maybe<Scalars["Boolean"]>;
}

/** Extended Types */
export interface UserappInstallationsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

/** Extended Types */
export interface UsercardsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  binCountries?: InputMaybe<Array<Scalars["String"]>>;
  cardBudgetOwnershipType?: InputMaybe<Array<CardBudgetOwnershipType>>;
  central?: InputMaybe<Scalars["Boolean"]>;
  first?: InputMaybe<Scalars["Int"]>;
  id?: InputMaybe<Array<Scalars["ID"]>>;
  instrumentType?: InputMaybe<InstrumentType>;
  isManagedByPartner?: InputMaybe<Scalars["Boolean"]>;
  isPreapproved?: InputMaybe<Scalars["Boolean"]>;
  last?: InputMaybe<Scalars["Int"]>;
  searchQuery?: InputMaybe<Scalars["String"]>;
  sortBy?: InputMaybe<CardSortColumn>;
  status?: InputMaybe<Array<Scalars["String"]>>;
  statusViews?: InputMaybe<Array<StatusView>>;
}

/** Extended Types */
export interface UserchannelsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filters?: InputMaybe<ChannelFilters>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

/** Extended Types */
export interface UserextendedFieldInstanceArgs {
  id: Scalars["ID"];
}

/** Extended Types */
export interface UserextendedFieldInstancesArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<ExtendedFieldFilterConditionInput>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

/** Extended Types */
export interface UserfraudAlertsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

/** Extended Types */
export interface UserlatestOnboardingApplicationArgs {
  type?: InputMaybe<UserOnboardingBlueprintType>;
}

/** Extended Types */
export interface UserlimitSourcesArgs {
  after?: InputMaybe<Scalars["String"]>;
  filter?: InputMaybe<LimitSourceFilterInput>;
  first?: InputMaybe<Scalars["Int"]>;
}

/** Extended Types */
export interface UsermemberedSpendLimitsArgs {
  filter?: InputMaybe<SpendLimitFilterInput>;
  order?: InputMaybe<SpendLimitOrderInput>;
  page?: InputMaybe<PaginationInput>;
}

/** Extended Types */
export interface UsermileageSettingArgs {
  countryAlpha2?: InputMaybe<Scalars["String"]>;
}

/** Extended Types */
export interface UsernestedReportsArgs {
  filter?: InputMaybe<ReportsFilterInput>;
  maxDepth?: InputMaybe<Scalars["Int"]>;
  page?: InputMaybe<PaginationInput>;
}

/** Extended Types */
export interface UsernotificationSubscriptionsArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

/** Extended Types */
export interface UserownedSpendBudgetsArgs {
  filter?: InputMaybe<SpendBudgetFilterInput>;
  order?: InputMaybe<SpendBudgetOrderInput>;
  page?: InputMaybe<PaginationInput>;
}

/** Extended Types */
export interface UserreportsInformationArgs {
  filter?: InputMaybe<ReportsFilterInput>;
}

/** Extended Types */
export interface UserseenFlagsArgs {
  keys: Array<InputMaybe<SeenFlagKey>>;
}

/** Extended Types */
export interface UsersubscriptionsV2Args {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

/** Extended Types */
export interface UseruserSyncSourcesArgs {
  userSyncSourceType?: InputMaybe<UserSyncSourceType>;
}

/** Temporary type to represent an application started by a user */
export interface UserApplication {
  blueprint: Blueprint;
  createdBy?: Maybe<User>;
  id: Scalars["String"];
  status: UserApplicationStatus;
}

/** Subset of application statuses based on what the user should see. */
export enum UserApplicationStatus {
  APPROVED = "APPROVED",
  CANCELED = "CANCELED",
  PENDING_EVIDENCE = "PENDING_EVIDENCE",
  PENDING_REVIEW = "PENDING_REVIEW",
  /**  error, new, in_progress, processing_approval, and submitted are all mapped to 'processing' */
  PROCESSING = "PROCESSING",
  /**  pending_rejection is mapped to `rejected` */
  REJECTED = "REJECTED",
}

export interface UserAssistantSetting {
  mode: AssistantMode;
  status: AssistantStatus;
}

export enum UserAttributeType {
  /** Map to the GraphQL type `CostCenter` */
  COST_CENTER = "COST_CENTER",
  /** Map to the GraphQL type `Department` */
  DEPARTMENT = "DEPARTMENT",
  /** Map to the GraphQL type `LegalEntity` */
  LEGAL_ENTITY = "LEGAL_ENTITY",
  /** Map to the GraphQL type `Location` */
  LOCATION = "LOCATION",
  /** Map to the GraphQL type `Title` */
  TITLE = "TITLE",
}

/** paginated user categories response */
export interface UserCategoriesPaginated {
  /** page token used for subsequent fetches for paginated user categories */
  nextPageToken?: Maybe<Scalars["String"]>;
  /** Response list of user categories */
  userCategories?: Maybe<Array<Maybe<UserCategory>>>;
}

export interface UserCategory extends Node {
  category?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  integration?: Maybe<Integration>;
  isDeleted?: Maybe<Scalars["Boolean"]>;
  isDisabled?: Maybe<Scalars["Boolean"]>;
  isInactive?: Maybe<Scalars["Boolean"]>;
  merchantCategories?: Maybe<MerchantCategoryConnection>;
  name?: Maybe<Scalars["String"]>;
  parentUserCategory?: Maybe<UserCategory>;
  /** ID reference to parent UserCategory */
  parentUserCategoryId?: Maybe<Scalars["ID"]>;
  /** Category name used by vendor */
  vendorCategory?: Maybe<Scalars["String"]>;
  vendorInternalId?: Maybe<Scalars["String"]>;
}

export interface UserCategorymerchantCategoriesArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
}

export interface UserCategoryConnection {
  edges?: Maybe<Array<Maybe<UserCategoryEdge>>>;
  /** Last updated for all user categories */
  lastUpdatedAt?: Maybe<Scalars["Time"]>;
  pageInfo: PageInfo;
  /** Total number of user categories. */
  totalCount: Scalars["Int"];
}

export interface UserCategoryEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<UserCategory>;
}

export interface UserCategoryExtendedFieldFilterInput {
  /** User category extended field key */
  key: Scalars["String"];
  /** Identifier ids of the user category extended field options to filter by */
  values?: InputMaybe<Array<Scalars["ID"]>>;
}

export interface UserCategoryInput {
  id: Scalars["ID"];
  isDisabled?: InputMaybe<Scalars["Boolean"]>;
}

export interface UserCategoryNameInput {
  /** Category of user category. */
  category: Scalars["String"];
  /** Name of user category. */
  name: Scalars["String"];
  /** Vendor internal id of user category. */
  vendorInternalId: Scalars["String"];
}

/** Filters specific to options with an extension of type UserCategoryOptionExtension */
export interface UserCategoryOptionExtensionFilterInput {
  /** The User Category types to filter by */
  userCategoryTypes?: InputMaybe<Array<UserCategoryType>>;
}

/** The category of the GL accounts */
export enum UserCategoryType {
  /** Assets */
  ASSET = "ASSET",
  BANK_ACCOUNT = "BANK_ACCOUNT",
  BUDGETARY_CREDIT = "BUDGETARY_CREDIT",
  BUDGETARY_DEBIT = "BUDGETARY_DEBIT",
  COST = "COST",
  CREDIT_CARD = "CREDIT_CARD",
  /** Equity */
  EQUITY = "EQUITY",
  /** Expenses */
  EXPENSE = "EXPENSE",
  FIXED_ASSET = "FIXED_ASSET",
  INCOME = "INCOME",
  /** Invalid */
  INVALID = "INVALID",
  /** Liabilities */
  LIABILITY = "LIABILITY",
  /** Other */
  OTHER = "OTHER",
  /** Revenue */
  REVENUE = "REVENUE",
}

export enum UserComplianceRatingCohort {
  COMPLIANCE_RATING_COHORT_HIGH = "COMPLIANCE_RATING_COHORT_HIGH",
  COMPLIANCE_RATING_COHORT_LOW = "COMPLIANCE_RATING_COHORT_LOW",
  COMPLIANCE_RATING_COHORT_MEDIUM = "COMPLIANCE_RATING_COHORT_MEDIUM",
}

/** The allowed attributes for user conditions */
export enum UserConditionAttributeType {
  COST_CENTER = "COST_CENTER",
  DEPARTMENT = "DEPARTMENT",
  LEGAL_ENTITY = "LEGAL_ENTITY",
  LOCATION = "LOCATION",
  MANAGER = "MANAGER",
  TITLE = "TITLE",
}

/** The comparison operator for user condition filtering on unary conditions */
export enum UserConditionComparisonOperator {
  EQ = "EQ",
  NE = "NE",
}

/** The user condition */
export interface UserConditionInput {
  compositeCondition?: InputMaybe<CompositeConditionInput>;
  conditionType: UserConditionType;
  unaryCondition?: InputMaybe<UnaryConditionInput>;
}

/** The logical operator for user condition filtering on composite conditions */
export enum UserConditionLogicalOperator {
  AND = "AND",
  OR = "OR",
}

/** The condition type for the user condition clause */
export enum UserConditionType {
  COMPOSITE_CONDITION = "COMPOSITE_CONDITION",
  UNARY_CONDITION = "UNARY_CONDITION",
}

/** User connection for pagination */
export interface UserConnection extends Connection {
  /**
   * This field must be included as it is present in the hierarchies schema.
   * @deprecated This is a legacy APIv1 field. Use totalCount instead.
   */
  count?: Maybe<Scalars["Int"]>;
  /** The items in the current page of results. */
  edges?: Maybe<Array<Maybe<UserEdge>>>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of items, across all pages, matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

/** User edge for the User connection. */
export interface UserEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The item at this edge. */
  node?: Maybe<User>;
}

export interface UserError {
  description: Scalars["String"];
  user?: Maybe<User>;
  userId: Scalars["ID"];
}

/** Relevant information to display to users when reviewing Expenses. */
export interface UserExpenseReviewTask {
  expense: Expense;
}

/** Extended field values to update for a User */
export interface UserExtendedFieldValueInput {
  key: Scalars["String"];
  value?: InputMaybe<UserIdentifierToStringValueInput>;
}

/** The available fields that are queryable that relate to users */
export enum UserFieldKeyType {
  ALL = "ALL",
  COMPLIANCE_RATING_COHORT = "COMPLIANCE_RATING_COHORT",
  FIRST_NAME = "FIRST_NAME",
  FULL_NAME = "FULL_NAME",
  LAST_NAME = "LAST_NAME",
}

export interface UserFieldKeyTypeWrapper {
  key: UserFieldKeyType;
}

/** Filters for the user entity. */
export interface UserFieldMatcherInput {
  complianceRatingCohort?: InputMaybe<UserComplianceRatingCohort>;
  complianceRatingCohorts?: InputMaybe<Array<UserComplianceRatingCohort>>;
  /**
   * Fuzzy search by user first and last name. This only includes results that the user's full name contains specified
   * search substring. The returned results are sorted by similarity.
   */
  userNameSearch?: InputMaybe<Scalars["String"]>;
}

/**
 * Filters for list users query. Records returned will match ALL filters.
 * Keep in sync with Task Manager DGS, which also defines this type.
 */
export interface UserFilterInput {
  access?: InputMaybe<Array<UserProductAccess>>;
  adminRoleFilter?: InputMaybe<AdminRoleFilter>;
  brexUserSignInValues?: InputMaybe<Array<BrexUserSignIn>>;
  capabilityKeyFilter?: InputMaybe<Array<AuthCapabilityKey>>;
  costCenterIds?: InputMaybe<Array<Scalars["ID"]>>;
  departmentIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Employment statuses from HRIS integrations */
  employmentStatuses?: InputMaybe<Array<EmploymentStatus>>;
  employmentStatusesOperator?: InputMaybe<QueryListOperator>;
  extendedFieldValuesFilter?: InputMaybe<Array<ExtendedFieldValuesFilterInput>>;
  identifiers?: InputMaybe<Array<UserIdentifier>>;
  /**
   * If true, integration users will be included in result
   * If false or null, integration users will be excluded in result
   */
  includeIntegrationUsers?: InputMaybe<Scalars["Boolean"]>;
  legalEntityIds?: InputMaybe<Array<Scalars["ID"]>>;
  locationIds?: InputMaybe<Array<Scalars["ID"]>>;
  managerIdentifiers?: InputMaybe<Array<UserIdentifier>>;
  roleIdFilters?: InputMaybe<Array<RoleIdFilterInput>>;
  /** Searches on first name, last name, and email */
  searchText?: InputMaybe<Scalars["String"]>;
  titleIds?: InputMaybe<Array<Scalars["ID"]>>;
  userRoles?: InputMaybe<Array<UserRole>>;
  userStatuses?: InputMaybe<Array<UserStatus>>;
  userSyncSourceFilters?: InputMaybe<Array<UserSyncSourceFilterInput>>;
}

export interface UserGroupConditionOptionsSearchResultEdge {
  cursor?: Maybe<Scalars["String"]>;
  node: UserGroupOptionsSearchResult;
}

/**
 * UserGroupInput, used for both create and update mutations
 * Display name and status will be defined by the budgets service as it is not a public group.
 * For updates, resource it is attached to will be used to fetch the group to be updated (i.e. SPEND_LIMIT and spendLimitId).
 */
export interface UserGroupInput {
  memberCondition?: InputMaybe<MemberConditionInput>;
  members?: InputMaybe<Array<GroupMemberInput>>;
  syncType?: InputMaybe<GroupSyncType>;
}

export interface UserGroupOptionsCostCenterSearchResult {
  employeeCount: Scalars["Int"];
  id: Scalars["ID"];
  name: Scalars["String"];
}

export interface UserGroupOptionsDepartmentSearchResult {
  employeeCount: Scalars["Int"];
  id: Scalars["ID"];
  name: Scalars["String"];
}

export interface UserGroupOptionsFilterInput {
  searchText?: InputMaybe<UserGroupOptionsFilterStringInput>;
  types: UserGroupOptionsFilterTypeInput;
}

export interface UserGroupOptionsFilterStringInput {
  contains: Scalars["String"];
}

/** Specify exactly one of `in` or `notIn`. `notIn` with an empty list returns all types. */
export interface UserGroupOptionsFilterTypeInput {
  in?: InputMaybe<Array<UserGroupOptionsType>>;
  notIn?: InputMaybe<Array<UserGroupOptionsType>>;
}

export interface UserGroupOptionsLegalEntitySearchResult {
  employeeCount: Scalars["Int"];
  id: Scalars["ID"];
  name: Scalars["String"];
}

export interface UserGroupOptionsLocationSearchResult {
  employeeCount: Scalars["Int"];
  id: Scalars["ID"];
  name: Scalars["String"];
}

export interface UserGroupOptionsManagerSearchResult {
  employeeCount: Scalars["Int"];
  id: Scalars["ID"];
  name: Scalars["String"];
}

export interface UserGroupOptionsRoleSearchResult {
  id: Scalars["ID"];
  name: Scalars["String"];
}

export type UserGroupOptionsSearchResult =
  | CustomFieldValue
  | UserGroupOptionsCostCenterSearchResult
  | UserGroupOptionsDepartmentSearchResult
  | UserGroupOptionsLegalEntitySearchResult
  | UserGroupOptionsLocationSearchResult
  | UserGroupOptionsManagerSearchResult
  | UserGroupOptionsRoleSearchResult
  | UserGroupOptionsTitleSearchResult
  | UserGroupOptionsUserSearchResult;

export interface UserGroupOptionsSearchResultConnection extends Connection {
  edges: Array<UserGroupConditionOptionsSearchResultEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"];
}

export interface UserGroupOptionsTitleSearchResult {
  employeeCount: Scalars["Int"];
  id: Scalars["ID"];
  name: Scalars["String"];
}

export enum UserGroupOptionsType {
  COST_CENTER = "COST_CENTER",
  CUSTOM_FIELD = "CUSTOM_FIELD",
  DEPARTMENT = "DEPARTMENT",
  LEGAL_ENTITY = "LEGAL_ENTITY",
  LOCATION = "LOCATION",
  MANAGER = "MANAGER",
  ROLE = "ROLE",
  TITLE = "TITLE",
  USER = "USER",
}

export interface UserGroupOptionsUserSearchResult {
  user: User;
}

export interface UserIdentifier {
  aggregatorId?: InputMaybe<Scalars["ID"]>;
  email?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["ID"]>;
  remoteId?: InputMaybe<Scalars["ID"]>;
  type: UserIdentifierType;
}

export interface UserIdentifierToStringValueInput {
  displayName: Scalars["String"];
  encodedIdentifier: Scalars["String"];
}

export enum UserIdentifierType {
  AGGREGATOR_ID = "AGGREGATOR_ID",
  EMAIL = "EMAIL",
  ID = "ID",
  REMOTE_ID = "REMOTE_ID",
}

/** Available filter to find users by join time relative to a spend limit group */
export enum UserInvitationFilter {
  ALL = "ALL",
  CURRENT = "CURRENT",
  FUTURE = "FUTURE",
}

/**
 * An user limit controls and restricts user expenditures, making sure they stay within periodic thresholds. Each user
 * should have an user limit as soon as their account is created.
 */
export interface UserLimit extends LimitSource, Node {
  /**
   * The Customer Account
   * Nullable to support partial failure
   */
  account?: Maybe<Account>;
  /** List of limit increases currently applied to the user limit. */
  activeLimitIncreases?: Maybe<Array<LimitSourceIncrease>>;
  /** A list of operations that the user can perform on the user limit */
  allowedOperations?: Maybe<Array<UserLimitOperationPermission>>;
  /**
   * The amount spent on the user limit for the current period
   * @deprecated Use spent
   */
  amountSpent: FinancialAsset;
  /** The exact settings that govern authorizations. */
  authSettings?: Maybe<AuthorizationSettings>;
  /** The ID of the user limit's customer user */
  customerUserId: Scalars["ID"];
  /** The ID of an object */
  id: Scalars["ID"];
  /** Override that associates all transactions to this legal entity instead of the default */
  legalEntity?: Maybe<LegalEntity>;
  /**
   * Limit of the user limit
   * @deprecated use AuthorizationSettings
   */
  limit: FinancialAsset;
  /** The exact settings that govern whether users can request for limit changes */
  limitChangeSettings?: Maybe<LimitChangeSettings>;
  /** Name of the user limit */
  name: Scalars["String"];
  /** List of limit source increase requests associated with this user limit that are pending review. */
  pendingLimitIncreaseRequests?: Maybe<Array<LimitSourceIncreaseRequest>>;
  /**
   * The recurring period type of the user limit
   * @deprecated use AuthorizationSettings
   */
  periodType: AuthorizationLimitPeriodType;
  /** The policy used for authorizing spend. This is the default expense policy for the account */
  policy?: Maybe<Policy>;
  /**
   * The remaining limit for the current period
   * @deprecated use AuthorizationSettings
   */
  remainingLimit: FinancialAsset;
  /** Defines if the user limit is spendable. Will validate both limit configuration and user permissions */
  spendable: Scalars["Boolean"];
  /** Amount spent in the period defined by the reset frequency */
  spent?: Maybe<FinancialAsset>;
  /** The timezone of this user limit */
  timezone?: Maybe<Scalars["String"]>;
  /** User whom this limit belongs to */
  user: User;
  /** Amount spent by the requesting user in the period defined by the reset frequency */
  userSpent?: Maybe<FinancialAsset>;
}

/**
 * An user limit controls and restricts user expenditures, making sure they stay within periodic thresholds. Each user
 * should have an user limit as soon as their account is created.
 */
export interface UserLimitallowedOperationsArgs {
  operations: Array<UserLimitOperation>;
}

export interface UserLimitAssignmentInsufficientLimitError {
  /** Whether the user has the capabilities to assign the expense and override the insufficient limit error, this is true for the case of admins, and false otherwise. */
  canOverride: Scalars["Boolean"];
  customerUserId: Scalars["ID"];
  /** The amount on the expense */
  expenseAmount: FinancialAsset;
  limitAmount?: Maybe<FinancialAsset>;
  overLimitAmount?: Maybe<FinancialAsset>;
}

/** An UserLimit connection for UserLimit pagination. */
export interface UserLimitConnection extends Connection {
  /** The user limits in the current page of results. */
  edges: Array<UserLimitEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of user limits matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

/** Display representation of a user limit that implements the basic limit functionality */
export interface UserLimitDisplayLimit extends DisplayLimit {
  /** Amount spent against this limit */
  amountSpent?: Maybe<FinancialAsset>;
  /** Ordered list of ancestors - Will be empty for user limits */
  ancestryPath: Array<SpendBudgetDisplayLimit>;
  /** Logical ID - The cuUserId for this user limit */
  id: Scalars["ID"];
  /** Name of the limit */
  name: Scalars["String"];
  /** The type of limit this represents */
  type: DisplayLimitType;
}

/** An User Limit edge for the User Limit connection. */
export interface UserLimitEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The user limit at this edge. */
  node?: Maybe<UserLimit>;
}

export interface UserLimitFilterInput {
  /** Search user limits by the customer user ids */
  customerUserIds?: InputMaybe<Array<Scalars["ID"]>>;
}

export interface UserLimitMutationError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export enum UserLimitOperation {
  /** Directly update the user limit */
  EDIT_FULL = "EDIT_FULL",
  /** Edit the current pending request for the user limit increase */
  EDIT_LIMIT_INCREASE_REQUEST = "EDIT_LIMIT_INCREASE_REQUEST",
  /** Request limit increase for the user limit */
  REQUEST_LIMIT_INCREASE = "REQUEST_LIMIT_INCREASE",
  /** View the policy for user limit */
  VIEW_POLICY = "VIEW_POLICY",
}

export interface UserLimitOperationPermission {
  allowed: Scalars["Boolean"];
  disabledReason?: Maybe<Array<Scalars["String"]>>;
  operation: UserLimitOperation;
}

export interface UserListRule {
  enabled: Scalars["Boolean"];
  users?: Maybe<Array<User>>;
}

/** How a given connection should sync employees and, optionally onboard or offboard Brex users. */
export interface UserManagementSettings {
  /** How to manage the auto-offboarding of users, if at all. */
  autoOffboardSetting?: Maybe<AutoOffboardSetting>;
  /** How to manage the auto-onboarding of users, if at all. */
  autoOnboardSetting?: Maybe<AutoOnboardSetting>;
  /** Created setting's HRIS connection id */
  connectionId: Scalars["ID"];
  /** Which kind of employees to manage. */
  employmentTypes?: Maybe<Array<HrisEmploymentType>>;
  /** Created setting's id */
  id: Scalars["ID"];
}

/** UsersMessageInfo will contain all infos for dedicated agents. */
export interface UserMessageInfo {
  /** `assetFileIds` is a list of asset file ids that are associated with the message */
  assetFileIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** `expenseAssistantInfo` is a field object which will contain Expense Assistant fields */
  expenseAssistantInfo?: InputMaybe<ExpenseAssistantInfo>;
  /** `policyQAInfo` is a field object which will contain Policy Q&A fields */
  policyQAInfo?: InputMaybe<PolicyQAInfo>;
}

/** Applications which belong to a specific user, rather than an account */
export enum UserOnboardingBlueprintType {
  /** Applications to change the user's cash role */
  CHANGE_ROLE = "CHANGE_ROLE",
  /** Onboarding flows to set up a user's account */
  USER_SETUP = "USER_SETUP",
}

export enum UserProductAccess {
  BILL_PAY_APPROVER = "BILL_PAY_APPROVER",
  BILL_PAY_DRAFTER = "BILL_PAY_DRAFTER",
  CARD_ACCESS = "CARD_ACCESS",
  EMPLOYEE_CARD_USER = "EMPLOYEE_CARD_USER",
  LIMIT_CARD_USER = "LIMIT_CARD_USER",
  PHYSICAL_CARD_USER = "PHYSICAL_CARD_USER",
  PURCHASING_CARD_USER = "PURCHASING_CARD_USER",
  REIMBURSEMENT_ACCESS = "REIMBURSEMENT_ACCESS",
  SPEND_LIMIT_CARD_USER = "SPEND_LIMIT_CARD_USER",
  TRAVEL_ADMIN = "TRAVEL_ADMIN",
  TRAVEL_USER = "TRAVEL_USER",
  TRAVEL_VIP_USER = "TRAVEL_VIP_USER",
  VIRTUAL_CARD_USER = "VIRTUAL_CARD_USER",
}

export enum UserResourceAttribute {
  ADMIN = "ADMIN",
  ADMIN_DETAILS = "ADMIN_DETAILS",
  ADMIN_ROLE = "ADMIN_ROLE",
  ADMIN_STATUS = "ADMIN_STATUS",
  ATTRIBUTE = "ATTRIBUTE",
  BILL_PAY_ACCESS = "BILL_PAY_ACCESS",
  BILL_PAY_ACESSS = "BILL_PAY_ACESSS",
  COPILOT = "COPILOT",
  MFA_RESET = "MFA_RESET",
  NON_ADMIN = "NON_ADMIN",
  NON_ADMIN_DETAILS = "NON_ADMIN_DETAILS",
  NON_ADMIN_ROLE = "NON_ADMIN_ROLE",
  NON_ADMIN_STATUS = "NON_ADMIN_STATUS",
  ONBOARDING_APPLICATION = "ONBOARDING_APPLICATION",
  PENDING_EMAIL_CHANGE = "PENDING_EMAIL_CHANGE",
  PHYSICAL_CARD_ACCESS = "PHYSICAL_CARD_ACCESS",
  ROLE = "ROLE",
  SPREADSHEET_EXPORT = "SPREADSHEET_EXPORT",
  SPREADSHEET_IMPORT = "SPREADSHEET_IMPORT",
  STATUS = "STATUS",
  TRAVEL_ACCESS = "TRAVEL_ACCESS",
  TRAVEL_ADMIN_ACCESS = "TRAVEL_ADMIN_ACCESS",
  USER_ATTRIBUTE = "USER_ATTRIBUTE",
}

export interface UserResourceOperation extends ResourceOperation {
  action: ResourceAction;
  attribute?: Maybe<UserResourceAttribute>;
}

/** An instance of a UserReviewTask. */
export interface UserReviewTask {
  /** The unique ID of the UserReviewTask. */
  id: Scalars["ID"];
  /** When the UserReviewTask was inserted */
  insertedAt: Scalars["Time"];
  /** The status of the UserReviewTask. */
  status: UserReviewTaskStatus;
  /** When the UserReviewTask was updated */
  updatedAt: Scalars["Time"];
  /** Relevant information to display in the UI depending on the UserReviewTaskType. */
  userReviewTaskCase: UserReviewTaskCase;
}

/** User Review Task Case union. */
export type UserReviewTaskCase = UserExpenseReviewTask;

/** An UserReviewTaskConnection connection for UserReviewTask pagination. */
export interface UserReviewTaskConnection extends Connection {
  /** The UserReviewTasks in the current page of results. */
  edges: Array<UserReviewTaskEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of UserReviewTasks matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

/** A UserReviewTask edge for the UserReviewTask connection. */
export interface UserReviewTaskEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The UserReviewTask at this edge. */
  node?: Maybe<UserReviewTask>;
}

/** The result of a UserReviewTask submission. */
export interface UserReviewTaskOutcome {
  /** The status to set the UserReviewTask to. Must be CONFIRMED or DISMISSED. */
  status: UserReviewTaskStatus;
  /** The ID of the UserReviewTask to submit. */
  userReviewTaskId: Scalars["ID"];
}

/** The result of a UserReviewTask submission. */
export interface UserReviewTaskOutcomeResult {
  /** The status that the UserReviewTask was set to. Will be CONFIRMED or DISMISSED. */
  status: UserReviewTaskStatus;
  /** The ID of the UserReviewTask that was submitted. */
  userReviewTaskId: Scalars["ID"];
}

/** The status of the UserReviewTask. */
export enum UserReviewTaskStatus {
  /** Confirmed as fraudulent. */
  CONFIRMED = "CONFIRMED",
  /** Dismissed as non-fraudulent. */
  DISMISSED = "DISMISSED",
  /** Not reviewed yet. */
  PENDING = "PENDING",
}

/** The type of the UserReviewTask. */
export enum UserReviewTaskType {
  /** A card expense review. */
  EXPENSE_REVIEW = "EXPENSE_REVIEW",
}

/** Filters available to control which user review tasks get returned. */
export interface UserReviewTasksFilterInput {
  /** Match IN specific statuses, match ALL when no filter is provided */
  statuses?: InputMaybe<Array<UserReviewTaskStatus>>;
  /** Match IN specific types, match ALL when no filter is provided */
  types?: InputMaybe<Array<UserReviewTaskType>>;
}

/** Inputs for listing user review tasks. */
export interface UserReviewTasksInput {
  filter?: InputMaybe<UserReviewTasksFilterInput>;
  page?: InputMaybe<PaginationInput>;
}

/**  Note: shadowed in HRIS-DGS and Budgets-DGS. If adding a case, add in both places. */
export enum UserRole {
  ACCOUNT_ADMIN = "ACCOUNT_ADMIN",
  AP_CLERK = "AP_CLERK",
  BOOKKEEPER = "BOOKKEEPER",
  CARD_ADMIN = "CARD_ADMIN",
  EMPLOYEE = "EMPLOYEE",
  EMPLOYEE_WITHOUT_CORP_CARDS = "EMPLOYEE_WITHOUT_CORP_CARDS",
  /** @deprecated No longer supported */
  EXPENSE_ADMIN = "EXPENSE_ADMIN",
  /** @deprecated No longer supported */
  SUPER_ADMIN = "SUPER_ADMIN",
  USER_MANAGEMENT_ADMIN = "USER_MANAGEMENT_ADMIN",
}

export interface UserRoleAssignmentError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
  userId?: Maybe<Scalars["ID"]>;
}

export interface UserRoleTarget {
  userRole?: Maybe<ApprovalChainUserRole>;
}

/**
 * DEPRECATED, DO NOT USE
 * This is ported from APIv1 to allow us to migrate the list users API.
 */
export enum UserRoleTypeInput {
  /** an admin is a card-only admin */
  ADMIN = "ADMIN",
  /** this is card and cash bookkeeper */
  BOOKKEEPER = "BOOKKEEPER",
  /** this is a card regular user and cash user role */
  CASH_AND_CARD_USER = "CASH_AND_CARD_USER",
  /** this is a card-only regular user */
  REGULAR = "REGULAR",
  /** a superadmin is a cash admin and card admin */
  SUPERADMIN = "SUPERADMIN",
}

export interface UserSSOStatus {
  enabled: Scalars["Boolean"];
  issuer?: Maybe<Scalars["String"]>;
}

export interface UserSetting {
  /** Monthly limit for the employee in cents. */
  monthlyLimitAmount?: InputMaybe<FinancialAssetInput>;
  /** Role that employees will be invited as */
  role?: InputMaybe<UserRole>;
}

/** Specifies the sort order for a particular field */
export interface UserSortOrder {
  field: UserSortableFields;
  order: QuerySortOrder;
}

/** Specifies which fields on the User entity can be sorted on */
export enum UserSortableFields {
  FIRST_NAME = "FIRST_NAME",
  LAST_NAME = "LAST_NAME",
}

export enum UserSpreadsheetColumn {
  ACCESS = "ACCESS",
  CARD_ACCESS = "CARD_ACCESS",
  COPILOT = "COPILOT",
  COST_CENTER = "COST_CENTER",
  DEPARTMENT = "DEPARTMENT",
  EMAIL = "EMAIL",
  EMPLOYMENT_TYPE = "EMPLOYMENT_TYPE",
  FIRST_NAME = "FIRST_NAME",
  LAST_NAME = "LAST_NAME",
  LEGAL_ENTITY = "LEGAL_ENTITY",
  LOCATION = "LOCATION",
  MANAGER = "MANAGER",
  MONTHLY_SPEND = "MONTHLY_SPEND",
  REIMBURSEMENT_ACCESS = "REIMBURSEMENT_ACCESS",
  ROLE = "ROLE",
  SIGN_IN = "SIGN_IN",
  STATUS = "STATUS",
  SYNCED = "SYNCED",
  TITLE = "TITLE",
}

export interface UserSpreadsheetExportInput {
  columns?: InputMaybe<Array<UserSpreadsheetColumn>>;
  /** Additional dynamic columns for extended fields */
  extendedFieldIds?: InputMaybe<Array<Scalars["String"]>>;
  filter?: InputMaybe<UserFilterInput>;
}

export interface UserSpreadsheetExportResponse {
  assetId: Scalars["ID"];
}

/** User Spreadsheet Import request */
export interface UserSpreadsheetImportInput {
  /** File ID of the CSV upload. */
  assetId: Scalars["String"];
}

/** User Spreadsheet Import request */
export interface UserSpreadsheetImportRequest {
  /** File ID of the CSV upload. */
  assetId: Scalars["String"];
}

export interface UserSpreadsheetImportResponse {
  errors?: Maybe<Array<SpreadsheetError>>;
  numUsersCreated: Scalars["Int"];
  numUsersUpdated: Scalars["Int"];
}

export enum UserStatus {
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
  DELETED = "DELETED",
  DISABLED = "DISABLED",
  INACTIVE = "INACTIVE",
  INVITED = "INVITED",
  PENDING_ACTIVATION = "PENDING_ACTIVATION",
}

export enum UserStatusFilterInput {
  ACTIVE = "ACTIVE",
  DELETED = "DELETED",
  DISABLED = "DISABLED",
  INACTIVE = "INACTIVE",
  INVITED = "INVITED",
  PENDING_ACTIVATION = "PENDING_ACTIVATION",
}

export interface UserSyncSource {
  displayName: Scalars["String"];
  slug: Scalars["String"];
  sourceType: UserSyncSourceType;
}

export interface UserSyncSourceFilterInput {
  slug: Scalars["String"];
  sourceType: UserSyncSourceType;
}

export enum UserSyncSourceType {
  HRIS = "HRIS",
  PARTNER = "PARTNER",
}

/** The user properties that can be changed in bulk by passing a filter. Only provided values will be updated. */
export interface UserUpdateByFilterInput {
  /** The role to assign. */
  role?: InputMaybe<UserRole>;
  /** The new status of the User. */
  userStatus?: InputMaybe<UserStatus>;
}

export interface UserUpdateInput {
  /** The new aggregatorId for the employee. */
  aggregatorId?: InputMaybe<Scalars["ID"]>;
  /** The new costCenterId for the employee. */
  costCenterId?: InputMaybe<Scalars["ID"]>;
  /** The new departmentId for the employee. */
  departmentId?: InputMaybe<Scalars["ID"]>;
  /** The new employment status for the employee. */
  employmentStatus?: InputMaybe<EmploymentStatus>;
  /** The new employment type for the employee. */
  employmentType?: InputMaybe<EmploymentType>;
  /** Extended field values for the employee. */
  extendedFieldValues?: InputMaybe<Array<UserExtendedFieldValueInput>>;
  /** The new first name for the employee. */
  firstName?: InputMaybe<Scalars["String"]>;
  /** The cuuser_id or emp_id of the User to update. */
  id: Scalars["ID"];
  /** The new last name for the employee. */
  lastName?: InputMaybe<Scalars["String"]>;
  /** The new legalEntityId for the employee. */
  legalEntityId?: InputMaybe<Scalars["ID"]>;
  /** The new locationId for the employee. */
  locationId?: InputMaybe<Scalars["ID"]>;
  /** The new manager reference for the employee. */
  managerIdentifier?: InputMaybe<UserIdentifier>;
  /** Product access role changes for the employee. */
  productAccess?: InputMaybe<UserUpdateProductAccessInput>;
  /** The new remoteDisplayId for the employee. */
  remoteDisplayId?: InputMaybe<Scalars["ID"]>;
  /** The new remoteId for the employee. */
  remoteId?: InputMaybe<Scalars["ID"]>;
  /** The new role for the employee. */
  role?: InputMaybe<UserRole>;
  /** The new titleId for the employee. */
  titleId?: InputMaybe<Scalars["ID"]>;
}

/** Type of product access change */
export enum UserUpdateProductAccessEditType {
  ADD = "ADD",
  REMOVE = "REMOVE",
}

/** Product access to update for a User */
export interface UserUpdateProductAccessInput {
  editType: UserUpdateProductAccessEditType;
  productAccess: UserProductAccess;
}

export interface ValidateActivation {
  active: Scalars["Boolean"];
  ssoIssuer?: Maybe<Scalars["String"]>;
}

export interface ValidateChequeImagesInput {
  amountUsdCents: Scalars["Int"];
  attemptNumber: Scalars["Int"];
  backImageAssetId?: InputMaybe<Scalars["ID"]>;
  clientMutationId: Scalars["String"];
  depositsAccountId: Scalars["ID"];
  frontImageAssetId?: InputMaybe<Scalars["ID"]>;
  validationType?: InputMaybe<ChequeImageValidationType>;
}

export interface ValidateChequeImagesPayload {
  clientMutationId: Scalars["String"];
  errorReason?: Maybe<Scalars["String"]>;
  errorSeverity?: Maybe<ChequeImageValidationErrorSeverity>;
  passedValidation: Scalars["Boolean"];
}

export interface ValidateEmailInput {
  clientMutationId: Scalars["String"];
  email: Scalars["Email"];
}

export interface ValidateEmailPayload {
  clientMutationId: Scalars["String"];
  valid: Scalars["Boolean"];
}

export interface ValidateMicroDepositsAmountsError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface ValidateMicroDepositsAmountsInput {
  firstAmount: Scalars["Decimal"];
  idempotencyKey: Scalars["String"];
  railAccountDetailsId: Scalars["ID"];
  secondAmount: Scalars["Decimal"];
  userId: Scalars["ID"];
}

export interface ValidateMicroDepositsAmountsResult extends MutationResult {
  errors?: Maybe<Array<ValidateMicroDepositsAmountsError>>;
  result?: Maybe<RailAccountDetailsVerification>;
}

export interface ValidateSmsInput {
  clientMutationId: Scalars["String"];
  number: Scalars["PhoneNumber"];
}

export interface ValidateSmsPayload {
  clientMutationId: Scalars["String"];
  valid: Scalars["Boolean"];
}

export interface ValidateValueRulesForDependencyCsvInput {
  /** Asset ID of the CSV in file store to validate as value rules for dependencies */
  assetId: Scalars["ID"];
}

/** Response of validating value rules for dependency CSV result */
export interface ValidateValueRulesForDependencyCsvResult
  extends MutationResult {
  errors?: Maybe<Array<ValueRulesForDependencyMutationError>>;
  valueRuleDependencyHeaders: Array<ValueRuleDependencyHeader>;
  valueRuleDependencyRows: Array<ValueRuleDependencyRow>;
}

export interface ValidateVerificationError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface ValidateVerificationInput {
  idempotencyKey: Scalars["String"];
  /**  No eGIRO input specified as no input is required */
  microDepositsValidation?: InputMaybe<MicroDepositsValidationInput>;
  railAccountDetailsId: Scalars["ID"];
  type: RailAccountDetailsVerificationType;
  userId: Scalars["ID"];
}

export interface ValidateVerificationResult extends MutationResult {
  errors?: Maybe<Array<ValidateVerificationError>>;
  result?: Maybe<RailAccountDetailsVerification>;
}

/** Validation results of a payment instrument */
export interface ValidatedPaymentInstrument {
  /** Fields of a payment instrument that are valid or not (boolean) */
  fields?: Maybe<Scalars["Json"]>;
  /** Enum whether the overall payment instrument is valid */
  isValid?: Maybe<Scalars["Boolean"]>;
}

/** Response that encapsulates the original contact input and its validation result */
export interface ValidatedVendorContactInput extends Node {
  /** Original contact input */
  data: VendorContactInputData;
  /** The ID of an object */
  id: Scalars["ID"];
  /** Validation for the contact input */
  validation: VendorContactInputValidation;
}

export interface ValidatedVendorContactInputConnection {
  edges?: Maybe<Array<Maybe<ValidatedVendorContactInputEdge>>>;
  pageInfo: PageInfo;
}

export interface ValidatedVendorContactInputEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<ValidatedVendorContactInput>;
}

export interface ValueAddSuggestion {
  /** Recommendation CTA body */
  body?: Maybe<Scalars["String"]>;
  /** Recommendation asset image url */
  imageUrl?: Maybe<Scalars["String"]>;
  /** Recommendation enablement status type */
  status: SuggestionEnablementStatusType;
  /** Recommendation CTA summary */
  summary?: Maybe<Scalars["String"]>;
  /** Recommendation CTA title */
  title?: Maybe<Scalars["String"]>;
  /** Recommendation CTA type */
  type: ValueAddSuggestionType;
}

/** Enum type for value add suggestions. */
export enum ValueAddSuggestionType {
  ACCOUNTING_AUTOMATION = "ACCOUNTING_AUTOMATION",
  ADD_BOOKKEEPER_ROLE = "ADD_BOOKKEEPER_ROLE",
  ASSISTANT = "ASSISTANT",
  AUTO_RECEIPTS = "AUTO_RECEIPTS",
  BILL_PAY = "BILL_PAY",
  CREATE_POLICY = "CREATE_POLICY",
  DEADLINE = "DEADLINE",
  DEPOSIT_CASH = "DEPOSIT_CASH",
  GMAIL_INTEGRATION = "GMAIL_INTEGRATION",
  REDEEM_REWARDS = "REDEEM_REWARDS",
  SLACK = "SLACK",
  SYNC_ERP = "SYNC_ERP",
  SYNC_HRIS = "SYNC_HRIS",
  UBER_LYFT_INTEGRATION = "UBER_LYFT_INTEGRATION",
  VENDOR_MIGRATION = "VENDOR_MIGRATION",
}

export interface ValueAddedServicePayloadV2 {
  vasOfferPayload: VasOfferPayloadV2;
}

export interface ValueMetric {
  /** Benchmark value for this metric. e.g. That's higher than 90% of similar companies */
  benchMarkValue?: Maybe<Scalars["String"]>;
  /** Benchmark value sentiment for this metric. */
  benchMarkValueSentiment?: Maybe<ValueSentimentType>;
  /** Category of the metric */
  category?: Maybe<MetricCategoryType>;
  /** Detailed child metrics, recursive format. */
  detailedValueMetrics?: Maybe<Array<ValueMetric>>;
  /** Explanation for the metric calculation. */
  explanation?: Maybe<MetricsIndividualExplanation>;
  /** Additional value for the metric, e.g. 1% cash back rate shown next to cash back dollar amount. */
  extraValue?: Maybe<MetricValue>;
  /** Fallback value when metric value is empty. e.g. Potential values customers are missing. */
  fallbackValue?: Maybe<MetricValue>;
  /** Graph of the metric */
  metricsGraph?: Maybe<MetricsGraph>;
  /** Detailed tabular view for this metric. e.g. top 5 employees with most out of policy spend */
  metricsTable?: Maybe<MetricsTable>;
  /** SubTitle of the metric */
  subTitle?: Maybe<Scalars["String"]>;
  /** Title of the metric */
  title: Scalars["String"];
  /** Trend value for the metric over a given time. e.g. month over month of spend out of policy has increased 1.4%. */
  trendValue?: Maybe<MetricValue>;
  /** Value of the metric, including string value and the unit */
  value?: Maybe<MetricValue>;
  /** Suggestions to help customers get additional value from Brex given the current metric value. */
  valueAddSuggestions?: Maybe<Array<ValueAddSuggestion>>;
}

/** Enum type for value metrics range. */
export enum ValueMetricsDateRangeType {
  APRIL = "APRIL",
  AUGUST = "AUGUST",
  DECEMBER = "DECEMBER",
  FEBRUARY = "FEBRUARY",
  JANUARY = "JANUARY",
  JULY = "JULY",
  JUNE = "JUNE",
  LAST_6_MONTHS = "LAST_6_MONTHS",
  LAST_12_MONTHS = "LAST_12_MONTHS",
  LAST_30_DAYS = "LAST_30_DAYS",
  LAST_MONTH = "LAST_MONTH",
  LAST_QUARTER = "LAST_QUARTER",
  MARCH = "MARCH",
  MAY = "MAY",
  NOVEMBER = "NOVEMBER",
  OCTOBER = "OCTOBER",
  SEPTEMBER = "SEPTEMBER",
  THIS_MONTH = "THIS_MONTH",
  THIS_QUARTER = "THIS_QUARTER",
}

export type ValueOriginator = ValueOriginatorAutomation | ValueOriginatorUser;

export interface ValueOriginatorAutomation {
  /**  A placeholder dummy field for now, need to determine how to best represent this later, depending on automated processes */
  _?: Maybe<Scalars["String"]>;
}

export interface ValueOriginatorUser {
  user: User;
}

/** Column metadata for value rule for dependency CSV file. */
export interface ValueRuleDependencyHeader {
  extendedFieldId: Scalars["ID"];
  extendedFieldName: Scalars["String"];
}

/**
 * A single dependency row. Value rule dependency is an ordered list of key value pairs where the each
 * item (cell) has a visibility dependency on all prior cells.
 */
export interface ValueRuleDependencyRow {
  valueRuleOptionDependencies: Array<ValueRuleOptionDependency>;
}

/** Metadata for a cell in a created dependency list */
export interface ValueRuleOptionDependency {
  extendedFieldId: Scalars["ID"];
  extendedFieldName: Scalars["String"];
  optionName?: Maybe<Scalars["String"]>;
}

export interface ValueRulesForDependencyMutationError
  extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

/** Enum type for value sentiment. */
export enum ValueSentimentType {
  NEGATIVE = "NEGATIVE",
  NEUTRAL = "NEUTRAL",
  POSITIVE = "POSITIVE",
}

export type VasOfferPayloadV2 =
  | CoachingOfferPayloadV2
  | DoohOfferPayloadV2
  | DoohOfferPayloadV3
  | MentalHealthOfferPayloadV2
  | OffsiteOfferPayloadV2;

export enum VatEnabledStatus {
  DISABLED = "DISABLED",
  ENABLED = "ENABLED",
}

export interface VatResult {
  extendedField?: Maybe<ExtendedField>;
  status: VatStatus;
}

export interface VatSettings {
  /** When using a custom tax code with a user-input rate/amount, the tax portion is recorded in this GL account. */
  customTaxGlAccount?: Maybe<ExtendedFieldOption>;
  /** Whether VAT is enabled on this subsidiary. */
  status?: Maybe<VatEnabledStatus>;
}

export enum VatStatus {
  AVAILABLE = "AVAILABLE",
  UNAVAILABLE = "UNAVAILABLE",
}

export interface VaultAccount extends BankingAccount, Node {
  balance?: Maybe<BankingAccountBalance>;
  cashflow?: Maybe<BankingAccountCashflow>;
  displayName?: Maybe<Scalars["String"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
  priority?: Maybe<BankingAccountPriority>;
  status?: Maybe<BankingAccountStatus>;
}

export interface VaultAccountcashflowArgs {
  endTime: Scalars["Time"];
  startTime: Scalars["Time"];
}

export interface VbMmSalesLeadDetailsInput {
  companyName?: InputMaybe<Scalars["String"]>;
  creditCardSpend?: InputMaybe<QuestionCreditCardSpendConsolidated>;
  email?: InputMaybe<Scalars["Email"]>;
  employeeCount?: InputMaybe<QuestionEmployeeCount>;
  firstName?: InputMaybe<Scalars["String"]>;
  fundingSource?: InputMaybe<QuestionFundingSource>;
  fundingSources?: InputMaybe<Array<InputMaybe<QuestionFundingSourceV2>>>;
  lastName?: InputMaybe<Scalars["String"]>;
  leadSelfAttestedType?: InputMaybe<LeadSelfAttestedType>;
  linkedinProfileUrl?: InputMaybe<Scalars["String"]>;
  phoneNumber?: InputMaybe<Scalars["PhoneNumber"]>;
  planningProfessionalInvestment?: InputMaybe<Scalars["Boolean"]>;
  productInterests?: InputMaybe<Array<InputMaybe<QuestionIntent>>>;
  salesRepName?: InputMaybe<Scalars["String"]>;
  salesVolumeLeadForm?: InputMaybe<QuestionSalesVolumeLeadForm>;
  salesVolumeV2?: InputMaybe<SalesVolumeV2>;
  segmentationDataV3?: InputMaybe<SegmentationDataV3>;
  selfAttestedRefCode?: InputMaybe<Scalars["String"]>;
  selfAttestedSource?: InputMaybe<Scalars["String"]>;
  website?: InputMaybe<Scalars["String"]>;
}

export interface VbMmSalesLeadDetailsObject {
  companyName?: Maybe<Scalars["String"]>;
  creditCardSpend?: Maybe<QuestionCreditCardSpendConsolidated>;
  email?: Maybe<Scalars["Email"]>;
  employeeCount?: Maybe<QuestionEmployeeCount>;
  firstName?: Maybe<Scalars["String"]>;
  fundingSource?: Maybe<QuestionFundingSource>;
  fundingSources?: Maybe<Array<Maybe<QuestionFundingSourceV2>>>;
  lastName?: Maybe<Scalars["String"]>;
  leadSelfAttestedType?: Maybe<LeadSelfAttestedType>;
  linkedinProfileUrl?: Maybe<Scalars["String"]>;
  phoneNumber?: Maybe<Scalars["PhoneNumber"]>;
  planningProfessionalInvestment?: Maybe<Scalars["Boolean"]>;
  productInterests?: Maybe<Array<Maybe<QuestionIntent>>>;
  salesRepName?: Maybe<Scalars["String"]>;
  salesVolumeLeadForm?: Maybe<QuestionSalesVolumeLeadForm>;
  salesVolumeV2?: Maybe<SalesVolumeV2>;
  segmentationDataV3?: Maybe<SegmentationDataV3Output>;
  selfAttestedRefCode?: Maybe<Scalars["String"]>;
  selfAttestedSource?: Maybe<Scalars["String"]>;
  website?: Maybe<Scalars["String"]>;
}

export enum Vendor {
  DEMO = "DEMO",
  DEPOSITS = "DEPOSITS",
  FINICITY = "FINICITY",
  INVALID = "INVALID",
  MANUAL = "MANUAL",
  OCROLUS = "OCROLUS",
  PLAID = "PLAID",
  TELLER = "TELLER",
}

export interface VendorAddDocumentsInput {
  documents: Array<VendorDocumentInput>;
  vendorId?: InputMaybe<Scalars["ID"]>;
}

export interface VendorAddDocumentsResult extends MutationResult {
  errors?: Maybe<Array<VendorMutationError>>;
  result?: Maybe<Array<VendorDocument>>;
}

export enum VendorCapabilities {
  /** DEPRECATED: Use accrual_accounting_card or accrual_accounting_reimbursements instead */
  FEATURE_ACCRUAL_ACCOUNTING = "FEATURE_ACCRUAL_ACCOUNTING",
  FEATURE_ACCRUAL_ACCOUNTING_CARD = "FEATURE_ACCRUAL_ACCOUNTING_CARD",
  FEATURE_ACCRUAL_ACCOUNTING_REIMBURSEMENTS = "FEATURE_ACCRUAL_ACCOUNTING_REIMBURSEMENTS",
  FEATURE_LOCAL_CURRENCY = "FEATURE_LOCAL_CURRENCY",
  FEATURE_MULTI_ENTITY = "FEATURE_MULTI_ENTITY",
  /** Whether an erp supports reimbursements as an expense type. May not be supported by all features */
  TRANSACTION_REIMBURSEMENTS = "TRANSACTION_REIMBURSEMENTS",
}

export interface VendorCategory extends Node {
  /** The ID of an object */
  id: Scalars["ID"];
  /** The name of this category */
  name: Scalars["String"];
  /** The parent vendor category. The field is non-null when the category is a subcategory. */
  parentVendorCategory?: Maybe<VendorCategory>;
}

export interface VendorCategoryFieldKeyTypeWrapper {
  key: VendorCategoryPrimitiveFieldKeyType;
}

/** The available fields that are queryable that relate to vendor categories */
export enum VendorCategoryPrimitiveFieldKeyType {
  ALL = "ALL",
  VENDOR_CATEGORY_ID = "VENDOR_CATEGORY_ID",
  VENDOR_CATEGORY_NAME = "VENDOR_CATEGORY_NAME",
}

export interface VendorCategoryPrimitiveFieldMatcherInput {
  /** This is for experiment only. The underlying implementation uses a fuzzy and semantic search. */
  similaritySearch?: InputMaybe<Scalars["String"]>;
  /** Match IN specific vendor category */
  vendorCategoryIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Match IN specific vendor category name */
  vendorCategoryNames?: InputMaybe<Array<Scalars["String"]>>;
  /** Fuzzy search by vendor category name */
  vendorCategorySearch?: InputMaybe<Scalars["String"]>;
}

/** A Vendor connection for Vendor pagination. */
export interface VendorConnection extends Connection {
  /** The vendors in the current page of results. */
  edges: Array<VendorEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of vendors matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

/** A contact input to be validated or created (needs at least one payment instrument to be valid) */
export interface VendorContactInput {
  /** Vendor's ACH Payment Instrument */
  achPaymentInstrument?: InputMaybe<AchPaymentInstrumentInput>;
  /** Vendor's Cheque Payment Instrument */
  chequePaymentInstrument?: InputMaybe<ChequePaymentInstrumentInput>;
  /** Vendor's Domestic Wire Payment Instrument */
  domesticWirePaymentInstrument?: InputMaybe<DomesticWirePaymentInstrumentInput>;
  /** Vendor's email */
  email?: InputMaybe<Scalars["String"]>;
  /** Client generated idempotency key */
  idempotencyKey: Scalars["String"];
  /** Vendor's International Wire Payment Instrument */
  internationalWirePaymentInstrument?: InputMaybe<InternationalWirePaymentInstrumentInput>;
  /** Name of the vendor (needs to be unique) */
  name: Scalars["String"];
  /** Vendor's phone number */
  phoneNumber?: InputMaybe<Scalars["String"]>;
}

/** The original contact input */
export interface VendorContactInputData {
  /** Vendor's ACH Payment Instrument */
  achPaymentInstrument?: Maybe<AchPaymentInstrument>;
  /** Vendor's Cheque Payment Instrument */
  chequePaymentInstrument?: Maybe<ChequePaymentInstrument>;
  /** Vendor's Domestic Wire Payment Instrument */
  domesticWirePaymentInstrument?: Maybe<DomesticWirePaymentInstrument>;
  /** Vendor's email */
  email?: Maybe<Scalars["String"]>;
  /** Client generated idempotency key */
  idempotencyKey: Scalars["String"];
  /** Vendor's International Wire Payment Instrument */
  internationalWirePaymentInstrument?: Maybe<InternationalWirePaymentInstrument>;
  /** Name of the vendor (needs to be unique) */
  name: Scalars["String"];
  /** Vendor's phone number */
  phoneNumber?: Maybe<Scalars["String"]>;
}

/** Validation result for a contact input */
export interface VendorContactInputValidation {
  /** Fields that are valid or not (string -> boolean) */
  fields: Scalars["Json"];
  /** Boolean whether the contact input is a duplicate */
  isDuplicate: Scalars["Boolean"];
  /** Boolean whether the contact input is valid */
  isValid: Scalars["Boolean"];
  /** Validated ACH Payment Instrument */
  validatedAchPaymentInstrument?: Maybe<ValidatedPaymentInstrument>;
  /** Validated Cheque Payment Instrument */
  validatedChequePaymentInstrument?: Maybe<ValidatedPaymentInstrument>;
  /** Validated Domestic Wire Payment Instrument */
  validatedDomesticWirePaymentInstrument?: Maybe<ValidatedPaymentInstrument>;
  /** Validated International Wire Payment Instrument */
  validatedInternationalWirePaymentInstrument?: Maybe<ValidatedPaymentInstrument>;
}

/** The creator source type of the vendor. */
export enum VendorCreatorSourceType {
  /** An billpay vendor */
  BILLPAY = "BILLPAY",
  /** A brex admin vendor */
  BREX_ADMIN = "BREX_ADMIN",
  /** A card vendor */
  CARD = "CARD",
  /** A cash vendor */
  CASH = "CASH",
  /** A reimbursement vendor */
  REIMBURSEMENT = "REIMBURSEMENT",
}

export interface VendorCredential {
  /** Vendor specific credential metadata */
  credentialPayload?: Maybe<CredentialPayload>;
  /** The current connection status of the credential */
  credentialStatus?: Maybe<CredentialStatus>;
  /** The customer account ID of the credential */
  customerAccountId?: Maybe<Scalars["String"]>;
  /** The customer user ID of the user who created the credential */
  customerUserId?: Maybe<Scalars["String"]>;
  /** The unique ID of the credential */
  id: Scalars["ID"];
}

export interface VendorCredentialEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<VendorCredential>;
}

/** false */
export interface VendorDetails extends Node {
  address?: Maybe<Address>;
  /** Bill Pay Vendor Extension */
  billPayVendorExtension?: Maybe<BillPayVendorExtension>;
  /** Additional merchant information related to the vendor. */
  category: Category;
  /**
   * [TEMP] Details of the contact associated with the vendor
   * @deprecated TEMP for migration
   */
  contactDetails?: Maybe<ContactToVendorMigrationDetails>;
  /** ID encoded with contact prefix for use with payment service */
  contactId?: Maybe<Scalars["ID"]>;
  contactName?: Maybe<Scalars["String"]>;
  customerAccountId?: Maybe<Scalars["ID"]>;
  /** Specific to Bill Pay vendors onboarded via self-service portal */
  customerDbaName?: Maybe<Scalars["String"]>;
  /** Fields that have been treated to be ready for display/CSV export. These fields will all return strings, and will be used by the downloads platform in CSV generation */
  displayFields?: Maybe<DisplayFields>;
  /** Display names of the owners for this vendor */
  displayOwners?: Maybe<Scalars["String"]>;
  /** Documents associated with the vendor */
  documents: Array<VendorDocument>;
  email?: Maybe<Scalars["String"]>;
  /** Extended field values */
  extendedFieldValues: Array<ExtendedFieldValue>;
  /** The ID of an object */
  id: Scalars["ID"];
  knowledgeBaseDetails: VendorKnowledgeBaseDetails;
  /** Knowledge base vendor associated with this vendor. */
  knowledgeBaseVendor?: Maybe<KnowledgeBaseVendor>;
  name: Scalars["String"];
  /** Next scheduled payments for this vendor. This currently only returns the one next upcoming payment but it can be expanded when we have a need to show more payments. */
  nextPaymentDates?: Maybe<Array<Maybe<UpcomingPayments>>>;
  /** Object mapping information for this vendor, showing how it maps to ERP systems */
  objectMapping?: Maybe<ObjectMapping>;
  /** Configuration for payments to this vendor (bill pay / send money) */
  paymentConfig?: Maybe<VendorPaymentConfig>;
  /** payment instruments */
  paymentInstruments?: Maybe<Array<PaymentInstrument>>;
  phone?: Maybe<Scalars["String"]>;
  /** Purchase orders associated with this vendor */
  purchaseOrders?: Maybe<Array<PurchaseOrder>>;
  /** A summary of purchase orders that are in draft/open state for this vendor. */
  purchaseOrdersSummary?: Maybe<VendorPurchaseOrdersSummary>;
  /**
   * Rail account details associated with this vendor.
   * Can be filtered by rail type.
   */
  railAccountDetails?: Maybe<Array<RailAccountDetails>>;
  /** summarize various types of spend for the vendor */
  spendSummary?: Maybe<FinancialAsset>;
  status?: Maybe<VendorStatus>;
  /** Display icon for vendor, corresponding to deprecated MerchantIcon type. */
  vendorIcon?: Maybe<VendorIcon>;
  version: Scalars["Int"];
  website?: Maybe<Scalars["String"]>;
}

/** false */
export interface VendorDetailsrailAccountDetailsArgs {
  railTypes?: InputMaybe<Array<RailType>>;
}

/** false */
export interface VendorDetailsspendSummaryArgs {
  period: VendorSpendSummaryPeriod;
  type?: InputMaybe<Array<VendorSpendSummaryType>>;
}

export interface VendorDisplay {
  category?: Maybe<Scalars["String"]>;
  icon?: Maybe<Asset>;
  name?: Maybe<Scalars["String"]>;
}

export interface VendorDocument {
  asset: Asset;
  documentType: VendorDocumentType;
  extractedData?: Maybe<VendorDocumentExtractionUnion>;
  extractionStatus?: Maybe<VendorDocumentExtractionStatus>;
  id: Scalars["ID"];
  name: Scalars["String"];
}

export enum VendorDocumentExtractionStatus {
  COMPLETE = "COMPLETE",
  ERROR = "ERROR",
  IN_PROGRESS = "IN_PROGRESS",
  REQUESTED = "REQUESTED",
  SKIPPED = "SKIPPED",
}

export type VendorDocumentExtractionUnion = VendorTaxFormW9;

export interface VendorDocumentInput {
  documentType: VendorDocumentType;
  fileStoreId: Scalars["ID"];
  name?: InputMaybe<Scalars["String"]>;
  /** Whether to OCR extract data on a vendor document */
  shouldExtractData?: InputMaybe<Scalars["Boolean"]>;
}

export enum VendorDocumentType {
  CONTRACT = "CONTRACT",
  DOCUMENT = "DOCUMENT",
  IRS_1099 = "IRS_1099",
  IRS_W8 = "IRS_W8",
  IRS_W9 = "IRS_W9",
  OTHER = "OTHER",
}

/** A Vendor edge for the Vendor connection. */
export interface VendorEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The vendor at this edge. */
  node?: Maybe<VendorDetails>;
}

export enum VendorExportColumn {
  ADDRESS = "ADDRESS",
  BUSINESS_NAME = "BUSINESS_NAME",
  BUSINESS_TYPE = "BUSINESS_TYPE",
  DEFAULT_ERP_ACCOUNT = "DEFAULT_ERP_ACCOUNT",
  FORM_1099_ELIGIBILITY = "FORM_1099_ELIGIBILITY",
  LEGAL_NAME = "LEGAL_NAME",
  NAME = "NAME",
  NEXT_PAYMENT = "NEXT_PAYMENT",
  PAYMENT_METHODS = "PAYMENT_METHODS",
  SPEND_2024_1099_ELIGIBLE = "SPEND_2024_1099_ELIGIBLE",
  THIRTY_DAY_SPEND = "THIRTY_DAY_SPEND",
  TIN = "TIN",
  VENDOR_OWNERS = "VENDOR_OWNERS",
  YTD_SPEND = "YTD_SPEND",
}

export enum VendorExportTrigger {
  /** Vendor is created in ERP after it attached to an exported bill */
  BILL_PAY = "BILL_PAY",
  /** Vendor is created in ERP right after its creation in Brex */
  CREATION = "CREATION",
}

export interface VendorFileMatch {
  card?: Maybe<Card>;
  id: Scalars["ID"];
  imports: SpendMigrationImportConnection;
  insertedAt: Scalars["Date"];
  migrationStatus: VendorFileMatchMigrationStatus;
  sanitizedVendorName: Scalars["String"];
  spendLimit?: Maybe<Budget>;
  /** Status dictating if spend has been detected on the vendor */
  spendStatus?: Maybe<SpendMigrationSpendStatus>;
  /** This field is only non-null when a Sunlight migration has been initialized */
  sunlightMigrationStatus?: Maybe<SunlightMigrationStatus>;
  totalSpend?: Maybe<FinancialAsset>;
  vendorDetails?: Maybe<VendorDetails>;
  vendorOwner?: Maybe<User>;
}

export interface VendorFileMatchConnection extends Connection {
  /** The vendors in the current page of results. */
  edges: Array<VendorFileMatchEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of vendors file match filters matching the filter criteria specified for this connection. */
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface VendorFileMatchEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The vendor file match at this edge. */
  node: VendorFileMatch;
}

/** Filters on vendor file matches. */
export interface VendorFileMatchFilterInput {
  /** Filter for specific migration statuses (union). */
  migrationStatuses?: InputMaybe<Array<VendorFileMatchMigrationStatus>>;
  /** Filter for specific vendor owner customer user IDs (union). */
  ownerCustomerUserIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Filter vendors by name using partial matching (case-insensitive). */
  vendorName?: InputMaybe<Scalars["String"]>;
}

export enum VendorFileMatchMigrationStatus {
  /** Waiting on delegated vendor owner to complete migration */
  DELEGATED = "DELEGATED",
  /** Async migration is in progress. This value reflects a user action to migrate the vendor. */
  IN_PROGRESS = "IN_PROGRESS",
  /**
   * Migration completed.
   * NOTE: Not yet supported.
   */
  MIGRATED = "MIGRATED",
  /**
   * The user manually migrated the vendor and marked the vendor as migrated
   * NOTE: this will soon be deprecated in favor of MIGRATED
   */
  MIGRATED_MANUALLY = "MIGRATED_MANUALLY",
  /**
   * The user used Sunlight to migrate the vendor.
   * NOTE: this will soon be deprecated in favor of MIGRATED
   */
  MIGRATED_VIA_SUNLIGHT = "MIGRATED_VIA_SUNLIGHT",
  /** The vendor file match is pending migration */
  NOT_YET_MIGRATED = "NOT_YET_MIGRATED",
  /** The user decided they will not migrate the card on file for the vendor */
  WILL_NOT_MIGRATE = "WILL_NOT_MIGRATE",
}

export interface VendorFileMatchMutationError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface VendorFileMatchStatusUpdate {
  /** The migration status of the vendor file match */
  migrationStatus: VendorFileMatchMigrationStatus;
}

export interface VendorFileMatchSunlightBlockedInput {
  vendorFileMatchId: Scalars["ID"];
}

export interface VendorFileMatchSunlightBlockedResult {
  result?: Maybe<VendorFileMatch>;
}

export interface VendorFileMatchUpdate {
  /** The migration status of the vendor file match */
  migrationStatus?: InputMaybe<VendorFileMatchMigrationStatus>;
  /** The network card ID. The spend limit ID of this vendor file match will always be changed to that of this network card ID. */
  networkCardId?: InputMaybe<Scalars["ID"]>;
  /**
   * The spend limit ID to assign this vendor to.
   * If the vendor is already assigned to a card, and the new spend limit specified is different than that of the card ID,
   * the existing network card ID will be set to null.
   *
   * If this update input contains both a spendLimitId and a networkCardId, the spend limit ID of the networkCardId
   * must match the spend limit ID specified in this input. Else a validation error will be thrown.
   */
  spendLimitId?: InputMaybe<Scalars["ID"]>;
  /** The customer user ID of the vendor owner (ie who is responsible for ensuring this vendor is migrated) */
  vendorOwnerCustomerUserId?: InputMaybe<Scalars["ID"]>;
}

/** Filters available to control which vendors get returned. */
export interface VendorFilterInput {
  /** Match IN specific business types (tax classifications), match ALL when no filter is provided */
  businessTypes?: InputMaybe<Array<VendorTaxClassification>>;
  /** Match IN specific category ids */
  categoryIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Match IN specific vendor creator source types, match ALL when no filter is provided */
  creatorSourceTypes?: InputMaybe<Array<VendorCreatorSourceType>>;
  /** Match IN specific accounts */
  customerAccountIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Match IN specific form 1099 eligibility statuses, match ALL when no filter is provided */
  irsForm1099EligibilityStatus?: InputMaybe<
    Array<IrsForm1099EligibilityStatus>
  >;
  /** Match IN specific root vendor ids */
  rootVendorIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Whether the vendor is global or scoped to a customer */
  scope?: InputMaybe<VendorScope>;
  /**
   * Returns vendors matching the specified scopes
   * Note: Not all filters are supported and only basic data (name, id, address etc.) is returned
   */
  scopes?: InputMaybe<Array<VendorScope>>;
  /** Match IN specific statuses, defaults to ACTIVE when no filter is provided */
  status?: InputMaybe<Array<VendorStatus>>;
  /** Match IN specific vendor group ids */
  vendorGroupIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Match IN specific vendor ids, match ALL when no filter is provided */
  vendorIds?: InputMaybe<Array<Scalars["ID"]>>;
  /** Search for names containing the given string (searches vendor name, legal name, and business name) */
  vendorNameSearch?: InputMaybe<Scalars["String"]>;
  /** Match IN specific vendor names */
  vendorNames?: InputMaybe<Array<Scalars["String"]>>;
  /** Match vendors owned by specific users */
  vendorOwnerUserIds?: InputMaybe<Array<Scalars["ID"]>>;
}

/** Display icon for vendor, corresponding to deprecated MerchantIcon type. */
export interface VendorIcon {
  asset: Asset;
}

export interface VendorInstitution {
  logoBase64?: Maybe<Scalars["String"]>;
  metadata?: Maybe<VendorInstitutionMetadata>;
  priority?: Maybe<Scalars["Int"]>;
  shouldBeUsed?: Maybe<Scalars["Boolean"]>;
  vendor?: Maybe<FinancialsVendor>;
  vendorInternalId?: Maybe<Scalars["String"]>;
}

export type VendorInstitutionMetadata = FinicityMetadata;

export interface VendorKnowledgeBaseDetails {
  helpCenterUrl?: Maybe<Scalars["String"]>;
  managePaymentsUrl?: Maybe<Scalars["String"]>;
  sunlightServiceId?: Maybe<Scalars["String"]>;
}

/** Vendor-specific metadata */
export interface VendorMetadata {
  vendorName: Scalars["String"];
}

export interface VendorMutationError extends StandardClientError {
  code: ErrorCode;
  message?: Maybe<Scalars["String"]>;
  path?: Maybe<Array<Scalars["String"]>>;
}

export interface VendorOneTimeCardDetails {
  card: Card;
  customerDbaName?: Maybe<Scalars["String"]>;
  expense: Expense;
}

/** Determines the order that the vendors will be returned. */
export interface VendorOrderInput {
  field: SortableVendorField;
  order: OrderByDirection;
}

export interface VendorOwnerGroupInput {
  /** Add by property (e.g. department, title, etc.) */
  memberCondition?: InputMaybe<MemberConditionInput>;
  /** Add by UserID directly */
  memberIds?: InputMaybe<Array<Scalars["ID"]>>;
}

export interface VendorPaymentConfig {
  /** The default payment instrument to use for this vendor */
  defaultPaymentInstrument?: Maybe<PaymentInstrument>;
  /** The default payment method to use (ACH / Wire / Check) */
  defaultPaymentMethodString?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  /** Internal notes */
  internalNotes?: Maybe<Scalars["String"]>;
  /** Form 1099 eligibility of the vendor */
  irsForm1099EligibilityStatus?: Maybe<IrsForm1099EligibilityStatus>;
  /** Legal entity that pays this vendor */
  legalEntity?: Maybe<LegalEntity>;
  /** Linked ERP vendor URL */
  linkedErpVendorUrl?: Maybe<Scalars["String"]>;
  /** Name of ERP that this vendor is linked to */
  linkedVendorErpName?: Maybe<LinkedVendorErpName>;
  /** Manually assigned owner of the vendor */
  ownerUser?: Maybe<User>;
  /** Payment terms */
  paymentTerms?: Maybe<Scalars["String"]>;
  /** Time at which invite was sent, or null if no valid invite */
  selfServeInviteSentAt?: Maybe<Scalars["Time"]>;
  /** Last user to invite the vendor to self-service onboard */
  selfServeLastInvitedByUser?: Maybe<User>;
  /** Whether the vendor should provide payment instrument via self-serve */
  selfServeRequestPaymentInstrument?: Maybe<VendorSelfServeInfoRequest>;
  /** Whether the vendor should provide tax info via self-serve */
  selfServeRequestTaxInfo?: Maybe<VendorSelfServeInfoRequest>;
  /** Whether to notify recipient by default */
  shouldNotifyRecipientDefault?: Maybe<Scalars["Boolean"]>;
  /** Tax form data for the vendor (W8 / W9) */
  taxFormData?: Maybe<VendorTaxFormUnion>;
  /** Tin validation status of tax information */
  taxFormTinValidationStatus?: Maybe<TaxFormTinValidationStatus>;
  /** The vendor owners */
  vendorOwners?: Maybe<Group>;
}

export interface VendorPaymentConfigInput {
  /** The default payment instrument to use for this vendor */
  defaultPaymentInstrumentId?: InputMaybe<Scalars["ID"]>;
  /** The default payment method to use (ACH / Wire / Check) */
  defaultPaymentMethodString?: InputMaybe<Scalars["String"]>;
  /** Legal entity that pays this vendor */
  entityId?: InputMaybe<Scalars["ID"]>;
  /** Internal notes */
  internalNotes?: InputMaybe<Scalars["String"]>;
  /** Form 1099 eligibility of the vendor */
  irsForm1099EligibilityStatus?: InputMaybe<IrsForm1099EligibilityStatus>;
  /** Name of the ERP that this vendor is linked to */
  linkedErpName?: InputMaybe<LinkedVendorErpName>;
  /** Id of the vendor in the ERP linked to this vendor */
  linkedErpVendorId?: InputMaybe<Scalars["String"]>;
  /** Manually assigned owner of the vendor */
  ownerUserId?: InputMaybe<Scalars["ID"]>;
  /** Payment terms */
  paymentTerms?: InputMaybe<Scalars["String"]>;
  /** Whether the vendor should provide payment instrument via self-serve */
  selfServeRequestPaymentInstrument?: InputMaybe<VendorSelfServeInfoRequest>;
  /** Whether the vendor should provide tax info via self-serve */
  selfServeRequestTaxInfo?: InputMaybe<VendorSelfServeInfoRequest>;
  /** Whether to notify recipient by default */
  shouldNotifyRecipientDefault?: InputMaybe<Scalars["Boolean"]>;
  /** Tax form data for the vendor (W8 / W9) */
  taxFormData?: InputMaybe<VendorTaxFormInputUnion>;
  /** The vendor owners */
  vendorOwners?: InputMaybe<VendorOwnerGroupInput>;
}

export interface VendorPaymentInput {
  paymentInstrumentId?: InputMaybe<Scalars["ID"]>;
  paymentMethod?: InputMaybe<BillPaymentMethod>;
  railsAccountId?: InputMaybe<Scalars["ID"]>;
}

/** Provides a summary of draft/open purchase orders for a vendor. */
export interface VendorPurchaseOrdersSummary {
  /** Details of the most recent purchase order for this vendor. */
  mostRecentPurchaseOrder?: Maybe<PurchaseOrder>;
  /** How many draft POs there are on this vendor */
  purchaseOrdersDraftCount: Scalars["Int"];
  /** How many open POs there are on this vendor */
  purchaseOrdersOpenCount: Scalars["Int"];
  /** Total spend available on draft POs. Returns a list of Financial Assets, each summed up per currency. */
  totalAvailableOnDraftPurchaseOrdersAmountByCurrency: Array<FinancialAsset>;
  /** Total spend available on Open POs. Returns a list of Financial Assets, each summed up per currency. */
  totalAvailableOnOpenPurchaseOrdersAmountByCurrency: Array<FinancialAsset>;
}

export interface VendorRemoveDocumentsInput {
  documentIds: Array<Scalars["ID"]>;
  vendorId?: InputMaybe<Scalars["ID"]>;
}

export interface VendorRemoveDocumentsResult extends MutationResult {
  errors?: Maybe<Array<VendorMutationError>>;
  result?: Maybe<Array<Scalars["ID"]>>;
}

/** VENDOR OPERATIONS */
export enum VendorResourceAttribute {
  VENDOR = "VENDOR",
}

export interface VendorResourceOperation extends ResourceOperation {
  action: ResourceAction;
  attribute?: Maybe<VendorResourceAttribute>;
}

/** The scope of the vendor. */
export enum VendorScope {
  /** Customer scoped vendors */
  CUSTOMER = "CUSTOMER",
  /** Global vendors that meet a criteria to be shown to all customers */
  GLOBAL = "GLOBAL",
  /** Vendors that the user is a 'vendor owner' of */
  OWNED_BY_USER = "OWNED_BY_USER",
  /** Global vendors that have expenses with the customer */
  TRANSACTED = "TRANSACTED",
}

export enum VendorSelfServeInfoRequest {
  /** field is not allowed to be updated by the vendor */
  NOT_ALLOWED = "NOT_ALLOWED",
  /** field is requested from the vendor */
  REQUESTED = "REQUESTED",
}

export interface VendorSettings {
  /** Whether vendor auto creation is enabled */
  autoCreationEnabled?: Maybe<Scalars["Boolean"]>;
  /** When vendor export is triggered (on creation or bill pay) */
  vendorExportTrigger?: Maybe<VendorExportTrigger>;
  /** Whether vendor sync is enabled */
  vendorSync?: Maybe<Scalars["Boolean"]>;
}

export interface VendorSettingsInput {
  /** Whether vendor auto creation is enabled */
  autoCreationEnabled?: InputMaybe<Scalars["Boolean"]>;
  /** When vendor export is triggered (on creation or bill pay) */
  vendorExportTrigger?: InputMaybe<VendorExportTrigger>;
  /** Whether vendor sync is enabled */
  vendorSync?: InputMaybe<Scalars["Boolean"]>;
}

export enum VendorSpendSummaryPeriod {
  LAST_30_DAYS = "LAST_30_DAYS",
  YEAR_2024 = "YEAR_2024",
  YEAR_TO_DATE = "YEAR_TO_DATE",
}

export enum VendorSpendSummaryType {
  BANKING = "BANKING",
  EXPENSES = "EXPENSES",
  NON_CARD_EXPENSES = "NON_CARD_EXPENSES",
}

/** The status of the vendor. */
export enum VendorStatus {
  /** An active vendor */
  ACTIVE = "ACTIVE",
  /** A declined vendor */
  DECLINED = "DECLINED",
  /** A deleted vendor */
  DELETED = "DELETED",
  /** A draft vendor */
  DRAFT = "DRAFT",
  /** A merged (duplicate) vendor */
  MERGED = "MERGED",
  /** A pending vendor */
  PENDING = "PENDING",
}

export interface VendorSubsidiary {
  /** Nullable. Country the subsidiary is associated with. */
  country?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  vendorInternalId?: Maybe<Scalars["String"]>;
}

export interface VendorSubsidiaryConnection extends Connection {
  /** The items in the current page of results. */
  edges: Array<VendorSubsidiaryEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of items, across all pages, matching the filter criteria specified for this connection. */
  totalCount: Scalars["Int"];
}

export interface VendorSubsidiaryEdge {
  /** Nullable. Country the subsidiary is associated with. */
  country?: Maybe<Scalars["String"]>;
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The Subsidiary at this edge. */
  node: VendorSubsidiary;
}

export enum VendorTaxClassification {
  C_CORP = "C_CORP",
  INDIVIDUAL = "INDIVIDUAL",
  LLC = "LLC",
  OTHER = "OTHER",
  PARTNERSHIP = "PARTNERSHIP",
  S_CORP = "S_CORP",
}

export interface VendorTaxFormInputUnion {
  w8?: InputMaybe<VendorTaxFormW8Input>;
  w9?: InputMaybe<VendorTaxFormW9Input>;
}

export type VendorTaxFormUnion = VendorTaxFormW8 | VendorTaxFormW9;

export interface VendorTaxFormW8 {
  countryOfCitizenship?: Maybe<Scalars["String"]>;
  dateOfBirth?: Maybe<Scalars["Date"]>;
  domesticTaxIdentificationNumber?: Maybe<Scalars["String"]>;
  foreignTaxIdentificationNumber?: Maybe<Scalars["String"]>;
  legalName?: Maybe<Scalars["String"]>;
  mailingAddress?: Maybe<Address>;
  residentialAddress?: Maybe<Address>;
}

export interface VendorTaxFormW8Input {
  countryOfCitizenship?: InputMaybe<Scalars["String"]>;
  dateOfBirth?: InputMaybe<Scalars["Date"]>;
  domesticTaxIdentificationNumber?: InputMaybe<Scalars["String"]>;
  foreignTaxIdentificationNumber?: InputMaybe<Scalars["String"]>;
  legalName?: InputMaybe<Scalars["String"]>;
  mailingAddress?: InputMaybe<AddressInput>;
  residentialAddress?: InputMaybe<AddressInput>;
}

export interface VendorTaxFormW9 {
  address?: Maybe<Address>;
  businessName?: Maybe<Scalars["String"]>;
  isSigned?: Maybe<Scalars["Boolean"]>;
  legalName?: Maybe<Scalars["String"]>;
  signedDate?: Maybe<Scalars["Date"]>;
  taxClassification?: Maybe<VendorTaxClassification>;
  taxIdentificationNumber?: Maybe<Scalars["String"]>;
}

export interface VendorTaxFormW9Input {
  address?: InputMaybe<AddressInput>;
  businessName?: InputMaybe<Scalars["String"]>;
  isSigned?: InputMaybe<Scalars["Boolean"]>;
  legalName?: InputMaybe<Scalars["String"]>;
  signedDate?: InputMaybe<Scalars["Date"]>;
  taxClassification?: InputMaybe<VendorTaxClassification>;
  taxIdentificationNumber?: InputMaybe<Scalars["String"]>;
}

export interface VerificationAnalysesFilterInput {
  /** Exclude specified statuses from filter */
  excludeStatuses?: InputMaybe<Array<VerificationAnalysisStatusV2>>;
  /** Requirement. */
  requirement?: InputMaybe<RequirementIdentifier>;
  /** Requirement List. */
  requirements?: InputMaybe<Array<InputMaybe<RequirementIdentifier>>>;
  /** Subject ID. */
  subjectId?: InputMaybe<Scalars["String"]>;
  /** Match specified verification request */
  verificationRequestFilter?: InputMaybe<VerificationRequestFilterInput>;
}

export interface VerificationAnalysis {
  /** Applicant's customer user ID of analysis. */
  applicantCustomerUserId?: Maybe<Scalars["String"]>;
  /** Customer account ID of analysis. */
  customerAccountId: Scalars["String"];
  /** ID of analysis. */
  id: Scalars["ID"];
  /** Timestamp at which analysis was created. */
  insertedAt: Scalars["Time"];
  /** Requests for information on the analysis. */
  requests: Array<VerificationRequest>;
  /** Requirement of analysis. */
  requirement: Requirement;
  /** Result of analysis. */
  result: VerificationAnalysisResult;
  /** Execution status of the analysis. */
  status: VerificationAnalysisStatusV2;
  /** Subject ID of analysis. */
  subjectId: Scalars["String"];
  /** Timestamp at which all user facing requests were completed. Null if still incomplete. */
  submittedAt?: Maybe<Scalars["Time"]>;
  /** Timestamp at which analysis was last updated. */
  updatedAt: Scalars["Time"];
}

export interface VerificationAnalysisConnection extends Connection {
  /** Analyses in the current page of results. */
  edges: Array<VerificationAnalysisEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of analyses matching the filter criteria specified for this connection. */
  totalCount: Scalars["Int"];
}

export interface VerificationAnalysisEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** Analysis at this edge. */
  node?: Maybe<VerificationAnalysis>;
}

export enum VerificationAnalysisResult {
  /** Verification is approved. Terminal. */
  APPROVED = "APPROVED",
  /** Verification is pending input from the user. */
  PENDING_EVIDENCE = "PENDING_EVIDENCE",
  /** Verification is pending review or input from an internal system. */
  PENDING_REVIEW = "PENDING_REVIEW",
  /** Verification is in a transient processing state. */
  PROCESSING = "PROCESSING",
  /** Verification is rejected. Terminal. */
  REJECTED = "REJECTED",
}

/** Misnomer: Specific to bank connection KYC use case */
export enum VerificationAnalysisStatus {
  /** Verification is approved. Terminal */
  APPROVED = "APPROVED",
  /** Verification is in a error state. Not terminal */
  ERROR = "ERROR",
  /** Unset */
  INVALID = "INVALID",
  /** No verification required */
  NOT_REQUIRED = "NOT_REQUIRED",
  /** Verification required, but no existing analysis found */
  NOT_STARTED = "NOT_STARTED",
  /** Verification is pending input from customer */
  PENDING_EVIDENCE = "PENDING_EVIDENCE",
  /** Verification is pending review or internal input */
  PENDING_REVIEW = "PENDING_REVIEW",
  /** Verification is in a transient processing state */
  PROCESSING = "PROCESSING",
  /** Verification is rejected. Terminal */
  REJECTED = "REJECTED",
}

/** Execution status of a verification analysis. */
export enum VerificationAnalysisStatusV2 {
  CANCELLED = "CANCELLED",
  COMPLETED = "COMPLETED",
  ERROR = "ERROR",
  NEW = "NEW",
  PENDING = "PENDING",
  RUNNING = "RUNNING",
}

/** Any document type that might be requested in the verification service via the CollectDocumentsQuery */
export enum VerificationDocumentType {
  INDIA_BANK_POAO = "INDIA_BANK_POAO",
  INDIA_BUSINESS_PERMANENT_ACCOUNT_NUMBER = "INDIA_BUSINESS_PERMANENT_ACCOUNT_NUMBER",
  INDIA_BUSINESS_PROOF = "INDIA_BUSINESS_PROOF",
  INDIA_SIGNATORY_PERMANENT_ACCOUNT_NUMBER = "INDIA_SIGNATORY_PERMANENT_ACCOUNT_NUMBER",
  INDIA_SIGNATORY_PROOF_OF_ADDRESS = "INDIA_SIGNATORY_PROOF_OF_ADDRESS",
  PROOF_OF_PHYSICAL_BUSINESS_ADDRESS = "PROOF_OF_PHYSICAL_BUSINESS_ADDRESS",
  PROOF_OF_RESIDENTIAL_INDIVIDUAL_ADDRESS = "PROOF_OF_RESIDENTIAL_INDIVIDUAL_ADDRESS",
}

/** Verification input */
export interface VerificationInput {
  /** ID of the Customer Account to get Verification requirements for */
  customerAccountId: Scalars["ID"];
  /** Requirements context for this Verification */
  reimbursementSetupContext?: InputMaybe<ReimbursementSetupContext>;
}

/**
 * Verification Notifications are created for a customer when they reach out to
 * customer support for a case which requires us to verify their identity.
 * Customers can approve or deny a verification notification.
 */
export interface VerificationNotification {
  /** ID of the Customer User that the notification belongs to" */
  customerUserId: Scalars["ID"];
  /** Datetime in which the notification expires */
  expiredAt: Scalars["Time"];
  /** ID of the Verification Notification */
  id: Scalars["ID"];
  /** Datetime in which the Salesforce Case was created */
  salesforceCaseCreatedAt: Scalars["Time"];
  /** Salesforce ID of the Case which the notification is related to */
  salesforceCaseId: Scalars["String"];
  /** Status of the verification notification */
  status: VerificationNotificationStatus;
}

/** VerificationNotifications connection */
export interface VerificationNotificationConnection extends Connection {
  /** The items in the current page of results. */
  edges: Array<VerificationNotificationEdge>;
  /** Page information for additional navigation through this connection. */
  pageInfo: PageInfo;
  /** The total count of items, across all pages, matching the filter criteria specified for this connection. */
  totalCount: Scalars["Int"];
}

/** VerificationNotificationConnection edge */
export interface VerificationNotificationEdge {
  /** The opaque cursor of the current edge. */
  cursor?: Maybe<Scalars["String"]>;
  /** The Verification Notification at this edge. */
  node: VerificationNotification;
}

export enum VerificationNotificationStatus {
  /** Verification is approved */
  APPROVED = "APPROVED",
  /** Verification is canceled */
  CANCELED = "CANCELED",
  /** Verification is denied */
  DENIED = "DENIED",
  /** Verification has expired */
  EXPIRED = "EXPIRED",
  /** Unset value for this enumeration */
  INVALID = "INVALID",
  /** Pending customer response */
  PENDING_CUSTOMER = "PENDING_CUSTOMER",
}

export interface VerificationRequest {
  config?: Maybe<VerificationRequestConfig>;
  id: Scalars["ID"];
  payload?: Maybe<Scalars["Json"]>;
  requestType: VerificationRequestType;
  status: VerificationRequestStatus;
}

export type VerificationRequestConfig =
  | BORefreshRequestConfig
  | BusinessCipRefreshRequestConfig
  | CollectDocumentsRequestConfig
  | CombinedTermsRequestConfig
  | DefaultRequestConfig
  | JsonSchemaRequestConfig
  | MainEntityDetailsRequestConfig
  | OwnershipRequestConfig
  | PersonaRequestConfig
  | SourceOfFundsRequestConfig
  | TermsRequestConfig
  | UnderwritingDetailsRequestConfig;

export interface VerificationRequestFilterInput {
  /** Must not match any of the specified request types */
  excludeTypes?: InputMaybe<Array<VerificationRequestType>>;
  /** Must match one of the specified request statuses */
  statuses?: InputMaybe<Array<VerificationRequestStatus>>;
}

/** Represents the status of a request. */
export enum VerificationRequestStatus {
  /** Indicates a request that has been canceled. */
  CANCELED = "CANCELED",
  /** Indicates a request that has been completed. Terminal. */
  COMPLETE = "COMPLETE",
  /** Indicates a request that is in progress. */
  IN_PROGRESS = "IN_PROGRESS",
  /** Indicates a new request. */
  NEW = "NEW",
  /** Indicates a request that has a valid payload and is ready to submit to reach a terminal state. */
  READY_TO_SUBMIT = "READY_TO_SUBMIT",
}

/** Represents the type of a form request. */
export enum VerificationRequestType {
  /** Airwallex Hosted Flow Review */
  AIRWALLEX_HOSTED_FLOW_REVIEW = "AIRWALLEX_HOSTED_FLOW_REVIEW",
  /** Airwallex KYC Hosted Flow */
  AIRWALLEX_KYC_HOSTED_FLOW = "AIRWALLEX_KYC_HOSTED_FLOW",
  /** Airwallex RFI Hosted Flow */
  AIRWALLEX_RFI_HOSTED_FLOW = "AIRWALLEX_RFI_HOSTED_FLOW",
  /** Generic user facing form request. */
  APPLICANT = "APPLICANT",
  /** Backup withholding form. */
  BACKUP_WITHHOLDING = "BACKUP_WITHHOLDING",
  /** BO refresh form. */
  BO_REFRESH = "BO_REFRESH",
  /** BR DLocal */
  BR_DLOCAL = "BR_DLOCAL",
  /** Business Cip Refresh */
  BUSINESS_CIP_REFRESH = "BUSINESS_CIP_REFRESH",
  /** Cash applicant form. */
  CASH_APPLICANT = "CASH_APPLICANT",
  /** Collect documents (generic query) */
  COLLECT_DOCUMENTS = "COLLECT_DOCUMENTS",
  /** EDD */
  EDD_ATTESTATION = "EDD_ATTESTATION",
  /** Address */
  ENTITY_ADDRESS = "ENTITY_ADDRESS",
  /** Entity corporate structure */
  ENTITY_CORPORATE_STRUCTURE = "ENTITY_CORPORATE_STRUCTURE",
  /** Entity customers */
  ENTITY_CUSTOMERS = "ENTITY_CUSTOMERS",
  /** Entity details */
  ENTITY_DETAILS = "ENTITY_DETAILS",
  /** Entity EIN */
  ENTITY_EIN = "ENTITY_EIN",
  /** Entity funding source */
  ENTITY_FUNDING_SOURCE = "ENTITY_FUNDING_SOURCE",
  /** Incorporation details */
  ENTITY_INCORPORATION_DETAILS = "ENTITY_INCORPORATION_DETAILS",
  /** Entity ownership */
  ENTITY_OWNERSHIP = "ENTITY_OWNERSHIP",
  /** Public company details */
  ENTITY_PUBLIC_COMPANY_DETAILS = "ENTITY_PUBLIC_COMPANY_DETAILS",
  /** Entity vendors */
  ENTITY_VENDORS = "ENTITY_VENDORS",
  /** Collect bank account info about an entity in India */
  INDIA_BANK_INFO = "INDIA_BANK_INFO",
  /** Collect business info about an entity in India */
  INDIA_BUSINESS_INFO = "INDIA_BUSINESS_INFO",
  /** For internal user (Ops). */
  INTERNAL = "INTERNAL",
  /** Lending Disclosure */
  LENDING_DISCLOSURE = "LENDING_DISCLOSURE",
  LLM_AGENT = "LLM_AGENT",
  /** Business description */
  MAIN_ENTITY_CUSTOMERS = "MAIN_ENTITY_CUSTOMERS",
  /** Entity name and industry. */
  MAIN_ENTITY_DETAILS = "MAIN_ENTITY_DETAILS",
  /** Entity BO/CO and applicant. */
  MAIN_ENTITY_OWNERSHIP = "MAIN_ENTITY_OWNERSHIP",
  /** Middesk. */
  MIDDESK = "MIDDESK",
  /** Persona. */
  PERSONA = "PERSONA",
  /** PH LCC DLocal */
  PH_LCC_DLOCAL = "PH_LCC_DLOCAL",
  /** PH LFR DLocal */
  PH_LFR_DLOCAL = "PH_LFR_DLOCAL",
  /** PUP form. */
  PRODUCT_USAGE_PROFILE = "PRODUCT_USAGE_PROFILE",
  /** Screening. */
  SCREENING = "SCREENING",
  /** Source of funds */
  SOURCE_OF_FUNDS = "SOURCE_OF_FUNDS",
  /** Terms form. */
  TERMS = "TERMS",
  /** Collect underwriting details */
  UNDERWRITING_DETAILS = "UNDERWRITING_DETAILS",
}

/** Verification result */
export interface VerificationResult {
  /** Information to satisfy the verification that needs to be collected. */
  informationRequirement?: Maybe<RequirementInformation>;
  /** Status of the verification */
  status: VerificationAnalysisStatus;
  /**
   * Name of requirement to satisfy verification
   * Clients may start analyses with this requirement to complete verification
   */
  verificationRequirement?: Maybe<Scalars["String"]>;
}

export interface VerificationStartAnalysisInput {
  clientMutationId: Scalars["String"];
  /** Idempotency key for the request */
  idempotencyKey?: InputMaybe<Scalars["String"]>;
  /** Analysis' requirement name */
  requirement?: InputMaybe<Scalars["String"]>;
  /** ID of the Subject to run the analysis on */
  subjectId?: InputMaybe<Scalars["String"]>;
}

export interface VerificationStartAnalysisPayload {
  /** The started KYC analysis */
  analysis?: Maybe<Analysis>;
  clientMutationId: Scalars["String"];
}

export enum VerificationStatus {
  AUTOMATICALLY_VERIFIED = "AUTOMATICALLY_VERIFIED",
  FAILED_VERIFICATION = "FAILED_VERIFICATION",
  INVALID = "INVALID",
  MANUALLY_VERIFIED = "MANUALLY_VERIFIED",
  PENDING_AUTOMATIC_VERIFICATION = "PENDING_AUTOMATIC_VERIFICATION",
  PENDING_MANUAL_VERIFICATION = "PENDING_MANUAL_VERIFICATION",
}

export enum VerificationStatusType {
  AUTOMATICALLY_VERIFIED = "AUTOMATICALLY_VERIFIED",
  MANUALLY_VERIFIED = "MANUALLY_VERIFIED",
  PENDING_AUTOMATIC_VERIFICATION = "PENDING_AUTOMATIC_VERIFICATION",
  PENDING_MANUAL_VERIFICATION = "PENDING_MANUAL_VERIFICATION",
  VERIFICATION_EXPIRED = "VERIFICATION_EXPIRED",
  VERIFICATION_FAILED = "VERIFICATION_FAILED",
}

/**
 * Tagged input of request submissions.
 * Only one top level field should be populated.
 */
export interface VerificationSubmissionPayload {
  airwallexHostedFlowPayload?: InputMaybe<AirwallexHostedFlowPayloadInput>;
  backupWithholdingSubmissionPayload?: InputMaybe<BackupWithholdingSubmissionPayloadInput>;
  boRefreshSubmissionPayload?: InputMaybe<BORefreshSubmissionPayloadInput>;
  brDLocalPayload?: InputMaybe<BRDLocalPayloadInput>;
  businessCipRefreshPayload?: InputMaybe<BusinessCipRefreshPayloadInput>;
  combinedTermsSubmissionPayload?: InputMaybe<CombinedTermsSubmissionPayloadInput>;
  documentsSubmissionPayload?: InputMaybe<DocumentsSubmissionPayloadInput>;
  eddAttestationPayload?: InputMaybe<EddAttestationPayloadInput>;
  entityAddressPayload?: InputMaybe<EntityAddressPayloadInput>;
  entityCorporateStructurePayload?: InputMaybe<EntityCorporateStructurePayloadInput>;
  entityCustomersPayload?: InputMaybe<EntityCustomersPayloadInput>;
  entityDetailsPayload?: InputMaybe<EntityDetailsPayloadInput>;
  entityEinPayload?: InputMaybe<EntityEinPayloadInput>;
  entityFundingSourcePayload?: InputMaybe<EntityFundingSourcePayloadInput>;
  entityIncorporationDetailsPayload?: InputMaybe<EntityIncorporationDetailsPayloadInput>;
  entityOwnershipPayload?: InputMaybe<EntityOwnershipPayloadInput>;
  entityPublicCompanyDetailsPayload?: InputMaybe<EntityPublicCompanyDetailsPayloadInput>;
  entityVendorsPayload?: InputMaybe<EntityVendorsPayloadInput>;
  indiaBankInfoSubmissionPayload?: InputMaybe<IndiaBankInfoSubmissionPayloadInput>;
  indiaBusinessInfoSubmissionPayload?: InputMaybe<IndiaBusinessInfoSubmissionPayloadInput>;
  individualSubmissionPayload?: InputMaybe<IndividualSubmissionPayloadInput>;
  jsonSchemaSubmissionPayload?: InputMaybe<JsonSchemaSubmissionPayloadInput>;
  lendingDisclosurePayload?: InputMaybe<LendingDisclosurePayloadInput>;
  mainEntityCustomersPayload?: InputMaybe<MainEntityCustomersPayloadInput>;
  mainEntityDetailsPayload?: InputMaybe<MainEntityDetailsPayloadInput>;
  mainEntityOwnershipPayload?: InputMaybe<MainEntityOwnershipPayloadInput>;
  personaSubmissionPayload?: InputMaybe<PersonaSubmissionPayloadInput>;
  phLFRDLocalPayload?: InputMaybe<PHLFRDLocalPayloadInput>;
  productUsageProfileSubmissionPayload?: InputMaybe<ProductUsageProfileSubmissionPayloadInput>;
  sourceOfFundsPayload?: InputMaybe<SourceOfFundsPayloadInput>;
  termsSubmissionPayload?: InputMaybe<TermsSubmissionPayloadInput>;
  underwritingDetailsPayload?: InputMaybe<UnderwritingDetailsPayloadInput>;
}

export interface VerifyAddressInput {
  /** Address to verify */
  address: AddressInput;
}

export interface VerifyAddressResponse extends Node {
  /** The ID of an object */
  id: Scalars["ID"];
  /** True if this address is deliverable */
  isDeliverable: Scalars["Boolean"];
  /** True if this address is deliverable based on Lob results */
  isDeliverableV2: Scalars["Boolean"];
  /** True if this address is a PO box or a General Delivery address */
  isPoBox: Scalars["Boolean"];
  /** The standardized address */
  suggestion: Address;
}

export interface VerifyAddressResult {
  /** True if this address is deliverable */
  isDeliverable: Scalars["Boolean"];
  /** True if this address is deliverable based on Lob results */
  isDeliverableV2: Scalars["Boolean"];
  /** True if this address is a PO box or a General Delivery address */
  isPoBox: Scalars["Boolean"];
  /** The standardized address */
  suggestion: Address;
}

export enum VisibilityExpenseType {
  BILLPAY = "BILLPAY",
  CARD = "CARD",
  CLAWBACK = "CLAWBACK",
  REIMBURSEMENT = "REIMBURSEMENT",
}

export interface VisibilityExtendedFieldValueInput {
  /** The identifier id from the extended field option encoded as a Global Id */
  encodedIdentifier: Scalars["ID"];
  /** The id from the extended field to consider */
  extendedFieldId: Scalars["ID"];
}

/** Visibility Rule Condition for an Extended Field or Extended Field Option */
export interface VisibilityRuleCondition {
  /** The left hand side operand for this condition */
  leftHandSide: LeftHandSide;
  /** The operator to use for the condition */
  operator: FilterOperator;
  /** The value that needs to match the filter based on the operator. Right hand side operand for this condition */
  rightHandSide: RightHandSide;
}

/** Specific input fields for creating an extended field visibility rule conditions */
export interface VisibilityRuleConditionInput {
  /** The left hand side operand for this condition */
  leftHandSide: LeftHandSideOneOfInput;
  /** The operator to use for the condition */
  operator: FilterOperator;
  /** The value that needs to match the filter based on the operator. Right hand side operand for this condition */
  rightHandSide: RightHandSideOneOfInput;
}

export interface VisibilityRuleData {
  /** The visibility rule data for expense object creation */
  expenseCreationData?: InputMaybe<VisibilityRuleExpenseCreationData>;
  /** The visibility rule data for an expense object */
  expenseData?: InputMaybe<VisibilityRuleExpenseData>;
}

export interface VisibilityRuleExpenseCreationData {
  /** The ID of the budget we want to use. */
  budgetId?: InputMaybe<Scalars["ID"]>;
  /** The expense type. */
  expenseType: VisibilityExpenseType;
  /** The list with field values IDs. */
  extendedFieldValues?: InputMaybe<
    Array<InputMaybe<VisibilityExtendedFieldValueInput>>
  >;
}

export interface VisibilityRuleExpenseData {
  /** The expense id. */
  expenseId: Scalars["ID"];
}

export interface VisibilityRuleExtendedFieldOption {
  /** The option's display name */
  displayName: Scalars["String"];
  /** The ID of the option */
  id: Scalars["ID"];
}

export interface VisibilityRuleExtendedFieldOptionInput {
  /** The ID of the option */
  id: Scalars["ID"];
}

export interface VisibilityRuleInput {
  leftHandSide: LeftHandSideOneOfInput;
  rightHandSide: RightHandSideOneOfInput;
}

export interface VisibilityRuleInputPair {
  /** The extended field id associated with the visibility rule. */
  extendedFieldId: Scalars["ID"];
  /** The visibility rule input. */
  visibilityRuleInput: VisibilityRuleInput;
}

export interface VisibilityRuleInputParams {
  /** The ID of the budget we want to use. */
  budgetId?: InputMaybe<Scalars["ID"]>;
  /** The expense type. */
  expenseType?: InputMaybe<VisibilityExpenseType>;
  /** The list with field values IDs. */
  extendedFieldValues?: InputMaybe<
    Array<InputMaybe<VisibilityExtendedFieldValueInput>>
  >;
}

export interface VisibilityRuleInputs {
  /** The role that visibility rules are being evaluated for. */
  role?: InputMaybe<ExtendedFieldVisibilityRuleRole>;
  /** The visibility rule inputs. */
  visibilityRuleInputPairs?: InputMaybe<Array<VisibilityRuleInputPair>>;
  /** The visibility rule input params, used to build visibility rule input pairs on the backend. */
  visibilityRuleInputParams?: InputMaybe<VisibilityRuleInputParams>;
  /** The visibility rule origins. */
  visibilityRuleOrigins?: InputMaybe<Array<ExtendedFieldVisibilityRuleOrigin>>;
}

export type VisibilityRuleResult =
  | ExtendedFieldOptionRuleResult
  | ExtendedFieldRuleResult;

/** Specific input fields for creating an extended field visibility rule result */
export interface VisibilityRuleResultOneOfInput {
  /** Extended field option rule result type. */
  extendedFieldOptionRuleResult?: InputMaybe<ExtendedFieldOptionRuleResultInput>;
  /** Extended field rule result type. */
  extendedFieldRuleResult?: InputMaybe<ExtendedFieldRuleResultInput>;
}

/** Filter ANDs the different set fields together. */
export interface VisibleOptionsFilterInput {
  /** Display name to query for. Is an ilike query. */
  displayName?: InputMaybe<Scalars["String"]>;
  /** The identifiers of the options to include. Should be a decoded string. */
  identifiers?: InputMaybe<Array<Scalars["String"]>>;
  /** The IDs of the options to include. */
  ids?: InputMaybe<Array<Scalars["ID"]>>;
  /** Filter options by remote Ids, where remote ID is the ID generated by the external system (e.g. ERP or HRIS system). */
  remoteIds?: InputMaybe<Array<Scalars["String"]>>;
  /**
   * Filter options by User Category (GL Account) extension values.
   * Setting this filter will exclude all options that do not contain a UserCategoryOptionExtension.
   */
  userCategoryOptionExtension?: InputMaybe<UserCategoryOptionExtensionFilterInput>;
  /** Filter options by value Ids, where value ID is a globally unique identifier across all remote systems (eg. EPR or HRIS system). */
  valueIds?: InputMaybe<Array<Scalars["String"]>>;
}

export interface WeekAndDayMonthlyScheduleRuleInput {
  /** The day of the week when the schedule will be triggered. */
  dayOfWeek: RecurringScheduleBusinessDays;
  /**
   * The date when the recurring will end.
   * null means infinite (until user cancels)
   */
  endAt?: InputMaybe<Scalars["Time"]>;
  /** The number of months between being triggered e.g. every 2 months -> interval = 2 */
  interval: Scalars["Int"];
  /**
   * The number of instances of the recurring schedule that will be triggered.
   * null means infinite (until user cancels)
   */
  numInstances?: InputMaybe<Scalars["Int"]>;
  /** The week of the month when the schedule will be triggered. */
  weekOfMonth: Scalars["Int"];
}

export interface WeekAndDayMonthlyScheduleSpec extends RecurringScheduleSpec {
  /** The day of the week when the schedule will be triggered. */
  dayOfWeek: RecurringScheduleBusinessDays;
  /**
   * The date when the recurring will end.
   * null means infinite (until user cancels)
   */
  endAt?: Maybe<Scalars["Time"]>;
  /** Cadence of the recurring schedule, e.g. every 1 week -> interval = 1 */
  interval: Scalars["Int"];
  /**
   * The number of instances of the recurring schedule that will be triggered.
   * null means infinite (until user cancels)
   */
  numInstances?: Maybe<Scalars["Int"]>;
  /** The week of the month when the schedule will be triggered. */
  weekOfMonth: Scalars["Int"];
}

export interface WeeklyClosingStrategy {
  dayOfWeek?: Maybe<Scalars["Int"]>;
}

export interface WeeklyDetails {
  /**
   * Day of the week (1 is Sunday...7 is Saturday)
   * https://hexdocs.pm/elixir/1.12/Date.html#day_of_week/2
   */
  dayOfWeek?: Maybe<Scalars["Int"]>;
}

export interface WeeklySchedule {
  dayOfWeek: BusinessDays;
  nWeeks: Scalars["Int"];
}

export interface WeeklyScheduleInput {
  dayOfWeek: BusinessDays;
  nWeeks: Scalars["Int"];
}

export interface WeeklyScheduleRuleInput {
  /**
   * The day of the week when the schedule will be triggered.
   * Only weekdays should be passed
   */
  dayOfWeek: RecurringScheduleBusinessDays;
  /**
   * The date when the recurring will end.
   * null means infinite (until user cancels)
   */
  endAt?: InputMaybe<Scalars["Time"]>;
  /** The number of weeks between being triggered e.g. every 2 weeks -> interval = 2 */
  interval: Scalars["Int"];
  /**
   * The number of instances of the recurring schedule that will be triggered.
   * null means infinite (until user cancels)
   */
  numInstances?: InputMaybe<Scalars["Int"]>;
}

export interface WeeklyScheduleSpec extends RecurringScheduleSpec {
  /**
   * The day of the week when the schedule will be triggered.
   * Only weekdays should be passed
   */
  dayOfWeek: RecurringScheduleBusinessDays;
  /**
   * The date when the recurring will end.
   * null means infinite (until user cancels)
   */
  endAt?: Maybe<Scalars["Time"]>;
  /** Cadence of the recurring schedule, e.g. every 1 week -> interval = 1 */
  interval: Scalars["Int"];
  /**
   * The number of instances of the recurring schedule that will be triggered.
   * null means infinite (until user cancels)
   */
  numInstances?: Maybe<Scalars["Int"]>;
}

export interface WidgetBalanceAndCashFlow {
  balanceHistory: LineMetricsGraph;
  cashflowHistory?: Maybe<WidgetCashFlowSummary>;
  description?: Maybe<WidgetDescription>;
  title: Scalars["String"];
  value: Scalars["String"];
}

export interface WidgetCashFlowSummaries {
  last3MonthsSummary?: Maybe<WidgetCashFlowSummary>;
  last6MonthsSummary?: Maybe<WidgetCashFlowSummary>;
  last12MonthsSummary?: Maybe<WidgetCashFlowSummary>;
}

export interface WidgetCashFlowSummary {
  monthlyCashFlowBreakdowns?: Maybe<Array<CashFlowsSummary>>;
  overallCashFlow: Scalars["Float"];
}

/** Deprecated, use account.creditLimitOverview query to retrieve the information */
export interface WidgetCreditLimitData {
  autopayDate?: Maybe<Scalars["Time"]>;
  balanceAmount: FinancialAsset;
  limitAmount: FinancialAsset;
  pendingAmount: FinancialAsset;
}

export type WidgetDescription = CashFlowsSummary | TotalInterestEarnedSummary;

export interface WidgetPercentageData {
  displayText: Scalars["String"];
  title: Scalars["String"];
  utilizationPercentage: Scalars["Float"];
  utilizationText?: Maybe<Scalars["String"]>;
}

export interface WidgetRewardsCard {
  iconName: Scalars["String"];
  pointsToUnlock: Scalars["Int"];
  redeemUrl: Scalars["String"];
  redemptionAmount?: Maybe<Scalars["Float"]>;
  title: Scalars["String"];
}

export interface WidgetRewardsCards {
  cards: Array<Maybe<WidgetRewardsCard>>;
  currentRewardsBalance: Scalars["Int"];
}

export interface WidgetRewardsMilestones {
  currentRewardsBalance: Scalars["Int"];
  milestones?: Maybe<Array<RewardsMilestone>>;
  nextRewardsReminder: Scalars["String"];
}

export interface WidgetTableColumn {
  entityId?: Maybe<Scalars["String"]>;
  iconName?: Maybe<Scalars["String"]>;
  text: Scalars["String"];
}

export interface WidgetTableRow {
  columns?: Maybe<Array<WidgetTableColumn>>;
  ctaUrl?: Maybe<Scalars["String"]>;
}

export interface WidgetTabularData {
  rows?: Maybe<Array<WidgetTableRow>>;
  title?: Maybe<Scalars["String"]>;
}

export interface WidgetTemplatesFilter {
  /** Deposits account ID. If not provided, the widget will be rendered for all deposits accounts. */
  depositsAccountId?: InputMaybe<Scalars["ID"]>;
}

export interface WidgetTimeSeriesData {
  description?: Maybe<WidgetDescription>;
  lineGraph: LineMetricsGraph;
  title: Scalars["String"];
  value: Scalars["String"];
}

export interface WidgetTransaction {
  amount: Scalars["Float"];
  ctaUrl: Scalars["String"];
  sourceAccountName: Scalars["String"];
  targetAccountName: Scalars["String"];
}

export interface WidgetTransactionsData {
  transactions?: Maybe<Array<WidgetTransaction>>;
}

/** Enum type for widget. this will help indicate what widgets to be rendered */
export enum WidgetType {
  /**
   *  These types are no longer supported
   * @deprecated No longer supported
   */
  ACCOUNTING = "ACCOUNTING",
  ACCOUNT_HEALTH = "ACCOUNT_HEALTH",
  BALANCE_AND_CASH_FLOW = "BALANCE_AND_CASH_FLOW",
  /** @deprecated No longer supported */
  BANK_BALANCE = "BANK_BALANCE",
  /** @deprecated No longer supported */
  CASH_FLOW = "CASH_FLOW",
  CREDIT_LIMIT = "CREDIT_LIMIT",
  /** @deprecated No longer supported */
  RECENT_TRANSACTIONS = "RECENT_TRANSACTIONS",
  REWARDS = "REWARDS",
  SPEND_BY_CATEGORY = "SPEND_BY_CATEGORY",
  YIELD_BREAKDOWN = "YIELD_BREAKDOWN",
}

export interface WidgetYieldBreakdown {
  gaugeData?: Maybe<Array<Maybe<GaugeData>>>;
  isCustomTier?: Maybe<Scalars["Boolean"]>;
  liveTotalPosition?: Maybe<FinancialAsset>;
  nextDividendPayoutDate?: Maybe<Scalars["String"]>;
  postedTier?: Maybe<AdditionalReturnTier>;
  postedTotalPosition?: Maybe<FinancialAsset>;
}

export interface WireBank {
  beneficiaryAccountNumber: Scalars["String"];
  beneficiaryAccountType: Scalars["String"];
  beneficiaryCity: Scalars["String"];
  beneficiaryName: Scalars["String"];
  beneficiaryState: Scalars["String"];
  beneficiaryStreet: Scalars["String"];
  beneficiarySuite: Scalars["String"];
  beneficiaryZip: Scalars["String"];
  city: Scalars["String"];
  name: Scalars["String"];
  state: Scalars["String"];
  street: Scalars["String"];
  suite: Scalars["String"];
  swiftCode: Scalars["String"];
  swiftRoutingNumber?: Maybe<Scalars["String"]>;
  zip: Scalars["String"];
}

export interface WireDetails {
  /** For a returned wire, this is the difference between the original wire amount vs what was actually returned back due to the beneficiary bank taking a fee. */
  amountDriftUsdCents?: Maybe<Scalars["Int"]>;
  /** The sending bank's reference number for this wire (F20 of the MT103) */
  bankReferenceNumber?: Maybe<Scalars["String"]>;
  counterparty: Counterparty;
  endToEndId?: Maybe<Scalars["String"]>;
  estimatedOn: Scalars["Time"];
  estimatedOnLatest?: Maybe<Scalars["Time"]>;
  fedReferenceNumber?: Maybe<Scalars["String"]>;
  imad?: Maybe<Scalars["String"]>;
  initiatorCustomerUser?: Maybe<User>;
  method: Method;
  mt103?: Maybe<Scalars["String"]>;
  omad?: Maybe<Scalars["String"]>;
  origin: Origin;
  transferDescription?: Maybe<Scalars["String"]>;
}

export interface WireDrawdownAuthorization {
  /** the user who created the drawdown authorization */
  authorizedByCustomerUserId?: Maybe<Scalars["String"]>;
  /** the deposit account id of the drawdown authorization */
  depositsAccountId: Scalars["ID"];
  /** Id of the drawdown authorization */
  id: Scalars["ID"];
  /** idempotency key of the drawdown authorization */
  idempotencyKey: Scalars["String"];
  /** maximum amount of the drawdown authorization */
  maxAuthorizationAmountUsdCents?: Maybe<Scalars["Int"]>;
  /** pdf download URL of the drawdown authorization */
  pdfUrl?: Maybe<Scalars["String"]>;
  /** the rail account details associated with this drawdown authorization */
  railAccountDetails?: Maybe<RailAccountDetails>;
  /** if rescinded, timestamp of the rescinded time */
  rescindedAt?: Maybe<Scalars["Time"]>;
  /** the user who rescinded the drawdown authorization */
  rescindedByCustomerUserId?: Maybe<Scalars["String"]>;
}

export interface WithdrawFundsInput {
  clientMutationId: Scalars["String"];
  depositsAccountId: Scalars["ID"];
  financialsAccountId: Scalars["ID"];
  idempotencyKey: Scalars["String"];
}

export interface WithdrawFundsPayload {
  clientMutationId: Scalars["String"];
  payment: DepositsPayment;
}

export interface WorkdayAuthPayloadInput {
  /** Workday account host */
  host?: InputMaybe<Scalars["String"]>;
  /** Workday account password */
  password?: InputMaybe<Scalars["String"]>;
  /** Workday account tenant */
  tenant?: InputMaybe<Scalars["String"]>;
  /** Workday account username */
  username?: InputMaybe<Scalars["String"]>;
}

/** user categories in Workday payload */
export interface WorkdayCategories {
  /** Accounts Payable */
  accountsPayableUserCategory?: Maybe<UserCategory>;
  /** awx wallet user category */
  awxWalletUserCategory?: Maybe<UserCategory>;
  /** Cash/Bank Account for collections */
  collectionTargetUserCategory?: Maybe<UserCategory>;
  /** personal expense user category */
  personalExpenseUserCategory?: Maybe<UserCategory>;
  /** reimbursement accrual basis accounting user category */
  reimbursementClearingUserCategory?: Maybe<UserCategory>;
  /** reimbursements user category */
  reimbursementsUserCategory?: Maybe<UserCategory>;
  /** Rewards */
  rewardsIncomeUserCategory?: Maybe<UserCategory>;
  /** vendor name - always 'workday' */
  vendorName?: Maybe<Scalars["String"]>;
}

export interface WorkdayPayload {
  host?: Maybe<Scalars["String"]>;
  password?: Maybe<Scalars["String"]>;
  tenant?: Maybe<Scalars["String"]>;
  username?: Maybe<Scalars["String"]>;
}

/** The specific Workflow this Rule is associated with */
export enum Workflow {
  /**
   * The workflow for Accounting Rules
   * Allows automatic categorization of Expenses and Accounting Records
   * Powers the Accounting Mappings page as well as Accounting Custom Rules page
   *
   * Required tag: `accounting_integration_id`
   */
  ACCOUNTING = "ACCOUNTING",
  /**
   * The workflow for Budget Override Rules
   * Overrides change the default categories for expenses in this budget and its nested budgets.
   * Powers the Budget Overrides tab in the advanced settings page for Budgets
   *
   * Required tag: `budget_id`
   */
  BUDGET_OVERRIDE = "BUDGET_OVERRIDE",
}

export interface WorkflowAccountingRecordExportActionDescriptor
  extends WorkflowActionDescriptor {
  description?: Maybe<Scalars["String"]>;
  restrictedAttributes?: Maybe<Array<WorkflowAttribute>>;
  title: Scalars["String"];
  unsupportedAttributes?: Maybe<Array<WorkflowAttribute>>;
}

export interface WorkflowAccountingRecordPrepareActionDescriptor
  extends WorkflowActionDescriptor {
  description?: Maybe<Scalars["String"]>;
  restrictedAttributes?: Maybe<Array<WorkflowAttribute>>;
  title: Scalars["String"];
  unsupportedAttributes?: Maybe<Array<WorkflowAttribute>>;
}

export interface WorkflowActionDescriptor {
  /** The description of the action */
  description?: Maybe<Scalars["String"]>;
  /**
   * The super set of attributes that support this action (this action is restricted to the listed attributes)
   * For example, rules that lead to block spend can only leverage amount and category
   */
  restrictedAttributes?: Maybe<Array<WorkflowAttribute>>;
  /** The title of the action */
  title: Scalars["String"];
  /**
   * The set of attributes that are not supported by this action
   * For example, ListAttendees action does not support the attendee list attribute
   */
  unsupportedAttributes?: Maybe<Array<WorkflowAttribute>>;
}

/**
 * This schema is supposed to be used to reference the attributes in the requests-dgs.
 * We had to split the definitions since the schema is being copied between requests (workflow owner) and
 * other client APIs (for instance policies). Since sharing the schema means essentially copying the
 * DGS graph, splitting the definition will allow the clients to use a copy of the MatchConditions
 * while using references to the WorkflowAttribute which the conditions depend on.
 */
export type WorkflowAttribute =
  | WorkflowBooleanAttribute
  | WorkflowDurationAttribute
  | WorkflowEnumeratedAttribute
  | WorkflowEnumeratedListAttribute
  | WorkflowFinancialAssetAttribute
  | WorkflowIdentifierAttribute
  | WorkflowLocationAttribute
  | WorkflowNumberAttribute
  | WorkflowStringAttribute;

export interface WorkflowAttributeConnection extends Connection {
  edges: Array<WorkflowAttributeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"];
}

/**  ---------------- WORKFLOW ATTRIBUTE TYPES ---------------------- */
export interface WorkflowAttributeDescriptor {
  /**
   * The attributes which this can be paired with.
   * If null, can be paired with any attribute.
   */
  allowedPairingAttributes?: Maybe<Array<WorkflowAttribute>>;
  /** The identifier of the attribute in policy-engine */
  attributeIdentifier?: Maybe<Scalars["String"]>;
  /** The description of the attribute */
  description?: Maybe<Scalars["String"]>;
  /** The extended field that this attribute is associated with */
  extendedField?: Maybe<ExtendedField>;
  /** The id of the attribute */
  id: Scalars["ID"];
  /**
   * Defines requirements for an attribute.
   * - If null or empty, attribute has no requirements.
   * - If an attribute has requirements, all of them must be met, on the currently selected rule, for the attribute
   *   to be selectable.
   */
  requirements?: Maybe<Array<WorkflowAttributeRequirement>>;
  /** The title of the attribute */
  title: Scalars["String"];
}

/**  ---------------- WORKFLOW ATTRIBUTE TYPES ---------------------- */
export interface WorkflowAttributeDescriptorallowedPairingAttributesArgs {
  workflowEntity: WorkflowEntity;
}

export interface WorkflowAttributeEdge {
  cursor?: Maybe<Scalars["String"]>;
  node: WorkflowAttribute;
}

/**
 * An attribute group is a collection of workflow attributes that are grouped together depending on the workflow entity and
 * entity type. This is just a way to aggregate the already available workflow attributes that we expose in the API.
 */
export interface WorkflowAttributeGroup extends Node {
  entityType: WorkflowEntity;
  /** The ID of an object */
  id: Scalars["ID"];
  title: Scalars["String"];
  workflowAttributes?: Maybe<WorkflowAttributeConnection>;
}

/**
 * An attribute group is a collection of workflow attributes that are grouped together depending on the workflow entity and
 * entity type. This is just a way to aggregate the already available workflow attributes that we expose in the API.
 */
export interface WorkflowAttributeGroupworkflowAttributesArgs {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
  last?: InputMaybe<Scalars["Int"]>;
  where?: InputMaybe<WorkflowAttributeWhereFilterInput>;
}

/**  ----------------- WORKFLOW ATTRIBUTE GROUP TYPES ---------------------- */
export interface WorkflowAttributeGroupConnection extends Connection {
  edges: Array<WorkflowAttributeGroupEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"];
}

export interface WorkflowAttributeGroupEdge {
  cursor?: Maybe<Scalars["String"]>;
  node: WorkflowAttributeGroup;
}

/** Allow filtering groups recursively based on the entity type and the group id */
export interface WorkflowAttributeGroupWhereFilterInput {
  and?: InputMaybe<Array<WorkflowAttributeGroupWhereFilterInput>>;
  entityType?: InputMaybe<WorkflowEntityFilterInput>;
  group?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<WorkflowAttributeGroupWhereFilterInput>;
  or?: InputMaybe<Array<WorkflowAttributeGroupWhereFilterInput>>;
}

export interface WorkflowAttributeRequirement {
  attributes: Array<WorkflowAttribute>;
  requirement: WorkflowAttributeRequirementType;
}

export enum WorkflowAttributeRequirementType {
  ANY_OF = "ANY_OF",
}

/** Allow filtering attributes recursively based on the entity type and text in the attribute title */
export interface WorkflowAttributeWhereFilterInput {
  and?: InputMaybe<Array<WorkflowAttributeWhereFilterInput>>;
  entityType?: InputMaybe<WorkflowEntityFilterInput>;
  group?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<WorkflowAttributeWhereFilterInput>;
  or?: InputMaybe<Array<WorkflowAttributeWhereFilterInput>>;
  text?: InputMaybe<StringFilterInput>;
}

/** Logic operators supported by a workflow. */
export enum WorkflowBlockLogicOperator {
  AND = "AND",
  OR = "OR",
}

export interface WorkflowBlockOneOfInput {
  bookingAllowActionBlock?: InputMaybe<WorkflowBookingAllowActionBlockInput>;
  bookingFlagOutOfPolicyActionBlock?: InputMaybe<WorkflowBookingFlagOutOfPolicyActionBlockInput>;
  bookingRequireApprovalActionBlock?: InputMaybe<WorkflowBookingRequireApprovalActionBlockInput>;
  bookingSendNotificationActionBlock?: InputMaybe<WorkflowBookingSendNotificationActionBlockInput>;
  booleanMatchCondition?: InputMaybe<WorkflowBooleanMatchConditionInput>;
  durationMatchCondition?: InputMaybe<WorkflowDurationMatchConditionInput>;
  enumeratedListMatchCondition?: InputMaybe<WorkflowEnumeratedListMatchConditionInput>;
  enumeratedMatchCondition?: InputMaybe<WorkflowEnumeratedMatchConditionInput>;
  expenseBlockSpendActionBlock?: InputMaybe<WorkflowExpenseBlockSpendActionBlockInput>;
  expenseDoNotRequireActionBlock?: InputMaybe<WorkflowExpenseDoNotRequireActionBlockInput>;
  expenseGenerateAutoMemoActionBlock?: InputMaybe<WorkflowExpenseGenerateAutoMemoActionBlockInput>;
  expenseRequestReviewActionBlock?: InputMaybe<WorkflowExpenseRequestReviewActionBlockInput>;
  expenseRequireAttendeesActionBlock?: InputMaybe<WorkflowExpenseRequireAttendeesActionBlockInput>;
  expenseRequireExtendedFieldsActionBlock?: InputMaybe<WorkflowExpenseRequireExtendedFieldsActionBlockInput>;
  expenseRequireInvoiceActionBlock?: InputMaybe<WorkflowExpenseRequireInvoiceActionBlockInput>;
  expenseRequireMemoActionBlock?: InputMaybe<WorkflowExpenseRequireMemoActionBlockInput>;
  expenseRequireReceiptActionBlock?: InputMaybe<WorkflowExpenseRequireReceiptActionBlockInput>;
  financialAssetFunctionMatchCondition?: InputMaybe<WorkflowFinancialAssetFunctionMatchConditionInput>;
  financialAssetMatchCondition?: InputMaybe<WorkflowFinancialAssetMatchConditionInput>;
  identifierMatchCondition?: InputMaybe<WorkflowIdentifierMatchConditionInput>;
  locationMatchCondition?: InputMaybe<WorkflowLocationMatchConditionInput>;
  logicalOperatorConditionBlock?: InputMaybe<WorkflowLogicOperatorConditionBlockInput>;
  numberMatchCondition?: InputMaybe<WorkflowNumberMatchConditionInput>;
  parallelBlock?: InputMaybe<WorkflowParallelBlockInput>;
  stringMatchCondition?: InputMaybe<WorkflowStringMatchConditionInput>;
}

/** We can allow users to book even if the booking was flagged as out of policy */
export interface WorkflowBookingAllowActionBlock extends IWorkflowBlock {
  key: Scalars["String"];
  nextKey?: Maybe<Scalars["String"]>;
}

/** We can allow users to book even if the booking was flagged as out of policy */
export interface WorkflowBookingAllowActionBlockInput {
  key: Scalars["String"];
  nextKey?: InputMaybe<Scalars["String"]>;
}

export interface WorkflowBookingAllowActionDescriptor
  extends WorkflowActionDescriptor {
  description?: Maybe<Scalars["String"]>;
  restrictedAttributes?: Maybe<Array<WorkflowAttribute>>;
  title: Scalars["String"];
  unsupportedAttributes?: Maybe<Array<WorkflowAttribute>>;
}

/** For each booking rule the only action allowed is flag as out of policy given Spotnana only accepts the action on booking type level */
export interface WorkflowBookingFlagOutOfPolicyActionBlock
  extends IWorkflowBlock {
  key: Scalars["String"];
  nextKey?: Maybe<Scalars["String"]>;
}

/** For each booking rule the only action allowed is flag as out of policy given spotnana only accept the action on booking type level */
export interface WorkflowBookingFlagOutOfPolicyActionBlockInput {
  key: Scalars["String"];
  nextKey?: InputMaybe<Scalars["String"]>;
}

export interface WorkflowBookingFlagOutOfPolicyActionDescriptor
  extends WorkflowActionDescriptor {
  description?: Maybe<Scalars["String"]>;
  restrictedAttributes?: Maybe<Array<WorkflowAttribute>>;
  title: Scalars["String"];
  unsupportedAttributes?: Maybe<Array<WorkflowAttribute>>;
}

/**
 * Require review from users & departments & levels or roles.
 * Should never return less than 1 item in one section (API should throw).
 */
export interface WorkflowBookingRequireApprovalActionBlock
  extends IWorkflowBlock {
  approvalSteps: Array<WorkflowExpenseRequestReviewApprovalChainStep>;
  key: Scalars["String"];
  nextKey?: Maybe<Scalars["String"]>;
}

/**
 * Require review from users & departments & levels or roles.
 * it's different from normal require review because we trigger a different set of actions
 * Should never return less than 1 item in one section (API should throw).
 */
export interface WorkflowBookingRequireApprovalActionBlockInput {
  approvalSteps: Array<WorkflowExpenseRequestReviewApprovalChainStepInput>;
  key: Scalars["String"];
  nextKey?: InputMaybe<Scalars["String"]>;
}

export interface WorkflowBookingRequireApprovalActionDescriptor
  extends WorkflowActionDescriptor {
  description?: Maybe<Scalars["String"]>;
  restrictedAttributes?: Maybe<Array<WorkflowAttribute>>;
  title: Scalars["String"];
  unsupportedAttributes?: Maybe<Array<WorkflowAttribute>>;
}

/**
 * Require review from users & departments & levels or roles.
 * Although we display as send notification, the people notified can perform a review on the booking and approve or deny it.
 * Should never return less than 1 item in one section (API should throw).
 */
export interface WorkflowBookingSendNotificationActionBlock
  extends IWorkflowBlock {
  approvalSteps: Array<WorkflowExpenseRequestReviewApprovalChainStep>;
  key: Scalars["String"];
  nextKey?: Maybe<Scalars["String"]>;
}

/**
 * Require review from users & departments & levels or roles.
 * Although we display as send notification, the people notified can perform a review on the booking and approve or deny it.
 * Should never return less than 1 item in one section (API should throw).
 */
export interface WorkflowBookingSendNotificationActionBlockInput {
  approvalSteps: Array<WorkflowExpenseRequestReviewApprovalChainStepInput>;
  key: Scalars["String"];
  nextKey?: InputMaybe<Scalars["String"]>;
}

export interface WorkflowBookingSendNotificationActionDescriptor
  extends WorkflowActionDescriptor {
  description?: Maybe<Scalars["String"]>;
  restrictedAttributes?: Maybe<Array<WorkflowAttribute>>;
  title: Scalars["String"];
  unsupportedAttributes?: Maybe<Array<WorkflowAttribute>>;
}

export interface WorkflowBooleanAttribute
  extends ExpensePolicyWorkflowAttributeDescriptor,
    Node,
    WorkflowAttributeDescriptor {
  allowedPairingAttributes?: Maybe<Array<WorkflowAttribute>>;
  attributeIdentifier?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  extendedField?: Maybe<ExtendedField>;
  /** The ID of an object */
  id: Scalars["ID"];
  isAI: Scalars["Boolean"];
  requirements?: Maybe<Array<WorkflowAttributeRequirement>>;
  title: Scalars["String"];
}

export interface WorkflowBooleanAttributeallowedPairingAttributesArgs {
  workflowEntity: WorkflowEntity;
}

export interface WorkflowBooleanAttributeInput {
  id: Scalars["ID"];
}

/** Matches a boolean. */
export interface WorkflowBooleanMatchCondition extends IMatchCondition {
  /** The boolean attribute to compare from. */
  attribute: WorkflowBooleanAttribute;
  /** The condition key for this condition */
  conditionKey: Scalars["String"];
  /** The value to compare to. */
  value: Scalars["Boolean"];
}

/** Matches a boolean. */
export interface WorkflowBooleanMatchConditionInput {
  /** The boolean attribute to compare from. */
  attribute: WorkflowBooleanAttributeInput;
  /** The condition key for this condition */
  conditionKey: Scalars["String"];
  /** The value to compare to. */
  value: Scalars["Boolean"];
}

export interface WorkflowBooleanValue extends WorkflowValue {
  boolValue?: Maybe<Scalars["Boolean"]>;
  hasConflict: Scalars["Boolean"];
  rule?: Maybe<WorkflowRule>;
}

export interface WorkflowCostCenterInput {
  id: Scalars["ID"];
}

export interface WorkflowDateValue extends WorkflowValue {
  dateValue?: Maybe<Scalars["Date"]>;
  hasConflict: Scalars["Boolean"];
  rule?: Maybe<WorkflowRule>;
}

export interface WorkflowDecimalValue extends WorkflowValue {
  decimalValue?: Maybe<Scalars["Decimal"]>;
  hasConflict: Scalars["Boolean"];
  rule?: Maybe<WorkflowRule>;
}

export interface WorkflowDepartmentInput {
  id: Scalars["ID"];
}

export interface WorkflowDurationAttribute
  extends ExpensePolicyWorkflowAttributeDescriptor,
    Node,
    WorkflowAttributeDescriptor {
  allowedPairingAttributes?: Maybe<Array<WorkflowAttribute>>;
  attributeIdentifier?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  enabledUnits?: Maybe<Array<WorkflowDurationUnit>>;
  extendedField?: Maybe<ExtendedField>;
  /** The ID of an object */
  id: Scalars["ID"];
  isAI: Scalars["Boolean"];
  requirements?: Maybe<Array<WorkflowAttributeRequirement>>;
  title: Scalars["String"];
}

export interface WorkflowDurationAttributeallowedPairingAttributesArgs {
  workflowEntity: WorkflowEntity;
}

export interface WorkflowDurationAttributeInput {
  id: Scalars["ID"];
}

/** Operators that can be used to match a duration. */
export enum WorkflowDurationAttributeOperator {
  EQUALS = "EQUALS",
  GREATER_THAN = "GREATER_THAN",
  GREATER_THAN_EQUALS = "GREATER_THAN_EQUALS",
  LESS_THAN = "LESS_THAN",
  LESS_THAN_EQUALS = "LESS_THAN_EQUALS",
}

/** Matches a duration. */
export interface WorkflowDurationMatchCondition extends IMatchCondition {
  /** The duration attribute to compare from. */
  attribute: WorkflowDurationAttribute;
  /** The condition key for this condition */
  conditionKey: Scalars["String"];
  /** The operator to use in comparison */
  operator: WorkflowDurationAttributeOperator;
  /** The value to compare to. */
  value: Scalars["Duration"];
}

/** Matches a duration. */
export interface WorkflowDurationMatchConditionInput {
  /** The duration attribute to compare from. */
  attribute: WorkflowDurationAttributeInput;
  /** The condition key for this condition */
  conditionKey: Scalars["String"];
  /** The operator to use in comparison */
  operator: WorkflowDurationAttributeOperator;
  /** The values to compare to. */
  value: Scalars["Duration"];
}

export enum WorkflowDurationUnit {
  DAYS = "DAYS",
  HOURS = "HOURS",
  MINUTES = "MINUTES",
  MONTHS = "MONTHS",
  SECONDS = "SECONDS",
  WEEKS = "WEEKS",
  YEARS = "YEARS",
}

/** Context for which we're building a rule or action for */
export enum WorkflowEntity {
  ACCOUNTING_EXPORT = "ACCOUNTING_EXPORT",
  ACCOUNTING_PREPARE = "ACCOUNTING_PREPARE",
  BILL_PAY = "BILL_PAY",
  EXPENSE_POLICY = "EXPENSE_POLICY",
  EXTENDED_FIELD_VALUE_VISIBILITY = "EXTENDED_FIELD_VALUE_VISIBILITY",
  TRAVEL = "TRAVEL",
  TRAVEL_AIR = "TRAVEL_AIR",
  TRAVEL_CAR_RENTAL = "TRAVEL_CAR_RENTAL",
  TRAVEL_EXPENSE = "TRAVEL_EXPENSE",
  TRAVEL_LODGING = "TRAVEL_LODGING",
  TRAVEL_RAIL = "TRAVEL_RAIL",
}

export interface WorkflowEntityFilterInput {
  in?: InputMaybe<Array<WorkflowEntity>>;
  notIn?: InputMaybe<Array<WorkflowEntity>>;
}

export interface WorkflowEnumeratedAttribute
  extends ExpensePolicyWorkflowAttributeDescriptor,
    Node,
    WorkflowAttributeDescriptor {
  allowMultiSelect: Scalars["Boolean"];
  allowedPairingAttributes?: Maybe<Array<WorkflowAttribute>>;
  attributeIdentifier?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  extendedField?: Maybe<ExtendedField>;
  /** The ID of an object */
  id: Scalars["ID"];
  isAI: Scalars["Boolean"];
  requirements?: Maybe<Array<WorkflowAttributeRequirement>>;
  title: Scalars["String"];
  values: Array<WorkflowEnumeratedAttributeValue>;
}

export interface WorkflowEnumeratedAttributeallowedPairingAttributesArgs {
  workflowEntity: WorkflowEntity;
}

export interface WorkflowEnumeratedAttributevaluesArgs {
  entityType?: InputMaybe<WorkflowEntity>;
}

export interface WorkflowEnumeratedAttributeInput {
  id: Scalars["ID"];
}

/** Operators that can be used to match an enumeration of values. */
export enum WorkflowEnumeratedAttributeOperator {
  IN = "IN",
  NOT_IN = "NOT_IN",
}

export interface WorkflowEnumeratedAttributeValue {
  description?: Maybe<Scalars["String"]>;
  title?: Maybe<Scalars["String"]>;
  value: Scalars["String"];
}

export interface WorkflowEnumeratedListAttribute
  extends ExpensePolicyWorkflowAttributeDescriptor,
    Node,
    WorkflowAttributeDescriptor {
  allowedPairingAttributes?: Maybe<Array<WorkflowAttribute>>;
  attributeIdentifier?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  extendedField?: Maybe<ExtendedField>;
  /** The ID of an object */
  id: Scalars["ID"];
  isAI: Scalars["Boolean"];
  requirements?: Maybe<Array<WorkflowAttributeRequirement>>;
  title: Scalars["String"];
  values: Array<WorkflowEnumeratedAttributeValue>;
}

export interface WorkflowEnumeratedListAttributeallowedPairingAttributesArgs {
  workflowEntity: WorkflowEntity;
}

export interface WorkflowEnumeratedListAttributeInput {
  id: Scalars["ID"];
}

/** Operators that can be used to match an enumeration list of values. */
export enum WorkflowEnumeratedListAttributeOperator {
  ALL = "ALL",
  ANY = "ANY",
}

/** Matches an enumerated list attribute (e.g.: receipt line items). */
export interface WorkflowEnumeratedListMatchCondition extends IMatchCondition {
  /** The enumerated list attribute to compare from. */
  attribute: WorkflowEnumeratedListAttribute;
  /** The condition key for this condition */
  conditionKey: Scalars["String"];
  /** The operator to use in comparison */
  operator: WorkflowEnumeratedListAttributeOperator;
  /** The values to compare to. */
  values: Array<WorkflowEnumeratedAttributeValue>;
}

/** Matches an enumerated list attribute (e.g.: receipt line items). */
export interface WorkflowEnumeratedListMatchConditionInput {
  /** The enumerated list attribute to compare from. */
  attribute: WorkflowEnumeratedListAttributeInput;
  /** The condition key for this condition */
  conditionKey: Scalars["String"];
  /** The operator to use in comparison */
  operator: WorkflowEnumeratedListAttributeOperator;
  /** The values to compare to. */
  values: Array<Scalars["String"]>;
}

/** Matches an enumerated attribute (e.g.: expense status). */
export interface WorkflowEnumeratedMatchCondition extends IMatchCondition {
  /** The enumerated attribute to compare from. */
  attribute: WorkflowEnumeratedAttribute;
  /** The condition key for this condition */
  conditionKey: Scalars["String"];
  /** The operator to use in comparison */
  operator: WorkflowEnumeratedAttributeOperator;
  /** The values to compare to. */
  values: Array<WorkflowEnumeratedAttributeValue>;
}

/** Matches an enumerated attribute (e.g.: expense status). */
export interface WorkflowEnumeratedMatchConditionInput {
  /** The enumerated attribute to compare from. */
  attribute: WorkflowEnumeratedAttributeInput;
  /** The condition key for this condition */
  conditionKey: Scalars["String"];
  /** The operator to use in comparison */
  operator: WorkflowEnumeratedAttributeOperator;
  /** The values to compare to. */
  values: Array<Scalars["String"]>;
}

/** Block this expense from happening. This action runs on authorization and only works when paired with a match block that targets attributes that are available during authorization. */
export interface WorkflowExpenseBlockSpendActionBlock extends IWorkflowBlock {
  key: Scalars["String"];
  nextKey?: Maybe<Scalars["String"]>;
}

/** Block this expense from happening. This action runs on authorization and only works when paired with a match block that targets attributes that are available during authorization. */
export interface WorkflowExpenseBlockSpendActionBlockInput {
  key: Scalars["String"];
  nextKey?: InputMaybe<Scalars["String"]>;
}

export interface WorkflowExpenseBlockTransactionActionDescriptor
  extends WorkflowActionDescriptor {
  description?: Maybe<Scalars["String"]>;
  restrictedAttributes?: Maybe<Array<WorkflowAttribute>>;
  title: Scalars["String"];
  unsupportedAttributes?: Maybe<Array<WorkflowAttribute>>;
}

/** Do not require a given action on the expense. */
export interface WorkflowExpenseDoNotRequireActionBlock extends IWorkflowBlock {
  doNotRequireActionType: Array<WorkflowExpenseDoNotRequireActionType>;
  key: Scalars["String"];
  nextKey?: Maybe<Scalars["String"]>;
}

/** Do not require given action on the expense. */
export interface WorkflowExpenseDoNotRequireActionBlockInput {
  doNotRequireActionType: Array<WorkflowExpenseDoNotRequireActionType>;
  key: Scalars["String"];
  nextKey?: InputMaybe<Scalars["String"]>;
}

export enum WorkflowExpenseDoNotRequireActionType {
  ATTENDEES = "ATTENDEES",
  EXTENDED_FIELDS = "EXTENDED_FIELDS",
  INVOICE = "INVOICE",
  MEMO = "MEMO",
  RECEIPT = "RECEIPT",
  REVIEW = "REVIEW",
}

export interface WorkflowExpenseDoNotRequireAttendeesActionDescriptor
  extends WorkflowActionDescriptor {
  description?: Maybe<Scalars["String"]>;
  doNotRequireActionType: WorkflowExpenseDoNotRequireActionType;
  restrictedAttributes?: Maybe<Array<WorkflowAttribute>>;
  title: Scalars["String"];
  unsupportedAttributes?: Maybe<Array<WorkflowAttribute>>;
}

export interface WorkflowExpenseDoNotRequireExtendedFieldActionDescriptor
  extends WorkflowActionDescriptor {
  description?: Maybe<Scalars["String"]>;
  doNotRequireActionType: WorkflowExpenseDoNotRequireActionType;
  restrictedAttributes?: Maybe<Array<WorkflowAttribute>>;
  title: Scalars["String"];
  unsupportedAttributes?: Maybe<Array<WorkflowAttribute>>;
}

export interface WorkflowExpenseDoNotRequireInvoiceActionDescriptor
  extends WorkflowActionDescriptor {
  description?: Maybe<Scalars["String"]>;
  doNotRequireActionType: WorkflowExpenseDoNotRequireActionType;
  restrictedAttributes?: Maybe<Array<WorkflowAttribute>>;
  title: Scalars["String"];
  unsupportedAttributes?: Maybe<Array<WorkflowAttribute>>;
}

export interface WorkflowExpenseDoNotRequireMemoActionDescriptor
  extends WorkflowActionDescriptor {
  description?: Maybe<Scalars["String"]>;
  doNotRequireActionType: WorkflowExpenseDoNotRequireActionType;
  restrictedAttributes?: Maybe<Array<WorkflowAttribute>>;
  title: Scalars["String"];
  unsupportedAttributes?: Maybe<Array<WorkflowAttribute>>;
}

export interface WorkflowExpenseDoNotRequireReceiptActionDescriptor
  extends WorkflowActionDescriptor {
  description?: Maybe<Scalars["String"]>;
  doNotRequireActionType: WorkflowExpenseDoNotRequireActionType;
  restrictedAttributes?: Maybe<Array<WorkflowAttribute>>;
  title: Scalars["String"];
  unsupportedAttributes?: Maybe<Array<WorkflowAttribute>>;
}

export interface WorkflowExpenseDoNotRequireReviewActionDescriptor
  extends WorkflowActionDescriptor {
  description?: Maybe<Scalars["String"]>;
  doNotRequireActionType: WorkflowExpenseDoNotRequireActionType;
  restrictedAttributes?: Maybe<Array<WorkflowAttribute>>;
  title: Scalars["String"];
  unsupportedAttributes?: Maybe<Array<WorkflowAttribute>>;
}

/** Automatically generates a memo for an expense */
export interface WorkflowExpenseGenerateAutoMemoActionBlock
  extends IWorkflowBlock {
  key: Scalars["String"];
  nextKey?: Maybe<Scalars["String"]>;
  /** What strategy to use when prefilling the memo. */
  prefillMode: WorkflowExpenseRequireMemoActionBlockPrefillMode;
  /** Prefill the memo with this text. If set & `prefillType` will be `TEXT`. */
  text?: Maybe<Scalars["String"]>;
}

/** Automatically generates a memo for an expense */
export interface WorkflowExpenseGenerateAutoMemoActionBlockInput {
  key: Scalars["String"];
  nextKey?: InputMaybe<Scalars["String"]>;
  /** What strategy to use when prefilling the memo. */
  prefillMode: WorkflowExpenseRequireMemoActionBlockPrefillMode;
  /** Prefill the memo with this text. If set & `prefillType` will be `TEXT`. */
  text?: InputMaybe<Scalars["String"]>;
}

export interface WorkflowExpenseGenerateAutoMemoActionDescriptor
  extends WorkflowActionDescriptor {
  description?: Maybe<Scalars["String"]>;
  restrictedAttributes?: Maybe<Array<WorkflowAttribute>>;
  title: Scalars["String"];
  unsupportedAttributes?: Maybe<Array<WorkflowAttribute>>;
}

/** Require receipt categorization */
export interface WorkflowExpenseReceiptCategorizationActionBlock
  extends IWorkflowBlock {
  key: Scalars["String"];
  nextKey?: Maybe<Scalars["String"]>;
}

/** Require review from users & departments & levels or roles. Should never return less than 1 item in one section (API should throw). */
export interface WorkflowExpenseRequestReviewActionBlock
  extends IWorkflowBlock {
  approvalSteps: Array<WorkflowExpenseRequestReviewApprovalChainStep>;
  key: Scalars["String"];
  nextKey?: Maybe<Scalars["String"]>;
}

/** Require review from users & departments & levels or roles. Should never return less than 1 item in one section (API should throw). */
export interface WorkflowExpenseRequestReviewActionBlockInput {
  approvalSteps: Array<WorkflowExpenseRequestReviewApprovalChainStepInput>;
  key: Scalars["String"];
  nextKey?: InputMaybe<Scalars["String"]>;
}

/** On each approval step, the operator is used to determine if all or any of the approvers must approve the expense. */
export interface WorkflowExpenseRequestReviewApprovalChainStep {
  approvers: Array<WorkflowExpenseRequestReviewApprover>;
  operator?: Maybe<WorkflowExpenseRequestReviewApprovalChainStepOperator>;
}

/** On each approval step, the operator is used to determine if all or any of the approvers must approve the expense. */
export interface WorkflowExpenseRequestReviewApprovalChainStepInput {
  approvers: Array<WorkflowExpenseRequestReviewApproverOnOfInput>;
  operator?: InputMaybe<WorkflowExpenseRequestReviewApprovalChainStepOperator>;
}

export enum WorkflowExpenseRequestReviewApprovalChainStepOperator {
  ALL = "ALL",
  ANY = "ANY",
}

export type WorkflowExpenseRequestReviewApprover =
  | WorkflowExpenseRequestReviewAuthRoleApprover
  | WorkflowExpenseRequestReviewLevelDifferenceApprover
  | WorkflowExpenseRequestReviewUserApprover
  | WorkflowExpenseRequestReviewUserRoleApprover
  | WorkflowExpenseRoleApprover;

/** Approver described by user, levels, or roles */
export interface WorkflowExpenseRequestReviewApproverOnOfInput {
  authRole?: InputMaybe<WorkflowExpenseRequestReviewAuthRoleApproverInput>;
  expenseRole?: InputMaybe<WorkflowExpenseRoleApproverInput>;
  level?: InputMaybe<WorkflowExpenseRequestReviewLevelDifferenceApproverInput>;
  role?: InputMaybe<WorkflowExpenseRequestReviewUserRoleApproverInput>;
  user?: InputMaybe<WorkflowExpenseRequestReviewUserApproverInput>;
}

export interface WorkflowExpenseRequestReviewAuthRoleApprover {
  authRole: AuthRole;
}

export interface WorkflowExpenseRequestReviewAuthRoleApproverInput {
  /** Id for an AuthRole. Supports custom roles. */
  roleId: Scalars["String"];
}

export interface WorkflowExpenseRequestReviewLevelDifferenceApprover {
  levelDifference: Scalars["Int"];
}

export interface WorkflowExpenseRequestReviewLevelDifferenceApproverInput {
  levelDifference: Scalars["Int"];
}

export interface WorkflowExpenseRequestReviewUserApprover {
  user: User;
}

export interface WorkflowExpenseRequestReviewUserApproverInput {
  user: WorkflowUserInput;
}

export interface WorkflowExpenseRequestReviewUserRoleApprover {
  requiredUserRole: RequiredUserRole;
}

/** Legacy user roles. Use WorkflowExpenseRequestReviewAuthRoleApproverInput instead. */
export interface WorkflowExpenseRequestReviewUserRoleApproverInput {
  requiredUserRole: RequiredUserRole;
}

/** Require that data about the attendees are defined on the expense. */
export interface WorkflowExpenseRequireAttendeesActionBlock
  extends IWorkflowBlock {
  key: Scalars["String"];
  nextKey?: Maybe<Scalars["String"]>;
  requires?: Maybe<Array<AttendeesRequirements>>;
}

/** Require that data about the attendees are defined on the expense. */
export interface WorkflowExpenseRequireAttendeesActionBlockInput {
  key: Scalars["String"];
  nextKey?: InputMaybe<Scalars["String"]>;
  requires?: InputMaybe<Array<AttendeesRequirements>>;
}

export interface WorkflowExpenseRequireAttendeesActionDescriptor
  extends WorkflowActionDescriptor {
  description?: Maybe<Scalars["String"]>;
  restrictedAttributes?: Maybe<Array<WorkflowAttribute>>;
  title: Scalars["String"];
  unsupportedAttributes?: Maybe<Array<WorkflowAttribute>>;
}

export interface WorkflowExpenseRequireExtendedFieldActionDescriptor
  extends WorkflowActionDescriptor {
  description?: Maybe<Scalars["String"]>;
  restrictedAttributes?: Maybe<Array<WorkflowAttribute>>;
  title: Scalars["String"];
  unsupportedAttributes?: Maybe<Array<WorkflowAttribute>>;
}

/** Requires the presence of a list of extended fields. */
export interface WorkflowExpenseRequireExtendedFieldsActionBlock
  extends IWorkflowBlock {
  /** The extended fields that are being required. */
  extendedField: Array<ExtendedField>;
  key: Scalars["String"];
  nextKey?: Maybe<Scalars["String"]>;
}

/** Requires the presence of a list of extended fields. */
export interface WorkflowExpenseRequireExtendedFieldsActionBlockInput {
  /** The extended fields that are being required. */
  extendedField: Array<WorkflowExtendedFieldInput>;
  key: Scalars["String"];
  nextKey?: InputMaybe<Scalars["String"]>;
}

/** Require invoice attached. Only works if this expense is a Reimbursement. TODO: Verify if the above is correct. */
export interface WorkflowExpenseRequireInvoiceActionBlock
  extends IWorkflowBlock {
  key: Scalars["String"];
  nextKey?: Maybe<Scalars["String"]>;
}

/** Require invoice attached. Only works if this expense is a Reimbursement. TODO: Verify if the above is correct. */
export interface WorkflowExpenseRequireInvoiceActionBlockInput {
  key: Scalars["String"];
  nextKey?: InputMaybe<Scalars["String"]>;
}

export interface WorkflowExpenseRequireInvoiceActionDescriptor
  extends WorkflowActionDescriptor {
  description?: Maybe<Scalars["String"]>;
  restrictedAttributes?: Maybe<Array<WorkflowAttribute>>;
  title: Scalars["String"];
  unsupportedAttributes?: Maybe<Array<WorkflowAttribute>>;
}

/** Require memo from an expense. Optionally prefill the memo & which automates this requirement. */
export interface WorkflowExpenseRequireMemoActionBlock extends IWorkflowBlock {
  key: Scalars["String"];
  nextKey?: Maybe<Scalars["String"]>;
  /** What strategy to use when prefilling the memo. */
  prefillMode?: Maybe<WorkflowExpenseRequireMemoActionBlockPrefillMode>;
  /** Prefill the memo with this text. If set & `prefillType` will be `TEXT`. */
  text?: Maybe<Scalars["String"]>;
}

/** Require memo from an expense. Optionally prefill the memo & which automates this requirement. */
export interface WorkflowExpenseRequireMemoActionBlockInput {
  key: Scalars["String"];
  nextKey?: InputMaybe<Scalars["String"]>;
  /** What strategy to use when prefilling the memo. */
  prefillMode?: InputMaybe<WorkflowExpenseRequireMemoActionBlockPrefillMode>;
  /** Prefill the memo with this text. If set & `prefillType` will be `TEXT`. */
  text?: InputMaybe<Scalars["String"]>;
}

/** How to prefill the expense's memo. */
export enum WorkflowExpenseRequireMemoActionBlockPrefillMode {
  /** Prefill this expense with the spend limit name. */
  SPEND_LIMIT = "SPEND_LIMIT",
  /** Prefill this expense with the spend limit description. */
  SPEND_LIMIT_DESCRIPTION = "SPEND_LIMIT_DESCRIPTION",
  /** Prefill this expense with a hardcoded text. */
  TEXT = "TEXT",
}

export interface WorkflowExpenseRequireMemoActionDescriptor
  extends WorkflowActionDescriptor {
  description?: Maybe<Scalars["String"]>;
  restrictedAttributes?: Maybe<Array<WorkflowAttribute>>;
  title: Scalars["String"];
  unsupportedAttributes?: Maybe<Array<WorkflowAttribute>>;
}

/** Require a receipt with a specific requirement level. */
export interface WorkflowExpenseRequireReceiptActionBlock
  extends IWorkflowBlock {
  key: Scalars["String"];
  nextKey?: Maybe<Scalars["String"]>;
  /** The type of requirement. NORMAL just requires receipt picture; COMPLIANCE requires ????; ITEMIZED requires the expense to be itemized. */
  requirement: WorkflowExpenseRequireReceiptActionBlockRequirementType;
}

/** Require a receipt with a specific requirement level. */
export interface WorkflowExpenseRequireReceiptActionBlockInput {
  key: Scalars["String"];
  nextKey?: InputMaybe<Scalars["String"]>;
  /** The type of requirement. NORMAL just requires receipt picture; COMPLIANCE requires ????; ITEMIZED requires the expense to be itemized. */
  requirement?: WorkflowExpenseRequireReceiptActionBlockRequirementType;
}

/** Requirements for a receipt. */
export enum WorkflowExpenseRequireReceiptActionBlockRequirementType {
  /** TODO: Not sure what this is */
  COMPLIANCE = "COMPLIANCE",
  /** Require the receipt to be itemized. */
  ITEMIZED = "ITEMIZED",
  /** Just require a receipt photo. */
  NORMAL = "NORMAL",
}

export interface WorkflowExpenseRequireReceiptActionDescriptor
  extends WorkflowActionDescriptor {
  description?: Maybe<Scalars["String"]>;
  restrictedAttributes?: Maybe<Array<WorkflowAttribute>>;
  title: Scalars["String"];
  unsupportedAttributes?: Maybe<Array<WorkflowAttribute>>;
}

export interface WorkflowExpenseRequireReviewActionDescriptor
  extends WorkflowActionDescriptor {
  description?: Maybe<Scalars["String"]>;
  restrictedAttributes?: Maybe<Array<WorkflowAttribute>>;
  title: Scalars["String"];
  unsupportedAttributes?: Maybe<Array<WorkflowAttribute>>;
}

export interface WorkflowExpenseRoleApprover {
  expenseRole: ExpenseRole;
}

export interface WorkflowExpenseRoleApproverInput {
  expenseRole: ExpenseRole;
}

export interface WorkflowExpenseShowActionDescriptor
  extends WorkflowActionDescriptor {
  description?: Maybe<Scalars["String"]>;
  restrictedAttributes?: Maybe<Array<WorkflowAttribute>>;
  title: Scalars["String"];
  unsupportedAttributes?: Maybe<Array<WorkflowAttribute>>;
}

export interface WorkflowExtendedFieldInput {
  id: Scalars["ID"];
}

export interface WorkflowExtendedFieldOptionInput {
  id: Scalars["ID"];
}

export interface WorkflowFinancialAssetAttribute
  extends ExpensePolicyWorkflowAttributeDescriptor,
    Node,
    WorkflowAttributeDescriptor {
  allowedPairingAttributes?: Maybe<Array<WorkflowAttribute>>;
  attributeIdentifier?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  extendedField?: Maybe<ExtendedField>;
  /** The ID of an object */
  id: Scalars["ID"];
  isAI: Scalars["Boolean"];
  requirements?: Maybe<Array<WorkflowAttributeRequirement>>;
  supportedFunctions?: Maybe<Array<WorkflowFunctionDescriptor>>;
  title: Scalars["String"];
}

export interface WorkflowFinancialAssetAttributeallowedPairingAttributesArgs {
  workflowEntity: WorkflowEntity;
}

export interface WorkflowFinancialAssetAttributeInput {
  id: Scalars["ID"];
}

/** Operators that can be used to match a financial asset. */
export enum WorkflowFinancialAssetAttributeOperator {
  GREATER_THAN = "GREATER_THAN",
  GREATER_THAN_EQUALS = "GREATER_THAN_EQUALS",
  LESS_THAN = "LESS_THAN",
  LESS_THAN_EQUALS = "LESS_THAN_EQUALS",
}

export interface WorkflowFinancialAssetDefaultValue {
  financialAsset: FinancialAsset;
}

export interface WorkflowFinancialAssetDefaultValueInput {
  financialAssetValue: FinancialAssetInput;
}

/** Matches a financial asset with function */
export interface WorkflowFinancialAssetFunctionMatchCondition
  extends IMatchCondition {
  /** The financial asset attribute to compare from. */
  attribute: WorkflowFinancialAssetAttribute;
  /** The condition key for this condition */
  conditionKey: Scalars["String"];
  /**
   * The function to compare to.
   * @deprecated use value instead to accept default value
   */
  function: WorkflowFinancialAssetFunctionValue;
  /** The operator to use in comparison */
  operator: WorkflowFinancialAssetAttributeOperator;
  /** The value or function to compare to. */
  value: WorkflowFinancialAssetFunctionValue;
}

/** Matches a financial asset with a function. */
export interface WorkflowFinancialAssetFunctionMatchConditionInput {
  /** The financial asset attribute to compare from. */
  attribute: WorkflowFinancialAssetAttributeInput;
  /** The condition key for this condition */
  conditionKey: Scalars["String"];
  /** The operator to use in comparison */
  operator: WorkflowFinancialAssetAttributeOperator;
  /** The value or function to compare to. */
  value: WorkflowFinancialAssetFunctionOneOfInput;
}

/**
 * Should only contain one details type
 * (@oneOf is not supported for inputs)
 */
export interface WorkflowFinancialAssetFunctionOneOfInput {
  default?: InputMaybe<WorkflowFinancialAssetDefaultValueInput>;
  lowestLogicalFare?: InputMaybe<WorkflowFinancialAssetLLFFunctionInput>;
  medianPrice?: InputMaybe<WorkflowFinancialAssetMedianPriceFunctionInput>;
}

export type WorkflowFinancialAssetFunctionValue =
  | WorkflowFinancialAssetDefaultValue
  | WorkflowFinancialAssetLLFFunctionValue
  | WorkflowFinancialAssetMedianPriceFunctionValue;

export interface WorkflowFinancialAssetLLFFunction
  extends WorkflowFunctionDescriptor {
  description?: Maybe<Scalars["String"]>;
  functionIdentifier: Scalars["String"];
  id: Scalars["ID"];
  title: Scalars["String"];
}

export interface WorkflowFinancialAssetLLFFunctionInput {
  percentage: Scalars["Long"];
}

export interface WorkflowFinancialAssetLLFFunctionValue {
  percentage: Scalars["Long"];
}

/** Matches a financial asset with specific value */
export interface WorkflowFinancialAssetMatchCondition extends IMatchCondition {
  /** The financial asset attribute to compare from. */
  attribute: WorkflowFinancialAssetAttribute;
  /** The condition key for this condition */
  conditionKey: Scalars["String"];
  /** The operator to use in comparison */
  operator: WorkflowFinancialAssetAttributeOperator;
  /** The value to compare to. */
  value: FinancialAsset;
}

/** Matches a financial asset with specific value. */
export interface WorkflowFinancialAssetMatchConditionInput {
  /** The financial asset attribute to compare from. */
  attribute: WorkflowFinancialAssetAttributeInput;
  /** The condition key for this condition */
  conditionKey: Scalars["String"];
  /** The operator to use in comparison */
  operator: WorkflowFinancialAssetAttributeOperator;
  /** The value to compare to. */
  value: FinancialAssetInput;
}

export interface WorkflowFinancialAssetMedianPriceFunction
  extends WorkflowFunctionDescriptor {
  description?: Maybe<Scalars["String"]>;
  functionIdentifier: Scalars["String"];
  id: Scalars["ID"];
  title: Scalars["String"];
}

export interface WorkflowFinancialAssetMedianPriceFunctionInput {
  percentage: Scalars["Long"];
}

export interface WorkflowFinancialAssetMedianPriceFunctionValue {
  percentage: Scalars["Long"];
}

export interface WorkflowFinancialAssetValue extends WorkflowValue {
  financialAssetValue?: Maybe<FinancialAsset>;
  hasConflict: Scalars["Boolean"];
  rule?: Maybe<WorkflowRule>;
}

/**  ---------------- WORKFLOW FUNCTION TYPES ---------------------- */
export interface WorkflowFunctionDescriptor {
  /** The description of the function */
  description?: Maybe<Scalars["String"]>;
  /** The identifier of the function in policy-engine */
  functionIdentifier: Scalars["String"];
  /** The id of the function */
  id: Scalars["ID"];
  /** The title of the function */
  title: Scalars["String"];
}

export interface WorkflowIdentifierAttribute
  extends ExpensePolicyWorkflowAttributeDescriptor,
    Node,
    WorkflowAttributeDescriptor {
  allowedPairingAttributes?: Maybe<Array<WorkflowAttribute>>;
  attributeIdentifier?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  entityType?: Maybe<EntityType>;
  extendedField?: Maybe<ExtendedField>;
  /** @deprecated Use extendedField instead */
  extensibleFieldId?: Maybe<Scalars["ID"]>;
  /** The ID of an object */
  id: Scalars["ID"];
  isAI: Scalars["Boolean"];
  requirements?: Maybe<Array<WorkflowAttributeRequirement>>;
  /** The functions that are supported for this attribute */
  supportedFunctions?: Maybe<Array<WorkflowFunctionDescriptor>>;
  title: Scalars["String"];
}

export interface WorkflowIdentifierAttributeallowedPairingAttributesArgs {
  workflowEntity: WorkflowEntity;
}

export interface WorkflowIdentifierAttributeInput {
  id: Scalars["ID"];
}

/** Operators that can be used to match an identifier. */
export enum WorkflowIdentifierAttributeOperator {
  /** The identifier is in the predicate list. */
  IN = "IN",
  /** The identifier is not in the predicate list. */
  NOT_IN = "NOT_IN",
}

export interface WorkflowIdentifierIsNotNullFunction
  extends WorkflowFunctionDescriptor {
  description?: Maybe<Scalars["String"]>;
  functionIdentifier: Scalars["String"];
  id: Scalars["ID"];
  title: Scalars["String"];
}

/**
 * Represents a function that checks if an identifier value is not null
 * The presence of this input in the query is enough -
 * the operator (IN/NOT_IN) determines whether we're checking for null or not null.
 */
export interface WorkflowIdentifierIsNotNullFunctionInput {
  /** Not a real id, just makes plumbing easier. This field is ignored */
  id: Scalars["ID"];
}

/**
 * Represents a function that checks if an identifier value is not null
 * The presence of this value in the condition is enough -
 * the operator (IN/NOT_IN) determines whether we're checking for null or not null.
 */
export interface WorkflowIdentifierIsNotNullFunctionValue {
  /** Not a real id, just makes plumbing easier. This field is ignored */
  id: Scalars["ID"];
}

/** A function that checks if an identifier value is null or not null */
export interface WorkflowIdentifierIsNullFunction
  extends WorkflowFunctionDescriptor {
  description?: Maybe<Scalars["String"]>;
  functionIdentifier: Scalars["String"];
  id: Scalars["ID"];
  title: Scalars["String"];
}

/**
 * Represents a function that checks if an identifier value is null
 * The presence of this input in the query is enough -
 * the operator (IN/NOT_IN) determines whether we're checking for null or not null.
 */
export interface WorkflowIdentifierIsNullFunctionInput {
  /** Not a real id, just makes plumbing easier. This field is ignored */
  id: Scalars["ID"];
}

/**
 * Represents a function that checks if an identifier value is null
 * The presence of this value in the condition is enough -
 * the operator (IN/NOT_IN) determines whether we're checking for null or not null.
 */
export interface WorkflowIdentifierIsNullFunctionValue {
  /** Not a real id, just makes plumbing easier. This field is ignored */
  id: Scalars["ID"];
}

/** Matches the ID of another entity. */
export interface WorkflowIdentifierMatchCondition extends IMatchCondition {
  /** The identifier attribute. */
  attribute: WorkflowIdentifierAttribute;
  /** The condition key for this condition */
  conditionKey: Scalars["String"];
  /** The operator to use in comparison */
  operator: WorkflowIdentifierAttributeOperator;
  /** The values */
  values: Array<WorkflowIdentifierValue>;
}

/** Matches the ID of another entity. */
export interface WorkflowIdentifierMatchConditionInput {
  /** The identifier attribute. */
  attribute: WorkflowIdentifierAttributeInput;
  /** The condition key for this condition */
  conditionKey: Scalars["String"];
  /** The operator to use in comparison */
  operator: WorkflowIdentifierAttributeOperator;
  /** The values */
  values: Array<WorkflowIdentifierValueOneOfInput>;
}

/** All possible types of workflow identifier values (the identifiers here are basically relationships). */
export type WorkflowIdentifierValue =
  | CostCenter
  | Department
  | ExtendedFieldOption
  | LegalEntity
  | Location
  | Policy
  | SpendLimit
  | Title
  | User
  | VendorCategory
  | VendorDetails
  | WorkflowIdentifierIsNotNullFunctionValue
  | WorkflowIdentifierIsNullFunctionValue;

export interface WorkflowIdentifierValueOneOfInput {
  costCenter?: InputMaybe<WorkflowCostCenterInput>;
  department?: InputMaybe<WorkflowDepartmentInput>;
  extendedFieldOption?: InputMaybe<WorkflowExtendedFieldOptionInput>;
  isNotNull?: InputMaybe<WorkflowIdentifierIsNotNullFunctionInput>;
  isNull?: InputMaybe<WorkflowIdentifierIsNullFunctionInput>;
  legalEntity?: InputMaybe<WorkflowLegalEntityInput>;
  location?: InputMaybe<WorkflowLocationInput>;
  policy?: InputMaybe<WorkflowPolicyInput>;
  spendLimit?: InputMaybe<WorkflowSpendLimitInput>;
  title?: InputMaybe<WorkflowTitleInput>;
  user?: InputMaybe<WorkflowUserInput>;
  vendorCategory?: InputMaybe<WorkflowVendorCategoryInput>;
  vendorDetails?: InputMaybe<WorkflowVendorDetailsInput>;
}

export interface WorkflowLegalEntityInput {
  id: Scalars["ID"];
}

export interface WorkflowLocationAttribute
  extends ExpensePolicyWorkflowAttributeDescriptor,
    Node,
    WorkflowAttributeDescriptor {
  allowedPairingAttributes?: Maybe<Array<WorkflowAttribute>>;
  attributeIdentifier?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  extendedField?: Maybe<ExtendedField>;
  /** The ID of an object */
  id: Scalars["ID"];
  isAI: Scalars["Boolean"];
  requirements?: Maybe<Array<WorkflowAttributeRequirement>>;
  title: Scalars["String"];
  variant?: Maybe<WorkflowLocationType>;
}

export interface WorkflowLocationAttributeallowedPairingAttributesArgs {
  workflowEntity: WorkflowEntity;
}

/** Pre-defined attribute returned to Policy Builder. */
export interface WorkflowLocationAttributeInput {
  id: Scalars["ID"];
}

/** Operators that can be used to match a location. */
export enum WorkflowLocationAttributeOperator {
  IN = "IN",
  NOT_IN = "NOT_IN",
}

export interface WorkflowLocationInput {
  id: Scalars["ID"];
}

/** Matches a location. */
export interface WorkflowLocationMatchCondition extends IMatchCondition {
  /** The location attribute to compare from. */
  attribute: WorkflowLocationAttribute;
  /** The condition key for this condition */
  conditionKey: Scalars["String"];
  /** The operator to use in comparison */
  operator: WorkflowLocationAttributeOperator;
  /** The value to compare to. */
  value: MapLocation;
}

/** Input for matching a location. */
export interface WorkflowLocationMatchConditionInput {
  /** The location attribute to compare from. */
  attribute: WorkflowLocationAttributeInput;
  /** The condition key for this condition */
  conditionKey: Scalars["String"];
  /** The operator to use in comparison */
  operator: WorkflowLocationAttributeOperator;
  /** The location value to compare to. */
  value: MapLocationInput;
}

/**
 * Informs the UI on which type of place suggestion should be used to populate the list of search results.
 * For example, CITY would limit the suggestion results to only cities.
 */
export enum WorkflowLocationType {
  ADDRESS = "ADDRESS",
  CITY = "CITY",
  COUNTRY = "COUNTRY",
  STATE = "STATE",
}

/** A group of match blocks that are to be AND'ed or OR'ed together. */
export interface WorkflowLogicOperatorConditionBlock
  extends ConditionalWorkflowBlock,
    IWorkflowBlock {
  /**
   * The keys to the conditions that will will be operated together.
   *
   * Note that all keys here must be of the Condition type (i.e: have the condition suffix)
   */
  conditionKeys: Array<Scalars["String"]>;
  /** The next key if the conditional is false. */
  elseKey?: Maybe<Scalars["String"]>;
  key: Scalars["String"];
  /** Key that will execute after then/else */
  nextKey?: Maybe<Scalars["String"]>;
  /** The operator to be applied. */
  operator: WorkflowBlockLogicOperator;
  /** The next key if the conditional is true. */
  thenKey?: Maybe<Scalars["String"]>;
}

/** A group of match blocks that are to be AND'ed or OR'ed together. */
export interface WorkflowLogicOperatorConditionBlockInput {
  /**
   * The keys to the conditions that will will be operated together.
   *
   * Note that all keys here must be of the Condition type (i.e: have the condition suffix)
   */
  conditionKeys: Array<Scalars["String"]>;
  /** The next key if the conditional is false. */
  elseKey?: InputMaybe<Scalars["String"]>;
  key: Scalars["String"];
  /** Key that will execute after then/else */
  nextKey?: InputMaybe<Scalars["String"]>;
  /** The operator to be applied. */
  operator: WorkflowBlockLogicOperator;
  /** The next key if the conditional is true. */
  thenKey: Scalars["String"];
}

export interface WorkflowNumberAttribute
  extends ExpensePolicyWorkflowAttributeDescriptor,
    Node,
    WorkflowAttributeDescriptor {
  allowedPairingAttributes?: Maybe<Array<WorkflowAttribute>>;
  attributeIdentifier?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  extendedField?: Maybe<ExtendedField>;
  /** The ID of an object */
  id: Scalars["ID"];
  isAI: Scalars["Boolean"];
  maxValue?: Maybe<Scalars["Int"]>;
  minValue?: Maybe<Scalars["Int"]>;
  requirements?: Maybe<Array<WorkflowAttributeRequirement>>;
  suffix?: Maybe<Scalars["String"]>;
  title: Scalars["String"];
}

export interface WorkflowNumberAttributeallowedPairingAttributesArgs {
  workflowEntity: WorkflowEntity;
}

export interface WorkflowNumberAttributeInput {
  id: Scalars["ID"];
}

/** Operators that can be used to match an integer asset. */
export enum WorkflowNumberAttributeOperator {
  EQUALS = "EQUALS",
  GREATER_THAN = "GREATER_THAN",
  GREATER_THAN_EQUALS = "GREATER_THAN_EQUALS",
  LESS_THAN = "LESS_THAN",
  LESS_THAN_EQUALS = "LESS_THAN_EQUALS",
}

/** Matches an integer number. */
export interface WorkflowNumberMatchCondition extends IMatchCondition {
  /** The integer attribute to compare from. */
  attribute: WorkflowNumberAttribute;
  /** The condition key for this condition */
  conditionKey: Scalars["String"];
  /** The operator to use in comparison */
  operator: WorkflowNumberAttributeOperator;
  /** The value to compare to. */
  value: Scalars["Long"];
}

/** Matches a number. */
export interface WorkflowNumberMatchConditionInput {
  /** The number attribute to compare from. */
  attribute: WorkflowNumberAttributeInput;
  /** The condition key for this condition */
  conditionKey: Scalars["String"];
  /** The operator to use in comparison */
  operator: WorkflowNumberAttributeOperator;
  /** The value to compare to. */
  value: Scalars["Long"];
}

export interface WorkflowOptionValue extends WorkflowValue {
  hasConflict: Scalars["Boolean"];
  optionValue?: Maybe<ExtendedFieldOption>;
  rule?: Maybe<WorkflowRule>;
}

/** A list of box to run in parallel. */
export interface WorkflowParallelBlock extends IWorkflowBlock {
  key: Scalars["String"];
  /** The criteria used to call this parallel block finished. */
  mergingCriteria: WorkflowParallelBlockMergingCriteria;
  nextKey?: Maybe<Scalars["String"]>;
  /**
   * The keys of the blocks that will run in parallel.
   *
   * Note that all keys here must be of the Block type (i.e: have the block suffix)
   */
  parallelKeys: Array<Scalars["String"]>;
}

/** A list of box to run in parallel. */
export interface WorkflowParallelBlockInput {
  key: Scalars["String"];
  /** The criteria used to call this parallel block finished. */
  mergingCriteria: WorkflowParallelBlockMergingCriteria;
  nextKey?: InputMaybe<Scalars["String"]>;
  /**
   * The keys of the blocks that will run in parallel.
   *
   * Note that all keys here must be of the Block type (i.e: have the block suffix)
   */
  parallelKeys: Array<Scalars["String"]>;
}

/** How to merge the execution of parallel blocks. */
export enum WorkflowParallelBlockMergingCriteria {
  /** Require all parallel blocks to finish. */
  ALL_OF = "ALL_OF",
  /** Require one of the parallel blocks to finish. */
  ONE_OF = "ONE_OF",
}

export interface WorkflowPolicyInput {
  id: Scalars["ID"];
}

export interface WorkflowResult extends MutationResult {
  errors?: Maybe<Array<StandardClientError>>;
  workflowId?: Maybe<Scalars["String"]>;
}

/**
 * A VX Workflow rule with filters and actions.
 * (e.g. filter by expenses without memo in a certain budget and set the memo)
 */
export interface WorkflowRule {
  /** Actions that will be taken when the rule applies */
  actions: Array<WorkflowRuleAction>;
  /** The customer account id this rule belongs to */
  customerAccountId: Scalars["ID"];
  /** More details about the rule */
  description?: Maybe<Scalars["String"]>;
  /** The user facing name for the rule */
  displayName?: Maybe<Scalars["String"]>;
  /** Rule evaluation status - whether the rule is currently evaluating, finished evaluating, or encountered an error */
  evaluationStatus: WorkflowRuleEvaluationStatus;
  /** Defines the filters that need to match in order for this Rule's Actions to apply */
  filters: Array<WorkflowRuleFilter>;
  /** The id of the rule */
  id: Scalars["ID"];
  /** The mapping that this rule underlies, if one exists. Will always be null for non-mapping rules. */
  mapping?: Maybe<Mapping>;
  /**
   * The primary source object type for the rule.
   * This is the object type that will be queried to find all matching objects when the rule mutates
   */
  primarySourceObjectType: SourceObjectType;
  /**
   * The priority of the rule
   * Higher priority rules will be applied first and automatically "win" during conflicts
   */
  priority: WorkflowRulePriority;
  /** Status of the rule */
  status: WorkflowRuleStatus;
  /** The tags associated with the VX Workflow Rule. The keys are unique. */
  tags: Array<WorkflowRuleTag>;
  /** The timestamp of the last update to the VX Workflow Rule. */
  updatedAt: Scalars["Time"];
  /**
   * The specific Workflow this Rule is associated with
   * Some Workflows have required tags that must be present on all Rules in that Workflow
   */
  workflow: Workflow;
}

export enum WorkflowRuleAccountingRecordLineType {
  ACCOUNTING_RECORD_LINE_TYPE_CREDIT = "ACCOUNTING_RECORD_LINE_TYPE_CREDIT",
  ACCOUNTING_RECORD_LINE_TYPE_DEBIT = "ACCOUNTING_RECORD_LINE_TYPE_DEBIT",
}

export enum WorkflowRuleAccountingRecordSource {
  ACCOUNTING_RECORD_SOURCE_TYPE_BILLING_PAYMENT_INTENT = "ACCOUNTING_RECORD_SOURCE_TYPE_BILLING_PAYMENT_INTENT",
  ACCOUNTING_RECORD_SOURCE_TYPE_EXPENSE = "ACCOUNTING_RECORD_SOURCE_TYPE_EXPENSE",
  ACCOUNTING_RECORD_SOURCE_TYPE_TILL = "ACCOUNTING_RECORD_SOURCE_TYPE_TILL",
}

/** Union of the available VX Workflow Actions */
export type WorkflowRuleAction = DeleteAction | SetAction;

/**
 * Acts as an input union/oneOf depending on which field is not NULL
 * One field is required to be set
 */
export interface WorkflowRuleActionOneOfInput {
  deleteAction?: InputMaybe<DeleteActionInput>;
  setAction?: InputMaybe<SetActionInput>;
}

export enum WorkflowRuleBillableStatus {
  BILLABLE_TYPE_BILLABLE = "BILLABLE_TYPE_BILLABLE",
  BILLABLE_TYPE_NON_BILLABLE = "BILLABLE_TYPE_NON_BILLABLE",
  BILLABLE_TYPE_NOT_SET = "BILLABLE_TYPE_NOT_SET",
}

/** A paginated list of Workflow Rule resources */
export interface WorkflowRuleConnection extends Connection {
  edges: Array<Maybe<WorkflowRuleEdge>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

/** A WorkflowRule within a WorkflowRuleConnection */
export interface WorkflowRuleEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<WorkflowRule>;
}

/** Evaluation status for a specific rule. Indicates whether the rule is running or completed/error-ed out */
export enum WorkflowRuleEvaluationStatus {
  /** The rule has completed a full evaluation against all source objects */
  COMPLETED = "COMPLETED",
  /** The rule encountered an error during evaluation */
  ERROR = "ERROR",
  /** The rule is currently running a full evaluation against all source objects */
  IN_PROGRESS = "IN_PROGRESS",
  /** The rule evaluation has not been started. May mean the rule was just created or is disabled / deleted */
  NOT_STARTED = "NOT_STARTED",
}

/**
 * We currently only need the APPROVED status for expenses to support the "is approved" filter.
 * More can be added when/if needed.
 */
export enum WorkflowRuleExpenseStatus {
  /** An approved expense is public, with a request evaluated to have met the policy requirements */
  APPROVED = "APPROVED",
}

/** VX Workflow Rule Filter */
export interface WorkflowRuleFilter {
  /**
   * Additional metadata for how to create the filter
   * See the particular metadata type for more information on the impacts it will have to the filter
   */
  filterMetadata?: Maybe<FilterMetadata>;
  /** The Field to filter on. Left hand side operand */
  leftHandSide: LeftHandSide;
  /**
   * The operator to be used for this filter.
   * Operands use infix notation like '<leftHandSide> <operator> <rightHandSide>'
   * (e.g. 'amount > 100' where lhs = amount, operator = >, rhs = 100)
   */
  operator: FilterOperator;
  /**
   * The value that needs to match the filter based on the operator. Right hand side operand
   *
   * Will be null when accompanied by a unary operator (e.g. 'IS_NULL')
   */
  rightHandSide?: Maybe<RightHandSide>;
}

export interface WorkflowRuleFilterInput {
  /**
   * Additional metadata for how to create the filter
   * See the particular metadata type for more information on the impacts it will have to the filter
   */
  filterMetadata?: InputMaybe<FilterMetadataOneOfInput>;
  /** The Field to filter on. Left hand side operand */
  leftHandSide: LeftHandSideOneOfInput;
  /**
   * The operator to be used for this filter.
   * Operands use infix notation like '<leftHandSide> <operator> <rightHandSide>'
   * (e.g. 'amount > 100' where lhs = amount, operator = >, rhs = 100)
   */
  operator: FilterOperator;
  /**
   * The value that needs to match the filter based on the operator. Right hand side operand
   *
   * Should be left null when using a unary operator (e.g. 'IS_NULL').
   * It will be ignored if set alongside a unary operator.
   */
  rightHandSide?: InputMaybe<RightHandSideOneOfInput>;
}

export interface WorkflowRulePriority {
  /** The priority of the rule */
  priority?: Maybe<Scalars["Int"]>;
}

export interface WorkflowRulePriorityInput {
  priority: Scalars["Int"];
}

/** The status of the Workflow Rule */
export enum WorkflowRuleStatus {
  /**  The rule is soft deleted by a user or service and cannot be evaluated  */
  DELETED = "DELETED",
  /**  The rule will be enabled and can be evaluated  */
  ENABLED = "ENABLED",
}

export interface WorkflowRuleSuggestionDataInput {
  /** Actions that will be taken when the rule applies */
  actions: Array<SuggestionsWorkflowRuleActionOneOfInput>;
  /** More details about the rule. Not available for all rules, e.g. mappings. */
  description?: InputMaybe<Scalars["String"]>;
  /** The user facing name for the rule. Not available for all rules, e.g. mappings. */
  displayName?: InputMaybe<Scalars["String"]>;
  /** Defines the filters that need to match in order for this Rule's Actions to apply */
  filters: Array<SuggestionsWorkflowRuleFilterInput>;
  /**
   * The primary source object type for the rule.
   * This is the object type that will be queried to find all matching objects when the rule mutates
   */
  primarySourceObjectType: SuggestionsSourceObjectType;
  /**
   * The priority of the rule
   * Higher priority rules will be applied first and automatically "win" during conflicts
   */
  priority: SuggestionsWorkflowRulePriorityInput;
  /** The id of the rule. Null if this suggestion will create a new rule instead of updating an existing one. */
  ruleId?: InputMaybe<Scalars["ID"]>;
  /** Optional. The rule's score. */
  score?: InputMaybe<Scalars["Float"]>;
  /** The tags associated with the VX Workflow Rule. The keys are unique. */
  tags: Array<SuggestionsWorkflowRuleTagFilterInput>;
  /**
   * The specific Workflow this Rule is associated with
   * Some Workflows have required tags that must be present on all Rules in that Workflow
   */
  workflow: SuggestionsWorkflow;
}

export interface WorkflowRuleSuggestionInformation {
  /** Actions that will be taken when the rule applies */
  actions: Array<SuggestionsWorkflowRuleAction>;
  /** More details about the rule. Not available for all rules, e.g. mappings. */
  description?: Maybe<Scalars["String"]>;
  /** The user facing name for the rule. Not available for all rules, e.g. mappings. */
  displayName?: Maybe<Scalars["String"]>;
  /** Defines the filters that need to match in order for this Rule's Actions to apply */
  filters: Array<SuggestionsWorkflowRuleFilter>;
  /**
   * The primary source object type for the rule.
   * This is the object type that will be queried to find all matching objects when the rule mutates
   */
  primarySourceObjectType: SuggestionsSourceObjectType;
  /**
   * The priority of the rule
   * Higher priority rules will be applied first and automatically "win" during conflicts
   */
  priority: SuggestionsWorkflowRulePriority;
  /** The id of the rule. Null if this suggestion will create a new rule instead of updating an existing one. */
  ruleId?: Maybe<Scalars["ID"]>;
  /** Optional. The rule's score. */
  score?: Maybe<Scalars["Float"]>;
  /** The tags associated with the VX Workflow Rule. The keys are unique. */
  tags: Array<SuggestionsWorkflowRuleTag>;
  /**
   * The specific Workflow this Rule is associated with
   * Some Workflows have required tags that must be present on all Rules in that Workflow
   */
  workflow: SuggestionsWorkflow;
}

/**
 * Tag belonging to a VX Workflow Rule.
 * Can be used to store client specific metadata about the rule.
 */
export interface WorkflowRuleTag {
  key: Scalars["String"];
  value: Scalars["String"];
}

/** Input fields for filtering by VX Workflow Rule tags */
export interface WorkflowRuleTagFilterInput {
  key: Scalars["String"];
  value: Scalars["String"];
}

/** Input fields for filtering by VX Workflow Rule value reference */
export interface WorkflowRuleValueReferenceFilterInput {
  valueFieldId: Scalars["String"];
  valueId: Scalars["String"];
}

export interface WorkflowRulesFacetBucket {
  count: Scalars["Int"];
  tagValue?: Maybe<Scalars["String"]>;
}

export interface WorkflowRulesFacetBucketConnection extends Connection {
  edges: Array<Maybe<WorkflowRulesFacetBucketEdge>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]>;
}

export interface WorkflowRulesFacetBucketEdge {
  cursor?: Maybe<Scalars["String"]>;
  node?: Maybe<WorkflowRulesFacetBucket>;
}

export interface WorkflowSpendLimitInput {
  id: Scalars["ID"];
}

export interface WorkflowStatus {
  /** The names of pending workflow activities. */
  pendingActivities: Array<Scalars["String"]>;
  /** The names of pending child workflows. */
  pendingChildren: Array<Scalars["String"]>;
  /** The current workflow status. */
  status?: Maybe<Scalars["String"]>;
}

export interface WorkflowStringAttribute
  extends ExpensePolicyWorkflowAttributeDescriptor,
    Node,
    WorkflowAttributeDescriptor {
  allowedPairingAttributes?: Maybe<Array<WorkflowAttribute>>;
  attributeIdentifier?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  extendedField?: Maybe<ExtendedField>;
  /** The ID of an object */
  id: Scalars["ID"];
  isAI: Scalars["Boolean"];
  requirements?: Maybe<Array<WorkflowAttributeRequirement>>;
  title: Scalars["String"];
}

export interface WorkflowStringAttributeallowedPairingAttributesArgs {
  workflowEntity: WorkflowEntity;
}

export interface WorkflowStringAttributeInput {
  id: Scalars["ID"];
}

/** Operators that can be used to match a string. */
export enum WorkflowStringAttributeOperator {
  /** The string is in the predicate list. */
  IN = "IN",
  /** The string is not in the predicate list. */
  NOT_IN = "NOT_IN",
}

/** Matches a string. */
export interface WorkflowStringMatchCondition extends IMatchCondition {
  /** The string attribute to compare from. */
  attribute: WorkflowStringAttribute;
  /** The condition key for this condition */
  conditionKey: Scalars["String"];
  /** The operator to use in comparison */
  operator: WorkflowStringAttributeOperator;
  /** The values to compare to. */
  values: Array<Scalars["String"]>;
}

/** Matches a string. */
export interface WorkflowStringMatchConditionInput {
  /** The string attribute to compare from. */
  attribute: WorkflowStringAttributeInput;
  /** The condition key for this condition */
  conditionKey: Scalars["String"];
  /** The operator to use in comparison */
  operator: WorkflowStringAttributeOperator;
  /** The values to compare to. */
  values: Array<Scalars["String"]>;
}

export interface WorkflowStringValue extends WorkflowValue {
  hasConflict: Scalars["Boolean"];
  rule?: Maybe<WorkflowRule>;
  stringValue?: Maybe<Scalars["String"]>;
}

/**
 * A switch block that will evaluate a set of conditions and execute the first matching condition.
 * If no condition matches, the elseKey will be executed.
 */
export interface WorkflowSwitchBlock extends IWorkflowBlock {
  /** The catch-all key that will be executed if no condition matches. */
  elseKey?: Maybe<Scalars["String"]>;
  /**
   * The keys of the WorkflowLogicOperatorConditionBlock blocks that will be used to determine the next block to run.
   * Only the first matching condition will be executed.
   */
  ifKeys: Array<Scalars["String"]>;
  key: Scalars["String"];
  /** Key that will execute after this block finishes evaluating */
  nextKey?: Maybe<Scalars["String"]>;
}

/** A group of match blocks that are to be AND'ed or OR'ed together. */
export interface WorkflowSwitchBlockInput {
  /** The catch-all key that will be executed if no condition matches. */
  elseKey?: InputMaybe<Scalars["String"]>;
  /**
   * The keys of the WorkflowLogicOperatorConditionBlockInput blocks that will be used to determine the next block to run.
   * Only the first matching condition will be executed.
   */
  ifKeys: Array<Scalars["String"]>;
  key: Scalars["String"];
  /** Key that will execute after this block finishes evaluating */
  nextKey?: InputMaybe<Scalars["String"]>;
}

export interface WorkflowTimestampValue extends WorkflowValue {
  hasConflict: Scalars["Boolean"];
  rule?: Maybe<WorkflowRule>;
  timeValue?: Maybe<Scalars["Time"]>;
}

export interface WorkflowTitleInput {
  id: Scalars["ID"];
}

export interface WorkflowUserInput {
  id: Scalars["ID"];
}

export interface WorkflowValue {
  /** Whether this set value is conflicting */
  hasConflict: Scalars["Boolean"];
  /** The workflow rule that caused this value to be set */
  rule?: Maybe<WorkflowRule>;
}

export interface WorkflowVendorCategoryInput {
  id: Scalars["ID"];
}

export interface WorkflowVendorDetailsInput {
  id: Scalars["ID"];
}

export interface XeroAuthPayloadInput {
  /** Brex page where Xero website will redirect back to when linking is complete. */
  redirectUrl?: InputMaybe<Scalars["String"]>;
}

export interface XeroCategories {
  accountsPayableUserCategory?: Maybe<UserCategory>;
  collectionTargetUserCategory?: Maybe<UserCategory>;
  organizationName?: Maybe<Scalars["String"]>;
  /** reimbursements user category */
  reimbursementsUserCategory?: Maybe<UserCategory>;
  rewardsIncomeUserCategory?: Maybe<UserCategory>;
  vendorName?: Maybe<Scalars["String"]>;
}

export interface XeroPayload {
  connectionId?: Maybe<Scalars["String"]>;
  oauth2AccessToken?: Maybe<Scalars["String"]>;
  oauth2RefreshToken?: Maybe<Scalars["String"]>;
  tenantId?: Maybe<Scalars["String"]>;
}

export interface XeroTrackingCategory {
  categoryName?: Maybe<Scalars["String"]>;
  categoryNameId?: Maybe<Scalars["String"]>;
  categoryOption?: Maybe<Scalars["String"]>;
  categoryOptionId?: Maybe<Scalars["String"]>;
  isInactive?: Maybe<Scalars["Boolean"]>;
}

export interface YieldRate {
  bps?: Maybe<Scalars["Int"]>;
  lastUpdated?: Maybe<Scalars["Date"]>;
}

/** South Africa bank account. */
export interface ZaSwift {
  accountNumber?: Maybe<Scalars["String"]>;
  swiftCode?: Maybe<Scalars["String"]>;
}

/** South Africa bank account. */
export interface ZaSwiftInput {
  accountNumber?: InputMaybe<Scalars["String"]>;
  swiftCode?: InputMaybe<Scalars["String"]>;
}

export interface budgetEntityIDOneOfInput {
  /** The ID of the budget entity */
  budgetId?: InputMaybe<Scalars["ID"]>;
  /** The ID of the budget request entity */
  budgetRequestId?: InputMaybe<Scalars["ID"]>;
}

export interface createEarlyCreditCommitmentInput {
  /** Flag to create a commitment if one doesn't exist. If nothing exists, and this flag is false, we will throw a NOT_FOUND Exception */
  createIfNoEligibleCommitment: Scalars["Boolean"];
  /** Customer Account ID that we're evaluating whether we can provide an early credit to */
  customerAccountId: Scalars["String"];
}

export interface isPaymentAccountsMappingEnabledResult {
  isEnabled: Scalars["Boolean"];
}

export interface savedViewCreateResult extends MutationResult {
  /** No error if the saved view was created successfully */
  errors?: Maybe<Array<ReportingClientError>>;
  result?: Maybe<SavedView>;
}
